var Sv = Object.defineProperty, wv = Object.defineProperties;
var Cv = Object.getOwnPropertyDescriptors;
var _c = Object.getOwnPropertySymbols;
var Cp = Object.prototype.hasOwnProperty, kp = Object.prototype.propertyIsEnumerable;
var pe = Math.pow, Bu = (t, r, f) => r in t ? Sv(t, r, { enumerable: !0, configurable: !0, writable: !0, value: f }) : t[r] = f, Ut = (t, r) => {
  for (var f in r || (r = {}))
    Cp.call(r, f) && Bu(t, f, r[f]);
  if (_c)
    for (var f of _c(r))
      kp.call(r, f) && Bu(t, f, r[f]);
  return t;
}, oe = (t, r) => wv(t, Cv(r));
var mr = (t, r) => {
  var f = {};
  for (var B in t)
    Cp.call(t, B) && r.indexOf(B) < 0 && (f[B] = t[B]);
  if (t != null && _c)
    for (var B of _c(t))
      r.indexOf(B) < 0 && kp.call(t, B) && (f[B] = t[B]);
  return f;
};
var ui = (t, r, f) => (Bu(t, typeof r != "symbol" ? r + "" : r, f), f);
import { jsxs as zo, jsx as ri, Fragment as kv } from "react/jsx-runtime";
import Oh, { createContext as Tv, useContext as Mv, useState as Av, useRef as td, useEffect as ed } from "react";
const Pv = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, r) {
    console && console[t] && console[t].apply(console, r);
  }
};
class lh {
  constructor(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(r, f);
  }
  init(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = f.prefix || "i18next:", this.logger = r || Pv, this.options = f, this.debug = f.debug;
  }
  log() {
    for (var r = arguments.length, f = new Array(r), B = 0; B < r; B++)
      f[B] = arguments[B];
    return this.forward(f, "log", "", !0);
  }
  warn() {
    for (var r = arguments.length, f = new Array(r), B = 0; B < r; B++)
      f[B] = arguments[B];
    return this.forward(f, "warn", "", !0);
  }
  error() {
    for (var r = arguments.length, f = new Array(r), B = 0; B < r; B++)
      f[B] = arguments[B];
    return this.forward(f, "error", "");
  }
  deprecate() {
    for (var r = arguments.length, f = new Array(r), B = 0; B < r; B++)
      f[B] = arguments[B];
    return this.forward(f, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(r, f, B, H) {
    return H && !this.debug ? null : (typeof r[0] == "string" && (r[0] = `${B}${this.prefix} ${r[0]}`), this.logger[f](r));
  }
  create(r) {
    return new lh(this.logger, Ut({
      prefix: `${this.prefix}:${r}:`
    }, this.options));
  }
  clone(r) {
    return r = r || this.options, r.prefix = r.prefix || this.prefix, new lh(this.logger, r);
  }
}
var Kr = new lh();
class Dh {
  constructor() {
    this.observers = {};
  }
  on(r, f) {
    return r.split(" ").forEach((B) => {
      this.observers[B] = this.observers[B] || [], this.observers[B].push(f);
    }), this;
  }
  off(r, f) {
    if (this.observers[r]) {
      if (!f) {
        delete this.observers[r];
        return;
      }
      this.observers[r] = this.observers[r].filter((B) => B !== f);
    }
  }
  emit(r) {
    for (var f = arguments.length, B = new Array(f > 1 ? f - 1 : 0), H = 1; H < f; H++)
      B[H - 1] = arguments[H];
    this.observers[r] && [].concat(this.observers[r]).forEach((st) => {
      st(...B);
    }), this.observers["*"] && [].concat(this.observers["*"]).forEach((st) => {
      st.apply(st, [r, ...B]);
    });
  }
}
function ul() {
  let t, r;
  const f = new Promise((B, H) => {
    t = B, r = H;
  });
  return f.resolve = t, f.reject = r, f;
}
function Tp(t) {
  return t == null ? "" : "" + t;
}
function Ev(t, r, f) {
  t.forEach((B) => {
    r[B] && (f[B] = r[B]);
  });
}
function jd(t, r, f) {
  function B(st) {
    return st && st.indexOf("###") > -1 ? st.replace(/###/g, ".") : st;
  }
  function H() {
    return !t || typeof t == "string";
  }
  const tt = typeof r != "string" ? [].concat(r) : r.split(".");
  for (; tt.length > 1; ) {
    if (H())
      return {};
    const st = B(tt.shift());
    !t[st] && f && (t[st] = new f()), Object.prototype.hasOwnProperty.call(t, st) ? t = t[st] : t = {};
  }
  return H() ? {} : {
    obj: t,
    k: B(tt.shift())
  };
}
function Mp(t, r, f) {
  const {
    obj: B,
    k: H
  } = jd(t, r, Object);
  B[H] = f;
}
function Lv(t, r, f, B) {
  const {
    obj: H,
    k: tt
  } = jd(t, r, Object);
  H[tt] = H[tt] || [], H[tt].push(f);
}
function ch(t, r) {
  const {
    obj: f,
    k: B
  } = jd(t, r);
  if (f)
    return f[B];
}
function Ov(t, r, f) {
  const B = ch(t, f);
  return B !== void 0 ? B : ch(r, f);
}
function Bg(t, r, f) {
  for (const B in r)
    B !== "__proto__" && B !== "constructor" && (B in t ? typeof t[B] == "string" || t[B] instanceof String || typeof r[B] == "string" || r[B] instanceof String ? f && (t[B] = r[B]) : Bg(t[B], r[B], f) : t[B] = r[B]);
  return t;
}
function Vs(t) {
  return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var Dv = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Iv(t) {
  return typeof t == "string" ? t.replace(/[&<>"'\/]/g, (r) => Dv[r]) : t;
}
const Rv = [" ", ",", "?", "!", ";"];
function jv(t, r, f) {
  r = r || "", f = f || "";
  const B = Rv.filter((st) => r.indexOf(st) < 0 && f.indexOf(st) < 0);
  if (B.length === 0)
    return !0;
  const H = new RegExp(`(${B.map((st) => st === "?" ? "\\?" : st).join("|")})`);
  let tt = !H.test(t);
  if (!tt) {
    const st = t.indexOf(f);
    st > 0 && !H.test(t.substring(0, st)) && (tt = !0);
  }
  return tt;
}
function hh(t, r) {
  let f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t)
    return;
  if (t[r])
    return t[r];
  const B = r.split(f);
  let H = t;
  for (let tt = 0; tt < B.length; ++tt) {
    if (!H || typeof H[B[tt]] == "string" && tt + 1 < B.length)
      return;
    if (H[B[tt]] === void 0) {
      let st = 2, lt = B.slice(tt, tt + st).join(f), ht = H[lt];
      for (; ht === void 0 && B.length > tt + st; )
        st++, lt = B.slice(tt, tt + st).join(f), ht = H[lt];
      if (ht === void 0)
        return;
      if (ht === null)
        return null;
      if (r.endsWith(lt)) {
        if (typeof ht == "string")
          return ht;
        if (lt && typeof ht[lt] == "string")
          return ht[lt];
      }
      const ut = B.slice(tt + st).join(f);
      return ut ? hh(ht, ut, f) : void 0;
    }
    H = H[B[tt]];
  }
  return H;
}
function uh(t) {
  return t && t.indexOf("_") > 0 ? t.replace("_", "-") : t;
}
class Ap extends Dh {
  constructor(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = r || {}, this.options = f, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(r) {
    this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
  }
  removeNamespaces(r) {
    const f = this.options.ns.indexOf(r);
    f > -1 && this.options.ns.splice(f, 1);
  }
  getResource(r, f, B) {
    let H = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const tt = H.keySeparator !== void 0 ? H.keySeparator : this.options.keySeparator, st = H.ignoreJSONStructure !== void 0 ? H.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let lt = [r, f];
    B && typeof B != "string" && (lt = lt.concat(B)), B && typeof B == "string" && (lt = lt.concat(tt ? B.split(tt) : B)), r.indexOf(".") > -1 && (lt = r.split("."));
    const ht = ch(this.data, lt);
    return ht || !st || typeof B != "string" ? ht : hh(this.data && this.data[r] && this.data[r][f], B, tt);
  }
  addResource(r, f, B, H) {
    let tt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const st = tt.keySeparator !== void 0 ? tt.keySeparator : this.options.keySeparator;
    let lt = [r, f];
    B && (lt = lt.concat(st ? B.split(st) : B)), r.indexOf(".") > -1 && (lt = r.split("."), H = f, f = lt[1]), this.addNamespaces(f), Mp(this.data, lt, H), tt.silent || this.emit("added", r, f, B, H);
  }
  addResources(r, f, B) {
    let H = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const tt in B)
      (typeof B[tt] == "string" || Object.prototype.toString.apply(B[tt]) === "[object Array]") && this.addResource(r, f, tt, B[tt], {
        silent: !0
      });
    H.silent || this.emit("added", r, f, B);
  }
  addResourceBundle(r, f, B, H, tt) {
    let st = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1
    }, lt = [r, f];
    r.indexOf(".") > -1 && (lt = r.split("."), H = B, B = f, f = lt[1]), this.addNamespaces(f);
    let ht = ch(this.data, lt) || {};
    H ? Bg(ht, B, tt) : ht = Ut(Ut({}, ht), B), Mp(this.data, lt, ht), st.silent || this.emit("added", r, f, B);
  }
  removeResourceBundle(r, f) {
    this.hasResourceBundle(r, f) && delete this.data[r][f], this.removeNamespaces(f), this.emit("removed", r, f);
  }
  hasResourceBundle(r, f) {
    return this.getResource(r, f) !== void 0;
  }
  getResourceBundle(r, f) {
    return f || (f = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? Ut({}, this.getResource(r, f)) : this.getResource(r, f);
  }
  getDataByLanguage(r) {
    return this.data[r];
  }
  hasLanguageSomeTranslations(r) {
    const f = this.getDataByLanguage(r);
    return !!(f && Object.keys(f) || []).find((H) => f[H] && Object.keys(f[H]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ng = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, r, f, B, H) {
    return t.forEach((tt) => {
      this.processors[tt] && (r = this.processors[tt].process(r, f, B, H));
    }), r;
  }
};
const Pp = {};
class dh extends Dh {
  constructor(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Ev(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], r, this), this.options = f, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Kr.create("translator");
  }
  changeLanguage(r) {
    r && (this.language = r);
  }
  exists(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (r == null)
      return !1;
    const B = this.resolve(r, f);
    return B && B.res !== void 0;
  }
  extractFromKey(r, f) {
    let B = f.nsSeparator !== void 0 ? f.nsSeparator : this.options.nsSeparator;
    B === void 0 && (B = ":");
    const H = f.keySeparator !== void 0 ? f.keySeparator : this.options.keySeparator;
    let tt = f.ns || this.options.defaultNS || [];
    const st = B && r.indexOf(B) > -1, lt = !this.options.userDefinedKeySeparator && !f.keySeparator && !this.options.userDefinedNsSeparator && !f.nsSeparator && !jv(r, B, H);
    if (st && !lt) {
      const ht = r.match(this.interpolator.nestingRegexp);
      if (ht && ht.length > 0)
        return {
          key: r,
          namespaces: tt
        };
      const ut = r.split(B);
      (B !== H || B === H && this.options.ns.indexOf(ut[0]) > -1) && (tt = ut.shift()), r = ut.join(H);
    }
    return typeof tt == "string" && (tt = [tt]), {
      key: r,
      namespaces: tt
    };
  }
  translate(r, f, B) {
    if (typeof f != "object" && this.options.overloadTranslationOptionHandler && (f = this.options.overloadTranslationOptionHandler(arguments)), typeof f == "object" && (f = Ut({}, f)), f || (f = {}), r == null)
      return "";
    Array.isArray(r) || (r = [String(r)]);
    const H = f.returnDetails !== void 0 ? f.returnDetails : this.options.returnDetails, tt = f.keySeparator !== void 0 ? f.keySeparator : this.options.keySeparator, {
      key: st,
      namespaces: lt
    } = this.extractFromKey(r[r.length - 1], f), ht = lt[lt.length - 1], ut = f.lng || this.language, yt = f.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (ut && ut.toLowerCase() === "cimode") {
      if (yt) {
        const q = f.nsSeparator || this.options.nsSeparator;
        return H ? {
          res: `${ht}${q}${st}`,
          usedKey: st,
          exactUsedKey: st,
          usedLng: ut,
          usedNS: ht
        } : `${ht}${q}${st}`;
      }
      return H ? {
        res: st,
        usedKey: st,
        exactUsedKey: st,
        usedLng: ut,
        usedNS: ht
      } : st;
    }
    const gt = this.resolve(r, f);
    let _ = gt && gt.res;
    const at = gt && gt.usedKey || st, G = gt && gt.exactUsedKey || st, F = Object.prototype.toString.apply(_), $ = ["[object Number]", "[object Function]", "[object RegExp]"], Y = f.joinArrays !== void 0 ? f.joinArrays : this.options.joinArrays, J = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (J && _ && (typeof _ != "string" && typeof _ != "boolean" && typeof _ != "number") && $.indexOf(F) < 0 && !(typeof Y == "string" && F === "[object Array]")) {
      if (!f.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const q = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(at, _, oe(Ut({}, f), {
          ns: lt
        })) : `key '${st} (${this.language})' returned an object instead of string.`;
        return H ? (gt.res = q, gt) : q;
      }
      if (tt) {
        const q = F === "[object Array]", U = q ? [] : {}, N = q ? G : at;
        for (const D in _)
          if (Object.prototype.hasOwnProperty.call(_, D)) {
            const k = `${N}${tt}${D}`;
            U[D] = this.translate(k, oe(Ut({}, f), {
              joinArrays: !1,
              ns: lt
            })), U[D] === k && (U[D] = _[D]);
          }
        _ = U;
      }
    } else if (J && typeof Y == "string" && F === "[object Array]")
      _ = _.join(Y), _ && (_ = this.extendTranslation(_, r, f, B));
    else {
      let q = !1, U = !1;
      const N = f.count !== void 0 && typeof f.count != "string", D = dh.hasDefaultValue(f), k = N ? this.pluralResolver.getSuffix(ut, f.count, f) : "", A = f.ordinal && N ? this.pluralResolver.getSuffix(ut, f.count, {
        ordinal: !1
      }) : "", b = f[`defaultValue${k}`] || f[`defaultValue${A}`] || f.defaultValue;
      !this.isValidLookup(_) && D && (q = !0, _ = b), this.isValidLookup(_) || (U = !0, _ = st);
      const m = (f.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && U ? void 0 : _, v = D && b !== _ && this.options.updateMissing;
      if (U || q || v) {
        if (this.logger.log(v ? "updateKey" : "missingKey", ut, ht, st, v ? b : _), tt) {
          const P = this.resolve(st, oe(Ut({}, f), {
            keySeparator: !1
          }));
          P && P.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let g = [];
        const x = this.languageUtils.getFallbackCodes(this.options.fallbackLng, f.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && x && x[0])
          for (let P = 0; P < x.length; P++)
            g.push(x[P]);
        else
          this.options.saveMissingTo === "all" ? g = this.languageUtils.toResolveHierarchy(f.lng || this.language) : g.push(f.lng || this.language);
        const E = (P, S, u) => {
          const y = D && u !== _ ? u : m;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(P, ht, S, y, v, f) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(P, ht, S, y, v, f), this.emit("missingKey", P, ht, S, _);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && N ? g.forEach((P) => {
          this.pluralResolver.getSuffixes(P, f).forEach((S) => {
            E([P], st + S, f[`defaultValue${S}`] || b);
          });
        }) : E(g, st, b));
      }
      _ = this.extendTranslation(_, r, f, gt, B), U && _ === st && this.options.appendNamespaceToMissingKey && (_ = `${ht}:${st}`), (U || q) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? _ = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${ht}:${st}` : st, q ? _ : void 0) : _ = this.options.parseMissingKeyHandler(_));
    }
    return H ? (gt.res = _, gt) : _;
  }
  extendTranslation(r, f, B, H, tt) {
    var st = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      r = this.i18nFormat.parse(r, Ut(Ut({}, this.options.interpolation.defaultVariables), B), H.usedLng, H.usedNS, H.usedKey, {
        resolved: H
      });
    else if (!B.skipInterpolation) {
      B.interpolation && this.interpolator.init(oe(Ut({}, B), {
        interpolation: Ut(Ut({}, this.options.interpolation), B.interpolation)
      }));
      const ut = typeof r == "string" && (B && B.interpolation && B.interpolation.skipOnVariables !== void 0 ? B.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let yt;
      if (ut) {
        const _ = r.match(this.interpolator.nestingRegexp);
        yt = _ && _.length;
      }
      let gt = B.replace && typeof B.replace != "string" ? B.replace : B;
      if (this.options.interpolation.defaultVariables && (gt = Ut(Ut({}, this.options.interpolation.defaultVariables), gt)), r = this.interpolator.interpolate(r, gt, B.lng || this.language, B), ut) {
        const _ = r.match(this.interpolator.nestingRegexp), at = _ && _.length;
        yt < at && (B.nest = !1);
      }
      !B.lng && this.options.compatibilityAPI !== "v1" && H && H.res && (B.lng = H.usedLng), B.nest !== !1 && (r = this.interpolator.nest(r, function() {
        for (var _ = arguments.length, at = new Array(_), G = 0; G < _; G++)
          at[G] = arguments[G];
        return tt && tt[0] === at[0] && !B.context ? (st.logger.warn(`It seems you are nesting recursively key: ${at[0]} in key: ${f[0]}`), null) : st.translate(...at, f);
      }, B)), B.interpolation && this.interpolator.reset();
    }
    const lt = B.postProcess || this.options.postProcess, ht = typeof lt == "string" ? [lt] : lt;
    return r != null && ht && ht.length && B.applyPostProcessor !== !1 && (r = Ng.handle(ht, r, f, this.options && this.options.postProcessPassResolved ? Ut({
      i18nResolved: H
    }, B) : B, this)), r;
  }
  resolve(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, B, H, tt, st, lt;
    return typeof r == "string" && (r = [r]), r.forEach((ht) => {
      if (this.isValidLookup(B))
        return;
      const ut = this.extractFromKey(ht, f), yt = ut.key;
      H = yt;
      let gt = ut.namespaces;
      this.options.fallbackNS && (gt = gt.concat(this.options.fallbackNS));
      const _ = f.count !== void 0 && typeof f.count != "string", at = _ && !f.ordinal && f.count === 0 && this.pluralResolver.shouldUseIntlApi(), G = f.context !== void 0 && (typeof f.context == "string" || typeof f.context == "number") && f.context !== "", F = f.lngs ? f.lngs : this.languageUtils.toResolveHierarchy(f.lng || this.language, f.fallbackLng);
      gt.forEach(($) => {
        this.isValidLookup(B) || (lt = $, !Pp[`${F[0]}-${$}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(lt) && (Pp[`${F[0]}-${$}`] = !0, this.logger.warn(`key "${H}" for languages "${F.join(", ")}" won't get resolved as namespace "${lt}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), F.forEach((Y) => {
          if (this.isValidLookup(B))
            return;
          st = Y;
          const J = [yt];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(J, yt, Y, $, f);
          else {
            let q;
            _ && (q = this.pluralResolver.getSuffix(Y, f.count, f));
            const U = `${this.options.pluralSeparator}zero`, N = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (_ && (J.push(yt + q), f.ordinal && q.indexOf(N) === 0 && J.push(yt + q.replace(N, this.options.pluralSeparator)), at && J.push(yt + U)), G) {
              const D = `${yt}${this.options.contextSeparator}${f.context}`;
              J.push(D), _ && (J.push(D + q), f.ordinal && q.indexOf(N) === 0 && J.push(D + q.replace(N, this.options.pluralSeparator)), at && J.push(D + U));
            }
          }
          let Q;
          for (; Q = J.pop(); )
            this.isValidLookup(B) || (tt = Q, B = this.getResource(Y, $, Q, f));
        }));
      });
    }), {
      res: B,
      usedKey: H,
      exactUsedKey: tt,
      usedLng: st,
      usedNS: lt
    };
  }
  isValidLookup(r) {
    return r !== void 0 && !(!this.options.returnNull && r === null) && !(!this.options.returnEmptyString && r === "");
  }
  getResource(r, f, B) {
    let H = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(r, f, B, H) : this.resourceStore.getResource(r, f, B, H);
  }
  static hasDefaultValue(r) {
    const f = "defaultValue";
    for (const B in r)
      if (Object.prototype.hasOwnProperty.call(r, B) && f === B.substring(0, f.length) && r[B] !== void 0)
        return !0;
    return !1;
  }
}
function Nu(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
class Ep {
  constructor(r) {
    this.options = r, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Kr.create("languageUtils");
  }
  getScriptPartFromCode(r) {
    if (r = uh(r), !r || r.indexOf("-") < 0)
      return null;
    const f = r.split("-");
    return f.length === 2 || (f.pop(), f[f.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(f.join("-"));
  }
  getLanguagePartFromCode(r) {
    if (r = uh(r), !r || r.indexOf("-") < 0)
      return r;
    const f = r.split("-");
    return this.formatLanguageCode(f[0]);
  }
  formatLanguageCode(r) {
    if (typeof r == "string" && r.indexOf("-") > -1) {
      const f = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let B = r.split("-");
      return this.options.lowerCaseLng ? B = B.map((H) => H.toLowerCase()) : B.length === 2 ? (B[0] = B[0].toLowerCase(), B[1] = B[1].toUpperCase(), f.indexOf(B[1].toLowerCase()) > -1 && (B[1] = Nu(B[1].toLowerCase()))) : B.length === 3 && (B[0] = B[0].toLowerCase(), B[1].length === 2 && (B[1] = B[1].toUpperCase()), B[0] !== "sgn" && B[2].length === 2 && (B[2] = B[2].toUpperCase()), f.indexOf(B[1].toLowerCase()) > -1 && (B[1] = Nu(B[1].toLowerCase())), f.indexOf(B[2].toLowerCase()) > -1 && (B[2] = Nu(B[2].toLowerCase()))), B.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? r.toLowerCase() : r;
  }
  isSupportedCode(r) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (r = this.getLanguagePartFromCode(r)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(r) > -1;
  }
  getBestMatchFromCodes(r) {
    if (!r)
      return null;
    let f;
    return r.forEach((B) => {
      if (f)
        return;
      const H = this.formatLanguageCode(B);
      (!this.options.supportedLngs || this.isSupportedCode(H)) && (f = H);
    }), !f && this.options.supportedLngs && r.forEach((B) => {
      if (f)
        return;
      const H = this.getLanguagePartFromCode(B);
      if (this.isSupportedCode(H))
        return f = H;
      f = this.options.supportedLngs.find((tt) => {
        if (tt === H)
          return tt;
        if (!(tt.indexOf("-") < 0 && H.indexOf("-") < 0) && tt.indexOf(H) === 0)
          return tt;
      });
    }), f || (f = this.getFallbackCodes(this.options.fallbackLng)[0]), f;
  }
  getFallbackCodes(r, f) {
    if (!r)
      return [];
    if (typeof r == "function" && (r = r(f)), typeof r == "string" && (r = [r]), Object.prototype.toString.apply(r) === "[object Array]")
      return r;
    if (!f)
      return r.default || [];
    let B = r[f];
    return B || (B = r[this.getScriptPartFromCode(f)]), B || (B = r[this.formatLanguageCode(f)]), B || (B = r[this.getLanguagePartFromCode(f)]), B || (B = r.default), B || [];
  }
  toResolveHierarchy(r, f) {
    const B = this.getFallbackCodes(f || this.options.fallbackLng || [], r), H = [], tt = (st) => {
      st && (this.isSupportedCode(st) ? H.push(st) : this.logger.warn(`rejecting language code not found in supportedLngs: ${st}`));
    };
    return typeof r == "string" && (r.indexOf("-") > -1 || r.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && tt(this.formatLanguageCode(r)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && tt(this.getScriptPartFromCode(r)), this.options.load !== "currentOnly" && tt(this.getLanguagePartFromCode(r))) : typeof r == "string" && tt(this.formatLanguageCode(r)), B.forEach((st) => {
      H.indexOf(st) < 0 && tt(this.formatLanguageCode(st));
    }), H;
  }
}
let _v = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Bv = {
  1: function(t) {
    return +(t > 1);
  },
  2: function(t) {
    return +(t != 1);
  },
  3: function(t) {
    return 0;
  },
  4: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  5: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5;
  },
  6: function(t) {
    return t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2;
  },
  7: function(t) {
    return t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  8: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3;
  },
  9: function(t) {
    return +(t >= 2);
  },
  10: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4;
  },
  11: function(t) {
    return t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3;
  },
  12: function(t) {
    return +(t % 10 != 1 || t % 100 == 11);
  },
  13: function(t) {
    return +(t !== 0);
  },
  14: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3;
  },
  15: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  16: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2;
  },
  17: function(t) {
    return t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1;
  },
  18: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : 2;
  },
  19: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3;
  },
  20: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2;
  },
  21: function(t) {
    return t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0;
  },
  22: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3;
  }
};
const Nv = ["v1", "v2", "v3"], zv = ["v4"], Lp = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function Fv() {
  const t = {};
  return _v.forEach((r) => {
    r.lngs.forEach((f) => {
      t[f] = {
        numbers: r.nr,
        plurals: Bv[r.fc]
      };
    });
  }), t;
}
class Wv {
  constructor(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = r, this.options = f, this.logger = Kr.create("pluralResolver"), (!this.options.compatibilityJSON || zv.includes(this.options.compatibilityJSON)) && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Fv();
  }
  addRule(r, f) {
    this.rules[r] = f;
  }
  getRule(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(uh(r), {
          type: f.ordinal ? "ordinal" : "cardinal"
        });
      } catch (B) {
        return;
      }
    return this.rules[r] || this.rules[this.languageUtils.getLanguagePartFromCode(r)];
  }
  needsPlural(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const B = this.getRule(r, f);
    return this.shouldUseIntlApi() ? B && B.resolvedOptions().pluralCategories.length > 1 : B && B.numbers.length > 1;
  }
  getPluralFormsOfKey(r, f) {
    let B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(r, B).map((H) => `${f}${H}`);
  }
  getSuffixes(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const B = this.getRule(r, f);
    return B ? this.shouldUseIntlApi() ? B.resolvedOptions().pluralCategories.sort((H, tt) => Lp[H] - Lp[tt]).map((H) => `${this.options.prepend}${f.ordinal ? `ordinal${this.options.prepend}` : ""}${H}`) : B.numbers.map((H) => this.getSuffix(r, H, f)) : [];
  }
  getSuffix(r, f) {
    let B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const H = this.getRule(r, B);
    return H ? this.shouldUseIntlApi() ? `${this.options.prepend}${B.ordinal ? `ordinal${this.options.prepend}` : ""}${H.select(f)}` : this.getSuffixRetroCompatible(H, f) : (this.logger.warn(`no plural rule found for: ${r}`), "");
  }
  getSuffixRetroCompatible(r, f) {
    const B = r.noAbs ? r.plurals(f) : r.plurals(Math.abs(f));
    let H = r.numbers[B];
    this.options.simplifyPluralSuffix && r.numbers.length === 2 && r.numbers[0] === 1 && (H === 2 ? H = "plural" : H === 1 && (H = ""));
    const tt = () => this.options.prepend && H.toString() ? this.options.prepend + H.toString() : H.toString();
    return this.options.compatibilityJSON === "v1" ? H === 1 ? "" : typeof H == "number" ? `_plural_${H.toString()}` : tt() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && r.numbers.length === 2 && r.numbers[0] === 1 ? tt() : this.options.prepend && B.toString() ? this.options.prepend + B.toString() : B.toString();
  }
  shouldUseIntlApi() {
    return !Nv.includes(this.options.compatibilityJSON);
  }
}
function Op(t, r, f) {
  let B = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", H = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, tt = Ov(t, r, f);
  return !tt && H && typeof f == "string" && (tt = hh(t, f, B), tt === void 0 && (tt = hh(r, f, B))), tt;
}
class Hv {
  constructor() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Kr.create("interpolator"), this.options = r, this.format = r.interpolation && r.interpolation.format || ((f) => f), this.init(r);
  }
  init() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    r.interpolation || (r.interpolation = {
      escapeValue: !0
    });
    const f = r.interpolation;
    this.escape = f.escape !== void 0 ? f.escape : Iv, this.escapeValue = f.escapeValue !== void 0 ? f.escapeValue : !0, this.useRawValueToEscape = f.useRawValueToEscape !== void 0 ? f.useRawValueToEscape : !1, this.prefix = f.prefix ? Vs(f.prefix) : f.prefixEscaped || "{{", this.suffix = f.suffix ? Vs(f.suffix) : f.suffixEscaped || "}}", this.formatSeparator = f.formatSeparator ? f.formatSeparator : f.formatSeparator || ",", this.unescapePrefix = f.unescapeSuffix ? "" : f.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : f.unescapeSuffix || "", this.nestingPrefix = f.nestingPrefix ? Vs(f.nestingPrefix) : f.nestingPrefixEscaped || Vs("$t("), this.nestingSuffix = f.nestingSuffix ? Vs(f.nestingSuffix) : f.nestingSuffixEscaped || Vs(")"), this.nestingOptionsSeparator = f.nestingOptionsSeparator ? f.nestingOptionsSeparator : f.nestingOptionsSeparator || ",", this.maxReplaces = f.maxReplaces ? f.maxReplaces : 1e3, this.alwaysFormat = f.alwaysFormat !== void 0 ? f.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const r = `${this.prefix}(.+?)${this.suffix}`;
    this.regexp = new RegExp(r, "g");
    const f = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
    this.regexpUnescape = new RegExp(f, "g");
    const B = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(B, "g");
  }
  interpolate(r, f, B, H) {
    let tt, st, lt;
    const ht = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function ut(G) {
      return G.replace(/\$/g, "$$$$");
    }
    const yt = (G) => {
      if (G.indexOf(this.formatSeparator) < 0) {
        const J = Op(f, ht, G, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(J, void 0, B, oe(Ut(Ut({}, H), f), {
          interpolationkey: G
        })) : J;
      }
      const F = G.split(this.formatSeparator), $ = F.shift().trim(), Y = F.join(this.formatSeparator).trim();
      return this.format(Op(f, ht, $, this.options.keySeparator, this.options.ignoreJSONStructure), Y, B, oe(Ut(Ut({}, H), f), {
        interpolationkey: $
      }));
    };
    this.resetRegExp();
    const gt = H && H.missingInterpolationHandler || this.options.missingInterpolationHandler, _ = H && H.interpolation && H.interpolation.skipOnVariables !== void 0 ? H.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (G) => ut(G)
    }, {
      regex: this.regexp,
      safeValue: (G) => this.escapeValue ? ut(this.escape(G)) : ut(G)
    }].forEach((G) => {
      for (lt = 0; tt = G.regex.exec(r); ) {
        const F = tt[1].trim();
        if (st = yt(F), st === void 0)
          if (typeof gt == "function") {
            const Y = gt(r, tt, H);
            st = typeof Y == "string" ? Y : "";
          } else if (H && Object.prototype.hasOwnProperty.call(H, F))
            st = "";
          else if (_) {
            st = tt[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${F} for interpolating ${r}`), st = "";
        else
          typeof st != "string" && !this.useRawValueToEscape && (st = Tp(st));
        const $ = G.safeValue(st);
        if (r = r.replace(tt[0], $), _ ? (G.regex.lastIndex += st.length, G.regex.lastIndex -= tt[0].length) : G.regex.lastIndex = 0, lt++, lt >= this.maxReplaces)
          break;
      }
    }), r;
  }
  nest(r, f) {
    let B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, H, tt, st;
    function lt(ht, ut) {
      const yt = this.nestingOptionsSeparator;
      if (ht.indexOf(yt) < 0)
        return ht;
      const gt = ht.split(new RegExp(`${yt}[ ]*{`));
      let _ = `{${gt[1]}`;
      ht = gt[0], _ = this.interpolate(_, st);
      const at = _.match(/'/g), G = _.match(/"/g);
      (at && at.length % 2 === 0 && !G || G.length % 2 !== 0) && (_ = _.replace(/'/g, '"'));
      try {
        st = JSON.parse(_), ut && (st = Ut(Ut({}, ut), st));
      } catch (F) {
        return this.logger.warn(`failed parsing options string in nesting for key ${ht}`, F), `${ht}${yt}${_}`;
      }
      return delete st.defaultValue, ht;
    }
    for (; H = this.nestingRegexp.exec(r); ) {
      let ht = [];
      st = Ut({}, B), st = st.replace && typeof st.replace != "string" ? st.replace : st, st.applyPostProcessor = !1, delete st.defaultValue;
      let ut = !1;
      if (H[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(H[1])) {
        const yt = H[1].split(this.formatSeparator).map((gt) => gt.trim());
        H[1] = yt.shift(), ht = yt, ut = !0;
      }
      if (tt = f(lt.call(this, H[1].trim(), st), st), tt && H[0] === r && typeof tt != "string")
        return tt;
      typeof tt != "string" && (tt = Tp(tt)), tt || (this.logger.warn(`missed to resolve ${H[1]} for nesting ${r}`), tt = ""), ut && (tt = ht.reduce((yt, gt) => this.format(yt, gt, B.lng, oe(Ut({}, B), {
        interpolationkey: H[1].trim()
      })), tt.trim())), r = r.replace(H[0], tt), this.regexp.lastIndex = 0;
    }
    return r;
  }
}
function Uv(t) {
  let r = t.toLowerCase().trim();
  const f = {};
  if (t.indexOf("(") > -1) {
    const B = t.split("(");
    r = B[0].toLowerCase().trim();
    const H = B[1].substring(0, B[1].length - 1);
    r === "currency" && H.indexOf(":") < 0 ? f.currency || (f.currency = H.trim()) : r === "relativetime" && H.indexOf(":") < 0 ? f.range || (f.range = H.trim()) : H.split(";").forEach((st) => {
      if (!st)
        return;
      const [lt, ...ht] = st.split(":"), ut = ht.join(":").trim().replace(/^'+|'+$/g, "");
      f[lt.trim()] || (f[lt.trim()] = ut), ut === "false" && (f[lt.trim()] = !1), ut === "true" && (f[lt.trim()] = !0), isNaN(ut) || (f[lt.trim()] = parseInt(ut, 10));
    });
  }
  return {
    formatName: r,
    formatOptions: f
  };
}
function $s(t) {
  const r = {};
  return function(B, H, tt) {
    const st = H + JSON.stringify(tt);
    let lt = r[st];
    return lt || (lt = t(uh(H), tt), r[st] = lt), lt(B);
  };
}
class Gv {
  constructor() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Kr.create("formatter"), this.options = r, this.formats = {
      number: $s((f, B) => {
        const H = new Intl.NumberFormat(f, Ut({}, B));
        return (tt) => H.format(tt);
      }),
      currency: $s((f, B) => {
        const H = new Intl.NumberFormat(f, oe(Ut({}, B), {
          style: "currency"
        }));
        return (tt) => H.format(tt);
      }),
      datetime: $s((f, B) => {
        const H = new Intl.DateTimeFormat(f, Ut({}, B));
        return (tt) => H.format(tt);
      }),
      relativetime: $s((f, B) => {
        const H = new Intl.RelativeTimeFormat(f, Ut({}, B));
        return (tt) => H.format(tt, B.range || "day");
      }),
      list: $s((f, B) => {
        const H = new Intl.ListFormat(f, Ut({}, B));
        return (tt) => H.format(tt);
      })
    }, this.init(r);
  }
  init(r) {
    const B = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = B.formatSeparator ? B.formatSeparator : B.formatSeparator || ",";
  }
  add(r, f) {
    this.formats[r.toLowerCase().trim()] = f;
  }
  addCached(r, f) {
    this.formats[r.toLowerCase().trim()] = $s(f);
  }
  format(r, f, B) {
    let H = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return f.split(this.formatSeparator).reduce((lt, ht) => {
      const {
        formatName: ut,
        formatOptions: yt
      } = Uv(ht);
      if (this.formats[ut]) {
        let gt = lt;
        try {
          const _ = H && H.formatParams && H.formatParams[H.interpolationkey] || {}, at = _.locale || _.lng || H.locale || H.lng || B;
          gt = this.formats[ut](lt, at, Ut(Ut(Ut({}, yt), H), _));
        } catch (_) {
          this.logger.warn(_);
        }
        return gt;
      } else
        this.logger.warn(`there was no format function for ${ut}`);
      return lt;
    }, r);
  }
}
function Xv(t, r) {
  t.pending[r] !== void 0 && (delete t.pending[r], t.pendingCount--);
}
class Yv extends Dh {
  constructor(r, f, B) {
    let H = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = r, this.store = f, this.services = B, this.languageUtils = B.languageUtils, this.options = H, this.logger = Kr.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = H.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = H.maxRetries >= 0 ? H.maxRetries : 5, this.retryTimeout = H.retryTimeout >= 1 ? H.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(B, H.backend, H);
  }
  queueLoad(r, f, B, H) {
    const tt = {}, st = {}, lt = {}, ht = {};
    return r.forEach((ut) => {
      let yt = !0;
      f.forEach((gt) => {
        const _ = `${ut}|${gt}`;
        !B.reload && this.store.hasResourceBundle(ut, gt) ? this.state[_] = 2 : this.state[_] < 0 || (this.state[_] === 1 ? st[_] === void 0 && (st[_] = !0) : (this.state[_] = 1, yt = !1, st[_] === void 0 && (st[_] = !0), tt[_] === void 0 && (tt[_] = !0), ht[gt] === void 0 && (ht[gt] = !0)));
      }), yt || (lt[ut] = !0);
    }), (Object.keys(tt).length || Object.keys(st).length) && this.queue.push({
      pending: st,
      pendingCount: Object.keys(st).length,
      loaded: {},
      errors: [],
      callback: H
    }), {
      toLoad: Object.keys(tt),
      pending: Object.keys(st),
      toLoadLanguages: Object.keys(lt),
      toLoadNamespaces: Object.keys(ht)
    };
  }
  loaded(r, f, B) {
    const H = r.split("|"), tt = H[0], st = H[1];
    f && this.emit("failedLoading", tt, st, f), B && this.store.addResourceBundle(tt, st, B), this.state[r] = f ? -1 : 2;
    const lt = {};
    this.queue.forEach((ht) => {
      Lv(ht.loaded, [tt], st), Xv(ht, r), f && ht.errors.push(f), ht.pendingCount === 0 && !ht.done && (Object.keys(ht.loaded).forEach((ut) => {
        lt[ut] || (lt[ut] = {});
        const yt = ht.loaded[ut];
        yt.length && yt.forEach((gt) => {
          lt[ut][gt] === void 0 && (lt[ut][gt] = !0);
        });
      }), ht.done = !0, ht.errors.length ? ht.callback(ht.errors) : ht.callback());
    }), this.emit("loaded", lt), this.queue = this.queue.filter((ht) => !ht.done);
  }
  read(r, f, B) {
    let H = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, tt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, st = arguments.length > 5 ? arguments[5] : void 0;
    if (!r.length)
      return st(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: r,
        ns: f,
        fcName: B,
        tried: H,
        wait: tt,
        callback: st
      });
      return;
    }
    this.readingCalls++;
    const lt = (ut, yt) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const gt = this.waitingReads.shift();
        this.read(gt.lng, gt.ns, gt.fcName, gt.tried, gt.wait, gt.callback);
      }
      if (ut && yt && H < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, r, f, B, H + 1, tt * 2, st);
        }, tt);
        return;
      }
      st(ut, yt);
    }, ht = this.backend[B].bind(this.backend);
    if (ht.length === 2) {
      try {
        const ut = ht(r, f);
        ut && typeof ut.then == "function" ? ut.then((yt) => lt(null, yt)).catch(lt) : lt(null, ut);
      } catch (ut) {
        lt(ut);
      }
      return;
    }
    return ht(r, f, lt);
  }
  prepareLoading(r, f) {
    let B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, H = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), H && H();
    typeof r == "string" && (r = this.languageUtils.toResolveHierarchy(r)), typeof f == "string" && (f = [f]);
    const tt = this.queueLoad(r, f, B, H);
    if (!tt.toLoad.length)
      return tt.pending.length || H(), null;
    tt.toLoad.forEach((st) => {
      this.loadOne(st);
    });
  }
  load(r, f, B) {
    this.prepareLoading(r, f, {}, B);
  }
  reload(r, f, B) {
    this.prepareLoading(r, f, {
      reload: !0
    }, B);
  }
  loadOne(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const B = r.split("|"), H = B[0], tt = B[1];
    this.read(H, tt, "read", void 0, void 0, (st, lt) => {
      st && this.logger.warn(`${f}loading namespace ${tt} for language ${H} failed`, st), !st && lt && this.logger.log(`${f}loaded namespace ${tt} for language ${H}`, lt), this.loaded(r, st, lt);
    });
  }
  saveMissing(r, f, B, H, tt) {
    let st = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, lt = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(f)) {
      this.logger.warn(`did not save key "${B}" as the namespace "${f}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(B == null || B === "")) {
      if (this.backend && this.backend.create) {
        const ht = oe(Ut({}, st), {
          isUpdate: tt
        }), ut = this.backend.create.bind(this.backend);
        if (ut.length < 6)
          try {
            let yt;
            ut.length === 5 ? yt = ut(r, f, B, H, ht) : yt = ut(r, f, B, H), yt && typeof yt.then == "function" ? yt.then((gt) => lt(null, gt)).catch(lt) : lt(null, yt);
          } catch (yt) {
            lt(yt);
          }
        else
          ut(r, f, B, H, lt, ht);
      }
      !r || !r[0] || this.store.addResource(r[0], f, B, H);
    }
  }
}
function Dp() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(r) {
      let f = {};
      if (typeof r[1] == "object" && (f = r[1]), typeof r[1] == "string" && (f.defaultValue = r[1]), typeof r[2] == "string" && (f.tDescription = r[2]), typeof r[2] == "object" || typeof r[3] == "object") {
        const B = r[3] || r[2];
        Object.keys(B).forEach((H) => {
          f[H] = B[H];
        });
      }
      return f;
    },
    interpolation: {
      escapeValue: !0,
      format: (t, r, f, B) => t,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function Ip(t) {
  return typeof t.ns == "string" && (t.ns = [t.ns]), typeof t.fallbackLng == "string" && (t.fallbackLng = [t.fallbackLng]), typeof t.fallbackNS == "string" && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t;
}
function Bc() {
}
function Vv(t) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((f) => {
    typeof t[f] == "function" && (t[f] = t[f].bind(t));
  });
}
class Sl extends Dh {
  constructor() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Ip(r), this.services = {}, this.logger = Kr, this.modules = {
      external: []
    }, Vv(this), f && !this.isInitialized && !r.isClone) {
      if (!this.options.initImmediate)
        return this.init(r, f), this;
      setTimeout(() => {
        this.init(r, f);
      }, 0);
    }
  }
  init() {
    var r = this;
    let f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, B = arguments.length > 1 ? arguments[1] : void 0;
    typeof f == "function" && (B = f, f = {}), !f.defaultNS && f.defaultNS !== !1 && f.ns && (typeof f.ns == "string" ? f.defaultNS = f.ns : f.ns.indexOf("translation") < 0 && (f.defaultNS = f.ns[0]));
    const H = Dp();
    this.options = Ut(Ut(Ut({}, H), this.options), Ip(f)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = Ut(Ut({}, H.interpolation), this.options.interpolation)), f.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = f.keySeparator), f.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = f.nsSeparator);
    function tt(yt) {
      return yt ? typeof yt == "function" ? new yt() : yt : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? Kr.init(tt(this.modules.logger), this.options) : Kr.init(null, this.options);
      let yt;
      this.modules.formatter ? yt = this.modules.formatter : typeof Intl != "undefined" && (yt = Gv);
      const gt = new Ep(this.options);
      this.store = new Ap(this.options.resources, this.options);
      const _ = this.services;
      _.logger = Kr, _.resourceStore = this.store, _.languageUtils = gt, _.pluralResolver = new Wv(gt, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), yt && (!this.options.interpolation.format || this.options.interpolation.format === H.interpolation.format) && (_.formatter = tt(yt), _.formatter.init(_, this.options), this.options.interpolation.format = _.formatter.format.bind(_.formatter)), _.interpolator = new Hv(this.options), _.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, _.backendConnector = new Yv(tt(this.modules.backend), _.resourceStore, _, this.options), _.backendConnector.on("*", function(at) {
        for (var G = arguments.length, F = new Array(G > 1 ? G - 1 : 0), $ = 1; $ < G; $++)
          F[$ - 1] = arguments[$];
        r.emit(at, ...F);
      }), this.modules.languageDetector && (_.languageDetector = tt(this.modules.languageDetector), _.languageDetector.init && _.languageDetector.init(_, this.options.detection, this.options)), this.modules.i18nFormat && (_.i18nFormat = tt(this.modules.i18nFormat), _.i18nFormat.init && _.i18nFormat.init(this)), this.translator = new dh(this.services, this.options), this.translator.on("*", function(at) {
        for (var G = arguments.length, F = new Array(G > 1 ? G - 1 : 0), $ = 1; $ < G; $++)
          F[$ - 1] = arguments[$];
        r.emit(at, ...F);
      }), this.modules.external.forEach((at) => {
        at.init && at.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, B || (B = Bc), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const yt = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      yt.length > 0 && yt[0] !== "dev" && (this.options.lng = yt[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((yt) => {
      this[yt] = function() {
        return r.store[yt](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((yt) => {
      this[yt] = function() {
        return r.store[yt](...arguments), r;
      };
    });
    const ht = ul(), ut = () => {
      const yt = (gt, _) => {
        this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), ht.resolve(_), B(gt, _);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return yt(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, yt);
    };
    return this.options.resources || !this.options.initImmediate ? ut() : setTimeout(ut, 0), ht;
  }
  loadResources(r) {
    let B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Bc;
    const H = typeof r == "string" ? r : this.language;
    if (typeof r == "function" && (B = r), !this.options.resources || this.options.partialBundledLanguages) {
      if (H && H.toLowerCase() === "cimode")
        return B();
      const tt = [], st = (lt) => {
        if (!lt)
          return;
        this.services.languageUtils.toResolveHierarchy(lt).forEach((ut) => {
          tt.indexOf(ut) < 0 && tt.push(ut);
        });
      };
      H ? st(H) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((ht) => st(ht)), this.options.preload && this.options.preload.forEach((lt) => st(lt)), this.services.backendConnector.load(tt, this.options.ns, (lt) => {
        !lt && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), B(lt);
      });
    } else
      B(null);
  }
  reloadResources(r, f, B) {
    const H = ul();
    return r || (r = this.languages), f || (f = this.options.ns), B || (B = Bc), this.services.backendConnector.reload(r, f, (tt) => {
      H.resolve(), B(tt);
    }), H;
  }
  use(r) {
    if (!r)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!r.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return r.type === "backend" && (this.modules.backend = r), (r.type === "logger" || r.log && r.warn && r.error) && (this.modules.logger = r), r.type === "languageDetector" && (this.modules.languageDetector = r), r.type === "i18nFormat" && (this.modules.i18nFormat = r), r.type === "postProcessor" && Ng.addPostProcessor(r), r.type === "formatter" && (this.modules.formatter = r), r.type === "3rdParty" && this.modules.external.push(r), this;
  }
  setResolvedLanguage(r) {
    if (!(!r || !this.languages) && !(["cimode", "dev"].indexOf(r) > -1))
      for (let f = 0; f < this.languages.length; f++) {
        const B = this.languages[f];
        if (!(["cimode", "dev"].indexOf(B) > -1) && this.store.hasLanguageSomeTranslations(B)) {
          this.resolvedLanguage = B;
          break;
        }
      }
  }
  changeLanguage(r, f) {
    var B = this;
    this.isLanguageChangingTo = r;
    const H = ul();
    this.emit("languageChanging", r);
    const tt = (ht) => {
      this.language = ht, this.languages = this.services.languageUtils.toResolveHierarchy(ht), this.resolvedLanguage = void 0, this.setResolvedLanguage(ht);
    }, st = (ht, ut) => {
      ut ? (tt(ut), this.translator.changeLanguage(ut), this.isLanguageChangingTo = void 0, this.emit("languageChanged", ut), this.logger.log("languageChanged", ut)) : this.isLanguageChangingTo = void 0, H.resolve(function() {
        return B.t(...arguments);
      }), f && f(ht, function() {
        return B.t(...arguments);
      });
    }, lt = (ht) => {
      !r && !ht && this.services.languageDetector && (ht = []);
      const ut = typeof ht == "string" ? ht : this.services.languageUtils.getBestMatchFromCodes(ht);
      ut && (this.language || tt(ut), this.translator.language || this.translator.changeLanguage(ut), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(ut)), this.loadResources(ut, (yt) => {
        st(yt, ut);
      });
    };
    return !r && this.services.languageDetector && !this.services.languageDetector.async ? lt(this.services.languageDetector.detect()) : !r && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(lt) : this.services.languageDetector.detect(lt) : lt(r), H;
  }
  getFixedT(r, f, B) {
    var H = this;
    const tt = function(st, lt) {
      let ht;
      if (typeof lt != "object") {
        for (var ut = arguments.length, yt = new Array(ut > 2 ? ut - 2 : 0), gt = 2; gt < ut; gt++)
          yt[gt - 2] = arguments[gt];
        ht = H.options.overloadTranslationOptionHandler([st, lt].concat(yt));
      } else
        ht = Ut({}, lt);
      ht.lng = ht.lng || tt.lng, ht.lngs = ht.lngs || tt.lngs, ht.ns = ht.ns || tt.ns, ht.keyPrefix = ht.keyPrefix || B || tt.keyPrefix;
      const _ = H.options.keySeparator || ".";
      let at;
      return ht.keyPrefix && Array.isArray(st) ? at = st.map((G) => `${ht.keyPrefix}${_}${G}`) : at = ht.keyPrefix ? `${ht.keyPrefix}${_}${st}` : st, H.t(at, ht);
    };
    return typeof r == "string" ? tt.lng = r : tt.lngs = r, tt.ns = f, tt.keyPrefix = B, tt;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(r) {
    this.options.defaultNS = r;
  }
  hasLoadedNamespace(r) {
    let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const B = f.lng || this.resolvedLanguage || this.languages[0], H = this.options ? this.options.fallbackLng : !1, tt = this.languages[this.languages.length - 1];
    if (B.toLowerCase() === "cimode")
      return !0;
    const st = (lt, ht) => {
      const ut = this.services.backendConnector.state[`${lt}|${ht}`];
      return ut === -1 || ut === 2;
    };
    if (f.precheck) {
      const lt = f.precheck(this, st);
      if (lt !== void 0)
        return lt;
    }
    return !!(this.hasResourceBundle(B, r) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || st(B, r) && (!H || st(tt, r)));
  }
  loadNamespaces(r, f) {
    const B = ul();
    return this.options.ns ? (typeof r == "string" && (r = [r]), r.forEach((H) => {
      this.options.ns.indexOf(H) < 0 && this.options.ns.push(H);
    }), this.loadResources((H) => {
      B.resolve(), f && f(H);
    }), B) : (f && f(), Promise.resolve());
  }
  loadLanguages(r, f) {
    const B = ul();
    typeof r == "string" && (r = [r]);
    const H = this.options.preload || [], tt = r.filter((st) => H.indexOf(st) < 0);
    return tt.length ? (this.options.preload = H.concat(tt), this.loadResources((st) => {
      B.resolve(), f && f(st);
    }), B) : (f && f(), Promise.resolve());
  }
  dir(r) {
    if (r || (r = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !r)
      return "rtl";
    const f = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], B = this.services && this.services.languageUtils || new Ep(Dp());
    return f.indexOf(B.getLanguagePartFromCode(r)) > -1 || r.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = arguments.length > 1 ? arguments[1] : void 0;
    return new Sl(r, f);
  }
  cloneInstance() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Bc;
    const B = r.forkResourceStore;
    B && delete r.forkResourceStore;
    const H = oe(Ut(Ut({}, this.options), r), {
      isClone: !0
    }), tt = new Sl(H);
    return (r.debug !== void 0 || r.prefix !== void 0) && (tt.logger = tt.logger.clone(r)), ["store", "services", "language"].forEach((lt) => {
      tt[lt] = this[lt];
    }), tt.services = Ut({}, this.services), tt.services.utils = {
      hasLoadedNamespace: tt.hasLoadedNamespace.bind(tt)
    }, B && (tt.store = new Ap(this.store.data, H), tt.services.resourceStore = tt.store), tt.translator = new dh(tt.services, H), tt.translator.on("*", function(lt) {
      for (var ht = arguments.length, ut = new Array(ht > 1 ? ht - 1 : 0), yt = 1; yt < ht; yt++)
        ut[yt - 1] = arguments[yt];
      tt.emit(lt, ...ut);
    }), tt.init(H, f), tt.translator.options = H, tt.translator.backendConnector.services.utils = {
      hasLoadedNamespace: tt.hasLoadedNamespace.bind(tt)
    }, tt;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const zg = Sl.createInstance();
zg.createInstance = Sl.createInstance;
const $v = {
  error: "Error"
}, Zv = {
  error: "Помилка"
}, Rp = "common", Kv = {
  en: $v,
  uk: Zv
}, Vr = zg.createInstance({
  defaultNS: Rp,
  resources: qv(Kv, Rp),
  lng: "en",
  fallbackLng: "en"
}), _d = {
  i18nextInstance: Vr,
  initPromise: Vr.init().then(() => Vr)
}, Qc = /* @__PURE__ */ new Map();
Qc.set("common", _d);
const Fg = (t) => {
  if (Qc.has(t.namespace))
    return Qc.get(t.namespace);
  if (t.plugins)
    for (const tt of t.plugins)
      Vr.use(tt);
  Object.keys(t.resource).forEach((tt) => {
    Vr.addResourceBundle(tt, t.namespace, t.resource[tt]);
  });
  const r = Vr.cloneInstance({
    defaultNS: t.namespace
  });
  let f = _d.initPromise.then(() => r);
  r.on("languageChanged", (tt) => {
    Vr.language !== tt && Vr.changeLanguage(tt);
  }), Vr.on("languageChanged", (tt) => {
    r.language !== tt && r.changeLanguage(tt);
  });
  const B = t.language || "en";
  Vr.language !== B && (f = f.then(() => r.changeLanguage(B)).then(() => r));
  const H = { initPromise: f, i18nextInstance: r };
  return Qc.set(t.namespace, H), H;
};
function qv(t, r) {
  return Object.keys(t).reduce((f, B) => (f[B] = {
    [r]: t[B]
  }, f), {});
}
class Wg extends Error {
  constructor(r, f, B) {
    const { key: H, interpolationOptions: tt } = f, st = B || _d.i18nextInstance.t, lt = Object.assign(Object.assign({}, tt), { ns: r }), ht = st(H, Object.assign(Object.assign({}, lt), { lng: "en" }));
    super(ht), this.key = H, this.namespace = r, this.interpolationOptions = lt;
  }
}
var Nc = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Hg(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function zL(t) {
  if (t.__esModule)
    return t;
  var r = t.default;
  if (typeof r == "function") {
    var f = function B() {
      return this instanceof B ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    f.prototype = r.prototype;
  } else
    f = {};
  return Object.defineProperty(f, "__esModule", { value: !0 }), Object.keys(t).forEach(function(B) {
    var H = Object.getOwnPropertyDescriptor(t, B);
    Object.defineProperty(f, B, H.get ? H : {
      enumerable: !0,
      get: function() {
        return t[B];
      }
    });
  }), f;
}
function Jv() {
  if (console && console.warn) {
    for (var t = arguments.length, r = new Array(t), f = 0; f < t; f++)
      r[f] = arguments[f];
    typeof r[0] == "string" && (r[0] = `react-i18next:: ${r[0]}`), console.warn(...r);
  }
}
const jp = {};
function id() {
  for (var t = arguments.length, r = new Array(t), f = 0; f < t; f++)
    r[f] = arguments[f];
  typeof r[0] == "string" && jp[r[0]] || (typeof r[0] == "string" && (jp[r[0]] = /* @__PURE__ */ new Date()), Jv(...r));
}
const Ug = (t, r) => () => {
  if (t.isInitialized)
    r();
  else {
    const f = () => {
      setTimeout(() => {
        t.off("initialized", f);
      }, 0), r();
    };
    t.on("initialized", f);
  }
};
function _p(t, r, f) {
  t.loadNamespaces(r, Ug(t, f));
}
function Bp(t, r, f, B) {
  typeof f == "string" && (f = [f]), f.forEach((H) => {
    t.options.ns.indexOf(H) < 0 && t.options.ns.push(H);
  }), t.loadLanguages(r, Ug(t, B));
}
function Qv(t, r) {
  let f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const B = r.languages[0], H = r.options ? r.options.fallbackLng : !1, tt = r.languages[r.languages.length - 1];
  if (B.toLowerCase() === "cimode")
    return !0;
  const st = (lt, ht) => {
    const ut = r.services.backendConnector.state[`${lt}|${ht}`];
    return ut === -1 || ut === 2;
  };
  return f.bindI18n && f.bindI18n.indexOf("languageChanging") > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !st(r.isLanguageChangingTo, t) ? !1 : !!(r.hasResourceBundle(B, t) || !r.services.backendConnector.backend || r.options.resources && !r.options.partialBundledLanguages || st(B, t) && (!H || st(tt, t)));
}
function t0(t, r) {
  let f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !r.languages || !r.languages.length ? (id("i18n.languages were undefined or empty", r.languages), !0) : r.options.ignoreJSONStructure !== void 0 ? r.hasLoadedNamespace(t, {
    lng: f.lng,
    precheck: (H, tt) => {
      if (f.bindI18n && f.bindI18n.indexOf("languageChanging") > -1 && H.services.backendConnector.backend && H.isLanguageChangingTo && !tt(H.isLanguageChangingTo, t))
        return !1;
    }
  }) : Qv(t, r, f);
}
const e0 = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, i0 = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, r0 = (t) => i0[t], n0 = (t) => t.replace(e0, r0);
let rd = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: n0
};
function o0() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  rd = Ut(Ut({}, rd), t);
}
function s0() {
  return rd;
}
let Gg;
function a0(t) {
  Gg = t;
}
function l0() {
  return Gg;
}
const c0 = {
  type: "3rdParty",
  init(t) {
    o0(t.options.react), a0(t);
  }
}, h0 = Tv();
class u0 {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(r) {
    r.forEach((f) => {
      this.usedNamespaces[f] || (this.usedNamespaces[f] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const d0 = (t, r) => {
  const f = td();
  return ed(() => {
    f.current = t;
  }, [t, r]), f.current;
};
function Xg(t) {
  let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: f
  } = r, {
    i18n: B,
    defaultNS: H
  } = Mv(h0) || {}, tt = f || B || l0();
  if (tt && !tt.reportNamespaces && (tt.reportNamespaces = new u0()), !tt) {
    id("You will need to pass in an i18next instance by using initReactI18next");
    const Q = (U, N) => typeof N == "string" ? N : N && typeof N == "object" && typeof N.defaultValue == "string" ? N.defaultValue : Array.isArray(U) ? U[U.length - 1] : U, q = [Q, {}, !1];
    return q.t = Q, q.i18n = {}, q.ready = !1, q;
  }
  tt.options.react && tt.options.react.wait !== void 0 && id("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const st = Ut(Ut(Ut({}, s0()), tt.options.react), r), {
    useSuspense: lt,
    keyPrefix: ht
  } = st;
  let ut = H || tt.options && tt.options.defaultNS;
  ut = typeof ut == "string" ? [ut] : ut || ["translation"], tt.reportNamespaces.addUsedNamespaces && tt.reportNamespaces.addUsedNamespaces(ut);
  const yt = (tt.isInitialized || tt.initializedStoreOnce) && ut.every((Q) => t0(Q, tt, st));
  function gt() {
    return tt.getFixedT(r.lng || null, st.nsMode === "fallback" ? ut : ut[0], ht);
  }
  const [_, at] = Av(gt);
  let G = ut.join();
  r.lng && (G = `${r.lng}${G}`);
  const F = d0(G), $ = td(!0);
  ed(() => {
    const {
      bindI18n: Q,
      bindI18nStore: q
    } = st;
    $.current = !0, !yt && !lt && (r.lng ? Bp(tt, r.lng, ut, () => {
      $.current && at(gt);
    }) : _p(tt, ut, () => {
      $.current && at(gt);
    })), yt && F && F !== G && $.current && at(gt);
    function U() {
      $.current && at(gt);
    }
    return Q && tt && tt.on(Q, U), q && tt && tt.store.on(q, U), () => {
      $.current = !1, Q && tt && Q.split(" ").forEach((N) => tt.off(N, U)), q && tt && q.split(" ").forEach((N) => tt.store.off(N, U));
    };
  }, [tt, G]);
  const Y = td(!0);
  ed(() => {
    $.current && !Y.current && at(gt), Y.current = !1;
  }, [tt, ht]);
  const J = [_, tt, yt];
  if (J.t = _, J.i18n = tt, J.ready = yt, yt || !yt && !lt)
    return J;
  throw new Promise((Q) => {
    r.lng ? Bp(tt, r.lng, ut, () => Q()) : _p(tt, ut, () => Q());
  });
}
const p0 = {
  errors: {
    noSisenseContext: "Sisense context is not initialized",
    componentRenderError: "Unable to render the component",
    sisenseContextNoAuthentication: "Authentication method is not specified",
    chartNoSisenseContext: "Sisense Context for Chart not found. To fix, add a dataSet to the Chart or wrap the component inside a Sisense context provider.",
    dashboardWidgetNoSisenseContext: "Sisense Context for Dashboard Widget not found. To fix, wrap the component inside a Sisense context provider.",
    dashboardWidgetInvalidIdentifiers: "Failed to retrieve widget. Please make sure the dashboard widget exists and is accessible.",
    dashboardWidgetsInvalidIdentifiers: "Failed to retrieve dashboard widgets. Please make sure the dashboard exists and is accessible.",
    executeQueryNoSisenseContext: "Sisense Context for query execution not found. To fix, wrap the component inside a Sisense context provider.",
    executeQueryNoDataSource: "No dataSource provided to execute query",
    dataOptions: {
      noDimensionsAndMeasures: "Neither dimensions nor measures found. Data options should have at least one dimension or measure.",
      attributeNotFound: 'Attribute "{{attributeName}}" not found in the data',
      measureNotFound: 'Measure "{{measureName}}" not found in the data',
      filterAttributeNotFound: 'Filter attribute "{{attributeName}}" not found in the data',
      highlightAttributeNotFound: 'Highlight attribute "{{attributeName}}" not found in the data'
    },
    themeNotFound: "Theme with oid {{themeOid}} not found in the Sisense instance",
    paletteNotFound: "Palette '{{paletteName}}' not found in the Sisense instance",
    chartTypeNotSupported: "Chart type {{chartType}} is not supported",
    chartInvalidProps: "Invalid chart props",
    unsupportedWidgetType: "Can't extract props for unsupported widget type - {{widgetType}}",
    sisenseContextNotFound: "Sisense Context not found. Please ensure it is provided.",
    dashboardInvalidIdentifier: "Failed to retrieve dashboard. Please make sure the dashboard exists and is accessible.",
    sharedFormula: {
      identifierExpected: "Failed to identify shared formula. Please provide oid or both name and datasource",
      failedToFetch: "Failed to fetch shared formula"
    },
    widgetModel: {
      pivotWidgetNotSupported: "Pivot widget is not supported for method {{methodName}}",
      textWidgetNotSupported: "Text widget is not supported for method {{methodName}}",
      onlyTableWidgetSupported: "Only table widget is supported for method {{methodName}}",
      onlyPivotWidgetSupported: "Only pivot widget is supported for method {{methodName}}",
      onlyTextWidgetSupported: "Only text widget is supported for method {{methodName}}",
      onlyPluginWidgetSupported: "Only plugin widget is supported for method {{methodName}}"
    },
    unknownFilterInFilterRelations: "Filter relations contain unknown filter",
    filterRelationsNotSupported: "Filter relations not supported yet",
    invalidFilterType: "Invalid filter type",
    secondsDateTimeLevelSupportedOnlyForLive: "Seconds datetime level is supported only for the 'live' datasource",
    missingMenuRoot: "Missing initialized menu root",
    missingDataSource: "The 'dataSource' value is missing. It must be provided explicitly, or a 'defaultDataSource' should be specified in the Sisense context provider.",
    incorrectOnDataReadyHandler: "'onDataReady' handler must return a valid data object",
    undefinedDataSource: "Data source is not defined",
    emptyModel: "Empty model",
    missingMetadata: "Missing metadata",
    missingModelTitle: "Missing model title",
    httpClientNotFound: "HttpClient not found.",
    serverSettingsNotLoaded: "Failed to load server settings",
    requiredColumnMissing: "Missing required column",
    unexpectedChartType: "Unexpected chart type: {{chartType}}",
    noRowNumColumn: "Data has no row num column",
    ticIntervalCalculationFailed: "Unable to calculate tic interval. Try specifying datetime granularity.",
    polarChartDesignOptionsExpected: "Polar chart design options expected for polar chart",
    polarChartDesignOptionsNotExpected: "Polar chart design options not expected for non-polar chart",
    indicatorInvalidRelativeSize: "Invalid relative size options",
    unsupportedMapType: "Unsupported map type: {{mapType}}",
    mapLoadingFailed: "Failed loading map",
    cascadingFilterOriginalNotFound: "Error in cascading filters reassembling. Original cascading filter not found",
    dashboardLoadFailed: "Failed to load Dashboard",
    dashboardWithOidNotFound: "Dashboard with oid {{dashboardOid}} not found",
    widgetWithOidNotFound: "Widget with oid {{widgetOid}} not found",
    widgetEmptyResponse: "Empty response for widget with oid {{widgetOid}}",
    dateFilterIncorrectOperator: "Incorrect operator: {{operator}}",
    synchronizedFilterInvalidProps: "`useSynchronizedFilter` hook must take at least one of [non-null `filterFromProps`] or [`createEmptyFilter` function]",
    methodNotImplemented: "Method not implemented.",
    noPivotClient: "Pivot client not initialized",
    unexpectedCacheValue: "Unexpected cache value",
    notAMembersFilter: "Filter is not a MembersFilter",
    drilldownNoInitialDimension: "Initial dimension has to be specified to use drilldown with custom components"
  },
  errorBoxText: "$t(common:error): {{errorMessage}}",
  chartNoData: "No Results",
  filters: "Filters",
  widgetDetails: "Widget Details",
  cancel: "Cancel",
  includeAll: "Include all",
  criteriaFilter: {
    displayModePrefix: "All items",
    equals: "Equals {{val}}",
    notEquals: "Does not equal {{val}}",
    lessThan: "Less than {{val}}",
    lessThanOrEqual: "Less than or equal to {{val}}",
    greaterThan: "Greater than {{val}}",
    greaterThanOrEqual: "Greater than or equal to {{val}}",
    between: "Between {{valA}} and {{valB}}",
    notBetween: "Not between {{valA}} and {{valB}}",
    top: "Top {{valA}} by {{valB}}",
    bottom: "Last {{valA}} by {{valB}}",
    is: "Is {{val}}",
    isNot: "Is not {{val}}",
    contains: "Contains {{val}}",
    notContains: "Doesn't contain {{val}}",
    startsWith: "Starts with {{val}}",
    notStartsWith: "Doesn't start with {{val}}",
    endsWith: "Ends with {{val}}",
    notEndsWith: "Doesn't end with {{val}}",
    like: "Is like {{val}}",
    byMeasure: "By measure",
    by: "by"
  },
  dateFilter: {
    last: "Last",
    next: "Next",
    from: "From",
    to: "To",
    count: "Count",
    select: "Select",
    today: "Today",
    days: "Days",
    weeks: "Weeks",
    months: "Months",
    quarters: "Quarters",
    years: "Years",
    earliestDate: "Earliest Date",
    latestDate: "Latest Date",
    todayOutOfRange: "Today is out of available date range",
    dateRange: {
      fromTo: "{{from}} to {{to}}",
      from: "From {{val}}",
      to: "To {{val}}"
    }
  },
  boxplot: {
    tooltip: {
      whiskers: "Whiskers",
      box: "Box",
      min: "Min",
      median: "Median",
      max: "Max"
    }
  },
  advanced: {
    tooltip: {
      min: "Lower Bound",
      max: "Upper Bound",
      forecastValue: "Forecast Value",
      forecast: "Forecast",
      trend: "Trend",
      trendLocalValue: "Local Value",
      confidenceInterval: "Confidence Interval",
      trendType: "Type",
      trendDataKey: "Trend Data",
      trendData: {
        min: "Min",
        max: "Max",
        median: "Median",
        average: "Average"
      }
    }
  },
  arearange: {
    tooltip: {
      min: "Min",
      max: "Max"
    }
  },
  unsupportedFilterMessage: "Unsupported Filter (applied to the data query)",
  unsupportedFilter: "Unsupported filter {{filter}}",
  commonFilter: {
    clearSelectionButton: "Clear Selection",
    selectMenuItem: "Select",
    unselectMenuItem: "Un-Select"
  },
  customFilterTileMessage: "filtered with custom filter",
  drilldown: {
    drillMenuItem: "Drill",
    breadcrumbsAllSuffix: "All",
    breadcrumbsPrev: "Prev",
    breadcrumbsNext: "Next",
    popover: {
      members: "Members",
      table: "Table",
      column: "Column"
    }
  },
  widgetHeader: {
    info: {
      details: "Widget Details",
      tooltip: "Click to view full details"
    }
  },
  plugins: {
    registerPrompt: "Unknown plugin type: {{pluginType}}. Please register this plugin so it can be rendered."
  },
  ai: {
    analyticsChatbot: "Analytics Chatbot",
    dataTopics: "Data Topics",
    chatbotDescription: "Analytics Chatbot is designed to help you interact with your data using natural language.",
    topicSelectPrompt: "Pick a topic you would like to explore:",
    betaLabel: "Beta",
    preview: "Preview",
    clearHistoryPrompt: "Do you want to clear this chat?",
    config: {
      inputPromptText: 'Ask a question or type "/" for ideas',
      welcomeText: "Welcome to the Analytics Assistant! I can help you explore and gain insights from your data.",
      suggestionsWelcomeText: "Some questions you may have:"
    },
    buttons: {
      insights: "Insights",
      correctResponse: "Correct response",
      incorrectResponse: "Incorrect response",
      clearChat: "Clear chat",
      refresh: "Refresh",
      readMore: "Read more",
      collapse: "Collapse",
      yes: "Yes",
      no: "No",
      seeMore: "See more"
    },
    disclaimer: {
      poweredByAi: "Content is powered by AI, so surprises and mistakes are possible.",
      rateRequest: "Please rate responses so we can improve!"
    },
    errors: {
      chatUnavailable: "Chat unavailable. Please try again later.",
      fetchHistory: "Something went wrong and we were unable to retrieve the chat thread. Let's start over!",
      recommendationsNotAvailable: "Recommendations aren't available right now. Try again in a few minutes.",
      insightsNotAvailable: "No insights available.",
      unexpectedChatResponse: "Oh snap, something went wrong. Please try again later or try asking a different question.",
      unexpected: "Oh snap, something went wrong. Please try again later.",
      unknownResponse: "Received unknown responseType, raw response=",
      invalidInput: "Invalid input",
      noAvailableDataTopics: "None of the provided data models or perspectives are available"
    }
  }
}, f0 = {
  errors: {
    noSisenseContext: "Контекст Sisense не ініціалізовано",
    componentRenderError: "Не вдалося відобразити компонент",
    sisenseContextNoAuthentication: "Не вказано метод аутентифікації",
    chartNoSisenseContext: "Контекст Sisense для діаграми не знайдено. Щоб виправити, додайте набір даних до Chart або оберніть компонент у SisenseContextProvider.",
    dashboardWidgetNoSisenseContext: "Контекст Sisense для віджета дашборди не знайдено. Щоб виправити, оберніть компонент у SisenseContextProvider.",
    dashboardWidgetInvalidIdentifiers: "Не вдалося отримати віджет. Переконайтеся, що віджет дашборди існує і доступний.",
    dashboardWidgetsInvalidIdentifiers: "Не вдалося отримати віджети дашборди. Переконайтеся, що дашборда існує і доступна.",
    executeQueryNoSisenseContext: "Контекст Sisense для виконання запиту не знайдено. Щоб виправити, оберніть компонент у SisenseContextProvider.",
    executeQueryNoDataSource: "Не надано dataSource для виконання запиту",
    dataOptions: {
      noDimensionsAndMeasures: "Не знайдено ні dimension-ів, ні measure-ів. Параметри даних повинні мати щонайменше один dimension або measure.",
      attributeNotFound: 'Атрибут "{{attributeName}}" не знайдено в даних',
      measureNotFound: 'Measure "{{measureName}}" не знайдено в даних',
      filterAttributeNotFound: 'Атрибут фільтра "{{attributeName}}" не знайдено в даних',
      highlightAttributeNotFound: 'Атрибут виділення "{{attributeName}}" не знайдено в даних'
    },
    themeNotFound: "Тему з oid {{themeOid}} не знайдено на Sisense-сервері",
    paletteNotFound: 'Палітру "{{paletteName}}" не знайдено на Sisense-сервері',
    chartTypeNotSupported: "Тип діаграми {{chartType}} не підтримується",
    chartInvalidProps: "Недійсні параметри діаграми",
    unsupportedWidgetType: "Неможливо отримати властивості для непідтримуваного типу віджета - {{widgetType}}",
    sisenseContextNotFound: "Контекст Sisense не знайдено. Переконайтеся, що він наданий.",
    dashboardInvalidIdentifier: "Не вдалося отримати дашборд. Переконайтеся, що дашборд існує і доступний.",
    sharedFormula: {
      identifierExpected: "Не вдалося ідентифікувати загальну формулу. Будь ласка, надайте oid або пару name та datasource",
      failedToFetch: "Не вдалося отримати спільну формулу"
    },
    widgetModel: {
      pivotWidgetNotSupported: "Метод {{methodName}} не підтримується для півот віджету",
      textWidgetNotSupported: "Метод {{methodName}} не підтримується для текстового віджету",
      onlyTableWidgetSupported: "Метод {{methodName}} підтримується тільки для табличних віджетів",
      onlyPivotWidgetSupported: "Метод {{methodName}} підтримується тільки для півот віджетів",
      onlyTextWidgetSupported: "Метод {{methodName}} підтримується тільки для текстових віджетів",
      onlyPluginWidgetSupported: "Метод {{methodName}} підтримується тільки для плагінних віджетів"
    },
    unknownFilterInFilterRelations: "Логічні відношення фільтрів містять невідомий фільтр",
    filterRelationsNotSupported: "Відносини фільтрів ще не підтримуються",
    invalidFilterType: "Недійсний тип фільтра",
    secondsDateTimeLevelSupportedOnlyForLive: "Рівень часу в секундах підтримується лише для 'live' джерела даних",
    missingMenuRoot: "Відсутній ініціалізований корінь меню",
    missingDataSource: "Значення 'dataSource' відсутнє. Воно має бути передано явно, або 'defaultDataSource' має бути вказано в SisenseContextProvider.",
    incorrectOnDataReadyHandler: "'onDataReady' має повертати дійсний об'єкт даних",
    undefinedDataSource: "Не задане джерело даних",
    emptyModel: "Пуста модель",
    missingMetadata: "Поле metadata відсутнє",
    missingModelTitle: "Не знайдено заголовоку моделі",
    httpClientNotFound: "HttpClient не знайдено",
    serverSettingsNotLoaded: "Failed to load server settings",
    requiredColumnMissing: "Відсутній обов’язковий стовпець",
    unexpectedChartType: "Невідомий тип графіка: {{chartType}}",
    noRowNumColumn: "Дані не містять row num column",
    ticIntervalCalculationFailed: "Неможливо обрахувати tic interval. Спробуйте задати datetime granularity.",
    polarChartDesignOptionsExpected: "Polar chart design options очікуються для polar chart",
    polarChartDesignOptionsNotExpected: "Polar chart design options не очікуються для non-polar chart",
    indicatorInvalidRelativeSize: "Невірні опції relative size",
    unsupportedMapType: "Непідтримуваний тип мапи: {{mapType}}",
    mapLoadingFailed: "Не вдалося завантажити мапу",
    cascadingFilterOriginalNotFound: "Помилка при реструктуризації каскадних фільтрів. Оригінальний фільтр не знайдено",
    dashboardLoadFailed: "Не вдалося завантажити Dashboard",
    dashboardWithOidNotFound: "Dashboard з oid {{dashboardOid}} не знайдено",
    widgetWithOidNotFound: "Віджет з oid {{widgetOid}} не знайдено",
    widgetEmptyResponse: "Пуста відповідь для віджета з oid {{widgetOid}}",
    dateFilterIncorrectOperator: "Некорректний оператор: {{operator}}",
    synchronizedFilterInvalidProps: "`useSynchronizedFilter` хук потребує одне з [non-null `filterFromProps`] чи [`createEmptyFilter` function]",
    methodNotImplemented: "Метод не реалізовано.",
    noPivotClient: "Pivot client не ініціалізовано",
    unexpectedCacheValue: "Неочікуване значення кешу",
    notAMembersFilter: "Фільтр не є MembersFilter",
    drilldownNoInitialDimension: "Initial dimension має бути задано щоб використовувати drilldown з користувацькими компонентами"
  },
  errorBoxText: "$t(common:error): {{errorMessage}}",
  chartNoData: "Результатів немає",
  filters: "Фільтри",
  widgetDetails: "Деталі віджета",
  cancel: "Відміна",
  includeAll: "Всі елементи",
  criteriaFilter: {
    displayModePrefix: "Всі елементи",
    equals: "Дорівнює {{val}}",
    notEquals: "Не дорівнює {{val}}",
    lessThan: "Менше ніж {{val}}",
    lessThanOrEqual: "Менше або дорівнює {{val}}",
    greaterThan: "Більше ніж {{val}}",
    greaterThanOrEqual: "Більше або дорівнює {{val}}",
    between: "Між {{valA}} та {{valB}}",
    notBetween: "Не між {{valA}} та {{valB}}",
    top: "Перші {{valA}} за {{valB}}",
    bottom: "Останні {{valA}} за {{valB}}",
    is: "Є {{val}}",
    isNot: "Не є {{val}}",
    contains: "Містить {{val}}",
    notContains: "Не містить {{val}}",
    startsWith: "Починається з {{val}}",
    notStartsWith: "Не починається з {{val}}",
    endsWith: "Закінчується на {{val}}",
    notEndsWith: "Не закінчується на {{val}}",
    like: "Схоже на {{val}}",
    byMeasure: "By measure",
    by: "by"
  },
  dateFilter: {
    last: "Останній",
    next: "Наступний",
    from: "Від",
    to: "До",
    count: "Кількість",
    select: "Вибрати",
    today: "Сьогодні",
    days: "Дні",
    weeks: "Тижні",
    months: "Місяці",
    quarters: "Квартали",
    years: "Роки",
    earliestDate: "Найбільш Рання Дата",
    latestDate: "Найбільш Пізня Дата",
    todayOutOfRange: "Сьогоднішній день поза доступним діапазоном дат",
    dateRange: {
      fromTo: "{{from}} до {{to}}",
      from: "Від {{val}}",
      to: "До {{val}}"
    }
  },
  boxplot: {
    tooltip: {
      whiskers: "Вуса",
      box: "Коробка",
      min: "Мінімум",
      median: "Медіана",
      max: "Максимум"
    }
  },
  advanced: {
    tooltip: {
      min: "Lower Bound",
      max: "Upper Bound",
      forecastValue: "Forecast Value",
      forecast: "Forecast",
      trend: "Trend",
      trendLocalValue: "Local Value",
      confidenceInterval: "Confidence Interval",
      trendType: "Type",
      trendDataKey: "Trend Data",
      trendData: {
        min: "Min",
        max: "Max",
        median: "Median",
        average: "Average"
      }
    }
  },
  arearange: {
    tooltip: {
      min: "Мінімум",
      max: "Максимум"
    }
  },
  unsupportedFilterMessage: "Непідтримуваний Фільтр (застосовано до запиту даних)",
  unsupportedFilter: "Непідтримуваний фільтр {{filter}}",
  commonFilter: {
    clearSelectionButton: "Очистити виділення",
    selectMenuItem: "Вибрати",
    unselectMenuItem: "Cкасувати вибір"
  },
  customFilterTileMessage: "застосовано користувацький фільтр",
  drilldown: {
    drillMenuItem: "Деталізація",
    breadcrumbsAllSuffix: "Все",
    breadcrumbsPrev: "Попередній",
    breadcrumbsNext: "Наступний",
    popover: {
      members: "Учасники",
      table: "Таблиця",
      column: "Колонка"
    }
  },
  widgetHeader: {
    info: {
      details: "Деталі віджета",
      tooltip: "Натисніть щоб побачити повну інформацію"
    }
  },
  plugins: {
    registerPrompt: "Невідомий плагін: {{pluginType}}. Будь ласка зареєструйте цей плагін щоб він міг бути відображений."
  },
  ai: {
    analyticsChatbot: "Аналітичний чат-бот",
    dataTopics: "Теми Даних",
    chatbotDescription: "Аналітичний чат-бот розроблено, щоб допомогти вам взаємодіяти з вашими даними за допомогою розмовної мови.",
    topicSelectPrompt: "Виберіть тему, яку б ви хотіли дослідити:",
    betaLabel: "Бета",
    preview: "Попередній перегляд",
    clearHistoryPrompt: "Ви дійсно хочете очистити чат?",
    config: {
      inputPromptText: "Поставте запитання або введіть «/» для отримання ідей",
      welcomeText: "Вітаємо в Аналітичному помічнику! Я можу допомогти вам досліджувати та зрозуміти ваші дані.",
      suggestionsWelcomeText: "Деякі запитання, які у вас можуть виникнути:"
    },
    buttons: {
      insights: "Інсайти",
      correctResponse: "Коректна відповідь",
      incorrectResponse: "Некоректна відповідь",
      clearChat: "Очистити чат",
      refresh: "Оновити",
      readMore: "Читати ще",
      collapse: "Згорнути",
      yes: "Так",
      no: "Ні",
      seeMore: "Більше"
    },
    disclaimer: {
      poweredByAi: "Вміст створено за допомогою ШІ, тому можливі несподіванки та помилки.",
      rateRequest: " Будь ласка, оцінюйте відповіді, щоб ми могли покращити продукт!"
    },
    errors: {
      chatUnavailable: "Чат недоступний. Спробуйте пізніше.",
      fetchHistory: "Щось пішло не так, і ми не змогли відновити історію чату. Почнімо спочатку!",
      recommendationsNotAvailable: "Наразі рекомендації недоступні. Спробуйте ще раз через кілька хвилин.",
      insightsNotAvailable: "Немає доступних інсайтів.",
      unexpectedChatResponse: "Ой, щось пішло не так. Повторіть спробу пізніше або спробуйте поставити інше запитання.",
      unexpected: "Ой, лихо! Шось йому стало. Спробуйте трохи пізніше.",
      unknownResponse: "Отримано невідомий тип відповіді, необроблена відповідь=",
      invalidInput: "Недійсне введення",
      noAvailableDataTopics: "Жодне з наданих моделей даних або перспектив доступне"
    }
  }
}, Yg = "sdkUi", g0 = {
  en: p0,
  uk: f0
};
function m0() {
  return Fg({
    resource: g0,
    plugins: [c0],
    language: "en",
    namespace: Yg
  });
}
const { i18nextInstance: y0 } = m0(), Np = (t) => {
  if (typeof t == "object" && t !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      const r = Object.getPrototypeOf(t);
      return r === Object.prototype || r === null;
    }
    return Object.prototype.toString.call(t) === "[object Object]";
  }
  return !1;
}, Or = (...t) => t.reduce((r, f) => {
  if (Array.isArray(f))
    throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
  return Object.keys(f).forEach((B) => {
    ["__proto__", "constructor", "prototype"].includes(B) || (Array.isArray(r[B]) && Array.isArray(f[B]) ? r[B] = Or.options.mergeArrays ? Array.from(new Set(r[B].concat(f[B]))) : f[B] : Np(r[B]) && Np(f[B]) ? r[B] = Or(r[B], f[B]) : r[B] = f[B]);
  }), r;
}, {}), Vg = {
  mergeArrays: !0
};
Or.options = Vg;
Or.withOptions = (t, ...r) => {
  Or.options = Object.assign({ mergeArrays: !0 }, t);
  const f = Or(...r);
  return Or.options = Vg, f;
};
const v0 = {
  errors: {
    measure: {
      unsupportedType: "Unsupported measure type",
      dimensionalCalculatedMeasure: {
        noContext: "DimensionalCalculatedMeasure must have 'context' property"
      },
      dimensionalBaseMeasure: {
        noAttributeDimExpression: "DimensionalBaseMeasure must have 'attribute'/'dim'/'expression' property",
        noAggAggregation: "DimensionalBaseMeasure must have 'agg' or 'aggregation' property"
      },
      notAFormula: "Jaql is not a formula"
    },
    dataModelConfig: {
      noName: "'name' must be specified in config for DataModel",
      noMetadata: "'metadata' must be specified in config for DataModel"
    },
    filter: {
      unsupportedType: "Unsupported filter type: {{filterType}}",
      unsupportedDatetimeLevel: 'Filters do not support the next "datetime" levels: Hours, MinutesRoundTo30, MinutesRoundTo15, Minutes, Seconds',
      membersFilterNullMember: "MembersFilter of {{attributeId}} - member cannot be null",
      unsupportedConditionFilter: "Jaql contains unsupported condition filter: {{filter}}",
      formulaFiltersNotSupported: "Formula-based filter not supported yet: {{filter}}"
    },
    unsupportedDimensionalElement: "Unsupported dimensional element type"
  }
}, b0 = {
  errors: {
    measure: {
      unsupportedType: "Непідтримуваний тип measure",
      dimensionalCalculatedMeasure: {
        noContext: "DimensionalCalculatedMeasure має мати властивість 'context'"
      },
      dimensionalBaseMeasure: {
        noAttributeDimExpression: "DimensionalBaseMeasure має мати властивість 'attribute'/'dim'/'expression'",
        noAggAggregation: "DimensionalBaseMeasure має мати властивість 'agg' або 'aggregation'"
      },
      notAFormula: "Jaql не формула"
    },
    dataModelConfig: {
      noName: "'name' має бути вказано в конфігурації для DataModel",
      noMetadata: "'metadata' має бути вказано в конфігурації для DataModel"
    },
    filter: {
      unsupportedType: "Непідтримуваний тип фільтра: {{filterType}}",
      unsupportedDatetimeLevel: 'Фільтри не підтримують наступні рівні "datetime": Hours, MinutesRoundTo30, MinutesRoundTo15, Minutes, Seconds',
      membersFilterNullMember: "MembersFilter у {{attributeId}} - member не може бути нульовим",
      unsupportedConditionFilter: "Jaql містить непідтримуваний condition фільтр: {{filter}}",
      formulaFiltersNotSupported: "Фільтри, що містять формули наразі не підтримуються: {{filter}}"
    },
    unsupportedDimensionalElement: "Непідтримуваний тип елемента"
  }
}, $g = "sdkData", x0 = {
  en: v0,
  uk: b0
};
function S0() {
  return Fg({
    resource: x0,
    language: "en",
    namespace: $g
  });
}
const { i18nextInstance: w0 } = S0(), oi = {
  /** Sum aggregation type */
  Sum: "sum",
  /** Average aggregation type */
  Average: "avg",
  /** Min aggregation type */
  Min: "min",
  /** Max aggregation type */
  Max: "max",
  /** Count aggregation type */
  Count: "count",
  /** Count distinct aggregation type */
  CountDistinct: "countDistinct",
  /** Median aggregation type */
  Median: "median",
  /** Variance aggregation type */
  Variance: "var",
  /** Standard deviation aggregation type */
  StandardDeviation: "stdev"
};
var di;
(function(t) {
  t[t.None = 0] = "None", t[t.Ascending = 1] = "Ascending", t[t.Descending = 2] = "Descending";
})(di = di || (di = {}));
const De = {
  Measure: "measure",
  MeasureTemplate: "measuretemplate",
  BaseMeasure: "basemeasure",
  CalculatedMeasure: "calculatedmeasure",
  Dimension: "dimension",
  DateDimension: "datedimension",
  TextDimension: "textdimension",
  NumericDimension: "numericdimension",
  DateLevel: "datelevel",
  Attribute: "attribute",
  TextAttribute: "text-attribute",
  NumericAttribute: "numeric-attribute",
  Filter: "filter",
  DimensionFilter: "dimensionfilter",
  MeasureFilter: "measurefilter",
  /**
   * Checks whether the given object or type is a metadata element
   *
   * @param o - object to check
   * @returns true if the object or type is a metadata element
   */
  isMetadata(t) {
    return De.isMeasure(t) || De.isDimension(t) || De.isAttribute(t) || De.isFilter(t);
  },
  /**
   * Checks whether the given object or type is a measure template
   *
   * @param o - object to check
   * @returns true if the object or type is a measure template
   */
  isMeasureTemplate(t) {
    return t ? typeof t == "string" ? t.toLowerCase() === De.MeasureTemplate : t.agg === "*" || t.aggregation === "*" || t.type && t.type.toLowerCase() === De.MeasureTemplate : !1;
  },
  /**
   * Checks whether the given object or type is a base measure
   *
   * @param o - object to check
   * @returns true if the object or type is a base measure
   */
  isBaseMeasure(t) {
    return t ? typeof t == "string" ? t.toLowerCase() === De.BaseMeasure : (t.agg || t.aggregation) && t.attribute && !this.isMeasureTemplate(t) : !1;
  },
  /**
   * Checks whether the given object or type is a measure - of any type
   *
   * @param o - object to check
   * @returns true if the object or type is a measure - of any type
   */
  isMeasure(t) {
    if (!t)
      return !1;
    if (typeof t == "string") {
      const r = t;
      return r.toLowerCase() === De.Measure || r.toLowerCase() === De.BaseMeasure || r.toLowerCase() === De.MeasureTemplate || r.toLowerCase() === De.CalculatedMeasure;
    }
    return this.isBaseMeasure(t) || this.isCalculatedMeasure(t) || this.isMeasureTemplate(t);
  },
  /**
   * Checks whether the given object or type is a calculated measure
   *
   * @param o - object to check
   * @returns true if the object or type is a calculated measure
   */
  isCalculatedMeasure(t) {
    return t ? typeof t == "string" ? t.toLowerCase() === De.CalculatedMeasure : (t.expression || t.formula) && t.context : !1;
  },
  /**
   * Checks whether the given object or type is a date dimension
   *
   * @param o - object to check
   * @returns true if the object or type is a date dimension
   */
  isDateDimension(t) {
    return t ? typeof t == "string" ? t.toLowerCase() === De.DateDimension : (t.dim || t.expression) && t.level : !1;
  },
  /**
   * Checks whether the given object or type is a text dimension
   *
   * @param o - object to check
   * @returns true if the object or type is a text dimension
   */
  isTextDimension(t) {
    return t && typeof t == "string" ? t.toLowerCase() === De.TextDimension : !1;
  },
  /**
   * Checks whether the given object or type is a numeric dimension
   *
   * @param o - object to check
   * @returns true if the object or type is a numeric dimension
   */
  isNumericDimension(t) {
    return t && typeof t == "string" ? t.toLowerCase() === De.NumericDimension : !1;
  },
  /**
   * Checks whether the given object or type is a dimension - of any type
   *
   * @param o - object to check
   * @returns true if the object or type is a dimension - of any type
   */
  isDimension(t) {
    if (typeof t == "object" && (t = t.type), typeof t == "string") {
      const r = t;
      return r.toLowerCase() === De.DateDimension || r.toLowerCase() === De.Dimension || r.toLowerCase() === De.TextDimension || r.toLowerCase() === De.NumericDimension;
    }
    return !1;
  },
  /**
   * Checks whether the given object or type is an attribute - of any type
   *
   * @param o - object to check
   * @returns true if the object or type is an attribute - of any type
   */
  isAttribute(t) {
    if (typeof t == "string") {
      const r = t;
      return r.toLowerCase() === De.Attribute || r.toLowerCase() === De.TextAttribute || r.toLowerCase() === De.NumericAttribute || r.toLowerCase() === De.DateLevel;
    }
    return t && t.type ? this.isAttribute(t.type) : !1;
  },
  /**
   * Checks whether the given object or type is a filter
   *
   * @param o - object to check
   * @returns true if the object or type is a filter
   */
  isFilter(t) {
    if (typeof t == "object" && (t = t.type), typeof t == "string") {
      const r = t;
      return r.toLowerCase() === De.Filter || r.toLowerCase() === De.DimensionFilter || r.toLowerCase() === De.MeasureFilter;
    }
    return !1;
  }
}, de = {
  Years: "Years",
  Quarters: "Quarters",
  Months: "Months",
  Weeks: "Weeks",
  Days: "Days",
  Hours: "Hours",
  MinutesRoundTo30: "MinutesRoundTo30",
  MinutesRoundTo15: "MinutesRoundTo15",
  Minutes: "Minutes",
  Seconds: "Seconds",
  AggHours: "AggHours",
  AggMinutesRoundTo30: "AggMinutesRoundTo30",
  AggMinutesRoundTo15: "AggMinutesRoundTo15",
  AggMinutesRoundTo1: "AggMinutesRoundTo1",
  /** @internal */
  get all() {
    return [
      de.Years,
      de.Quarters,
      de.Months,
      de.Weeks,
      de.Days,
      de.Hours,
      de.MinutesRoundTo30,
      de.MinutesRoundTo15,
      de.Minutes,
      de.Seconds,
      de.AggHours,
      de.AggMinutesRoundTo30,
      de.AggMinutesRoundTo15,
      de.AggMinutesRoundTo1
    ];
  }
};
var zu;
(function(t) {
  t.TEXT = "text", t.NUMERIC = "numeric", t.DATETIME = "datetime";
})(zu = zu || (zu = {}));
var vl;
(function(t) {
  t.ASC = "asc", t.DESC = "desc";
})(vl = vl || (vl = {}));
class Ih {
  constructor(r, f, B, H) {
    this._name = r, this.type = f, this.description = B || "", H && (this._dataSource = H);
  }
  /**
   * Defines the element's name
   */
  get name() {
    return this._name;
  }
  set name(r) {
    this._name = r;
  }
  /**
   * Defines the element's data source
   */
  get dataSource() {
    return this._dataSource;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    return {
      name: this.name,
      type: this.type,
      desc: this.description,
      dataSource: this.dataSource,
      __serializable: "DimensionalElement"
    };
  }
  toJSON() {
    return this.serializable();
  }
  /**
   * Gets a string representation of the element
   */
  toString() {
    return this.jaql();
  }
}
function qs(t) {
  let r = t.replace(/[^a-zA-Z0-9_.]/g, "").replace(".", "_");
  return r.charAt(0).match(/[0-9]/) && (r = "_" + r), r;
}
var Zg = typeof global == "object" && global && global.Object === Object && global, C0 = typeof self == "object" && self && self.Object === Object && self, _r = Zg || C0 || Function("return this")(), xr = _r.Symbol, Kg = Object.prototype, k0 = Kg.hasOwnProperty, T0 = Kg.toString, dl = xr ? xr.toStringTag : void 0;
function M0(t) {
  var r = k0.call(t, dl), f = t[dl];
  try {
    t[dl] = void 0;
    var B = !0;
  } catch (tt) {
  }
  var H = T0.call(t);
  return B && (r ? t[dl] = f : delete t[dl]), H;
}
var A0 = Object.prototype, P0 = A0.toString;
function E0(t) {
  return P0.call(t);
}
var L0 = "[object Null]", O0 = "[object Undefined]", zp = xr ? xr.toStringTag : void 0;
function Uo(t) {
  return t == null ? t === void 0 ? O0 : L0 : zp && zp in Object(t) ? M0(t) : E0(t);
}
function jr(t) {
  var r = typeof t;
  return t != null && (r == "object" || r == "function");
}
var D0 = "[object AsyncFunction]", I0 = "[object Function]", R0 = "[object GeneratorFunction]", j0 = "[object Proxy]";
function Bd(t) {
  if (!jr(t))
    return !1;
  var r = Uo(t);
  return r == I0 || r == R0 || r == D0 || r == j0;
}
var Fu = _r["__core-js_shared__"], Fp = function() {
  var t = /[^.]+$/.exec(Fu && Fu.keys && Fu.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function _0(t) {
  return !!Fp && Fp in t;
}
var B0 = Function.prototype, N0 = B0.toString;
function Go(t) {
  if (t != null) {
    try {
      return N0.call(t);
    } catch (r) {
    }
    try {
      return t + "";
    } catch (r) {
    }
  }
  return "";
}
var z0 = /[\\^$.*+?()[\]{}|]/g, F0 = /^\[object .+?Constructor\]$/, W0 = Function.prototype, H0 = Object.prototype, U0 = W0.toString, G0 = H0.hasOwnProperty, X0 = RegExp(
  "^" + U0.call(G0).replace(z0, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Y0(t) {
  if (!jr(t) || _0(t))
    return !1;
  var r = Bd(t) ? X0 : F0;
  return r.test(Go(t));
}
function V0(t, r) {
  return t == null ? void 0 : t[r];
}
function Xo(t, r) {
  var f = V0(t, r);
  return Y0(f) ? f : void 0;
}
var ph = function() {
  try {
    var t = Xo(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch (r) {
  }
}();
function Nd(t, r, f) {
  r == "__proto__" && ph ? ph(t, r, {
    configurable: !0,
    enumerable: !0,
    value: f,
    writable: !0
  }) : t[r] = f;
}
function $0(t) {
  return function(r, f, B) {
    for (var H = -1, tt = Object(r), st = B(r), lt = st.length; lt--; ) {
      var ht = st[++H];
      if (f(tt[ht], ht, tt) === !1)
        break;
    }
    return r;
  };
}
var Z0 = $0();
function K0(t, r) {
  for (var f = -1, B = Array(t); ++f < t; )
    B[f] = r(f);
  return B;
}
function Jr(t) {
  return t != null && typeof t == "object";
}
var q0 = "[object Arguments]";
function Wp(t) {
  return Jr(t) && Uo(t) == q0;
}
var qg = Object.prototype, J0 = qg.hasOwnProperty, Q0 = qg.propertyIsEnumerable, zd = Wp(/* @__PURE__ */ function() {
  return arguments;
}()) ? Wp : function(t) {
  return Jr(t) && J0.call(t, "callee") && !Q0.call(t, "callee");
}, nr = Array.isArray;
function tb() {
  return !1;
}
var Jg = typeof exports == "object" && exports && !exports.nodeType && exports, Hp = Jg && typeof module == "object" && module && !module.nodeType && module, eb = Hp && Hp.exports === Jg, Up = eb ? _r.Buffer : void 0, ib = Up ? Up.isBuffer : void 0, fh = ib || tb, rb = 9007199254740991, nb = /^(?:0|[1-9]\d*)$/;
function Fd(t, r) {
  var f = typeof t;
  return r = r == null ? rb : r, !!r && (f == "number" || f != "symbol" && nb.test(t)) && t > -1 && t % 1 == 0 && t < r;
}
var ob = 9007199254740991;
function Wd(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= ob;
}
var sb = "[object Arguments]", ab = "[object Array]", lb = "[object Boolean]", cb = "[object Date]", hb = "[object Error]", ub = "[object Function]", db = "[object Map]", pb = "[object Number]", fb = "[object Object]", gb = "[object RegExp]", mb = "[object Set]", yb = "[object String]", vb = "[object WeakMap]", bb = "[object ArrayBuffer]", xb = "[object DataView]", Sb = "[object Float32Array]", wb = "[object Float64Array]", Cb = "[object Int8Array]", kb = "[object Int16Array]", Tb = "[object Int32Array]", Mb = "[object Uint8Array]", Ab = "[object Uint8ClampedArray]", Pb = "[object Uint16Array]", Eb = "[object Uint32Array]", ei = {};
ei[Sb] = ei[wb] = ei[Cb] = ei[kb] = ei[Tb] = ei[Mb] = ei[Ab] = ei[Pb] = ei[Eb] = !0;
ei[sb] = ei[ab] = ei[bb] = ei[lb] = ei[xb] = ei[cb] = ei[hb] = ei[ub] = ei[db] = ei[pb] = ei[fb] = ei[gb] = ei[mb] = ei[yb] = ei[vb] = !1;
function Lb(t) {
  return Jr(t) && Wd(t.length) && !!ei[Uo(t)];
}
function Rh(t) {
  return function(r) {
    return t(r);
  };
}
var Qg = typeof exports == "object" && exports && !exports.nodeType && exports, bl = Qg && typeof module == "object" && module && !module.nodeType && module, Ob = bl && bl.exports === Qg, Wu = Ob && Zg.process, ta = function() {
  try {
    var t = bl && bl.require && bl.require("util").types;
    return t || Wu && Wu.binding && Wu.binding("util");
  } catch (r) {
  }
}(), Gp = ta && ta.isTypedArray, tm = Gp ? Rh(Gp) : Lb, Db = Object.prototype, Ib = Db.hasOwnProperty;
function em(t, r) {
  var f = nr(t), B = !f && zd(t), H = !f && !B && fh(t), tt = !f && !B && !H && tm(t), st = f || B || H || tt, lt = st ? K0(t.length, String) : [], ht = lt.length;
  for (var ut in t)
    (r || Ib.call(t, ut)) && !(st && // Safari 9 has enumerable `arguments.length` in strict mode.
    (ut == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    H && (ut == "offset" || ut == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    tt && (ut == "buffer" || ut == "byteLength" || ut == "byteOffset") || // Skip index properties.
    Fd(ut, ht))) && lt.push(ut);
  return lt;
}
var Rb = Object.prototype;
function Hd(t) {
  var r = t && t.constructor, f = typeof r == "function" && r.prototype || Rb;
  return t === f;
}
function im(t, r) {
  return function(f) {
    return t(r(f));
  };
}
var jb = im(Object.keys, Object), _b = Object.prototype, Bb = _b.hasOwnProperty;
function Nb(t) {
  if (!Hd(t))
    return jb(t);
  var r = [];
  for (var f in Object(t))
    Bb.call(t, f) && f != "constructor" && r.push(f);
  return r;
}
function rm(t) {
  return t != null && Wd(t.length) && !Bd(t);
}
function Il(t) {
  return rm(t) ? em(t) : Nb(t);
}
function zb(t, r) {
  return t && Z0(t, r, Il);
}
function Fb() {
  this.__data__ = [], this.size = 0;
}
function Ud(t, r) {
  return t === r || t !== t && r !== r;
}
function jh(t, r) {
  for (var f = t.length; f--; )
    if (Ud(t[f][0], r))
      return f;
  return -1;
}
var Wb = Array.prototype, Hb = Wb.splice;
function Ub(t) {
  var r = this.__data__, f = jh(r, t);
  if (f < 0)
    return !1;
  var B = r.length - 1;
  return f == B ? r.pop() : Hb.call(r, f, 1), --this.size, !0;
}
function Gb(t) {
  var r = this.__data__, f = jh(r, t);
  return f < 0 ? void 0 : r[f][1];
}
function Xb(t) {
  return jh(this.__data__, t) > -1;
}
function Yb(t, r) {
  var f = this.__data__, B = jh(f, t);
  return B < 0 ? (++this.size, f.push([t, r])) : f[B][1] = r, this;
}
function fn(t) {
  var r = -1, f = t == null ? 0 : t.length;
  for (this.clear(); ++r < f; ) {
    var B = t[r];
    this.set(B[0], B[1]);
  }
}
fn.prototype.clear = Fb;
fn.prototype.delete = Ub;
fn.prototype.get = Gb;
fn.prototype.has = Xb;
fn.prototype.set = Yb;
function Vb() {
  this.__data__ = new fn(), this.size = 0;
}
function $b(t) {
  var r = this.__data__, f = r.delete(t);
  return this.size = r.size, f;
}
function Zb(t) {
  return this.__data__.get(t);
}
function Kb(t) {
  return this.__data__.has(t);
}
var wl = Xo(_r, "Map"), Cl = Xo(Object, "create");
function qb() {
  this.__data__ = Cl ? Cl(null) : {}, this.size = 0;
}
function Jb(t) {
  var r = this.has(t) && delete this.__data__[t];
  return this.size -= r ? 1 : 0, r;
}
var Qb = "__lodash_hash_undefined__", tx = Object.prototype, ex = tx.hasOwnProperty;
function ix(t) {
  var r = this.__data__;
  if (Cl) {
    var f = r[t];
    return f === Qb ? void 0 : f;
  }
  return ex.call(r, t) ? r[t] : void 0;
}
var rx = Object.prototype, nx = rx.hasOwnProperty;
function ox(t) {
  var r = this.__data__;
  return Cl ? r[t] !== void 0 : nx.call(r, t);
}
var sx = "__lodash_hash_undefined__";
function ax(t, r) {
  var f = this.__data__;
  return this.size += this.has(t) ? 0 : 1, f[t] = Cl && r === void 0 ? sx : r, this;
}
function Fo(t) {
  var r = -1, f = t == null ? 0 : t.length;
  for (this.clear(); ++r < f; ) {
    var B = t[r];
    this.set(B[0], B[1]);
  }
}
Fo.prototype.clear = qb;
Fo.prototype.delete = Jb;
Fo.prototype.get = ix;
Fo.prototype.has = ox;
Fo.prototype.set = ax;
function lx() {
  this.size = 0, this.__data__ = {
    hash: new Fo(),
    map: new (wl || fn)(),
    string: new Fo()
  };
}
function cx(t) {
  var r = typeof t;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
}
function _h(t, r) {
  var f = t.__data__;
  return cx(r) ? f[typeof r == "string" ? "string" : "hash"] : f.map;
}
function hx(t) {
  var r = _h(this, t).delete(t);
  return this.size -= r ? 1 : 0, r;
}
function ux(t) {
  return _h(this, t).get(t);
}
function dx(t) {
  return _h(this, t).has(t);
}
function px(t, r) {
  var f = _h(this, t), B = f.size;
  return f.set(t, r), this.size += f.size == B ? 0 : 1, this;
}
function gn(t) {
  var r = -1, f = t == null ? 0 : t.length;
  for (this.clear(); ++r < f; ) {
    var B = t[r];
    this.set(B[0], B[1]);
  }
}
gn.prototype.clear = lx;
gn.prototype.delete = hx;
gn.prototype.get = ux;
gn.prototype.has = dx;
gn.prototype.set = px;
var fx = 200;
function gx(t, r) {
  var f = this.__data__;
  if (f instanceof fn) {
    var B = f.__data__;
    if (!wl || B.length < fx - 1)
      return B.push([t, r]), this.size = ++f.size, this;
    f = this.__data__ = new gn(B);
  }
  return f.set(t, r), this.size = f.size, this;
}
function qr(t) {
  var r = this.__data__ = new fn(t);
  this.size = r.size;
}
qr.prototype.clear = Vb;
qr.prototype.delete = $b;
qr.prototype.get = Zb;
qr.prototype.has = Kb;
qr.prototype.set = gx;
var mx = "__lodash_hash_undefined__";
function yx(t) {
  return this.__data__.set(t, mx), this;
}
function vx(t) {
  return this.__data__.has(t);
}
function gh(t) {
  var r = -1, f = t == null ? 0 : t.length;
  for (this.__data__ = new gn(); ++r < f; )
    this.add(t[r]);
}
gh.prototype.add = gh.prototype.push = yx;
gh.prototype.has = vx;
function bx(t, r) {
  for (var f = -1, B = t == null ? 0 : t.length; ++f < B; )
    if (r(t[f], f, t))
      return !0;
  return !1;
}
function xx(t, r) {
  return t.has(r);
}
var Sx = 1, wx = 2;
function nm(t, r, f, B, H, tt) {
  var st = f & Sx, lt = t.length, ht = r.length;
  if (lt != ht && !(st && ht > lt))
    return !1;
  var ut = tt.get(t), yt = tt.get(r);
  if (ut && yt)
    return ut == r && yt == t;
  var gt = -1, _ = !0, at = f & wx ? new gh() : void 0;
  for (tt.set(t, r), tt.set(r, t); ++gt < lt; ) {
    var G = t[gt], F = r[gt];
    if (B)
      var $ = st ? B(F, G, gt, r, t, tt) : B(G, F, gt, t, r, tt);
    if ($ !== void 0) {
      if ($)
        continue;
      _ = !1;
      break;
    }
    if (at) {
      if (!bx(r, function(Y, J) {
        if (!xx(at, J) && (G === Y || H(G, Y, f, B, tt)))
          return at.push(J);
      })) {
        _ = !1;
        break;
      }
    } else if (!(G === F || H(G, F, f, B, tt))) {
      _ = !1;
      break;
    }
  }
  return tt.delete(t), tt.delete(r), _;
}
var mh = _r.Uint8Array;
function Cx(t) {
  var r = -1, f = Array(t.size);
  return t.forEach(function(B, H) {
    f[++r] = [H, B];
  }), f;
}
function kx(t) {
  var r = -1, f = Array(t.size);
  return t.forEach(function(B) {
    f[++r] = B;
  }), f;
}
var Tx = 1, Mx = 2, Ax = "[object Boolean]", Px = "[object Date]", Ex = "[object Error]", Lx = "[object Map]", Ox = "[object Number]", Dx = "[object RegExp]", Ix = "[object Set]", Rx = "[object String]", jx = "[object Symbol]", _x = "[object ArrayBuffer]", Bx = "[object DataView]", Xp = xr ? xr.prototype : void 0, Hu = Xp ? Xp.valueOf : void 0;
function Nx(t, r, f, B, H, tt, st) {
  switch (f) {
    case Bx:
      if (t.byteLength != r.byteLength || t.byteOffset != r.byteOffset)
        return !1;
      t = t.buffer, r = r.buffer;
    case _x:
      return !(t.byteLength != r.byteLength || !tt(new mh(t), new mh(r)));
    case Ax:
    case Px:
    case Ox:
      return Ud(+t, +r);
    case Ex:
      return t.name == r.name && t.message == r.message;
    case Dx:
    case Rx:
      return t == r + "";
    case Lx:
      var lt = Cx;
    case Ix:
      var ht = B & Tx;
      if (lt || (lt = kx), t.size != r.size && !ht)
        return !1;
      var ut = st.get(t);
      if (ut)
        return ut == r;
      B |= Mx, st.set(t, r);
      var yt = nm(lt(t), lt(r), B, H, tt, st);
      return st.delete(t), yt;
    case jx:
      if (Hu)
        return Hu.call(t) == Hu.call(r);
  }
  return !1;
}
function Gd(t, r) {
  for (var f = -1, B = r.length, H = t.length; ++f < B; )
    t[H + f] = r[f];
  return t;
}
function om(t, r, f) {
  var B = r(t);
  return nr(t) ? B : Gd(B, f(t));
}
function zx(t, r) {
  for (var f = -1, B = t == null ? 0 : t.length, H = 0, tt = []; ++f < B; ) {
    var st = t[f];
    r(st, f, t) && (tt[H++] = st);
  }
  return tt;
}
function sm() {
  return [];
}
var Fx = Object.prototype, Wx = Fx.propertyIsEnumerable, Yp = Object.getOwnPropertySymbols, Xd = Yp ? function(t) {
  return t == null ? [] : (t = Object(t), zx(Yp(t), function(r) {
    return Wx.call(t, r);
  }));
} : sm;
function nd(t) {
  return om(t, Il, Xd);
}
var Hx = 1, Ux = Object.prototype, Gx = Ux.hasOwnProperty;
function Xx(t, r, f, B, H, tt) {
  var st = f & Hx, lt = nd(t), ht = lt.length, ut = nd(r), yt = ut.length;
  if (ht != yt && !st)
    return !1;
  for (var gt = ht; gt--; ) {
    var _ = lt[gt];
    if (!(st ? _ in r : Gx.call(r, _)))
      return !1;
  }
  var at = tt.get(t), G = tt.get(r);
  if (at && G)
    return at == r && G == t;
  var F = !0;
  tt.set(t, r), tt.set(r, t);
  for (var $ = st; ++gt < ht; ) {
    _ = lt[gt];
    var Y = t[_], J = r[_];
    if (B)
      var Q = st ? B(J, Y, _, r, t, tt) : B(Y, J, _, t, r, tt);
    if (!(Q === void 0 ? Y === J || H(Y, J, f, B, tt) : Q)) {
      F = !1;
      break;
    }
    $ || ($ = _ == "constructor");
  }
  if (F && !$) {
    var q = t.constructor, U = r.constructor;
    q != U && "constructor" in t && "constructor" in r && !(typeof q == "function" && q instanceof q && typeof U == "function" && U instanceof U) && (F = !1);
  }
  return tt.delete(t), tt.delete(r), F;
}
var od = Xo(_r, "DataView"), sd = Xo(_r, "Promise"), ad = Xo(_r, "Set"), kl = Xo(_r, "WeakMap"), Vp = "[object Map]", Yx = "[object Object]", $p = "[object Promise]", Zp = "[object Set]", Kp = "[object WeakMap]", qp = "[object DataView]", Vx = Go(od), $x = Go(wl), Zx = Go(sd), Kx = Go(ad), qx = Go(kl), Er = Uo;
(od && Er(new od(new ArrayBuffer(1))) != qp || wl && Er(new wl()) != Vp || sd && Er(sd.resolve()) != $p || ad && Er(new ad()) != Zp || kl && Er(new kl()) != Kp) && (Er = function(t) {
  var r = Uo(t), f = r == Yx ? t.constructor : void 0, B = f ? Go(f) : "";
  if (B)
    switch (B) {
      case Vx:
        return qp;
      case $x:
        return Vp;
      case Zx:
        return $p;
      case Kx:
        return Zp;
      case qx:
        return Kp;
    }
  return r;
});
var Jx = 1, Jp = "[object Arguments]", Qp = "[object Array]", zc = "[object Object]", Qx = Object.prototype, tf = Qx.hasOwnProperty;
function t1(t, r, f, B, H, tt) {
  var st = nr(t), lt = nr(r), ht = st ? Qp : Er(t), ut = lt ? Qp : Er(r);
  ht = ht == Jp ? zc : ht, ut = ut == Jp ? zc : ut;
  var yt = ht == zc, gt = ut == zc, _ = ht == ut;
  if (_ && fh(t)) {
    if (!fh(r))
      return !1;
    st = !0, yt = !1;
  }
  if (_ && !yt)
    return tt || (tt = new qr()), st || tm(t) ? nm(t, r, f, B, H, tt) : Nx(t, r, ht, f, B, H, tt);
  if (!(f & Jx)) {
    var at = yt && tf.call(t, "__wrapped__"), G = gt && tf.call(r, "__wrapped__");
    if (at || G) {
      var F = at ? t.value() : t, $ = G ? r.value() : r;
      return tt || (tt = new qr()), H(F, $, f, B, tt);
    }
  }
  return _ ? (tt || (tt = new qr()), Xx(t, r, f, B, H, tt)) : !1;
}
function Yd(t, r, f, B, H) {
  return t === r ? !0 : t == null || r == null || !Jr(t) && !Jr(r) ? t !== t && r !== r : t1(t, r, f, B, Yd, H);
}
var e1 = 1, i1 = 2;
function r1(t, r, f, B) {
  var H = f.length, tt = H;
  if (t == null)
    return !tt;
  for (t = Object(t); H--; ) {
    var st = f[H];
    if (st[2] ? st[1] !== t[st[0]] : !(st[0] in t))
      return !1;
  }
  for (; ++H < tt; ) {
    st = f[H];
    var lt = st[0], ht = t[lt], ut = st[1];
    if (st[2]) {
      if (ht === void 0 && !(lt in t))
        return !1;
    } else {
      var yt = new qr(), gt;
      if (!(gt === void 0 ? Yd(ut, ht, e1 | i1, B, yt) : gt))
        return !1;
    }
  }
  return !0;
}
function am(t) {
  return t === t && !jr(t);
}
function n1(t) {
  for (var r = Il(t), f = r.length; f--; ) {
    var B = r[f], H = t[B];
    r[f] = [B, H, am(H)];
  }
  return r;
}
function lm(t, r) {
  return function(f) {
    return f == null ? !1 : f[t] === r && (r !== void 0 || t in Object(f));
  };
}
function o1(t) {
  var r = n1(t);
  return r.length == 1 && r[0][2] ? lm(r[0][0], r[0][1]) : function(f) {
    return f === t || r1(f, t, r);
  };
}
var s1 = "[object Symbol]";
function Bh(t) {
  return typeof t == "symbol" || Jr(t) && Uo(t) == s1;
}
var a1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l1 = /^\w*$/;
function Vd(t, r) {
  if (nr(t))
    return !1;
  var f = typeof t;
  return f == "number" || f == "symbol" || f == "boolean" || t == null || Bh(t) ? !0 : l1.test(t) || !a1.test(t) || r != null && t in Object(r);
}
var c1 = "Expected a function";
function $d(t, r) {
  if (typeof t != "function" || r != null && typeof r != "function")
    throw new TypeError(c1);
  var f = function() {
    var B = arguments, H = r ? r.apply(this, B) : B[0], tt = f.cache;
    if (tt.has(H))
      return tt.get(H);
    var st = t.apply(this, B);
    return f.cache = tt.set(H, st) || tt, st;
  };
  return f.cache = new ($d.Cache || gn)(), f;
}
$d.Cache = gn;
var h1 = 500;
function u1(t) {
  var r = $d(t, function(B) {
    return f.size === h1 && f.clear(), B;
  }), f = r.cache;
  return r;
}
var d1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, p1 = /\\(\\)?/g, f1 = u1(function(t) {
  var r = [];
  return t.charCodeAt(0) === 46 && r.push(""), t.replace(d1, function(f, B, H, tt) {
    r.push(H ? tt.replace(p1, "$1") : B || f);
  }), r;
});
function Zd(t, r) {
  for (var f = -1, B = t == null ? 0 : t.length, H = Array(B); ++f < B; )
    H[f] = r(t[f], f, t);
  return H;
}
var g1 = 1 / 0, ef = xr ? xr.prototype : void 0, rf = ef ? ef.toString : void 0;
function cm(t) {
  if (typeof t == "string")
    return t;
  if (nr(t))
    return Zd(t, cm) + "";
  if (Bh(t))
    return rf ? rf.call(t) : "";
  var r = t + "";
  return r == "0" && 1 / t == -g1 ? "-0" : r;
}
function ld(t) {
  return t == null ? "" : cm(t);
}
function Nh(t, r) {
  return nr(t) ? t : Vd(t, r) ? [t] : f1(ld(t));
}
var m1 = 1 / 0;
function Rl(t) {
  if (typeof t == "string" || Bh(t))
    return t;
  var r = t + "";
  return r == "0" && 1 / t == -m1 ? "-0" : r;
}
function Kd(t, r) {
  r = Nh(r, t);
  for (var f = 0, B = r.length; t != null && f < B; )
    t = t[Rl(r[f++])];
  return f && f == B ? t : void 0;
}
function y1(t, r, f) {
  var B = t == null ? void 0 : Kd(t, r);
  return B === void 0 ? f : B;
}
function v1(t, r) {
  return t != null && r in Object(t);
}
function b1(t, r, f) {
  r = Nh(r, t);
  for (var B = -1, H = r.length, tt = !1; ++B < H; ) {
    var st = Rl(r[B]);
    if (!(tt = t != null && f(t, st)))
      break;
    t = t[st];
  }
  return tt || ++B != H ? tt : (H = t == null ? 0 : t.length, !!H && Wd(H) && Fd(st, H) && (nr(t) || zd(t)));
}
function hm(t, r) {
  return t != null && b1(t, r, v1);
}
var x1 = 1, S1 = 2;
function w1(t, r) {
  return Vd(t) && am(r) ? lm(Rl(t), r) : function(f) {
    var B = y1(f, t);
    return B === void 0 && B === r ? hm(f, t) : Yd(r, B, x1 | S1);
  };
}
function qd(t) {
  return t;
}
function C1(t) {
  return function(r) {
    return r == null ? void 0 : r[t];
  };
}
function k1(t) {
  return function(r) {
    return Kd(r, t);
  };
}
function T1(t) {
  return Vd(t) ? C1(Rl(t)) : k1(t);
}
function um(t) {
  return typeof t == "function" ? t : t == null ? qd : typeof t == "object" ? nr(t) ? w1(t[0], t[1]) : o1(t) : T1(t);
}
function M1(t, r) {
  var f = {};
  return r = um(r), zb(t, function(B, H, tt) {
    Nd(f, H, r(B, H, tt));
  }), f;
}
const A1 = (t) => [
  "__int4",
  "__int8",
  "int",
  "tinyint",
  "bigint",
  "int2",
  "int4",
  "int8",
  "smallint",
  "mediumint",
  "serial",
  "integer",
  "byteint",
  "int64"
].includes(t.toLowerCase()), P1 = (t) => [
  "basemeasure",
  "calculatedmeasure",
  "float",
  "float4",
  "float8",
  "double precision",
  "double",
  "numeric",
  "decimal",
  "real",
  "number",
  "float64"
].includes(t.toLowerCase()), Fi = (t) => A1(t) || P1(t) || t === "numeric-attribute", E1 = (t) => [
  "textdimension",
  "string",
  "varchar",
  "text",
  "ntext",
  "char",
  "character",
  "character varying",
  "smalltext",
  "nchar",
  "nvarchar",
  "json",
  "jsonb",
  "object",
  "text-attribute"
].includes(t.toLowerCase()), pn = (t) => [
  "datelevel",
  "date",
  "time",
  "datetime",
  "timestamp without time zone",
  "timestamp",
  "timestamp with time zone",
  "timestamp(6)",
  "timestamp_tz",
  "timestamp_ntz",
  "timestamp_ltz",
  "timestampltz",
  "timestampntz",
  "timestamptz",
  "datetime64[ns]",
  "timewithtimezone",
  "timestampwithtimezone",
  "timestamp_with_timezone"
].includes(t.toLowerCase()), L1 = (t) => ["bool", "boolean", "bit", "logical"].includes(t.toLowerCase()), O1 = (t) => Fi(t) ? "number" : pn(t) ? "datetime" : E1(t) ? "text" : L1(t) ? "boolean" : "text", dm = (t) => O1(t).replace("number", "numeric");
class la extends Ih {
  constructor(r, f, B, H, tt, st) {
    super(r, B || De.Attribute, H, st), this._sort = di.None, this.expression = f, this._sort = tt || di.None;
  }
  /**
   * gets the element's ID
   */
  get id() {
    return this.expression;
  }
  /**
   * Gets the sort definition of this instance
   *
   * @returns The Sort definition of this instance
   */
  getSort() {
    return this._sort;
  }
  /**
   * Gets a sorted {@link Attribute} with the given definition
   *
   * @param sort - Sort definition
   * @returns An instance representing the sorted {@link Attribute} of this instance
   */
  sort(r) {
    return new la(this.name, this.expression, this.type, this.description, r, this.dataSource);
  }
  /**
   * Gets the JAQL representation of this instance
   *
   * @param nested - defines whether the JAQL is nested within parent JAQL statement or a root JAQL element
   */
  jaql(r) {
    const f = {
      jaql: {
        title: this.name,
        dim: this.expression,
        datatype: dm(this.type)
      }
    };
    return this._sort != di.None && (f.jaql.sort = this._sort == di.Ascending ? "asc" : "desc"), r === !0 ? f.jaql : f;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.expression = this.expression, this.getSort() !== di.None && (r.sort = this.getSort().toString()), r;
  }
}
class Rr extends la {
  constructor(r, f, B, H, tt, st, lt) {
    super(r, f, De.DateLevel, tt, st, lt), this._format = H, this.granularity = B;
  }
  /**
   * gets the element's ID
   */
  get id() {
    let r = `${this.expression}`;
    const { level: f = "", dateTimeLevel: B = "", bucket: H } = this.translateGranularityToJaql();
    return r += `_${(f || B).toLowerCase()}`, H && (r += `_${H}`), r;
  }
  /**
   * Gets the sort definition of this instance
   *
   * @returns The Sort definition of this instance
   */
  getSort() {
    return this._sort;
  }
  /**
   * Gets a sorted {@link LevelAttribute} with the given definition
   *
   * @param sort - Sort definition
   * @returns An instance representing the sorted {@link LevelAttribute} of this instance
   */
  sort(r) {
    return new Rr(this.name, this.expression, this.granularity, this._format, this.description, r, this.dataSource);
  }
  /**
   * The string formatting of this instance
   *
   * @returns string formatting
   */
  getFormat() {
    return this._format;
  }
  /**
   * Gets a formatted {@link LevelAttribute} with the given definition
   *
   * @param format - Format string
   * @returns An instance representing the formatted {@link LevelAttribute} of this instance
   */
  format(r) {
    return new Rr(this.name, this.expression, this.granularity, r, this.description, this._sort, this.dataSource);
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.granularity = this.granularity, this.getFormat() !== void 0 && (r.format = this.getFormat()), r;
  }
  /**
   * Gets the JAQL representation of this instance
   *
   * @param nested - defines whether the JAQL is nested within parent JAQL statement or a root JAQL element
   */
  jaql(r) {
    const f = {
      jaql: Object.assign({ title: this.name, dim: this.expression, datatype: dm(this.type) }, this.translateGranularityToJaql())
    };
    if (this._format !== void 0) {
      const B = f.jaql.dateTimeLevel || f.jaql.level;
      f.format = { mask: {} }, f.format.mask[B] = this._format;
    }
    return this._sort != di.None && (f.jaql.sort = this._sort == di.Ascending ? "asc" : "desc"), r === !0 ? f.jaql : f;
  }
  /**
   * Obtain the JAQL representation of the level that depends on the granularity
   */
  translateGranularityToJaql() {
    const r = "minutes", f = "seconds";
    switch (this.granularity) {
      case de.Years:
      case de.Quarters:
      case de.Months:
      case de.Weeks:
      case de.Days:
        return { level: this.granularity.toLowerCase() };
      case de.Hours:
        return {
          dateTimeLevel: r,
          bucket: "60"
        };
      case de.MinutesRoundTo30:
        return {
          dateTimeLevel: r,
          bucket: "30"
        };
      case de.MinutesRoundTo15:
        return {
          dateTimeLevel: r,
          bucket: "15"
        };
      case de.Minutes:
        return {
          dateTimeLevel: r,
          bucket: "1"
        };
      case de.Seconds:
        return {
          dateTimeLevel: f,
          bucket: "0"
        };
      case de.AggHours:
        return {
          level: r,
          bucket: "60"
        };
      case de.AggMinutesRoundTo30:
        return {
          level: r,
          bucket: "30"
        };
      case de.AggMinutesRoundTo15:
        return {
          level: r,
          bucket: "15"
        };
      case de.AggMinutesRoundTo1:
        return {
          level: r,
          bucket: "1"
        };
      default:
        return console.warn("Unsupported level"), { level: this.granularity };
    }
  }
  static translateJaqlToGranularity(r) {
    const f = (B) => (console.warn("Unsupported granularity", B), B);
    if (r.dateTimeLevel) {
      if (r.dateTimeLevel !== "minutes" && r.dateTimeLevel !== "seconds")
        return f(r.dateTimeLevel);
      switch (r.bucket) {
        case "60":
          return de.Hours;
        case "30":
          return de.MinutesRoundTo30;
        case "15":
          return de.MinutesRoundTo15;
        case "1":
          return de.Minutes;
        case "0":
          return de.Seconds;
        default:
          return f(r.dateTimeLevel);
      }
    }
    switch (r.level) {
      case "years":
        return de.Years;
      case "quarters":
        return de.Quarters;
      case "months":
        return de.Months;
      case "weeks":
        return de.Weeks;
      case "days":
        return de.Days;
      case "minutes":
        switch (r.bucket) {
          case "60":
            return de.AggHours;
          case "30":
            return de.AggMinutesRoundTo30;
          case "15":
            return de.AggMinutesRoundTo15;
          case "1":
            return de.AggMinutesRoundTo1;
          default:
            return f(r.level);
        }
      default:
        return f(r.level);
    }
  }
  static getDefaultFormatForGranularity(r) {
    switch (r) {
      case de.Years:
        return "yyyy";
      case de.Quarters:
        return "Q yyyy";
      case de.Months:
        return "yyyy-MM";
      case de.Weeks:
        return "ww yyyy";
      case de.Days:
        return "yyyy-MM-dd";
      case de.Hours:
        return "yyyy-MM-dd HH:mm";
      case de.MinutesRoundTo30:
        return "yyyy-MM-dd HH:mm";
      case de.MinutesRoundTo15:
        return "yyyy-MM-dd HH:mm";
      case de.Minutes:
        return "yyyy-MM-dd HH:mm";
      case de.Seconds:
        return "yyyy-MM-dd HH:mm:ss";
      case de.AggHours:
        return "HH:mm";
      case de.AggMinutesRoundTo30:
        return "HH:mm";
      case de.AggMinutesRoundTo15:
        return "HH:mm";
      case de.AggMinutesRoundTo1:
        return "HH:mm";
      default:
        return "";
    }
  }
}
function FL(t) {
  return t.granularity ? D1(t) : new la(t.name || t.title, t.attribute || t.expression || t.dim, t.type, t.desc || t.description, t.sort, t.dataSource);
}
function D1(t) {
  return new Rr(t.name || t.title, t.attribute || t.expression || t.dim, t.granularity, t.format, t.desc || t.description, t.sort, t.dataSource);
}
function nf(t, r, f, B) {
  return (B.length > 0 ? B + "." : "") + qs(t) + "." + qs(r) + (f && f.length > 0 ? "." + Rr.translateJaqlToGranularity({ level: f }) : "");
}
function I1(t, r) {
  for (var f = -1, B = t == null ? 0 : t.length; ++f < B && r(t[f], f, t) !== !1; )
    ;
  return t;
}
var R1 = Object.prototype, j1 = R1.hasOwnProperty;
function Jd(t, r, f) {
  var B = t[r];
  (!(j1.call(t, r) && Ud(B, f)) || f === void 0 && !(r in t)) && Nd(t, r, f);
}
function zh(t, r, f, B) {
  var H = !f;
  f || (f = {});
  for (var tt = -1, st = r.length; ++tt < st; ) {
    var lt = r[tt], ht = void 0;
    ht === void 0 && (ht = t[lt]), H ? Nd(f, lt, ht) : Jd(f, lt, ht);
  }
  return f;
}
function _1(t, r) {
  return t && zh(r, Il(r), t);
}
function B1(t) {
  var r = [];
  if (t != null)
    for (var f in Object(t))
      r.push(f);
  return r;
}
var N1 = Object.prototype, z1 = N1.hasOwnProperty;
function F1(t) {
  if (!jr(t))
    return B1(t);
  var r = Hd(t), f = [];
  for (var B in t)
    B == "constructor" && (r || !z1.call(t, B)) || f.push(B);
  return f;
}
function Qd(t) {
  return rm(t) ? em(t, !0) : F1(t);
}
function W1(t, r) {
  return t && zh(r, Qd(r), t);
}
var pm = typeof exports == "object" && exports && !exports.nodeType && exports, of = pm && typeof module == "object" && module && !module.nodeType && module, H1 = of && of.exports === pm, sf = H1 ? _r.Buffer : void 0, af = sf ? sf.allocUnsafe : void 0;
function U1(t, r) {
  if (r)
    return t.slice();
  var f = t.length, B = af ? af(f) : new t.constructor(f);
  return t.copy(B), B;
}
function fm(t, r) {
  var f = -1, B = t.length;
  for (r || (r = Array(B)); ++f < B; )
    r[f] = t[f];
  return r;
}
function G1(t, r) {
  return zh(t, Xd(t), r);
}
var gm = im(Object.getPrototypeOf, Object), X1 = Object.getOwnPropertySymbols, mm = X1 ? function(t) {
  for (var r = []; t; )
    Gd(r, Xd(t)), t = gm(t);
  return r;
} : sm;
function Y1(t, r) {
  return zh(t, mm(t), r);
}
function V1(t) {
  return om(t, Qd, mm);
}
var $1 = Object.prototype, Z1 = $1.hasOwnProperty;
function K1(t) {
  var r = t.length, f = new t.constructor(r);
  return r && typeof t[0] == "string" && Z1.call(t, "index") && (f.index = t.index, f.input = t.input), f;
}
function tp(t) {
  var r = new t.constructor(t.byteLength);
  return new mh(r).set(new mh(t)), r;
}
function q1(t, r) {
  var f = r ? tp(t.buffer) : t.buffer;
  return new t.constructor(f, t.byteOffset, t.byteLength);
}
var J1 = /\w*$/;
function Q1(t) {
  var r = new t.constructor(t.source, J1.exec(t));
  return r.lastIndex = t.lastIndex, r;
}
var lf = xr ? xr.prototype : void 0, cf = lf ? lf.valueOf : void 0;
function tS(t) {
  return cf ? Object(cf.call(t)) : {};
}
function eS(t, r) {
  var f = r ? tp(t.buffer) : t.buffer;
  return new t.constructor(f, t.byteOffset, t.length);
}
var iS = "[object Boolean]", rS = "[object Date]", nS = "[object Map]", oS = "[object Number]", sS = "[object RegExp]", aS = "[object Set]", lS = "[object String]", cS = "[object Symbol]", hS = "[object ArrayBuffer]", uS = "[object DataView]", dS = "[object Float32Array]", pS = "[object Float64Array]", fS = "[object Int8Array]", gS = "[object Int16Array]", mS = "[object Int32Array]", yS = "[object Uint8Array]", vS = "[object Uint8ClampedArray]", bS = "[object Uint16Array]", xS = "[object Uint32Array]";
function SS(t, r, f) {
  var B = t.constructor;
  switch (r) {
    case hS:
      return tp(t);
    case iS:
    case rS:
      return new B(+t);
    case uS:
      return q1(t, f);
    case dS:
    case pS:
    case fS:
    case gS:
    case mS:
    case yS:
    case vS:
    case bS:
    case xS:
      return eS(t, f);
    case nS:
      return new B();
    case oS:
    case lS:
      return new B(t);
    case sS:
      return Q1(t);
    case aS:
      return new B();
    case cS:
      return tS(t);
  }
}
var hf = Object.create, ep = /* @__PURE__ */ function() {
  function t() {
  }
  return function(r) {
    if (!jr(r))
      return {};
    if (hf)
      return hf(r);
    t.prototype = r;
    var f = new t();
    return t.prototype = void 0, f;
  };
}();
function wS(t) {
  return typeof t.constructor == "function" && !Hd(t) ? ep(gm(t)) : {};
}
var CS = "[object Map]";
function kS(t) {
  return Jr(t) && Er(t) == CS;
}
var uf = ta && ta.isMap, TS = uf ? Rh(uf) : kS, MS = "[object Set]";
function AS(t) {
  return Jr(t) && Er(t) == MS;
}
var df = ta && ta.isSet, PS = df ? Rh(df) : AS, ES = 1, LS = 2, OS = 4, ym = "[object Arguments]", DS = "[object Array]", IS = "[object Boolean]", RS = "[object Date]", jS = "[object Error]", vm = "[object Function]", _S = "[object GeneratorFunction]", BS = "[object Map]", NS = "[object Number]", bm = "[object Object]", zS = "[object RegExp]", FS = "[object Set]", WS = "[object String]", HS = "[object Symbol]", US = "[object WeakMap]", GS = "[object ArrayBuffer]", XS = "[object DataView]", YS = "[object Float32Array]", VS = "[object Float64Array]", $S = "[object Int8Array]", ZS = "[object Int16Array]", KS = "[object Int32Array]", qS = "[object Uint8Array]", JS = "[object Uint8ClampedArray]", QS = "[object Uint16Array]", tw = "[object Uint32Array]", Qe = {};
Qe[ym] = Qe[DS] = Qe[GS] = Qe[XS] = Qe[IS] = Qe[RS] = Qe[YS] = Qe[VS] = Qe[$S] = Qe[ZS] = Qe[KS] = Qe[BS] = Qe[NS] = Qe[bm] = Qe[zS] = Qe[FS] = Qe[WS] = Qe[HS] = Qe[qS] = Qe[JS] = Qe[QS] = Qe[tw] = !0;
Qe[jS] = Qe[vm] = Qe[US] = !1;
function th(t, r, f, B, H, tt) {
  var st, lt = r & ES, ht = r & LS, ut = r & OS;
  if (f && (st = H ? f(t, B, H, tt) : f(t)), st !== void 0)
    return st;
  if (!jr(t))
    return t;
  var yt = nr(t);
  if (yt) {
    if (st = K1(t), !lt)
      return fm(t, st);
  } else {
    var gt = Er(t), _ = gt == vm || gt == _S;
    if (fh(t))
      return U1(t, lt);
    if (gt == bm || gt == ym || _ && !H) {
      if (st = ht || _ ? {} : wS(t), !lt)
        return ht ? Y1(t, W1(st, t)) : G1(t, _1(st, t));
    } else {
      if (!Qe[gt])
        return H ? t : {};
      st = SS(t, gt, lt);
    }
  }
  tt || (tt = new qr());
  var at = tt.get(t);
  if (at)
    return at;
  tt.set(t, st), PS(t) ? t.forEach(function($) {
    st.add(th($, r, f, $, t, tt));
  }) : TS(t) && t.forEach(function($, Y) {
    st.set(Y, th($, r, f, Y, t, tt));
  });
  var G = ut ? ht ? V1 : nd : ht ? Qd : Il, F = yt ? void 0 : G(t);
  return I1(F || t, function($, Y) {
    F && (Y = $, $ = t[Y]), Jd(st, Y, th($, r, f, Y, t, tt));
  }), st;
}
var ew = 1, iw = 4;
function Fh(t) {
  return th(t, ew | iw);
}
var eh;
(function(t) {
  t.INCLUDE_ALL = "INCLUDE_ALL", t.ADVANCED = "ADVANCED", t.INVALID = "INVALID", t.CONDITION = "CONDITION", t.SPECIFIC_ITEMS = "SPECIFIC_ITEMS";
})(eh = eh || (eh = {}));
var ih;
(function(t) {
  t.PERIOD = "PERIOD", t.DATE_RANGE = "DATE_RANGE";
})(ih = ih || (ih = {}));
var rh;
(function(t) {
  t.NUMERIC_RANGE = "NUMERIC_RANGE";
})(rh = rh || (rh = {}));
var $n;
(function(t) {
  t.YEARS = "years", t.QUARTERS = "quarters", t.MONTHS = "months", t.WEEKS = "weeks", t.DAYS = "days", t.HOURS = "hours", t.MINUTES = "minutes";
})($n = $n || ($n = {}));
var Js;
(function(t) {
  t.DATE_TIME = "datetime", t.NUMERIC = "numeric", t.TEXT = "text";
})(Js = Js || (Js = {}));
const rw = ["1", "30"], We = Object.assign(Object.assign(Object.assign({}, eh), ih), rh), nw = {
  [We.INCLUDE_ALL]: {
    all: !0,
    filterType: We.INCLUDE_ALL
  },
  [We.PERIOD]: {
    last: { count: 1, offset: 1 },
    isNotCurrentPeriod: !0,
    filterType: We.PERIOD
  },
  [We.DATE_RANGE]: {
    filterType: We.DATE_RANGE
  },
  [We.NUMERIC_RANGE]: {
    filterType: We.NUMERIC_RANGE
  },
  [We.CONDITION]: {
    explicit: !1,
    multiSelection: !0,
    exclude: { members: [] },
    filterType: We.CONDITION
  },
  [We.SPECIFIC_ITEMS]: {
    explicit: !0,
    multiSelection: !0,
    members: [],
    filterType: We.SPECIFIC_ITEMS
  }
}, ow = {
  filter: nw.INCLUDE_ALL,
  level: $n.YEARS
};
var me;
(function(t) {
  t.IS = "members", t.IS_NOT = "exclude", t.IS_WITHIN = "isWithin", t.TOP = "top", t.BOTTOM = "bottom", t.AFTER = "after", t.BEFORE = "before", t.STARTS_WITH = "startsWith", t.DOESNT_START_WITH = "doesntStartWith", t.ENDS_WITH = "endsWith", t.DOESNT_END_WITH = "doesntEndWith", t.CONTAINS = "contains", t.DOESNT_CONTAIN = "doesntContain", t.EQUALS = "equals", t.DOESNT_EQUAL = "doesntEqual", t.IS_EMPTY = "isEmpty", t.IS_NOT_EMPTY = "isNotEmpty", t.GREATER_THAN = "fromNotEqual", t.GREATER_THAN_OR_EQUAL = "from", t.LESS_THAN = "toNotEqual", t.LESS_THAN_OR_EQUAL = "to", t.BETWEEN = "between", t.IS_NOT_BETWEEN = "isNotBetween", t.MULTIPLE_CONDITION = "multipleCondition", t.NONE = "none";
})(me = me || (me = {}));
function sw(t) {
  for (var r = t.length, f = 5381, B = 52711, H; r--; )
    H = t.charCodeAt(r), f = f * 33 ^ H, B = B * 33 ^ H;
  return (f >>> 0) * 4096 + (B >>> 0);
}
var Tl = "|", aw = /\[object ([HTML|SVG](.*)Element)\]/, lw = {
  "[object Arguments]": 0,
  "[object Array]": 1,
  "[object ArrayBuffer]": 2,
  "[object AsyncFunction]": 3,
  "[object AsyncGeneratorFunction]": 4,
  "[object BigInt]": 5,
  "[object BigInt64Array]": 6,
  "[object BigUint64Array]": 7,
  "[object Boolean]": 8,
  "[object DataView]": 9,
  "[object Date]": 10,
  "[object DocumentFragment]": 11,
  "[object Error]": 12,
  "[object Event]": 13,
  "[object Float32Array]": 14,
  "[object Float64Array]": 15,
  "[object Function]": 16,
  "[object Generator]": 17,
  "[object GeneratorFunction]": 18,
  "[object Int8Array]": 19,
  "[object Int16Array]": 20,
  "[object Map]": 21,
  "[object Number]": 22,
  "[object Object]": 23,
  "[object Promise]": 24,
  "[object RegExp]": 25,
  "[object Set]": 26,
  "[object SharedArrayBuffer]": 27,
  "[object String]": 28,
  "[object Uint8Array]": 29,
  "[object Uint8ClampedArray]": 30,
  "[object Uint16Array]": 31,
  "[object Uint32Array]": 32,
  "[object WeakMap]": 33,
  "[object WeakRef]": 34,
  "[object WeakSet]": 35,
  CUSTOM: 36,
  ELEMENT: 37
}, cw = {
  "[object Arguments]": 1,
  "[object Array]": 2
}, xm = {
  "[object Generator]": 1,
  "[object Promise]": 2,
  "[object WeakMap]": 3,
  "[object WeakRef]": 4,
  "[object WeakSet]": 5
}, hw = {
  "[object AsyncFunction]": 1,
  "[object AsyncGeneratorFunction]": 2,
  "[object Boolean]": 3,
  "[object Function]": 4,
  "[object GeneratorFunction]": 5,
  "[object Number]": 6,
  "[object String]": 7
}, uw = {
  "[object BigInt64Array]": 1,
  "[object BigUint64Array]": 2,
  "[object Float32Array]": 3,
  "[object Float64Array]": 4,
  "[object Int8Array]": 5,
  "[object Int16Array]": 6,
  "[object Uint8Array]": 7,
  "[object Uint8ClampedArray]": 8,
  "[object Uint16Array]": 9,
  "[object Uint32Array]": 10
}, dw = {
  "[object Arguments]": 1,
  "[object Array]": 2,
  "[object ArrayBuffer]": 3,
  "[object BigInt64Array]": 4,
  "[object BigUint64Array]": 5,
  "[object DataView]": 6,
  "[object Float32Array]": 7,
  "[object Float64Array]": 8,
  "[object Int8Array]": 9,
  "[object Int16Array]": 10,
  "[object Map]": 11,
  "[object Object]": 12,
  "[object Set]": 13,
  "[object SharedArrayBuffer]": 14,
  "[object Uint8Array]": 15,
  "[object Uint8ClampedArray]": 16,
  "[object Uint16Array]": 17,
  "[object Uint32Array]": 18,
  CUSTOM: 19
}, ml = {
  bigint: "i",
  boolean: "b",
  empty: "e",
  function: "g",
  number: "n",
  object: "o",
  string: "s",
  symbol: "s"
};
function pw(t, r) {
  return t[0] > r[0];
}
function Sm(t, r) {
  return t > r;
}
function ip(t, r) {
  for (var f, B, H = 0; H < t.length; ++H) {
    for (B = t[H], f = H - 1; ~f && r(t[f], B); --f)
      t[f + 1] = t[f];
    t[f + 1] = B;
  }
  return t;
}
function Ci(t, r) {
  return ml.object + Tl + lw[t] + Tl + r;
}
var pf = /* @__PURE__ */ new WeakMap(), fw = 0;
function cd(t, r) {
  var f = pf.get(t);
  if (f)
    return f;
  var B = Ci(r, "NOT_ENUMERABLE" + Tl + fw++);
  return pf.set(t, B), B;
}
var gw = Object.prototype.toString;
function mw(t, r, f) {
  if (dw[r])
    return ff(r, t, f);
  if (r === "[object Date]")
    return Ci(r, t.getTime());
  if (r === "[object RegExp]")
    return Ci(r, t.toString());
  if (r === "[object Event]")
    return Ci(r, [
      t.bubbles,
      t.cancelBubble,
      t.cancelable,
      t.composed,
      t.currentTarget,
      t.defaultPrevented,
      t.eventPhase,
      t.isTrusted,
      t.returnValue,
      t.target,
      t.type
    ].join());
  if (r === "[object Error]")
    return Ci(r, t.message + Tl + t.stack);
  if (r === "[object DocumentFragment]")
    return Ci(r, Sw(t));
  var B = r.match(aw);
  return B ? Ci("ELEMENT", B[1] + Tl + t.outerHTML) : xm[r] ? cd(t, r) : hw[r] ? Ci(r, t.toString()) : ff("CUSTOM", t, f);
}
function ff(t, r, f) {
  var B = f.cache.get(r);
  return B ? Ci(t, "RECURSIVE~" + B) : (f.cache.set(r, ++f.id), t === "[object Object]" ? r[Symbol.iterator] ? cd(r, t) : Ci(t, mf(r, f)) : cw[t] ? Ci(t, yw(r, f)) : t === "[object Map]" ? Ci(t, ww(r, f)) : t === "[object Set]" ? Ci(t, Cw(r, f)) : uw[t] ? Ci(t, r.join()) : t === "[object ArrayBuffer]" ? Ci(t, gf(r)) : t === "[object DataView]" ? Ci(t, gf(r.buffer)) : xm[t] ? cd(r, t) : Ci("CUSTOM", mf(r, f)));
}
function yw(t, r) {
  for (var f = t.length, B = new Array(f); --f >= 0; )
    B[f] = ea(t[f], r);
  return B.join();
}
function vw(t) {
  return Buffer.from(t).toString("utf8");
}
function bw(t) {
  return String.fromCharCode.apply(null, new Uint16Array(t));
}
function xw() {
  return "UNSUPPORTED";
}
function Sw(t) {
  for (var r = t.children, f = r.length, B = new Array(f); --f >= 0; )
    B[f] = r[f].outerHTML;
  return B.join();
}
var gf = typeof Buffer != "undefined" && typeof Buffer.from == "function" ? vw : typeof Uint16Array == "function" ? bw : xw;
function ww(t, r) {
  var f = new Array(t.size), B = 0;
  for (t.forEach(function(H, tt) {
    f[B++] = [ea(tt, r), ea(H, r)];
  }), ip(f, pw); --B >= 0; )
    f[B] = "[" + f[B][0] + "," + f[B][1] + "]";
  return "[" + f.join() + "]";
}
function mf(t, r) {
  for (var f = ip(Object.getOwnPropertyNames(t), Sm), B = f.length, H = new Array(B), tt = B; --tt >= 0; )
    H[tt] = f[tt] + ":" + ea(t[f[tt]], r);
  return "{" + H.join() + "}";
}
function Cw(t, r) {
  var f = new Array(t.size), B = 0;
  return t.forEach(function(H) {
    f[B++] = ea(H, r);
  }), "[" + ip(f, Sm).join() + "]";
}
function ea(t, r) {
  var f = typeof t;
  return t == null || f === "undefined" ? ml.empty + t : f === "object" ? mw(t, gw.call(t), r || { cache: /* @__PURE__ */ new WeakMap(), id: 1 }) : f === "function" || f === "symbol" ? ml[f] + t.toString() : f === "boolean" ? ml.boolean + +t : ml[f] + t;
}
function kw(t) {
  return sw(ea(t, void 0));
}
let ca = class extends Wg {
  constructor(r, f) {
    super($g, {
      key: r,
      interpolationOptions: f
    }, w0.t);
  }
};
const mn = {
  Contains: "contains",
  StartsWith: "startsWith",
  EndsWith: "endsWith",
  Equals: "equals",
  DoesntEqual: "doesntEqual",
  DoesntStartWith: "doesntStartWith",
  DoesntContain: "doesntContain",
  DoesntEndWith: "doesntEndWith",
  Like: "like"
}, Wi = {
  Equals: "equals",
  DoesntEqual: "doesntEqual",
  From: "from",
  FromNotEqual: "fromNotEqual",
  To: "to",
  ToNotEqual: "toNotEqual"
}, Ml = {
  From: "from",
  To: "to",
  Last: "last",
  Next: "next",
  Anchor: "Anchor"
}, wm = {
  Union: "or",
  Intersection: "and",
  Exclude: "exclude"
}, Cm = {
  Top: "top",
  Bottom: "bottom"
}, ci = {
  logicalAttribute: "logicalAttribute",
  members: "members",
  exclude: "exclude",
  measure: "measure",
  ranking: "ranking",
  text: "text",
  numeric: "numeric",
  dateRange: "dateRange",
  relativeDate: "relativeDate",
  cascading: "cascading",
  advanced: "advanced"
};
class or extends Ih {
  constructor(r, f, B) {
    super("filter", De.Filter), this.filterType = f, or.checkAttributeSupport(r), this.attribute = r, this.guid = B || Lm(13), this.disabled = !1, this.locked = !1;
  }
  /**
   * Boolean flag whether the filter is disabled
   *
   * @internal
   */
  get disabled() {
    return this._disabled;
  }
  set disabled(r) {
    this._disabled = r;
  }
  /**
   * Boolean flag whether the filter is locked
   *
   * @internal
   */
  get locked() {
    return this._locked;
  }
  set locked(r) {
    this._locked = r;
  }
  get name() {
    return kw(this.jaql()).toString(16);
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.filterType = this.filterType, r.attribute = this.attribute.serializable(), r;
  }
  /**
   * Gets the JAQL representation of this instance
   *
   * @param nested - defines whether the JAQL is nested within parent JAQL statement or a root JAQL element
   */
  jaql(r) {
    if (this.disabled)
      return or.disabledJaql(r);
    const f = this.attribute.jaql(!1), B = this.attribute;
    if (B.getFormat && B.getFormat() !== void 0) {
      const H = B.translateGranularityToJaql();
      f.format = {
        mask: {
          [H.level]: B.getFormat()
        }
      };
    }
    return f.jaql.filter = this.filterJaql(), this.attribute.dataSource && (f.jaql.datasource = this.attribute.dataSource), this.isScope && (f.panel = "scope"), r === !0 ? f.jaql : f;
  }
  static checkAttributeSupport(r) {
    const { granularity: f } = r;
    if (f === de.Hours || f === de.MinutesRoundTo30 || f === de.MinutesRoundTo15 || f === de.Minutes || f === de.Seconds)
      throw new ca("errors.filter.unsupportedDatetimeLevel");
  }
  static disabledJaql(r) {
    return r ? { filter: {} } : { jaql: { filter: {} } };
  }
}
class km extends or {
  constructor(r, f, B) {
    super(r[0].attribute, ci.logicalAttribute, B), this.operator = f, this.filters = r;
  }
  /**
   * gets the element's ID
   */
  get id() {
    return `${this.operator}_${this.filters.map((r) => r.id).join()}`;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.operator = this.operator, r.filters = this.filters.map((f) => f.serializable()), r;
  }
  /**
   * Gets JAQL representing this Filter instance
   */
  filterJaql() {
    const r = {};
    return r[this.operator] = this.filters.map((f) => f.filterJaql()), r;
  }
}
class Tw extends or {
  constructor(r, f, B, H, tt, st) {
    if (super(r, ci.members, H), this.members = f != null ? f : [], this.excludeMembers = B != null ? B : !1, this.deactivatedMembers = tt != null ? tt : [], this.backgroundFilter = st, this.members.filter((lt) => lt == null).length > 0)
      throw new ca("errors.filter.membersFilterNullMember", {
        attributeId: r.id
      });
  }
  /**
   * gets the element's ID
   */
  get id() {
    return `${this.attribute.id}_${this.members.map((r) => r.toString()).join()}`;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.members = this.members, this.backgroundFilter && (r.backgroundFilter = this.backgroundFilter.serializable()), r;
  }
  /**
   * Gets JAQL representing this Filter instance
   */
  filterJaql() {
    const r = {
      members: this.members.map((B) => B.toString())
    }, f = this.excludeMembers && this.members.length ? { exclude: r } : r;
    return this.backgroundFilter ? {
      and: [f, this.backgroundFilter.filterJaql()]
    } : f;
  }
}
class HL extends or {
  constructor(r, f) {
    super(r[0].attribute, ci.cascading, f), this.filters = r;
  }
  /**
   * gets the element's ID
   */
  get id() {
    return `${this.filterType}_${this.filters.map((r) => r.id).join()}`;
  }
  get disabled() {
    return super.disabled;
  }
  set disabled(r) {
    super.disabled = r, this.filters && this.filters.forEach((f) => {
      f.disabled = r;
    });
  }
  get locked() {
    return super.locked;
  }
  set locked(r) {
    super.locked = r, this.filters && this.filters.forEach((f) => {
      f.locked = r;
    });
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.filters = this.filters.map((f) => f.serializable()), r;
  }
  /**
   * Gets JAQL representing this Filter instance
   */
  filterJaql() {
    return {};
  }
  jaql(r) {
    return this.disabled ? or.disabledJaql(r) : this.filters.map((f) => (f.isScope = !0, f.jaql(r)));
  }
}
class Mw extends or {
  constructor(r, f, B) {
    super(r.attribute, ci.exclude, B), this.input = f, this.filter = r;
  }
  /**
   * gets the element's ID
   */
  get id() {
    let r = `exclude_${this.filter.id}`;
    return this.input && (r += "_from_" + this.input.id), r;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.filter = this.filter.serializable(), this.input && (r.input = this.input.serializable()), r;
  }
  /**
   * Gets JAQL representing this Filter instance
   */
  filterJaql() {
    const r = {}, f = this.filter.filterJaql();
    return this.input ? (r.filter = this.input.filterJaql(), r.filter.filter = { exclude: f }) : r.exclude = f, r;
  }
}
class Wh extends or {
  constructor(r, f, B, H, tt, st, lt) {
    super(r, f, lt), B && H !== void 0 && (this.valueA = H, this.operatorA = B), tt && st !== void 0 && (this.operatorB = tt, this.valueB = st);
  }
  /**
   * gets the element's ID
   */
  get id() {
    let r = `${this.attribute.id}`;
    return this.operatorA && this.valueA !== void 0 && (r += `_${this.operatorA}:${this.valueA}`), this.operatorB && this.valueB !== void 0 && (r += `_${this.operatorB}:${this.valueB}`), r;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return this.operatorA && (r.operatorA = this.operatorA), this.operatorB && (r.operatorB = this.operatorB), this.valueA !== void 0 && (r.valueA = this.valueA), this.valueB !== void 0 && (r.valueB = this.valueB), r;
  }
  /**
   * Gets JAQL representing this Filter instance
   */
  filterJaql() {
    const r = {};
    return this.operatorA && this.valueA !== void 0 && (r[this.operatorA] = this.valueA), this.operatorB && this.valueB !== void 0 && (r[this.operatorB] = this.valueB), r;
  }
}
class Aw extends Wh {
  constructor(r, f, B, H, tt, st, lt) {
    super(r, ci.measure, B, H, tt, st, lt), this.measure = f;
  }
  /**
   * gets the element's ID
   */
  get id() {
    let r = `${this.attribute.id}_${this.measure.id}`;
    return this.operatorA && this.valueA !== void 0 && (r += `_${this.operatorA}:${this.valueA}`), this.operatorB && this.valueB !== void 0 && (r += `_${this.operatorB}${this.valueB}`), r;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.measure = this.measure.serializable(), r;
  }
  jaql(r) {
    if (this.disabled)
      return or.disabledJaql(r);
    const f = super.jaql(r);
    return this.measure instanceof Zn && Object.entries(this.measure.jaql().jaql).forEach(([B, H]) => {
      f.jaql[B] = H;
    }), f;
  }
}
class Tm extends or {
  constructor(r, f, B, H, tt) {
    super(r, ci.ranking, tt), this.count = H, this.operator = B, this.measure = f;
  }
  /**
   * gets the element's ID
   */
  get id() {
    return `${this.operator}_${this.count}_${this.attribute.id}_by_${this.measure.id}`;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.count = this.count, r.operator = this.operator, r.measure = this.measure.serializable(), r;
  }
  /**
   * Gets JAQL representing this Filter instance
   */
  filterJaql() {
    const r = {};
    return r[this.operator] = this.count, r.by = this.measure.jaql(!0), r;
  }
}
class Pw extends Wh {
  constructor(r, f, B, H, tt, st) {
    super(r, ci.numeric, f, B, H, tt, st);
  }
}
class yn extends Wh {
  constructor(r, f, B, H) {
    super(r, ci.text, f, B, void 0, void 0, H);
  }
}
class Ew extends Wh {
  constructor(r, f, B, H) {
    super(r, ci.dateRange, Ml.From, f, Ml.To, B, H), typeof f == "object" && (this.valueA = f.toISOString()), typeof B == "object" && (this.valueB = B.toISOString());
  }
  get level() {
    return this.attribute;
  }
  get from() {
    return this.valueA;
  }
  get to() {
    return this.valueB;
  }
  /**
   * Gets JAQL representing this Filter instance
   */
  filterJaql() {
    return super.filterJaql();
  }
}
class Mm extends or {
  constructor(r, f, B, H, tt, st) {
    super(r, ci.relativeDate, st), H || (H = Ml.Next), this.anchor = tt, this.operator = H, this.offset = f, this.count = B;
  }
  get level() {
    return this.attribute;
  }
  /**
   * gets the element's ID
   */
  get id() {
    let r = `${this.level.id}_${this.operator}_${this.offset}_${this.count}`;
    return this.anchor && (typeof this.anchor == "string" ? r += `_${this.anchor}` : typeof this.anchor == "object" && (r += `_${this.anchor.toISOString()}`)), r;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.offset = this.offset, r.count = this.count, r.operator = this.operator, this.anchor && (r.anchor = this.anchor), r;
  }
  /**
   * Gets JAQL representing this Filter instance
   *
   */
  filterJaql() {
    const r = {};
    return r[this.operator] = {
      offset: this.offset,
      count: this.count
    }, this.anchor && (typeof this.anchor == "string" ? r[this.operator].anchor = this.anchor : typeof this.anchor == "object" && (r[this.operator].anchor = this.anchor.toISOString())), r;
  }
}
class Lw extends or {
  constructor(r, f, B) {
    super(r, ci.advanced, B), delete f.filterType, this.jaqlExpression = f;
  }
  /**
   * gets the element's ID
   */
  get id() {
    return `custom_${this.attribute.id}_${this.guid}`;
  }
  /**
   * Gets JAQL representing this Filter instance
   *
   */
  filterJaql() {
    return this.jaqlExpression;
  }
}
function UL(t) {
  return "filterType" in t && t.filterType === ci.advanced;
}
function GL(t) {
  return "filterType" in t && t.filterType === ci.members;
}
function XL(t) {
  return "filterType" in t && t.filterType === ci.numeric;
}
function YL(t) {
  return "filterType" in t && t.filterType === ci.ranking;
}
function VL(t) {
  return "filterType" in t && t.filterType === ci.measure;
}
function Ow(t) {
  return "filterType" in t && t.filterType === ci.cascading;
}
function $L(t) {
  return "filterType" in t && t.filterType === ci.relativeDate;
}
function ZL(t) {
  return "filterType" in t && t.filterType === ci.text;
}
function KL(t) {
  return "filterType" in t && t.filterType === ci.dateRange;
}
function Dw(t, r) {
  return new km(t, wm.Union, r);
}
function Iw(t, r) {
  return new km(t, wm.Intersection, r);
}
function Rw(t, r, f) {
  return new Mw(t, r, f);
}
function jw(t, r, f) {
  return new yn(t, mn.DoesntContain, r, f);
}
function _w(t, r, f) {
  return new yn(t, mn.DoesntEndWith, r, f);
}
function Bw(t, r, f) {
  return new yn(t, mn.DoesntStartWith, r, f);
}
function Nw(t, r, f) {
  return new yn(t, mn.Contains, r, f);
}
function zw(t, r, f) {
  return new yn(t, mn.EndsWith, r, f);
}
function Fw(t, r, f) {
  return new yn(t, mn.StartsWith, r, f);
}
function qL(t, r, f) {
  return new yn(t, mn.Like, r, f);
}
function Ww(t, r, f) {
  return typeof r == "string" ? new yn(t, mn.DoesntEqual, r, f) : Yo(t, Wi.DoesntEqual, r, void 0, void 0, f);
}
function Hw(t, r, f) {
  return typeof r == "string" ? new yn(t, mn.Equals, r, f) : Yo(t, Wi.Equals, r, void 0, void 0, f);
}
function Uw(t, r, f) {
  return Yo(t, Wi.FromNotEqual, r, void 0, void 0, f);
}
function Gw(t, r, f) {
  return Yo(t, Wi.From, r, void 0, void 0, f);
}
function Xw(t, r, f) {
  return Yo(t, Wi.ToNotEqual, r, void 0, void 0, f);
}
function Yw(t, r, f) {
  return Yo(t, Wi.To, r, void 0, void 0, f);
}
function hd(t, r, f, B) {
  return Yo(t, Wi.From, r, Wi.To, f, B);
}
function Yo(t, r, f, B, H, tt) {
  return new Pw(t, r, f, B, H, tt);
}
function rp(t, r, f, B, H, tt) {
  return new Tw(t, r, f, B, H, tt);
}
function Vw(t, r, f, B) {
  return new Ew(t, r, f, B);
}
function $w(t, r, f, B, H) {
  return new Mm(t, r, f, Ml.Next, B, H);
}
function Zw(t, r, f, B, H) {
  return new Mm(t, r, f, Ml.Last, B, H);
}
function ha(t, r, f, B, H, tt, st) {
  return new Aw(t, r, f, B, H, tt, st);
}
function Kw(t, r, f) {
  return ha(t.attribute, t, Wi.Equals, r, void 0, void 0, f);
}
function qw(t, r, f) {
  return ha(t.attribute, t, Wi.FromNotEqual, r, void 0, void 0, f);
}
function Jw(t, r, f) {
  return ha(t.attribute, t, Wi.From, r, void 0, void 0, f);
}
function Qw(t, r, f) {
  return ha(t.attribute, t, Wi.To, r, void 0, void 0, f);
}
function tC(t, r, f) {
  return ha(t.attribute, t, Wi.ToNotEqual, r, void 0, void 0, f);
}
function eC(t, r, f, B) {
  return ha(t.attribute, t, Wi.From, r, Wi.To, f, B);
}
function iC(t, r, f, B) {
  return new Tm(t, r, Cm.Top, f, B);
}
function rC(t, r, f, B) {
  return new Tm(t, r, Cm.Bottom, f, B);
}
const _o = (t) => {
  if (Array.isArray(t)) {
    const [r, ...f] = t;
    return f.length === 0 ? _o(r) : {
      operator: "AND",
      left: _o(r),
      right: _o(f)
    };
  }
  return t;
};
var Uu;
(function(t) {
  t.and = (r, f) => ({
    operator: "AND",
    left: _o(r),
    right: _o(f)
  }), t.or = (r, f) => ({
    operator: "OR",
    left: _o(r),
    right: _o(f)
  });
})(Uu = Uu || (Uu = {}));
function nC(t, r, f) {
  return new Lw(t, r, f);
}
function Am(t) {
  try {
    if (t == null)
      return JSON.stringify(t);
    if (t === Object(t) && "composeCode" in t)
      return t.composeCode;
    if (Array.isArray(t))
      return "[" + t.map((r) => Am(r)).join(", ") + "]";
    if (typeof t == "string")
      return `'${t}'`;
    if (typeof t == "number" || !isNaN(t))
      return t;
  } catch (r) {
    console.error(r);
  }
  return JSON.stringify(t);
}
function Be(t) {
  return function(...r) {
    const f = r.map(Am).join(", ").replace(/(,\s*)+$/, ""), B = `filterFactory.${t.name}(${f})`, H = t(...r);
    return H.composeCode = B, H;
  };
}
const yf = "DM", Pm = (t, r, f, B, H, tt, st) => {
  const lt = r != null ? r : t.slice(1, -1).split(".")[0];
  if (B) {
    const yt = Rr.translateJaqlToGranularity({ level: B }), gt = Rr.getDefaultFormatForGranularity(yt), _ = new Rr(tt != null ? tt : f, t, yt, gt, void 0, void 0, st);
    return _.composeCode = nf(lt, f, B, yf), _;
  }
  const ht = Fi(H) ? De.NumericAttribute : De.TextAttribute, ut = new la(tt != null ? tt : f, t, ht, void 0, void 0, st);
  return ut.composeCode = nf(lt, f, void 0, yf), ut;
}, oC = (t) => {
  const { dim: r, table: f, column: B, level: H, datatype: tt, title: st, datasource: lt } = t;
  return Pm(r, f, B, H, tt, st, lt);
}, Em = (t, r, f, B, H, tt, st, lt) => {
  const ht = Pm(t, r, f, B, H, st, lt), ut = sp(ht, tt);
  return ut.composeCode = `measureFactory.${tt}(${ht.composeCode})`, ut;
}, sC = (t) => {
  const r = op(t);
  return r.composeCode = "'Formula code to be implemented'", r;
}, aC = (t) => {
  const { dim: r, table: f, column: B, title: H, level: tt, datatype: st, agg: lt, datasource: ht } = t;
  if (lt)
    return Em(r, f, B, tt, st, lt, H, ht);
}, vf = (t) => {
  if ("formula" in t)
    return sC(t);
  const { dim: r, table: f, column: B, level: H, datatype: tt, agg: st } = t;
  return Em(r, f, B, H, tt, st);
}, lC = (t) => t.top !== void 0, cC = (t) => t.bottom !== void 0, hC = (t) => {
  var r;
  return !!(!((r = t.exclude) === null || r === void 0) && r.members);
}, uC = (t) => !!t.members && !!t.isCondition, dC = (t) => {
  var r, f;
  return ((r = t.last) === null || r === void 0 ? void 0 : r.anchor) !== void 0 || ((f = t.next) === null || f === void 0 ? void 0 : f.anchor) !== void 0;
}, pC = (t) => t.fromNotEqual !== void 0, fC = (t) => t.from !== void 0 && !t.isBetween, gC = (t) => t.toNotEqual !== void 0, mC = (t) => t.to !== void 0 && !t.isBetween, yC = (t) => t.equals !== void 0, vC = (t) => t.doesntEqual !== void 0, bC = (t) => !!(t.equals === "" && t.isEmpty), xC = (t) => !!(t.doesntEqual === "" && t.isEmpty), SC = (t) => t.contains !== void 0, wC = (t) => t.doesntContain !== void 0, CC = (t) => t.startsWith !== void 0, kC = (t) => t.doesntStartWith !== void 0, TC = (t) => t.endsWith !== void 0, MC = (t) => t.doesntEndWith !== void 0, AC = (t) => t.from !== void 0 && t.to !== void 0, PC = (t) => {
  var r, f;
  return ((r = t.exclude) === null || r === void 0 ? void 0 : r.from) !== void 0 && ((f = t.exclude) === null || f === void 0 ? void 0 : f.to) !== void 0;
}, EC = (t) => !!(t.or || t.and), np = (t) => cC(t) ? me.BOTTOM : lC(t) ? me.TOP : hC(t) ? me.IS_NOT : dC(t) ? me.IS_WITHIN : pC(t) ? me.GREATER_THAN : gC(t) ? me.LESS_THAN : yC(t) ? me.EQUALS : vC(t) ? me.DOESNT_EQUAL : bC(t) ? me.IS_EMPTY : xC(t) ? me.IS_NOT_EMPTY : SC(t) ? me.CONTAINS : wC(t) ? me.DOESNT_CONTAIN : MC(t) ? me.DOESNT_END_WITH : kC(t) ? me.DOESNT_START_WITH : TC(t) ? me.ENDS_WITH : CC(t) ? me.STARTS_WITH : PC(t) ? me.IS_NOT_BETWEEN : uC(t) ? me.IS : EC(t) ? me.MULTIPLE_CONDITION : AC(t) ? me.BETWEEN : fC(t) ? me.GREATER_THAN_OR_EQUAL : mC(t) ? me.LESS_THAN_OR_EQUAL : me.NONE, ud = (t, r, f) => {
  var B, H, tt, st, lt;
  switch (np(r)) {
    case me.BOTTOM:
      if (r.by)
        return Be(rC)(t, vf(r.by), r[me.BOTTOM], f);
      break;
    case me.EQUALS:
      return Be(Hw)(t, r[me.EQUALS], f);
    case me.DOESNT_EQUAL:
      return Be(Ww)(t, r[me.DOESNT_EQUAL], f);
    case me.GREATER_THAN:
      return Be(Uw)(t, r[me.GREATER_THAN], f);
    case me.GREATER_THAN_OR_EQUAL:
      return Be(Gw)(t, r[me.GREATER_THAN_OR_EQUAL], f);
    case me.TOP:
      if (r.by)
        return Be(iC)(t, vf(r.by), r[me.TOP], f);
      break;
    case me.STARTS_WITH:
      return Be(Fw)(t, r[me.STARTS_WITH], f);
    case me.DOESNT_START_WITH:
      return Be(Bw)(t, r[me.DOESNT_START_WITH], f);
    case me.ENDS_WITH:
      return Be(zw)(t, r[me.ENDS_WITH], f);
    case me.DOESNT_END_WITH:
      return Be(_w)(t, r[me.DOESNT_END_WITH], f);
    case me.CONTAINS:
      return Be(Nw)(t, r[me.CONTAINS], f);
    case me.DOESNT_CONTAIN:
      return Be(jw)(t, r[me.DOESNT_CONTAIN], f);
    case me.LESS_THAN:
      return Be(Xw)(t, r[me.LESS_THAN], f);
    case me.LESS_THAN_OR_EQUAL:
      return Be(Yw)(t, r[me.LESS_THAN_OR_EQUAL], f);
    case me.BETWEEN:
      return Be(hd)(t, r.from, r.to, f);
    case me.IS_NOT_BETWEEN:
      return Be(Rw)(Be(hd)(t, (B = r.exclude) === null || B === void 0 ? void 0 : B.from, (H = r.exclude) === null || H === void 0 ? void 0 : H.to, f), void 0, f);
    case me.MULTIPLE_CONDITION:
      if (r.and)
        return Be(Iw)(r.and.map((ut) => ud(t, ut, f)), f);
      if (r.or)
        return Be(Dw)(r.or.map((ut) => ud(t, ut, f)), f);
      break;
    case me.IS_NOT:
      return Be(rp)(t, ((tt = r.exclude) === null || tt === void 0 ? void 0 : tt.members) || [], !0, f, ((st = r.filter) === null || st === void 0 ? void 0 : st.turnedOff) && ((lt = r.filter.exclude) === null || lt === void 0 ? void 0 : lt.members) || []);
  }
  throw new ca("errors.filter.unsupportedConditionFilter", {
    filter: JSON.stringify(r)
  });
}, LC = (t, r, f) => {
  switch (np(r)) {
    case me.EQUALS:
      return Be(Kw)(t, r[me.EQUALS], f);
    case me.GREATER_THAN:
      return Be(qw)(t, r[me.GREATER_THAN], f);
    case me.GREATER_THAN_OR_EQUAL:
      return Be(Jw)(t, r[me.GREATER_THAN_OR_EQUAL], f);
    case me.LESS_THAN:
      return Be(tC)(t, r[me.LESS_THAN], f);
    case me.LESS_THAN_OR_EQUAL:
      return Be(Qw)(t, r[me.LESS_THAN_OR_EQUAL], f);
    case me.BETWEEN:
      return Be(eC)(t, r.from, r.to, f);
  }
  throw new ca("errors.filter.unsupportedConditionFilter", {
    filter: JSON.stringify(r)
  });
}, OC = (t, r) => {
  let f = t ? t.toLocaleLowerCase() : $n.YEARS;
  return f === $n.MINUTES && r === "60" && (f = $n.HOURS), f;
}, DC = (t) => t == null ? void 0 : t.all, IC = (t) => t.last ? t.last : t.next, RC = (t) => {
  var r;
  return ((r = IC(t)) === null || r === void 0 ? void 0 : r.offset) < 2;
}, jC = (t) => {
  var r;
  return ((r = t == null ? void 0 : t.members) === null || r === void 0 ? void 0 : r.length) >= 0;
}, _C = (t, r) => t && typeof t == "string" || r && typeof r == "string", BC = (t, r) => t === "" && r === "", NC = (t, r) => {
  const { from: f, to: B } = t;
  return r !== Js.DATE_TIME ? !1 : _C(f, B) ? !0 : BC(f, B);
}, zC = (t) => {
  const { from: r, to: f } = t;
  return r !== void 0 && f !== void 0 && !t.isBetween;
}, FC = (t) => np(t) !== me.NONE, WC = (t) => Object.keys(t).includes("isAdvanced"), HC = (t) => !!(t.level && t.bucket && t.level === $n.MINUTES && rw.includes(t.bucket)), UC = (t) => t.filterType === We.INVALID, bf = (t, r = Js.DATE_TIME, f) => f && HC(f) || WC(t) ? We.ADVANCED : DC(t) ? We.INCLUDE_ALL : RC(t) ? We.PERIOD : jC(t) ? We.SPECIFIC_ITEMS : NC(t, r) ? We.DATE_RANGE : zC(t) ? We.NUMERIC_RANGE : FC(t) ? We.CONDITION : (UC(t), We.INVALID), GC = (t, r) => {
  const { level: f, filter: B, bucket: H } = t, tt = B || ow.filter, st = {
    filter: Object.assign(Object.assign({}, tt), { filterType: bf(tt, r) })
  };
  if (r === Js.DATE_TIME) {
    const lt = tt, ht = (lt == null ? void 0 : lt.level) || f;
    st.level = OC(ht, H), st.filter.filterType = bf(tt, r, { level: ht, bucket: H });
  }
  return st;
}, xf = (t, r) => ({
  guid: r || Lm(13),
  jaql: (f) => f ? t : {
    jaql: t,
    panel: "scope"
  },
  attribute: {
    id: t.dim
  },
  type: "filter",
  serializable() {
    return Object.assign(Object.assign({}, this), { jaql: this.jaql() });
  },
  toJSON() {
    return this.serializable();
  }
}), XC = (t, r) => Be(rp)(t, [], !0, r), YC = (t, r, f) => {
  const B = VC(r), H = $C(r, B);
  return Be(rp)(
    t,
    H,
    void 0,
    // use undefined instead of false to avoid including the property in composeCode
    f,
    B
  );
};
function VC(t) {
  var r, f, B;
  return !((r = t.filter) === null || r === void 0) && r.turnedOff ? (B = (f = t.filter) === null || f === void 0 ? void 0 : f.exclude) === null || B === void 0 ? void 0 : B.members : void 0;
}
function $C(t, r) {
  const f = t.members;
  return r ? f.filter((B) => !r.includes(B)) : f;
}
const ZC = (t, r, f) => Be(Vw)(t, r.from, r.to, f), KC = (t, r, f) => Be(hd)(t, r.from, r.to, f), qC = (t, r, f) => r.last ? Be(Zw)(t, r.last.offset, r.last.count, r.last.anchor, f) : Be($w)(t, r.next.offset, r.next.count, r.next.anchor, f), JC = (t, r, f, B) => f ? LC(f, r, B) : ud(t, r, B), QC = (t, r, f) => Be(nC)(t, r, f), Sf = (t, r) => {
  try {
    if ("formula" in t)
      throw new ca("errors.filter.formulaFiltersNotSupported", {
        filter: JSON.stringify(t)
      });
    const f = GC(t, t.datatype), { filter: B } = f, { filterType: H } = B, tt = oC(t), st = aC(t);
    switch (H) {
      case We.INCLUDE_ALL:
        return XC(tt, r);
      case We.SPECIFIC_ITEMS:
        return YC(tt, B, r);
      case We.CONDITION:
        return JC(tt, B, st, r);
      case We.DATE_RANGE:
        return ZC(tt, B, r);
      case We.PERIOD:
        return qC(tt, B, r);
      case We.NUMERIC_RANGE:
        return KC(tt, B, r);
      case We.ADVANCED:
        return QC(tt, B, r);
      case We.INVALID:
        return xf(t, r);
    }
  } catch (f) {
    console.debug("Fall back to generic pass-through JAQL filter due to filter translation error:", f);
  }
  return xf(t, r);
}, Lm = function(t) {
  const r = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""), f = new Array(t);
  let B = 0, H;
  for (let tt = 0; tt < t; tt += 1) {
    if (tt > 0 && tt % 5 == 0) {
      f[tt] = "-";
      continue;
    }
    B <= 2 && (B = 33554432 + Math.random() * 16777216 | 0), H = B & 15, B = B >> 4, f[tt] = r[tt == 19 ? H & 3 | 8 : H];
  }
  return f.join("");
}, JL = (t) => {
  if (!t)
    return { filters: void 0, relations: void 0 };
  if (Array.isArray(t))
    return { filters: t, relations: void 0 };
  const r = /* @__PURE__ */ new Set();
  function f(tt) {
    return tt && ("guid" in tt ? (r.add(tt), { instanceid: tt.guid }) : ("left" in tt && (tt.left = f(tt.left)), "right" in tt && (tt.right = f(tt.right)), tt));
  }
  const B = Fh(t), H = f(B);
  return { filters: Array.from(r), relations: H };
};
function QL(t) {
  return typeof t == "string" ? t : t.title;
}
function tk(t) {
  return typeof t == "object" && "type" in t && "title" in t;
}
function tO(t) {
  return {
    title: t.title,
    type: t.live ? "live" : "elasticube"
  };
}
function eO(t) {
  return tk(t) ? {
    title: t.title,
    live: t.type === "live"
  } : {
    title: t,
    live: !1
  };
}
function Om(t) {
  return t ? t === "asc" ? di.Ascending : di.Descending : di.None;
}
const ek = (t, r) => {
  const f = t.filter.filter && !("turnedOff" in t.filter.filter), B = Sf(t, r);
  return f && (B.backgroundFilter = Sf(Object.assign(Object.assign({}, t), { filter: t.filter.filter }), `${r}-bg`)), B;
};
function Dm(t) {
  const [r, f] = t.slice(1, -1).split(".");
  return {
    table: r,
    column: f
  };
}
function iO(t) {
  return Dm(t.expression).table;
}
function rO(t) {
  return Dm(t.expression).column;
}
function ik(t, r, f) {
  if (typeof f == "number")
    t.push(f.toString());
  else if (f && De.isMeasureTemplate(f.type)) {
    f = f.sum();
    const B = `[${qs(f.name)}]`;
    t.push(B), r[B] = f;
  } else if (f && De.isMeasure(f.type)) {
    const B = `[${qs(f.name)}]`;
    t.push(B), r[B] = f;
  } else if (f && De.isFilter(f.type)) {
    const B = `[${qs(f.name)}]`;
    t.push(B), r[B] = f;
  } else if (f && De.isAttribute(f.type)) {
    const B = `[${qs(f.name)}]`;
    t.push(B), r[B] = f;
  }
}
function Im(t, r, f, B) {
  const H = {}, tt = [f + "("];
  return ik(tt, H, t), B && tt.push(`, ${B}`), tt.push(")"), new Al(r, tt.join(""), H);
}
function rk(t) {
  if ("formula" in t)
    return op(t);
  const f = Om(t.sort), B = !!t.agg, H = pn(t.datatype), tt = Fi(t.datatype) ? De.NumericAttribute : De.TextAttribute, st = H ? new Rr(t.title, t.dim, Rr.translateJaqlToGranularity(t), void 0, void 0, f) : new la(t.title, t.dim, tt, void 0, f);
  return B ? new Zn(t.title, st, Zn.aggregationFromJAQL(t.agg || ""), void 0, void 0, f) : "filter" in t ? ek(t) : st;
}
function op(t) {
  var r;
  if (!("formula" in t))
    throw new ca("errors.measure.notAFormula");
  const B = Om(t.sort), H = M1((r = t.context) !== null && r !== void 0 ? r : {}, (tt) => tt ? rk(tt) : {});
  return new Al(t.title, t.formula, H, void 0, void 0, B);
}
function nO(t, r, f) {
  const B = Object.entries(f).reduce((H, [tt, st]) => (H[`[${tt}]`] = st.jaql().jaql, H), {});
  return op({ title: t, formula: r, context: B });
}
function sp(t, r, f, B) {
  return new Zn(`${r.toString()} ${t.name}`, t, r, B);
}
function oO(t, r, f) {
  return sp(t, oi.Min, r, f);
}
function sO(t, r, f) {
  return sp(t, oi.Max, r, f);
}
function nk(t, r, f) {
  let B;
  const H = (tt) => tt.replace("advancedSmoothing", "smooth").replace("localEstimates", "local");
  return f && (B = Object.entries(f).map((tt) => H(`"${tt[0]}=${tt[1]}"`)).join(",")), Im(t, r != null ? r : t.name + " Trend", "trend", B);
}
function ok(t, r, f) {
  let B;
  if (f) {
    const H = Object.assign({ forecastHorizon: 3 }, f);
    if (H.startDate) {
      const tt = new Date(H.startDate);
      H.startDate = tt.toISOString().replace(/.\d+Z$/g, "");
    }
    if (H.endDate) {
      const tt = new Date(H.endDate);
      H.endDate = tt.toISOString().replace(/.\d+Z$/g, "");
    }
    B = Object.entries(H).map((tt) => `"${tt[0]}=${tt[1]}"`).join(",");
  } else
    B = '"forecastHorizon=3"';
  return Im(t, r != null ? r : t.name + " Forecast", "forecast", B);
}
class Rm extends Ih {
  constructor(r, f, B, H, tt) {
    super(r, f, H), this._sort = di.None, this._format = "#,#.00", this._format = B, this._sort = tt || di.None;
  }
  /**
   * Gets the sort definition of this instance
   *
   * @returns The Sort definition of this instance
   */
  getSort() {
    return this._sort;
  }
  /**
   * The string formatting of this instance
   *
   * @returns string formatting
   */
  getFormat() {
    return this._format;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return this.getFormat() !== void 0 && (r.format = this.getFormat()), this.getSort() !== void 0 && (r.sort = this.getSort()), r;
  }
}
class Zn extends Rm {
  constructor(r, f, B, H, tt, st) {
    super(r, De.BaseMeasure, H, tt, st), this.attribute = f, this.aggregation = B;
  }
  static aggregationFromJAQL(r) {
    switch (r) {
      case "sum":
        return oi.Sum;
      case "avg":
        return oi.Average;
      case "min":
        return oi.Min;
      case "max":
        return oi.Max;
      case "countduplicates":
        return oi.Count;
      case "median":
        return oi.Median;
      case "count":
        return oi.CountDistinct;
      case "var":
        return oi.Variance;
      case "stdev":
        return oi.StandardDeviation;
    }
    return oi.Sum;
  }
  static aggregationToJAQL(r) {
    switch (r) {
      case oi.Sum:
        return "sum";
      case oi.Average:
        return "avg";
      case oi.Min:
        return "min";
      case oi.Max:
        return "max";
      case oi.Count:
        return "countduplicates";
      case oi.CountDistinct:
        return "count";
      case oi.Median:
        return "median";
      case oi.Variance:
        return "var";
      case oi.StandardDeviation:
        return "stdev";
    }
    return oi.Sum;
  }
  /**
   * Gets a sorted {@link Measure} with the given definition
   *
   * @param sort - Sort definition
   * @returns An instance representing the sorted {@link Measure} of this instance
   */
  sort(r) {
    return new Zn(this.name, this.attribute, this.aggregation, this._format, this.description, r);
  }
  /**
   * Gets a formatted {@link Measure} with the given definition
   *
   * Input string is in Numeral format - @see http://numeraljs.com/
   *
   * @param format - Format string
   * @returns An instance representing the formatted {@link Measure} of this instance
   */
  format(r) {
    return new Zn(this.name, this.attribute, this.aggregation, r, this.description, this._sort);
  }
  /**
   * gets the element's ID
   */
  get id() {
    return `${this.attribute.expression}_${this.aggregation}`;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.aggregation = this.aggregation, r.attribute = this.attribute.serializable(), r;
  }
  jaql(r) {
    const f = this.attribute.jaql(!0), B = {
      jaql: Object.assign(Object.assign({}, f), { title: this.name, agg: Zn.aggregationToJAQL(this.aggregation) })
    };
    return this._format && (B.format = { number: this._format }), this._sort != di.None && (B.jaql.sort = this._sort == di.Ascending ? "asc" : "desc"), r === !0 ? B.jaql : B;
  }
}
class Al extends Rm {
  constructor(r, f, B, H, tt, st) {
    super(r, De.CalculatedMeasure, H, tt, st), this.expression = f, this.context = B;
  }
  /**
   * Gets a sorted {@link Measure} with the given definition
   *
   * @param sort - Sort definition
   * @returns An instance representing the sorted {@link Measure} of this instance
   */
  sort(r) {
    return new Al(this.name, this.expression, this.context, this._format, this.description, r);
  }
  /**
   * Gets a formatted {@link Measure} with the given definition
   *
   * Input string is in Numeral format - @see http://numeraljs.com/
   *
   * @param format - Format string
   * @returns An instance representing the formatted {@link Measure} of this instance
   */
  format(r) {
    return new Al(this.name, this.expression, this.context, r, this.description, this._sort);
  }
  /**
   * gets the element's ID
   */
  get id() {
    return this.expression;
  }
  /**
   * Gets a serializable representation of the element
   */
  serializable() {
    const r = super.serializable();
    return r.expression = this.expression, r.context = {}, Object.getOwnPropertyNames(this.context).forEach((f) => {
      r.context[f] = this.context[f].serializable();
    }), r;
  }
  jaql(r) {
    const f = {
      jaql: {
        title: this.name,
        formula: this.expression
      }
    }, B = {};
    return Object.getOwnPropertyNames(this.context).forEach((tt) => B[tt] = this.context[tt].jaql(!0)), f.jaql.context = B, this._format && (f.format = { number: this._format }), this._sort != di.None && (f.jaql.sort = this._sort == di.Ascending ? "asc" : "desc"), r === !0 ? f.jaql : f;
  }
}
function sk(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var r = Number(t);
  return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
}
function ak(t, r) {
  if (r.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + r.length + " present");
}
var jm = 6e4, _m = 36e5;
function Bm(t, r) {
  var f;
  ak(1, arguments);
  var B = sk((f = void 0) !== null && f !== void 0 ? f : 2);
  if (B !== 2 && B !== 1 && B !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var H = uk(t), tt;
  if (H.date) {
    var st = dk(H.date, B);
    tt = pk(st.restDateString, st.year);
  }
  if (!tt || isNaN(tt.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var lt = tt.getTime(), ht = 0, ut;
  if (H.time && (ht = fk(H.time), isNaN(ht)))
    return /* @__PURE__ */ new Date(NaN);
  if (H.timezone) {
    if (ut = gk(H.timezone), isNaN(ut))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var yt = new Date(lt + ht), gt = /* @__PURE__ */ new Date(0);
    return gt.setFullYear(yt.getUTCFullYear(), yt.getUTCMonth(), yt.getUTCDate()), gt.setHours(yt.getUTCHours(), yt.getUTCMinutes(), yt.getUTCSeconds(), yt.getUTCMilliseconds()), gt;
  }
  return new Date(lt + ht + ut);
}
var Fc = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, lk = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, ck = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, hk = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function uk(t) {
  var r = {}, f = t.split(Fc.dateTimeDelimiter), B;
  if (f.length > 2)
    return r;
  if (/:/.test(f[0]) ? B = f[0] : (r.date = f[0], B = f[1], Fc.timeZoneDelimiter.test(r.date) && (r.date = t.split(Fc.timeZoneDelimiter)[0], B = t.substr(r.date.length, t.length))), B) {
    var H = Fc.timezone.exec(B);
    H ? (r.time = B.replace(H[1], ""), r.timezone = H[1]) : r.time = B;
  }
  return r;
}
function dk(t, r) {
  var f = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"), B = t.match(f);
  if (!B)
    return {
      year: NaN,
      restDateString: ""
    };
  var H = B[1] ? parseInt(B[1]) : null, tt = B[2] ? parseInt(B[2]) : null;
  return {
    year: tt === null ? H : tt * 100,
    restDateString: t.slice((B[1] || B[2]).length)
  };
}
function pk(t, r) {
  if (r === null)
    return /* @__PURE__ */ new Date(NaN);
  var f = t.match(lk);
  if (!f)
    return /* @__PURE__ */ new Date(NaN);
  var B = !!f[4], H = pl(f[1]), tt = pl(f[2]) - 1, st = pl(f[3]), lt = pl(f[4]), ht = pl(f[5]) - 1;
  if (B)
    return xk(r, lt, ht) ? mk(r, lt, ht) : /* @__PURE__ */ new Date(NaN);
  var ut = /* @__PURE__ */ new Date(0);
  return !vk(r, tt, st) || !bk(r, H) ? /* @__PURE__ */ new Date(NaN) : (ut.setUTCFullYear(r, tt, Math.max(H, st)), ut);
}
function pl(t) {
  return t ? parseInt(t) : 1;
}
function fk(t) {
  var r = t.match(ck);
  if (!r)
    return NaN;
  var f = Gu(r[1]), B = Gu(r[2]), H = Gu(r[3]);
  return Sk(f, B, H) ? f * _m + B * jm + H * 1e3 : NaN;
}
function Gu(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function gk(t) {
  if (t === "Z")
    return 0;
  var r = t.match(hk);
  if (!r)
    return 0;
  var f = r[1] === "+" ? -1 : 1, B = parseInt(r[2]), H = r[3] && parseInt(r[3]) || 0;
  return wk(B, H) ? f * (B * _m + H * jm) : NaN;
}
function mk(t, r, f) {
  var B = /* @__PURE__ */ new Date(0);
  B.setUTCFullYear(t, 0, 4);
  var H = B.getUTCDay() || 7, tt = (r - 1) * 7 + f + 1 - H;
  return B.setUTCDate(B.getUTCDate() + tt), B;
}
var yk = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Nm(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function vk(t, r, f) {
  return r >= 0 && r <= 11 && f >= 1 && f <= (yk[r] || (Nm(t) ? 29 : 28));
}
function bk(t, r) {
  return r >= 1 && r <= (Nm(t) ? 366 : 365);
}
function xk(t, r, f) {
  return r >= 1 && r <= 53 && f >= 0 && f <= 6;
}
function Sk(t, r, f) {
  return t === 24 ? r === 0 && f === 0 : f >= 0 && f < 60 && r >= 0 && r < 60 && t >= 0 && t < 25;
}
function wk(t, r) {
  return r >= 0 && r <= 59;
}
var Ck = /\s/;
function kk(t) {
  for (var r = t.length; r-- && Ck.test(t.charAt(r)); )
    ;
  return r;
}
var Tk = /^\s+/;
function Mk(t) {
  return t && t.slice(0, kk(t) + 1).replace(Tk, "");
}
var wf = NaN, Ak = /^[-+]0x[0-9a-f]+$/i, Pk = /^0b[01]+$/i, Ek = /^0o[0-7]+$/i, Lk = parseInt;
function zm(t) {
  if (typeof t == "number")
    return t;
  if (Bh(t))
    return wf;
  if (jr(t)) {
    var r = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = jr(r) ? r + "" : r;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = Mk(t);
  var f = Pk.test(t);
  return f || Ek.test(t) ? Lk(t.slice(2), f ? 2 : 8) : Ak.test(t) ? wf : +t;
}
var Cf = 1 / 0, Ok = 17976931348623157e292;
function Dk(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = zm(t), t === Cf || t === -Cf) {
    var r = t < 0 ? -1 : 1;
    return r * Ok;
  }
  return t === t ? t : 0;
}
class Jn extends Wg {
  constructor(r, f) {
    super(
      Yg,
      {
        key: r,
        interpolationOptions: f
      },
      y0.t
    );
  }
}
function ap() {
}
function Qn(t, r) {
  this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = void 0;
}
Qn.prototype = ep(ap.prototype);
Qn.prototype.constructor = Qn;
var kf = xr ? xr.isConcatSpreadable : void 0;
function Ik(t) {
  return nr(t) || zd(t) || !!(kf && t && t[kf]);
}
function Rk(t, r, f, B, H) {
  var tt = -1, st = t.length;
  for (f || (f = Ik), H || (H = []); ++tt < st; ) {
    var lt = t[tt];
    f(lt) ? Gd(H, lt) : B || (H[H.length] = lt);
  }
  return H;
}
function jk(t) {
  var r = t == null ? 0 : t.length;
  return r ? Rk(t) : [];
}
function Fm(t, r, f) {
  switch (f.length) {
    case 0:
      return t.call(r);
    case 1:
      return t.call(r, f[0]);
    case 2:
      return t.call(r, f[0], f[1]);
    case 3:
      return t.call(r, f[0], f[1], f[2]);
  }
  return t.apply(r, f);
}
var Tf = Math.max;
function Wm(t, r, f) {
  return r = Tf(r === void 0 ? t.length - 1 : r, 0), function() {
    for (var B = arguments, H = -1, tt = Tf(B.length - r, 0), st = Array(tt); ++H < tt; )
      st[H] = B[r + H];
    H = -1;
    for (var lt = Array(r + 1); ++H < r; )
      lt[H] = B[H];
    return lt[r] = f(st), Fm(t, this, lt);
  };
}
function _k(t) {
  return function() {
    return t;
  };
}
var Bk = ph ? function(t, r) {
  return ph(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: _k(r),
    writable: !0
  });
} : qd, Nk = 800, zk = 16, Fk = Date.now;
function Wk(t) {
  var r = 0, f = 0;
  return function() {
    var B = Fk(), H = zk - (B - f);
    if (f = B, H > 0) {
      if (++r >= Nk)
        return arguments[0];
    } else
      r = 0;
    return t.apply(void 0, arguments);
  };
}
var Hm = Wk(Bk);
function lp(t) {
  return Hm(Wm(t, void 0, jk), t + "");
}
var Mf = kl && new kl();
function Hk() {
}
var Um = Mf ? function(t) {
  return Mf.get(t);
} : Hk, Af = {}, Uk = Object.prototype, Gk = Uk.hasOwnProperty;
function nh(t) {
  for (var r = t.name + "", f = Af[r], B = Gk.call(Af, r) ? f.length : 0; B--; ) {
    var H = f[B], tt = H.func;
    if (tt == null || tt == t)
      return H.name;
  }
  return r;
}
var Xk = 4294967295;
function ia(t) {
  this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Xk, this.__views__ = [];
}
ia.prototype = ep(ap.prototype);
ia.prototype.constructor = ia;
function Yk(t) {
  if (t instanceof ia)
    return t.clone();
  var r = new Qn(t.__wrapped__, t.__chain__);
  return r.__actions__ = fm(t.__actions__), r.__index__ = t.__index__, r.__values__ = t.__values__, r;
}
var Vk = Object.prototype, $k = Vk.hasOwnProperty;
function yh(t) {
  if (Jr(t) && !nr(t) && !(t instanceof ia)) {
    if (t instanceof Qn)
      return t;
    if ($k.call(t, "__wrapped__"))
      return Yk(t);
  }
  return new Qn(t);
}
yh.prototype = ap.prototype;
yh.prototype.constructor = yh;
function Pf(t) {
  var r = nh(t), f = yh[r];
  if (typeof f != "function" || !(r in ia.prototype))
    return !1;
  if (t === f)
    return !0;
  var B = Um(f);
  return !!B && t === B[0];
}
var Zk = "Expected a function", Kk = 8, qk = 32, Jk = 128, Qk = 256;
function tT(t) {
  return lp(function(r) {
    for (var f = r.length, B = f, H = Qn.prototype.thru; B--; ) {
      var tt = r[B];
      if (typeof tt != "function")
        throw new TypeError(Zk);
      if (H && !st && nh(tt) == "wrapper")
        var st = new Qn([], !0);
    }
    for (B = st ? B : f; ++B < f; ) {
      tt = r[B];
      var lt = nh(tt), ht = lt == "wrapper" ? Um(tt) : void 0;
      ht && Pf(ht[0]) && ht[1] == (Jk | Kk | qk | Qk) && !ht[4].length && ht[9] == 1 ? st = st[nh(ht[0])].apply(st, ht[3]) : st = tt.length == 1 && Pf(tt) ? st[lt]() : st.thru(tt);
    }
    return function() {
      var ut = arguments, yt = ut[0];
      if (st && ut.length == 1 && nr(yt))
        return st.plant(yt).value();
      for (var gt = 0, _ = f ? r[gt].apply(this, ut) : yt; ++gt < f; )
        _ = r[gt].call(this, _);
      return _;
    };
  });
}
var eT = tT();
const vh = (t, r) => {
  const f = !t || t === "";
  let B, H, tt;
  return Fi(r) ? (B = parseFloat(t), H = isNaN(B)) : pn(r) ? (B = Bm(t).valueOf(), H = isNaN(B)) : (B = t, tt = t == null ? void 0 : t.toLowerCase(), H = !1), Ut({
    value: B,
    valueUndefined: f,
    valueIsNaN: H
  }, tt && { lowercaseValue: tt });
};
function Ef(t, r) {
  const f = jr(t) ? t : { displayValue: t == null ? void 0 : t.toString() };
  return f.compareValue || (f.compareValue = vh(f.displayValue, r)), f;
}
var Gm = /* @__PURE__ */ ((t) => (t[t.ASC = 1] = "ASC", t[t.DESC = -1] = "DESC", t[t.NONE = 0] = "NONE", t))(Gm || {});
function Xm(t, r, f = 1, B = "string") {
  const H = Ef(t, B), tt = Ef(r, B), st = H.compareValue, lt = tt.compareValue;
  if (st.valueUndefined && lt.valueUndefined)
    return 0;
  if (st.valueUndefined)
    return 1;
  if (lt.valueUndefined)
    return -1;
  if (st.valueIsNaN && lt.valueIsNaN)
    return 0;
  if (st.valueIsNaN)
    return 1;
  if (lt.valueIsNaN)
    return -1;
  const ht = st.lowercaseValue, ut = lt.lowercaseValue;
  if (ht !== void 0 && ut !== void 0) {
    if (ht < ut)
      return -1 * f;
    if (ht > ut)
      return 1 * f;
  }
  return st.value < lt.value ? -1 * f : st.value > lt.value ? 1 * f : 0;
}
class Ym {
  constructor(r) {
    ui(this, "columns", []);
    this.columns = r;
  }
  compare(r, f) {
    for (let B = 0; B < this.columns.length; B++) {
      const H = this.columns[B], tt = r[H.index], st = f[H.index], lt = H.direction || 1, ht = Xm(tt, st, lt, H.type);
      if (ht !== 0)
        return ht;
    }
    return 0;
  }
}
const iT = (t) => t instanceof Object && "data" in t, aO = (t) => t.rows.length === 0, Vm = "$rownum", lO = (t) => {
  let r = 0;
  const f = t.rows.map((H) => {
    const tt = t.columns.map((st, lt) => {
      var gt;
      const ht = H[lt];
      if (iT(ht)) {
        let _ = ht.data.toString();
        if (pn(st.type)) {
          const at = "1111-11-11T";
          _.startsWith(at) && (_ = _.replace(at, "1970-01-01T"));
        }
        return Ut(Ut({
          rawValue: ht.data,
          displayValue: (gt = ht.text) != null ? gt : _,
          compareValue: vh(_, st.type)
        }, ht.blur !== void 0 ? { blur: ht.blur } : {}), ht.color ? { color: ht.color } : {});
      }
      let ut, yt;
      return pn(st.type) && (ut = vh(`${ht}`, st.type), yt = new Date(ut.value).toISOString()), {
        rawValue: yt != null ? yt : ht,
        displayValue: `${ht != null ? ht : ""}`,
        compareValue: ut
      };
    });
    return r++, tt.push({
      displayValue: `${r}`,
      rawValue: r
    }), tt;
  }), B = t.columns.map((H, tt) => ({
    name: H.name,
    type: H.type,
    index: tt,
    direction: 0
  }));
  return B.push({
    name: Vm,
    type: "number",
    index: B.length,
    direction: 0
  }), {
    columns: B,
    rows: f
  };
}, $m = ["polar"], rT = [
  "line",
  "area",
  "bar",
  "column",
  ...$m
], nT = ["pie", "funnel", "treemap", "sunburst"], oT = ["scatter"], sT = ["table"], aT = ["indicator"], lT = ["boxplot"], cT = ["areamap"], hT = ["scattermap"], uT = ["arearange"], Zm = (t) => rT.find((r) => r === t) !== void 0, dT = (t) => nT.find((r) => r === t) !== void 0, pT = (t) => oT.find((r) => r === t) !== void 0, fT = (t) => hT.find((r) => r === t) !== void 0, gT = (t) => aT.find((r) => r === t) !== void 0, Km = (t) => $m.find((r) => r === t) !== void 0, cO = (t) => sT.find((r) => r === t) !== void 0, mT = (t) => lT.find((r) => r === t) !== void 0, yT = (t) => cT.find((r) => r === t) !== void 0, hO = (t) => uT.find((r) => r === t) !== void 0;
class Lf {
  constructor(r) {
    ui(this, "data");
    ui(this, "sum");
    ui(this, "max");
    ui(this, "min");
    ui(this, "avg");
    ui(this, "variance");
    ui(this, "stddev");
    this.data = r;
  }
  getStat(r) {
    switch (r) {
      case "sum":
        return this.getSum();
      case "max":
        return this.getMax();
      case "min":
        return this.getMin();
      case "count":
        return this.getCount();
      case "countdistinct":
        return this.getCountDistinct();
      case "avg":
      case "mean":
      case "average":
        return this.getAverage();
      case "var":
      case "variance":
        return this.getVariance();
      case "stddev":
        return this.getStdDev();
    }
    return NaN;
  }
  getSum() {
    if (this.data.length === 0)
      return NaN;
    if (this.sum != null)
      return this.sum;
    this.sum = 0;
    for (const r of this.data)
      this.sum += r;
    return this.sum;
  }
  getMax() {
    if (this.data.length === 0)
      return NaN;
    if (this.max)
      return this.max;
    if (this.data.length <= 0)
      return NaN;
    this.max = this.data[0];
    for (const r of this.data)
      r > this.max && (this.max = r);
    return this.max;
  }
  getMin() {
    if (this.data.length === 0)
      return NaN;
    if (this.min)
      return this.min;
    if (this.data.length <= 0)
      return NaN;
    this.min = this.data[0];
    for (const r of this.data)
      r < this.min && (this.min = r);
    return this.min;
  }
  getMean() {
    return this.getAverage();
  }
  getAverage() {
    return this.data.length === 0 ? NaN : this.avg ? this.avg : (this.avg = this.getSum() / this.data.length, this.avg);
  }
  getN() {
    return this.getCount();
  }
  getCount() {
    return this.data.length;
  }
  getCountDistinct() {
    return this.data.filter((r, f, B) => B.indexOf(r) === f).length;
  }
  getVariance() {
    if (this.variance === void 0)
      if (this.data.length === 0)
        this.variance = NaN;
      else if (this.data.length === 1)
        this.variance = 0;
      else {
        const r = this.getMean();
        this.variance = this.data.reduce((f, B) => f.concat(pe(B - r, 2)), []).reduce((f, B) => f + B, 0) / (this.data.length - 1);
      }
    return this.variance;
  }
  getStdDev() {
    return this.data.length === 0 ? NaN : this.stddev != null ? this.stddev : (this.stddev = Math.sqrt(this.getVariance()), this.stddev);
  }
}
class vT {
  constructor(r) {
    ui(this, "data");
    ui(this, "countDistinct");
    this.data = r;
  }
  getStat(r) {
    switch (r) {
      case "count":
        return this.getCount();
      case "countdistinct":
        return this.getCountDistinct();
    }
    return NaN;
  }
  getN() {
    return this.getCount();
  }
  getCount() {
    return this.data.length;
  }
  getCountDistinct() {
    return this.data.filter((r, f, B) => B.indexOf(r) === f).length;
  }
}
const qm = (t, r) => t.slice(0).sort((f, B) => r.compare(f, B)), cp = (t, r) => {
  if (!(t && t.length > 0))
    return [];
  const f = new Ym(r), B = qm(t, f);
  let H = [];
  const tt = [];
  let st = B[0];
  for (const lt of Array.from(B))
    f.compare(lt, st) !== 0 && (tt.push(H), H = []), H.push(lt), st = lt;
  return tt.push(H), tt;
}, bT = (t, r) => {
  var B, H;
  const f = [];
  for (const tt of r) {
    let st;
    const lt = tt.column, { aggFunc: ht } = tt, ut = t.filter((_) => !!_[lt.index] && _[lt.index].displayValue !== ""), yt = (H = (B = ut.find((_) => {
      var at;
      return _ !== void 0 && ((at = _ == null ? void 0 : _[lt.index]) == null ? void 0 : at.color);
    })) == null ? void 0 : B[lt.index]) == null ? void 0 : H.color, gt = ut.some((_) => _[lt.index].blur);
    if (pn(lt.type)) {
      const _ = ut.map((at) => Bm(at[lt.index].displayValue).valueOf());
      st = new Lf(_).getStat(ht);
    } else if (Fi(lt.type)) {
      const _ = ut.map((at) => parseFloat(at[lt.index].displayValue));
      st = new Lf(_).getStat(ht);
    } else {
      const _ = ut.map((at) => at[lt.index].displayValue);
      st = new vT(_).getStat(ht);
    }
    f.push(Ut(Ut({
      displayValue: `${st}`
    }, yt && { color: yt }), gt && { blur: gt }));
  }
  return f;
}, xT = (t, r) => {
  if (Qm(t))
    return { columns: [], rows: [] };
  const f = new Ym(r);
  return { columns: t.columns, rows: qm(t.rows, f) };
}, ST = (t, r, f) => {
  if (Qm(t))
    return { rows: [], columns: [] };
  const B = { name: "n/a", type: "n/a", index: -1, direction: 0 }, H = f.map((ut) => ({
    aggFunc: ut.agg,
    aggName: ut.title,
    column: Bo(t, ut.column) || B
  })).filter((ut) => ut.column.index !== -1), tt = cp(t.rows, r), st = H.map((ut) => ut.aggName), lt = [];
  for (const ut of tt) {
    const yt = jl(ut[0], r), gt = bT(ut, H), _ = yt.slice(0).concat(gt);
    lt.push(_);
  }
  const ht = r.slice(0).concat(
    st.map((ut) => ({
      name: ut,
      type: "number",
      index: 0,
      direction: 0
    }))
  );
  return {
    rows: lt,
    columns: ht.map((ut, yt) => oe(Ut({}, ut), { index: yt }))
  };
}, Bo = (t, r) => t.columns.find((f) => f.name === r), bh = (t, r) => {
  const f = {
    name: "foo",
    type: "string",
    index: -1,
    direction: 0
  };
  return r.map((B) => Bo(t, B) || f).filter((B) => B !== f);
}, wT = (t, r) => {
  const f = t.rows.map((H) => r.map((tt) => H[tt.index]));
  return { columns: r.map((H, tt) => oe(Ut({}, H), { index: tt })), rows: f };
}, CT = (t, r) => {
  if (!(t && r.index < t.length))
    return;
  const f = t[r.index];
  return f.compareValue || (f.compareValue = vh(f.displayValue, r.type)), f.compareValue.value;
}, kT = (t, r) => {
  var f;
  return (f = t[r.index]) == null ? void 0 : f.blur;
}, jl = (t, r) => {
  const f = [];
  for (const B of r)
    f.push(t[B.index]);
  return f;
}, TT = (t, r) => jl(t, r).map((f) => f.rawValue || f.displayValue).join(","), Jm = (t, r) => {
  if (!(t && t.length > 0))
    return {};
  const f = cp(t, r), B = {};
  for (const H of f) {
    const tt = TT(H[0], r);
    B[tt] = H;
  }
  return B;
}, Qm = (t) => !(t.rows && t.columns && t.rows.length > 0 && t.columns.length > 0), ty = ({ x: t, y: r, breakBy: f }) => iy(r) && ey(t) && f.length === 0, MT = ({ x: t, y: r, breakBy: f }) => ey(t) && iy(r) && f.length > 0, ey = (t) => t.length === 0, iy = (t) => t.length > 0, AT = (t, r) => t * (r / 100), PT = (t, r) => t === 0 ? 0 : Math.abs(r) / Math.abs(t) * 100, oh = (t) => `${t}%`;
var Of;
(function(t) {
  t.event = "event", t.props = "prop";
})(Of || (Of = {}));
function ET(t) {
  switch (t) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function LT(t, r, f) {
  var B = ET(f), H = t.search(/[1-9]/);
  return H = H === -1 ? t.length : H, t.substring(0, H) + t.substring(H, t.length).replace(B, "$1" + r);
}
function OT(t, r) {
  r === void 0 && (r = !0);
  var f = t[0] === "-", B = f && r;
  t = t.replace("-", "");
  var H = t.split("."), tt = H[0], st = H[1] || "";
  return {
    beforeDecimal: tt,
    afterDecimal: st,
    hasNegation: f,
    addNegation: B
  };
}
function DT(t, r, f) {
  for (var B = "", H = f ? "0" : "", tt = 0; tt <= r - 1; tt++)
    B += t[tt] || H;
  return B;
}
function IT(t, r) {
  var f = r.decimalScale, B = r.fixedDecimalScale, H = r.prefix;
  H === void 0 && (H = "");
  var tt = r.suffix;
  tt === void 0 && (tt = "");
  var st = r.allowNegative, lt = r.thousandsGroupStyle;
  if (lt === void 0 && (lt = "thousand"), t === "" || t === "-")
    return t;
  var ht = RT(r), ut = ht.thousandSeparator, yt = ht.decimalSeparator, gt = f !== 0 && t.indexOf(".") !== -1 || f && B, _ = OT(t, st), at = _.beforeDecimal, G = _.afterDecimal, F = _.addNegation;
  return f !== void 0 && (G = DT(G, f, !!B)), ut && (at = LT(at, ut, lt)), H && (at = H + at), tt && (G = G + tt), F && (at = "-" + at), t = at + (gt && yt || "") + G, t;
}
function RT(t) {
  var r = t.decimalSeparator;
  r === void 0 && (r = ".");
  var f = t.thousandSeparator, B = t.allowedDecimalSeparators;
  return f === !0 && (f = ","), B || (B = [r, "."]), {
    decimalSeparator: r,
    thousandSeparator: f,
    allowedDecimalSeparators: B
  };
}
function jT(t) {
  var r = Dk(t), f = r % 1;
  return r === r ? f ? r - f : r : 0;
}
var _T = _r.isFinite, BT = Math.min;
function NT(t) {
  var r = Math[t];
  return function(f, B) {
    if (f = zm(f), B = B == null ? 0 : BT(jT(B), 292), B && _T(f)) {
      var H = (ld(f) + "e").split("e"), tt = r(H[0] + "e" + (+H[1] + B));
      return H = (ld(tt) + "e").split("e"), +(H[0] + "e" + (+H[1] - B));
    }
    return r(f);
  };
}
var zT = NT("round");
const dd = 1e3, pd = dd * 1e3, fd = pd * 1e3, Df = fd * 1e3, ry = 1000.1.toLocaleString().replace(/\d/g, ""), FT = ry[0], WT = ry[1], HT = {
  name: "Numbers",
  decimalScale: "auto",
  trillion: !0,
  billion: !0,
  million: !0,
  kilo: !0,
  thousandSeparator: !0,
  prefix: !0,
  symbol: "$"
}, li = (t) => Ut(Ut({}, HT), t || {}), UT = (t, r) => isNaN(r) ? "" : `<span>${ra(t, r)}</span>`, GT = (t, r) => Math.sign(t) * zT(Math.abs(t), r), ra = (t, r) => {
  const f = t.decimalScale !== 0 && t.decimalScale !== "auto", B = t.decimalScale === "auto" ? 2 : t.decimalScale;
  let H = !0;
  t.name === "Numbers" && !t.thousandSeparator && (H = void 0);
  let tt, st, lt = r;
  return t.name === "Percent" && (st = "%", lt = r * 100), (t.name === "Numbers" || t.name === "Currency") && (t.trillion && Math.abs(r) / Df >= 1 ? (lt = r / Df, st = "T") : t.billion && Math.abs(r) / fd >= 1 ? (lt = r / fd, st = "B") : t.million && Math.abs(r) / pd >= 1 ? (lt = r / pd, st = "M") : t.kilo && Math.abs(r) / dd >= 1 && (lt = r / dd, st = "K")), t.name === "Currency" && (t.prefix ? tt = t.symbol : st ? st = `${st}${t.symbol}` : st = t.symbol), IT(`${GT(lt, B)}`, {
    displayType: "text",
    thousandSeparator: H ? FT : void 0,
    fixedDecimalScale: f,
    decimalScale: B,
    decimalSeparator: WT,
    prefix: tt,
    suffix: st
  });
}, Hi = (t, r) => {
  let f = UT(t, r);
  return f = f.replace("<span>", ""), f = f.replace("</span>", ""), f;
}, gd = "#dcdcdc", to = "#CCCCCC", eo = "#FFFFFF", XT = [
  "#00cee6",
  "#9b9bd7",
  "#6eda55",
  "#fc7570",
  "#fbb755",
  "#218a8c",
  "#08e5ff",
  "#b3b3f7",
  "#7efb62",
  "#ff8a87",
  "#ffc26a",
  "#279fa1"
], ny = (t) => ({
  type: "uniform",
  color: t
});
function YT(t) {
  return () => t.color;
}
const oy = (t) => {
  if (t !== void 0)
    return typeof t == "string" ? ny(t).color : t.type === "uniform" ? t.color : gd;
};
function VT(t) {
  var f;
  const r = ((f = t.conditions) != null ? f : []).map((B) => ({
    match: $T(B),
    color: B.color
  }));
  return (B) => {
    const H = r.find((tt) => tt.match(B));
    return H ? H.color : t.defaultColor;
  };
}
function $T(t) {
  const r = Number(t.expression);
  switch (t.operator) {
    case "<":
      return (f) => f < r;
    case ">":
      return (f) => f > r;
    case "≤":
    case "<=":
      return (f) => f <= r;
    case "≥":
    case ">=":
      return (f) => f >= r;
    case "=":
      return (f) => f == r;
    case "≠":
    case "!=":
      return (f) => f != r;
    default:
      return () => !0;
  }
}
function ai(t, r) {
  let f = t.length;
  Array.isArray(t[0]) || (t = [t]), Array.isArray(r[0]) || (r = r.map((st) => [st]));
  let B = r[0].length, H = r[0].map((st, lt) => r.map((ht) => ht[lt])), tt = t.map((st) => H.map((lt) => {
    let ht = 0;
    if (!Array.isArray(st)) {
      for (let ut of lt)
        ht += st * ut;
      return ht;
    }
    for (let ut = 0; ut < st.length; ut++)
      ht += st[ut] * (lt[ut] || 0);
    return ht;
  }));
  return f === 1 && (tt = tt[0]), B === 1 ? tt.map((st) => st[0]) : tt;
}
function _l(t) {
  return Kn(t) === "string";
}
function Kn(t) {
  return (Object.prototype.toString.call(t).match(/^\[object\s+(.*?)\]$/)[1] || "").toLowerCase();
}
function xh(t, r) {
  t = +t, r = +r;
  let f = (Math.floor(t) + "").length;
  if (r > f)
    return +t.toFixed(r - f);
  {
    let B = pe(10, f - r);
    return Math.round(t / B) * B;
  }
}
function sy(t) {
  if (!t)
    return;
  t = t.trim();
  const r = /^([a-z]+)\((.+?)\)$/i, f = /^-?[\d.]+$/;
  let B = t.match(r);
  if (B) {
    let H = [];
    return B[2].replace(/\/?\s*([-\w.]+(?:%|deg)?)/g, (tt, st) => {
      /%$/.test(st) ? (st = new Number(st.slice(0, -1) / 100), st.type = "<percentage>") : /deg$/.test(st) ? (st = new Number(+st.slice(0, -3)), st.type = "<angle>", st.unit = "deg") : f.test(st) && (st = new Number(st), st.type = "<number>"), tt.startsWith("/") && (st = st instanceof Number ? st : new Number(st), st.alpha = !0), H.push(st);
    }), {
      name: B[1].toLowerCase(),
      rawName: B[1],
      rawArgs: B[2],
      // An argument could be (as of css-color-4):
      // a number, percentage, degrees (hue), ident (in color())
      args: H
    };
  }
}
function ay(t) {
  return t[t.length - 1];
}
function Sh(t, r, f) {
  return isNaN(t) ? r : isNaN(r) ? t : t + (r - t) * f;
}
function ly(t, r, f) {
  return (f - t) / (r - t);
}
function hp(t, r, f) {
  return Sh(r[0], r[1], ly(t[0], t[1], f));
}
function cy(t) {
  return t.map((r) => r.split("|").map((f) => {
    f = f.trim();
    let B = f.match(/^(<[a-z]+>)\[(-?[.\d]+),\s*(-?[.\d]+)\]?$/);
    if (B) {
      let H = new String(B[1]);
      return H.range = [+B[2], +B[3]], H;
    }
    return f;
  }));
}
var ZT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  interpolate: Sh,
  interpolateInv: ly,
  isString: _l,
  last: ay,
  mapRange: hp,
  multiplyMatrices: ai,
  parseCoordGrammar: cy,
  parseFunction: sy,
  toPrecision: xh,
  type: Kn
});
class KT {
  add(r, f, B) {
    if (typeof arguments[0] != "string") {
      for (var r in arguments[0])
        this.add(r, arguments[0][r], arguments[1]);
      return;
    }
    (Array.isArray(r) ? r : [r]).forEach(function(H) {
      this[H] = this[H] || [], f && this[H][B ? "unshift" : "push"](f);
    }, this);
  }
  run(r, f) {
    this[r] = this[r] || [], this[r].forEach(function(B) {
      B.call(f && f.context ? f.context : f, f);
    });
  }
}
const io = new KT();
var Qr = {
  gamut_mapping: "lch.c",
  precision: 5,
  deltaE: "76"
  // Default deltaE method
};
const Dr = {
  // for compatibility, the four-digit chromaticity-derived ones everyone else uses
  D50: [0.3457 / 0.3585, 1, (1 - 0.3457 - 0.3585) / 0.3585],
  D65: [0.3127 / 0.329, 1, (1 - 0.3127 - 0.329) / 0.329]
};
function md(t) {
  return Array.isArray(t) ? t : Dr[t];
}
function wh(t, r, f, B = {}) {
  if (t = md(t), r = md(r), !t || !r)
    throw new TypeError(`Missing white point to convert ${t ? "" : "from"}${!t && !r ? "/" : ""}${r ? "" : "to"}`);
  if (t === r)
    return f;
  let H = { W1: t, W2: r, XYZ: f, options: B };
  if (io.run("chromatic-adaptation-start", H), H.M || (H.W1 === Dr.D65 && H.W2 === Dr.D50 ? H.M = [
    [1.0479298208405488, 0.022946793341019088, -0.05019222954313557],
    [0.029627815688159344, 0.990434484573249, -0.01707382502938514],
    [-0.009243058152591178, 0.015055144896577895, 0.7518742899580008]
  ] : H.W1 === Dr.D50 && H.W2 === Dr.D65 && (H.M = [
    [0.9554734527042182, -0.023098536874261423, 0.0632593086610217],
    [-0.028369706963208136, 1.0099954580058226, 0.021041398966943008],
    [0.012314001688319899, -0.020507696433477912, 1.3303659366080753]
  ])), io.run("chromatic-adaptation-end", H), H.M)
    return ai(H.M, H.XYZ);
  throw new TypeError("Only Bradford CAT with white points D50 and D65 supported for now.");
}
const qT = 75e-6, ir = class ir {
  constructor(r) {
    var H, tt, st, lt, ht, ut, yt;
    this.id = r.id, this.name = r.name, this.base = r.base ? ir.get(r.base) : null, this.aliases = r.aliases, this.base && (this.fromBase = r.fromBase, this.toBase = r.toBase);
    let f = (H = r.coords) != null ? H : this.base.coords;
    for (let gt in f)
      "name" in f[gt] || (f[gt].name = gt);
    this.coords = f;
    let B = (st = (tt = r.white) != null ? tt : this.base.white) != null ? st : "D65";
    this.white = md(B), this.formats = (lt = r.formats) != null ? lt : {};
    for (let gt in this.formats) {
      let _ = this.formats[gt];
      _.type || (_.type = "function"), _.name || (_.name = gt);
    }
    r.cssId && !((ht = this.formats.functions) != null && ht.color) ? (this.formats.color = { id: r.cssId }, Object.defineProperty(this, "cssId", { value: r.cssId })) : (ut = this.formats) != null && ut.color && !((yt = this.formats) != null && yt.color.id) && (this.formats.color.id = this.id), this.referred = r.referred, Object.defineProperty(this, "path", {
      value: JT(this).reverse(),
      writable: !1,
      enumerable: !0,
      configurable: !0
    }), io.run("colorspace-init-end", this);
  }
  inGamut(r, { epsilon: f = qT } = {}) {
    if (this.isPolar)
      return r = this.toBase(r), this.base.inGamut(r, { epsilon: f });
    let B = Object.values(this.coords);
    return r.every((H, tt) => {
      let st = B[tt];
      if (st.type !== "angle" && st.range) {
        if (Number.isNaN(H))
          return !0;
        let [lt, ht] = st.range;
        return (lt === void 0 || H >= lt - f) && (ht === void 0 || H <= ht + f);
      }
      return !0;
    });
  }
  get cssId() {
    var r, f;
    return ((f = (r = this.formats.functions) == null ? void 0 : r.color) == null ? void 0 : f.id) || this.id;
  }
  get isPolar() {
    for (let r in this.coords)
      if (this.coords[r].type === "angle")
        return !0;
    return !1;
  }
  getFormat(r) {
    if (typeof r == "object")
      return r = If(r, this), r;
    let f;
    return r === "default" ? f = Object.values(this.formats)[0] : f = this.formats[r], f ? (f = If(f, this), f) : null;
  }
  // We cannot rely on simple === because then ColorSpace objects cannot be proxied
  equals(r) {
    return r ? this === r || this.id === r.id : !1;
  }
  to(r, f) {
    if (arguments.length === 1 && ([r, f] = [r.space, r.coords]), r = ir.get(r), this.equals(r))
      return f;
    f = f.map((lt) => Number.isNaN(lt) ? 0 : lt);
    let B = this.path, H = r.path, tt, st;
    for (let lt = 0; lt < B.length && B[lt].equals(H[lt]); lt++)
      tt = B[lt], st = lt;
    if (!tt)
      throw new Error(`Cannot convert between color spaces ${this} and ${r}: no connection space was found`);
    for (let lt = B.length - 1; lt > st; lt--)
      f = B[lt].toBase(f);
    for (let lt = st + 1; lt < H.length; lt++)
      f = H[lt].fromBase(f);
    return f;
  }
  from(r, f) {
    return arguments.length === 1 && ([r, f] = [r.space, r.coords]), r = ir.get(r), r.to(this, f);
  }
  toString() {
    return `${this.name} (${this.id})`;
  }
  getMinCoords() {
    var f;
    let r = [];
    for (let B in this.coords) {
      let H = this.coords[B], tt = H.range || H.refRange;
      r.push((f = tt == null ? void 0 : tt.min) != null ? f : 0);
    }
    return r;
  }
  // Returns array of unique color spaces
  static get all() {
    return [...new Set(Object.values(ir.registry))];
  }
  static register(r, f) {
    if (arguments.length === 1 && (f = arguments[0], r = f.id), f = this.get(f), this.registry[r] && this.registry[r] !== f)
      throw new Error(`Duplicate color space registration: '${r}'`);
    if (this.registry[r] = f, arguments.length === 1 && f.aliases)
      for (let B of f.aliases)
        this.register(B, f);
    return f;
  }
  /**
   * Lookup ColorSpace object by name
   * @param {ColorSpace | string} name
   */
  static get(r, ...f) {
    if (!r || r instanceof ir)
      return r;
    if (Kn(r) === "string") {
      let H = ir.registry[r.toLowerCase()];
      if (!H)
        throw new TypeError(`No color space found with id = "${r}"`);
      return H;
    }
    if (f.length)
      return ir.get(...f);
    throw new TypeError(`${r} is not a valid color space`);
  }
  /**
   * Get metadata about a coordinate of a color space
   *
   * @static
   * @param {Array | string} ref
   * @param {ColorSpace | string} [workingSpace]
   * @return {Object}
   */
  static resolveCoord(r, f) {
    var ht;
    let B = Kn(r), H, tt;
    if (B === "string" ? r.includes(".") ? [H, tt] = r.split(".") : [H, tt] = [, r] : Array.isArray(r) ? [H, tt] = r : (H = r.space, tt = r.coordId), H = ir.get(H), H || (H = f), !H)
      throw new TypeError(`Cannot resolve coordinate reference ${r}: No color space specified and relative references are not allowed here`);
    if (B = Kn(tt), B === "number" || B === "string" && tt >= 0) {
      let ut = Object.entries(H.coords)[tt];
      if (ut)
        return Ut({ space: H, id: ut[0], index: tt }, ut[1]);
    }
    H = ir.get(H);
    let st = tt.toLowerCase(), lt = 0;
    for (let ut in H.coords) {
      let yt = H.coords[ut];
      if (ut.toLowerCase() === st || ((ht = yt.name) == null ? void 0 : ht.toLowerCase()) === st)
        return Ut({ space: H, id: ut, index: lt }, yt);
      lt++;
    }
    throw new TypeError(`No "${tt}" coordinate found in ${H.name}. Its coordinates are: ${Object.keys(H.coords).join(", ")}`);
  }
};
ui(ir, "registry", {}), ui(ir, "DEFAULT_FORMAT", {
  type: "functions",
  name: "color"
});
let Ae = ir;
function JT(t) {
  let r = [t];
  for (let f = t; f = f.base; )
    r.push(f);
  return r;
}
function If(t, { coords: r } = {}) {
  if (t.coords && !t.coordGrammar) {
    t.type || (t.type = "function"), t.name || (t.name = "color"), t.coordGrammar = cy(t.coords);
    let f = Object.entries(r).map(([B, H], tt) => {
      let st = t.coordGrammar[tt][0], lt = H.range || H.refRange, ht = st.range, ut = "";
      return st == "<percentage>" ? (ht = [0, 100], ut = "%") : st == "<angle>" && (ut = "deg"), { fromRange: lt, toRange: ht, suffix: ut };
    });
    t.serializeCoords = (B, H) => B.map((tt, st) => {
      let { fromRange: lt, toRange: ht, suffix: ut } = f[st];
      return lt && ht && (tt = hp(lt, ht, tt)), tt = xh(tt, H), ut && (tt += ut), tt;
    });
  }
  return t;
}
var vr = new Ae({
  id: "xyz-d65",
  name: "XYZ D65",
  coords: {
    x: { name: "X" },
    y: { name: "Y" },
    z: { name: "Z" }
  },
  white: "D65",
  formats: {
    color: {
      ids: ["xyz-d65", "xyz"]
    }
  },
  aliases: ["xyz"]
});
class Zi extends Ae {
  /**
   * Creates a new RGB ColorSpace.
   * If coords are not specified, they will use the default RGB coords.
   * Instead of `fromBase()` and `toBase()` functions,
   * you can specify to/from XYZ matrices and have `toBase()` and `fromBase()` automatically generated.
   * @param {*} options - Same options as {@link ColorSpace} plus:
   * @param {number[][]} options.toXYZ_M - Matrix to convert to XYZ
   * @param {number[][]} options.fromXYZ_M - Matrix to convert from XYZ
   */
  constructor(r) {
    var f, B, H;
    r.coords || (r.coords = {
      r: {
        range: [0, 1],
        name: "Red"
      },
      g: {
        range: [0, 1],
        name: "Green"
      },
      b: {
        range: [0, 1],
        name: "Blue"
      }
    }), r.base || (r.base = vr), r.toXYZ_M && r.fromXYZ_M && ((f = r.toBase) != null || (r.toBase = (tt) => {
      let st = ai(r.toXYZ_M, tt);
      return this.white !== this.base.white && (st = wh(this.white, this.base.white, st)), st;
    }), (B = r.fromBase) != null || (r.fromBase = (tt) => (tt = wh(this.base.white, this.white, tt), ai(r.fromXYZ_M, tt)))), (H = r.referred) != null || (r.referred = "display"), super(r);
  }
}
function hy(t, { meta: r } = {}) {
  var B, H, tt, st, lt, ht;
  let f = { str: (B = String(t)) == null ? void 0 : B.trim() };
  if (io.run("parse-start", f), f.color)
    return f.color;
  if (f.parsed = sy(f.str), f.parsed) {
    let ut = f.parsed.name;
    if (ut === "color") {
      let yt = f.parsed.args.shift(), gt = f.parsed.rawArgs.indexOf("/") > 0 ? f.parsed.args.pop() : 1;
      for (let at of Ae.all) {
        let G = at.getFormat("color");
        if (G && (yt === G.id || (H = G.ids) != null && H.includes(yt))) {
          const F = Object.keys(at.coords).map(($, Y) => f.parsed.args[Y] || 0);
          return r && (r.formatId = "color"), { spaceId: at.id, coords: F, alpha: gt };
        }
      }
      let _ = "";
      if (yt in Ae.registry) {
        let at = (lt = (st = (tt = Ae.registry[yt].formats) == null ? void 0 : tt.functions) == null ? void 0 : st.color) == null ? void 0 : lt.id;
        at && (_ = `Did you mean color(${at})?`);
      }
      throw new TypeError(`Cannot parse color(${yt}). ` + (_ || "Missing a plugin?"));
    } else
      for (let yt of Ae.all) {
        let gt = yt.getFormat(ut);
        if (gt && gt.type === "function") {
          let _ = 1;
          (gt.lastAlpha || ay(f.parsed.args).alpha) && (_ = f.parsed.args.pop());
          let at = f.parsed.args, G;
          return gt.coordGrammar && (G = Object.entries(yt.coords).map(([F, $], Y) => {
            var D;
            let J = gt.coordGrammar[Y], Q = (D = at[Y]) == null ? void 0 : D.type, q = J.find((k) => k == Q);
            if (!q) {
              let k = $.name || F;
              throw new TypeError(`${Q} not allowed for ${k} in ${ut}()`);
            }
            let U = q.range;
            Q === "<percentage>" && (U || (U = [0, 1]));
            let N = $.range || $.refRange;
            return U && N && (at[Y] = hp(U, N, at[Y])), q;
          })), r && Object.assign(r, { formatId: gt.name, types: G }), {
            spaceId: yt.id,
            coords: at,
            alpha: _
          };
        }
      }
  } else
    for (let ut of Ae.all)
      for (let yt in ut.formats) {
        let gt = ut.formats[yt];
        if (gt.type !== "custom" || gt.test && !gt.test(f.str))
          continue;
        let _ = gt.parse(f.str);
        if (_)
          return (ht = _.alpha) != null || (_.alpha = 1), r && (r.formatId = yt), _;
      }
  throw new TypeError(`Could not parse ${t} as a color. Missing a plugin?`);
}
function Ue(t) {
  if (!t)
    throw new TypeError("Empty color reference");
  _l(t) && (t = hy(t));
  let r = t.space || t.spaceId;
  return r instanceof Ae || (t.space = Ae.get(r)), t.alpha === void 0 && (t.alpha = 1), t;
}
function Bl(t, r) {
  return r = Ae.get(r), r.from(t);
}
function br(t, r) {
  let { space: f, index: B } = Ae.resolveCoord(r, t.space);
  return Bl(t, f)[B];
}
function uy(t, r, f) {
  return r = Ae.get(r), t.coords = r.to(t.space, f), t;
}
function ro(t, r, f) {
  if (t = Ue(t), arguments.length === 2 && Kn(arguments[1]) === "object") {
    let B = arguments[1];
    for (let H in B)
      ro(t, H, B[H]);
  } else {
    typeof f == "function" && (f = f(br(t, r)));
    let { space: B, index: H } = Ae.resolveCoord(r, t.space), tt = Bl(t, B);
    tt[H] = f, uy(t, B, tt);
  }
  return t;
}
var up = new Ae({
  id: "xyz-d50",
  name: "XYZ D50",
  white: "D50",
  base: vr,
  fromBase: (t) => wh(vr.white, "D50", t),
  toBase: (t) => wh("D50", vr.white, t),
  formats: {
    color: {}
  }
});
const QT = 216 / 24389, Rf = 24 / 116, Wc = 24389 / 27;
let Xu = Dr.D50;
var rr = new Ae({
  id: "lab",
  name: "Lab",
  coords: {
    l: {
      refRange: [0, 100],
      name: "L"
    },
    a: {
      refRange: [-125, 125]
    },
    b: {
      refRange: [-125, 125]
    }
  },
  // Assuming XYZ is relative to D50, convert to CIE Lab
  // from CIE standard, which now defines these as a rational fraction
  white: Xu,
  base: up,
  // Convert D50-adapted XYX to Lab
  //  CIE 15.3:2004 section 8.2.1.1
  fromBase(t) {
    let f = t.map((B, H) => B / Xu[H]).map((B) => B > QT ? Math.cbrt(B) : (Wc * B + 16) / 116);
    return [
      116 * f[1] - 16,
      // L
      500 * (f[0] - f[1]),
      // a
      200 * (f[1] - f[2])
      // b
    ];
  },
  // Convert Lab to D50-adapted XYZ
  // Same result as CIE 15.3:2004 Appendix D although the derivation is different
  // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
  toBase(t) {
    let r = [];
    return r[1] = (t[0] + 16) / 116, r[0] = t[1] / 500 + r[1], r[2] = r[1] - t[2] / 200, [
      r[0] > Rf ? Math.pow(r[0], 3) : (116 * r[0] - 16) / Wc,
      t[0] > 8 ? Math.pow((t[0] + 16) / 116, 3) : t[0] / Wc,
      r[2] > Rf ? Math.pow(r[2], 3) : (116 * r[2] - 16) / Wc
    ].map((B, H) => B * Xu[H]);
  },
  formats: {
    lab: {
      coords: ["<number> | <percentage>", "<number> | <percentage>[-1,1]", "<number> | <percentage>[-1,1]"]
    }
  }
});
function Hh(t) {
  return (t % 360 + 360) % 360;
}
function tM(t, r) {
  if (t === "raw")
    return r;
  let [f, B] = r.map(Hh), H = B - f;
  return t === "increasing" ? H < 0 && (B += 360) : t === "decreasing" ? H > 0 && (f += 360) : t === "longer" ? -180 < H && H < 180 && (H > 0 ? f += 360 : B += 360) : t === "shorter" && (H > 180 ? f += 360 : H < -180 && (B += 360)), [f, B];
}
var Pl = new Ae({
  id: "lch",
  name: "LCH",
  coords: {
    l: {
      refRange: [0, 100],
      name: "Lightness"
    },
    c: {
      refRange: [0, 150],
      name: "Chroma"
    },
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  base: rr,
  fromBase(t) {
    let [r, f, B] = t, H;
    const tt = 0.02;
    return Math.abs(f) < tt && Math.abs(B) < tt ? H = NaN : H = Math.atan2(B, f) * 180 / Math.PI, [
      r,
      // L is still L
      Math.sqrt(pe(f, 2) + pe(B, 2)),
      // Chroma
      Hh(H)
      // Hue, in degrees [0 to 360)
    ];
  },
  toBase(t) {
    let [r, f, B] = t;
    return f < 0 && (f = 0), isNaN(B) && (B = 0), [
      r,
      // L is still L
      f * Math.cos(B * Math.PI / 180),
      // a
      f * Math.sin(B * Math.PI / 180)
      // b
    ];
  },
  formats: {
    lch: {
      coords: ["<number> | <percentage>", "<number> | <percentage>", "<number> | <angle>"]
    }
  }
});
const jf = pe(25, 7), Ch = Math.PI, _f = 180 / Ch, Zs = Ch / 180;
function yd(t, r, { kL: f = 1, kC: B = 1, kH: H = 1 } = {}) {
  let [tt, st, lt] = rr.from(t), ht = Pl.from(rr, [tt, st, lt])[1], [ut, yt, gt] = rr.from(r), _ = Pl.from(rr, [ut, yt, gt])[1];
  ht < 0 && (ht = 0), _ < 0 && (_ = 0);
  let at = (ht + _) / 2, G = pe(at, 7), F = 0.5 * (1 - Math.sqrt(G / (G + jf))), $ = (1 + F) * st, Y = (1 + F) * yt, J = Math.sqrt(pe($, 2) + pe(lt, 2)), Q = Math.sqrt(pe(Y, 2) + pe(gt, 2)), q = $ === 0 && lt === 0 ? 0 : Math.atan2(lt, $), U = Y === 0 && gt === 0 ? 0 : Math.atan2(gt, Y);
  q < 0 && (q += 2 * Ch), U < 0 && (U += 2 * Ch), q *= _f, U *= _f;
  let N = ut - tt, D = Q - J, k = U - q, A = q + U, b = Math.abs(k), d;
  J * Q === 0 ? d = 0 : b <= 180 ? d = k : k > 180 ? d = k - 360 : k < -180 ? d = k + 360 : console.log("the unthinkable has happened");
  let m = 2 * Math.sqrt(Q * J) * Math.sin(d * Zs / 2), v = (tt + ut) / 2, g = (J + Q) / 2, x = Math.pow(g, 7), E;
  J * Q === 0 ? E = A : b <= 180 ? E = A / 2 : A < 360 ? E = (A + 360) / 2 : E = (A - 360) / 2;
  let P = pe(v - 50, 2), S = 1 + 0.015 * P / Math.sqrt(20 + P), u = 1 + 0.045 * g, y = 1;
  y -= 0.17 * Math.cos((E - 30) * Zs), y += 0.24 * Math.cos(2 * E * Zs), y += 0.32 * Math.cos((3 * E + 6) * Zs), y -= 0.2 * Math.cos((4 * E - 63) * Zs);
  let s = 1 + 0.015 * g * y, a = 30 * Math.exp(-1 * pe((E - 275) / 25, 2)), e = 2 * Math.sqrt(x / (x + jf)), n = -1 * Math.sin(2 * a * Zs) * e, o = pe(N / (f * S), 2);
  return o += pe(D / (B * u), 2), o += pe(m / (H * s), 2), o += n * (D / (B * u)) * (m / (H * s)), Math.sqrt(o);
}
const eM = 75e-6;
function xl(t, r = t.space, { epsilon: f = eM } = {}) {
  t = Ue(t), r = Ae.get(r);
  let B = t.coords;
  return r !== t.space && (B = r.from(t)), r.inGamut(B, { epsilon: f });
}
function El(t) {
  return {
    space: t.space,
    coords: t.coords.slice(),
    alpha: t.alpha
  };
}
function no(t, { method: r = Qr.gamut_mapping, space: f = t.space } = {}) {
  if (_l(arguments[1]) && (f = arguments[1]), f = Ae.get(f), xl(t, f, { epsilon: 0 }))
    return Ue(t);
  let B = yr(t, f);
  if (r !== "clip" && !xl(t, f)) {
    let H = no(El(B), { method: "clip", space: f });
    if (yd(t, H) > 2) {
      let tt = Ae.resolveCoord(r), st = tt.space, lt = tt.id, ht = yr(B, st), yt = (tt.range || tt.refRange)[0], gt = 0.01, _ = yt, at = br(ht, lt);
      for (; at - _ > gt; ) {
        let G = El(ht);
        G = no(G, { space: f, method: "clip" }), yd(ht, G) - 2 < gt ? _ = br(ht, lt) : at = br(ht, lt), ro(ht, lt, (_ + at) / 2);
      }
      B = yr(ht, f);
    } else
      B = H;
  }
  if (r === "clip" || !xl(B, f, { epsilon: 0 })) {
    let H = Object.values(f.coords).map((tt) => tt.range || []);
    B.coords = B.coords.map((tt, st) => {
      let [lt, ht] = H[st];
      return lt !== void 0 && (tt = Math.max(lt, tt)), ht !== void 0 && (tt = Math.min(tt, ht)), tt;
    });
  }
  return f !== t.space && (B = yr(B, t.space)), t.coords = B.coords, t;
}
no.returns = "color";
function yr(t, r, { inGamut: f } = {}) {
  t = Ue(t), r = Ae.get(r);
  let B = r.from(t), H = { space: r, coords: B, alpha: t.alpha };
  return f && (H = no(H)), H;
}
yr.returns = "color";
function kh(t, tt = {}) {
  var st = tt, {
    precision: r = Qr.precision,
    format: f = "default",
    inGamut: B = !0
  } = st, H = mr(st, [
    "precision",
    "format",
    "inGamut"
  ]);
  var yt, gt, _;
  let lt;
  t = Ue(t);
  let ht = f;
  f = (gt = (yt = t.space.getFormat(f)) != null ? yt : t.space.getFormat("default")) != null ? gt : Ae.DEFAULT_FORMAT, B || (B = f.toGamut);
  let ut = t.coords;
  if (ut = ut.map((at) => at || 0), B && !xl(t) && (ut = no(El(t), B === !0 ? void 0 : B).coords), f.type === "custom")
    if (H.precision = r, f.serialize)
      lt = f.serialize(ut, t.alpha, H);
    else
      throw new TypeError(`format ${ht} can only be used to parse colors, not for serialization`);
  else {
    let at = f.name || "color";
    f.serializeCoords ? ut = f.serializeCoords(ut, r) : r !== null && (ut = ut.map((Y) => xh(Y, r)));
    let G = [...ut];
    if (at === "color") {
      let Y = f.id || ((_ = f.ids) == null ? void 0 : _[0]) || t.space.id;
      G.unshift(Y);
    }
    let F = t.alpha;
    r !== null && (F = xh(F, r));
    let $ = t.alpha < 1 && !f.noAlpha ? `${f.commas ? "," : " /"} ${F}` : "";
    lt = `${at}(${G.join(f.commas ? ", " : " ")}${$})`;
  }
  return lt;
}
const iM = [
  [0.6369580483012914, 0.14461690358620832, 0.1688809751641721],
  [0.2627002120112671, 0.6779980715188708, 0.05930171646986196],
  [0, 0.028072693049087428, 1.060985057710791]
], rM = [
  [1.716651187971268, -0.355670783776392, -0.25336628137366],
  [-0.666684351832489, 1.616481236634939, 0.0157685458139111],
  [0.017639857445311, -0.042770613257809, 0.942103121235474]
];
var Uh = new Zi({
  id: "rec2020-linear",
  name: "Linear REC.2020",
  white: "D65",
  toXYZ_M: iM,
  fromXYZ_M: rM,
  formats: {
    color: {}
  }
});
const Hc = 1.09929682680944, Bf = 0.018053968510807;
var dy = new Zi({
  id: "rec2020",
  name: "REC.2020",
  base: Uh,
  // Non-linear transfer function from Rec. ITU-R BT.2020-2 table 4
  toBase(t) {
    return t.map(function(r) {
      return r < Bf * 4.5 ? r / 4.5 : Math.pow((r + Hc - 1) / Hc, 1 / 0.45);
    });
  },
  fromBase(t) {
    return t.map(function(r) {
      return r >= Bf ? Hc * Math.pow(r, 0.45) - (Hc - 1) : 4.5 * r;
    });
  },
  formats: {
    color: {}
  }
});
const nM = [
  [0.4865709486482162, 0.26566769316909306, 0.1982172852343625],
  [0.2289745640697488, 0.6917385218365064, 0.079286914093745],
  [0, 0.04511338185890264, 1.043944368900976]
], oM = [
  [2.493496911941425, -0.9313836179191239, -0.40271078445071684],
  [-0.8294889695615747, 1.7626640603183463, 0.023624685841943577],
  [0.03584583024378447, -0.07617238926804182, 0.9568845240076872]
];
var py = new Zi({
  id: "p3-linear",
  name: "Linear P3",
  white: "D65",
  toXYZ_M: nM,
  fromXYZ_M: oM
});
const sM = [
  [0.41239079926595934, 0.357584339383878, 0.1804807884018343],
  [0.21263900587151027, 0.715168678767756, 0.07219231536073371],
  [0.01933081871559182, 0.11919477979462598, 0.9505321522496607]
], aM = [
  [3.2409699419045226, -1.537383177570094, -0.4986107602930034],
  [-0.9692436362808796, 1.8759675015077202, 0.04155505740717559],
  [0.05563007969699366, -0.20397695888897652, 1.0569715142428786]
];
var fy = new Zi({
  id: "srgb-linear",
  name: "Linear sRGB",
  white: "D65",
  toXYZ_M: sM,
  fromXYZ_M: aM,
  formats: {
    color: {}
  }
}), Nf = {
  aliceblue: [240 / 255, 248 / 255, 1],
  antiquewhite: [250 / 255, 235 / 255, 215 / 255],
  aqua: [0, 1, 1],
  aquamarine: [127 / 255, 1, 212 / 255],
  azure: [240 / 255, 1, 1],
  beige: [245 / 255, 245 / 255, 220 / 255],
  bisque: [1, 228 / 255, 196 / 255],
  black: [0, 0, 0],
  blanchedalmond: [1, 235 / 255, 205 / 255],
  blue: [0, 0, 1],
  blueviolet: [138 / 255, 43 / 255, 226 / 255],
  brown: [165 / 255, 42 / 255, 42 / 255],
  burlywood: [222 / 255, 184 / 255, 135 / 255],
  cadetblue: [95 / 255, 158 / 255, 160 / 255],
  chartreuse: [127 / 255, 1, 0],
  chocolate: [210 / 255, 105 / 255, 30 / 255],
  coral: [1, 127 / 255, 80 / 255],
  cornflowerblue: [100 / 255, 149 / 255, 237 / 255],
  cornsilk: [1, 248 / 255, 220 / 255],
  crimson: [220 / 255, 20 / 255, 60 / 255],
  cyan: [0, 1, 1],
  darkblue: [0, 0, 139 / 255],
  darkcyan: [0, 139 / 255, 139 / 255],
  darkgoldenrod: [184 / 255, 134 / 255, 11 / 255],
  darkgray: [169 / 255, 169 / 255, 169 / 255],
  darkgreen: [0, 100 / 255, 0],
  darkgrey: [169 / 255, 169 / 255, 169 / 255],
  darkkhaki: [189 / 255, 183 / 255, 107 / 255],
  darkmagenta: [139 / 255, 0, 139 / 255],
  darkolivegreen: [85 / 255, 107 / 255, 47 / 255],
  darkorange: [1, 140 / 255, 0],
  darkorchid: [153 / 255, 50 / 255, 204 / 255],
  darkred: [139 / 255, 0, 0],
  darksalmon: [233 / 255, 150 / 255, 122 / 255],
  darkseagreen: [143 / 255, 188 / 255, 143 / 255],
  darkslateblue: [72 / 255, 61 / 255, 139 / 255],
  darkslategray: [47 / 255, 79 / 255, 79 / 255],
  darkslategrey: [47 / 255, 79 / 255, 79 / 255],
  darkturquoise: [0, 206 / 255, 209 / 255],
  darkviolet: [148 / 255, 0, 211 / 255],
  deeppink: [1, 20 / 255, 147 / 255],
  deepskyblue: [0, 191 / 255, 1],
  dimgray: [105 / 255, 105 / 255, 105 / 255],
  dimgrey: [105 / 255, 105 / 255, 105 / 255],
  dodgerblue: [30 / 255, 144 / 255, 1],
  firebrick: [178 / 255, 34 / 255, 34 / 255],
  floralwhite: [1, 250 / 255, 240 / 255],
  forestgreen: [34 / 255, 139 / 255, 34 / 255],
  fuchsia: [1, 0, 1],
  gainsboro: [220 / 255, 220 / 255, 220 / 255],
  ghostwhite: [248 / 255, 248 / 255, 1],
  gold: [1, 215 / 255, 0],
  goldenrod: [218 / 255, 165 / 255, 32 / 255],
  gray: [128 / 255, 128 / 255, 128 / 255],
  green: [0, 128 / 255, 0],
  greenyellow: [173 / 255, 1, 47 / 255],
  grey: [128 / 255, 128 / 255, 128 / 255],
  honeydew: [240 / 255, 1, 240 / 255],
  hotpink: [1, 105 / 255, 180 / 255],
  indianred: [205 / 255, 92 / 255, 92 / 255],
  indigo: [75 / 255, 0, 130 / 255],
  ivory: [1, 1, 240 / 255],
  khaki: [240 / 255, 230 / 255, 140 / 255],
  lavender: [230 / 255, 230 / 255, 250 / 255],
  lavenderblush: [1, 240 / 255, 245 / 255],
  lawngreen: [124 / 255, 252 / 255, 0],
  lemonchiffon: [1, 250 / 255, 205 / 255],
  lightblue: [173 / 255, 216 / 255, 230 / 255],
  lightcoral: [240 / 255, 128 / 255, 128 / 255],
  lightcyan: [224 / 255, 1, 1],
  lightgoldenrodyellow: [250 / 255, 250 / 255, 210 / 255],
  lightgray: [211 / 255, 211 / 255, 211 / 255],
  lightgreen: [144 / 255, 238 / 255, 144 / 255],
  lightgrey: [211 / 255, 211 / 255, 211 / 255],
  lightpink: [1, 182 / 255, 193 / 255],
  lightsalmon: [1, 160 / 255, 122 / 255],
  lightseagreen: [32 / 255, 178 / 255, 170 / 255],
  lightskyblue: [135 / 255, 206 / 255, 250 / 255],
  lightslategray: [119 / 255, 136 / 255, 153 / 255],
  lightslategrey: [119 / 255, 136 / 255, 153 / 255],
  lightsteelblue: [176 / 255, 196 / 255, 222 / 255],
  lightyellow: [1, 1, 224 / 255],
  lime: [0, 1, 0],
  limegreen: [50 / 255, 205 / 255, 50 / 255],
  linen: [250 / 255, 240 / 255, 230 / 255],
  magenta: [1, 0, 1],
  maroon: [128 / 255, 0, 0],
  mediumaquamarine: [102 / 255, 205 / 255, 170 / 255],
  mediumblue: [0, 0, 205 / 255],
  mediumorchid: [186 / 255, 85 / 255, 211 / 255],
  mediumpurple: [147 / 255, 112 / 255, 219 / 255],
  mediumseagreen: [60 / 255, 179 / 255, 113 / 255],
  mediumslateblue: [123 / 255, 104 / 255, 238 / 255],
  mediumspringgreen: [0, 250 / 255, 154 / 255],
  mediumturquoise: [72 / 255, 209 / 255, 204 / 255],
  mediumvioletred: [199 / 255, 21 / 255, 133 / 255],
  midnightblue: [25 / 255, 25 / 255, 112 / 255],
  mintcream: [245 / 255, 1, 250 / 255],
  mistyrose: [1, 228 / 255, 225 / 255],
  moccasin: [1, 228 / 255, 181 / 255],
  navajowhite: [1, 222 / 255, 173 / 255],
  navy: [0, 0, 128 / 255],
  oldlace: [253 / 255, 245 / 255, 230 / 255],
  olive: [128 / 255, 128 / 255, 0],
  olivedrab: [107 / 255, 142 / 255, 35 / 255],
  orange: [1, 165 / 255, 0],
  orangered: [1, 69 / 255, 0],
  orchid: [218 / 255, 112 / 255, 214 / 255],
  palegoldenrod: [238 / 255, 232 / 255, 170 / 255],
  palegreen: [152 / 255, 251 / 255, 152 / 255],
  paleturquoise: [175 / 255, 238 / 255, 238 / 255],
  palevioletred: [219 / 255, 112 / 255, 147 / 255],
  papayawhip: [1, 239 / 255, 213 / 255],
  peachpuff: [1, 218 / 255, 185 / 255],
  peru: [205 / 255, 133 / 255, 63 / 255],
  pink: [1, 192 / 255, 203 / 255],
  plum: [221 / 255, 160 / 255, 221 / 255],
  powderblue: [176 / 255, 224 / 255, 230 / 255],
  purple: [128 / 255, 0, 128 / 255],
  rebeccapurple: [102 / 255, 51 / 255, 153 / 255],
  red: [1, 0, 0],
  rosybrown: [188 / 255, 143 / 255, 143 / 255],
  royalblue: [65 / 255, 105 / 255, 225 / 255],
  saddlebrown: [139 / 255, 69 / 255, 19 / 255],
  salmon: [250 / 255, 128 / 255, 114 / 255],
  sandybrown: [244 / 255, 164 / 255, 96 / 255],
  seagreen: [46 / 255, 139 / 255, 87 / 255],
  seashell: [1, 245 / 255, 238 / 255],
  sienna: [160 / 255, 82 / 255, 45 / 255],
  silver: [192 / 255, 192 / 255, 192 / 255],
  skyblue: [135 / 255, 206 / 255, 235 / 255],
  slateblue: [106 / 255, 90 / 255, 205 / 255],
  slategray: [112 / 255, 128 / 255, 144 / 255],
  slategrey: [112 / 255, 128 / 255, 144 / 255],
  snow: [1, 250 / 255, 250 / 255],
  springgreen: [0, 1, 127 / 255],
  steelblue: [70 / 255, 130 / 255, 180 / 255],
  tan: [210 / 255, 180 / 255, 140 / 255],
  teal: [0, 128 / 255, 128 / 255],
  thistle: [216 / 255, 191 / 255, 216 / 255],
  tomato: [1, 99 / 255, 71 / 255],
  turquoise: [64 / 255, 224 / 255, 208 / 255],
  violet: [238 / 255, 130 / 255, 238 / 255],
  wheat: [245 / 255, 222 / 255, 179 / 255],
  white: [1, 1, 1],
  whitesmoke: [245 / 255, 245 / 255, 245 / 255],
  yellow: [1, 1, 0],
  yellowgreen: [154 / 255, 205 / 255, 50 / 255]
};
let zf = Array(3).fill("<percentage> | <number>[0, 255]"), Ff = Array(3).fill("<number>[0, 255]");
var Ll = new Zi({
  id: "srgb",
  name: "sRGB",
  base: fy,
  fromBase: (t) => t.map((r) => {
    let f = r < 0 ? -1 : 1, B = r * f;
    return B > 31308e-7 ? f * (1.055 * pe(B, 1 / 2.4) - 0.055) : 12.92 * r;
  }),
  toBase: (t) => t.map((r) => {
    let f = r < 0 ? -1 : 1, B = r * f;
    return B < 0.04045 ? r / 12.92 : f * pe((B + 0.055) / 1.055, 2.4);
  }),
  formats: {
    rgb: {
      coords: zf
    },
    rgb_number: {
      name: "rgb",
      commas: !0,
      coords: Ff,
      noAlpha: !0
    },
    color: {
      /* use defaults */
    },
    rgba: {
      coords: zf,
      commas: !0,
      lastAlpha: !0
    },
    rgba_number: {
      name: "rgba",
      commas: !0,
      coords: Ff
    },
    hex: {
      type: "custom",
      toGamut: !0,
      test: (t) => /^#([a-f0-9]{3,4}){1,2}$/i.test(t),
      parse(t) {
        t.length <= 5 && (t = t.replace(/[a-f0-9]/gi, "$&$&"));
        let r = [];
        return t.replace(/[a-f0-9]{2}/gi, (f) => {
          r.push(parseInt(f, 16) / 255);
        }), {
          spaceId: "srgb",
          coords: r.slice(0, 3),
          alpha: r.slice(3)[0]
        };
      },
      serialize: (t, r, {
        collapse: f = !0
        // collapse to 3-4 digit hex when possible?
      } = {}) => {
        r < 1 && t.push(r), t = t.map((tt) => Math.round(tt * 255));
        let B = f && t.every((tt) => tt % 17 === 0);
        return "#" + t.map((tt) => B ? (tt / 17).toString(16) : tt.toString(16).padStart(2, "0")).join("");
      }
    },
    keyword: {
      type: "custom",
      test: (t) => /^[a-z]+$/i.test(t),
      parse(t) {
        t = t.toLowerCase();
        let r = { spaceId: "srgb", coords: null, alpha: 1 };
        if (t === "transparent" ? (r.coords = Nf.black, r.alpha = 0) : r.coords = Nf[t], r.coords)
          return r;
      }
    }
  }
}), gy = new Zi({
  id: "p3",
  name: "P3",
  base: py,
  // Gamma encoding/decoding is the same as sRGB
  fromBase: Ll.fromBase,
  toBase: Ll.toBase,
  formats: {
    color: {
      id: "display-p3"
    }
  }
});
Qr.display_space = Ll;
if (typeof CSS != "undefined" && CSS.supports)
  for (let t of [rr, dy, gy]) {
    let r = t.getMinCoords(), B = kh({ space: t, coords: r, alpha: 1 });
    if (CSS.supports("color", B)) {
      Qr.display_space = t;
      break;
    }
  }
function lM(t, B = {}) {
  var H = B, { space: r = Qr.display_space } = H, f = mr(H, ["space"]);
  let tt = kh(t, f);
  if (typeof CSS == "undefined" || CSS.supports("color", tt) || !Qr.display_space)
    tt = new String(tt), tt.color = t;
  else {
    let st = yr(t, r);
    tt = new String(kh(st, f)), tt.color = st;
  }
  return tt;
}
function my(t, r, f = "lab") {
  f = Ae.get(f);
  let B = f.from(t), H = f.from(r);
  return Math.sqrt(B.reduce((tt, st, lt) => {
    let ht = H[lt];
    return isNaN(st) || isNaN(ht) ? tt : tt + pe(ht - st, 2);
  }, 0));
}
function cM(t, r) {
  return t = Ue(t), r = Ue(r), t.space === r.space && t.alpha === r.alpha && t.coords.every((f, B) => f === r.coords[B]);
}
function oo(t) {
  return br(t, [vr, "y"]);
}
function yy(t, r) {
  ro(t, [vr, "y"], r);
}
function hM(t) {
  Object.defineProperty(t.prototype, "luminance", {
    get() {
      return oo(this);
    },
    set(r) {
      yy(this, r);
    }
  });
}
var uM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  getLuminance: oo,
  register: hM,
  setLuminance: yy
});
function dM(t, r) {
  t = Ue(t), r = Ue(r);
  let f = Math.max(oo(t), 0), B = Math.max(oo(r), 0);
  return B > f && ([f, B] = [B, f]), (f + 0.05) / (B + 0.05);
}
const pM = 0.56, fM = 0.57, gM = 0.62, mM = 0.65, Wf = 0.022, yM = 1.414, vM = 0.1, bM = 5e-4, xM = 1.14, Hf = 0.027, SM = 1.14;
function Uf(t) {
  return t >= Wf ? t : t + pe(Wf - t, yM);
}
function Ks(t) {
  let r = t < 0 ? -1 : 1, f = Math.abs(t);
  return r * Math.pow(f, 2.4);
}
function wM(t, r) {
  r = Ue(r), t = Ue(t);
  let f, B, H, tt, st, lt;
  r = yr(r, "srgb"), [tt, st, lt] = r.coords;
  let ht = Ks(tt) * 0.2126729 + Ks(st) * 0.7151522 + Ks(lt) * 0.072175;
  t = yr(t, "srgb"), [tt, st, lt] = t.coords;
  let ut = Ks(tt) * 0.2126729 + Ks(st) * 0.7151522 + Ks(lt) * 0.072175, yt = Uf(ht), gt = Uf(ut), _ = gt > yt;
  return Math.abs(gt - yt) < bM ? B = 0 : _ ? (f = pe(gt, pM) - pe(yt, fM), B = f * xM) : (f = pe(gt, mM) - pe(yt, gM), B = f * SM), Math.abs(B) < vM ? H = 0 : B > 0 ? H = B - Hf : H = B + Hf, H * 100;
}
function CM(t, r) {
  t = Ue(t), r = Ue(r);
  let f = Math.max(oo(t), 0), B = Math.max(oo(r), 0);
  B > f && ([f, B] = [B, f]);
  let H = f + B;
  return H === 0 ? 0 : (f - B) / H;
}
const kM = 5e4;
function TM(t, r) {
  t = Ue(t), r = Ue(r);
  let f = Math.max(oo(t), 0), B = Math.max(oo(r), 0);
  return B > f && ([f, B] = [B, f]), B === 0 ? kM : (f - B) / B;
}
function MM(t, r) {
  t = Ue(t), r = Ue(r);
  let f = br(t, [rr, "l"]), B = br(r, [rr, "l"]);
  return Math.abs(f - B);
}
const AM = 216 / 24389, Gf = 24 / 116, Uc = 24389 / 27;
let Yu = Dr.D65;
var vd = new Ae({
  id: "lab-d65",
  name: "Lab D65",
  coords: {
    l: {
      refRange: [0, 100],
      name: "L"
    },
    a: {
      refRange: [-125, 125]
    },
    b: {
      refRange: [-125, 125]
    }
  },
  // Assuming XYZ is relative to D65, convert to CIE Lab
  // from CIE standard, which now defines these as a rational fraction
  white: Yu,
  base: vr,
  // Convert D65-adapted XYZ to Lab
  //  CIE 15.3:2004 section 8.2.1.1
  fromBase(t) {
    let f = t.map((B, H) => B / Yu[H]).map((B) => B > AM ? Math.cbrt(B) : (Uc * B + 16) / 116);
    return [
      116 * f[1] - 16,
      // L
      500 * (f[0] - f[1]),
      // a
      200 * (f[1] - f[2])
      // b
    ];
  },
  // Convert Lab to D65-adapted XYZ
  // Same result as CIE 15.3:2004 Appendix D although the derivation is different
  // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
  toBase(t) {
    let r = [];
    return r[1] = (t[0] + 16) / 116, r[0] = t[1] / 500 + r[1], r[2] = r[1] - t[2] / 200, [
      r[0] > Gf ? Math.pow(r[0], 3) : (116 * r[0] - 16) / Uc,
      t[0] > 8 ? Math.pow((t[0] + 16) / 116, 3) : t[0] / Uc,
      r[2] > Gf ? Math.pow(r[2], 3) : (116 * r[2] - 16) / Uc
    ].map((B, H) => B * Yu[H]);
  },
  formats: {
    "lab-d65": {
      coords: ["<number> | <percentage>", "<number> | <percentage>[-1,1]", "<number> | <percentage>[-1,1]"]
    }
  }
});
const Vu = Math.pow(5, 0.5) * 0.5 + 0.5;
function PM(t, r) {
  t = Ue(t), r = Ue(r);
  let f = br(t, [vd, "l"]), B = br(r, [vd, "l"]), H = Math.abs(Math.pow(f, Vu) - Math.pow(B, Vu)), tt = Math.pow(H, 1 / Vu) * Math.SQRT2 - 40;
  return tt < 7.5 ? 0 : tt;
}
var sh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  contrastAPCA: wM,
  contrastDeltaPhi: PM,
  contrastLstar: MM,
  contrastMichelson: CM,
  contrastWCAG21: dM,
  contrastWeber: TM
});
function EM(t, r, f = {}) {
  _l(f) && (f = { algorithm: f });
  let tt = f, { algorithm: B } = tt, H = mr(tt, ["algorithm"]);
  if (!B) {
    let st = Object.keys(sh).map((lt) => lt.replace(/^contrast/, "")).join(", ");
    throw new TypeError(`contrast() function needs a contrast algorithm. Please specify one of: ${st}`);
  }
  t = Ue(t), r = Ue(r);
  for (let st in sh)
    if ("contrast" + B.toLowerCase() === st.toLowerCase())
      return sh[st](t, r, H);
  throw new TypeError(`Unknown contrast algorithm: ${B}`);
}
function vy(t) {
  let [r, f, B] = Bl(t, vr), H = r + 15 * f + 3 * B;
  return [4 * r / H, 9 * f / H];
}
function by(t) {
  let [r, f, B] = Bl(t, vr), H = r + f + B;
  return [r / H, f / H];
}
function LM(t) {
  Object.defineProperty(t.prototype, "uv", {
    get() {
      return vy(this);
    }
  }), Object.defineProperty(t.prototype, "xy", {
    get() {
      return by(this);
    }
  });
}
var OM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  register: LM,
  uv: vy,
  xy: by
});
function DM(t, r) {
  return my(t, r, "lab");
}
const IM = Math.PI, Xf = IM / 180;
function RM(t, r, { l: f = 2, c: B = 1 } = {}) {
  let [H, tt, st] = rr.from(t), [, lt, ht] = Pl.from(rr, [H, tt, st]), [ut, yt, gt] = rr.from(r), _ = Pl.from(rr, [ut, yt, gt])[1];
  lt < 0 && (lt = 0), _ < 0 && (_ = 0);
  let at = H - ut, G = lt - _, F = tt - yt, $ = st - gt, Y = pe(F, 2) + pe($, 2) - pe(G, 2), J = 0.511;
  H >= 16 && (J = 0.040975 * H / (1 + 0.01765 * H));
  let Q = 0.0638 * lt / (1 + 0.0131 * lt) + 0.638, q;
  Number.isNaN(ht) && (ht = 0), ht >= 164 && ht <= 345 ? q = 0.56 + Math.abs(0.2 * Math.cos((ht + 168) * Xf)) : q = 0.36 + Math.abs(0.4 * Math.cos((ht + 35) * Xf));
  let U = Math.pow(lt, 4), N = Math.sqrt(U / (U + 1900)), D = Q * (N * q + 1 - N), k = pe(at / (f * J), 2);
  return k += pe(G / (B * Q), 2), k += Y / pe(D, 2), Math.sqrt(k);
}
const Yf = 203;
var dp = new Ae({
  // Absolute CIE XYZ, with a D65 whitepoint,
  // as used in most HDR colorspaces as a starting point.
  // SDR spaces are converted per BT.2048
  // so that diffuse, media white is 203 cd/m²
  id: "xyz-abs-d65",
  name: "Absolute XYZ D65",
  coords: {
    x: {
      refRange: [0, 9504.7],
      name: "Xa"
    },
    y: {
      refRange: [0, 1e4],
      name: "Ya"
    },
    z: {
      refRange: [0, 10888.3],
      name: "Za"
    }
  },
  base: vr,
  fromBase(t) {
    return t.map((r) => Math.max(r * Yf, 0));
  },
  toBase(t) {
    return t.map((r) => Math.max(r / Yf, 0));
  }
});
const Gc = 1.15, Xc = 0.66, Vf = 2610 / pe(2, 14), jM = pe(2, 14) / 2610, $f = 3424 / pe(2, 12), Zf = 2413 / pe(2, 7), Kf = 2392 / pe(2, 7), _M = 1.7 * 2523 / pe(2, 5), qf = pe(2, 5) / (1.7 * 2523), Yc = -0.56, $u = 16295499532821565e-27, BM = [
  [0.41478972, 0.579999, 0.014648],
  [-0.20151, 1.120649, 0.0531008],
  [-0.0166008, 0.2648, 0.6684799]
], NM = [
  [1.9242264357876067, -1.0047923125953657, 0.037651404030618],
  [0.35031676209499907, 0.7264811939316552, -0.06538442294808501],
  [-0.09098281098284752, -0.3127282905230739, 1.5227665613052603]
], zM = [
  [0.5, 0.5, 0],
  [3.524, -4.066708, 0.542708],
  [0.199076, 1.096799, -1.295875]
], FM = [
  [1, 0.1386050432715393, 0.05804731615611886],
  [0.9999999999999999, -0.1386050432715393, -0.05804731615611886],
  [0.9999999999999998, -0.09601924202631895, -0.8118918960560388]
];
var xy = new Ae({
  id: "jzazbz",
  name: "Jzazbz",
  coords: {
    jz: {
      refRange: [0, 1],
      name: "Jz"
    },
    az: {
      refRange: [-0.5, 0.5]
    },
    bz: {
      refRange: [-0.5, 0.5]
    }
  },
  base: dp,
  fromBase(t) {
    let [r, f, B] = t, H = Gc * r - (Gc - 1) * B, tt = Xc * f - (Xc - 1) * r, lt = ai(BM, [H, tt, B]).map(function(_) {
      let at = $f + Zf * pe(_ / 1e4, Vf), G = 1 + Kf * pe(_ / 1e4, Vf);
      return pe(at / G, _M);
    }), [ht, ut, yt] = ai(zM, lt);
    return [(1 + Yc) * ht / (1 + Yc * ht) - $u, ut, yt];
  },
  toBase(t) {
    let [r, f, B] = t, H = (r + $u) / (1 + Yc - Yc * (r + $u)), st = ai(FM, [H, f, B]).map(function(_) {
      let at = $f - pe(_, qf), G = Kf * pe(_, qf) - Zf;
      return 1e4 * pe(at / G, jM);
    }), [lt, ht, ut] = ai(NM, st), yt = (lt + (Gc - 1) * ut) / Gc, gt = (ht + (Xc - 1) * yt) / Xc;
    return [yt, gt, ut];
  },
  formats: {
    // https://drafts.csswg.org/css-color-hdr/#Jzazbz
    color: {}
  }
}), bd = new Ae({
  id: "jzczhz",
  name: "JzCzHz",
  coords: {
    jz: {
      refRange: [0, 1],
      name: "Jz"
    },
    cz: {
      refRange: [0, 1],
      name: "Chroma"
    },
    hz: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  base: xy,
  fromBase(t) {
    let [r, f, B] = t, H;
    const tt = 2e-4;
    return Math.abs(f) < tt && Math.abs(B) < tt ? H = NaN : H = Math.atan2(B, f) * 180 / Math.PI, [
      r,
      // Jz is still Jz
      Math.sqrt(pe(f, 2) + pe(B, 2)),
      // Chroma
      Hh(H)
      // Hue, in degrees [0 to 360)
    ];
  },
  toBase(t) {
    return [
      t[0],
      // Jz is still Jz
      t[1] * Math.cos(t[2] * Math.PI / 180),
      // az
      t[1] * Math.sin(t[2] * Math.PI / 180)
      // bz
    ];
  },
  formats: {
    color: {}
  }
});
function WM(t, r) {
  let [f, B, H] = bd.from(t), [tt, st, lt] = bd.from(r), ht = f - tt, ut = B - st;
  Number.isNaN(H) && Number.isNaN(lt) ? (H = 0, lt = 0) : Number.isNaN(H) ? H = lt : Number.isNaN(lt) && (lt = H);
  let yt = H - lt, gt = 2 * Math.sqrt(B * st) * Math.sin(yt / 2 * (Math.PI / 180));
  return Math.sqrt(pe(ht, 2) + pe(ut, 2) + pe(gt, 2));
}
const Sy = 3424 / 4096, wy = 2413 / 128, Cy = 2392 / 128, Jf = 2610 / 16384, HM = 2523 / 32, UM = 16384 / 2610, Qf = 32 / 2523, GM = [
  [0.3592, 0.6976, -0.0358],
  [-0.1922, 1.1004, 0.0755],
  [7e-3, 0.0749, 0.8434]
], XM = [
  [2048 / 4096, 2048 / 4096, 0],
  [6610 / 4096, -13613 / 4096, 7003 / 4096],
  [17933 / 4096, -17390 / 4096, -543 / 4096]
], YM = [
  [0.9999888965628402, 0.008605050147287059, 0.11103437159861648],
  [1.00001110343716, -0.008605050147287059, -0.11103437159861648],
  [1.0000320633910054, 0.56004913547279, -0.3206339100541203]
], VM = [
  [2.0701800566956137, -1.326456876103021, 0.20661600684785517],
  [0.3649882500326575, 0.6804673628522352, -0.04542175307585323],
  [-0.04959554223893211, -0.04942116118675749, 1.1879959417328034]
];
var xd = new Ae({
  id: "ictcp",
  name: "ICTCP",
  // From BT.2100-2 page 7:
  // During production, signal values are expected to exceed the
  // range E′ = [0.0 : 1.0]. This provides processing headroom and avoids
  // signal degradation during cascaded processing. Such values of E′,
  // below 0.0 or exceeding 1.0, should not be clipped during production
  // and exchange.
  // Values below 0.0 should not be clipped in reference displays (even
  // though they represent “negative” light) to allow the black level of
  // the signal (LB) to be properly set using test signals known as “PLUGE”
  coords: {
    i: {
      refRange: [0, 1],
      // Constant luminance,
      name: "I"
    },
    ct: {
      refRange: [-0.5, 0.5],
      // Full BT.2020 gamut in range [-0.5, 0.5]
      name: "CT"
    },
    cp: {
      refRange: [-0.5, 0.5],
      name: "CP"
    }
  },
  base: dp,
  fromBase(t) {
    let r = ai(GM, t);
    return $M(r);
  },
  toBase(t) {
    let r = ZM(t);
    return ai(VM, r);
  },
  formats: {
    color: {}
  }
});
function $M(t) {
  let r = t.map(function(f) {
    let B = Sy + wy * pe(f / 1e4, Jf), H = 1 + Cy * pe(f / 1e4, Jf);
    return pe(B / H, HM);
  });
  return ai(XM, r);
}
function ZM(t) {
  return ai(YM, t).map(function(B) {
    let H = Math.max(pe(B, Qf) - Sy, 0), tt = wy - Cy * pe(B, Qf);
    return 1e4 * pe(H / tt, UM);
  });
}
function KM(t, r) {
  let [f, B, H] = xd.from(t), [tt, st, lt] = xd.from(r);
  return 720 * Math.sqrt(pe(f - tt, 2) + 0.25 * pe(B - st, 2) + pe(H - lt, 2));
}
const qM = [
  [0.8190224432164319, 0.3619062562801221, -0.12887378261216414],
  [0.0329836671980271, 0.9292868468965546, 0.03614466816999844],
  [0.048177199566046255, 0.26423952494422764, 0.6335478258136937]
], JM = [
  [1.2268798733741557, -0.5578149965554813, 0.28139105017721583],
  [-0.04057576262431372, 1.1122868293970594, -0.07171106666151701],
  [-0.07637294974672142, -0.4214933239627914, 1.5869240244272418]
], QM = [
  [0.2104542553, 0.793617785, -0.0040720468],
  [1.9779984951, -2.428592205, 0.4505937099],
  [0.0259040371, 0.7827717662, -0.808675766]
], tA = [
  [0.9999999984505198, 0.39633779217376786, 0.2158037580607588],
  [1.0000000088817609, -0.10556134232365635, -0.06385417477170591],
  [1.0000000546724108, -0.08948418209496575, -1.2914855378640917]
];
var Th = new Ae({
  id: "oklab",
  name: "Oklab",
  coords: {
    l: {
      refRange: [0, 1],
      name: "L"
    },
    a: {
      refRange: [-0.4, 0.4]
    },
    b: {
      refRange: [-0.4, 0.4]
    }
  },
  // Note that XYZ is relative to D65
  white: "D65",
  base: vr,
  fromBase(t) {
    let f = ai(qM, t).map((B) => Math.cbrt(B));
    return ai(QM, f);
  },
  toBase(t) {
    let f = ai(tA, t).map((B) => pe(B, 3));
    return ai(JM, f);
  },
  formats: {
    oklab: {
      coords: ["<percentage> | <number>", "<number> | <percentage>[-1,1]", "<number> | <percentage>[-1,1]"]
    }
  }
});
function eA(t, r) {
  let [f, B, H] = Th.from(t), [tt, st, lt] = Th.from(r), ht = f - tt, ut = B - st, yt = H - lt;
  return Math.sqrt(pe(ht, 2) + pe(ut, 2) + pe(yt, 2));
}
var Mh = {
  deltaE76: DM,
  deltaECMC: RM,
  deltaE2000: yd,
  deltaEJz: WM,
  deltaEITP: KM,
  deltaEOK: eA
};
function yl(t, r, f = {}) {
  _l(f) && (f = { method: f });
  let tt = f, { method: B = Qr.deltaE } = tt, H = mr(tt, ["method"]);
  t = Ue(t), r = Ue(r);
  for (let st in Mh)
    if ("deltae" + B.toLowerCase() === st.toLowerCase())
      return Mh[st](t, r, H);
  throw new TypeError(`Unknown deltaE method: ${B}`);
}
function iA(t, r = 0.25) {
  let B = [Ae.get("oklch", "lch"), "l"];
  return ro(t, B, (H) => H * (1 + r));
}
function rA(t, r = 0.25) {
  let B = [Ae.get("oklch", "lch"), "l"];
  return ro(t, B, (H) => H * (1 - r));
}
var nA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  darken: rA,
  lighten: iA
});
function ky(t, r, f = 0.5, B = {}) {
  [t, r] = [Ue(t), Ue(r)], Kn(f) === "object" && ([f, B] = [0.5, f]);
  let { space: H, outputSpace: tt, premultiplied: st } = B;
  return Nl(t, r, { space: H, outputSpace: tt, premultiplied: st })(f);
}
function Ty(t, r, f = {}) {
  let B;
  pp(t) && ([B, f] = [t, r], [t, r] = B.rangeArgs.colors);
  let _ = f, {
    maxDeltaE: H,
    deltaEMethod: tt,
    steps: st = 2,
    maxSteps: lt = 1e3
  } = _, ht = mr(_, [
    "maxDeltaE",
    "deltaEMethod",
    "steps",
    "maxSteps"
  ]);
  B || ([t, r] = [Ue(t), Ue(r)], B = Nl(t, r, ht));
  let ut = yl(t, r), yt = H > 0 ? Math.max(st, Math.ceil(ut / H) + 1) : st, gt = [];
  if (lt !== void 0 && (yt = Math.min(yt, lt)), yt === 1)
    gt = [{ p: 0.5, color: B(0.5) }];
  else {
    let at = 1 / (yt - 1);
    gt = Array.from({ length: yt }, (G, F) => {
      let $ = F * at;
      return { p: $, color: B($) };
    });
  }
  if (H > 0) {
    let at = gt.reduce((G, F, $) => {
      if ($ === 0)
        return 0;
      let Y = yl(F.color, gt[$ - 1].color, tt);
      return Math.max(G, Y);
    }, 0);
    for (; at > H; ) {
      at = 0;
      for (let G = 1; G < gt.length && gt.length < lt; G++) {
        let F = gt[G - 1], $ = gt[G], Y = ($.p + F.p) / 2, J = B(Y);
        at = Math.max(at, yl(J, F.color), yl(J, $.color)), gt.splice(G, 0, { p: Y, color: B(Y) }), G++;
      }
    }
  }
  return gt = gt.map((at) => at.color), gt;
}
function Nl(t, r, f = {}) {
  if (pp(t)) {
    let [ht, ut] = [t, r];
    return Nl(...ht.rangeArgs.colors, Ut(Ut({}, ht.rangeArgs.options), ut));
  }
  let { space: B, outputSpace: H, progression: tt, premultiplied: st } = f;
  t = Ue(t), r = Ue(r), t = El(t), r = El(r);
  let lt = { colors: [t, r], options: f };
  if (B ? B = Ae.get(B) : B = Ae.registry[Qr.interpolationSpace] || t.space, H = H ? Ae.get(H) : B, t = yr(t, B), r = yr(r, B), t = no(t), r = no(r), B.coords.h && B.coords.h.type === "angle") {
    let ht = f.hue = f.hue || "shorter", ut = [B, "h"], [yt, gt] = [br(t, ut), br(r, ut)];
    [yt, gt] = tM(ht, [yt, gt]), ro(t, ut, yt), ro(r, ut, gt);
  }
  return st && (t.coords = t.coords.map((ht) => ht * t.alpha), r.coords = r.coords.map((ht) => ht * r.alpha)), Object.assign((ht) => {
    ht = tt ? tt(ht) : ht;
    let ut = t.coords.map((_, at) => {
      let G = r.coords[at];
      return Sh(_, G, ht);
    }), yt = Sh(t.alpha, r.alpha, ht), gt = { space: B, coords: ut, alpha: yt };
    return st && (gt.coords = gt.coords.map((_) => _ / yt)), H !== B && (gt = yr(gt, H)), gt;
  }, {
    rangeArgs: lt
  });
}
function pp(t) {
  return Kn(t) === "function" && !!t.rangeArgs;
}
Qr.interpolationSpace = "lab";
function oA(t) {
  t.defineFunction("mix", ky, { returns: "color" }), t.defineFunction("range", Nl, { returns: "function<color>" }), t.defineFunction("steps", Ty, { returns: "array<color>" });
}
var sA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isRange: pp,
  mix: ky,
  range: Nl,
  register: oA,
  steps: Ty
}), My = new Ae({
  id: "hsl",
  name: "HSL",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    s: {
      range: [0, 100],
      name: "Saturation"
    },
    l: {
      range: [0, 100],
      name: "Lightness"
    }
  },
  base: Ll,
  // Adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB
  fromBase: (t) => {
    let r = Math.max(...t), f = Math.min(...t), [B, H, tt] = t, [st, lt, ht] = [NaN, 0, (f + r) / 2], ut = r - f;
    if (ut !== 0) {
      switch (lt = ht === 0 || ht === 1 ? 0 : (r - ht) / Math.min(ht, 1 - ht), r) {
        case B:
          st = (H - tt) / ut + (H < tt ? 6 : 0);
          break;
        case H:
          st = (tt - B) / ut + 2;
          break;
        case tt:
          st = (B - H) / ut + 4;
      }
      st = st * 60;
    }
    return [st, lt * 100, ht * 100];
  },
  // Adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
  toBase: (t) => {
    let [r, f, B] = t;
    r = r % 360, r < 0 && (r += 360), f /= 100, B /= 100;
    function H(tt) {
      let st = (tt + r / 30) % 12, lt = f * Math.min(B, 1 - B);
      return B - lt * Math.max(-1, Math.min(st - 3, 9 - st, 1));
    }
    return [H(0), H(8), H(4)];
  },
  formats: {
    hsl: {
      toGamut: !0,
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"]
    },
    hsla: {
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"],
      commas: !0,
      lastAlpha: !0
    }
  }
}), Ay = new Ae({
  id: "hsv",
  name: "HSV",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    s: {
      range: [0, 100],
      name: "Saturation"
    },
    v: {
      range: [0, 100],
      name: "Value"
    }
  },
  base: My,
  // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
  fromBase(t) {
    let [r, f, B] = t;
    f /= 100, B /= 100;
    let H = B + f * Math.min(B, 1 - B);
    return [
      r,
      // h is the same
      H === 0 ? 0 : 200 * (1 - B / H),
      // s
      100 * H
    ];
  },
  // https://en.wikipedia.org/wiki/HSL_and_HSV#Interconversion
  toBase(t) {
    let [r, f, B] = t;
    f /= 100, B /= 100;
    let H = B * (1 - f / 2);
    return [
      r,
      // h is the same
      H === 0 || H === 1 ? 0 : (B - H) / Math.min(H, 1 - H) * 100,
      H * 100
    ];
  },
  formats: {
    color: {
      toGamut: !0
    }
  }
}), aA = new Ae({
  id: "hwb",
  name: "HWB",
  coords: {
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    },
    w: {
      range: [0, 100],
      name: "Whiteness"
    },
    b: {
      range: [0, 100],
      name: "Blackness"
    }
  },
  base: Ay,
  fromBase(t) {
    let [r, f, B] = t;
    return [r, B * (100 - f) / 100, 100 - B];
  },
  toBase(t) {
    let [r, f, B] = t;
    f /= 100, B /= 100;
    let H = f + B;
    if (H >= 1) {
      let lt = f / H;
      return [r, 0, lt * 100];
    }
    let tt = 1 - B, st = tt === 0 ? 0 : 1 - f / tt;
    return [r, st * 100, tt * 100];
  },
  formats: {
    hwb: {
      toGamut: !0,
      coords: ["<number> | <angle>", "<percentage>", "<percentage>"]
    }
  }
});
const lA = [
  [0.5766690429101305, 0.1855582379065463, 0.1882286462349947],
  [0.29734497525053605, 0.6273635662554661, 0.07529145849399788],
  [0.02703136138641234, 0.07068885253582723, 0.9913375368376388]
], cA = [
  [2.0415879038107465, -0.5650069742788596, -0.34473135077832956],
  [-0.9692436362808795, 1.8759675015077202, 0.04155505740717557],
  [0.013444280632031142, -0.11836239223101838, 1.0151749943912054]
];
var Py = new Zi({
  id: "a98rgb-linear",
  name: "Linear Adobe® 98 RGB compatible",
  white: "D65",
  toXYZ_M: lA,
  fromXYZ_M: cA
}), hA = new Zi({
  id: "a98rgb",
  name: "Adobe® 98 RGB compatible",
  base: Py,
  toBase: (t) => t.map((r) => Math.pow(Math.abs(r), 563 / 256) * Math.sign(r)),
  fromBase: (t) => t.map((r) => Math.pow(Math.abs(r), 256 / 563) * Math.sign(r)),
  formats: {
    color: {
      id: "a98-rgb"
    }
  }
});
const uA = [
  [0.7977604896723027, 0.13518583717574031, 0.0313493495815248],
  [0.2880711282292934, 0.7118432178101014, 8565396060525902e-20],
  [0, 0, 0.8251046025104601]
], dA = [
  [1.3457989731028281, -0.25558010007997534, -0.05110628506753401],
  [-0.5446224939028347, 1.5082327413132781, 0.02053603239147973],
  [0, 0, 1.2119675456389454]
];
var Ey = new Zi({
  id: "prophoto-linear",
  name: "Linear ProPhoto",
  white: "D50",
  base: up,
  toXYZ_M: uA,
  fromXYZ_M: dA
});
const pA = 1 / 512, fA = 16 / 512;
var gA = new Zi({
  id: "prophoto",
  name: "ProPhoto",
  base: Ey,
  toBase(t) {
    return t.map((r) => r < fA ? r / 16 : pe(r, 1.8));
  },
  fromBase(t) {
    return t.map((r) => r >= pA ? pe(r, 1 / 1.8) : 16 * r);
  },
  formats: {
    color: {
      id: "prophoto-rgb"
    }
  }
}), mA = new Ae({
  id: "oklch",
  name: "Oklch",
  coords: {
    l: {
      refRange: [0, 1],
      name: "Lightness"
    },
    c: {
      refRange: [0, 0.4],
      name: "Chroma"
    },
    h: {
      refRange: [0, 360],
      type: "angle",
      name: "Hue"
    }
  },
  white: "D65",
  base: Th,
  fromBase(t) {
    let [r, f, B] = t, H;
    const tt = 2e-4;
    return Math.abs(f) < tt && Math.abs(B) < tt ? H = NaN : H = Math.atan2(B, f) * 180 / Math.PI, [
      r,
      // OKLab L is still L
      Math.sqrt(pe(f, 2) + pe(B, 2)),
      // Chroma
      Hh(H)
      // Hue, in degrees [0 to 360)
    ];
  },
  // Convert from polar form
  toBase(t) {
    let [r, f, B] = t, H, tt;
    return isNaN(B) ? (H = 0, tt = 0) : (H = f * Math.cos(B * Math.PI / 180), tt = f * Math.sin(B * Math.PI / 180)), [r, H, tt];
  },
  formats: {
    oklch: {
      coords: ["<number> | <percentage>", "<number> | <percentage>[0,1]", "<number> | <angle>"]
    }
  }
});
const tg = 203, eg = 2610 / pe(2, 14), yA = pe(2, 14) / 2610, vA = 2523 / pe(2, 5), ig = pe(2, 5) / 2523, rg = 3424 / pe(2, 12), ng = 2413 / pe(2, 7), og = 2392 / pe(2, 7);
var bA = new Zi({
  id: "rec2100pq",
  name: "REC.2100-PQ",
  base: Uh,
  toBase(t) {
    return t.map(function(r) {
      return pe(Math.max(pe(r, ig) - rg, 0) / (ng - og * pe(r, ig)), yA) * 1e4 / tg;
    });
  },
  fromBase(t) {
    return t.map(function(r) {
      let f = Math.max(r * tg / 1e4, 0), B = rg + ng * pe(f, eg), H = 1 + og * pe(f, eg);
      return pe(B / H, vA);
    });
  },
  formats: {
    color: {
      id: "rec2100-pq"
    }
  }
});
const sg = 0.17883277, ag = 0.28466892, lg = 0.55991073, Zu = 3.7743;
var xA = new Zi({
  id: "rec2100hlg",
  cssid: "rec2100-hlg",
  name: "REC.2100-HLG",
  referred: "scene",
  base: Uh,
  toBase(t) {
    return t.map(function(r) {
      return r <= 0.5 ? pe(r, 2) / 3 * Zu : (Math.exp((r - lg) / sg) + ag) / 12 * Zu;
    });
  },
  fromBase(t) {
    return t.map(function(r) {
      return r /= Zu, r <= 1 / 12 ? Math.sqrt(3 * r) : sg * Math.log(12 * r - ag) + lg;
    });
  },
  formats: {
    color: {
      id: "rec2100-hlg"
    }
  }
});
const Ly = {};
io.add("chromatic-adaptation-start", (t) => {
  t.options.method && (t.M = Oy(t.W1, t.W2, t.options.method));
});
io.add("chromatic-adaptation-end", (t) => {
  t.M || (t.M = Oy(t.W1, t.W2, t.options.method));
});
function Gh({ id: t, toCone_M: r, fromCone_M: f }) {
  Ly[t] = arguments[0];
}
function Oy(t, r, f = "Bradford") {
  let B = Ly[f], [H, tt, st] = ai(B.toCone_M, t), [lt, ht, ut] = ai(B.toCone_M, r), yt = [
    [lt / H, 0, 0],
    [0, ht / tt, 0],
    [0, 0, ut / st]
  ], gt = ai(yt, B.toCone_M);
  return ai(B.fromCone_M, gt);
}
Gh({
  id: "von Kries",
  toCone_M: [
    [0.40024, 0.7076, -0.08081],
    [-0.2263, 1.16532, 0.0457],
    [0, 0, 0.91822]
  ],
  fromCone_M: [
    [1.8599364, -1.1293816, 0.2198974],
    [0.3611914, 0.6388125, -64e-7],
    [0, 0, 1.0890636]
  ]
});
Gh({
  id: "Bradford",
  // Convert an array of XYZ values in the range 0.0 - 1.0
  // to cone fundamentals
  toCone_M: [
    [0.8951, 0.2664, -0.1614],
    [-0.7502, 1.7135, 0.0367],
    [0.0389, -0.0685, 1.0296]
  ],
  // and back
  fromCone_M: [
    [0.9869929, -0.1470543, 0.1599627],
    [0.4323053, 0.5183603, 0.0492912],
    [-85287e-7, 0.0400428, 0.9684867]
  ]
});
Gh({
  id: "CAT02",
  // with complete chromatic adaptation to W2, so D = 1.0
  toCone_M: [
    [0.7328, 0.4296, -0.1624],
    [-0.7036, 1.6975, 61e-4],
    [3e-3, 0.0136, 0.9834]
  ],
  fromCone_M: [
    [1.0961238, -0.278869, 0.1827452],
    [0.454369, 0.4735332, 0.0720978],
    [-96276e-7, -5698e-6, 1.0153256]
  ]
});
Gh({
  id: "CAT16",
  toCone_M: [
    [0.401288, 0.650173, -0.051461],
    [-0.250268, 1.204414, 0.045854],
    [-2079e-6, 0.048952, 0.953127]
  ],
  // the extra precision is needed to avoid roundtripping errors
  fromCone_M: [
    [1.862067855087233, -1.011254630531685, 0.1491867754444518],
    [0.3875265432361372, 0.6214474419314753, -0.008973985167612518],
    [-0.01584149884933386, -0.03412293802851557, 1.04996443687785]
  ]
});
Object.assign(Dr, {
  // whitepoint values from ASTM E308-01 with 10nm spacing, 1931 2 degree observer
  // all normalized to Y (luminance) = 1.00000
  // Illuminant A is a tungsten electric light, giving a very warm, orange light.
  A: [1.0985, 1, 0.35585],
  // Illuminant C was an early approximation to daylight: illuminant A with a blue filter.
  C: [0.98074, 1, 1.18232],
  // The daylight series of illuminants simulate natural daylight.
  // The color temperature (in degrees Kelvin/100) ranges from
  // cool, overcast daylight (D50) to bright, direct sunlight (D65).
  D55: [0.95682, 1, 0.92149],
  D75: [0.94972, 1, 1.22638],
  // Equal-energy illuminant, used in two-stage CAT16
  E: [1, 1, 1],
  // The F series of illuminants represent fluorescent lights
  F2: [0.99186, 1, 0.67393],
  F7: [0.95041, 1, 1.08747],
  F11: [1.00962, 1, 0.6435]
});
Dr.ACES = [0.32168 / 0.33767, 1, (1 - 0.32168 - 0.33767) / 0.33767];
const SA = [
  [0.6624541811085053, 0.13400420645643313, 0.1561876870049078],
  [0.27222871678091454, 0.6740817658111484, 0.05368951740793705],
  [-0.005574649490394108, 0.004060733528982826, 1.0103391003129971]
], wA = [
  [1.6410233796943257, -0.32480329418479, -0.23642469523761225],
  [-0.6636628587229829, 1.6153315916573379, 0.016756347685530137],
  [0.011721894328375376, -0.008284441996237409, 0.9883948585390215]
];
var Dy = new Zi({
  id: "acescg",
  name: "ACEScg",
  // ACEScg – A scene-referred, linear-light encoding of ACES Data
  // https://docs.acescentral.com/specifications/acescg/
  // uses the AP1 primaries, see section 4.3.1 Color primaries
  coords: {
    r: {
      range: [0, 65504],
      name: "Red"
    },
    g: {
      range: [0, 65504],
      name: "Green"
    },
    b: {
      range: [0, 65504],
      name: "Blue"
    }
  },
  referred: "scene",
  white: Dr.ACES,
  toXYZ_M: SA,
  fromXYZ_M: wA,
  formats: {
    color: {}
  }
});
const Vc = pe(2, -16), Ku = -0.35828683, $c = (Math.log2(65504) + 9.72) / 17.52;
var CA = new Zi({
  id: "acescc",
  name: "ACEScc",
  // see S-2014-003 ACEScc – A Logarithmic Encoding of ACES Data
  // https://docs.acescentral.com/specifications/acescc/
  // uses the AP1 primaries, see section 4.3.1 Color primaries
  // Appendix A: "Very small ACES scene referred values below 7 1/4 stops
  // below 18% middle gray are encoded as negative ACEScc values.
  // These values should be preserved per the encoding in Section 4.4
  // so that all positive ACES values are maintained."
  coords: {
    r: {
      range: [Ku, $c],
      name: "Red"
    },
    g: {
      range: [Ku, $c],
      name: "Green"
    },
    b: {
      range: [Ku, $c],
      name: "Blue"
    }
  },
  referred: "scene",
  base: Dy,
  // from section 4.4.2 Decoding Function
  toBase(t) {
    const r = -0.3013698630136986;
    return t.map(function(f) {
      return f <= r ? (pe(2, f * 17.52 - 9.72) - Vc) * 2 : f < $c ? pe(2, f * 17.52 - 9.72) : 65504;
    });
  },
  // Non-linear encoding function from S-2014-003, section 4.4.1 Encoding Function
  fromBase(t) {
    return t.map(function(r) {
      return r <= 0 ? (Math.log2(Vc) + 9.72) / 17.52 : r < Vc ? (Math.log2(Vc + r * 0.5) + 9.72) / 17.52 : (Math.log2(r) + 9.72) / 17.52;
    });
  },
  // encoded media white (rgb 1,1,1) => linear  [ 222.861, 222.861, 222.861 ]
  // encoded media black (rgb 0,0,0) => linear [ 0.0011857, 0.0011857, 0.0011857]
  formats: {
    color: {}
  }
}), cg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  A98RGB: hA,
  A98RGB_Linear: Py,
  ACEScc: CA,
  ACEScg: Dy,
  HSL: My,
  HSV: Ay,
  HWB: aA,
  ICTCP: xd,
  JzCzHz: bd,
  Jzazbz: xy,
  LCH: Pl,
  Lab: rr,
  Lab_D65: vd,
  OKLCH: mA,
  OKLab: Th,
  P3: gy,
  P3_Linear: py,
  ProPhoto: gA,
  ProPhoto_Linear: Ey,
  REC_2020: dy,
  REC_2020_Linear: Uh,
  REC_2100_HLG: xA,
  REC_2100_PQ: bA,
  XYZ_ABS_D65: dp,
  XYZ_D50: up,
  XYZ_D65: vr,
  sRGB: Ll,
  sRGB_Linear: fy
});
class Ne {
  /**
   * Creates an instance of Color.
   * Signatures:
   * - `new Color(stringToParse)`
   * - `new Color(otherColor)`
   * - `new Color({space, coords, alpha})`
   * - `new Color(space, coords, alpha)`
   * - `new Color(spaceId, coords, alpha)`
   */
  constructor(...r) {
    let f;
    r.length === 1 && (f = Ue(r[0]));
    let B, H, tt;
    f ? (B = f.space || f.spaceId, H = f.coords, tt = f.alpha) : [B, H, tt] = r, Object.defineProperty(this, "space", {
      value: Ae.get(B),
      writable: !1,
      enumerable: !0,
      configurable: !0
      // see note in https://262.ecma-international.org/8.0/#sec-proxy-object-internal-methods-and-internal-slots-get-p-receiver
    }), this.coords = H ? H.slice() : [0, 0, 0], this.alpha = tt < 1 ? tt : 1;
    for (let st = 0; st < this.coords.length; st++)
      this.coords[st] === "NaN" && (this.coords[st] = NaN);
    for (let st in this.space.coords)
      Object.defineProperty(this, st, {
        get: () => this.get(st),
        set: (lt) => this.set(st, lt)
      });
  }
  get spaceId() {
    return this.space.id;
  }
  clone() {
    return new Ne(this.space, this.coords, this.alpha);
  }
  toJSON() {
    return {
      spaceId: this.spaceId,
      coords: this.coords,
      alpha: this.alpha
    };
  }
  display(...r) {
    let f = lM(this, ...r);
    return f.color = new Ne(f.color), f;
  }
  /**
   * Get a color from the argument passed
   * Basically gets us the same result as new Color(color) but doesn't clone an existing color object
   */
  static get(r, ...f) {
    return r instanceof Ne ? r : new Ne(r, ...f);
  }
  static defineFunction(r, f, B = f) {
    let { instance: H = !0, returns: tt } = B, st = function(...lt) {
      let ht = f(...lt);
      if (tt === "color")
        ht = Ne.get(ht);
      else if (tt === "function<color>") {
        let ut = ht;
        ht = function(...yt) {
          let gt = ut(...yt);
          return Ne.get(gt);
        }, Object.assign(ht, ut);
      } else
        tt === "array<color>" && (ht = ht.map((ut) => Ne.get(ut)));
      return ht;
    };
    r in Ne || (Ne[r] = st), H && (Ne.prototype[r] = function(...lt) {
      return st(this, ...lt);
    });
  }
  static defineFunctions(r) {
    for (let f in r)
      Ne.defineFunction(f, r[f], r[f]);
  }
  static extend(r) {
    if (r.register)
      r.register(Ne);
    else
      for (let f in r)
        Ne.defineFunction(f, r[f]);
  }
}
Ne.defineFunctions({
  get: br,
  getAll: Bl,
  set: ro,
  setAll: uy,
  to: yr,
  equals: cM,
  inGamut: xl,
  toGamut: no,
  distance: my,
  toString: kh
});
Object.assign(Ne, {
  util: ZT,
  hooks: io,
  WHITES: Dr,
  Space: Ae,
  spaces: Ae.registry,
  parse: hy,
  // Global defaults one may want to configure
  defaults: Qr
});
for (let t of Object.keys(cg))
  Ae.register(cg[t]);
for (let t in Ae.registry)
  Sd(t, Ae.registry[t]);
io.add("colorspace-init-end", (t) => {
  var r;
  Sd(t.id, t), (r = t.aliases) == null || r.forEach((f) => {
    Sd(f, t);
  });
});
function Sd(t, r) {
  Object.values(r.coords).map((B) => B.name);
  let f = t.replace(/-/g, "_");
  Object.defineProperty(Ne.prototype, f, {
    // Convert coords to coords in another colorspace and return them
    // Source colorspace: this.spaceId
    // Target colorspace: id
    get() {
      let B = this.getAll(t);
      return typeof Proxy == "undefined" ? B : new Proxy(B, {
        has: (H, tt) => {
          try {
            return Ae.resolveCoord([r, tt]), !0;
          } catch (st) {
          }
          return Reflect.has(H, tt);
        },
        get: (H, tt, st) => {
          if (tt && typeof tt != "symbol" && !(tt in H)) {
            let { index: lt } = Ae.resolveCoord([r, tt]);
            if (lt >= 0)
              return H[lt];
          }
          return Reflect.get(H, tt, st);
        },
        set: (H, tt, st, lt) => {
          if (tt && typeof tt != "symbol" && !(tt in H) || tt >= 0) {
            let { index: ht } = Ae.resolveCoord([r, tt]);
            if (ht >= 0)
              return H[ht] = st, this.setAll(t, H), !0;
          }
          return Reflect.set(H, tt, st, lt);
        }
      });
    },
    // Convert coords in another colorspace to internal coords and set them
    // Target colorspace: this.spaceId
    // Source colorspace: id
    set(B) {
      this.setAll(t, B);
    },
    configurable: !0,
    enumerable: !0
  });
}
Ne.extend(Mh);
Ne.extend({ deltaE: yl });
Object.assign(Ne, { deltaEMethods: Mh });
Ne.extend(nA);
Ne.extend({ contrast: EM });
Ne.extend(OM);
Ne.extend(uM);
Ne.extend(sA);
Ne.extend(sh);
const uO = 0.15, tn = (t) => typeof t == "string" ? new Ne(t) : t, dn = (t) => t.toString({ format: "hex" }), Iy = (...t) => {
  const r = t.map(tn);
  if (r.length < 2)
    return () => dn(r[0]);
  const B = r.slice(0, -1).map((H, tt) => [H, r[tt + 1]]).map(([H, tt]) => {
    const st = Ne.range(H, tt, { outputSpace: "srgb" });
    return (lt) => dn(st(lt));
  });
  return (H) => {
    if (H <= 0)
      return dn(r[0]);
    if (H >= 1)
      return dn(r[r.length - 1]);
    const tt = Math.floor(H * B.length);
    return B[tt](H * B.length - tt);
  };
}, kA = (t, ...r) => {
  const f = r.map(tn);
  if (f.length < 2)
    return Array(t).fill(dn(f[0]));
  const B = Iy(...f);
  return Array(t).fill(0).map((H, tt) => B(tt / (t - 1)));
}, TA = (t) => dn(tn(t).set("hsl.s", 0)), MA = (t, r) => dn(Ne.mix(t, r, 0.5, { outputSpace: "srgb" })), AA = (t, r) => Math.abs(tn(r).hsl.h - tn(t).hsl.h), Ah = (t, r) => {
  const f = tn(t);
  return f.hsv.v = f.hsv.v + f.hsv.v * r, f.hsv.v > 100 && (f.hsv.s = f.hsv.s - (f.hsv.v - 100) / 1.677), f.hsv.s = Math.max(0, Math.min(100, f.hsv.s)), f.hsv.v = Math.max(0, Math.min(100, f.hsv.v)), dn(f);
}, Ry = (t) => ({
  R: t.srgb[0] * 255,
  G: t.srgb[1] * 255,
  B: t.srgb[2] * 255
}), Xh = (t) => {
  const { R: r, G: f, B } = Ry(t);
  return 1 - (0.299 * r + 0.587 * f + 0.114 * B) / 255;
};
function PA(t) {
  return Xh(t) < 0.9;
}
const dO = (t, r = 0.05, f = 1) => {
  const B = tn(t), { R: H, G: tt, B: st } = Ry(B), lt = Xh(B);
  let ht = r;
  PA(B) && (ht *= -0.6), ht *= Math.exp(lt * 1.2);
  const ut = Math.min(Math.max(Math.round(255 * ht) + H, 0), 255), yt = Math.min(Math.max(Math.round(255 * ht) + tt, 0), 255), gt = Math.min(Math.max(Math.round(255 * ht) + st, 0), 255);
  return `rgba(${ut}, ${yt}, ${gt}, ${f})`;
}, EA = (t, r) => {
  const f = tn(t);
  return f.alpha = r, dn(f);
}, LA = (t, r, f) => Ne.steps(new Ne(t), new Ne(r), { steps: f }).map(
  (B) => new Ne(B).to("srgb").toString()
);
function OA(t) {
  return (r) => {
    var ut, yt, gt;
    const { steps: f, minColor: B, maxColor: H } = t, tt = (ut = t.minValue) != null ? ut : Math.min(...r), st = (yt = t.maxValue) != null ? yt : Math.max(...r), lt = (gt = t.midValue) != null ? gt : tt < 0 && st > 0 ? 0 : (tt + st) / 2, ht = DA(
      B != null ? B : gd,
      H != null ? H : gd,
      tt,
      lt,
      st,
      f
    );
    return (_) => ht(_);
  };
}
const DA = (t, r, f, B, H, tt = 0) => {
  const st = jA(f, B, H), lt = AA(t, r) > 90 ? [t, TA(MA(t, r)), r] : [t, r];
  return tt <= 0 ? IA(st, lt) : RA(st, tt, lt);
}, IA = (t, r) => {
  const f = Iy(...r);
  return (B) => f(t(B));
}, RA = (t, r, f) => {
  const B = kA(r, ...f);
  return (H) => {
    const tt = Math.floor(t(H) * r);
    return B[Math.min(Math.max(tt, 0), r - 1)];
  };
}, jA = (t, r, f) => (B) => B == t && B == f ? 0.5 : B < r ? 0.5 * ((B - t) / (r - t)) : 0.5 + 0.5 * (B - r) / (f - r);
function _A(t) {
  let r;
  switch (typeof t == "string" ? r = ny(t) : r = t, r.type) {
    case "uniform":
      return {
        type: "Static",
        getColor: YT(r)
      };
    case "conditional":
      return {
        type: "Absolute",
        getColor: VT(r)
      };
    case "range":
      return {
        type: "Relative",
        getColor: OA(r)
      };
  }
}
const jy = (t) => {
  const { getValueFromDataStructure: r, applyColorToDataStructure: f } = t;
  return (B, H) => {
    const tt = _A(H);
    let st;
    switch (tt.type) {
      case "Static":
        st = () => tt.getColor();
        break;
      case "Absolute":
        st = (lt) => tt.getColor(lt);
        break;
      case "Relative": {
        const lt = B.map(r), ht = tt.getColor(
          lt
        );
        st = (ut) => ht(ut);
        break;
      }
    }
    return B.map((lt) => {
      const ht = r(lt), ut = st(ht);
      return f(lt, ut);
    });
  };
}, BA = jy({
  getValueFromDataStructure: (t) => t.value,
  applyColorToDataStructure: (t, r) => oe(Ut({}, t), {
    color: r
  })
}), wd = (t, r) => Object.assign(Object.create(t), r), pO = (t, r) => Object.assign(
  Object.create(Object.getPrototypeOf(t)),
  t,
  r
), Yh = (t) => {
  if (By(t)) {
    const r = t, { column: f } = r, B = mr(r, ["column"]);
    return {
      column: f,
      style: B
    };
  }
  return {
    column: t,
    style: {}
  };
};
function vn(t) {
  const r = "column" in t ? t.column : t, f = "aggregation" in r && !!r.aggregation, B = "context" in r && !!r.context, H = "formula" in r && !!r.formula;
  return f || B || H ? !0 : !("type" in r);
}
const Li = ({ column: t }) => "title" in t && t.title || t.name, _y = ({ column: t, granularity: r }) => r || t.granularity, fO = (t) => {
  const { column: r } = Yh(t);
  return r;
}, gO = (t) => {
  const { column: r } = Yh(t);
  return r;
};
function By(t) {
  return "column" in t && t.column !== void 0;
}
function NA(t) {
  return !("column" in t);
}
function zA(t) {
  var H;
  const { column: r, style: f } = Yh(t), B = pn(r.type) ? (H = r == null ? void 0 : r.getFormat) == null ? void 0 : H.call(r) : void 0;
  return oe(Ut({}, f), {
    dateFormat: f.dateFormat || B,
    column: r
  });
}
function FA(t) {
  var B, H;
  const { column: r, style: f } = Yh(t);
  return oe(Ut({}, f), {
    column: wd(r, {
      title: (B = r.title) != null ? B : r.name,
      aggregation: (H = r.aggregation) != null ? H : "sum"
    }),
    enabled: !0
  });
}
function mO(t) {
  return vn(t) ? FA(t) : zA(t);
}
const hg = (t, r) => {
  var gt;
  if (r.rows.length === 0)
    return { type: "cartesian", series: [], xValues: [], xAxisCount: 0 };
  const f = t.x.length;
  let B = bh(
    r,
    t.x.map(({ column: { name: _ } }) => _)
  );
  B = B.map((_, at) => oe(Ut({}, _), {
    direction: WA(t.x[at].sortType)
  }));
  const H = bh(
    r,
    t.breakBy.map(({ column: { name: _ } }) => _)
  ), tt = t.y.filter(
    ({ sortType: _ }) => _ && _ !== "sortNone"
  ), st = B.length > 1 ? 1 : 0, lt = HA(
    r,
    tt,
    B,
    ((gt = B[st]) == null ? void 0 : gt.direction) === 0 ? Vm : void 0
  ), ht = t.y.map(({ column: { name: _ } }) => _), ut = t.breakBy.length > 0 ? YA(
    r,
    lt,
    B,
    ht[0],
    H,
    t.breakBy
  ) : UA(r, lt, B, ht, t.y);
  return oe(Ut({}, ut), {
    xAxisCount: f,
    type: "cartesian"
  });
}, WA = (t) => {
  switch (t) {
    case "sortNone":
      return 0;
    case "sortDesc":
      return -1;
    case "sortAsc":
    default:
      return 1;
  }
}, HA = (t, r, f, B) => {
  if (f.length === 0)
    return [{ key: "", xValues: [""], rawValues: [] }];
  const H = r.map(({ column: { name: gt } }) => ({
    column: gt,
    agg: "sum",
    // any ranking or ordering is by sum
    title: gt
  }));
  if (B) {
    const gt = {
      column: B,
      title: B,
      agg: "min"
    };
    H.push(gt);
  }
  const tt = ST(t, f, H), st = [];
  let lt = 0;
  if (f.length === 2) {
    lt = 1;
    const _ = Bo(tt, f[0].name);
    _ && st.push(_);
  }
  if (r.map((gt) => {
    const _ = Bo(tt, gt.column.name);
    return _ && st.push(oe(Ut({}, _), {
      direction: gt.sortType === "sortAsc" ? 1 : -1
    })), gt;
  }), B) {
    const gt = Bo(tt, B);
    gt && st.push(gt);
  }
  if (f.length > 0) {
    const gt = Bo(tt, f[lt].name);
    gt && st.push(gt);
  }
  const ht = xT(tt, st), ut = bh(
    ht,
    f.map((gt) => gt.name)
  ), yt = wT(ht, ut);
  return yt.rows.map((gt) => {
    const _ = jl(gt, yt.columns), at = _.map((Y) => Y.displayValue), G = _.map((Y) => {
      var J;
      return (J = Y.rawValue) != null ? J : Y.displayValue;
    }), F = _.map((Y) => {
      var J;
      return (J = Y == null ? void 0 : Y.compareValue) == null ? void 0 : J.value;
    });
    return { key: G.join(","), xValues: at, rawValues: G, compareValues: F };
  });
}, Ny = (t, r, f) => {
  var st, lt;
  const B = f ? CT(t, f) : 1e-5, { color: H, rawValue: tt } = (lt = t[(st = f == null ? void 0 : f.index) != null ? st : 0]) != null ? lt : {};
  return Ut({
    rawValue: tt,
    xValue: r.rawValues,
    xDisplayValue: r.xValues,
    xCompareValue: r.compareValues,
    value: B === void 0 ? NaN : B,
    blur: f ? kT(t, f) : void 0
  }, H && { color: H });
}, UA = (t, r, f, B, H) => {
  const tt = B.length > 0 ? bh(t, B) : [void 0], st = H.reduce((ut, yt) => (ut[yt.column.name] = yt, ut), {}), lt = Jm(t.rows, f), ht = tt.map((ut) => {
    var G, F;
    let yt = r.map(($) => {
      const Y = lt[$.key], J = Y ? Y[0] : [];
      return Ny(J, $, ut);
    });
    const gt = (G = ut == null ? void 0 : ut.name) != null ? G : "", _ = gt ? Li(st[gt]) : "", at = (F = st[gt]) == null ? void 0 : F.color;
    return at && (yt = BA(yt, at)), {
      name: gt,
      title: _,
      data: yt
    };
  });
  return { xValues: r, series: ht };
}, GA = (t, r, f) => jl(t, r).map((B, H) => {
  const tt = li(f[H].numberFormatConfig);
  return Fi(r[H].type) ? Hi(tt, parseFloat(B.displayValue)) : B.displayValue;
}).join(","), XA = (t, r) => jl(t, r).map(({ rawValue: f }) => f), YA = (t, r, f, B, H, tt) => {
  const st = Bo(t, B), ut = cp(t.rows, H).map((yt) => {
    const gt = yt[0];
    return {
      seriesName: GA(
        // all rows contain same series name
        gt,
        H,
        tt
      ),
      seriesValues: XA(gt, H),
      rowsByXColumns: Jm(yt, f)
    };
  }).map((yt) => {
    const gt = r.map((_) => {
      const at = yt.rowsByXColumns[_.key], G = at ? at[0] : [];
      return Ny(G, _, st);
    });
    return {
      name: yt.seriesName,
      data: gt,
      custom: { rawValue: yt.seriesValues }
    };
  });
  return { xValues: r, series: ut };
}, VA = { displayValue: "0" }, fl = (t, r) => {
  if (r) {
    for (let f = 0; f < t.columns.length; f++)
      if (t.columns[f].name === r.column.name)
        return f;
  }
  return -1;
}, $A = (t, r) => ({
  x: fl(r, t.x),
  y: fl(r, t.y),
  breakByPoint: fl(r, t.breakByPoint),
  breakByColor: fl(r, t.breakByColor),
  size: fl(r, t.size)
}), ug = (t, r) => r[t] || VA, ZA = (t, r) => {
  const f = /* @__PURE__ */ new Set();
  return t.forEach((B) => {
    f.add(B[r].displayValue);
  }), Array.from(f.values());
}, dg = (t, r, f) => {
  if (f && !vn(f))
    return ZA(t, r);
}, pg = (t, r) => [t, r], KA = (t, r) => {
  const f = new Map(t == null ? void 0 : t.map(pg)), B = new Map(r == null ? void 0 : r.map(pg));
  return {
    xCategoriesMap: f,
    yCategoriesMap: B
  };
}, qA = (t, r) => {
  var tt, st;
  const f = $A(t, r), B = t != null && t.breakByPoint && Fi(t.breakByPoint.column.type) ? li((tt = t.breakByPoint) == null ? void 0 : tt.numberFormatConfig) : void 0, H = t != null && t.breakByColor && (vn(t.breakByColor) || Fi(t.breakByColor.column.type)) ? li((st = t.breakByColor) == null ? void 0 : st.numberFormatConfig) : void 0;
  return r.rows.map((lt) => {
    const ht = Ut({}, lt[f.breakByPoint]);
    B && (ht.displayValue = Hi(
      B,
      ht.compareValue ? ht.compareValue.value : parseFloat(ht.displayValue)
    ));
    const ut = Ut({}, lt[f.breakByColor]);
    return H && (ut.displayValue = Hi(
      H,
      ut.compareValue ? ut.compareValue.value : parseFloat(ut.displayValue)
    )), {
      xAxis: ug(f.x, lt),
      yAxis: ug(f.y, lt),
      breakByPoint: ht,
      breakByColor: ut,
      size: lt[f.size]
    };
  });
}, yO = (t, r) => {
  const f = qA(t, r), { x: B, y: H } = t, tt = dg(f, "xAxis", B), st = dg(f, "yAxis", H);
  return {
    type: "scatter",
    scatterDataTable: f,
    xCategories: tt,
    yCategories: st
  };
}, en = (t, r) => {
  var B;
  const f = t == null ? void 0 : t.filter((H) => H);
  return (B = f && f[r % f.length]) != null ? B : XT[r % 10];
};
var JA = function(r) {
  return QA(r) && !tP(r);
};
function QA(t) {
  return !!t && typeof t == "object";
}
function tP(t) {
  var r = Object.prototype.toString.call(t);
  return r === "[object RegExp]" || r === "[object Date]" || rP(t);
}
var eP = typeof Symbol == "function" && Symbol.for, iP = eP ? Symbol.for("react.element") : 60103;
function rP(t) {
  return t.$$typeof === iP;
}
function nP(t) {
  return Array.isArray(t) ? [] : {};
}
function Ol(t, r) {
  return r.clone !== !1 && r.isMergeableObject(t) ? na(nP(t), t, r) : t;
}
function oP(t, r, f) {
  return t.concat(r).map(function(B) {
    return Ol(B, f);
  });
}
function sP(t, r) {
  if (!r.customMerge)
    return na;
  var f = r.customMerge(t);
  return typeof f == "function" ? f : na;
}
function aP(t) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function(r) {
    return Object.propertyIsEnumerable.call(t, r);
  }) : [];
}
function fg(t) {
  return Object.keys(t).concat(aP(t));
}
function zy(t, r) {
  try {
    return r in t;
  } catch (f) {
    return !1;
  }
}
function lP(t, r) {
  return zy(t, r) && !(Object.hasOwnProperty.call(t, r) && Object.propertyIsEnumerable.call(t, r));
}
function cP(t, r, f) {
  var B = {};
  return f.isMergeableObject(t) && fg(t).forEach(function(H) {
    B[H] = Ol(t[H], f);
  }), fg(r).forEach(function(H) {
    lP(t, H) || (zy(t, H) && f.isMergeableObject(r[H]) ? B[H] = sP(H, f)(t[H], r[H], f) : B[H] = Ol(r[H], f));
  }), B;
}
function na(t, r, f) {
  f = f || {}, f.arrayMerge = f.arrayMerge || oP, f.isMergeableObject = f.isMergeableObject || JA, f.cloneUnlessOtherwiseSpecified = Ol;
  var B = Array.isArray(r), H = Array.isArray(t), tt = B === H;
  return tt ? B ? f.arrayMerge(t, r, f) : cP(t, r, f) : Ol(r, f);
}
na.all = function(r, f) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(B, H) {
    return na(B, H, f);
  }, {});
};
var hP = na, uP = hP;
const Lr = /* @__PURE__ */ Hg(uP), dP = {
  cursor: "default",
  fontFamily: "Open Sans",
  fontSize: "13px",
  fontWeight: "normal",
  color: "#5b6372",
  textOutline: "none",
  pointerEvents: "auto"
}, Wo = (t) => {
  const r = {
    symbolRadius: 0,
    backgroundColor: "transparent",
    borderColor: "transparent",
    borderWidth: 0,
    itemStyle: dP
  };
  if (!t)
    return {
      enabled: !1,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal"
    };
  switch (t) {
    case "bottom":
      return Ut({
        enabled: !0,
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal"
      }, r);
    case "left":
      return Ut({
        enabled: !0,
        align: "left",
        verticalAlign: "middle",
        layout: "vertical"
      }, r);
    case "right":
      return Ut({
        enabled: !0,
        align: "right",
        verticalAlign: "middle",
        layout: "vertical"
      }, r);
    case "top":
      return Ut({
        enabled: !0,
        align: "center",
        verticalAlign: "top",
        layout: "horizontal"
      }, r);
    default:
      return Ut({
        enabled: !0,
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal"
      }, r);
  }
}, Oi = "#d1d1d7", Fy = 25, Wy = [-10, -20, -30, -40, -50, -60, -70, -80, -90], ki = {
  fontFamily: "Open Sans",
  fontSize: "13px",
  fontWeight: "normal",
  color: "#5b6372",
  textOutline: "none",
  pointerEvents: "none"
}, pP = {
  color: "#56535b",
  fontFamily: "Open Sans",
  fontSize: "13px",
  textOverflow: "ellipsis",
  pointerEvents: "none",
  textOutline: "none",
  fontWeight: "bold"
}, Cd = {
  labels: {
    overflow: "none",
    enabled: !0,
    autoRotation: Wy,
    style: ki
  },
  tickmarkPlacement: "on",
  title: {
    text: "",
    enabled: !1,
    margin: Fy,
    style: ki
  },
  gridLineDashStyle: "Dot",
  minorGridLineWidth: 0,
  startOnTick: !1,
  endOnTick: !1,
  lineColor: Oi,
  lineWidth: 1,
  tickColor: Oi,
  minorTickColor: Oi,
  gridLineColor: Oi,
  minorGridLineColor: Oi
}, gg = {
  labels: {
    autoRotation: Wy,
    style: ki
  },
  tickmarkPlacement: "on",
  startOnTick: !0,
  endOnTick: !0,
  title: {
    text: "",
    margin: Fy,
    enabled: !1,
    style: ki
  },
  gridLineWidth: 1,
  minorTickWidth: 0,
  tickWidth: 0,
  minorGridLineWidth: 0,
  gridLineDashStyle: "Dot",
  lineColor: Oi,
  lineWidth: 1,
  tickColor: Oi,
  minorTickColor: Oi,
  gridLineColor: Oi,
  minorGridLineColor: Oi,
  minorGridLineDashStyle: "Dot",
  stackLabels: {
    style: pP,
    crop: !0,
    allowOverlap: !1,
    enabled: !1,
    rotation: 0,
    labelrank: 99999
  },
  showLastLabel: !0
}, fP = (t, r, f) => {
  switch (t) {
    case "line":
      return Io;
    case "area":
      return Lr(Io, mg(f));
    case "bar":
      return Lr(Io, mP(f));
    case "column":
      return Lr(Io, gP(f));
    case "polar":
      return Lr(
        Io,
        yP(r)
      );
    case "arearange":
      return Lr(Io, mg(f));
    default:
      return Io;
  }
}, Io = {
  chart: {
    type: "line",
    spacing: [],
    alignTicks: !1,
    polar: !1
  },
  legend: Wo(null),
  credits: {
    enabled: !1
  },
  exporting: {
    enabled: !0
  },
  plotOptions: {
    area: {
      className: "area-series--without-pointer-events",
      states: {
        inactive: {
          enabled: !0,
          opacity: 0.3
        }
      }
    },
    series: {
      dataLabels: {
        enabled: !1,
        crop: !1,
        style: oe(Ut({}, ki), {
          textOutline: "none"
        })
      },
      stickyTracking: !1,
      states: {
        select: {
          color: null,
          // Explicitly set to null in order to inherit from series color
          opacity: 0.3,
          borderColor: "transparent"
        }
      }
    }
  },
  xAxis: [],
  yAxis: [],
  series: [],
  boost: {
    useGPUTranslations: !0,
    usePreAllocated: !0
  }
}, mg = (t) => ({
  plotOptions: {
    area: Ut({}, t && {
      lineColor: "#ffffff"
    }),
    series: Ut({}, t && {
      stacking: t
    })
  }
}), gP = (t) => ({
  plotOptions: {
    column: Ut({
      groupPadding: 0.1,
      pointPadding: 0.01
    }, t && { borderWidth: 0 }),
    series: Ut({}, t && { stacking: t })
  }
}), mP = (t) => ({
  plotOptions: {
    bar: Ut({
      groupPadding: 0.1,
      pointPadding: 0.01
    }, t && { borderWidth: 0 }),
    series: Ut({}, t && { stacking: t })
  }
});
function yP(t) {
  return {
    plotOptions: {
      series: oe(Ut({}, t !== "line" && { stacking: "normal" }), {
        fillOpacity: 1
      })
    }
  };
}
const Hy = (t) => t.compareValues ? t.compareValues[0] : NaN, vP = (t) => {
  switch (t) {
    case de.Years:
      return 31536e6;
    case de.Quarters:
      return 7884e6;
    case de.Months:
      return 2592e6;
    case de.Weeks:
      return 6048e5;
    case de.Days:
      return 864e5;
    case de.AggHours:
    case de.Hours:
      return 36e5;
    case de.AggMinutesRoundTo30:
    case de.MinutesRoundTo30:
      return 18e5;
    case de.AggMinutesRoundTo15:
    case de.MinutesRoundTo15:
      return 9e5;
    case de.AggMinutesRoundTo1:
      return 6e4;
  }
  return console.warn("Unsupported level"), 0;
}, Uy = (t) => {
  if (t !== void 0) {
    switch (t) {
      case de.Years:
        return "yyyy";
      case de.Quarters:
        return "yyyy Q";
      case de.Months:
        return "MM/yyyy";
      case de.Weeks:
        return "ww yyyy";
      case de.Days:
        return "M/d/yy";
      case de.AggHours:
        return "HH";
      case de.Hours:
        return "M/d/yy HH";
      case de.AggMinutesRoundTo30:
        return "HH:mm";
      case de.MinutesRoundTo30:
        return "HH:mm";
      case de.AggMinutesRoundTo15:
        return "HH:mm";
      case de.MinutesRoundTo15:
        return "HH:mm";
      case de.AggMinutesRoundTo1:
        return "HH:mm";
      case de.Minutes:
        return "HH:mm";
      case de.Seconds:
        return "HH:mm:ss";
    }
    return console.warn("Unsupported level"), "M/d/yy HH";
  }
}, bP = (t, r) => {
  const f = _y(t), B = (t == null ? void 0 : t.dateFormat) || Uy(f);
  return !r || !B ? (H) => `${H}` : function(H) {
    return r(new Date(H), B);
  };
}, xP = (t, r, f, B) => {
  const H = _y(r), tt = (_, at) => _.lastValue ? { minInterval: Math.min(at - _.lastValue, _.minInterval), lastValue: at } : oe(Ut({}, _), { lastValue: at }), st = f[0], lt = f[f.length - 1];
  let ht = H ? vP(H) : f.reduce(tt, {
    minInterval: (lt - st) / (f.length - 1),
    lastValue: void 0
  }).minInterval;
  if (ht < 30 * 864e5 && ht > 25 * 864e5 && (ht = 2592e6), f.length > 1 && (isNaN(ht) || ht === 0))
    throw new Jn("errors.ticIntervalCalculationFailed");
  let ut;
  const yt = (r == null ? void 0 : r.dateFormat) || Uy(H);
  B && yt && (ut = function() {
    const _ = this;
    return B(new Date(_.value), yt);
  });
  const gt = {
    millisecond: "%A, %b %e, %H:%M:%S.%L",
    second: "%A, %b %e, %H:%M:%S",
    minute: "%A, %b %e, %H:%M",
    hour: "%A, %b %e, %H:%M",
    day: "%A, %b %e, %Y",
    week: "Week from %A, %b %e, %Y",
    month: "%B %Y",
    year: "%Y"
  };
  return [
    Lr(Cd, {
      type: "datetime",
      title: {
        enabled: t.enabled && t.titleEnabled,
        text: t.title
      },
      dateTimeLabelFormats: gt,
      gridLineDashStyle: "Dot",
      gridLineWidth: t.enabled && t.gridLine ? 1 : 0,
      // 0 to disable the grid line
      gridLineColor: Oi,
      tickWidth: 0,
      lineColor: Oi,
      lineWidth: 1,
      labels: oe(Ut({}, ut && { formatter: ut }), {
        overflow: "none",
        enabled: t.enabled && t.labels,
        autoRotation: [-10, -20, -30, -40, -50, -60, -70, -80, -90],
        style: ki
      }),
      min: st,
      max: lt,
      tickInterval: ht,
      minTickInterval: ht,
      tickmarkPlacement: "on",
      startOnTick: !0,
      endOnTick: !0,
      startOfWeek: 4,
      showFirstLabel: !0,
      showLastLabel: !0,
      minRange: ht,
      isDate: !0
    })
  ];
}, SP = (t, r, f, B, H, tt, st) => {
  const lt = (B || []).map((at) => ({
    isPlotBand: !0,
    from: at.from,
    to: at.to,
    label: Ut({
      text: at.text,
      y: -5,
      style: oe(Ut({}, ki), {
        width: "70px",
        textOverflow: "ellipsis"
      })
    }, H === "vertical" && {
      align: "right",
      x: 5,
      textAlign: "left",
      y: 0
    })
  })), ht = (B || []).filter((at) => at.from > 0).map((at) => ({
    color: "#C0D0E0",
    dashStyle: "shortDot",
    width: 1,
    value: at.from
  })), ut = tt, yt = ut.x[ut.x.length - 1], gt = Km(st);
  let _ = [
    Lr(Cd, {
      type: t.type,
      title: Ut({
        enabled: t.enabled && t.titleEnabled,
        text: t.title
      }, gt && {
        textAlign: "center",
        align: "high",
        y: -25
      }),
      gridLineDashStyle: "Dot",
      gridLineWidth: t.enabled && t.gridLine ? 1 : 0,
      // 0 to disable the grid line
      gridLineColor: Oi,
      tickWidth: 0,
      lineColor: Oi,
      lineWidth: 1,
      labels: oe(Ut({
        enabled: t.enabled && t.labels,
        style: ki
      }, gt && { rotation: 0 }), {
        formatter: function() {
          const at = this;
          return !yt || !Fi(yt == null ? void 0 : yt.column.type) || isNaN(parseFloat(at.value)) ? at.value : Hi(
            li(yt == null ? void 0 : yt.numberFormatConfig),
            parseFloat(at.value)
          );
        }
      }),
      min: t.min,
      max: t.max,
      tickInterval: t.tickInterval,
      categories: f,
      plotBands: lt,
      plotLines: ht,
      tickmarkPlacement: "on"
    })
  ];
  return r && (_ = _.concat(
    Lr(Cd, {
      title: {
        enabled: r.enabled && r.titleEnabled,
        text: r.title
      },
      categories: f,
      opposite: !0,
      gridLineWidth: 0,
      tickWidth: 0,
      lineWidth: 0
    })
  )), _;
}, wP = (t, r, f, B, H, tt, st) => {
  var at, G, F, $;
  const lt = tt, ht = li(
    (at = lt.y.find(({ showOnRightAxis: Y }) => !Y)) == null ? void 0 : at.numberFormatConfig
  ), ut = li(
    (G = lt.y.find(({ showOnRightAxis: Y }) => Y)) == null ? void 0 : G.numberFormatConfig
  ), yt = [
    { minClipped: !!(t.enabled && t.min), maxClipped: !!(t.enabled && t.max) }
  ];
  function gt(Y, J) {
    return function() {
      const Q = Hi(Y, this.value);
      return J === "percent" ? `${Q}%` : Q;
    };
  }
  const _ = [
    Lr(gg, oe(Ut(Ut({
      type: t.type,
      title: { enabled: t.enabled && t.titleEnabled, text: t.title },
      gridLineDashStyle: "Dot",
      gridLineWidth: t.enabled && t.gridLine ? 1 : 0,
      // 0 to disable the grid line
      gridLineColor: Oi,
      tickWidth: 0,
      lineColor: Oi,
      lineWidth: 1,
      labels: {
        enabled: t.enabled && t.labels,
        style: ki,
        formatter: gt(ht, st)
      },
      startOnTick: !(t.enabled && t.min)
    }, t.min && { minPadding: 0 }), t.max && { maxPadding: 0 }), {
      min: t.enabled ? (F = t.min) != null ? F : f.min : null,
      max: t.enabled ? ($ = t.max) != null ? $ : f.max : null,
      tickInterval: t.enabled ? t.tickInterval : null,
      stackLabels: { enabled: H }
    }))
  ];
  if (B) {
    yt.push({
      minClipped: !!(r != null && r.enabled && r.min),
      maxClipped: !!(r != null && r.enabled && r.max)
    });
    const Y = {
      startOnTick: !(r != null && r.enabled && r.min),
      min: r != null && r.enabled ? r.min || B.min : null,
      max: r != null && r.enabled ? r.max || B.max : null
    }, J = r != null && r.enabled ? {
      opposite: !0,
      gridLineWidth: 0,
      title: {
        enabled: r.enabled && r.titleEnabled,
        text: r.title
      },
      labels: {
        enabled: r.enabled && r.labels,
        style: ki,
        formatter: gt(ut, st)
      },
      tickInterval: r.enabled ? r.tickInterval : null,
      stackLabels: { enabled: H }
    } : { visible: !1 };
    _.push(
      Lr(gg, Ut(Ut({}, Y), J))
    );
  }
  return [_, yt];
}, CP = (t, r) => {
  const f = () => oe(Ut({}, t), {
    y: []
  }), B = f(), H = f(), tt = 1, st = 0;
  t.seriesValues.forEach((ut) => {
    B.y.push(ut), H.y.push(ut);
  }), t.rangeValues.forEach((ut) => {
    const yt = ut[tt], gt = ut[st];
    B.y.push(yt), H.y.push(gt);
  });
  const lt = hg(B, r), ht = hg(H, r);
  return oe(Ut({}, lt), {
    type: "range",
    seriesOther: ht
  });
}, Vh = "$forecast", fp = "$trend", Qs = (t) => t.startsWith(Vh), Gy = (t) => t.startsWith(fp), Ph = (t) => `${t} $range`, kP = (t, r, f) => {
  const B = f[Ph(t.name)], H = r[Ph(t.name)], tt = t.name.substring(Vh.length + 1), st = r[tt], lt = t.data.findIndex((ht) => !isNaN((ht == null ? void 0 : ht.y) || NaN));
  return t.type = "line", t.showInLegend = !1, t.data[lt - 1].y = st.data[lt - 1].y, t.dashStyle = "ShortDash", t.color = st.color, t.data.forEach((ht, ut) => {
    ht.high = B.data[ut].y, ht.low = H.data[ut].y;
  }), lt;
}, TP = (t, r) => {
  t.showInLegend = !1, t.enableMouseTracking = !1;
  const f = t.name.substring(Vh.length + 1, t.name.length - 7), B = r[f];
  t.color = B.color, t.fillOpacity = 0.15, t.lineWidth = 0;
}, MP = (t, r) => {
  const f = t.name.substring(10, t.name.length - 7), B = r[f], H = t.data.findIndex((tt) => !isNaN((tt == null ? void 0 : tt.low) || NaN));
  t.data[H - 1].low = B.data[H - 1].y, t.data[H - 1].high = B.data[H - 1].y;
}, AP = (t, r, f) => {
  t.forEach(
    (B) => B.plotBands = [
      {
        color: "#F7F7FA",
        borderWidth: 0,
        from: r - 1,
        to: f
      }
    ]
  );
}, PP = (t, r) => {
  t.type = "line";
  const f = t.name.substring(fp.length + 1), B = r[f];
  t.showInLegend = !1, t.dashStyle = "ShortDot", t.color = B.color;
  let H = 0, tt = Number.MAX_VALUE;
  const st = B.data.filter((G) => G.y).map((G) => (H = Math.max(H, G.y || 0), tt = Math.min(tt, G.y || 0), G.y)), lt = tt, ht = H, ut = st.reduce((G, F) => G + F, 0) / st.length, yt = [...st].sort((G, F) => G - F), gt = Math.floor(yt.length / 2), _ = yt.length % 2 !== 0 ? yt[gt] : (yt[gt - 1] + yt[gt]) / 2, at = {
    min: lt,
    max: ht,
    median: _,
    average: ut
  };
  t.data.forEach((G) => {
    G.trend = at;
  });
}, EP = (t) => {
  const r = {};
  t.forEach((f) => {
    r[f.name] = f;
  }), t.forEach((f) => {
    Gy(f.name) && PP(f, r);
  });
}, Xy = (t) => {
  const { breakBy: r } = t;
  if (r.length > 0)
    return !1;
  const f = t.category.filter((tt) => !("enabled" in tt) || tt.enabled);
  if (f.length !== 1)
    return !1;
  const [B] = f;
  let H = !1;
  return By(B) ? H = B.column.type === "datelevel" : NA(B) && (H = B.type === "datelevel"), H;
}, vO = (t) => Xy(t) ? t.value.filter(
  (r) => (r == null ? void 0 : r.trend) !== void 0
).map(
  (r) => nk(
    r.column,
    `${fp}_${r.column.name}`,
    r.trend
  )
) : [], bO = (t) => Xy(t) ? t.value.filter(
  (r) => (r == null ? void 0 : r.forecast) !== void 0
).map(
  (r) => ok(
    r.column,
    `${Vh}_${r.column.name}`,
    r.forecast
  )
) : [], LP = (t) => t.rangeValues ? !1 : t.y.some((f) => Qs(Li(f))), Yy = (t) => {
  const r = t.y.filter((tt) => Qs(Li(tt))).map((tt) => {
    const st = oe(Ut({}, tt), {
      column: wd(tt.column, {
        title: tt.column.title && Ph(tt.column.title),
        name: `${tt.column.name}_upper`
      })
    });
    return [oe(Ut({}, tt), {
      column: wd(tt.column, {
        title: tt.column.title && Ph(tt.column.title),
        name: `${tt.column.name}_lower`
      })
    }), st];
  }), B = r.concat(t.y).flat(), H = t.y;
  return oe(Ut({}, t), {
    rangeValues: r,
    seriesValues: H,
    y: B
  });
}, xO = (t, r) => {
  const f = Yy(t);
  return oe(Ut({}, CP(f, r)), {
    type: "cartesian"
  });
};
function OP(t, r) {
  return Hm(Wm(t, r, qd), t + "");
}
var DP = "[object Number]";
function yg(t) {
  return typeof t == "number" || Jr(t) && Uo(t) == DP;
}
var IP = /* @__PURE__ */ ((t) => (t.FILTER = "filter", t.SELECT = "select", t))(IP || {});
function SO(t) {
  return !!t && t.min !== null && t.max !== null;
}
var RP = /* @__PURE__ */ ((t) => (t.PRE = "pre", t.POST = "post", t))(RP || {}), ah = /* @__PURE__ */ ((t) => (t.WIDGET_FIRST = "widgetFirst", t.CODE_FIRST = "codeFirst", t.CODE_ONLY = "codeOnly", t))(ah || {});
function jP(t) {
  return lp(function(r) {
    return r = Zd(r, Rh(um)), OP(function(f) {
      var B = this;
      return t(r, function(H) {
        return Fm(H, B, f);
      });
    });
  });
}
var _P = jP(Zd);
function $h(t, r = !1) {
  const f = t.filter((B) => Bd(B));
  return r ? eT(f) : _P(f);
}
const Vy = {
  "chart/line": "line",
  "chart/area": "area",
  "chart/bar": "bar",
  "chart/column": "column",
  "chart/polar": "polar",
  "chart/pie": "pie",
  "chart/funnel": "funnel",
  treemap: "treemap",
  sunburst: "sunburst",
  "chart/scatter": "scatter",
  indicator: "indicator",
  "chart/boxplot": "boxplot",
  "map/scatter": "scattermap",
  "map/area": "areamap",
  tablewidget: "table",
  tablewidgetagg: "table"
};
function wO(t) {
  return Vy[t];
}
function CO(t) {
  return Object.entries(Vy).reduce(
    (f, [B, H]) => (f[H] = B, f),
    {}
  )[t];
}
function kO(t) {
  return {
    "area/basic": "area/basic",
    "area/stacked": "area/stacked",
    "area/stacked100": "area/stacked100",
    "area/spline": "area/spline",
    "area/stackedspline": "area/stackedspline",
    "area/stackedspline100": "area/stackedspline100",
    "bar/classic": "bar/classic",
    "bar/stacked": "bar/stacked",
    "bar/stacked100": "bar/stacked100",
    "column/classic": "column/classic",
    "column/stackedcolumn": "column/stackedcolumn",
    "column/stackedcolumn100": "column/stackedcolumn100",
    "line/basic": "line/basic",
    "line/spline": "line/spline",
    "pie/classic": "pie/classic",
    "pie/donut": "pie/donut",
    "pie/ring": "pie/ring",
    "column/polar": "polar/column",
    "area/polar": "polar/area",
    "line/polar": "polar/line",
    "indicator/numeric": "indicator/numeric",
    "indicator/gauge": "indicator/gauge",
    treemap: "treemap",
    sunburst: "sunburst",
    "boxplot/full": "boxplot/full",
    "boxplot/hollow": "boxplot/hollow",
    "map/scatter": "scattermap"
  }[t];
}
function TO(t) {
  return [
    "chart/line",
    "chart/area",
    "chart/bar",
    "chart/column",
    "chart/polar",
    "chart/pie",
    "chart/funnel",
    "treemap",
    "sunburst",
    "chart/scatter",
    "indicator",
    "tablewidget",
    "tablewidgetagg",
    "pivot",
    "pivot2",
    "chart/boxplot",
    "map/scatter",
    "map/area",
    "richtexteditor"
  ].includes(t);
}
function MO(t) {
  return t === "tablewidget" || t === "tablewidgetagg";
}
function BP(t) {
  return t === "pivot" || t === "pivot2";
}
function NP(t) {
  return t === "richtexteditor";
}
function AO(t) {
  return t === "plugin";
}
function PO(t) {
  return !BP(t) && !NP(t);
}
function zP(t) {
  return t.widgetType === "text";
}
function FP(t) {
  return t.widgetType === "pivot";
}
function WP(t) {
  return t.widgetType === "plugin";
}
function gp(t) {
  return t.widgetType === "chart";
}
function EO(t) {
  return FP(t) ? "pivot" : WP(t) ? "plugin" : zP(t) ? "text" : t.chartType;
}
function LO(t, r) {
  gp(t) && (t.onDataPointClick = $h([t.onDataPointClick, r]));
}
function OO(t, r) {
  gp(t) && (t.onDataPointContextMenu = $h([
    t.onDataPointContextMenu,
    r
  ]));
}
function DO(t, r) {
  gp(t) && (t.onDataPointsSelected = $h([t.onDataPointsSelected, r]));
}
function IO(t, r) {
  var B;
  const f = t.styleOptions;
  t.styleOptions = oe(Ut({}, f), {
    header: oe(Ut({}, f == null ? void 0 : f.header), {
      renderToolbar: $h([(B = f == null ? void 0 : f.header) == null ? void 0 : B.renderToolbar, r])
    })
  });
}
function RO(t, r) {
  var H;
  const f = t.find((tt) => tt.name === r);
  return ((H = f == null ? void 0 : f.items) != null ? H : []).filter((tt) => !tt.disabled);
}
function HP(t) {
  return t.parent ? HP(t.parent) : t;
}
function UP(t) {
  switch (t) {
    case vl.ASC:
      return "sortAsc";
    case vl.DESC:
      return "sortDesc";
    default:
      return "sortNone";
  }
}
function kd(t) {
  if (Ow(t))
    return t.filters.map(kd).join("-");
  const { attribute: r } = t, f = t.jaql().jaql, B = r.expression || f.dim, H = r.granularity || ((f == null ? void 0 : f.datatype) === "datetime" ? Rr.translateJaqlToGranularity(f) : "");
  return `${B}${H}`;
}
function qu(t = [], r = []) {
  const f = [...t];
  return r.forEach((B) => {
    const H = f.findIndex(
      (st) => kd(B) === kd(st)
    );
    H !== -1 ? f[H] = B : f.push(B);
  }), f;
}
function jO(t = [], r = [], f) {
  switch (f) {
    case ah.WIDGET_FIRST:
      return qu(r, t);
    case ah.CODE_FIRST:
      return qu(t, r);
    case ah.CODE_ONLY:
      return r;
    default:
      return qu(t, r);
  }
}
function _O(t, r, f) {
  if (!f || r.length)
    return t;
  const B = Fh(f);
  function H(tt) {
    if ("instanceid" in tt) {
      const st = t.find((lt) => lt.guid === tt.instanceid);
      if (!st)
        throw new Jn("errors.unknownFilterInFilterRelations");
      return st;
    }
    if ("operator" in tt) {
      const st = { operator: tt.operator };
      return "left" in tt && (st.left = H(tt.left)), "right" in tt && (st.right = H(tt.right)), st;
    }
    return tt;
  }
  return H(B);
}
function BO(t) {
  if (!t)
    return t;
  const r = Fh(t);
  function f(B) {
    if ("instanceId" in B)
      return { instanceid: B.instanceId };
    if ("value" in B)
      return f(B.value);
    if ("operator" in B) {
      const H = { operator: B.operator };
      return "left" in B && (H.left = f(B.left)), "right" in B && (H.right = f(B.right)), H;
    }
    return B;
  }
  return f(r);
}
const GP = (t) => t ? vn(t) || t.column.type && Fi(t.column.type) : !1, vi = (t, r, f) => {
  if (!t || r === void 0 || isNaN(r))
    return f;
  const B = li(t.numberFormatConfig);
  return ra(B, r);
}, Dl = (t, r, f) => GP(t) ? vi(t, parseFloat(`${r}`), f) : f, XP = [
  "auto",
  "column",
  "area",
  "areaspline",
  "bar",
  "scatter",
  "arearange"
];
function $y(t) {
  return t != null && t.chartType ? XP.includes(t.chartType) : !0;
}
const Ei = (t, r) => t !== "" ? `<span style="color:${r != null ? r : "currentColor"}; font-size: 15px; line-height: 18px">${t}</span>` : "", gl = (t, r) => `${r || ""}${r && t ? "<br />" : ""}${t || ""}`, oa = (t) => `<div style="minWidth: 100px; color: #5B6372; fontSize: 13px; lineHeight: 18px; margin: 4px 6px">
    ${t}
  </div>`, qn = () => '<hr class="csdk-border-t" style="margin: 7px 0px" />', YP = (t) => {
  const r = t.map((f, B) => f && B > 0 ? qn() + f : f).join("");
  return oa(r);
}, VP = (t, r) => {
  const { maskedX: f, maskedY: B, maskedBreakByPoint: H, maskedSize: tt, maskedBreakByColor: st } = t.point.custom, lt = Dl(r.x, t.point.x, f), ht = vi(r.y, t.point.y, B), ut = vi(r.size, t.point.z, tt || ""), yt = Ei(lt, t.point.color), gt = Ei(ht, t.point.color), _ = Ei(H || "", t.point.color), at = Ei(st || "", t.point.color), G = Ei(ut, t.point.color);
  return {
    x: yt,
    y: gt,
    breakByPoint: _,
    breakByColor: at,
    size: G
  };
}, $P = (t, r) => {
  const f = gl(t.x, r.x && Li(r.x)), B = gl(t.y, r.y && Li(r.y)), H = gl(
    t.breakByPoint,
    r.breakByPoint && Li(r.breakByPoint)
  ), tt = gl(
    t.breakByColor,
    r.breakByColor && Li(r.breakByColor)
  ), st = gl(t.size, r.size && Li(r.size));
  return {
    x: f,
    y: B,
    breakByPoint: H,
    breakByColor: tt,
    size: st
  };
}, ZP = (t, r) => {
  const f = VP(t, r), { x: B, y: H, breakByPoint: tt, breakByColor: st, size: lt } = $P(f, r);
  return YP([B, H, tt, st, lt]);
}, KP = (t) => ({
  enabled: !0,
  useHTML: !0,
  formatter() {
    return ZP(this, t);
  }
}), Td = {
  enabled: !0,
  types: {
    count: !1,
    relative: !0,
    totals: !0
  }
}, qP = (t) => function() {
  return this.y === void 0 || isNaN(this.y) ? "" : Hi(li(t), this.y);
}, mp = (t) => {
  const r = Math.abs(t) % 180;
  return r < 20 ? "horizontal" : r < 60 ? "diagonal" : r < 120 ? "vertical" : r < 160 ? "diagonal" : "horizontal";
}, JP = (t, r, f) => {
  var tt;
  if (!r.enabled)
    return { enabled: !1 };
  const B = oe(Ut({}, Td), {
    align: "center",
    verticalAlign: "middle",
    rotation: (tt = r.rotation) != null ? tt : 0
  });
  if (f)
    return B;
  const H = mp(B.rotation);
  if (t === "vertical")
    return oe(Ut({}, B), {
      align: H === "horizontal" ? "left" : "center"
    });
  switch (H) {
    case "horizontal":
      return oe(Ut({}, B), {
        verticalAlign: "bottom",
        padding: 5
      });
    case "diagonal":
      return oe(Ut({}, B), {
        align: "left",
        y: -10,
        x: -2
      });
    case "vertical":
      return oe(Ut({}, B), {
        align: "left",
        y: -10
      });
  }
}, QP = (t, r) => {
  var H, tt;
  if (!t)
    return { enabled: !1 };
  const f = (H = t.rotation) != null ? H : 0, B = (tt = t.enabled) != null ? tt : Td.enabled;
  return oe(Ut({}, Td), {
    verticalAlign: r === "line" ? "bottom" : "middle",
    rotation: f,
    enabled: B,
    align: mp(f) === "vertical" ? "left" : "center",
    padding: 5
  });
}, vg = (t) => oe(Ut({
  enabled: t.enabled,
  radius: !t.enabled || t.size === "small" ? 4 : 7,
  fillColor: !t.enabled || t.fill === "full" ? null : eo,
  lineColor: null,
  lineWidth: 2,
  symbol: "circle",
  fillOpacity: 0.3
}, !t.enabled && { symbol: "circle" }), {
  states: {
    hover: {
      fillColor: eo,
      radius: t.size === "small" ? 6 : 9,
      lineWidth: 3
    }
  }
});
function bg(t) {
  return "polarType" in t;
}
const Zh = (t, r) => t === "line" && r.lineType === "smooth" ? "spline" : t === "area" && r.lineType === "smooth" ? "areaspline" : t === "polar" ? r.polarType : t === "scatter" ? "bubble" : t, Zy = (t, r) => {
  if (t !== "area" && t !== "bar" && t !== "column" && t !== "polar")
    return { showTotal: !1 };
  if (t === "polar") {
    if (bg(r))
      return {
        stacking: r.polarType === "column" || r.polarType === "area" ? "normal" : void 0,
        showTotal: !1
      };
    throw new Jn("errors.polarChartDesignOptionsExpected");
  }
  if (bg(r))
    throw new Jn("errors.polarChartDesignOptionsNotExpected");
  const f = r.valueLabel && r.showTotal || !1;
  switch (r.stackType) {
    case "stacked":
      return {
        stacking: "normal",
        showTotal: f
      };
    case "stack100":
      return {
        stacking: "percent",
        showTotal: f
      };
    default:
      return { showTotal: !1 };
  }
}, tE = (t, r) => t.map((f, B) => r === B ? 0 : -1), eE = (t, r, f, B, H, tt, st, lt) => {
  const ht = qy(t, f), gt = t, { title: ut } = gt, yt = mr(gt, ["title"]);
  return oe(Ut({}, yt), {
    name: ut != null ? ut : t.name,
    data: rE(
      ht,
      r,
      B,
      H,
      f,
      tt,
      st,
      lt
    )
  });
}, iE = (t, r) => {
  !r.minClipped && (t != null && t.min) && (t == null ? void 0 : t.min) > 0 && (t.min = 0), !r.maxClipped && (t != null && t.max) && (t == null ? void 0 : t.max) < 0 && (t.max = 0);
}, rE = (t, r, f, B, H, tt, st, lt) => {
  const ht = r.map((at, G) => {
    if (at < 0)
      return { y: null };
    const { value: F, blur: $, color: Y, rawValue: J, xValue: Q, xDisplayValue: q, xCompareValue: U } = t[at], N = Ky(t, r, at, G), D = N || $, k = {
      enabled: !$,
      isIsolatedPoint: N
    }, A = U ? U[0] : NaN;
    return oe(Ut(Ut({
      x: A,
      y: F,
      selected: !!$
    }, D && { marker: k }), Y && { color: Y }), {
      custom: { rawValue: J, xValue: Q, xDisplayValue: q || Q }
    });
  }), ut = [];
  let yt = -1;
  const gt = f / 2;
  let _ = 0;
  return ht.forEach((at) => {
    if (at.x && yt === -1 && (yt = at.x + gt), at.x && at.x > yt) {
      let G = Math.round((at.x - (yt - gt)) / f);
      for (; G > 0 && (_++, !(_ > B)); ) {
        const F = at.x - f * G;
        ut.push({
          custom: { xDisplayValue: tt(F) },
          x: F,
          y: H ? 0 : null
        }), H && (st != null && st.min) && (st == null ? void 0 : st.min) > 0 && iE(st, lt), G--, yt += f;
      }
    }
    ut.push(at), at.x ? yt = at.x + f + gt : yt += f;
  }), ut;
}, sa = (t, r, f, B, H, tt) => {
  const st = qy(t, f, tt), ut = t, { title: lt } = ut, ht = mr(ut, ["title"]);
  return oe(Ut({}, ht), {
    name: lt != null ? lt : t.name,
    data: nE(st, r, B, H)
  });
}, Ky = (t, r, f, B) => {
  const H = B === 0 || r[B - 1] < 0 || isNaN(t[r[B - 1]].value), tt = B + 1 === r.length || r[B + 1] < 0 || isNaN(t[r[B + 1]].value);
  return H && tt;
}, qy = (t, r, f) => t.data.map((tt) => {
  var st = tt, { value: B } = st, H = mr(st, ["value"]);
  return Ut({
    value: r && Number.isNaN(B) ? 0 : f ? Math.abs(B) : B
  }, H);
}), nE = (t, r, f, B) => {
  const H = t.some((tt) => tt.blur !== void 0);
  return r.map((tt, st) => {
    if (tt < 0)
      return { y: null };
    const { value: lt, blur: ht, color: ut, rawValue: yt, xValue: gt } = t[tt];
    if (f)
      return oe(Ut({
        name: f[tt],
        y: lt,
        color: ut != null ? ut : B == null ? void 0 : B[tt]
      }, H && !ht && { selected: !0 }), {
        custom: { rawValue: yt, xValue: gt }
      });
    {
      const _ = Ky(t, r, tt, st), at = _ || H, G = {
        enabled: !ht,
        isIsolatedPoint: _
      };
      return oe(Ut(Ut({
        y: isNaN(+lt) ? lt : +lt,
        selected: !!ht
      }, at && { marker: G }), ut && { color: ut }), {
        custom: { rawValue: yt, xValue: gt }
      });
    }
  });
}, oE = (t, r, f = 0.1) => {
  const H = Math.abs(r - t) * f / 2;
  return {
    min: t < 0 ? t - H : t,
    max: r >= 0 ? r + H : r
  };
}, xg = (t, r) => {
  const f = Ut({}, r);
  return t.min && t.min >= f.max && (f.max = t.min * (t.min >= 0 ? 2 : 0.5)), t.max && t.max <= f.min && (f.min = t.max * (t.max >= 0 ? 0.5 : 2)), f;
}, Sg = (t, r) => {
  const f = Ut({}, r);
  return f.min <= 0 || (t === "column" || t === "bar") && (f.min = 0), f;
}, wg = (t, r, f, B, H, tt) => {
  const st = r.series.map((gt, _) => oe(Ut({}, gt), {
    data: gt.data.map((F) => {
      var $ = F, { value: at } = $, G = mr($, ["value"]);
      return Ut({
        value: isNaN(at) && H[_] ? 0 : at
      }, G);
    })
  })).filter((gt, _) => B[_] === tt), { stacking: lt } = Zy(
    t,
    f
  ), ht = tt === 0 ? f.yAxis : f.y2Axis || {
    min: void 0,
    max: void 0
  }, ut = Km(t) && f.polarType !== "line";
  if (lt === "percent")
    return { min: 0, max: 100 };
  if (lt === "normal" || ut) {
    const gt = Array.from(Array(r.xValues.length), () => ({
      plus: 0,
      minus: 0
    }));
    let at = st.reduce((G, F) => (F.data.forEach(({ value: $ }, Y) => {
      $ < 0 ? G[Y].minus += $ || 0 : G[Y].plus += $ || 0;
    }), G), gt).reduce(
      (G, F) => ({
        min: Math.min(G.min, F.minus),
        max: Math.max(G.max, F.plus)
      }),
      { min: Number.MAX_VALUE, max: Number.MIN_VALUE }
    );
    return at = xg(ht, at), at = Sg(t, at), f.valueLabel && (at = oE(
      ht.min || at.min,
      ht.max || at.max
    )), at;
  }
  let yt = st.reduce(
    (gt, _) => {
      const at = _.data.map(({ value: G }) => G).filter((G) => !isNaN(G));
      return {
        min: Math.min(gt.min, ...at),
        max: Math.max(gt.max, ...at)
      };
    },
    { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY }
  );
  return yt = xg(ht, yt), yt = Sg(t, yt), yt;
}, sE = (t, r) => {
  var lt;
  if (t.type !== "cartesian")
    return [[], [], [], []];
  let f = [], B = [];
  const H = r;
  let tt = H.y.map(
    ({ treatNullDataAsZeros: ht }) => !!ht
  ), st = H.y.map(({ connectNulls: ht }) => !!ht);
  if (H.breakBy.length === 0) {
    if (H.y.length === 0)
      return [[0], [void 0], [!1], [!1]];
    f = H.y.map(({ showOnRightAxis: ut }) => ut ? 1 : 0);
    let ht = H.y.length <= 1;
    if (!ht) {
      let ut = 0;
      H.y.map(({ enabled: yt }) => (yt && (ut += 1), null)), ut <= 1 && (ht = !0);
    }
    B = H.y.map(({ chartType: ut }) => {
      if (!(!ut || ut === "auto" || ht))
        return ut;
    });
  } else {
    const ht = (lt = H.y[0]) != null && lt.showOnRightAxis ? 1 : 0;
    f = t.series.map(() => ht), B = t.series.map(() => {
    }), tt = t.series.map(() => tt[0]), st = t.series.map(() => st[0]);
  }
  return [f, B, tt, st];
}, Kh = (t, r) => {
  var f, B;
  if (t.breakBy.length === 0) {
    if (t.y.length === 0)
      return to;
    const H = (f = t.y.find((tt) => tt.column.name === r)) == null ? void 0 : f.color;
    return oy(H);
  } else
    return (B = t.seriesToColorMap) == null ? void 0 : B[r];
};
var so = {}, Ro = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cg;
function aE() {
  if (Cg)
    return Ro;
  Cg = 1;
  var t = Oh;
  function r(vt) {
    for (var Pt = "https://reactjs.org/docs/error-decoder.html?invariant=" + vt, jt = 1; jt < arguments.length; jt++)
      Pt += "&args[]=" + encodeURIComponent(arguments[jt]);
    return "Minified React error #" + vt + "; visit " + Pt + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var f = Object.prototype.hasOwnProperty, B = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, H = {}, tt = {};
  function st(vt) {
    return f.call(tt, vt) ? !0 : f.call(H, vt) ? !1 : B.test(vt) ? tt[vt] = !0 : (H[vt] = !0, !1);
  }
  function lt(vt, Pt, jt, Bt, $t, Xt, te) {
    this.acceptsBooleans = Pt === 2 || Pt === 3 || Pt === 4, this.attributeName = Bt, this.attributeNamespace = $t, this.mustUseProperty = jt, this.propertyName = vt, this.type = Pt, this.sanitizeURL = Xt, this.removeEmptyString = te;
  }
  var ht = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(vt) {
    ht[vt] = new lt(vt, 0, !1, vt, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(vt) {
    var Pt = vt[0];
    ht[Pt] = new lt(Pt, 1, !1, vt[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(vt) {
    ht[vt] = new lt(vt, 2, !1, vt.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(vt) {
    ht[vt] = new lt(vt, 2, !1, vt, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(vt) {
    ht[vt] = new lt(vt, 3, !1, vt.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(vt) {
    ht[vt] = new lt(vt, 3, !0, vt, null, !1, !1);
  }), ["capture", "download"].forEach(function(vt) {
    ht[vt] = new lt(vt, 4, !1, vt, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(vt) {
    ht[vt] = new lt(vt, 6, !1, vt, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(vt) {
    ht[vt] = new lt(vt, 5, !1, vt.toLowerCase(), null, !1, !1);
  });
  var ut = /[\-:]([a-z])/g;
  function yt(vt) {
    return vt[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(vt) {
    var Pt = vt.replace(
      ut,
      yt
    );
    ht[Pt] = new lt(Pt, 1, !1, vt, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(vt) {
    var Pt = vt.replace(ut, yt);
    ht[Pt] = new lt(Pt, 1, !1, vt, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(vt) {
    var Pt = vt.replace(ut, yt);
    ht[Pt] = new lt(Pt, 1, !1, vt, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(vt) {
    ht[vt] = new lt(vt, 1, !1, vt.toLowerCase(), null, !1, !1);
  }), ht.xlinkHref = new lt("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(vt) {
    ht[vt] = new lt(vt, 1, !1, vt.toLowerCase(), null, !0, !0);
  });
  var gt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, _ = ["Webkit", "ms", "Moz", "O"];
  Object.keys(gt).forEach(function(vt) {
    _.forEach(function(Pt) {
      Pt = Pt + vt.charAt(0).toUpperCase() + vt.substring(1), gt[Pt] = gt[vt];
    });
  });
  var at = /["'&<>]/;
  function G(vt) {
    if (typeof vt == "boolean" || typeof vt == "number")
      return "" + vt;
    vt = "" + vt;
    var Pt = at.exec(vt);
    if (Pt) {
      var jt = "", Bt, $t = 0;
      for (Bt = Pt.index; Bt < vt.length; Bt++) {
        switch (vt.charCodeAt(Bt)) {
          case 34:
            Pt = "&quot;";
            break;
          case 38:
            Pt = "&amp;";
            break;
          case 39:
            Pt = "&#x27;";
            break;
          case 60:
            Pt = "&lt;";
            break;
          case 62:
            Pt = "&gt;";
            break;
          default:
            continue;
        }
        $t !== Bt && (jt += vt.substring($t, Bt)), $t = Bt + 1, jt += Pt;
      }
      vt = $t !== Bt ? jt + vt.substring($t, Bt) : jt;
    }
    return vt;
  }
  var F = /([A-Z])/g, $ = /^ms-/, Y = Array.isArray;
  function J(vt, Pt) {
    return { insertionMode: vt, selectedValue: Pt };
  }
  function Q(vt, Pt, jt) {
    switch (Pt) {
      case "select":
        return J(1, jt.value != null ? jt.value : jt.defaultValue);
      case "svg":
        return J(2, null);
      case "math":
        return J(3, null);
      case "foreignObject":
        return J(1, null);
      case "table":
        return J(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return J(5, null);
      case "colgroup":
        return J(7, null);
      case "tr":
        return J(6, null);
    }
    return 4 <= vt.insertionMode || vt.insertionMode === 0 ? J(1, null) : vt;
  }
  var q = /* @__PURE__ */ new Map();
  function U(vt, Pt, jt) {
    if (typeof jt != "object")
      throw Error(r(62));
    Pt = !0;
    for (var Bt in jt)
      if (f.call(jt, Bt)) {
        var $t = jt[Bt];
        if ($t != null && typeof $t != "boolean" && $t !== "") {
          if (Bt.indexOf("--") === 0) {
            var Xt = G(Bt);
            $t = G(("" + $t).trim());
          } else {
            Xt = Bt;
            var te = q.get(Xt);
            te !== void 0 || (te = G(Xt.replace(F, "-$1").toLowerCase().replace($, "-ms-")), q.set(Xt, te)), Xt = te, $t = typeof $t == "number" ? $t === 0 || f.call(gt, Bt) ? "" + $t : $t + "px" : G(("" + $t).trim());
          }
          Pt ? (Pt = !1, vt.push(' style="', Xt, ":", $t)) : vt.push(";", Xt, ":", $t);
        }
      }
    Pt || vt.push('"');
  }
  function N(vt, Pt, jt, Bt) {
    switch (jt) {
      case "style":
        U(vt, Pt, Bt);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < jt.length) || jt[0] !== "o" && jt[0] !== "O" || jt[1] !== "n" && jt[1] !== "N") {
      if (Pt = ht.hasOwnProperty(jt) ? ht[jt] : null, Pt !== null) {
        switch (typeof Bt) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!Pt.acceptsBooleans)
              return;
        }
        switch (jt = Pt.attributeName, Pt.type) {
          case 3:
            Bt && vt.push(" ", jt, '=""');
            break;
          case 4:
            Bt === !0 ? vt.push(" ", jt, '=""') : Bt !== !1 && vt.push(" ", jt, '="', G(Bt), '"');
            break;
          case 5:
            isNaN(Bt) || vt.push(" ", jt, '="', G(Bt), '"');
            break;
          case 6:
            !isNaN(Bt) && 1 <= Bt && vt.push(" ", jt, '="', G(Bt), '"');
            break;
          default:
            Pt.sanitizeURL && (Bt = "" + Bt), vt.push(" ", jt, '="', G(Bt), '"');
        }
      } else if (st(jt)) {
        switch (typeof Bt) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (Pt = jt.toLowerCase().slice(0, 5), Pt !== "data-" && Pt !== "aria-")
              return;
        }
        vt.push(" ", jt, '="', G(Bt), '"');
      }
    }
  }
  function D(vt, Pt, jt) {
    if (Pt != null) {
      if (jt != null)
        throw Error(r(60));
      if (typeof Pt != "object" || !("__html" in Pt))
        throw Error(r(61));
      Pt = Pt.__html, Pt != null && vt.push("" + Pt);
    }
  }
  function k(vt) {
    var Pt = "";
    return t.Children.forEach(vt, function(jt) {
      jt != null && (Pt += jt);
    }), Pt;
  }
  function A(vt, Pt, jt, Bt) {
    vt.push(m(jt));
    var $t = jt = null, Xt;
    for (Xt in Pt)
      if (f.call(Pt, Xt)) {
        var te = Pt[Xt];
        if (te != null)
          switch (Xt) {
            case "children":
              jt = te;
              break;
            case "dangerouslySetInnerHTML":
              $t = te;
              break;
            default:
              N(vt, Bt, Xt, te);
          }
      }
    return vt.push(">"), D(vt, $t, jt), typeof jt == "string" ? (vt.push(G(jt)), null) : jt;
  }
  var b = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, d = /* @__PURE__ */ new Map();
  function m(vt) {
    var Pt = d.get(vt);
    if (Pt === void 0) {
      if (!b.test(vt))
        throw Error(r(65, vt));
      Pt = "<" + vt, d.set(vt, Pt);
    }
    return Pt;
  }
  function v(vt, Pt, jt, Bt, $t) {
    switch (Pt) {
      case "select":
        vt.push(m("select"));
        var Xt = null, te = null;
        for (ve in jt)
          if (f.call(jt, ve)) {
            var le = jt[ve];
            if (le != null)
              switch (ve) {
                case "children":
                  Xt = le;
                  break;
                case "dangerouslySetInnerHTML":
                  te = le;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  N(vt, Bt, ve, le);
              }
          }
        return vt.push(">"), D(vt, te, Xt), Xt;
      case "option":
        te = $t.selectedValue, vt.push(m("option"));
        var be = le = null, ke = null, ve = null;
        for (Xt in jt)
          if (f.call(jt, Xt)) {
            var je = jt[Xt];
            if (je != null)
              switch (Xt) {
                case "children":
                  le = je;
                  break;
                case "selected":
                  ke = je;
                  break;
                case "dangerouslySetInnerHTML":
                  ve = je;
                  break;
                case "value":
                  be = je;
                default:
                  N(vt, Bt, Xt, je);
              }
          }
        if (te != null)
          if (jt = be !== null ? "" + be : k(le), Y(te)) {
            for (Bt = 0; Bt < te.length; Bt++)
              if ("" + te[Bt] === jt) {
                vt.push(' selected=""');
                break;
              }
          } else
            "" + te === jt && vt.push(' selected=""');
        else
          ke && vt.push(' selected=""');
        return vt.push(">"), D(vt, ve, le), le;
      case "textarea":
        vt.push(m("textarea")), ve = te = Xt = null;
        for (le in jt)
          if (f.call(jt, le) && (be = jt[le], be != null))
            switch (le) {
              case "children":
                ve = be;
                break;
              case "value":
                Xt = be;
                break;
              case "defaultValue":
                te = be;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(r(91));
              default:
                N(
                  vt,
                  Bt,
                  le,
                  be
                );
            }
        if (Xt === null && te !== null && (Xt = te), vt.push(">"), ve != null) {
          if (Xt != null)
            throw Error(r(92));
          if (Y(ve) && 1 < ve.length)
            throw Error(r(93));
          Xt = "" + ve;
        }
        return typeof Xt == "string" && Xt[0] === `
` && vt.push(`
`), Xt !== null && vt.push(G("" + Xt)), null;
      case "input":
        vt.push(m("input")), be = ve = le = Xt = null;
        for (te in jt)
          if (f.call(jt, te) && (ke = jt[te], ke != null))
            switch (te) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(399, "input"));
              case "defaultChecked":
                be = ke;
                break;
              case "defaultValue":
                le = ke;
                break;
              case "checked":
                ve = ke;
                break;
              case "value":
                Xt = ke;
                break;
              default:
                N(vt, Bt, te, ke);
            }
        return ve !== null ? N(vt, Bt, "checked", ve) : be !== null && N(vt, Bt, "checked", be), Xt !== null ? N(vt, Bt, "value", Xt) : le !== null && N(vt, Bt, "value", le), vt.push("/>"), null;
      case "menuitem":
        vt.push(m("menuitem"));
        for (var Mi in jt)
          if (f.call(jt, Mi) && (Xt = jt[Mi], Xt != null))
            switch (Mi) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(400));
              default:
                N(vt, Bt, Mi, Xt);
            }
        return vt.push(">"), null;
      case "title":
        vt.push(m("title")), Xt = null;
        for (je in jt)
          if (f.call(jt, je) && (te = jt[je], te != null))
            switch (je) {
              case "children":
                Xt = te;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(r(434));
              default:
                N(vt, Bt, je, te);
            }
        return vt.push(">"), Xt;
      case "listing":
      case "pre":
        vt.push(m(Pt)), te = Xt = null;
        for (be in jt)
          if (f.call(jt, be) && (le = jt[be], le != null))
            switch (be) {
              case "children":
                Xt = le;
                break;
              case "dangerouslySetInnerHTML":
                te = le;
                break;
              default:
                N(vt, Bt, be, le);
            }
        if (vt.push(">"), te != null) {
          if (Xt != null)
            throw Error(r(60));
          if (typeof te != "object" || !("__html" in te))
            throw Error(r(61));
          jt = te.__html, jt != null && (typeof jt == "string" && 0 < jt.length && jt[0] === `
` ? vt.push(`
`, jt) : vt.push("" + jt));
        }
        return typeof Xt == "string" && Xt[0] === `
` && vt.push(`
`), Xt;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        vt.push(m(Pt));
        for (var mi in jt)
          if (f.call(jt, mi) && (Xt = jt[mi], Xt != null))
            switch (mi) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(399, Pt));
              default:
                N(vt, Bt, mi, Xt);
            }
        return vt.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return A(
          vt,
          jt,
          Pt,
          Bt
        );
      case "html":
        return $t.insertionMode === 0 && vt.push("<!DOCTYPE html>"), A(vt, jt, Pt, Bt);
      default:
        if (Pt.indexOf("-") === -1 && typeof jt.is != "string")
          return A(vt, jt, Pt, Bt);
        vt.push(m(Pt)), te = Xt = null;
        for (ke in jt)
          if (f.call(jt, ke) && (le = jt[ke], le != null))
            switch (ke) {
              case "children":
                Xt = le;
                break;
              case "dangerouslySetInnerHTML":
                te = le;
                break;
              case "style":
                U(vt, Bt, le);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                st(ke) && typeof le != "function" && typeof le != "symbol" && vt.push(" ", ke, '="', G(le), '"');
            }
        return vt.push(">"), D(vt, te, Xt), Xt;
    }
  }
  function g(vt, Pt, jt) {
    if (vt.push('<!--$?--><template id="'), jt === null)
      throw Error(r(395));
    return vt.push(jt), vt.push('"></template>');
  }
  function x(vt, Pt, jt, Bt) {
    switch (jt.insertionMode) {
      case 0:
      case 1:
        return vt.push('<div hidden id="'), vt.push(Pt.segmentPrefix), Pt = Bt.toString(16), vt.push(Pt), vt.push('">');
      case 2:
        return vt.push('<svg aria-hidden="true" style="display:none" id="'), vt.push(Pt.segmentPrefix), Pt = Bt.toString(16), vt.push(Pt), vt.push('">');
      case 3:
        return vt.push('<math aria-hidden="true" style="display:none" id="'), vt.push(Pt.segmentPrefix), Pt = Bt.toString(16), vt.push(Pt), vt.push('">');
      case 4:
        return vt.push('<table hidden id="'), vt.push(Pt.segmentPrefix), Pt = Bt.toString(16), vt.push(Pt), vt.push('">');
      case 5:
        return vt.push('<table hidden><tbody id="'), vt.push(Pt.segmentPrefix), Pt = Bt.toString(16), vt.push(Pt), vt.push('">');
      case 6:
        return vt.push('<table hidden><tr id="'), vt.push(Pt.segmentPrefix), Pt = Bt.toString(16), vt.push(Pt), vt.push('">');
      case 7:
        return vt.push('<table hidden><colgroup id="'), vt.push(Pt.segmentPrefix), Pt = Bt.toString(16), vt.push(Pt), vt.push('">');
      default:
        throw Error(r(397));
    }
  }
  function E(vt, Pt) {
    switch (Pt.insertionMode) {
      case 0:
      case 1:
        return vt.push("</div>");
      case 2:
        return vt.push("</svg>");
      case 3:
        return vt.push("</math>");
      case 4:
        return vt.push("</table>");
      case 5:
        return vt.push("</tbody></table>");
      case 6:
        return vt.push("</tr></table>");
      case 7:
        return vt.push("</colgroup></table>");
      default:
        throw Error(r(397));
    }
  }
  var P = /[<\u2028\u2029]/g;
  function S(vt) {
    return JSON.stringify(vt).replace(P, function(Pt) {
      switch (Pt) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function u(vt, Pt) {
    return Pt = Pt === void 0 ? "" : Pt, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: Pt + "P:", segmentPrefix: Pt + "S:", boundaryPrefix: Pt + "B:", idPrefix: Pt, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: vt };
  }
  function y(vt, Pt, jt, Bt) {
    return jt.generateStaticMarkup ? (vt.push(G(Pt)), !1) : (Pt === "" ? vt = Bt : (Bt && vt.push("<!-- -->"), vt.push(G(Pt)), vt = !0), vt);
  }
  var s = Object.assign, a = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), l = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), M = Symbol.for("react.suspense_list"), O = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), w = Symbol.for("react.scope"), T = Symbol.for("react.debug_trace_mode"), z = Symbol.for("react.legacy_hidden"), W = Symbol.for("react.default_value"), L = Symbol.iterator;
  function I(vt) {
    if (vt == null)
      return null;
    if (typeof vt == "function")
      return vt.displayName || vt.name || null;
    if (typeof vt == "string")
      return vt;
    switch (vt) {
      case n:
        return "Fragment";
      case e:
        return "Portal";
      case i:
        return "Profiler";
      case o:
        return "StrictMode";
      case C:
        return "Suspense";
      case M:
        return "SuspenseList";
    }
    if (typeof vt == "object")
      switch (vt.$$typeof) {
        case l:
          return (vt.displayName || "Context") + ".Consumer";
        case c:
          return (vt._context.displayName || "Context") + ".Provider";
        case h:
          var Pt = vt.render;
          return vt = vt.displayName, vt || (vt = Pt.displayName || Pt.name || "", vt = vt !== "" ? "ForwardRef(" + vt + ")" : "ForwardRef"), vt;
        case O:
          return Pt = vt.displayName || null, Pt !== null ? Pt : I(vt.type) || "Memo";
        case p:
          Pt = vt._payload, vt = vt._init;
          try {
            return I(vt(Pt));
          } catch (jt) {
          }
      }
    return null;
  }
  var j = {};
  function Z(vt, Pt) {
    if (vt = vt.contextTypes, !vt)
      return j;
    var jt = {}, Bt;
    for (Bt in vt)
      jt[Bt] = Pt[Bt];
    return jt;
  }
  var V = null;
  function X(vt, Pt) {
    if (vt !== Pt) {
      vt.context._currentValue2 = vt.parentValue, vt = vt.parent;
      var jt = Pt.parent;
      if (vt === null) {
        if (jt !== null)
          throw Error(r(401));
      } else {
        if (jt === null)
          throw Error(r(401));
        X(vt, jt);
      }
      Pt.context._currentValue2 = Pt.value;
    }
  }
  function et(vt) {
    vt.context._currentValue2 = vt.parentValue, vt = vt.parent, vt !== null && et(vt);
  }
  function ot(vt) {
    var Pt = vt.parent;
    Pt !== null && ot(Pt), vt.context._currentValue2 = vt.value;
  }
  function it(vt, Pt) {
    if (vt.context._currentValue2 = vt.parentValue, vt = vt.parent, vt === null)
      throw Error(r(402));
    vt.depth === Pt.depth ? X(vt, Pt) : it(vt, Pt);
  }
  function pt(vt, Pt) {
    var jt = Pt.parent;
    if (jt === null)
      throw Error(r(402));
    vt.depth === jt.depth ? X(vt, jt) : pt(vt, jt), Pt.context._currentValue2 = Pt.value;
  }
  function mt(vt) {
    var Pt = V;
    Pt !== vt && (Pt === null ? ot(vt) : vt === null ? et(Pt) : Pt.depth === vt.depth ? X(Pt, vt) : Pt.depth > vt.depth ? it(Pt, vt) : pt(Pt, vt), V = vt);
  }
  var Ct = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(vt, Pt) {
    vt = vt._reactInternals, vt.queue !== null && vt.queue.push(Pt);
  }, enqueueReplaceState: function(vt, Pt) {
    vt = vt._reactInternals, vt.replace = !0, vt.queue = [Pt];
  }, enqueueForceUpdate: function() {
  } };
  function kt(vt, Pt, jt, Bt) {
    var $t = vt.state !== void 0 ? vt.state : null;
    vt.updater = Ct, vt.props = jt, vt.state = $t;
    var Xt = { queue: [], replace: !1 };
    vt._reactInternals = Xt;
    var te = Pt.contextType;
    if (vt.context = typeof te == "object" && te !== null ? te._currentValue2 : Bt, te = Pt.getDerivedStateFromProps, typeof te == "function" && (te = te(jt, $t), $t = te == null ? $t : s({}, $t, te), vt.state = $t), typeof Pt.getDerivedStateFromProps != "function" && typeof vt.getSnapshotBeforeUpdate != "function" && (typeof vt.UNSAFE_componentWillMount == "function" || typeof vt.componentWillMount == "function"))
      if (Pt = vt.state, typeof vt.componentWillMount == "function" && vt.componentWillMount(), typeof vt.UNSAFE_componentWillMount == "function" && vt.UNSAFE_componentWillMount(), Pt !== vt.state && Ct.enqueueReplaceState(vt, vt.state, null), Xt.queue !== null && 0 < Xt.queue.length)
        if (Pt = Xt.queue, te = Xt.replace, Xt.queue = null, Xt.replace = !1, te && Pt.length === 1)
          vt.state = Pt[0];
        else {
          for (Xt = te ? Pt[0] : vt.state, $t = !0, te = te ? 1 : 0; te < Pt.length; te++) {
            var le = Pt[te];
            le = typeof le == "function" ? le.call(vt, Xt, jt, Bt) : le, le != null && ($t ? ($t = !1, Xt = s({}, Xt, le)) : s(Xt, le));
          }
          vt.state = Xt;
        }
      else
        Xt.queue = null;
  }
  var Lt = { id: 1, overflow: "" };
  function Tt(vt, Pt, jt) {
    var Bt = vt.id;
    vt = vt.overflow;
    var $t = 32 - xt(Bt) - 1;
    Bt &= ~(1 << $t), jt += 1;
    var Xt = 32 - xt(Pt) + $t;
    if (30 < Xt) {
      var te = $t - $t % 5;
      return Xt = (Bt & (1 << te) - 1).toString(32), Bt >>= te, $t -= te, { id: 1 << 32 - xt(Pt) + $t | jt << $t | Bt, overflow: Xt + vt };
    }
    return { id: 1 << Xt | jt << $t | Bt, overflow: vt };
  }
  var xt = Math.clz32 ? Math.clz32 : St, ct = Math.log, ft = Math.LN2;
  function St(vt) {
    return vt >>>= 0, vt === 0 ? 32 : 31 - (ct(vt) / ft | 0) | 0;
  }
  function Mt(vt, Pt) {
    return vt === Pt && (vt !== 0 || 1 / vt === 1 / Pt) || vt !== vt && Pt !== Pt;
  }
  var Dt = typeof Object.is == "function" ? Object.is : Mt, Ot = null, Nt = null, Wt = null, zt = null, Ht = !1, Kt = !1, Gt = 0, ee = null, Jt = 0;
  function Qt() {
    if (Ot === null)
      throw Error(r(321));
    return Ot;
  }
  function ne() {
    if (0 < Jt)
      throw Error(r(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function ae() {
    return zt === null ? Wt === null ? (Ht = !1, Wt = zt = ne()) : (Ht = !0, zt = Wt) : zt.next === null ? (Ht = !1, zt = zt.next = ne()) : (Ht = !0, zt = zt.next), zt;
  }
  function Me() {
    Nt = Ot = null, Kt = !1, Wt = null, Jt = 0, zt = ee = null;
  }
  function he(vt, Pt) {
    return typeof Pt == "function" ? Pt(vt) : Pt;
  }
  function fe(vt, Pt, jt) {
    if (Ot = Qt(), zt = ae(), Ht) {
      var Bt = zt.queue;
      if (Pt = Bt.dispatch, ee !== null && (jt = ee.get(Bt), jt !== void 0)) {
        ee.delete(Bt), Bt = zt.memoizedState;
        do
          Bt = vt(Bt, jt.action), jt = jt.next;
        while (jt !== null);
        return zt.memoizedState = Bt, [Bt, Pt];
      }
      return [zt.memoizedState, Pt];
    }
    return vt = vt === he ? typeof Pt == "function" ? Pt() : Pt : jt !== void 0 ? jt(Pt) : Pt, zt.memoizedState = vt, vt = zt.queue = { last: null, dispatch: null }, vt = vt.dispatch = Xe.bind(null, Ot, vt), [zt.memoizedState, vt];
  }
  function Ee(vt, Pt) {
    if (Ot = Qt(), zt = ae(), Pt = Pt === void 0 ? null : Pt, zt !== null) {
      var jt = zt.memoizedState;
      if (jt !== null && Pt !== null) {
        var Bt = jt[1];
        t:
          if (Bt === null)
            Bt = !1;
          else {
            for (var $t = 0; $t < Bt.length && $t < Pt.length; $t++)
              if (!Dt(Pt[$t], Bt[$t])) {
                Bt = !1;
                break t;
              }
            Bt = !0;
          }
        if (Bt)
          return jt[0];
      }
    }
    return vt = vt(), zt.memoizedState = [vt, Pt], vt;
  }
  function Xe(vt, Pt, jt) {
    if (25 <= Jt)
      throw Error(r(301));
    if (vt === Ot)
      if (Kt = !0, vt = { action: jt, next: null }, ee === null && (ee = /* @__PURE__ */ new Map()), jt = ee.get(Pt), jt === void 0)
        ee.set(Pt, vt);
      else {
        for (Pt = jt; Pt.next !== null; )
          Pt = Pt.next;
        Pt.next = vt;
      }
  }
  function Se() {
    throw Error(r(394));
  }
  function Le() {
  }
  var Ye = { readContext: function(vt) {
    return vt._currentValue2;
  }, useContext: function(vt) {
    return Qt(), vt._currentValue2;
  }, useMemo: Ee, useReducer: fe, useRef: function(vt) {
    Ot = Qt(), zt = ae();
    var Pt = zt.memoizedState;
    return Pt === null ? (vt = { current: vt }, zt.memoizedState = vt) : Pt;
  }, useState: function(vt) {
    return fe(he, vt);
  }, useInsertionEffect: Le, useLayoutEffect: function() {
  }, useCallback: function(vt, Pt) {
    return Ee(function() {
      return vt;
    }, Pt);
  }, useImperativeHandle: Le, useEffect: Le, useDebugValue: Le, useDeferredValue: function(vt) {
    return Qt(), vt;
  }, useTransition: function() {
    return Qt(), [
      !1,
      Se
    ];
  }, useId: function() {
    var vt = Nt.treeContext, Pt = vt.overflow;
    vt = vt.id, vt = (vt & ~(1 << 32 - xt(vt) - 1)).toString(32) + Pt;
    var jt = qt;
    if (jt === null)
      throw Error(r(404));
    return Pt = Gt++, vt = ":" + jt.idPrefix + "R" + vt, 0 < Pt && (vt += "H" + Pt.toString(32)), vt + ":";
  }, useMutableSource: function(vt, Pt) {
    return Qt(), Pt(vt._source);
  }, useSyncExternalStore: function(vt, Pt, jt) {
    if (jt === void 0)
      throw Error(r(407));
    return jt();
  } }, qt = null, ue = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function ye(vt) {
    return console.error(vt), null;
  }
  function xe() {
  }
  function Ve(vt, Pt, jt, Bt, $t, Xt, te, le, be) {
    var ke = [], ve = /* @__PURE__ */ new Set();
    return Pt = { destination: null, responseState: Pt, progressiveChunkSize: Bt === void 0 ? 12800 : Bt, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: ve, pingedTasks: ke, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: $t === void 0 ? ye : $t, onAllReady: xe, onShellReady: te === void 0 ? xe : te, onShellError: xe, onFatalError: xe }, jt = _e(Pt, 0, null, jt, !1, !1), jt.parentFlushed = !0, vt = ze(Pt, vt, null, jt, ve, j, null, Lt), ke.push(vt), Pt;
  }
  function ze(vt, Pt, jt, Bt, $t, Xt, te, le) {
    vt.allPendingTasks++, jt === null ? vt.pendingRootTasks++ : jt.pendingTasks++;
    var be = { node: Pt, ping: function() {
      var ke = vt.pingedTasks;
      ke.push(be), ke.length === 1 && fi(vt);
    }, blockedBoundary: jt, blockedSegment: Bt, abortSet: $t, legacyContext: Xt, context: te, treeContext: le };
    return $t.add(be), be;
  }
  function _e(vt, Pt, jt, Bt, $t, Xt) {
    return { status: 0, id: -1, index: Pt, parentFlushed: !1, chunks: [], children: [], formatContext: Bt, boundary: jt, lastPushedText: $t, textEmbedded: Xt };
  }
  function Ce(vt, Pt) {
    if (vt = vt.onError(Pt), vt != null && typeof vt != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof vt + '" instead');
    return vt;
  }
  function bi(vt, Pt) {
    var jt = vt.onShellError;
    jt(Pt), jt = vt.onFatalError, jt(Pt), vt.destination !== null ? (vt.status = 2, vt.destination.destroy(Pt)) : (vt.status = 1, vt.fatalError = Pt);
  }
  function ti(vt, Pt, jt, Bt, $t) {
    for (Ot = {}, Nt = Pt, Gt = 0, vt = jt(Bt, $t); Kt; )
      Kt = !1, Gt = 0, Jt += 1, zt = null, vt = jt(Bt, $t);
    return Me(), vt;
  }
  function pi(vt, Pt, jt, Bt) {
    var $t = jt.render(), Xt = Bt.childContextTypes;
    if (Xt != null) {
      var te = Pt.legacyContext;
      if (typeof jt.getChildContext != "function")
        Bt = te;
      else {
        jt = jt.getChildContext();
        for (var le in jt)
          if (!(le in Xt))
            throw Error(r(108, I(Bt) || "Unknown", le));
        Bt = s({}, te, jt);
      }
      Pt.legacyContext = Bt, Fe(vt, Pt, $t), Pt.legacyContext = te;
    } else
      Fe(vt, Pt, $t);
  }
  function Ki(vt, Pt) {
    if (vt && vt.defaultProps) {
      Pt = s({}, Pt), vt = vt.defaultProps;
      for (var jt in vt)
        Pt[jt] === void 0 && (Pt[jt] = vt[jt]);
      return Pt;
    }
    return Pt;
  }
  function ni(vt, Pt, jt, Bt, $t) {
    if (typeof jt == "function")
      if (jt.prototype && jt.prototype.isReactComponent) {
        $t = Z(jt, Pt.legacyContext);
        var Xt = jt.contextType;
        Xt = new jt(Bt, typeof Xt == "object" && Xt !== null ? Xt._currentValue2 : $t), kt(Xt, jt, Bt, $t), pi(vt, Pt, Xt, jt);
      } else {
        Xt = Z(jt, Pt.legacyContext), $t = ti(vt, Pt, jt, Bt, Xt);
        var te = Gt !== 0;
        if (typeof $t == "object" && $t !== null && typeof $t.render == "function" && $t.$$typeof === void 0)
          kt($t, jt, Bt, Xt), pi(vt, Pt, $t, jt);
        else if (te) {
          Bt = Pt.treeContext, Pt.treeContext = Tt(Bt, 1, 0);
          try {
            Fe(vt, Pt, $t);
          } finally {
            Pt.treeContext = Bt;
          }
        } else
          Fe(vt, Pt, $t);
      }
    else if (typeof jt == "string") {
      switch ($t = Pt.blockedSegment, Xt = v($t.chunks, jt, Bt, vt.responseState, $t.formatContext), $t.lastPushedText = !1, te = $t.formatContext, $t.formatContext = Q(te, jt, Bt), qe(vt, Pt, Xt), $t.formatContext = te, jt) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          $t.chunks.push("</", jt, ">");
      }
      $t.lastPushedText = !1;
    } else {
      switch (jt) {
        case z:
        case T:
        case o:
        case i:
        case n:
          Fe(vt, Pt, Bt.children);
          return;
        case M:
          Fe(vt, Pt, Bt.children);
          return;
        case w:
          throw Error(r(343));
        case C:
          t: {
            jt = Pt.blockedBoundary, $t = Pt.blockedSegment, Xt = Bt.fallback, Bt = Bt.children, te = /* @__PURE__ */ new Set();
            var le = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: te, errorDigest: null }, be = _e(vt, $t.chunks.length, le, $t.formatContext, !1, !1);
            $t.children.push(be), $t.lastPushedText = !1;
            var ke = _e(vt, 0, null, $t.formatContext, !1, !1);
            ke.parentFlushed = !0, Pt.blockedBoundary = le, Pt.blockedSegment = ke;
            try {
              if (qe(
                vt,
                Pt,
                Bt
              ), vt.responseState.generateStaticMarkup || ke.lastPushedText && ke.textEmbedded && ke.chunks.push("<!-- -->"), ke.status = 1, Ui(le, ke), le.pendingTasks === 0)
                break t;
            } catch (ve) {
              ke.status = 4, le.forceClientRender = !0, le.errorDigest = Ce(vt, ve);
            } finally {
              Pt.blockedBoundary = jt, Pt.blockedSegment = $t;
            }
            Pt = ze(vt, Xt, jt, be, te, Pt.legacyContext, Pt.context, Pt.treeContext), vt.pingedTasks.push(Pt);
          }
          return;
      }
      if (typeof jt == "object" && jt !== null)
        switch (jt.$$typeof) {
          case h:
            if (Bt = ti(vt, Pt, jt.render, Bt, $t), Gt !== 0) {
              jt = Pt.treeContext, Pt.treeContext = Tt(jt, 1, 0);
              try {
                Fe(vt, Pt, Bt);
              } finally {
                Pt.treeContext = jt;
              }
            } else
              Fe(vt, Pt, Bt);
            return;
          case O:
            jt = jt.type, Bt = Ki(jt, Bt), ni(vt, Pt, jt, Bt, $t);
            return;
          case c:
            if ($t = Bt.children, jt = jt._context, Bt = Bt.value, Xt = jt._currentValue2, jt._currentValue2 = Bt, te = V, V = Bt = { parent: te, depth: te === null ? 0 : te.depth + 1, context: jt, parentValue: Xt, value: Bt }, Pt.context = Bt, Fe(vt, Pt, $t), vt = V, vt === null)
              throw Error(r(403));
            Bt = vt.parentValue, vt.context._currentValue2 = Bt === W ? vt.context._defaultValue : Bt, vt = V = vt.parent, Pt.context = vt;
            return;
          case l:
            Bt = Bt.children, Bt = Bt(jt._currentValue2), Fe(vt, Pt, Bt);
            return;
          case p:
            $t = jt._init, jt = $t(jt._payload), Bt = Ki(jt, Bt), ni(
              vt,
              Pt,
              jt,
              Bt,
              void 0
            );
            return;
        }
      throw Error(r(130, jt == null ? jt : typeof jt, ""));
    }
  }
  function Fe(vt, Pt, jt) {
    if (Pt.node = jt, typeof jt == "object" && jt !== null) {
      switch (jt.$$typeof) {
        case a:
          ni(vt, Pt, jt.type, jt.props, jt.ref);
          return;
        case e:
          throw Error(r(257));
        case p:
          var Bt = jt._init;
          jt = Bt(jt._payload), Fe(vt, Pt, jt);
          return;
      }
      if (Y(jt)) {
        Ie(vt, Pt, jt);
        return;
      }
      if (jt === null || typeof jt != "object" ? Bt = null : (Bt = L && jt[L] || jt["@@iterator"], Bt = typeof Bt == "function" ? Bt : null), Bt && (Bt = Bt.call(jt))) {
        if (jt = Bt.next(), !jt.done) {
          var $t = [];
          do
            $t.push(jt.value), jt = Bt.next();
          while (!jt.done);
          Ie(vt, Pt, $t);
        }
        return;
      }
      throw vt = Object.prototype.toString.call(jt), Error(r(31, vt === "[object Object]" ? "object with keys {" + Object.keys(jt).join(", ") + "}" : vt));
    }
    typeof jt == "string" ? (Bt = Pt.blockedSegment, Bt.lastPushedText = y(Pt.blockedSegment.chunks, jt, vt.responseState, Bt.lastPushedText)) : typeof jt == "number" && (Bt = Pt.blockedSegment, Bt.lastPushedText = y(Pt.blockedSegment.chunks, "" + jt, vt.responseState, Bt.lastPushedText));
  }
  function Ie(vt, Pt, jt) {
    for (var Bt = jt.length, $t = 0; $t < Bt; $t++) {
      var Xt = Pt.treeContext;
      Pt.treeContext = Tt(Xt, Bt, $t);
      try {
        qe(vt, Pt, jt[$t]);
      } finally {
        Pt.treeContext = Xt;
      }
    }
  }
  function qe(vt, Pt, jt) {
    var Bt = Pt.blockedSegment.formatContext, $t = Pt.legacyContext, Xt = Pt.context;
    try {
      return Fe(vt, Pt, jt);
    } catch (be) {
      if (Me(), typeof be == "object" && be !== null && typeof be.then == "function") {
        jt = be;
        var te = Pt.blockedSegment, le = _e(vt, te.chunks.length, null, te.formatContext, te.lastPushedText, !0);
        te.children.push(le), te.lastPushedText = !1, vt = ze(vt, Pt.node, Pt.blockedBoundary, le, Pt.abortSet, Pt.legacyContext, Pt.context, Pt.treeContext).ping, jt.then(vt, vt), Pt.blockedSegment.formatContext = Bt, Pt.legacyContext = $t, Pt.context = Xt, mt(Xt);
      } else
        throw Pt.blockedSegment.formatContext = Bt, Pt.legacyContext = $t, Pt.context = Xt, mt(Xt), be;
    }
  }
  function si(vt) {
    var Pt = vt.blockedBoundary;
    vt = vt.blockedSegment, vt.status = 3, Di(this, Pt, vt);
  }
  function sr(vt, Pt, jt) {
    var Bt = vt.blockedBoundary;
    vt.blockedSegment.status = 3, Bt === null ? (Pt.allPendingTasks--, Pt.status !== 2 && (Pt.status = 2, Pt.destination !== null && Pt.destination.push(null))) : (Bt.pendingTasks--, Bt.forceClientRender || (Bt.forceClientRender = !0, vt = jt === void 0 ? Error(r(432)) : jt, Bt.errorDigest = Pt.onError(vt), Bt.parentFlushed && Pt.clientRenderedBoundaries.push(Bt)), Bt.fallbackAbortableTasks.forEach(function($t) {
      return sr($t, Pt, jt);
    }), Bt.fallbackAbortableTasks.clear(), Pt.allPendingTasks--, Pt.allPendingTasks === 0 && (Bt = Pt.onAllReady, Bt()));
  }
  function Ui(vt, Pt) {
    if (Pt.chunks.length === 0 && Pt.children.length === 1 && Pt.children[0].boundary === null) {
      var jt = Pt.children[0];
      jt.id = Pt.id, jt.parentFlushed = !0, jt.status === 1 && Ui(vt, jt);
    } else
      vt.completedSegments.push(Pt);
  }
  function Di(vt, Pt, jt) {
    if (Pt === null) {
      if (jt.parentFlushed) {
        if (vt.completedRootSegment !== null)
          throw Error(r(389));
        vt.completedRootSegment = jt;
      }
      vt.pendingRootTasks--, vt.pendingRootTasks === 0 && (vt.onShellError = xe, Pt = vt.onShellReady, Pt());
    } else
      Pt.pendingTasks--, Pt.forceClientRender || (Pt.pendingTasks === 0 ? (jt.parentFlushed && jt.status === 1 && Ui(Pt, jt), Pt.parentFlushed && vt.completedBoundaries.push(Pt), Pt.fallbackAbortableTasks.forEach(si, vt), Pt.fallbackAbortableTasks.clear()) : jt.parentFlushed && jt.status === 1 && (Ui(Pt, jt), Pt.completedSegments.length === 1 && Pt.parentFlushed && vt.partialBoundaries.push(Pt)));
    vt.allPendingTasks--, vt.allPendingTasks === 0 && (vt = vt.onAllReady, vt());
  }
  function fi(vt) {
    if (vt.status !== 2) {
      var Pt = V, jt = ue.current;
      ue.current = Ye;
      var Bt = qt;
      qt = vt.responseState;
      try {
        var $t = vt.pingedTasks, Xt;
        for (Xt = 0; Xt < $t.length; Xt++) {
          var te = $t[Xt], le = vt, be = te.blockedSegment;
          if (be.status === 0) {
            mt(te.context);
            try {
              Fe(le, te, te.node), le.responseState.generateStaticMarkup || be.lastPushedText && be.textEmbedded && be.chunks.push("<!-- -->"), te.abortSet.delete(te), be.status = 1, Di(le, te.blockedBoundary, be);
            } catch (yi) {
              if (Me(), typeof yi == "object" && yi !== null && typeof yi.then == "function") {
                var ke = te.ping;
                yi.then(ke, ke);
              } else {
                te.abortSet.delete(te), be.status = 4;
                var ve = te.blockedBoundary, je = yi, Mi = Ce(le, je);
                if (ve === null ? bi(le, je) : (ve.pendingTasks--, ve.forceClientRender || (ve.forceClientRender = !0, ve.errorDigest = Mi, ve.parentFlushed && le.clientRenderedBoundaries.push(ve))), le.allPendingTasks--, le.allPendingTasks === 0) {
                  var mi = le.onAllReady;
                  mi();
                }
              }
            } finally {
            }
          }
        }
        $t.splice(0, Xt), vt.destination !== null && ii(vt, vt.destination);
      } catch (yi) {
        Ce(vt, yi), bi(vt, yi);
      } finally {
        qt = Bt, ue.current = jt, jt === Ye && mt(Pt);
      }
    }
  }
  function ar(vt, Pt, jt) {
    switch (jt.parentFlushed = !0, jt.status) {
      case 0:
        var Bt = jt.id = vt.nextSegmentId++;
        return jt.lastPushedText = !1, jt.textEmbedded = !1, vt = vt.responseState, Pt.push('<template id="'), Pt.push(vt.placeholderPrefix), vt = Bt.toString(16), Pt.push(vt), Pt.push('"></template>');
      case 1:
        jt.status = 2;
        var $t = !0;
        Bt = jt.chunks;
        var Xt = 0;
        jt = jt.children;
        for (var te = 0; te < jt.length; te++) {
          for ($t = jt[te]; Xt < $t.index; Xt++)
            Pt.push(Bt[Xt]);
          $t = gi(vt, Pt, $t);
        }
        for (; Xt < Bt.length - 1; Xt++)
          Pt.push(Bt[Xt]);
        return Xt < Bt.length && ($t = Pt.push(Bt[Xt])), $t;
      default:
        throw Error(r(390));
    }
  }
  function gi(vt, Pt, jt) {
    var Bt = jt.boundary;
    if (Bt === null)
      return ar(vt, Pt, jt);
    if (Bt.parentFlushed = !0, Bt.forceClientRender)
      return vt.responseState.generateStaticMarkup || (Bt = Bt.errorDigest, Pt.push("<!--$!-->"), Pt.push("<template"), Bt && (Pt.push(' data-dgst="'), Bt = G(Bt), Pt.push(Bt), Pt.push('"')), Pt.push("></template>")), ar(vt, Pt, jt), vt = vt.responseState.generateStaticMarkup ? !0 : Pt.push("<!--/$-->"), vt;
    if (0 < Bt.pendingTasks) {
      Bt.rootSegmentID = vt.nextSegmentId++, 0 < Bt.completedSegments.length && vt.partialBoundaries.push(Bt);
      var $t = vt.responseState, Xt = $t.nextSuspenseID++;
      return $t = $t.boundaryPrefix + Xt.toString(16), Bt = Bt.id = $t, g(Pt, vt.responseState, Bt), ar(vt, Pt, jt), Pt.push("<!--/$-->");
    }
    if (Bt.byteSize > vt.progressiveChunkSize)
      return Bt.rootSegmentID = vt.nextSegmentId++, vt.completedBoundaries.push(Bt), g(Pt, vt.responseState, Bt.id), ar(vt, Pt, jt), Pt.push("<!--/$-->");
    if (vt.responseState.generateStaticMarkup || Pt.push("<!--$-->"), jt = Bt.completedSegments, jt.length !== 1)
      throw Error(r(391));
    return gi(vt, Pt, jt[0]), vt = vt.responseState.generateStaticMarkup ? !0 : Pt.push("<!--/$-->"), vt;
  }
  function Gi(vt, Pt, jt) {
    return x(Pt, vt.responseState, jt.formatContext, jt.id), gi(vt, Pt, jt), E(Pt, jt.formatContext);
  }
  function Ii(vt, Pt, jt) {
    for (var Bt = jt.completedSegments, $t = 0; $t < Bt.length; $t++)
      Br(vt, Pt, jt, Bt[$t]);
    if (Bt.length = 0, vt = vt.responseState, Bt = jt.id, jt = jt.rootSegmentID, Pt.push(vt.startInlineScript), vt.sentCompleteBoundaryFunction ? Pt.push('$RC("') : (vt.sentCompleteBoundaryFunction = !0, Pt.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), Bt === null)
      throw Error(r(395));
    return jt = jt.toString(16), Pt.push(Bt), Pt.push('","'), Pt.push(vt.segmentPrefix), Pt.push(jt), Pt.push('")<\/script>');
  }
  function Br(vt, Pt, jt, Bt) {
    if (Bt.status === 2)
      return !0;
    var $t = Bt.id;
    if ($t === -1) {
      if ((Bt.id = jt.rootSegmentID) === -1)
        throw Error(r(392));
      return Gi(vt, Pt, Bt);
    }
    return Gi(vt, Pt, Bt), vt = vt.responseState, Pt.push(vt.startInlineScript), vt.sentCompleteSegmentFunction ? Pt.push('$RS("') : (vt.sentCompleteSegmentFunction = !0, Pt.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), Pt.push(vt.segmentPrefix), $t = $t.toString(16), Pt.push($t), Pt.push('","'), Pt.push(vt.placeholderPrefix), Pt.push($t), Pt.push('")<\/script>');
  }
  function ii(vt, Pt) {
    try {
      var jt = vt.completedRootSegment;
      if (jt !== null && vt.pendingRootTasks === 0) {
        gi(vt, Pt, jt), vt.completedRootSegment = null;
        var Bt = vt.responseState.bootstrapChunks;
        for (jt = 0; jt < Bt.length - 1; jt++)
          Pt.push(Bt[jt]);
        jt < Bt.length && Pt.push(Bt[jt]);
      }
      var $t = vt.clientRenderedBoundaries, Xt;
      for (Xt = 0; Xt < $t.length; Xt++) {
        var te = $t[Xt];
        Bt = Pt;
        var le = vt.responseState, be = te.id, ke = te.errorDigest, ve = te.errorMessage, je = te.errorComponentStack;
        if (Bt.push(le.startInlineScript), le.sentClientRenderFunction ? Bt.push('$RX("') : (le.sentClientRenderFunction = !0, Bt.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), be === null)
          throw Error(r(395));
        if (Bt.push(be), Bt.push('"'), ke || ve || je) {
          Bt.push(",");
          var Mi = S(ke || "");
          Bt.push(Mi);
        }
        if (ve || je) {
          Bt.push(",");
          var mi = S(ve || "");
          Bt.push(mi);
        }
        if (je) {
          Bt.push(",");
          var yi = S(je);
          Bt.push(yi);
        }
        if (!Bt.push(")<\/script>")) {
          vt.destination = null, Xt++, $t.splice(0, Xt);
          return;
        }
      }
      $t.splice(0, Xt);
      var lr = vt.completedBoundaries;
      for (Xt = 0; Xt < lr.length; Xt++)
        if (!Ii(vt, Pt, lr[Xt])) {
          vt.destination = null, Xt++, lr.splice(0, Xt);
          return;
        }
      lr.splice(0, Xt);
      var Xi = vt.partialBoundaries;
      for (Xt = 0; Xt < Xi.length; Xt++) {
        var cr = Xi[Xt];
        t: {
          $t = vt, te = Pt;
          var hr = cr.completedSegments;
          for (le = 0; le < hr.length; le++)
            if (!Br($t, te, cr, hr[le])) {
              le++, hr.splice(0, le);
              var Sr = !1;
              break t;
            }
          hr.splice(0, le), Sr = !0;
        }
        if (!Sr) {
          vt.destination = null, Xt++, Xi.splice(0, Xt);
          return;
        }
      }
      Xi.splice(0, Xt);
      var Ji = vt.completedBoundaries;
      for (Xt = 0; Xt < Ji.length; Xt++)
        if (!Ii(vt, Pt, Ji[Xt])) {
          vt.destination = null, Xt++, Ji.splice(0, Xt);
          return;
        }
      Ji.splice(0, Xt);
    } finally {
      vt.allPendingTasks === 0 && vt.pingedTasks.length === 0 && vt.clientRenderedBoundaries.length === 0 && vt.completedBoundaries.length === 0 && Pt.push(null);
    }
  }
  function Ti(vt, Pt) {
    try {
      var jt = vt.abortableTasks;
      jt.forEach(function(Bt) {
        return sr(Bt, vt, Pt);
      }), jt.clear(), vt.destination !== null && ii(vt, vt.destination);
    } catch (Bt) {
      Ce(vt, Bt), bi(vt, Bt);
    }
  }
  function Nr() {
  }
  function qi(vt, Pt, jt, Bt) {
    var $t = !1, Xt = null, te = "", le = { push: function(ke) {
      return ke !== null && (te += ke), !0;
    }, destroy: function(ke) {
      $t = !0, Xt = ke;
    } }, be = !1;
    if (vt = Ve(vt, u(jt, Pt ? Pt.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, Nr, void 0, function() {
      be = !0;
    }), fi(vt), Ti(vt, Bt), vt.status === 1)
      vt.status = 2, le.destroy(vt.fatalError);
    else if (vt.status !== 2 && vt.destination === null) {
      vt.destination = le;
      try {
        ii(vt, le);
      } catch (ke) {
        Ce(vt, ke), bi(vt, ke);
      }
    }
    if ($t)
      throw Xt;
    if (!be)
      throw Error(r(426));
    return te;
  }
  return Ro.renderToNodeStream = function() {
    throw Error(r(207));
  }, Ro.renderToStaticMarkup = function(vt, Pt) {
    return qi(vt, Pt, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Ro.renderToStaticNodeStream = function() {
    throw Error(r(208));
  }, Ro.renderToString = function(vt, Pt) {
    return qi(vt, Pt, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Ro.version = "18.3.1", Ro;
}
var Zc = {};
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kg;
function lE() {
  if (kg)
    return Zc;
  kg = 1;
  var t = Oh;
  function r(bt) {
    for (var At = "https://reactjs.org/docs/error-decoder.html?invariant=" + bt, It = 1; It < arguments.length; It++)
      At += "&args[]=" + encodeURIComponent(arguments[It]);
    return "Minified React error #" + bt + "; visit " + At + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var f = null, B = 0;
  function H(bt, At) {
    if (At.length !== 0)
      if (512 < At.length)
        0 < B && (bt.enqueue(new Uint8Array(f.buffer, 0, B)), f = new Uint8Array(512), B = 0), bt.enqueue(At);
      else {
        var It = f.length - B;
        It < At.length && (It === 0 ? bt.enqueue(f) : (f.set(At.subarray(0, It), B), bt.enqueue(f), At = At.subarray(It)), f = new Uint8Array(512), B = 0), f.set(At, B), B += At.length;
      }
  }
  function tt(bt, At) {
    return H(bt, At), !0;
  }
  function st(bt) {
    f && 0 < B && (bt.enqueue(new Uint8Array(f.buffer, 0, B)), f = null, B = 0);
  }
  var lt = new TextEncoder();
  function ht(bt) {
    return lt.encode(bt);
  }
  function ut(bt) {
    return lt.encode(bt);
  }
  function yt(bt, At) {
    typeof bt.error == "function" ? bt.error(At) : bt.close();
  }
  var gt = Object.prototype.hasOwnProperty, _ = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, at = {}, G = {};
  function F(bt) {
    return gt.call(G, bt) ? !0 : gt.call(at, bt) ? !1 : _.test(bt) ? G[bt] = !0 : (at[bt] = !0, !1);
  }
  function $(bt, At, It, _t, Zt, Vt, re) {
    this.acceptsBooleans = At === 2 || At === 3 || At === 4, this.attributeName = _t, this.attributeNamespace = Zt, this.mustUseProperty = It, this.propertyName = bt, this.type = At, this.sanitizeURL = Vt, this.removeEmptyString = re;
  }
  var Y = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(bt) {
    Y[bt] = new $(bt, 0, !1, bt, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(bt) {
    var At = bt[0];
    Y[At] = new $(At, 1, !1, bt[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(bt) {
    Y[bt] = new $(bt, 2, !1, bt.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(bt) {
    Y[bt] = new $(bt, 2, !1, bt, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(bt) {
    Y[bt] = new $(bt, 3, !1, bt.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(bt) {
    Y[bt] = new $(bt, 3, !0, bt, null, !1, !1);
  }), ["capture", "download"].forEach(function(bt) {
    Y[bt] = new $(bt, 4, !1, bt, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(bt) {
    Y[bt] = new $(bt, 6, !1, bt, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(bt) {
    Y[bt] = new $(bt, 5, !1, bt.toLowerCase(), null, !1, !1);
  });
  var J = /[\-:]([a-z])/g;
  function Q(bt) {
    return bt[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(bt) {
    var At = bt.replace(
      J,
      Q
    );
    Y[At] = new $(At, 1, !1, bt, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(bt) {
    var At = bt.replace(J, Q);
    Y[At] = new $(At, 1, !1, bt, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(bt) {
    var At = bt.replace(J, Q);
    Y[At] = new $(At, 1, !1, bt, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(bt) {
    Y[bt] = new $(bt, 1, !1, bt.toLowerCase(), null, !1, !1);
  }), Y.xlinkHref = new $("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(bt) {
    Y[bt] = new $(bt, 1, !1, bt.toLowerCase(), null, !0, !0);
  });
  var q = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, U = ["Webkit", "ms", "Moz", "O"];
  Object.keys(q).forEach(function(bt) {
    U.forEach(function(At) {
      At = At + bt.charAt(0).toUpperCase() + bt.substring(1), q[At] = q[bt];
    });
  });
  var N = /["'&<>]/;
  function D(bt) {
    if (typeof bt == "boolean" || typeof bt == "number")
      return "" + bt;
    bt = "" + bt;
    var At = N.exec(bt);
    if (At) {
      var It = "", _t, Zt = 0;
      for (_t = At.index; _t < bt.length; _t++) {
        switch (bt.charCodeAt(_t)) {
          case 34:
            At = "&quot;";
            break;
          case 38:
            At = "&amp;";
            break;
          case 39:
            At = "&#x27;";
            break;
          case 60:
            At = "&lt;";
            break;
          case 62:
            At = "&gt;";
            break;
          default:
            continue;
        }
        Zt !== _t && (It += bt.substring(Zt, _t)), Zt = _t + 1, It += At;
      }
      bt = Zt !== _t ? It + bt.substring(Zt, _t) : It;
    }
    return bt;
  }
  var k = /([A-Z])/g, A = /^ms-/, b = Array.isArray, d = ut("<script>"), m = ut("<\/script>"), v = ut('<script src="'), g = ut('<script type="module" src="'), x = ut('" async=""><\/script>'), E = /(<\/|<)(s)(cript)/gi;
  function P(bt, At, It, _t) {
    return "" + At + (It === "s" ? "\\u0073" : "\\u0053") + _t;
  }
  function S(bt, At, It, _t, Zt) {
    bt = bt === void 0 ? "" : bt, At = At === void 0 ? d : ut('<script nonce="' + D(At) + '">');
    var Vt = [];
    if (It !== void 0 && Vt.push(At, ht(("" + It).replace(E, P)), m), _t !== void 0)
      for (It = 0; It < _t.length; It++)
        Vt.push(v, ht(D(_t[It])), x);
    if (Zt !== void 0)
      for (_t = 0; _t < Zt.length; _t++)
        Vt.push(g, ht(D(Zt[_t])), x);
    return { bootstrapChunks: Vt, startInlineScript: At, placeholderPrefix: ut(bt + "P:"), segmentPrefix: ut(bt + "S:"), boundaryPrefix: bt + "B:", idPrefix: bt, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function u(bt, At) {
    return { insertionMode: bt, selectedValue: At };
  }
  function y(bt) {
    return u(bt === "http://www.w3.org/2000/svg" ? 2 : bt === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function s(bt, At, It) {
    switch (At) {
      case "select":
        return u(1, It.value != null ? It.value : It.defaultValue);
      case "svg":
        return u(2, null);
      case "math":
        return u(3, null);
      case "foreignObject":
        return u(1, null);
      case "table":
        return u(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return u(5, null);
      case "colgroup":
        return u(7, null);
      case "tr":
        return u(6, null);
    }
    return 4 <= bt.insertionMode || bt.insertionMode === 0 ? u(1, null) : bt;
  }
  var a = ut("<!-- -->");
  function e(bt, At, It, _t) {
    return At === "" ? _t : (_t && bt.push(a), bt.push(ht(D(At))), !0);
  }
  var n = /* @__PURE__ */ new Map(), o = ut(' style="'), i = ut(":"), c = ut(";");
  function l(bt, At, It) {
    if (typeof It != "object")
      throw Error(r(62));
    At = !0;
    for (var _t in It)
      if (gt.call(It, _t)) {
        var Zt = It[_t];
        if (Zt != null && typeof Zt != "boolean" && Zt !== "") {
          if (_t.indexOf("--") === 0) {
            var Vt = ht(D(_t));
            Zt = ht(D(("" + Zt).trim()));
          } else {
            Vt = _t;
            var re = n.get(Vt);
            re !== void 0 || (re = ut(D(Vt.replace(k, "-$1").toLowerCase().replace(A, "-ms-"))), n.set(Vt, re)), Vt = re, Zt = typeof Zt == "number" ? Zt === 0 || gt.call(q, _t) ? ht("" + Zt) : ht(Zt + "px") : ht(D(("" + Zt).trim()));
          }
          At ? (At = !1, bt.push(o, Vt, i, Zt)) : bt.push(c, Vt, i, Zt);
        }
      }
    At || bt.push(M);
  }
  var h = ut(" "), C = ut('="'), M = ut('"'), O = ut('=""');
  function p(bt, At, It, _t) {
    switch (It) {
      case "style":
        l(bt, At, _t);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < It.length) || It[0] !== "o" && It[0] !== "O" || It[1] !== "n" && It[1] !== "N") {
      if (At = Y.hasOwnProperty(It) ? Y[It] : null, At !== null) {
        switch (typeof _t) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!At.acceptsBooleans)
              return;
        }
        switch (It = ht(At.attributeName), At.type) {
          case 3:
            _t && bt.push(h, It, O);
            break;
          case 4:
            _t === !0 ? bt.push(h, It, O) : _t !== !1 && bt.push(h, It, C, ht(D(_t)), M);
            break;
          case 5:
            isNaN(_t) || bt.push(h, It, C, ht(D(_t)), M);
            break;
          case 6:
            !isNaN(_t) && 1 <= _t && bt.push(h, It, C, ht(D(_t)), M);
            break;
          default:
            At.sanitizeURL && (_t = "" + _t), bt.push(h, It, C, ht(D(_t)), M);
        }
      } else if (F(It)) {
        switch (typeof _t) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (At = It.toLowerCase().slice(0, 5), At !== "data-" && At !== "aria-")
              return;
        }
        bt.push(h, ht(It), C, ht(D(_t)), M);
      }
    }
  }
  var w = ut(">"), T = ut("/>");
  function z(bt, At, It) {
    if (At != null) {
      if (It != null)
        throw Error(r(60));
      if (typeof At != "object" || !("__html" in At))
        throw Error(r(61));
      At = At.__html, At != null && bt.push(ht("" + At));
    }
  }
  function W(bt) {
    var At = "";
    return t.Children.forEach(bt, function(It) {
      It != null && (At += It);
    }), At;
  }
  var L = ut(' selected=""');
  function I(bt, At, It, _t) {
    bt.push(X(It));
    var Zt = It = null, Vt;
    for (Vt in At)
      if (gt.call(At, Vt)) {
        var re = At[Vt];
        if (re != null)
          switch (Vt) {
            case "children":
              It = re;
              break;
            case "dangerouslySetInnerHTML":
              Zt = re;
              break;
            default:
              p(bt, _t, Vt, re);
          }
      }
    return bt.push(w), z(bt, Zt, It), typeof It == "string" ? (bt.push(ht(D(It))), null) : It;
  }
  var j = ut(`
`), Z = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, V = /* @__PURE__ */ new Map();
  function X(bt) {
    var At = V.get(bt);
    if (At === void 0) {
      if (!Z.test(bt))
        throw Error(r(65, bt));
      At = ut("<" + bt), V.set(bt, At);
    }
    return At;
  }
  var et = ut("<!DOCTYPE html>");
  function ot(bt, At, It, _t, Zt) {
    switch (At) {
      case "select":
        bt.push(X("select"));
        var Vt = null, re = null;
        for (Pe in It)
          if (gt.call(It, Pe)) {
            var ce = It[Pe];
            if (ce != null)
              switch (Pe) {
                case "children":
                  Vt = ce;
                  break;
                case "dangerouslySetInnerHTML":
                  re = ce;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  p(bt, _t, Pe, ce);
              }
          }
        return bt.push(w), z(bt, re, Vt), Vt;
      case "option":
        re = Zt.selectedValue, bt.push(X("option"));
        var we = ce = null, Oe = null, Pe = null;
        for (Vt in It)
          if (gt.call(It, Vt)) {
            var Ge = It[Vt];
            if (Ge != null)
              switch (Vt) {
                case "children":
                  ce = Ge;
                  break;
                case "selected":
                  Oe = Ge;
                  break;
                case "dangerouslySetInnerHTML":
                  Pe = Ge;
                  break;
                case "value":
                  we = Ge;
                default:
                  p(bt, _t, Vt, Ge);
              }
          }
        if (re != null)
          if (It = we !== null ? "" + we : W(ce), b(re)) {
            for (_t = 0; _t < re.length; _t++)
              if ("" + re[_t] === It) {
                bt.push(L);
                break;
              }
          } else
            "" + re === It && bt.push(L);
        else
          Oe && bt.push(L);
        return bt.push(w), z(bt, Pe, ce), ce;
      case "textarea":
        bt.push(X("textarea")), Pe = re = Vt = null;
        for (ce in It)
          if (gt.call(It, ce) && (we = It[ce], we != null))
            switch (ce) {
              case "children":
                Pe = we;
                break;
              case "value":
                Vt = we;
                break;
              case "defaultValue":
                re = we;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(r(91));
              default:
                p(bt, _t, ce, we);
            }
        if (Vt === null && re !== null && (Vt = re), bt.push(w), Pe != null) {
          if (Vt != null)
            throw Error(r(92));
          if (b(Pe) && 1 < Pe.length)
            throw Error(r(93));
          Vt = "" + Pe;
        }
        return typeof Vt == "string" && Vt[0] === `
` && bt.push(j), Vt !== null && bt.push(ht(D("" + Vt))), null;
      case "input":
        bt.push(X("input")), we = Pe = ce = Vt = null;
        for (re in It)
          if (gt.call(It, re) && (Oe = It[re], Oe != null))
            switch (re) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(399, "input"));
              case "defaultChecked":
                we = Oe;
                break;
              case "defaultValue":
                ce = Oe;
                break;
              case "checked":
                Pe = Oe;
                break;
              case "value":
                Vt = Oe;
                break;
              default:
                p(bt, _t, re, Oe);
            }
        return Pe !== null ? p(
          bt,
          _t,
          "checked",
          Pe
        ) : we !== null && p(bt, _t, "checked", we), Vt !== null ? p(bt, _t, "value", Vt) : ce !== null && p(bt, _t, "value", ce), bt.push(T), null;
      case "menuitem":
        bt.push(X("menuitem"));
        for (var wi in It)
          if (gt.call(It, wi) && (Vt = It[wi], Vt != null))
            switch (wi) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(400));
              default:
                p(bt, _t, wi, Vt);
            }
        return bt.push(w), null;
      case "title":
        bt.push(X("title")), Vt = null;
        for (Ge in It)
          if (gt.call(It, Ge) && (re = It[Ge], re != null))
            switch (Ge) {
              case "children":
                Vt = re;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(r(434));
              default:
                p(bt, _t, Ge, re);
            }
        return bt.push(w), Vt;
      case "listing":
      case "pre":
        bt.push(X(At)), re = Vt = null;
        for (we in It)
          if (gt.call(It, we) && (ce = It[we], ce != null))
            switch (we) {
              case "children":
                Vt = ce;
                break;
              case "dangerouslySetInnerHTML":
                re = ce;
                break;
              default:
                p(bt, _t, we, ce);
            }
        if (bt.push(w), re != null) {
          if (Vt != null)
            throw Error(r(60));
          if (typeof re != "object" || !("__html" in re))
            throw Error(r(61));
          It = re.__html, It != null && (typeof It == "string" && 0 < It.length && It[0] === `
` ? bt.push(j, ht(It)) : bt.push(ht("" + It)));
        }
        return typeof Vt == "string" && Vt[0] === `
` && bt.push(j), Vt;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        bt.push(X(At));
        for (var Ri in It)
          if (gt.call(It, Ri) && (Vt = It[Ri], Vt != null))
            switch (Ri) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(399, At));
              default:
                p(bt, _t, Ri, Vt);
            }
        return bt.push(T), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return I(bt, It, At, _t);
      case "html":
        return Zt.insertionMode === 0 && bt.push(et), I(bt, It, At, _t);
      default:
        if (At.indexOf("-") === -1 && typeof It.is != "string")
          return I(bt, It, At, _t);
        bt.push(X(At)), re = Vt = null;
        for (Oe in It)
          if (gt.call(It, Oe) && (ce = It[Oe], ce != null))
            switch (Oe) {
              case "children":
                Vt = ce;
                break;
              case "dangerouslySetInnerHTML":
                re = ce;
                break;
              case "style":
                l(bt, _t, ce);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                F(Oe) && typeof ce != "function" && typeof ce != "symbol" && bt.push(h, ht(Oe), C, ht(D(ce)), M);
            }
        return bt.push(w), z(bt, re, Vt), Vt;
    }
  }
  var it = ut("</"), pt = ut(">"), mt = ut('<template id="'), Ct = ut('"></template>'), kt = ut("<!--$-->"), Lt = ut('<!--$?--><template id="'), Tt = ut('"></template>'), xt = ut("<!--$!-->"), ct = ut("<!--/$-->"), ft = ut("<template"), St = ut('"'), Mt = ut(' data-dgst="');
  ut(' data-msg="'), ut(' data-stck="');
  var Dt = ut("></template>");
  function Ot(bt, At, It) {
    if (H(bt, Lt), It === null)
      throw Error(r(395));
    return H(bt, It), tt(bt, Tt);
  }
  var Nt = ut('<div hidden id="'), Wt = ut('">'), zt = ut("</div>"), Ht = ut('<svg aria-hidden="true" style="display:none" id="'), Kt = ut('">'), Gt = ut("</svg>"), ee = ut('<math aria-hidden="true" style="display:none" id="'), Jt = ut('">'), Qt = ut("</math>"), ne = ut('<table hidden id="'), ae = ut('">'), Me = ut("</table>"), he = ut('<table hidden><tbody id="'), fe = ut('">'), Ee = ut("</tbody></table>"), Xe = ut('<table hidden><tr id="'), Se = ut('">'), Le = ut("</tr></table>"), Ye = ut('<table hidden><colgroup id="'), qt = ut('">'), ue = ut("</colgroup></table>");
  function ye(bt, At, It, _t) {
    switch (It.insertionMode) {
      case 0:
      case 1:
        return H(bt, Nt), H(bt, At.segmentPrefix), H(bt, ht(_t.toString(16))), tt(bt, Wt);
      case 2:
        return H(bt, Ht), H(bt, At.segmentPrefix), H(bt, ht(_t.toString(16))), tt(bt, Kt);
      case 3:
        return H(bt, ee), H(bt, At.segmentPrefix), H(bt, ht(_t.toString(16))), tt(bt, Jt);
      case 4:
        return H(bt, ne), H(bt, At.segmentPrefix), H(bt, ht(_t.toString(16))), tt(bt, ae);
      case 5:
        return H(bt, he), H(bt, At.segmentPrefix), H(bt, ht(_t.toString(16))), tt(bt, fe);
      case 6:
        return H(bt, Xe), H(bt, At.segmentPrefix), H(bt, ht(_t.toString(16))), tt(bt, Se);
      case 7:
        return H(
          bt,
          Ye
        ), H(bt, At.segmentPrefix), H(bt, ht(_t.toString(16))), tt(bt, qt);
      default:
        throw Error(r(397));
    }
  }
  function xe(bt, At) {
    switch (At.insertionMode) {
      case 0:
      case 1:
        return tt(bt, zt);
      case 2:
        return tt(bt, Gt);
      case 3:
        return tt(bt, Qt);
      case 4:
        return tt(bt, Me);
      case 5:
        return tt(bt, Ee);
      case 6:
        return tt(bt, Le);
      case 7:
        return tt(bt, ue);
      default:
        throw Error(r(397));
    }
  }
  var Ve = ut('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), ze = ut('$RS("'), _e = ut('","'), Ce = ut('")<\/script>'), bi = ut('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), ti = ut('$RC("'), pi = ut('","'), Ki = ut('")<\/script>'), ni = ut('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), Fe = ut('$RX("'), Ie = ut('"'), qe = ut(")<\/script>"), si = ut(","), sr = /[<\u2028\u2029]/g;
  function Ui(bt) {
    return JSON.stringify(bt).replace(sr, function(At) {
      switch (At) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var Di = Object.assign, fi = Symbol.for("react.element"), ar = Symbol.for("react.portal"), gi = Symbol.for("react.fragment"), Gi = Symbol.for("react.strict_mode"), Ii = Symbol.for("react.profiler"), Br = Symbol.for("react.provider"), ii = Symbol.for("react.context"), Ti = Symbol.for("react.forward_ref"), Nr = Symbol.for("react.suspense"), qi = Symbol.for("react.suspense_list"), vt = Symbol.for("react.memo"), Pt = Symbol.for("react.lazy"), jt = Symbol.for("react.scope"), Bt = Symbol.for("react.debug_trace_mode"), $t = Symbol.for("react.legacy_hidden"), Xt = Symbol.for("react.default_value"), te = Symbol.iterator;
  function le(bt) {
    if (bt == null)
      return null;
    if (typeof bt == "function")
      return bt.displayName || bt.name || null;
    if (typeof bt == "string")
      return bt;
    switch (bt) {
      case gi:
        return "Fragment";
      case ar:
        return "Portal";
      case Ii:
        return "Profiler";
      case Gi:
        return "StrictMode";
      case Nr:
        return "Suspense";
      case qi:
        return "SuspenseList";
    }
    if (typeof bt == "object")
      switch (bt.$$typeof) {
        case ii:
          return (bt.displayName || "Context") + ".Consumer";
        case Br:
          return (bt._context.displayName || "Context") + ".Provider";
        case Ti:
          var At = bt.render;
          return bt = bt.displayName, bt || (bt = At.displayName || At.name || "", bt = bt !== "" ? "ForwardRef(" + bt + ")" : "ForwardRef"), bt;
        case vt:
          return At = bt.displayName || null, At !== null ? At : le(bt.type) || "Memo";
        case Pt:
          At = bt._payload, bt = bt._init;
          try {
            return le(bt(At));
          } catch (It) {
          }
      }
    return null;
  }
  var be = {};
  function ke(bt, At) {
    if (bt = bt.contextTypes, !bt)
      return be;
    var It = {}, _t;
    for (_t in bt)
      It[_t] = At[_t];
    return It;
  }
  var ve = null;
  function je(bt, At) {
    if (bt !== At) {
      bt.context._currentValue = bt.parentValue, bt = bt.parent;
      var It = At.parent;
      if (bt === null) {
        if (It !== null)
          throw Error(r(401));
      } else {
        if (It === null)
          throw Error(r(401));
        je(bt, It);
      }
      At.context._currentValue = At.value;
    }
  }
  function Mi(bt) {
    bt.context._currentValue = bt.parentValue, bt = bt.parent, bt !== null && Mi(bt);
  }
  function mi(bt) {
    var At = bt.parent;
    At !== null && mi(At), bt.context._currentValue = bt.value;
  }
  function yi(bt, At) {
    if (bt.context._currentValue = bt.parentValue, bt = bt.parent, bt === null)
      throw Error(r(402));
    bt.depth === At.depth ? je(bt, At) : yi(bt, At);
  }
  function lr(bt, At) {
    var It = At.parent;
    if (It === null)
      throw Error(r(402));
    bt.depth === It.depth ? je(bt, It) : lr(bt, It), At.context._currentValue = At.value;
  }
  function Xi(bt) {
    var At = ve;
    At !== bt && (At === null ? mi(bt) : bt === null ? Mi(At) : At.depth === bt.depth ? je(At, bt) : At.depth > bt.depth ? yi(At, bt) : lr(At, bt), ve = bt);
  }
  var cr = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(bt, At) {
    bt = bt._reactInternals, bt.queue !== null && bt.queue.push(At);
  }, enqueueReplaceState: function(bt, At) {
    bt = bt._reactInternals, bt.replace = !0, bt.queue = [At];
  }, enqueueForceUpdate: function() {
  } };
  function hr(bt, At, It, _t) {
    var Zt = bt.state !== void 0 ? bt.state : null;
    bt.updater = cr, bt.props = It, bt.state = Zt;
    var Vt = { queue: [], replace: !1 };
    bt._reactInternals = Vt;
    var re = At.contextType;
    if (bt.context = typeof re == "object" && re !== null ? re._currentValue : _t, re = At.getDerivedStateFromProps, typeof re == "function" && (re = re(It, Zt), Zt = re == null ? Zt : Di({}, Zt, re), bt.state = Zt), typeof At.getDerivedStateFromProps != "function" && typeof bt.getSnapshotBeforeUpdate != "function" && (typeof bt.UNSAFE_componentWillMount == "function" || typeof bt.componentWillMount == "function"))
      if (At = bt.state, typeof bt.componentWillMount == "function" && bt.componentWillMount(), typeof bt.UNSAFE_componentWillMount == "function" && bt.UNSAFE_componentWillMount(), At !== bt.state && cr.enqueueReplaceState(bt, bt.state, null), Vt.queue !== null && 0 < Vt.queue.length)
        if (At = Vt.queue, re = Vt.replace, Vt.queue = null, Vt.replace = !1, re && At.length === 1)
          bt.state = At[0];
        else {
          for (Vt = re ? At[0] : bt.state, Zt = !0, re = re ? 1 : 0; re < At.length; re++) {
            var ce = At[re];
            ce = typeof ce == "function" ? ce.call(bt, Vt, It, _t) : ce, ce != null && (Zt ? (Zt = !1, Vt = Di({}, Vt, ce)) : Di(Vt, ce));
          }
          bt.state = Vt;
        }
      else
        Vt.queue = null;
  }
  var Sr = { id: 1, overflow: "" };
  function Ji(bt, At, It) {
    var _t = bt.id;
    bt = bt.overflow;
    var Zt = 32 - rn(_t) - 1;
    _t &= ~(1 << Zt), It += 1;
    var Vt = 32 - rn(At) + Zt;
    if (30 < Vt) {
      var re = Zt - Zt % 5;
      return Vt = (_t & (1 << re) - 1).toString(32), _t >>= re, Zt -= re, { id: 1 << 32 - rn(At) + Zt | It << Zt | _t, overflow: Vt + bt };
    }
    return { id: 1 << Vt | It << Zt | _t, overflow: bt };
  }
  var rn = Math.clz32 ? Math.clz32 : ao, Vo = Math.log, Yi = Math.LN2;
  function ao(bt) {
    return bt >>>= 0, bt === 0 ? 32 : 31 - (Vo(bt) / Yi | 0) | 0;
  }
  function da(bt, At) {
    return bt === At && (bt !== 0 || 1 / bt === 1 / At) || bt !== bt && At !== At;
  }
  var pa = typeof Object.is == "function" ? Object.is : da, Qi = null, lo = null, bn = null, He = null, wr = !1, xn = !1, Cr = 0, ur = null, Sn = 0;
  function dr() {
    if (Qi === null)
      throw Error(r(321));
    return Qi;
  }
  function xi() {
    if (0 < Sn)
      throw Error(r(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function co() {
    return He === null ? bn === null ? (wr = !1, bn = He = xi()) : (wr = !0, He = bn) : He.next === null ? (wr = !1, He = He.next = xi()) : (wr = !0, He = He.next), He;
  }
  function nn() {
    lo = Qi = null, xn = !1, bn = null, Sn = 0, He = ur = null;
  }
  function $o(bt, At) {
    return typeof At == "function" ? At(bt) : At;
  }
  function Zo(bt, At, It) {
    if (Qi = dr(), He = co(), wr) {
      var _t = He.queue;
      if (At = _t.dispatch, ur !== null && (It = ur.get(_t), It !== void 0)) {
        ur.delete(_t), _t = He.memoizedState;
        do
          _t = bt(_t, It.action), It = It.next;
        while (It !== null);
        return He.memoizedState = _t, [_t, At];
      }
      return [He.memoizedState, At];
    }
    return bt = bt === $o ? typeof At == "function" ? At() : At : It !== void 0 ? It(At) : At, He.memoizedState = bt, bt = He.queue = { last: null, dispatch: null }, bt = bt.dispatch = fa.bind(null, Qi, bt), [He.memoizedState, bt];
  }
  function Ko(bt, At) {
    if (Qi = dr(), He = co(), At = At === void 0 ? null : At, He !== null) {
      var It = He.memoizedState;
      if (It !== null && At !== null) {
        var _t = It[1];
        t:
          if (_t === null)
            _t = !1;
          else {
            for (var Zt = 0; Zt < _t.length && Zt < At.length; Zt++)
              if (!pa(At[Zt], _t[Zt])) {
                _t = !1;
                break t;
              }
            _t = !0;
          }
        if (_t)
          return It[0];
      }
    }
    return bt = bt(), He.memoizedState = [bt, At], bt;
  }
  function fa(bt, At, It) {
    if (25 <= Sn)
      throw Error(r(301));
    if (bt === Qi)
      if (xn = !0, bt = { action: It, next: null }, ur === null && (ur = /* @__PURE__ */ new Map()), It = ur.get(At), It === void 0)
        ur.set(At, bt);
      else {
        for (At = It; At.next !== null; )
          At = At.next;
        At.next = bt;
      }
  }
  function ga() {
    throw Error(r(394));
  }
  function on() {
  }
  var qo = { readContext: function(bt) {
    return bt._currentValue;
  }, useContext: function(bt) {
    return dr(), bt._currentValue;
  }, useMemo: Ko, useReducer: Zo, useRef: function(bt) {
    Qi = dr(), He = co();
    var At = He.memoizedState;
    return At === null ? (bt = { current: bt }, He.memoizedState = bt) : At;
  }, useState: function(bt) {
    return Zo($o, bt);
  }, useInsertionEffect: on, useLayoutEffect: function() {
  }, useCallback: function(bt, At) {
    return Ko(function() {
      return bt;
    }, At);
  }, useImperativeHandle: on, useEffect: on, useDebugValue: on, useDeferredValue: function(bt) {
    return dr(), bt;
  }, useTransition: function() {
    return dr(), [!1, ga];
  }, useId: function() {
    var bt = lo.treeContext, At = bt.overflow;
    bt = bt.id, bt = (bt & ~(1 << 32 - rn(bt) - 1)).toString(32) + At;
    var It = wn;
    if (It === null)
      throw Error(r(404));
    return At = Cr++, bt = ":" + It.idPrefix + "R" + bt, 0 < At && (bt += "H" + At.toString(32)), bt + ":";
  }, useMutableSource: function(bt, At) {
    return dr(), At(bt._source);
  }, useSyncExternalStore: function(bt, At, It) {
    if (It === void 0)
      throw Error(r(407));
    return It();
  } }, wn = null, Cn = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function ma(bt) {
    return console.error(bt), null;
  }
  function sn() {
  }
  function ho(bt, At, It, _t, Zt, Vt, re, ce, we) {
    var Oe = [], Pe = /* @__PURE__ */ new Set();
    return At = { destination: null, responseState: At, progressiveChunkSize: _t === void 0 ? 12800 : _t, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: Pe, pingedTasks: Oe, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: Zt === void 0 ? ma : Zt, onAllReady: Vt === void 0 ? sn : Vt, onShellReady: re === void 0 ? sn : re, onShellError: ce === void 0 ? sn : ce, onFatalError: we === void 0 ? sn : we }, It = zr(At, 0, null, It, !1, !1), It.parentFlushed = !0, bt = uo(At, bt, null, It, Pe, be, null, Sr), Oe.push(bt), At;
  }
  function uo(bt, At, It, _t, Zt, Vt, re, ce) {
    bt.allPendingTasks++, It === null ? bt.pendingRootTasks++ : It.pendingTasks++;
    var we = { node: At, ping: function() {
      var Oe = bt.pingedTasks;
      Oe.push(we), Oe.length === 1 && ns(bt);
    }, blockedBoundary: It, blockedSegment: _t, abortSet: Zt, legacyContext: Vt, context: re, treeContext: ce };
    return Zt.add(we), we;
  }
  function zr(bt, At, It, _t, Zt, Vt) {
    return { status: 0, id: -1, index: At, parentFlushed: !1, chunks: [], children: [], formatContext: _t, boundary: It, lastPushedText: Zt, textEmbedded: Vt };
  }
  function an(bt, At) {
    if (bt = bt.onError(At), bt != null && typeof bt != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof bt + '" instead');
    return bt;
  }
  function kn(bt, At) {
    var It = bt.onShellError;
    It(At), It = bt.onFatalError, It(At), bt.destination !== null ? (bt.status = 2, yt(bt.destination, At)) : (bt.status = 1, bt.fatalError = At);
  }
  function Jo(bt, At, It, _t, Zt) {
    for (Qi = {}, lo = At, Cr = 0, bt = It(_t, Zt); xn; )
      xn = !1, Cr = 0, Sn += 1, He = null, bt = It(_t, Zt);
    return nn(), bt;
  }
  function Qo(bt, At, It, _t) {
    var Zt = It.render(), Vt = _t.childContextTypes;
    if (Vt != null) {
      var re = At.legacyContext;
      if (typeof It.getChildContext != "function")
        _t = re;
      else {
        It = It.getChildContext();
        for (var ce in It)
          if (!(ce in Vt))
            throw Error(r(108, le(_t) || "Unknown", ce));
        _t = Di({}, re, It);
      }
      At.legacyContext = _t, Si(bt, At, Zt), At.legacyContext = re;
    } else
      Si(bt, At, Zt);
  }
  function ts(bt, At) {
    if (bt && bt.defaultProps) {
      At = Di({}, At), bt = bt.defaultProps;
      for (var It in bt)
        At[It] === void 0 && (At[It] = bt[It]);
      return At;
    }
    return At;
  }
  function Tn(bt, At, It, _t, Zt) {
    if (typeof It == "function")
      if (It.prototype && It.prototype.isReactComponent) {
        Zt = ke(It, At.legacyContext);
        var Vt = It.contextType;
        Vt = new It(_t, typeof Vt == "object" && Vt !== null ? Vt._currentValue : Zt), hr(Vt, It, _t, Zt), Qo(bt, At, Vt, It);
      } else {
        Vt = ke(It, At.legacyContext), Zt = Jo(bt, At, It, _t, Vt);
        var re = Cr !== 0;
        if (typeof Zt == "object" && Zt !== null && typeof Zt.render == "function" && Zt.$$typeof === void 0)
          hr(Zt, It, _t, Vt), Qo(bt, At, Zt, It);
        else if (re) {
          _t = At.treeContext, At.treeContext = Ji(_t, 1, 0);
          try {
            Si(bt, At, Zt);
          } finally {
            At.treeContext = _t;
          }
        } else
          Si(bt, At, Zt);
      }
    else if (typeof It == "string") {
      switch (Zt = At.blockedSegment, Vt = ot(Zt.chunks, It, _t, bt.responseState, Zt.formatContext), Zt.lastPushedText = !1, re = Zt.formatContext, Zt.formatContext = s(re, It, _t), Mn(bt, At, Vt), Zt.formatContext = re, It) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          Zt.chunks.push(it, ht(It), pt);
      }
      Zt.lastPushedText = !1;
    } else {
      switch (It) {
        case $t:
        case Bt:
        case Gi:
        case Ii:
        case gi:
          Si(bt, At, _t.children);
          return;
        case qi:
          Si(bt, At, _t.children);
          return;
        case jt:
          throw Error(r(343));
        case Nr:
          t: {
            It = At.blockedBoundary, Zt = At.blockedSegment, Vt = _t.fallback, _t = _t.children, re = /* @__PURE__ */ new Set();
            var ce = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: re, errorDigest: null }, we = zr(bt, Zt.chunks.length, ce, Zt.formatContext, !1, !1);
            Zt.children.push(we), Zt.lastPushedText = !1;
            var Oe = zr(bt, 0, null, Zt.formatContext, !1, !1);
            Oe.parentFlushed = !0, At.blockedBoundary = ce, At.blockedSegment = Oe;
            try {
              if (Mn(
                bt,
                At,
                _t
              ), Oe.lastPushedText && Oe.textEmbedded && Oe.chunks.push(a), Oe.status = 1, An(ce, Oe), ce.pendingTasks === 0)
                break t;
            } catch (Pe) {
              Oe.status = 4, ce.forceClientRender = !0, ce.errorDigest = an(bt, Pe);
            } finally {
              At.blockedBoundary = It, At.blockedSegment = Zt;
            }
            At = uo(bt, Vt, It, we, re, At.legacyContext, At.context, At.treeContext), bt.pingedTasks.push(At);
          }
          return;
      }
      if (typeof It == "object" && It !== null)
        switch (It.$$typeof) {
          case Ti:
            if (_t = Jo(bt, At, It.render, _t, Zt), Cr !== 0) {
              It = At.treeContext, At.treeContext = Ji(It, 1, 0);
              try {
                Si(bt, At, _t);
              } finally {
                At.treeContext = It;
              }
            } else
              Si(bt, At, _t);
            return;
          case vt:
            It = It.type, _t = ts(It, _t), Tn(bt, At, It, _t, Zt);
            return;
          case Br:
            if (Zt = _t.children, It = It._context, _t = _t.value, Vt = It._currentValue, It._currentValue = _t, re = ve, ve = _t = { parent: re, depth: re === null ? 0 : re.depth + 1, context: It, parentValue: Vt, value: _t }, At.context = _t, Si(bt, At, Zt), bt = ve, bt === null)
              throw Error(r(403));
            _t = bt.parentValue, bt.context._currentValue = _t === Xt ? bt.context._defaultValue : _t, bt = ve = bt.parent, At.context = bt;
            return;
          case ii:
            _t = _t.children, _t = _t(It._currentValue), Si(bt, At, _t);
            return;
          case Pt:
            Zt = It._init, It = Zt(It._payload), _t = ts(It, _t), Tn(bt, At, It, _t, void 0);
            return;
        }
      throw Error(r(
        130,
        It == null ? It : typeof It,
        ""
      ));
    }
  }
  function Si(bt, At, It) {
    if (At.node = It, typeof It == "object" && It !== null) {
      switch (It.$$typeof) {
        case fi:
          Tn(bt, At, It.type, It.props, It.ref);
          return;
        case ar:
          throw Error(r(257));
        case Pt:
          var _t = It._init;
          It = _t(It._payload), Si(bt, At, It);
          return;
      }
      if (b(It)) {
        es(bt, At, It);
        return;
      }
      if (It === null || typeof It != "object" ? _t = null : (_t = te && It[te] || It["@@iterator"], _t = typeof _t == "function" ? _t : null), _t && (_t = _t.call(It))) {
        if (It = _t.next(), !It.done) {
          var Zt = [];
          do
            Zt.push(It.value), It = _t.next();
          while (!It.done);
          es(bt, At, Zt);
        }
        return;
      }
      throw bt = Object.prototype.toString.call(It), Error(r(31, bt === "[object Object]" ? "object with keys {" + Object.keys(It).join(", ") + "}" : bt));
    }
    typeof It == "string" ? (_t = At.blockedSegment, _t.lastPushedText = e(At.blockedSegment.chunks, It, bt.responseState, _t.lastPushedText)) : typeof It == "number" && (_t = At.blockedSegment, _t.lastPushedText = e(At.blockedSegment.chunks, "" + It, bt.responseState, _t.lastPushedText));
  }
  function es(bt, At, It) {
    for (var _t = It.length, Zt = 0; Zt < _t; Zt++) {
      var Vt = At.treeContext;
      At.treeContext = Ji(Vt, _t, Zt);
      try {
        Mn(bt, At, It[Zt]);
      } finally {
        At.treeContext = Vt;
      }
    }
  }
  function Mn(bt, At, It) {
    var _t = At.blockedSegment.formatContext, Zt = At.legacyContext, Vt = At.context;
    try {
      return Si(bt, At, It);
    } catch (we) {
      if (nn(), typeof we == "object" && we !== null && typeof we.then == "function") {
        It = we;
        var re = At.blockedSegment, ce = zr(bt, re.chunks.length, null, re.formatContext, re.lastPushedText, !0);
        re.children.push(ce), re.lastPushedText = !1, bt = uo(bt, At.node, At.blockedBoundary, ce, At.abortSet, At.legacyContext, At.context, At.treeContext).ping, It.then(bt, bt), At.blockedSegment.formatContext = _t, At.legacyContext = Zt, At.context = Vt, Xi(Vt);
      } else
        throw At.blockedSegment.formatContext = _t, At.legacyContext = Zt, At.context = Vt, Xi(Vt), we;
    }
  }
  function ya(bt) {
    var At = bt.blockedBoundary;
    bt = bt.blockedSegment, bt.status = 3, rs(this, At, bt);
  }
  function is(bt, At, It) {
    var _t = bt.blockedBoundary;
    bt.blockedSegment.status = 3, _t === null ? (At.allPendingTasks--, At.status !== 2 && (At.status = 2, At.destination !== null && At.destination.close())) : (_t.pendingTasks--, _t.forceClientRender || (_t.forceClientRender = !0, bt = It === void 0 ? Error(r(432)) : It, _t.errorDigest = At.onError(bt), _t.parentFlushed && At.clientRenderedBoundaries.push(_t)), _t.fallbackAbortableTasks.forEach(function(Zt) {
      return is(Zt, At, It);
    }), _t.fallbackAbortableTasks.clear(), At.allPendingTasks--, At.allPendingTasks === 0 && (_t = At.onAllReady, _t()));
  }
  function An(bt, At) {
    if (At.chunks.length === 0 && At.children.length === 1 && At.children[0].boundary === null) {
      var It = At.children[0];
      It.id = At.id, It.parentFlushed = !0, It.status === 1 && An(bt, It);
    } else
      bt.completedSegments.push(At);
  }
  function rs(bt, At, It) {
    if (At === null) {
      if (It.parentFlushed) {
        if (bt.completedRootSegment !== null)
          throw Error(r(389));
        bt.completedRootSegment = It;
      }
      bt.pendingRootTasks--, bt.pendingRootTasks === 0 && (bt.onShellError = sn, At = bt.onShellReady, At());
    } else
      At.pendingTasks--, At.forceClientRender || (At.pendingTasks === 0 ? (It.parentFlushed && It.status === 1 && An(At, It), At.parentFlushed && bt.completedBoundaries.push(At), At.fallbackAbortableTasks.forEach(ya, bt), At.fallbackAbortableTasks.clear()) : It.parentFlushed && It.status === 1 && (An(At, It), At.completedSegments.length === 1 && At.parentFlushed && bt.partialBoundaries.push(At)));
    bt.allPendingTasks--, bt.allPendingTasks === 0 && (bt = bt.onAllReady, bt());
  }
  function ns(bt) {
    if (bt.status !== 2) {
      var At = ve, It = Cn.current;
      Cn.current = qo;
      var _t = wn;
      wn = bt.responseState;
      try {
        var Zt = bt.pingedTasks, Vt;
        for (Vt = 0; Vt < Zt.length; Vt++) {
          var re = Zt[Vt], ce = bt, we = re.blockedSegment;
          if (we.status === 0) {
            Xi(re.context);
            try {
              Si(ce, re, re.node), we.lastPushedText && we.textEmbedded && we.chunks.push(a), re.abortSet.delete(re), we.status = 1, rs(ce, re.blockedBoundary, we);
            } catch (ji) {
              if (nn(), typeof ji == "object" && ji !== null && typeof ji.then == "function") {
                var Oe = re.ping;
                ji.then(Oe, Oe);
              } else {
                re.abortSet.delete(re), we.status = 4;
                var Pe = re.blockedBoundary, Ge = ji, wi = an(ce, Ge);
                if (Pe === null ? kn(ce, Ge) : (Pe.pendingTasks--, Pe.forceClientRender || (Pe.forceClientRender = !0, Pe.errorDigest = wi, Pe.parentFlushed && ce.clientRenderedBoundaries.push(Pe))), ce.allPendingTasks--, ce.allPendingTasks === 0) {
                  var Ri = ce.onAllReady;
                  Ri();
                }
              }
            } finally {
            }
          }
        }
        Zt.splice(0, Vt), bt.destination !== null && po(bt, bt.destination);
      } catch (ji) {
        an(bt, ji), kn(bt, ji);
      } finally {
        wn = _t, Cn.current = It, It === qo && Xi(At);
      }
    }
  }
  function Pn(bt, At, It) {
    switch (It.parentFlushed = !0, It.status) {
      case 0:
        var _t = It.id = bt.nextSegmentId++;
        return It.lastPushedText = !1, It.textEmbedded = !1, bt = bt.responseState, H(At, mt), H(At, bt.placeholderPrefix), bt = ht(_t.toString(16)), H(At, bt), tt(At, Ct);
      case 1:
        It.status = 2;
        var Zt = !0;
        _t = It.chunks;
        var Vt = 0;
        It = It.children;
        for (var re = 0; re < It.length; re++) {
          for (Zt = It[re]; Vt < Zt.index; Vt++)
            H(At, _t[Vt]);
          Zt = En(bt, At, Zt);
        }
        for (; Vt < _t.length - 1; Vt++)
          H(At, _t[Vt]);
        return Vt < _t.length && (Zt = tt(At, _t[Vt])), Zt;
      default:
        throw Error(r(390));
    }
  }
  function En(bt, At, It) {
    var _t = It.boundary;
    if (_t === null)
      return Pn(bt, At, It);
    if (_t.parentFlushed = !0, _t.forceClientRender)
      _t = _t.errorDigest, tt(At, xt), H(At, ft), _t && (H(At, Mt), H(At, ht(D(_t))), H(At, St)), tt(At, Dt), Pn(bt, At, It);
    else if (0 < _t.pendingTasks) {
      _t.rootSegmentID = bt.nextSegmentId++, 0 < _t.completedSegments.length && bt.partialBoundaries.push(_t);
      var Zt = bt.responseState, Vt = Zt.nextSuspenseID++;
      Zt = ut(Zt.boundaryPrefix + Vt.toString(16)), _t = _t.id = Zt, Ot(At, bt.responseState, _t), Pn(bt, At, It);
    } else if (_t.byteSize > bt.progressiveChunkSize)
      _t.rootSegmentID = bt.nextSegmentId++, bt.completedBoundaries.push(_t), Ot(At, bt.responseState, _t.id), Pn(bt, At, It);
    else {
      if (tt(At, kt), It = _t.completedSegments, It.length !== 1)
        throw Error(r(391));
      En(bt, At, It[0]);
    }
    return tt(At, ct);
  }
  function os(bt, At, It) {
    return ye(At, bt.responseState, It.formatContext, It.id), En(bt, At, It), xe(At, It.formatContext);
  }
  function ss(bt, At, It) {
    for (var _t = It.completedSegments, Zt = 0; Zt < _t.length; Zt++)
      as(bt, At, It, _t[Zt]);
    if (_t.length = 0, bt = bt.responseState, _t = It.id, It = It.rootSegmentID, H(At, bt.startInlineScript), bt.sentCompleteBoundaryFunction ? H(At, ti) : (bt.sentCompleteBoundaryFunction = !0, H(At, bi)), _t === null)
      throw Error(r(395));
    return It = ht(It.toString(16)), H(At, _t), H(At, pi), H(At, bt.segmentPrefix), H(At, It), tt(At, Ki);
  }
  function as(bt, At, It, _t) {
    if (_t.status === 2)
      return !0;
    var Zt = _t.id;
    if (Zt === -1) {
      if ((_t.id = It.rootSegmentID) === -1)
        throw Error(r(392));
      return os(bt, At, _t);
    }
    return os(bt, At, _t), bt = bt.responseState, H(At, bt.startInlineScript), bt.sentCompleteSegmentFunction ? H(At, ze) : (bt.sentCompleteSegmentFunction = !0, H(At, Ve)), H(At, bt.segmentPrefix), Zt = ht(Zt.toString(16)), H(At, Zt), H(At, _e), H(At, bt.placeholderPrefix), H(At, Zt), tt(At, Ce);
  }
  function po(bt, At) {
    f = new Uint8Array(512), B = 0;
    try {
      var It = bt.completedRootSegment;
      if (It !== null && bt.pendingRootTasks === 0) {
        En(bt, At, It), bt.completedRootSegment = null;
        var _t = bt.responseState.bootstrapChunks;
        for (It = 0; It < _t.length - 1; It++)
          H(At, _t[It]);
        It < _t.length && tt(At, _t[It]);
      }
      var Zt = bt.clientRenderedBoundaries, Vt;
      for (Vt = 0; Vt < Zt.length; Vt++) {
        var re = Zt[Vt];
        _t = At;
        var ce = bt.responseState, we = re.id, Oe = re.errorDigest, Pe = re.errorMessage, Ge = re.errorComponentStack;
        if (H(_t, ce.startInlineScript), ce.sentClientRenderFunction ? H(_t, Fe) : (ce.sentClientRenderFunction = !0, H(
          _t,
          ni
        )), we === null)
          throw Error(r(395));
        H(_t, we), H(_t, Ie), (Oe || Pe || Ge) && (H(_t, si), H(_t, ht(Ui(Oe || "")))), (Pe || Ge) && (H(_t, si), H(_t, ht(Ui(Pe || "")))), Ge && (H(_t, si), H(_t, ht(Ui(Ge)))), tt(_t, qe);
      }
      Zt.splice(0, Vt);
      var wi = bt.completedBoundaries;
      for (Vt = 0; Vt < wi.length; Vt++)
        ss(bt, At, wi[Vt]);
      wi.splice(0, Vt), st(At), f = new Uint8Array(512), B = 0;
      var Ri = bt.partialBoundaries;
      for (Vt = 0; Vt < Ri.length; Vt++) {
        var ji = Ri[Vt];
        t: {
          Zt = bt, re = At;
          var Fr = ji.completedSegments;
          for (ce = 0; ce < Fr.length; ce++)
            if (!as(
              Zt,
              re,
              ji,
              Fr[ce]
            )) {
              ce++, Fr.splice(0, ce);
              var cs = !1;
              break t;
            }
          Fr.splice(0, ce), cs = !0;
        }
        if (!cs) {
          bt.destination = null, Vt++, Ri.splice(0, Vt);
          return;
        }
      }
      Ri.splice(0, Vt);
      var fo = bt.completedBoundaries;
      for (Vt = 0; Vt < fo.length; Vt++)
        ss(bt, At, fo[Vt]);
      fo.splice(0, Vt);
    } finally {
      st(At), bt.allPendingTasks === 0 && bt.pingedTasks.length === 0 && bt.clientRenderedBoundaries.length === 0 && bt.completedBoundaries.length === 0 && At.close();
    }
  }
  function ls(bt, At) {
    try {
      var It = bt.abortableTasks;
      It.forEach(function(_t) {
        return is(_t, bt, At);
      }), It.clear(), bt.destination !== null && po(bt, bt.destination);
    } catch (_t) {
      an(bt, _t), kn(bt, _t);
    }
  }
  return Zc.renderToReadableStream = function(bt, At) {
    return new Promise(function(It, _t) {
      var Zt, Vt, re = new Promise(function(Pe, Ge) {
        Vt = Pe, Zt = Ge;
      }), ce = ho(bt, S(At ? At.identifierPrefix : void 0, At ? At.nonce : void 0, At ? At.bootstrapScriptContent : void 0, At ? At.bootstrapScripts : void 0, At ? At.bootstrapModules : void 0), y(At ? At.namespaceURI : void 0), At ? At.progressiveChunkSize : void 0, At ? At.onError : void 0, Vt, function() {
        var Pe = new ReadableStream({ type: "bytes", pull: function(Ge) {
          if (ce.status === 1)
            ce.status = 2, yt(Ge, ce.fatalError);
          else if (ce.status !== 2 && ce.destination === null) {
            ce.destination = Ge;
            try {
              po(ce, Ge);
            } catch (wi) {
              an(ce, wi), kn(ce, wi);
            }
          }
        }, cancel: function() {
          ls(ce);
        } }, { highWaterMark: 0 });
        Pe.allReady = re, It(Pe);
      }, function(Pe) {
        re.catch(function() {
        }), _t(Pe);
      }, Zt);
      if (At && At.signal) {
        var we = At.signal, Oe = function() {
          ls(ce, we.reason), we.removeEventListener("abort", Oe);
        };
        we.addEventListener("abort", Oe);
      }
      ns(ce);
    });
  }, Zc.version = "18.3.1", Zc;
}
var jo = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tg;
function cE() {
  return Tg || (Tg = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Oh, r = "18.3.1", f = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function B(rt) {
      {
        for (var R = arguments.length, K = new Array(R > 1 ? R - 1 : 0), nt = 1; nt < R; nt++)
          K[nt - 1] = arguments[nt];
        tt("warn", rt, K);
      }
    }
    function H(rt) {
      {
        for (var R = arguments.length, K = new Array(R > 1 ? R - 1 : 0), nt = 1; nt < R; nt++)
          K[nt - 1] = arguments[nt];
        tt("error", rt, K);
      }
    }
    function tt(rt, R, K) {
      {
        var nt = f.ReactDebugCurrentFrame, dt = nt.getStackAddendum();
        dt !== "" && (R += "%s", K = K.concat([dt]));
        var wt = K.map(function(Et) {
          return String(Et);
        });
        wt.unshift("Warning: " + R), Function.prototype.apply.call(console[rt], console, wt);
      }
    }
    function st(rt) {
      rt();
    }
    function lt(rt, R) {
      ht(rt, R);
    }
    function ht(rt, R) {
      return rt.push(R);
    }
    function ut(rt) {
      rt.push(null);
    }
    function yt(rt) {
      return rt;
    }
    function gt(rt) {
      return rt;
    }
    function _(rt, R) {
      rt.destroy(R);
    }
    function at(rt) {
      {
        var R = typeof Symbol == "function" && Symbol.toStringTag, K = R && rt[Symbol.toStringTag] || rt.constructor.name || "Object";
        return K;
      }
    }
    function G(rt) {
      try {
        return !1;
      } catch (R) {
        return !0;
      }
    }
    function F(rt) {
      return "" + rt;
    }
    function $(rt, R) {
      if (G())
        return H("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", R, at(rt)), F(rt);
    }
    function Y(rt, R) {
      if (G())
        return H("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", R, at(rt)), F(rt);
    }
    function J(rt) {
      if (G())
        return H("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", at(rt)), F(rt);
    }
    var Q = Object.prototype.hasOwnProperty, q = 0, U = 1, N = 2, D = 3, k = 4, A = 5, b = 6, d = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", m = d + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", v = new RegExp("^[" + d + "][" + m + "]*$"), g = {}, x = {};
    function E(rt) {
      return Q.call(x, rt) ? !0 : Q.call(g, rt) ? !1 : v.test(rt) ? (x[rt] = !0, !0) : (g[rt] = !0, H("Invalid attribute name: `%s`", rt), !1);
    }
    function P(rt, R, K, nt) {
      if (K !== null && K.type === q)
        return !1;
      switch (typeof R) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (K !== null)
            return !K.acceptsBooleans;
          var dt = rt.toLowerCase().slice(0, 5);
          return dt !== "data-" && dt !== "aria-";
        }
        default:
          return !1;
      }
    }
    function S(rt) {
      return y.hasOwnProperty(rt) ? y[rt] : null;
    }
    function u(rt, R, K, nt, dt, wt, Et) {
      this.acceptsBooleans = R === N || R === D || R === k, this.attributeName = nt, this.attributeNamespace = dt, this.mustUseProperty = K, this.propertyName = rt, this.type = R, this.sanitizeURL = wt, this.removeEmptyString = Et;
    }
    var y = {}, s = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    s.forEach(function(rt) {
      y[rt] = new u(
        rt,
        q,
        !1,
        // mustUseProperty
        rt,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(rt) {
      var R = rt[0], K = rt[1];
      y[R] = new u(
        R,
        U,
        !1,
        // mustUseProperty
        K,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(rt) {
      y[rt] = new u(
        rt,
        N,
        !1,
        // mustUseProperty
        rt.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(rt) {
      y[rt] = new u(
        rt,
        N,
        !1,
        // mustUseProperty
        rt,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(rt) {
      y[rt] = new u(
        rt,
        D,
        !1,
        // mustUseProperty
        rt.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(rt) {
      y[rt] = new u(
        rt,
        D,
        !0,
        // mustUseProperty
        rt,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(rt) {
      y[rt] = new u(
        rt,
        k,
        !1,
        // mustUseProperty
        rt,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(rt) {
      y[rt] = new u(
        rt,
        b,
        !1,
        // mustUseProperty
        rt,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(rt) {
      y[rt] = new u(
        rt,
        A,
        !1,
        // mustUseProperty
        rt.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var a = /[\-\:]([a-z])/g, e = function(rt) {
      return rt[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(rt) {
      var R = rt.replace(a, e);
      y[R] = new u(
        R,
        U,
        !1,
        // mustUseProperty
        rt,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(rt) {
      var R = rt.replace(a, e);
      y[R] = new u(
        R,
        U,
        !1,
        // mustUseProperty
        rt,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(rt) {
      var R = rt.replace(a, e);
      y[R] = new u(
        R,
        U,
        !1,
        // mustUseProperty
        rt,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(rt) {
      y[rt] = new u(
        rt,
        U,
        !1,
        // mustUseProperty
        rt.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var n = "xlinkHref";
    y[n] = new u(
      "xlinkHref",
      U,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(rt) {
      y[rt] = new u(
        rt,
        U,
        !1,
        // mustUseProperty
        rt.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var o = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function i(rt, R) {
      return rt + R.charAt(0).toUpperCase() + R.substring(1);
    }
    var c = ["Webkit", "ms", "Moz", "O"];
    Object.keys(o).forEach(function(rt) {
      c.forEach(function(R) {
        o[i(R, rt)] = o[rt];
      });
    });
    var l = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function h(rt, R) {
      l[R.type] || R.onChange || R.onInput || R.readOnly || R.disabled || R.value == null || H("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), R.onChange || R.readOnly || R.disabled || R.checked == null || H("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function C(rt, R) {
      if (rt.indexOf("-") === -1)
        return typeof R.is == "string";
      switch (rt) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var M = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, O = {}, p = new RegExp("^(aria)-[" + m + "]*$"), w = new RegExp("^(aria)[A-Z][" + m + "]*$");
    function T(rt, R) {
      {
        if (Q.call(O, R) && O[R])
          return !0;
        if (w.test(R)) {
          var K = "aria-" + R.slice(4).toLowerCase(), nt = M.hasOwnProperty(K) ? K : null;
          if (nt == null)
            return H("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", R), O[R] = !0, !0;
          if (R !== nt)
            return H("Invalid ARIA attribute `%s`. Did you mean `%s`?", R, nt), O[R] = !0, !0;
        }
        if (p.test(R)) {
          var dt = R.toLowerCase(), wt = M.hasOwnProperty(dt) ? dt : null;
          if (wt == null)
            return O[R] = !0, !1;
          if (R !== wt)
            return H("Unknown ARIA attribute `%s`. Did you mean `%s`?", R, wt), O[R] = !0, !0;
        }
      }
      return !0;
    }
    function z(rt, R) {
      {
        var K = [];
        for (var nt in R) {
          var dt = T(rt, nt);
          dt || K.push(nt);
        }
        var wt = K.map(function(Et) {
          return "`" + Et + "`";
        }).join(", ");
        K.length === 1 ? H("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", wt, rt) : K.length > 1 && H("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", wt, rt);
      }
    }
    function W(rt, R) {
      C(rt, R) || z(rt, R);
    }
    var L = !1;
    function I(rt, R) {
      {
        if (rt !== "input" && rt !== "textarea" && rt !== "select")
          return;
        R != null && R.value === null && !L && (L = !0, rt === "select" && R.multiple ? H("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", rt) : H("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", rt));
      }
    }
    var j = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Z = function() {
    };
    {
      var V = {}, X = /^on./, et = /^on[^A-Z]/, ot = new RegExp("^(aria)-[" + m + "]*$"), it = new RegExp("^(aria)[A-Z][" + m + "]*$");
      Z = function(rt, R, K, nt) {
        if (Q.call(V, R) && V[R])
          return !0;
        var dt = R.toLowerCase();
        if (dt === "onfocusin" || dt === "onfocusout")
          return H("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), V[R] = !0, !0;
        if (nt != null) {
          var wt = nt.registrationNameDependencies, Et = nt.possibleRegistrationNames;
          if (wt.hasOwnProperty(R))
            return !0;
          var Rt = Et.hasOwnProperty(dt) ? Et[dt] : null;
          if (Rt != null)
            return H("Invalid event handler property `%s`. Did you mean `%s`?", R, Rt), V[R] = !0, !0;
          if (X.test(R))
            return H("Unknown event handler property `%s`. It will be ignored.", R), V[R] = !0, !0;
        } else if (X.test(R))
          return et.test(R) && H("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", R), V[R] = !0, !0;
        if (ot.test(R) || it.test(R))
          return !0;
        if (dt === "innerhtml")
          return H("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), V[R] = !0, !0;
        if (dt === "aria")
          return H("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), V[R] = !0, !0;
        if (dt === "is" && K !== null && K !== void 0 && typeof K != "string")
          return H("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof K), V[R] = !0, !0;
        if (typeof K == "number" && isNaN(K))
          return H("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", R), V[R] = !0, !0;
        var Ft = S(R), Yt = Ft !== null && Ft.type === q;
        if (j.hasOwnProperty(dt)) {
          var ie = j[dt];
          if (ie !== R)
            return H("Invalid DOM property `%s`. Did you mean `%s`?", R, ie), V[R] = !0, !0;
        } else if (!Yt && R !== dt)
          return H("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", R, dt), V[R] = !0, !0;
        return typeof K == "boolean" && P(R, K, Ft) ? (K ? H('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', K, R, R, K, R) : H('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', K, R, R, K, R, R, R), V[R] = !0, !0) : Yt ? !0 : P(R, K, Ft) ? (V[R] = !0, !1) : ((K === "false" || K === "true") && Ft !== null && Ft.type === D && (H("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", K, R, K === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', R, K), V[R] = !0), !0);
      };
    }
    var pt = function(rt, R, K) {
      {
        var nt = [];
        for (var dt in R) {
          var wt = Z(rt, dt, R[dt], K);
          wt || nt.push(dt);
        }
        var Et = nt.map(function(Rt) {
          return "`" + Rt + "`";
        }).join(", ");
        nt.length === 1 ? H("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Et, rt) : nt.length > 1 && H("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Et, rt);
      }
    };
    function mt(rt, R, K) {
      C(rt, R) || pt(rt, R, K);
    }
    var Ct = function() {
    };
    {
      var kt = /^(?:webkit|moz|o)[A-Z]/, Lt = /^-ms-/, Tt = /-(.)/g, xt = /;\s*$/, ct = {}, ft = {}, St = !1, Mt = !1, Dt = function(rt) {
        return rt.replace(Tt, function(R, K) {
          return K.toUpperCase();
        });
      }, Ot = function(rt) {
        ct.hasOwnProperty(rt) && ct[rt] || (ct[rt] = !0, H(
          "Unsupported style property %s. Did you mean %s?",
          rt,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Dt(rt.replace(Lt, "ms-"))
        ));
      }, Nt = function(rt) {
        ct.hasOwnProperty(rt) && ct[rt] || (ct[rt] = !0, H("Unsupported vendor-prefixed style property %s. Did you mean %s?", rt, rt.charAt(0).toUpperCase() + rt.slice(1)));
      }, Wt = function(rt, R) {
        ft.hasOwnProperty(R) && ft[R] || (ft[R] = !0, H(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, rt, R.replace(xt, "")));
      }, zt = function(rt, R) {
        St || (St = !0, H("`NaN` is an invalid value for the `%s` css style property.", rt));
      }, Ht = function(rt, R) {
        Mt || (Mt = !0, H("`Infinity` is an invalid value for the `%s` css style property.", rt));
      };
      Ct = function(rt, R) {
        rt.indexOf("-") > -1 ? Ot(rt) : kt.test(rt) ? Nt(rt) : xt.test(R) && Wt(rt, R), typeof R == "number" && (isNaN(R) ? zt(rt, R) : isFinite(R) || Ht(rt, R));
      };
    }
    var Kt = Ct, Gt = /["'&<>]/;
    function ee(rt) {
      J(rt);
      var R = "" + rt, K = Gt.exec(R);
      if (!K)
        return R;
      var nt, dt = "", wt, Et = 0;
      for (wt = K.index; wt < R.length; wt++) {
        switch (R.charCodeAt(wt)) {
          case 34:
            nt = "&quot;";
            break;
          case 38:
            nt = "&amp;";
            break;
          case 39:
            nt = "&#x27;";
            break;
          case 60:
            nt = "&lt;";
            break;
          case 62:
            nt = "&gt;";
            break;
          default:
            continue;
        }
        Et !== wt && (dt += R.substring(Et, wt)), Et = wt + 1, dt += nt;
      }
      return Et !== wt ? dt + R.substring(Et, wt) : dt;
    }
    function Jt(rt) {
      return typeof rt == "boolean" || typeof rt == "number" ? "" + rt : ee(rt);
    }
    var Qt = /([A-Z])/g, ne = /^ms-/;
    function ae(rt) {
      return rt.replace(Qt, "-$1").toLowerCase().replace(ne, "-ms-");
    }
    var Me = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, he = !1;
    function fe(rt) {
      !he && Me.test(rt) && (he = !0, H("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(rt)));
    }
    var Ee = Array.isArray;
    function Xe(rt) {
      return Ee(rt);
    }
    var Se = "<script>";
    function Le(rt, R, K, nt, dt) {
      var wt = rt === void 0 ? "" : rt, Et = Se, Rt = [];
      return {
        bootstrapChunks: Rt,
        startInlineScript: Et,
        placeholderPrefix: wt + "P:",
        segmentPrefix: wt + "S:",
        boundaryPrefix: wt + "B:",
        idPrefix: wt,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var Ye = 0, qt = 1, ue = 2, ye = 3, xe = 4, Ve = 5, ze = 6, _e = 7;
    function Ce(rt, R) {
      return {
        insertionMode: rt,
        selectedValue: R
      };
    }
    function bi(rt, R, K) {
      switch (R) {
        case "select":
          return Ce(qt, K.value != null ? K.value : K.defaultValue);
        case "svg":
          return Ce(ue, null);
        case "math":
          return Ce(ye, null);
        case "foreignObject":
          return Ce(qt, null);
        case "table":
          return Ce(xe, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return Ce(Ve, null);
        case "colgroup":
          return Ce(_e, null);
        case "tr":
          return Ce(ze, null);
      }
      return rt.insertionMode >= xe || rt.insertionMode === Ye ? Ce(qt, null) : rt;
    }
    var ti = null;
    function pi(rt) {
      var R = rt.nextSuspenseID++;
      return rt.boundaryPrefix + R.toString(16);
    }
    function Ki(rt, R, K) {
      var nt = rt.idPrefix, dt = ":" + nt + "R" + R;
      return K > 0 && (dt += "H" + K.toString(32)), dt + ":";
    }
    function ni(rt) {
      return Jt(rt);
    }
    var Fe = "<!-- -->";
    function Ie(rt, R, K, nt) {
      return R === "" ? nt : (nt && rt.push(Fe), rt.push(ni(R)), !0);
    }
    function qe(rt, R, K, nt) {
      K && nt && rt.push(Fe);
    }
    var si = /* @__PURE__ */ new Map();
    function sr(rt) {
      var R = si.get(rt);
      if (R !== void 0)
        return R;
      var K = Jt(ae(rt));
      return si.set(rt, K), K;
    }
    var Ui = ' style="', Di = ":", fi = ";";
    function ar(rt, R, K) {
      if (typeof K != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var nt = !0;
      for (var dt in K)
        if (Q.call(K, dt)) {
          var wt = K[dt];
          if (!(wt == null || typeof wt == "boolean" || wt === "")) {
            var Et = void 0, Rt = void 0, Ft = dt.indexOf("--") === 0;
            Ft ? (Et = Jt(dt), Y(wt, dt), Rt = Jt(("" + wt).trim())) : (Kt(dt, wt), Et = sr(dt), typeof wt == "number" ? wt !== 0 && !Q.call(o, dt) ? Rt = wt + "px" : Rt = "" + wt : (Y(wt, dt), Rt = Jt(("" + wt).trim()))), nt ? (nt = !1, rt.push(Ui, Et, Di, Rt)) : rt.push(fi, Et, Di, Rt);
          }
        }
      nt || rt.push(Ii);
    }
    var gi = " ", Gi = '="', Ii = '"', Br = '=""';
    function ii(rt, R, K, nt) {
      switch (K) {
        case "style": {
          ar(rt, R, nt);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(K.length > 2 && (K[0] === "o" || K[0] === "O") && (K[1] === "n" || K[1] === "N"))
      ) {
        var dt = S(K);
        if (dt !== null) {
          switch (typeof nt) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!dt.acceptsBooleans)
                return;
          }
          var wt = dt.attributeName, Et = wt;
          switch (dt.type) {
            case D:
              nt && rt.push(gi, Et, Br);
              return;
            case k:
              nt === !0 ? rt.push(gi, Et, Br) : nt === !1 || rt.push(gi, Et, Gi, Jt(nt), Ii);
              return;
            case A:
              isNaN(nt) || rt.push(gi, Et, Gi, Jt(nt), Ii);
              break;
            case b:
              !isNaN(nt) && nt >= 1 && rt.push(gi, Et, Gi, Jt(nt), Ii);
              break;
            default:
              dt.sanitizeURL && ($(nt, wt), nt = "" + nt, fe(nt)), rt.push(gi, Et, Gi, Jt(nt), Ii);
          }
        } else if (E(K)) {
          switch (typeof nt) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var Rt = K.toLowerCase().slice(0, 5);
              if (Rt !== "data-" && Rt !== "aria-")
                return;
            }
          }
          rt.push(gi, K, Gi, Jt(nt), Ii);
        }
      }
    }
    var Ti = ">", Nr = "/>";
    function qi(rt, R, K) {
      if (R != null) {
        if (K != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof R != "object" || !("__html" in R))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var nt = R.__html;
        nt != null && (J(nt), rt.push("" + nt));
      }
    }
    var vt = !1, Pt = !1, jt = !1, Bt = !1, $t = !1, Xt = !1, te = !1;
    function le(rt, R) {
      {
        var K = rt[R];
        if (K != null) {
          var nt = Xe(K);
          rt.multiple && !nt ? H("The `%s` prop supplied to <select> must be an array if `multiple` is true.", R) : !rt.multiple && nt && H("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", R);
        }
      }
    }
    function be(rt, R, K) {
      h("select", R), le(R, "value"), le(R, "defaultValue"), R.value !== void 0 && R.defaultValue !== void 0 && !jt && (H("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), jt = !0), rt.push(Yi("select"));
      var nt = null, dt = null;
      for (var wt in R)
        if (Q.call(R, wt)) {
          var Et = R[wt];
          if (Et == null)
            continue;
          switch (wt) {
            case "children":
              nt = Et;
              break;
            case "dangerouslySetInnerHTML":
              dt = Et;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              ii(rt, K, wt, Et);
              break;
          }
        }
      return rt.push(Ti), qi(rt, dt, nt), nt;
    }
    function ke(rt) {
      var R = "";
      return t.Children.forEach(rt, function(K) {
        K != null && (R += K, !$t && typeof K != "string" && typeof K != "number" && ($t = !0, H("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), R;
    }
    var ve = ' selected=""';
    function je(rt, R, K, nt) {
      var dt = nt.selectedValue;
      rt.push(Yi("option"));
      var wt = null, Et = null, Rt = null, Ft = null;
      for (var Yt in R)
        if (Q.call(R, Yt)) {
          var ie = R[Yt];
          if (ie == null)
            continue;
          switch (Yt) {
            case "children":
              wt = ie;
              break;
            case "selected":
              Rt = ie, te || (H("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), te = !0);
              break;
            case "dangerouslySetInnerHTML":
              Ft = ie;
              break;
            case "value":
              Et = ie;
            default:
              ii(rt, K, Yt, ie);
              break;
          }
        }
      if (dt != null) {
        var se;
        if (Et !== null ? ($(Et, "value"), se = "" + Et) : (Ft !== null && (Xt || (Xt = !0, H("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), se = ke(wt)), Xe(dt))
          for (var ge = 0; ge < dt.length; ge++) {
            $(dt[ge], "value");
            var Te = "" + dt[ge];
            if (Te === se) {
              rt.push(ve);
              break;
            }
          }
        else
          $(dt, "select.value"), "" + dt === se && rt.push(ve);
      } else
        Rt && rt.push(ve);
      return rt.push(Ti), qi(rt, Ft, wt), wt;
    }
    function Mi(rt, R, K) {
      h("input", R), R.checked !== void 0 && R.defaultChecked !== void 0 && !Pt && (H("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", R.type), Pt = !0), R.value !== void 0 && R.defaultValue !== void 0 && !vt && (H("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", R.type), vt = !0), rt.push(Yi("input"));
      var nt = null, dt = null, wt = null, Et = null;
      for (var Rt in R)
        if (Q.call(R, Rt)) {
          var Ft = R[Rt];
          if (Ft == null)
            continue;
          switch (Rt) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              Et = Ft;
              break;
            case "defaultValue":
              dt = Ft;
              break;
            case "checked":
              wt = Ft;
              break;
            case "value":
              nt = Ft;
              break;
            default:
              ii(rt, K, Rt, Ft);
              break;
          }
        }
      return wt !== null ? ii(rt, K, "checked", wt) : Et !== null && ii(rt, K, "checked", Et), nt !== null ? ii(rt, K, "value", nt) : dt !== null && ii(rt, K, "value", dt), rt.push(Nr), null;
    }
    function mi(rt, R, K) {
      h("textarea", R), R.value !== void 0 && R.defaultValue !== void 0 && !Bt && (H("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Bt = !0), rt.push(Yi("textarea"));
      var nt = null, dt = null, wt = null;
      for (var Et in R)
        if (Q.call(R, Et)) {
          var Rt = R[Et];
          if (Rt == null)
            continue;
          switch (Et) {
            case "children":
              wt = Rt;
              break;
            case "value":
              nt = Rt;
              break;
            case "defaultValue":
              dt = Rt;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              ii(rt, K, Et, Rt);
              break;
          }
        }
      if (nt === null && dt !== null && (nt = dt), rt.push(Ti), wt != null) {
        if (H("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), nt != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (Xe(wt)) {
          if (wt.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          J(wt[0]), nt = "" + wt[0];
        }
        J(wt), nt = "" + wt;
      }
      return typeof nt == "string" && nt[0] === `
` && rt.push(Sr), nt !== null && ($(nt, "value"), rt.push(ni("" + nt))), null;
    }
    function yi(rt, R, K, nt) {
      rt.push(Yi(K));
      for (var dt in R)
        if (Q.call(R, dt)) {
          var wt = R[dt];
          if (wt == null)
            continue;
          switch (dt) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(K + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              ii(rt, nt, dt, wt);
              break;
          }
        }
      return rt.push(Nr), null;
    }
    function lr(rt, R, K) {
      rt.push(Yi("menuitem"));
      for (var nt in R)
        if (Q.call(R, nt)) {
          var dt = R[nt];
          if (dt == null)
            continue;
          switch (nt) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              ii(rt, K, nt, dt);
              break;
          }
        }
      return rt.push(Ti), null;
    }
    function Xi(rt, R, K) {
      rt.push(Yi("title"));
      var nt = null;
      for (var dt in R)
        if (Q.call(R, dt)) {
          var wt = R[dt];
          if (wt == null)
            continue;
          switch (dt) {
            case "children":
              nt = wt;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              ii(rt, K, dt, wt);
              break;
          }
        }
      rt.push(Ti);
      {
        var Et = Array.isArray(nt) && nt.length < 2 ? nt[0] || null : nt;
        Array.isArray(nt) && nt.length > 1 ? H("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : Et != null && Et.$$typeof != null ? H("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : Et != null && typeof Et != "string" && typeof Et != "number" && H("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return nt;
    }
    function cr(rt, R, K, nt) {
      rt.push(Yi(K));
      var dt = null, wt = null;
      for (var Et in R)
        if (Q.call(R, Et)) {
          var Rt = R[Et];
          if (Rt == null)
            continue;
          switch (Et) {
            case "children":
              dt = Rt;
              break;
            case "dangerouslySetInnerHTML":
              wt = Rt;
              break;
            default:
              ii(rt, nt, Et, Rt);
              break;
          }
        }
      return rt.push(Ti), qi(rt, wt, dt), typeof dt == "string" ? (rt.push(ni(dt)), null) : dt;
    }
    function hr(rt, R, K, nt) {
      rt.push(Yi(K));
      var dt = null, wt = null;
      for (var Et in R)
        if (Q.call(R, Et)) {
          var Rt = R[Et];
          if (Rt == null)
            continue;
          switch (Et) {
            case "children":
              dt = Rt;
              break;
            case "dangerouslySetInnerHTML":
              wt = Rt;
              break;
            case "style":
              ar(rt, nt, Rt);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              E(Et) && typeof Rt != "function" && typeof Rt != "symbol" && rt.push(gi, Et, Gi, Jt(Rt), Ii);
              break;
          }
        }
      return rt.push(Ti), qi(rt, wt, dt), dt;
    }
    var Sr = `
`;
    function Ji(rt, R, K, nt) {
      rt.push(Yi(K));
      var dt = null, wt = null;
      for (var Et in R)
        if (Q.call(R, Et)) {
          var Rt = R[Et];
          if (Rt == null)
            continue;
          switch (Et) {
            case "children":
              dt = Rt;
              break;
            case "dangerouslySetInnerHTML":
              wt = Rt;
              break;
            default:
              ii(rt, nt, Et, Rt);
              break;
          }
        }
      if (rt.push(Ti), wt != null) {
        if (dt != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof wt != "object" || !("__html" in wt))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var Ft = wt.__html;
        Ft != null && (typeof Ft == "string" && Ft.length > 0 && Ft[0] === `
` ? rt.push(Sr, Ft) : (J(Ft), rt.push("" + Ft)));
      }
      return typeof dt == "string" && dt[0] === `
` && rt.push(Sr), dt;
    }
    var rn = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Vo = /* @__PURE__ */ new Map();
    function Yi(rt) {
      var R = Vo.get(rt);
      if (R === void 0) {
        if (!rn.test(rt))
          throw new Error("Invalid tag: " + rt);
        R = "<" + rt, Vo.set(rt, R);
      }
      return R;
    }
    var ao = "<!DOCTYPE html>";
    function da(rt, R, K, nt, dt) {
      switch (W(R, K), I(R, K), mt(R, K, null), !K.suppressContentEditableWarning && K.contentEditable && K.children != null && H("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), dt.insertionMode !== ue && dt.insertionMode !== ye && R.indexOf("-") === -1 && typeof K.is != "string" && R.toLowerCase() !== R && H("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", R), R) {
        case "select":
          return be(rt, K, nt);
        case "option":
          return je(rt, K, nt, dt);
        case "textarea":
          return mi(rt, K, nt);
        case "input":
          return Mi(rt, K, nt);
        case "menuitem":
          return lr(rt, K, nt);
        case "title":
          return Xi(rt, K, nt);
        case "listing":
        case "pre":
          return Ji(rt, K, R, nt);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return yi(rt, K, R, nt);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return cr(rt, K, R, nt);
        case "html":
          return dt.insertionMode === Ye && rt.push(ao), cr(rt, K, R, nt);
        default:
          return R.indexOf("-") === -1 && typeof K.is != "string" ? cr(rt, K, R, nt) : hr(rt, K, R, nt);
      }
    }
    var pa = "</", Qi = ">";
    function lo(rt, R, K) {
      switch (R) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          rt.push(pa, R, Qi);
      }
    }
    function bn(rt, R) {
      for (var K = R.bootstrapChunks, nt = 0; nt < K.length - 1; nt++)
        lt(rt, K[nt]);
      return nt < K.length ? ht(rt, K[nt]) : !0;
    }
    var He = '<template id="', wr = '"></template>';
    function xn(rt, R, K) {
      lt(rt, He), lt(rt, R.placeholderPrefix);
      var nt = K.toString(16);
      return lt(rt, nt), ht(rt, wr);
    }
    var Cr = "<!--$-->", ur = '<!--$?--><template id="', Sn = '"></template>', dr = "<!--$!-->", xi = "<!--/$-->", co = "<template", nn = '"', $o = ' data-dgst="', Zo = ' data-msg="', Ko = ' data-stck="', fa = "></template>";
    function ga(rt, R) {
      return ht(rt, Cr);
    }
    function on(rt, R, K) {
      if (lt(rt, ur), K === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return lt(rt, K), ht(rt, Sn);
    }
    function qo(rt, R, K, nt, dt) {
      var wt;
      return wt = ht(rt, dr), lt(rt, co), K && (lt(rt, $o), lt(rt, Jt(K)), lt(rt, nn)), nt && (lt(rt, Zo), lt(rt, Jt(nt)), lt(rt, nn)), dt && (lt(rt, Ko), lt(rt, Jt(dt)), lt(rt, nn)), wt = ht(rt, fa), wt;
    }
    function wn(rt, R) {
      return ht(rt, xi);
    }
    function Cn(rt, R) {
      return ht(rt, xi);
    }
    function ma(rt, R) {
      return ht(rt, xi);
    }
    var sn = '<div hidden id="', ho = '">', uo = "</div>", zr = '<svg aria-hidden="true" style="display:none" id="', an = '">', kn = "</svg>", Jo = '<math aria-hidden="true" style="display:none" id="', Qo = '">', ts = "</math>", Tn = '<table hidden id="', Si = '">', es = "</table>", Mn = '<table hidden><tbody id="', ya = '">', is = "</tbody></table>", An = '<table hidden><tr id="', rs = '">', ns = "</tr></table>", Pn = '<table hidden><colgroup id="', En = '">', os = "</colgroup></table>";
    function ss(rt, R, K, nt) {
      switch (K.insertionMode) {
        case Ye:
        case qt:
          return lt(rt, sn), lt(rt, R.segmentPrefix), lt(rt, nt.toString(16)), ht(rt, ho);
        case ue:
          return lt(rt, zr), lt(rt, R.segmentPrefix), lt(rt, nt.toString(16)), ht(rt, an);
        case ye:
          return lt(rt, Jo), lt(rt, R.segmentPrefix), lt(rt, nt.toString(16)), ht(rt, Qo);
        case xe:
          return lt(rt, Tn), lt(rt, R.segmentPrefix), lt(rt, nt.toString(16)), ht(rt, Si);
        case Ve:
          return lt(rt, Mn), lt(rt, R.segmentPrefix), lt(rt, nt.toString(16)), ht(rt, ya);
        case ze:
          return lt(rt, An), lt(rt, R.segmentPrefix), lt(rt, nt.toString(16)), ht(rt, rs);
        case _e:
          return lt(rt, Pn), lt(rt, R.segmentPrefix), lt(rt, nt.toString(16)), ht(rt, En);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function as(rt, R) {
      switch (R.insertionMode) {
        case Ye:
        case qt:
          return ht(rt, uo);
        case ue:
          return ht(rt, kn);
        case ye:
          return ht(rt, ts);
        case xe:
          return ht(rt, es);
        case Ve:
          return ht(rt, is);
        case ze:
          return ht(rt, ns);
        case _e:
          return ht(rt, os);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var po = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", ls = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', bt = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', At = po + ';$RS("', It = '$RS("', _t = '","', Zt = '")<\/script>';
    function Vt(rt, R, K) {
      lt(rt, R.startInlineScript), R.sentCompleteSegmentFunction ? lt(rt, It) : (R.sentCompleteSegmentFunction = !0, lt(rt, At)), lt(rt, R.segmentPrefix);
      var nt = K.toString(16);
      return lt(rt, nt), lt(rt, _t), lt(rt, R.placeholderPrefix), lt(rt, nt), ht(rt, Zt);
    }
    var re = ls + ';$RC("', ce = '$RC("', we = '","', Oe = '")<\/script>';
    function Pe(rt, R, K, nt) {
      if (lt(rt, R.startInlineScript), R.sentCompleteBoundaryFunction ? lt(rt, ce) : (R.sentCompleteBoundaryFunction = !0, lt(rt, re)), K === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var dt = nt.toString(16);
      return lt(rt, K), lt(rt, we), lt(rt, R.segmentPrefix), lt(rt, dt), ht(rt, Oe);
    }
    var Ge = bt + ';$RX("', wi = '$RX("', Ri = '"', ji = ")<\/script>", Fr = ",";
    function cs(rt, R, K, nt, dt, wt) {
      if (lt(rt, R.startInlineScript), R.sentClientRenderFunction ? lt(rt, wi) : (R.sentClientRenderFunction = !0, lt(rt, Ge)), K === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return lt(rt, K), lt(rt, Ri), (nt || dt || wt) && (lt(rt, Fr), lt(rt, va(nt || ""))), (dt || wt) && (lt(rt, Fr), lt(rt, va(dt || ""))), wt && (lt(rt, Fr), lt(rt, va(wt))), ht(rt, ji);
    }
    var fo = /[<\u2028\u2029]/g;
    function va(rt) {
      var R = JSON.stringify(rt);
      return R.replace(fo, function(K) {
        switch (K) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function Qh(rt, R) {
      var K = Le(R);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: K.bootstrapChunks,
        startInlineScript: K.startInlineScript,
        placeholderPrefix: K.placeholderPrefix,
        segmentPrefix: K.segmentPrefix,
        boundaryPrefix: K.boundaryPrefix,
        idPrefix: K.idPrefix,
        nextSuspenseID: K.nextSuspenseID,
        sentCompleteSegmentFunction: K.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: K.sentCompleteBoundaryFunction,
        sentClientRenderFunction: K.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: rt
      };
    }
    function tu() {
      return {
        insertionMode: qt,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function Hl(rt, R, K, nt) {
      return K.generateStaticMarkup ? (rt.push(Jt(R)), !1) : Ie(rt, R, K, nt);
    }
    function Ul(rt, R, K, nt) {
      if (!R.generateStaticMarkup)
        return qe(rt, R, K, nt);
    }
    function eu(rt, R) {
      return R.generateStaticMarkup ? !0 : ga(rt);
    }
    function iu(rt, R, K, nt, dt) {
      return R.generateStaticMarkup ? !0 : qo(rt, R, K, nt, dt);
    }
    function ru(rt, R) {
      return R.generateStaticMarkup ? !0 : wn(rt);
    }
    function nu(rt, R) {
      return R.generateStaticMarkup ? !0 : ma(rt);
    }
    var Vi = Object.assign, ou = Symbol.for("react.element"), hs = Symbol.for("react.portal"), Gl = Symbol.for("react.fragment"), Xl = Symbol.for("react.strict_mode"), us = Symbol.for("react.profiler"), Ai = Symbol.for("react.provider"), ba = Symbol.for("react.context"), ds = Symbol.for("react.forward_ref"), ps = Symbol.for("react.suspense"), fs = Symbol.for("react.suspense_list"), gs = Symbol.for("react.memo"), Ln = Symbol.for("react.lazy"), xa = Symbol.for("react.scope"), Sa = Symbol.for("react.debug_trace_mode"), wa = Symbol.for("react.legacy_hidden"), Ca = Symbol.for("react.default_value"), ms = Symbol.iterator, ys = "@@iterator";
    function su(rt) {
      if (rt === null || typeof rt != "object")
        return null;
      var R = ms && rt[ms] || rt[ys];
      return typeof R == "function" ? R : null;
    }
    function au(rt, R, K) {
      var nt = rt.displayName;
      if (nt)
        return nt;
      var dt = R.displayName || R.name || "";
      return dt !== "" ? K + "(" + dt + ")" : K;
    }
    function Yl(rt) {
      return rt.displayName || "Context";
    }
    function Je(rt) {
      if (rt == null)
        return null;
      if (typeof rt.tag == "number" && H("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof rt == "function")
        return rt.displayName || rt.name || null;
      if (typeof rt == "string")
        return rt;
      switch (rt) {
        case Gl:
          return "Fragment";
        case hs:
          return "Portal";
        case us:
          return "Profiler";
        case Xl:
          return "StrictMode";
        case ps:
          return "Suspense";
        case fs:
          return "SuspenseList";
      }
      if (typeof rt == "object")
        switch (rt.$$typeof) {
          case ba:
            var R = rt;
            return Yl(R) + ".Consumer";
          case Ai:
            var K = rt;
            return Yl(K._context) + ".Provider";
          case ds:
            return au(rt, rt.render, "ForwardRef");
          case gs:
            var nt = rt.displayName || null;
            return nt !== null ? nt : Je(rt.type) || "Memo";
          case Ln: {
            var dt = rt, wt = dt._payload, Et = dt._init;
            try {
              return Je(Et(wt));
            } catch (Rt) {
              return null;
            }
          }
        }
      return null;
    }
    var On = 0, Vl, $l, Zl, ka, Ke, Dn, Ta;
    function Ma() {
    }
    Ma.__reactDisabledLog = !0;
    function Kl() {
      {
        if (On === 0) {
          Vl = console.log, $l = console.info, Zl = console.warn, ka = console.error, Ke = console.group, Dn = console.groupCollapsed, Ta = console.groupEnd;
          var rt = {
            configurable: !0,
            enumerable: !0,
            value: Ma,
            writable: !0
          };
          Object.defineProperties(console, {
            info: rt,
            log: rt,
            warn: rt,
            error: rt,
            group: rt,
            groupCollapsed: rt,
            groupEnd: rt
          });
        }
        On++;
      }
    }
    function ql() {
      {
        if (On--, On === 0) {
          var rt = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Vi({}, rt, {
              value: Vl
            }),
            info: Vi({}, rt, {
              value: $l
            }),
            warn: Vi({}, rt, {
              value: Zl
            }),
            error: Vi({}, rt, {
              value: ka
            }),
            group: Vi({}, rt, {
              value: Ke
            }),
            groupCollapsed: Vi({}, rt, {
              value: Dn
            }),
            groupEnd: Vi({}, rt, {
              value: Ta
            })
          });
        }
        On < 0 && H("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var vs = f.ReactCurrentDispatcher, bs;
    function In(rt, R, K) {
      {
        if (bs === void 0)
          try {
            throw Error();
          } catch (dt) {
            var nt = dt.stack.trim().match(/\n( *(at )?)/);
            bs = nt && nt[1] || "";
          }
        return `
` + bs + rt;
      }
    }
    var xs = !1, Ss;
    {
      var lu = typeof WeakMap == "function" ? WeakMap : Map;
      Ss = new lu();
    }
    function go(rt, R) {
      if (!rt || xs)
        return "";
      {
        var K = Ss.get(rt);
        if (K !== void 0)
          return K;
      }
      var nt;
      xs = !0;
      var dt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var wt;
      wt = vs.current, vs.current = null, Kl();
      try {
        if (R) {
          var Et = function() {
            throw Error();
          };
          if (Object.defineProperty(Et.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Et, []);
            } catch (Re) {
              nt = Re;
            }
            Reflect.construct(rt, [], Et);
          } else {
            try {
              Et.call();
            } catch (Re) {
              nt = Re;
            }
            rt.call(Et.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Re) {
            nt = Re;
          }
          rt();
        }
      } catch (Re) {
        if (Re && nt && typeof Re.stack == "string") {
          for (var Rt = Re.stack.split(`
`), Ft = nt.stack.split(`
`), Yt = Rt.length - 1, ie = Ft.length - 1; Yt >= 1 && ie >= 0 && Rt[Yt] !== Ft[ie]; )
            ie--;
          for (; Yt >= 1 && ie >= 0; Yt--, ie--)
            if (Rt[Yt] !== Ft[ie]) {
              if (Yt !== 1 || ie !== 1)
                do
                  if (Yt--, ie--, ie < 0 || Rt[Yt] !== Ft[ie]) {
                    var se = `
` + Rt[Yt].replace(" at new ", " at ");
                    return rt.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", rt.displayName)), typeof rt == "function" && Ss.set(rt, se), se;
                  }
                while (Yt >= 1 && ie >= 0);
              break;
            }
        }
      } finally {
        xs = !1, vs.current = wt, ql(), Error.prepareStackTrace = dt;
      }
      var ge = rt ? rt.displayName || rt.name : "", Te = ge ? In(ge) : "";
      return typeof rt == "function" && Ss.set(rt, Te), Te;
    }
    function Aa(rt, R, K) {
      return go(rt, !0);
    }
    function Rn(rt, R, K) {
      return go(rt, !1);
    }
    function Pa(rt) {
      var R = rt.prototype;
      return !!(R && R.isReactComponent);
    }
    function jn(rt, R, K) {
      if (rt == null)
        return "";
      if (typeof rt == "function")
        return go(rt, Pa(rt));
      if (typeof rt == "string")
        return In(rt);
      switch (rt) {
        case ps:
          return In("Suspense");
        case fs:
          return In("SuspenseList");
      }
      if (typeof rt == "object")
        switch (rt.$$typeof) {
          case ds:
            return Rn(rt.render);
          case gs:
            return jn(rt.type);
          case Ln: {
            var nt = rt, dt = nt._payload, wt = nt._init;
            try {
              return jn(wt(dt));
            } catch (Et) {
            }
          }
        }
      return "";
    }
    var Jl = {}, ws = f.ReactDebugCurrentFrame;
    function Cs(rt) {
      if (rt) {
        var R = jn(rt.type);
        ws.setExtraStackFrame(R);
      } else
        ws.setExtraStackFrame(null);
    }
    function Ea(rt, R, K, nt, dt) {
      {
        var wt = Function.call.bind(Q);
        for (var Et in rt)
          if (wt(rt, Et)) {
            var Rt = void 0;
            try {
              if (typeof rt[Et] != "function") {
                var Ft = Error((nt || "React class") + ": " + K + " type `" + Et + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof rt[Et] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ft.name = "Invariant Violation", Ft;
              }
              Rt = rt[Et](R, Et, nt, K, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Yt) {
              Rt = Yt;
            }
            Rt && !(Rt instanceof Error) && (Cs(dt), H("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", nt || "React class", K, Et, typeof Rt), Cs(null)), Rt instanceof Error && !(Rt.message in Jl) && (Jl[Rt.message] = !0, Cs(dt), H("Failed %s type: %s", K, Rt.message), Cs(null));
          }
      }
    }
    var La;
    La = {};
    var _n = {};
    Object.freeze(_n);
    function Oa(rt, R) {
      {
        var K = rt.contextTypes;
        if (!K)
          return _n;
        var nt = {};
        for (var dt in K)
          nt[dt] = R[dt];
        {
          var wt = Je(rt) || "Unknown";
          Ea(K, nt, "context", wt);
        }
        return nt;
      }
    }
    function Ql(rt, R, K, nt) {
      {
        if (typeof rt.getChildContext != "function") {
          {
            var dt = Je(R) || "Unknown";
            La[dt] || (La[dt] = !0, H("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", dt, dt));
          }
          return K;
        }
        var wt = rt.getChildContext();
        for (var Et in wt)
          if (!(Et in nt))
            throw new Error((Je(R) || "Unknown") + '.getChildContext(): key "' + Et + '" is not defined in childContextTypes.');
        {
          var Rt = Je(R) || "Unknown";
          Ea(nt, wt, "child context", Rt);
        }
        return Vi({}, K, wt);
      }
    }
    var Wr;
    Wr = {};
    var tc = null, kr = null;
    function Bn(rt) {
      rt.context._currentValue2 = rt.parentValue;
    }
    function ks(rt) {
      rt.context._currentValue2 = rt.value;
    }
    function Ts(rt, R) {
      if (rt !== R) {
        Bn(rt);
        var K = rt.parent, nt = R.parent;
        if (K === null) {
          if (nt !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (nt === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          Ts(K, nt);
        }
        ks(R);
      }
    }
    function Nn(rt) {
      Bn(rt);
      var R = rt.parent;
      R !== null && Nn(R);
    }
    function ec(rt) {
      var R = rt.parent;
      R !== null && ec(R), ks(rt);
    }
    function Hr(rt, R) {
      Bn(rt);
      var K = rt.parent;
      if (K === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      K.depth === R.depth ? Ts(K, R) : Hr(K, R);
    }
    function Ms(rt, R) {
      var K = R.parent;
      if (K === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      rt.depth === K.depth ? Ts(rt, K) : Ms(rt, K), ks(R);
    }
    function zn(rt) {
      var R = kr, K = rt;
      R !== K && (R === null ? ec(K) : K === null ? Nn(R) : R.depth === K.depth ? Ts(R, K) : R.depth > K.depth ? Hr(R, K) : Ms(R, K), kr = K);
    }
    function As(rt, R) {
      var K;
      K = rt._currentValue2, rt._currentValue2 = R, rt._currentRenderer2 !== void 0 && rt._currentRenderer2 !== null && rt._currentRenderer2 !== Wr && H("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), rt._currentRenderer2 = Wr;
      var nt = kr, dt = {
        parent: nt,
        depth: nt === null ? 0 : nt.depth + 1,
        context: rt,
        parentValue: K,
        value: R
      };
      return kr = dt, dt;
    }
    function ic(rt) {
      var R = kr;
      if (R === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      R.context !== rt && H("The parent context is not the expected context. This is probably a bug in React.");
      {
        var K = R.parentValue;
        K === Ca ? R.context._currentValue2 = R.context._defaultValue : R.context._currentValue2 = K, rt._currentRenderer2 !== void 0 && rt._currentRenderer2 !== null && rt._currentRenderer2 !== Wr && H("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), rt._currentRenderer2 = Wr;
      }
      return kr = R.parent;
    }
    function rc() {
      return kr;
    }
    function Fn(rt) {
      var R = rt._currentValue2;
      return R;
    }
    function Ps(rt) {
      return rt._reactInternals;
    }
    function Es(rt, R) {
      rt._reactInternals = R;
    }
    var nc = {}, oc = {}, Da, ln, mo, Ia, Ra, yo, vo, bo, xo;
    {
      Da = /* @__PURE__ */ new Set(), ln = /* @__PURE__ */ new Set(), mo = /* @__PURE__ */ new Set(), vo = /* @__PURE__ */ new Set(), Ia = /* @__PURE__ */ new Set(), bo = /* @__PURE__ */ new Set(), xo = /* @__PURE__ */ new Set();
      var Ls = /* @__PURE__ */ new Set();
      yo = function(rt, R) {
        if (!(rt === null || typeof rt == "function")) {
          var K = R + "_" + rt;
          Ls.has(K) || (Ls.add(K), H("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", R, rt));
        }
      }, Ra = function(rt, R) {
        if (R === void 0) {
          var K = Je(rt) || "Component";
          Ia.has(K) || (Ia.add(K), H("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", K));
        }
      };
    }
    function ja(rt, R) {
      {
        var K = rt.constructor, nt = K && Je(K) || "ReactClass", dt = nt + "." + R;
        if (nc[dt])
          return;
        H(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, R, R, nt), nc[dt] = !0;
      }
    }
    var So = {
      isMounted: function(rt) {
        return !1;
      },
      enqueueSetState: function(rt, R, K) {
        var nt = Ps(rt);
        nt.queue === null ? ja(rt, "setState") : (nt.queue.push(R), K != null && yo(K, "setState"));
      },
      enqueueReplaceState: function(rt, R, K) {
        var nt = Ps(rt);
        nt.replace = !0, nt.queue = [R], K != null && yo(K, "setState");
      },
      enqueueForceUpdate: function(rt, R) {
        var K = Ps(rt);
        K.queue === null ? ja(rt, "forceUpdate") : R != null && yo(R, "setState");
      }
    };
    function _a(rt, R, K, nt, dt) {
      var wt = K(dt, nt);
      Ra(R, wt);
      var Et = wt == null ? nt : Vi({}, nt, wt);
      return Et;
    }
    function Ba(rt, R, K) {
      var nt = _n, dt = rt.contextType;
      if ("contextType" in rt) {
        var wt = (
          // Allow null for conditional declaration
          dt === null || dt !== void 0 && dt.$$typeof === ba && dt._context === void 0
        );
        if (!wt && !xo.has(rt)) {
          xo.add(rt);
          var Et = "";
          dt === void 0 ? Et = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof dt != "object" ? Et = " However, it is set to a " + typeof dt + "." : dt.$$typeof === Ai ? Et = " Did you accidentally pass the Context.Provider instead?" : dt._context !== void 0 ? Et = " Did you accidentally pass the Context.Consumer instead?" : Et = " However, it is set to an object with keys {" + Object.keys(dt).join(", ") + "}.", H("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Je(rt) || "Component", Et);
        }
      }
      typeof dt == "object" && dt !== null ? nt = Fn(dt) : nt = K;
      var Rt = new rt(R, nt);
      {
        if (typeof rt.getDerivedStateFromProps == "function" && (Rt.state === null || Rt.state === void 0)) {
          var Ft = Je(rt) || "Component";
          Da.has(Ft) || (Da.add(Ft), H("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Ft, Rt.state === null ? "null" : "undefined", Ft));
        }
        if (typeof rt.getDerivedStateFromProps == "function" || typeof Rt.getSnapshotBeforeUpdate == "function") {
          var Yt = null, ie = null, se = null;
          if (typeof Rt.componentWillMount == "function" && Rt.componentWillMount.__suppressDeprecationWarning !== !0 ? Yt = "componentWillMount" : typeof Rt.UNSAFE_componentWillMount == "function" && (Yt = "UNSAFE_componentWillMount"), typeof Rt.componentWillReceiveProps == "function" && Rt.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? ie = "componentWillReceiveProps" : typeof Rt.UNSAFE_componentWillReceiveProps == "function" && (ie = "UNSAFE_componentWillReceiveProps"), typeof Rt.componentWillUpdate == "function" && Rt.componentWillUpdate.__suppressDeprecationWarning !== !0 ? se = "componentWillUpdate" : typeof Rt.UNSAFE_componentWillUpdate == "function" && (se = "UNSAFE_componentWillUpdate"), Yt !== null || ie !== null || se !== null) {
            var ge = Je(rt) || "Component", Te = typeof rt.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            mo.has(ge) || (mo.add(ge), H(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, ge, Te, Yt !== null ? `
  ` + Yt : "", ie !== null ? `
  ` + ie : "", se !== null ? `
  ` + se : ""));
          }
        }
      }
      return Rt;
    }
    function Na(rt, R, K) {
      {
        var nt = Je(R) || "Component", dt = rt.render;
        dt || (R.prototype && typeof R.prototype.render == "function" ? H("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", nt) : H("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", nt)), rt.getInitialState && !rt.getInitialState.isReactClassApproved && !rt.state && H("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", nt), rt.getDefaultProps && !rt.getDefaultProps.isReactClassApproved && H("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", nt), rt.propTypes && H("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", nt), rt.contextType && H("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", nt), rt.contextTypes && H("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", nt), R.contextType && R.contextTypes && !bo.has(R) && (bo.add(R), H("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", nt)), typeof rt.componentShouldUpdate == "function" && H("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", nt), R.prototype && R.prototype.isPureReactComponent && typeof rt.shouldComponentUpdate != "undefined" && H("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Je(R) || "A pure component"), typeof rt.componentDidUnmount == "function" && H("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", nt), typeof rt.componentDidReceiveProps == "function" && H("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", nt), typeof rt.componentWillRecieveProps == "function" && H("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", nt), typeof rt.UNSAFE_componentWillRecieveProps == "function" && H("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", nt);
        var wt = rt.props !== K;
        rt.props !== void 0 && wt && H("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", nt, nt), rt.defaultProps && H("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", nt, nt), typeof rt.getSnapshotBeforeUpdate == "function" && typeof rt.componentDidUpdate != "function" && !ln.has(R) && (ln.add(R), H("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Je(R))), typeof rt.getDerivedStateFromProps == "function" && H("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", nt), typeof rt.getDerivedStateFromError == "function" && H("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", nt), typeof R.getSnapshotBeforeUpdate == "function" && H("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", nt);
        var Et = rt.state;
        Et && (typeof Et != "object" || Xe(Et)) && H("%s.state: must be set to an object or null", nt), typeof rt.getChildContext == "function" && typeof R.childContextTypes != "object" && H("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", nt);
      }
    }
    function sc(rt, R) {
      var K = R.state;
      if (typeof R.componentWillMount == "function") {
        if (R.componentWillMount.__suppressDeprecationWarning !== !0) {
          var nt = Je(rt) || "Unknown";
          oc[nt] || (B(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            nt
          ), oc[nt] = !0);
        }
        R.componentWillMount();
      }
      typeof R.UNSAFE_componentWillMount == "function" && R.UNSAFE_componentWillMount(), K !== R.state && (H("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Je(rt) || "Component"), So.enqueueReplaceState(R, R.state, null));
    }
    function ac(rt, R, K, nt) {
      if (rt.queue !== null && rt.queue.length > 0) {
        var dt = rt.queue, wt = rt.replace;
        if (rt.queue = null, rt.replace = !1, wt && dt.length === 1)
          R.state = dt[0];
        else {
          for (var Et = wt ? dt[0] : R.state, Rt = !0, Ft = wt ? 1 : 0; Ft < dt.length; Ft++) {
            var Yt = dt[Ft], ie = typeof Yt == "function" ? Yt.call(R, Et, K, nt) : Yt;
            ie != null && (Rt ? (Rt = !1, Et = Vi({}, Et, ie)) : Vi(Et, ie));
          }
          R.state = Et;
        }
      } else
        rt.queue = null;
    }
    function za(rt, R, K, nt) {
      Na(rt, R, K);
      var dt = rt.state !== void 0 ? rt.state : null;
      rt.updater = So, rt.props = K, rt.state = dt;
      var wt = {
        queue: [],
        replace: !1
      };
      Es(rt, wt);
      var Et = R.contextType;
      if (typeof Et == "object" && Et !== null ? rt.context = Fn(Et) : rt.context = nt, rt.state === K) {
        var Rt = Je(R) || "Component";
        vo.has(Rt) || (vo.add(Rt), H("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", Rt));
      }
      var Ft = R.getDerivedStateFromProps;
      typeof Ft == "function" && (rt.state = _a(rt, R, Ft, dt, K)), typeof R.getDerivedStateFromProps != "function" && typeof rt.getSnapshotBeforeUpdate != "function" && (typeof rt.UNSAFE_componentWillMount == "function" || typeof rt.componentWillMount == "function") && (sc(R, rt), ac(wt, rt, K, nt));
    }
    var cu = {
      id: 1,
      overflow: ""
    };
    function hu(rt) {
      var R = rt.overflow, K = rt.id, nt = K & ~uu(K);
      return nt.toString(32) + R;
    }
    function Fa(rt, R, K) {
      var nt = rt.id, dt = rt.overflow, wt = Os(nt) - 1, Et = nt & ~(1 << wt), Rt = K + 1, Ft = Os(R) + wt;
      if (Ft > 30) {
        var Yt = wt - wt % 5, ie = (1 << Yt) - 1, se = (Et & ie).toString(32), ge = Et >> Yt, Te = wt - Yt, Re = Os(R) + Te, hi = Rt << Te, hn = hi | ge, un = se + dt;
        return {
          id: 1 << Re | hn,
          overflow: un
        };
      } else {
        var Pr = Rt << wt, Vn = Pr | Et, _u = dt;
        return {
          id: 1 << Ft | Vn,
          overflow: _u
        };
      }
    }
    function Os(rt) {
      return 32 - lc(rt);
    }
    function uu(rt) {
      return 1 << Os(rt) - 1;
    }
    var lc = Math.clz32 ? Math.clz32 : Wa, du = Math.log, pu = Math.LN2;
    function Wa(rt) {
      var R = rt >>> 0;
      return R === 0 ? 32 : 31 - (du(R) / pu | 0) | 0;
    }
    function Ds(rt, R) {
      return rt === R && (rt !== 0 || 1 / rt === 1 / R) || rt !== rt && R !== R;
    }
    var fu = typeof Object.is == "function" ? Object.is : Ds, Tr = null, Ha = null, Is = null, $e = null, wo = !1, Rs = !1, $i = 0, pr = null, cn = 0, Ze = 25, Pi = !1, Mr;
    function fr() {
      if (Tr === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return Pi && H("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Tr;
    }
    function Ur(rt, R) {
      if (R === null)
        return H("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Mr), !1;
      rt.length !== R.length && H(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Mr, "[" + rt.join(", ") + "]", "[" + R.join(", ") + "]");
      for (var K = 0; K < R.length && K < rt.length; K++)
        if (!fu(rt[K], R[K]))
          return !1;
      return !0;
    }
    function Co() {
      if (cn > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Ua() {
      return $e === null ? Is === null ? (wo = !1, Is = $e = Co()) : (wo = !0, $e = Is) : $e.next === null ? (wo = !1, $e = $e.next = Co()) : (wo = !0, $e = $e.next), $e;
    }
    function gr(rt, R) {
      Tr = R, Ha = rt, Pi = !1, $i = 0;
    }
    function Wn(rt, R, K, nt) {
      for (; Rs; )
        Rs = !1, $i = 0, cn += 1, $e = null, K = rt(R, nt);
      return Ga(), K;
    }
    function Gr() {
      var rt = $i !== 0;
      return rt;
    }
    function Ga() {
      Pi = !1, Tr = null, Ha = null, Rs = !1, Is = null, cn = 0, pr = null, $e = null;
    }
    function cc(rt) {
      return Pi && H("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Fn(rt);
    }
    function Xa(rt) {
      return Mr = "useContext", fr(), Fn(rt);
    }
    function Ya(rt, R) {
      return typeof R == "function" ? R(rt) : R;
    }
    function gu(rt) {
      return Mr = "useState", Va(
        Ya,
        // useReducer has a special case to support lazy useState initializers
        rt
      );
    }
    function Va(rt, R, K) {
      if (rt !== Ya && (Mr = "useReducer"), Tr = fr(), $e = Ua(), wo) {
        var nt = $e.queue, dt = nt.dispatch;
        if (pr !== null) {
          var wt = pr.get(nt);
          if (wt !== void 0) {
            pr.delete(nt);
            var Et = $e.memoizedState, Rt = wt;
            do {
              var Ft = Rt.action;
              Pi = !0, Et = rt(Et, Ft), Pi = !1, Rt = Rt.next;
            } while (Rt !== null);
            return $e.memoizedState = Et, [Et, dt];
          }
        }
        return [$e.memoizedState, dt];
      } else {
        Pi = !0;
        var Yt;
        rt === Ya ? Yt = typeof R == "function" ? R() : R : Yt = K !== void 0 ? K(R) : R, Pi = !1, $e.memoizedState = Yt;
        var ie = $e.queue = {
          last: null,
          dispatch: null
        }, se = ie.dispatch = $a.bind(null, Tr, ie);
        return [$e.memoizedState, se];
      }
    }
    function js(rt, R) {
      Tr = fr(), $e = Ua();
      var K = R === void 0 ? null : R;
      if ($e !== null) {
        var nt = $e.memoizedState;
        if (nt !== null && K !== null) {
          var dt = nt[1];
          if (Ur(K, dt))
            return nt[0];
        }
      }
      Pi = !0;
      var wt = rt();
      return Pi = !1, $e.memoizedState = [wt, K], wt;
    }
    function mu(rt) {
      Tr = fr(), $e = Ua();
      var R = $e.memoizedState;
      if (R === null) {
        var K = {
          current: rt
        };
        return Object.seal(K), $e.memoizedState = K, K;
      } else
        return R;
    }
    function yu(rt, R) {
      Mr = "useLayoutEffect", H("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function $a(rt, R, K) {
      if (cn >= Ze)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (rt === Tr) {
        Rs = !0;
        var nt = {
          action: K,
          next: null
        };
        pr === null && (pr = /* @__PURE__ */ new Map());
        var dt = pr.get(R);
        if (dt === void 0)
          pr.set(R, nt);
        else {
          for (var wt = dt; wt.next !== null; )
            wt = wt.next;
          wt.next = nt;
        }
      }
    }
    function vu(rt, R) {
      return js(function() {
        return rt;
      }, R);
    }
    function hc(rt, R, K) {
      return fr(), R(rt._source);
    }
    function uc(rt, R, K) {
      if (K === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return K();
    }
    function bu(rt) {
      return fr(), rt;
    }
    function xu() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Su() {
      return fr(), [!1, xu];
    }
    function wu() {
      var rt = Ha, R = hu(rt.treeContext), K = Za;
      if (K === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var nt = $i++;
      return Ki(K, R, nt);
    }
    function _s() {
    }
    var dc = {
      readContext: cc,
      useContext: Xa,
      useMemo: js,
      useReducer: Va,
      useRef: mu,
      useState: gu,
      useInsertionEffect: _s,
      useLayoutEffect: yu,
      useCallback: vu,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: _s,
      // Effects are not run in the server environment.
      useEffect: _s,
      // Debugging effect
      useDebugValue: _s,
      useDeferredValue: bu,
      useTransition: Su,
      useId: wu,
      // Subscriptions are not setup in a server environment.
      useMutableSource: hc,
      useSyncExternalStore: uc
    }, Za = null;
    function pc(rt) {
      Za = rt;
    }
    function Cu(rt) {
      try {
        var R = "", K = rt;
        do {
          switch (K.tag) {
            case 0:
              R += In(K.type);
              break;
            case 1:
              R += Rn(K.type);
              break;
            case 2:
              R += Aa(K.type);
              break;
          }
          K = K.parent;
        } while (K);
        return R;
      } catch (nt) {
        return `
Error generating stack: ` + nt.message + `
` + nt.stack;
      }
    }
    var Ka = f.ReactCurrentDispatcher, Hn = f.ReactDebugCurrentFrame, Bs = 0, Xr = 1, qa = 2, fc = 3, Ns = 4, Ja = 0, zs = 1, tr = 2, gc = 12800;
    function mc(rt) {
      return console.error(rt), null;
    }
    function Un() {
    }
    function ku(rt, R, K, nt, dt, wt, Et, Rt, Ft) {
      var Yt = [], ie = /* @__PURE__ */ new Set(), se = {
        destination: null,
        responseState: R,
        progressiveChunkSize: nt === void 0 ? gc : nt,
        status: Ja,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: ie,
        pingedTasks: Yt,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: dt === void 0 ? mc : dt,
        onAllReady: Un,
        onShellReady: Et === void 0 ? Un : Et,
        onShellError: Un,
        onFatalError: Un
      }, ge = Fs(
        se,
        0,
        null,
        K,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      ge.parentFlushed = !0;
      var Te = Qa(se, rt, null, ge, ie, _n, tc, cu);
      return Yt.push(Te), se;
    }
    function yc(rt, R) {
      var K = rt.pingedTasks;
      K.push(R), K.length === 1 && st(function() {
        return Lc(rt);
      });
    }
    function Gn(rt, R) {
      return {
        id: ti,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: R,
        errorDigest: null
      };
    }
    function Qa(rt, R, K, nt, dt, wt, Et, Rt) {
      rt.allPendingTasks++, K === null ? rt.pendingRootTasks++ : K.pendingTasks++;
      var Ft = {
        node: R,
        ping: function() {
          return yc(rt, Ft);
        },
        blockedBoundary: K,
        blockedSegment: nt,
        abortSet: dt,
        legacyContext: wt,
        context: Et,
        treeContext: Rt
      };
      return Ft.componentStack = null, dt.add(Ft), Ft;
    }
    function Fs(rt, R, K, nt, dt, wt) {
      return {
        status: Bs,
        id: -1,
        // lazily assigned later
        index: R,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: nt,
        boundary: K,
        lastPushedText: dt,
        textEmbedded: wt
      };
    }
    var _i = null;
    function tl() {
      return _i === null || _i.componentStack === null ? "" : Cu(_i.componentStack);
    }
    function ko(rt, R) {
      rt.componentStack = {
        tag: 0,
        parent: rt.componentStack,
        type: R
      };
    }
    function vc(rt, R) {
      rt.componentStack = {
        tag: 1,
        parent: rt.componentStack,
        type: R
      };
    }
    function el(rt, R) {
      rt.componentStack = {
        tag: 2,
        parent: rt.componentStack,
        type: R
      };
    }
    function er(rt) {
      rt.componentStack === null ? H("Unexpectedly popped too many stack frames. This is a bug in React.") : rt.componentStack = rt.componentStack.parent;
    }
    var Bi = null;
    function To(rt, R) {
      {
        var K;
        typeof R == "string" ? K = R : R && typeof R.message == "string" ? K = R.message : K = String(R);
        var nt = Bi || tl();
        Bi = null, rt.errorMessage = K, rt.errorComponentStack = nt;
      }
    }
    function Ar(rt, R) {
      var K = rt.onError(R);
      if (K != null && typeof K != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof K + '" instead');
      return K;
    }
    function Mo(rt, R) {
      var K = rt.onShellError;
      K(R);
      var nt = rt.onFatalError;
      nt(R), rt.destination !== null ? (rt.status = tr, _(rt.destination, R)) : (rt.status = zs, rt.fatalError = R);
    }
    function Tu(rt, R, K) {
      ko(R, "Suspense");
      var nt = R.blockedBoundary, dt = R.blockedSegment, wt = K.fallback, Et = K.children, Rt = /* @__PURE__ */ new Set(), Ft = Gn(rt, Rt), Yt = dt.chunks.length, ie = Fs(
        rt,
        Yt,
        Ft,
        dt.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      dt.children.push(ie), dt.lastPushedText = !1;
      var se = Fs(
        rt,
        0,
        null,
        dt.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      se.parentFlushed = !0, R.blockedBoundary = Ft, R.blockedSegment = se;
      try {
        if (Eo(rt, R, Et), Ul(se.chunks, rt.responseState, se.lastPushedText, se.textEmbedded), se.status = Xr, Lo(Ft, se), Ft.pendingTasks === 0) {
          er(R);
          return;
        }
      } catch (Te) {
        se.status = Ns, Ft.forceClientRender = !0, Ft.errorDigest = Ar(rt, Te), To(Ft, Te);
      } finally {
        R.blockedBoundary = nt, R.blockedSegment = dt;
      }
      var ge = Qa(rt, wt, nt, ie, Rt, R.legacyContext, R.context, R.treeContext);
      ge.componentStack = R.componentStack, rt.pingedTasks.push(ge), er(R);
    }
    function Yr(rt, R, K, nt) {
      ko(R, K);
      var dt = R.blockedSegment, wt = da(dt.chunks, K, nt, rt.responseState, dt.formatContext);
      dt.lastPushedText = !1;
      var Et = dt.formatContext;
      dt.formatContext = bi(Et, K, nt), Eo(rt, R, wt), dt.formatContext = Et, lo(dt.chunks, K), dt.lastPushedText = !1, er(R);
    }
    function Ao(rt) {
      return rt.prototype && rt.prototype.isReactComponent;
    }
    function Ws(rt, R, K, nt, dt) {
      var wt = {};
      gr(R, wt);
      var Et = K(nt, dt);
      return Wn(K, nt, Et, dt);
    }
    function Xn(rt, R, K, nt, dt) {
      var wt = K.render();
      K.props !== dt && (rl || H("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Je(nt) || "a component"), rl = !0);
      {
        var Et = nt.childContextTypes;
        if (Et != null) {
          var Rt = R.legacyContext, Ft = Ql(K, nt, Rt, Et);
          R.legacyContext = Ft, Ni(rt, R, wt), R.legacyContext = Rt;
          return;
        }
      }
      Ni(rt, R, wt);
    }
    function Hs(rt, R, K, nt) {
      el(R, K);
      var dt = Oa(K, R.legacyContext), wt = Ba(K, nt, dt);
      za(wt, K, nt, dt), Xn(rt, R, wt, K, nt), er(R);
    }
    var bc = {}, Us = {}, xc = {}, il = {}, rl = !1, Sc = {}, nl = !1, Po = !1, ol = !1;
    function wc(rt, R, K, nt) {
      var dt;
      if (dt = Oa(K, R.legacyContext), vc(R, K), K.prototype && typeof K.prototype.render == "function") {
        var wt = Je(K) || "Unknown";
        bc[wt] || (H("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", wt, wt), bc[wt] = !0);
      }
      var Et = Ws(rt, R, K, nt, dt), Rt = Gr();
      if (typeof Et == "object" && Et !== null && typeof Et.render == "function" && Et.$$typeof === void 0) {
        var Ft = Je(K) || "Unknown";
        Us[Ft] || (H("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ft, Ft, Ft), Us[Ft] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof Et == "object" && Et !== null && typeof Et.render == "function" && Et.$$typeof === void 0
      ) {
        {
          var Yt = Je(K) || "Unknown";
          Us[Yt] || (H("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Yt, Yt, Yt), Us[Yt] = !0);
        }
        za(Et, K, nt, dt), Xn(rt, R, Et, K, nt);
      } else if (Cc(K), Rt) {
        var ie = R.treeContext, se = 1, ge = 0;
        R.treeContext = Fa(ie, se, ge);
        try {
          Ni(rt, R, Et);
        } finally {
          R.treeContext = ie;
        }
      } else
        Ni(rt, R, Et);
      er(R);
    }
    function Cc(rt) {
      {
        if (rt && rt.childContextTypes && H("%s(...): childContextTypes cannot be defined on a function component.", rt.displayName || rt.name || "Component"), rt.defaultProps !== void 0) {
          var R = Je(rt) || "Unknown";
          Sc[R] || (H("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", R), Sc[R] = !0);
        }
        if (typeof rt.getDerivedStateFromProps == "function") {
          var K = Je(rt) || "Unknown";
          il[K] || (H("%s: Function components do not support getDerivedStateFromProps.", K), il[K] = !0);
        }
        if (typeof rt.contextType == "object" && rt.contextType !== null) {
          var nt = Je(rt) || "Unknown";
          xc[nt] || (H("%s: Function components do not support contextType.", nt), xc[nt] = !0);
        }
      }
    }
    function sl(rt, R) {
      if (rt && rt.defaultProps) {
        var K = Vi({}, R), nt = rt.defaultProps;
        for (var dt in nt)
          K[dt] === void 0 && (K[dt] = nt[dt]);
        return K;
      }
      return R;
    }
    function kc(rt, R, K, nt, dt) {
      vc(R, K.render);
      var wt = Ws(rt, R, K.render, nt, dt), Et = Gr();
      if (Et) {
        var Rt = R.treeContext, Ft = 1, Yt = 0;
        R.treeContext = Fa(Rt, Ft, Yt);
        try {
          Ni(rt, R, wt);
        } finally {
          R.treeContext = Rt;
        }
      } else
        Ni(rt, R, wt);
      er(R);
    }
    function Tc(rt, R, K, nt, dt) {
      var wt = K.type, Et = sl(wt, nt);
      Gs(rt, R, wt, Et, dt);
    }
    function Mc(rt, R, K, nt) {
      K._context === void 0 ? K !== K.Consumer && (ol || (ol = !0, H("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : K = K._context;
      var dt = nt.children;
      typeof dt != "function" && H("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var wt = Fn(K), Et = dt(wt);
      Ni(rt, R, Et);
    }
    function Mu(rt, R, K, nt) {
      var dt = K._context, wt = nt.value, Et = nt.children, Rt;
      Rt = R.context, R.context = As(dt, wt), Ni(rt, R, Et), R.context = ic(dt), Rt !== R.context && H("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Au(rt, R, K, nt, dt) {
      ko(R, "Lazy");
      var wt = K._payload, Et = K._init, Rt = Et(wt), Ft = sl(Rt, nt);
      Gs(rt, R, Rt, Ft, dt), er(R);
    }
    function Gs(rt, R, K, nt, dt) {
      if (typeof K == "function")
        if (Ao(K)) {
          Hs(rt, R, K, nt);
          return;
        } else {
          wc(rt, R, K, nt);
          return;
        }
      if (typeof K == "string") {
        Yr(rt, R, K, nt);
        return;
      }
      switch (K) {
        case wa:
        case Sa:
        case Xl:
        case us:
        case Gl: {
          Ni(rt, R, nt.children);
          return;
        }
        case fs: {
          ko(R, "SuspenseList"), Ni(rt, R, nt.children), er(R);
          return;
        }
        case xa:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case ps: {
          Tu(rt, R, nt);
          return;
        }
      }
      if (typeof K == "object" && K !== null)
        switch (K.$$typeof) {
          case ds: {
            kc(rt, R, K, nt, dt);
            return;
          }
          case gs: {
            Tc(rt, R, K, nt, dt);
            return;
          }
          case Ai: {
            Mu(rt, R, K, nt);
            return;
          }
          case ba: {
            Mc(rt, R, K, nt);
            return;
          }
          case Ln: {
            Au(rt, R, K, nt);
            return;
          }
        }
      var wt = "";
      throw (K === void 0 || typeof K == "object" && K !== null && Object.keys(K).length === 0) && (wt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (K == null ? K : typeof K) + "." + wt));
    }
    function Pu(rt, R) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      rt[Symbol.toStringTag] === "Generator" && (nl || H("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), nl = !0), rt.entries === R && (Po || H("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Po = !0);
    }
    function Ni(rt, R, K) {
      try {
        return Eu(rt, R, K);
      } catch (nt) {
        throw typeof nt == "object" && nt !== null && typeof nt.then == "function" || (Bi = Bi !== null ? Bi : tl()), nt;
      }
    }
    function Eu(rt, R, K) {
      if (R.node = K, typeof K == "object" && K !== null) {
        switch (K.$$typeof) {
          case ou: {
            var nt = K, dt = nt.type, wt = nt.props, Et = nt.ref;
            Gs(rt, R, dt, wt, Et);
            return;
          }
          case hs:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case Ln: {
            var Rt = K, Ft = Rt._payload, Yt = Rt._init, ie;
            try {
              ie = Yt(Ft);
            } catch (Pr) {
              throw typeof Pr == "object" && Pr !== null && typeof Pr.then == "function" && ko(R, "Lazy"), Pr;
            }
            Ni(rt, R, ie);
            return;
          }
        }
        if (Xe(K)) {
          Ac(rt, R, K);
          return;
        }
        var se = su(K);
        if (se) {
          Pu(K, se);
          var ge = se.call(K);
          if (ge) {
            var Te = ge.next();
            if (!Te.done) {
              var Re = [];
              do
                Re.push(Te.value), Te = ge.next();
              while (!Te.done);
              Ac(rt, R, Re);
              return;
            }
            return;
          }
        }
        var hi = Object.prototype.toString.call(K);
        throw new Error("Objects are not valid as a React child (found: " + (hi === "[object Object]" ? "object with keys {" + Object.keys(K).join(", ") + "}" : hi) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof K == "string") {
        var hn = R.blockedSegment;
        hn.lastPushedText = Hl(R.blockedSegment.chunks, K, rt.responseState, hn.lastPushedText);
        return;
      }
      if (typeof K == "number") {
        var un = R.blockedSegment;
        un.lastPushedText = Hl(R.blockedSegment.chunks, "" + K, rt.responseState, un.lastPushedText);
        return;
      }
      typeof K == "function" && H("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Ac(rt, R, K) {
      for (var nt = K.length, dt = 0; dt < nt; dt++) {
        var wt = R.treeContext;
        R.treeContext = Fa(wt, nt, dt);
        try {
          Eo(rt, R, K[dt]);
        } finally {
          R.treeContext = wt;
        }
      }
    }
    function Lu(rt, R, K) {
      var nt = R.blockedSegment, dt = nt.chunks.length, wt = Fs(
        rt,
        dt,
        null,
        nt.formatContext,
        // Adopt the parent segment's leading text embed
        nt.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      nt.children.push(wt), nt.lastPushedText = !1;
      var Et = Qa(rt, R.node, R.blockedBoundary, wt, R.abortSet, R.legacyContext, R.context, R.treeContext);
      R.componentStack !== null && (Et.componentStack = R.componentStack.parent);
      var Rt = Et.ping;
      K.then(Rt, Rt);
    }
    function Eo(rt, R, K) {
      var nt = R.blockedSegment.formatContext, dt = R.legacyContext, wt = R.context, Et = null;
      Et = R.componentStack;
      try {
        return Ni(rt, R, K);
      } catch (Rt) {
        if (Ga(), typeof Rt == "object" && Rt !== null && typeof Rt.then == "function") {
          Lu(rt, R, Rt), R.blockedSegment.formatContext = nt, R.legacyContext = dt, R.context = wt, zn(wt), R.componentStack = Et;
          return;
        } else
          throw R.blockedSegment.formatContext = nt, R.legacyContext = dt, R.context = wt, zn(wt), R.componentStack = Et, Rt;
      }
    }
    function Ou(rt, R, K, nt) {
      var dt = Ar(rt, nt);
      if (R === null ? Mo(rt, nt) : (R.pendingTasks--, R.forceClientRender || (R.forceClientRender = !0, R.errorDigest = dt, To(R, nt), R.parentFlushed && rt.clientRenderedBoundaries.push(R))), rt.allPendingTasks--, rt.allPendingTasks === 0) {
        var wt = rt.onAllReady;
        wt();
      }
    }
    function zi(rt) {
      var R = this, K = rt.blockedBoundary, nt = rt.blockedSegment;
      nt.status = fc, Ec(R, K, nt);
    }
    function Pc(rt, R, K) {
      var nt = rt.blockedBoundary, dt = rt.blockedSegment;
      if (dt.status = fc, nt === null)
        R.allPendingTasks--, R.status !== tr && (R.status = tr, R.destination !== null && ut(R.destination));
      else {
        if (nt.pendingTasks--, !nt.forceClientRender) {
          nt.forceClientRender = !0;
          var wt = K === void 0 ? new Error("The render was aborted by the server without a reason.") : K;
          nt.errorDigest = R.onError(wt);
          {
            var Et = "The server did not finish this Suspense boundary: ";
            wt && typeof wt.message == "string" ? wt = Et + wt.message : wt = Et + String(wt);
            var Rt = _i;
            _i = rt;
            try {
              To(nt, wt);
            } finally {
              _i = Rt;
            }
          }
          nt.parentFlushed && R.clientRenderedBoundaries.push(nt);
        }
        if (nt.fallbackAbortableTasks.forEach(function(Yt) {
          return Pc(Yt, R, K);
        }), nt.fallbackAbortableTasks.clear(), R.allPendingTasks--, R.allPendingTasks === 0) {
          var Ft = R.onAllReady;
          Ft();
        }
      }
    }
    function Lo(rt, R) {
      if (R.chunks.length === 0 && R.children.length === 1 && R.children[0].boundary === null) {
        var K = R.children[0];
        K.id = R.id, K.parentFlushed = !0, K.status === Xr && Lo(rt, K);
      } else {
        var nt = rt.completedSegments;
        nt.push(R);
      }
    }
    function Ec(rt, R, K) {
      if (R === null) {
        if (K.parentFlushed) {
          if (rt.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          rt.completedRootSegment = K;
        }
        if (rt.pendingRootTasks--, rt.pendingRootTasks === 0) {
          rt.onShellError = Un;
          var nt = rt.onShellReady;
          nt();
        }
      } else if (R.pendingTasks--, !R.forceClientRender) {
        if (R.pendingTasks === 0)
          K.parentFlushed && K.status === Xr && Lo(R, K), R.parentFlushed && rt.completedBoundaries.push(R), R.fallbackAbortableTasks.forEach(zi, rt), R.fallbackAbortableTasks.clear();
        else if (K.parentFlushed && K.status === Xr) {
          Lo(R, K);
          var dt = R.completedSegments;
          dt.length === 1 && R.parentFlushed && rt.partialBoundaries.push(R);
        }
      }
      if (rt.allPendingTasks--, rt.allPendingTasks === 0) {
        var wt = rt.onAllReady;
        wt();
      }
    }
    function al(rt, R) {
      var K = R.blockedSegment;
      if (K.status === Bs) {
        zn(R.context);
        var nt = null;
        nt = _i, _i = R;
        try {
          Ni(rt, R, R.node), Ul(K.chunks, rt.responseState, K.lastPushedText, K.textEmbedded), R.abortSet.delete(R), K.status = Xr, Ec(rt, R.blockedBoundary, K);
        } catch (wt) {
          if (Ga(), typeof wt == "object" && wt !== null && typeof wt.then == "function") {
            var dt = R.ping;
            wt.then(dt, dt);
          } else
            R.abortSet.delete(R), K.status = Ns, Ou(rt, R.blockedBoundary, K, wt);
        } finally {
          _i = nt;
        }
      }
    }
    function Lc(rt) {
      if (rt.status !== tr) {
        var R = rc(), K = Ka.current;
        Ka.current = dc;
        var nt;
        nt = Hn.getCurrentStack, Hn.getCurrentStack = tl;
        var dt = Za;
        pc(rt.responseState);
        try {
          var wt = rt.pingedTasks, Et;
          for (Et = 0; Et < wt.length; Et++) {
            var Rt = wt[Et];
            al(rt, Rt);
          }
          wt.splice(0, Et), rt.destination !== null && Yn(rt, rt.destination);
        } catch (Ft) {
          Ar(rt, Ft), Mo(rt, Ft);
        } finally {
          pc(dt), Ka.current = K, Hn.getCurrentStack = nt, K === dc && zn(R);
        }
      }
    }
    function Xs(rt, R, K) {
      switch (K.parentFlushed = !0, K.status) {
        case Bs: {
          var nt = K.id = rt.nextSegmentId++;
          return K.lastPushedText = !1, K.textEmbedded = !1, xn(R, rt.responseState, nt);
        }
        case Xr: {
          K.status = qa;
          for (var dt = !0, wt = K.chunks, Et = 0, Rt = K.children, Ft = 0; Ft < Rt.length; Ft++) {
            for (var Yt = Rt[Ft]; Et < Yt.index; Et++)
              lt(R, wt[Et]);
            dt = Oo(rt, R, Yt);
          }
          for (; Et < wt.length - 1; Et++)
            lt(R, wt[Et]);
          return Et < wt.length && (dt = ht(R, wt[Et])), dt;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Oo(rt, R, K) {
      var nt = K.boundary;
      if (nt === null)
        return Xs(rt, R, K);
      if (nt.parentFlushed = !0, nt.forceClientRender)
        return iu(R, rt.responseState, nt.errorDigest, nt.errorMessage, nt.errorComponentStack), Xs(rt, R, K), nu(R, rt.responseState);
      if (nt.pendingTasks > 0) {
        nt.rootSegmentID = rt.nextSegmentId++, nt.completedSegments.length > 0 && rt.partialBoundaries.push(nt);
        var dt = nt.id = pi(rt.responseState);
        return on(R, rt.responseState, dt), Xs(rt, R, K), Cn(R);
      } else {
        if (nt.byteSize > rt.progressiveChunkSize)
          return nt.rootSegmentID = rt.nextSegmentId++, rt.completedBoundaries.push(nt), on(R, rt.responseState, nt.id), Xs(rt, R, K), Cn(R);
        eu(R, rt.responseState);
        var wt = nt.completedSegments;
        if (wt.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var Et = wt[0];
        return Oo(rt, R, Et), ru(R, rt.responseState);
      }
    }
    function Ys(rt, R, K) {
      return cs(R, rt.responseState, K.id, K.errorDigest, K.errorMessage, K.errorComponentStack);
    }
    function ll(rt, R, K) {
      return ss(R, rt.responseState, K.formatContext, K.id), Oo(rt, R, K), as(R, K.formatContext);
    }
    function Oc(rt, R, K) {
      for (var nt = K.completedSegments, dt = 0; dt < nt.length; dt++) {
        var wt = nt[dt];
        Do(rt, R, K, wt);
      }
      return nt.length = 0, Pe(R, rt.responseState, K.id, K.rootSegmentID);
    }
    function Dc(rt, R, K) {
      for (var nt = K.completedSegments, dt = 0; dt < nt.length; dt++) {
        var wt = nt[dt];
        if (!Do(rt, R, K, wt))
          return dt++, nt.splice(0, dt), !1;
      }
      return nt.splice(0, dt), !0;
    }
    function Do(rt, R, K, nt) {
      if (nt.status === qa)
        return !0;
      var dt = nt.id;
      if (dt === -1) {
        var wt = nt.id = K.rootSegmentID;
        if (wt === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return ll(rt, R, nt);
      } else
        return ll(rt, R, nt), Vt(R, rt.responseState, dt);
    }
    function Yn(rt, R) {
      try {
        var K = rt.completedRootSegment;
        K !== null && rt.pendingRootTasks === 0 && (Oo(rt, R, K), rt.completedRootSegment = null, bn(R, rt.responseState));
        var nt = rt.clientRenderedBoundaries, dt;
        for (dt = 0; dt < nt.length; dt++) {
          var wt = nt[dt];
          if (!Ys(rt, R, wt)) {
            rt.destination = null, dt++, nt.splice(0, dt);
            return;
          }
        }
        nt.splice(0, dt);
        var Et = rt.completedBoundaries;
        for (dt = 0; dt < Et.length; dt++) {
          var Rt = Et[dt];
          if (!Oc(rt, R, Rt)) {
            rt.destination = null, dt++, Et.splice(0, dt);
            return;
          }
        }
        Et.splice(0, dt);
        var Ft = rt.partialBoundaries;
        for (dt = 0; dt < Ft.length; dt++) {
          var Yt = Ft[dt];
          if (!Dc(rt, R, Yt)) {
            rt.destination = null, dt++, Ft.splice(0, dt);
            return;
          }
        }
        Ft.splice(0, dt);
        var ie = rt.completedBoundaries;
        for (dt = 0; dt < ie.length; dt++) {
          var se = ie[dt];
          if (!Oc(rt, R, se)) {
            rt.destination = null, dt++, ie.splice(0, dt);
            return;
          }
        }
        ie.splice(0, dt);
      } finally {
        rt.allPendingTasks === 0 && rt.pingedTasks.length === 0 && rt.clientRenderedBoundaries.length === 0 && rt.completedBoundaries.length === 0 && (rt.abortableTasks.size !== 0 && H("There was still abortable task at the root when we closed. This is a bug in React."), ut(R));
      }
    }
    function Du(rt) {
      st(function() {
        return Lc(rt);
      });
    }
    function Ic(rt, R) {
      if (rt.status === zs) {
        rt.status = tr, _(R, rt.fatalError);
        return;
      }
      if (rt.status !== tr && rt.destination === null) {
        rt.destination = R;
        try {
          Yn(rt, R);
        } catch (K) {
          Ar(rt, K), Mo(rt, K);
        }
      }
    }
    function Rc(rt, R) {
      try {
        var K = rt.abortableTasks;
        K.forEach(function(nt) {
          return Pc(nt, rt, R);
        }), K.clear(), rt.destination !== null && Yn(rt, rt.destination);
      } catch (nt) {
        Ar(rt, nt), Mo(rt, nt);
      }
    }
    function Iu() {
    }
    function cl(rt, R, K, nt) {
      var dt = !1, wt = null, Et = "", Rt = {
        push: function(se) {
          return se !== null && (Et += se), !0;
        },
        destroy: function(se) {
          dt = !0, wt = se;
        }
      }, Ft = !1;
      function Yt() {
        Ft = !0;
      }
      var ie = ku(rt, Qh(K, R ? R.identifierPrefix : void 0), tu(), 1 / 0, Iu, void 0, Yt);
      if (Du(ie), Rc(ie, nt), Ic(ie, Rt), dt)
        throw wt;
      if (!Ft)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return Et;
    }
    function hl(rt, R) {
      return cl(rt, R, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function Ru(rt, R) {
      return cl(rt, R, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function ju() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function jc() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    jo.renderToNodeStream = ju, jo.renderToStaticMarkup = Ru, jo.renderToStaticNodeStream = jc, jo.renderToString = hl, jo.version = r;
  }()), jo;
}
var Kc = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mg;
function hE() {
  return Mg || (Mg = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Oh, r = "18.3.1", f = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function B(R) {
      {
        for (var K = arguments.length, nt = new Array(K > 1 ? K - 1 : 0), dt = 1; dt < K; dt++)
          nt[dt - 1] = arguments[dt];
        tt("warn", R, nt);
      }
    }
    function H(R) {
      {
        for (var K = arguments.length, nt = new Array(K > 1 ? K - 1 : 0), dt = 1; dt < K; dt++)
          nt[dt - 1] = arguments[dt];
        tt("error", R, nt);
      }
    }
    function tt(R, K, nt) {
      {
        var dt = f.ReactDebugCurrentFrame, wt = dt.getStackAddendum();
        wt !== "" && (K += "%s", nt = nt.concat([wt]));
        var Et = nt.map(function(Rt) {
          return String(Rt);
        });
        Et.unshift("Warning: " + K), Function.prototype.apply.call(console[R], console, Et);
      }
    }
    function st(R) {
      R();
    }
    var lt = 512, ht = null, ut = 0;
    function yt(R) {
      ht = new Uint8Array(lt), ut = 0;
    }
    function gt(R, K) {
      if (K.length !== 0) {
        if (K.length > lt) {
          ut > 0 && (R.enqueue(new Uint8Array(ht.buffer, 0, ut)), ht = new Uint8Array(lt), ut = 0), R.enqueue(K);
          return;
        }
        var nt = K, dt = ht.length - ut;
        dt < nt.length && (dt === 0 ? R.enqueue(ht) : (ht.set(nt.subarray(0, dt), ut), R.enqueue(ht), nt = nt.subarray(dt)), ht = new Uint8Array(lt), ut = 0), ht.set(nt, ut), ut += nt.length;
      }
    }
    function _(R, K) {
      return gt(R, K), !0;
    }
    function at(R) {
      ht && ut > 0 && (R.enqueue(new Uint8Array(ht.buffer, 0, ut)), ht = null, ut = 0);
    }
    function G(R) {
      R.close();
    }
    var F = new TextEncoder();
    function $(R) {
      return F.encode(R);
    }
    function Y(R) {
      return F.encode(R);
    }
    function J(R, K) {
      typeof R.error == "function" ? R.error(K) : R.close();
    }
    function Q(R) {
      {
        var K = typeof Symbol == "function" && Symbol.toStringTag, nt = K && R[Symbol.toStringTag] || R.constructor.name || "Object";
        return nt;
      }
    }
    function q(R) {
      try {
        return !1;
      } catch (K) {
        return !0;
      }
    }
    function U(R) {
      return "" + R;
    }
    function N(R, K) {
      if (q())
        return H("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", K, Q(R)), U(R);
    }
    function D(R, K) {
      if (q())
        return H("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", K, Q(R)), U(R);
    }
    function k(R) {
      if (q())
        return H("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Q(R)), U(R);
    }
    var A = Object.prototype.hasOwnProperty, b = 0, d = 1, m = 2, v = 3, g = 4, x = 5, E = 6, P = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", S = P + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", u = new RegExp("^[" + P + "][" + S + "]*$"), y = {}, s = {};
    function a(R) {
      return A.call(s, R) ? !0 : A.call(y, R) ? !1 : u.test(R) ? (s[R] = !0, !0) : (y[R] = !0, H("Invalid attribute name: `%s`", R), !1);
    }
    function e(R, K, nt, dt) {
      if (nt !== null && nt.type === b)
        return !1;
      switch (typeof K) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (nt !== null)
            return !nt.acceptsBooleans;
          var wt = R.toLowerCase().slice(0, 5);
          return wt !== "data-" && wt !== "aria-";
        }
        default:
          return !1;
      }
    }
    function n(R) {
      return i.hasOwnProperty(R) ? i[R] : null;
    }
    function o(R, K, nt, dt, wt, Et, Rt) {
      this.acceptsBooleans = K === m || K === v || K === g, this.attributeName = dt, this.attributeNamespace = wt, this.mustUseProperty = nt, this.propertyName = R, this.type = K, this.sanitizeURL = Et, this.removeEmptyString = Rt;
    }
    var i = {}, c = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    c.forEach(function(R) {
      i[R] = new o(
        R,
        b,
        !1,
        // mustUseProperty
        R,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(R) {
      var K = R[0], nt = R[1];
      i[K] = new o(
        K,
        d,
        !1,
        // mustUseProperty
        nt,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(R) {
      i[R] = new o(
        R,
        m,
        !1,
        // mustUseProperty
        R.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(R) {
      i[R] = new o(
        R,
        m,
        !1,
        // mustUseProperty
        R,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(R) {
      i[R] = new o(
        R,
        v,
        !1,
        // mustUseProperty
        R.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(R) {
      i[R] = new o(
        R,
        v,
        !0,
        // mustUseProperty
        R,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(R) {
      i[R] = new o(
        R,
        g,
        !1,
        // mustUseProperty
        R,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(R) {
      i[R] = new o(
        R,
        E,
        !1,
        // mustUseProperty
        R,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(R) {
      i[R] = new o(
        R,
        x,
        !1,
        // mustUseProperty
        R.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var l = /[\-\:]([a-z])/g, h = function(R) {
      return R[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(R) {
      var K = R.replace(l, h);
      i[K] = new o(
        K,
        d,
        !1,
        // mustUseProperty
        R,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(R) {
      var K = R.replace(l, h);
      i[K] = new o(
        K,
        d,
        !1,
        // mustUseProperty
        R,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(R) {
      var K = R.replace(l, h);
      i[K] = new o(
        K,
        d,
        !1,
        // mustUseProperty
        R,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(R) {
      i[R] = new o(
        R,
        d,
        !1,
        // mustUseProperty
        R.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var C = "xlinkHref";
    i[C] = new o(
      "xlinkHref",
      d,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(R) {
      i[R] = new o(
        R,
        d,
        !1,
        // mustUseProperty
        R.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var M = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function O(R, K) {
      return R + K.charAt(0).toUpperCase() + K.substring(1);
    }
    var p = ["Webkit", "ms", "Moz", "O"];
    Object.keys(M).forEach(function(R) {
      p.forEach(function(K) {
        M[O(K, R)] = M[R];
      });
    });
    var w = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function T(R, K) {
      w[K.type] || K.onChange || K.onInput || K.readOnly || K.disabled || K.value == null || H("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), K.onChange || K.readOnly || K.disabled || K.checked == null || H("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function z(R, K) {
      if (R.indexOf("-") === -1)
        return typeof K.is == "string";
      switch (R) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var W = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, L = {}, I = new RegExp("^(aria)-[" + S + "]*$"), j = new RegExp("^(aria)[A-Z][" + S + "]*$");
    function Z(R, K) {
      {
        if (A.call(L, K) && L[K])
          return !0;
        if (j.test(K)) {
          var nt = "aria-" + K.slice(4).toLowerCase(), dt = W.hasOwnProperty(nt) ? nt : null;
          if (dt == null)
            return H("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", K), L[K] = !0, !0;
          if (K !== dt)
            return H("Invalid ARIA attribute `%s`. Did you mean `%s`?", K, dt), L[K] = !0, !0;
        }
        if (I.test(K)) {
          var wt = K.toLowerCase(), Et = W.hasOwnProperty(wt) ? wt : null;
          if (Et == null)
            return L[K] = !0, !1;
          if (K !== Et)
            return H("Unknown ARIA attribute `%s`. Did you mean `%s`?", K, Et), L[K] = !0, !0;
        }
      }
      return !0;
    }
    function V(R, K) {
      {
        var nt = [];
        for (var dt in K) {
          var wt = Z(R, dt);
          wt || nt.push(dt);
        }
        var Et = nt.map(function(Rt) {
          return "`" + Rt + "`";
        }).join(", ");
        nt.length === 1 ? H("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Et, R) : nt.length > 1 && H("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Et, R);
      }
    }
    function X(R, K) {
      z(R, K) || V(R, K);
    }
    var et = !1;
    function ot(R, K) {
      {
        if (R !== "input" && R !== "textarea" && R !== "select")
          return;
        K != null && K.value === null && !et && (et = !0, R === "select" && K.multiple ? H("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", R) : H("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", R));
      }
    }
    var it = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, pt = function() {
    };
    {
      var mt = {}, Ct = /^on./, kt = /^on[^A-Z]/, Lt = new RegExp("^(aria)-[" + S + "]*$"), Tt = new RegExp("^(aria)[A-Z][" + S + "]*$");
      pt = function(R, K, nt, dt) {
        if (A.call(mt, K) && mt[K])
          return !0;
        var wt = K.toLowerCase();
        if (wt === "onfocusin" || wt === "onfocusout")
          return H("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), mt[K] = !0, !0;
        if (dt != null) {
          var Et = dt.registrationNameDependencies, Rt = dt.possibleRegistrationNames;
          if (Et.hasOwnProperty(K))
            return !0;
          var Ft = Rt.hasOwnProperty(wt) ? Rt[wt] : null;
          if (Ft != null)
            return H("Invalid event handler property `%s`. Did you mean `%s`?", K, Ft), mt[K] = !0, !0;
          if (Ct.test(K))
            return H("Unknown event handler property `%s`. It will be ignored.", K), mt[K] = !0, !0;
        } else if (Ct.test(K))
          return kt.test(K) && H("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", K), mt[K] = !0, !0;
        if (Lt.test(K) || Tt.test(K))
          return !0;
        if (wt === "innerhtml")
          return H("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), mt[K] = !0, !0;
        if (wt === "aria")
          return H("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), mt[K] = !0, !0;
        if (wt === "is" && nt !== null && nt !== void 0 && typeof nt != "string")
          return H("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof nt), mt[K] = !0, !0;
        if (typeof nt == "number" && isNaN(nt))
          return H("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", K), mt[K] = !0, !0;
        var Yt = n(K), ie = Yt !== null && Yt.type === b;
        if (it.hasOwnProperty(wt)) {
          var se = it[wt];
          if (se !== K)
            return H("Invalid DOM property `%s`. Did you mean `%s`?", K, se), mt[K] = !0, !0;
        } else if (!ie && K !== wt)
          return H("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", K, wt), mt[K] = !0, !0;
        return typeof nt == "boolean" && e(K, nt, Yt) ? (nt ? H('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', nt, K, K, nt, K) : H('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', nt, K, K, nt, K, K, K), mt[K] = !0, !0) : ie ? !0 : e(K, nt, Yt) ? (mt[K] = !0, !1) : ((nt === "false" || nt === "true") && Yt !== null && Yt.type === v && (H("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", nt, K, nt === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', K, nt), mt[K] = !0), !0);
      };
    }
    var xt = function(R, K, nt) {
      {
        var dt = [];
        for (var wt in K) {
          var Et = pt(R, wt, K[wt], nt);
          Et || dt.push(wt);
        }
        var Rt = dt.map(function(Ft) {
          return "`" + Ft + "`";
        }).join(", ");
        dt.length === 1 ? H("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Rt, R) : dt.length > 1 && H("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Rt, R);
      }
    };
    function ct(R, K, nt) {
      z(R, K) || xt(R, K, nt);
    }
    var ft = function() {
    };
    {
      var St = /^(?:webkit|moz|o)[A-Z]/, Mt = /^-ms-/, Dt = /-(.)/g, Ot = /;\s*$/, Nt = {}, Wt = {}, zt = !1, Ht = !1, Kt = function(R) {
        return R.replace(Dt, function(K, nt) {
          return nt.toUpperCase();
        });
      }, Gt = function(R) {
        Nt.hasOwnProperty(R) && Nt[R] || (Nt[R] = !0, H(
          "Unsupported style property %s. Did you mean %s?",
          R,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Kt(R.replace(Mt, "ms-"))
        ));
      }, ee = function(R) {
        Nt.hasOwnProperty(R) && Nt[R] || (Nt[R] = !0, H("Unsupported vendor-prefixed style property %s. Did you mean %s?", R, R.charAt(0).toUpperCase() + R.slice(1)));
      }, Jt = function(R, K) {
        Wt.hasOwnProperty(K) && Wt[K] || (Wt[K] = !0, H(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, R, K.replace(Ot, "")));
      }, Qt = function(R, K) {
        zt || (zt = !0, H("`NaN` is an invalid value for the `%s` css style property.", R));
      }, ne = function(R, K) {
        Ht || (Ht = !0, H("`Infinity` is an invalid value for the `%s` css style property.", R));
      };
      ft = function(R, K) {
        R.indexOf("-") > -1 ? Gt(R) : St.test(R) ? ee(R) : Ot.test(K) && Jt(R, K), typeof K == "number" && (isNaN(K) ? Qt(R, K) : isFinite(K) || ne(R, K));
      };
    }
    var ae = ft, Me = /["'&<>]/;
    function he(R) {
      k(R);
      var K = "" + R, nt = Me.exec(K);
      if (!nt)
        return K;
      var dt, wt = "", Et, Rt = 0;
      for (Et = nt.index; Et < K.length; Et++) {
        switch (K.charCodeAt(Et)) {
          case 34:
            dt = "&quot;";
            break;
          case 38:
            dt = "&amp;";
            break;
          case 39:
            dt = "&#x27;";
            break;
          case 60:
            dt = "&lt;";
            break;
          case 62:
            dt = "&gt;";
            break;
          default:
            continue;
        }
        Rt !== Et && (wt += K.substring(Rt, Et)), Rt = Et + 1, wt += dt;
      }
      return Rt !== Et ? wt + K.substring(Rt, Et) : wt;
    }
    function fe(R) {
      return typeof R == "boolean" || typeof R == "number" ? "" + R : he(R);
    }
    var Ee = /([A-Z])/g, Xe = /^ms-/;
    function Se(R) {
      return R.replace(Ee, "-$1").toLowerCase().replace(Xe, "-ms-");
    }
    var Le = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Ye = !1;
    function qt(R) {
      !Ye && Le.test(R) && (Ye = !0, H("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(R)));
    }
    var ue = Array.isArray;
    function ye(R) {
      return ue(R);
    }
    var xe = Y("<script>"), Ve = Y("<\/script>"), ze = Y('<script src="'), _e = Y('<script type="module" src="'), Ce = Y('" async=""><\/script>');
    function bi(R) {
      return k(R), ("" + R).replace(ti, pi);
    }
    var ti = /(<\/|<)(s)(cript)/gi, pi = function(R, K, nt, dt) {
      return "" + K + (nt === "s" ? "\\u0073" : "\\u0053") + dt;
    };
    function Ki(R, K, nt, dt, wt) {
      var Et = R === void 0 ? "" : R, Rt = K === void 0 ? xe : Y('<script nonce="' + fe(K) + '">'), Ft = [];
      if (nt !== void 0 && Ft.push(Rt, $(bi(nt)), Ve), dt !== void 0)
        for (var Yt = 0; Yt < dt.length; Yt++)
          Ft.push(ze, $(fe(dt[Yt])), Ce);
      if (wt !== void 0)
        for (var ie = 0; ie < wt.length; ie++)
          Ft.push(_e, $(fe(wt[ie])), Ce);
      return {
        bootstrapChunks: Ft,
        startInlineScript: Rt,
        placeholderPrefix: Y(Et + "P:"),
        segmentPrefix: Y(Et + "S:"),
        boundaryPrefix: Et + "B:",
        idPrefix: Et,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var ni = 0, Fe = 1, Ie = 2, qe = 3, si = 4, sr = 5, Ui = 6, Di = 7;
    function fi(R, K) {
      return {
        insertionMode: R,
        selectedValue: K
      };
    }
    function ar(R) {
      var K = R === "http://www.w3.org/2000/svg" ? Ie : R === "http://www.w3.org/1998/Math/MathML" ? qe : ni;
      return fi(K, null);
    }
    function gi(R, K, nt) {
      switch (K) {
        case "select":
          return fi(Fe, nt.value != null ? nt.value : nt.defaultValue);
        case "svg":
          return fi(Ie, null);
        case "math":
          return fi(qe, null);
        case "foreignObject":
          return fi(Fe, null);
        case "table":
          return fi(si, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return fi(sr, null);
        case "colgroup":
          return fi(Di, null);
        case "tr":
          return fi(Ui, null);
      }
      return R.insertionMode >= si || R.insertionMode === ni ? fi(Fe, null) : R;
    }
    var Gi = null;
    function Ii(R) {
      var K = R.nextSuspenseID++;
      return Y(R.boundaryPrefix + K.toString(16));
    }
    function Br(R, K, nt) {
      var dt = R.idPrefix, wt = ":" + dt + "R" + K;
      return nt > 0 && (wt += "H" + nt.toString(32)), wt + ":";
    }
    function ii(R) {
      return fe(R);
    }
    var Ti = Y("<!-- -->");
    function Nr(R, K, nt, dt) {
      return K === "" ? dt : (dt && R.push(Ti), R.push($(ii(K))), !0);
    }
    function qi(R, K, nt, dt) {
      nt && dt && R.push(Ti);
    }
    var vt = /* @__PURE__ */ new Map();
    function Pt(R) {
      var K = vt.get(R);
      if (K !== void 0)
        return K;
      var nt = Y(fe(Se(R)));
      return vt.set(R, nt), nt;
    }
    var jt = Y(' style="'), Bt = Y(":"), $t = Y(";");
    function Xt(R, K, nt) {
      if (typeof nt != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var dt = !0;
      for (var wt in nt)
        if (A.call(nt, wt)) {
          var Et = nt[wt];
          if (!(Et == null || typeof Et == "boolean" || Et === "")) {
            var Rt = void 0, Ft = void 0, Yt = wt.indexOf("--") === 0;
            Yt ? (Rt = $(fe(wt)), D(Et, wt), Ft = $(fe(("" + Et).trim()))) : (ae(wt, Et), Rt = Pt(wt), typeof Et == "number" ? Et !== 0 && !A.call(M, wt) ? Ft = $(Et + "px") : Ft = $("" + Et) : (D(Et, wt), Ft = $(fe(("" + Et).trim())))), dt ? (dt = !1, R.push(jt, Rt, Bt, Ft)) : R.push($t, Rt, Bt, Ft);
          }
        }
      dt || R.push(be);
    }
    var te = Y(" "), le = Y('="'), be = Y('"'), ke = Y('=""');
    function ve(R, K, nt, dt) {
      switch (nt) {
        case "style": {
          Xt(R, K, dt);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(nt.length > 2 && (nt[0] === "o" || nt[0] === "O") && (nt[1] === "n" || nt[1] === "N"))
      ) {
        var wt = n(nt);
        if (wt !== null) {
          switch (typeof dt) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!wt.acceptsBooleans)
                return;
          }
          var Et = wt.attributeName, Rt = $(Et);
          switch (wt.type) {
            case v:
              dt && R.push(te, Rt, ke);
              return;
            case g:
              dt === !0 ? R.push(te, Rt, ke) : dt === !1 || R.push(te, Rt, le, $(fe(dt)), be);
              return;
            case x:
              isNaN(dt) || R.push(te, Rt, le, $(fe(dt)), be);
              break;
            case E:
              !isNaN(dt) && dt >= 1 && R.push(te, Rt, le, $(fe(dt)), be);
              break;
            default:
              wt.sanitizeURL && (N(dt, Et), dt = "" + dt, qt(dt)), R.push(te, Rt, le, $(fe(dt)), be);
          }
        } else if (a(nt)) {
          switch (typeof dt) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var Ft = nt.toLowerCase().slice(0, 5);
              if (Ft !== "data-" && Ft !== "aria-")
                return;
            }
          }
          R.push(te, $(nt), le, $(fe(dt)), be);
        }
      }
    }
    var je = Y(">"), Mi = Y("/>");
    function mi(R, K, nt) {
      if (K != null) {
        if (nt != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof K != "object" || !("__html" in K))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var dt = K.__html;
        dt != null && (k(dt), R.push($("" + dt)));
      }
    }
    var yi = !1, lr = !1, Xi = !1, cr = !1, hr = !1, Sr = !1, Ji = !1;
    function rn(R, K) {
      {
        var nt = R[K];
        if (nt != null) {
          var dt = ye(nt);
          R.multiple && !dt ? H("The `%s` prop supplied to <select> must be an array if `multiple` is true.", K) : !R.multiple && dt && H("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", K);
        }
      }
    }
    function Vo(R, K, nt) {
      T("select", K), rn(K, "value"), rn(K, "defaultValue"), K.value !== void 0 && K.defaultValue !== void 0 && !Xi && (H("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Xi = !0), R.push(xi("select"));
      var dt = null, wt = null;
      for (var Et in K)
        if (A.call(K, Et)) {
          var Rt = K[Et];
          if (Rt == null)
            continue;
          switch (Et) {
            case "children":
              dt = Rt;
              break;
            case "dangerouslySetInnerHTML":
              wt = Rt;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              ve(R, nt, Et, Rt);
              break;
          }
        }
      return R.push(je), mi(R, wt, dt), dt;
    }
    function Yi(R) {
      var K = "";
      return t.Children.forEach(R, function(nt) {
        nt != null && (K += nt, !hr && typeof nt != "string" && typeof nt != "number" && (hr = !0, H("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), K;
    }
    var ao = Y(' selected=""');
    function da(R, K, nt, dt) {
      var wt = dt.selectedValue;
      R.push(xi("option"));
      var Et = null, Rt = null, Ft = null, Yt = null;
      for (var ie in K)
        if (A.call(K, ie)) {
          var se = K[ie];
          if (se == null)
            continue;
          switch (ie) {
            case "children":
              Et = se;
              break;
            case "selected":
              Ft = se, Ji || (H("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Ji = !0);
              break;
            case "dangerouslySetInnerHTML":
              Yt = se;
              break;
            case "value":
              Rt = se;
            default:
              ve(R, nt, ie, se);
              break;
          }
        }
      if (wt != null) {
        var ge;
        if (Rt !== null ? (N(Rt, "value"), ge = "" + Rt) : (Yt !== null && (Sr || (Sr = !0, H("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), ge = Yi(Et)), ye(wt))
          for (var Te = 0; Te < wt.length; Te++) {
            N(wt[Te], "value");
            var Re = "" + wt[Te];
            if (Re === ge) {
              R.push(ao);
              break;
            }
          }
        else
          N(wt, "select.value"), "" + wt === ge && R.push(ao);
      } else
        Ft && R.push(ao);
      return R.push(je), mi(R, Yt, Et), Et;
    }
    function pa(R, K, nt) {
      T("input", K), K.checked !== void 0 && K.defaultChecked !== void 0 && !lr && (H("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", K.type), lr = !0), K.value !== void 0 && K.defaultValue !== void 0 && !yi && (H("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", K.type), yi = !0), R.push(xi("input"));
      var dt = null, wt = null, Et = null, Rt = null;
      for (var Ft in K)
        if (A.call(K, Ft)) {
          var Yt = K[Ft];
          if (Yt == null)
            continue;
          switch (Ft) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              Rt = Yt;
              break;
            case "defaultValue":
              wt = Yt;
              break;
            case "checked":
              Et = Yt;
              break;
            case "value":
              dt = Yt;
              break;
            default:
              ve(R, nt, Ft, Yt);
              break;
          }
        }
      return Et !== null ? ve(R, nt, "checked", Et) : Rt !== null && ve(R, nt, "checked", Rt), dt !== null ? ve(R, nt, "value", dt) : wt !== null && ve(R, nt, "value", wt), R.push(Mi), null;
    }
    function Qi(R, K, nt) {
      T("textarea", K), K.value !== void 0 && K.defaultValue !== void 0 && !cr && (H("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), cr = !0), R.push(xi("textarea"));
      var dt = null, wt = null, Et = null;
      for (var Rt in K)
        if (A.call(K, Rt)) {
          var Ft = K[Rt];
          if (Ft == null)
            continue;
          switch (Rt) {
            case "children":
              Et = Ft;
              break;
            case "value":
              dt = Ft;
              break;
            case "defaultValue":
              wt = Ft;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              ve(R, nt, Rt, Ft);
              break;
          }
        }
      if (dt === null && wt !== null && (dt = wt), R.push(je), Et != null) {
        if (H("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), dt != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (ye(Et)) {
          if (Et.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          k(Et[0]), dt = "" + Et[0];
        }
        k(Et), dt = "" + Et;
      }
      return typeof dt == "string" && dt[0] === `
` && R.push(Cr), dt !== null && (N(dt, "value"), R.push($(ii("" + dt)))), null;
    }
    function lo(R, K, nt, dt) {
      R.push(xi(nt));
      for (var wt in K)
        if (A.call(K, wt)) {
          var Et = K[wt];
          if (Et == null)
            continue;
          switch (wt) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(nt + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              ve(R, dt, wt, Et);
              break;
          }
        }
      return R.push(Mi), null;
    }
    function bn(R, K, nt) {
      R.push(xi("menuitem"));
      for (var dt in K)
        if (A.call(K, dt)) {
          var wt = K[dt];
          if (wt == null)
            continue;
          switch (dt) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              ve(R, nt, dt, wt);
              break;
          }
        }
      return R.push(je), null;
    }
    function He(R, K, nt) {
      R.push(xi("title"));
      var dt = null;
      for (var wt in K)
        if (A.call(K, wt)) {
          var Et = K[wt];
          if (Et == null)
            continue;
          switch (wt) {
            case "children":
              dt = Et;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              ve(R, nt, wt, Et);
              break;
          }
        }
      R.push(je);
      {
        var Rt = Array.isArray(dt) && dt.length < 2 ? dt[0] || null : dt;
        Array.isArray(dt) && dt.length > 1 ? H("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : Rt != null && Rt.$$typeof != null ? H("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : Rt != null && typeof Rt != "string" && typeof Rt != "number" && H("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return dt;
    }
    function wr(R, K, nt, dt) {
      R.push(xi(nt));
      var wt = null, Et = null;
      for (var Rt in K)
        if (A.call(K, Rt)) {
          var Ft = K[Rt];
          if (Ft == null)
            continue;
          switch (Rt) {
            case "children":
              wt = Ft;
              break;
            case "dangerouslySetInnerHTML":
              Et = Ft;
              break;
            default:
              ve(R, dt, Rt, Ft);
              break;
          }
        }
      return R.push(je), mi(R, Et, wt), typeof wt == "string" ? (R.push($(ii(wt))), null) : wt;
    }
    function xn(R, K, nt, dt) {
      R.push(xi(nt));
      var wt = null, Et = null;
      for (var Rt in K)
        if (A.call(K, Rt)) {
          var Ft = K[Rt];
          if (Ft == null)
            continue;
          switch (Rt) {
            case "children":
              wt = Ft;
              break;
            case "dangerouslySetInnerHTML":
              Et = Ft;
              break;
            case "style":
              Xt(R, dt, Ft);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              a(Rt) && typeof Ft != "function" && typeof Ft != "symbol" && R.push(te, $(Rt), le, $(fe(Ft)), be);
              break;
          }
        }
      return R.push(je), mi(R, Et, wt), wt;
    }
    var Cr = Y(`
`);
    function ur(R, K, nt, dt) {
      R.push(xi(nt));
      var wt = null, Et = null;
      for (var Rt in K)
        if (A.call(K, Rt)) {
          var Ft = K[Rt];
          if (Ft == null)
            continue;
          switch (Rt) {
            case "children":
              wt = Ft;
              break;
            case "dangerouslySetInnerHTML":
              Et = Ft;
              break;
            default:
              ve(R, dt, Rt, Ft);
              break;
          }
        }
      if (R.push(je), Et != null) {
        if (wt != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof Et != "object" || !("__html" in Et))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var Yt = Et.__html;
        Yt != null && (typeof Yt == "string" && Yt.length > 0 && Yt[0] === `
` ? R.push(Cr, $(Yt)) : (k(Yt), R.push($("" + Yt))));
      }
      return typeof wt == "string" && wt[0] === `
` && R.push(Cr), wt;
    }
    var Sn = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, dr = /* @__PURE__ */ new Map();
    function xi(R) {
      var K = dr.get(R);
      if (K === void 0) {
        if (!Sn.test(R))
          throw new Error("Invalid tag: " + R);
        K = Y("<" + R), dr.set(R, K);
      }
      return K;
    }
    var co = Y("<!DOCTYPE html>");
    function nn(R, K, nt, dt, wt) {
      switch (X(K, nt), ot(K, nt), ct(K, nt, null), !nt.suppressContentEditableWarning && nt.contentEditable && nt.children != null && H("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), wt.insertionMode !== Ie && wt.insertionMode !== qe && K.indexOf("-") === -1 && typeof nt.is != "string" && K.toLowerCase() !== K && H("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", K), K) {
        case "select":
          return Vo(R, nt, dt);
        case "option":
          return da(R, nt, dt, wt);
        case "textarea":
          return Qi(R, nt, dt);
        case "input":
          return pa(R, nt, dt);
        case "menuitem":
          return bn(R, nt, dt);
        case "title":
          return He(R, nt, dt);
        case "listing":
        case "pre":
          return ur(R, nt, K, dt);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return lo(R, nt, K, dt);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return wr(R, nt, K, dt);
        case "html":
          return wt.insertionMode === ni && R.push(co), wr(R, nt, K, dt);
        default:
          return K.indexOf("-") === -1 && typeof nt.is != "string" ? wr(R, nt, K, dt) : xn(R, nt, K, dt);
      }
    }
    var $o = Y("</"), Zo = Y(">");
    function Ko(R, K, nt) {
      switch (K) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          R.push($o, $(K), Zo);
      }
    }
    function fa(R, K) {
      for (var nt = K.bootstrapChunks, dt = 0; dt < nt.length - 1; dt++)
        gt(R, nt[dt]);
      return dt < nt.length ? _(R, nt[dt]) : !0;
    }
    var ga = Y('<template id="'), on = Y('"></template>');
    function qo(R, K, nt) {
      gt(R, ga), gt(R, K.placeholderPrefix);
      var dt = $(nt.toString(16));
      return gt(R, dt), _(R, on);
    }
    var wn = Y("<!--$-->"), Cn = Y('<!--$?--><template id="'), ma = Y('"></template>'), sn = Y("<!--$!-->"), ho = Y("<!--/$-->"), uo = Y("<template"), zr = Y('"'), an = Y(' data-dgst="'), kn = Y(' data-msg="'), Jo = Y(' data-stck="'), Qo = Y("></template>");
    function ts(R, K) {
      return _(R, wn);
    }
    function Tn(R, K, nt) {
      if (gt(R, Cn), nt === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return gt(R, nt), _(R, ma);
    }
    function Si(R, K, nt, dt, wt) {
      var Et;
      return Et = _(R, sn), gt(R, uo), nt && (gt(R, an), gt(R, $(fe(nt))), gt(R, zr)), dt && (gt(R, kn), gt(R, $(fe(dt))), gt(R, zr)), wt && (gt(R, Jo), gt(R, $(fe(wt))), gt(R, zr)), Et = _(R, Qo), Et;
    }
    function es(R, K) {
      return _(R, ho);
    }
    function Mn(R, K) {
      return _(R, ho);
    }
    function ya(R, K) {
      return _(R, ho);
    }
    var is = Y('<div hidden id="'), An = Y('">'), rs = Y("</div>"), ns = Y('<svg aria-hidden="true" style="display:none" id="'), Pn = Y('">'), En = Y("</svg>"), os = Y('<math aria-hidden="true" style="display:none" id="'), ss = Y('">'), as = Y("</math>"), po = Y('<table hidden id="'), ls = Y('">'), bt = Y("</table>"), At = Y('<table hidden><tbody id="'), It = Y('">'), _t = Y("</tbody></table>"), Zt = Y('<table hidden><tr id="'), Vt = Y('">'), re = Y("</tr></table>"), ce = Y('<table hidden><colgroup id="'), we = Y('">'), Oe = Y("</colgroup></table>");
    function Pe(R, K, nt, dt) {
      switch (nt.insertionMode) {
        case ni:
        case Fe:
          return gt(R, is), gt(R, K.segmentPrefix), gt(R, $(dt.toString(16))), _(R, An);
        case Ie:
          return gt(R, ns), gt(R, K.segmentPrefix), gt(R, $(dt.toString(16))), _(R, Pn);
        case qe:
          return gt(R, os), gt(R, K.segmentPrefix), gt(R, $(dt.toString(16))), _(R, ss);
        case si:
          return gt(R, po), gt(R, K.segmentPrefix), gt(R, $(dt.toString(16))), _(R, ls);
        case sr:
          return gt(R, At), gt(R, K.segmentPrefix), gt(R, $(dt.toString(16))), _(R, It);
        case Ui:
          return gt(R, Zt), gt(R, K.segmentPrefix), gt(R, $(dt.toString(16))), _(R, Vt);
        case Di:
          return gt(R, ce), gt(R, K.segmentPrefix), gt(R, $(dt.toString(16))), _(R, we);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Ge(R, K) {
      switch (K.insertionMode) {
        case ni:
        case Fe:
          return _(R, rs);
        case Ie:
          return _(R, En);
        case qe:
          return _(R, as);
        case si:
          return _(R, bt);
        case sr:
          return _(R, _t);
        case Ui:
          return _(R, re);
        case Di:
          return _(R, Oe);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var wi = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", Ri = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', ji = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', Fr = Y(wi + ';$RS("'), cs = Y('$RS("'), fo = Y('","'), va = Y('")<\/script>');
    function Qh(R, K, nt) {
      gt(R, K.startInlineScript), K.sentCompleteSegmentFunction ? gt(R, cs) : (K.sentCompleteSegmentFunction = !0, gt(R, Fr)), gt(R, K.segmentPrefix);
      var dt = $(nt.toString(16));
      return gt(R, dt), gt(R, fo), gt(R, K.placeholderPrefix), gt(R, dt), _(R, va);
    }
    var tu = Y(Ri + ';$RC("'), Hl = Y('$RC("'), Ul = Y('","'), eu = Y('")<\/script>');
    function iu(R, K, nt, dt) {
      if (gt(R, K.startInlineScript), K.sentCompleteBoundaryFunction ? gt(R, Hl) : (K.sentCompleteBoundaryFunction = !0, gt(R, tu)), nt === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var wt = $(dt.toString(16));
      return gt(R, nt), gt(R, Ul), gt(R, K.segmentPrefix), gt(R, wt), _(R, eu);
    }
    var ru = Y(ji + ';$RX("'), nu = Y('$RX("'), Vi = Y('"'), ou = Y(")<\/script>"), hs = Y(",");
    function Gl(R, K, nt, dt, wt, Et) {
      if (gt(R, K.startInlineScript), K.sentClientRenderFunction ? gt(R, nu) : (K.sentClientRenderFunction = !0, gt(R, ru)), nt === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return gt(R, nt), gt(R, Vi), (dt || wt || Et) && (gt(R, hs), gt(R, $(us(dt || "")))), (wt || Et) && (gt(R, hs), gt(R, $(us(wt || "")))), Et && (gt(R, hs), gt(R, $(us(Et)))), _(R, ou);
    }
    var Xl = /[<\u2028\u2029]/g;
    function us(R) {
      var K = JSON.stringify(R);
      return K.replace(Xl, function(nt) {
        switch (nt) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var Ai = Object.assign, ba = Symbol.for("react.element"), ds = Symbol.for("react.portal"), ps = Symbol.for("react.fragment"), fs = Symbol.for("react.strict_mode"), gs = Symbol.for("react.profiler"), Ln = Symbol.for("react.provider"), xa = Symbol.for("react.context"), Sa = Symbol.for("react.forward_ref"), wa = Symbol.for("react.suspense"), Ca = Symbol.for("react.suspense_list"), ms = Symbol.for("react.memo"), ys = Symbol.for("react.lazy"), su = Symbol.for("react.scope"), au = Symbol.for("react.debug_trace_mode"), Yl = Symbol.for("react.legacy_hidden"), Je = Symbol.for("react.default_value"), On = Symbol.iterator, Vl = "@@iterator";
    function $l(R) {
      if (R === null || typeof R != "object")
        return null;
      var K = On && R[On] || R[Vl];
      return typeof K == "function" ? K : null;
    }
    function Zl(R, K, nt) {
      var dt = R.displayName;
      if (dt)
        return dt;
      var wt = K.displayName || K.name || "";
      return wt !== "" ? nt + "(" + wt + ")" : nt;
    }
    function ka(R) {
      return R.displayName || "Context";
    }
    function Ke(R) {
      if (R == null)
        return null;
      if (typeof R.tag == "number" && H("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof R == "function")
        return R.displayName || R.name || null;
      if (typeof R == "string")
        return R;
      switch (R) {
        case ps:
          return "Fragment";
        case ds:
          return "Portal";
        case gs:
          return "Profiler";
        case fs:
          return "StrictMode";
        case wa:
          return "Suspense";
        case Ca:
          return "SuspenseList";
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case xa:
            var K = R;
            return ka(K) + ".Consumer";
          case Ln:
            var nt = R;
            return ka(nt._context) + ".Provider";
          case Sa:
            return Zl(R, R.render, "ForwardRef");
          case ms:
            var dt = R.displayName || null;
            return dt !== null ? dt : Ke(R.type) || "Memo";
          case ys: {
            var wt = R, Et = wt._payload, Rt = wt._init;
            try {
              return Ke(Rt(Et));
            } catch (Ft) {
              return null;
            }
          }
        }
      return null;
    }
    var Dn = 0, Ta, Ma, Kl, ql, vs, bs, In;
    function xs() {
    }
    xs.__reactDisabledLog = !0;
    function Ss() {
      {
        if (Dn === 0) {
          Ta = console.log, Ma = console.info, Kl = console.warn, ql = console.error, vs = console.group, bs = console.groupCollapsed, In = console.groupEnd;
          var R = {
            configurable: !0,
            enumerable: !0,
            value: xs,
            writable: !0
          };
          Object.defineProperties(console, {
            info: R,
            log: R,
            warn: R,
            error: R,
            group: R,
            groupCollapsed: R,
            groupEnd: R
          });
        }
        Dn++;
      }
    }
    function lu() {
      {
        if (Dn--, Dn === 0) {
          var R = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ai({}, R, {
              value: Ta
            }),
            info: Ai({}, R, {
              value: Ma
            }),
            warn: Ai({}, R, {
              value: Kl
            }),
            error: Ai({}, R, {
              value: ql
            }),
            group: Ai({}, R, {
              value: vs
            }),
            groupCollapsed: Ai({}, R, {
              value: bs
            }),
            groupEnd: Ai({}, R, {
              value: In
            })
          });
        }
        Dn < 0 && H("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var go = f.ReactCurrentDispatcher, Aa;
    function Rn(R, K, nt) {
      {
        if (Aa === void 0)
          try {
            throw Error();
          } catch (wt) {
            var dt = wt.stack.trim().match(/\n( *(at )?)/);
            Aa = dt && dt[1] || "";
          }
        return `
` + Aa + R;
      }
    }
    var Pa = !1, jn;
    {
      var Jl = typeof WeakMap == "function" ? WeakMap : Map;
      jn = new Jl();
    }
    function ws(R, K) {
      if (!R || Pa)
        return "";
      {
        var nt = jn.get(R);
        if (nt !== void 0)
          return nt;
      }
      var dt;
      Pa = !0;
      var wt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Et;
      Et = go.current, go.current = null, Ss();
      try {
        if (K) {
          var Rt = function() {
            throw Error();
          };
          if (Object.defineProperty(Rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Rt, []);
            } catch (hi) {
              dt = hi;
            }
            Reflect.construct(R, [], Rt);
          } else {
            try {
              Rt.call();
            } catch (hi) {
              dt = hi;
            }
            R.call(Rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (hi) {
            dt = hi;
          }
          R();
        }
      } catch (hi) {
        if (hi && dt && typeof hi.stack == "string") {
          for (var Ft = hi.stack.split(`
`), Yt = dt.stack.split(`
`), ie = Ft.length - 1, se = Yt.length - 1; ie >= 1 && se >= 0 && Ft[ie] !== Yt[se]; )
            se--;
          for (; ie >= 1 && se >= 0; ie--, se--)
            if (Ft[ie] !== Yt[se]) {
              if (ie !== 1 || se !== 1)
                do
                  if (ie--, se--, se < 0 || Ft[ie] !== Yt[se]) {
                    var ge = `
` + Ft[ie].replace(" at new ", " at ");
                    return R.displayName && ge.includes("<anonymous>") && (ge = ge.replace("<anonymous>", R.displayName)), typeof R == "function" && jn.set(R, ge), ge;
                  }
                while (ie >= 1 && se >= 0);
              break;
            }
        }
      } finally {
        Pa = !1, go.current = Et, lu(), Error.prepareStackTrace = wt;
      }
      var Te = R ? R.displayName || R.name : "", Re = Te ? Rn(Te) : "";
      return typeof R == "function" && jn.set(R, Re), Re;
    }
    function Cs(R, K, nt) {
      return ws(R, !0);
    }
    function Ea(R, K, nt) {
      return ws(R, !1);
    }
    function La(R) {
      var K = R.prototype;
      return !!(K && K.isReactComponent);
    }
    function _n(R, K, nt) {
      if (R == null)
        return "";
      if (typeof R == "function")
        return ws(R, La(R));
      if (typeof R == "string")
        return Rn(R);
      switch (R) {
        case wa:
          return Rn("Suspense");
        case Ca:
          return Rn("SuspenseList");
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case Sa:
            return Ea(R.render);
          case ms:
            return _n(R.type);
          case ys: {
            var dt = R, wt = dt._payload, Et = dt._init;
            try {
              return _n(Et(wt));
            } catch (Rt) {
            }
          }
        }
      return "";
    }
    var Oa = {}, Ql = f.ReactDebugCurrentFrame;
    function Wr(R) {
      if (R) {
        var K = _n(R.type);
        Ql.setExtraStackFrame(K);
      } else
        Ql.setExtraStackFrame(null);
    }
    function tc(R, K, nt, dt, wt) {
      {
        var Et = Function.call.bind(A);
        for (var Rt in R)
          if (Et(R, Rt)) {
            var Ft = void 0;
            try {
              if (typeof R[Rt] != "function") {
                var Yt = Error((dt || "React class") + ": " + nt + " type `" + Rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof R[Rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Yt.name = "Invariant Violation", Yt;
              }
              Ft = R[Rt](K, Rt, dt, nt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ie) {
              Ft = ie;
            }
            Ft && !(Ft instanceof Error) && (Wr(wt), H("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", dt || "React class", nt, Rt, typeof Ft), Wr(null)), Ft instanceof Error && !(Ft.message in Oa) && (Oa[Ft.message] = !0, Wr(wt), H("Failed %s type: %s", nt, Ft.message), Wr(null));
          }
      }
    }
    var kr;
    kr = {};
    var Bn = {};
    Object.freeze(Bn);
    function ks(R, K) {
      {
        var nt = R.contextTypes;
        if (!nt)
          return Bn;
        var dt = {};
        for (var wt in nt)
          dt[wt] = K[wt];
        {
          var Et = Ke(R) || "Unknown";
          tc(nt, dt, "context", Et);
        }
        return dt;
      }
    }
    function Ts(R, K, nt, dt) {
      {
        if (typeof R.getChildContext != "function") {
          {
            var wt = Ke(K) || "Unknown";
            kr[wt] || (kr[wt] = !0, H("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", wt, wt));
          }
          return nt;
        }
        var Et = R.getChildContext();
        for (var Rt in Et)
          if (!(Rt in dt))
            throw new Error((Ke(K) || "Unknown") + '.getChildContext(): key "' + Rt + '" is not defined in childContextTypes.');
        {
          var Ft = Ke(K) || "Unknown";
          tc(dt, Et, "child context", Ft);
        }
        return Ai({}, nt, Et);
      }
    }
    var Nn;
    Nn = {};
    var ec = null, Hr = null;
    function Ms(R) {
      R.context._currentValue = R.parentValue;
    }
    function zn(R) {
      R.context._currentValue = R.value;
    }
    function As(R, K) {
      if (R !== K) {
        Ms(R);
        var nt = R.parent, dt = K.parent;
        if (nt === null) {
          if (dt !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (dt === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          As(nt, dt);
        }
        zn(K);
      }
    }
    function ic(R) {
      Ms(R);
      var K = R.parent;
      K !== null && ic(K);
    }
    function rc(R) {
      var K = R.parent;
      K !== null && rc(K), zn(R);
    }
    function Fn(R, K) {
      Ms(R);
      var nt = R.parent;
      if (nt === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      nt.depth === K.depth ? As(nt, K) : Fn(nt, K);
    }
    function Ps(R, K) {
      var nt = K.parent;
      if (nt === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      R.depth === nt.depth ? As(R, nt) : Ps(R, nt), zn(K);
    }
    function Es(R) {
      var K = Hr, nt = R;
      K !== nt && (K === null ? rc(nt) : nt === null ? ic(K) : K.depth === nt.depth ? As(K, nt) : K.depth > nt.depth ? Fn(K, nt) : Ps(K, nt), Hr = nt);
    }
    function nc(R, K) {
      var nt;
      nt = R._currentValue, R._currentValue = K, R._currentRenderer !== void 0 && R._currentRenderer !== null && R._currentRenderer !== Nn && H("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), R._currentRenderer = Nn;
      var dt = Hr, wt = {
        parent: dt,
        depth: dt === null ? 0 : dt.depth + 1,
        context: R,
        parentValue: nt,
        value: K
      };
      return Hr = wt, wt;
    }
    function oc(R) {
      var K = Hr;
      if (K === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      K.context !== R && H("The parent context is not the expected context. This is probably a bug in React.");
      {
        var nt = K.parentValue;
        nt === Je ? K.context._currentValue = K.context._defaultValue : K.context._currentValue = nt, R._currentRenderer !== void 0 && R._currentRenderer !== null && R._currentRenderer !== Nn && H("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), R._currentRenderer = Nn;
      }
      return Hr = K.parent;
    }
    function Da() {
      return Hr;
    }
    function ln(R) {
      var K = R._currentValue;
      return K;
    }
    function mo(R) {
      return R._reactInternals;
    }
    function Ia(R, K) {
      R._reactInternals = K;
    }
    var Ra = {}, yo = {}, vo, bo, xo, Ls, ja, So, _a, Ba, Na;
    {
      vo = /* @__PURE__ */ new Set(), bo = /* @__PURE__ */ new Set(), xo = /* @__PURE__ */ new Set(), _a = /* @__PURE__ */ new Set(), Ls = /* @__PURE__ */ new Set(), Ba = /* @__PURE__ */ new Set(), Na = /* @__PURE__ */ new Set();
      var sc = /* @__PURE__ */ new Set();
      So = function(R, K) {
        if (!(R === null || typeof R == "function")) {
          var nt = K + "_" + R;
          sc.has(nt) || (sc.add(nt), H("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", K, R));
        }
      }, ja = function(R, K) {
        if (K === void 0) {
          var nt = Ke(R) || "Component";
          Ls.has(nt) || (Ls.add(nt), H("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", nt));
        }
      };
    }
    function ac(R, K) {
      {
        var nt = R.constructor, dt = nt && Ke(nt) || "ReactClass", wt = dt + "." + K;
        if (Ra[wt])
          return;
        H(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, K, K, dt), Ra[wt] = !0;
      }
    }
    var za = {
      isMounted: function(R) {
        return !1;
      },
      enqueueSetState: function(R, K, nt) {
        var dt = mo(R);
        dt.queue === null ? ac(R, "setState") : (dt.queue.push(K), nt != null && So(nt, "setState"));
      },
      enqueueReplaceState: function(R, K, nt) {
        var dt = mo(R);
        dt.replace = !0, dt.queue = [K], nt != null && So(nt, "setState");
      },
      enqueueForceUpdate: function(R, K) {
        var nt = mo(R);
        nt.queue === null ? ac(R, "forceUpdate") : K != null && So(K, "setState");
      }
    };
    function cu(R, K, nt, dt, wt) {
      var Et = nt(wt, dt);
      ja(K, Et);
      var Rt = Et == null ? dt : Ai({}, dt, Et);
      return Rt;
    }
    function hu(R, K, nt) {
      var dt = Bn, wt = R.contextType;
      if ("contextType" in R) {
        var Et = (
          // Allow null for conditional declaration
          wt === null || wt !== void 0 && wt.$$typeof === xa && wt._context === void 0
        );
        if (!Et && !Na.has(R)) {
          Na.add(R);
          var Rt = "";
          wt === void 0 ? Rt = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof wt != "object" ? Rt = " However, it is set to a " + typeof wt + "." : wt.$$typeof === Ln ? Rt = " Did you accidentally pass the Context.Provider instead?" : wt._context !== void 0 ? Rt = " Did you accidentally pass the Context.Consumer instead?" : Rt = " However, it is set to an object with keys {" + Object.keys(wt).join(", ") + "}.", H("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Ke(R) || "Component", Rt);
        }
      }
      typeof wt == "object" && wt !== null ? dt = ln(wt) : dt = nt;
      var Ft = new R(K, dt);
      {
        if (typeof R.getDerivedStateFromProps == "function" && (Ft.state === null || Ft.state === void 0)) {
          var Yt = Ke(R) || "Component";
          vo.has(Yt) || (vo.add(Yt), H("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Yt, Ft.state === null ? "null" : "undefined", Yt));
        }
        if (typeof R.getDerivedStateFromProps == "function" || typeof Ft.getSnapshotBeforeUpdate == "function") {
          var ie = null, se = null, ge = null;
          if (typeof Ft.componentWillMount == "function" && Ft.componentWillMount.__suppressDeprecationWarning !== !0 ? ie = "componentWillMount" : typeof Ft.UNSAFE_componentWillMount == "function" && (ie = "UNSAFE_componentWillMount"), typeof Ft.componentWillReceiveProps == "function" && Ft.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? se = "componentWillReceiveProps" : typeof Ft.UNSAFE_componentWillReceiveProps == "function" && (se = "UNSAFE_componentWillReceiveProps"), typeof Ft.componentWillUpdate == "function" && Ft.componentWillUpdate.__suppressDeprecationWarning !== !0 ? ge = "componentWillUpdate" : typeof Ft.UNSAFE_componentWillUpdate == "function" && (ge = "UNSAFE_componentWillUpdate"), ie !== null || se !== null || ge !== null) {
            var Te = Ke(R) || "Component", Re = typeof R.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            xo.has(Te) || (xo.add(Te), H(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Te, Re, ie !== null ? `
  ` + ie : "", se !== null ? `
  ` + se : "", ge !== null ? `
  ` + ge : ""));
          }
        }
      }
      return Ft;
    }
    function Fa(R, K, nt) {
      {
        var dt = Ke(K) || "Component", wt = R.render;
        wt || (K.prototype && typeof K.prototype.render == "function" ? H("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", dt) : H("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", dt)), R.getInitialState && !R.getInitialState.isReactClassApproved && !R.state && H("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", dt), R.getDefaultProps && !R.getDefaultProps.isReactClassApproved && H("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", dt), R.propTypes && H("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", dt), R.contextType && H("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", dt), R.contextTypes && H("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", dt), K.contextType && K.contextTypes && !Ba.has(K) && (Ba.add(K), H("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", dt)), typeof R.componentShouldUpdate == "function" && H("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", dt), K.prototype && K.prototype.isPureReactComponent && typeof R.shouldComponentUpdate != "undefined" && H("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Ke(K) || "A pure component"), typeof R.componentDidUnmount == "function" && H("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", dt), typeof R.componentDidReceiveProps == "function" && H("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", dt), typeof R.componentWillRecieveProps == "function" && H("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", dt), typeof R.UNSAFE_componentWillRecieveProps == "function" && H("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", dt);
        var Et = R.props !== nt;
        R.props !== void 0 && Et && H("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", dt, dt), R.defaultProps && H("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", dt, dt), typeof R.getSnapshotBeforeUpdate == "function" && typeof R.componentDidUpdate != "function" && !bo.has(K) && (bo.add(K), H("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Ke(K))), typeof R.getDerivedStateFromProps == "function" && H("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", dt), typeof R.getDerivedStateFromError == "function" && H("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", dt), typeof K.getSnapshotBeforeUpdate == "function" && H("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", dt);
        var Rt = R.state;
        Rt && (typeof Rt != "object" || ye(Rt)) && H("%s.state: must be set to an object or null", dt), typeof R.getChildContext == "function" && typeof K.childContextTypes != "object" && H("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", dt);
      }
    }
    function Os(R, K) {
      var nt = K.state;
      if (typeof K.componentWillMount == "function") {
        if (K.componentWillMount.__suppressDeprecationWarning !== !0) {
          var dt = Ke(R) || "Unknown";
          yo[dt] || (B(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            dt
          ), yo[dt] = !0);
        }
        K.componentWillMount();
      }
      typeof K.UNSAFE_componentWillMount == "function" && K.UNSAFE_componentWillMount(), nt !== K.state && (H("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Ke(R) || "Component"), za.enqueueReplaceState(K, K.state, null));
    }
    function uu(R, K, nt, dt) {
      if (R.queue !== null && R.queue.length > 0) {
        var wt = R.queue, Et = R.replace;
        if (R.queue = null, R.replace = !1, Et && wt.length === 1)
          K.state = wt[0];
        else {
          for (var Rt = Et ? wt[0] : K.state, Ft = !0, Yt = Et ? 1 : 0; Yt < wt.length; Yt++) {
            var ie = wt[Yt], se = typeof ie == "function" ? ie.call(K, Rt, nt, dt) : ie;
            se != null && (Ft ? (Ft = !1, Rt = Ai({}, Rt, se)) : Ai(Rt, se));
          }
          K.state = Rt;
        }
      } else
        R.queue = null;
    }
    function lc(R, K, nt, dt) {
      Fa(R, K, nt);
      var wt = R.state !== void 0 ? R.state : null;
      R.updater = za, R.props = nt, R.state = wt;
      var Et = {
        queue: [],
        replace: !1
      };
      Ia(R, Et);
      var Rt = K.contextType;
      if (typeof Rt == "object" && Rt !== null ? R.context = ln(Rt) : R.context = dt, R.state === nt) {
        var Ft = Ke(K) || "Component";
        _a.has(Ft) || (_a.add(Ft), H("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", Ft));
      }
      var Yt = K.getDerivedStateFromProps;
      typeof Yt == "function" && (R.state = cu(R, K, Yt, wt, nt)), typeof K.getDerivedStateFromProps != "function" && typeof R.getSnapshotBeforeUpdate != "function" && (typeof R.UNSAFE_componentWillMount == "function" || typeof R.componentWillMount == "function") && (Os(K, R), uu(Et, R, nt, dt));
    }
    var du = {
      id: 1,
      overflow: ""
    };
    function pu(R) {
      var K = R.overflow, nt = R.id, dt = nt & ~fu(nt);
      return dt.toString(32) + K;
    }
    function Wa(R, K, nt) {
      var dt = R.id, wt = R.overflow, Et = Ds(dt) - 1, Rt = dt & ~(1 << Et), Ft = nt + 1, Yt = Ds(K) + Et;
      if (Yt > 30) {
        var ie = Et - Et % 5, se = (1 << ie) - 1, ge = (Rt & se).toString(32), Te = Rt >> ie, Re = Et - ie, hi = Ds(K) + Re, hn = Ft << Re, un = hn | Te, Pr = ge + wt;
        return {
          id: 1 << hi | un,
          overflow: Pr
        };
      } else {
        var Vn = Ft << Et, _u = Vn | Rt, xv = wt;
        return {
          id: 1 << Yt | _u,
          overflow: xv
        };
      }
    }
    function Ds(R) {
      return 32 - Tr(R);
    }
    function fu(R) {
      return 1 << Ds(R) - 1;
    }
    var Tr = Math.clz32 ? Math.clz32 : $e, Ha = Math.log, Is = Math.LN2;
    function $e(R) {
      var K = R >>> 0;
      return K === 0 ? 32 : 31 - (Ha(K) / Is | 0) | 0;
    }
    function wo(R, K) {
      return R === K && (R !== 0 || 1 / R === 1 / K) || R !== R && K !== K;
    }
    var Rs = typeof Object.is == "function" ? Object.is : wo, $i = null, pr = null, cn = null, Ze = null, Pi = !1, Mr = !1, fr = 0, Ur = null, Co = 0, Ua = 25, gr = !1, Wn;
    function Gr() {
      if ($i === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return gr && H("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), $i;
    }
    function Ga(R, K) {
      if (K === null)
        return H("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Wn), !1;
      R.length !== K.length && H(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Wn, "[" + R.join(", ") + "]", "[" + K.join(", ") + "]");
      for (var nt = 0; nt < K.length && nt < R.length; nt++)
        if (!Rs(R[nt], K[nt]))
          return !1;
      return !0;
    }
    function cc() {
      if (Co > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Xa() {
      return Ze === null ? cn === null ? (Pi = !1, cn = Ze = cc()) : (Pi = !0, Ze = cn) : Ze.next === null ? (Pi = !1, Ze = Ze.next = cc()) : (Pi = !0, Ze = Ze.next), Ze;
    }
    function Ya(R, K) {
      $i = K, pr = R, gr = !1, fr = 0;
    }
    function gu(R, K, nt, dt) {
      for (; Mr; )
        Mr = !1, fr = 0, Co += 1, Ze = null, nt = R(K, dt);
      return js(), nt;
    }
    function Va() {
      var R = fr !== 0;
      return R;
    }
    function js() {
      gr = !1, $i = null, pr = null, Mr = !1, cn = null, Co = 0, Ur = null, Ze = null;
    }
    function mu(R) {
      return gr && H("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), ln(R);
    }
    function yu(R) {
      return Wn = "useContext", Gr(), ln(R);
    }
    function $a(R, K) {
      return typeof K == "function" ? K(R) : K;
    }
    function vu(R) {
      return Wn = "useState", hc(
        $a,
        // useReducer has a special case to support lazy useState initializers
        R
      );
    }
    function hc(R, K, nt) {
      if (R !== $a && (Wn = "useReducer"), $i = Gr(), Ze = Xa(), Pi) {
        var dt = Ze.queue, wt = dt.dispatch;
        if (Ur !== null) {
          var Et = Ur.get(dt);
          if (Et !== void 0) {
            Ur.delete(dt);
            var Rt = Ze.memoizedState, Ft = Et;
            do {
              var Yt = Ft.action;
              gr = !0, Rt = R(Rt, Yt), gr = !1, Ft = Ft.next;
            } while (Ft !== null);
            return Ze.memoizedState = Rt, [Rt, wt];
          }
        }
        return [Ze.memoizedState, wt];
      } else {
        gr = !0;
        var ie;
        R === $a ? ie = typeof K == "function" ? K() : K : ie = nt !== void 0 ? nt(K) : K, gr = !1, Ze.memoizedState = ie;
        var se = Ze.queue = {
          last: null,
          dispatch: null
        }, ge = se.dispatch = Su.bind(null, $i, se);
        return [Ze.memoizedState, ge];
      }
    }
    function uc(R, K) {
      $i = Gr(), Ze = Xa();
      var nt = K === void 0 ? null : K;
      if (Ze !== null) {
        var dt = Ze.memoizedState;
        if (dt !== null && nt !== null) {
          var wt = dt[1];
          if (Ga(nt, wt))
            return dt[0];
        }
      }
      gr = !0;
      var Et = R();
      return gr = !1, Ze.memoizedState = [Et, nt], Et;
    }
    function bu(R) {
      $i = Gr(), Ze = Xa();
      var K = Ze.memoizedState;
      if (K === null) {
        var nt = {
          current: R
        };
        return Object.seal(nt), Ze.memoizedState = nt, nt;
      } else
        return K;
    }
    function xu(R, K) {
      Wn = "useLayoutEffect", H("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Su(R, K, nt) {
      if (Co >= Ua)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (R === $i) {
        Mr = !0;
        var dt = {
          action: nt,
          next: null
        };
        Ur === null && (Ur = /* @__PURE__ */ new Map());
        var wt = Ur.get(K);
        if (wt === void 0)
          Ur.set(K, dt);
        else {
          for (var Et = wt; Et.next !== null; )
            Et = Et.next;
          Et.next = dt;
        }
      }
    }
    function wu(R, K) {
      return uc(function() {
        return R;
      }, K);
    }
    function _s(R, K, nt) {
      return Gr(), K(R._source);
    }
    function dc(R, K, nt) {
      if (nt === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return nt();
    }
    function Za(R) {
      return Gr(), R;
    }
    function pc() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Cu() {
      return Gr(), [!1, pc];
    }
    function Ka() {
      var R = pr, K = pu(R.treeContext), nt = Xr;
      if (nt === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var dt = fr++;
      return Br(nt, K, dt);
    }
    function Hn() {
    }
    var Bs = {
      readContext: mu,
      useContext: yu,
      useMemo: uc,
      useReducer: hc,
      useRef: bu,
      useState: vu,
      useInsertionEffect: Hn,
      useLayoutEffect: xu,
      useCallback: wu,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: Hn,
      // Effects are not run in the server environment.
      useEffect: Hn,
      // Debugging effect
      useDebugValue: Hn,
      useDeferredValue: Za,
      useTransition: Cu,
      useId: Ka,
      // Subscriptions are not setup in a server environment.
      useMutableSource: _s,
      useSyncExternalStore: dc
    }, Xr = null;
    function qa(R) {
      Xr = R;
    }
    function fc(R) {
      try {
        var K = "", nt = R;
        do {
          switch (nt.tag) {
            case 0:
              K += Rn(nt.type);
              break;
            case 1:
              K += Ea(nt.type);
              break;
            case 2:
              K += Cs(nt.type);
              break;
          }
          nt = nt.parent;
        } while (nt);
        return K;
      } catch (dt) {
        return `
Error generating stack: ` + dt.message + `
` + dt.stack;
      }
    }
    var Ns = f.ReactCurrentDispatcher, Ja = f.ReactDebugCurrentFrame, zs = 0, tr = 1, gc = 2, mc = 3, Un = 4, ku = 0, yc = 1, Gn = 2, Qa = 12800;
    function Fs(R) {
      return console.error(R), null;
    }
    function _i() {
    }
    function tl(R, K, nt, dt, wt, Et, Rt, Ft, Yt) {
      var ie = [], se = /* @__PURE__ */ new Set(), ge = {
        destination: null,
        responseState: K,
        progressiveChunkSize: dt === void 0 ? Qa : dt,
        status: ku,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: se,
        pingedTasks: ie,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: wt === void 0 ? Fs : wt,
        onAllReady: Et === void 0 ? _i : Et,
        onShellReady: Rt === void 0 ? _i : Rt,
        onShellError: Ft === void 0 ? _i : Ft,
        onFatalError: Yt === void 0 ? _i : Yt
      }, Te = er(
        ge,
        0,
        null,
        nt,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      Te.parentFlushed = !0;
      var Re = el(ge, R, null, Te, se, Bn, ec, du);
      return ie.push(Re), ge;
    }
    function ko(R, K) {
      var nt = R.pingedTasks;
      nt.push(K), nt.length === 1 && st(function() {
        return Dc(R);
      });
    }
    function vc(R, K) {
      return {
        id: Gi,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: K,
        errorDigest: null
      };
    }
    function el(R, K, nt, dt, wt, Et, Rt, Ft) {
      R.allPendingTasks++, nt === null ? R.pendingRootTasks++ : nt.pendingTasks++;
      var Yt = {
        node: K,
        ping: function() {
          return ko(R, Yt);
        },
        blockedBoundary: nt,
        blockedSegment: dt,
        abortSet: wt,
        legacyContext: Et,
        context: Rt,
        treeContext: Ft
      };
      return Yt.componentStack = null, wt.add(Yt), Yt;
    }
    function er(R, K, nt, dt, wt, Et) {
      return {
        status: zs,
        id: -1,
        // lazily assigned later
        index: K,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: dt,
        boundary: nt,
        lastPushedText: wt,
        textEmbedded: Et
      };
    }
    var Bi = null;
    function To() {
      return Bi === null || Bi.componentStack === null ? "" : fc(Bi.componentStack);
    }
    function Ar(R, K) {
      R.componentStack = {
        tag: 0,
        parent: R.componentStack,
        type: K
      };
    }
    function Mo(R, K) {
      R.componentStack = {
        tag: 1,
        parent: R.componentStack,
        type: K
      };
    }
    function Tu(R, K) {
      R.componentStack = {
        tag: 2,
        parent: R.componentStack,
        type: K
      };
    }
    function Yr(R) {
      R.componentStack === null ? H("Unexpectedly popped too many stack frames. This is a bug in React.") : R.componentStack = R.componentStack.parent;
    }
    var Ao = null;
    function Ws(R, K) {
      {
        var nt;
        typeof K == "string" ? nt = K : K && typeof K.message == "string" ? nt = K.message : nt = String(K);
        var dt = Ao || To();
        Ao = null, R.errorMessage = nt, R.errorComponentStack = dt;
      }
    }
    function Xn(R, K) {
      var nt = R.onError(K);
      if (nt != null && typeof nt != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof nt + '" instead');
      return nt;
    }
    function Hs(R, K) {
      var nt = R.onShellError;
      nt(K);
      var dt = R.onFatalError;
      dt(K), R.destination !== null ? (R.status = Gn, J(R.destination, K)) : (R.status = yc, R.fatalError = K);
    }
    function bc(R, K, nt) {
      Ar(K, "Suspense");
      var dt = K.blockedBoundary, wt = K.blockedSegment, Et = nt.fallback, Rt = nt.children, Ft = /* @__PURE__ */ new Set(), Yt = vc(R, Ft), ie = wt.chunks.length, se = er(
        R,
        ie,
        Yt,
        wt.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      wt.children.push(se), wt.lastPushedText = !1;
      var ge = er(
        R,
        0,
        null,
        wt.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      ge.parentFlushed = !0, K.blockedBoundary = Yt, K.blockedSegment = ge;
      try {
        if (al(R, K, Rt), qi(ge.chunks, R.responseState, ge.lastPushedText, ge.textEmbedded), ge.status = tr, Ys(Yt, ge), Yt.pendingTasks === 0) {
          Yr(K);
          return;
        }
      } catch (Re) {
        ge.status = Un, Yt.forceClientRender = !0, Yt.errorDigest = Xn(R, Re), Ws(Yt, Re);
      } finally {
        K.blockedBoundary = dt, K.blockedSegment = wt;
      }
      var Te = el(R, Et, dt, se, Ft, K.legacyContext, K.context, K.treeContext);
      Te.componentStack = K.componentStack, R.pingedTasks.push(Te), Yr(K);
    }
    function Us(R, K, nt, dt) {
      Ar(K, nt);
      var wt = K.blockedSegment, Et = nn(wt.chunks, nt, dt, R.responseState, wt.formatContext);
      wt.lastPushedText = !1;
      var Rt = wt.formatContext;
      wt.formatContext = gi(Rt, nt, dt), al(R, K, Et), wt.formatContext = Rt, Ko(wt.chunks, nt), wt.lastPushedText = !1, Yr(K);
    }
    function xc(R) {
      return R.prototype && R.prototype.isReactComponent;
    }
    function il(R, K, nt, dt, wt) {
      var Et = {};
      Ya(K, Et);
      var Rt = nt(dt, wt);
      return gu(nt, dt, Rt, wt);
    }
    function rl(R, K, nt, dt, wt) {
      var Et = nt.render();
      nt.props !== wt && (Cc || H("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Ke(dt) || "a component"), Cc = !0);
      {
        var Rt = dt.childContextTypes;
        if (Rt != null) {
          var Ft = K.legacyContext, Yt = Ts(nt, dt, Ft, Rt);
          K.legacyContext = Yt, zi(R, K, Et), K.legacyContext = Ft;
          return;
        }
      }
      zi(R, K, Et);
    }
    function Sc(R, K, nt, dt) {
      Tu(K, nt);
      var wt = ks(nt, K.legacyContext), Et = hu(nt, dt, wt);
      lc(Et, nt, dt, wt), rl(R, K, Et, nt, dt), Yr(K);
    }
    var nl = {}, Po = {}, ol = {}, wc = {}, Cc = !1, sl = {}, kc = !1, Tc = !1, Mc = !1;
    function Mu(R, K, nt, dt) {
      var wt;
      if (wt = ks(nt, K.legacyContext), Mo(K, nt), nt.prototype && typeof nt.prototype.render == "function") {
        var Et = Ke(nt) || "Unknown";
        nl[Et] || (H("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Et, Et), nl[Et] = !0);
      }
      var Rt = il(R, K, nt, dt, wt), Ft = Va();
      if (typeof Rt == "object" && Rt !== null && typeof Rt.render == "function" && Rt.$$typeof === void 0) {
        var Yt = Ke(nt) || "Unknown";
        Po[Yt] || (H("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Yt, Yt, Yt), Po[Yt] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof Rt == "object" && Rt !== null && typeof Rt.render == "function" && Rt.$$typeof === void 0
      ) {
        {
          var ie = Ke(nt) || "Unknown";
          Po[ie] || (H("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ie, ie, ie), Po[ie] = !0);
        }
        lc(Rt, nt, dt, wt), rl(R, K, Rt, nt, dt);
      } else if (Au(nt), Ft) {
        var se = K.treeContext, ge = 1, Te = 0;
        K.treeContext = Wa(se, ge, Te);
        try {
          zi(R, K, Rt);
        } finally {
          K.treeContext = se;
        }
      } else
        zi(R, K, Rt);
      Yr(K);
    }
    function Au(R) {
      {
        if (R && R.childContextTypes && H("%s(...): childContextTypes cannot be defined on a function component.", R.displayName || R.name || "Component"), R.defaultProps !== void 0) {
          var K = Ke(R) || "Unknown";
          sl[K] || (H("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", K), sl[K] = !0);
        }
        if (typeof R.getDerivedStateFromProps == "function") {
          var nt = Ke(R) || "Unknown";
          wc[nt] || (H("%s: Function components do not support getDerivedStateFromProps.", nt), wc[nt] = !0);
        }
        if (typeof R.contextType == "object" && R.contextType !== null) {
          var dt = Ke(R) || "Unknown";
          ol[dt] || (H("%s: Function components do not support contextType.", dt), ol[dt] = !0);
        }
      }
    }
    function Gs(R, K) {
      if (R && R.defaultProps) {
        var nt = Ai({}, K), dt = R.defaultProps;
        for (var wt in dt)
          nt[wt] === void 0 && (nt[wt] = dt[wt]);
        return nt;
      }
      return K;
    }
    function Pu(R, K, nt, dt, wt) {
      Mo(K, nt.render);
      var Et = il(R, K, nt.render, dt, wt), Rt = Va();
      if (Rt) {
        var Ft = K.treeContext, Yt = 1, ie = 0;
        K.treeContext = Wa(Ft, Yt, ie);
        try {
          zi(R, K, Et);
        } finally {
          K.treeContext = Ft;
        }
      } else
        zi(R, K, Et);
      Yr(K);
    }
    function Ni(R, K, nt, dt, wt) {
      var Et = nt.type, Rt = Gs(Et, dt);
      Eo(R, K, Et, Rt, wt);
    }
    function Eu(R, K, nt, dt) {
      nt._context === void 0 ? nt !== nt.Consumer && (Mc || (Mc = !0, H("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : nt = nt._context;
      var wt = dt.children;
      typeof wt != "function" && H("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var Et = ln(nt), Rt = wt(Et);
      zi(R, K, Rt);
    }
    function Ac(R, K, nt, dt) {
      var wt = nt._context, Et = dt.value, Rt = dt.children, Ft;
      Ft = K.context, K.context = nc(wt, Et), zi(R, K, Rt), K.context = oc(wt), Ft !== K.context && H("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Lu(R, K, nt, dt, wt) {
      Ar(K, "Lazy");
      var Et = nt._payload, Rt = nt._init, Ft = Rt(Et), Yt = Gs(Ft, dt);
      Eo(R, K, Ft, Yt, wt), Yr(K);
    }
    function Eo(R, K, nt, dt, wt) {
      if (typeof nt == "function")
        if (xc(nt)) {
          Sc(R, K, nt, dt);
          return;
        } else {
          Mu(R, K, nt, dt);
          return;
        }
      if (typeof nt == "string") {
        Us(R, K, nt, dt);
        return;
      }
      switch (nt) {
        case Yl:
        case au:
        case fs:
        case gs:
        case ps: {
          zi(R, K, dt.children);
          return;
        }
        case Ca: {
          Ar(K, "SuspenseList"), zi(R, K, dt.children), Yr(K);
          return;
        }
        case su:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case wa: {
          bc(R, K, dt);
          return;
        }
      }
      if (typeof nt == "object" && nt !== null)
        switch (nt.$$typeof) {
          case Sa: {
            Pu(R, K, nt, dt, wt);
            return;
          }
          case ms: {
            Ni(R, K, nt, dt, wt);
            return;
          }
          case Ln: {
            Ac(R, K, nt, dt);
            return;
          }
          case xa: {
            Eu(R, K, nt, dt);
            return;
          }
          case ys: {
            Lu(R, K, nt, dt);
            return;
          }
        }
      var Et = "";
      throw (nt === void 0 || typeof nt == "object" && nt !== null && Object.keys(nt).length === 0) && (Et += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (nt == null ? nt : typeof nt) + "." + Et));
    }
    function Ou(R, K) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      R[Symbol.toStringTag] === "Generator" && (kc || H("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), kc = !0), R.entries === K && (Tc || H("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Tc = !0);
    }
    function zi(R, K, nt) {
      try {
        return Pc(R, K, nt);
      } catch (dt) {
        throw typeof dt == "object" && dt !== null && typeof dt.then == "function" || (Ao = Ao !== null ? Ao : To()), dt;
      }
    }
    function Pc(R, K, nt) {
      if (K.node = nt, typeof nt == "object" && nt !== null) {
        switch (nt.$$typeof) {
          case ba: {
            var dt = nt, wt = dt.type, Et = dt.props, Rt = dt.ref;
            Eo(R, K, wt, Et, Rt);
            return;
          }
          case ds:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case ys: {
            var Ft = nt, Yt = Ft._payload, ie = Ft._init, se;
            try {
              se = ie(Yt);
            } catch (Vn) {
              throw typeof Vn == "object" && Vn !== null && typeof Vn.then == "function" && Ar(K, "Lazy"), Vn;
            }
            zi(R, K, se);
            return;
          }
        }
        if (ye(nt)) {
          Lo(R, K, nt);
          return;
        }
        var ge = $l(nt);
        if (ge) {
          Ou(nt, ge);
          var Te = ge.call(nt);
          if (Te) {
            var Re = Te.next();
            if (!Re.done) {
              var hi = [];
              do
                hi.push(Re.value), Re = Te.next();
              while (!Re.done);
              Lo(R, K, hi);
              return;
            }
            return;
          }
        }
        var hn = Object.prototype.toString.call(nt);
        throw new Error("Objects are not valid as a React child (found: " + (hn === "[object Object]" ? "object with keys {" + Object.keys(nt).join(", ") + "}" : hn) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof nt == "string") {
        var un = K.blockedSegment;
        un.lastPushedText = Nr(K.blockedSegment.chunks, nt, R.responseState, un.lastPushedText);
        return;
      }
      if (typeof nt == "number") {
        var Pr = K.blockedSegment;
        Pr.lastPushedText = Nr(K.blockedSegment.chunks, "" + nt, R.responseState, Pr.lastPushedText);
        return;
      }
      typeof nt == "function" && H("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Lo(R, K, nt) {
      for (var dt = nt.length, wt = 0; wt < dt; wt++) {
        var Et = K.treeContext;
        K.treeContext = Wa(Et, dt, wt);
        try {
          al(R, K, nt[wt]);
        } finally {
          K.treeContext = Et;
        }
      }
    }
    function Ec(R, K, nt) {
      var dt = K.blockedSegment, wt = dt.chunks.length, Et = er(
        R,
        wt,
        null,
        dt.formatContext,
        // Adopt the parent segment's leading text embed
        dt.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      dt.children.push(Et), dt.lastPushedText = !1;
      var Rt = el(R, K.node, K.blockedBoundary, Et, K.abortSet, K.legacyContext, K.context, K.treeContext);
      K.componentStack !== null && (Rt.componentStack = K.componentStack.parent);
      var Ft = Rt.ping;
      nt.then(Ft, Ft);
    }
    function al(R, K, nt) {
      var dt = K.blockedSegment.formatContext, wt = K.legacyContext, Et = K.context, Rt = null;
      Rt = K.componentStack;
      try {
        return zi(R, K, nt);
      } catch (Ft) {
        if (js(), typeof Ft == "object" && Ft !== null && typeof Ft.then == "function") {
          Ec(R, K, Ft), K.blockedSegment.formatContext = dt, K.legacyContext = wt, K.context = Et, Es(Et), K.componentStack = Rt;
          return;
        } else
          throw K.blockedSegment.formatContext = dt, K.legacyContext = wt, K.context = Et, Es(Et), K.componentStack = Rt, Ft;
      }
    }
    function Lc(R, K, nt, dt) {
      var wt = Xn(R, dt);
      if (K === null ? Hs(R, dt) : (K.pendingTasks--, K.forceClientRender || (K.forceClientRender = !0, K.errorDigest = wt, Ws(K, dt), K.parentFlushed && R.clientRenderedBoundaries.push(K))), R.allPendingTasks--, R.allPendingTasks === 0) {
        var Et = R.onAllReady;
        Et();
      }
    }
    function Xs(R) {
      var K = this, nt = R.blockedBoundary, dt = R.blockedSegment;
      dt.status = mc, ll(K, nt, dt);
    }
    function Oo(R, K, nt) {
      var dt = R.blockedBoundary, wt = R.blockedSegment;
      if (wt.status = mc, dt === null)
        K.allPendingTasks--, K.status !== Gn && (K.status = Gn, K.destination !== null && G(K.destination));
      else {
        if (dt.pendingTasks--, !dt.forceClientRender) {
          dt.forceClientRender = !0;
          var Et = nt === void 0 ? new Error("The render was aborted by the server without a reason.") : nt;
          dt.errorDigest = K.onError(Et);
          {
            var Rt = "The server did not finish this Suspense boundary: ";
            Et && typeof Et.message == "string" ? Et = Rt + Et.message : Et = Rt + String(Et);
            var Ft = Bi;
            Bi = R;
            try {
              Ws(dt, Et);
            } finally {
              Bi = Ft;
            }
          }
          dt.parentFlushed && K.clientRenderedBoundaries.push(dt);
        }
        if (dt.fallbackAbortableTasks.forEach(function(ie) {
          return Oo(ie, K, nt);
        }), dt.fallbackAbortableTasks.clear(), K.allPendingTasks--, K.allPendingTasks === 0) {
          var Yt = K.onAllReady;
          Yt();
        }
      }
    }
    function Ys(R, K) {
      if (K.chunks.length === 0 && K.children.length === 1 && K.children[0].boundary === null) {
        var nt = K.children[0];
        nt.id = K.id, nt.parentFlushed = !0, nt.status === tr && Ys(R, nt);
      } else {
        var dt = R.completedSegments;
        dt.push(K);
      }
    }
    function ll(R, K, nt) {
      if (K === null) {
        if (nt.parentFlushed) {
          if (R.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          R.completedRootSegment = nt;
        }
        if (R.pendingRootTasks--, R.pendingRootTasks === 0) {
          R.onShellError = _i;
          var dt = R.onShellReady;
          dt();
        }
      } else if (K.pendingTasks--, !K.forceClientRender) {
        if (K.pendingTasks === 0)
          nt.parentFlushed && nt.status === tr && Ys(K, nt), K.parentFlushed && R.completedBoundaries.push(K), K.fallbackAbortableTasks.forEach(Xs, R), K.fallbackAbortableTasks.clear();
        else if (nt.parentFlushed && nt.status === tr) {
          Ys(K, nt);
          var wt = K.completedSegments;
          wt.length === 1 && K.parentFlushed && R.partialBoundaries.push(K);
        }
      }
      if (R.allPendingTasks--, R.allPendingTasks === 0) {
        var Et = R.onAllReady;
        Et();
      }
    }
    function Oc(R, K) {
      var nt = K.blockedSegment;
      if (nt.status === zs) {
        Es(K.context);
        var dt = null;
        dt = Bi, Bi = K;
        try {
          zi(R, K, K.node), qi(nt.chunks, R.responseState, nt.lastPushedText, nt.textEmbedded), K.abortSet.delete(K), nt.status = tr, ll(R, K.blockedBoundary, nt);
        } catch (Et) {
          if (js(), typeof Et == "object" && Et !== null && typeof Et.then == "function") {
            var wt = K.ping;
            Et.then(wt, wt);
          } else
            K.abortSet.delete(K), nt.status = Un, Lc(R, K.blockedBoundary, nt, Et);
        } finally {
          Bi = dt;
        }
      }
    }
    function Dc(R) {
      if (R.status !== Gn) {
        var K = Da(), nt = Ns.current;
        Ns.current = Bs;
        var dt;
        dt = Ja.getCurrentStack, Ja.getCurrentStack = To;
        var wt = Xr;
        qa(R.responseState);
        try {
          var Et = R.pingedTasks, Rt;
          for (Rt = 0; Rt < Et.length; Rt++) {
            var Ft = Et[Rt];
            Oc(R, Ft);
          }
          Et.splice(0, Rt), R.destination !== null && hl(R, R.destination);
        } catch (Yt) {
          Xn(R, Yt), Hs(R, Yt);
        } finally {
          qa(wt), Ns.current = nt, Ja.getCurrentStack = dt, nt === Bs && Es(K);
        }
      }
    }
    function Do(R, K, nt) {
      switch (nt.parentFlushed = !0, nt.status) {
        case zs: {
          var dt = nt.id = R.nextSegmentId++;
          return nt.lastPushedText = !1, nt.textEmbedded = !1, qo(K, R.responseState, dt);
        }
        case tr: {
          nt.status = gc;
          for (var wt = !0, Et = nt.chunks, Rt = 0, Ft = nt.children, Yt = 0; Yt < Ft.length; Yt++) {
            for (var ie = Ft[Yt]; Rt < ie.index; Rt++)
              gt(K, Et[Rt]);
            wt = Yn(R, K, ie);
          }
          for (; Rt < Et.length - 1; Rt++)
            gt(K, Et[Rt]);
          return Rt < Et.length && (wt = _(K, Et[Rt])), wt;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Yn(R, K, nt) {
      var dt = nt.boundary;
      if (dt === null)
        return Do(R, K, nt);
      if (dt.parentFlushed = !0, dt.forceClientRender)
        return Si(K, R.responseState, dt.errorDigest, dt.errorMessage, dt.errorComponentStack), Do(R, K, nt), ya(K);
      if (dt.pendingTasks > 0) {
        dt.rootSegmentID = R.nextSegmentId++, dt.completedSegments.length > 0 && R.partialBoundaries.push(dt);
        var wt = dt.id = Ii(R.responseState);
        return Tn(K, R.responseState, wt), Do(R, K, nt), Mn(K);
      } else {
        if (dt.byteSize > R.progressiveChunkSize)
          return dt.rootSegmentID = R.nextSegmentId++, R.completedBoundaries.push(dt), Tn(K, R.responseState, dt.id), Do(R, K, nt), Mn(K);
        ts(K);
        var Et = dt.completedSegments;
        if (Et.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var Rt = Et[0];
        return Yn(R, K, Rt), es(K);
      }
    }
    function Du(R, K, nt) {
      return Gl(K, R.responseState, nt.id, nt.errorDigest, nt.errorMessage, nt.errorComponentStack);
    }
    function Ic(R, K, nt) {
      return Pe(K, R.responseState, nt.formatContext, nt.id), Yn(R, K, nt), Ge(K, nt.formatContext);
    }
    function Rc(R, K, nt) {
      for (var dt = nt.completedSegments, wt = 0; wt < dt.length; wt++) {
        var Et = dt[wt];
        cl(R, K, nt, Et);
      }
      return dt.length = 0, iu(K, R.responseState, nt.id, nt.rootSegmentID);
    }
    function Iu(R, K, nt) {
      for (var dt = nt.completedSegments, wt = 0; wt < dt.length; wt++) {
        var Et = dt[wt];
        if (!cl(R, K, nt, Et))
          return wt++, dt.splice(0, wt), !1;
      }
      return dt.splice(0, wt), !0;
    }
    function cl(R, K, nt, dt) {
      if (dt.status === gc)
        return !0;
      var wt = dt.id;
      if (wt === -1) {
        var Et = dt.id = nt.rootSegmentID;
        if (Et === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return Ic(R, K, dt);
      } else
        return Ic(R, K, dt), Qh(K, R.responseState, wt);
    }
    function hl(R, K) {
      yt();
      try {
        var nt = R.completedRootSegment;
        nt !== null && R.pendingRootTasks === 0 && (Yn(R, K, nt), R.completedRootSegment = null, fa(K, R.responseState));
        var dt = R.clientRenderedBoundaries, wt;
        for (wt = 0; wt < dt.length; wt++) {
          var Et = dt[wt];
          Du(R, K, Et);
        }
        dt.splice(0, wt);
        var Rt = R.completedBoundaries;
        for (wt = 0; wt < Rt.length; wt++) {
          var Ft = Rt[wt];
          Rc(R, K, Ft);
        }
        Rt.splice(0, wt), at(K), yt();
        var Yt = R.partialBoundaries;
        for (wt = 0; wt < Yt.length; wt++) {
          var ie = Yt[wt];
          if (!Iu(R, K, ie)) {
            R.destination = null, wt++, Yt.splice(0, wt);
            return;
          }
        }
        Yt.splice(0, wt);
        var se = R.completedBoundaries;
        for (wt = 0; wt < se.length; wt++) {
          var ge = se[wt];
          Rc(R, K, ge);
        }
        se.splice(0, wt);
      } finally {
        at(K), R.allPendingTasks === 0 && R.pingedTasks.length === 0 && R.clientRenderedBoundaries.length === 0 && R.completedBoundaries.length === 0 && (R.abortableTasks.size !== 0 && H("There was still abortable task at the root when we closed. This is a bug in React."), G(K));
      }
    }
    function Ru(R) {
      st(function() {
        return Dc(R);
      });
    }
    function ju(R, K) {
      if (R.status === yc) {
        R.status = Gn, J(K, R.fatalError);
        return;
      }
      if (R.status !== Gn && R.destination === null) {
        R.destination = K;
        try {
          hl(R, K);
        } catch (nt) {
          Xn(R, nt), Hs(R, nt);
        }
      }
    }
    function jc(R, K) {
      try {
        var nt = R.abortableTasks;
        nt.forEach(function(dt) {
          return Oo(dt, R, K);
        }), nt.clear(), R.destination !== null && hl(R, R.destination);
      } catch (dt) {
        Xn(R, dt), Hs(R, dt);
      }
    }
    function rt(R, K) {
      return new Promise(function(nt, dt) {
        var wt, Et, Rt = new Promise(function(Te, Re) {
          Et = Te, wt = Re;
        });
        function Ft() {
          var Te = new ReadableStream(
            {
              type: "bytes",
              pull: function(Re) {
                ju(ie, Re);
              },
              cancel: function(Re) {
                jc(ie);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          Te.allReady = Rt, nt(Te);
        }
        function Yt(Te) {
          Rt.catch(function() {
          }), dt(Te);
        }
        var ie = tl(R, Ki(K ? K.identifierPrefix : void 0, K ? K.nonce : void 0, K ? K.bootstrapScriptContent : void 0, K ? K.bootstrapScripts : void 0, K ? K.bootstrapModules : void 0), ar(K ? K.namespaceURI : void 0), K ? K.progressiveChunkSize : void 0, K ? K.onError : void 0, Et, Ft, Yt, wt);
        if (K && K.signal) {
          var se = K.signal, ge = function() {
            jc(ie, se.reason), se.removeEventListener("abort", ge);
          };
          se.addEventListener("abort", ge);
        }
        Ru(ie);
      });
    }
    Kc.renderToReadableStream = rt, Kc.version = r;
  }()), Kc;
}
var Ho, Md;
process.env.NODE_ENV === "production" ? (Ho = aE(), Md = lE()) : (Ho = cE(), Md = hE());
so.version = Ho.version;
so.renderToString = Ho.renderToString;
so.renderToStaticMarkup = Ho.renderToStaticMarkup;
so.renderToNodeStream = Ho.renderToNodeStream;
so.renderToStaticNodeStream = Ho.renderToStaticNodeStream;
so.renderToReadableStream = Md.renderToReadableStream;
function Jy(t) {
  const { prefix: r, title: f } = t;
  return /* @__PURE__ */ zo(
    "div",
    {
      style: {
        display: "flex",
        marginBottom: "5px"
      },
      children: [
        /* @__PURE__ */ ri(
          "div",
          {
            style: {
              flexShrink: 0
            },
            children: r
          }
        ),
        /* @__PURE__ */ ri(
          "div",
          {
            style: {
              marginLeft: "5px",
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordWrap: "normal",
              wordBreak: "keep-all",
              whiteSpace: "nowrap"
            },
            children: f
          }
        )
      ]
    }
  );
}
function No(t) {
  const { name: r, value: f } = t;
  return /* @__PURE__ */ ri("div", { style: { display: "table-row-group" }, children: /* @__PURE__ */ zo("div", { style: { display: "table-row", height: "18px" }, children: [
    /* @__PURE__ */ ri(
      "div",
      {
        style: {
          display: "table-cell",
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordWrap: "normal",
          wordBreak: "keep-all",
          whiteSpace: "nowrap"
        },
        children: r
      }
    ),
    /* @__PURE__ */ ri("div", { style: { display: "table-cell", paddingLeft: "15px", fontWeight: "600" }, children: f.map((B, H) => /* @__PURE__ */ ri("div", { children: B }, H)) })
  ] }) });
}
function Qy(t) {
  const { x1Value: r, x2Value: f } = t;
  return /* @__PURE__ */ zo(kv, { children: [
    /* @__PURE__ */ ri(
      "div",
      {
        style: {
          fontSize: "10px",
          color: "#666",
          marginTop: "6px"
        },
        children: f || r ? /* @__PURE__ */ ri("hr", { className: "csdk-border-t", style: { margin: "7px 0px" } }) : ""
      }
    ),
    f || "",
    f && r ? /* @__PURE__ */ ri(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "18",
        viewBox: "0 0 24 24",
        style: { display: "inline-block" },
        children: /* @__PURE__ */ ri(
          "path",
          {
            fill: "#5B6372",
            fillRule: "nonzero",
            d: "M6.84 8.5l-2.72-3.175a.5.5 0 1 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175z"
          }
        )
      }
    ) : "",
    r || ""
  ] });
}
const uE = {
  smooth: "Advanced Smoothing",
  linear: "Linear Trend",
  local: "Local Estimates",
  logarithmic: "Logarithmic Trend"
};
function dE(t) {
  const { t: r } = Xg(), f = t.translate || r, { localValue: B, trendData: H, modelType: tt, title: st, x1Value: lt, x2Value: ht } = t, ut = [
    `${f("advanced.tooltip.trendData.min")} ${H.min}`,
    `${f("advanced.tooltip.trendData.max")} ${H.max}`,
    `${f("advanced.tooltip.trendData.median")} ${H.median}`,
    `${f("advanced.tooltip.trendData.average")} ${H.average}`
  ];
  return /* @__PURE__ */ zo(
    "div",
    {
      style: {
        color: "#5B6372",
        fontSize: "13px",
        lineHeight: "18px",
        margin: "4px 6px"
      },
      children: [
        /* @__PURE__ */ ri(Jy, { prefix: f("advanced.tooltip.trend"), title: st }),
        /* @__PURE__ */ zo("div", { style: { display: "table" }, children: [
          /* @__PURE__ */ ri(
            No,
            {
              name: f("advanced.tooltip.trendType"),
              value: [uE[tt]]
            }
          ),
          /* @__PURE__ */ ri(
            No,
            {
              name: f("advanced.tooltip.trendLocalValue"),
              value: [B]
            }
          ),
          /* @__PURE__ */ ri(
            No,
            {
              name: f("advanced.tooltip.trendDataKey"),
              value: ut
            }
          )
        ] }),
        /* @__PURE__ */ ri(Qy, { x1Value: lt, x2Value: ht })
      ]
    }
  );
}
const pE = (t) => so.renderToString(/* @__PURE__ */ ri(dE, Ut({}, t)));
function fE(t) {
  const { t: r } = Xg(), f = t.translate || r, { confidenceValue: B, lowerValue: H, forecastValue: tt, upperValue: st, title: lt, x1Value: ht, x2Value: ut } = t;
  return /* @__PURE__ */ zo(
    "div",
    {
      style: {
        color: "#5B6372",
        fontSize: "13px",
        lineHeight: "18px",
        margin: "4px 6px"
      },
      children: [
        /* @__PURE__ */ ri(
          Jy,
          {
            prefix: f("advanced.tooltip.forecast"),
            title: lt
          }
        ),
        /* @__PURE__ */ zo("div", { style: { display: "table" }, children: [
          /* @__PURE__ */ ri(
            No,
            {
              name: f("advanced.tooltip.forecastValue"),
              value: [tt]
            }
          ),
          /* @__PURE__ */ ri(
            No,
            {
              name: f("advanced.tooltip.max"),
              value: [st]
            }
          ),
          /* @__PURE__ */ ri(
            No,
            {
              name: f("advanced.tooltip.min"),
              value: [H]
            }
          ),
          /* @__PURE__ */ ri(
            No,
            {
              name: f("advanced.tooltip.confidenceInterval"),
              value: [B]
            }
          )
        ] }),
        /* @__PURE__ */ ri(Qy, { x1Value: ht, x2Value: ut })
      ]
    }
  );
}
const gE = (t) => so.renderToString(/* @__PURE__ */ ri(fE, Ut({}, t))), tv = function(t, r, f, B) {
  var N, D, k, A, b, d, m, v, g, x, E, P;
  let H;
  t.percentage && (H = r ? t.percentage.toFixed(1) : `${Math.round(t.percentage)}`);
  const tt = f, st = tt.breakBy.length > 0 ? (N = tt.y) == null ? void 0 : N.find((S) => S.enabled) : (D = tt.y) == null ? void 0 : D.find((S) => S.column.title === t.series.name), lt = $y(st), ht = vi(st, t.point.y, ""), ut = (b = (A = (k = t.point) == null ? void 0 : k.custom) == null ? void 0 : A.xDisplayValue) != null ? b : t.x, yt = tt.x ? Dl(tt.x[0], t.x, ut) : ut;
  let gt;
  if ((d = t.point.custom) != null && d.xValue && (tt != null && tt.x) && tt.x.length === 2) {
    const S = `${t.point.custom.xValue[0]}`;
    gt = Dl(tt.x[1], S, S);
  }
  const _ = ht + (lt && H ? ` / ${H}%` : ""), at = t.point.color || t.series.color, G = Qs(t.point.name || t.series.name), F = Gy(t.point.name || t.series.name), $ = B && G ? `${t.series.name.substring(10)}` : B && F ? `${t.series.name.substring(7)}` : t.series.name, Y = (m = t.point) != null && m.low ? vi(st, (v = t.point) == null ? void 0 : v.low, "") : "", J = (g = t.point) != null && g.high ? vi(st, (x = t.point) == null ? void 0 : x.high, "") : "", Q = (S, u, y) => !S || S === "" ? "" : !B || !G && !F || !u ? `<br /${Ei(S, y)}` : `<br /><span>${B(u)} </span>${Ei(S, y)}`, q = B ? `(+${B("advanced.tooltip.trend")})` : "", U = G ? "advanced.tooltip.forecastValue" : "";
  if (F) {
    const S = /modelType=([^"]+)/, u = (E = st == null ? void 0 : st.column) == null ? void 0 : E.expression.match(
      S
    ), y = u ? u[1] : null, { min: s, max: a, median: e, average: n } = t.point.trend, o = vi(st, s, ""), i = vi(st, a, ""), c = vi(st, e, ""), l = vi(st, n, "");
    return pE({
      title: $,
      modelType: y,
      trendData: {
        min: o,
        max: i,
        median: c,
        average: l
      },
      localValue: _,
      x1Value: yt,
      x2Value: gt,
      translate: B
    });
  }
  if (G) {
    const S = /confidenceInterval=([^"]+)/, u = (P = st == null ? void 0 : st.column) == null ? void 0 : P.expression.match(
      S
    ), y = u ? u[1] : "0.8", s = (parseFloat(y) * 100).toFixed(0) + "%";
    return gE({
      title: $,
      confidenceValue: s,
      forecastValue: _,
      x1Value: yt,
      x2Value: gt,
      translate: B,
      upperValue: J,
      lowerValue: Y
    });
  }
  return oa(`
    ${$.replace(q, "")}
    ${Q(_, U, at)}
    ${Q(J, "advanced.tooltip.max", at)}
    ${Q(Y, "advanced.tooltip.min", at)}
    ${gt || yt ? qn() : ""}
    ${gt || ""}
    ${gt && yt ? `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 24 24" style="display: inline-block">
        <path
         fill="#5B6372"
         fillRule="nonzero"
          d="M6.84 8.5l-2.72-3.175a.5.5 0 1 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175z"
        />
        </svg>
        ` : ""}
    ${yt || ""}
 `);
}, mE = (t, r, f) => ({
  animation: !1,
  backgroundColor: eo,
  borderColor: to,
  borderRadius: 10,
  borderWidth: 1,
  useHTML: !0,
  formatter: function() {
    return tv(this, t, r, f);
  }
}), yE = (t, r) => {
  const f = t;
  if (f.x.length !== 2)
    return r;
  const { categories: B, indexMap: H, plotBands: tt } = r, st = f.x[1], lt = f.x[0], ht = li(st == null ? void 0 : st.numberFormatConfig), ut = li(lt == null ? void 0 : lt.numberFormatConfig);
  let yt = B;
  st && Fi(st.column.type) && (yt = B.map((_) => Hi(ht, parseFloat(_))));
  let gt = tt;
  return lt && Fi(lt.column.type) && (gt = tt.map((_) => {
    const at = Hi(ut, parseFloat(_.text));
    return oe(Ut({}, _), { text: at });
  })), { categories: yt, indexMap: H, plotBands: gt };
}, vE = (t, r) => {
  const { stackType: f } = r;
  return f === "classic" && (ty(t) || MT(t));
}, bE = (t) => {
  const { xValues: r, xAxisCount: f } = t;
  return f !== 2 || r.length === 0;
}, Ju = (t, r) => ({
  plotBands: [],
  indexMap: t.map((f, B) => B),
  categories: r
}), xE = (t, r, f, B) => {
  const { xValues: st } = t, { y: lt } = r;
  if (vE(r, f))
    return Ju(
      st,
      lt.map((F) => Li(F))
    );
  if (B)
    return Ju(
      st,
      st.map(Hy).map((F) => `${F}`)
    );
  if (bE(t))
    return Ju(
      st,
      st.map((F) => F.xValues[0])
    );
  const ht = [], ut = [], yt = [];
  let gt = st[0].xValues[0], _ = -0.5;
  st.map((F, $) => {
    const Y = F.xValues[1], J = F.xValues[0];
    if (J !== gt) {
      ht.push(-1);
      const Q = ht.length - 1;
      yt.push(" "), ut.push({ text: gt, from: _, to: Q }), _ = Q, gt = J;
    }
    return ht.push($), yt.push(Y), F.xValues[1];
  });
  const at = st.length - 1, G = st[at].xValues[0];
  return ut.push({
    text: G,
    from: _,
    to: ht.length - 0.5
  }), { categories: yt, indexMap: ht, plotBands: ut };
}, ev = (t, r, f, B, H = !1) => {
  const ht = B < (H ? 200 : 400), yt = f * 20, gt = B > yt;
  return !r || ht || gt ? { enabled: !1 } : {
    series: {
      type: t,
      dataGrouping: {
        enabled: !1
      }
    },
    tooltipFormatter: () => ({
      left: "",
      right: ""
    }),
    enabled: !0,
    margin: 30,
    height: 40,
    xAxis: {
      labels: {
        enabled: !1
      }
    },
    handles: {
      symbols: ["navigator-handle", "navigator-handle"],
      backgroundColor: to,
      borderColor: eo
    },
    maskInside: !0,
    maskFill: "rgba(91,99,114, 0.15)",
    outlineColor: to,
    outlineWidth: 1
  };
};
function iv(t, r, f) {
  t.xAxis[0].setExtremes(r, f, !1);
}
const aa = (t, r) => `Maximum number of series (${r}) exceeded (${t})`, Ad = (t, r, f) => `'${t.toUpperCase()}-Axis:' Maximum number of categories (${f}) exceeded (${r})`, Pd = (t, r, f, B, H, tt, st) => {
  const lt = [], ht = B.x.length === 1 && B.x[0].continuous && pn(B.x[0].column.type) || !1, ut = Zh(r, f);
  if (t.type !== "cartesian")
    throw new Jn("errors.unexpectedChartType", { chartType: t.type });
  const { seriesCapacity: yt, categoriesCapacity: gt } = f.dataLimits;
  t.xValues.length > gt && lt.push(Ad("x", t.xValues.length, gt));
  const { categories: _, indexMap: at, plotBands: G } = yE(
    B,
    xE(
      oe(Ut({}, t), {
        xValues: t.xValues.slice(0, gt)
      }),
      B,
      f,
      ht
    )
  ), [F, $, Y, J] = sE(
    t,
    B
  ), Q = r === "bar" || $.includes("bar") ? "vertical" : "horizontal", q = ht ? xP(
    f.xAxis,
    B.x[0],
    t.xValues.map(Hy),
    st
  ) : SP(
    f.xAxis,
    f.x2Axis,
    _,
    G,
    Q,
    B,
    r
  ), U = wg(
    r,
    t,
    f,
    F,
    Y,
    0
  ), N = F.some((P) => P === 1) ? wg(
    r,
    t,
    f,
    F,
    Y,
    1
  ) : void 0, { stacking: D, showTotal: k } = Zy(
    r,
    f
  );
  let A, b = f.yAxis;
  "polarType" in f && (A = f.polarType, b = oe(Ut({}, f.yAxis), {
    titleEnabled: !1,
    title: null
  }));
  const [d, m] = wP(
    b,
    f.y2Axis,
    U,
    N,
    k,
    B,
    D
  ), v = t.xAxisCount > 1 && Q === "vertical" ? 90 : 20, g = r === "area" && D !== void 0, x = !!A;
  return t.series.length > yt && lt.push(aa(t.series.length, yt)), { options: Lr(
    fP(r, A, D),
    {
      title: { text: null },
      chart: {
        type: ut,
        spacing: [20, v, 20, 20],
        alignTicks: !1,
        polar: x,
        events: {
          load: function() {
            if (B.x.length === 2)
              return;
            const P = this;
            if (f.autoZoom && f.autoZoom.scrollerLocation) {
              const { min: s, max: a } = f.autoZoom.scrollerLocation;
              iv(P, s, a);
            }
            const S = P.chartWidth, u = P.chartHeight, y = ev(
              ut,
              f.autoZoom.enabled,
              t.xValues.length,
              r === "bar" ? u : S,
              r === "bar"
            );
            P.update({ navigator: y }, !0);
          }
        }
      },
      xAxis: q,
      yAxis: d,
      // The series level animation disables all animations, the chart
      // level animation only disables initial or subsequent paints
      legend: Wo(f.legend),
      series: t.series.slice(0, yt).map((P, S) => {
        var n, o;
        const u = B.breakBy.length ? B.y[0] : B.y.find(({ column: { name: i } }) => i === P.name), y = u == null ? void 0 : u.column.name, e = (y ? f.designPerSeries[y] : void 0) || f;
        return oe(Ut(oe(Ut({}, ht ? eE(
          P,
          at,
          g || Y[S],
          q[0].tickInterval,
          f.dataLimits.categoriesCapacity,
          bP(B.x[0], st),
          d[S],
          m[S]
        ) : ty(B) && !D ? sa(
          P,
          tE(_, S),
          g || Y[S]
        ) : sa(P, at, g || Y[S])), {
          showInNavigator: !0,
          stickyTracking: !1,
          boostThreshold: 0,
          turboThreshold: 0,
          color: (o = Kh(B, P.name)) != null ? o : en((n = tt == null ? void 0 : tt.palette) == null ? void 0 : n.variantColors, S),
          yAxis: F[S],
          dataLabels: {
            formatter: qP(u == null ? void 0 : u.numberFormatConfig)
          }
        }), $[S] && { type: $[S] }), {
          connectNulls: J[S],
          marker: vg(e.marker),
          lineWidth: e.lineWidth
        });
      }),
      plotOptions: {
        series: oe(Ut({
          dataLabels: x ? QP(f.valueLabel, A) : JP(
            Q,
            f.valueLabel,
            D && r !== "area"
          ),
          marker: vg(f.marker)
        }, D && { stacking: D }), {
          // Force setup of "stacking" as undefined required for correct transition between classic and stacked modes
          // if it missing then classic would not correct render if previously it was stacked
          stacking: D || void 0,
          connectNulls: !1
        })
      },
      tooltip: mE(void 0, B, H)
    }
  ), alerts: lt };
}, Ag = (t, r) => ({
  animation: !1,
  backgroundColor: eo,
  borderColor: to,
  borderRadius: 10,
  borderWidth: 1,
  useHTML: !0,
  formatter: function() {
    var yt, gt, _, at, G, F, $;
    const f = this;
    let B;
    f.percentage && (B = t ? f.percentage.toFixed(1) : `${Math.round(f.percentage)}`);
    const H = r;
    let tt = (gt = (yt = H.y) == null ? void 0 : yt.find(
      (Y) => Y.column.name === f.series.name
    )) == null ? void 0 : gt.numberFormatConfig;
    !tt && H.breakBy.length > 0 && (tt = (at = (_ = H.y) == null ? void 0 : _.find(
      (Y) => Y.enabled
    )) == null ? void 0 : at.numberFormatConfig);
    const st = li(tt), lt = ($ = (F = (G = f.point) == null ? void 0 : G.custom) == null ? void 0 : F.xDisplayValue) != null ? $ : f.x, ht = ra(st, f.y) + (B ? ` / ${B}%` : ""), ut = f.point.color || f.series.color;
    return oa(`
          ${f.series.name || ""}
          ${f.series.name && f.point.name ? " - " : ""}
          ${f.point.name || ""}
          <br />
          ${Ei(ht, ut)}
          ${lt ? qn() + lt : ""}
        `);
  }
}), rv = {
  enabled: !0,
  showCategories: !0,
  showValue: !0,
  showPercent: !0,
  showDecimals: !1
}, nv = "classic", SE = {
  classic: "0%",
  donut: "40%",
  ring: "80%"
}, wE = () => ({
  allowPointSelect: !1,
  showInLegend: !0,
  dataLabels: {
    enabled: !1,
    showPercentLabels: !1,
    showDecimals: !1,
    pieMinimumFontSizeToTextLabel: 8,
    align: "center",
    style: ki
  },
  innerSize: "0%"
}), CE = () => ({
  dataLabels: {
    enabled: !1
  }
}), kE = (t = nv, r = rv, f, B) => {
  var st;
  const H = wE(), tt = CE();
  if (H.innerSize = SE[t], B && (H.dataLabels.style = {
    color: B.chart.textColor,
    fontFamily: B.typography.fontFamily
  }), r.enabled) {
    const lt = r.showCategories || r.showValue, { dataLabels: ht } = H;
    ht.enabled = lt, ht.showPercentLabels = r.showPercent, ht.showDecimals = r.showDecimals;
    const ut = li(
      (st = f.y[0]) == null ? void 0 : st.numberFormatConfig
    );
    ht.formatter = function() {
      const yt = this.point.name || this.series.name, gt = this.y;
      return `<div>
          ${r.showCategories ? yt : ""}
          ${r.showCategories && r.showValue ? "<br />" : ""}
          ${r.showValue ? Hi(ut, gt) : ""}
        </div>`;
    }, tt.dataLabels && (tt.dataLabels.enabled = lt);
  }
  return {
    pie: H,
    series: tt
  };
}, yp = {
  enabled: !0,
  showCategories: !0,
  showValue: !0,
  showPercent: !0,
  showDecimals: !1
}, vp = "regular", bp = "regular", xp = "regular", TE = (t) => t !== "regular", Pg = () => ({
  allowPointSelect: !1,
  cursor: "pointer",
  showInLegend: !0,
  dataLabels: {
    enabled: !1,
    funnelMinimumFontSizeToTextLabel: 8,
    align: "center",
    style: ki
  },
  reversed: !0,
  neckWidth: OE,
  neckHeight: 0,
  width: ov
}), ME = () => ({
  dataLabels: {
    enabled: !1
  }
}), AE = (t) => {
  const { enabled: r, showCategories: f, showValue: B, showPercent: H } = t;
  return {
    enabled: r && [f, B, H].find(Boolean) !== void 0
  };
}, PE = (t, r) => r.showCategories ? t.point.name || t.series.name : "", EE = (t, r, f) => {
  if (!r.showValue)
    return "";
  const B = Hi(f, t.y);
  return r.showValue && r.showCategories ? `<br />${B}` : B;
}, LE = (t, r) => {
  var H, tt;
  if (!r.showPercent)
    return "";
  const f = ((tt = (H = t.point) == null ? void 0 : H.custom) == null ? void 0 : tt.number1) || 0, B = r.showDecimals ? f.toFixed(1) : `${Math.round(f)}`;
  return ` <b>${oh(B)}</b>`;
}, ov = 66.6, OE = 15, DE = (t) => ov, IE = {
  wide: 60,
  regular: 30,
  narrow: 15
}, RE = (t, r) => Math.round(AT(t, IE[r])), jE = (t) => t === "pinched" ? 30 : 0, _E = (t, r, f) => {
  var gt;
  const {
    funnelType: B = bp,
    funnelSize: H = vp,
    funnelDirection: tt = xp,
    funnelLabels: st = yp
  } = t, lt = oe(Ut({}, ME()), {
    dataLabels: AE(st)
  }), ht = li(
    (gt = r.y[0]) == null ? void 0 : gt.numberFormatConfig
  ), ut = DE();
  return {
    funnel: oe(Ut({}, Pg()), {
      dataLabels: oe(Ut(Ut({}, Pg().dataLabels), f ? {
        color: f.chart.textColor,
        style: {
          fontFamily: f.typography.fontFamily
        }
      } : null), {
        enabled: st.enabled && (st.showCategories || st.showValue || st.showPercent),
        formatter: function() {
          const _ = PE(this, st), at = EE(this, st, ht), G = LE(this, st);
          return `${_}${at}${G}`;
        }
      }),
      reversed: TE(tt),
      neckWidth: oh(RE(ut, H)),
      neckHeight: oh(jE(B)),
      width: oh(ut)
    }),
    series: lt
  };
}, sv = "Other", av = "Others", BE = "#525A6B", NE = (t, r, f, B) => {
  const H = [], { seriesCapacity: tt } = f.dataLimits;
  let st;
  if (t.xAxisCount === 0) {
    t.series.length > tt && H.push(aa(t.series.length, tt));
    const ht = t.series.slice(0, tt), ut = ht.map((yt) => {
      var gt;
      return (gt = yt.title) != null ? gt : yt.name;
    });
    st = [
      {
        name: "",
        data: ht.map(
          (yt) => sa(yt, [0], !1, ut, void 0, !0).data
        ).flat().map((yt, gt) => {
          var _, at;
          return oe(Ut({}, yt), {
            sliced: (_ = yt.selected) != null ? _ : !1,
            name: ut[gt],
            color: (at = Kh(r, ht[gt].name)) != null ? at : en(B == null ? void 0 : B.palette.variantColors, gt)
          });
        }),
        boostThreshold: 0,
        turboThreshold: 0
      }
    ];
  } else {
    t.xValues.length > tt && H.push(aa(t.xValues.length, tt));
    const ht = t.xValues.slice(0, tt).map((gt) => gt.xValues.join(",")), ut = ht.map((gt, _) => _), yt = ht.map(
      (gt, _) => {
        var at, G, F;
        return (F = (at = r.seriesToColorMap) == null ? void 0 : at[gt]) != null ? F : en((G = B == null ? void 0 : B.palette) == null ? void 0 : G.variantColors, _);
      }
    );
    st = t.series.map((gt) => {
      const G = sa(
        gt,
        ut,
        !1,
        ht,
        yt,
        !0
      ), { data: _ } = G, at = mr(G, ["data"]);
      return oe(Ut({}, at), {
        data: _.map((F) => {
          var $;
          return oe(Ut({}, F), {
            sliced: ($ = F.selected) != null ? $ : !1
          });
        }),
        boostThreshold: 0,
        turboThreshold: 0
      });
    });
  }
  const lt = f == null ? void 0 : f.convolution;
  if (!(lt != null && lt.enabled))
    return { series: st, alerts: H, convolutionSeries: [] };
  switch (lt == null ? void 0 : lt.selectedConvolutionType) {
    case "byPercentage":
      return oe(Ut({}, FE(st, lt)), { alerts: H });
    case "bySlicesCount":
      return oe(Ut({}, WE(st, lt)), { alerts: H });
    default:
      return { series: st, alerts: H, convolutionSeries: [] };
  }
}, zE = (t, r) => {
  var f;
  return t + ((f = r.y) != null ? f : 0);
}, Eg = (t, r, f) => {
  var B;
  return ((B = t.y) != null ? B : 0) / r >= f;
}, lv = (t, r) => {
  const f = r.reduce((B, H) => {
    var tt;
    return B + ((tt = H.y) != null ? tt : 0);
  }, 0);
  return t[0].data.push({
    y: f,
    name: sv,
    color: BE,
    sliced: !1,
    drilldown: av
  }), t;
}, cv = (t) => [
  {
    name: sv,
    id: av,
    data: t
  }
], FE = (t, r) => {
  if ((r == null ? void 0 : r.minimalIndependentSlicePercentage) === void 0 || t.length === 0)
    return { series: t, convolutionSeries: [] };
  const f = r.minimalIndependentSlicePercentage / 100, B = t[0].data.reduce(zE, 0), H = t[0].data.filter((tt) => !Eg(tt, B, f));
  return H.length === 0 ? { series: t, convolutionSeries: [] } : (t[0].data = t[0].data.filter((tt) => Eg(tt, B, f)), {
    series: lv(t, H),
    convolutionSeries: cv(H)
  });
}, WE = (t, r) => {
  if ((r == null ? void 0 : r.independentSlicesCount) === void 0)
    return { series: t, convolutionSeries: [] };
  const f = r.independentSlicesCount, B = t[0].data.map((st, lt) => oe(Ut({}, st), { index: lt })).sort((st, lt) => {
    var ht, ut;
    return ((ht = lt.y) != null ? ht : 0) - ((ut = st.y) != null ? ut : 0);
  }).slice(0, f), H = Object.fromEntries(B.map((st) => [st.index, !0])), tt = t[0].data.filter((st, lt) => !H[lt]);
  return tt.length === 0 ? { series: t, convolutionSeries: [] } : (t[0].data = t[0].data.filter((st, lt) => H[lt]), {
    series: lv(t, tt),
    convolutionSeries: cv(tt)
  });
}, HE = (t, r, f, B) => {
  let H;
  const tt = [], { seriesCapacity: st } = f.dataLimits;
  if (t.xAxisCount === 0) {
    t.series.length > st && tt.push(aa(t.series.length, st));
    const lt = t.series.slice(0, st), ht = lt.map((ut) => {
      var yt;
      return (yt = ut.title) != null ? yt : ut.name;
    });
    H = [
      {
        name: "",
        data: lt.map((ut) => sa(ut, [0], !1, ht).data).flat().map((ut, yt) => {
          var gt;
          return oe(Ut({}, ut), {
            name: ht[yt],
            color: (gt = Kh(r, lt[yt].name)) != null ? gt : en(B == null ? void 0 : B.palette.variantColors, yt)
          });
        }),
        boostThreshold: 0,
        turboThreshold: 0
      }
    ], Lg(H[0]);
  } else {
    t.xValues.length > st && tt.push(aa(t.xValues.length, st));
    const lt = t.xValues.slice(0, st).map((yt) => yt.xValues.join(",")), ht = lt.map((yt, gt) => gt), ut = lt.map(
      (yt, gt) => {
        var _, at, G;
        return (G = (_ = r.seriesToColorMap) == null ? void 0 : _[yt]) != null ? G : en((at = B == null ? void 0 : B.palette) == null ? void 0 : at.variantColors, gt);
      }
    );
    H = t.series.map((yt) => oe(Ut({}, Lg(sa(yt, ht, !1, lt, ut))), {
      boostThreshold: 0,
      turboThreshold: 0
    }));
  }
  return { series: H, alerts: tt };
}, Lg = (t) => {
  let r = 0;
  const f = t.data.map((B, H) => {
    const tt = B.y;
    return H === 0 && (r = tt), B.custom = oe(Ut({}, B.custom), { number1: PT(r, tt) }), B;
  });
  return oe(Ut({}, t), {
    data: f
  });
}, hv = (t, r, f) => ({
  animation: !1,
  backgroundColor: eo,
  borderColor: to,
  borderRadius: 10,
  borderWidth: 1,
  padding: 1,
  useHTML: !0,
  outside: !0,
  formatter: function() {
    return XE(this, t, r, f);
  }
}), UE = `
  <div style="position: absolute; top: 100%; right: 40px; z-index: 1">
    <div style="
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136,136,136,0);
      border-top-color: #ccc;
      border-width: 7px 12px 12px 12px;
      margin-left: -7px;
    "></div>
     <div style="
       border: solid transparent;
       content: ' ';
       height: 0;
       width: 0;
       position: absolute;
       pointer-events: none;
       border-color: rgba(255,255,255,0);
       border-top-color: #fff;
       border-width: 6px 11px 11px 11px;
       margin-left: -6px;
     "></div>
  </div>
`;
function GE(t, r) {
  return t / (r / 100);
}
function qc(t, r) {
  return `${GE(t, r).toPrecision(3)}%`;
}
function XE(t, r, f, B) {
  var gt, _, at, G, F, $, Y, J, Q;
  if (B != null && B.shouldSkip && B.shouldSkip(t))
    return !1;
  const H = li(
    (_ = (gt = r.y) == null ? void 0 : gt[0]) == null ? void 0 : _.numberFormatConfig
  ), tt = ((at = f == null ? void 0 : f.tooltip) == null ? void 0 : at.mode) === "contribution", st = Li((G = r.y) == null ? void 0 : G[0]), lt = t.color;
  let ht = 0;
  const ut = [], yt = (q) => {
    if (q.parentNode)
      ut.push(q);
    else {
      ht = q.val;
      return;
    }
    yt(q.parentNode);
  };
  return yt(t.point.node), `
      <div
        class="csdk-treemap-tooltip-wrapper">
        ${[...ut].reverse().map((q, U) => {
    const N = U === ut.length - 1;
    return `
                <div
                  class="csdk-treemap-tooltip-level"
                  style="background: ${N ? "#f2f2f2" : "white"};"
                  >
                  ${B != null && B.displayColorCircles ? YE(q.color) : ""}
                  <span
                    style="color: ${N ? lt : "currentColor"}"
                  >${q.name}</span>
                  <span
                    style="color: ${N ? "#5B6372" : "currentColor"}; margin-left: auto;"
                  >${tt ? qc(q.val, ht) : ra(H, q.val)}</span>
                  ${N ? "" : UE}
                </div>`;
  }).join("")}
        <div class="csdk-treemap-tooltip-value">
          <span style="color:${lt}; font-size: 15px">${tt ? qc(ut[0].val, ht) : ra(H, (F = ut[0]) == null ? void 0 : F.val)}</span> of ${st}
        </div>
        ${ut[1] ? `<div class="csdk-treemap-tooltip-value" style="padding-top: 4px;">
                  <span style="color:${lt}; font-size: 15px">${qc(
    ($ = ut[0]) == null ? void 0 : $.val,
    (Y = ut[1]) == null ? void 0 : Y.val
  )}
                  </span> of ${(J = ut[1]) == null ? void 0 : J.name}
                </div>` : ""}
        ${B != null && B.displayTotalContribution && !tt ? `<div class="csdk-treemap-tooltip-value" style="padding-top: 4px;">
                    <span style="color:${lt}; font-size: 15px">${qc(
    (Q = ut[0]) == null ? void 0 : Q.val,
    ht
  )}
                    </span> of total
                   </div>` : ""}
        </div>
      </div>`;
}
function YE(t) {
  return `
    <div style="
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background-color: ${t};
      margin-right: 6px;
    "></div>
  `;
}
var Ed = { exports: {} };
/*! For license information please see index.js.LICENSE.txt */
(function(t, r) {
  (function(f, B) {
    t.exports = B();
  })(self, () => (() => {
    var f = { 4658: function(tt, st, lt) {
      var ht = this && this.__createBinding || (Object.create ? function(_, at, G, F) {
        F === void 0 && (F = G);
        var $ = Object.getOwnPropertyDescriptor(at, G);
        $ && !("get" in $ ? !at.__esModule : $.writable || $.configurable) || ($ = { enumerable: !0, get: function() {
          return at[G];
        } }), Object.defineProperty(_, F, $);
      } : function(_, at, G, F) {
        F === void 0 && (F = G), _[F] = at[G];
      }), ut = this && this.__exportStar || function(_, at) {
        for (var G in _)
          G === "default" || Object.prototype.hasOwnProperty.call(at, G) || ht(at, _, G);
      }, yt = this && this.__importDefault || function(_) {
        return _ && _.__esModule ? _ : { default: _ };
      };
      Object.defineProperty(st, "__esModule", { value: !0 }), st.default = void 0, ut(lt(1920), st);
      var gt = lt(1920);
      Object.defineProperty(st, "default", { enumerable: !0, get: function() {
        return yt(gt).default;
      } });
    }, 1920: function(tt, st, lt) {
      var ht = this && this.__createBinding || (Object.create ? function(_, at, G, F) {
        F === void 0 && (F = G);
        var $ = Object.getOwnPropertyDescriptor(at, G);
        $ && !("get" in $ ? !at.__esModule : $.writable || $.configurable) || ($ = { enumerable: !0, get: function() {
          return at[G];
        } }), Object.defineProperty(_, F, $);
      } : function(_, at, G, F) {
        F === void 0 && (F = G), _[F] = at[G];
      }), ut = this && this.__exportStar || function(_, at) {
        for (var G in _)
          G === "default" || Object.prototype.hasOwnProperty.call(at, G) || ht(at, _, G);
      }, yt = this && this.__importDefault || function(_) {
        return _ && _.__esModule ? _ : { default: _ };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var gt = yt(lt(7155));
      st.default = gt.default, ut(lt(8840), st);
    }, 6598: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(gt) {
        return gt && gt.__esModule ? gt : { default: gt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(4052)), yt = { xAxis: { labels: { style: { color: ut.default.labelColor, fontFamily: ut.default.fontFamily } }, title: { style: { color: ut.default.textColor, fontFamily: ut.default.fontFamily } }, crosshair: !1 }, yAxis: { labels: { style: { color: ut.default.labelColor, fontFamily: ut.default.fontFamily } }, title: { style: { color: ut.default.textColor, fontFamily: ut.default.fontFamily } }, crosshair: !1 }, zAxis: { labels: { style: { color: ut.default.labelColor, fontFamily: ut.default.fontFamily } }, title: { style: { color: ut.default.textColor, fontFamily: ut.default.fontFamily } } } };
      st.default = yt;
    }, 4052: (tt, st) => {
      Object.defineProperty(st, "__esModule", { value: !0 }), st.default = { fontFamily: "Open Sans", textColor: "#5B6372", labelColor: "#5B6372", legendColor: "#5B6372", legendNavigationColor: "#5B6372", legendNavigationSecondaryColor: "#9EA2AB" };
    }, 548: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(yt) {
        return yt && yt.__esModule ? yt : { default: yt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(3941));
      st.default = ut.default;
    }, 2243: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(gt) {
        return gt && gt.__esModule ? gt : { default: gt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(4052)), yt = { align: "center", itemHoverStyle: { color: ut.default.legendColor }, itemStyle: { color: ut.default.legendColor, fontSize: "12px", fontWeight: "bold", textOverflow: "ellipsis", fontFamily: ut.default.fontFamily }, navigation: { style: { color: ut.default.legendNavigationColor, fontFamily: ut.default.fontFamily }, activeColor: ut.default.legendNavigationColor, inactiveColor: ut.default.legendNavigationSecondaryColor }, alignColumns: !1 };
      st.default = yt;
    }, 3941: function(tt, st, lt) {
      var ht = this && this.__assign || function() {
        return ht = Object.assign || function(Y) {
          for (var J, Q = 1, q = arguments.length; Q < q; Q++)
            for (var U in J = arguments[Q])
              Object.prototype.hasOwnProperty.call(J, U) && (Y[U] = J[U]);
          return Y;
        }, ht.apply(this, arguments);
      }, ut = this && this.__importDefault || function(Y) {
        return Y && Y.__esModule ? Y : { default: Y };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var yt = ut(lt(4052)), gt = ut(lt(8655)), _ = ut(lt(2243)), at = ut(lt(1222)), G = ut(lt(6598)), F = { enabled: !1, text: "Sisense", href: "http://www.sisense.com", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: yt.default.textColor, fontSize: "9px" } }, $ = ht({ boost: { allowForce: !0, debug: { showSkipSummary: !0, timeBufferCopy: !0, timeKDTree: !0, timeRendering: !0, timeSeriesProcessing: !0, timeSetup: !0 }, enabled: !0, seriesThreshold: null, useGPUTranslations: !0 }, chart: { spacing: [10, 10, 10, 10], backgroundColor: "rgba(222,222,222,0)" }, credits: F, drilldown: { breadcrumbs: { buttonTheme: { fill: "#ffcb05", "stroke-width": 4, "stroke-linejoin": "round", stroke: "#ffcb05", padding: 5, states: { hover: { fill: "#f2b900", stroke: "#f2b900" } }, style: { color: "#3a4356" } }, format: "Back", floating: !0, position: { align: "right" }, showFullPath: !1 } }, exporting: { enabled: !1 }, global: { useUTC: !1 }, lang: { contextButtonTitle: "Chart context menu", decimalPoint: ".", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadPNG: "Download PNG image", downloadSVG: "Download SVG vector image", drillUpText: "Back", invalidDate: "", loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], noData: "No data to display", numericSymbolMagnitude: 1e3, numericSymbols: ["k", "M", "G", "T", "P", "E"], printChart: "Print chart", resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], shortWeekdays: void 0, thousandsSep: " ", weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] }, legend: _.default, navigator: { yAxis: { gridLineWidth: 0 }, xAxis: { gridLineWidth: 0 } }, plotOptions: at.default, title: { margin: 0 }, tooltip: gt.default }, G.default);
      st.default = $;
    }, 1222: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(at) {
        return at && at.__esModule ? at : { default: at };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(3491)), yt = ht(lt(4052)), gt = { enabled: !0, overflow: "justify", style: { color: yt.default.labelColor, fontFamily: yt.default.fontFamily, fontSize: "13px", fontWeight: "normal", cursor: "default", lineHeight: "14px" } }, _ = { series: { turboThreshold: 1e3, dataLabels: ut.default.merge(gt, { align: "center" }), states: { inactive: { enabled: !1 } } }, line: { allowPointSelect: !1, showCheckbox: !1, animation: { duration: 1e3 }, connectNulls: !1, cursor: "default", clip: !0, dashStyle: null, enableMouseTracking: !0, events: {}, legendIndex: 0, linecap: "round", lineWidth: 2, shadow: !1, stacking: null, label: { style: { color: yt.default.labelColor, fontFamily: yt.default.fontFamily } }, marker: { enabled: !0, symbol: null, lineWidth: 0, radius: 4, lineColor: "#FFFFFF", fillColor: null, states: { hover: { enabled: !0 }, select: { fillColor: "transparent", lineColor: "transparent" } } }, point: { events: {} }, dataLabels: ut.default.merge(gt, { align: "center", enabled: !1 }), cropThreshold: 300, pointRange: 0, states: { hover: { marker: {} }, select: { marker: {} } }, stickyTracking: !0 }, column: { maxPointWidth: 82, dataLabels: ut.default.merge(gt, { align: "center", enabled: !1, verticalAlign: "bottom", overflow: "justify" }) }, bar: { maxPointWidth: 82, dataLabels: ut.default.merge(gt, { align: "center", enabled: !1, verticalAlign: "middle", overflow: "justify" }) }, pie: { dataLabels: { overflow: "ellipsis" } } };
      st.default = _;
    }, 8655: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(yt) {
        return yt && yt.__esModule ? yt : { default: yt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(5837));
      st.default = ut.default;
    }, 5837: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(yt) {
        return yt && yt.__esModule ? yt : { default: yt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = { style: { fontSize: "13px", fontWeight: "normal", color: "#5B6372", fontFamily: ht(lt(4052)).default.fontFamily }, borderWidth: 1, borderColor: "#CCCCCC", backgroundColor: "#FFFFFF", borderRadius: 10, hideDelay: 20, shadow: { color: "#CECECE", offsetX: 2, offsetY: 2, width: 5 } };
      st.default = ut;
    }, 8040: function(tt, st, lt) {
      var ht = this && this.__assign || function() {
        return ht = Object.assign || function(G) {
          for (var F, $ = 1, Y = arguments.length; $ < Y; $++)
            for (var J in F = arguments[$])
              Object.prototype.hasOwnProperty.call(F, J) && (G[J] = F[J]);
          return G;
        }, ht.apply(this, arguments);
      }, ut = this && this.__importDefault || function(G) {
        return G && G.__esModule ? G : { default: G };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var yt = ut(lt(1857)), gt = ut(lt(4402)), _ = ut(lt(5998)), at = lt(2930);
      st.default = function(G) {
        var F = G.merge, $ = G.extend, Y = G.pick;
        G.getOptions().plotOptions.boxplot.lineWidth = 1, G.getOptions().plotOptions.boxplot.fillOpacity = 0.6, G.getOptions().plotOptions.boxplot.strokeOpacity = 0.6, G.getOptions().plotOptions.boxplot.strokeWidth = 1, G.getOptions().plotOptions.boxplot.states.select.lineWidth = 1, G.getOptions().plotOptions.boxplot.states.select.fillOpacity = 0.3, G.getOptions().plotOptions.boxplot.states.select.strokeOpacity = 0.3, G.getOptions().plotOptions.boxplot.states.hover.lineWidth = 1, G.getOptions().plotOptions.boxplot.states.hover.fillOpacity = 1, G.getOptions().plotOptions.boxplot.states.hover.strokeOpacity = 1, G.wrap(G.seriesTypes.boxplot.prototype, "drawPoints", function() {
          var J, Q, q, U, N, D, k, A, b, d, m, v, g, x, E, P, S, u, y, s, a, e, n, o, i, c, l = this, h = l.points, C = l.options, M = l.chart.renderer, O = l.doQuartiles !== !1, p = parseInt(l.options.whiskerLength, 10) / 100;
          h.forEach(function(w) {
            if (m = w.graphic, o = w.shapeArgs, g = {}, S = {}, y = {}, i = w.color || l.color, c = w.innerBoxColor || l.color, w.plotY !== void 0) {
              J = { fill: c, "fill-opacity": 0.75, stroke: l.color, "stroke-opacity": 1, "stroke-width": 1 }, w.selected && (J.fill = c, J["fill-opacity"] = 0.3, J["stroke-opacity"] = 0.3), q = { fill: c, "fill-opacity": J["fill-opacity"], stroke: i, "stroke-width": 1 };
              var T = { fill: J.fill, "fill-opacity": J["fill-opacity"], "stroke-opacity": J["fill-opacity"] };
              Q = ht({}, J), s = o.width, a = Math.floor(o.x), e = a + s, n = Math.round(s / 2), U = Math.floor(O ? w.q1Plot : w.lowPlot), N = Math.floor(O ? w.q3Plot : w.lowPlot), D = Math.floor(w.highPlot), k = Math.floor(w.lowPlot), g.stroke = w.stemColor || C.stemColor || i, g["stroke-width"] = Y(w.stemWidth, C.stemWidth, C.lineWidth), g.dashstyle = w.stemDashStyle || C.stemDashStyle, S.stroke = w.whiskerColor || C.whiskerColor || i, S["stroke-width"] = Y(w.whiskerWidth, C.whiskerWidth, C.lineWidth), y.stroke = w.medianColor || C.medianColor || i, y["stroke-width"] = Y(w.medianWidth, C.medianWidth, C.lineWidth), y["stroke-linecap"] = "round", b = g["stroke-width"] % 2 / 2, v = ["M", d = a + n + b, N, "L", d, D, "M", d, U, "L", d, k, "z"], O && (b = J["stroke-width"] % 2 / 2, d = Math.floor(d) + b, U = Math.floor(U) + b, N = Math.floor(N) + b, x = ["M", a += b, N, "L", a, U, "L", e += b, U, "L", e, N, "L", a, N, "z"]), p && (b = S["stroke-width"] % 2 / 2, E = ["M", d - n * p, D += b, "L", d + n * p, D, "M", d - n * p, k += b, "L", d + n * p, k]), b = 2, A = Math.round(w.medianPlot) + b, u = ["M", a, A, "L", e, A, "z"], O && (P = ["M", a + 0.5, A + 0.5, "L", a + 0.5, U - 0.5, "L", e - 0.5, U - 0.5, "L", e - 0.5, A + 0.5, "L", a + 0.5, A + 0.5, "z"]), m ? (m.attr(T), w.stem.attr(g), w.stem.animate({ d: v }), p && (w.whiskers.attr(S), w.whiskers.animate({ d: E })), O && (w.box.attr(Q), w.box.attr("stroke", Q.stroke), w.box.animate({ d: x }), w.innerBox.animate({ d: P }), w.innerBox.attr(q)), w.medianShape.attr(y), w.medianShape.animate({ d: u })) : (w.graphic = m = M.g().add(l.group).attr(T).attr("name", "graphic"), w.stem = M.path(v).attr(g).attr("name", "stem").add(m), p && (w.whiskers = M.path(E).attr(S).attr("name", "whiskers").add(m)), O && (w.box = M.path(x).attr(Q).attr("stroke", Q.stroke).attr("name", "box").add(m), w.innerBox = M.path(P).attr(q).attr("name", "inner-box").add(m)), w.medianShape = M.path(u).attr(y).attr("name", "median").add(m));
            }
          });
        }), G.wrap(G.seriesTypes.boxplot.prototype, "drawDataLabels", function(J, Q, q) {
          var U, N, D, k, A = this, b = A.options, d = b.cursor, m = A.points, v = b.dataLabels, g = [{ name: "median", enabled: !0, indent: -15, path: function(S, u) {
            return ["M", S, u, "L", S - 10, u];
          } }, { name: "q3", enabled: !0, indent: -20, path: function(S, u) {
            return ["M", S, u, "L", S - 2, u + 5, S - 10, u + 5];
          } }, { name: "high", enabled: !0, indent: -20, path: function(S, u) {
            return ["M", S, u, "L", S - 2, u + 5, S - 10, u + 5];
          } }, { name: "q1", enabled: !0, indent: -7, path: function(S, u) {
            return ["M", S, u, "L", S - 2, u - 5, S - 10, u - 5];
          } }, { name: "low", enabled: !0, indent: -7, path: function(S, u) {
            return ["M", S, u, "L", S - 2, u - 5, S - 10, u - 5];
          } }];
          if (J.call(this, v, q), A.data.length > 0) {
            var x = A.barW;
            A.barW > A.options.maxPointWidth && (x = A.options.maxPointWidth), this.data.forEach(function(S) {
              S.shapeArgs.x += (S.shapeArgs.width - x) / 2, S.shapeArgs.width = x;
            });
          }
          if (v.enabled || A._hasPointLabels) {
            k = A.plotGroup("dataLabelsGroup", "data-labels", A.visible ? "visible" : "hidden", v.zIndex || 6);
            var E = A.chart.plotBox.height;
            if (A.type === "boxplot" && E < 200)
              if ((0, at.defined)((0, yt.default)(m, "0.dataLabel")))
                for (var P = 0; P < m.length; P++)
                  m[P].dataLabel && ((0, at.defined)((0, yt.default)(m[P].dataLabel, "high")) && m[P].dataLabel.high.destroy(), (0, at.defined)((0, yt.default)(m[P].dataLabel, "low")) && m[P].dataLabel.low.destroy());
              else
                delete g[2], delete g[4];
            N = v, m.forEach(function(S) {
              var u, y, s, a, e, n, o = !0, i = S.connector, c = S.shapeArgs, l = Math.floor(c.x) + c.width;
              U = S.options && S.options.dataLabels;
              var h = Y(U && U.enabled, N.enabled), C = S.innerBoxColor || A.color;
              if (h) {
                v = F(N, U), n = v.rotation, s = S.getLabelConfig();
                var M = !1, O = (0, _.default)(g);
                (0, at.defined)(S, "shapeArgs.height") && S.shapeArgs.height < 30 && (delete O[2], delete O[4], S.shapeArgs.height === 0 && (M = !0)), (0, at.defined)(S.dataLabel) || (S.dataLabel = {}, S.dataLabel.element = {}, S.dataLabel.destroy = function() {
                  G.removeEvent(S.dataLabel, "add"), G.removeEvent(S.dataLabel.element, "mouseenter"), G.removeEvent(S.dataLabel.element, "mouseleave"), O.forEach(function(p) {
                    p && S.dataLabel[p.name] && (S.dataLabel[p.name].destroy(), S.dataLabelLine[p.name].destroy());
                  }), S.dataLabel = null, S.dataLabelLine = null;
                }), (0, at.defined)(S.dataLabelLine) || (S.dataLabelLine = {}), O.forEach(function(p) {
                  if (p && p.enabled) {
                    u = S.dataLabel[p.name], y = S.dataLabelLine[p.name], D = v.formatter.call(s, v, p.name), v.style.color = Y(v.color, v.style.color, A.color, "black"), v.x = l + 12, v.y = S[p.name + "Plot"] - S.highPlot + p.indent;
                    var w = A.visible && A.chart.isInsidePlot(S.plotX, S.plotY, A.chart.inverted) && A.chart.isInsidePlot(S.plotX, S.yBottom, A.chart.inverted);
                    if (u)
                      w ? ((0, at.defined)(D) ? (u.attr({ text: D }), o = !1) : (S.dataLabel[p.name] = u = u.destroy(), i && (S.connector = i.destroy())), y && y.destroy()) : (S.dataLabel[p.name] = u = u.destroy(), y && y.destroy());
                    else if ((0, at.defined)(D) && D !== "null") {
                      for (e in a = { fill: v.backgroundColor, stroke: v.borderColor, "stroke-width": v.borderWidth, r: v.borderRadius || 0, rotation: n, padding: v.padding, zIndex: 1 })
                        (0, gt.default)(a[e]) && delete a[e];
                      w && ((u = A.chart.renderer[n ? "text" : "label"](D, 0, -999, null, null, null, v.useHTML)).attr(a).css($(v.style, d && { cursor: d })).add(k).shadow(v.shadow), u.options = {}, S.dataLabel[p.name] = u);
                    }
                    if (w) {
                      var T = { fill: C, "fill-opacity": 0.75, stroke: A.color, "stroke-opacity": 1, "stroke-width": 1 }, z = 13;
                      M && (p.name === "q1" ? z = 5 : p.name === "q3" && (z = 21)), y = S.dataLabelLine[p.name] = S.series.chart.renderer.path(p.path(2, z)).attr({ "stroke-width": 1, stroke: T.stroke, "stroke-opacity": T["fill-opacity"] || 1 }).add(u);
                    }
                    u && A.alignDataLabel(S, u, v, null, o, y, p.name), u.options = {}, S["dataLabel" + p.name] = u;
                  }
                });
              }
              S.dataLabels = g.map(function(p) {
                return S.dataLabel[p.name];
              }).filter(function(p) {
                return p;
              });
            }), A.dataLabelCollections = [], g.map(function(S) {
              return S.name;
            }).forEach(function(S) {
              A.dataLabelCollections.push("dataLabel" + S);
            });
          }
        }), G.wrap(G.seriesTypes.boxplot.prototype, "alignDataLabel", function(J, Q, q, U, N, D, k, A) {
          var b = this.chart, d = b.inverted, m = Q.dlBox || Q.shapeArgs, v = Q.below || Q.plotY > Y(this.translatedThreshold, b.plotSizeY), g = Y(U.inside, !!this.options.stacking);
          m && ((N = F(m)).y += v ? N.height : 0, N.height = 0), U.align = Y(U.align, "left"), U.verticalAlign = Y(U.verticalAlign, d || g ? "middle" : v ? "top" : "bottom");
          var x, E = q.getBBox(), P = this.visible && b.isInsidePlot(Q.plotX, Q.plotY, d) && b.isInsidePlot(Q.plotX, Q.yBottom, d);
          if (P) {
            switch ($(U, { width: E.width, height: E.height }), x = { align: U.align, x: U.x, y: N.y + U.y + N.height / 2 }, A) {
              case "q3":
                (0, at.defined)(Q, "dataLabel.median.y") && Q.dataLabel.median.y != 999 && x.y + U.height > Q.dataLabel.median.y && (x.y = Q.dataLabel.median.y - (U.height / 2 + 4));
                break;
              case "high":
                (0, at.defined)(Q, "dataLabel.q3.y") && Q.dataLabel.q3.y != 999 && x.y + U.height > Q.dataLabel.q3.y && (x.y = Q.dataLabel.q3.y - (U.height / 2 + 4));
                break;
              case "q1":
                (0, at.defined)(Q, "dataLabel.median.y") && Q.dataLabel.median.y != 999 && x.y < Q.dataLabel.median.y + Q.dataLabel.median.height && (x.y = Q.dataLabel.median.y + (U.height / 2 + 4));
                break;
              case "low":
                (0, at.defined)(Q, "dataLabel.q1.y") && Q.dataLabel.q1.y != 999 && x.y < Q.dataLabel.q1.y + Q.dataLabel.q1.height ? x.y = Q.dataLabel.q1.y + (U.height / 2 + 4) : (0, at.defined)(Q, "yBottom") && x.y + U.height > b.plotHeight && (x.y = b.plotHeight - U.height);
            }
            x.y = isNaN(x.y) ? 0 : x.y, q[D ? "attr" : "animate"](x);
          }
          P || (q.attr({ y: -999 }), q.placed = !1, k.attr({ "stroke-opacity": 0 }));
        });
      };
    }, 9688: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(gt) {
        return gt && gt.__esModule ? gt : { default: gt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(1284)), yt = ht(lt(1654));
      st.default = function(gt) {
        var _ = gt.wrap;
        function at(G) {
          this.hasCartesianSeries && this.series.forEach(function(F) {
            F.options && F.options.stacking === "percent" && (F.userOptions.data.forEach(function($) {
              $ && ($.originalY = $.y, $.y = Math.abs($.y));
            }), F.yData = F.yData.map(Math.abs));
          }), G.apply(this, [].slice.call(arguments, 1));
        }
        (0, yt.default)(gt), _(gt.Chart.prototype, "render", at), _(gt.Chart.prototype, "redraw", at), gt.Axis.prototype.renderUnsquish = function() {
          var G, F, $, Y, J, Q = this.chart, q = Q.renderer, U = this.tickPositions, N = this.ticks, D = this.options.labels, k = D.style, A = this.horiz, b = this.getSlotWidth(), d = Math.max(1, Math.round(b - 2 * D.padding)), m = {}, v = this.labelMetrics(), g = k.textOverflow, x = 0;
          if ((0, ut.default)(D.rotation) || (m.rotation = D.rotation || 0), U.forEach(function(E) {
            var P = N[E];
            P.movedLabel && P.replaceMovedLabel(), P && P.label && P.label.textPxLength > x && (x = P.label.textPxLength);
          }), this.maxLabelLength = x, this.autoRotation)
            x > d && x > v.h ? m.rotation = this.labelRotation : this.labelRotation = 0;
          else if (b && (G = d, !g))
            for (F = "clip", Y = U.length; !A && Y--; )
              J = U[Y], ($ = N[J].label) && ($.styles && $.styles.textOverflow === "ellipsis" ? $.css({ textOverflow: "clip" }) : $.textPxLength > b && $.css({ width: b + "px" }), $.getBBox().height > this.len / U.length - (v.h - v.f) && ($.specificTextOverflow = "ellipsis"));
          m.rotation && (G = x > 0.33 * Q.chartHeight ? 0.28 * Q.chartHeight : x, g || (F = "ellipsis")), this.labelAlign = D.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (m.align = this.labelAlign), U.forEach(function(E) {
            var P = N[E], S = P && P.label, u = k.width, y = {};
            S && (S.attr(m), P.shortenLabel ? P.shortenLabel() : G && !u && k.whiteSpace !== "nowrap" && (G < S.textPxLength || S.element.tagName === "SPAN") ? (y.width = G + "px", g || (y.textOverflow = S.specificTextOverflow || F), S.css(y)) : S.styles && S.styles.width && !y.width && !u && S.css({ width: null }), delete S.specificTextOverflow, P.rotation = m.rotation);
          }, this), this.tickRotCorr = q.rotCorr(v.b, this.labelRotation || 0, this.side !== 0);
        };
      };
    }, 9639: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(yt) {
        return yt && yt.__esModule ? yt : { default: yt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 }), st.default = void 0;
      var ut = lt(9688);
      Object.defineProperty(st, "default", { enumerable: !0, get: function() {
        return ht(ut).default;
      } });
    }, 1654: function(tt, st, lt) {
      var ht = this && this.__read || function(G, F) {
        var $ = typeof Symbol == "function" && G[Symbol.iterator];
        if (!$)
          return G;
        var Y, J, Q = $.call(G), q = [];
        try {
          for (; (F === void 0 || F-- > 0) && !(Y = Q.next()).done; )
            q.push(Y.value);
        } catch (U) {
          J = { error: U };
        } finally {
          try {
            Y && !Y.done && ($ = Q.return) && $.call(Q);
          } finally {
            if (J)
              throw J.error;
          }
        }
        return q;
      }, ut = this && this.__spreadArray || function(G, F, $) {
        if ($ || arguments.length === 2)
          for (var Y, J = 0, Q = F.length; J < Q; J++)
            !Y && J in F || (Y || (Y = Array.prototype.slice.call(F, 0, J)), Y[J] = F[J]);
        return G.concat(Y || Array.prototype.slice.call(F));
      }, yt = this && this.__importDefault || function(G) {
        return G && G.__esModule ? G : { default: G };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var gt = yt(lt(1857)), _ = yt(lt(4402)), at = lt(2930);
      st.default = function(G) {
        var F, $ = G.fireEvent, Y = /* @__PURE__ */ new Map(), J = !1;
        function Q(k, A) {
          for (var b = [k, A], d = 0; d < b.length; d++)
            for (var m = b[d], v = 0; v < m.length; v++) {
              for (var g = (v + 1) % m.length, x = m[v], E = m[g], P = { x: E.y - x.y, y: x.x - E.x }, S = void 0, u = void 0, y = 0; y < k.length; y++) {
                var s = P.x * k[y].x + P.y * k[y].y;
                ((0, _.default)(S) || s < S) && (S = s), ((0, _.default)(u) || s > u) && (u = s);
              }
              var a = void 0, e = void 0;
              for (y = 0; y < A.length; y++)
                s = P.x * A[y].x + P.y * A[y].y, ((0, _.default)(a) || s < a) && (a = s), ((0, _.default)(e) || s > e) && (e = s);
              if (u < a || e < S)
                return !1;
            }
          return !0;
        }
        function q(k, A) {
          return (k.yAxis || []).some(function(b) {
            return !(!b.options.stackLabels || !b.stacking.stacks) && Object.values(b.stacking.stacks || []).some(function(d) {
              return Object.values(d).some(function(m) {
                return m.label === A;
              });
            });
          });
        }
        function U(k) {
          return k.series && k.series.some(function(A) {
            return (0, gt.default)(A, "xAxis.axisLine.animating");
          });
        }
        function N(k, A, b) {
          return b && !(0, _.default)(b.totalsRank) && q(k, A) ? b.totalsRank : A.labelrank || 0;
        }
        function D() {
          J || (J = !0, Y.forEach(function(k, A) {
            if (!U(A)) {
              if (k.length) {
                var b = k[k.length - 1];
                A.hideOverlappingLabels(b.labels, b.options);
              }
              Y.delete(A);
            }
          }), Y.size && (clearTimeout(F), F = setTimeout(D, 100)), J = !1);
        }
        G.wrap(G.Axis.prototype, "addPlotBandOrLine", function(k) {
          var A = k.apply(this, [].slice.call(arguments, 1));
          return (0, gt.default)(A, "options.isPlotBand") === !0 && (this.sisensePlotBands || (this.sisensePlotBands = []), this.sisensePlotBands.push(A)), A;
        }), G.wrap(G.PlotLineOrBand.prototype, "render", function(k) {
          var A = this, b = A.axis, d = A.options, m = d.to, v = d.from, g = (0, at.defined)(v) && (0, at.defined)(m), x = G.pick(d.zIndex, 0), E = b.chart.renderer, P = g ? "bands" : "lines", S = { zIndex: x };
          P += "-labels-" + x;
          var u = b.plotLinesAndBandsGroups[P];
          return u || (S.translateX = 0, S.translateY = 0, b.plotLinesAndBandsGroups[P] = u = E.g("plot-" + P).attr(S).add()), k.apply(this, [].slice.call(arguments, 1));
        }), G.PlotLineOrBand.prototype.renderLabel = function(k, A, b, d) {
          var m = this, v = m.axis, g = v.chart.renderer, x = m.label, E = (b ? "bands" : "lines") + "-labels-" + d, P = v.plotLinesAndBandsGroups[E];
          x || (m.label = x = g.text(this.getLabelText(k), 0, 0, k.useHTML).attr({ align: k.textAlign || k.align, rotation: k.rotation, class: "highcharts-plot-" + (b ? "band" : "line") + "-label " + (k.className || ""), zIndex: d }).add(P), v.chart.styledMode || x.css(G.merge({ textOverflow: "ellipsis" }, k.style)));
          var S = A.xBounds || [A[0][1], A[1][1], b ? A[2][1] : A[0][1]], u = A.yBounds || [A[0][2], A[1][2], b ? A[2][2] : A[0][2]], y = (0, at.arrayMin)(S), s = (0, at.arrayMin)(u);
          if (x.align(k, !1, { x: y, y: s, width: (0, at.arrayMax)(S) - y, height: (0, at.arrayMax)(u) - s }), !(x.styles.width && x.styles.width !== "auto" || x.alignValue && x.alignValue !== "left")) {
            var a = k.clip ? v.width : v.chart.chartWidth;
            x.css({ width: (x.rotation === 90 ? v.height - (x.alignAttr.y - v.top) : a - (x.alignAttr.x - v.left)) + "px" });
          }
          x.show(!0);
        }, G.addEvent(G.Chart.prototype, "render", function() {
          var k = [];
          (this.xAxis || []).forEach(function(A) {
            A.plotLinesAndBands && A.plotLinesAndBands.forEach(function(b) {
              b.label && b.label.visibility !== "hidden" && (b.label.isSerieLabel = !0, k.push(b.label));
            });
          }), k.length > 0 && this.hideOverlappingLabels(k);
        }), G.Chart.prototype.hideOverlappingLabels = function(k, A) {
          var b = this;
          A === void 0 && (A = {});
          var d = this;
          if (U(d))
            return function(e, n, o) {
              Y.has(e) || Y.set(e, []), Y.get(e).push({ labels: n, options: o }), D();
            }(d, ut([], ht(k), !1), A);
          D(), (k = k.filter(function(e) {
            var n = e == null ? void 0 : e.element, o = (e == null ? void 0 : e.className) === "stack-labels", i = (e == null ? void 0 : e.visibility) !== "hidden" || o && (e == null ? void 0 : e.placed);
            return n && i;
          })).forEach(function(e) {
            e.oldOpacity = e.opacity, e.newOpacity = 1, e.polygon = function(n) {
              var o = document.createElementNS("http://www.w3.org/2000/svg", "svg"), i = n.element, c = i.transform.baseVal.consolidate().matrix, l = i.getBBox();
              function h(C, M) {
                var O = o.createSVGPoint();
                O.x = C, O.y = M;
                var p = O.matrixTransform(c);
                return { x: p.x, y: p.y };
              }
              return [h(l.x, l.y), h(l.x, l.y + l.height), h(l.x + l.width, l.y + l.height), h(l.x + l.width, l.y)];
            }(e);
          }), k.sort(function(e, n) {
            return N(d, n, A) - N(d, e, A);
          });
          var m = this.plotBackground && this.plotBackground.element ? this.plotBackground.element.getBoundingClientRect() : null, v = m ? { x: (0, at.defined)(m.x) ? m.x : m.left, y: (0, at.defined)(m.y) ? m.y : m.top, width: m.width, height: m.height } : null, g = (0, gt.default)(d, "options.chart.type"), x = g === "area" || g === "areaspline", E = g === "pie";
          if ((x || g === "column" || g === "bar" || g === "line" || g === "bubble" || g === "boxplot") && v) {
            v.x -= 10, v.y -= 10, v.width += 20, v.height += 20, x && !function(e) {
              var n = (e.xAxis || []).filter(function(o) {
                return (0, gt.default)(o, "options.labels.enabled");
              });
              return n.length > 1 || n.some(function(o) {
                return o.options.plotBands && o.options.plotBands.length;
              });
            }(d) && (v.y -= 30, v.height += 30);
            var P = this.series && this.series.some(function(e) {
              return (0, gt.default)(e, "options.stacking") === "percent";
            });
            k.forEach(function(e) {
              var n, o, i, c;
              e.newOpacity === 0 || e.isSerieLabel || P && q(b, e) || (n = v, o = e.element.getBoundingClientRect(), i = (0, at.defined)(o.x) ? o.x : o.left, c = (0, at.defined)(o.y) ? o.y : o.top, n.x <= i && n.y <= c && n.x + n.width >= i + o.width && n.y + n.height >= c + o.height) || (e.newOpacity = 0);
            });
          }
          for (var S = k.length, u = 0; u < S; u++)
            for (var y = k[u], s = u + 1; s < S; ++s) {
              var a = k[s];
              y.polygon && a.polygon && y !== a && y.newOpacity !== 0 && a.newOpacity !== 0 && Q(y.polygon, a.polygon) && ((N(d, y, A) < N(d, a, A) ? y : a).newOpacity = 0);
            }
          k.forEach(function(e) {
            var n, o;
            e && (o = e.newOpacity, E && !e.placed || (o ? e.show(!0) : n = function() {
              e.hide();
            }, e.oldOpacity !== o && (e.alignAttr ? (e.alignAttr.opacity = o, e[e.isOld ? "animate" : "attr"](e.alignAttr, null, n), $(d, "afterHideOverlappingLabels")) : e.attr({ opacity: o })), e.isOld = !0));
          });
        }, G.wrap(G.SVGElement.prototype, "animate", function(k, A, b, d) {
          var m = this;
          return m.animating = !0, k.apply(this, [A, b, function() {
            m.animating = !1, d ? d(arguments) : b && b.complete && b.complete(arguments);
          }]);
        });
      };
    }, 4389: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(yt) {
        return yt && yt.__esModule ? yt : { default: yt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(4402));
      st.default = function(yt) {
        var gt, _, at = yt.objectEach, G = yt.pick, F = "legend-hovered", $ = document.documentElement.ontouchstart !== void 0;
        function Y() {
          clearTimeout(gt), clearTimeout(_), gt = null, _ = null;
        }
        yt.wrap(yt.Legend.prototype, "renderItem", function(J, Q) {
          J.call(this, Q);
          var q = Q.chart ? Q.chart : Q.series.chart, U = !!Q.series, N = q.options.$familyType === "pie", D = U ? ["graphic"] : ["group", "markerGroup"], k = Q.legendItem.group.element, A = U ? Q.series.points : this.chart.series;
          function b(P) {
            var S = [];
            return (P.yAxis || []).forEach(function(u) {
              u.options.stackLabels && !u.options.stackLabels.allowOverlap && at(u.stacking.stacks, function(y) {
                at(y, function(s) {
                  s && s.label && (s.label.isStackLabel = !0), S.push(s.label);
                });
              });
            }), S;
          }
          function d() {
            _ = null, gt || x(Q);
          }
          function m() {
            var P;
            gt = null, _ || (P = Q, (q.series || []).forEach(function(S) {
              S !== P && x(S);
            }));
          }
          function v(P, S) {
            q.hideOverlappingLabels(P, S);
          }
          function g(P) {
            (q.series || []).forEach(function(S) {
              S === P && (S.dataLabelCollections || ["dataLabel"]).forEach(function(u) {
                S.points.forEach(function(y) {
                  var s = y[String(u)];
                  s && s.visibility !== "hidden" && (s.prevOpacity = s.opacity, s.opacitySetter(0, "opacity", s.element), s.prevVisibility = s.visibility, s.visibilitySetter("hidden", "visibility", s.element));
                });
              });
            });
          }
          function x(P) {
            (q.series || []).forEach(function(S) {
              if (S === P) {
                (S.dataLabelCollections || ["dataLabel"]).forEach(function(s) {
                  S.points.forEach(function(a) {
                    var e = a[String(s)];
                    if (e && e.visibility === "hidden") {
                      var n = (0, ut.default)(e.prevOpacity) ? 1 : e.prevOpacity;
                      e.prevOpacity = e.opacity, e.opacitySetter(n, "opacity", e.element);
                      var o = (0, ut.default)(e.prevVisibility) ? "visible" : e.prevVisibility;
                      e.prevVisibility = e.visibility, e.visibilitySetter(o, "visibility", e.element);
                    }
                  });
                });
                var u = E(S), y = b(q);
                v([].concat(u, y), { totalsRank: Number.MIN_SAFE_INTEGER });
              }
            });
          }
          function E(P) {
            var S = [], u = P.options.dataLabels, y = P.dataLabelCollections || ["dataLabel", "dataLabelsGroup"];
            return u && (u.enabled || P._hasPointLabels) && !u.allowOverlap && P.visible && y.forEach(function(s) {
              P.points && P.points.forEach(function(a) {
                a[s] && (a[s].labelrank = G(a.labelrank, a.shapeArgs && a.shapeArgs.height), S.push(a[s]));
              });
            }), S;
          }
          (0, ut.default)(A) && (A = []), $ || (k.onmouseover = function() {
            if (Q.visible) {
              Y();
              var P = U && Q.series.halo;
              P && P.attr({ d: "M 0 0" }), A.forEach(function(S) {
                S !== Q && S.visible && (D.forEach(function(u) {
                  S[u] && S[u].animate({ opacity: 0.15 }, { duration: 400 });
                }), g(S));
              }), D.forEach(function(S) {
                Q[S] && Q[S].addClass(F);
              }), N || (_ = setTimeout(d, 100));
            }
          }, k.onmouseout = function() {
            Q.visible && (Y(), A.forEach(function(P) {
              P.visible && P !== Q && D.forEach(function(S) {
                P[S] && P[S].animate({ opacity: 1 }, { duration: 400 });
              });
            }), D.forEach(function(P) {
              Q[P] && Q[P].removeClass(F);
            }), N || (gt = setTimeout(m, 100)));
          }, k.addEventListener("click", function() {
            Y();
            var P = [];
            A.forEach(function(u) {
              u.visible ? (D.forEach(function(y) {
                u[y] && u[y].animate({ opacity: 1 }, { duration: 50 });
              }), P = P.concat(E(u))) : (D.forEach(function(y) {
                u[y] && u[y].animate({ opacity: 0.25 }, { duration: 150 });
              }), g(u));
            });
            var S = b(q);
            v(P = P.concat(S));
          }));
        });
      };
    }, 2372: (tt, st) => {
      Object.defineProperty(st, "__esModule", { value: !0 }), st.default = function(lt) {
        var ht = lt.defaultOptions, ut = ht.plotOptions, yt = { fillOpacity: 0.2, color: null, borderColor: null }, gt = { fillColor: null, lineColor: null, lineWidth: 2 };
        ht.plotOptions.column.states.select = yt, ht.plotOptions.area.states.select = yt, ht.plotOptions.bar.states.select = yt, ht.plotOptions.line.states.select = yt, ht.plotOptions.spline.states.select = yt, ht.plotOptions.scatter.marker = { enabled: !0, radius: 4, fillOpacity: 0.25, fillColor: null, lineColor: null, lineWidth: 1, states: { select: { fillOpacity: 0.85, fillColor: null, lineColor: null }, hover: { animation: { duration: 50 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 } } }, ht.plotOptions.series = { states: { select: yt } }, ut.area.marker.states.select = gt, ut.line.marker.states.select = gt, ut.spline.marker.states.select = gt, ut.bubble.marker.states.select = { fillOpacity: 0.25, fillColor: null, lineColor: null, lineWidth: 1 }, lt.timeUnits.month = 26784e5, lt.timeUnits.year = 31556952e3;
      };
    }, 1639: function(tt, st, lt) {
      var ht = this && this.__assign || function() {
        return ht = Object.assign || function(F) {
          for (var $, Y = 1, J = arguments.length; Y < J; Y++)
            for (var Q in $ = arguments[Y])
              Object.prototype.hasOwnProperty.call($, Q) && (F[Q] = $[Q]);
          return F;
        }, ht.apply(this, arguments);
      }, ut = this && this.__read || function(F, $) {
        var Y = typeof Symbol == "function" && F[Symbol.iterator];
        if (!Y)
          return F;
        var J, Q, q = Y.call(F), U = [];
        try {
          for (; ($ === void 0 || $-- > 0) && !(J = q.next()).done; )
            U.push(J.value);
        } catch (N) {
          Q = { error: N };
        } finally {
          try {
            J && !J.done && (Y = q.return) && Y.call(q);
          } finally {
            if (Q)
              throw Q.error;
          }
        }
        return U;
      }, yt = this && this.__spreadArray || function(F, $, Y) {
        if (Y || arguments.length === 2)
          for (var J, Q = 0, q = $.length; Q < q; Q++)
            !J && Q in $ || (J || (J = Array.prototype.slice.call($, 0, Q)), J[Q] = $[Q]);
        return F.concat(J || Array.prototype.slice.call($));
      }, gt = this && this.__importDefault || function(F) {
        return F && F.__esModule ? F : { default: F };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var _ = gt(lt(1857)), at = gt(lt(4891)), G = lt(2930);
      st.default = function(F) {
        var $ = F.removeEvent, Y = F.splat, J = F.isArray, Q = F.defaultOptions.plotOptions, q = F.fireEvent, U = F.color, N = F.extend, D = F.isNumber, k = F.merge, A = F.pick, b = F.Series, d = F.Point, m = navigator.userAgent, v = /(ipad|iphone|ipod)/g.test(m.toLowerCase()), g = document.documentElement.ontouchstart !== void 0, x = F.defaultOptions, E = "highcharts-", P = "hover";
        F.Axis.prototype.allowNegativeLog = !0, F.addEvent(F.Axis, "afterInit", function() {
          var S = this.logarithmic;
          S && (this.positiveValuesOnly = !1, S.log2lin = function(u) {
            var y = u < 0, s = Math.abs(u);
            s < 10 && (s += (10 - s) / 10);
            var a = Math.log(s) / Math.LN10;
            return y ? -a : a;
          }, S.lin2log = function(u) {
            var y = u < 0, s = Math.pow(10, Math.abs(u));
            return s < 10 && (s = 10 * (s - 1) / 9), y ? -s : s;
          });
        }), F.Series.prototype.setPercentStacks = function() {
          var S, u = this, y = u.stackKey, s = u.yAxis.stacking.stacks, a = new RegExp(/navigator.\d*/gi);
          S = u.name.match(a) ? u.chart.yAxis[1].options.max || 100 : u.chart.yAxis[u.options.yAxis || 0].options.max || 100, [y, "-" + y].forEach(function(e) {
            for (var n, o, i, c, l = u.xData.length; l--; )
              n = u.xData[l], (i = (o = s[e] && s[e][n]) && o.points[u.index]) && (c = o.total ? 100 / o.total : 0, i[0] = (0, G.correctFloat)(i[0] * c * ((0, G.defined)(S) ? S / 100 : 1)), i[1] = (0, G.correctFloat)(i[1] * c * ((0, G.defined)(S) ? S / 100 : 1)), u.stackedYData[l] = i[1]);
          });
        }, F.seriesTypes.area.prototype.getStackPoints = function(S) {
          var u = this, y = [], s = [], a = this.xAxis, e = this.yAxis, n = e.stacking.stacks[this.stackKey], o = {}, i = e.series, c = i.length, l = e.options.reversedStacks ? 1 : -1, h = i.indexOf(u);
          if (S = S || this.points, this.options.stacking) {
            for (var C = 0; C < S.length; C++)
              S[C].leftNull = S[C].rightNull = void 0, o[S[C].x] = S[C];
            F.objectEach(n, function(O, p) {
              O.total !== null && s.push(p);
            }), s.sort(function(O, p) {
              return O - p;
            });
            var M = i.map(function(O) {
              return O.visible;
            });
            s.forEach(function(O, p) {
              var w, T, z = 0;
              if (o[O] && !o[O].isNull)
                y.push(o[O]), [-1, 1].forEach(function(I) {
                  var j = I === 1 ? "rightNull" : "leftNull", Z = I === 1 ? "rightCliff" : "leftCliff", V = n[s[p + I]], X = 0;
                  if (V)
                    for (var et = h; et >= 0 && et < c; ) {
                      var ot = i[et].index;
                      (w = V.points[ot]) || (ot === u.index ? o[O][j] = !0 : M[et] && (T = n[O].points[ot]) && (X -= T[1] - T[0])), et += l;
                    }
                  o[O][Z] = X;
                });
              else {
                for (var W = h; W >= 0 && W < c; ) {
                  var L = i[W].index;
                  if (w = n[O].points[L]) {
                    z = w[1];
                    break;
                  }
                  W += l;
                }
                z = A(z, 0), z = e.translate(z, 0, 1, 0, 1), y.push({ isNull: !0, plotX: a.translate(O, 0, 0, 0, 1), x: O, plotY: z, yBottom: z, isDividerNull: o[O] && o[O].isDividerNull });
              }
            });
          }
          return y;
        }, F.seriesTypes.areaspline.prototype.getStackPoints = F.seriesTypes.area.prototype.getStackPoints, F.seriesTypes.area.prototype.getGraphPath = function(S) {
          var u, y, s, a = F.seriesTypes.line.prototype.getGraphPath, e = this.options, n = e.stacking, o = this.yAxis, i = [], c = [], l = this.index, h = o.stacking.stacks[this.stackKey], C = e.threshold, M = Math.round(o.getThreshold(e.threshold)), O = A(e.connectNulls, n === "percent"), p = function(ot, it, pt) {
            var mt, Ct, kt = S[ot], Lt = n && h[kt.x].points[l], Tt = kt[pt + "Null"] || 0, xt = kt[pt + "Cliff"] || 0, ct = !0;
            xt || Tt ? (mt = (Tt ? Lt[0] : Lt[1]) + xt, Ct = Lt[0] + xt, ct = !!Tt) : !n && S[it] && S[it].isNull && (mt = Ct = C), mt !== void 0 && (c.push({ plotX: u, plotY: mt === null ? M : o.getThreshold(mt), isNull: ct, isCliff: !0 }), i.push({ plotX: u, plotY: Ct === null ? M : o.getThreshold(Ct), doCurve: !1 }));
          };
          S = S || this.points, n && (S = this.getStackPoints(S));
          for (var w = 0, T = S.length; w < T; ++w)
            if (n || (S[w].leftCliff = S[w].rightCliff = S[w].leftNull = S[w].rightNull = void 0), y = S[w].isNull, u = A(S[w].rectPlotX, S[w].plotX), s = n ? A(S[w].yBottom, M) : M, !y || O) {
              var z = S[w - 1], W = S[w + 1], L = !S[w].isDividerNull && z && z.isDividerNull, I = !S[w].isDividerNull && W && W.isDividerNull;
              O && !L || p(w, w - 1, "left"), y && !n && O || (c.push(S[w]), i.push({ x: w, plotX: u, plotY: s })), O && !I || p(w, w + 1, "right");
            }
          var j = a.call(this, c, !0, !0);
          i.reversed = !0;
          var Z = a.call(this, i, !0, !0), V = Z[0];
          V && V[0] === "M" && (Z[0] = ["L", V[1], V[2]]);
          var X = j.concat(Z);
          X.length && X.push(["Z"]);
          var et = a.call(this, c, !1, O);
          return X.xMap = j.xMap, this.areaPath = X, et;
        }, F.seriesTypes.areaspline.prototype.getGraphPath = F.seriesTypes.area.prototype.getGraphPath, F.Series.prototype.pointAttribs = function(S, u) {
          var y, s, a, e, n, o, i = this.options.marker, c = S && S.options, l = c && c.marker || {}, h = this.color, C = c && c.color, M = S && S.color, O = A(l.lineWidth, i.lineWidth), p = S && S.zone && S.zone.color;
          return h = C || p || M || h, a = l.fillColor || i.fillColor || h, e = l.lineColor || i.lineColor || h, n = 1, o = 1, u && (y = i.states[u], s = l.states && l.states[u] || {}, O = A(s.lineWidth, y.lineWidth, O + A(s.lineWidthPlus, y.lineWidthPlus, 0)), a = s.fillColor || y.fillColor || a, e = s.lineColor || y.lineColor || e, n = s.fillOpacity || y.fillOpacity || 1, o = s.fillOpacity || y.fillOpacity || 1), { stroke: e, "stroke-width": O, "stroke-opacity": o, "fill-opacity": n, fill: a };
        }, F.Point.prototype.setState = function(S, u) {
          var y, s, a, e = this, n = Math.floor(e.plotX), o = e.plotY, i = e.series, c = i.options.states[S] || {}, l = Q[i.type].marker && i.options.marker, h = l && l.enabled === !1, C = l && l.states && l.states[S] || {}, M = C.enabled === !1, O = i.stateMarkerGraphic, p = e.marker || {}, w = i.chart, T = i.halo, z = l && i.markerAttribs;
          if (!((S = S || "") === e.state && !u || e.selected && S !== "select" || c.enabled === !1 || S && (M || h && C.enabled === !1) || S && p.states && p.states[S] && p.states[S].enabled === !1)) {
            if (z && (s = i.markerAttribs(e, S)), e.graphic) {
              e.state && e.graphic.removeClass("highcharts-point-" + e.state), S && e.graphic.addClass("highcharts-point-" + S);
              var W = e.innerBoxColor || i.color, L = { fill: W, "fill-opacity": 0.8, stroke: i.color, "stroke-opacity": 1, "stroke-width": 1 };
              if (e.selected) {
                var I = 0.3;
                L.fill = W, L["fill-opacity"] = I, L["stroke-opacity"] = I;
              }
              S === "hover" && (I = 0.9, L.fill = W, L["fill-opacity"] = I, L["stroke-opacity"] = I);
              var j = { fill: W, "fill-opacity": 1, stroke: U, "stroke-width": 1 }, Z = ht({}, L), V = i.pointAttribs(e, S);
              e.graphic.attr(V), e.stem && e.stem.attr({}), e.whiskers && e.whiskers.attr({}), e.box && (e.box.attr(Z), e.box.attr("stroke", Z.stroke), e.innerBox.attr(j)), e.medianShape && e.medianShape.attr({}), s && e.graphic.animate(s, A(w.options.chart.animation, C.animation, l.animation)), O && O.hide();
            } else
              S && C && (a = p.symbol || i.symbol, O && O.currentSymbol !== a && (O = O.destroy()), O ? O[u ? "animate" : "attr"]({ x: s.x, y: s.y }) : a && (i.stateMarkerGraphic = O = w.renderer.symbol(a, s.x, s.y, s.width, s.height).add(i.markerGroup), O.currentSymbol = a), O && O.attr(i.pointAttribs(e, S))), O && (O[S && w.isInsidePlot(n, o, w.inverted) ? "show" : "hide"](), O.element.point = e);
            (y = c.halo) && y.size ? (T || (i.halo = T = w.renderer.path().add((e.graphic || O).parentGroup)), T[u ? "animate" : "attr"]({ d: e.haloPath(y.size) }), T.attr({ class: "highcharts-halo highcharts-color-" + A(e.colorIndex, i.colorIndex) }), T.point = e, T.attr(N({ fill: e.color || i.color, "fill-opacity": y.opacity, zIndex: -1 }, y.attributes))) : T && T.point && T.point.haloPath && T.animate({ d: T.point.haloPath(0) }), e.state = S;
          }
        }, F.Point.prototype.applyOptions = function(S, u) {
          var y = this, s = y.series, a = s.options.pointValKey || s.pointValKey;
          return S = d.prototype.optionsToObject.call(this, S), N(y, S), y.options = y.options ? N(y.options, S) : S, S.group && delete y.group, a && (y.y = y[a]), y.isNull = A(y.isValid && !y.isValid(), y.x === null || y.y === null || !D(y.y, !0)), y.selected && (y.state = "select"), "name" in y && u === void 0 && s.xAxis && s.xAxis.hasNames && (y.x = s.xAxis.nameToX(y)), y.x === void 0 && s && (y.x = u === void 0 ? s.autoIncrement(y) : u), y;
        }, F.seriesTypes.column.prototype.pointAttribs = function(S, u) {
          var y, s, a, e, n, o = this.options, i = this.pointAttrToOptions || {}, c = i.stroke || "borderColor", l = i["stroke-width"] || "borderWidth", h = S && S.color || this.color, C = S[c] || o[c] || this.color || h, M = S[l] || o[l] || this[l] || 0, O = o.dashStyle;
          return S && this.zones.length && (h = (e = S.getZone()) && e.color || S.options.color || this.color), u && (n = (y = o.states[u]).brightness, s = y.fillOpacity, h = y.color || n !== void 0 && U(h).brighten(y.brightness).get() || h, s && s !== 1 && (h = U(h).setOpacity(s).get("rgba")), C = y[c] || C, M = y[l] || M, O = y.dashStyle || O), a = { fill: h, stroke: C, "stroke-width": M }, o.borderRadius && (a.r = o.borderRadius), O && (a.dashstyle = O), a;
        }, F.seriesTypes.scatter.prototype.pointAttribs = function(S, u) {
          var y = u ? this.options.marker.states[u] : this.options.marker, s = A(y.fillOpacity, 0.5), a = b.prototype.pointAttribs.call(this, S, u);
          return s !== 1 && (a.fill = U(a.fill).setOpacity(s).get("rgba")), a;
        }, F.seriesTypes.bubble.prototype.pointAttribs = function(S, u) {
          var y = u ? this.options.marker.states[u] : this.options.marker, s = A(y.fillOpacity, 0.5), a = b.prototype.pointAttribs.call(this, S, u);
          return s !== 1 && (a.fill = U(a.fill).setOpacity(s).get("rgba")), a;
        }, F.seriesTypes.boxplot.prototype.pointAttribs = function(S, u) {
          var y = u ? this.options.states[u] : this.options, s = A(y.fillOpacity, 0.5), a = S && S.color || this.color, e = S.fillColor || y.fillColor || a;
          return s !== 1 && (e = U(e).setOpacity(s).get("rgba")), { fill: e, stroke: y.lineColor || a, "stroke-width": y.lineWidth || 0 };
        }, F.Pointer.prototype.onContainerClick = function(S) {
          var u, y, s, a = this.chart, e = a.hoverPoint, n = a.plotLeft, o = a.plotTop, i = a.inverted, c = S.type;
          S = this.normalize(S), a.cancelClick || (e && this.inClass(S.target, E + "tracker") ? (u = this.chartPosition, y = e.plotX, s = e.plotY, N(e, { pageX: u.left + n + (i ? a.plotWidth - s : y), pageY: u.top + o + (i ? a.plotHeight - y : s) }), q(e.series, c, N(S, { point: e })), a.hoverPoint && e.firePointEvent(c, S)) : (N(S, this.getCoordinates(S)), a.isInsidePlot(S.chartX - n, S.chartY - o) && q(a, "click", S)));
        }, F.Pointer.prototype.onContainerTapHold = function(S) {
          var u, y, s, a = this.chart, e = a.hoverPoint, n = a.plotLeft, o = a.plotTop, i = a.inverted, c = "contextmenu";
          (S = this.normalize(S)).hasTapHold = !0, a.cancelClick || e && this.inClass(S.target, E + "tracker") && (u = this.chartPosition, y = e.plotX, s = e.plotY, N(e, { pageX: u.left + n + (i ? a.plotWidth - s : y), pageY: u.top + o + (i ? a.plotHeight - y : s) }), q(e.series, c, N(S, { point: e })), a.hoverPoint && (S.type = "taphold", S.point = e, S.target = a, e.firePointEvent(c, S)));
        }, F.Pointer.prototype.setDOMEvents = function() {
          var S, u = this, y = u.chart.container;
          this.unbindContainerMouseLeave = function() {
          }, this._events = S = [[y, "onmousedown", "onContainerMouseDown"], [y, "onmousemove", "onContainerMouseMove"], [y, "onclick", "onContainerClick"], [y, "mouseleave", "onContainerMouseLeave"], [y, "contextmenu", "onContainerClick"], [y, "mousemove", "onDocumentMouseMove"], [y, "mouseup", "onDocumentMouseUp"]], g && v && S.push([y, "taphold", "onContainerClick"]), g && S.push([y, "ontouchmove", "onContainerTouchMove"], [y, "ontouchstart", "onContainerTouchStart"], [y, "taphold", "onContainerTapHold"], [document, "touchend", "onDocumentTouchEnd"]), S.forEach(function(s) {
            var a = ut(s, 3), e = a[0], n = a[1], o = a[2];
            u["_" + o] = function(i) {
              typeof u[s[2]] == "function" && u[s[2]](i);
            }, n.indexOf("on") === 0 ? e[n] = u["_" + o] : e.addEventListener(n, u["_" + o]);
          });
        }, F.Navigator.prototype.updateNavigatorSeries = function(S, u) {
          var y, s, a, e = this, n = e.chart, o = e.baseSeries, i = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: "navigator-x-axis", yAxis: "navigator-y-axis", showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } }, visible: !0 }, c = e.series = (e.series || []).filter(function(h) {
            var C = h.baseSeries;
            return !(o.indexOf(C) < 0 && (C && ($(C, "updatedData", e.updatedDataHandler), delete C.navigatorSeries), h.chart && h.destroy(), 1));
          }), l = e.navigatorOptions.series;
          o && o.length && o.forEach(function(h) {
            var C, M = h.navigatorSeries, O = N({ color: h.color, visible: h.visible }, J(l) ? x.navigator.series : l);
            if (!M || e.navigatorOptions.adaptToUpdatedData !== !1) {
              i.name = "Navigator " + o.length, (y = h.options || {}).navigatorOptions = ht(ht({}, y.navigatorOptions), { marker: ht(ht({}, (C = y.navigatorOptions) === null || C === void 0 ? void 0 : C.marker), { radius: 0 }) }), a = y.navigatorOptions || {}, O.dataLabels = Y(O.dataLabels), (s = k(y, i, O, a)).pointRange = A(O.pointRange, a.pointRange, x.plotOptions[s.type || "line"].pointRange);
              var p = a.data || O.data;
              e.hasNavigatorData = e.hasNavigatorData || !!p, s.data = p || y.data && y.data.slice(0), s.color = y.color, s.fillOpacity = y.fillOpacity, s.type !== "spline" && s.type !== "areaspline" || (s.stacking = y.stacking), y.stacking !== "percent" && y.stacking !== "normal" || (s.stacking = y.stacking, s.startFromThreshold = !1), M && M.options ? M.update(s, u) : (h.navigatorSeries = n.initSeries(s), h.navigatorSeries.baseSeries = h, c.push(h.navigatorSeries));
            }
          }), (!l.data || o && o.length) && !J(l) || (e.hasNavigatorData = !1, (l = Y(l)).forEach(function(h, C) {
            i.name = "Navigator " + (c.length + 1), (s = k(x.navigator.series, { color: n.series[C] && !n.series[C].options.isInternal && n.series[C].color || n.options.colors[C] || n.options.colors[0] }, i, h)).data = h.data, s.data && (e.hasNavigatorData = !0, c.push(n.initSeries(s)));
          })), S && this.addBaseSeriesEvents();
        }, F.seriesTypes.scatter.prototype.drawLegendSymbol = F.seriesTypes.column.prototype.drawLegendSymbol, (0, G.wrap)(F.Pointer.prototype, "runPointActions", function(S, u, y) {
          var s, a = u, e = this.chart;
          S.call(this, u, y);
          var n = e.hoverPoint, o = e.hoverSeries;
          if (a && e.hoverPoint && (l = a.touches ? a.touches.length && a.touches.item ? a.touches.item(0) : a.changedTouches ? a.changedTouches[0] : a : a) && l.clientX && l.clientY) {
            for (var i = document.elementFromPoint(l.clientX, l.clientY); i && !s; )
              s = i.point, i = i.parentNode;
            s && e.hoverPoint != s && s.onMouseOver(a);
          }
          (0, G.defined)(n) || (0, G.defined)(o) || (0, _.default)(e, "sisenseTipper.status") !== "on" || !e.sisenseTipper.tipper || (e.sisenseTipper.tipper.deactivate(), (0, at.default)(e, "sisenseTipper.status", "off"));
          var c = (0, _.default)(e, "sisenseTipper.chartType");
          if ((0, _.default)(e, "sisenseTipper.status") !== "off" && (0, _.default)(e, "sisenseTipper.tipper") && (c === "pie" || c === "scatter" || c === "bubble" || a.type === "touchmove")) {
            var l = a.touches ? a.touches.length && a.touches.item ? a.touches.item(0) : a.changedTouches ? a.changedTouches[0] : a : a;
            e.sisenseTipper.tipper.activate({ x: l.clientX, y: l.clientY, space: 0 });
          }
        }), (0, G.wrap)(F.Chart.prototype, "getContainer", function(S, u, y) {
          S.call(this, u, y);
          var s, a = this;
          a.renderTo = s = a.container.parentElement, s.setAttribute("data-type", (0, _.default)(a, "options.chart.type"));
        }), (0, G.wrap)(F.Chart.prototype, "setChartSize", function(S) {
          var u, y, s, a, e = this.legend, n = this.navigator;
          if (S.apply(this, [].slice.call(arguments, 1)), n) {
            if (y = e && e.options, s = n.xAxis, a = n.yAxis, u = n.scrollbarHeight, this.inverted) {
              var o = n.opposite ? this.chartWidth - u - n.height : this.spacing[3] + u, i = this.plotTop + u;
              y.align === "left" && e.legendWidth && (o += e.legendWidth), n.left = n.navigatorOptions.left || o, n.top = n.navigatorOptions.top || i;
            }
            s && a && (this.inverted ? s.options.left = a.options.left = n.left : s.options.top = a.options.top = n.top, s.setAxisSize(), a.setAxisSize());
          }
        }), (0, G.wrap)(F.Chart.prototype, "renderLabels", function(S) {
          var u, y, s, a = this;
          if (S.apply(this, [].slice.call(arguments, 1)), a && a.polar && a.userOptions && ((u = a.userOptions) === null || u === void 0 ? void 0 : u.labels) && ((s = (y = a.userOptions.labels) === null || y === void 0 ? void 0 : y.items) === null || s === void 0 ? void 0 : s.length)) {
            var e = 20, n = 20, o = void 0, i = a.userOptions.labels.items[0].html, c = yt([], ut(a.container.querySelectorAll("text")), !1).find(function(w) {
              return w.innerHTML.includes(i);
            }), l = a.containerWidth, h = c.clientWidth, C = c.getBBox(), M = C.height ? C.height : n, O = l / 2 - h / 2, p = void 0;
            a.legend.options.verticalAlign === "top" ? (o = a.legend.legendHeight + e + M) > a.plotTop && (p = e + M, o = a.legend.legendHeight + p / 2 + e / 2, a.legend.update({ margin: p }, !0)) : (o = n) > a.plotTop && (p = e + M, o = e / 2 + M, a.update({ chart: { marginTop: p } }, !0)), c.setAttribute("x", O), c.setAttribute("y", o);
          }
        }), F.wrap(F.SVGElement.prototype, "titleSetter", function(S, u) {
          var y, s, a = this.element.getElementsByTagName("title")[0];
          a || (a = document.createElementNS(this.SVG_NS, "title"), this.element.appendChild(a)), a.firstChild && a.removeChild(a.firstChild), a.appendChild(document.createTextNode((y = this.renderer.escapes, s = u, F.objectEach(y, function(e, n) {
            s = s.replace(new RegExp(e, "g"), n);
          }), s)));
        }), (0, G.wrap)(F.Chart.prototype, "renderLabels", function(S) {
          var u = this;
          S.apply(this, [].slice.call(arguments, 1)), u.chartBackground.addClass("widget-body");
        }), (0, G.wrap)(F.Legend.prototype, "renderItem", function(S, u) {
          var y = this, s = y.options, a = u.legendItem, e = !u.series, n = !e && u.series.drawLegendSymbol ? u.series : u, o = s.useHTML;
          S.apply(this, [].slice.call(arguments, 1)), /msie|trident/i.exec(navigator.userAgent) && u.legendItem.group.element.addEventListener("contextmenu", function(i) {
            var c = "legendItemClick", l = { eventType: "contextmenu", browserEvent: i };
            return u.firePointEvent ? u.firePointEvent(c, l, null) : q(n, c, l, null), !1;
          }), (o ? a : u.legendItem.group).on("mouseover", function() {
            var i;
            u.setState(P), a && ((i = a.css) === null || i === void 0 || i.call(a, y.options.itemHoverStyle));
          }).on("contextmenu", function(i) {
            var c = "legendItemClick", l = { eventType: "contextmenu", browserEvent: i };
            return u.firePointEvent ? u.firePointEvent(c, l, null) : q(n, c, l, null), !1;
          });
        }), (0, G.wrap)(F.StackItem.prototype, "render", function(S) {
          var u = this.options, y = (0, _.default)(this, "axis.chart.options.chart.type"), s = 5;
          if (this.alignOptions && this.total !== void 0 && (y === "column" || y === "bar" && Math.abs(u.rotation) === 90) && (this.alignOptions.y = this.alignOptions.x = 0), S.apply(this, [].slice.call(arguments, 1)), this.total !== void 0) {
            var a = this.label.getBBox(!0, 0), e = this.label.getBBox(), n = -Math.sign(this.total), o = 0, i = 0;
            if (y === "column" ? (this.total < 0 || Math.abs(u.rotation) === 90 ? o = e.height / 2 * n : Math.abs(u.rotation) === 45 && this.total > 0 && (o = -a.width / 2 * Math.sin(45 * Math.PI / 180)), Math.abs(u.rotation) === 45 && (i += -e.width / 4 * n), Math.abs(u.rotation) === 90 && (i += a.height / 4), o += s * n) : y === "bar" && Math.abs(u.rotation) === 90 && (o = -e.height / 2 * n, this.total >= 0 && (i += a.height / 2), i += -s * n), this.label.translate(i, o), this.label && !this.label.labelrank) {
              var c = this.total === 0 ? Number.MIN_SAFE_INTEGER : 0;
              this.label.labelrank = this.x + u.labelrank + c;
            }
          }
        }), F.wrap(F, "fireEvent", function(S, u, y, s) {
          var a = new Event(y), e = (0, _.default)(s, "changedTouches"), n = (0, _.default)(s, "point.graphic.element");
          N(a, s), e && (a.clientX = (0, _.default)(e, "0.clientX"), a.clientY = (0, _.default)(e, "0.clientY"), a.target = n), S.apply(this, [].slice.call(arguments, 1));
        }), (0, G.wrap)(F.Point.prototype, "getLabelConfig", function(S) {
          var u = S.apply(this, [].slice.call(arguments, 1));
          return this.originalY && (u.y = this.originalY), u;
        }), (0, G.wrap)(F.seriesTypes.column.prototype, "alignDataLabel", function(S, u, y, s) {
          var a = u.series.options.stacking, e = this.chart.inverted, n = s.rotation, o = u.y < 0 && u.dataLabel, i = u.dlBox, c = u.dataLabel.getBBox();
          if (!a && o) {
            u.below = !0;
            var l = k(u.dlBox || u.shapeArgs), h = e ? c.width : c.height;
            l.y += h, u.dlBox = l;
          } else
            a && (s.align = "center");
          !a && n && (c = u.dataLabel.getBBox(), e ? s.x += 0.5 * c.width : o && Math.abs(n) % 360 == 45 && (s.x = 0.5 * -c.width));
          var C = S.apply(this, [].slice.call(arguments, 1));
          return u.dlBox = i, C;
        }), F.Scroller = F.Navigator;
      };
    }, 9984: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(_) {
        return _ && _.__esModule ? _ : { default: _ };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(1857)), yt = lt(2930), gt = ht(lt(4052));
      st.default = function(_) {
        var at = _.wrap;
        at(_.seriesTypes.pie.prototype, "drawDataLabels", function(G, F, $) {
          var Y, J = this, Q = J.chart.renderer;
          G.call(this, F, $);
          var q = function(D) {
            var k, A, b, d, m, v, g, x, E, P, S, u, y, s, a, e, n, o, i, c, l = (0, ut.default)(D, "shapeArgs.x") + D.series.chart.plotBox.x, h = (0, ut.default)(D, "shapeArgs.y") + D.series.chart.plotBox.y, C = (0, ut.default)(D, "shapeArgs.innerR"), M = (0, ut.default)(D, "shapeArgs.r") - C, O = {}, p = D.shapeArgs;
            b = p.r * Math.sin(p.start + 1.571) + l, d = p.r * Math.cos(p.start + 1.571) * -1 + h, S = b - (k = p.r * Math.sin((p.end + 1.571 + p.start + 1.571) / 2) + l), u = d - (A = p.r * Math.cos((p.end + 1.571 + p.start + 1.571) / 2) * -1 + h), P = h - d, (E = l - b) == 0 ? (g = 1, x = 0, s = 1) : (g = P / E, x = 1, s = Math.sqrt(Math.pow(g, 2) + Math.pow(x, 2)), p.start + 1.571 > Math.PI ? x *= -1 : g *= -1), m = l - k, a = (E * u / P - S) / (E * (v = h - A) / (P * (y = Math.sqrt(Math.pow(m, 2) + Math.pow(v, 2)))) - E * x / (P * s) + g / s - m / y), e = k + m / y * Math.abs(a), n = A + v / y * Math.abs(a), o = Math.sqrt(Math.pow(e - k, 2) + Math.pow(n - A, 2));
            var w = p.end - p.start, T = Math.round((0, yt.radiansToDegrees)(w)), z = (0, yt.radiansToDegrees)(Math.PI);
            return (2 * o > M || T >= z) && (e = k + m / y * (o = M / 2), n = A + v / y * o), c = (0, ut.default)(D, "series.chart.options.plotOptions.pie.dataLabels.showDecimals") === !0 ? D.percentage.toFixed(1).replace(".0", "") : Math.round(D.percentage), (0, yt.defined)(O[c]) ? i = O[c] : (i = o / 1.5, O[c] = i), { fontSize: i, slicePercentage: c, newCenterX: e, newCenterY: n, circleCenterX: l, circleCenterY: h };
          }, U = function(D, k, A, b) {
            var d = Q.text(k.slicePercentage + "%", k.newCenterX, k.newCenterY), m = { class: "pie-percent-label", zIndex: 13, "text-anchor": "middle", "font-size": k.fontSize }, v = { "pointer-events": "none", "font-family": (0, ut.default)(b, "options.dataLabels.style.fontFamily", gt.default.fontFamily), "letter-spacing": "-0.05em", color: "white", fontSize: !1 }, g = d.attr(m).attr(A).add(), x = d.element.getBBox().height / 4, E = { x: k.newCenterX, y: k.newCenterY + x };
            D.sisenseLabel = g.css(v).attr(E).add();
          }, N = (0, ut.default)(J, "chart.options.chart.isHighlightMode");
          J.points.forEach(function(D) {
            var k, A;
            if (D.graphic) {
              if ((0, ut.default)(D, "series.chart.options.plotOptions.pie.dataLabels.showPercentLabels") === !0)
                if (k = q(D), A = (0, ut.default)(D, "series.chart.options.plotOptions.pie.dataLabels.pieMinimumFontSizeToTextLabel"), k.fontSize > A)
                  if ((0, yt.defined)((0, ut.default)(D, "sisenseLabel.element"))) {
                    var b = { x: k.newCenterX, y: k.newCenterY };
                    N && (b.translateX = D.sliced ? D.slicedTranslation.translateX : 0, b.translateY = D.sliced ? D.slicedTranslation.translateY : 0), D.sisenseLabel.attr({ text: k.slicePercentage + "%", "font-size": k.fontSize }).animate(b);
                  } else
                    U(D, k, Y, J), D.sisenseLabel && N && ((b = { x: k.newCenterX, y: k.newCenterY }).translateX = D.sliced ? D.slicedTranslation.translateX : 0, b.translateY = D.sliced ? D.slicedTranslation.translateY : 0, D.sisenseLabel.attr({ text: k.slicePercentage + "%", "font-size": k.fontSize }).attr(b));
                else
                  (0, yt.defined)((0, ut.default)(D, "sisenseLabel.element")) && D.sisenseLabel.destroy();
            } else
              (0, ut.default)(D, "series.chart.options.plotOptions.pie.dataLabels.showPercentLabels") === !0 && (k = q(D), A = (0, ut.default)(D, "series.chart.options.plotOptions.pie.dataLabels.pieMinimumFontSizeToTextLabel"), k.fontSize > A && U(D, k, Y, J));
          });
        }), at(_.Point.prototype, "destroyElements", function(G, F, $) {
          for (var Y, J = this, Q = ["decoration", "sisenseLabel"], q = Q.length; q--; )
            J[Y = Q[q]] && J.visible && J[Y].renderer && J[Y].destroy();
          G.call(this, F, $);
        }), at(_.seriesTypes.pie.prototype.pointClass.prototype, "slice", function(G) {
          var F = this;
          G.apply(this, [].slice.call(arguments, 1)), (0, ut.default)(F, "sisenseLabel.renderer") && F.sisenseLabel.animate(this.getTranslate());
        }), _.seriesTypes.pie.prototype.placeDataLabels = function() {
          this.points.forEach(function(G) {
            var F, $ = G.dataLabel;
            $ && G.visible && ((F = $._pos) ? ($.sideOverflow && ($._attr.width = $.getBBox().width - $.sideOverflow, $.css({ width: $._attr.width + "px", textOverflow: "ellipsis" }), $.shortened = !0), $.attr($._attr), $[$.moved ? "animate" : "attr"](F), $.moved = !0) : $ && $.attr({ y: -9999 }));
          }, this);
        }, _.Point.prototype.getClassName = function() {
          return "highcharts-point" + (this.selected || this.sliced ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        };
      };
    }, 7155: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(A) {
        return A && A.__esModule ? A : { default: A };
      };
      Object.defineProperty(st, "__esModule", { value: !0 });
      var ut = ht(lt(3491)), yt = ht(lt(3805)), gt = ht(lt(7274)), _ = ht(lt(8291)), at = ht(lt(7330)), G = ht(lt(8693)), F = ht(lt(7922)), $ = ht(lt(1548)), Y = ht(lt(3968)), J = ht(lt(8040)), Q = ht(lt(4389)), q = ht(lt(2372)), U = ht(lt(9984)), N = ht(lt(9639)), D = ht(lt(1639)), k = ht(lt(548));
      (0, gt.default)(ut.default), (0, yt.default)(ut.default), (0, _.default)(ut.default), (0, at.default)(ut.default), (0, G.default)(ut.default), (0, F.default)(ut.default), (0, $.default)(ut.default), (0, Y.default)(ut.default), (0, q.default)(ut.default), (0, U.default)(ut.default), (0, N.default)(ut.default), (0, D.default)(ut.default), (0, J.default)(ut.default), (0, Q.default)(ut.default), ut.default.setOptions(k.default), st.default = ut.default;
    }, 2930: function(tt, st, lt) {
      var ht = this && this.__importDefault || function(yt) {
        return yt && yt.__esModule ? yt : { default: yt };
      };
      Object.defineProperty(st, "__esModule", { value: !0 }), st.arrayMax = st.arrayMin = st.correctFloat = st.radiansToDegrees = st.defined = st.wrap = void 0;
      var ut = ht(lt(1857));
      st.wrap = function(yt, gt, _) {
        var at = yt[gt];
        yt[gt] = function() {
          var G = Array.prototype.slice.call(arguments);
          return G.unshift(at), _.apply(this, G);
        };
      }, st.defined = function(yt, gt) {
        return gt === void 0 || gt === "null" || gt === "" ? yt != null : (0, ut.default)(yt, gt) !== void 0;
      }, st.radiansToDegrees = function(yt) {
        return 180 * yt / Math.PI;
      }, st.correctFloat = function(yt) {
        return parseFloat(yt.toPrecision(14));
      }, st.arrayMin = function(yt) {
        for (var gt = yt.length, _ = yt[0]; gt--; )
          yt[gt] < _ && (_ = yt[gt]);
        return _;
      }, st.arrayMax = function(yt) {
        for (var gt = yt.length, _ = yt[0]; gt--; )
          yt[gt] > _ && (_ = yt[gt]);
        return _;
      };
    }, 3805: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Core/Math3D.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.deg2rad, Y = F.pick;
          function J(U, N, D, k) {
            var A = N.options.chart.options3d, b = Y(k, !!D && N.inverted), d = { x: N.plotWidth / 2, y: N.plotHeight / 2, z: A.depth / 2, vd: Y(A.depth, 1) * Y(A.viewDistance, 0) }, m = N.scale3d || 1, v = $ * A.beta * (b ? -1 : 1), g = $ * A.alpha * (b ? -1 : 1), x = { cosA: Math.cos(g), cosB: Math.cos(-v), sinA: Math.sin(g), sinB: Math.sin(-v) };
            return D || (d.x += N.plotLeft, d.y += N.plotTop), U.map(function(E) {
              var P = function(u, y, s, a) {
                return { x: a.cosB * u - a.sinB * s, y: -a.sinA * a.sinB * u + a.cosA * y - a.cosB * a.sinA * s, z: a.cosA * a.sinB * u + a.sinA * y + a.cosA * a.cosB * s };
              }((b ? E.y : E.x) - d.x, (b ? E.x : E.y) - d.y, (E.z || 0) - d.z, x), S = Q(P, d, d.vd);
              return S.x = S.x * m + d.x, S.y = S.y * m + d.y, S.z = P.z * m + d.z, { x: b ? S.y : S.x, y: b ? S.x : S.y, z: S.z };
            });
          }
          function Q(U, N, D) {
            var k = D > 0 && D < Number.POSITIVE_INFINITY ? D / (U.z + N.z + D) : 1;
            return { x: U.x * k, y: U.y * k };
          }
          function q(U) {
            var N, D, k = 0;
            for (N = 0; N < U.length; N++)
              D = (N + 1) % U.length, k += U[N].x * U[D].y - U[D].x * U[N].y;
            return k / 2;
          }
          return { perspective: J, perspective3D: Q, pointCameraDistance: function(U, N) {
            var D = N.options.chart.options3d, k = N.plotWidth / 2, A = N.plotHeight / 2, b = Y(D.depth, 1) * Y(D.viewDistance, 0) + D.depth;
            return Math.sqrt(Math.pow(k - Y(U.plotX, U.x), 2) + Math.pow(A - Y(U.plotY, U.y), 2) + Math.pow(b - Y(U.plotZ, U.z), 2));
          }, shapeArea: q, shapeArea3D: function(U, N, D) {
            return q(J(U, N, D));
          } };
        }), at(_, "Core/Renderer/SVG/SVGElement3D.js", [_["Core/Color/Color.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.parse, J = $.defined, Q = $.merge, q = $.objectEach, U = $.pick, N = {};
          return N.base = { initArgs: function(D) {
            var k = this, A = k.renderer, b = A[k.pathType + "Path"](D), d = b.zIndexes;
            k.parts.forEach(function(m) {
              var v = { class: "highcharts-3d-" + m, zIndex: d[m] || 0 };
              A.styledMode && (m === "top" ? v.filter = "url(#highcharts-brighter)" : m === "side" && (v.filter = "url(#highcharts-darker)")), k[m] = A.path(b[m]).attr(v).add(k);
            }), k.attr({ "stroke-linejoin": "round", zIndex: d.group }), k.originalDestroy = k.destroy, k.destroy = k.destroyParts, k.forcedSides = b.forcedSides;
          }, singleSetterForParts: function(D, k, A, b, d, m) {
            var v = {}, g = [null, null, b || "attr", d, m], x = A && A.zIndexes;
            return A ? (x && x.group && this.attr({ zIndex: x.group }), q(A, function(E, P) {
              v[P] = {}, v[P][D] = E, x && (v[P].zIndex = A.zIndexes[P] || 0);
            }), g[1] = v) : (v[D] = k, g[0] = v), this.processParts.apply(this, g);
          }, processParts: function(D, k, A, b, d) {
            var m = this;
            return m.parts.forEach(function(v) {
              k && (D = U(k[v], !1)), D !== !1 && m[v][A](D, b, d);
            }), m;
          }, destroyParts: function() {
            return this.processParts(null, null, "destroy"), this.originalDestroy();
          } }, N.cuboid = Q(N.base, { parts: ["front", "top", "side"], pathType: "cuboid", attr: function(D, k, A, b) {
            if (typeof D == "string" && k !== void 0) {
              var d = D;
              (D = {})[d] = k;
            }
            return D.shapeArgs || J(D.x) ? this.singleSetterForParts("d", null, this.renderer[this.pathType + "Path"](D.shapeArgs || D)) : F.prototype.attr.call(this, D, void 0, A, b);
          }, animate: function(D, k, A) {
            if (J(D.x) && J(D.y)) {
              var b = this.renderer[this.pathType + "Path"](D), d = b.forcedSides;
              this.singleSetterForParts("d", null, b, "animate", k, A), this.attr({ zIndex: b.zIndexes.group }), d !== this.forcedSides && (this.forcedSides = d, this.renderer.styledMode || N.cuboid.fillSetter.call(this, this.fill));
            } else
              F.prototype.animate.call(this, D, k, A);
            return this;
          }, fillSetter: function(D) {
            var k = this;
            return k.forcedSides = k.forcedSides || [], k.singleSetterForParts("fill", null, { front: D, top: Y(D).brighten(k.forcedSides.indexOf("top") >= 0 ? 0 : 0.1).get(), side: Y(D).brighten(k.forcedSides.indexOf("side") >= 0 ? 0 : -0.1).get() }), k.color = k.fill = D, k;
          } }), N;
        }), at(_, "Core/Renderer/SVG/SVGRenderer3D.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Math3D.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Renderer/SVG/SVGElement3D.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N, D = this && this.__extends || (N = function(e, n) {
            return N = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, i) {
              o.__proto__ = i;
            } || function(o, i) {
              for (var c in i)
                i.hasOwnProperty(c) && (o[c] = i[c]);
            }, N(e, n);
          }, function(e, n) {
            function o() {
              this.constructor = e;
            }
            N(e, n), e.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
          }), k = G.animObject, A = F.parse, b = $.charts, d = $.deg2rad, m = Y.perspective, v = Y.shapeArea, g = U.defined, x = U.extend, E = U.merge, P = U.pick, S = Math.cos, u = Math.sin, y = Math.PI, s = 4 * (Math.sqrt(2) - 1) / 3 / (y / 2), a = function(e) {
            function n() {
              return e !== null && e.apply(this, arguments) || this;
            }
            return D(n, e), n.compose = function(o) {
              var i = o.prototype, c = n.prototype;
              i.elements3d = Q, i.arc3d = c.arc3d, i.arc3dPath = c.arc3dPath, i.cuboid = c.cuboid, i.cuboidPath = c.cuboidPath, i.element3d = c.element3d, i.face3d = c.face3d, i.polyhedron = c.polyhedron, i.toLinePath = c.toLinePath, i.toLineSegments = c.toLineSegments;
            }, n.curveTo = function(o, i, c, l, h, C, M, O) {
              var p = [], w = C - h;
              return C > h && C - h > Math.PI / 2 + 1e-4 ? p = (p = p.concat(this.curveTo(o, i, c, l, h, h + Math.PI / 2, M, O))).concat(this.curveTo(o, i, c, l, h + Math.PI / 2, C, M, O)) : C < h && h - C > Math.PI / 2 + 1e-4 ? p = (p = p.concat(this.curveTo(o, i, c, l, h, h - Math.PI / 2, M, O))).concat(this.curveTo(o, i, c, l, h - Math.PI / 2, C, M, O)) : [["C", o + c * Math.cos(h) - c * s * w * Math.sin(h) + M, i + l * Math.sin(h) + l * s * w * Math.cos(h) + O, o + c * Math.cos(C) + c * s * w * Math.sin(C) + M, i + l * Math.sin(C) - l * s * w * Math.cos(C) + O, o + c * Math.cos(C) + M, i + l * Math.sin(C) + O]];
            }, n.prototype.toLinePath = function(o, i) {
              var c = [];
              return o.forEach(function(l) {
                c.push(["L", l.x, l.y]);
              }), o.length && (c[0][0] = "M", i && c.push(["Z"])), c;
            }, n.prototype.toLineSegments = function(o) {
              var i = [], c = !0;
              return o.forEach(function(l) {
                i.push(c ? ["M", l.x, l.y] : ["L", l.x, l.y]), c = !c;
              }), i;
            }, n.prototype.face3d = function(o) {
              var i = this, c = this.createElement("path");
              return c.vertexes = [], c.insidePlotArea = !1, c.enabled = !0, c.attr = function(l) {
                if (typeof l == "object" && (g(l.enabled) || g(l.vertexes) || g(l.insidePlotArea))) {
                  this.enabled = P(l.enabled, this.enabled), this.vertexes = P(l.vertexes, this.vertexes), this.insidePlotArea = P(l.insidePlotArea, this.insidePlotArea), delete l.enabled, delete l.vertexes, delete l.insidePlotArea;
                  var h = b[i.chartIndex], C = m(this.vertexes, h, this.insidePlotArea), M = i.toLinePath(C, !0), O = v(C);
                  l.d = M, l.visibility = this.enabled && O > 0 ? "inherit" : "hidden";
                }
                return J.prototype.attr.apply(this, arguments);
              }, c.animate = function(l) {
                if (typeof l == "object" && (g(l.enabled) || g(l.vertexes) || g(l.insidePlotArea))) {
                  this.enabled = P(l.enabled, this.enabled), this.vertexes = P(l.vertexes, this.vertexes), this.insidePlotArea = P(l.insidePlotArea, this.insidePlotArea), delete l.enabled, delete l.vertexes, delete l.insidePlotArea;
                  var h = b[i.chartIndex], C = m(this.vertexes, h, this.insidePlotArea), M = i.toLinePath(C, !0), O = v(C), p = this.enabled && O > 0 ? "visible" : "hidden";
                  l.d = M, this.attr("visibility", p);
                }
                return J.prototype.animate.apply(this, arguments);
              }, c.attr(o);
            }, n.prototype.polyhedron = function(o) {
              var i = this, c = this.g(), l = c.destroy;
              return this.styledMode || c.attr({ "stroke-linejoin": "round" }), c.faces = [], c.destroy = function() {
                for (var h = 0; h < c.faces.length; h++)
                  c.faces[h].destroy();
                return l.call(this);
              }, c.attr = function(h, C, M, O) {
                if (typeof h == "object" && g(h.faces)) {
                  for (; c.faces.length > h.faces.length; )
                    c.faces.pop().destroy();
                  for (; c.faces.length < h.faces.length; )
                    c.faces.push(i.face3d().add(c));
                  for (var p = 0; p < h.faces.length; p++)
                    i.styledMode && delete h.faces[p].fill, c.faces[p].attr(h.faces[p], null, M, O);
                  delete h.faces;
                }
                return J.prototype.attr.apply(this, arguments);
              }, c.animate = function(h, C, M) {
                if (h && h.faces) {
                  for (; c.faces.length > h.faces.length; )
                    c.faces.pop().destroy();
                  for (; c.faces.length < h.faces.length; )
                    c.faces.push(i.face3d().add(c));
                  for (var O = 0; O < h.faces.length; O++)
                    c.faces[O].animate(h.faces[O], C, M);
                  delete h.faces;
                }
                return J.prototype.animate.apply(this, arguments);
              }, c.attr(o);
            }, n.prototype.element3d = function(o, i) {
              var c = this.g();
              return x(c, this.elements3d[o]), c.initArgs(i), c;
            }, n.prototype.cuboid = function(o) {
              return this.element3d("cuboid", o);
            }, n.prototype.cuboidPath = function(o) {
              var i, c, l, h, C, M, O, p, w = o.x || 0, T = o.y || 0, z = o.z || 0, W = o.height || 0, L = o.width || 0, I = o.depth || 0, j = b[this.chartIndex], Z = j.options.chart.options3d.alpha, V = 1e6, X = 0, et = [{ x: w, y: T, z }, { x: w + L, y: T, z }, { x: w + L, y: T + W, z }, { x: w, y: T + W, z }, { x: w, y: T + W, z: z + I }, { x: w + L, y: T + W, z: z + I }, { x: w + L, y: T, z: z + I }, { x: w, y: T, z: z + I }], ot = [];
              function it(mt) {
                return W === 0 && mt > 1 && mt < 6 ? { x: et[mt].x, y: et[mt].y + 10, z: et[mt].z } : et[0].x === et[7].x && mt >= 4 ? { x: et[mt].x + 10, y: et[mt].y, z: et[mt].z } : I === 0 && mt < 2 || mt > 5 ? { x: et[mt].x, y: et[mt].y, z: et[mt].z + 10 } : et[mt];
              }
              function pt(mt) {
                return et[mt];
              }
              return et = m(et, j, o.insidePlotArea), c = (i = (p = function(mt, Ct, kt) {
                var Lt = [[], -1], Tt = mt.map(pt), xt = Ct.map(pt), ct = mt.map(it), ft = Ct.map(it);
                return v(Tt) < 0 ? Lt = [Tt, 0] : v(xt) < 0 ? Lt = [xt, 1] : kt && (ot.push(kt), Lt = v(ct) < 0 ? [Tt, 0] : v(ft) < 0 ? [xt, 1] : [Tt, 0]), Lt;
              })([3, 2, 1, 0], [7, 6, 5, 4], "front"))[0], C = i[1], l = (i = p([1, 6, 7, 0], [4, 5, 2, 3], "top"))[0], M = i[1], h = (i = p([1, 2, 5, 6], [0, 7, 4, 3], "side"))[0], (O = i[1]) === 1 ? X += V * (j.plotWidth - w) : O || (X += V * w), X += 10 * (!M || Z >= 0 && Z <= 180 || Z < 360 && Z > 357.5 ? j.plotHeight - T : 10 + T), C === 1 ? X += 100 * z : C || (X += 100 * (1e3 - z)), { front: this.toLinePath(c, !0), top: this.toLinePath(l, !0), side: this.toLinePath(h, !0), zIndexes: { group: Math.round(X) }, forcedSides: ot, isFront: C, isTop: M };
            }, n.prototype.arc3d = function(o) {
              var i = this.g(), c = i.renderer, l = ["x", "y", "r", "innerR", "start", "end", "depth"];
              function h(C) {
                var M, O = !1, p = {};
                for (M in C = E(C))
                  l.indexOf(M) !== -1 && (p[M] = C[M], delete C[M], O = !0);
                return !!O && [p, C];
              }
              return (o = E(o)).alpha = (o.alpha || 0) * d, o.beta = (o.beta || 0) * d, i.top = c.path(), i.side1 = c.path(), i.side2 = c.path(), i.inn = c.path(), i.out = c.path(), i.onAdd = function() {
                var C = i.parentGroup, M = i.attr("class");
                i.top.add(i), ["out", "inn", "side1", "side2"].forEach(function(O) {
                  i[O].attr({ class: M + " highcharts-3d-side" }).add(C);
                });
              }, ["addClass", "removeClass"].forEach(function(C) {
                i[C] = function() {
                  var M = arguments;
                  ["top", "out", "inn", "side1", "side2"].forEach(function(O) {
                    i[O][C].apply(i[O], M);
                  });
                };
              }), i.setPaths = function(C) {
                var M = i.renderer.arc3dPath(C), O = 100 * M.zTop;
                i.attribs = C, i.top.attr({ d: M.top, zIndex: M.zTop }), i.inn.attr({ d: M.inn, zIndex: M.zInn }), i.out.attr({ d: M.out, zIndex: M.zOut }), i.side1.attr({ d: M.side1, zIndex: M.zSide1 }), i.side2.attr({ d: M.side2, zIndex: M.zSide2 }), i.zIndex = O, i.attr({ zIndex: O }), C.center && (i.top.setRadialReference(C.center), delete C.center);
              }, i.setPaths(o), i.fillSetter = function(C) {
                var M = A(C).brighten(-0.1).get();
                return this.fill = C, this.side1.attr({ fill: M }), this.side2.attr({ fill: M }), this.inn.attr({ fill: M }), this.out.attr({ fill: M }), this.top.attr({ fill: C }), this;
              }, ["opacity", "translateX", "translateY", "visibility"].forEach(function(C) {
                i[C + "Setter"] = function(M, O) {
                  i[O] = M, ["out", "inn", "side1", "side2", "top"].forEach(function(p) {
                    i[p].attr(O, M);
                  });
                };
              }), i.attr = function(C) {
                var M, O;
                return typeof C == "object" && (O = h(C)) && (M = O[0], arguments[0] = O[1], x(i.attribs, M), i.setPaths(i.attribs)), J.prototype.attr.apply(i, arguments);
              }, i.animate = function(C, M, O) {
                var p, w, T, z = this.attribs, W = "data-" + Math.random().toString(26).substring(2, 9);
                return delete C.center, delete C.z, delete C.alpha, delete C.beta, (T = k(P(M, this.renderer.globalAnimation))).duration && (p = h(C), i[W] = 0, C[W] = 1, i[W + "Setter"] = $.noop, p && (w = p[0], T.step = function(L, I) {
                  function j(Z) {
                    return z[Z] + (P(w[Z], z[Z]) - z[Z]) * I.pos;
                  }
                  I.prop === W && I.elem.setPaths(E(z, { x: j("x"), y: j("y"), r: j("r"), innerR: j("innerR"), start: j("start"), end: j("end"), depth: j("depth") }));
                }), M = T), J.prototype.animate.call(this, C, M, O);
              }, i.destroy = function() {
                return this.top.destroy(), this.out.destroy(), this.inn.destroy(), this.side1.destroy(), this.side2.destroy(), J.prototype.destroy.call(this);
              }, i.hide = function() {
                this.top.hide(), this.out.hide(), this.inn.hide(), this.side1.hide(), this.side2.hide();
              }, i.show = function(C) {
                this.top.show(C), this.out.show(C), this.inn.show(C), this.side1.show(C), this.side2.show(C);
              }, i;
            }, n.prototype.arc3dPath = function(o) {
              var i = o.x || 0, c = o.y || 0, l = o.start || 0, h = (o.end || 0) - 1e-5, C = o.r || 0, M = o.innerR || 0, O = o.depth || 0, p = o.alpha || 0, w = o.beta || 0, T = Math.cos(l), z = Math.sin(l), W = Math.cos(h), L = Math.sin(h), I = C * Math.cos(w), j = C * Math.cos(p), Z = M * Math.cos(w), V = M * Math.cos(p), X = O * Math.sin(w), et = O * Math.sin(p), ot = [["M", i + I * T, c + j * z]];
              (ot = ot.concat(n.curveTo(i, c, I, j, l, h, 0, 0))).push(["L", i + Z * W, c + V * L]), (ot = ot.concat(n.curveTo(i, c, Z, V, h, l, 0, 0))).push(["Z"]);
              var it = w > 0 ? Math.PI / 2 : 0, pt = p > 0 ? 0 : Math.PI / 2, mt = l > -it ? l : h > -it ? -it : l, Ct = h < y - pt ? h : l < y - pt ? y - pt : h, kt = 2 * y - pt, Lt = [["M", i + I * S(mt), c + j * u(mt)]];
              Lt = Lt.concat(n.curveTo(i, c, I, j, mt, Ct, 0, 0)), h > kt && l < kt ? (Lt.push(["L", i + I * S(Ct) + X, c + j * u(Ct) + et]), (Lt = Lt.concat(n.curveTo(i, c, I, j, Ct, kt, X, et))).push(["L", i + I * S(kt), c + j * u(kt)]), (Lt = Lt.concat(n.curveTo(i, c, I, j, kt, h, 0, 0))).push(["L", i + I * S(h) + X, c + j * u(h) + et]), (Lt = Lt.concat(n.curveTo(i, c, I, j, h, kt, X, et))).push(["L", i + I * S(kt), c + j * u(kt)]), Lt = Lt.concat(n.curveTo(i, c, I, j, kt, Ct, 0, 0))) : h > y - pt && l < y - pt && (Lt.push(["L", i + I * Math.cos(Ct) + X, c + j * Math.sin(Ct) + et]), (Lt = Lt.concat(n.curveTo(i, c, I, j, Ct, h, X, et))).push(["L", i + I * Math.cos(h), c + j * Math.sin(h)]), Lt = Lt.concat(n.curveTo(i, c, I, j, h, Ct, 0, 0))), Lt.push(["L", i + I * Math.cos(Ct) + X, c + j * Math.sin(Ct) + et]), (Lt = Lt.concat(n.curveTo(i, c, I, j, Ct, mt, X, et))).push(["Z"]);
              var Tt = [["M", i + Z * T, c + V * z]];
              (Tt = Tt.concat(n.curveTo(i, c, Z, V, l, h, 0, 0))).push(["L", i + Z * Math.cos(h) + X, c + V * Math.sin(h) + et]), (Tt = Tt.concat(n.curveTo(i, c, Z, V, h, l, X, et))).push(["Z"]);
              var xt = [["M", i + I * T, c + j * z], ["L", i + I * T + X, c + j * z + et], ["L", i + Z * T + X, c + V * z + et], ["L", i + Z * T, c + V * z], ["Z"]], ct = [["M", i + I * W, c + j * L], ["L", i + I * W + X, c + j * L + et], ["L", i + Z * W + X, c + V * L + et], ["L", i + Z * W, c + V * L], ["Z"]], ft = Math.atan2(et, -X), St = Math.abs(h + ft), Mt = Math.abs(l + ft), Dt = Math.abs((l + h) / 2 + ft);
              function Ot(Kt) {
                return (Kt %= 2 * Math.PI) > Math.PI && (Kt = 2 * Math.PI - Kt), Kt;
              }
              St = Ot(St), Mt = Ot(Mt);
              var Nt = 1e5, Wt = (Dt = Ot(Dt)) * Nt, zt = Mt * Nt, Ht = St * Nt;
              return { top: ot, zTop: Math.PI * Nt + 1, out: Lt, zOut: Math.max(Wt, zt, Ht), inn: Tt, zInn: Math.max(Wt, zt, Ht), side1: xt, zSide1: 0.99 * Ht, side2: ct, zSide2: 0.99 * zt };
            }, n;
          }(q);
          return a;
        }), at(_, "Core/Chart/Chart3D.js", [_["Core/Color/Color.js"], _["Core/Defaults.js"], _["Core/Math3D.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = G.parse, q = F.defaultOptions, U = $.perspective, N = $.shapeArea3D, D = Y.addEvent, k = Y.isArray, A = Y.merge, b = Y.pick, d = Y.wrap;
          return function(m) {
            var v = function() {
              function o(i) {
                this.frame3d = void 0, this.chart = i;
              }
              return o.prototype.get3dFrame = function() {
                var i = this.chart, c = i.options.chart.options3d, l = c.frame, h = i.plotLeft, C = i.plotLeft + i.plotWidth, M = i.plotTop, O = i.plotTop + i.plotHeight, p = c.depth, w = function(ct) {
                  var ft = N(ct, i);
                  return ft > 0.5 ? 1 : ft < -0.5 ? -1 : 0;
                }, T = w([{ x: h, y: O, z: p }, { x: C, y: O, z: p }, { x: C, y: O, z: 0 }, { x: h, y: O, z: 0 }]), z = w([{ x: h, y: M, z: 0 }, { x: C, y: M, z: 0 }, { x: C, y: M, z: p }, { x: h, y: M, z: p }]), W = w([{ x: h, y: M, z: 0 }, { x: h, y: M, z: p }, { x: h, y: O, z: p }, { x: h, y: O, z: 0 }]), L = w([{ x: C, y: M, z: p }, { x: C, y: M, z: 0 }, { x: C, y: O, z: 0 }, { x: C, y: O, z: p }]), I = w([{ x: h, y: O, z: 0 }, { x: C, y: O, z: 0 }, { x: C, y: M, z: 0 }, { x: h, y: M, z: 0 }]), j = w([{ x: h, y: M, z: p }, { x: C, y: M, z: p }, { x: C, y: O, z: p }, { x: h, y: O, z: p }]), Z = !1, V = !1, X = !1, et = !1;
                [].concat(i.xAxis, i.yAxis, i.zAxis).forEach(function(ct) {
                  ct && (ct.horiz ? ct.opposite ? V = !0 : Z = !0 : ct.opposite ? et = !0 : X = !0);
                });
                var ot = function(ct, ft, St) {
                  for (var Mt = ["size", "color", "visible"], Dt = {}, Ot = 0; Ot < Mt.length; Ot++)
                    for (var Nt = Mt[Ot], Wt = 0; Wt < ct.length; Wt++)
                      if (typeof ct[Wt] == "object") {
                        var zt = ct[Wt][Nt];
                        if (zt != null) {
                          Dt[Nt] = zt;
                          break;
                        }
                      }
                  var Ht = St;
                  return Dt.visible === !0 || Dt.visible === !1 ? Ht = Dt.visible : Dt.visible === "auto" && (Ht = ft > 0), { size: b(Dt.size, 1), color: b(Dt.color, "none"), frontFacing: ft > 0, visible: Ht };
                }, it = { axes: {}, bottom: ot([l.bottom, l.top, l], T, Z), top: ot([l.top, l.bottom, l], z, V), left: ot([l.left, l.right, l.side, l], W, X), right: ot([l.right, l.left, l.side, l], L, et), back: ot([l.back, l.front, l], j, !0), front: ot([l.front, l.back, l], I, !1) };
                if (c.axisLabelPosition === "auto") {
                  var pt = function(ct, ft) {
                    return ct.visible !== ft.visible || ct.visible && ft.visible && ct.frontFacing !== ft.frontFacing;
                  }, mt = [];
                  pt(it.left, it.front) && mt.push({ y: (M + O) / 2, x: h, z: 0, xDir: { x: 1, y: 0, z: 0 } }), pt(it.left, it.back) && mt.push({ y: (M + O) / 2, x: h, z: p, xDir: { x: 0, y: 0, z: -1 } }), pt(it.right, it.front) && mt.push({ y: (M + O) / 2, x: C, z: 0, xDir: { x: 0, y: 0, z: 1 } }), pt(it.right, it.back) && mt.push({ y: (M + O) / 2, x: C, z: p, xDir: { x: -1, y: 0, z: 0 } });
                  var Ct = [];
                  pt(it.bottom, it.front) && Ct.push({ x: (h + C) / 2, y: O, z: 0, xDir: { x: 1, y: 0, z: 0 } }), pt(it.bottom, it.back) && Ct.push({ x: (h + C) / 2, y: O, z: p, xDir: { x: -1, y: 0, z: 0 } });
                  var kt = [];
                  pt(it.top, it.front) && kt.push({ x: (h + C) / 2, y: M, z: 0, xDir: { x: 1, y: 0, z: 0 } }), pt(it.top, it.back) && kt.push({ x: (h + C) / 2, y: M, z: p, xDir: { x: -1, y: 0, z: 0 } });
                  var Lt = [];
                  pt(it.bottom, it.left) && Lt.push({ z: (0 + p) / 2, y: O, x: h, xDir: { x: 0, y: 0, z: -1 } }), pt(it.bottom, it.right) && Lt.push({ z: (0 + p) / 2, y: O, x: C, xDir: { x: 0, y: 0, z: 1 } });
                  var Tt = [];
                  pt(it.top, it.left) && Tt.push({ z: (0 + p) / 2, y: M, x: h, xDir: { x: 0, y: 0, z: -1 } }), pt(it.top, it.right) && Tt.push({ z: (0 + p) / 2, y: M, x: C, xDir: { x: 0, y: 0, z: 1 } });
                  var xt = function(ct, ft, St) {
                    if (ct.length === 0)
                      return null;
                    if (ct.length === 1)
                      return ct[0];
                    for (var Mt = U(ct, i, !1), Dt = 0, Ot = 1; Ot < Mt.length; Ot++)
                      (St * Mt[Ot][ft] > St * Mt[Dt][ft] || St * Mt[Ot][ft] == St * Mt[Dt][ft] && Mt[Ot].z < Mt[Dt].z) && (Dt = Ot);
                    return ct[Dt];
                  };
                  it.axes = { y: { left: xt(mt, "x", -1), right: xt(mt, "x", 1) }, x: { top: xt(kt, "y", -1), bottom: xt(Ct, "y", 1) }, z: { top: xt(Tt, "y", -1), bottom: xt(Lt, "y", 1) } };
                } else
                  it.axes = { y: { left: { x: h, z: 0, xDir: { x: 1, y: 0, z: 0 } }, right: { x: C, z: 0, xDir: { x: 0, y: 0, z: 1 } } }, x: { top: { y: M, z: 0, xDir: { x: 1, y: 0, z: 0 } }, bottom: { y: O, z: 0, xDir: { x: 1, y: 0, z: 0 } } }, z: { top: { x: X ? C : h, y: M, xDir: X ? { x: 0, y: 0, z: 1 } : { x: 0, y: 0, z: -1 } }, bottom: { x: X ? C : h, y: O, xDir: X ? { x: 0, y: 0, z: 1 } : { x: 0, y: 0, z: -1 } } } };
                return it;
              }, o.prototype.getScale = function(i) {
                var c, l = this.chart, h = l.plotLeft, C = l.plotWidth + h, M = l.plotTop, O = l.plotHeight + M, p = h + l.plotWidth / 2, w = M + l.plotHeight / 2, T = { minX: Number.MAX_VALUE, maxX: -Number.MAX_VALUE, minY: Number.MAX_VALUE, maxY: -Number.MAX_VALUE }, z = 1;
                return c = [{ x: h, y: M, z: 0 }, { x: h, y: M, z: i }], [0, 1].forEach(function(W) {
                  c.push({ x: C, y: c[W].y, z: c[W].z });
                }), [0, 1, 2, 3].forEach(function(W) {
                  c.push({ x: c[W].x, y: O, z: c[W].z });
                }), (c = U(c, l, !1)).forEach(function(W) {
                  T.minX = Math.min(T.minX, W.x), T.maxX = Math.max(T.maxX, W.x), T.minY = Math.min(T.minY, W.y), T.maxY = Math.max(T.maxY, W.y);
                }), h > T.minX && (z = Math.min(z, 1 - Math.abs((h + p) / (T.minX + p)) % 1)), C < T.maxX && (z = Math.min(z, (C - p) / (T.maxX - p))), M > T.minY && (z = T.minY < 0 ? Math.min(z, (M + w) / (-T.minY + M + w)) : Math.min(z, 1 - (M + w) / (T.minY + w) % 1)), O < T.maxY && (z = Math.min(z, Math.abs((O - w) / (T.maxY - w)))), z;
              }, o;
            }();
            function g(o) {
              this.is3d() && o.options.type === "scatter" && (o.options.type = "scatter3d");
            }
            function x() {
              if (this.chart3d && this.is3d()) {
                var o = this, i = o.renderer, c = o.options.chart.options3d, l = o.chart3d.get3dFrame(), h = o.plotLeft, C = o.plotLeft + o.plotWidth, M = o.plotTop, O = o.plotTop + o.plotHeight, p = c.depth, w = h - (l.left.visible ? l.left.size : 0), T = C + (l.right.visible ? l.right.size : 0), z = M - (l.top.visible ? l.top.size : 0), W = O + (l.bottom.visible ? l.bottom.size : 0), L = 0 - (l.front.visible ? l.front.size : 0), I = p + (l.back.visible ? l.back.size : 0), j = o.hasRendered ? "animate" : "attr";
                o.chart3d.frame3d = l, o.frameShapes || (o.frameShapes = { bottom: i.polyhedron().add(), top: i.polyhedron().add(), left: i.polyhedron().add(), right: i.polyhedron().add(), back: i.polyhedron().add(), front: i.polyhedron().add() }), o.frameShapes.bottom[j]({ class: "highcharts-3d-frame highcharts-3d-frame-bottom", zIndex: l.bottom.frontFacing ? -1e3 : 1e3, faces: [{ fill: Q(l.bottom.color).brighten(0.1).get(), vertexes: [{ x: w, y: W, z: L }, { x: T, y: W, z: L }, { x: T, y: W, z: I }, { x: w, y: W, z: I }], enabled: l.bottom.visible }, { fill: Q(l.bottom.color).brighten(0.1).get(), vertexes: [{ x: h, y: O, z: p }, { x: C, y: O, z: p }, { x: C, y: O, z: 0 }, { x: h, y: O, z: 0 }], enabled: l.bottom.visible }, { fill: Q(l.bottom.color).brighten(-0.1).get(), vertexes: [{ x: w, y: W, z: L }, { x: w, y: W, z: I }, { x: h, y: O, z: p }, { x: h, y: O, z: 0 }], enabled: l.bottom.visible && !l.left.visible }, { fill: Q(l.bottom.color).brighten(-0.1).get(), vertexes: [{ x: T, y: W, z: I }, { x: T, y: W, z: L }, { x: C, y: O, z: 0 }, { x: C, y: O, z: p }], enabled: l.bottom.visible && !l.right.visible }, { fill: Q(l.bottom.color).get(), vertexes: [{ x: T, y: W, z: L }, { x: w, y: W, z: L }, { x: h, y: O, z: 0 }, { x: C, y: O, z: 0 }], enabled: l.bottom.visible && !l.front.visible }, { fill: Q(l.bottom.color).get(), vertexes: [{ x: w, y: W, z: I }, { x: T, y: W, z: I }, { x: C, y: O, z: p }, { x: h, y: O, z: p }], enabled: l.bottom.visible && !l.back.visible }] }), o.frameShapes.top[j]({ class: "highcharts-3d-frame highcharts-3d-frame-top", zIndex: l.top.frontFacing ? -1e3 : 1e3, faces: [{ fill: Q(l.top.color).brighten(0.1).get(), vertexes: [{ x: w, y: z, z: I }, { x: T, y: z, z: I }, { x: T, y: z, z: L }, { x: w, y: z, z: L }], enabled: l.top.visible }, { fill: Q(l.top.color).brighten(0.1).get(), vertexes: [{ x: h, y: M, z: 0 }, { x: C, y: M, z: 0 }, { x: C, y: M, z: p }, { x: h, y: M, z: p }], enabled: l.top.visible }, { fill: Q(l.top.color).brighten(-0.1).get(), vertexes: [{ x: w, y: z, z: I }, { x: w, y: z, z: L }, { x: h, y: M, z: 0 }, { x: h, y: M, z: p }], enabled: l.top.visible && !l.left.visible }, { fill: Q(l.top.color).brighten(-0.1).get(), vertexes: [{ x: T, y: z, z: L }, { x: T, y: z, z: I }, { x: C, y: M, z: p }, { x: C, y: M, z: 0 }], enabled: l.top.visible && !l.right.visible }, { fill: Q(l.top.color).get(), vertexes: [{ x: w, y: z, z: L }, { x: T, y: z, z: L }, { x: C, y: M, z: 0 }, { x: h, y: M, z: 0 }], enabled: l.top.visible && !l.front.visible }, { fill: Q(l.top.color).get(), vertexes: [{ x: T, y: z, z: I }, { x: w, y: z, z: I }, { x: h, y: M, z: p }, { x: C, y: M, z: p }], enabled: l.top.visible && !l.back.visible }] }), o.frameShapes.left[j]({ class: "highcharts-3d-frame highcharts-3d-frame-left", zIndex: l.left.frontFacing ? -1e3 : 1e3, faces: [{ fill: Q(l.left.color).brighten(0.1).get(), vertexes: [{ x: w, y: W, z: L }, { x: h, y: O, z: 0 }, { x: h, y: O, z: p }, { x: w, y: W, z: I }], enabled: l.left.visible && !l.bottom.visible }, { fill: Q(l.left.color).brighten(0.1).get(), vertexes: [{ x: w, y: z, z: I }, { x: h, y: M, z: p }, { x: h, y: M, z: 0 }, { x: w, y: z, z: L }], enabled: l.left.visible && !l.top.visible }, { fill: Q(l.left.color).brighten(-0.1).get(), vertexes: [{ x: w, y: W, z: I }, { x: w, y: z, z: I }, { x: w, y: z, z: L }, { x: w, y: W, z: L }], enabled: l.left.visible }, { fill: Q(l.left.color).brighten(-0.1).get(), vertexes: [{ x: h, y: M, z: p }, { x: h, y: O, z: p }, { x: h, y: O, z: 0 }, { x: h, y: M, z: 0 }], enabled: l.left.visible }, { fill: Q(l.left.color).get(), vertexes: [{ x: w, y: W, z: L }, { x: w, y: z, z: L }, { x: h, y: M, z: 0 }, { x: h, y: O, z: 0 }], enabled: l.left.visible && !l.front.visible }, { fill: Q(l.left.color).get(), vertexes: [{ x: w, y: z, z: I }, { x: w, y: W, z: I }, { x: h, y: O, z: p }, { x: h, y: M, z: p }], enabled: l.left.visible && !l.back.visible }] }), o.frameShapes.right[j]({ class: "highcharts-3d-frame highcharts-3d-frame-right", zIndex: l.right.frontFacing ? -1e3 : 1e3, faces: [{ fill: Q(l.right.color).brighten(0.1).get(), vertexes: [{ x: T, y: W, z: I }, { x: C, y: O, z: p }, { x: C, y: O, z: 0 }, { x: T, y: W, z: L }], enabled: l.right.visible && !l.bottom.visible }, { fill: Q(l.right.color).brighten(0.1).get(), vertexes: [{ x: T, y: z, z: L }, { x: C, y: M, z: 0 }, { x: C, y: M, z: p }, { x: T, y: z, z: I }], enabled: l.right.visible && !l.top.visible }, { fill: Q(l.right.color).brighten(-0.1).get(), vertexes: [{ x: C, y: M, z: 0 }, { x: C, y: O, z: 0 }, { x: C, y: O, z: p }, { x: C, y: M, z: p }], enabled: l.right.visible }, { fill: Q(l.right.color).brighten(-0.1).get(), vertexes: [{ x: T, y: W, z: L }, { x: T, y: z, z: L }, { x: T, y: z, z: I }, { x: T, y: W, z: I }], enabled: l.right.visible }, { fill: Q(l.right.color).get(), vertexes: [{ x: T, y: z, z: L }, { x: T, y: W, z: L }, { x: C, y: O, z: 0 }, { x: C, y: M, z: 0 }], enabled: l.right.visible && !l.front.visible }, { fill: Q(l.right.color).get(), vertexes: [{ x: T, y: W, z: I }, { x: T, y: z, z: I }, { x: C, y: M, z: p }, { x: C, y: O, z: p }], enabled: l.right.visible && !l.back.visible }] }), o.frameShapes.back[j]({ class: "highcharts-3d-frame highcharts-3d-frame-back", zIndex: l.back.frontFacing ? -1e3 : 1e3, faces: [{ fill: Q(l.back.color).brighten(0.1).get(), vertexes: [{ x: T, y: W, z: I }, { x: w, y: W, z: I }, { x: h, y: O, z: p }, { x: C, y: O, z: p }], enabled: l.back.visible && !l.bottom.visible }, { fill: Q(l.back.color).brighten(0.1).get(), vertexes: [{ x: w, y: z, z: I }, { x: T, y: z, z: I }, { x: C, y: M, z: p }, { x: h, y: M, z: p }], enabled: l.back.visible && !l.top.visible }, { fill: Q(l.back.color).brighten(-0.1).get(), vertexes: [{ x: w, y: W, z: I }, { x: w, y: z, z: I }, { x: h, y: M, z: p }, { x: h, y: O, z: p }], enabled: l.back.visible && !l.left.visible }, { fill: Q(l.back.color).brighten(-0.1).get(), vertexes: [{ x: T, y: z, z: I }, { x: T, y: W, z: I }, { x: C, y: O, z: p }, { x: C, y: M, z: p }], enabled: l.back.visible && !l.right.visible }, { fill: Q(l.back.color).get(), vertexes: [{ x: h, y: M, z: p }, { x: C, y: M, z: p }, { x: C, y: O, z: p }, { x: h, y: O, z: p }], enabled: l.back.visible }, { fill: Q(l.back.color).get(), vertexes: [{ x: w, y: W, z: I }, { x: T, y: W, z: I }, { x: T, y: z, z: I }, { x: w, y: z, z: I }], enabled: l.back.visible }] }), o.frameShapes.front[j]({ class: "highcharts-3d-frame highcharts-3d-frame-front", zIndex: l.front.frontFacing ? -1e3 : 1e3, faces: [{ fill: Q(l.front.color).brighten(0.1).get(), vertexes: [{ x: w, y: W, z: L }, { x: T, y: W, z: L }, { x: C, y: O, z: 0 }, { x: h, y: O, z: 0 }], enabled: l.front.visible && !l.bottom.visible }, { fill: Q(l.front.color).brighten(0.1).get(), vertexes: [{ x: T, y: z, z: L }, { x: w, y: z, z: L }, { x: h, y: M, z: 0 }, { x: C, y: M, z: 0 }], enabled: l.front.visible && !l.top.visible }, { fill: Q(l.front.color).brighten(-0.1).get(), vertexes: [{ x: w, y: z, z: L }, { x: w, y: W, z: L }, { x: h, y: O, z: 0 }, { x: h, y: M, z: 0 }], enabled: l.front.visible && !l.left.visible }, { fill: Q(l.front.color).brighten(-0.1).get(), vertexes: [{ x: T, y: W, z: L }, { x: T, y: z, z: L }, { x: C, y: M, z: 0 }, { x: C, y: O, z: 0 }], enabled: l.front.visible && !l.right.visible }, { fill: Q(l.front.color).get(), vertexes: [{ x: C, y: M, z: 0 }, { x: h, y: M, z: 0 }, { x: h, y: O, z: 0 }, { x: C, y: O, z: 0 }], enabled: l.front.visible }, { fill: Q(l.front.color).get(), vertexes: [{ x: T, y: W, z: L }, { x: w, y: W, z: L }, { x: w, y: z, z: L }, { x: T, y: z, z: L }], enabled: l.front.visible }] });
              }
            }
            function E() {
              this.styledMode && [{ name: "darker", slope: 0.6 }, { name: "brighter", slope: 1.4 }].forEach(function(o) {
                this.renderer.definition({ tagName: "filter", attributes: { id: "highcharts-" + o.name }, children: [{ tagName: "feComponentTransfer", children: [{ tagName: "feFuncR", attributes: { type: "linear", slope: o.slope } }, { tagName: "feFuncG", attributes: { type: "linear", slope: o.slope } }, { tagName: "feFuncB", attributes: { type: "linear", slope: o.slope } }] }] });
              }, this);
            }
            function P() {
              var o = this.options;
              this.is3d() && (o.series || []).forEach(function(i) {
                (i.type || o.chart.type || o.chart.defaultSeriesType) === "scatter" && (i.type = "scatter3d");
              });
            }
            function S() {
              var o = this, i = o.options.chart.options3d;
              if (o.chart3d && o.is3d()) {
                i && (i.alpha = i.alpha % 360 + (i.alpha >= 0 ? 0 : 360), i.beta = i.beta % 360 + (i.beta >= 0 ? 0 : 360));
                var c = o.inverted, l = o.clipBox, h = o.margin, C = c ? "x" : "y", M = c ? "height" : "width", O = c ? "width" : "height";
                l[c ? "y" : "x"] = -(h[3] || 0), l[C] = -(h[0] || 0), l[M] = o.chartWidth + (h[3] || 0) + (h[1] || 0), l[O] = o.chartHeight + (h[0] || 0) + (h[2] || 0), o.scale3d = 1, i.fitToPlot === !0 && (o.scale3d = o.chart3d.getScale(i.depth)), o.chart3d.frame3d = o.chart3d.get3dFrame();
              }
            }
            function u() {
              this.is3d() && (this.isDirtyBox = !0);
            }
            function y() {
              this.chart3d && this.is3d() && (this.chart3d.frame3d = this.chart3d.get3dFrame());
            }
            function s() {
              this.chart3d || (this.chart3d = new v(this));
            }
            function a(o) {
              return this.is3d() || o.apply(this, [].slice.call(arguments, 1));
            }
            function e(o) {
              var i, c = this.series.length;
              if (this.is3d())
                for (; c--; )
                  (i = this.series[c]).translate(), i.render();
              else
                o.call(this);
            }
            function n(o) {
              o.apply(this, [].slice.call(arguments, 1)), this.is3d() && (this.container.className += " highcharts-3d-chart");
            }
            m.Composition = v, m.defaultOptions = { chart: { options3d: { enabled: !1, alpha: 0, beta: 0, depth: 100, fitToPlot: !0, viewDistance: 25, axisLabelPosition: null, frame: { visible: "default", size: 1, bottom: {}, top: {}, left: {}, right: {}, back: {}, front: {} } } } }, m.compose = function(o, i) {
              var c = o.prototype, l = i.prototype;
              c.is3d = function() {
                return !!(this.options.chart.options3d && this.options.chart.options3d.enabled);
              }, c.propsRequireDirtyBox.push("chart.options3d"), c.propsRequireUpdateSeries.push("chart.options3d"), l.matrixSetter = function() {
                var h;
                if (this.pos < 1 && (k(this.start) || k(this.end))) {
                  var C = this.start || [1, 0, 0, 1, 0, 0], M = this.end || [1, 0, 0, 1, 0, 0];
                  h = [];
                  for (var O = 0; O < 6; O++)
                    h.push(this.pos * M[O] + (1 - this.pos) * C[O]);
                } else
                  h = this.end;
                this.elem.attr(this.prop, h, null, !0);
              }, A(!0, q, m.defaultOptions), D(o, "init", s), D(o, "addSeries", g), D(o, "afterDrawChartBox", x), D(o, "afterGetContainer", E), D(o, "afterInit", P), D(o, "afterSetChartSize", S), D(o, "beforeRedraw", u), D(o, "beforeRender", y), d(c, "isInsidePlot", a), d(c, "renderSeries", e), d(c, "setClassName", n);
            };
          }(J || (J = {})), J;
        }), at(_, "Core/Axis/ZAxis.js", [_["Core/Axis/Axis.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(b, d) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, $(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            $(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), J = F.addEvent, Q = F.merge, q = F.pick, U = F.splat, N = [];
          function D(b) {
            return new A(this, b);
          }
          function k() {
            var b = this, d = this.options.zAxis = U(this.options.zAxis || {});
            this.is3d() && (this.zAxis = [], d.forEach(function(m, v) {
              m.index = v, m.isX = !0, b.addZAxis(m).setScale();
            }));
          }
          var A = function(b) {
            function d(m, v) {
              var g = b.call(this, m, v) || this;
              return g.isZAxis = !0, g;
            }
            return Y(d, b), d.compose = function(m) {
              if (N.indexOf(m) === -1) {
                N.push(m), J(m, "afterGetAxes", k);
                var v = m.prototype;
                v.addZAxis = D, v.collectionsWithInit.zAxis = [v.addZAxis], v.collectionsWithUpdate.push("zAxis");
              }
            }, d.prototype.getSeriesExtremes = function() {
              var m = this, v = this.chart;
              this.hasVisibleSeries = !1, this.dataMin = this.dataMax = this.ignoreMinPadding = this.ignoreMaxPadding = void 0, this.stacking && this.stacking.buildStacks(), this.series.forEach(function(g) {
                if (g.visible || !v.options.chart.ignoreHiddenSeries) {
                  m.hasVisibleSeries = !0;
                  var x = g.zData;
                  x.length && (m.dataMin = Math.min(q(m.dataMin, x[0]), Math.min.apply(null, x)), m.dataMax = Math.max(q(m.dataMax, x[0]), Math.max.apply(null, x)));
                }
              });
            }, d.prototype.setAxisSize = function() {
              var m = this.chart;
              b.prototype.setAxisSize.call(this), this.width = this.len = m.options.chart.options3d && m.options.chart.options3d.depth || 0, this.right = m.chartWidth - this.width - this.left;
            }, d.prototype.setOptions = function(m) {
              m = Q({ offset: 0, lineWidth: 0 }, m), this.isZAxis = !0, b.prototype.setOptions.call(this, m), this.coll = "zAxis";
            }, d;
          }(G);
          return A;
        }), at(_, "Core/Axis/Axis3DDefaults.js", [], function() {
          return { labels: { position3d: "offset", skew3d: !1 }, title: { position3d: null, skew3d: null } };
        }), at(_, "Core/Axis/Tick3DComposition.js", [_["Core/Utilities.js"]], function(G) {
          var F = G.addEvent, $ = G.extend, Y = G.wrap, J = [];
          function Q(U) {
            var N = this.axis.axis3D;
            N && $(U.pos, N.fix3dPosition(U.pos));
          }
          function q(U) {
            var N = this.axis.axis3D, D = U.apply(this, [].slice.call(arguments, 1));
            if (N) {
              var k = D[0], A = D[1];
              if (k[0] === "M" && A[0] === "L") {
                var b = [N.fix3dPosition({ x: k[1], y: k[2], z: 0 }), N.fix3dPosition({ x: A[1], y: A[2], z: 0 })];
                return this.axis.chart.renderer.toLineSegments(b);
              }
            }
            return D;
          }
          return { compose: function(U) {
            J.indexOf(U) === -1 && (J.push(U), F(U, "afterGetLabelPosition", Q), Y(U.prototype, "getMarkPath", q));
          } };
        }), at(_, "Core/Axis/Axis3DComposition.js", [_["Core/Axis/Axis3DDefaults.js"], _["Core/Globals.js"], _["Core/Math3D.js"], _["Core/Axis/Tick3DComposition.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = F.deg2rad, q = $.perspective, U = $.perspective3D, N = $.shapeArea, D = J.addEvent, k = J.merge, A = J.pick, b = J.wrap, d = [];
          function m() {
            var s = this, a = s.chart, e = s.options;
            a.is3d && a.is3d() && s.coll !== "colorAxis" && (e.tickWidth = A(e.tickWidth, 0), e.gridLineWidth = A(e.gridLineWidth, 1));
          }
          function v(s) {
            var a = this;
            a.chart.is3d() && a.coll !== "colorAxis" && s.point && (s.point.crosshairPos = a.isXAxis ? s.point.axisXpos : a.len - s.point.axisYpos);
          }
          function g() {
            var s = this;
            s.axis3D || (s.axis3D = new y(s));
          }
          function x(s) {
            var a = this;
            return a.chart.is3d() && a.coll !== "colorAxis" ? [] : s.apply(a, [].slice.call(arguments, 1));
          }
          function E(s) {
            if (!this.chart.is3d() || this.coll === "colorAxis")
              return s.apply(this, [].slice.call(arguments, 1));
            var a = arguments, e = a[1], n = a[2], o = [], i = this.getPlotLinePath({ value: e }), c = this.getPlotLinePath({ value: n });
            if (i && c)
              for (var l = 0; l < i.length; l += 2) {
                var h = i[l], C = i[l + 1], M = c[l], O = c[l + 1];
                h[0] === "M" && C[0] === "L" && M[0] === "M" && O[0] === "L" && o.push(h, C, O, ["L", M[1], M[2]], ["Z"]);
              }
            return o;
          }
          function P(s) {
            var a = this, e = a.axis3D, n = a.chart, o = s.apply(a, [].slice.call(arguments, 1));
            if (a.coll === "colorAxis" || !n.chart3d || !n.is3d() || o === null)
              return o;
            var i, c = n.options.chart.options3d, l = a.isZAxis ? n.plotWidth : c.depth, h = n.chart3d.frame3d, C = o[0], M = o[1], O = [];
            return C[0] === "M" && M[0] === "L" && (i = [e.swapZ({ x: C[1], y: C[2], z: 0 }), e.swapZ({ x: C[1], y: C[2], z: l }), e.swapZ({ x: M[1], y: M[2], z: 0 }), e.swapZ({ x: M[1], y: M[2], z: l })], this.horiz ? this.isZAxis ? (h.left.visible && O.push(i[0], i[2]), h.right.visible && O.push(i[1], i[3]), h.top.visible && O.push(i[0], i[1]), h.bottom.visible && O.push(i[2], i[3])) : (h.front.visible && O.push(i[0], i[2]), h.back.visible && O.push(i[1], i[3]), h.top.visible && O.push(i[0], i[1]), h.bottom.visible && O.push(i[2], i[3])) : (h.front.visible && O.push(i[0], i[2]), h.back.visible && O.push(i[1], i[3]), h.left.visible && O.push(i[0], i[1]), h.right.visible && O.push(i[2], i[3])), O = q(O, this.chart, !1)), n.renderer.toLineSegments(O);
          }
          function S(s, a) {
            var e = this, n = e.chart, o = e.ticks, i = e.gridGroup;
            if (e.categories && n.frameShapes && n.is3d() && i && a && a.label) {
              var c = i.element.childNodes[0].getBBox(), l = n.frameShapes.left.getBBox(), h = n.options.chart.options3d, C = { x: n.plotWidth / 2, y: n.plotHeight / 2, z: h.depth / 2, vd: A(h.depth, 1) * A(h.viewDistance, 0) }, M = a.pos, O = o[M - 1], p = o[M + 1], w = void 0, T = void 0, z = void 0;
              return M !== 0 && O && O.label && O.label.xy && (T = U({ x: O.label.xy.x, y: O.label.xy.y, z: null }, C, C.vd)), p && p.label && p.label.xy && (z = U({ x: p.label.xy.x, y: p.label.xy.y, z: null }, C, C.vd)), w = { x: a.label.xy.x, y: a.label.xy.y, z: null }, w = U(w, C, C.vd), Math.abs(T ? w.x - T.x : z ? z.x - w.x : c.x - l.x);
            }
            return s.apply(e, [].slice.call(arguments, 1));
          }
          function u(s) {
            var a = s.apply(this, [].slice.call(arguments, 1));
            return this.axis3D ? this.axis3D.fix3dPosition(a, !0) : a;
          }
          var y = function() {
            function s(a) {
              this.axis = a;
            }
            return s.compose = function(a, e) {
              if (Y.compose(e), d.indexOf(a) === -1) {
                d.push(a), k(!0, a.defaultOptions, G), a.keepProps.push("axis3D"), D(a, "init", g), D(a, "afterSetOptions", m), D(a, "drawCrosshair", v);
                var n = a.prototype;
                b(n, "getLinePath", x), b(n, "getPlotBandPath", E), b(n, "getPlotLinePath", P), b(n, "getSlotWidth", S), b(n, "getTitlePosition", u);
              }
            }, s.prototype.fix3dPosition = function(a, e) {
              var n = this.axis, o = n.chart;
              if (n.coll === "colorAxis" || !o.chart3d || !o.is3d())
                return a;
              var i, c = Q * o.options.chart.options3d.alpha, l = Q * o.options.chart.options3d.beta, h = A(e && n.options.title.position3d, n.options.labels.position3d), C = A(e && n.options.title.skew3d, n.options.labels.skew3d), M = o.chart3d.frame3d, O = o.plotLeft, p = o.plotWidth + O, w = o.plotTop, T = o.plotHeight + w, z = 0, W = 0, L = { x: 0, y: 1, z: 0 }, I = !1;
              if (a = n.axis3D.swapZ({ x: a.x, y: a.y, z: 0 }), n.isZAxis)
                if (n.opposite) {
                  if (M.axes.z.top === null)
                    return {};
                  W = a.y - w, a.x = M.axes.z.top.x, a.y = M.axes.z.top.y, i = M.axes.z.top.xDir, I = !M.top.frontFacing;
                } else {
                  if (M.axes.z.bottom === null)
                    return {};
                  W = a.y - T, a.x = M.axes.z.bottom.x, a.y = M.axes.z.bottom.y, i = M.axes.z.bottom.xDir, I = !M.bottom.frontFacing;
                }
              else if (n.horiz)
                if (n.opposite) {
                  if (M.axes.x.top === null)
                    return {};
                  W = a.y - w, a.y = M.axes.x.top.y, a.z = M.axes.x.top.z, i = M.axes.x.top.xDir, I = !M.top.frontFacing;
                } else {
                  if (M.axes.x.bottom === null)
                    return {};
                  W = a.y - T, a.y = M.axes.x.bottom.y, a.z = M.axes.x.bottom.z, i = M.axes.x.bottom.xDir, I = !M.bottom.frontFacing;
                }
              else if (n.opposite) {
                if (M.axes.y.right === null)
                  return {};
                z = a.x - p, a.x = M.axes.y.right.x, a.z = M.axes.y.right.z, i = { x: (i = M.axes.y.right.xDir).z, y: i.y, z: -i.x };
              } else {
                if (M.axes.y.left === null)
                  return {};
                z = a.x - O, a.x = M.axes.y.left.x, a.z = M.axes.y.left.z, i = M.axes.y.left.xDir;
              }
              if (h !== "chart")
                if (h === "flap")
                  if (n.horiz) {
                    var j = Math.sin(c), Z = Math.cos(c);
                    n.opposite && (j = -j), I && (j = -j), L = { x: i.z * j, y: Z, z: -i.x * j };
                  } else
                    i = { x: Math.cos(l), y: 0, z: Math.sin(l) };
                else if (h === "ortho")
                  if (n.horiz) {
                    var V = Math.sin(c), X = Math.cos(c), et = { x: Math.sin(l) * X, y: -V, z: -X * Math.cos(l) };
                    L = { x: i.y * et.z - i.z * et.y, y: i.z * et.x - i.x * et.z, z: i.x * et.y - i.y * et.x };
                    var ot = 1 / Math.sqrt(L.x * L.x + L.y * L.y + L.z * L.z);
                    I && (ot = -ot), L = { x: ot * L.x, y: ot * L.y, z: ot * L.z };
                  } else
                    i = { x: Math.cos(l), y: 0, z: Math.sin(l) };
                else
                  n.horiz ? L = { x: Math.sin(l) * Math.sin(c), y: Math.cos(c), z: -Math.cos(l) * Math.sin(c) } : i = { x: Math.cos(l), y: 0, z: Math.sin(l) };
              a.x += z * i.x + W * L.x, a.y += z * i.y + W * L.y, a.z += z * i.z + W * L.z;
              var it = q([a], n.chart)[0];
              if (C) {
                N(q([a, { x: a.x + i.x, y: a.y + i.y, z: a.z + i.z }, { x: a.x + L.x, y: a.y + L.y, z: a.z + L.z }], n.chart)) < 0 && (i = { x: -i.x, y: -i.y, z: -i.z });
                var pt = q([{ x: a.x, y: a.y, z: a.z }, { x: a.x + i.x, y: a.y + i.y, z: a.z + i.z }, { x: a.x + L.x, y: a.y + L.y, z: a.z + L.z }], n.chart);
                it.matrix = [pt[1].x - pt[0].x, pt[1].y - pt[0].y, pt[2].x - pt[0].x, pt[2].y - pt[0].y, it.x, it.y], it.matrix[4] -= it.x * it.matrix[0] + it.y * it.matrix[2], it.matrix[5] -= it.x * it.matrix[1] + it.y * it.matrix[3];
              }
              return it;
            }, s.prototype.swapZ = function(a, e) {
              var n = this.axis;
              if (n.isZAxis) {
                var o = e ? 0 : n.chart.plotLeft;
                return { x: o + a.z, y: a.y, z: a.x - o };
              }
              return a;
            }, s;
          }();
          return y;
        }), at(_, "Core/Series/Series3D.js", [_["Core/Math3D.js"], _["Core/Series/Series.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(b, d) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, Y(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            Y(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), Q = G.perspective, q = $.addEvent, U = $.extend, N = $.merge, D = $.pick, k = $.isNumber, A = function(b) {
            function d() {
              return b !== null && b.apply(this, arguments) || this;
            }
            return J(d, b), d.prototype.translate = function() {
              b.prototype.translate.apply(this, arguments), this.chart.is3d() && this.translate3dPoints();
            }, d.prototype.translate3dPoints = function() {
              var m, v, g, x, E, P = this, S = P.options, u = P.chart, y = D(P.zAxis, u.options.zAxis[0]), s = [], a = [], e = S.stacking ? k(S.stack) ? S.stack : 0 : P.index || 0;
              for (P.zPadding = e * (S.depth || 0 + (S.groupZPadding || 1)), E = 0; E < P.data.length; E++)
                m = P.data[E], y && y.translate ? (x = y.logarithmic && y.val2lin ? y.val2lin(m.z) : m.z, m.plotZ = y.translate(x), m.isInside = !!m.isInside && x >= y.min && x <= y.max) : m.plotZ = P.zPadding, m.axisXpos = m.plotX, m.axisYpos = m.plotY, m.axisZpos = m.plotZ, s.push({ x: m.plotX, y: m.plotY, z: m.plotZ }), a.push(m.plotX || 0);
              for (P.rawPointsX = a, v = Q(s, u, !0), E = 0; E < P.data.length; E++)
                m = P.data[E], g = v[E], m.plotX = g.x, m.plotY = g.y, m.plotZ = g.z;
            }, d.defaultOptions = N(F.defaultOptions), d;
          }(F);
          return q(F, "afterTranslate", function() {
            this.chart.is3d() && this.translate3dPoints();
          }), U(F.prototype, { translate3dPoints: A.prototype.translate3dPoints }), A;
        }), at(_, "Series/Area3D/Area3DSeries.js", [_["Core/Math3D.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.perspective, J = F.seriesTypes.line.prototype, Q = $.wrap, q = [];
          function U(N) {
            var D = this, k = N.apply(D, [].slice.call(arguments, 1));
            if (!D.chart.is3d())
              return k;
            var A = J.getGraphPath, b = D.options, d = Math.round(D.yAxis.getThreshold(b.threshold)), m = [];
            if (D.rawPointsX)
              for (var v = 0; v < D.points.length; v++)
                m.push({ x: D.rawPointsX[v], y: b.stacking ? D.points[v].yBottom : d, z: D.zPadding });
            var g = D.chart.options.chart.options3d;
            m = Y(m, D.chart, !0).map(function(P) {
              return { plotX: P.x, plotY: P.y, plotZ: P.z };
            }), D.group && g && g.depth && g.beta && (D.markerGroup && (D.markerGroup.add(D.group), D.markerGroup.attr({ translateX: 0, translateY: 0 })), D.group.attr({ zIndex: Math.max(1, g.beta > 270 || g.beta < 90 ? g.depth - Math.round(D.zPadding || 0) : Math.round(D.zPadding || 0)) })), m.reversed = !0;
            var x = A.call(D, m, !0, !0);
            if (x[0] && x[0][0] === "M" && (x[0] = ["L", x[0][1], x[0][2]]), D.areaPath) {
              var E = D.areaPath.splice(0, D.areaPath.length / 2).concat(x);
              E.xMap = D.areaPath.xMap, D.areaPath = E;
            }
            return k;
          }
          return { compose: function(N) {
            q.indexOf(N) === -1 && (q.push(N), Q(N.prototype, "getGraphPath", U));
          } };
        }), at(_, "Series/Column3D/Column3DComposition.js", [_["Series/Column/ColumnSeries.js"], _["Core/Globals.js"], _["Core/Series/Series.js"], _["Core/Math3D.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Axis/Stacking/StackItem.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q) {
          var U = G.prototype, N = F.svg, D = Y.perspective, k = q.addEvent, A = q.pick, b = q.wrap;
          function d(x) {
            var E = x.apply(this, [].slice.call(arguments, 1));
            return this.chart.is3d && this.chart.is3d() && (E.stroke = this.options.edgeColor || E.fill, E["stroke-width"] = A(this.options.edgeWidth, 1)), E;
          }
          function m(x, E, P) {
            var S = this.chart.is3d && this.chart.is3d();
            S && (this.options.inactiveOtherPoints = !0), x.call(this, E, P), S && (this.options.inactiveOtherPoints = !1);
          }
          function v(x) {
            for (var E = [], P = 1; P < arguments.length; P++)
              E[P - 1] = arguments[P];
            return this.series.chart.is3d() ? this.graphic && this.graphic.element.nodeName !== "g" : x.apply(this, E);
          }
          if (b(U, "translate", function(x) {
            x.apply(this, [].slice.call(arguments, 1)), this.chart.is3d() && this.translate3dShapes();
          }), b($.prototype, "justifyDataLabel", function(x) {
            return !arguments[2].outside3dPlot && x.apply(this, [].slice.call(arguments, 1));
          }), U.translate3dPoints = function() {
          }, U.translate3dShapes = function() {
            var x, E = this, P = E.chart, S = E.options, u = S.depth, y = (S.stacking ? S.stack || 0 : E.index) * (u + (S.groupZPadding || 1)), s = E.borderWidth % 2 ? 0.5 : 0;
            P.inverted && !E.yAxis.reversed && (s *= -1), S.grouping !== !1 && (y = 0), y += S.groupZPadding || 1, E.data.forEach(function(a) {
              if (a.outside3dPlot = null, a.y !== null) {
                var e, n = a.shapeArgs, o = a.tooltipPos;
                [["x", "width"], ["y", "height"]].forEach(function(i) {
                  if ((e = n[i[0]] - s) < 0 && (n[i[1]] += n[i[0]] + s, n[i[0]] = -s, e = 0), e + n[i[1]] > E[i[0] + "Axis"].len && n[i[1]] !== 0 && (n[i[1]] = E[i[0] + "Axis"].len - n[i[0]]), n[i[1]] !== 0 && (n[i[0]] >= E[i[0] + "Axis"].len || n[i[0]] + n[i[1]] <= s)) {
                    for (var c in n)
                      n[c] = c === "y" ? -9999 : 0;
                    a.outside3dPlot = !0;
                  }
                }), a.shapeType === "rect" && (a.shapeType = "cuboid"), n.z = y, n.depth = u, n.insidePlotArea = !0, x = { x: n.x + n.width / 2, y: n.y, z: y + u / 2 }, P.inverted && (x.x = n.height, x.y = a.clientX), a.plot3d = D([x], P, !0, !1)[0], o = D([{ x: o[0], y: o[1], z: y + u / 2 }], P, !0, !1)[0], a.tooltipPos = [o.x, o.y];
              }
            }), E.z = y;
          }, b(U, "animate", function(x) {
            if (this.chart.is3d()) {
              var E = arguments, P = E[1], S = this.yAxis, u = this, y = this.yAxis.reversed;
              N && (P ? u.data.forEach(function(s) {
                s.y !== null && (s.height = s.shapeArgs.height, s.shapey = s.shapeArgs.y, s.shapeArgs.height = 1, y || (s.stackY ? s.shapeArgs.y = s.plotY + S.translate(s.stackY) : s.shapeArgs.y = s.plotY + (s.negative ? -s.height : s.height)));
              }) : (u.data.forEach(function(s) {
                s.y !== null && (s.shapeArgs.height = s.height, s.shapeArgs.y = s.shapey, s.graphic && s.graphic[s.outside3dPlot ? "attr" : "animate"](s.shapeArgs, u.options.animation));
              }), this.drawDataLabels()));
            } else
              x.apply(this, [].slice.call(arguments, 1));
          }), b(U, "plotGroup", function(x, E, P, S, u, y) {
            return E !== "dataLabelsGroup" && E !== "markerGroup" && this.chart.is3d() && (this[E] && delete this[E], y && (this.chart.columnGroup || (this.chart.columnGroup = this.chart.renderer.g("columnGroup").add(y)), this[E] = this.chart.columnGroup, this.chart.columnGroup.attr(this.getPlotBox()), this[E].survive = !0, E === "group" && (arguments[3] = "visible"))), x.apply(this, Array.prototype.slice.call(arguments, 1));
          }), b(U, "setVisible", function(x, E) {
            var P = this;
            P.chart.is3d() && P.data.forEach(function(S) {
              S.visible = S.options.visible = E = E === void 0 ? !A(P.visible, S.visible) : E, P.options.data[P.data.indexOf(S)] = S.options, S.graphic && S.graphic.attr({ visibility: E ? "visible" : "hidden" });
            }), x.apply(this, Array.prototype.slice.call(arguments, 1));
          }), k(G, "afterInit", function() {
            if (this.chart.is3d()) {
              var x = this.options, E = x.grouping, P = x.stacking, S = this.yAxis.options.reversedStacks, u = 0;
              if (E === void 0 || E) {
                var y = function(e, n) {
                  var o, i = e.series, c = { totalStacks: 0 }, l = 1;
                  return i.forEach(function(h) {
                    o = A(h.options.stack, n ? 0 : i.length - 1 - h.index), c[o] ? c[o].series.push(h) : (c[o] = { series: [h], position: l }, l++);
                  }), c.totalStacks = l + 1, c;
                }(this.chart, P), s = x.stack || 0, a = void 0;
                for (a = 0; a < y[s].series.length && y[s].series[a] !== this; a++)
                  ;
                u = 10 * (y.totalStacks - y[s].position) + (S ? a : -a), this.xAxis.reversed || (u = 10 * y.totalStacks - u);
              }
              x.depth = x.depth || 25, this.z = this.z || 0, x.zIndex = u;
            }
          }), b(U, "pointAttribs", d), b(U, "setState", m), b(U.pointClass.prototype, "hasNewShapeType", v), J.seriesTypes.columnRange) {
            var g = J.seriesTypes.columnrange.prototype;
            b(g, "pointAttribs", d), b(g, "setState", m), b(g.pointClass.prototype, "hasNewShapeType", v), g.plotGroup = U.plotGroup, g.setVisible = U.setVisible;
          }
          return b($.prototype, "alignDataLabel", function(x, E, P, S, u) {
            var y = this.chart;
            if (S.outside3dPlot = E.outside3dPlot, y.is3d() && this.is("column")) {
              var s = this, a = s.options, e = A(S.inside, !!s.options.stacking), n = y.options.chart.options3d, o = E.pointWidth / 2 || 0, i = { x: u.x + o, y: u.y, z: s.z + a.depth / 2 };
              y.inverted && (e && (u.width = 0, i.x += E.shapeArgs.height / 2), n.alpha >= 90 && n.alpha <= 270 && (i.y += E.shapeArgs.width)), i = D([i], y, !0, !1)[0], u.x = i.x - o, u.y = E.outside3dPlot ? -9e9 : i.y;
            }
            x.apply(this, [].slice.call(arguments, 1));
          }), b(Q.prototype, "getStackBox", function(x, E) {
            var P = x.apply(this, [].slice.call(arguments, 1)), S = this, u = this.axis.chart, y = E.width;
            if (u.is3d() && S.base) {
              var s = +S.base.split(",")[0], a = u.series[s], e = u.options.chart.options3d;
              if (a && a instanceof J.seriesTypes.column) {
                var n = { x: P.x + (u.inverted ? P.height : y / 2), y: P.y, z: a.options.depth / 2 };
                u.inverted && (P.width = 0, e.alpha >= 90 && e.alpha <= 270 && (n.y += y)), n = D([n], u, !0, !1)[0], P.x = n.x - y / 2, P.y = n.y;
              }
            }
            return P;
          }), G;
        }), at(_, "Series/Pie3D/Pie3DPoint.js", [_["Core/Series/SeriesRegistry.js"]], function(G) {
          var F, $ = this && this.__extends || (F = function(q, U) {
            return F = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(N, D) {
              N.__proto__ = D;
            } || function(N, D) {
              for (var k in D)
                D.hasOwnProperty(k) && (N[k] = D[k]);
            }, F(q, U);
          }, function(q, U) {
            function N() {
              this.constructor = q;
            }
            F(q, U), q.prototype = U === null ? Object.create(U) : (N.prototype = U.prototype, new N());
          }), Y = G.seriesTypes.pie.prototype.pointClass, J = Y.prototype.haloPath, Q = function(q) {
            function U() {
              var N = q !== null && q.apply(this, arguments) || this;
              return N.series = void 0, N;
            }
            return $(U, q), U.prototype.haloPath = function() {
              return this.series.chart.is3d() ? [] : J.apply(this, arguments);
            }, U;
          }(Y);
          return Q;
        }), at(_, "Series/Pie3D/Pie3DSeries.js", [_["Core/Globals.js"], _["Series/Pie3D/Pie3DPoint.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(b, d) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, J(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            J(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), q = G.deg2rad, U = G.svg, N = $.seriesTypes.pie, D = Y.extend, k = Y.pick, A = function(b) {
            function d() {
              return b !== null && b.apply(this, arguments) || this;
            }
            return Q(d, b), d.prototype.addPoint = function() {
              b.prototype.addPoint.apply(this, arguments), this.chart.is3d() && this.update(this.userOptions, !0);
            }, d.prototype.animate = function(m) {
              if (this.chart.is3d()) {
                var v = this.options.animation, g = void 0, x = this.center, E = this.group, P = this.markerGroup;
                U && (v === !0 && (v = {}), m ? (E.oldtranslateX = k(E.oldtranslateX, E.translateX), E.oldtranslateY = k(E.oldtranslateY, E.translateY), g = { translateX: x[0], translateY: x[1], scaleX: 1e-3, scaleY: 1e-3 }, E.attr(g), P && (P.attrSetters = E.attrSetters, P.attr(g))) : (g = { translateX: E.oldtranslateX, translateY: E.oldtranslateY, scaleX: 1, scaleY: 1 }, E.animate(g, v), P && P.animate(g, v)));
              } else
                b.prototype.animate.apply(this, arguments);
            }, d.prototype.drawDataLabels = function() {
              if (this.chart.is3d()) {
                var m = this, v = m.chart, g = v.options.chart.options3d;
                m.data.forEach(function(x) {
                  var E = x.shapeArgs, P = E.r, S = (E.alpha || g.alpha) * q, u = (E.beta || g.beta) * q, y = (E.start + E.end) / 2, s = x.labelPosition, a = s.connectorPosition, e = -P * (1 - Math.cos(S)) * Math.sin(y), n = P * (Math.cos(u) - 1) * Math.cos(y);
                  [s.natural, a.breakAt, a.touchingSliceAt].forEach(function(o) {
                    o.x += n, o.y += e;
                  });
                });
              }
              b.prototype.drawDataLabels.apply(this, arguments);
            }, d.prototype.pointAttribs = function(m) {
              var v = b.prototype.pointAttribs.apply(this, arguments), g = this.options;
              return this.chart.is3d() && !this.chart.styledMode && (v.stroke = g.edgeColor || m.color || this.color, v["stroke-width"] = k(g.edgeWidth, 1)), v;
            }, d.prototype.translate = function() {
              if (b.prototype.translate.apply(this, arguments), this.chart.is3d()) {
                var m = this, v = m.options, g = v.depth || 0, x = m.chart.options.chart.options3d, E = x.alpha, P = x.beta, S = v.stacking ? (v.stack || 0) * g : m._i * g;
                S += g / 2, v.grouping !== !1 && (S = 0), m.data.forEach(function(u) {
                  var y, s = u.shapeArgs;
                  u.shapeType = "arc3d", s.z = S, s.depth = 0.75 * g, s.alpha = E, s.beta = P, s.center = m.center, y = (s.end + s.start) / 2, u.slicedTranslation = { translateX: Math.round(Math.cos(y) * v.slicedOffset * Math.cos(E * q)), translateY: Math.round(Math.sin(y) * v.slicedOffset * Math.cos(E * q)) };
                });
              }
            }, d.prototype.drawTracker = function() {
              b.prototype.drawTracker.apply(this, arguments), this.chart.is3d() && this.points.forEach(function(m) {
                m.graphic && ["out", "inn", "side1", "side2"].forEach(function(v) {
                  m.graphic && (m.graphic[v].element.point = m);
                });
              });
            }, d;
          }(N);
          return D(A.prototype, { pointClass: F }), A;
        }), at(_, "Series/Pie3D/Pie3DComposition.js", [_["Series/Pie3D/Pie3DPoint.js"], _["Series/Pie3D/Pie3DSeries.js"], _["Core/Series/SeriesRegistry.js"]], function(G, F, $) {
          $.seriesTypes.pie.prototype.pointClass.prototype.haloPath = G.prototype.haloPath, $.seriesTypes.pie = F;
        }), at(_, "Series/Scatter3D/Scatter3DPoint.js", [_["Series/Scatter/ScatterSeries.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(q, U) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(N, D) {
              N.__proto__ = D;
            } || function(N, D) {
              for (var k in D)
                D.hasOwnProperty(k) && (N[k] = D[k]);
            }, $(q, U);
          }, function(q, U) {
            function N() {
              this.constructor = q;
            }
            $(q, U), q.prototype = U === null ? Object.create(U) : (N.prototype = U.prototype, new N());
          }), J = F.defined, Q = function(q) {
            function U() {
              var N = q !== null && q.apply(this, arguments) || this;
              return N.options = void 0, N.series = void 0, N;
            }
            return Y(U, q), U.prototype.applyOptions = function() {
              return q.prototype.applyOptions.apply(this, arguments), J(this.z) || (this.z = 0), this;
            }, U;
          }(G.prototype.pointClass);
          return Q;
        }), at(_, "Series/Scatter3D/Scatter3DSeries.js", [_["Core/Math3D.js"], _["Series/Scatter3D/Scatter3DPoint.js"], _["Series/Scatter/ScatterSeries.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q, q = this && this.__extends || (Q = function(A, b) {
            return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, m) {
              d.__proto__ = m;
            } || function(d, m) {
              for (var v in m)
                m.hasOwnProperty(v) && (d[v] = m[v]);
            }, Q(A, b);
          }, function(A, b) {
            function d() {
              this.constructor = A;
            }
            Q(A, b), A.prototype = b === null ? Object.create(b) : (d.prototype = b.prototype, new d());
          }), U = G.pointCameraDistance, N = J.extend, D = J.merge, k = function(A) {
            function b() {
              var d = A !== null && A.apply(this, arguments) || this;
              return d.data = void 0, d.options = void 0, d.points = void 0, d;
            }
            return q(b, A), b.prototype.pointAttribs = function(d) {
              var m = A.prototype.pointAttribs.apply(this, arguments);
              return this.chart.is3d() && d && (m.zIndex = U(d, this.chart)), m;
            }, b.defaultOptions = D($.defaultOptions, { tooltip: { pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>z: <b>{point.z}</b><br/>" } }), b;
          }($);
          return N(k.prototype, { axisTypes: ["xAxis", "yAxis", "zAxis"], directTouch: !0, parallelArrays: ["x", "y", "z"], pointArrayMap: ["x", "y", "z"], pointClass: F }), Y.registerSeriesType("scatter3d", k), k;
        }), at(_, "masters/highcharts-3d.src.js", [_["Core/Globals.js"], _["Core/Renderer/SVG/SVGRenderer3D.js"], _["Core/Chart/Chart3D.js"], _["Core/Axis/ZAxis.js"], _["Core/Axis/Axis3DComposition.js"], _["Series/Area3D/Area3DSeries.js"]], function(G, F, $, Y, J, Q) {
          var q = G;
          F.compose(q.SVGRenderer), $.compose(q.Chart, q.Fx), Y.compose(q.Chart), J.compose(q.Axis, q.Tick), Q.compose(q.seriesTypes.area);
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 7274: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Extensions/Pane.js", [_["Core/Chart/Chart.js"], _["Series/CenteredUtilities.js"], _["Core/Globals.js"], _["Core/Pointer.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = J.addEvent, q = J.correctFloat, U = J.defined, N = J.extend, D = J.merge, k = J.pick, A = J.splat;
          G.prototype.collectionsWithUpdate.push("pane");
          var b = function() {
            function m(v, g) {
              this.background = void 0, this.center = void 0, this.chart = void 0, this.options = void 0, this.coll = "pane", this.defaultOptions = { center: ["50%", "50%"], size: "85%", innerSize: "0%", startAngle: 0 }, this.defaultBackgroundOptions = { shape: "circle", borderWidth: 1, borderColor: "#cccccc", backgroundColor: { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, "#ffffff"], [1, "#e6e6e6"]] }, from: -Number.MAX_VALUE, innerRadius: 0, to: Number.MAX_VALUE, outerRadius: "105%" }, this.init(v, g);
            }
            return m.prototype.init = function(v, g) {
              this.chart = g, this.background = [], g.pane.push(this), this.setOptions(v);
            }, m.prototype.setOptions = function(v) {
              this.options = v = D(this.defaultOptions, this.chart.angular ? { background: {} } : void 0, v);
            }, m.prototype.render = function() {
              var v, g, x = this.options, E = this.options.background, P = this.chart.renderer;
              if (this.group || (this.group = P.g("pane-group").attr({ zIndex: x.zIndex || 0 }).add()), this.updateCenter(), E)
                for (E = A(E), v = Math.max(E.length, this.background.length || 0), g = 0; g < v; g++)
                  E[g] && this.axis ? this.renderBackground(D(this.defaultBackgroundOptions, E[g]), g) : this.background[g] && (this.background[g] = this.background[g].destroy(), this.background.splice(g, 1));
            }, m.prototype.renderBackground = function(v, g) {
              var x = "animate", E = { class: "highcharts-pane " + (v.className || "") };
              this.chart.styledMode || N(E, { fill: v.backgroundColor, stroke: v.borderColor, "stroke-width": v.borderWidth }), this.background[g] || (this.background[g] = this.chart.renderer.path().add(this.group), x = "attr"), this.background[g][x]({ d: this.axis.getPlotBandPath(v.from, v.to, v) }).attr(E);
            }, m.prototype.updateCenter = function(v) {
              this.center = (v || this.axis || {}).center = F.getCenter.call(this);
            }, m.prototype.update = function(v, g) {
              D(!0, this.options, v), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(x) {
                x.pane === this && (x.pane = null, x.update({}, g));
              }, this);
            }, m;
          }();
          function d(m, v, g, x, E) {
            var P = !0, S = g[0], u = g[1], y = Math.sqrt(Math.pow(m - S, 2) + Math.pow(v - u, 2));
            if (U(x) && U(E)) {
              var s = Math.atan2(q(v - u, 8), q(m - S, 8));
              E !== x && (P = x > E ? s >= x && s <= Math.PI || s <= E && s >= -Math.PI : s >= x && s <= q(E, 8));
            }
            return y <= Math.ceil(g[2] / 2) && P;
          }
          return G.prototype.getHoverPane = function(m) {
            var v, g = this;
            return m && g.pane.forEach(function(x) {
              d(m.chartX - g.plotLeft, m.chartY - g.plotTop, x.center) && (v = x);
            }), v;
          }, Q(G, "afterIsInsidePlot", function(m) {
            var v;
            this.polar && (m.options.inverted && (v = [m.y, m.x], m.x = v[0], m.y = v[1]), m.isInsidePlot = this.pane.some(function(g) {
              return d(m.x, m.y, g.center, g.axis && g.axis.normalizedStartAngleRad, g.axis && g.axis.normalizedEndAngleRad);
            }));
          }), Q(Y, "beforeGetHoverData", function(m) {
            var v = this.chart;
            v.polar ? (v.hoverPane = v.getHoverPane(m), m.filter = function(g) {
              return g.visible && !(!m.shared && g.directTouch) && k(g.options.enableMouseTracking, !0) && (!v.hoverPane || g.xAxis.pane === v.hoverPane);
            }) : v.hoverPane = void 0;
          }), Q(Y, "afterGetHoverData", function(m) {
            var v = this.chart;
            m.hoverPoint && m.hoverPoint.plotX && m.hoverPoint.plotY && v.hoverPane && !d(m.hoverPoint.plotX, m.hoverPoint.plotY, v.hoverPane.center) && (m.hoverPoint = void 0);
          }), $.Pane = b, $.Pane;
        }), at(_, "Series/AreaRange/AreaRangePoint.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(k, A) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
              b.__proto__ = d;
            } || function(b, d) {
              for (var m in d)
                d.hasOwnProperty(m) && (b[m] = d[m]);
            }, $(k, A);
          }, function(k, A) {
            function b() {
              this.constructor = k;
            }
            $(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
          }), J = G.seriesTypes.area.prototype, Q = J.pointClass, q = J.pointClass.prototype, U = F.defined, N = F.isNumber, D = function(k) {
            function A() {
              var b = k !== null && k.apply(this, arguments) || this;
              return b.high = void 0, b.low = void 0, b.options = void 0, b.plotX = void 0, b.series = void 0, b;
            }
            return Y(A, k), A.prototype.setState = function() {
              var b = this.state, d = this.series, m = d.chart.polar;
              U(this.plotHigh) || (this.plotHigh = d.yAxis.toPixels(this.high, !0)), U(this.plotLow) || (this.plotLow = this.plotY = d.yAxis.toPixels(this.low, !0)), d.stateMarkerGraphic && (d.lowerStateMarkerGraphic = d.stateMarkerGraphic, d.stateMarkerGraphic = d.upperStateMarkerGraphic), this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, m && N(this.plotHighX) && (this.plotX = this.plotHighX), q.setState.apply(this, arguments), this.state = b, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], m && N(this.plotLowX) && (this.plotX = this.plotLowX), d.stateMarkerGraphic && (d.upperStateMarkerGraphic = d.stateMarkerGraphic, d.stateMarkerGraphic = d.lowerStateMarkerGraphic, d.lowerStateMarkerGraphic = void 0), q.setState.apply(this, arguments);
            }, A.prototype.haloPath = function() {
              var b = this.series.chart.polar, d = [];
              return this.plotY = this.plotLow, b && N(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (d = q.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, b && N(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (d = d.concat(q.haloPath.apply(this, arguments))), d;
            }, A.prototype.isValid = function() {
              return N(this.low) && N(this.high);
            }, A;
          }(Q);
          return D;
        }), at(_, "Series/AreaRange/AreaRangeSeries.js", [_["Series/AreaRange/AreaRangePoint.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(S, u) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(y, s) {
              y.__proto__ = s;
            } || function(y, s) {
              for (var a in s)
                s.hasOwnProperty(a) && (y[a] = s[a]);
            }, J(S, u);
          }, function(S, u) {
            function y() {
              this.constructor = S;
            }
            J(S, u), S.prototype = u === null ? Object.create(u) : (y.prototype = u.prototype, new y());
          }), q = F.noop, U = $.seriesTypes, N = U.area, D = U.area.prototype, k = U.column.prototype, A = Y.addEvent, b = Y.defined, d = Y.extend, m = Y.isArray, v = Y.isNumber, g = Y.pick, x = Y.merge, E = { lineWidth: 1, threshold: null, tooltip: { pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, trackByArea: !0, dataLabels: { align: void 0, verticalAlign: void 0, xLow: 0, xHigh: 0, yLow: 0, yHigh: 0 } }, P = function(S) {
            function u() {
              var y = S !== null && S.apply(this, arguments) || this;
              return y.data = void 0, y.options = void 0, y.points = void 0, y.lowerStateMarkerGraphic = void 0, y.xAxis = void 0, y;
            }
            return Q(u, S), u.prototype.toYData = function(y) {
              return [y.low, y.high];
            }, u.prototype.highToXY = function(y) {
              var s = this.chart, a = this.xAxis.postTranslate(y.rectPlotX || 0, this.yAxis.len - (y.plotHigh || 0));
              y.plotHighX = a.x - s.plotLeft, y.plotHigh = a.y - s.plotTop, y.plotLowX = y.plotX;
            }, u.prototype.getGraphPath = function(y) {
              var s, a, e, n = [], o = [], i = D.getGraphPath, c = this.options, l = this.chart.polar, h = l && c.connectEnds !== !1, C = c.connectNulls, M = c.step;
              for (s = (y = y || this.points).length; s--; ) {
                a = y[s];
                var O = l ? { plotX: a.rectPlotX, plotY: a.yBottom, doCurve: !1 } : { plotX: a.plotX, plotY: a.plotY, doCurve: !1 };
                a.isNull || h || C || y[s + 1] && !y[s + 1].isNull || o.push(O), e = { polarPlotY: a.polarPlotY, rectPlotX: a.rectPlotX, yBottom: a.yBottom, plotX: g(a.plotHighX, a.plotX), plotY: a.plotHigh, isNull: a.isNull }, o.push(e), n.push(e), a.isNull || h || C || y[s - 1] && !y[s - 1].isNull || o.push(O);
              }
              var p = i.call(this, y);
              M && (M === !0 && (M = "left"), c.step = { left: "right", center: "center", right: "left" }[M]);
              var w = i.call(this, n), T = i.call(this, o);
              c.step = M;
              var z = [].concat(p, w);
              return !this.chart.polar && T[0] && T[0][0] === "M" && (T[0] = ["L", T[0][1], T[0][2]]), this.graphPath = z, this.areaPath = p.concat(T), z.isArea = !0, z.xMap = p.xMap, this.areaPath.xMap = p.xMap, z;
            }, u.prototype.drawDataLabels = function() {
              var y, s, a, e, n, o = this.points, i = o.length, c = [], l = this.options.dataLabels, h = this.chart.inverted;
              if (l) {
                if (m(l) ? (e = l[0] || { enabled: !1 }, n = l[1] || { enabled: !1 }) : ((e = d({}, l)).x = l.xHigh, e.y = l.yHigh, (n = d({}, l)).x = l.xLow, n.y = l.yLow), e.enabled || this._hasPointLabels) {
                  for (y = i; y--; )
                    if (s = o[y]) {
                      var C = s.plotHigh, M = C === void 0 ? 0 : C, O = s.plotLow, p = O === void 0 ? 0 : O;
                      a = e.inside ? M < p : M > p, s.y = s.high, s._plotY = s.plotY, s.plotY = M, c[y] = s.dataLabel, s.dataLabel = s.dataLabelUpper, s.below = a, h ? e.align || (e.align = a ? "right" : "left") : e.verticalAlign || (e.verticalAlign = a ? "top" : "bottom");
                    }
                  for (this.options.dataLabels = e, D.drawDataLabels && D.drawDataLabels.apply(this, arguments), y = i; y--; )
                    (s = o[y]) && (s.dataLabelUpper = s.dataLabel, s.dataLabel = c[y], delete s.dataLabels, s.y = s.low, s.plotY = s._plotY);
                }
                if (n.enabled || this._hasPointLabels) {
                  for (y = i; y--; )
                    if (s = o[y]) {
                      var w = s.plotHigh, T = (M = w === void 0 ? 0 : w, s.plotLow);
                      p = T === void 0 ? 0 : T, a = n.inside ? M < p : M > p, s.below = !a, h ? n.align || (n.align = a ? "left" : "right") : n.verticalAlign || (n.verticalAlign = a ? "bottom" : "top");
                    }
                  this.options.dataLabels = n, D.drawDataLabels && D.drawDataLabels.apply(this, arguments);
                }
                if (e.enabled)
                  for (y = i; y--; )
                    (s = o[y]) && (s.dataLabels = [s.dataLabelUpper, s.dataLabel].filter(function(z) {
                      return !!z;
                    }));
                this.options.dataLabels = l;
              }
            }, u.prototype.alignDataLabel = function() {
              k.alignDataLabel.apply(this, arguments);
            }, u.prototype.drawPoints = function() {
              var y, s, a = this, e = a.points.length;
              for (D.drawPoints.apply(a, arguments), y = 0; y < e; )
                (s = a.points[y]).graphics = s.graphics || [], s.origProps = { plotY: s.plotY, plotX: s.plotX, isInside: s.isInside, negative: s.negative, zone: s.zone, y: s.y }, (s.graphic || s.graphics[0]) && (s.graphics[0] = s.graphic), s.graphic = s.graphics[1], s.plotY = s.plotHigh, b(s.plotHighX) && (s.plotX = s.plotHighX), s.y = g(s.high, s.origProps.y), s.negative = s.y < (a.options.threshold || 0), a.zones.length && (s.zone = s.getZone()), a.chart.polar || (s.isInside = s.isTopInside = s.plotY !== void 0 && s.plotY >= 0 && s.plotY <= a.yAxis.len && s.plotX >= 0 && s.plotX <= a.xAxis.len), y++;
              for (D.drawPoints.apply(a, arguments), y = 0; y < e; )
                (s = a.points[y]).graphics = s.graphics || [], (s.graphic || s.graphics[1]) && (s.graphics[1] = s.graphic), s.graphic = s.graphics[0], s.origProps && (d(s, s.origProps), delete s.origProps), y++;
            }, u.defaultOptions = x(N.defaultOptions, E), u;
          }(N);
          return A(P, "afterTranslate", function() {
            var S = this;
            this.pointArrayMap.join(",") === "low,high" && this.points.forEach(function(u) {
              var y = u.high, s = u.plotY;
              u.isNull ? u.plotY = void 0 : (u.plotLow = s, u.plotHigh = v(y) ? S.yAxis.translate(S.dataModify ? S.dataModify.modifyValue(y) : y, !1, !0, void 0, !0) : void 0, S.dataModify && (u.yBottom = u.plotHigh));
            });
          }, { order: 0 }), A(P, "afterTranslate", function() {
            var S = this;
            this.points.forEach(function(u) {
              if (S.chart.polar)
                S.highToXY(u), u.plotLow = u.plotY, u.tooltipPos = [((u.plotHighX || 0) + (u.plotLowX || 0)) / 2, ((u.plotHigh || 0) + (u.plotLow || 0)) / 2];
              else {
                var y = u.pos(!1, u.plotLow), s = u.pos(!1, u.plotHigh);
                y && s && (y[0] = (y[0] + s[0]) / 2, y[1] = (y[1] + s[1]) / 2), u.tooltipPos = y;
              }
            });
          }, { order: 3 }), d(P.prototype, { deferTranslatePolar: !0, pointArrayMap: ["low", "high"], pointClass: G, pointValKey: "low", setStackedPoints: q }), $.registerSeriesType("arearange", P), P;
        }), at(_, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [_["Series/AreaRange/AreaRangeSeries.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(D, k) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, b) {
              A.__proto__ = b;
            } || function(A, b) {
              for (var d in b)
                b.hasOwnProperty(d) && (A[d] = b[d]);
            }, Y(D, k);
          }, function(D, k) {
            function A() {
              this.constructor = D;
            }
            Y(D, k), D.prototype = k === null ? Object.create(k) : (A.prototype = k.prototype, new A());
          }), Q = F.seriesTypes.spline.prototype, q = $.merge, U = $.extend, N = function(D) {
            function k() {
              var A = D !== null && D.apply(this, arguments) || this;
              return A.options = void 0, A.data = void 0, A.points = void 0, A;
            }
            return J(k, D), k.defaultOptions = q(G.defaultOptions), k;
          }(G);
          return U(N.prototype, { getPointSpline: Q.getPointSpline }), F.registerSeriesType("areasplinerange", N), N;
        }), at(_, "Series/BoxPlot/BoxPlotSeries.js", [_["Series/Column/ColumnSeries.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(A, b) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, m) {
              d.__proto__ = m;
            } || function(d, m) {
              for (var v in m)
                m.hasOwnProperty(v) && (d[v] = m[v]);
            }, J(A, b);
          }, function(A, b) {
            function d() {
              this.constructor = A;
            }
            J(A, b), A.prototype = b === null ? Object.create(b) : (d.prototype = b.prototype, new d());
          }), q = F.noop, U = Y.extend, N = Y.merge, D = Y.pick, k = function(A) {
            function b() {
              var d = A !== null && A.apply(this, arguments) || this;
              return d.data = void 0, d.options = void 0, d.points = void 0, d;
            }
            return Q(b, A), b.prototype.pointAttribs = function() {
              return {};
            }, b.prototype.translate = function() {
              var d = this, m = d.yAxis, v = d.pointArrayMap;
              A.prototype.translate.apply(d), d.points.forEach(function(g) {
                v.forEach(function(x) {
                  g[x] !== null && (g[x + "Plot"] = m.translate(g[x], 0, 1, 0, 1));
                }), g.plotHigh = g.highPlot;
              });
            }, b.prototype.drawPoints = function() {
              var d, m, v, g, x, E, P, S, u, y, s, a = this, e = a.points, n = a.options, o = a.chart, i = o.renderer, c = 0, l = a.doQuartiles !== !1, h = a.options.whiskerLength;
              e.forEach(function(C) {
                var M = C.graphic, O = M ? "animate" : "attr", p = C.shapeArgs, w = {}, T = {}, z = {}, W = {}, L = C.color || a.color;
                if (C.plotY !== void 0) {
                  P = Math.round(p.width), S = Math.floor(p.x), u = S + P, y = Math.round(P / 2), d = Math.floor(l ? C.q1Plot : C.lowPlot), m = Math.floor(l ? C.q3Plot : C.lowPlot), v = Math.floor(C.highPlot), g = Math.floor(C.lowPlot), M || (C.graphic = M = i.g("point").add(a.group), C.stem = i.path().addClass("highcharts-boxplot-stem").add(M), h && (C.whiskers = i.path().addClass("highcharts-boxplot-whisker").add(M)), l && (C.box = i.path(void 0).addClass("highcharts-boxplot-box").add(M)), C.medianShape = i.path(void 0).addClass("highcharts-boxplot-median").add(M)), o.styledMode || (T.stroke = C.stemColor || n.stemColor || L, T["stroke-width"] = D(C.stemWidth, n.stemWidth, n.lineWidth), T.dashstyle = C.stemDashStyle || n.stemDashStyle || n.dashStyle, C.stem.attr(T), h && (z.stroke = C.whiskerColor || n.whiskerColor || L, z["stroke-width"] = D(C.whiskerWidth, n.whiskerWidth, n.lineWidth), z.dashstyle = C.whiskerDashStyle || n.whiskerDashStyle || n.dashStyle, C.whiskers.attr(z)), l && (w.fill = C.fillColor || n.fillColor || L, w.stroke = n.lineColor || L, w["stroke-width"] = n.lineWidth || 0, w.dashstyle = C.boxDashStyle || n.boxDashStyle || n.dashStyle, C.box.attr(w)), W.stroke = C.medianColor || n.medianColor || L, W["stroke-width"] = D(C.medianWidth, n.medianWidth, n.lineWidth), W.dashstyle = C.medianDashStyle || n.medianDashStyle || n.dashStyle, C.medianShape.attr(W));
                  var I = void 0;
                  E = C.stem.strokeWidth() % 2 / 2, I = [["M", c = S + y + E, m], ["L", c, v], ["M", c, d], ["L", c, g]], C.stem[O]({ d: I }), l && (E = C.box.strokeWidth() % 2 / 2, d = Math.floor(d) + E, m = Math.floor(m) + E, I = [["M", S += E, m], ["L", S, d], ["L", u += E, d], ["L", u, m], ["L", S, m], ["Z"]], C.box[O]({ d: I })), h && (E = C.whiskers.strokeWidth() % 2 / 2, v += E, g += E, s = /%$/.test(h) ? y * parseFloat(h) / 100 : h / 2, I = [["M", c - s, v], ["L", c + s, v], ["M", c - s, g], ["L", c + s, g]], C.whiskers[O]({ d: I })), x = Math.round(C.medianPlot), E = C.medianShape.strokeWidth() % 2 / 2, I = [["M", S, x += E], ["L", u, x]], C.medianShape[O]({ d: I });
                }
              });
            }, b.prototype.toYData = function(d) {
              return [d.low, d.q1, d.median, d.q3, d.high];
            }, b.defaultOptions = N(G.defaultOptions, { threshold: null, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>' }, whiskerLength: "50%", fillColor: "#ffffff", lineWidth: 1, medianWidth: 2, whiskerWidth: 2 }), b;
          }(G);
          return U(k.prototype, { pointArrayMap: ["low", "q1", "median", "q3", "high"], pointValKey: "high", drawDataLabels: q, setStackedPoints: q }), $.registerSeriesType("boxplot", k), k;
        }), at(_, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
          return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "10px", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
        }), at(_, "Series/Bubble/BubbleLegendItem.js", [_["Core/Color/Color.js"], _["Core/FormatUtilities.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = G.parse, Q = $.noop, q = Y.arrayMax, U = Y.arrayMin, N = Y.isNumber, D = Y.merge, k = Y.pick, A = Y.stableSort;
          return function() {
            function b(d, m) {
              this.chart = void 0, this.fontMetrics = void 0, this.legend = void 0, this.maxLabel = void 0, this.movementX = void 0, this.ranges = void 0, this.selected = void 0, this.visible = void 0, this.symbols = void 0, this.options = void 0, this.setState = Q, this.init(d, m);
            }
            return b.prototype.init = function(d, m) {
              this.options = d, this.visible = !0, this.chart = m.chart, this.legend = m;
            }, b.prototype.addToLegend = function(d) {
              d.splice(this.options.legendIndex, 0, this);
            }, b.prototype.drawLegendSymbol = function(d) {
              var m, v = this.chart, g = k(d.options.itemDistance, 20), x = this.legendItem || {}, E = this.options, P = E.ranges, S = E.connectorDistance;
              if (this.fontMetrics = v.renderer.fontMetrics(E.labels.style.fontSize), P && P.length && N(P[0].value)) {
                A(P, function(a, e) {
                  return e.value - a.value;
                }), this.ranges = P, this.setOptions(), this.render();
                var u = this.getMaxLabelSize(), y = this.ranges[0].radius, s = 2 * y;
                m = (m = S - y + u.width) > 0 ? m : 0, this.maxLabel = u, this.movementX = E.labels.align === "left" ? m : 0, x.labelWidth = s + m + g, x.labelHeight = s + this.fontMetrics.h / 2;
              } else
                d.options.bubbleLegend.autoRanges = !0;
            }, b.prototype.setOptions = function() {
              var d = this.ranges, m = this.options, v = this.chart.series[m.seriesIndex], g = this.legend.baseline, x = { zIndex: m.zIndex, "stroke-width": m.borderWidth }, E = { zIndex: m.zIndex, "stroke-width": m.connectorWidth }, P = { align: this.legend.options.rtl || m.labels.align === "left" ? "right" : "left", zIndex: m.zIndex }, S = v.options.marker.fillOpacity, u = this.chart.styledMode;
              d.forEach(function(y, s) {
                u || (x.stroke = k(y.borderColor, m.borderColor, v.color), x.fill = k(y.color, m.color, S !== 1 ? J(v.color).setOpacity(S).get("rgba") : v.color), E.stroke = k(y.connectorColor, m.connectorColor, v.color)), d[s].radius = this.getRangeRadius(y.value), d[s] = D(d[s], { center: d[0].radius - d[s].radius + g }), u || D(!0, d[s], { bubbleAttribs: D(x), connectorAttribs: D(E), labelAttribs: P });
              }, this);
            }, b.prototype.getRangeRadius = function(d) {
              var m = this.options, v = this.options.seriesIndex, g = this.chart.series[v], x = m.ranges[0].value, E = m.ranges[m.ranges.length - 1].value, P = m.minSize, S = m.maxSize;
              return g.getRadius.call(this, E, x, P, S, d);
            }, b.prototype.render = function() {
              var d = this.legendItem || {}, m = this.chart.renderer, v = this.options.zThreshold;
              this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), d.symbol = m.g("bubble-legend"), d.label = m.g("bubble-legend-item"), d.symbol.translateX = 0, d.symbol.translateY = 0;
              for (var g = 0, x = this.ranges; g < x.length; g++) {
                var E = x[g];
                E.value >= v && this.renderRange(E);
              }
              d.symbol.add(d.label), d.label.add(d.group), this.hideOverlappingLabels();
            }, b.prototype.renderRange = function(d) {
              var m = this.ranges[0], v = this.legend, g = this.options, x = g.labels, E = this.chart, P = E.series[g.seriesIndex], S = E.renderer, u = this.symbols, y = u.labels, s = d.center, a = Math.abs(d.radius), e = g.connectorDistance || 0, n = x.align, o = v.options.rtl, i = g.borderWidth, c = g.connectorWidth, l = m.radius || 0, h = s - a - i / 2 + c / 2, C = this.fontMetrics, M = C.f / 2 - (C.h - C.f) / 2, O = (h % 1 ? 1 : 0.5) - (c % 2 ? 0 : 0.5), p = S.styledMode, w = o || n === "left" ? -e : e;
              n === "center" && (w = 0, g.connectorDistance = 0, d.labelAttribs.align = "center");
              var T = h + g.labels.y, z = l + w + g.labels.x;
              u.bubbleItems.push(S.circle(l, s + O, a).attr(p ? {} : d.bubbleAttribs).addClass((p ? "highcharts-color-" + P.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (g.className || "")).add(this.legendItem.symbol)), u.connectors.push(S.path(S.crispLine([["M", l, h], ["L", l + w, h]], g.connectorWidth)).attr(p ? {} : d.connectorAttribs).addClass((p ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (g.connectorClassName || "")).add(this.legendItem.symbol));
              var W = S.text(this.formatLabel(d), z, T + M).attr(p ? {} : d.labelAttribs).css(p ? {} : x.style).addClass("highcharts-bubble-legend-labels " + (g.labels.className || "")).add(this.legendItem.symbol);
              y.push(W), W.placed = !0, W.alignAttr = { x: z, y: T + M };
            }, b.prototype.getMaxLabelSize = function() {
              var d, m;
              return this.symbols.labels.forEach(function(v) {
                m = v.getBBox(!0), d = d ? m.width > d.width ? m : d : m;
              }), d || {};
            }, b.prototype.formatLabel = function(d) {
              var m = this.options, v = m.labels.formatter, g = m.labels.format, x = this.chart.numberFormatter;
              return g ? F.format(g, d) : v ? v.call(d) : x(d.value, 1);
            }, b.prototype.hideOverlappingLabels = function() {
              var d = this.chart, m = this.options.labels.allowOverlap, v = this.symbols;
              !m && v && (d.hideOverlappingLabels(v.labels), v.labels.forEach(function(g, x) {
                g.newOpacity ? g.newOpacity !== g.oldOpacity && v.connectors[x].show() : v.connectors[x].hide();
              }));
            }, b.prototype.getRanges = function() {
              var d, m, v = this.legend.bubbleLegend, g = v.chart.series, x = v.options.ranges, E = Number.MAX_VALUE, P = -Number.MAX_VALUE;
              return g.forEach(function(S) {
                S.isBubble && !S.ignoreSeries && (m = S.zData.filter(N)).length && (E = k(S.options.zMin, Math.min(E, Math.max(U(m), S.options.displayNegative === !1 ? S.options.zThreshold : -Number.MAX_VALUE))), P = k(S.options.zMax, Math.max(P, q(m))));
              }), d = E === P ? [{ value: P }] : [{ value: E }, { value: (E + P) / 2 }, { value: P, autoRanges: !0 }], x.length && x[0].radius && d.reverse(), d.forEach(function(S, u) {
                x && x[u] && (d[u] = D(x[u], S));
              }), d;
            }, b.prototype.predictBubbleSizes = function() {
              var d, m = this.chart, v = this.fontMetrics, g = m.legend.options, x = g.floating, E = g.layout === "horizontal", P = E ? m.legend.lastLineHeight : 0, S = m.plotSizeX, u = m.plotSizeY, y = m.series[this.options.seriesIndex], s = y.getPxExtremes(), a = Math.ceil(s.minPxSize), e = Math.ceil(s.maxPxSize), n = Math.min(u, S), o = y.options.maxSize;
              return x || !/%$/.test(o) ? d = e : (o = parseFloat(o), d = (n + P - v.h / 2) * o / 100 / (o / 100 + 1), (E && u - d >= S || !E && S - d >= u) && (d = e)), [a, Math.ceil(d)];
            }, b.prototype.updateRanges = function(d, m) {
              var v = this.legend.options.bubbleLegend;
              v.minSize = d, v.maxSize = m, v.ranges = this.getRanges();
            }, b.prototype.correctSizes = function() {
              var d = this.legend, m = this.chart.series[this.options.seriesIndex].getPxExtremes(), v = m.maxPxSize, g = this.options.maxSize;
              Math.abs(Math.ceil(v) - g) > 1 && (this.updateRanges(this.options.minSize, m.maxPxSize), d.render());
            }, b;
          }();
        }), at(_, "Series/Bubble/BubbleLegendComposition.js", [_["Series/Bubble/BubbleLegendDefaults.js"], _["Series/Bubble/BubbleLegendItem.js"], _["Core/Defaults.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = $.setOptions, Q = Y.addEvent, q = Y.objectEach, U = Y.wrap, N = [];
          function D(v, g, x) {
            var E, P, S, u = this, y = u.legend, s = k(u) >= 0;
            y && y.options.enabled && y.bubbleLegend && y.options.bubbleLegend.autoRanges && s ? (E = y.bubbleLegend.options, P = y.bubbleLegend.predictBubbleSizes(), y.bubbleLegend.updateRanges(P[0], P[1]), E.placed || (y.group.placed = !1, y.allItems.forEach(function(a) {
              (S = a.legendItem || {}).group && (S.group.translateY = null);
            })), y.render(), u.getMargins(), u.axes.forEach(function(a) {
              a.visible && a.render(), E.placed || (a.setScale(), a.updateNames(), q(a.ticks, function(e) {
                e.isNew = !0, e.isNewLabel = !0;
              }));
            }), E.placed = !0, u.getMargins(), v.call(u, g, x), y.bubbleLegend.correctSizes(), m(y, A(y))) : (v.call(u, g, x), y && y.options.enabled && y.bubbleLegend && (y.render(), m(y, A(y))));
          }
          function k(v) {
            for (var g = v.series, x = 0; x < g.length; ) {
              if (g[x] && g[x].isBubble && g[x].visible && g[x].zData.length)
                return x;
              x++;
            }
            return -1;
          }
          function A(v) {
            var g, x, E, P = v.allItems, S = [], u = P.length, y = 0, s = 0;
            for (y = 0; y < u; y++)
              if (x = P[y].legendItem || {}, E = (P[y + 1] || {}).legendItem || {}, x.labelHeight && (P[y].itemHeight = x.labelHeight), P[y] === P[u - 1] || x.y !== E.y) {
                for (S.push({ height: 0 }), g = S[S.length - 1]; s <= y; s++)
                  P[s].itemHeight > g.height && (g.height = P[s].itemHeight);
                g.step = y;
              }
            return S;
          }
          function b(v) {
            var g = this, x = g.bubbleLegend, E = g.options, P = E.bubbleLegend, S = k(g.chart);
            x && x.ranges && x.ranges.length && (P.ranges.length && (P.autoRanges = !!P.ranges[0].autoRanges), g.destroyItem(x)), S >= 0 && E.enabled && P.enabled && (P.seriesIndex = S, g.bubbleLegend = new F(P, g), g.bubbleLegend.addToLegend(v.allItems));
          }
          function d() {
            var v, g = this, x = g.chart, E = g.visible, P = g.chart.legend;
            P && P.bubbleLegend && (g.visible = !E, g.ignoreSeries = E, v = k(x) >= 0, P.bubbleLegend.visible !== v && (P.update({ bubbleLegend: { enabled: v } }), P.bubbleLegend.visible = v), g.visible = E);
          }
          function m(v, g) {
            var x, E, P, S, u = v.allItems, y = v.options.rtl, s = 0;
            u.forEach(function(a, e) {
              (S = a.legendItem || {}).group && (x = S.group.translateX || 0, E = S.y || 0, ((P = a.movementX) || y && a.ranges) && (P = y ? x - a.options.maxSize / 2 : x + P, S.group.attr({ translateX: P })), e > g[s].step && s++, S.group.attr({ translateY: Math.round(E + g[s].height / 2) }), S.y = E + g[s].height / 2);
            });
          }
          return { compose: function(v, g, x) {
            N.indexOf(v) === -1 && (N.push(v), J({ legend: { bubbleLegend: G } }), U(v.prototype, "drawChartBox", D)), N.indexOf(g) === -1 && (N.push(g), Q(g, "afterGetAllItems", b)), N.indexOf(x) === -1 && (N.push(x), Q(x, "legendItemClick", d));
          } };
        }), at(_, "Series/Bubble/BubblePoint.js", [_["Core/Series/Point.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(N, D) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, A) {
              k.__proto__ = A;
            } || function(k, A) {
              for (var b in A)
                A.hasOwnProperty(b) && (k[b] = A[b]);
            }, Y(N, D);
          }, function(N, D) {
            function k() {
              this.constructor = N;
            }
            Y(N, D), N.prototype = D === null ? Object.create(D) : (k.prototype = D.prototype, new k());
          }), Q = F.seriesTypes.scatter.prototype.pointClass, q = $.extend, U = function(N) {
            function D() {
              var k = N !== null && N.apply(this, arguments) || this;
              return k.options = void 0, k.series = void 0, k;
            }
            return J(D, N), D.prototype.haloPath = function(k) {
              return G.prototype.haloPath.call(this, k === 0 ? 0 : (this.marker && this.marker.radius || 0) + k);
            }, D;
          }(Q);
          return q(U.prototype, { ttBelow: !1 }), U;
        }), at(_, "Series/Bubble/BubbleSeries.js", [_["Series/Bubble/BubbleLegendComposition.js"], _["Series/Bubble/BubblePoint.js"], _["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q, U = this && this.__extends || (q = function(e, n) {
            return q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, i) {
              o.__proto__ = i;
            } || function(o, i) {
              for (var c in i)
                i.hasOwnProperty(c) && (o[c] = i[c]);
            }, q(e, n);
          }, function(e, n) {
            function o() {
              this.constructor = e;
            }
            q(e, n), e.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
          }), N = $.parse, D = Y.noop, k = J.series, A = J.seriesTypes, b = A.column.prototype, d = A.scatter, m = Q.addEvent, v = Q.arrayMax, g = Q.arrayMin, x = Q.clamp, E = Q.extend, P = Q.isNumber, S = Q.merge, u = Q.pick, y = [];
          function s() {
            var e, n = this, o = this.len, i = this.chart, c = this.isXAxis, l = c ? "xData" : "yData", h = this.min, C = this.max - h, M = 0, O = o, p = o / C;
            this.series.forEach(function(w) {
              if (w.bubblePadding && (w.visible || !i.options.chart.ignoreHiddenSeries)) {
                n.allowZoomOutside = !0, e = !0;
                var T = w[l];
                if (c && ((w.onPoint || w).getRadii(0, 0, w), w.onPoint && (w.radii = w.onPoint.radii)), C > 0) {
                  for (var z = T.length; z--; )
                    if (P(T[z]) && n.dataMin <= T[z] && T[z] <= n.max) {
                      var W = w.radii && w.radii[z] || 0;
                      M = Math.min((T[z] - h) * p - W, M), O = Math.max((T[z] - h) * p + W, O);
                    }
                }
              }
            }), e && C > 0 && !this.logarithmic && (O -= o, p *= (o + Math.max(0, M) - Math.min(O, o)) / o, [["min", "userMin", M], ["max", "userMax", O]].forEach(function(w) {
              u(n.options[w[0]], n[w[1]]) === void 0 && (n[w[0]] += w[2] / p);
            }));
          }
          var a = function(e) {
            function n() {
              var o = e !== null && e.apply(this, arguments) || this;
              return o.data = void 0, o.maxPxSize = void 0, o.minPxSize = void 0, o.options = void 0, o.points = void 0, o.radii = void 0, o.yData = void 0, o.zData = void 0, o;
            }
            return U(n, e), n.compose = function(o, i, c, l) {
              G.compose(i, c, l), y.indexOf(o) === -1 && (y.push(o), o.prototype.beforePadding = s);
            }, n.prototype.animate = function(o) {
              !o && this.points.length < this.options.animationLimit && this.points.forEach(function(i) {
                var c = i.graphic;
                c && c.width && (this.hasRendered || c.attr({ x: i.plotX, y: i.plotY, width: 1, height: 1 }), c.animate(this.markerAttribs(i), this.options.animation));
              }, this);
            }, n.prototype.getRadii = function() {
              var o, i, c, l = this, h = this.zData, C = this.yData, M = [], O = this.chart.bubbleZExtremes, p = this.getPxExtremes(), w = p.minPxSize, T = p.maxPxSize;
              if (!O) {
                var z, W = Number.MAX_VALUE, L = -Number.MAX_VALUE;
                this.chart.series.forEach(function(I) {
                  if (I.bubblePadding && (I.visible || !l.chart.options.chart.ignoreHiddenSeries)) {
                    var j = (I.onPoint || I).getZExtremes();
                    j && (W = Math.min(W || j.zMin, j.zMin), L = Math.max(L || j.zMax, j.zMax), z = !0);
                  }
                }), z ? (O = { zMin: W, zMax: L }, this.chart.bubbleZExtremes = O) : O = { zMin: 0, zMax: 0 };
              }
              for (i = 0, o = h.length; i < o; i++)
                c = h[i], M.push(this.getRadius(O.zMin, O.zMax, w, T, c, C && C[i]));
              this.radii = M;
            }, n.prototype.getRadius = function(o, i, c, l, h, C) {
              var M = this.options, O = M.sizeBy !== "width", p = M.zThreshold, w = i - o, T = 0.5;
              if (C === null || h === null)
                return null;
              if (P(h)) {
                if (M.sizeByAbsoluteValue && (h = Math.abs(h - p), i = w = Math.max(i - p, Math.abs(o - p)), o = 0), h < o)
                  return c / 2 - 1;
                w > 0 && (T = (h - o) / w);
              }
              return O && T >= 0 && (T = Math.sqrt(T)), Math.ceil(c + T * (l - c)) / 2;
            }, n.prototype.hasData = function() {
              return !!this.processedXData.length;
            }, n.prototype.pointAttribs = function(o, i) {
              var c = this.options.marker.fillOpacity, l = k.prototype.pointAttribs.call(this, o, i);
              return c !== 1 && (l.fill = N(l.fill).setOpacity(c).get("rgba")), l;
            }, n.prototype.translate = function() {
              e.prototype.translate.call(this), this.getRadii(), this.translateBubble();
            }, n.prototype.translateBubble = function() {
              for (var o = this.data, i = this.radii, c = this.getPxExtremes().minPxSize, l = o.length; l--; ) {
                var h = o[l], C = i ? i[l] : 0;
                P(C) && C >= c / 2 ? (h.marker = E(h.marker, { radius: C, width: 2 * C, height: 2 * C }), h.dlBox = { x: h.plotX - C, y: h.plotY - C, width: 2 * C, height: 2 * C }) : (h.shapeArgs = h.plotY = h.dlBox = void 0, h.isInside = !1);
              }
            }, n.prototype.getPxExtremes = function() {
              var o = Math.min(this.chart.plotWidth, this.chart.plotHeight), i = function(l) {
                var h;
                return typeof l == "string" && (h = /%$/.test(l), l = parseInt(l, 10)), h ? o * l / 100 : l;
              }, c = i(u(this.options.minSize, 8));
              return { minPxSize: c, maxPxSize: Math.max(i(u(this.options.maxSize, "20%")), c) };
            }, n.prototype.getZExtremes = function() {
              var o = this.options, i = (this.zData || []).filter(P);
              if (i.length) {
                var c = u(o.zMin, x(g(i), o.displayNegative === !1 ? o.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), l = u(o.zMax, v(i));
                if (P(c) && P(l))
                  return { zMin: c, zMax: l };
              }
            }, n.defaultOptions = S(d.defaultOptions, { dataLabels: { formatter: function() {
              var o = this.series.chart.numberFormatter, i = this.point.z;
              return P(i) ? o(i, -1) : "";
            }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), n;
          }(d);
          return E(a.prototype, { alignDataLabel: b.alignDataLabel, applyZones: D, bubblePadding: !0, buildKDTree: D, directTouch: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: F, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), m(a, "updatedData", function(e) {
            delete e.target.chart.bubbleZExtremes;
          }), m(a, "remove", function(e) {
            delete e.target.chart.bubbleZExtremes;
          }), J.registerSeriesType("bubble", a), a;
        }), at(_, "Series/ColumnRange/ColumnRangePoint.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(k, A) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
              b.__proto__ = d;
            } || function(b, d) {
              for (var m in d)
                d.hasOwnProperty(m) && (b[m] = d[m]);
            }, $(k, A);
          }, function(k, A) {
            function b() {
              this.constructor = k;
            }
            $(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
          }), J = G.seriesTypes, Q = J.column.prototype.pointClass.prototype, q = J.arearange.prototype.pointClass, U = F.extend, N = F.isNumber, D = function(k) {
            function A() {
              var b = k !== null && k.apply(this, arguments) || this;
              return b.options = void 0, b.series = void 0, b;
            }
            return Y(A, k), A.prototype.isValid = function() {
              return N(this.low);
            }, A;
          }(q);
          return U(D.prototype, { setState: Q.setState }), D;
        }), at(_, "Series/ColumnRange/ColumnRangeSeries.js", [_["Series/ColumnRange/ColumnRangePoint.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(E, P) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(S, u) {
              S.__proto__ = u;
            } || function(S, u) {
              for (var y in u)
                u.hasOwnProperty(y) && (S[y] = u[y]);
            }, J(E, P);
          }, function(E, P) {
            function S() {
              this.constructor = E;
            }
            J(E, P), E.prototype = P === null ? Object.create(P) : (S.prototype = P.prototype, new S());
          }), q = F.noop, U = $.seriesTypes, N = U.arearange, D = U.column, k = U.column.prototype, A = Y.clamp, b = Y.extend, d = Y.isNumber, m = Y.merge, v = Y.pick, g = { pointRange: null, marker: null, states: { hover: { halo: !1 } } }, x = function(E) {
            function P() {
              return E !== null && E.apply(this, arguments) || this;
            }
            return Q(P, E), P.prototype.setOptions = function() {
              return m(!0, arguments[0], { stacking: void 0 }), N.prototype.setOptions.apply(this, arguments);
            }, P.prototype.translate = function() {
              var S, u, y, s, a = this, e = this.yAxis, n = this.xAxis, o = n.startAngleRad, i = this.chart, c = this.xAxis.isRadial, l = Math.max(i.chartWidth, i.chartHeight) + 999;
              function h(C) {
                return A(C, -l, l);
              }
              k.translate.apply(this), this.points.forEach(function(C) {
                var M = C.shapeArgs || {}, O = a.options.minPointLength, p = C.plotY, w = e.translate(C.high, 0, 1, 0, 1);
                if (d(w) && d(p))
                  if (C.plotHigh = h(w), C.plotLow = h(p), s = C.plotHigh, S = v(C.rectPlotY, C.plotY) - C.plotHigh, Math.abs(S) < O ? (S += u = O - S, s -= u / 2) : S < 0 && (s -= S *= -1), c && a.polar)
                    y = C.barX + o, C.shapeType = "arc", C.shapeArgs = a.polar.arc(s + S, s, y, y + C.pointWidth);
                  else {
                    M.height = S, M.y = s;
                    var T = M.x, z = T === void 0 ? 0 : T, W = M.width, L = W === void 0 ? 0 : W;
                    C.tooltipPos = i.inverted ? [e.len + e.pos - i.plotLeft - s - S / 2, n.len + n.pos - i.plotTop - z - L / 2, S] : [n.left - i.plotLeft + z + L / 2, e.pos - i.plotTop + s + S / 2, S];
                  }
              });
            }, P.prototype.pointAttribs = function() {
              return k.pointAttribs.apply(this, arguments);
            }, P.prototype.translate3dPoints = function() {
              return k.translate3dPoints.apply(this, arguments);
            }, P.prototype.translate3dShapes = function() {
              return k.translate3dShapes.apply(this, arguments);
            }, P.defaultOptions = m(D.defaultOptions, N.defaultOptions, g), P;
          }(N);
          return b(x.prototype, { directTouch: !0, pointClass: G, trackerGroups: ["group", "dataLabelsGroup"], adjustForMissingColumns: k.adjustForMissingColumns, animate: k.animate, crispCol: k.crispCol, drawGraph: q, drawPoints: k.drawPoints, getSymbol: q, drawTracker: k.drawTracker, getColumnMetrics: k.getColumnMetrics }), $.registerSeriesType("columnrange", x), x;
        }), at(_, "Series/ColumnPyramid/ColumnPyramidSeries.js", [_["Series/Column/ColumnSeries.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(k, A) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
              b.__proto__ = d;
            } || function(b, d) {
              for (var m in d)
                d.hasOwnProperty(m) && (b[m] = d[m]);
            }, Y(k, A);
          }, function(k, A) {
            function b() {
              this.constructor = k;
            }
            Y(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
          }), Q = G.prototype, q = $.clamp, U = $.merge, N = $.pick, D = function(k) {
            function A() {
              var b = k !== null && k.apply(this, arguments) || this;
              return b.data = void 0, b.options = void 0, b.points = void 0, b;
            }
            return J(A, k), A.prototype.translate = function() {
              var b = this, d = b.chart, m = b.options, v = b.dense = b.closestPointRange * b.xAxis.transA < 2, g = b.borderWidth = N(m.borderWidth, v ? 0 : 1), x = b.yAxis, E = m.threshold, P = b.translatedThreshold = x.getThreshold(E), S = N(m.minPointLength, 5), u = b.getColumnMetrics(), y = u.width, s = b.barW = Math.max(y, 1 + 2 * g), a = b.pointXOffset = u.offset;
              d.inverted && (P -= 0.5), m.pointPadding && (s = Math.ceil(s)), Q.translate.apply(b), b.points.forEach(function(e) {
                var n, o, i, c, l, h, C, M, O, p, w, T, z = N(e.yBottom, P), W = 999 + Math.abs(z), L = q(e.plotY, -W, x.len + W), I = e.plotX + a, j = s / 2, Z = Math.min(L, z), V = Math.max(L, z) - Z;
                e.barX = I, e.pointWidth = y, e.tooltipPos = d.inverted ? [x.len + x.pos - d.plotLeft - L, b.xAxis.len - I - j, V] : [I + j, L + x.pos - d.plotTop, V], n = E + (e.total || e.y), m.stacking === "percent" && (n = E + (e.y < 0) ? -100 : 100), i = x.toPixels(n, !0), C = I - (c = (o = d.plotHeight - i - (d.plotHeight - P)) ? j * (Z - i) / o : 0) + j, M = I + c + j, O = I + (l = o ? j * (Z + V - i) / o : 0) + j, p = I - l + j, w = Z - S, T = Z + V, e.y < 0 && (w = Z, T = Z + V + S), d.inverted && (M = (C = I + j + (c = j * (i - (h = x.width - Z)) / (o = i - (x.width - P)))) - 2 * c, O = I - (l = j * (i - (h - V)) / o) + j, p = I + l + j, w = Z, T = Z + V - S, e.y < 0 && (T = Z + V + S)), e.shapeType = "path", e.shapeArgs = { x: C, y: w, width: M - C, height: V, d: [["M", C, w], ["L", M, w], ["L", O, T], ["L", p, T], ["Z"]] };
              });
            }, A.defaultOptions = U(G.defaultOptions, {}), A;
          }(G);
          return F.registerSeriesType("columnpyramid", D), D;
        }), at(_, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function() {
          return { color: "#000000", grouping: !1, linkedTo: ":previous", tooltip: { pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>' }, whiskerWidth: null };
        }), at(_, "Series/ErrorBar/ErrorBarSeries.js", [_["Series/BoxPlot/BoxPlotSeries.js"], _["Series/Column/ColumnSeries.js"], _["Series/ErrorBar/ErrorBarSeriesDefaults.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q, q = this && this.__extends || (Q = function(b, d) {
            return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, Q(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            Q(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), U = Y.seriesTypes.arearange, N = J.addEvent, D = J.merge, k = J.extend, A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.data = void 0, m.options = void 0, m.points = void 0, m;
            }
            return q(d, b), d.prototype.getColumnMetrics = function() {
              return this.linkedParent && this.linkedParent.columnMetrics || F.prototype.getColumnMetrics.call(this);
            }, d.prototype.drawDataLabels = function() {
              var m = this.pointValKey;
              U && (U.prototype.drawDataLabels.call(this), this.data.forEach(function(v) {
                v.y = v[m];
              }));
            }, d.prototype.toYData = function(m) {
              return [m.low, m.high];
            }, d.defaultOptions = D(G.defaultOptions, $), d;
          }(G);
          return N(A, "afterTranslate", function() {
            this.points.forEach(function(b) {
              b.plotLow = b.plotY;
            });
          }, { order: 0 }), k(A.prototype, { pointArrayMap: ["low", "high"], pointValKey: "high", doQuartiles: !1 }), Y.registerSeriesType("errorbar", A), A;
        }), at(_, "Series/Gauge/GaugePoint.js", [_["Core/Series/SeriesRegistry.js"]], function(G) {
          var F, $ = this && this.__extends || (F = function(J, Q) {
            return F = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(q, U) {
              q.__proto__ = U;
            } || function(q, U) {
              for (var N in U)
                U.hasOwnProperty(N) && (q[N] = U[N]);
            }, F(J, Q);
          }, function(J, Q) {
            function q() {
              this.constructor = J;
            }
            F(J, Q), J.prototype = Q === null ? Object.create(Q) : (q.prototype = Q.prototype, new q());
          }), Y = function(J) {
            function Q() {
              var q = J !== null && J.apply(this, arguments) || this;
              return q.options = void 0, q.series = void 0, q.shapeArgs = void 0, q;
            }
            return $(Q, J), Q.prototype.setState = function(q) {
              this.state = q;
            }, Q;
          }(G.series.prototype.pointClass);
          return Y;
        }), at(_, "Series/Gauge/GaugeSeries.js", [_["Series/Gauge/GaugePoint.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(g, x) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, P) {
              E.__proto__ = P;
            } || function(E, P) {
              for (var S in P)
                P.hasOwnProperty(S) && (E[S] = P[S]);
            }, J(g, x);
          }, function(g, x) {
            function E() {
              this.constructor = g;
            }
            J(g, x), g.prototype = x === null ? Object.create(x) : (E.prototype = x.prototype, new E());
          }), q = F.noop, U = $.series, N = $.seriesTypes.column, D = Y.clamp, k = Y.isNumber, A = Y.extend, b = Y.merge, d = Y.pick, m = Y.pInt, v = function(g) {
            function x() {
              var E = g !== null && g.apply(this, arguments) || this;
              return E.data = void 0, E.points = void 0, E.options = void 0, E.yAxis = void 0, E;
            }
            return Q(x, g), x.prototype.translate = function() {
              var E = this, P = E.yAxis, S = E.options, u = P.center;
              E.generatePoints(), E.points.forEach(function(y) {
                var s = b(S.dial, y.dial), a = m(s.radius) * u[2] / 200, e = m(s.baseLength) * a / 100, n = m(s.rearLength) * a / 100, o = s.baseWidth, i = s.topWidth, c = S.overshoot, l = P.startAngleRad + P.translate(y.y, void 0, void 0, void 0, !0);
                (k(c) || S.wrap === !1) && (c = k(c) ? c / 180 * Math.PI : 0, l = D(l, P.startAngleRad - c, P.endAngleRad + c)), l = 180 * l / Math.PI, y.shapeType = "path";
                var h = s.path || [["M", -n, -o / 2], ["L", e, -o / 2], ["L", a, -i / 2], ["L", a, i / 2], ["L", e, o / 2], ["L", -n, o / 2], ["Z"]];
                y.shapeArgs = { d: h, translateX: u[0], translateY: u[1], rotation: l }, y.plotX = u[0], y.plotY = u[1];
              });
            }, x.prototype.drawPoints = function() {
              var E = this, P = E.chart, S = E.yAxis.center, u = E.pivot, y = E.options, s = y.pivot, a = P.renderer;
              E.points.forEach(function(e) {
                var n = e.graphic, o = e.shapeArgs, i = o.d, c = b(y.dial, e.dial);
                n ? (n.animate(o), o.d = i) : e.graphic = a[e.shapeType](o).attr({ rotation: o.rotation, zIndex: 1 }).addClass("highcharts-dial").add(E.group), P.styledMode || e.graphic[n ? "animate" : "attr"]({ stroke: c.borderColor, "stroke-width": c.borderWidth, fill: c.backgroundColor });
              }), u ? u.animate({ translateX: S[0], translateY: S[1] }) : s && (E.pivot = a.circle(0, 0, s.radius).attr({ zIndex: 2 }).addClass("highcharts-pivot").translate(S[0], S[1]).add(E.group), P.styledMode || E.pivot.attr({ fill: s.backgroundColor, stroke: s.borderColor, "stroke-width": s.borderWidth }));
            }, x.prototype.animate = function(E) {
              var P = this;
              E || P.points.forEach(function(S) {
                var u = S.graphic;
                u && (u.attr({ rotation: 180 * P.yAxis.startAngleRad / Math.PI }), u.animate({ rotation: S.shapeArgs.rotation }, P.options.animation));
              });
            }, x.prototype.render = function() {
              this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), U.prototype.render.call(this), this.group.clip(this.chart.clipRect);
            }, x.prototype.setData = function(E, P) {
              U.prototype.setData.call(this, E, !1), this.processData(), this.generatePoints(), d(P, !0) && this.chart.redraw();
            }, x.prototype.hasData = function() {
              return !!this.points.length;
            }, x.defaultOptions = b(U.defaultOptions, { dataLabels: { borderColor: "#cccccc", borderRadius: 3, borderWidth: 1, crop: !1, defer: !1, enabled: !0, verticalAlign: "top", y: 15, zIndex: 2 }, dial: { backgroundColor: "#000000", baseLength: "70%", baseWidth: 3, borderColor: "#cccccc", borderWidth: 0, radius: "80%", rearLength: "10%", topWidth: 1 }, pivot: { radius: 5, borderWidth: 0, borderColor: "#cccccc", backgroundColor: "#000000" }, tooltip: { headerFormat: "" }, showInLegend: !1 }), x;
          }(U);
          return A(v.prototype, { angular: !0, directTouch: !0, drawGraph: q, drawTracker: N.prototype.drawTracker, fixedBox: !0, forceDL: !0, noSharedTooltip: !0, pointClass: G, trackerGroups: ["group", "dataLabelsGroup"] }), $.registerSeriesType("gauge", v), v;
        }), at(_, "Series/DragNodesComposition.js", [_["Core/Utilities.js"]], function(G) {
          var F = G.addEvent, $ = [];
          function Y() {
            var J, Q, q, U = this;
            U.container && (J = F(U.container, "mousedown", function(N) {
              var D = U.hoverPoint;
              D && D.series && D.series.hasDraggableNodes && D.series.options.draggable && (D.series.onMouseDown(D, N), Q = F(U.container, "mousemove", function(k) {
                return D && D.series && D.series.onMouseMove(D, k);
              }), q = F(U.container.ownerDocument, "mouseup", function(k) {
                return Q(), q(), D && D.series && D.series.onMouseUp(D, k);
              }));
            })), F(U, "destroy", function() {
              J();
            });
          }
          return { compose: function(J) {
            $.indexOf(J) === -1 && ($.push(J), F(J, "load", Y));
          }, onMouseDown: function(J, Q) {
            var q = this.chart.pointer.normalize(Q);
            J.fixedPosition = { chartX: q.chartX, chartY: q.chartY, plotX: J.plotX, plotY: J.plotY }, J.inDragMode = !0;
          }, onMouseMove: function(J, Q) {
            if (J.fixedPosition && J.inDragMode) {
              var q = this.chart, U = q.pointer.normalize(Q), N = J.fixedPosition.chartX - U.chartX, D = J.fixedPosition.chartY - U.chartY, k = q.graphLayoutsLookup, A = void 0, b = void 0;
              (Math.abs(N) > 5 || Math.abs(D) > 5) && (A = J.fixedPosition.plotX - N, b = J.fixedPosition.plotY - D, q.isInsidePlot(A, b) && (J.plotX = A, J.plotY = b, J.hasDragged = !0, this.redrawHalo(J), k.forEach(function(d) {
                d.restartSimulation();
              })));
            }
          }, onMouseUp: function(J, Q) {
            J.fixedPosition && (J.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), J.inDragMode = J.hasDragged = !1, this.options.fixedDraggable || delete J.fixedPosition);
          }, redrawHalo: function(J) {
            J && this.halo && this.halo.attr({ d: J.haloPath(this.options.states.hover.halo.size) });
          } };
        }), at(_, "Series/GraphLayoutComposition.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.setAnimation, Y = F.addEvent, J = [];
          function Q() {
            this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach(function(D) {
              D.updateSimulation();
            }), this.redraw());
          }
          function q() {
            this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach(function(D) {
              D.updateSimulation(!1);
            }), this.redraw());
          }
          function U() {
            this.graphLayoutsLookup && this.graphLayoutsLookup.forEach(function(D) {
              D.stop();
            });
          }
          function N() {
            var D, k = !1, A = function(b) {
              b.maxIterations-- && isFinite(b.temperature) && !b.isStable() && !b.enableSimulation && (b.beforeStep && b.beforeStep(), b.step(), D = !1, k = !0);
            };
            if (this.graphLayoutsLookup) {
              for ($(!1, this), this.graphLayoutsLookup.forEach(function(b) {
                return b.start();
              }); !D; )
                D = !0, this.graphLayoutsLookup.forEach(A);
              k && this.series.forEach(function(b) {
                b && b.layout && b.render();
              });
            }
          }
          return { compose: function(D) {
            J.indexOf(D) && (J.push(D), Y(D, "afterPrint", Q), Y(D, "beforePrint", q), Y(D, "predraw", U), Y(D, "render", N));
          }, integrations: {}, layouts: {} };
        }), at(_, "Series/PackedBubble/PackedBubblePoint.js", [_["Core/Chart/Chart.js"], _["Core/Series/Point.js"], _["Core/Series/SeriesRegistry.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(q, U) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(N, D) {
              N.__proto__ = D;
            } || function(N, D) {
              for (var k in D)
                D.hasOwnProperty(k) && (N[k] = D[k]);
            }, Y(q, U);
          }, function(q, U) {
            function N() {
              this.constructor = q;
            }
            Y(q, U), q.prototype = U === null ? Object.create(U) : (N.prototype = U.prototype, new N());
          }), Q = function(q) {
            function U() {
              var N = q !== null && q.apply(this, arguments) || this;
              return N.degree = NaN, N.mass = NaN, N.radius = NaN, N.options = void 0, N.series = void 0, N.value = null, N;
            }
            return J(U, q), U.prototype.destroy = function() {
              return this.series.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), F.prototype.destroy.apply(this, arguments);
            }, U.prototype.firePointEvent = function() {
              var N = this.series, D = N.options;
              if (this.isParentNode && D.parentNode) {
                var k = D.allowPointSelect;
                D.allowPointSelect = D.parentNode.allowPointSelect, F.prototype.firePointEvent.apply(this, arguments), D.allowPointSelect = k;
              } else
                F.prototype.firePointEvent.apply(this, arguments);
            }, U.prototype.select = function() {
              var N = this, D = this.series, k = D.chart;
              N.isParentNode ? (k.getSelectedPoints = k.getSelectedParentNodes, F.prototype.select.apply(this, arguments), k.getSelectedPoints = G.prototype.getSelectedPoints) : F.prototype.select.apply(this, arguments);
            }, U;
          }($.seriesTypes.bubble.prototype.pointClass);
          return Q;
        }), at(_, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [_["Core/Utilities.js"]], function(G) {
          var F = G.isNumber;
          return { minSize: "10%", maxSize: "50%", sizeBy: "area", zoneAxis: "y", crisp: !1, tooltip: { pointFormat: "Value: {point.value}" }, draggable: !0, useSimulation: !0, parentNode: { allowPointSelect: !1 }, dataLabels: { formatter: function() {
            var $ = this.series.chart.numberFormatter, Y = this.point.value;
            return F(Y) ? $(Y, -1) : "";
          }, parentNodeFormatter: function() {
            return this.name;
          }, parentNodeTextPath: { enabled: !0 }, padding: 0, style: { transition: "opacity 2000ms" } }, layoutAlgorithm: { initialPositions: "circle", initialPositionRadius: 20, bubblePadding: 5, parentNodeLimit: !1, seriesInteraction: !0, dragBetweenSeries: !1, parentNodeOptions: { maxIterations: 400, gravitationalConstant: 0.03, maxSpeed: 50, initialPositionRadius: 100, seriesInteraction: !0, marker: { fillColor: null, fillOpacity: 1, lineWidth: null, lineColor: null, symbol: "circle" } }, enableSimulation: !0, type: "packedbubble", integration: "packedbubble", maxIterations: 1e3, splitSeries: !1, maxSpeed: 5, gravitationalConstant: 0.01, friction: -0.981 } };
        }), at(_, "Series/Networkgraph/VerletIntegration.js", [], function() {
          return { attractive: function(G, F, $) {
            var Y = G.getMass(), J = -$.x * F * this.diffTemperature, Q = -$.y * F * this.diffTemperature;
            G.fromNode.fixedPosition || (G.fromNode.plotX -= J * Y.fromNode / G.fromNode.degree, G.fromNode.plotY -= Q * Y.fromNode / G.fromNode.degree), G.toNode.fixedPosition || (G.toNode.plotX += J * Y.toNode / G.toNode.degree, G.toNode.plotY += Q * Y.toNode / G.toNode.degree);
          }, attractiveForceFunction: function(G, F) {
            return (F - G) / G;
          }, barycenter: function() {
            var G = this.options.gravitationalConstant, F = this.barycenter.xFactor, $ = this.barycenter.yFactor;
            F = (F - (this.box.left + this.box.width) / 2) * G, $ = ($ - (this.box.top + this.box.height) / 2) * G, this.nodes.forEach(function(Y) {
              Y.fixedPosition || (Y.plotX -= F / Y.mass / Y.degree, Y.plotY -= $ / Y.mass / Y.degree);
            });
          }, getK: function(G) {
            return Math.pow(G.box.width * G.box.height / G.nodes.length, 0.5);
          }, integrate: function(G, F) {
            var $ = -G.options.friction, Y = G.options.maxSpeed, J = F.prevX, Q = F.prevY, q = (F.plotX + F.dispX - J) * $, U = (F.plotY + F.dispY - Q) * $, N = Math.abs, D = N(q) / (q || 1), k = N(U) / (U || 1);
            q = D * Math.min(Y, Math.abs(q)), U = k * Math.min(Y, Math.abs(U)), F.prevX = F.plotX + F.dispX, F.prevY = F.plotY + F.dispY, F.plotX += q, F.plotY += U, F.temperature = G.vectorLength({ x: q, y: U });
          }, repulsive: function(G, F, $) {
            var Y = F * this.diffTemperature / G.mass / G.degree;
            G.fixedPosition || (G.plotX += $.x * Y, G.plotY += $.y * Y);
          }, repulsiveForceFunction: function(G, F) {
            return (F - G) / G * (F > G ? 1 : 0);
          } };
        }), at(_, "Series/PackedBubble/PackedBubbleIntegration.js", [_["Core/Globals.js"], _["Series/Networkgraph/VerletIntegration.js"]], function(G, F) {
          return { barycenter: function() {
            for (var $, Y, J = this, Q = J.options.gravitationalConstant, q = J.box, U = J.nodes, N = 0, D = U; N < D.length; N++) {
              var k = D[N];
              J.options.splitSeries && !k.isParentNode ? ($ = k.series.parentNode.plotX, Y = k.series.parentNode.plotY) : ($ = q.width / 2, Y = q.height / 2), k.fixedPosition || (k.plotX -= (k.plotX - $) * Q / (k.mass * Math.sqrt(U.length)), k.plotY -= (k.plotY - Y) * Q / (k.mass * Math.sqrt(U.length)));
            }
          }, getK: G.noop, integrate: F.integrate, repulsive: function($, Y, J, Q) {
            var q = Y * this.diffTemperature / $.mass / $.degree, U = J.x * q, N = J.y * q;
            $.fixedPosition || ($.plotX += U, $.plotY += N), Q.fixedPosition || (Q.plotX -= U, Q.plotY -= N);
          }, repulsiveForceFunction: function($, Y, J, Q) {
            return Math.min($, (J.marker.radius + Q.marker.radius) / 2);
          } };
        }), at(_, "Series/Networkgraph/EulerIntegration.js", [], function() {
          return { attractive: function(G, F, $, Y) {
            var J = G.getMass(), Q = $.x / Y * F, q = $.y / Y * F;
            G.fromNode.fixedPosition || (G.fromNode.dispX -= Q * J.fromNode / G.fromNode.degree, G.fromNode.dispY -= q * J.fromNode / G.fromNode.degree), G.toNode.fixedPosition || (G.toNode.dispX += Q * J.toNode / G.toNode.degree, G.toNode.dispY += q * J.toNode / G.toNode.degree);
          }, attractiveForceFunction: function(G, F) {
            return G * G / F;
          }, barycenter: function() {
            var G = this.options.gravitationalConstant, F = this.barycenter.xFactor, $ = this.barycenter.yFactor;
            this.nodes.forEach(function(Y) {
              if (!Y.fixedPosition) {
                var J = Y.getDegree(), Q = J * (1 + J / 2);
                Y.dispX += (F - Y.plotX) * G * Q / Y.degree, Y.dispY += ($ - Y.plotY) * G * Q / Y.degree;
              }
            });
          }, getK: function(G) {
            return Math.pow(G.box.width * G.box.height / G.nodes.length, 0.3);
          }, integrate: function(G, F) {
            var $;
            F.dispX += F.dispX * G.options.friction, F.dispY += F.dispY * G.options.friction, ($ = F.temperature = G.vectorLength({ x: F.dispX, y: F.dispY })) !== 0 && (F.plotX += F.dispX / $ * Math.min(Math.abs(F.dispX), G.temperature), F.plotY += F.dispY / $ * Math.min(Math.abs(F.dispY), G.temperature));
          }, repulsive: function(G, F, $, Y) {
            G.dispX += $.x / Y * F / G.degree, G.dispY += $.y / Y * F / G.degree;
          }, repulsiveForceFunction: function(G, F) {
            return F * F / G;
          } };
        }), at(_, "Series/Networkgraph/QuadTreeNode.js", [], function() {
          return function() {
            function G(F) {
              this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = F, this.boxSize = Math.min(F.width, F.height);
            }
            return G.prototype.divideBox = function() {
              var F = this.box.width / 2, $ = this.box.height / 2;
              this.nodes[0] = new G({ left: this.box.left, top: this.box.top, width: F, height: $ }), this.nodes[1] = new G({ left: this.box.left + F, top: this.box.top, width: F, height: $ }), this.nodes[2] = new G({ left: this.box.left + F, top: this.box.top + $, width: F, height: $ }), this.nodes[3] = new G({ left: this.box.left, top: this.box.top + $, width: F, height: $ });
            }, G.prototype.getBoxPosition = function(F) {
              var $ = F.plotX < this.box.left + this.box.width / 2, Y = F.plotY < this.box.top + this.box.height / 2;
              return $ ? Y ? 0 : 3 : Y ? 1 : 2;
            }, G.prototype.insert = function(F, $) {
              var Y;
              this.isInternal ? this.nodes[this.getBoxPosition(F)].insert(F, $ - 1) : (this.isEmpty = !1, this.body ? $ ? (this.isInternal = !0, this.divideBox(), this.body !== !0 && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, $ - 1), this.body = !0), this.nodes[this.getBoxPosition(F)].insert(F, $ - 1)) : ((Y = new G({ top: F.plotX || NaN, left: F.plotY || NaN, width: 0.1, height: 0.1 })).body = F, Y.isInternal = !1, this.nodes.push(Y)) : (this.isInternal = !1, this.body = F));
            }, G.prototype.updateMassAndCenter = function() {
              var F = 0, $ = 0, Y = 0;
              if (this.isInternal) {
                for (var J = 0, Q = this.nodes; J < Q.length; J++) {
                  var q = Q[J];
                  q.isEmpty || (F += q.mass, $ += q.plotX * q.mass, Y += q.plotY * q.mass);
                }
                $ /= F, Y /= F;
              } else
                this.body && (F = this.body.mass, $ = this.body.plotX, Y = this.body.plotY);
              this.mass = F, this.plotX = $, this.plotY = Y;
            }, G;
          }();
        }), at(_, "Series/Networkgraph/QuadTree.js", [_["Series/Networkgraph/QuadTreeNode.js"]], function(G) {
          return function() {
            function F($, Y, J, Q) {
              this.box = { left: $, top: Y, width: J, height: Q }, this.maxDepth = 25, this.root = new G(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
            }
            return F.prototype.calculateMassAndCenter = function() {
              this.visitNodeRecursive(null, null, function($) {
                $.updateMassAndCenter();
              });
            }, F.prototype.insertNodes = function($) {
              for (var Y = 0, J = $; Y < J.length; Y++) {
                var Q = J[Y];
                this.root.insert(Q, this.maxDepth);
              }
            }, F.prototype.visitNodeRecursive = function($, Y, J) {
              var Q;
              if ($ || ($ = this.root), $ === this.root && Y && (Q = Y($)), Q !== !1) {
                for (var q = 0, U = $.nodes; q < U.length; q++) {
                  var N = U[q];
                  if (N.isInternal) {
                    if (Y && (Q = Y(N)), Q === !1)
                      continue;
                    this.visitNodeRecursive(N, Y, J);
                  } else
                    N.body && Y && Y(N.body);
                  J && J(N);
                }
                $ === this.root && J && J($);
              }
            }, F;
          }();
        }), at(_, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [_["Series/Networkgraph/EulerIntegration.js"], _["Core/Globals.js"], _["Series/GraphLayoutComposition.js"], _["Series/Networkgraph/QuadTree.js"], _["Core/Utilities.js"], _["Series/Networkgraph/VerletIntegration.js"]], function(G, F, $, Y, J, Q) {
          var q = F.win, U = J.clamp, N = J.defined, D = J.isFunction, k = J.pick, A = function() {
            function b() {
              this.attractiveForce = void 0, this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.integration = void 0, this.links = [], this.nodes = [], this.options = void 0, this.quadTree = void 0, this.repulsiveForce = void 0, this.series = [], this.simulation = !1;
            }
            return b.compose = function(d) {
              $.compose(d), $.integrations.euler = G, $.integrations.verlet = Q, $.layouts["reingold-fruchterman"] = b;
            }, b.prototype.init = function(d) {
              this.options = d, this.nodes = [], this.links = [], this.series = [], this.box = { x: 0, y: 0, width: 0, height: 0 }, this.setInitialRendering(!0), this.integration = $.integrations[d.integration], this.enableSimulation = d.enableSimulation, this.attractiveForce = k(d.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = k(d.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = d.approximation;
            }, b.prototype.updateSimulation = function(d) {
              this.enableSimulation = k(d, this.options.enableSimulation);
            }, b.prototype.start = function() {
              var d = this, m = this.series, v = this.options;
              d.currentStep = 0, d.forces = m[0] && m[0].forces || [], d.chart = m[0] && m[0].chart, d.initialRendering && (d.initPositions(), m.forEach(function(g) {
                g.finishedAnimating = !0, g.render();
              })), d.setK(), d.resetSimulation(v), d.enableSimulation && d.step();
            }, b.prototype.step = function() {
              var d = this, m = this.series;
              this.currentStep++, this.approximation === "barnes-hut" && (this.createQuadTree(), this.quadTree.calculateMassAndCenter());
              for (var v = 0, g = this.forces || []; v < g.length; v++)
                this[g[v] + "Forces"](this.temperature);
              if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
                for (var x = 0, E = m; x < E.length; x++) {
                  var P = E[x];
                  P.chart && P.render();
                }
                this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && q.cancelAnimationFrame(this.simulation), this.simulation = q.requestAnimationFrame(function() {
                  return d.step();
                })) : this.simulation = !1;
              }
            }, b.prototype.stop = function() {
              this.simulation && q.cancelAnimationFrame(this.simulation);
            }, b.prototype.setArea = function(d, m, v, g) {
              this.box = { left: d, top: m, width: v, height: g };
            }, b.prototype.setK = function() {
              this.k = this.options.linkLength || this.integration.getK(this);
            }, b.prototype.addElementsToCollection = function(d, m) {
              for (var v = 0, g = d; v < g.length; v++) {
                var x = g[v];
                m.indexOf(x) === -1 && m.push(x);
              }
            }, b.prototype.removeElementFromCollection = function(d, m) {
              var v = m.indexOf(d);
              v !== -1 && m.splice(v, 1);
            }, b.prototype.clear = function() {
              this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
            }, b.prototype.resetSimulation = function() {
              this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
            }, b.prototype.restartSimulation = function() {
              this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
            }, b.prototype.setMaxIterations = function(d) {
              this.maxIterations = k(d, this.options.maxIterations);
            }, b.prototype.setTemperature = function() {
              this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
            }, b.prototype.setDiffTemperature = function() {
              this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
            }, b.prototype.setInitialRendering = function(d) {
              this.initialRendering = d;
            }, b.prototype.createQuadTree = function() {
              this.quadTree = new Y(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
            }, b.prototype.initPositions = function() {
              var d = this.options.initialPositions;
              if (D(d)) {
                d.call(this);
                for (var m = 0, v = this.nodes; m < v.length; m++) {
                  var g = v[m];
                  N(g.prevX) || (g.prevX = g.plotX), N(g.prevY) || (g.prevY = g.plotY), g.dispX = 0, g.dispY = 0;
                }
              } else
                d === "circle" ? this.setCircularPositions() : this.setRandomPositions();
            }, b.prototype.setCircularPositions = function() {
              for (var d, m = this.box, v = this.nodes, g = v.length + 1, x = 2 * Math.PI / g, E = v.filter(function(h) {
                return h.linksTo.length === 0;
              }), P = {}, S = this.options.initialPositionRadius, u = function(h) {
                for (var C = 0, M = h.linksFrom || []; C < M.length; C++) {
                  var O = M[C];
                  P[O.toNode.id] || (P[O.toNode.id] = !0, y.push(O.toNode), u(O.toNode));
                }
              }, y = [], s = 0, a = E; s < a.length; s++) {
                var e = a[s];
                y.push(e), u(e);
              }
              if (y.length)
                for (var n = 0, o = v; n < o.length; n++) {
                  var i = o[n];
                  y.indexOf(i) === -1 && y.push(i);
                }
              else
                y = v;
              for (var c = 0, l = y.length; c < l; ++c)
                (d = y[c]).plotX = d.prevX = k(d.plotX, m.width / 2 + S * Math.cos(c * x)), d.plotY = d.prevY = k(d.plotY, m.height / 2 + S * Math.sin(c * x)), d.dispX = 0, d.dispY = 0;
            }, b.prototype.setRandomPositions = function() {
              for (var d, m = this.box, v = this.nodes, g = v.length + 1, x = function(S) {
                var u = S * S / Math.PI;
                return u - Math.floor(u);
              }, E = 0, P = v.length; E < P; ++E)
                (d = v[E]).plotX = d.prevX = k(d.plotX, m.width * x(E)), d.plotY = d.prevY = k(d.plotY, m.height * x(g + E)), d.dispX = 0, d.dispY = 0;
            }, b.prototype.force = function(d) {
              for (var m = [], v = 1; v < arguments.length; v++)
                m[v - 1] = arguments[v];
              this.integration[d].apply(this, m);
            }, b.prototype.barycenterForces = function() {
              this.getBarycenter(), this.force("barycenter");
            }, b.prototype.getBarycenter = function() {
              for (var d = 0, m = 0, v = 0, g = 0, x = this.nodes; g < x.length; g++) {
                var E = x[g];
                m += E.plotX * E.mass, v += E.plotY * E.mass, d += E.mass;
              }
              return this.barycenter = { x: m, y: v, xFactor: m / d, yFactor: v / d }, this.barycenter;
            }, b.prototype.barnesHutApproximation = function(d, m) {
              var v, g, x = this.getDistXY(d, m), E = this.vectorLength(x);
              return d !== m && E !== 0 && (m.isInternal ? m.boxSize / E < this.options.theta && E !== 0 ? (g = this.repulsiveForce(E, this.k), this.force("repulsive", d, g * m.mass, x, E), v = !1) : v = !0 : (g = this.repulsiveForce(E, this.k), this.force("repulsive", d, g * m.mass, x, E))), v;
            }, b.prototype.repulsiveForces = function() {
              var d = this;
              if (this.approximation === "barnes-hut")
                for (var m = function(o) {
                  v.quadTree.visitNodeRecursive(null, function(i) {
                    return d.barnesHutApproximation(o, i);
                  });
                }, v = this, g = 0, x = this.nodes; g < x.length; g++)
                  m(s = x[g]);
              else
                for (var E = void 0, P = void 0, S = void 0, u = 0, y = this.nodes; u < y.length; u++)
                  for (var s = y[u], a = 0, e = this.nodes; a < e.length; a++) {
                    var n = e[a];
                    s === n || s.fixedPosition || (S = this.getDistXY(s, n), (P = this.vectorLength(S)) !== 0 && (E = this.repulsiveForce(P, this.k), this.force("repulsive", s, E * n.mass, S, P)));
                  }
            }, b.prototype.attractiveForces = function() {
              for (var d, m, v, g = 0, x = this.links; g < x.length; g++) {
                var E = x[g];
                E.fromNode && E.toNode && (d = this.getDistXY(E.fromNode, E.toNode), (m = this.vectorLength(d)) !== 0 && (v = this.attractiveForce(m, this.k), this.force("attractive", E, v, d, m)));
              }
            }, b.prototype.applyLimits = function() {
              for (var d = 0, m = this.nodes; d < m.length; d++) {
                var v = m[d];
                if (v.fixedPosition)
                  return;
                this.integration.integrate(this, v), this.applyLimitBox(v, this.box), v.dispX = 0, v.dispY = 0;
              }
            }, b.prototype.applyLimitBox = function(d, m) {
              var v = d.radius;
              d.plotX = U(d.plotX, m.left + v, m.width - v), d.plotY = U(d.plotY, m.top + v, m.height - v);
            }, b.prototype.coolDown = function(d, m, v) {
              return d - m * v;
            }, b.prototype.isStable = function() {
              return Math.abs(this.systemTemperature - this.prevSystemTemperature) < 1e-5 || this.temperature <= 0;
            }, b.prototype.getSystemTemperature = function() {
              for (var d = 0, m = 0, v = this.nodes; m < v.length; m++)
                d += v[m].temperature;
              return d;
            }, b.prototype.vectorLength = function(d) {
              return Math.sqrt(d.x * d.x + d.y * d.y);
            }, b.prototype.getDistR = function(d, m) {
              var v = this.getDistXY(d, m);
              return this.vectorLength(v);
            }, b.prototype.getDistXY = function(d, m) {
              var v = d.plotX - m.plotX, g = d.plotY - m.plotY;
              return { x: v, y: g, absX: Math.abs(v), absY: Math.abs(g) };
            }, b;
          }();
          return A;
        }), at(_, "Series/PackedBubble/PackedBubbleLayout.js", [_["Series/GraphLayoutComposition.js"], _["Series/PackedBubble/PackedBubbleIntegration.js"], _["Series/Networkgraph/ReingoldFruchtermanLayout.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(b, d) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, J(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            J(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), q = Y.addEvent, U = Y.pick, N = [];
          function D() {
            var b = this.series, d = [];
            return b.forEach(function(m) {
              m.parentNode && m.parentNode.selected && d.push(m.parentNode);
            }), d;
          }
          function k() {
            this.allDataPoints && delete this.allDataPoints;
          }
          var A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.index = NaN, m.nodes = [], m.options = void 0, m.series = [], m;
            }
            return Q(d, b), d.compose = function(m) {
              $.compose(m), G.integrations.packedbubble = F, G.layouts.packedbubble = d, N.indexOf(m) === -1 && (N.push(m), q(m, "beforeRedraw", k), m.prototype.getSelectedParentNodes = D);
            }, d.prototype.beforeStep = function() {
              this.options.marker && this.series.forEach(function(m) {
                m && m.calculateParentRadius();
              });
            }, d.prototype.isStable = function() {
              var m = Math.abs(this.prevSystemTemperature - this.systemTemperature), v = 10 * this.systemTemperature / Math.sqrt(this.nodes.length);
              return Math.abs(v) < 1 && m < 1e-5 || this.temperature <= 0;
            }, d.prototype.setCircularPositions = function() {
              for (var m, v, g = this, x = g.box, E = g.nodes, P = E.length + 1, S = 2 * Math.PI / P, u = g.options.initialPositionRadius, y = 0, s = 0, a = E; s < a.length; s++) {
                var e = a[s];
                g.options.splitSeries && !e.isParentNode ? (m = e.series.parentNode.plotX, v = e.series.parentNode.plotY) : (m = x.width / 2, v = x.height / 2), e.plotX = e.prevX = U(e.plotX, m + u * Math.cos(e.index || y * S)), e.plotY = e.prevY = U(e.plotY, v + u * Math.sin(e.index || y * S)), e.dispX = 0, e.dispY = 0, y++;
              }
            }, d.prototype.repulsiveForces = function() {
              var m, v, g, x = this, E = x.options.bubblePadding;
              x.nodes.forEach(function(P) {
                P.degree = P.mass, P.neighbours = 0, x.nodes.forEach(function(S) {
                  m = 0, P === S || P.fixedPosition || !x.options.seriesInteraction && P.series !== S.series || (g = x.getDistXY(P, S), (v = x.vectorLength(g) - (P.marker.radius + S.marker.radius + E)) < 0 && (P.degree += 0.01, P.neighbours++, m = x.repulsiveForce(-v / Math.sqrt(P.neighbours), x.k, P, S)), x.force("repulsive", P, m * S.mass, g, S, v));
                });
              });
            }, d.prototype.applyLimitBox = function(m, v) {
              var g, x, E = this;
              E.options.splitSeries && !m.isParentNode && E.options.parentNodeLimit && (g = E.getDistXY(m, m.series.parentNode), (x = m.series.parentNodeRadius - m.marker.radius - E.vectorLength(g)) < 0 && x > -2 * m.marker.radius && (m.plotX -= 0.01 * g.x, m.plotY -= 0.01 * g.y)), b.prototype.applyLimitBox.call(this, m, v);
            }, d;
          }($);
          return G.layouts.packedbubble = A, A;
        }), at(_, "Series/PackedBubble/PackedBubbleSeries.js", [_["Core/Color/Color.js"], _["Series/DragNodesComposition.js"], _["Series/GraphLayoutComposition.js"], _["Core/Globals.js"], _["Series/PackedBubble/PackedBubblePoint.js"], _["Series/PackedBubble/PackedBubbleSeriesDefaults.js"], _["Series/PackedBubble/PackedBubbleLayout.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N) {
          var D, k = this && this.__extends || (D = function(e, n) {
            return D = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, i) {
              o.__proto__ = i;
            } || function(o, i) {
              for (var c in i)
                i.hasOwnProperty(c) && (o[c] = i[c]);
            }, D(e, n);
          }, function(e, n) {
            function o() {
              this.constructor = e;
            }
            D(e, n), e.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
          }), A = G.parse, b = Y.noop, d = U.series.prototype, m = U.seriesTypes.bubble, v = N.addEvent, g = N.clamp, x = N.defined, E = N.extend, P = N.fireEvent, S = N.isArray, u = N.isNumber, y = N.merge, s = N.pick, a = function(e) {
            function n() {
              var o = e !== null && e.apply(this, arguments) || this;
              return o.chart = void 0, o.data = void 0, o.layout = void 0, o.options = void 0, o.parentNodeMass = 0, o.points = void 0, o.xData = void 0, o;
            }
            return k(n, e), n.compose = function(o, i, c, l) {
              m.compose(o, i, c, l), F.compose(i), q.compose(i);
            }, n.prototype.accumulateAllPoints = function() {
              for (var o, i = this.chart, c = [], l = 0, h = i.series; l < h.length; l++) {
                var C = h[l];
                if (C.is("packedbubble") && C.visible || !i.options.chart.ignoreHiddenSeries) {
                  o = C.yData || [];
                  for (var M = 0; M < o.length; M++)
                    c.push([null, null, o[M], C.index, M, { id: M, marker: { radius: 0 } }]);
                }
              }
              return c;
            }, n.prototype.addLayout = function() {
              var o, i = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, c = i.type || "packedbubble", l = this.chart.options.chart, h = this.chart.graphLayoutsStorage, C = this.chart.graphLayoutsLookup;
              h || (this.chart.graphLayoutsStorage = h = {}, this.chart.graphLayoutsLookup = C = []), (o = h[c]) || (i.enableSimulation = x(l.forExport) ? !l.forExport : i.enableSimulation, h[c] = o = new $.layouts[c](), o.init(i), C.splice(o.index, 0, o)), this.layout = o, this.points.forEach(function(M) {
                M.mass = 2, M.degree = 1, M.collisionNmb = 1;
              }), o.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), o.addElementsToCollection([this], o.series), o.addElementsToCollection(this.points, o.nodes);
            }, n.prototype.addSeriesLayout = function() {
              var o = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, i = o.type || "packedbubble", c = this.chart.graphLayoutsStorage, l = this.chart.graphLayoutsLookup, h = y(o, o.parentNodeOptions, { enableSimulation: this.layout.options.enableSimulation }), C = c[i + "-series"];
              C || (c[i + "-series"] = C = new $.layouts[i](), C.init(h), l.splice(C.index, 0, C)), this.parentNodeLayout = C, this.createParentNodes();
            }, n.prototype.calculateParentRadius = function() {
              var o = this.seriesBox();
              this.parentNodeRadius = g(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, o ? Math.max(Math.sqrt(Math.pow(o.width, 2) + Math.pow(o.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
            }, n.prototype.calculateZExtremes = function() {
              var o = this.chart.series, i = this.options.zMin, c = this.options.zMax, l = 1 / 0, h = -1 / 0;
              return i && c ? [i, c] : (o.forEach(function(C) {
                C.yData.forEach(function(M) {
                  x(M) && (M > h && (h = M), M < l && (l = M));
                });
              }), [i = s(i, l), c = s(c, h)]);
            }, n.prototype.checkOverlap = function(o, i) {
              var c = o[0] - i[0], l = o[1] - i[1], h = o[2] + i[2];
              return Math.sqrt(c * c + l * l) - Math.abs(h) < -1e-3;
            }, n.prototype.createParentNodes = function() {
              var o, i = this, c = this.pointClass, l = this.chart, h = this.parentNodeLayout, C = this.layout.options, M = this.parentNode, O = { radius: this.parentNodeRadius, lineColor: this.color, fillColor: A(this.color).brighten(0.4).get() };
              C.parentNodeOptions && (O = y(C.parentNodeOptions.marker || {}, O)), this.parentNodeMass = 0, this.points.forEach(function(p) {
                i.parentNodeMass += Math.PI * Math.pow(p.marker.radius, 2);
              }), this.calculateParentRadius(), h.nodes.forEach(function(p) {
                p.seriesIndex === i.index && (o = !0);
              }), h.setArea(0, 0, l.plotWidth, l.plotHeight), o || (M || (M = new c().init(this, { mass: this.parentNodeRadius / 2, marker: O, dataLabels: { inside: !1 }, states: { normal: { marker: O }, hover: { marker: O } }, dataLabelOnNull: !0, degree: this.parentNodeRadius, isParentNode: !0, seriesIndex: this.index })), this.parentNode && (M.plotX = this.parentNode.plotX, M.plotY = this.parentNode.plotY), this.parentNode = M, h.addElementsToCollection([this], h.series), h.addElementsToCollection([M], h.nodes));
            }, n.prototype.deferLayout = function() {
              var o = this.options.layoutAlgorithm;
              this.visible && (this.addLayout(), o.splitSeries && this.addSeriesLayout());
            }, n.prototype.destroy = function() {
              var o = this;
              this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach(function(i) {
                i.removeElementFromCollection(o, i.series);
              }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), d.destroy.apply(this, arguments);
            }, n.prototype.drawDataLabels = function() {
              d.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", d.drawDataLabels.call(this, [this.parentNode]));
            }, n.prototype.drawGraph = function() {
              if (this.layout && this.layout.options.splitSeries) {
                var o, i = this.chart, c = this.layout.options.parentNodeOptions.marker, l = { fill: c.fillColor || A(this.color).brighten(0.4).get(), opacity: c.fillOpacity, stroke: c.lineColor || this.color, "stroke-width": s(c.lineWidth, this.options.lineWidth) };
                this.parentNodesGroup || (this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, i.seriesGroup), this.group.attr({ zIndex: 2 })), this.calculateParentRadius(), o = y({ x: this.parentNode.plotX - this.parentNodeRadius, y: this.parentNode.plotY - this.parentNodeRadius, width: 2 * this.parentNodeRadius, height: 2 * this.parentNodeRadius }, l), this.parentNode.graphic || (this.graph = this.parentNode.graphic = i.renderer.symbol(l.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(o);
              }
            }, n.prototype.drawTracker = function() {
              var o, i = this.parentNode;
              e.prototype.drawTracker.call(this), i && (o = S(i.dataLabels) ? i.dataLabels : i.dataLabel ? [i.dataLabel] : [], i.graphic && (i.graphic.element.point = i), o.forEach(function(c) {
                c.div ? c.div.point = i : c.element.point = i;
              }));
            }, n.prototype.getPointRadius = function() {
              var o, i, c, l, h = this, C = this.chart, M = C.plotWidth, O = C.plotHeight, p = this.options, w = p.useSimulation, T = Math.min(M, O), z = {}, W = [], L = C.allDataPoints || [], I = L.length;
              ["minSize", "maxSize"].forEach(function(Z) {
                var V = parseInt(p[Z], 10), X = /%$/.test(p[Z]);
                z[Z] = X ? T * V / 100 : V * Math.sqrt(I);
              }), C.minRadius = o = z.minSize / Math.sqrt(I), C.maxRadius = i = z.maxSize / Math.sqrt(I);
              var j = w ? this.calculateZExtremes() : [o, i];
              L.forEach(function(Z, V) {
                c = w ? g(Z[2], j[0], j[1]) : Z[2], (l = h.getRadius(j[0], j[1], o, i, c)) === 0 && (l = null), L[V][2] = l, W.push(l);
              }), this.radii = W;
            }, n.prototype.init = function() {
              return d.init.apply(this, arguments), this.eventsToUnbind.push(v(this, "updatedData", function() {
                var o = this;
                this.chart.series.forEach(function(i) {
                  i.type === o.type && (i.isDirty = !0);
                }, this);
              })), this;
            }, n.prototype.onMouseUp = function(o) {
              var i = o;
              if (i.fixedPosition && !i.removed) {
                var c, l = this.layout, h = this.parentNodeLayout;
                h && l.options.dragBetweenSeries && h.nodes.forEach(function(C) {
                  i && i.marker && C !== i.series.parentNode && (c = l.getDistXY(i, C), l.vectorLength(c) - C.marker.radius - i.marker.radius < 0 && (C.series.addPoint(y(i.options, { plotX: i.plotX, plotY: i.plotY }), !1), l.removeElementFromCollection(i, l.nodes), i.remove()));
                }), F.onMouseUp.apply(this, arguments);
              }
            }, n.prototype.placeBubbles = function(o) {
              var i, c, l = this.checkOverlap, h = this.positionBubble, C = [], M = 1, O = 0, p = 0, w = [], T = o.sort(function(z, W) {
                return W[2] - z[2];
              });
              if (T.length) {
                if (C.push([[0, 0, T[0][2], T[0][3], T[0][4]]]), T.length > 1)
                  for (C.push([[0, 0 - T[1][2] - T[0][2], T[1][2], T[1][3], T[1][4]]]), c = 2; c < T.length; c++)
                    T[c][2] = T[c][2] || 1, l(i = h(C[M][O], C[M - 1][p], T[c]), C[M][0]) ? (C.push([]), p = 0, C[M + 1].push(h(C[M][O], C[M][0], T[c])), M++, O = 0) : M > 1 && C[M - 1][p + 1] && l(i, C[M - 1][p + 1]) ? (p++, C[M].push(h(C[M][O], C[M - 1][p], T[c])), O++) : (O++, C[M].push(i));
                this.chart.stages = C, this.chart.rawPositions = [].concat.apply([], C), this.resizeRadius(), w = this.chart.rawPositions;
              }
              return w;
            }, n.prototype.pointAttribs = function(o, i) {
              var c = this.options, l = o && o.isParentNode, h = c.marker;
              l && c.layoutAlgorithm && c.layoutAlgorithm.parentNodeOptions && (h = c.layoutAlgorithm.parentNodeOptions.marker);
              var C = h.fillOpacity, M = d.pointAttribs.call(this, o, i);
              return C !== 1 && (M["fill-opacity"] = C), M;
            }, n.prototype.positionBubble = function(o, i, c) {
              var l = Math.sqrt, h = Math.asin, C = Math.acos, M = Math.pow, O = Math.abs, p = l(M(o[0] - i[0], 2) + M(o[1] - i[1], 2)), w = C((M(p, 2) + M(c[2] + i[2], 2) - M(c[2] + o[2], 2)) / (2 * (c[2] + i[2]) * p)), T = h(O(o[0] - i[0]) / p), z = (o[1] - i[1] < 0 ? 0 : Math.PI) + w + T * ((o[0] - i[0]) * (o[1] - i[1]) < 0 ? 1 : -1), W = Math.cos(z), L = Math.sin(z);
              return [i[0] + (i[2] + c[2]) * L, i[1] - (i[2] + c[2]) * W, c[2], c[3], c[4]];
            }, n.prototype.render = function() {
              var o = [];
              d.render.apply(this, arguments), this.options.dataLabels.allowOverlap || (this.data.forEach(function(i) {
                S(i.dataLabels) && i.dataLabels.forEach(function(c) {
                  o.push(c);
                });
              }), this.options.useSimulation && this.chart.hideOverlappingLabels(o));
            }, n.prototype.resizeRadius = function() {
              var o, i, c, l, h, C = this.chart, M = C.rawPositions, O = Math.min, p = Math.max, w = C.plotLeft, T = C.plotTop, z = C.plotHeight, W = C.plotWidth;
              o = c = Number.POSITIVE_INFINITY, i = l = Number.NEGATIVE_INFINITY;
              for (var L = 0, I = M; L < I.length; L++)
                h = (ot = I[L])[2], o = O(o, ot[0] - h), i = p(i, ot[0] + h), c = O(c, ot[1] - h), l = p(l, ot[1] + h);
              var j = [i - o, l - c], Z = [(W - w) / j[0], (z - T) / j[1]], V = O.apply([], Z);
              if (Math.abs(V - 1) > 1e-10) {
                for (var X = 0, et = M; X < et.length; X++) {
                  var ot;
                  (ot = et[X])[2] *= V;
                }
                this.placeBubbles(M);
              } else
                C.diffY = z / 2 + T - c - (l - c) / 2, C.diffX = W / 2 + w - o - (i - o) / 2;
            }, n.prototype.seriesBox = function() {
              var o, i = this.chart, c = this.data, l = Math.max, h = Math.min, C = [i.plotLeft, i.plotLeft + i.plotWidth, i.plotTop, i.plotTop + i.plotHeight];
              return c.forEach(function(M) {
                x(M.plotX) && x(M.plotY) && M.marker.radius && (o = M.marker.radius, C[0] = h(C[0], M.plotX - o), C[1] = l(C[1], M.plotX + o), C[2] = h(C[2], M.plotY - o), C[3] = l(C[3], M.plotY + o));
              }), u(C.width / C.height) ? C : null;
            }, n.prototype.setVisible = function() {
              var o = this;
              d.setVisible.apply(o, arguments), o.parentNodeLayout && o.graph ? o.visible ? (o.graph.show(), o.parentNode.dataLabel && o.parentNode.dataLabel.show()) : (o.graph.hide(), o.parentNodeLayout.removeElementFromCollection(o.parentNode, o.parentNodeLayout.nodes), o.parentNode.dataLabel && o.parentNode.dataLabel.hide()) : o.layout && (o.visible ? o.layout.addElementsToCollection(o.points, o.layout.nodes) : o.points.forEach(function(i) {
                o.layout.removeElementFromCollection(i, o.layout.nodes);
              }));
            }, n.prototype.translate = function() {
              var o, i, c, l = this.chart, h = this.data, C = this.index, M = this.options.useSimulation;
              this.processedXData = this.xData, this.generatePoints(), x(l.allDataPoints) || (l.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), M ? c = l.allDataPoints : (c = this.placeBubbles(l.allDataPoints), this.options.draggable = !1);
              for (var O = 0, p = c; O < p.length; O++) {
                var w = p[O];
                w[3] === C && (o = h[w[4]], i = s(w[2], void 0), M || (o.plotX = w[0] - l.plotLeft + l.diffX, o.plotY = w[1] - l.plotTop + l.diffY), u(i) && (o.marker = E(o.marker, { radius: i, width: 2 * i, height: 2 * i }), o.radius = i));
              }
              M && this.deferLayout(), P(this, "afterTranslate");
            }, n.defaultOptions = y(m.defaultOptions, Q), n;
          }(m);
          return E(a.prototype, { pointClass: J, axisTypes: [], directTouch: !0, forces: ["barycenter", "repulsive"], hasDraggableNodes: !0, isCartesian: !1, noSharedTooltip: !0, pointArrayMap: ["value"], pointValKey: "value", requireSorting: !1, trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"], alignDataLabel: d.alignDataLabel, indexateNodes: b, onMouseDown: F.onMouseDown, onMouseMove: F.onMouseMove, redrawHalo: F.redrawHalo, searchPoint: b }), U.registerSeriesType("packedbubble", a), a;
        }), at(_, "Series/Polygon/PolygonSeries.js", [_["Core/Globals.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(v, g) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(x, E) {
              x.__proto__ = E;
            } || function(x, E) {
              for (var P in E)
                E.hasOwnProperty(P) && (x[P] = E[P]);
            }, J(v, g);
          }, function(v, g) {
            function x() {
              this.constructor = v;
            }
            J(v, g), v.prototype = g === null ? Object.create(g) : (x.prototype = g.prototype, new x());
          }), q = G.noop, U = $.series, N = $.seriesTypes, D = N.area, k = N.line, A = N.scatter, b = Y.extend, d = Y.merge, m = function(v) {
            function g() {
              var x = v !== null && v.apply(this, arguments) || this;
              return x.data = void 0, x.options = void 0, x.points = void 0, x;
            }
            return Q(g, v), g.prototype.getGraphPath = function() {
              for (var x = k.prototype.getGraphPath.call(this), E = x.length + 1; E--; )
                (E === x.length || x[E][0] === "M") && E > 0 && x.splice(E, 0, ["Z"]);
              return this.areaPath = x, x;
            }, g.prototype.drawGraph = function() {
              this.options.fillColor = this.color, D.prototype.drawGraph.call(this);
            }, g.defaultOptions = d(A.defaultOptions, { marker: { enabled: !1, states: { hover: { enabled: !1 } } }, stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "" }, trackByArea: !0 }), g;
          }(A);
          return b(m.prototype, { type: "polygon", drawLegendSymbol: F.drawRectangle, drawTracker: U.prototype.drawTracker, setStackedPoints: q }), $.registerSeriesType("polygon", m), m;
        }), at(_, "Core/Axis/WaterfallAxis.js", [_["Core/Axis/Stacking/StackItem.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = F.addEvent, J = F.objectEach;
          return function(Q) {
            var q = function() {
              function A(b) {
                this.axis = b, this.stacks = { changed: !1 };
              }
              return A.prototype.renderStackTotals = function() {
                var b = this.axis, d = b.waterfall.stacks, m = b.stacking && b.stacking.stackTotalGroup, v = new G(b, b.options.stackLabels || {}, !1, 0, void 0);
                this.dummyStackItem = v, m && J(d, function(g) {
                  J(g, function(x, E) {
                    v.total = x.stackTotal, v.x = +E, x.label && (v.label = x.label), G.prototype.render.call(v, m), x.label = v.label, delete v.label;
                  });
                }), v.total = null;
              }, A;
            }();
            function U() {
              var A = this.waterfall.stacks;
              A && (A.changed = !1, delete A.alreadyChanged);
            }
            function N() {
              var A = this, b = A.options.stackLabels;
              b && b.enabled && A.waterfall.stacks && A.waterfall.renderStackTotals();
            }
            function D() {
              for (var A = this.axes, b = this.series, d = b.length; d--; )
                b[d].options.stacking && (A.forEach(function(m) {
                  m.isXAxis || (m.waterfall.stacks.changed = !0);
                }), d = 0);
            }
            function k() {
              var A = this;
              A.waterfall || (A.waterfall = new q(A));
            }
            Q.Composition = q, Q.compose = function(A, b) {
              Y(A, "init", k), Y(A, "afterBuildStacks", U), Y(A, "afterRender", N), Y(b, "beforeRedraw", D);
            };
          }($ || ($ = {})), $;
        }), at(_, "Series/Waterfall/WaterfallPoint.js", [_["Series/Column/ColumnSeries.js"], _["Core/Series/Point.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(U, N) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, k) {
              D.__proto__ = k;
            } || function(D, k) {
              for (var A in k)
                k.hasOwnProperty(A) && (D[A] = k[A]);
            }, Y(U, N);
          }, function(U, N) {
            function D() {
              this.constructor = U;
            }
            Y(U, N), U.prototype = N === null ? Object.create(N) : (D.prototype = N.prototype, new D());
          }), Q = $.isNumber, q = function(U) {
            function N() {
              var D = U !== null && U.apply(this, arguments) || this;
              return D.options = void 0, D.series = void 0, D;
            }
            return J(N, U), N.prototype.getClassName = function() {
              var D = F.prototype.getClassName.call(this);
              return this.isSum ? D += " highcharts-sum" : this.isIntermediateSum && (D += " highcharts-intermediate-sum"), D;
            }, N.prototype.isValid = function() {
              return Q(this.y) || this.isSum || !!this.isIntermediateSum;
            }, N;
          }(G.prototype.pointClass);
          return q;
        }), at(_, "Series/Waterfall/WaterfallSeries.js", [_["Core/Axis/Axis.js"], _["Core/Chart/Chart.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"], _["Core/Axis/WaterfallAxis.js"], _["Series/Waterfall/WaterfallPoint.js"]], function(G, F, $, Y, J, Q) {
          var q, U = this && this.__extends || (q = function(u, y) {
            return q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, a) {
              s.__proto__ = a;
            } || function(s, a) {
              for (var e in a)
                a.hasOwnProperty(e) && (s[e] = a[e]);
            }, q(u, y);
          }, function(u, y) {
            function s() {
              this.constructor = u;
            }
            q(u, y), u.prototype = y === null ? Object.create(y) : (s.prototype = y.prototype, new s());
          }), N = $.seriesTypes, D = N.column, k = N.line, A = Y.arrayMax, b = Y.arrayMin, d = Y.correctFloat, m = Y.extend, v = Y.isNumber, g = Y.merge, x = Y.objectEach, E = Y.pick;
          function P(u, y) {
            return Object.hasOwnProperty.call(u, y);
          }
          var S = function(u) {
            function y() {
              var s = u !== null && u.apply(this, arguments) || this;
              return s.chart = void 0, s.data = void 0, s.options = void 0, s.points = void 0, s.stackedYNeg = void 0, s.stackedYPos = void 0, s.stackKey = void 0, s.xData = void 0, s.yAxis = void 0, s.yData = void 0, s;
            }
            return U(y, u), y.prototype.generatePoints = function() {
              D.prototype.generatePoints.apply(this);
              for (var s = 0, a = this.points.length; s < a; s++) {
                var e = this.points[s], n = this.processedYData[s];
                v(n) && (e.isIntermediateSum || e.isSum) && (e.y = d(n));
              }
            }, y.prototype.translate = function() {
              var s, a, e, n, o = this, i = o.options, c = o.yAxis, l = E(i.minPointLength, 5), h = l / 2, C = i.threshold || 0, M = i.stacking, O = c.waterfall.stacks[o.stackKey], p = C, w = C;
              D.prototype.translate.apply(o);
              for (var T = o.points, z = 0; z < T.length; z++) {
                var W = T[z], L = o.processedYData[z], I = W.shapeArgs;
                if (I && v(L)) {
                  var j = [0, L], Z = W.y;
                  if (M) {
                    if (O) {
                      var V = O[z];
                      M === "overlap" ? (a = V.stackState[V.stateIndex--], s = Z >= 0 ? a : a - Z, P(V, "absolutePos") && delete V.absolutePos, P(V, "absoluteNeg") && delete V.absoluteNeg) : (Z >= 0 ? (a = V.threshold + V.posTotal, V.posTotal -= Z, s = a) : (a = V.threshold + V.negTotal, V.negTotal -= Z, s = a - Z), V.posTotal || v(V.absolutePos) && P(V, "absolutePos") && (V.posTotal = V.absolutePos, delete V.absolutePos), V.negTotal || v(V.absoluteNeg) && P(V, "absoluteNeg") && (V.negTotal = V.absoluteNeg, delete V.absoluteNeg)), W.isSum || (V.connectorThreshold = V.threshold + V.stackTotal), c.reversed ? (e = Z >= 0 ? s - Z : s + Z, n = s) : (e = s, n = s - Z), W.below = e <= C, I.y = c.translate(e, !1, !0, !1, !0), I.height = Math.abs(I.y - c.translate(n, !1, !0, !1, !0));
                      var X = c.waterfall.dummyStackItem;
                      X && (X.x = z, X.label = O[z].label, X.setOffset(o.pointXOffset || 0, o.barW || 0, o.stackedYNeg[z], o.stackedYPos[z], void 0, this.xAxis));
                    }
                  } else
                    s = Math.max(w, w + Z) + j[0], I.y = c.translate(s, !1, !0, !1, !0), W.isSum ? (I.y = c.translate(j[1], !1, !0, !1, !0), I.height = Math.min(c.translate(j[0], !1, !0, !1, !0), c.len) - I.y, W.below = j[1] <= C) : W.isIntermediateSum ? (Z >= 0 ? (e = j[1] + p, n = p) : (e = p, n = j[1] + p), c.reversed && (e ^= n, e ^= n ^= e), I.y = c.translate(e, !1, !0, !1, !0), I.height = Math.abs(I.y - Math.min(c.translate(n, !1, !0, !1, !0), c.len)), p += j[1], W.below = e <= C) : (I.height = L > 0 ? c.translate(w, !1, !0, !1, !0) - I.y : c.translate(w, !1, !0, !1, !0) - c.translate(w - L, !1, !0, !1, !0), w += L, W.below = w < C), I.height < 0 && (I.y += I.height, I.height *= -1);
                  W.plotY = I.y = Math.round(I.y || 0) - o.borderWidth % 2 / 2, I.height = Math.max(Math.round(I.height || 0), 1e-3), W.yBottom = I.y + I.height, I.height <= l && !W.isNull ? (I.height = l, I.y -= h, W.plotY = I.y, W.y < 0 ? W.minPointLengthOffset = -h : W.minPointLengthOffset = h) : (W.isNull && (I.width = 0), W.minPointLengthOffset = 0);
                  var et = W.plotY + (W.negative ? I.height : 0);
                  W.below && (W.plotY += I.height), W.tooltipPos && (o.chart.inverted ? W.tooltipPos[0] = c.len - et : W.tooltipPos[1] = et), W.isInside = this.isPointInside(W);
                }
              }
            }, y.prototype.processData = function(s) {
              var a, e, n, o, i, c, l, h = this, C = h.options, M = h.yData, O = C.data, p = M.length, w = C.threshold || 0;
              for (n = e = o = i = 0, l = 0; l < p; l++)
                c = M[l], a = O && O[l] ? O[l] : {}, c === "sum" || a.isSum ? M[l] = d(n) : c === "intermediateSum" || a.isIntermediateSum ? (M[l] = d(e), e = 0) : (n += c, e += c), o = Math.min(n, o), i = Math.max(n, i);
              u.prototype.processData.call(this, s), C.stacking || (h.dataMin = o + w, h.dataMax = i);
            }, y.prototype.toYData = function(s) {
              return s.isSum ? "sum" : s.isIntermediateSum ? "intermediateSum" : s.y;
            }, y.prototype.updateParallelArrays = function(s, a) {
              u.prototype.updateParallelArrays.call(this, s, a), this.yData[0] !== "sum" && this.yData[0] !== "intermediateSum" || (this.yData[0] = null);
            }, y.prototype.pointAttribs = function(s, a) {
              var e = this.options.upColor;
              e && !s.options.color && (s.color = s.y > 0 ? e : void 0);
              var n = D.prototype.pointAttribs.call(this, s, a);
              return delete n.dashstyle, n;
            }, y.prototype.getGraphPath = function() {
              return [["M", 0, 0]];
            }, y.prototype.getCrispPath = function() {
              var s, a, e, n, o, i, c, l, h, C = this.data, M = this.yAxis, O = C.length, p = Math.round(this.graph.strokeWidth()) % 2 / 2, w = Math.round(this.borderWidth) % 2 / 2, T = this.xAxis.reversed, z = this.yAxis.reversed, W = this.options.stacking, L = [];
              for (h = 1; h < O; h++)
                if (l = C[h].shapeArgs, n = C[h - 1], c = C[h - 1].shapeArgs, a = M.waterfall.stacks[this.stackKey], i = n.y > 0 ? -c.height : 0, a && c && l && (e = a[h - 1], W ? (s = e.connectorThreshold, o = Math.round(M.translate(s, !1, !0, !1, !0) + (z ? i : 0)) - p) : o = c.y + n.minPointLengthOffset + w - p, L.push(["M", (c.x || 0) + (T ? 0 : c.width || 0), o], ["L", (l.x || 0) + (T && l.width || 0), o])), c && L.length && (!W && n.y < 0 && !z || n.y > 0 && z)) {
                  var I = L[L.length - 2];
                  I && typeof I[2] == "number" && (I[2] += c.height || 0);
                  var j = L[L.length - 1];
                  j && typeof j[2] == "number" && (j[2] += c.height || 0);
                }
              return L;
            }, y.prototype.drawGraph = function() {
              k.prototype.drawGraph.call(this), this.graph && this.graph.attr({ d: this.getCrispPath() });
            }, y.prototype.setStackedPoints = function() {
              var s, a, e, n, o, i, c, l, h, C, M, O, p = this, w = p.options, T = p.yAxis.waterfall.stacks, z = w.threshold || 0, W = z, L = W, I = p.stackKey, j = p.xData, Z = j.length;
              function V(ot, it, pt, mt) {
                if (s) {
                  if (o)
                    for (; pt < o; pt++)
                      s.stackState[pt] += mt;
                  else
                    s.stackState[0] = ot, o = s.stackState.length;
                  s.stackState.push(s.stackState[o - 1] + it);
                }
              }
              if (p.yAxis.stacking.usePercentage = !1, a = e = n = W, p.visible || !p.chart.options.chart.ignoreHiddenSeries) {
                O = T.changed, (M = T.alreadyChanged) && M.indexOf(I) < 0 && (O = !0), T[I] || (T[I] = {});
                var X = T[I];
                if (X)
                  for (var et = 0; et < Z; et++)
                    X[C = j[et]] && !O || (X[C] = { negTotal: 0, posTotal: 0, stackTotal: 0, threshold: 0, stateIndex: 0, stackState: [], label: O && X[C] ? X[C].label : void 0 }), s = X[C], (h = p.yData[et]) >= 0 ? s.posTotal += h : s.negTotal += h, l = w.data[et], i = s.absolutePos = s.posTotal, c = s.absoluteNeg = s.negTotal, s.stackTotal = i + c, o = s.stackState.length, l && l.isIntermediateSum ? (V(n, e, 0, n), n = e, e = z, W ^= L, W ^= L ^= W) : l && l.isSum ? (V(z, a, o, 0), W = z) : (V(W, h, 0, a), l && (a += h, e += h)), s.stateIndex++, s.threshold = W, W += s.stackTotal;
                T.changed = !1, T.alreadyChanged || (T.alreadyChanged = []), T.alreadyChanged.push(I);
              }
            }, y.prototype.getExtremes = function() {
              var s, a, e, n = this.options.stacking;
              return n ? (s = this.yAxis.waterfall.stacks, a = this.stackedYNeg = [], e = this.stackedYPos = [], x(s[this.stackKey], n === "overlap" ? function(o) {
                a.push(b(o.stackState)), e.push(A(o.stackState));
              } : function(o) {
                a.push(o.negTotal + o.threshold), e.push(o.posTotal + o.threshold);
              }), { dataMin: b(a), dataMax: A(e) }) : { dataMin: this.dataMin, dataMax: this.dataMax };
            }, y.defaultOptions = g(D.defaultOptions, { dataLabels: { inside: !0 }, lineWidth: 1, lineColor: "#333333", dashStyle: "Dot", borderColor: "#333333", states: { hover: { lineWidthPlus: 0 } } }), y;
          }(D);
          return m(S.prototype, { getZonesGraphs: k.prototype.getZonesGraphs, pointValKey: "y", showLine: !0, pointClass: Q }), $.registerSeriesType("waterfall", S), J.compose(G, F), S;
        }), at(_, "Core/Axis/RadialAxis.js", [_["Core/Axis/AxisDefaults.js"], _["Core/Defaults.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = F.defaultOptions, q = $.noop, U = Y.addEvent, N = Y.correctFloat, D = Y.defined, k = Y.extend, A = Y.fireEvent, b = Y.merge, d = Y.pick, m = Y.relativeLength, v = Y.wrap;
          return function(g) {
            var x = [], E = { gridLineWidth: 1, labels: { align: void 0, distance: 15, x: 0, y: void 0, style: { textOverflow: "none" } }, maxPadding: 0, minPadding: 0, showLastLabel: !1, tickLength: 0 }, P = { labels: { align: "center", x: 0, y: void 0 }, minorGridLineWidth: 0, minorTickInterval: "auto", minorTickLength: 10, minorTickPosition: "inside", minorTickWidth: 1, tickLength: 10, tickPosition: "inside", tickWidth: 2, title: { rotation: 0 }, zIndex: 2 }, S = { gridLineInterpolation: "circle", gridLineWidth: 1, labels: { align: "right", x: -3, y: -2 }, showLastLabel: !1, title: { x: 4, text: null, rotation: 90 } };
            function u() {
              this.autoConnect = this.isCircular && d(this.userMax, this.options.max) === void 0 && N(this.endAngleRad - this.startAngleRad) === N(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += (this.categories ? 1 : this.pointRange) || this.closestPointRange || 0);
            }
            function y() {
              var X = this;
              return function() {
                if (X.isRadial && X.tickPositions && X.options.labels && X.options.labels.allowOverlap !== !0)
                  return X.tickPositions.map(function(et) {
                    return X.ticks[et] && X.ticks[et].label;
                  }).filter(function(et) {
                    return !!et;
                  });
              };
            }
            function s() {
              return q;
            }
            function a(X, et, ot) {
              var it, pt, mt, Ct = this.pane.center, kt = X.value;
              return this.isCircular ? (D(kt) ? X.point && (X.point.shapeArgs || {}).start && (kt = this.chart.inverted ? this.translate(X.point.rectPlotY, !0) : X.point.x) : (pt = X.chartX || 0, mt = X.chartY || 0, kt = this.translate(Math.atan2(mt - ot, pt - et) - this.startAngleRad, !0)), pt = (it = this.getPosition(kt)).x, mt = it.y) : (D(kt) || (pt = X.chartX, mt = X.chartY), D(pt) && D(mt) && (ot = Ct[1] + this.chart.plotTop, kt = this.translate(Math.min(Math.sqrt(Math.pow(pt - et, 2) + Math.pow(mt - ot, 2)), Ct[2] / 2) - Ct[3] / 2, !0))), [kt, pt || 0, mt || 0];
            }
            function e(X, et, ot) {
              var it, pt, mt = this.pane.center, Ct = this.chart, kt = this.left || 0, Lt = this.top || 0, Tt = d(et, mt[2] / 2 - this.offset);
              return ot === void 0 && (ot = this.horiz ? 0 : this.center && -this.center[3] / 2), ot && (Tt += ot), this.isCircular || et !== void 0 ? ((pt = this.chart.renderer.symbols.arc(kt + mt[0], Lt + mt[1], Tt, Tt, { start: this.startAngleRad, end: this.endAngleRad, open: !0, innerR: 0 })).xBounds = [kt + mt[0]], pt.yBounds = [Lt + mt[1] - Tt]) : (it = this.postTranslate(this.angleRad, Tt), pt = [["M", this.center[0] + Ct.plotLeft, this.center[1] + Ct.plotTop], ["L", it.x, it.y]]), pt;
            }
            function n() {
              this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
            }
            function o(X, et, ot) {
              var it, pt, mt, Ct, kt, Lt, Tt = this.chart, xt = function(Jt) {
                if (typeof Jt == "string") {
                  var Qt = parseInt(Jt, 10);
                  return Nt.test(Jt) && (Qt = Qt * St / 100), Qt;
                }
                return Jt;
              }, ct = this.center, ft = this.startAngleRad, St = ct[2] / 2, Mt = Math.min(this.offset, 0), Dt = this.left || 0, Ot = this.top || 0, Nt = /%$/, Wt = this.isCircular, zt = d(xt(ot.outerRadius), St), Ht = xt(ot.innerRadius), Kt = d(xt(ot.thickness), 10);
              if (this.options.gridLineInterpolation === "polygon")
                Lt = this.getPlotLinePath({ value: X }).concat(this.getPlotLinePath({ value: et, reverse: !0 }));
              else {
                X = Math.max(X, this.min), et = Math.min(et, this.max);
                var Gt = this.translate(X), ee = this.translate(et);
                Wt || (zt = Gt || 0, Ht = ee || 0), ot.shape !== "circle" && Wt ? (it = ft + (Gt || 0), pt = ft + (ee || 0)) : (it = -Math.PI / 2, pt = 1.5 * Math.PI, kt = !0), zt -= Mt, Kt -= Mt, Lt = Tt.renderer.symbols.arc(Dt + ct[0], Ot + ct[1], zt, zt, { start: Math.min(it, pt), end: Math.max(it, pt), innerR: d(Ht, zt - Kt), open: kt }), Wt && (mt = (pt + it) / 2, Ct = Dt + ct[0] + ct[2] / 2 * Math.cos(mt), Lt.xBounds = mt > -Math.PI / 2 && mt < Math.PI / 2 ? [Ct, Tt.plotWidth] : [0, Ct], Lt.yBounds = [Ot + ct[1] + ct[2] / 2 * Math.sin(mt)], Lt.yBounds[0] += mt > -Math.PI && mt < 0 || mt > Math.PI ? -10 : 10);
              }
              return Lt;
            }
            function i(X) {
              var et, ot, it, pt, mt, Ct, kt, Lt, Tt, xt = this, ct = this.pane.center, ft = this.chart, St = ft.inverted, Mt = X.reverse, Dt = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {}, Ot = Dt.innerRadius || "0%", Nt = Dt.outerRadius || "100%", Wt = ct[0] + ft.plotLeft, zt = ct[1] + ft.plotTop, Ht = this.height, Kt = X.isCrosshair, Gt = ct[3] / 2, ee = X.value, Jt = this.getPosition(ee), Qt = Jt.x, ne = Jt.y;
              if (Kt && (ee = (Lt = this.getCrosshairPosition(X, Wt, zt))[0], Qt = Lt[1], ne = Lt[2]), this.isCircular)
                ot = Math.sqrt(Math.pow(Qt - Wt, 2) + Math.pow(ne - zt, 2)), it = typeof Ot == "string" ? m(Ot, 1) : Ot / ot, pt = typeof Nt == "string" ? m(Nt, 1) : Nt / ot, ct && Gt && (it < (et = Gt / ot) && (it = et), pt < et && (pt = et)), Tt = [["M", Wt + it * (Qt - Wt), zt - it * (zt - ne)], ["L", Qt - (1 - pt) * (Qt - Wt), ne + (1 - pt) * (zt - ne)]];
              else if ((ee = this.translate(ee)) && (ee < 0 || ee > Ht) && (ee = 0), this.options.gridLineInterpolation === "circle")
                Tt = this.getLinePath(0, ee, Gt);
              else if (Tt = [], ft[St ? "yAxis" : "xAxis"].forEach(function(Me) {
                Me.pane === xt.pane && (mt = Me);
              }), mt) {
                kt = mt.tickPositions, mt.autoConnect && (kt = kt.concat([kt[0]])), Mt && (kt = kt.slice().reverse()), ee && (ee += Gt);
                for (var ae = 0; ae < kt.length; ae++)
                  Ct = mt.getPosition(kt[ae], ee), Tt.push(ae ? ["L", Ct.x, Ct.y] : ["M", Ct.x, Ct.y]);
              }
              return Tt;
            }
            function c(X, et) {
              var ot = this.translate(X);
              return this.postTranslate(this.isCircular ? ot : this.angleRad, d(this.isCircular ? et : ot < 0 ? 0 : ot, this.center[2] / 2) - this.offset);
            }
            function l() {
              var X = this.center, et = this.chart, ot = this.options.title;
              return { x: et.plotLeft + X[0] + (ot.x || 0), y: et.plotTop + X[1] - { high: 0.5, middle: 0.25, low: 0 }[ot.align] * X[2] + (ot.y || 0) };
            }
            function h(X) {
              X.beforeSetTickPositions = u, X.createLabelCollector = y, X.getCrosshairPosition = a, X.getLinePath = e, X.getOffset = n, X.getPlotBandPath = o, X.getPlotLinePath = i, X.getPosition = c, X.getTitlePosition = l, X.postTranslate = W, X.setAxisSize = I, X.setAxisTranslation = j, X.setOptions = Z;
            }
            function C() {
              var X = this.chart, et = this.options, ot = X.angular && this.isXAxis, it = this.pane, pt = it && it.options;
              if (!ot && it && (X.angular || X.polar)) {
                var mt = 2 * Math.PI, Ct = (d(pt.startAngle, 0) - 90) * Math.PI / 180, kt = (d(pt.endAngle, d(pt.startAngle, 0) + 360) - 90) * Math.PI / 180;
                this.angleRad = (et.angle || 0) * Math.PI / 180, this.startAngleRad = Ct, this.endAngleRad = kt, this.offset = et.offset || 0;
                var Lt = (Ct % mt + mt) % mt, Tt = (kt % mt + mt) % mt;
                Lt > Math.PI && (Lt -= mt), Tt > Math.PI && (Tt -= mt), this.normalizedStartAngleRad = Lt, this.normalizedEndAngleRad = Tt;
              }
            }
            function M(X) {
              this.isRadial && (X.align = void 0, X.preventDefault());
            }
            function O() {
              if (this.chart && this.chart.labelCollectors) {
                var X = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
                X >= 0 && this.chart.labelCollectors.splice(X, 1);
              }
            }
            function p(X) {
              var et, ot, it = this.chart, pt = it.inverted, mt = it.angular, Ct = it.polar, kt = this.isXAxis, Lt = this.coll, Tt = mt && kt, xt = X.userOptions.pane || 0, ct = this.pane = it.pane && it.pane[xt];
              Lt !== "colorAxis" ? (mt ? (Tt ? ((ot = this).isHidden = !0, ot.createLabelCollector = s, ot.getOffset = q, ot.redraw = L, ot.render = L, ot.setScale = q, ot.setCategories = q, ot.setTitle = q) : h(this), (et = !kt) && (this.defaultPolarOptions = P)) : Ct && (h(this), et = this.horiz, this.defaultPolarOptions = et ? E : b(Lt === "xAxis" ? G.defaultXAxisOptions : G.defaultYAxisOptions, S), pt && Lt === "yAxis" && (this.defaultPolarOptions.stackLabels = G.defaultYAxisOptions.stackLabels, this.defaultPolarOptions.reversedStacks = !0)), mt || Ct ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && it.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, ct && et && (ct.axis = this), this.isCircular = et) : this.isRadial = !1;
            }
            function w() {
              this.isRadial && this.beforeSetTickPositions();
            }
            function T(X) {
              var et = this.label;
              if (et) {
                var ot, it = this.axis, pt = et.getBBox(), mt = it.options.labels, Ct = (it.translate(this.pos) + it.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, kt = Math.round(Ct), Lt = D(mt.y) ? 0 : 0.3 * -pt.height, Tt = mt.y, xt = 20, ct = mt.align, ft = "end", St = kt < 0 ? kt + 360 : kt, Mt = St, Dt = 0, Ot = 0;
                it.isRadial && (ot = it.getPosition(this.pos, it.center[2] / 2 + m(d(mt.distance, -25), it.center[2] / 2, -it.center[2] / 2)), mt.rotation === "auto" ? et.attr({ rotation: Ct }) : D(Tt) || (Tt = it.chart.renderer.fontMetrics(et.styles && et.styles.fontSize).b - pt.height / 2), D(ct) || (it.isCircular ? (pt.width > it.len * it.tickInterval / (it.max - it.min) && (xt = 0), ct = Ct > xt && Ct < 180 - xt ? "left" : Ct > 180 + xt && Ct < 360 - xt ? "right" : "center") : ct = "center", et.attr({ align: ct })), ct === "auto" && it.tickPositions.length === 2 && it.isCircular && (St > 90 && St < 180 ? St = 180 - St : St > 270 && St <= 360 && (St = 540 - St), Mt > 180 && Mt <= 360 && (Mt = 360 - Mt), it.pane.options.startAngle !== kt && it.pane.options.startAngle !== kt + 360 && it.pane.options.startAngle !== kt - 360 || (ft = "start"), ct = kt >= -90 && kt <= 90 || kt >= -360 && kt <= -270 || kt >= 270 && kt <= 360 ? ft === "start" ? "right" : "left" : ft === "start" ? "left" : "right", Mt > 70 && Mt < 110 && (ct = "center"), St < 15 || St >= 180 && St < 195 ? Dt = 0.3 * pt.height : St >= 15 && St <= 35 ? Dt = ft === "start" ? 0 : 0.75 * pt.height : St >= 195 && St <= 215 ? Dt = ft === "start" ? 0.75 * pt.height : 0 : St > 35 && St <= 90 ? Dt = ft === "start" ? 0.25 * -pt.height : pt.height : St > 215 && St <= 270 && (Dt = ft === "start" ? pt.height : 0.25 * -pt.height), Mt < 15 ? Ot = ft === "start" ? 0.15 * -pt.height : 0.15 * pt.height : Mt > 165 && Mt <= 180 && (Ot = ft === "start" ? 0.15 * pt.height : 0.15 * -pt.height), et.attr({ align: ct }), et.translate(Ot, Dt + Lt)), X.pos.x = ot.x + (mt.x || 0), X.pos.y = ot.y + (Tt || 0));
              }
            }
            function z(X) {
              this.axis.getPosition && k(X.pos, this.axis.getPosition(this.pos));
            }
            function W(X, et) {
              var ot = this.chart, it = this.center;
              return X = this.startAngleRad + X, { x: ot.plotLeft + it[0] + Math.cos(X) * et, y: ot.plotTop + it[1] + Math.sin(X) * et };
            }
            function L() {
              this.isDirty = !1;
            }
            function I() {
              var X, et;
              this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), X = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (et = this.postTranslate(this.angleRad, X[3] / 2), X[0] = et.x - this.chart.plotLeft, X[1] = et.y - this.chart.plotTop), this.len = this.width = this.height = (X[2] - X[3]) * d(this.sector, 1) / 2);
            }
            function j() {
              this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
            }
            function Z(X) {
              var et = this.options = b(this.constructor.defaultOptions, this.defaultPolarOptions, Q[this.coll], X);
              et.plotBands || (et.plotBands = []), A(this, "afterSetOptions");
            }
            function V(X, et, ot, it, pt, mt, Ct) {
              var kt, Lt = this.axis;
              return Lt.isRadial ? ["M", et, ot, "L", (kt = Lt.getPosition(this.pos, Lt.center[2] / 2 + it)).x, kt.y] : X.call(this, et, ot, it, pt, mt, Ct);
            }
            g.compose = function(X, et) {
              return x.indexOf(X) === -1 && (x.push(X), U(X, "afterInit", C), U(X, "autoLabelAlign", M), U(X, "destroy", O), U(X, "init", p), U(X, "initialAxisTranslation", w)), x.indexOf(et) === -1 && (x.push(et), U(et, "afterGetLabelPosition", T), U(et, "afterGetPosition", z), v(et.prototype, "getMarkPath", V)), X;
            };
          }(J || (J = {})), J;
        }), at(_, "Series/PolarComposition.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Globals.js"], _["Extensions/Pane.js"], _["Core/Axis/RadialAxis.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = this && this.__spreadArray || function(p, w, T) {
            if (T || arguments.length === 2)
              for (var z, W = 0, L = w.length; W < L; W++)
                !z && W in w || (z || (z = Array.prototype.slice.call(w, 0, W)), z[W] = w[W]);
            return p.concat(z || Array.prototype.slice.call(w));
          }, q = G.animObject, U = J.addEvent, N = J.defined, D = J.find, k = J.isNumber, A = J.pick, b = J.splat, d = J.uniqueKey, m = J.wrap, v = [];
          function g(p, w, T, z) {
            var W, L, I, j, Z, V, X = 1.5, et = 2.5, ot = z ? 1 : 0, it = (W = w >= 0 && w <= p.length - 1 ? w : w < 0 ? p.length - 1 + w : 0) - 1 < 0 ? p.length - (1 + ot) : W - 1, pt = W + 1 > p.length - 1 ? ot : W + 1, mt = p[it], Ct = p[pt], kt = mt.plotX, Lt = mt.plotY, Tt = Ct.plotX, xt = Ct.plotY, ct = p[W].plotX, ft = p[W].plotY;
            L = (X * ct + kt) / et, I = (X * ft + Lt) / et, j = (X * ct + Tt) / et, Z = (X * ft + xt) / et;
            var St = Math.sqrt(Math.pow(L - ct, 2) + Math.pow(I - ft, 2)), Mt = Math.sqrt(Math.pow(j - ct, 2) + Math.pow(Z - ft, 2)), Dt = Math.atan2(I - ft, L - ct), Ot = Math.atan2(Z - ft, j - ct);
            V = Math.PI / 2 + (Dt + Ot) / 2, Math.abs(Dt - V) > Math.PI / 2 && (V -= Math.PI), L = ct + Math.cos(V) * St, I = ft + Math.sin(V) * St;
            var Nt = { rightContX: j = ct + Math.cos(Math.PI + V) * Mt, rightContY: Z = ft + Math.sin(Math.PI + V) * Mt, leftContX: L, leftContY: I, plotX: ct, plotY: ft };
            return T && (Nt.prevPointCont = g(p, it, !1, z)), Nt;
          }
          function x() {
            (this.pane || []).forEach(function(p) {
              p.render();
            });
          }
          function E(p) {
            var w = p.args[0].xAxis, T = p.args[0].yAxis, z = p.args[0].chart;
            w && T && (T.gridLineInterpolation === "polygon" ? (w.startOnTick = !0, w.endOnTick = !0) : w.gridLineInterpolation === "polygon" && z.inverted && (T.startOnTick = !0, T.endOnTick = !0));
          }
          function P() {
            var p = this;
            this.pane || (this.pane = []), this.options.pane = b(this.options.pane), this.options.pane.forEach(function(w) {
              new $(w, p);
            }, this);
          }
          function S(p) {
            var w = p.args.marker, T = this.chart.xAxis[0], z = this.chart.yAxis[0], W = this.chart.inverted, L = W ? z : T, I = W ? T : z;
            if (this.chart.polar) {
              p.preventDefault();
              var j = (w.attr ? w.attr("start") : w.start) - L.startAngleRad, Z = w.attr ? w.attr("r") : w.r, V = (w.attr ? w.attr("end") : w.end) - L.startAngleRad, X = w.attr ? w.attr("innerR") : w.innerR;
              p.result.x = j + L.pos, p.result.width = V - j, p.result.y = I.len + I.pos - X, p.result.height = X - Z;
            }
          }
          function u(p) {
            var w = this.chart;
            if (w.polar && w.hoverPane && w.hoverPane.axis) {
              p.preventDefault();
              var T = w.hoverPane.center, z = this.mouseDownX || 0, W = this.mouseDownY || 0, L = p.args.chartY, I = p.args.chartX, j = 2 * Math.PI, Z = w.hoverPane.axis.startAngleRad, V = w.hoverPane.axis.endAngleRad, X = w.inverted ? w.xAxis[0] : w.yAxis[0], et = {}, ot = "arc";
              if (et.x = T[0] + w.plotLeft, et.y = T[1] + w.plotTop, this.zoomHor) {
                var it = Z > 0 ? V - Z : Math.abs(Z) + Math.abs(V), pt = Math.atan2(W - w.plotTop - T[1], z - w.plotLeft - T[0]) - Z, mt = Math.atan2(L - w.plotTop - T[1], I - w.plotLeft - T[0]) - Z;
                et.r = T[2] / 2, et.innerR = T[3] / 2, pt <= 0 && (pt += j), mt <= 0 && (mt += j), mt < pt && (mt = [pt, pt = mt][0]), it < j && Z + mt > V + (j - it) / 2 && (mt = pt, pt = Z <= 0 ? Z : 0);
                var Ct = et.start = Math.max(pt + Z, Z), kt = et.end = Math.min(mt + Z, V);
                if (X.options.gridLineInterpolation === "polygon") {
                  (Ht = w.hoverPane.axis).tickInterval;
                  var Lt = Ct - Ht.startAngleRad + Ht.pos, Tt = kt - Ct, xt = X.getPlotLinePath({ value: X.max }), ct = Ht.toValue(Lt), ft = Ht.toValue(Lt + Tt);
                  if (ct < Ht.getExtremes().min) {
                    var St = Ht.getExtremes(), Mt = St.min;
                    ct = St.max - (Mt - ct);
                  }
                  if (ft < Ht.getExtremes().min) {
                    var Dt = Ht.getExtremes(), Ot = Dt.min;
                    ft = Dt.max - (Ot - ft);
                  }
                  ft < ct && (ft = [ct, ct = ft][0]), (xt = e(xt, ct, ft, Ht)).push(["L", T[0] + w.plotLeft, w.plotTop + T[1]]), et.d = xt, ot = "path";
                }
              }
              if (this.zoomVert) {
                var Nt = w.inverted ? w.xAxis[0] : w.yAxis[0], Wt = Math.sqrt(Math.pow(z - w.plotLeft - T[0], 2) + Math.pow(W - w.plotTop - T[1], 2)), zt = Math.sqrt(Math.pow(I - w.plotLeft - T[0], 2) + Math.pow(L - w.plotTop - T[1], 2));
                zt < Wt && (Wt = [zt, zt = Wt][0]), zt > T[2] / 2 && (zt = T[2] / 2), Wt < T[3] / 2 && (Wt = T[3] / 2), this.zoomHor || (et.start = Z, et.end = V), et.r = zt, et.innerR = Wt, Nt.options.gridLineInterpolation === "polygon" && (kt = Nt.toValue(Nt.len + Nt.pos - Wt), Ct = Nt.toValue(Nt.len + Nt.pos - zt), xt = Nt.getPlotLinePath({ value: Ct }).concat(Nt.getPlotLinePath({ value: kt, reverse: !0 })), et.d = xt, ot = "path");
              }
              if (this.zoomHor && this.zoomVert && X.options.gridLineInterpolation === "polygon") {
                var Ht = w.hoverPane.axis;
                if (Ct = et.start || 0, kt = et.end || 0, Lt = Ct - Ht.startAngleRad + Ht.pos, Tt = kt - Ct, ct = Ht.toValue(Lt), ft = Ht.toValue(Lt + Tt), et.d instanceof Array) {
                  var Kt = et.d.slice(0, et.d.length / 2), Gt = et.d.slice(et.d.length / 2, et.d.length);
                  Gt = Q([], Gt, !0).reverse();
                  var ee = w.hoverPane.axis;
                  Kt = e(Kt, ct, ft, ee), (Gt = e(Gt, ct, ft, ee)) && (Gt[0][0] = "L"), Gt = Q([], Gt, !0).reverse(), et.d = Kt.concat(Gt), ot = "path";
                }
              }
              p.attrs = et, p.shapeType = ot;
            }
          }
          function y() {
            var p = this.chart;
            p.polar && (this.polar = new O(this), p.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
          }
          function s() {
            if (this.chart.polar && this.xAxis) {
              var p = this, w = p.chart;
              p.kdByAngle = w.tooltip && w.tooltip.shared, p.kdByAngle ? p.searchPoint = a : p.options.findNearestPointBy = "xy";
              for (var T = p.points, z = T.length; z--; )
                p.preventPostTranslate || p.polar.toXY(T[z]), w.hasParallelCoordinates || p.yAxis.reversed || (A(T[z].y, Number.MIN_VALUE) < p.yAxis.min || T[z].x < p.xAxis.min || T[z].x > p.xAxis.max ? (T[z].isNull = !0, T[z].plotY = NaN) : T[z].isNull = T[z].isValid && !T[z].isValid());
              this.hasClipCircleSetter || (this.hasClipCircleSetter = !!p.eventsToUnbind.push(U(p, "afterRender", function() {
                var W, L, I, j, Z, V, X, et, ot;
                w.polar && (W = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({ x: W[0], y: W[1], r: W[2] / 2, innerR: W[3] / 2 }) : this.clipCircle = (L = w.renderer, I = W[0], j = W[1], Z = W[2] / 2, V = W[3] / 2, X = d(), et = L.createElement("clipPath").attr({ id: X }).add(L.defs), (ot = V ? L.arc(I, j, Z, V, 0, 2 * Math.PI).add(et) : L.circle(I, j, Z).add(et)).id = X, ot.clipPath = et, ot), this.group.clip(this.clipCircle), this.setClip = F.noop);
              })));
            }
          }
          function a(p) {
            var w = this, T = w.chart, z = w.xAxis, W = z.pane && z.pane.center, L = p.chartX - (W && W[0] || 0) - T.plotLeft, I = p.chartY - (W && W[1] || 0) - T.plotTop;
            return w.searchKDTree({ clientX: 180 + Math.atan2(L, I) * (-180 / Math.PI) });
          }
          function e(p, w, T, z) {
            var W = z.tickInterval, L = z.tickPositions, I = D(L, function(Z) {
              return Z >= T;
            }), j = D(Q([], L, !0).reverse(), function(Z) {
              return Z <= w;
            });
            return N(I) || (I = L[L.length - 1]), N(j) || (j = L[0], I += W, p[0][0] = "L", p.unshift(p[p.length - 3])), (p = p.slice(L.indexOf(j), L.indexOf(I) + 1))[0][0] = "M", p;
          }
          function n(p, w) {
            return D(this.pane || [], function(T) {
              return T.options.id === w;
            }) || p.call(this, w);
          }
          function o(p, w, T, z, W, L) {
            var I, j, Z, V = this.chart, X = A(z.inside, !!this.options.stacking);
            V.polar ? (I = w.rectPlotX / Math.PI * 180, V.inverted ? (this.forceDL = V.isInsidePlot(w.plotX, w.plotY), X && w.shapeArgs ? (j = w.shapeArgs, W = { x: (Z = this.yAxis.postTranslate(((j.start || 0) + (j.end || 0)) / 2 - this.xAxis.startAngleRad, w.barX + w.pointWidth / 2)).x - V.plotLeft, y: Z.y - V.plotTop }) : w.tooltipPos && (W = { x: w.tooltipPos[0], y: w.tooltipPos[1] }), z.align = A(z.align, "center"), z.verticalAlign = A(z.verticalAlign, "middle")) : z = function(et, ot) {
              var it, pt;
              return ot.align === null && (it = et > 20 && et < 160 ? "left" : et > 200 && et < 340 ? "right" : "center", ot.align = it), ot.verticalAlign === null && (pt = et < 45 || et > 315 ? "bottom" : et > 135 && et < 225 ? "top" : "middle", ot.verticalAlign = pt), ot;
            }(I, z), Object.getPrototypeOf(Object.getPrototypeOf(this)).alignDataLabel.call(this, w, T, z, W, L), this.isRadialBar && w.shapeArgs && w.shapeArgs.start === w.shapeArgs.end ? T.hide() : T.show()) : p.call(this, w, T, z, W, L);
          }
          function i(p) {
            var w, T, z, W, L, I, j, Z, V, X, et, ot, it, pt = this, mt = pt.options, Ct = mt.stacking, kt = pt.chart, Lt = pt.xAxis, Tt = pt.yAxis, xt = Tt.reversed, ct = Tt.center, ft = Lt.startAngleRad, St = Lt.endAngleRad - ft, Mt = mt.threshold, Dt = 0, Ot = 0, Nt = 0;
            if (pt.preventPostTranslate = !0, p.call(pt), Lt.isRadial)
              for (z = (w = pt.points).length, W = Tt.translate(Tt.min), L = Tt.translate(Tt.max), Mt = mt.threshold || 0, kt.inverted && k(Mt) && (Dt = Tt.translate(Mt), N(Dt) && (Dt < 0 ? Dt = 0 : Dt > St && (Dt = St), pt.translatedThreshold = Dt + ft)); z--; )
                et = (T = w[z]).barX, j = T.x, Z = T.y, T.shapeType = "arc", kt.inverted ? (T.plotY = Tt.translate(Z), Ct && Tt.stacking ? (X = Tt.stacking.stacks[(Z < 0 ? "-" : "") + pt.stackKey], pt.visible && X && X[j] && (T.isNull || (V = X[j].points[pt.getStackIndicator(void 0, j, pt.index).key], Ot = Tt.translate(V[0]), Nt = Tt.translate(V[1]), N(Ot) && (Ot = J.clamp(Ot, 0, St))))) : (Ot = Dt, Nt = T.plotY), Ot > Nt && (Nt = [Ot, Ot = Nt][0]), xt ? Nt > W ? Nt = W : Ot < L ? Ot = L : (Ot > W || Nt < L) && (Ot = Nt = St) : Ot < W ? Ot = W : Nt > L ? Nt = L : (Nt < W || Ot > L) && (Ot = Nt = 0), Tt.min > Tt.max && (Ot = Nt = xt ? St : 0), Ot += ft, Nt += ft, ct && (T.barX = et += ct[3] / 2), ot = Math.max(et, 0), it = Math.max(et + T.pointWidth, 0), T.shapeArgs = { x: ct && ct[0], y: ct && ct[1], r: it, innerR: ot, start: Ot, end: Nt }, T.opacity = Ot === Nt ? 0 : void 0, T.plotY = (N(pt.translatedThreshold) && (Ot < pt.translatedThreshold ? Ot : Nt)) - ft) : (Ot = et + ft, T.shapeArgs = pt.polar.arc(T.yBottom, T.plotY, Ot, Ot + T.pointWidth)), pt.polar.toXY(T), kt.inverted ? (I = Tt.postTranslate(T.rectPlotY, et + T.pointWidth / 2), T.tooltipPos = [I.x - kt.plotLeft, I.y - kt.plotTop]) : T.tooltipPos = [T.plotX, T.plotY], ct && (T.ttBelow = T.plotY > ct[1]);
          }
          function c(p, w) {
            var T, z, W = this;
            if (this.chart.polar) {
              w = w || this.points;
              for (var L = 0; L < w.length; L++)
                if (!w[L].isNull) {
                  T = L;
                  break;
                }
              this.options.connectEnds !== !1 && T !== void 0 && (this.connectEnds = !0, w.splice(w.length, 0, w[T]), z = !0), w.forEach(function(j) {
                j.polarPlotY === void 0 && W.polar.toXY(j);
              });
            }
            var I = p.apply(this, [].slice.call(arguments, 1));
            return z && w.pop(), I;
          }
          function l(p, w) {
            var T = this.chart, z = { xAxis: [], yAxis: [] };
            return T.polar ? T.axes.forEach(function(W) {
              if (W.coll !== "colorAxis") {
                var L = W.isXAxis, I = W.center, j = w.chartX - I[0] - T.plotLeft, Z = w.chartY - I[1] - T.plotTop;
                z[L ? "xAxis" : "yAxis"].push({ axis: W, value: W.translate(L ? Math.PI - Math.atan2(j, Z) : Math.sqrt(Math.pow(j, 2) + Math.pow(Z, 2)), !0) });
              }
            }) : z = p.call(this, w), z;
          }
          function h(p, w) {
            this.chart.polar || p.call(this, w);
          }
          function C(p, w) {
            var T, z, W, L, I, j, Z = this, V = this.chart, X = this.group, et = this.markerGroup, ot = this.xAxis && this.xAxis.center, it = V.plotLeft, pt = V.plotTop, mt = this.options.animation;
            V.polar ? Z.isRadialBar ? w || (Z.startAngleRad = A(Z.translatedThreshold, Z.xAxis.startAngleRad), F.seriesTypes.pie.prototype.animate.call(Z, w)) : V.renderer.isSVG && (mt = q(mt), Z.is("column") ? w || (z = ot[3] / 2, Z.points.forEach(function(Ct) {
              W = Ct.graphic, L = Ct.shapeArgs, I = L && L.r, j = L && L.innerR, W && L && (W.attr({ r: z, innerR: z }), W.animate({ r: I, innerR: j }, Z.options.animation));
            })) : w ? (T = { translateX: ot[0] + it, translateY: ot[1] + pt, scaleX: 1e-3, scaleY: 1e-3 }, X.attr(T), et && et.attr(T)) : (T = { translateX: it, translateY: pt, scaleX: 1, scaleY: 1 }, X.animate(T, mt), et && et.animate(T, mt))) : p.call(this, w);
          }
          function M(p, w, T, z) {
            var W, L;
            if (this.chart.polar)
              if (z) {
                var I = (L = g(w, z, !0, this.connectEnds)).prevPointCont && L.prevPointCont.rightContX, j = L.prevPointCont && L.prevPointCont.rightContY;
                W = ["C", k(I) ? I : L.plotX, k(j) ? j : L.plotY, k(L.leftContX) ? L.leftContX : L.plotX, k(L.leftContY) ? L.leftContY : L.plotY, L.plotX, L.plotY];
              } else
                W = ["M", T.plotX, T.plotY];
            else
              W = p.call(this, w, T, z);
            return W;
          }
          var O = function() {
            function p(w) {
              this.series = w;
            }
            return p.compose = function(w, T, z, W, L, I, j, Z, V) {
              if (Y.compose(w, L), v.indexOf(T) === -1) {
                v.push(T), U(T, "afterDrawChartBox", x), U(T, "getAxes", P), U(T, "init", E);
                var X = T.prototype;
                m(X, "get", n);
              }
              if (v.indexOf(z) === -1) {
                v.push(z);
                var et = z.prototype;
                m(et, "getCoordinates", l), m(et, "pinch", h), U(z, "getSelectionMarkerAttrs", u), U(z, "getSelectionBox", S);
              }
              if (v.indexOf(W) === -1) {
                v.push(W), U(W, "afterInit", y), U(W, "afterTranslate", s, { order: 2 });
                var ot = W.prototype;
                m(ot, "animate", C);
              }
              if (j && v.indexOf(j) === -1) {
                v.push(j);
                var it = j.prototype;
                m(it, "alignDataLabel", o), m(it, "animate", C), m(it, "translate", i);
              }
              if (Z && v.indexOf(Z) === -1) {
                v.push(Z);
                var pt = Z.prototype;
                m(pt, "getGraphPath", c);
              }
              if (V && v.indexOf(V) === -1) {
                v.push(V);
                var mt = V.prototype;
                m(mt, "getPointSpline", M), I && v.indexOf(I) === -1 && (v.push(I), I.prototype.getPointSpline = mt.getPointSpline);
              }
            }, p.prototype.arc = function(w, T, z, W) {
              var L = this.series, I = L.xAxis.center, j = L.yAxis.len, Z = I[3] / 2, V = j - T + Z, X = j - A(w, j) + Z;
              return L.yAxis.reversed && (V < 0 && (V = Z), X < 0 && (X = Z)), { x: I[0], y: I[1], r: V, innerR: X, start: z, end: W };
            }, p.prototype.toXY = function(w) {
              var T, z = this.series, W = z.chart, L = z.xAxis, I = z.yAxis, j = w.plotX, Z = W.inverted, V = w.y, X = w.plotY, et = Z ? j : I.len - X;
              if (Z && z && !z.isRadialBar && (w.plotY = X = k(V) ? I.translate(V) : 0), w.rectPlotX = j, w.rectPlotY = X, I.center && (et += I.center[3] / 2), k(X)) {
                var ot = Z ? I.postTranslate(X, et) : L.postTranslate(j, et);
                w.plotX = w.polarPlotX = ot.x - W.plotLeft, w.plotY = w.polarPlotY = ot.y - W.plotTop;
              }
              z.kdByAngle ? ((T = (j / Math.PI * 180 + L.pane.options.startAngle) % 360) < 0 && (T += 360), w.clientX = T) : w.clientX = w.plotX;
            }, p;
          }();
          return O;
        }), at(_, "masters/highcharts-more.src.js", [_["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Series/Bubble/BubbleSeries.js"], _["Series/PackedBubble/PackedBubbleSeries.js"], _["Series/PolarComposition.js"]], function(G, F, $, Y, J) {
          var Q = G;
          $.compose(Q.Axis, Q.Chart, Q.Legend, Q.Series), Y.compose(Q.Axis, Q.Chart, Q.Legend, Q.Series), J.compose(Q.Axis, Q.Chart, Q.Pointer, Q.Series, Q.Tick, F.seriesTypes.areasplinerange, F.seriesTypes.column, F.seriesTypes.line, F.seriesTypes.spline);
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 8840: function(tt, st, lt) {
      var ht, ut, yt;
      ut = typeof window != "undefined" ? window : this, yt = function(gt) {
        function _(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && gt.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        var at = {};
        return _(at, "Core/Globals.js", [], function() {
          var G;
          return function(F) {
            F.SVG_NS = "http://www.w3.org/2000/svg", F.product = "Highcharts", F.version = "10.3.3", F.win = gt !== void 0 ? gt : {}, F.doc = F.win.document, F.svg = F.doc && F.doc.createElementNS && !!F.doc.createElementNS(F.SVG_NS, "svg").createSVGRect, F.userAgent = F.win.navigator && F.win.navigator.userAgent || "", F.isChrome = F.userAgent.indexOf("Chrome") !== -1, F.isFirefox = F.userAgent.indexOf("Firefox") !== -1, F.isMS = /(edge|msie|trident)/i.test(F.userAgent) && !F.win.opera, F.isSafari = !F.isChrome && F.userAgent.indexOf("Safari") !== -1, F.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(F.userAgent), F.isWebKit = F.userAgent.indexOf("AppleWebKit") !== -1, F.deg2rad = 2 * Math.PI / 360, F.hasBidiBug = F.isFirefox && 4 > parseInt(F.userAgent.split("Firefox/")[1], 10), F.hasTouch = !!F.win.TouchEvent, F.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], F.noop = function() {
            }, F.supportsPassiveEvents = function() {
              var $ = !1;
              if (!F.isMS) {
                var Y = Object.defineProperty({}, "passive", { get: function() {
                  $ = !0;
                } });
                F.win.addEventListener && F.win.removeEventListener && (F.win.addEventListener("testPassive", F.noop, Y), F.win.removeEventListener("testPassive", F.noop, Y));
              }
              return $;
            }(), F.charts = [], F.dateFormats = {}, F.seriesTypes = {}, F.symbolSizes = {}, F.chartCount = 0;
          }(G || (G = {})), G;
        }), _(at, "Core/Utilities.js", [at["Core/Globals.js"]], function(G) {
          function F(e, n, o, i) {
            var c = n ? "Highcharts error" : "Highcharts warning";
            e === 32 && (e = c + ": Deprecated member");
            var l = N(e), h = l ? c + " #" + e + ": www.highcharts.com/errors/" + e + "/" : e.toString();
            if (i !== void 0) {
              var C = "";
              l && (h += "?"), g(i, function(M, O) {
                C += `
 - `.concat(O, ": ").concat(M), l && (h += encodeURI(O) + "=" + encodeURI(M));
              }), h += C;
            }
            E(G, "displayError", { chart: o, code: e, message: h, params: i }, function() {
              if (n)
                throw Error(h);
              u.console && F.messages.indexOf(h) === -1 && console.warn(h);
            }), F.messages.push(h);
          }
          function $(e, n) {
            return parseInt(e, n || 10);
          }
          function Y(e) {
            return typeof e == "string";
          }
          function J(e) {
            return (e = Object.prototype.toString.call(e)) === "[object Array]" || e === "[object Array Iterator]";
          }
          function Q(e, n) {
            return !(!e || typeof e != "object" || n && J(e));
          }
          function q(e) {
            return Q(e) && typeof e.nodeType == "number";
          }
          function U(e) {
            var n = e && e.constructor;
            return !(!Q(e, !0) || q(e) || !n || !n.name || n.name === "Object");
          }
          function N(e) {
            return typeof e == "number" && !isNaN(e) && 1 / 0 > e && -1 / 0 < e;
          }
          function D(e) {
            return e != null;
          }
          function k(e, n, o) {
            var i, c = Y(n) && !D(o), l = function(h, C) {
              D(h) ? e.setAttribute(C, h) : c ? (i = e.getAttribute(C)) || C !== "class" || (i = e.getAttribute(C + "Name")) : e.removeAttribute(C);
            };
            return Y(n) ? l(o, n) : g(n, l), i;
          }
          function A(e, n) {
            var o;
            for (o in e || (e = {}), n)
              e[o] = n[o];
            return e;
          }
          function b() {
            for (var e = arguments, n = e.length, o = 0; o < n; o++) {
              var i = e[o];
              if (i != null)
                return i;
            }
          }
          function d(e, n) {
            G.isMS && !G.svg && n && D(n.opacity) && (n.filter = "alpha(opacity=".concat(100 * n.opacity, ")")), A(e.style, n);
          }
          function m(e) {
            return Math.pow(10, Math.floor(Math.log(e) / Math.LN10));
          }
          function v(e, n) {
            return 1e14 < e ? e : parseFloat(e.toPrecision(n || 14));
          }
          function g(e, n, o) {
            for (var i in e)
              Object.hasOwnProperty.call(e, i) && n.call(o || e[i], e[i], i, e);
          }
          function x(e, n, o) {
            function i(C, M) {
              var O = e.removeEventListener || G.removeEventListenerPolyfill;
              O && O.call(e, C, M, !1);
            }
            function c(C) {
              var M;
              if (e.nodeName) {
                if (n) {
                  var O = {};
                  O[n] = !0;
                } else
                  O = C;
                g(O, function(p, w) {
                  if (C[w])
                    for (M = C[w].length; M--; )
                      i(w, C[w][M].fn);
                });
              }
            }
            var l = typeof e == "function" && e.prototype || e;
            if (Object.hasOwnProperty.call(l, "hcEvents")) {
              var h = l.hcEvents;
              n ? (l = h[n] || [], o ? (h[n] = l.filter(function(C) {
                return o !== C.fn;
              }), i(n, o)) : (c(h), h[n] = [])) : (c(h), delete l.hcEvents);
            }
          }
          function E(e, n, o, i) {
            if (o = o || {}, S.createEvent && (e.dispatchEvent || e.fireEvent && e !== G)) {
              var c = S.createEvent("Events");
              c.initEvent(n, !0, !0), o = A(c, o), e.dispatchEvent ? e.dispatchEvent(o) : e.fireEvent(n, o);
            } else if (e.hcEvents) {
              o.target || A(o, { preventDefault: function() {
                o.defaultPrevented = !0;
              }, target: e, type: n }), c = [];
              for (var l = e, h = !1; l.hcEvents; )
                Object.hasOwnProperty.call(l, "hcEvents") && l.hcEvents[n] && (c.length && (h = !0), c.unshift.apply(c, l.hcEvents[n])), l = Object.getPrototypeOf(l);
              h && c.sort(function(C, M) {
                return C.order - M.order;
              }), c.forEach(function(C) {
                C.fn.call(e, o) === !1 && o.preventDefault();
              });
            }
            i && !o.defaultPrevented && i.call(e, o);
          }
          var P = G.charts, S = G.doc, u = G.win;
          (F || (F = {})).messages = [], Math.easeInOutSine = function(e) {
            return -0.5 * (Math.cos(Math.PI * e) - 1);
          };
          var y = Array.prototype.find ? function(e, n) {
            return e.find(n);
          } : function(e, n) {
            var o, i = e.length;
            for (o = 0; o < i; o++)
              if (n(e[o], o))
                return e[o];
          };
          g({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(e, n) {
            G[n] = function(o) {
              var i;
              return F(32, !1, void 0, ((i = {})["Highcharts.".concat(n)] = "use Array.".concat(e), i)), Array.prototype[e].apply(o, [].slice.call(arguments, 1));
            };
          });
          var s, a = function() {
            var e = Math.random().toString(36).substring(2, 9) + "-", n = 0;
            return function() {
              return "highcharts-" + (s ? "" : e) + n++;
            };
          }();
          return u.jQuery, y = { addEvent: function(e, n, o, i) {
            i === void 0 && (i = {});
            var c = typeof e == "function" && e.prototype || e;
            Object.hasOwnProperty.call(c, "hcEvents") || (c.hcEvents = {}), c = c.hcEvents, G.Point && e instanceof G.Point && e.series && e.series.chart && (e.series.chart.runTrackerClick = !0);
            var l = e.addEventListener || G.addEventListenerPolyfill;
            return l && l.call(e, n, o, !!G.supportsPassiveEvents && { passive: i.passive === void 0 ? n.indexOf("touch") !== -1 : i.passive, capture: !1 }), c[n] || (c[n] = []), c[n].push({ fn: o, order: typeof i.order == "number" ? i.order : 1 / 0 }), c[n].sort(function(h, C) {
              return h.order - C.order;
            }), function() {
              x(e, n, o);
            };
          }, arrayMax: function(e) {
            for (var n = e.length, o = e[0]; n--; )
              e[n] > o && (o = e[n]);
            return o;
          }, arrayMin: function(e) {
            for (var n = e.length, o = e[0]; n--; )
              e[n] < o && (o = e[n]);
            return o;
          }, attr: k, clamp: function(e, n, o) {
            return e > n ? e < o ? e : o : n;
          }, cleanRecursively: function e(n, o) {
            var i = {};
            return g(n, function(c, l) {
              Q(n[l], !0) && !n.nodeType && o[l] ? (c = e(n[l], o[l]), Object.keys(c).length && (i[l] = c)) : (Q(n[l]) || n[l] !== o[l] || l in n && !(l in o)) && (i[l] = n[l]);
            }), i;
          }, clearTimeout: function(e) {
            D(e) && clearTimeout(e);
          }, correctFloat: v, createElement: function(e, n, o, i, c) {
            return e = S.createElement(e), n && A(e, n), c && d(e, { padding: "0", border: "none", margin: "0" }), o && d(e, o), i && i.appendChild(e), e;
          }, css: d, defined: D, destroyObjectProperties: function(e, n) {
            g(e, function(o, i) {
              o && o !== n && o.destroy && o.destroy(), delete e[i];
            });
          }, discardElement: function(e) {
            e && e.parentElement && e.parentElement.removeChild(e);
          }, erase: function(e, n) {
            for (var o = e.length; o--; )
              if (e[o] === n) {
                e.splice(o, 1);
                break;
              }
          }, error: F, extend: A, extendClass: function(e, n) {
            var o = function() {
            };
            return A(o.prototype = new e(), n), o;
          }, find: y, fireEvent: E, getMagnitude: m, getNestedProperty: function(e, n) {
            for (e = e.split("."); e.length && D(n); ) {
              var o = e.shift();
              if (o === void 0 || o === "__proto__" || !D(n = n[o]) || typeof n == "function" || typeof n.nodeType == "number" || n === u)
                return;
            }
            return n;
          }, getStyle: function e(n, o, i) {
            var c = G.getStyle || e;
            if (o === "width")
              return o = Math.min(n.offsetWidth, n.scrollWidth), (i = n.getBoundingClientRect && n.getBoundingClientRect().width) < o && i >= o - 1 && (o = Math.floor(i)), Math.max(0, o - (c(n, "padding-left", !0) || 0) - (c(n, "padding-right", !0) || 0));
            if (o === "height")
              return Math.max(0, Math.min(n.offsetHeight, n.scrollHeight) - (c(n, "padding-top", !0) || 0) - (c(n, "padding-bottom", !0) || 0));
            if (u.getComputedStyle || F(27, !0), n = u.getComputedStyle(n, void 0)) {
              var l = n.getPropertyValue(o);
              b(i, o !== "opacity") && (l = $(l));
            }
            return l;
          }, inArray: function(e, n, o) {
            return F(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), n.indexOf(e, o);
          }, isArray: J, isClass: U, isDOMElement: q, isFunction: function(e) {
            return typeof e == "function";
          }, isNumber: N, isObject: Q, isString: Y, keys: function(e) {
            return F(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(e);
          }, merge: function() {
            var e, n = arguments, o = {}, i = function(l, h) {
              return typeof l != "object" && (l = {}), g(h, function(C, M) {
                M !== "__proto__" && M !== "constructor" && (!Q(C, !0) || U(C) || q(C) ? l[M] = h[M] : l[M] = i(l[M] || {}, C));
              }), l;
            };
            n[0] === !0 && (o = n[1], n = Array.prototype.slice.call(n, 2));
            var c = n.length;
            for (e = 0; e < c; e++)
              o = i(o, n[e]);
            return o;
          }, normalizeTickInterval: function(e, n, o, i, c) {
            var l = e, h = e / (o = b(o, m(e)));
            for (n || (n = c ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], i === !1 && (o === 1 ? n = n.filter(function(C) {
              return C % 1 == 0;
            }) : 0.1 >= o && (n = [1 / o]))), i = 0; i < n.length && (l = n[i], !(c && l * o >= e || !c && h <= (n[i] + (n[i + 1] || n[i])) / 2)); i++)
              ;
            return v(l * o, -Math.round(Math.log(1e-3) / Math.LN10));
          }, objectEach: g, offset: function(e) {
            var n = S.documentElement;
            return { top: (e = e.parentElement || e.parentNode ? e.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 }).top + (u.pageYOffset || n.scrollTop) - (n.clientTop || 0), left: e.left + (u.pageXOffset || n.scrollLeft) - (n.clientLeft || 0), width: e.width, height: e.height };
          }, pad: function(e, n, o) {
            return Array((n || 2) + 1 - String(e).replace("-", "").length).join(o || "0") + e;
          }, pick: b, pInt: $, relativeLength: function(e, n, o) {
            return /%$/.test(e) ? n * parseFloat(e) / 100 + (o || 0) : parseFloat(e);
          }, removeEvent: x, splat: function(e) {
            return J(e) ? e : [e];
          }, stableSort: function(e, n) {
            var o, i, c = e.length;
            for (i = 0; i < c; i++)
              e[i].safeI = i;
            for (e.sort(function(l, h) {
              return (o = n(l, h)) === 0 ? l.safeI - h.safeI : o;
            }), i = 0; i < c; i++)
              delete e[i].safeI;
          }, syncTimeout: function(e, n, o) {
            return 0 < n ? setTimeout(e, n, o) : (e.call(0, o), -1);
          }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: a, useSerialIds: function(e) {
            return s = b(e, s);
          }, wrap: function(e, n, o) {
            var i = e[n];
            e[n] = function() {
              var c = arguments, l = this;
              return o.apply(this, [function() {
                return i.apply(l, arguments.length ? arguments : c);
              }].concat([].slice.call(arguments)));
            };
          } }, y;
        }), _(at, "Core/Chart/ChartDefaults.js", [], function() {
          return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, defaultSeriesType: "line", ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } }, zoomBySingleTouch: !1, zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#335cad", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
        }), _(at, "Core/Color/Color.js", [at["Core/Globals.js"], at["Core/Utilities.js"]], function(G, F) {
          var $ = F.isNumber, Y = F.merge, J = F.pInt;
          return F = function() {
            function Q(q) {
              this.rgba = [NaN, NaN, NaN, NaN], this.input = q;
              var U = G.Color;
              return U && U !== Q ? new U(q) : this instanceof Q ? void this.init(q) : new Q(q);
            }
            return Q.parse = function(q) {
              return q ? new Q(q) : Q.None;
            }, Q.prototype.init = function(q) {
              var U;
              if (typeof q == "object" && q.stops !== void 0)
                this.stops = q.stops.map(function(A) {
                  return new Q(A[1]);
                });
              else if (typeof q == "string") {
                if (this.input = q = Q.names[q.toLowerCase()] || q, q.charAt(0) === "#") {
                  var N = q.length, D = parseInt(q.substr(1), 16);
                  N === 7 ? U = [(16711680 & D) >> 16, (65280 & D) >> 8, 255 & D, 1] : N === 4 && (U = [(3840 & D) >> 4 | (3840 & D) >> 8, (240 & D) >> 4 | 240 & D, (15 & D) << 4 | 15 & D, 1]);
                }
                if (!U)
                  for (D = Q.parsers.length; D-- && !U; ) {
                    var k = Q.parsers[D];
                    (N = k.regex.exec(q)) && (U = k.parse(N));
                  }
              }
              U && (this.rgba = U);
            }, Q.prototype.get = function(q) {
              var U = this.input, N = this.rgba;
              if (typeof U == "object" && this.stops !== void 0) {
                var D = Y(U);
                return D.stops = [].slice.call(D.stops), this.stops.forEach(function(k, A) {
                  D.stops[A] = [D.stops[A][0], k.get(q)];
                }), D;
              }
              return N && $(N[0]) ? q === "rgb" || !q && N[3] === 1 ? "rgb(" + N[0] + "," + N[1] + "," + N[2] + ")" : q === "a" ? "".concat(N[3]) : "rgba(" + N.join(",") + ")" : U;
            }, Q.prototype.brighten = function(q) {
              var U = this.rgba;
              if (this.stops)
                this.stops.forEach(function(D) {
                  D.brighten(q);
                });
              else if ($(q) && q !== 0)
                for (var N = 0; 3 > N; N++)
                  U[N] += J(255 * q), 0 > U[N] && (U[N] = 0), 255 < U[N] && (U[N] = 255);
              return this;
            }, Q.prototype.setOpacity = function(q) {
              return this.rgba[3] = q, this;
            }, Q.prototype.tweenTo = function(q, U) {
              var N = this.rgba, D = q.rgba;
              return $(N[0]) && $(D[0]) ? ((q = D[3] !== 1 || N[3] !== 1) ? "rgba(" : "rgb(") + Math.round(D[0] + (N[0] - D[0]) * (1 - U)) + "," + Math.round(D[1] + (N[1] - D[1]) * (1 - U)) + "," + Math.round(D[2] + (N[2] - D[2]) * (1 - U)) + (q ? "," + (D[3] + (N[3] - D[3]) * (1 - U)) : "") + ")" : q.input || "none";
            }, Q.names = { white: "#ffffff", black: "#000000" }, Q.parsers = [{ regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/, parse: function(q) {
              return [J(q[1]), J(q[2]), J(q[3]), parseFloat(q[4], 10)];
            } }, { regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/, parse: function(q) {
              return [J(q[1]), J(q[2]), J(q[3]), 1];
            } }], Q.None = new Q(""), Q;
          }(), F;
        }), _(at, "Core/Color/Palettes.js", [], function() {
          return { colors: "#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" ") };
        }), _(at, "Core/Time.js", [at["Core/Globals.js"], at["Core/Utilities.js"]], function(G, F) {
          var $ = G.win, Y = F.defined, J = F.error, Q = F.extend, q = F.isObject, U = F.merge, N = F.objectEach, D = F.pad, k = F.pick, A = F.splat, b = F.timeUnits, d = G.isSafari && $.Intl && $.Intl.DateTimeFormat.prototype.formatRange, m = G.isSafari && $.Intl && !$.Intl.DateTimeFormat.prototype.formatRange;
          return F = function() {
            function v(g) {
              this.options = {}, this.variableTimezone = this.useUTC = !1, this.Date = $.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(g);
            }
            return v.prototype.get = function(g, x) {
              if (this.variableTimezone || this.timezoneOffset) {
                var E = x.getTime(), P = E - this.getTimezoneOffset(x);
                return x.setTime(P), g = x["getUTC" + g](), x.setTime(E), g;
              }
              return this.useUTC ? x["getUTC" + g]() : x["get" + g]();
            }, v.prototype.set = function(g, x, E) {
              if (this.variableTimezone || this.timezoneOffset) {
                if (g === "Milliseconds" || g === "Seconds" || g === "Minutes" && this.getTimezoneOffset(x) % 36e5 == 0)
                  return x["setUTC" + g](E);
                var P = this.getTimezoneOffset(x);
                return P = x.getTime() - P, x.setTime(P), x["setUTC" + g](E), g = this.getTimezoneOffset(x), P = x.getTime() + g, x.setTime(P);
              }
              return this.useUTC || d && g === "FullYear" ? x["setUTC" + g](E) : x["set" + g](E);
            }, v.prototype.update = function(g) {
              g === void 0 && (g = {});
              var x = k(g.useUTC, !0);
              this.options = g = U(!0, this.options, g), this.Date = g.Date || $.Date || Date, this.timezoneOffset = (this.useUTC = x) && g.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = x && !(!g.getTimezoneOffset && !g.timezone);
            }, v.prototype.makeTime = function(g, x, E, P, S, u) {
              if (this.useUTC) {
                var y = this.Date.UTC.apply(0, arguments), s = this.getTimezoneOffset(y);
                y += s;
                var a = this.getTimezoneOffset(y);
                s !== a ? y += a - s : s - 36e5 !== this.getTimezoneOffset(y - 36e5) || m || (y -= 36e5);
              } else
                y = new this.Date(g, x, k(E, 1), k(P, 0), k(S, 0), k(u, 0)).getTime();
              return y;
            }, v.prototype.timezoneOffsetFunction = function() {
              var g = this, x = this.options, E = x.getTimezoneOffset, P = x.moment || $.moment;
              if (!this.useUTC)
                return function(S) {
                  return 6e4 * new Date(S.toString()).getTimezoneOffset();
                };
              if (x.timezone) {
                if (P)
                  return function(S) {
                    return 6e4 * -P.tz(S, x.timezone).utcOffset();
                  };
                J(25);
              }
              return this.useUTC && E ? function(S) {
                return 6e4 * E(S.valueOf());
              } : function() {
                return 6e4 * (g.timezoneOffset || 0);
              };
            }, v.prototype.dateFormat = function(g, x, E) {
              if (!Y(x) || isNaN(x))
                return G.defaultOptions.lang && G.defaultOptions.lang.invalidDate || "";
              g = k(g, "%Y-%m-%d %H:%M:%S");
              var P = this, S = new this.Date(x), u = this.get("Hours", S), y = this.get("Day", S), s = this.get("Date", S), a = this.get("Month", S), e = this.get("FullYear", S), n = G.defaultOptions.lang, o = n && n.weekdays, i = n && n.shortWeekdays;
              return S = Q({ a: i ? i[y] : o[y].substr(0, 3), A: o[y], d: D(s), e: D(s, 2, " "), w: y, b: n.shortMonths[a], B: n.months[a], m: D(a + 1), o: a + 1, y: e.toString().substr(2, 2), Y: e, H: D(u), k: u, I: D(u % 12 || 12), l: u % 12 || 12, M: D(this.get("Minutes", S)), p: 12 > u ? "AM" : "PM", P: 12 > u ? "am" : "pm", S: D(S.getSeconds()), L: D(Math.floor(x % 1e3), 3) }, G.dateFormats), N(S, function(c, l) {
                for (; g.indexOf("%" + l) !== -1; )
                  g = g.replace("%" + l, typeof c == "function" ? c.call(P, x) : c);
              }), E ? g.substr(0, 1).toUpperCase() + g.substr(1) : g;
            }, v.prototype.resolveDTLFormat = function(g) {
              return q(g, !0) ? g : { main: (g = A(g))[0], from: g[1], to: g[2] };
            }, v.prototype.getTimeTicks = function(g, x, E, P) {
              var S, u = this, y = [], s = {}, a = new u.Date(x), e = g.unitRange, n = g.count || 1;
              if (P = k(P, 1), Y(x)) {
                if (u.set("Milliseconds", a, e >= b.second ? 0 : n * Math.floor(u.get("Milliseconds", a) / n)), e >= b.second && u.set("Seconds", a, e >= b.minute ? 0 : n * Math.floor(u.get("Seconds", a) / n)), e >= b.minute && u.set("Minutes", a, e >= b.hour ? 0 : n * Math.floor(u.get("Minutes", a) / n)), e >= b.hour && u.set("Hours", a, e >= b.day ? 0 : n * Math.floor(u.get("Hours", a) / n)), e >= b.day && u.set("Date", a, e >= b.month ? 1 : Math.max(1, n * Math.floor(u.get("Date", a) / n))), e >= b.month) {
                  u.set("Month", a, e >= b.year ? 0 : n * Math.floor(u.get("Month", a) / n));
                  var o = u.get("FullYear", a);
                }
                e >= b.year && u.set("FullYear", a, o - o % n), e === b.week && (o = u.get("Day", a), u.set("Date", a, u.get("Date", a) - o + P + (o < P ? -7 : 0))), o = u.get("FullYear", a), P = u.get("Month", a);
                var i = u.get("Date", a), c = u.get("Hours", a);
                for (x = a.getTime(), !u.variableTimezone && u.useUTC || !Y(E) || (S = E - x > 4 * b.month || u.getTimezoneOffset(x) !== u.getTimezoneOffset(E)), x = a.getTime(), a = 1; x < E; )
                  y.push(x), x = e === b.year ? u.makeTime(o + a * n, 0) : e === b.month ? u.makeTime(o, P + a * n) : !S || e !== b.day && e !== b.week ? S && e === b.hour && 1 < n ? u.makeTime(o, P, i, c + a * n) : x + e * n : u.makeTime(o, P, i + a * n * (e === b.day ? 1 : 7)), a++;
                y.push(x), e <= b.hour && 1e4 > y.length && y.forEach(function(l) {
                  l % 18e5 == 0 && u.dateFormat("%H%M%S%L", l) === "000000000" && (s[l] = "day");
                });
              }
              return y.info = Q(g, { higherRanks: s, totalRange: e * n }), y;
            }, v.prototype.getDateFormat = function(g, x, E, P) {
              var S = this.dateFormat("%m-%d %H:%M:%S.%L", x), u = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, y = "millisecond";
              for (s in b) {
                if (g === b.week && +this.dateFormat("%w", x) === E && S.substr(6) === "00:00:00.000") {
                  var s = "week";
                  break;
                }
                if (b[s] > g) {
                  s = y;
                  break;
                }
                if (u[s] && S.substr(u[s]) !== "01-01 00:00:00.000".substr(u[s]))
                  break;
                s !== "week" && (y = s);
              }
              return this.resolveDTLFormat(P[s]).main;
            }, v;
          }(), F;
        }), _(at, "Core/Defaults.js", [at["Core/Chart/ChartDefaults.js"], at["Core/Color/Color.js"], at["Core/Globals.js"], at["Core/Color/Palettes.js"], at["Core/Time.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          F = F.parse;
          var q = Q.merge, U = { colors: Y.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: "January February March April May June July August September October November December".split(" "), shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "), weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), decimalPoint: ".", numericSymbols: "kMGTPE".split(""), resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: {}, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: G, title: { text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, labels: { style: { position: "absolute", color: "#333333" } }, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", layout: "horizontal", labelFormatter: function() {
            return this.name;
          }, borderColor: "#999999", borderRadius: 0, navigation: { activeColor: "#003399", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "12px", fontWeight: "bold", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#cccccc" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: $.svg, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %b %e, %H:%M:%S.%L", second: "%A, %b %e, %H:%M:%S", minute: "%A, %b %e, %H:%M", hour: "%A, %b %e, %H:%M", day: "%A, %b %e, %Y", week: "Week from %A, %b %e, %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: $.isTouchDevice ? 25 : 10, headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: F("#f7f7f7").setOpacity(0.85).get(), borderWidth: 1, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "12px", whiteSpace: "nowrap" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "9px" }, text: "Highcharts.com" } };
          U.chart.styledMode = !1;
          var N = new J(q(U.global, U.time));
          return { defaultOptions: U, defaultTime: N, getOptions: function() {
            return U;
          }, setOptions: function(D) {
            return q(!0, U, D), (D.time || D.global) && ($.time ? $.time.update(q(U.global, U.time, D.global, D.time)) : $.time = N), U;
          } };
        }), _(at, "Core/Animation/Fx.js", [at["Core/Color/Color.js"], at["Core/Globals.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.parse, J = F.win, Q = $.isNumber, q = $.objectEach;
          return function() {
            function U(N, D, k) {
              this.pos = NaN, this.options = D, this.elem = N, this.prop = k;
            }
            return U.prototype.dSetter = function() {
              var N = this.paths, D = N && N[0];
              N = N && N[1];
              var k = this.now || 0, A = [];
              if (k !== 1 && D && N)
                if (D.length === N.length && 1 > k)
                  for (var b = 0; b < N.length; b++) {
                    for (var d = D[b], m = N[b], v = [], g = 0; g < m.length; g++) {
                      var x = d[g], E = m[g];
                      Q(x) && Q(E) && (m[0] !== "A" || g !== 4 && g !== 5) ? v[g] = x + k * (E - x) : v[g] = E;
                    }
                    A.push(v);
                  }
                else
                  A = N;
              else
                A = this.toD || [];
              this.elem.attr("d", A, void 0, !0);
            }, U.prototype.update = function() {
              var N = this.elem, D = this.prop, k = this.now, A = this.options.step;
              this[D + "Setter"] ? this[D + "Setter"]() : N.attr ? N.element && N.attr(D, k, null, !0) : N.style[D] = k + this.unit, A && A.call(N, k, this);
            }, U.prototype.run = function(N, D, k) {
              var A = this, b = A.options, d = function(g) {
                return !d.stopped && A.step(g);
              }, m = J.requestAnimationFrame || function(g) {
                setTimeout(g, 13);
              }, v = function() {
                for (var g = 0; g < U.timers.length; g++)
                  U.timers[g]() || U.timers.splice(g--, 1);
                U.timers.length && m(v);
              };
              N !== D || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = N, this.end = D, this.unit = k, this.now = this.start, this.pos = 0, d.elem = this.elem, d.prop = this.prop, d() && U.timers.push(d) === 1 && m(v)) : (delete b.curAnim[this.prop], b.complete && Object.keys(b.curAnim).length === 0 && b.complete.call(this.elem));
            }, U.prototype.step = function(N) {
              var D = +/* @__PURE__ */ new Date(), k = this.options, A = this.elem, b = k.complete, d = k.duration, m = k.curAnim;
              if (A.attr && !A.element)
                N = !1;
              else if (N || D >= d + this.startTime) {
                this.now = this.end, this.pos = 1, this.update();
                var v = m[this.prop] = !0;
                q(m, function(g) {
                  g !== !0 && (v = !1);
                }), v && b && b.call(A), N = !1;
              } else
                this.pos = k.easing((D - this.startTime) / d), this.now = this.start + (this.end - this.start) * this.pos, this.update(), N = !0;
              return N;
            }, U.prototype.initPath = function(N, D, k) {
              function A(S, u) {
                for (; S.length < P; ) {
                  var y = S[0], s = u[P - S.length];
                  s && y[0] === "M" && (S[0] = s[0] === "C" ? ["C", y[1], y[2], y[1], y[2], y[1], y[2]] : ["L", y[1], y[2]]), S.unshift(y), v && (y = S.pop(), S.push(S[S.length - 1], y));
                }
              }
              function b(S, u) {
                for (; S.length < P; )
                  if ((u = S[Math.floor(S.length / g) - 1].slice())[0] === "C" && (u[1] = u[5], u[2] = u[6]), v) {
                    var y = S[Math.floor(S.length / g)].slice();
                    S.splice(S.length / 2, 0, u, y);
                  } else
                    S.push(u);
              }
              var d = N.startX, m = N.endX;
              k = k.slice();
              var v = N.isArea, g = v ? 2 : 1;
              if (!(D = D && D.slice()))
                return [k, k];
              if (d && m && m.length) {
                for (N = 0; N < d.length; N++) {
                  if (d[N] === m[0]) {
                    var x = N;
                    break;
                  }
                  if (d[0] === m[m.length - d.length + N]) {
                    x = N;
                    var E = !0;
                    break;
                  }
                  if (d[d.length - 1] === m[m.length - d.length + N]) {
                    x = d.length - N;
                    break;
                  }
                }
                x === void 0 && (D = []);
              }
              if (D.length && Q(x)) {
                var P = k.length + x * g;
                E ? (A(D, k), b(k, D)) : (A(k, D), b(D, k));
              }
              return [D, k];
            }, U.prototype.fillSetter = function() {
              U.prototype.strokeSetter.apply(this, arguments);
            }, U.prototype.strokeSetter = function() {
              this.elem.attr(this.prop, Y(this.start).tweenTo(Y(this.end), this.pos), void 0, !0);
            }, U.timers = [], U;
          }();
        }), _(at, "Core/Animation/AnimationUtilities.js", [at["Core/Animation/Fx.js"], at["Core/Utilities.js"]], function(G, F) {
          function $(b) {
            return N(b) ? D({ duration: 500, defer: 0 }, b) : { duration: b ? 500 : 0, defer: 0 };
          }
          function Y(b, d) {
            for (var m = G.timers.length; m--; )
              G.timers[m].elem !== b || d && d !== G.timers[m].prop || (G.timers[m].stopped = !0);
          }
          var J = F.defined, Q = F.getStyle, q = F.isArray, U = F.isNumber, N = F.isObject, D = F.merge, k = F.objectEach, A = F.pick;
          return { animate: function(b, d, m) {
            var v, g, x, E = "";
            if (!N(m)) {
              var P = arguments;
              m = { duration: P[2], easing: P[3], complete: P[4] };
            }
            U(m.duration) || (m.duration = 400), m.easing = typeof m.easing == "function" ? m.easing : Math[m.easing] || Math.easeInOutSine, m.curAnim = D(d), k(d, function(S, u) {
              Y(b, u), x = new G(b, m, u), g = void 0, u === "d" && q(d.d) ? (x.paths = x.initPath(b, b.pathArray, d.d), x.toD = d.d, v = 0, g = 1) : b.attr ? v = b.attr(u) : (v = parseFloat(Q(b, u)) || 0, u !== "opacity" && (E = "px")), g || (g = S), typeof g == "string" && g.match("px") && (g = g.replace(/px/g, "")), x.run(v, g, E);
            });
          }, animObject: $, getDeferredAnimation: function(b, d, m) {
            var v = $(d), g = 0, x = 0;
            return (m ? [m] : b.series).forEach(function(E) {
              E = $(E.options.animation), g = d && J(d.defer) ? v.defer : Math.max(g, E.duration + E.defer), x = Math.min(v.duration, E.duration);
            }), b.renderer.forExport && (g = 0), { defer: Math.max(0, g - x), duration: Math.min(g, x) };
          }, setAnimation: function(b, d) {
            d.renderer.globalAnimation = A(b, d.options.chart.animation, !0);
          }, stop: Y };
        }), _(at, "Core/Renderer/HTML/AST.js", [at["Core/Globals.js"], at["Core/Utilities.js"]], function(G, F) {
          var $ = G.SVG_NS, Y = F.attr, J = F.createElement, Q = F.css, q = F.error, U = F.isFunction, N = F.isString, D = F.objectEach, k = F.splat, A = (F = G.win.trustedTypes) && U(F.createPolicy) && F.createPolicy("highcharts", { createHTML: function(m) {
            return m;
          } }), b = A ? A.createHTML("") : "";
          try {
            var d = !!new DOMParser().parseFromString(b, "text/html");
          } catch (m) {
            d = !1;
          }
          return U = function() {
            function m(v) {
              this.nodes = typeof v == "string" ? this.parseMarkup(v) : v;
            }
            return m.filterUserAttributes = function(v) {
              return D(v, function(g, x) {
                var E = !0;
                m.allowedAttributes.indexOf(x) === -1 && (E = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(x) !== -1 && (E = N(g) && m.allowedReferences.some(function(P) {
                  return g.indexOf(P) === 0;
                })), E || (q(33, !1, void 0, { "Invalid attribute in config": "".concat(x) }), delete v[x]), N(g) && v[x] && (v[x] = g.replace(/</g, "&lt;"));
              }), v;
            }, m.parseStyle = function(v) {
              return v.split(";").reduce(function(g, x) {
                x = x.split(":").map(function(P) {
                  return P.trim();
                });
                var E = x.shift();
                return E && x.length && (g[E.replace(/-([a-z])/g, function(P) {
                  return P[1].toUpperCase();
                })] = x.join(":")), g;
              }, {});
            }, m.setElementHTML = function(v, g) {
              v.innerHTML = m.emptyHTML, g && new m(g).addToDOM(v);
            }, m.prototype.addToDOM = function(v) {
              return function g(x, E) {
                var P;
                return k(x).forEach(function(S) {
                  var u = S.tagName, y = S.textContent ? G.doc.createTextNode(S.textContent) : void 0, s = m.bypassHTMLFiltering;
                  if (u)
                    if (u === "#text")
                      var a = y;
                    else if (m.allowedTags.indexOf(u) !== -1 || s) {
                      u = G.doc.createElementNS(u === "svg" ? $ : E.namespaceURI || $, u);
                      var e = S.attributes || {};
                      D(S, function(n, o) {
                        o !== "tagName" && o !== "attributes" && o !== "children" && o !== "style" && o !== "textContent" && (e[o] = n);
                      }), Y(u, s ? e : m.filterUserAttributes(e)), S.style && Q(u, S.style), y && u.appendChild(y), g(S.children || [], u), a = u;
                    } else
                      q(33, !1, void 0, { "Invalid tagName in config": u });
                  a && E.appendChild(a), P = a;
                }), P;
              }(this.nodes, v);
            }, m.prototype.parseMarkup = function(v) {
              var g = [];
              if (v = v.trim().replace(/ style=(["'])/g, " data-style=$1"), d)
                v = new DOMParser().parseFromString(A ? A.createHTML(v) : v, "text/html");
              else {
                var x = J("div");
                x.innerHTML = v, v = { body: x };
              }
              var E = function(P, S) {
                var u = P.nodeName.toLowerCase(), y = { tagName: u };
                if (u === "#text" && (y.textContent = P.textContent || ""), u = P.attributes) {
                  var s = {};
                  [].forEach.call(u, function(e) {
                    e.name === "data-style" ? y.style = m.parseStyle(e.value) : s[e.name] = e.value;
                  }), y.attributes = s;
                }
                if (P.childNodes.length) {
                  var a = [];
                  [].forEach.call(P.childNodes, function(e) {
                    E(e, a);
                  }), a.length && (y.children = a);
                }
                S.push(y);
              };
              return [].forEach.call(v.body.childNodes, function(P) {
                return E(P, g);
              }), g;
            }, m.allowedAttributes = "aria-controls aria-describedby aria-expanded aria-haspopup aria-hidden aria-label aria-labelledby aria-live aria-pressed aria-readonly aria-roledescription aria-selected class clip-path color colspan cx cy d dx dy disabled fill height href id in markerHeight markerWidth offset opacity orient padding paddingLeft paddingRight patternUnits r refX refY role scope slope src startOffset stdDeviation stroke stroke-linecap stroke-width style tableValues result rowspan summary target tabindex text-align text-anchor textAnchor textLength title type valign width x x1 x2 xlink:href y y1 y2 zIndex".split(" "), m.allowedReferences = "https:// http:// mailto: / ../ ./ #".split(" "), m.allowedTags = "a abbr b br button caption circle clipPath code dd defs div dl dt em feComponentTransfer feFuncA feFuncB feFuncG feFuncR feGaussianBlur feOffset feMerge feMergeNode filter h1 h2 h3 h4 h5 h6 hr i img li linearGradient marker ol p path pattern pre rect small span stop strong style sub sup svg table text textPath thead title tbody tspan td th tr u ul #text".split(" "), m.emptyHTML = b, m.bypassHTMLFiltering = !1, m;
          }(), U;
        }), _(at, "Core/FormatUtilities.js", [at["Core/Defaults.js"], at["Core/Utilities.js"]], function(G, F) {
          function $(D, k, A, b) {
            D = +D || 0, k = +k;
            var d = Y.lang, m = (D.toString().split(".")[1] || "").split("e")[0].length, v = D.toString().split("e"), g = k;
            if (k === -1)
              k = Math.min(m, 20);
            else if (q(k)) {
              if (k && v[1] && 0 > v[1]) {
                var x = k + +v[1];
                0 <= x ? (v[0] = (+v[0]).toExponential(x).split("e")[0], k = x) : (v[0] = v[0].split(".")[0] || 0, D = 20 > k ? (v[0] * Math.pow(10, v[1])).toFixed(k) : 0, v[1] = 0);
              }
            } else
              k = 2;
            x = (Math.abs(v[1] ? v[0] : D) + Math.pow(10, -Math.max(k, m) - 1)).toFixed(k);
            var E = 3 < (m = String(N(x))).length ? m.length % 3 : 0;
            return A = U(A, d.decimalPoint), b = U(b, d.thousandsSep), D = (0 > D ? "-" : "") + (E ? m.substr(0, E) + b : ""), D = 0 > +v[1] && !g ? "0" : D + m.substr(E).replace(/(\d{3})(?=\d)/g, "$1" + b), k && (D += A + x.slice(-k)), v[1] && +D != 0 && (D += "e" + v[1]), D;
          }
          var Y = G.defaultOptions, J = G.defaultTime, Q = F.getNestedProperty, q = F.isNumber, U = F.pick, N = F.pInt;
          return { dateFormat: function(D, k, A) {
            return J.dateFormat(D, k, A);
          }, format: function(D, k, A) {
            var b = "{", d = !1, m = /f$/, v = /\.([0-9])/, g = Y.lang, x = A && A.time || J;
            A = A && A.numberFormatter || $;
            for (var E = []; D; ) {
              var P = D.indexOf(b);
              if (P === -1)
                break;
              var S = D.slice(0, P);
              if (d) {
                if (S = S.split(":"), b = Q(S.shift() || "", k), S.length && typeof b == "number")
                  if (S = S.join(":"), m.test(S)) {
                    var u = parseInt((S.match(v) || ["", "-1"])[1], 10);
                    b !== null && (b = A(b, u, g.decimalPoint, -1 < S.indexOf(",") ? g.thousandsSep : ""));
                  } else
                    b = x.dateFormat(S, b);
                E.push(b);
              } else
                E.push(S);
              D = D.slice(P + 1), b = (d = !d) ? "}" : "{";
            }
            return E.push(D), E.join("");
          }, numberFormat: $ };
        }), _(at, "Core/Renderer/RendererUtilities.js", [at["Core/Utilities.js"]], function(G) {
          var F, $ = G.clamp, Y = G.pick, J = G.stableSort;
          return function(Q) {
            Q.distribute = function q(U, N, D) {
              var k, A = U, b = A.reducedLen || N, d = function(E, P) {
                return (P.rank || 0) - (E.rank || 0);
              }, m = function(E, P) {
                return E.target - P.target;
              }, v = !0, g = [], x = 0;
              for (k = U.length; k--; )
                x += U[k].size;
              if (x > b) {
                for (J(U, d), x = k = 0; x <= b; )
                  x += U[k].size, k++;
                g = U.splice(k - 1, U.length);
              }
              for (J(U, m), U = U.map(function(E) {
                return { size: E.size, targets: [E.target], align: Y(E.align, 0.5) };
              }); v; ) {
                for (k = U.length; k--; )
                  b = U[k], d = (Math.min.apply(0, b.targets) + Math.max.apply(0, b.targets)) / 2, b.pos = $(d - b.size * b.align, 0, N - b.size);
                for (k = U.length, v = !1; k--; )
                  0 < k && U[k - 1].pos + U[k - 1].size > U[k].pos && (U[k - 1].size += U[k].size, U[k - 1].targets = U[k - 1].targets.concat(U[k].targets), U[k - 1].align = 0.5, U[k - 1].pos + U[k - 1].size > N && (U[k - 1].pos = N - U[k - 1].size), U.splice(k, 1), v = !0);
              }
              return A.push.apply(A, g), k = 0, U.some(function(E) {
                var P = 0;
                return (E.targets || []).some(function() {
                  return A[k].pos = E.pos + P, D !== void 0 && Math.abs(A[k].pos - A[k].target) > D ? (A.slice(0, k + 1).forEach(function(S) {
                    return delete S.pos;
                  }), A.reducedLen = (A.reducedLen || N) - 0.1 * N, A.reducedLen > 0.1 * N && q(A, N, D), !0) : (P += A[k].size, k++, !1);
                });
              }), J(A, m), A;
            };
          }(F || (F = {})), F;
        }), _(at, "Core/Renderer/SVG/SVGElement.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Color/Color.js"], at["Core/Globals.js"], at["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = G.animate, Q = G.animObject, q = G.stop, U = $.deg2rad, N = $.doc, D = $.svg, k = $.SVG_NS, A = $.win, b = Y.addEvent, d = Y.attr, m = Y.createElement, v = Y.css, g = Y.defined, x = Y.erase, E = Y.extend, P = Y.fireEvent, S = Y.isArray, u = Y.isFunction, y = Y.isString, s = Y.merge, a = Y.objectEach, e = Y.pick, n = Y.pInt, o = Y.syncTimeout, i = Y.uniqueKey;
          return G = function() {
            function c() {
              this.element = void 0, this.onEvents = {}, this.opacity = 1, this.renderer = void 0, this.SVG_NS = k, this.symbolCustomAttribs = "x y width height r start end innerR anchorX anchorY rounded".split(" ");
            }
            return c.prototype._defaultGetter = function(l) {
              return l = e(this[l + "Value"], this[l], this.element ? this.element.getAttribute(l) : null, 0), /^[\-0-9\.]+$/.test(l) && (l = parseFloat(l)), l;
            }, c.prototype._defaultSetter = function(l, h, C) {
              C.setAttribute(h, l);
            }, c.prototype.add = function(l) {
              var h = this.renderer, C = this.element;
              if (l && (this.parentGroup = l), this.textStr !== void 0 && this.element.nodeName === "text" && h.buildText(this), this.added = !0, !l || l.handleZ || this.zIndex)
                var M = this.zIndexSetter();
              return M || (l ? l.element : h.box).appendChild(C), this.onAdd && this.onAdd(), this;
            }, c.prototype.addClass = function(l, h) {
              var C = h ? "" : this.attr("class") || "";
              return l = (l || "").split(/ /g).reduce(function(M, O) {
                return C.indexOf(O) === -1 && M.push(O), M;
              }, C ? [C] : []).join(" "), l !== C && this.attr("class", l), this;
            }, c.prototype.afterSetters = function() {
              this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }, c.prototype.align = function(l, h, C) {
              var M, O, p, w = {}, T = this.renderer, z = T.alignedObjects;
              l ? (this.alignOptions = l, this.alignByTranslate = h, (!C || y(C)) && (this.alignTo = M = C || "renderer", x(z, this), z.push(this), C = void 0)) : (l = this.alignOptions, h = this.alignByTranslate, M = this.alignTo), C = e(C, T[M], M === "scrollablePlotBox" ? T.plotBox : void 0, T), M = l.align;
              var W = l.verticalAlign;
              return T = (C.x || 0) + (l.x || 0), z = (C.y || 0) + (l.y || 0), M === "right" ? O = 1 : M === "center" && (O = 2), O && (T += (C.width - (l.width || 0)) / O), w[h ? "translateX" : "x"] = Math.round(T), W === "bottom" ? p = 1 : W === "middle" && (p = 2), p && (z += (C.height - (l.height || 0)) / p), w[h ? "translateY" : "y"] = Math.round(z), this[this.placed ? "animate" : "attr"](w), this.placed = !0, this.alignAttr = w, this;
            }, c.prototype.alignSetter = function(l) {
              var h = { left: "start", center: "middle", right: "end" };
              h[l] && (this.alignValue = l, this.element.setAttribute("text-anchor", h[l]));
            }, c.prototype.animate = function(l, h, C) {
              var M = this, O = Q(e(h, this.renderer.globalAnimation, !0));
              return h = O.defer, e(N.hidden, N.msHidden, N.webkitHidden, !1) && (O.duration = 0), O.duration !== 0 ? (C && (O.complete = C), o(function() {
                M.element && J(M, l, O);
              }, h)) : (this.attr(l, void 0, C || O.complete), a(l, function(p, w) {
                O.step && O.step.call(this, p, { prop: w, pos: 1, elem: this });
              }, this)), this;
            }, c.prototype.applyTextOutline = function(l) {
              var h = this.element;
              l.indexOf("contrast") !== -1 && (l = l.replace(/contrast/g, this.renderer.getContrast(h.style.fill)));
              var C = l.split(" ");
              if (l = C[C.length - 1], (C = C[0]) && C !== "none" && $.svg) {
                this.fakeTS = !0, C = C.replace(/(^[\d\.]+)(.*?)$/g, function(p, w, T) {
                  return 2 * Number(w) + T;
                }), this.removeTextOutline();
                var M = N.createElementNS(k, "tspan");
                d(M, { class: "highcharts-text-outline", fill: l, stroke: l, "stroke-width": C, "stroke-linejoin": "round" }), l = h.querySelector("textPath") || h, [].forEach.call(l.childNodes, function(p) {
                  var w = p.cloneNode(!0);
                  w.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach(function(T) {
                    return w.removeAttribute(T);
                  }), M.appendChild(w);
                });
                var O = 0;
                [].forEach.call(l.querySelectorAll("text tspan"), function(p) {
                  O += Number(p.getAttribute("dy"));
                }), (C = N.createElementNS(k, "tspan")).textContent = "​", d(C, { x: Number(h.getAttribute("x")), dy: -O }), M.appendChild(C), l.insertBefore(M, l.firstChild);
              }
            }, c.prototype.attr = function(l, h, C, M) {
              var O, p, w, T = this.element, z = this.symbolCustomAttribs, W = this;
              if (typeof l == "string" && h !== void 0) {
                var L = l;
                (l = {})[L] = h;
              }
              return typeof l == "string" ? W = (this[l + "Getter"] || this._defaultGetter).call(this, l, T) : (a(l, function(I, j) {
                p = !1, M || q(this, j), this.symbolName && z.indexOf(j) !== -1 && (O || (this.symbolAttr(l), O = !0), p = !0), !this.rotation || j !== "x" && j !== "y" || (this.doTransform = !0), p || ((w = this[j + "Setter"] || this._defaultSetter).call(this, I, j, T), !this.styledMode && this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(j) && this.updateShadows(j, I, w));
              }, this), this.afterSetters()), C && C.call(this), W;
            }, c.prototype.clip = function(l) {
              return this.attr("clip-path", l ? "url(" + this.renderer.url + "#" + l.id + ")" : "none");
            }, c.prototype.crisp = function(l, h) {
              h = h || l.strokeWidth || 0;
              var C = Math.round(h) % 2 / 2;
              return l.x = Math.floor(l.x || this.x || 0) + C, l.y = Math.floor(l.y || this.y || 0) + C, l.width = Math.floor((l.width || this.width || 0) - 2 * C), l.height = Math.floor((l.height || this.height || 0) - 2 * C), g(l.strokeWidth) && (l.strokeWidth = h), l;
            }, c.prototype.complexColor = function(l, h, C) {
              var M, O, p, w, T, z, W, L, I, j, Z, V = this.renderer, X = [];
              P(this.renderer, "complexColor", { args: arguments }, function() {
                if (l.radialGradient ? O = "radialGradient" : l.linearGradient && (O = "linearGradient"), O) {
                  if (p = l[O], T = V.gradients, z = l.stops, I = C.radialReference, S(p) && (l[O] = p = { x1: p[0], y1: p[1], x2: p[2], y2: p[3], gradientUnits: "userSpaceOnUse" }), O === "radialGradient" && I && !g(p.gradientUnits) && (w = p, p = s(p, V.getRadialAttr(I, w), { gradientUnits: "userSpaceOnUse" })), a(p, function(ot, it) {
                    it !== "id" && X.push(it, ot);
                  }), a(z, function(ot) {
                    X.push(ot);
                  }), X = X.join(","), T[X])
                    j = T[X].attr("id");
                  else {
                    p.id = j = i();
                    var et = T[X] = V.createElement(O).attr(p).add(V.defs);
                    et.radAttr = w, et.stops = [], z.forEach(function(ot) {
                      ot[1].indexOf("rgba") === 0 ? (M = F.parse(ot[1]), W = M.get("rgb"), L = M.get("a")) : (W = ot[1], L = 1), ot = V.createElement("stop").attr({ offset: ot[0], "stop-color": W, "stop-opacity": L }).add(et), et.stops.push(ot);
                    });
                  }
                  Z = "url(" + V.url + "#" + j + ")", C.setAttribute(h, Z), C.gradient = X, l.toString = function() {
                    return Z;
                  };
                }
              });
            }, c.prototype.css = function(l) {
              var h = this.styles, C = {}, M = this.element, O = !h;
              if (l.color && (l.fill = l.color), h && a(l, function(T, z) {
                h && h[z] !== T && (C[z] = T, O = !0);
              }), O) {
                if (h && (l = E(h, C)), l.width === null || l.width === "auto")
                  delete this.textWidth;
                else if (M.nodeName.toLowerCase() === "text" && l.width)
                  var p = this.textWidth = n(l.width);
                this.styles = l, p && !D && this.renderer.forExport && delete l.width;
                var w = s(l);
                M.namespaceURI === this.SVG_NS && ["textOutline", "textOverflow", "width"].forEach(function(T) {
                  return w && delete w[T];
                }), v(M, w), this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), l.textOutline && this.applyTextOutline(l.textOutline));
              }
              return this;
            }, c.prototype.dashstyleSetter = function(l) {
              var h = this["stroke-width"];
              if (h === "inherit" && (h = 1), l = l && l.toLowerCase()) {
                var C = l.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                for (l = C.length; l--; )
                  C[l] = "" + n(C[l]) * e(h, NaN);
                l = C.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", l);
              }
            }, c.prototype.destroy = function() {
              var l = this, h = l.element || {}, C = l.renderer, M = h.ownerSVGElement, O = C.isSVG && h.nodeName === "SPAN" && l.parentGroup || void 0;
              if (h.onclick = h.onmouseout = h.onmouseover = h.onmousemove = h.point = null, q(l), l.clipPath && M) {
                var p = l.clipPath;
                [].forEach.call(M.querySelectorAll("[clip-path],[CLIP-PATH]"), function(w) {
                  -1 < w.getAttribute("clip-path").indexOf(p.element.id) && w.removeAttribute("clip-path");
                }), l.clipPath = p.destroy();
              }
              if (l.stops) {
                for (M = 0; M < l.stops.length; M++)
                  l.stops[M].destroy();
                l.stops.length = 0, l.stops = void 0;
              }
              for (l.safeRemoveChild(h), C.styledMode || l.destroyShadows(); O && O.div && O.div.childNodes.length === 0; )
                h = O.parentGroup, l.safeRemoveChild(O.div), delete O.div, O = h;
              l.alignTo && x(C.alignedObjects, l), a(l, function(w, T) {
                l[T] && l[T].parentGroup === l && l[T].destroy && l[T].destroy(), delete l[T];
              });
            }, c.prototype.destroyShadows = function() {
              (this.shadows || []).forEach(function(l) {
                this.safeRemoveChild(l);
              }, this), this.shadows = void 0;
            }, c.prototype.dSetter = function(l, h, C) {
              S(l) && (typeof l[0] == "string" && (l = this.renderer.pathToSegments(l)), this.pathArray = l, l = l.reduce(function(M, O, p) {
                return O && O.join ? (p ? M + " " : "") + O.join(" ") : (O || "").toString();
              }, "")), /(NaN| {2}|^$)/.test(l) && (l = "M 0 0"), this[h] !== l && (C.setAttribute(h, l), this[h] = l);
            }, c.prototype.fadeOut = function(l) {
              var h = this;
              h.animate({ opacity: 0 }, { duration: e(l, 150), complete: function() {
                h.hide();
              } });
            }, c.prototype.fillSetter = function(l, h, C) {
              typeof l == "string" ? C.setAttribute(h, l) : l && this.complexColor(l, h, C);
            }, c.prototype.getBBox = function(l, h) {
              var C = this.alignValue, M = this.element, O = this.renderer, p = this.styles, w = this.textStr, T = O.cache, z = O.cacheKeys, W = M.namespaceURI === this.SVG_NS;
              h = e(h, this.rotation, 0);
              var L, I = O.styledMode ? M && c.prototype.getStyle.call(M, "font-size") : p && p.fontSize;
              if (g(w)) {
                var j = w.toString();
                j.indexOf("<") === -1 && (j = j.replace(/[0-9]/g, "0")), j += ["", h, I, this.textWidth, C, p && p.textOverflow, p && p.fontWeight].join();
              }
              if (j && !l && (L = T[j]), !L) {
                if (W || O.forExport) {
                  try {
                    var Z = this.fakeTS && function(X) {
                      var et = M.querySelector(".highcharts-text-outline");
                      et && v(et, { display: X });
                    };
                    u(Z) && Z("none"), L = M.getBBox ? E({}, M.getBBox()) : { width: M.offsetWidth, height: M.offsetHeight, x: 0, y: 0 }, u(Z) && Z("");
                  } catch (X) {
                  }
                  (!L || 0 > L.width) && (L = { x: 0, y: 0, width: 0, height: 0 });
                } else
                  L = this.htmlGetBBox();
                if (O.isSVG && (O = L.width, l = L.height, W && (L.height = l = { "11px,17": 14, "13px,20": 16 }["" + (I || "") + ",".concat(Math.round(l))] || l), h)) {
                  W = Number(M.getAttribute("y") || 0) - L.y, C = { right: 1, center: 0.5 }[C || 0] || 0, p = h * U, I = (h - 90) * U;
                  var V = O * Math.cos(p);
                  h = O * Math.sin(p), Z = Math.cos(I), p = Math.sin(I), V = (Z = (I = (O = L.x + C * (O - V) + W * Z) + V) - l * Z) - V, h = (l = (C = (W = L.y + W - C * h + W * p) + h) - l * p) - h, L.x = Math.min(O, I, Z, V), L.y = Math.min(W, C, l, h), L.width = Math.max(O, I, Z, V) - L.x, L.height = Math.max(W, C, l, h) - L.y;
                }
                if (j && (w === "" || 0 < L.height)) {
                  for (; 250 < z.length; )
                    delete T[z.shift()];
                  T[j] || z.push(j), T[j] = L;
                }
              }
              return L;
            }, c.prototype.getStyle = function(l) {
              return A.getComputedStyle(this.element || this, "").getPropertyValue(l);
            }, c.prototype.hasClass = function(l) {
              return ("" + this.attr("class")).split(" ").indexOf(l) !== -1;
            }, c.prototype.hide = function() {
              return this.attr({ visibility: "hidden" });
            }, c.prototype.htmlGetBBox = function() {
              return { height: 0, width: 0, x: 0, y: 0 };
            }, c.prototype.init = function(l, h) {
              this.element = h === "span" ? m(h) : N.createElementNS(this.SVG_NS, h), this.renderer = l, P(this, "afterInit");
            }, c.prototype.on = function(l, h) {
              var C = this.onEvents;
              return C[l] && C[l](), C[l] = b(this.element, l, h), this;
            }, c.prototype.opacitySetter = function(l, h, C) {
              this.opacity = l = Number(Number(l).toFixed(3)), C.setAttribute(h, l);
            }, c.prototype.removeClass = function(l) {
              return this.attr("class", ("" + this.attr("class")).replace(y(l) ? new RegExp("(^| )".concat(l, "( |$)")) : l, " ").replace(/ +/g, " ").trim());
            }, c.prototype.removeTextOutline = function() {
              var l = this.element.querySelector("tspan.highcharts-text-outline");
              l && this.safeRemoveChild(l);
            }, c.prototype.safeRemoveChild = function(l) {
              var h = l.parentNode;
              h && h.removeChild(l);
            }, c.prototype.setRadialReference = function(l) {
              var h = this.element.gradient && this.renderer.gradients[this.element.gradient];
              return this.element.radialReference = l, h && h.radAttr && h.animate(this.renderer.getRadialAttr(l, h.radAttr)), this;
            }, c.prototype.setTextPath = function(l, h) {
              var C = this;
              h = s(!0, { enabled: !0, attributes: { dy: -5, startOffset: "50%", textAnchor: "middle" } }, h);
              var M = this.renderer.url, O = this.text || this, p = O.textPath, w = h.attributes, T = h.enabled;
              return l = l || p && p.path, p && p.undo(), l && T ? (h = b(O, "afterModifyTree", function(z) {
                if (l && T) {
                  var W = l.attr("id");
                  W || l.attr("id", W = i());
                  var L = { x: 0, y: 0 };
                  g(w.dx) && (L.dx = w.dx, delete w.dx), g(w.dy) && (L.dy = w.dy, delete w.dy), O.attr(L), C.attr({ transform: "" }), C.box && (C.box = C.box.destroy()), L = z.nodes.slice(0), z.nodes.length = 0, z.nodes[0] = { tagName: "textPath", attributes: E(w, { "text-anchor": w.textAnchor, href: "" + M + "#".concat(W) }), children: L };
                }
              }), O.textPath = { path: l, undo: h }) : (O.attr({ dx: 0, dy: 0 }), delete O.textPath), this.added && (O.textCache = "", this.renderer.buildText(O)), this;
            }, c.prototype.shadow = function(l, h, C) {
              var M = [], O = this.element, p = this.oldShadowOptions, w = this.parentGroup, T = w && w.rotation === 90;
              w = { color: "#000000", offsetX: T ? -1 : 1, offsetY: T ? -1 : 1, opacity: 0.15, width: 3 };
              var z, W = !1;
              if (l === !0 ? z = w : typeof l == "object" && (z = E(w, l)), z && (z && p && a(z, function(Z, V) {
                Z !== p[V] && (W = !0);
              }), W && this.destroyShadows(), this.oldShadowOptions = z), z) {
                if (!this.shadows) {
                  w = z.opacity / z.width;
                  var L = T ? "translate(".concat(z.offsetY, ", ").concat(z.offsetX, ")") : "translate(".concat(z.offsetX, ", ").concat(z.offsetY, ")");
                  for (T = 1; T <= z.width; T++) {
                    var I = O.cloneNode(!1), j = 2 * z.width + 1 - 2 * T;
                    d(I, { stroke: l.color || "#000000", "stroke-opacity": w * T, "stroke-width": j, transform: L, fill: "none" }), I.setAttribute("class", (I.getAttribute("class") || "") + " highcharts-shadow"), C && (d(I, "height", Math.max(d(I, "height") - j, 0)), I.cutHeight = j), h ? h.element.appendChild(I) : O.parentNode && O.parentNode.insertBefore(I, O), M.push(I);
                  }
                  this.shadows = M;
                }
              } else
                this.destroyShadows();
              return this;
            }, c.prototype.show = function(l) {
              return l === void 0 && (l = !0), this.attr({ visibility: l ? "inherit" : "visible" });
            }, c.prototype["stroke-widthSetter"] = function(l, h, C) {
              this[h] = l, C.setAttribute(h, l);
            }, c.prototype.strokeWidth = function() {
              if (!this.renderer.styledMode)
                return this["stroke-width"] || 0;
              var l = this.getStyle("stroke-width"), h = 0;
              if (l.indexOf("px") === l.length - 2)
                h = n(l);
              else if (l !== "") {
                var C = N.createElementNS(k, "rect");
                d(C, { width: l, "stroke-width": 0 }), this.element.parentNode.appendChild(C), h = C.getBBox().width, C.parentNode.removeChild(C);
              }
              return h;
            }, c.prototype.symbolAttr = function(l) {
              var h = this;
              "x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(C) {
                h[C] = e(l[C], h[C]);
              }), h.attr({ d: h.renderer.symbols[h.symbolName](h.x, h.y, h.width, h.height, h) });
            }, c.prototype.textSetter = function(l) {
              l !== this.textStr && (delete this.textPxLength, this.textStr = l, this.added && this.renderer.buildText(this));
            }, c.prototype.titleSetter = function(l) {
              var h = this.element, C = h.getElementsByTagName("title")[0] || N.createElementNS(this.SVG_NS, "title");
              h.insertBefore ? h.insertBefore(C, h.firstChild) : h.appendChild(C), C.textContent = String(e(l, "")).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }, c.prototype.toFront = function() {
              var l = this.element;
              return l.parentNode.appendChild(l), this;
            }, c.prototype.translate = function(l, h) {
              return this.attr({ translateX: l, translateY: h });
            }, c.prototype.updateShadows = function(l, h, C) {
              var M = this.shadows;
              if (M)
                for (var O = M.length; O--; )
                  C.call(M[O], l === "height" ? Math.max(h - (M[O].cutHeight || 0), 0) : l === "d" ? this.d : h, l, M[O]);
            }, c.prototype.updateTransform = function() {
              var l = this.element, h = this.matrix, C = this.rotation;
              C = C === void 0 ? 0 : C;
              var M = this.scaleX, O = this.scaleY, p = this.translateX, w = this.translateY;
              p = ["translate(" + (p === void 0 ? 0 : p) + "," + (w === void 0 ? 0 : w) + ")"], g(h) && p.push("matrix(" + h.join(",") + ")"), C && p.push("rotate(" + C + " " + e(this.rotationOriginX, l.getAttribute("x"), 0) + " " + e(this.rotationOriginY, l.getAttribute("y") || 0) + ")"), (g(M) || g(O)) && p.push("scale(" + e(M, 1) + " " + e(O, 1) + ")"), p.length && !(this.text || this).textPath && l.setAttribute("transform", p.join(" "));
            }, c.prototype.visibilitySetter = function(l, h, C) {
              l === "inherit" ? C.removeAttribute(h) : this[h] !== l && C.setAttribute(h, l), this[h] = l;
            }, c.prototype.xGetter = function(l) {
              return this.element.nodeName === "circle" && (l === "x" ? l = "cx" : l === "y" && (l = "cy")), this._defaultGetter(l);
            }, c.prototype.zIndexSetter = function(l, h) {
              var C = this.renderer, M = this.parentGroup, O = (M || C).element || C.box, p = this.element;
              C = O === C.box;
              var w, T = !1, z = this.added;
              if (g(l) ? (p.setAttribute("data-z-index", l), l = +l, this[h] === l && (z = !1)) : g(this[h]) && p.removeAttribute("data-z-index"), this[h] = l, z) {
                for ((l = this.zIndex) && M && (M.handleZ = !0), w = (h = O.childNodes).length - 1; 0 <= w && !T; w--) {
                  z = (M = h[w]).getAttribute("data-z-index");
                  var W = !g(z);
                  M !== p && (0 > l && W && !C && !w ? (O.insertBefore(p, h[w]), T = !0) : (n(z) <= l || W && (!g(l) || 0 <= l)) && (O.insertBefore(p, h[w + 1] || null), T = !0));
                }
                T || (O.insertBefore(p, h[C ? 3 : 0] || null), T = !0);
              }
              return T;
            }, c;
          }(), G.prototype.strokeSetter = G.prototype.fillSetter, G.prototype.yGetter = G.prototype.xGetter, G.prototype.matrixSetter = G.prototype.rotationOriginXSetter = G.prototype.rotationOriginYSetter = G.prototype.rotationSetter = G.prototype.scaleXSetter = G.prototype.scaleYSetter = G.prototype.translateXSetter = G.prototype.translateYSetter = G.prototype.verticalAlignSetter = function(c, l) {
            this[l] = c, this.doTransform = !0;
          }, G;
        }), _(at, "Core/Renderer/RendererRegistry.js", [at["Core/Globals.js"]], function(G) {
          var F;
          return function($) {
            var Y;
            $.rendererTypes = {}, $.getRendererType = function(J) {
              return J === void 0 && (J = Y), $.rendererTypes[J] || $.rendererTypes[Y];
            }, $.registerRendererType = function(J, Q, q) {
              $.rendererTypes[J] = Q, Y && !q || (Y = J, G.Renderer = Q);
            };
          }(F || (F = {})), F;
        }), _(at, "Core/Renderer/SVG/SVGLabel.js", [at["Core/Renderer/SVG/SVGElement.js"], at["Core/Utilities.js"]], function(G, F) {
          var $ = this && this.__extends || /* @__PURE__ */ function() {
            var D = function(k, A) {
              return D = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
                b.__proto__ = d;
              } || function(b, d) {
                for (var m in d)
                  d.hasOwnProperty(m) && (b[m] = d[m]);
              }, D(k, A);
            };
            return function(k, A) {
              function b() {
                this.constructor = k;
              }
              D(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
            };
          }(), Y = F.defined, J = F.extend, Q = F.isNumber, q = F.merge, U = F.pick, N = F.removeEvent;
          return function(D) {
            function k(A, b, d, m, v, g, x, E, P, S) {
              var u, y = D.call(this) || this;
              return y.paddingLeftSetter = y.paddingSetter, y.paddingRightSetter = y.paddingSetter, y.init(A, "g"), y.textStr = b, y.x = d, y.y = m, y.anchorX = g, y.anchorY = x, y.baseline = P, y.className = S, y.addClass(S === "button" ? "highcharts-no-tooltip" : "highcharts-label"), S && y.addClass("highcharts-" + S), y.text = A.text(void 0, 0, 0, E).attr({ zIndex: 1 }), typeof v == "string" && ((u = /^url\((.*?)\)$/.test(v)) || y.renderer.symbols[v]) && (y.symbolKey = v), y.bBox = k.emptyBBox, y.padding = 3, y.baselineOffset = 0, y.needsBox = A.styledMode || u, y.deferredAttr = {}, y.alignFactor = 0, y;
            }
            return $(k, D), k.prototype.alignSetter = function(A) {
              (A = { left: 0, center: 0.5, right: 1 }[A]) !== this.alignFactor && (this.alignFactor = A, this.bBox && Q(this.xSetting) && this.attr({ x: this.xSetting }));
            }, k.prototype.anchorXSetter = function(A, b) {
              this.anchorX = A, this.boxAttr(b, Math.round(A) - this.getCrispAdjust() - this.xSetting);
            }, k.prototype.anchorYSetter = function(A, b) {
              this.anchorY = A, this.boxAttr(b, A - this.ySetting);
            }, k.prototype.boxAttr = function(A, b) {
              this.box ? this.box.attr(A, b) : this.deferredAttr[A] = b;
            }, k.prototype.css = function(A) {
              if (A) {
                var b = {};
                A = q(A), k.textProps.forEach(function(d) {
                  A[d] !== void 0 && (b[d] = A[d], delete A[d]);
                }), this.text.css(b), "fontSize" in b || "fontWeight" in b ? this.updateTextPadding() : ("width" in b || "textOverflow" in b) && this.updateBoxSize();
              }
              return G.prototype.css.call(this, A);
            }, k.prototype.destroy = function() {
              N(this.element, "mouseenter"), N(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), G.prototype.destroy.call(this);
            }, k.prototype.fillSetter = function(A, b) {
              A && (this.needsBox = !0), this.fill = A, this.boxAttr(b, A);
            }, k.prototype.getBBox = function() {
              this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
              var A = this.padding, b = U(this.paddingLeft, A);
              return { width: this.width, height: this.height, x: this.bBox.x - b, y: this.bBox.y - A };
            }, k.prototype.getCrispAdjust = function() {
              return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }, k.prototype.heightSetter = function(A) {
              this.heightSetting = A;
            }, k.prototype.onAdd = function() {
              this.text.add(this), this.attr({ text: U(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && Y(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
            }, k.prototype.paddingSetter = function(A, b) {
              Q(A) ? A !== this[b] && (this[b] = A, this.updateTextPadding()) : this[b] = void 0;
            }, k.prototype.rSetter = function(A, b) {
              this.boxAttr(b, A);
            }, k.prototype.shadow = function(A) {
              return A && !this.renderer.styledMode && (this.updateBoxSize(), this.box && this.box.shadow(A)), this;
            }, k.prototype.strokeSetter = function(A, b) {
              this.stroke = A, this.boxAttr(b, A);
            }, k.prototype["stroke-widthSetter"] = function(A, b) {
              A && (this.needsBox = !0), this["stroke-width"] = A, this.boxAttr(b, A);
            }, k.prototype["text-alignSetter"] = function(A) {
              this.textAlign = A;
            }, k.prototype.textSetter = function(A) {
              A !== void 0 && this.text.attr({ text: A }), this.updateTextPadding();
            }, k.prototype.updateBoxSize = function() {
              var A = this.text, b = A.element.style, d = {}, m = this.padding, v = this.bBox = Q(this.widthSetting) && Q(this.heightSetting) && !this.textAlign || !Y(A.textStr) ? k.emptyBBox : A.getBBox();
              this.width = this.getPaddedWidth(), this.height = (this.heightSetting || v.height || 0) + 2 * m, b = this.renderer.fontMetrics(b && b.fontSize, A), this.baselineOffset = m + Math.min((this.text.firstLineMetrics || b).b, v.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - b.h) / 2), this.needsBox && !A.textPath && (this.box || ((A = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect()).addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), A.add(this)), A = this.getCrispAdjust(), d.x = A, d.y = (this.baseline ? -this.baselineOffset : 0) + A, d.width = Math.round(this.width), d.height = Math.round(this.height), this.box.attr(J(d, this.deferredAttr)), this.deferredAttr = {});
            }, k.prototype.updateTextPadding = function() {
              var A = this.text;
              if (!A.textPath) {
                this.updateBoxSize();
                var b = this.baseline ? 0 : this.baselineOffset, d = U(this.paddingLeft, this.padding);
                Y(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (d += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), d === A.x && b === A.y || (A.attr("x", d), A.hasBoxWidthChanged && (this.bBox = A.getBBox(!0)), b !== void 0 && A.attr("y", b)), A.x = d, A.y = b;
              }
            }, k.prototype.widthSetter = function(A) {
              this.widthSetting = Q(A) ? A : void 0;
            }, k.prototype.getPaddedWidth = function() {
              var A = this.padding, b = U(this.paddingLeft, A);
              return A = U(this.paddingRight, A), (this.widthSetting || this.bBox.width || 0) + b + A;
            }, k.prototype.xSetter = function(A) {
              this.x = A, this.alignFactor && (A -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(A), this.attr("translateX", this.xSetting);
            }, k.prototype.ySetter = function(A) {
              this.ySetting = this.y = Math.round(A), this.attr("translateY", this.ySetting);
            }, k.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, k.textProps = "color direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" "), k;
          }(G);
        }), _(at, "Core/Renderer/SVG/Symbols.js", [at["Core/Utilities.js"]], function(G) {
          function F(U, N, D, k, A) {
            var b = [];
            if (A) {
              var d = A.start || 0, m = q(A.r, D);
              D = q(A.r, k || D);
              var v = (A.end || 0) - 1e-3;
              k = A.innerR;
              var g = q(A.open, 1e-3 > Math.abs((A.end || 0) - d - 2 * Math.PI)), x = Math.cos(d), E = Math.sin(d), P = Math.cos(v), S = Math.sin(v);
              d = q(A.longArc, 1e-3 > v - d - Math.PI ? 0 : 1), b.push(["M", U + m * x, N + D * E], ["A", m, D, 0, d, q(A.clockwise, 1), U + m * P, N + D * S]), J(k) && b.push(g ? ["M", U + k * P, N + k * S] : ["L", U + k * P, N + k * S], ["A", k, k, 0, d, J(A.clockwise) ? 1 - A.clockwise : 0, U + k * x, N + k * E]), g || b.push(["Z"]);
            }
            return b;
          }
          function $(U, N, D, k, A) {
            return A && A.r ? Y(U, N, D, k, A) : [["M", U, N], ["L", U + D, N], ["L", U + D, N + k], ["L", U, N + k], ["Z"]];
          }
          function Y(U, N, D, k, A) {
            return [["M", U + (A = A && A.r || 0), N], ["L", U + D - A, N], ["C", U + D, N, U + D, N, U + D, N + A], ["L", U + D, N + k - A], ["C", U + D, N + k, U + D, N + k, U + D - A, N + k], ["L", U + A, N + k], ["C", U, N + k, U, N + k, U, N + k - A], ["L", U, N + A], ["C", U, N, U, N, U + A, N]];
          }
          var J = G.defined, Q = G.isNumber, q = G.pick;
          return { arc: F, callout: function(U, N, D, k, A) {
            var b = Math.min(A && A.r || 0, D, k), d = b + 6, m = A && A.anchorX;
            A = A && A.anchorY || 0;
            var v = Y(U, N, D, k, { r: b });
            return Q(m) && (U + m >= D ? A > N + d && A < N + k - d ? v.splice(3, 1, ["L", U + D, A - 6], ["L", U + D + 6, A], ["L", U + D, A + 6], ["L", U + D, N + k - b]) : v.splice(3, 1, ["L", U + D, k / 2], ["L", m, A], ["L", U + D, k / 2], ["L", U + D, N + k - b]) : 0 >= U + m ? A > N + d && A < N + k - d ? v.splice(7, 1, ["L", U, A + 6], ["L", U - 6, A], ["L", U, A - 6], ["L", U, N + b]) : v.splice(7, 1, ["L", U, k / 2], ["L", m, A], ["L", U, k / 2], ["L", U, N + b]) : A && A > k && m > U + d && m < U + D - d ? v.splice(5, 1, ["L", m + 6, N + k], ["L", m, N + k + 6], ["L", m - 6, N + k], ["L", U + b, N + k]) : A && 0 > A && m > U + d && m < U + D - d && v.splice(1, 1, ["L", m - 6, N], ["L", m, N - 6], ["L", m + 6, N], ["L", D - b, N])), v;
          }, circle: function(U, N, D, k) {
            return F(U + D / 2, N + k / 2, D / 2, k / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
          }, diamond: function(U, N, D, k) {
            return [["M", U + D / 2, N], ["L", U + D, N + k / 2], ["L", U + D / 2, N + k], ["L", U, N + k / 2], ["Z"]];
          }, rect: $, roundedRect: Y, square: $, triangle: function(U, N, D, k) {
            return [["M", U + D / 2, N], ["L", U + D, N + k], ["L", U, N + k], ["Z"]];
          }, "triangle-down": function(U, N, D, k) {
            return [["M", U, N], ["L", U + D, N], ["L", U + D / 2, N + k], ["Z"]];
          } };
        }), _(at, "Core/Renderer/SVG/TextBuilder.js", [at["Core/Renderer/HTML/AST.js"], at["Core/Globals.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = F.doc, J = F.SVG_NS, Q = F.win, q = $.attr, U = $.extend, N = $.fireEvent, D = $.isString, k = $.objectEach, A = $.pick;
          return function() {
            function b(d) {
              var m = d.styles;
              this.renderer = d.renderer, this.svgElement = d, this.width = d.textWidth, this.textLineHeight = m && m.lineHeight, this.textOutline = m && m.textOutline, this.ellipsis = !(!m || m.textOverflow !== "ellipsis"), this.noWrap = !(!m || m.whiteSpace !== "nowrap"), this.fontSize = m && m.fontSize;
            }
            return b.prototype.buildSVG = function() {
              var d = this.svgElement, m = d.element, v = d.renderer, g = A(d.textStr, "").toString(), x = g.indexOf("<") !== -1, E = m.childNodes;
              v = this.width && !d.added && v.box;
              var P = [g, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, this.fontSize, this.width].join();
              if (P !== d.textCache) {
                for (d.textCache = P, delete d.actualWidth, P = E.length; P--; )
                  m.removeChild(E[P]);
                x || this.ellipsis || this.width || d.textPath || g.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(g)) ? g !== "" && (v && v.appendChild(m), g = new G(g), this.modifyTree(g.nodes), g.addToDOM(m), this.modifyDOM(), this.ellipsis && (m.textContent || "").indexOf("…") !== -1 && d.attr("title", this.unescapeEntities(d.textStr || "", ["&lt;", "&gt;"])), v && v.removeChild(m)) : m.appendChild(Y.createTextNode(this.unescapeEntities(g))), D(this.textOutline) && d.applyTextOutline && d.applyTextOutline(this.textOutline);
              }
            }, b.prototype.modifyDOM = function() {
              var d, m = this, v = this.svgElement, g = q(v.element, "x");
              for (v.firstLineMetrics = void 0; (d = v.element.firstChild) && /^[\s\u200B]*$/.test(d.textContent || " "); )
                v.element.removeChild(d);
              [].forEach.call(v.element.querySelectorAll("tspan.highcharts-br"), function(S, u) {
                S.nextSibling && S.previousSibling && (u === 0 && S.previousSibling.nodeType === 1 && (v.firstLineMetrics = v.renderer.fontMetrics(void 0, S.previousSibling)), q(S, { dy: m.getLineHeight(S.nextSibling), x: g }));
              });
              var x = this.width || 0;
              if (x) {
                var E = function(S, u) {
                  var y = S.textContent || "", s = y.replace(/([^\^])-/g, "$1- ").split(" "), a = !m.noWrap && (1 < s.length || 1 < v.element.childNodes.length), e = m.getLineHeight(u), n = 0, o = v.actualWidth;
                  if (m.ellipsis)
                    y && m.truncate(S, y, void 0, 0, Math.max(0, x - parseInt(m.fontSize || 12, 10)), function(i, c) {
                      return i.substring(0, c) + "…";
                    });
                  else if (a) {
                    for (y = [], a = []; u.firstChild && u.firstChild !== S; )
                      a.push(u.firstChild), u.removeChild(u.firstChild);
                    for (; s.length; )
                      s.length && !m.noWrap && 0 < n && (y.push(S.textContent || ""), S.textContent = s.join(" ").replace(/- /g, "-")), m.truncate(S, void 0, s, n === 0 && o || 0, x, function(i, c) {
                        return s.slice(0, c).join(" ").replace(/- /g, "-");
                      }), o = v.actualWidth, n++;
                    a.forEach(function(i) {
                      u.insertBefore(i, S);
                    }), y.forEach(function(i) {
                      u.insertBefore(Y.createTextNode(i), S), (i = Y.createElementNS(J, "tspan")).textContent = "​", q(i, { dy: e, x: g }), u.insertBefore(i, S);
                    });
                  }
                }, P = function(S) {
                  [].slice.call(S.childNodes).forEach(function(u) {
                    u.nodeType === Q.Node.TEXT_NODE ? E(u, S) : (u.className.baseVal.indexOf("highcharts-br") !== -1 && (v.actualWidth = 0), P(u));
                  });
                };
                P(v.element);
              }
            }, b.prototype.getLineHeight = function(d) {
              var m;
              return d = d.nodeType === Q.Node.TEXT_NODE ? d.parentElement : d, this.renderer.styledMode || (m = d && /(px|em)$/.test(d.style.fontSize) ? d.style.fontSize : this.fontSize || this.renderer.style.fontSize || 12), this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(m, d || this.svgElement.element).h;
            }, b.prototype.modifyTree = function(d) {
              var m = this, v = function(g, x) {
                var E = g.attributes;
                E = E === void 0 ? {} : E;
                var P = g.children, S = g.style;
                S = S === void 0 ? {} : S;
                var u = g.tagName, y = m.renderer.styledMode;
                u === "b" || u === "strong" ? y ? E.class = "highcharts-strong" : S.fontWeight = "bold" : u !== "i" && u !== "em" || (y ? E.class = "highcharts-emphasized" : S.fontStyle = "italic"), S && S.color && (S.fill = S.color), u === "br" ? (E.class = "highcharts-br", g.textContent = "​", (x = d[x + 1]) && x.textContent && (x.textContent = x.textContent.replace(/^ +/gm, ""))) : u === "a" && P && P.some(function(s) {
                  return s.tagName === "#text";
                }) && (g.children = [{ children: P, tagName: "tspan" }]), u !== "#text" && u !== "a" && (g.tagName = "tspan"), U(g, { attributes: E, style: S }), P && P.filter(function(s) {
                  return s.tagName !== "#text";
                }).forEach(v);
              };
              d.forEach(v), N(this.svgElement, "afterModifyTree", { nodes: d });
            }, b.prototype.truncate = function(d, m, v, g, x, E) {
              var P, S = this.svgElement, u = S.renderer, y = S.rotation, s = [], a = v ? 1 : 0, e = (m || v || "").length, n = e, o = function(c, l) {
                l = l || c;
                var h = d.parentNode;
                if (h && s[l] === void 0)
                  if (h.getSubStringLength)
                    try {
                      s[l] = g + h.getSubStringLength(0, v ? l + 1 : l);
                    } catch (C) {
                    }
                  else
                    u.getSpanWidth && (d.textContent = E(m || v, c), s[l] = g + u.getSpanWidth(S, d));
                return s[l];
              };
              S.rotation = 0;
              var i = o(d.textContent.length);
              if (g + i > x) {
                for (; a <= e; )
                  n = Math.ceil((a + e) / 2), v && (P = E(v, n)), i = o(n, P && P.length - 1), a === e ? a = e + 1 : i > x ? e = n - 1 : a = n;
                e === 0 ? d.textContent = "" : m && e === m.length - 1 || (d.textContent = P || E(m || v, n));
              }
              v && v.splice(0, n), S.actualWidth = i, S.rotation = y;
            }, b.prototype.unescapeEntities = function(d, m) {
              return k(this.renderer.escapes, function(v, g) {
                m && m.indexOf(v) !== -1 || (d = d.toString().replace(new RegExp(v, "g"), g));
              }), d;
            }, b;
          }();
        }), _(at, "Core/Renderer/SVG/SVGRenderer.js", [at["Core/Renderer/HTML/AST.js"], at["Core/Color/Color.js"], at["Core/Globals.js"], at["Core/Renderer/RendererRegistry.js"], at["Core/Renderer/SVG/SVGElement.js"], at["Core/Renderer/SVG/SVGLabel.js"], at["Core/Renderer/SVG/Symbols.js"], at["Core/Renderer/SVG/TextBuilder.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N) {
          var D, k = $.charts, A = $.deg2rad, b = $.doc, d = $.isFirefox, m = $.isMS, v = $.isWebKit, g = $.noop, x = $.SVG_NS, E = $.symbolSizes, P = $.win, S = N.addEvent, u = N.attr, y = N.createElement, s = N.css, a = N.defined, e = N.destroyObjectProperties, n = N.extend, o = N.isArray, i = N.isNumber, c = N.isObject, l = N.isString, h = N.merge, C = N.pick, M = N.pInt, O = N.uniqueKey;
          return $ = function() {
            function p(w, T, z, W, L, I, j) {
              this.width = this.url = this.style = this.isSVG = this.imgCount = this.height = this.gradients = this.globalAnimation = this.defs = this.chartIndex = this.cacheKeys = this.cache = this.boxWrapper = this.box = this.alignedObjects = void 0, this.init(w, T, z, W, L, I, j);
            }
            return p.prototype.init = function(w, T, z, W, L, I, j) {
              var Z, V = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), X = V.element;
              j || V.css(this.getStyle(W)), w.appendChild(X), u(w, "dir", "ltr"), w.innerHTML.indexOf("xmlns") === -1 && u(X, "xmlns", this.SVG_NS), this.isSVG = !0, this.box = X, this.boxWrapper = V, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(b.createTextNode("Created with Highcharts 10.3.3")), this.defs = this.createElement("defs").add(), this.allowHTML = I, this.forExport = L, this.styledMode = j, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.setSize(T, z, !1), d && w.getBoundingClientRect && ((T = function() {
                s(w, { left: 0, top: 0 }), Z = w.getBoundingClientRect(), s(w, { left: Math.ceil(Z.left) - Z.left + "px", top: Math.ceil(Z.top) - Z.top + "px" });
              })(), this.unSubPixelFix = S(P, "resize", T));
            }, p.prototype.definition = function(w) {
              return new G([w]).addToDOM(this.defs.element);
            }, p.prototype.getReferenceURL = function() {
              if ((d || v) && b.getElementsByTagName("base").length) {
                if (!a(D)) {
                  var w = O();
                  w = new G([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: w }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": "url(#".concat(w, ")"), fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(b.body), s(w, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
                  var T = b.elementFromPoint(6, 6);
                  D = (T && T.id) === "hitme", b.body.removeChild(w);
                }
                if (D)
                  return P.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20");
              }
              return "";
            }, p.prototype.getStyle = function(w) {
              return this.style = n({ fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', fontSize: "12px" }, w);
            }, p.prototype.setStyle = function(w) {
              this.boxWrapper.css(this.getStyle(w));
            }, p.prototype.isHidden = function() {
              return !this.boxWrapper.getBBox().width;
            }, p.prototype.destroy = function() {
              var w = this.defs;
              return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), e(this.gradients || {}), this.gradients = null, w && (this.defs = w.destroy()), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null;
            }, p.prototype.createElement = function(w) {
              var T = new this.Element();
              return T.init(this, w), T;
            }, p.prototype.getRadialAttr = function(w, T) {
              return { cx: w[0] - w[2] / 2 + (T.cx || 0) * w[2], cy: w[1] - w[2] / 2 + (T.cy || 0) * w[2], r: (T.r || 0) * w[2] };
            }, p.prototype.buildText = function(w) {
              new U(w).buildSVG();
            }, p.prototype.getContrast = function(w) {
              return 1.05 / (0.05 + (w = 0.2126 * (w = F.parse(w).rgba.map(function(T) {
                return 0.03928 >= (T /= 255) ? T / 12.92 : Math.pow((T + 0.055) / 1.055, 2.4);
              }))[0] + 0.7152 * w[1] + 0.0722 * w[2])) > (w + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
            }, p.prototype.button = function(w, T, z, W, L, I, j, Z, V, X) {
              L === void 0 && (L = {});
              var et = this.label(w, T, z, V, void 0, void 0, X, void 0, "button"), ot = this.styledMode;
              w = L.states || {};
              var it = 0;
              delete (L = h(L)).states;
              var pt = h({ color: "#333333", cursor: "pointer", fontWeight: "normal" }, L.style);
              delete L.style;
              var mt = G.filterUserAttributes(L);
              if (et.attr(h({ padding: 8, r: 2 }, mt)), !ot) {
                mt = h({ fill: "#f7f7f7", stroke: "#cccccc", "stroke-width": 1 }, mt);
                var Ct = (I = h(mt, { fill: "#e6e6e6" }, G.filterUserAttributes(I || w.hover || {}))).style;
                delete I.style;
                var kt = (j = h(mt, { fill: "#e6ebf5", style: { color: "#000000", fontWeight: "bold" } }, G.filterUserAttributes(j || w.select || {}))).style;
                delete j.style;
                var Lt = (Z = h(mt, { style: { color: "#cccccc" } }, G.filterUserAttributes(Z || w.disabled || {}))).style;
                delete Z.style;
              }
              return S(et.element, m ? "mouseover" : "mouseenter", function() {
                it !== 3 && et.setState(1);
              }), S(et.element, m ? "mouseout" : "mouseleave", function() {
                it !== 3 && et.setState(it);
              }), et.setState = function(Tt) {
                Tt !== 1 && (et.state = it = Tt), et.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][Tt || 0]), ot || (et.attr([mt, I, j, Z][Tt || 0]), c(Tt = [pt, Ct, kt, Lt][Tt || 0]) && et.css(Tt));
              }, ot || (et.attr(mt).css(n({ cursor: "default" }, pt)), X && et.text.css({ pointerEvents: "none" })), et.on("touchstart", function(Tt) {
                return Tt.stopPropagation();
              }).on("click", function(Tt) {
                it !== 3 && W.call(et, Tt);
              });
            }, p.prototype.crispLine = function(w, T, z) {
              z === void 0 && (z = "round");
              var W = w[0], L = w[1];
              return a(W[1]) && W[1] === L[1] && (W[1] = L[1] = Math[z](W[1]) - T % 2 / 2), a(W[2]) && W[2] === L[2] && (W[2] = L[2] = Math[z](W[2]) + T % 2 / 2), w;
            }, p.prototype.path = function(w) {
              var T = this.styledMode ? {} : { fill: "none" };
              return o(w) ? T.d = w : c(w) && n(T, w), this.createElement("path").attr(T);
            }, p.prototype.circle = function(w, T, z) {
              return w = c(w) ? w : w === void 0 ? {} : { x: w, y: T, r: z }, (T = this.createElement("circle")).xSetter = T.ySetter = function(W, L, I) {
                I.setAttribute("c" + L, W);
              }, T.attr(w);
            }, p.prototype.arc = function(w, T, z, W, L, I) {
              return c(w) ? (T = (W = w).y, z = W.r, w = W.x) : W = { innerR: W, start: L, end: I }, (w = this.symbol("arc", w, T, z, z, W)).r = z, w;
            }, p.prototype.rect = function(w, T, z, W, L, I) {
              L = c(w) ? w.r : L;
              var j = this.createElement("rect");
              return w = c(w) ? w : w === void 0 ? {} : { x: w, y: T, width: Math.max(z, 0), height: Math.max(W, 0) }, this.styledMode || (I !== void 0 && (w["stroke-width"] = I, w = j.crisp(w)), w.fill = "none"), L && (w.r = L), j.rSetter = function(Z, V, X) {
                j.r = Z, u(X, { rx: Z, ry: Z });
              }, j.rGetter = function() {
                return j.r || 0;
              }, j.attr(w);
            }, p.prototype.setSize = function(w, T, z) {
              this.width = w, this.height = T, this.boxWrapper.animate({ width: w, height: T }, { step: function() {
                this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
              }, duration: C(z, !0) ? void 0 : 0 }), this.alignElements();
            }, p.prototype.g = function(w) {
              var T = this.createElement("g");
              return w ? T.attr({ class: "highcharts-" + w }) : T;
            }, p.prototype.image = function(w, T, z, W, L, I) {
              var j = { preserveAspectRatio: "none" }, Z = function(X, et) {
                X.setAttributeNS ? X.setAttributeNS("http://www.w3.org/1999/xlink", "href", et) : X.setAttribute("hc-svg-href", et);
              };
              i(T) && (j.x = T), i(z) && (j.y = z), i(W) && (j.width = W), i(L) && (j.height = L);
              var V = this.createElement("image").attr(j);
              return T = function(X) {
                Z(V.element, w), I.call(V, X);
              }, I ? (Z(V.element, "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="), z = new P.Image(), S(z, "load", T), z.src = w, z.complete && T({})) : Z(V.element, w), V;
            }, p.prototype.symbol = function(w, T, z, W, L, I) {
              var j, Z = this, V = /^url\((.*?)\)$/, X = V.test(w), et = !X && (this.symbols[w] ? w : "circle"), ot = et && this.symbols[et];
              if (ot) {
                typeof T == "number" && (j = ot.call(this.symbols, Math.round(T || 0), Math.round(z || 0), W || 0, L || 0, I));
                var it = this.path(j);
                Z.styledMode || it.attr("fill", "none"), n(it, { symbolName: et || void 0, x: T, y: z, width: W, height: L }), I && n(it, I);
              } else if (X) {
                var pt = w.match(V)[1], mt = it = this.image(pt);
                mt.imgwidth = C(E[pt] && E[pt].width, I && I.width), mt.imgheight = C(E[pt] && E[pt].height, I && I.height);
                var Ct = function(kt) {
                  return kt.attr({ width: kt.width, height: kt.height });
                };
                ["width", "height"].forEach(function(kt) {
                  mt[kt + "Setter"] = function(Lt, Tt) {
                    this[Tt] = Lt, Lt = this.alignByTranslate;
                    var xt = this.element, ct = this.width, ft = this.height, St = this.imgwidth, Mt = this.imgheight, Dt = this["img" + Tt];
                    if (a(Dt)) {
                      var Ot = 1;
                      I && I.backgroundSize === "within" && ct && ft ? (Ot = Math.min(ct / St, ft / Mt), Dt = Math.round(Dt * Ot), u(xt, { width: Math.round(St * Ot), height: Math.round(Mt * Ot) })) : xt && xt.setAttribute(Tt, Dt), Lt || this.translate(((ct || 0) - Dt * Ot) / 2, ((ft || 0) - Dt * Ot) / 2);
                    }
                  };
                }), a(T) && mt.attr({ x: T, y: z }), mt.isImg = !0, a(mt.imgwidth) && a(mt.imgheight) ? Ct(mt) : (mt.attr({ width: 0, height: 0 }), y("img", { onload: function() {
                  var kt = k[Z.chartIndex];
                  this.width === 0 && (s(this, { position: "absolute", top: "-999em" }), b.body.appendChild(this)), E[pt] = { width: this.width, height: this.height }, mt.imgwidth = this.width, mt.imgheight = this.height, mt.element && Ct(mt), this.parentNode && this.parentNode.removeChild(this), Z.imgCount--, Z.imgCount || !kt || kt.hasLoaded || kt.onload();
                }, src: pt }), this.imgCount++);
              }
              return it;
            }, p.prototype.clipRect = function(w, T, z, W) {
              var L = O() + "-", I = this.createElement("clipPath").attr({ id: L }).add(this.defs);
              return (w = this.rect(w, T, z, W, 0).add(I)).id = L, w.clipPath = I, w.count = 0, w;
            }, p.prototype.text = function(w, T, z, W) {
              var L = {};
              return !W || !this.allowHTML && this.forExport ? (L.x = Math.round(T || 0), z && (L.y = Math.round(z)), a(w) && (L.text = w), w = this.createElement("text").attr(L), (!W || this.forExport && !this.allowHTML) && (w.xSetter = function(I, j, Z) {
                for (var V, X = Z.getElementsByTagName("tspan"), et = Z.getAttribute(j), ot = 0; ot < X.length; ot++)
                  (V = X[ot]).getAttribute(j) === et && V.setAttribute(j, I);
                Z.setAttribute(j, I);
              }), w) : this.html(w, T, z);
            }, p.prototype.fontMetrics = function(w, T) {
              return w = !this.styledMode && /px/.test(w) || !P.getComputedStyle ? w || T && T.style && T.style.fontSize || this.style && this.style.fontSize : T && J.prototype.getStyle.call(T, "font-size"), { h: T = 24 > (w = /px/.test(w) ? M(w) : 12) ? w + 3 : Math.round(1.2 * w), b: Math.round(0.8 * T), f: w };
            }, p.prototype.rotCorr = function(w, T, z) {
              var W = w;
              return T && z && (W = Math.max(W * Math.cos(T * A), 4)), { x: -w / 3 * Math.sin(T * A), y: W };
            }, p.prototype.pathToSegments = function(w) {
              for (var T = [], z = [], W = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 }, L = 0; L < w.length; L++)
                l(z[0]) && i(w[L]) && z.length === W[z[0].toUpperCase()] && w.splice(L, 0, z[0].replace("M", "L").replace("m", "l")), typeof w[L] == "string" && (z.length && T.push(z.slice(0)), z.length = 0), z.push(w[L]);
              return T.push(z.slice(0)), T;
            }, p.prototype.label = function(w, T, z, W, L, I, j, Z, V) {
              return new Q(this, w, T, z, W, L, I, j, Z, V);
            }, p.prototype.alignElements = function() {
              this.alignedObjects.forEach(function(w) {
                return w.align();
              });
            }, p;
          }(), n($.prototype, { Element: J, SVG_NS: x, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: q, draw: g }), Y.registerRendererType("svg", $, !0), $;
        }), _(at, "Core/Renderer/HTML/HTMLElement.js", [at["Core/Globals.js"], at["Core/Renderer/SVG/SVGElement.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = this && this.__extends || /* @__PURE__ */ function() {
            var d = function(m, v) {
              return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, x) {
                g.__proto__ = x;
              } || function(g, x) {
                for (var E in x)
                  x.hasOwnProperty(E) && (g[E] = x[E]);
              }, d(m, v);
            };
            return function(m, v) {
              function g() {
                this.constructor = m;
              }
              d(m, v), m.prototype = v === null ? Object.create(v) : (g.prototype = v.prototype, new g());
            };
          }(), J = G.isFirefox, Q = G.isMS, q = G.isWebKit, U = G.win, N = $.css, D = $.defined, k = $.extend, A = $.pick, b = $.pInt;
          return function(d) {
            function m() {
              return d !== null && d.apply(this, arguments) || this;
            }
            return Y(m, d), m.compose = function(v) {
              if (m.composedClasses.indexOf(v) === -1) {
                m.composedClasses.push(v);
                var g = m.prototype, x = v.prototype;
                x.getSpanCorrection = g.getSpanCorrection, x.htmlCss = g.htmlCss, x.htmlGetBBox = g.htmlGetBBox, x.htmlUpdateTransform = g.htmlUpdateTransform, x.setSpanRotation = g.setSpanRotation;
              }
              return v;
            }, m.prototype.getSpanCorrection = function(v, g, x) {
              this.xCorr = -v * x, this.yCorr = -g;
            }, m.prototype.htmlCss = function(v) {
              var g = this.element.tagName === "SPAN" && v && "width" in v, x = A(g && v.width, void 0);
              if (g) {
                delete v.width, this.textWidth = x;
                var E = !0;
              }
              return v && v.textOverflow === "ellipsis" && (v.whiteSpace = "nowrap", v.overflow = "hidden"), this.styles = k(this.styles, v), N(this.element, v), E && this.htmlUpdateTransform(), this;
            }, m.prototype.htmlGetBBox = function() {
              var v = this.element;
              return { x: v.offsetLeft, y: v.offsetTop, width: v.offsetWidth, height: v.offsetHeight };
            }, m.prototype.htmlUpdateTransform = function() {
              if (this.added) {
                var v = this.renderer, g = this.element, x = this.translateX || 0, E = this.translateY || 0, P = this.x || 0, S = this.y || 0, u = this.textAlign || "left", y = { left: 0, center: 0.5, right: 1 }[u], s = this.styles;
                if (s = s && s.whiteSpace, N(g, { marginLeft: x, marginTop: E }), !v.styledMode && this.shadows && this.shadows.forEach(function(c) {
                  N(c, { marginLeft: x + 1, marginTop: E + 1 });
                }), this.inverted && [].forEach.call(g.childNodes, function(c) {
                  v.invertChild(c, g);
                }), g.tagName === "SPAN") {
                  var a = this.rotation, e = this.textWidth && b(this.textWidth), n = [a, u, g.innerHTML, this.textWidth, this.textAlign].join(), o = void 0;
                  if (o = !1, e !== this.oldTextWidth) {
                    if (this.textPxLength)
                      var i = this.textPxLength;
                    else
                      N(g, { width: "", whiteSpace: s || "nowrap" }), i = g.offsetWidth;
                    (e > this.oldTextWidth || i > e) && (/[ \-]/.test(g.textContent || g.innerText) || g.style.textOverflow === "ellipsis") && (N(g, { width: i > e || a ? e + "px" : "auto", display: "block", whiteSpace: s || "normal" }), this.oldTextWidth = e, o = !0);
                  }
                  this.hasBoxWidthChanged = o, n !== this.cTT && (o = v.fontMetrics(g.style.fontSize, g).b, !D(a) || a === (this.oldRotation || 0) && u === this.oldAlign || this.setSpanRotation(a, y, o), this.getSpanCorrection(!D(a) && this.textPxLength || g.offsetWidth, o, y, a, u)), N(g, { left: P + (this.xCorr || 0) + "px", top: S + (this.yCorr || 0) + "px" }), this.cTT = n, this.oldRotation = a, this.oldAlign = u;
                }
              } else
                this.alignOnAdd = !0;
            }, m.prototype.setSpanRotation = function(v, g, x) {
              var E = {}, P = Q && !/Edge/.test(U.navigator.userAgent) ? "-ms-transform" : q ? "-webkit-transform" : J ? "MozTransform" : U.opera ? "-o-transform" : void 0;
              P && (E[P] = E.transform = "rotate(" + v + "deg)", E[P + (J ? "Origin" : "-origin")] = E.transformOrigin = 100 * g + "% " + x + "px", N(this.element, E));
            }, m.composedClasses = [], m;
          }(F);
        }), _(at, "Core/Renderer/HTML/HTMLRenderer.js", [at["Core/Renderer/HTML/AST.js"], at["Core/Renderer/SVG/SVGElement.js"], at["Core/Renderer/SVG/SVGRenderer.js"], at["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = this && this.__extends || /* @__PURE__ */ function() {
            var D = function(k, A) {
              return D = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
                b.__proto__ = d;
              } || function(b, d) {
                for (var m in d)
                  d.hasOwnProperty(m) && (b[m] = d[m]);
              }, D(k, A);
            };
            return function(k, A) {
              function b() {
                this.constructor = k;
              }
              D(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
            };
          }(), Q = Y.attr, q = Y.createElement, U = Y.extend, N = Y.pick;
          return function(D) {
            function k() {
              return D !== null && D.apply(this, arguments) || this;
            }
            return J(k, D), k.compose = function(A) {
              return k.composedClasses.indexOf(A) === -1 && (k.composedClasses.push(A), A.prototype.html = k.prototype.html), A;
            }, k.prototype.html = function(A, b, d) {
              var m = this.createElement("span"), v = m.element, g = m.renderer, x = g.isSVG, E = function(P, S) {
                ["opacity", "visibility"].forEach(function(u) {
                  P[u + "Setter"] = function(y, s, a) {
                    var e = P.div ? P.div.style : S;
                    F.prototype[u + "Setter"].call(this, y, s, a), e && (e[s] = y);
                  };
                }), P.addedSetters = !0;
              };
              return m.textSetter = function(P) {
                P !== this.textStr && (delete this.bBox, delete this.oldTextWidth, G.setElementHTML(this.element, N(P, "")), this.textStr = P, m.doTransform = !0);
              }, x && E(m, m.element.style), m.xSetter = m.ySetter = m.alignSetter = m.rotationSetter = function(P, S) {
                S === "align" ? m.alignValue = m.textAlign = P : m[S] = P, m.doTransform = !0;
              }, m.afterSetters = function() {
                this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
              }, m.attr({ text: A, x: Math.round(b), y: Math.round(d) }).css({ position: "absolute" }), g.styledMode || m.css({ fontFamily: this.style.fontFamily, fontSize: this.style.fontSize }), v.style.whiteSpace = "nowrap", m.css = m.htmlCss, x && (m.add = function(P) {
                var S = g.box.parentNode, u = [];
                if (this.parentGroup = P) {
                  var y = P.div;
                  if (!y) {
                    for (; P; )
                      u.push(P), P = P.parentGroup;
                    u.reverse().forEach(function(s) {
                      function a(i, c) {
                        s[c] = i, c === "translateX" ? o.left = i + "px" : o.top = i + "px", s.doTransform = !0;
                      }
                      var e = Q(s.element, "class"), n = s.styles || {}, o = (y = s.div = s.div || q("div", e ? { className: e } : void 0, { position: "absolute", left: (s.translateX || 0) + "px", top: (s.translateY || 0) + "px", display: s.display, opacity: s.opacity, cursor: n.cursor, pointerEvents: n.pointerEvents, visibility: s.visibility }, y || S)).style;
                      U(s, { classSetter: /* @__PURE__ */ function(i) {
                        return function(c) {
                          this.element.setAttribute("class", c), i.className = c;
                        };
                      }(y), on: function() {
                        return u[0].div && m.on.apply({ element: u[0].div, onEvents: s.onEvents }, arguments), s;
                      }, translateXSetter: a, translateYSetter: a }), s.addedSetters || E(s);
                    });
                  }
                } else
                  y = S;
                return y.appendChild(v), m.added = !0, m.alignOnAdd && m.htmlUpdateTransform(), m;
              }), m;
            }, k.composedClasses = [], k;
          }($);
        }), _(at, "Core/Axis/AxisDefaults.js", [], function() {
          var G;
          return function(F) {
            F.defaultXAxisOptions = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e. %b" }, week: { main: "%e. %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotation: void 0, autoRotationLimit: 80, distance: void 0, enabled: !0, indentation: 10, overflow: "justify", padding: 5, reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, x: 0, zIndex: 7, style: { color: "#666666", cursor: "default", fontSize: "11px" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minPadding: 0.01, offset: void 0, opposite: !1, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", rotation: 0, useHTML: !1, x: 0, y: 0, style: { color: "#666666" } }, type: "linear", uniqueNames: !0, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#ccd6eb", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#ccd6eb" }, F.defaultYAxisOptions = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: -8 }, startOnTick: !0, title: { rotation: 270, text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
              return (0, this.axis.chart.numberFormatter)(this.total || 0, -1);
            }, style: { color: "#000000", fontSize: "11px", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, F.defaultLeftAxisOptions = { labels: { x: -15 }, title: { rotation: 270 } }, F.defaultRightAxisOptions = { labels: { x: 15 }, title: { rotation: 90 } }, F.defaultBottomAxisOptions = { labels: { autoRotation: [-45], x: 0 }, margin: 15, title: { rotation: 0 } }, F.defaultTopAxisOptions = { labels: { autoRotation: [-45], x: 0 }, margin: 15, title: { rotation: 0 } };
          }(G || (G = {})), G;
        }), _(at, "Core/Foundation.js", [at["Core/Utilities.js"]], function(G) {
          var F, $ = G.addEvent, Y = G.isFunction, J = G.objectEach, Q = G.removeEvent;
          return function(q) {
            q.registerEventOptions = function(U, N) {
              U.eventOptions = U.eventOptions || {}, J(N.events, function(D, k) {
                U.eventOptions[k] !== D && (U.eventOptions[k] && (Q(U, k, U.eventOptions[k]), delete U.eventOptions[k]), Y(D) && (U.eventOptions[k] = D, $(U, k, D)));
              });
            };
          }(F || (F = {})), F;
        }), _(at, "Core/Axis/Tick.js", [at["Core/FormatUtilities.js"], at["Core/Globals.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = F.deg2rad, J = $.clamp, Q = $.correctFloat, q = $.defined, U = $.destroyObjectProperties, N = $.extend, D = $.fireEvent, k = $.isNumber, A = $.merge, b = $.objectEach, d = $.pick;
          return F = function() {
            function m(v, g, x, E, P) {
              this.isNewLabel = this.isNew = !0, this.axis = v, this.pos = g, this.type = x || "", this.parameters = P || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, D(this, "init"), x || E || this.addLabel();
            }
            return m.prototype.addLabel = function() {
              var v = this, g = v.axis, x = g.options, E = g.chart, P = g.categories, S = g.logarithmic, u = g.names, y = v.pos, s = d(v.options && v.options.labels, x.labels), a = g.tickPositions, e = y === a[0], n = y === a[a.length - 1], o = (!s.step || s.step === 1) && g.tickInterval === 1;
              a = a.info;
              var i, c = v.label;
              if (P = this.parameters.category || (P ? d(P[y], u[y], y) : y), S && k(P) && (P = Q(S.lin2log(P))), g.dateTime)
                if (a)
                  var l = E.time.resolveDTLFormat(x.dateTimeLabelFormats[!x.grid && a.higherRanks[y] || a.unitName]), h = l.main;
                else
                  k(P) && (h = g.dateTime.getXDateFormat(P, x.dateTimeLabelFormats || {}));
              v.isFirst = e, v.isLast = n;
              var C = { axis: g, chart: E, dateTimeLabelFormat: h, isFirst: e, isLast: n, pos: y, tick: v, tickPositionInfo: a, value: P };
              D(this, "labelFormat", C);
              var M = function(p) {
                return s.formatter ? s.formatter.call(p, p) : s.format ? (p.text = g.defaultLabelFormatter.call(p, p), G.format(s.format, p, E)) : g.defaultLabelFormatter.call(p, p);
              };
              x = M.call(C, C);
              var O = l && l.list;
              v.shortenLabel = O ? function() {
                for (i = 0; i < O.length; i++)
                  if (N(C, { dateTimeLabelFormat: O[i] }), c.attr({ text: M.call(C, C) }), c.getBBox().width < g.getSlotWidth(v) - 2 * s.padding)
                    return;
                c.attr({ text: "" });
              } : void 0, o && g._addedPlotLB && v.moveLabel(x, s), q(c) || v.movedLabel ? c && c.textStr !== x && !o && (!c.textWidth || s.style.width || c.styles.width || c.css({ width: null }), c.attr({ text: x }), c.textPxLength = c.getBBox().width) : (v.label = c = v.createLabel({ x: 0, y: 0 }, x, s), v.rotation = 0);
            }, m.prototype.createLabel = function(v, g, x) {
              var E = this.axis, P = E.chart;
              return (v = q(g) && x.enabled ? P.renderer.text(g, v.x, v.y, x.useHTML).add(E.labelGroup) : null) && (P.styledMode || v.css(A(x.style)), v.textPxLength = v.getBBox().width), v;
            }, m.prototype.destroy = function() {
              U(this, this.axis);
            }, m.prototype.getPosition = function(v, g, x, E) {
              var P = this.axis, S = P.chart, u = E && S.oldChartHeight || S.chartHeight;
              return (v = { x: v ? Q(P.translate(g + x, void 0, void 0, E) + P.transB) : P.left + P.offset + (P.opposite ? (E && S.oldChartWidth || S.chartWidth) - P.right - P.left : 0), y: v ? u - P.bottom + P.offset - (P.opposite ? P.height : 0) : Q(u - P.translate(g + x, void 0, void 0, E) - P.transB) }).y = J(v.y, -1e5, 1e5), D(this, "afterGetPosition", { pos: v }), v;
            }, m.prototype.getLabelPosition = function(v, g, x, E, P, S, u, y) {
              var s = this.axis, a = s.transA, e = s.isLinked && s.linkedParent ? s.linkedParent.reversed : s.reversed, n = s.staggerLines, o = s.tickRotCorr || { x: 0, y: 0 }, i = E || s.reserveSpaceDefault ? 0 : -s.labelOffset * (s.labelAlign === "center" ? 0.5 : 1), c = {};
              return x = s.side === 0 ? x.rotation ? -8 : -x.getBBox().height : s.side === 2 ? o.y + 8 : Math.cos(x.rotation * Y) * (o.y - x.getBBox(!1, 0).height / 2), q(P.y) && (x = s.side === 0 && s.horiz ? P.y + x : P.y), v = v + P.x + i + o.x - (S && E ? S * a * (e ? -1 : 1) : 0), g = g + x - (S && !E ? S * a * (e ? 1 : -1) : 0), n && (E = u / (y || 1) % n, s.opposite && (E = n - E - 1), g += s.labelOffset / n * E), c.x = v, c.y = Math.round(g), D(this, "afterGetLabelPosition", { pos: c, tickmarkOffset: S, index: u }), c;
            }, m.prototype.getLabelSize = function() {
              return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }, m.prototype.getMarkPath = function(v, g, x, E, P, S) {
              return S.crispLine([["M", v, g], ["L", v + (P ? 0 : -x), g + (P ? x : 0)]], E);
            }, m.prototype.handleOverflow = function(v) {
              var g = this.axis, x = g.options.labels, E = v.x, P = g.chart.chartWidth, S = g.chart.spacing, u = d(g.labelLeft, Math.min(g.pos, S[3]));
              S = d(g.labelRight, Math.max(g.isRadial ? 0 : g.pos + g.len, P - S[1]));
              var y, s = this.label, a = this.rotation, e = { left: 0, center: 0.5, right: 1 }[g.labelAlign || s.attr("align")], n = s.getBBox().width, o = g.getSlotWidth(this), i = {}, c = o, l = 1;
              a || x.overflow !== "justify" ? 0 > a && E - e * n < u ? y = Math.round(E / Math.cos(a * Y) - u) : 0 < a && E + e * n > S && (y = Math.round((P - E) / Math.cos(a * Y))) : (P = E + (1 - e) * n, E - e * n < u ? c = v.x + c * (1 - e) - u : P > S && (c = S - v.x + c * e, l = -1), (c = Math.min(o, c)) < o && g.labelAlign === "center" && (v.x += l * (o - c - e * (o - Math.min(n, c)))), (n > c || g.autoRotation && (s.styles || {}).width) && (y = c)), y && (this.shortenLabel ? this.shortenLabel() : (i.width = Math.floor(y) + "px", (x.style || {}).textOverflow || (i.textOverflow = "ellipsis"), s.css(i)));
            }, m.prototype.moveLabel = function(v, g) {
              var x = this, E = x.label, P = x.axis, S = P.reversed, u = !1;
              if (E && E.textStr === v ? (x.movedLabel = E, u = !0, delete x.label) : b(P.ticks, function(s) {
                u || s.isNew || s === x || !s.label || s.label.textStr !== v || (x.movedLabel = s.label, u = !0, s.labelPos = x.movedLabel.xy, delete s.label);
              }), !u && (x.labelPos || E)) {
                var y = x.labelPos || E.xy;
                E = P.horiz ? S ? 0 : P.width + P.left : y.x, P = P.horiz ? y.y : S ? P.width + P.left : 0, x.movedLabel = x.createLabel({ x: E, y: P }, v, g), x.movedLabel && x.movedLabel.attr({ opacity: 0 });
              }
            }, m.prototype.render = function(v, g, x) {
              var E = this.axis, P = E.horiz, S = this.pos, u = d(this.tickmarkOffset, E.tickmarkOffset);
              u = (S = this.getPosition(P, S, u, g)).x;
              var y = S.y;
              E = P && u === E.pos + E.len || !P && y === E.pos ? -1 : 1, P = d(x, this.label && this.label.newOpacity, 1), x = d(x, 1), this.isActive = !0, this.renderGridLine(g, x, E), this.renderMark(S, x, E), this.renderLabel(S, g, P, v), this.isNew = !1, D(this, "afterRender");
            }, m.prototype.renderGridLine = function(v, g, x) {
              var E = this.axis, P = E.options, S = {}, u = this.pos, y = this.type, s = d(this.tickmarkOffset, E.tickmarkOffset), a = E.chart.renderer, e = this.gridLine, n = P.gridLineWidth, o = P.gridLineColor, i = P.gridLineDashStyle;
              this.type === "minor" && (n = P.minorGridLineWidth, o = P.minorGridLineColor, i = P.minorGridLineDashStyle), e || (E.chart.styledMode || (S.stroke = o, S["stroke-width"] = n || 0, S.dashstyle = i), y || (S.zIndex = 1), v && (g = 0), this.gridLine = e = a.path().attr(S).addClass("highcharts-" + (y ? y + "-" : "") + "grid-line").add(E.gridGroup)), e && (x = E.getPlotLinePath({ value: u + s, lineWidth: e.strokeWidth() * x, force: "pass", old: v, acrossPanes: !1 })) && e[v || this.isNew ? "attr" : "animate"]({ d: x, opacity: g });
            }, m.prototype.renderMark = function(v, g, x) {
              var E = this.axis, P = E.options, S = E.chart.renderer, u = this.type, y = E.tickSize(u ? u + "Tick" : "tick"), s = v.x;
              v = v.y;
              var a = d(P[u !== "minor" ? "tickWidth" : "minorTickWidth"], !u && E.isXAxis ? 1 : 0);
              P = P[u !== "minor" ? "tickColor" : "minorTickColor"];
              var e = this.mark, n = !e;
              y && (E.opposite && (y[0] = -y[0]), e || (this.mark = e = S.path().addClass("highcharts-" + (u ? u + "-" : "") + "tick").add(E.axisGroup), E.chart.styledMode || e.attr({ stroke: P, "stroke-width": a })), e[n ? "attr" : "animate"]({ d: this.getMarkPath(s, v, y[0], e.strokeWidth() * x, E.horiz, S), opacity: g }));
            }, m.prototype.renderLabel = function(v, g, x, E) {
              var P = this.axis, S = P.horiz, u = P.options, y = this.label, s = u.labels, a = s.step;
              P = d(this.tickmarkOffset, P.tickmarkOffset);
              var e = v.x;
              v = v.y;
              var n = !0;
              y && k(e) && (y.xy = v = this.getLabelPosition(e, v, y, S, s, P, E, a), this.isFirst && !this.isLast && !u.showFirstLabel || this.isLast && !this.isFirst && !u.showLastLabel ? n = !1 : !S || s.step || s.rotation || g || x === 0 || this.handleOverflow(v), a && E % a && (n = !1), n && k(v.y) ? (v.opacity = x, y[this.isNewLabel ? "attr" : "animate"](v).show(!0), this.isNewLabel = !1) : (y.hide(), this.isNewLabel = !0));
            }, m.prototype.replaceMovedLabel = function() {
              var v = this.label, g = this.axis, x = g.reversed;
              if (v && !this.isNew) {
                var E = g.horiz ? x ? g.left : g.width + g.left : v.xy.x;
                x = g.horiz ? v.xy.y : x ? g.width + g.top : g.top, v.animate({ x: E, y: x, opacity: 0 }, void 0, v.destroy), delete this.label;
              }
              g.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
            }, m;
          }(), F;
        }), _(at, "Core/Axis/Axis.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Axis/AxisDefaults.js"], at["Core/Color/Color.js"], at["Core/Defaults.js"], at["Core/Foundation.js"], at["Core/Globals.js"], at["Core/Axis/Tick.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N = G.animObject, D = Y.defaultOptions, k = J.registerEventOptions, A = Q.deg2rad, b = U.arrayMax, d = U.arrayMin, m = U.clamp, v = U.correctFloat, g = U.defined, x = U.destroyObjectProperties, E = U.erase, P = U.error, S = U.extend, u = U.fireEvent, y = U.isArray, s = U.isNumber, a = U.isString, e = U.merge, n = U.normalizeTickInterval, o = U.objectEach, i = U.pick, c = U.relativeLength, l = U.removeEvent, h = U.splat, C = U.syncTimeout, M = function(O, p) {
            return n(p, void 0, void 0, i(O.options.allowDecimals, 0.5 > p || O.tickAmount !== void 0), !!O.tickAmount);
          };
          return G = function() {
            function O(p, w) {
              this.zoomEnabled = this.width = this.visible = this.userOptions = this.translationSlope = this.transB = this.transA = this.top = this.ticks = this.tickRotCorr = this.tickPositions = this.tickmarkOffset = this.tickInterval = this.tickAmount = this.side = this.series = this.right = this.positiveValuesOnly = this.pos = this.pointRangePadding = this.pointRange = this.plotLinesAndBandsGroups = this.plotLinesAndBands = this.paddedTicks = this.overlap = this.options = this.offset = this.names = this.minPixelPadding = this.minorTicks = this.minorTickInterval = this.min = this.maxLabelLength = this.max = this.len = this.left = this.labelFormatter = this.labelEdge = this.isLinked = this.height = this.hasVisibleSeries = this.hasNames = this.eventOptions = this.coll = this.closestPointRange = this.chart = this.bottom = this.alternateBands = void 0, this.init(p, w);
            }
            return O.prototype.init = function(p, w) {
              var T = w.isX;
              this.chart = p, this.horiz = p.inverted && !this.isZAxis ? !T : T, this.isXAxis = T, this.coll = this.coll || (T ? "xAxis" : "yAxis"), u(this, "init", { userOptions: w }), this.opposite = i(w.opposite, this.opposite), this.side = i(w.side, this.side, this.horiz ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(w);
              var z = this.options, W = z.labels, L = z.type;
              this.userOptions = w, this.minPixelPadding = 0, this.reversed = i(z.reversed, this.reversed), this.visible = z.visible, this.zoomEnabled = z.zoomEnabled, this.hasNames = L === "category" || z.categories === !0, this.categories = z.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = g(z.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len = 0, this.minRange = this.userMinRange = z.minRange || z.maxZoom, this.range = z.range, this.offset = z.offset || 0, this.min = this.max = null, w = i(z.crosshair, h(p.options.tooltip.crosshairs)[T ? 0 : 1]), this.crosshair = w === !0 ? {} : w, p.axes.indexOf(this) === -1 && (T ? p.axes.splice(p.xAxis.length, 0, this) : p.axes.push(this), p[this.coll].push(this)), this.series = this.series || [], p.inverted && !this.isZAxis && T && this.reversed === void 0 && (this.reversed = !0), this.labelRotation = s(W.rotation) ? W.rotation : void 0, k(this, z), u(this, "afterInit");
            }, O.prototype.setOptions = function(p) {
              this.options = e(F.defaultXAxisOptions, this.coll === "yAxis" && F.defaultYAxisOptions, [F.defaultTopAxisOptions, F.defaultRightAxisOptions, F.defaultBottomAxisOptions, F.defaultLeftAxisOptions][this.side], e(D[this.coll], p)), u(this, "afterSetOptions", { userOptions: p });
            }, O.prototype.defaultLabelFormatter = function(p) {
              var w = this.axis;
              p = this.chart.numberFormatter;
              var T = s(this.value) ? this.value : NaN, z = w.chart.time, W = this.dateTimeLabelFormat, L = D.lang, I = L.numericSymbols;
              L = L.numericSymbolMagnitude || 1e3;
              var j = w.logarithmic ? Math.abs(T) : w.tickInterval, Z = I && I.length;
              if (w.categories)
                var V = "".concat(this.value);
              else if (W)
                V = z.dateFormat(W, T);
              else if (Z && 1e3 <= j)
                for (; Z-- && V === void 0; )
                  j >= (w = Math.pow(L, Z + 1)) && 10 * T % w == 0 && I[Z] !== null && T !== 0 && (V = p(T / w, -1) + I[Z]);
              return V === void 0 && (V = 1e4 <= Math.abs(T) ? p(T, -1) : p(T, -1, void 0, "")), V;
            }, O.prototype.getSeriesExtremes = function() {
              var p, w = this, T = w.chart;
              u(this, "getSeriesExtremes", null, function() {
                w.hasVisibleSeries = !1, w.dataMin = w.dataMax = w.threshold = null, w.softThreshold = !w.isXAxis, w.series.forEach(function(z) {
                  if (z.visible || !T.options.chart.ignoreHiddenSeries) {
                    var W = z.options, L = W.threshold;
                    if (w.hasVisibleSeries = !0, w.positiveValuesOnly && 0 >= L && (L = null), w.isXAxis) {
                      if ((W = z.xData).length) {
                        W = w.logarithmic ? W.filter(w.validatePositiveValue) : W;
                        var I = (p = z.getXExtremes(W)).min, j = p.max;
                        s(I) || I instanceof Date || (W = W.filter(s), I = (p = z.getXExtremes(W)).min, j = p.max), W.length && (w.dataMin = Math.min(i(w.dataMin, I), I), w.dataMax = Math.max(i(w.dataMax, j), j));
                      }
                    } else
                      z = z.applyExtremes(), s(z.dataMin) && (I = z.dataMin, w.dataMin = Math.min(i(w.dataMin, I), I)), s(z.dataMax) && (j = z.dataMax, w.dataMax = Math.max(i(w.dataMax, j), j)), g(L) && (w.threshold = L), (!W.softThreshold || w.positiveValuesOnly) && (w.softThreshold = !1);
                  }
                });
              }), u(this, "afterGetSeriesExtremes");
            }, O.prototype.translate = function(p, w, T, z, W, L) {
              var I = this.linkedParent || this, j = z && I.old ? I.old.min : I.min;
              if (!s(j))
                return NaN;
              var Z = I.minPixelPadding;
              W = (I.isOrdinal || I.brokenAxis && I.brokenAxis.hasBreaks || I.logarithmic && W) && I.lin2val;
              var V = 1, X = 0;
              return (z = z && I.old ? I.old.transA : I.transA) || (z = I.transA), T && (V *= -1, X = I.len), I.reversed && (X -= (V *= -1) * (I.sector || I.len)), w ? (L = (p * V + X - Z) / z + j, W && (L = I.lin2val(L))) : (W && (p = I.val2lin(p)), p = V * (p - j) * z, L = (I.isRadial ? p : v(p)) + X + V * Z + (s(L) ? z * L : 0)), L;
            }, O.prototype.toPixels = function(p, w) {
              return this.translate(p, !1, !this.horiz, void 0, !0) + (w ? 0 : this.pos);
            }, O.prototype.toValue = function(p, w) {
              return this.translate(p - (w ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }, O.prototype.getPlotLinePath = function(p) {
              function w(Tt, xt, ct) {
                return Lt !== "pass" && (Tt < xt || Tt > ct) && (Lt ? Tt = m(Tt, xt, ct) : I = !0), Tt;
              }
              var T, z, W, L, I, j = this, Z = j.chart, V = j.left, X = j.top, et = p.old, ot = p.value, it = p.lineWidth, pt = et && Z.oldChartHeight || Z.chartHeight, mt = et && Z.oldChartWidth || Z.chartWidth, Ct = j.transB, kt = p.translatedValue, Lt = p.force;
              return p = { value: ot, lineWidth: it, old: et, force: Lt, acrossPanes: p.acrossPanes, translatedValue: kt }, u(this, "getPlotLinePath", p, function(Tt) {
                kt = i(kt, j.translate(ot, void 0, void 0, et)), kt = m(kt, -1e5, 1e5), T = W = Math.round(kt + Ct), z = L = Math.round(pt - kt - Ct), s(kt) ? j.horiz ? (z = X, L = pt - j.bottom, T = W = w(T, V, V + j.width)) : (T = V, W = mt - j.right, z = L = w(z, X, X + j.height)) : (I = !0, Lt = !1), Tt.path = I && !Lt ? null : Z.renderer.crispLine([["M", T, z], ["L", W, L]], it || 1);
              }), p.path;
            }, O.prototype.getLinearTickPositions = function(p, w, T) {
              var z = v(Math.floor(w / p) * p);
              T = v(Math.ceil(T / p) * p);
              var W, L = [];
              if (v(z + p) === z && (W = 20), this.single)
                return [w];
              for (w = z; w <= T && (L.push(w), (w = v(w + p, W)) !== I); )
                var I = w;
              return L;
            }, O.prototype.getMinorTickInterval = function() {
              var p = this.options;
              return p.minorTicks === !0 ? i(p.minorTickInterval, "auto") : p.minorTicks === !1 ? null : p.minorTickInterval;
            }, O.prototype.getMinorTickPositions = function() {
              var p = this.options, w = this.tickPositions, T = this.minorTickInterval, z = this.pointRangePadding || 0, W = this.min - z, L = (z = this.max + z) - W, I = [];
              if (L && L / T < this.len / 3) {
                var j = this.logarithmic;
                if (j)
                  this.paddedTicks.forEach(function(Z, V, X) {
                    V && I.push.apply(I, j.getLogTickPositions(T, X[V - 1], X[V], !0));
                  });
                else if (this.dateTime && this.getMinorTickInterval() === "auto")
                  I = I.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(T), W, z, p.startOfWeek));
                else
                  for (p = W + (w[0] - W) % T; p <= z && p !== I[0]; p += T)
                    I.push(p);
              }
              return I.length !== 0 && this.trimTicks(I), I;
            }, O.prototype.adjustForMinRange = function() {
              var p, w, T, z, W = this.options, L = this.logarithmic, I = this.min, j = this.max, Z = 0;
              if (this.isXAxis && this.minRange === void 0 && !L && (g(W.min) || g(W.max) || g(W.floor) || g(W.ceiling) ? this.minRange = null : (this.series.forEach(function(ot) {
                if (T = ot.xData, z = ot.xIncrement ? 1 : T.length - 1, 1 < T.length)
                  for (p = z; 0 < p; p--)
                    w = T[p] - T[p - 1], (!Z || w < Z) && (Z = w);
              }), this.minRange = Math.min(5 * Z, this.dataMax - this.dataMin))), j - I < this.minRange) {
                var V = this.dataMax - this.dataMin >= this.minRange, X = this.minRange, et = (X - j + I) / 2;
                et = [I - et, i(W.min, I - et)], V && (et[2] = this.logarithmic ? this.logarithmic.log2lin(this.dataMin) : this.dataMin), j = [(I = b(et)) + X, i(W.max, I + X)], V && (j[2] = L ? L.log2lin(this.dataMax) : this.dataMax), (j = d(j)) - I < X && (et[0] = j - X, et[1] = i(W.min, j - X), I = b(et));
              }
              this.min = I, this.max = j;
            }, O.prototype.getClosest = function() {
              var p;
              return this.categories ? p = 1 : this.series.forEach(function(w) {
                var T = w.closestPointRange, z = w.visible || !w.chart.options.chart.ignoreHiddenSeries;
                !w.noSharedTooltip && g(T) && z && (p = g(p) ? Math.min(p, T) : T);
              }), p;
            }, O.prototype.nameToX = function(p) {
              var w = y(this.options.categories), T = w ? this.categories : this.names, z = p.options.x;
              if (p.series.requireSorting = !1, g(z) || (z = this.options.uniqueNames && T ? w ? T.indexOf(p.name) : i(T.keys[p.name], -1) : p.series.autoIncrement()), z === -1) {
                if (!w && T)
                  var W = T.length;
              } else
                W = z;
              return W !== void 0 ? (this.names[W] = p.name, this.names.keys[p.name] = W) : p.x && (W = p.x), W;
            }, O.prototype.updateNames = function() {
              var p = this, w = this.names;
              0 < w.length && (Object.keys(w.keys).forEach(function(T) {
                delete w.keys[T];
              }), w.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function(T) {
                T.xIncrement = null, T.points && !T.isDirtyData || (p.max = Math.max(p.max, T.xData.length - 1), T.processData(), T.generatePoints()), T.data.forEach(function(z, W) {
                  if (z && z.options && z.name !== void 0) {
                    var L = p.nameToX(z);
                    L !== void 0 && L !== z.x && (z.x = L, T.xData[W] = L);
                  }
                });
              }));
            }, O.prototype.setAxisTranslation = function() {
              var p = this, w = p.max - p.min, T = p.linkedParent, z = !!p.categories, W = p.isXAxis, L = p.axisPointRange || 0, I = 0, j = 0, Z = p.transA;
              if (W || z || L) {
                var V = p.getClosest();
                T ? (I = T.minPointOffset, j = T.pointRangePadding) : p.series.forEach(function(X) {
                  var et = z ? 1 : W ? i(X.options.pointRange, V, 0) : p.axisPointRange || 0, ot = X.options.pointPlacement;
                  L = Math.max(L, et), p.single && !z || (X = X.is("xrange") ? !W : W, I = Math.max(I, X && a(ot) ? 0 : et / 2), j = Math.max(j, X && ot === "on" ? 0 : et));
                }), T = p.ordinal && p.ordinal.slope && V ? p.ordinal.slope / V : 1, p.minPointOffset = I *= T, p.pointRangePadding = j *= T, p.pointRange = Math.min(L, p.single && z ? 1 : w), W && (p.closestPointRange = V);
              }
              p.translationSlope = p.transA = Z = p.staticScale || p.len / (w + j || 1), p.transB = p.horiz ? p.left : p.bottom, p.minPixelPadding = Z * I, u(this, "afterSetAxisTranslation");
            }, O.prototype.minFromRange = function() {
              return this.max - this.range;
            }, O.prototype.setTickInterval = function(p) {
              var w = this.chart, T = this.logarithmic, z = this.options, W = this.isXAxis, L = this.isLinked, I = z.tickPixelInterval, j = this.categories, Z = this.softThreshold, V = z.maxPadding, X = z.minPadding, et = s(z.tickInterval) && 0 <= z.tickInterval ? z.tickInterval : void 0, ot = s(this.threshold) ? this.threshold : null;
              this.dateTime || j || L || this.getTickAmount();
              var it = i(this.userMin, z.min), pt = i(this.userMax, z.max);
              if (L) {
                this.linkedParent = w[this.coll][z.linkedTo];
                var mt = this.linkedParent.getExtremes();
                this.min = i(mt.min, mt.dataMin), this.max = i(mt.max, mt.dataMax), z.type !== this.linkedParent.options.type && P(11, 1, w);
              } else {
                if (Z && g(ot)) {
                  if (this.dataMin >= ot)
                    mt = ot, X = 0;
                  else if (this.dataMax <= ot) {
                    var Ct = ot;
                    V = 0;
                  }
                }
                this.min = i(it, mt, this.dataMin), this.max = i(pt, Ct, this.dataMax);
              }
              if (T && (this.positiveValuesOnly && !p && 0 >= Math.min(this.min, i(this.dataMin, this.min)) && P(10, 1, w), this.min = v(T.log2lin(this.min), 16), this.max = v(T.log2lin(this.max), 16)), this.range && g(this.max) && (this.userMin = this.min = it = Math.max(this.dataMin, this.minFromRange()), this.userMax = pt = this.max, this.range = null), u(this, "foundExtremes"), this.beforePadding && this.beforePadding(), this.adjustForMinRange(), !(j || this.axisPointRange || this.stacking && this.stacking.usePercentage || L) && g(this.min) && g(this.max) && (w = this.max - this.min) && (!g(it) && X && (this.min -= w * X), !g(pt) && V && (this.max += w * V)), s(this.userMin) || (s(z.softMin) && z.softMin < this.min && (this.min = it = z.softMin), s(z.floor) && (this.min = Math.max(this.min, z.floor))), s(this.userMax) || (s(z.softMax) && z.softMax > this.max && (this.max = pt = z.softMax), s(z.ceiling) && (this.max = Math.min(this.max, z.ceiling))), Z && g(this.dataMin) && (ot = ot || 0, !g(it) && this.min < ot && this.dataMin >= ot ? this.min = this.options.minRange ? Math.min(ot, this.max - this.minRange) : ot : !g(pt) && this.max > ot && this.dataMax <= ot && (this.max = this.options.minRange ? Math.max(ot, this.min + this.minRange) : ot)), s(this.min) && s(this.max) && !this.chart.polar && this.min > this.max && (g(this.options.min) ? this.max = this.min : g(this.options.max) && (this.min = this.max)), this.tickInterval = this.min === this.max || this.min === void 0 || this.max === void 0 ? 1 : L && this.linkedParent && !et && I === this.linkedParent.options.tickPixelInterval ? et = this.linkedParent.tickInterval : i(et, this.tickAmount ? (this.max - this.min) / Math.max(this.tickAmount - 1, 1) : void 0, j ? 1 : (this.max - this.min) * I / Math.max(this.len, I)), W && !p) {
                var kt = this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max);
                this.series.forEach(function(Lt) {
                  Lt.forceCrop = Lt.forceCropping && Lt.forceCropping(), Lt.processData(kt);
                }), u(this, "postProcessData", { hasExtremesChanged: kt });
              }
              this.setAxisTranslation(), u(this, "initialAxisTranslation"), this.pointRange && !et && (this.tickInterval = Math.max(this.pointRange, this.tickInterval)), p = i(z.minTickInterval, this.dateTime && !this.series.some(function(Lt) {
                return Lt.noSharedTooltip;
              }) ? this.closestPointRange : 0), !et && this.tickInterval < p && (this.tickInterval = p), this.dateTime || this.logarithmic || et || (this.tickInterval = M(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
            }, O.prototype.setTickPositions = function() {
              var p, w = this.options, T = w.tickPositions, z = w.tickPositioner, W = this.getMinorTickInterval(), L = this.hasVerticalPanning(), I = this.coll === "colorAxis", j = (I || !L) && w.startOnTick;
              if (L = (I || !L) && w.endOnTick, I = [], this.tickmarkOffset = this.categories && w.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.minorTickInterval = W === "auto" && this.tickInterval ? this.tickInterval / 5 : W, this.single = this.min === this.max && g(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || w.allowDecimals !== !1), T)
                I = T.slice();
              else if (s(this.min) && s(this.max)) {
                if (this.ordinal && this.ordinal.positions || !((this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)))
                  if (this.dateTime)
                    I = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, w.units), this.min, this.max, w.startOfWeek, this.ordinal && this.ordinal.positions, this.closestPointRange, !0);
                  else if (this.logarithmic)
                    I = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                  else
                    for (W = w = this.tickInterval; W <= 2 * w && (I = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && I.length > this.tickAmount); )
                      this.tickInterval = M(this, W *= 1.1);
                else
                  I = [this.min, this.max], P(19, !1, this.chart);
                I.length > this.len && (I = [I[0], I[I.length - 1]])[0] === I[1] && (I.length = 1), z && (this.tickPositions = I, (p = z.apply(this, [this.min, this.max])) && (I = p));
              }
              this.tickPositions = I, this.paddedTicks = I.slice(0), this.trimTicks(I, j, L), !this.isLinked && s(this.min) && s(this.max) && (this.single && 2 > I.length && !this.categories && !this.series.some(function(Z) {
                return Z.is("heatmap") && Z.options.pointPlacement === "between";
              }) && (this.min -= 0.5, this.max += 0.5), T || p || this.adjustTickAmount()), u(this, "afterSetTickPositions");
            }, O.prototype.trimTicks = function(p, w, T) {
              var z = p[0], W = p[p.length - 1], L = !this.isOrdinal && this.minPointOffset || 0;
              if (u(this, "trimTicks"), !this.isLinked) {
                if (w && z !== -1 / 0)
                  this.min = z;
                else
                  for (; this.min - L > p[0]; )
                    p.shift();
                if (T)
                  this.max = W;
                else
                  for (; this.max + L < p[p.length - 1]; )
                    p.pop();
                p.length === 0 && g(z) && !this.options.tickPositions && p.push((W + z) / 2);
              }
            }, O.prototype.alignToOthers = function() {
              var p, w = this, T = [this], z = w.options, W = this.coll === "yAxis" && this.chart.options.chart.alignThresholds, L = [];
              if (w.thresholdAlignment = void 0, (this.chart.options.chart.alignTicks !== !1 && z.alignTicks || W) && z.startOnTick !== !1 && z.endOnTick !== !1 && !w.logarithmic) {
                var I = function(V) {
                  var X = V.options;
                  return [V.horiz ? X.left : X.top, X.width, X.height, X.pane].join();
                }, j = I(this);
                this.chart[this.coll].forEach(function(V) {
                  var X = V.series;
                  X.length && X.some(function(et) {
                    return et.visible;
                  }) && V !== w && I(V) === j && (p = !0, T.push(V));
                });
              }
              if (p && W) {
                T.forEach(function(V) {
                  V = V.getThresholdAlignment(w), s(V) && L.push(V);
                });
                var Z = 1 < L.length ? L.reduce(function(V, X) {
                  return V + X;
                }, 0) / L.length : void 0;
                T.forEach(function(V) {
                  V.thresholdAlignment = Z;
                });
              }
              return p;
            }, O.prototype.getThresholdAlignment = function(p) {
              if ((!s(this.dataMin) || this !== p && this.series.some(function(w) {
                return w.isDirty || w.isDirtyData;
              })) && this.getSeriesExtremes(), s(this.threshold))
                return p = m((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1), this.options.reversed && (p = 1 - p), p;
            }, O.prototype.getTickAmount = function() {
              var p = this.options, w = p.tickPixelInterval, T = p.tickAmount;
              !g(p.tickInterval) && !T && this.len < w && !this.isRadial && !this.logarithmic && p.startOnTick && p.endOnTick && (T = 2), !T && this.alignToOthers() && (T = Math.ceil(this.len / w) + 1), 4 > T && (this.finalTickAmt = T, T = 5), this.tickAmount = T;
            }, O.prototype.adjustTickAmount = function() {
              var p = this, w = p.finalTickAmt, T = p.max, z = p.min, W = p.options, L = p.tickPositions, I = p.tickAmount, j = p.thresholdAlignment, Z = L && L.length, V = i(p.threshold, p.softThreshold ? 0 : null), X = p.tickInterval;
              if (s(j)) {
                var et = 0.5 > j ? Math.ceil(j * (I - 1)) : Math.floor(j * (I - 1));
                W.reversed && (et = I - 1 - et);
              }
              if (p.hasData() && s(z) && s(T)) {
                if (j = function() {
                  p.transA *= (Z - 1) / (I - 1), p.min = W.startOnTick ? L[0] : Math.min(z, L[0]), p.max = W.endOnTick ? L[L.length - 1] : Math.max(T, L[L.length - 1]);
                }, s(et) && s(p.threshold)) {
                  for (; L[et] !== V || L.length !== I || L[0] > z || L[L.length - 1] < T; ) {
                    for (L.length = 0, L.push(p.threshold); L.length < I; )
                      L[et] === void 0 || L[et] > p.threshold ? L.unshift(v(L[0] - X)) : L.push(v(L[L.length - 1] + X));
                    if (X > 8 * p.tickInterval)
                      break;
                    X *= 2;
                  }
                  j();
                } else if (Z < I) {
                  for (; L.length < I; )
                    L.length % 2 || z === V ? L.push(v(L[L.length - 1] + X)) : L.unshift(v(L[0] - X));
                  j();
                }
                if (g(w)) {
                  for (X = V = L.length; X--; )
                    (w === 3 && X % 2 == 1 || 2 >= w && 0 < X && X < V - 1) && L.splice(X, 1);
                  p.finalTickAmt = void 0;
                }
              }
            }, O.prototype.setScale = function() {
              var p = !1, w = !1;
              this.series.forEach(function(z) {
                p = p || z.isDirtyData || z.isDirty, w = w || z.xAxis && z.xAxis.isDirty || !1;
              }), this.setAxisSize();
              var T = this.len !== (this.old && this.old.len);
              T || p || w || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (this.stacking && (this.stacking.resetStacks(), this.stacking.buildStacks()), this.forceRedraw = !1, this.getSeriesExtremes(), this.setTickInterval(), this.isDirty || (this.isDirty = T || this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max))) : this.stacking && this.stacking.cleanStacks(), p && this.panningState && (this.panningState.isDirty = !0), u(this, "afterSetScale");
            }, O.prototype.setExtremes = function(p, w, T, z, W) {
              var L = this, I = L.chart;
              T = i(T, !0), L.series.forEach(function(j) {
                delete j.kdTree;
              }), W = S(W, { min: p, max: w }), u(L, "setExtremes", W, function() {
                L.userMin = p, L.userMax = w, L.eventArgs = W, T && I.redraw(z);
              });
            }, O.prototype.zoom = function(p, w) {
              var T = this, z = this.dataMin, W = this.dataMax, L = this.options, I = Math.min(z, i(L.min, z)), j = Math.max(W, i(L.max, W));
              return u(this, "zoom", p = { newMin: p, newMax: w }, function(Z) {
                var V = Z.newMin, X = Z.newMax;
                V === T.min && X === T.max || (T.allowZoomOutside || (g(z) && (V < I && (V = I), V > j && (V = j)), g(W) && (X < I && (X = I), X > j && (X = j))), T.displayBtn = V !== void 0 || X !== void 0, T.setExtremes(V, X, !1, void 0, { trigger: "zoom" })), Z.zoomed = !0;
              }), p.zoomed;
            }, O.prototype.setAxisSize = function() {
              var p = this.chart, w = this.options, T = w.offsets || [0, 0, 0, 0], z = this.horiz, W = this.width = Math.round(c(i(w.width, p.plotWidth - T[3] + T[1]), p.plotWidth)), L = this.height = Math.round(c(i(w.height, p.plotHeight - T[0] + T[2]), p.plotHeight)), I = this.top = Math.round(c(i(w.top, p.plotTop + T[0]), p.plotHeight, p.plotTop));
              w = this.left = Math.round(c(i(w.left, p.plotLeft + T[3]), p.plotWidth, p.plotLeft)), this.bottom = p.chartHeight - L - I, this.right = p.chartWidth - W - w, this.len = Math.max(z ? W : L, 0), this.pos = z ? w : I;
            }, O.prototype.getExtremes = function() {
              var p = this.logarithmic;
              return { min: p ? v(p.lin2log(this.min)) : this.min, max: p ? v(p.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
            }, O.prototype.getThreshold = function(p) {
              var w = this.logarithmic, T = w ? w.lin2log(this.min) : this.min;
              return w = w ? w.lin2log(this.max) : this.max, p === null || p === -1 / 0 ? p = T : p === 1 / 0 ? p = w : T > p ? p = T : w < p && (p = w), this.translate(p, 0, 1, 0, 1);
            }, O.prototype.autoLabelAlign = function(p) {
              var w = (i(p, 0) - 90 * this.side + 720) % 360;
              return u(this, "autoLabelAlign", p = { align: "center" }, function(T) {
                15 < w && 165 > w ? T.align = "right" : 195 < w && 345 > w && (T.align = "left");
              }), p.align;
            }, O.prototype.tickSize = function(p) {
              var w = this.options, T = i(w[p === "tick" ? "tickWidth" : "minorTickWidth"], p === "tick" && this.isXAxis && !this.categories ? 1 : 0), z = w[p === "tick" ? "tickLength" : "minorTickLength"];
              if (T && z) {
                w[p + "Position"] === "inside" && (z = -z);
                var W = [z, T];
              }
              return u(this, "afterTickSize", p = { tickSize: W }), p.tickSize;
            }, O.prototype.labelMetrics = function() {
              var p = this.tickPositions && this.tickPositions[0] || 0;
              return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize, this.ticks[p] && this.ticks[p].label);
            }, O.prototype.unsquish = function() {
              var p = this.options.labels, w = this.horiz, T = this.tickInterval, z = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / T), W = p.rotation, L = this.labelMetrics(), I = Math.max(this.max - this.min, 0), j = function(Ct) {
                var kt = Ct / (z || 1);
                return (kt = 1 < kt ? Math.ceil(kt) : 1) * T > I && Ct !== 1 / 0 && z !== 1 / 0 && I && (kt = Math.ceil(I / T)), v(kt * T);
              }, Z = T, V = Number.MAX_VALUE;
              if (w) {
                if (!p.staggerLines)
                  if (s(W))
                    var X = [W];
                  else
                    z < p.autoRotationLimit && (X = p.autoRotation);
                if (X)
                  for (var et = w = void 0, ot = 0, it = X; ot < it.length; ot++) {
                    var pt = it[ot];
                    if ((pt === W || pt && -90 <= pt && 90 >= pt) && (et = (w = j(Math.abs(L.h / Math.sin(A * pt)))) + Math.abs(pt / 360)) < V) {
                      V = et;
                      var mt = pt;
                      Z = w;
                    }
                  }
              } else
                Z = j(L.h);
              return this.autoRotation = X, this.labelRotation = i(mt, s(W) ? W : 0), p.step ? T : Z;
            }, O.prototype.getSlotWidth = function(p) {
              var w = this.chart, T = this.horiz, z = this.options.labels, W = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), L = w.margin[3];
              if (p && s(p.slotWidth))
                return p.slotWidth;
              if (T && 2 > z.step)
                return z.rotation ? 0 : (this.staggerLines || 1) * this.len / W;
              if (!T) {
                if ((p = z.style.width) !== void 0)
                  return parseInt(String(p), 10);
                if (L)
                  return L - w.spacing[3];
              }
              return 0.33 * w.chartWidth;
            }, O.prototype.renderUnsquish = function() {
              var p = this.chart, w = p.renderer, T = this.tickPositions, z = this.ticks, W = this.options.labels, L = W.style, I = this.horiz, j = this.getSlotWidth(), Z = Math.max(1, Math.round(j - 2 * W.padding)), V = {}, X = this.labelMetrics(), et = L.textOverflow, ot = 0;
              if (a(W.rotation) || (V.rotation = W.rotation || 0), T.forEach(function(Ct) {
                (Ct = z[Ct]).movedLabel && Ct.replaceMovedLabel(), Ct && Ct.label && Ct.label.textPxLength > ot && (ot = Ct.label.textPxLength);
              }), this.maxLabelLength = ot, this.autoRotation)
                ot > Z && ot > X.h ? V.rotation = this.labelRotation : this.labelRotation = 0;
              else if (j) {
                var it = Z;
                if (!et) {
                  var pt = "clip";
                  for (Z = T.length; !I && Z--; ) {
                    var mt = T[Z];
                    (mt = z[mt].label) && (mt.styles && mt.styles.textOverflow === "ellipsis" ? mt.css({ textOverflow: "clip" }) : mt.textPxLength > j && mt.css({ width: j + "px" }), mt.getBBox().height > this.len / T.length - (X.h - X.f) && (mt.specificTextOverflow = "ellipsis"));
                  }
                }
              }
              V.rotation && (it = ot > 0.5 * p.chartHeight ? 0.33 * p.chartHeight : ot, et || (pt = "ellipsis")), (this.labelAlign = W.align || this.autoLabelAlign(this.labelRotation)) && (V.align = this.labelAlign), T.forEach(function(Ct) {
                var kt = (Ct = z[Ct]) && Ct.label, Lt = L.width, Tt = {};
                kt && (kt.attr(V), Ct.shortenLabel ? Ct.shortenLabel() : it && !Lt && L.whiteSpace !== "nowrap" && (it < kt.textPxLength || kt.element.tagName === "SPAN") ? (Tt.width = it + "px", et || (Tt.textOverflow = kt.specificTextOverflow || pt), kt.css(Tt)) : kt.styles && kt.styles.width && !Tt.width && !Lt && kt.css({ width: null }), delete kt.specificTextOverflow, Ct.rotation = V.rotation);
              }, this), this.tickRotCorr = w.rotCorr(X.b, this.labelRotation || 0, this.side !== 0);
            }, O.prototype.hasData = function() {
              return this.series.some(function(p) {
                return p.hasData();
              }) || this.options.showEmpty && g(this.min) && g(this.max);
            }, O.prototype.addTitle = function(p) {
              var w, T = this.chart.renderer, z = this.horiz, W = this.opposite, L = this.options.title, I = this.chart.styledMode;
              this.axisTitle || ((w = L.textAlign) || (w = (z ? { low: "left", middle: "center", high: "right" } : { low: W ? "right" : "left", middle: "center", high: W ? "left" : "right" })[L.align]), this.axisTitle = T.text(L.text || "", 0, 0, L.useHTML).attr({ zIndex: 7, rotation: L.rotation, align: w }).addClass("highcharts-axis-title"), I || this.axisTitle.css(e(L.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), I || L.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[p ? "show" : "hide"](p);
            }, O.prototype.generateTick = function(p) {
              var w = this.ticks;
              w[p] ? w[p].addLabel() : w[p] = new q(this, p);
            }, O.prototype.getOffset = function() {
              var p = this, w = this, T = w.chart, z = w.horiz, W = w.options, L = w.side, I = w.ticks, j = w.tickPositions, Z = w.coll, V = w.axisParent, X = T.renderer, et = T.inverted && !w.isZAxis ? [1, 0, 3, 2][L] : L, ot = w.hasData(), it = W.title, pt = W.labels, mt = T.axisOffset;
              T = T.clipOffset;
              var Ct, kt = [-1, 1, 1, -1][L], Lt = W.className, Tt = 0, xt = 0, ct = 0;
              if (w.showAxis = Ct = ot || W.showEmpty, w.staggerLines = w.horiz && pt.staggerLines || void 0, !w.axisGroup) {
                var ft = function(Mt, Dt, Ot) {
                  return X.g(Mt).attr({ zIndex: Ot }).addClass("highcharts-".concat(Z.toLowerCase()).concat(Dt, " ") + (p.isRadial ? "highcharts-radial-axis".concat(Dt, " ") : "") + (Lt || "")).add(V);
                };
                w.gridGroup = ft("grid", "-grid", W.gridZIndex), w.axisGroup = ft("axis", "", W.zIndex), w.labelGroup = ft("axis-labels", "-labels", pt.zIndex);
              }
              if (ot || w.isLinked ? (j.forEach(function(Mt) {
                w.generateTick(Mt);
              }), w.renderUnsquish(), w.reserveSpaceDefault = L === 0 || L === 2 || { 1: "left", 3: "right" }[L] === w.labelAlign, i(pt.reserveSpace, w.labelAlign === "center" || null, w.reserveSpaceDefault) && j.forEach(function(Mt) {
                ct = Math.max(I[Mt].getLabelSize(), ct);
              }), w.staggerLines && (ct *= w.staggerLines), w.labelOffset = ct * (w.opposite ? -1 : 1)) : o(I, function(Mt, Dt) {
                Mt.destroy(), delete I[Dt];
              }), it && it.text && it.enabled !== !1 && (w.addTitle(Ct), Ct && it.reserveSpace !== !1)) {
                w.titleOffset = Tt = w.axisTitle.getBBox()[z ? "height" : "width"];
                var St = it.offset;
                xt = g(St) ? 0 : i(it.margin, z ? 5 : 10);
              }
              w.renderLine(), w.offset = kt * i(W.offset, mt[L] ? mt[L] + (W.margin || 0) : 0), w.tickRotCorr = w.tickRotCorr || { x: 0, y: 0 }, it = L === 0 ? -w.labelMetrics().h : L === 2 ? w.tickRotCorr.y : 0, ot = Math.abs(ct) + xt, ct && (ot = ot - it + kt * (z ? i(pt.y, w.tickRotCorr.y + 8 * kt) : pt.x)), w.axisTitleMargin = i(St, ot), w.getMaxLabelDimensions && (w.maxLabelDimensions = w.getMaxLabelDimensions(I, j)), Z !== "colorAxis" && (z = this.tickSize("tick"), mt[L] = Math.max(mt[L], (w.axisTitleMargin || 0) + Tt + kt * w.offset, ot, j && j.length && z ? z[0] + kt * w.offset : 0), W = !w.axisLine || W.offset ? 0 : 2 * Math.floor(w.axisLine.strokeWidth() / 2), T[et] = Math.max(T[et], W)), u(this, "afterGetOffset");
            }, O.prototype.getLinePath = function(p) {
              var w = this.chart, T = this.opposite, z = this.offset, W = this.horiz, L = this.left + (T ? this.width : 0) + z;
              return z = w.chartHeight - this.bottom - (T ? this.height : 0) + z, T && (p *= -1), w.renderer.crispLine([["M", W ? this.left : L, W ? z : this.top], ["L", W ? w.chartWidth - this.right : L, W ? z : w.chartHeight - this.bottom]], p);
            }, O.prototype.renderLine = function() {
              this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
            }, O.prototype.getTitlePosition = function() {
              var p = this.horiz, w = this.left, T = this.top, z = this.len, W = this.options.title, L = p ? w : T, I = this.opposite, j = this.offset, Z = W.x, V = W.y, X = this.axisTitle, et = this.chart.renderer.fontMetrics(W.style.fontSize, X);
              return X = X ? Math.max(X.getBBox(!1, 0).height - et.h - 1, 0) : 0, z = { low: L + (p ? 0 : z), middle: L + z / 2, high: L + (p ? z : 0) }[W.align], w = (p ? T + this.height : w) + (p ? 1 : -1) * (I ? -1 : 1) * (this.axisTitleMargin || 0) + [-X, X, et.f, -X][this.side], p = { x: p ? z + Z : w + (I ? this.width : 0) + j + Z, y: p ? w + V - (I ? this.height : 0) + j : z + V }, u(this, "afterGetTitlePosition", { titlePosition: p }), p;
            }, O.prototype.renderMinorTick = function(p, w) {
              var T = this.minorTicks;
              T[p] || (T[p] = new q(this, p, "minor")), w && T[p].isNew && T[p].render(null, !0), T[p].render(null, !1, 1);
            }, O.prototype.renderTick = function(p, w, T) {
              var z = this.ticks;
              (!this.isLinked || p >= this.min && p <= this.max || this.grid && this.grid.isColumn) && (z[p] || (z[p] = new q(this, p)), T && z[p].isNew && z[p].render(w, !0, -1), z[p].render(w));
            }, O.prototype.render = function() {
              var p, w, T = this, z = T.chart, W = T.logarithmic, L = T.options, I = T.isLinked, j = T.tickPositions, Z = T.axisTitle, V = T.ticks, X = T.minorTicks, et = T.alternateBands, ot = L.stackLabels, it = L.alternateGridColor, pt = T.tickmarkOffset, mt = T.axisLine, Ct = T.showAxis, kt = N(z.renderer.globalAnimation);
              if (T.labelEdge.length = 0, T.overlap = !1, [V, X, et].forEach(function(Tt) {
                o(Tt, function(xt) {
                  xt.isActive = !1;
                });
              }), T.hasData() || I) {
                var Lt = T.chart.hasRendered && T.old && s(T.old.min);
                T.minorTickInterval && !T.categories && T.getMinorTickPositions().forEach(function(Tt) {
                  T.renderMinorTick(Tt, Lt);
                }), j.length && (j.forEach(function(Tt, xt) {
                  T.renderTick(Tt, xt, Lt);
                }), pt && (T.min === 0 || T.single) && (V[-1] || (V[-1] = new q(T, -1, null, !0)), V[-1].render(-1))), it && j.forEach(function(Tt, xt) {
                  w = j[xt + 1] !== void 0 ? j[xt + 1] + pt : T.max - pt, xt % 2 == 0 && Tt < T.max && w <= T.max + (z.polar ? -pt : pt) && (et[Tt] || (et[Tt] = new Q.PlotLineOrBand(T)), p = Tt + pt, et[Tt].options = { from: W ? W.lin2log(p) : p, to: W ? W.lin2log(w) : w, color: it, className: "highcharts-alternate-grid" }, et[Tt].render(), et[Tt].isActive = !0);
                }), T._addedPlotLB || (T._addedPlotLB = !0, (L.plotLines || []).concat(L.plotBands || []).forEach(function(Tt) {
                  T.addPlotBandOrLine(Tt);
                }));
              }
              [V, X, et].forEach(function(Tt) {
                var xt = [], ct = kt.duration;
                o(Tt, function(ft, St) {
                  ft.isActive || (ft.render(St, !1, 0), ft.isActive = !1, xt.push(St));
                }), C(function() {
                  for (var ft = xt.length; ft--; )
                    Tt[xt[ft]] && !Tt[xt[ft]].isActive && (Tt[xt[ft]].destroy(), delete Tt[xt[ft]]);
                }, Tt !== et && z.hasRendered && ct ? ct : 0);
              }), mt && (mt[mt.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(mt.strokeWidth()) }), mt.isPlaced = !0, mt[Ct ? "show" : "hide"](Ct)), Z && Ct && (L = T.getTitlePosition(), Z[Z.isNew ? "attr" : "animate"](L), Z.isNew = !1), ot && ot.enabled && T.stacking && T.stacking.renderStackTotals(), T.old = { len: T.len, max: T.max, min: T.min, transA: T.transA, userMax: T.userMax, userMin: T.userMin }, T.isDirty = !1, u(this, "afterRender");
            }, O.prototype.redraw = function() {
              this.visible && (this.render(), this.plotLinesAndBands.forEach(function(p) {
                p.render();
              })), this.series.forEach(function(p) {
                p.isDirty = !0;
              });
            }, O.prototype.getKeepProps = function() {
              return this.keepProps || O.keepProps;
            }, O.prototype.destroy = function(p) {
              var w = this, T = w.plotLinesAndBands, z = this.eventOptions;
              if (u(this, "destroy", { keepEvents: p }), p || l(w), [w.ticks, w.minorTicks, w.alternateBands].forEach(function(L) {
                x(L);
              }), T)
                for (p = T.length; p--; )
                  T[p].destroy();
              for (var W in "axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(L) {
                w[L] && (w[L] = w[L].destroy());
              }), w.plotLinesAndBandsGroups)
                w.plotLinesAndBandsGroups[W] = w.plotLinesAndBandsGroups[W].destroy();
              o(w, function(L, I) {
                w.getKeepProps().indexOf(I) === -1 && delete w[I];
              }), this.eventOptions = z;
            }, O.prototype.drawCrosshair = function(p, w) {
              var T, z = this.crosshair, W = i(z && z.snap, !0), L = this.chart, I = this.cross;
              if (u(this, "drawCrosshair", { e: p, point: w }), p || (p = this.cross && this.cross.e), z && (g(w) || !W) !== !1) {
                if (W ? g(w) && (T = i(this.coll !== "colorAxis" ? w.crosshairPos : null, this.isXAxis ? w.plotX : this.len - w.plotY)) : T = p && (this.horiz ? p.chartX - this.pos : this.len - p.chartY + this.pos), g(T)) {
                  var j = { value: w && (this.isXAxis ? w.x : i(w.stackY, w.y)), translatedValue: T };
                  L.polar && S(j, { isCrosshair: !0, chartX: p && p.chartX, chartY: p && p.chartY, point: w }), j = this.getPlotLinePath(j) || null;
                }
                if (!g(j))
                  return void this.hideCrosshair();
                W = this.categories && !this.isRadial, I || (this.cross = I = L.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (W ? "category " : "thin ") + (z.className || "")).attr({ zIndex: i(z.zIndex, 2) }).add(), L.styledMode || (I.attr({ stroke: z.color || (W ? $.parse("#ccd6eb").setOpacity(0.25).get() : "#cccccc"), "stroke-width": i(z.width, 1) }).css({ "pointer-events": "none" }), z.dashStyle && I.attr({ dashstyle: z.dashStyle }))), I.show().attr({ d: j }), W && !z.width && I.attr({ "stroke-width": this.transA }), this.cross.e = p;
              } else
                this.hideCrosshair();
              u(this, "afterDrawCrosshair", { e: p, point: w });
            }, O.prototype.hideCrosshair = function() {
              this.cross && this.cross.hide(), u(this, "afterHideCrosshair");
            }, O.prototype.hasVerticalPanning = function() {
              var p = this.chart.options.chart.panning;
              return !!(p && p.enabled && /y/.test(p.type));
            }, O.prototype.validatePositiveValue = function(p) {
              return s(p) && 0 < p;
            }, O.prototype.update = function(p, w) {
              var T = this.chart;
              p = e(this.userOptions, p), this.destroy(!0), this.init(T, p), T.isDirtyBox = !0, i(w, !0) && T.redraw();
            }, O.prototype.remove = function(p) {
              for (var w = this.chart, T = this.coll, z = this.series, W = z.length; W--; )
                z[W] && z[W].remove(!1);
              E(w.axes, this), E(w[T], this), w[T].forEach(function(L, I) {
                L.options.index = L.userOptions.index = I;
              }), this.destroy(), w.isDirtyBox = !0, i(p, !0) && w.redraw();
            }, O.prototype.setTitle = function(p, w) {
              this.update({ title: p }, w);
            }, O.prototype.setCategories = function(p, w) {
              this.update({ categories: p }, w);
            }, O.defaultOptions = F.defaultXAxisOptions, O.keepProps = "extKey hcEvents names series userMax userMin".split(" "), O;
          }(), G;
        }), _(at, "Core/Axis/DateTimeAxis.js", [at["Core/Utilities.js"]], function(G) {
          var F, $ = G.addEvent, Y = G.getMagnitude, J = G.normalizeTickInterval, Q = G.timeUnits;
          return function(q) {
            function U() {
              return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function N(A) {
              A.userOptions.type !== "datetime" ? this.dateTime = void 0 : this.dateTime || (this.dateTime = new k(this));
            }
            var D = [];
            q.compose = function(A) {
              return D.indexOf(A) === -1 && (D.push(A), A.keepProps.push("dateTime"), A.prototype.getTimeTicks = U, $(A, "init", N)), A;
            };
            var k = function() {
              function A(b) {
                this.axis = b;
              }
              return A.prototype.normalizeTimeTickInterval = function(b, d) {
                var m = d || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]];
                d = m[m.length - 1];
                var v, g = Q[d[0]], x = d[1];
                for (v = 0; v < m.length && (d = m[v], g = Q[d[0]], x = d[1], !(m[v + 1] && b <= (g * x[x.length - 1] + Q[m[v + 1][0]]) / 2)); v++)
                  ;
                return g === Q.year && b < 5 * g && (x = [1, 2, 5]), { unitRange: g, count: b = J(b / g, x, d[0] === "year" ? Math.max(Y(b / g), 1) : 1), unitName: d[0] };
              }, A.prototype.getXDateFormat = function(b, d) {
                var m = this.axis, v = m.chart.time;
                return m.closestPointRange ? v.getDateFormat(m.closestPointRange, b, m.options.startOfWeek, d) || v.resolveDTLFormat(d.year).main : v.resolveDTLFormat(d.day).main;
              }, A;
            }();
            q.Additions = k;
          }(F || (F = {})), F;
        }), _(at, "Core/Axis/LogarithmicAxis.js", [at["Core/Utilities.js"]], function(G) {
          var F, $ = G.addEvent, Y = G.normalizeTickInterval, J = G.pick;
          return function(Q) {
            function q(k) {
              var A = this.logarithmic;
              k.userOptions.type !== "logarithmic" ? this.logarithmic = void 0 : A || (this.logarithmic = new D(this));
            }
            function U() {
              var k = this.logarithmic;
              k && (this.lin2val = function(A) {
                return k.lin2log(A);
              }, this.val2lin = function(A) {
                return k.log2lin(A);
              });
            }
            var N = [];
            Q.compose = function(k) {
              return N.indexOf(k) === -1 && (N.push(k), k.keepProps.push("logarithmic"), $(k, "init", q), $(k, "afterInit", U)), k;
            };
            var D = function() {
              function k(A) {
                this.axis = A;
              }
              return k.prototype.getLogTickPositions = function(A, b, d, m) {
                var v = this.axis, g = v.len, x = v.options, E = [];
                if (m || (this.minorAutoInterval = void 0), 0.5 <= A)
                  A = Math.round(A), E = v.getLinearTickPositions(A, b, d);
                else if (0.08 <= A) {
                  var P, S = Math.floor(b), u = x = void 0;
                  for (g = 0.3 < A ? [1, 2, 4] : 0.15 < A ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9]; S < d + 1 && !u; S++) {
                    var y = g.length;
                    for (P = 0; P < y && !u; P++) {
                      var s = this.log2lin(this.lin2log(S) * g[P]);
                      s > b && (!m || x <= d) && x !== void 0 && E.push(x), x > d && (u = !0), x = s;
                    }
                  }
                } else
                  b = this.lin2log(b), d = this.lin2log(d), A = m ? v.getMinorTickInterval() : x.tickInterval, A = J(A === "auto" ? null : A, this.minorAutoInterval, x.tickPixelInterval / (m ? 5 : 1) * (d - b) / ((m ? g / v.tickPositions.length : g) || 1)), A = Y(A), E = v.getLinearTickPositions(A, b, d).map(this.log2lin), m || (this.minorAutoInterval = A / 5);
                return m || (v.tickInterval = A), E;
              }, k.prototype.lin2log = function(A) {
                return Math.pow(10, A);
              }, k.prototype.log2lin = function(A) {
                return Math.log(A) / Math.LN10;
              }, k;
            }();
            Q.Additions = D;
          }(F || (F = {})), F;
        }), _(at, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [at["Core/Utilities.js"]], function(G) {
          var F, $ = G.erase, Y = G.extend, J = G.isNumber;
          return function(Q) {
            var q, U = [];
            Q.compose = function(D, k) {
              return q || (q = D), U.indexOf(k) === -1 && (U.push(k), Y(k.prototype, N.prototype)), k;
            };
            var N = function() {
              function D() {
              }
              return D.prototype.getPlotBandPath = function(k, A, b) {
                b === void 0 && (b = this.options);
                var d = this.getPlotLinePath({ value: A, force: !0, acrossPanes: b.acrossPanes }), m = [], v = this.horiz;
                if (A = !J(this.min) || !J(this.max) || k < this.min && A < this.min || k > this.max && A > this.max, k = this.getPlotLinePath({ value: k, force: !0, acrossPanes: b.acrossPanes }), b = 1, k && d) {
                  if (A) {
                    var g = k.toString() === d.toString();
                    b = 0;
                  }
                  for (A = 0; A < k.length; A += 2) {
                    var x = k[A], E = k[A + 1], P = d[A], S = d[A + 1];
                    x[0] !== "M" && x[0] !== "L" || E[0] !== "M" && E[0] !== "L" || P[0] !== "M" && P[0] !== "L" || S[0] !== "M" && S[0] !== "L" || (v && P[1] === x[1] ? (P[1] += b, S[1] += b) : v || P[2] !== x[2] || (P[2] += b, S[2] += b), m.push(["M", x[1], x[2]], ["L", E[1], E[2]], ["L", S[1], S[2]], ["L", P[1], P[2]], ["Z"])), m.isFlat = g;
                  }
                }
                return m;
              }, D.prototype.addPlotBand = function(k) {
                return this.addPlotBandOrLine(k, "plotBands");
              }, D.prototype.addPlotLine = function(k) {
                return this.addPlotBandOrLine(k, "plotLines");
              }, D.prototype.addPlotBandOrLine = function(k, A) {
                var b = this, d = this.userOptions, m = new q(this, k);
                if (this.visible && (m = m.render()), m) {
                  if (this._addedPlotLB || (this._addedPlotLB = !0, (d.plotLines || []).concat(d.plotBands || []).forEach(function(g) {
                    b.addPlotBandOrLine(g);
                  })), A) {
                    var v = d[A] || [];
                    v.push(k), d[A] = v;
                  }
                  this.plotLinesAndBands.push(m);
                }
                return m;
              }, D.prototype.removePlotBandOrLine = function(k) {
                var A = this.plotLinesAndBands, b = this.options, d = this.userOptions;
                if (A) {
                  for (var m = A.length; m--; )
                    A[m].id === k && A[m].destroy();
                  [b.plotLines || [], d.plotLines || [], b.plotBands || [], d.plotBands || []].forEach(function(v) {
                    for (m = v.length; m--; )
                      (v[m] || {}).id === k && $(v, v[m]);
                  });
                }
              }, D.prototype.removePlotBand = function(k) {
                this.removePlotBandOrLine(k);
              }, D.prototype.removePlotLine = function(k) {
                this.removePlotBandOrLine(k);
              }, D;
            }();
          }(F || (F = {})), F;
        }), _(at, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [at["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], at["Core/Utilities.js"]], function(G, F) {
          var $ = F.arrayMax, Y = F.arrayMin, J = F.defined, Q = F.destroyObjectProperties, q = F.erase, U = F.fireEvent, N = F.merge, D = F.objectEach, k = F.pick;
          return F = function() {
            function A(b, d) {
              this.axis = b, d && (this.options = d, this.id = d.id);
            }
            return A.compose = function(b) {
              return G.compose(A, b);
            }, A.prototype.render = function() {
              U(this, "render");
              var b = this, d = b.axis, m = d.horiz, v = d.logarithmic, g = b.options, x = g.color, E = k(g.zIndex, 0), P = g.events, S = {}, u = d.chart.renderer, y = g.label, s = b.label, a = g.to, e = g.from, n = g.value, o = b.svgElem, i = [], c = J(e) && J(a);
              i = J(n);
              var l = !o, h = { class: "highcharts-plot-" + (c ? "band " : "line ") + (g.className || "") }, C = c ? "bands" : "lines";
              if (v && (e = v.log2lin(e), a = v.log2lin(a), n = v.log2lin(n)), d.chart.styledMode || (i ? (h.stroke = x || "#999999", h["stroke-width"] = k(g.width, 1), g.dashStyle && (h.dashstyle = g.dashStyle)) : c && (h.fill = x || "#e6ebf5", g.borderWidth && (h.stroke = g.borderColor, h["stroke-width"] = g.borderWidth))), S.zIndex = E, C += "-" + E, (v = d.plotLinesAndBandsGroups[C]) || (d.plotLinesAndBandsGroups[C] = v = u.g("plot-" + C).attr(S).add()), l && (b.svgElem = o = u.path().attr(h).add(v)), i)
                i = d.getPlotLinePath({ value: n, lineWidth: o.strokeWidth(), acrossPanes: g.acrossPanes });
              else {
                if (!c)
                  return;
                i = d.getPlotBandPath(e, a, g);
              }
              return !b.eventsAdded && P && (D(P, function(M, O) {
                o.on(O, function(p) {
                  P[O].apply(b, [p]);
                });
              }), b.eventsAdded = !0), (l || !o.d) && i && i.length ? o.attr({ d: i }) : o && (i ? (o.show(), o.animate({ d: i })) : o.d && (o.hide(), s && (b.label = s = s.destroy()))), y && (J(y.text) || J(y.formatter)) && i && i.length && 0 < d.width && 0 < d.height && !i.isFlat ? (y = N({ align: m && c && "center", x: m ? !c && 4 : 10, verticalAlign: !m && c && "middle", y: m ? c ? 16 : 10 : c ? 6 : -4, rotation: m && !c && 90 }, y), this.renderLabel(y, i, c, E)) : s && s.hide(), b;
            }, A.prototype.renderLabel = function(b, d, m, v) {
              var g = this.axis, x = g.chart.renderer, E = this.label;
              E || (this.label = E = x.text(this.getLabelText(b), 0, 0, b.useHTML).attr({ align: b.textAlign || b.align, rotation: b.rotation, class: "highcharts-plot-" + (m ? "band" : "line") + "-label " + (b.className || ""), zIndex: v }).add(), g.chart.styledMode || E.css(N({ textOverflow: "ellipsis" }, b.style))), v = d.xBounds || [d[0][1], d[1][1], m ? d[2][1] : d[0][1]], d = d.yBounds || [d[0][2], d[1][2], m ? d[2][2] : d[0][2]], m = Y(v), x = Y(d), E.align(b, !1, { x: m, y: x, width: $(v) - m, height: $(d) - x }), E.alignValue && E.alignValue !== "left" || (b = b.clip ? g.width : g.chart.chartWidth, E.css({ width: (E.rotation === 90 ? g.height - (E.alignAttr.y - g.top) : b - (E.alignAttr.x - g.left)) + "px" })), E.show(!0);
            }, A.prototype.getLabelText = function(b) {
              return J(b.formatter) ? b.formatter.call(this) : b.text;
            }, A.prototype.destroy = function() {
              q(this.axis.plotLinesAndBands, this), delete this.axis, Q(this);
            }, A;
          }(), F;
        }), _(at, "Core/Tooltip.js", [at["Core/FormatUtilities.js"], at["Core/Globals.js"], at["Core/Renderer/RendererUtilities.js"], at["Core/Renderer/RendererRegistry.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = G.format, q = F.doc, U = $.distribute, N = J.clamp, D = J.css, k = J.discardElement, A = J.extend, b = J.fireEvent, d = J.isArray, m = J.isNumber, v = J.isString, g = J.merge, x = J.pick, E = J.splat, P = J.syncTimeout;
          return G = function() {
            function S(u, y) {
              this.allowShared = !0, this.container = void 0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.now = {}, this.options = {}, this.outside = !1, this.chart = u, this.init(u, y);
            }
            return S.prototype.applyFilter = function() {
              var u = this.chart;
              u.renderer.definition({ tagName: "filter", attributes: { id: "drop-shadow-" + u.index, opacity: 0.5 }, children: [{ tagName: "feGaussianBlur", attributes: { in: "SourceAlpha", stdDeviation: 1 } }, { tagName: "feOffset", attributes: { dx: 1, dy: 1 } }, { tagName: "feComponentTransfer", children: [{ tagName: "feFuncA", attributes: { type: "linear", slope: 0.3 } }] }, { tagName: "feMerge", children: [{ tagName: "feMergeNode" }, { tagName: "feMergeNode", attributes: { in: "SourceGraphic" } }] }] });
            }, S.prototype.bodyFormatter = function(u) {
              return u.map(function(y) {
                var s = y.series.tooltipOptions;
                return (s[(y.point.formatPrefix || "point") + "Formatter"] || y.point.tooltipFormatter).call(y.point, s[(y.point.formatPrefix || "point") + "Format"] || "");
              });
            }, S.prototype.cleanSplit = function(u) {
              this.chart.series.forEach(function(y) {
                var s = y && y.tt;
                s && (!s.isActive || u ? y.tt = s.destroy() : s.isActive = !1);
              });
            }, S.prototype.defaultFormatter = function(u) {
              var y = this.points || E(this), s = [u.tooltipFooterHeaderFormatter(y[0])];
              return (s = s.concat(u.bodyFormatter(y))).push(u.tooltipFooterHeaderFormatter(y[0], !0)), s;
            }, S.prototype.destroy = function() {
              this.label && (this.label = this.label.destroy()), this.split && this.tt && (this.cleanSplit(!0), this.tt = this.tt.destroy()), this.renderer && (this.renderer = this.renderer.destroy(), k(this.container)), J.clearTimeout(this.hideTimer), J.clearTimeout(this.tooltipTimeout);
            }, S.prototype.getAnchor = function(u, y) {
              var s = this.chart, a = s.pointer, e = s.inverted, n = s.plotTop;
              if (s = s.plotLeft, (u = E(u))[0].series && u[0].series.yAxis && !u[0].series.yAxis.options.reversedStacks && (u = u.slice().reverse()), this.followPointer && y)
                y.chartX === void 0 && (y = a.normalize(y)), u = [y.chartX - s, y.chartY - n];
              else if (u[0].tooltipPos)
                u = u[0].tooltipPos;
              else {
                var o = 0, i = 0;
                u.forEach(function(c) {
                  (c = c.pos(!0)) && (o += c[0], i += c[1]);
                }), o /= u.length, i /= u.length, this.shared && 1 < u.length && y && (e ? o = y.chartX : i = y.chartY), u = [o - s, i - n];
              }
              return u.map(Math.round);
            }, S.prototype.getClassName = function(u, y, s) {
              var a = u.series, e = a.options;
              return [this.options.className, "highcharts-label", s && "highcharts-tooltip-header", y ? "highcharts-tooltip-box" : "highcharts-tooltip", !s && "highcharts-color-" + x(u.colorIndex, a.colorIndex), e && e.className].filter(v).join(" ");
            }, S.prototype.getLabel = function() {
              var u, y = this, s = this.chart.styledMode, a = this.options, e = this.split && this.allowShared, n = a.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none"), o = this.chart.renderer;
              if (y.label) {
                var i = !y.label.hasClass("highcharts-label");
                (e && !i || !e && i) && y.destroy();
              }
              if (!this.label) {
                if (this.outside) {
                  i = this.chart.options.chart.style;
                  var c = Y.getRendererType();
                  this.container = u = F.doc.createElement("div"), u.className = "highcharts-tooltip-container", D(u, { position: "absolute", top: "1px", pointerEvents: n, zIndex: Math.max(this.options.style.zIndex || 0, (i && i.zIndex || 0) + 3) }), F.doc.body.appendChild(u), this.renderer = o = new c(u, 0, 0, i, void 0, void 0, o.styledMode);
                }
                if (e ? this.label = o.g("tooltip") : (this.label = o.label("", 0, 0, a.shape, void 0, void 0, a.useHTML, void 0, "tooltip").attr({ padding: a.padding, r: a.borderRadius }), s || this.label.attr({ fill: a.backgroundColor, "stroke-width": a.borderWidth }).css(a.style).css({ pointerEvents: n }).shadow(a.shadow)), s && a.shadow && (this.applyFilter(), this.label.attr({ filter: "url(#drop-shadow-" + this.chart.index + ")" })), y.outside && !y.split) {
                  var l = this.label, h = l.xSetter, C = l.ySetter;
                  l.xSetter = function(M) {
                    h.call(l, y.distance), u.style.left = M + "px";
                  }, l.ySetter = function(M) {
                    C.call(l, y.distance), u.style.top = M + "px";
                  };
                }
                this.label.attr({ zIndex: 8 }).add();
              }
              return this.label;
            }, S.prototype.getPosition = function(u, y, s) {
              var a, e = this.chart, n = this.distance, o = {}, i = e.inverted && s.h || 0, c = this.outside, l = c ? q.documentElement.clientWidth - 2 * n : e.chartWidth, h = c ? Math.max(q.body.scrollHeight, q.documentElement.scrollHeight, q.body.offsetHeight, q.documentElement.offsetHeight, q.documentElement.clientHeight) : e.chartHeight, C = e.pointer.getChartPosition(), M = function(I) {
                var j = I === "x";
                return [I, j ? l : h, j ? u : y].concat(c ? [j ? u * C.scaleX : y * C.scaleY, j ? C.left - n + (s.plotX + e.plotLeft) * C.scaleX : C.top - n + (s.plotY + e.plotTop) * C.scaleY, 0, j ? l : h] : [j ? u : y, j ? s.plotX + e.plotLeft : s.plotY + e.plotTop, j ? e.plotLeft : e.plotTop, j ? e.plotLeft + e.plotWidth : e.plotTop + e.plotHeight]);
              }, O = M("y"), p = M("x");
              M = !!s.negative, !e.polar && e.hoverSeries && e.hoverSeries.yAxis && e.hoverSeries.yAxis.reversed && (M = !M);
              var w = !this.followPointer && x(s.ttBelow, !e.inverted === M), T = function(I, j, Z, V, X, et, ot) {
                var it = c ? I === "y" ? n * C.scaleY : n * C.scaleX : n, pt = (Z - V) / 2, mt = V < X - n, Ct = X + n + V < j, kt = X - it - Z + pt;
                if (X = X + it - pt, w && Ct)
                  o[I] = X;
                else if (!w && mt)
                  o[I] = kt;
                else if (mt)
                  o[I] = Math.min(ot - V, 0 > kt - i ? kt : kt - i);
                else {
                  if (!Ct)
                    return !1;
                  o[I] = Math.max(et, X + i + Z > j ? X : X + i);
                }
              }, z = function(I, j, Z, V, X) {
                var et;
                return X < n || X > j - n ? et = !1 : o[I] = X < Z / 2 ? 1 : X > j - V / 2 ? j - V - 2 : X - Z / 2, et;
              }, W = function(I) {
                var j = O;
                O = p, p = j, a = I;
              }, L = function() {
                T.apply(0, O) !== !1 ? z.apply(0, p) !== !1 || a || (W(!0), L()) : a ? o.x = o.y = 0 : (W(!0), L());
              };
              return (e.inverted || 1 < this.len) && W(), L(), o;
            }, S.prototype.hide = function(u) {
              var y = this;
              J.clearTimeout(this.hideTimer), u = x(u, this.options.hideDelay), this.isHidden || (this.hideTimer = P(function() {
                y.getLabel().fadeOut(u && void 0), y.isHidden = !0;
              }, u));
            }, S.prototype.init = function(u, y) {
              this.chart = u, this.options = y, this.crosshairs = [], this.now = { x: 0, y: 0 }, this.isHidden = !0, this.split = y.split && !u.inverted && !u.polar, this.shared = y.shared || this.split, this.outside = x(y.outside, !(!u.scrollablePixelsX && !u.scrollablePixelsY));
            }, S.prototype.shouldStickOnContact = function(u) {
              return !(this.followPointer || !this.options.stickOnContact || u && !this.chart.pointer.inClass(u.target, "highcharts-tooltip"));
            }, S.prototype.move = function(u, y, s, a) {
              var e = this, n = e.now, o = e.options.animation !== !1 && !e.isHidden && (1 < Math.abs(u - n.x) || 1 < Math.abs(y - n.y)), i = e.followPointer || 1 < e.len;
              A(n, { x: o ? (2 * n.x + u) / 3 : u, y: o ? (n.y + y) / 2 : y, anchorX: i ? void 0 : o ? (2 * n.anchorX + s) / 3 : s, anchorY: i ? void 0 : o ? (n.anchorY + a) / 2 : a }), e.getLabel().attr(n), e.drawTracker(), o && (J.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function() {
                e && e.move(u, y, s, a);
              }, 32));
            }, S.prototype.refresh = function(u, y) {
              var s = this.chart, a = this.options, e = s.pointer, n = E(u), o = n[0], i = [], c = a.formatter || this.defaultFormatter, l = this.shared, h = s.styledMode, C = {};
              if (a.enabled && o.series) {
                J.clearTimeout(this.hideTimer), this.allowShared = !(!d(u) && u.series && u.series.noSharedTooltip), this.followPointer = !this.split && o.series.tooltipOptions.followPointer;
                var M = (u = this.getAnchor(u, y))[0], O = u[1];
                if (l && this.allowShared ? (e.applyInactiveState(n), n.forEach(function(T) {
                  T.setState("hover"), i.push(T.getLabelConfig());
                }), (C = { x: o.category, y: o.y }).points = i) : C = o.getLabelConfig(), this.len = i.length, c = c.call(C, this), l = o.series, this.distance = x(l.tooltipOptions.distance, 16), c === !1)
                  this.hide();
                else {
                  if (this.split && this.allowShared)
                    this.renderSplit(c, n);
                  else {
                    var p = M, w = O;
                    if (y && e.isDirectTouch && (p = y.chartX - s.plotLeft, w = y.chartY - s.plotTop), !s.polar && l.options.clip !== !1 && !n.some(function(T) {
                      return e.isDirectTouch || T.series.shouldShowTooltip(p, w);
                    }))
                      return void this.hide();
                    y = this.getLabel(), a.style.width && !h || y.css({ width: s.spacingBox.width + "px" }), y.attr({ text: c && c.join ? c.join("") : c }), y.addClass(this.getClassName(o), !0), h || y.attr({ stroke: a.borderColor || o.color || l.color || "#666666" }), this.updatePosition({ plotX: M, plotY: O, negative: o.negative, ttBelow: o.ttBelow, h: u[2] || 0 });
                  }
                  this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
                }
                b(this, "refresh");
              }
            }, S.prototype.renderSplit = function(u, y) {
              function s(Ct, kt, Lt, Tt, xt) {
                return xt === void 0 && (xt = !0), Lt ? (kt = V ? 0 : it, Ct = N(Ct - Tt / 2, I.left, I.right - Tt - (a.outside ? X : 0))) : (kt -= et, Ct = N(Ct = xt ? Ct - Tt - z : Ct + z, xt ? Ct : I.left, I.right)), { x: Ct, y: kt };
              }
              var a = this, e = a.chart, n = a.chart, o = n.chartWidth, i = n.chartHeight, c = n.plotHeight, l = n.plotLeft, h = n.plotTop, C = n.pointer, M = n.scrollablePixelsY;
              M = M === void 0 ? 0 : M;
              var O = n.scrollablePixelsX, p = n.scrollingContainer, w = (p = p === void 0 ? { scrollLeft: 0, scrollTop: 0 } : p).scrollLeft;
              p = p.scrollTop;
              var T = n.styledMode, z = a.distance, W = a.options, L = a.options.positioner, I = a.outside && typeof O != "number" ? q.documentElement.getBoundingClientRect() : { left: w, right: w + o, top: p, bottom: p + i }, j = a.getLabel(), Z = this.renderer || e.renderer, V = !(!e.xAxis[0] || !e.xAxis[0].opposite), X = (e = C.getChartPosition()).left;
              e = e.top;
              var et = h + p, ot = 0, it = c - M;
              v(u) && (u = [!1, u]), u = u.slice(0, y.length + 1).reduce(function(Ct, kt, Lt) {
                if (kt !== !1 && kt !== "") {
                  var Tt = (Lt = y[Lt - 1] || { isHeader: !0, plotX: y[0].plotX, plotY: c, series: {} }).isHeader, xt = Tt ? a : Lt.series;
                  kt = kt.toString();
                  var ct = xt.tt, ft = Lt.isHeader, St = Lt.series;
                  ct || (ct = { padding: W.padding, r: W.borderRadius }, T || (ct.fill = W.backgroundColor, ct["stroke-width"] = W.borderWidth), ct = Z.label("", 0, 0, W[ft ? "headerShape" : "shape"], void 0, void 0, W.useHTML).addClass(a.getClassName(Lt, !0, ft)).attr(ct).add(j)), ct.isActive = !0, ct.attr({ text: kt }), T || ct.css(W.style).shadow(W.shadow).attr({ stroke: W.borderColor || Lt.color || St.color || "#333333" }), kt = (ft = (xt = xt.tt = ct).getBBox()).width + xt.strokeWidth(), Tt && (ot = ft.height, it += ot, V && (et -= ot)), St = (St = Lt.plotX) === void 0 ? 0 : St, ct = (ct = Lt.plotY) === void 0 ? 0 : ct;
                  var Mt = Lt.series;
                  if (Lt.isHeader) {
                    St = l + St;
                    var Dt = h + c / 2;
                  } else {
                    var Ot = Mt.xAxis, Nt = Mt.yAxis;
                    St = Ot.pos + N(St, -z, Ot.len + z), Mt.shouldShowTooltip(0, Nt.pos - h + ct, { ignoreX: !0 }) && (Dt = Nt.pos + ct);
                  }
                  St = N(St, I.left - z, I.right + z), typeof Dt == "number" ? (ft = ft.height + 1, ct = L ? L.call(a, kt, ft, Lt) : s(St, Dt, Tt, kt), Ct.push({ align: L ? 0 : void 0, anchorX: St, anchorY: Dt, boxWidth: kt, point: Lt, rank: x(ct.rank, Tt ? 1 : 0), size: ft, target: ct.y, tt: xt, x: ct.x })) : xt.isActive = !1;
                }
                return Ct;
              }, []), !L && u.some(function(Ct) {
                var kt = (a.outside ? X : 0) + Ct.anchorX;
                return kt < I.left && kt + Ct.boxWidth < I.right || kt < X - I.left + Ct.boxWidth && I.right - kt > kt;
              }) && (u = u.map(function(Ct) {
                var kt = s(Ct.anchorX, Ct.anchorY, Ct.point.isHeader, Ct.boxWidth, !1);
                return A(Ct, { target: kt.y, x: kt.x });
              })), a.cleanSplit(), U(u, it);
              var pt = X, mt = X;
              u.forEach(function(Ct) {
                var kt = Ct.x, Lt = Ct.boxWidth;
                (Ct = Ct.isHeader) || (a.outside && X + kt < pt && (pt = X + kt), !Ct && a.outside && pt + Lt > mt && (mt = X + kt));
              }), u.forEach(function(Ct) {
                var kt = Ct.x, Lt = Ct.anchorX, Tt = Ct.pos, xt = Ct.point.isHeader;
                if (Tt = { visibility: Tt === void 0 ? "hidden" : "inherit", x: kt, y: (Tt || 0) + et, anchorX: Lt, anchorY: Ct.anchorY }, a.outside && kt < Lt) {
                  var ct = X - pt;
                  0 < ct && (xt || (Tt.x = kt + ct, Tt.anchorX = Lt + ct), xt && (Tt.x = (mt - pt) / 2, Tt.anchorX = Lt + ct));
                }
                Ct.tt.attr(Tt);
              }), u = a.container, M = a.renderer, a.outside && u && M && (n = j.getBBox(), M.setSize(n.width + n.x, n.height + n.y, !1), u.style.left = pt + "px", u.style.top = e + "px");
            }, S.prototype.drawTracker = function() {
              if (this.shouldStickOnContact()) {
                var u = this.chart, y = this.label, s = this.shared ? u.hoverPoints : u.hoverPoint;
                if (y && s) {
                  var a = { x: 0, y: 0, width: 0, height: 0 };
                  s = this.getAnchor(s);
                  var e = y.getBBox();
                  s[0] += u.plotLeft - y.translateX, s[1] += u.plotTop - y.translateY, a.x = Math.min(0, s[0]), a.y = Math.min(0, s[1]), a.width = 0 > s[0] ? Math.max(Math.abs(s[0]), e.width - s[0]) : Math.max(Math.abs(s[0]), e.width), a.height = 0 > s[1] ? Math.max(Math.abs(s[1]), e.height - Math.abs(s[1])) : Math.max(Math.abs(s[1]), e.height), this.tracker ? this.tracker.attr(a) : (this.tracker = y.renderer.rect(a).addClass("highcharts-tracker").add(y), u.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
                }
              } else
                this.tracker && this.tracker.destroy();
            }, S.prototype.styledModeFormat = function(u) {
              return u.replace('style="font-size: 10px"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }, S.prototype.tooltipFooterHeaderFormatter = function(u, y) {
              var s = u.series, a = s.tooltipOptions, e = s.xAxis, n = e && e.dateTime;
              e = { isFooter: y, labelConfig: u };
              var o = a.xDateFormat, i = a[y ? "footerFormat" : "headerFormat"];
              return b(this, "headerFormatter", e, function(c) {
                n && !o && m(u.key) && (o = n.getXDateFormat(u.key, a.dateTimeLabelFormats)), n && o && (u.point && u.point.tooltipDateKeys || ["key"]).forEach(function(l) {
                  i = i.replace("{point." + l + "}", "{point." + l + ":" + o + "}");
                }), s.chart.styledMode && (i = this.styledModeFormat(i)), c.text = Q(i, { point: u, series: s }, this.chart);
              }), e.text;
            }, S.prototype.update = function(u) {
              this.destroy(), g(!0, this.chart.options.tooltip.userOptions, u), this.init(this.chart, g(!0, this.options, u));
            }, S.prototype.updatePosition = function(u) {
              var y = this.chart, s = this.distance, a = this.options, e = y.pointer, n = this.getLabel(), o = e.getChartPosition();
              e = o.left;
              var i = o.top, c = o.scaleX;
              o = o.scaleY;
              var l = (a.positioner || this.getPosition).call(this, n.width, n.height, u), h = (u.plotX || 0) + y.plotLeft;
              u = (u.plotY || 0) + y.plotTop, this.outside && (a.positioner && (l.x += e - s, l.y += i - s), s = a.borderWidth + 2 * s, this.renderer.setSize(n.width + s, n.height + s, !1), c === 1 && o === 1 || (D(this.container, { transform: "scale(".concat(c, ", ").concat(o, ")") }), h *= c, u *= o), h += e - l.x, u += i - l.y), this.move(Math.round(l.x), Math.round(l.y || 0), h, u);
            }, S;
          }(), G;
        }), _(at, "Core/Series/Point.js", [at["Core/Renderer/HTML/AST.js"], at["Core/Animation/AnimationUtilities.js"], at["Core/Defaults.js"], at["Core/FormatUtilities.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = F.animObject, q = $.defaultOptions, U = Y.format, N = J.addEvent, D = J.defined, k = J.erase, A = J.extend, b = J.fireEvent, d = J.getNestedProperty, m = J.isArray, v = J.isFunction, g = J.isNumber, x = J.isObject, E = J.merge, P = J.objectEach, S = J.pick, u = J.syncTimeout, y = J.removeEvent, s = J.uniqueKey;
          return F = function() {
            function a() {
              this.category = void 0, this.formatPrefix = "point", this.id = void 0, this.isNull = !1, this.percentage = this.options = this.name = void 0, this.selected = !1, this.total = this.shapeArgs = this.series = void 0, this.visible = !0, this.x = void 0;
            }
            return a.prototype.animateBeforeDestroy = function() {
              var e = this, n = { x: e.startXPos, opacity: 0 }, o = e.getGraphicalProps();
              o.singular.forEach(function(i) {
                e[i] = e[i].animate(i === "dataLabel" ? { x: e[i].startXPos, y: e[i].startYPos, opacity: 0 } : n);
              }), o.plural.forEach(function(i) {
                e[i].forEach(function(c) {
                  c.element && c.animate(A({ x: e.startXPos }, c.startYPos ? { x: c.startXPos, y: c.startYPos } : {}));
                });
              });
            }, a.prototype.applyOptions = function(e, n) {
              var o = this.series, i = o.options.pointValKey || o.pointValKey;
              return e = a.prototype.optionsToObject.call(this, e), A(this, e), this.options = this.options ? A(this.options, e) : e, e.group && delete this.group, e.dataLabels && delete this.dataLabels, i && (this.y = a.prototype.getNestedProperty.call(this, i)), this.formatPrefix = (this.isNull = this.isValid && !this.isValid()) ? "null" : "point", this.selected && (this.state = "select"), "name" in this && n === void 0 && o.xAxis && o.xAxis.hasNames && (this.x = o.xAxis.nameToX(this)), this.x === void 0 && o ? this.x = n === void 0 ? o.autoIncrement() : n : g(e.x) && o.options.relativeXValue && (this.x = o.autoIncrement(e.x)), this;
            }, a.prototype.destroy = function() {
              function e() {
                for (c in (n.graphic || n.graphics || n.dataLabel || n.dataLabels) && (y(n), n.destroyElements()), n)
                  n[c] = null;
              }
              var n = this, o = n.series, i = o.chart;
              o = o.options.dataSorting;
              var c, l = i.hoverPoints, h = Q(n.series.chart.renderer.globalAnimation);
              n.legendItem && i.legend.destroyItem(n), l && (n.setState(), k(l, n), l.length || (i.hoverPoints = null)), n === i.hoverPoint && n.onMouseOut(), o && o.enabled ? (this.animateBeforeDestroy(), u(e, h.duration)) : e(), i.pointCount--;
            }, a.prototype.destroyElements = function(e) {
              var n = this;
              (e = n.getGraphicalProps(e)).singular.forEach(function(o) {
                n[o] = n[o].destroy();
              }), e.plural.forEach(function(o) {
                n[o].forEach(function(i) {
                  i && i.element && i.destroy();
                }), delete n[o];
              });
            }, a.prototype.firePointEvent = function(e, n, o) {
              var i = this, c = this.series.options;
              (c.point.events[e] || i.options && i.options.events && i.options.events[e]) && i.importEvents(), e === "click" && c.allowPointSelect && (o = function(l) {
                i.select && i.select(null, l.ctrlKey || l.metaKey || l.shiftKey);
              }), b(i, e, n, o);
            }, a.prototype.getClassName = function() {
              return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            }, a.prototype.getGraphicalProps = function(e) {
              var n, o = this, i = [], c = { singular: [], plural: [] };
              for ((e = e || { graphic: 1, dataLabel: 1 }).graphic && i.push("graphic", "shadowGroup"), e.dataLabel && i.push("dataLabel", "dataLabelPath", "dataLabelUpper", "connector"), n = i.length; n--; ) {
                var l = i[n];
                o[l] && c.singular.push(l);
              }
              return ["graphic", "dataLabel", "connector"].forEach(function(h) {
                var C = h + "s";
                e[h] && o[C] && c.plural.push(C);
              }), c;
            }, a.prototype.getLabelConfig = function() {
              return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
            }, a.prototype.getNestedProperty = function(e) {
              if (e)
                return e.indexOf("custom.") === 0 ? d(e, this.options) : this[e];
            }, a.prototype.getZone = function() {
              var e = this.series, n = e.zones;
              e = e.zoneAxis || "y";
              var o, i = 0;
              for (o = n[i]; this[e] >= o.value; )
                o = n[++i];
              return this.nonZonedColor || (this.nonZonedColor = this.color), this.color = o && o.color && !this.options.color ? o.color : this.nonZonedColor, o;
            }, a.prototype.hasNewShapeType = function() {
              return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            }, a.prototype.init = function(e, n, o) {
              return this.series = e, this.applyOptions(n, o), this.id = D(this.id) ? this.id : s(), this.resolveColor(), e.chart.pointCount++, b(this, "afterInit"), this;
            }, a.prototype.isValid = function() {
              return this.x !== null && g(this.y);
            }, a.prototype.optionsToObject = function(e) {
              var n = this.series, o = n.options.keys, i = o || n.pointArrayMap || ["y"], c = i.length, l = {}, h = 0, C = 0;
              if (g(e) || e === null)
                l[i[0]] = e;
              else if (m(e))
                for (!o && e.length > c && ((n = typeof e[0]) == "string" ? l.name = e[0] : n === "number" && (l.x = e[0]), h++); C < c; )
                  o && e[h] === void 0 || (0 < i[C].indexOf(".") ? a.prototype.setNestedProperty(l, e[h], i[C]) : l[i[C]] = e[h]), h++, C++;
              else
                typeof e == "object" && (l = e, e.dataLabels && (n._hasPointLabels = !0), e.marker && (n._hasPointMarkers = !0));
              return l;
            }, a.prototype.pos = function(e, n) {
              n === void 0 && (n = this.plotY);
              var o = this.plotX, i = this.series, c = i.chart, l = i.xAxis;
              i = i.yAxis;
              var h = 0, C = 0;
              if (g(o) && g(n))
                return e && (h = l ? l.pos : c.plotLeft, C = i ? i.pos : c.plotTop), c.inverted && l && i ? [i.len - n + C, l.len - o + h] : [o + h, n + C];
            }, a.prototype.resolveColor = function() {
              var e = this.series, n = e.chart.styledMode, o = e.chart.options.chart.colorCount;
              if (delete this.nonZonedColor, e.options.colorByPoint) {
                if (!n) {
                  var i = (o = e.options.colors || e.chart.options.colors)[e.colorCounter];
                  o = o.length;
                }
                n = e.colorCounter, e.colorCounter++, e.colorCounter === o && (e.colorCounter = 0);
              } else
                n || (i = e.color), n = e.colorIndex;
              this.colorIndex = S(this.options.colorIndex, n), this.color = S(this.options.color, i);
            }, a.prototype.setNestedProperty = function(e, n, o) {
              return o.split(".").reduce(function(i, c, l, h) {
                return i[c] = h.length - 1 === l ? n : x(i[c], !0) ? i[c] : {}, i[c];
              }, e), e;
            }, a.prototype.shouldDraw = function() {
              return !this.isNull;
            }, a.prototype.tooltipFormatter = function(e) {
              var n = this.series, o = n.tooltipOptions, i = S(o.valueDecimals, ""), c = o.valuePrefix || "", l = o.valueSuffix || "";
              return n.chart.styledMode && (e = n.chart.tooltip.styledModeFormat(e)), (n.pointArrayMap || ["y"]).forEach(function(h) {
                h = "{point." + h, (c || l) && (e = e.replace(RegExp(h + "}", "g"), c + h + "}" + l)), e = e.replace(RegExp(h + "}", "g"), h + ":,." + i + "f}");
              }), U(e, { point: this, series: this.series }, n.chart);
            }, a.prototype.update = function(e, n, o, i) {
              function c() {
                h.applyOptions(e);
                var w = M && h.hasMockGraphic;
                w = h.y === null ? !w : w, M && w && (h.graphic = M.destroy(), delete h.hasMockGraphic), x(e, !0) && (M && M.element && e && e.marker && e.marker.symbol !== void 0 && (h.graphic = M.destroy()), e && e.dataLabels && h.dataLabel && (h.dataLabel = h.dataLabel.destroy()), h.connector && (h.connector = h.connector.destroy())), l = h.index, C.updateParallelArrays(h, l), p.data[l] = x(p.data[l], !0) || x(e, !0) ? h.options : S(e, p.data[l]), C.isDirty = C.isDirtyData = !0, !C.fixedBox && C.hasCartesianSeries && (O.isDirtyBox = !0), p.legendType === "point" && (O.isDirtyLegend = !0), n && O.redraw(o);
              }
              var l, h = this, C = h.series, M = h.graphic, O = C.chart, p = C.options;
              n = S(n, !0), i === !1 ? c() : h.firePointEvent("update", { options: e }, c);
            }, a.prototype.remove = function(e, n) {
              this.series.removePoint(this.series.data.indexOf(this), e, n);
            }, a.prototype.select = function(e, n) {
              var o = this, i = o.series, c = i.chart;
              this.selectedStaging = e = S(e, !o.selected), o.firePointEvent(e ? "select" : "unselect", { accumulate: n }, function() {
                o.selected = o.options.selected = e, i.options.data[i.data.indexOf(o)] = o.options, o.setState(e && "select"), n || c.getSelectedPoints().forEach(function(l) {
                  var h = l.series;
                  l.selected && l !== o && (l.selected = l.options.selected = !1, h.options.data[h.data.indexOf(l)] = l.options, l.setState(c.hoverPoints && h.options.inactiveOtherPoints ? "inactive" : ""), l.firePointEvent("unselect"));
                });
              }), delete this.selectedStaging;
            }, a.prototype.onMouseOver = function(e) {
              var n = this.series.chart, o = n.pointer;
              e = e ? o.normalize(e) : o.getChartCoordinatesFromPoint(this, n.inverted), o.runPointActions(e, this);
            }, a.prototype.onMouseOut = function() {
              var e = this.series.chart;
              this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (e.hoverPoints || []).forEach(function(n) {
                n.setState();
              }), e.hoverPoints = e.hoverPoint = null;
            }, a.prototype.importEvents = function() {
              if (!this.hasImportedEvents) {
                var e = this, n = E(e.series.options.point, e.options).events;
                e.events = n, P(n, function(o, i) {
                  v(o) && N(e, i, o);
                }), this.hasImportedEvents = !0;
              }
            }, a.prototype.setState = function(e, n) {
              var o, i = this.series, c = this.state, l = i.options.states[e || "normal"] || {}, h = q.plotOptions[i.type].marker && i.options.marker, C = h && h.enabled === !1, M = h && h.states && h.states[e || "normal"] || {}, O = M.enabled === !1, p = this.marker || {}, w = i.chart, T = h && i.markerAttribs, z = i.halo, W = i.stateMarkerGraphic;
              if (!((e = e || "") === this.state && !n || this.selected && e !== "select" || l.enabled === !1 || e && (O || C && M.enabled === !1) || e && p.states && p.states[e] && p.states[e].enabled === !1)) {
                if (this.state = e, T && (o = i.markerAttribs(this, e)), this.graphic && !this.hasMockGraphic) {
                  if (c && this.graphic.removeClass("highcharts-point-" + c), e && this.graphic.addClass("highcharts-point-" + e), !w.styledMode) {
                    c = i.pointAttribs(this, e);
                    var L = S(w.options.chart.animation, l.animation), I = c.opacity;
                    i.options.inactiveOtherPoints && g(I) && ((this.dataLabels || []).forEach(function(j) {
                      j && !j.hasClass("highcharts-data-label-hidden") && j.animate({ opacity: I }, L);
                    }), this.connector && this.connector.animate({ opacity: I }, L)), this.graphic.animate(c, L);
                  }
                  o && this.graphic.animate(o, S(w.options.chart.animation, M.animation, h.animation)), W && W.hide();
                } else
                  e && M && (h = p.symbol || i.symbol, W && W.currentSymbol !== h && (W = W.destroy()), o && (W ? W[n ? "animate" : "attr"]({ x: o.x, y: o.y }) : h && (i.stateMarkerGraphic = W = w.renderer.symbol(h, o.x, o.y, o.width, o.height).add(i.markerGroup), W.currentSymbol = h)), !w.styledMode && W && this.state !== "inactive" && W.attr(i.pointAttribs(this, e))), W && (W[e && this.isInside ? "show" : "hide"](), W.element.point = this, W.addClass(this.getClassName(), !0));
                l = l.halo, o = (W = this.graphic || W) && W.visibility || "inherit", l && l.size && W && o !== "hidden" && !this.isCluster ? (z || (i.halo = z = w.renderer.path().add(W.parentGroup)), z.show()[n ? "animate" : "attr"]({ d: this.haloPath(l.size) }), z.attr({ class: "highcharts-halo highcharts-color-" + S(this.colorIndex, i.colorIndex) + (this.className ? " " + this.className : ""), visibility: o, zIndex: -1 }), z.point = this, w.styledMode || z.attr(A({ fill: this.color || i.color, "fill-opacity": l.opacity }, G.filterUserAttributes(l.attributes || {})))) : z && z.point && z.point.haloPath && z.animate({ d: z.point.haloPath(0) }, null, z.hide), b(this, "afterSetState", { state: e });
              }
            }, a.prototype.haloPath = function(e) {
              var n = this.pos();
              return n ? this.series.chart.renderer.symbols.circle(Math.floor(n[0]) - e, n[1] - e, 2 * e, 2 * e) : [];
            }, a;
          }(), F;
        }), _(at, "Core/Pointer.js", [at["Core/Color/Color.js"], at["Core/Globals.js"], at["Core/Tooltip.js"], at["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = G.parse, Q = F.charts, q = F.noop, U = Y.addEvent, N = Y.attr, D = Y.css, k = Y.defined, A = Y.extend, b = Y.find, d = Y.fireEvent, m = Y.isNumber, v = Y.isObject, g = Y.objectEach, x = Y.offset, E = Y.pick, P = Y.splat;
          return G = function() {
            function S(u, y) {
              this.lastValidTouch = {}, this.pinchDown = [], this.runChartClick = !1, this.eventsToUnbind = [], this.chart = u, this.hasDragged = !1, this.options = y, this.init(u, y);
            }
            return S.prototype.applyInactiveState = function(u) {
              var y, s = [];
              (u || []).forEach(function(a) {
                y = a.series, s.push(y), y.linkedParent && s.push(y.linkedParent), y.linkedSeries && (s = s.concat(y.linkedSeries)), y.navigatorSeries && s.push(y.navigatorSeries);
              }), this.chart.series.forEach(function(a) {
                s.indexOf(a) === -1 ? a.setState("inactive", !0) : a.options.inactiveOtherPoints && a.setAllPointsToState("inactive");
              });
            }, S.prototype.destroy = function() {
              var u = this;
              this.eventsToUnbind.forEach(function(y) {
                return y();
              }), this.eventsToUnbind = [], F.chartCount || (S.unbindDocumentMouseUp && (S.unbindDocumentMouseUp = S.unbindDocumentMouseUp()), S.unbindDocumentTouchEnd && (S.unbindDocumentTouchEnd = S.unbindDocumentTouchEnd())), clearInterval(u.tooltipTimeout), g(u, function(y, s) {
                u[s] = void 0;
              });
            }, S.prototype.getSelectionMarkerAttrs = function(u, y) {
              var s = this, a = { args: { chartX: u, chartY: y }, attrs: {}, shapeType: "rect" };
              return d(this, "getSelectionMarkerAttrs", a, function(e) {
                var n = s.chart, o = s.mouseDownX;
                o = o === void 0 ? 0 : o;
                var i = s.mouseDownY;
                i = i === void 0 ? 0 : i;
                var c = s.zoomHor, l = s.zoomVert;
                (e = e.attrs).x = n.plotLeft, e.y = n.plotTop, e.width = c ? 1 : n.plotWidth, e.height = l ? 1 : n.plotHeight, c && (n = u - o, e.width = Math.abs(n), e.x = (0 < n ? 0 : n) + o), l && (n = y - i, e.height = Math.abs(n), e.y = (0 < n ? 0 : n) + i);
              }), a;
            }, S.prototype.drag = function(u) {
              var y = this.chart, s = y.options.chart, a = y.plotLeft, e = y.plotTop, n = y.plotWidth, o = y.plotHeight, i = this.mouseDownX || 0, c = this.mouseDownY || 0, l = v(s.panning) ? s.panning && s.panning.enabled : s.panning, h = s.panKey && u[s.panKey + "Key"], C = u.chartX, M = u.chartY, O = this.selectionMarker;
              O && O.touch || (C < a ? C = a : C > a + n && (C = a + n), M < e ? M = e : M > e + o && (M = e + o), this.hasDragged = Math.sqrt(Math.pow(i - C, 2) + Math.pow(c - M, 2)), 10 < this.hasDragged && (a = y.isInsidePlot(i - a, c - e, { visiblePlotOnly: !0 }), C = (M = this.getSelectionMarkerAttrs(C, M)).shapeType, M = M.attrs, !y.hasCartesianSeries && !y.mapView || !this.zoomX && !this.zoomY || !a || h || O || (this.selectionMarker = O = y.renderer[C](), O.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), y.styledMode || O.attr({ fill: s.selectionMarkerFill || J("#335cad").setOpacity(0.25).get() })), O && O.attr(M), a && !O && l && y.pan(u, s.panning)));
            }, S.prototype.dragStart = function(u) {
              var y = this.chart;
              y.mouseIsDown = u.type, y.cancelClick = !1, y.mouseDownX = this.mouseDownX = u.chartX, y.mouseDownY = this.mouseDownY = u.chartY;
            }, S.prototype.getSelectionBox = function(u) {
              var y = { args: { marker: u }, result: {} };
              return d(this, "getSelectionBox", y, function(s) {
                s.result = { x: u.attr ? +u.attr("x") : u.x, y: u.attr ? +u.attr("y") : u.y, width: u.attr ? u.attr("width") : u.width, height: u.attr ? u.attr("height") : u.height };
              }), y.result;
            }, S.prototype.drop = function(u) {
              var y = this, s = this.chart, a = this.hasPinched;
              if (this.selectionMarker) {
                var e = this.getSelectionBox(this.selectionMarker), n = e.x, o = e.y, i = e.width, c = e.height, l = { originalEvent: u, xAxis: [], yAxis: [], x: n, y: o, width: i, height: c }, h = !!s.mapView;
                (this.hasDragged || a) && (s.axes.forEach(function(C) {
                  if (C.zoomEnabled && k(C.min) && (a || y[{ xAxis: "zoomX", yAxis: "zoomY" }[C.coll]]) && m(n) && m(o) && m(i) && m(c)) {
                    var M = C.horiz, O = u.type === "touchend" ? C.minPixelPadding : 0, p = C.toValue((M ? n : o) + O);
                    M = C.toValue((M ? n + i : o + c) - O), l[C.coll].push({ axis: C, min: Math.min(p, M), max: Math.max(p, M) }), h = !0;
                  }
                }), h && d(s, "selection", l, function(C) {
                  s.zoom(A(C, a ? { animation: !1 } : null));
                })), m(s.index) && (this.selectionMarker = this.selectionMarker.destroy()), a && this.scaleGroups();
              }
              s && m(s.index) && (D(s.container, { cursor: s._cursor }), s.cancelClick = 10 < this.hasDragged, s.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
            }, S.prototype.findNearestKDPoint = function(u, y, s) {
              var a;
              return u.forEach(function(e) {
                var n = !(e.noSharedTooltip && y) && 0 > e.options.findNearestPointBy.indexOf("y");
                if (e = e.searchPoint(s, n), (n = v(e, !0) && e.series) && !(n = !v(a, !0))) {
                  n = a.distX - e.distX;
                  var o = a.dist - e.dist, i = (e.series.group && e.series.group.zIndex) - (a.series.group && a.series.group.zIndex);
                  n = 0 < (n !== 0 && y ? n : o !== 0 ? o : i !== 0 ? i : a.series.index > e.series.index ? -1 : 1);
                }
                n && (a = e);
              }), a;
            }, S.prototype.getChartCoordinatesFromPoint = function(u, y) {
              var s = u.series, a = s.xAxis;
              s = s.yAxis;
              var e = u.shapeArgs;
              if (a && s) {
                var n = E(u.clientX, u.plotX), o = u.plotY || 0;
                return u.isNode && e && m(e.x) && m(e.y) && (n = e.x, o = e.y), y ? { chartX: s.len + s.pos - o, chartY: a.len + a.pos - n } : { chartX: n + a.pos, chartY: o + s.pos };
              }
              if (e && e.x && e.y)
                return { chartX: e.x, chartY: e.y };
            }, S.prototype.getChartPosition = function() {
              if (this.chartPosition)
                return this.chartPosition;
              var u = this.chart.container, y = x(u);
              this.chartPosition = { left: y.left, top: y.top, scaleX: 1, scaleY: 1 };
              var s = u.offsetWidth;
              return u = u.offsetHeight, 2 < s && 2 < u && (this.chartPosition.scaleX = y.width / s, this.chartPosition.scaleY = y.height / u), this.chartPosition;
            }, S.prototype.getCoordinates = function(u) {
              var y = { xAxis: [], yAxis: [] };
              return this.chart.axes.forEach(function(s) {
                y[s.isXAxis ? "xAxis" : "yAxis"].push({ axis: s, value: s.toValue(u[s.horiz ? "chartX" : "chartY"]) });
              }), y;
            }, S.prototype.getHoverData = function(u, y, s, a, e, n) {
              var o = [];
              a = !(!a || !u);
              var i = function(C) {
                return C.visible && !(!e && C.directTouch) && E(C.options.enableMouseTracking, !0);
              }, c = { chartX: n ? n.chartX : void 0, chartY: n ? n.chartY : void 0, shared: e };
              d(this, "beforeGetHoverData", c);
              var l = y && !y.stickyTracking ? [y] : s.filter(function(C) {
                return C.stickyTracking && (c.filter || i)(C);
              }), h = a || !n ? u : this.findNearestKDPoint(l, e, n);
              return y = h && h.series, h && (e && !y.noSharedTooltip ? (l = s.filter(function(C) {
                return c.filter ? c.filter(C) : i(C) && !C.noSharedTooltip;
              }), l.forEach(function(C) {
                var M = b(C.points, function(O) {
                  return O.x === h.x && !O.isNull;
                });
                v(M) && (C.boosted && C.boost && (M = C.boost.getPoint(M)), o.push(M));
              })) : o.push(h)), d(this, "afterGetHoverData", c = { hoverPoint: h }), { hoverPoint: c.hoverPoint, hoverSeries: y, hoverPoints: o };
            }, S.prototype.getPointFromEvent = function(u) {
              u = u.target;
              for (var y; u && !y; )
                y = u.point, u = u.parentNode;
              return y;
            }, S.prototype.onTrackerMouseOut = function(u) {
              u = u.relatedTarget || u.toElement;
              var y = this.chart.hoverSeries;
              this.isDirectTouch = !1, !y || !u || y.stickyTracking || this.inClass(u, "highcharts-tooltip") || this.inClass(u, "highcharts-series-" + y.index) && this.inClass(u, "highcharts-tracker") || y.onMouseOut();
            }, S.prototype.inClass = function(u, y) {
              for (var s; u; ) {
                if (s = N(u, "class")) {
                  if (s.indexOf(y) !== -1)
                    return !0;
                  if (s.indexOf("highcharts-container") !== -1)
                    return !1;
                }
                u = u.parentElement;
              }
            }, S.prototype.init = function(u, y) {
              this.options = y, this.chart = u, this.runChartClick = !(!y.chart.events || !y.chart.events.click), this.pinchDown = [], this.lastValidTouch = {}, $ && (u.tooltip = new $(u, y.tooltip)), this.setDOMEvents();
            }, S.prototype.normalize = function(u, y) {
              var s = u.touches, a = s ? s.length ? s.item(0) : E(s.changedTouches, u.changedTouches)[0] : u;
              return y || (y = this.getChartPosition()), s = a.pageX - y.left, a = a.pageY - y.top, s /= y.scaleX, a /= y.scaleY, A(u, { chartX: Math.round(s), chartY: Math.round(a) });
            }, S.prototype.onContainerClick = function(u) {
              var y = this.chart, s = y.hoverPoint;
              u = this.normalize(u);
              var a = y.plotLeft, e = y.plotTop;
              y.cancelClick || (s && this.inClass(u.target, "highcharts-tracker") ? (d(s.series, "click", A(u, { point: s })), y.hoverPoint && s.firePointEvent("click", u)) : (A(u, this.getCoordinates(u)), y.isInsidePlot(u.chartX - a, u.chartY - e, { visiblePlotOnly: !0 }) && d(y, "click", u)));
            }, S.prototype.onContainerMouseDown = function(u) {
              var y = (1 & (u.buttons || u.button)) == 1;
              u = this.normalize(u), F.isFirefox && u.button !== 0 && this.onContainerMouseMove(u), (u.button === void 0 || y) && (this.zoomOption(u), y && u.preventDefault && u.preventDefault(), this.dragStart(u));
            }, S.prototype.onContainerMouseLeave = function(u) {
              var y = Q[E(S.hoverChartIndex, -1)], s = this.chart.tooltip;
              u = this.normalize(u), y && (u.relatedTarget || u.toElement) && (y.pointer.reset(), y.pointer.chartPosition = void 0), s && !s.isHidden && this.reset();
            }, S.prototype.onContainerMouseEnter = function(u) {
              delete this.chartPosition;
            }, S.prototype.onContainerMouseMove = function(u) {
              var y = this.chart, s = y.tooltip;
              u = this.normalize(u), this.setHoverChartIndex(), u.preventDefault || (u.returnValue = !1), (y.mouseIsDown === "mousedown" || this.touchSelect(u)) && this.drag(u), y.openMenu || !this.inClass(u.target, "highcharts-tracker") && !y.isInsidePlot(u.chartX - y.plotLeft, u.chartY - y.plotTop, { visiblePlotOnly: !0 }) || s && s.shouldStickOnContact(u) || (this.inClass(u.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(u));
            }, S.prototype.onDocumentTouchEnd = function(u) {
              var y = Q[E(S.hoverChartIndex, -1)];
              y && y.pointer.drop(u);
            }, S.prototype.onContainerTouchMove = function(u) {
              this.touchSelect(u) ? this.onContainerMouseMove(u) : this.touch(u);
            }, S.prototype.onContainerTouchStart = function(u) {
              this.touchSelect(u) ? this.onContainerMouseDown(u) : (this.zoomOption(u), this.touch(u, !0));
            }, S.prototype.onDocumentMouseMove = function(u) {
              var y = this.chart, s = y.tooltip, a = this.chartPosition;
              u = this.normalize(u, a), !a || y.isInsidePlot(u.chartX - y.plotLeft, u.chartY - y.plotTop, { visiblePlotOnly: !0 }) || s && s.shouldStickOnContact(u) || this.inClass(u.target, "highcharts-tracker") || this.reset();
            }, S.prototype.onDocumentMouseUp = function(u) {
              var y = Q[E(S.hoverChartIndex, -1)];
              y && y.pointer.drop(u);
            }, S.prototype.pinch = function(u) {
              var y = this, s = y.chart, a = y.pinchDown, e = u.touches || [], n = e.length, o = y.lastValidTouch, i = y.hasZoom, c = {}, l = n === 1 && (y.inClass(u.target, "highcharts-tracker") && s.runTrackerClick || y.runChartClick), h = {}, C = y.chart.tooltip;
              C = n === 1 && E(C && C.options.followTouchMove, !0);
              var M = y.selectionMarker;
              1 < n ? y.initiated = !0 : C && (y.initiated = !1), i && y.initiated && !l && u.cancelable !== !1 && u.preventDefault(), [].map.call(e, function(O) {
                return y.normalize(O);
              }), u.type === "touchstart" ? ([].forEach.call(e, function(O, p) {
                a[p] = { chartX: O.chartX, chartY: O.chartY };
              }), o.x = [a[0].chartX, a[1] && a[1].chartX], o.y = [a[0].chartY, a[1] && a[1].chartY], s.axes.forEach(function(O) {
                if (O.zoomEnabled) {
                  var p = s.bounds[O.horiz ? "h" : "v"], w = O.minPixelPadding, T = O.toPixels(Math.min(E(O.options.min, O.dataMin), O.dataMin)), z = O.toPixels(Math.max(E(O.options.max, O.dataMax), O.dataMax)), W = Math.max(T, z);
                  p.min = Math.min(O.pos, Math.min(T, z) - w), p.max = Math.max(O.pos + O.len, W + w);
                }
              }), y.res = !0) : C ? this.runPointActions(y.normalize(u)) : a.length && (d(s, "touchpan", { originalEvent: u }, function() {
                M || (y.selectionMarker = M = A({ destroy: q, touch: !0 }, s.plotBox)), y.pinchTranslate(a, e, c, M, h, o), y.hasPinched = i, y.scaleGroups(c, h);
              }), y.res && (y.res = !1, this.reset(!1, 0)));
            }, S.prototype.pinchTranslate = function(u, y, s, a, e, n) {
              this.zoomHor && this.pinchTranslateDirection(!0, u, y, s, a, e, n), this.zoomVert && this.pinchTranslateDirection(!1, u, y, s, a, e, n);
            }, S.prototype.pinchTranslateDirection = function(u, y, s, a, e, n, o, i) {
              var c = this.chart, l = u ? "x" : "y", h = u ? "X" : "Y", C = "chart" + h, M = u ? "width" : "height", O = c["plot" + (u ? "Left" : "Top")], p = c.inverted, w = c.bounds[u ? "h" : "v"], T = y.length === 1, z = y[0][C], W = !T && y[1][C];
              y = function() {
                typeof V == "number" && 20 < Math.abs(z - W) && (j = i || Math.abs(Z - V) / Math.abs(z - W)), I = (O - Z) / j + z, L = c["plot" + (u ? "Width" : "Height")] / j;
              };
              var L, I, j = i || 1, Z = s[0][C], V = !T && s[1][C];
              if (y(), (s = I) < w.min) {
                s = w.min;
                var X = !0;
              } else
                s + L > w.max && (s = w.max - L, X = !0);
              X ? (Z -= 0.8 * (Z - o[l][0]), typeof V == "number" && (V -= 0.8 * (V - o[l][1])), y()) : o[l] = [Z, V], p || (n[l] = I - O, n[M] = L), n = p ? 1 / j : j, e[M] = L, e[l] = s, a[p ? u ? "scaleY" : "scaleX" : "scale" + h] = j, a["translate" + h] = n * O + (Z - n * z);
            }, S.prototype.reset = function(u, y) {
              var s = this.chart, a = s.hoverSeries, e = s.hoverPoint, n = s.hoverPoints, o = s.tooltip, i = o && o.shared ? n : e;
              u && i && P(i).forEach(function(c) {
                c.series.isCartesian && c.plotX === void 0 && (u = !1);
              }), u ? o && i && P(i).length && (o.refresh(i), o.shared && n ? n.forEach(function(c) {
                c.setState(c.state, !0), c.series.isCartesian && (c.series.xAxis.crosshair && c.series.xAxis.drawCrosshair(null, c), c.series.yAxis.crosshair && c.series.yAxis.drawCrosshair(null, c));
              }) : e && (e.setState(e.state, !0), s.axes.forEach(function(c) {
                c.crosshair && e.series[c.coll] === c && c.drawCrosshair(null, e);
              }))) : (e && e.onMouseOut(), n && n.forEach(function(c) {
                c.setState();
              }), a && a.onMouseOut(), o && o.hide(y), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), s.axes.forEach(function(c) {
                c.hideCrosshair();
              }), this.hoverX = s.hoverPoints = s.hoverPoint = null);
            }, S.prototype.runPointActions = function(u, y, s) {
              var a = this.chart, e = a.tooltip && a.tooltip.options.enabled ? a.tooltip : void 0, n = !!e && e.shared, o = y || a.hoverPoint, i = o && o.series || a.hoverSeries;
              y = this.getHoverData(o, i, a.series, (!u || u.type !== "touchmove") && (!!y || i && i.directTouch && this.isDirectTouch), n, u), o = y.hoverPoint, i = y.hoverSeries;
              var c = y.hoverPoints;
              y = i && i.tooltipOptions.followPointer && !i.tooltipOptions.split;
              var l = n && i && !i.noSharedTooltip;
              if (o && (s || o !== a.hoverPoint || e && e.isHidden)) {
                if ((a.hoverPoints || []).forEach(function(h) {
                  c.indexOf(h) === -1 && h.setState();
                }), a.hoverSeries !== i && i.onMouseOver(), this.applyInactiveState(c), (c || []).forEach(function(h) {
                  h.setState("hover");
                }), a.hoverPoint && a.hoverPoint.firePointEvent("mouseOut"), !o.series)
                  return;
                a.hoverPoints = c, a.hoverPoint = o, o.firePointEvent("mouseOver", void 0, function() {
                  e && o && e.refresh(l ? c : o, u);
                });
              } else
                y && e && !e.isHidden && (s = e.getAnchor([{}], u), a.isInsidePlot(s[0], s[1], { visiblePlotOnly: !0 }) && e.updatePosition({ plotX: s[0], plotY: s[1] }));
              this.unDocMouseMove || (this.unDocMouseMove = U(a.container.ownerDocument, "mousemove", function(h) {
                var C = Q[S.hoverChartIndex];
                C && C.pointer.onDocumentMouseMove(h);
              }), this.eventsToUnbind.push(this.unDocMouseMove)), a.axes.forEach(function(h) {
                var C, M = E((h.crosshair || {}).snap, !0);
                M && ((C = a.hoverPoint) && C.series[h.coll] === h || (C = b(c, function(O) {
                  return O.series && O.series[h.coll] === h;
                }))), C || !M ? h.drawCrosshair(u, C) : h.hideCrosshair();
              });
            }, S.prototype.scaleGroups = function(u, y) {
              var s = this.chart;
              s.series.forEach(function(a) {
                var e = u || a.getPlotBox();
                a.group && (a.xAxis && a.xAxis.zoomEnabled || s.mapView) && (a.group.attr(e), a.markerGroup && (a.markerGroup.attr(e), a.markerGroup.clip(y ? s.clipRect : null)), a.dataLabelsGroup && a.dataLabelsGroup.attr(e));
              }), s.clipRect.attr(y || s.clipBox);
            }, S.prototype.setDOMEvents = function() {
              var u = this, y = this.chart.container, s = y.ownerDocument;
              y.onmousedown = this.onContainerMouseDown.bind(this), y.onmousemove = this.onContainerMouseMove.bind(this), y.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(U(y, "mouseenter", this.onContainerMouseEnter.bind(this))), this.eventsToUnbind.push(U(y, "mouseleave", this.onContainerMouseLeave.bind(this))), S.unbindDocumentMouseUp || (S.unbindDocumentMouseUp = U(s, "mouseup", this.onDocumentMouseUp.bind(this)));
              for (var a = this.chart.renderTo.parentElement; a && a.tagName !== "BODY"; )
                this.eventsToUnbind.push(U(a, "scroll", function() {
                  delete u.chartPosition;
                })), a = a.parentElement;
              F.hasTouch && (this.eventsToUnbind.push(U(y, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 })), this.eventsToUnbind.push(U(y, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), S.unbindDocumentTouchEnd || (S.unbindDocumentTouchEnd = U(s, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })));
            }, S.prototype.setHoverChartIndex = function() {
              var u = this.chart, y = F.charts[E(S.hoverChartIndex, -1)];
              y && y !== u && y.pointer.onContainerMouseLeave({ relatedTarget: u.container }), y && y.mouseIsDown || (S.hoverChartIndex = u.index);
            }, S.prototype.touch = function(u, y) {
              var s = this.chart;
              if (this.setHoverChartIndex(), u.touches.length === 1)
                if (u = this.normalize(u), s.isInsidePlot(u.chartX - s.plotLeft, u.chartY - s.plotTop, { visiblePlotOnly: !0 }) && !s.openMenu) {
                  if (y && this.runPointActions(u), u.type === "touchmove")
                    var a = !!(y = this.pinchDown)[0] && 4 <= Math.sqrt(Math.pow(y[0].chartX - u.chartX, 2) + Math.pow(y[0].chartY - u.chartY, 2));
                  E(a, !0) && this.pinch(u);
                } else
                  y && this.reset();
              else
                u.touches.length === 2 && this.pinch(u);
            }, S.prototype.touchSelect = function(u) {
              return !(!this.chart.options.chart.zooming.singleTouch || !u.touches || u.touches.length !== 1);
            }, S.prototype.zoomOption = function(u) {
              var y = this.chart, s = y.options.chart;
              y = y.inverted;
              var a = s.zooming.type || "";
              /touch/.test(u.type) && (a = E(s.zooming.pinchType, a)), this.zoomX = u = /x/.test(a), this.zoomY = s = /y/.test(a), this.zoomHor = u && !y || s && y, this.zoomVert = s && !y || u && y, this.hasZoom = u || s;
            }, S;
          }(), G;
        }), _(at, "Core/MSPointer.js", [at["Core/Globals.js"], at["Core/Pointer.js"], at["Core/Utilities.js"]], function(G, F, $) {
          function Y() {
            var x = [];
            return x.item = function(E) {
              return this[E];
            }, b(v, function(E) {
              x.push({ pageX: E.pageX, pageY: E.pageY, target: E.target });
            }), x;
          }
          function J(x, E, P, S) {
            var u = q[F.hoverChartIndex || NaN];
            x.pointerType !== "touch" && x.pointerType !== x.MSPOINTER_TYPE_TOUCH || !u || (u = u.pointer, S(x), u[E]({ type: P, target: x.currentTarget, preventDefault: N, touches: Y() }));
          }
          var Q = this && this.__extends || /* @__PURE__ */ function() {
            var x = function(E, P) {
              return x = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(S, u) {
                S.__proto__ = u;
              } || function(S, u) {
                for (var y in u)
                  u.hasOwnProperty(y) && (S[y] = u[y]);
              }, x(E, P);
            };
            return function(E, P) {
              function S() {
                this.constructor = E;
              }
              x(E, P), E.prototype = P === null ? Object.create(P) : (S.prototype = P.prototype, new S());
            };
          }(), q = G.charts, U = G.doc, N = G.noop, D = G.win, k = $.addEvent, A = $.css, b = $.objectEach, d = $.pick, m = $.removeEvent, v = {}, g = !!D.PointerEvent;
          return function(x) {
            function E() {
              return x !== null && x.apply(this, arguments) || this;
            }
            return Q(E, x), E.isRequired = function() {
              return !(G.hasTouch || !D.PointerEvent && !D.MSPointerEvent);
            }, E.prototype.batchMSEvents = function(P) {
              P(this.chart.container, g ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown), P(this.chart.container, g ? "pointermove" : "MSPointerMove", this.onContainerPointerMove), P(U, g ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
            }, E.prototype.destroy = function() {
              this.batchMSEvents(m), x.prototype.destroy.call(this);
            }, E.prototype.init = function(P, S) {
              x.prototype.init.call(this, P, S), this.hasZoom && A(P.container, { "-ms-touch-action": "none", "touch-action": "none" });
            }, E.prototype.onContainerPointerDown = function(P) {
              J(P, "onContainerTouchStart", "touchstart", function(S) {
                v[S.pointerId] = { pageX: S.pageX, pageY: S.pageY, target: S.currentTarget };
              });
            }, E.prototype.onContainerPointerMove = function(P) {
              J(P, "onContainerTouchMove", "touchmove", function(S) {
                v[S.pointerId] = { pageX: S.pageX, pageY: S.pageY }, v[S.pointerId].target || (v[S.pointerId].target = S.currentTarget);
              });
            }, E.prototype.onDocumentPointerUp = function(P) {
              J(P, "onDocumentTouchEnd", "touchend", function(S) {
                delete v[S.pointerId];
              });
            }, E.prototype.setDOMEvents = function() {
              var P = this.chart.tooltip;
              x.prototype.setDOMEvents.call(this), (this.hasZoom || d(P && P.options.followTouchMove, !0)) && this.batchMSEvents(k);
            }, E;
          }(F);
        }), _(at, "Core/Legend/Legend.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/FormatUtilities.js"], at["Core/Globals.js"], at["Core/Series/Point.js"], at["Core/Renderer/RendererUtilities.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = G.animObject, U = G.setAnimation, N = F.format, D = $.marginNames, k = J.distribute, A = Q.addEvent, b = Q.createElement, d = Q.css, m = Q.defined, v = Q.discardElement, g = Q.find, x = Q.fireEvent, E = Q.isNumber, P = Q.merge, S = Q.pick, u = Q.relativeLength, y = Q.stableSort, s = Q.syncTimeout;
          return G = function() {
            function a(e, n) {
              this.allItems = [], this.contentGroup = this.box = void 0, this.display = !1, this.group = void 0, this.offsetWidth = this.maxLegendWidth = this.maxItemWidth = this.legendWidth = this.legendHeight = this.lastLineHeight = this.lastItemY = this.itemY = this.itemX = this.itemMarginTop = this.itemMarginBottom = this.itemHeight = this.initialItemY = 0, this.options = void 0, this.padding = 0, this.pages = [], this.proximate = !1, this.scrollGroup = void 0, this.widthOption = this.totalItemWidth = this.titleHeight = this.symbolWidth = this.symbolHeight = 0, this.chart = e, this.init(e, n);
            }
            return a.prototype.init = function(e, n) {
              this.chart = e, this.setOptions(n), n.enabled && (this.render(), A(this.chart, "endResize", function() {
                this.legend.positionCheckboxes();
              }), this.proximate ? this.unchartrender = A(this.chart, "render", function() {
                this.legend.proximatePositions(), this.legend.positionItems();
              }) : this.unchartrender && this.unchartrender());
            }, a.prototype.setOptions = function(e) {
              var n = S(e.padding, 8);
              this.options = e, this.chart.styledMode || (this.itemStyle = e.itemStyle, this.itemHiddenStyle = P(this.itemStyle, e.itemHiddenStyle)), this.itemMarginTop = e.itemMarginTop || 0, this.itemMarginBottom = e.itemMarginBottom || 0, this.padding = n, this.initialItemY = n - 5, this.symbolWidth = S(e.symbolWidth, 16), this.pages = [], this.proximate = e.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
            }, a.prototype.update = function(e, n) {
              var o = this.chart;
              this.setOptions(P(!0, this.options, e)), this.destroy(), o.isDirtyLegend = o.isDirtyBox = !0, S(n, !0) && o.redraw(), x(this, "afterUpdate");
            }, a.prototype.colorizeItem = function(e, n) {
              var o = e.legendItem || {}, i = o.group, c = o.label, l = o.line;
              if (o = o.symbol, i && i[n ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                var h = this.options;
                i = this.itemHiddenStyle.color, h = n ? h.itemStyle.color : i;
                var C = n && e.color || i, M = e.options && e.options.marker, O = { fill: C };
                c && c.css({ fill: h, color: h }), l && l.attr({ stroke: C }), o && (M && o.isMarker && (O = e.pointAttribs(), n || (O.stroke = O.fill = i)), o.attr(O));
              }
              x(this, "afterColorizeItem", { item: e, visible: n });
            }, a.prototype.positionItems = function() {
              this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
            }, a.prototype.positionItem = function(e) {
              var n = this, o = e.legendItem || {}, i = o.group, c = o.x;
              c = c === void 0 ? 0 : c, o = (o = o.y) === void 0 ? 0 : o;
              var l = this.options, h = l.symbolPadding, C = !l.rtl;
              l = e.checkbox, i && i.element && (h = { translateX: C ? c : this.legendWidth - c - 2 * h - 4, translateY: o }, i[m(i.translateY) ? "animate" : "attr"](h, void 0, function() {
                x(n, "afterPositionItem", { item: e });
              })), l && (l.x = c, l.y = o);
            }, a.prototype.destroyItem = function(e) {
              for (var n = e.checkbox, o = e.legendItem || {}, i = 0, c = ["group", "label", "line", "symbol"]; i < c.length; i++) {
                var l = c[i];
                o[l] && (o[l] = o[l].destroy());
              }
              n && v(n), e.legendItem = void 0;
            }, a.prototype.destroy = function() {
              for (var e = 0, n = this.getAllItems(); e < n.length; e++)
                this.destroyItem(n[e]);
              for (e = 0, n = "clipRect up down pager nav box title group".split(" "); e < n.length; e++) {
                var o = n[e];
                this[o] && (this[o] = this[o].destroy());
              }
              this.display = null;
            }, a.prototype.positionCheckboxes = function() {
              var e = this.group && this.group.alignAttr, n = this.clipHeight || this.legendHeight, o = this.titleHeight;
              if (e) {
                var i = e.translateY;
                this.allItems.forEach(function(c) {
                  var l = c.checkbox;
                  if (l) {
                    var h = i + o + l.y + (this.scrollOffset || 0) + 3;
                    d(l, { left: e.translateX + c.checkboxOffset + l.x - 20 + "px", top: h + "px", display: this.proximate || h > i - 6 && h < i + n - 6 ? "" : "none" });
                  }
                }, this);
              }
            }, a.prototype.renderTitle = function() {
              var e = this.options, n = this.padding, o = e.title, i = 0;
              o.text && (this.title || (this.title = this.chart.renderer.label(o.text, n - 3, n - 4, void 0, void 0, void 0, e.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(o.style), this.title.add(this.group)), o.width || this.title.css({ width: this.maxLegendWidth + "px" }), i = (e = this.title.getBBox()).height, this.offsetWidth = e.width, this.contentGroup.attr({ translateY: i })), this.titleHeight = i;
            }, a.prototype.setText = function(e) {
              var n = this.options;
              e.legendItem.label.attr({ text: n.labelFormat ? N(n.labelFormat, e, this.chart) : n.labelFormatter.call(e) });
            }, a.prototype.renderItem = function(e) {
              var n = e.legendItem = e.legendItem || {}, o = this.chart, i = o.renderer, c = this.options, l = this.symbolWidth, h = c.symbolPadding || 0, C = this.itemStyle, M = this.itemHiddenStyle, O = c.layout === "horizontal" ? S(c.itemDistance, 20) : 0, p = !c.rtl, w = !e.series, T = !w && e.series.drawLegendSymbol ? e.series : e, z = T.options, W = this.createCheckboxForItem && z && z.showCheckbox, L = c.useHTML, I = e.options.className, j = n.label;
              z = l + h + O + (W ? 20 : 0), j || (n.group = i.g("legend-item").addClass("highcharts-" + T.type + "-series highcharts-color-" + e.colorIndex + (I ? " " + I : "") + (w ? " highcharts-series-" + e.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), n.label = j = i.text("", p ? l + h : -h, this.baseline || 0, L), o.styledMode || j.css(P(e.visible ? C : M)), j.attr({ align: p ? "left" : "right", zIndex: 2 }).add(n.group), this.baseline || (this.fontMetrics = i.fontMetrics(o.styledMode ? 12 : C.fontSize, j), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, j.attr("y", this.baseline), this.symbolHeight = c.symbolHeight || this.fontMetrics.f, c.squareSymbol && (this.symbolWidth = S(c.symbolWidth, Math.max(this.symbolHeight, 16)), z = this.symbolWidth + h + O + (W ? 20 : 0), p && j.attr("x", this.symbolWidth + h))), T.drawLegendSymbol(this, e), this.setItemEvents && this.setItemEvents(e, j, L)), W && !e.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(e), this.colorizeItem(e, e.visible), !o.styledMode && C.width || j.css({ width: (c.itemWidth || this.widthOption || o.spacingBox.width) - z + "px" }), this.setText(e), o = j.getBBox(), i = this.fontMetrics && this.fontMetrics.h || 0, e.itemWidth = e.checkboxOffset = c.itemWidth || n.labelWidth || o.width + z, this.maxItemWidth = Math.max(this.maxItemWidth, e.itemWidth), this.totalItemWidth += e.itemWidth, this.itemHeight = e.itemHeight = Math.round(n.labelHeight || (o.height > 1.5 * i ? o.height : i));
            }, a.prototype.layoutItem = function(e) {
              var n = this.options, o = this.padding, i = n.layout === "horizontal", c = e.itemHeight, l = this.itemMarginBottom, h = this.itemMarginTop, C = i ? S(n.itemDistance, 20) : 0, M = this.maxLegendWidth;
              n = n.alignColumns && this.totalItemWidth > M ? this.maxItemWidth : e.itemWidth;
              var O = e.legendItem || {};
              i && this.itemX - o + n > M && (this.itemX = o, this.lastLineHeight && (this.itemY += h + this.lastLineHeight + l), this.lastLineHeight = 0), this.lastItemY = h + this.itemY + l, this.lastLineHeight = Math.max(c, this.lastLineHeight), O.x = this.itemX, O.y = this.itemY, i ? this.itemX += n : (this.itemY += h + c + l, this.lastLineHeight = c), this.offsetWidth = this.widthOption || Math.max((i ? this.itemX - o - (e.checkbox ? 0 : C) : n) + o, this.offsetWidth);
            }, a.prototype.getAllItems = function() {
              var e = [];
              return this.chart.series.forEach(function(n) {
                var o = n && n.options;
                n && S(o.showInLegend, !m(o.linkedTo) && void 0, !0) && (e = e.concat((n.legendItem || {}).labels || (o.legendType === "point" ? n.data : n)));
              }), x(this, "afterGetAllItems", { allItems: e }), e;
            }, a.prototype.getAlignment = function() {
              var e = this.options;
              return this.proximate ? e.align.charAt(0) + "tv" : e.floating ? "" : e.align.charAt(0) + e.verticalAlign.charAt(0) + e.layout.charAt(0);
            }, a.prototype.adjustMargins = function(e, n) {
              var o = this.chart, i = this.options, c = this.getAlignment();
              c && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(l, h) {
                l.test(c) && !m(e[h]) && (o[D[h]] = Math.max(o[D[h]], o.legend[(h + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][h] * i[h % 2 ? "x" : "y"] + S(i.margin, 12) + n[h] + (o.titleOffset[h] || 0)));
              });
            }, a.prototype.proximatePositions = function() {
              var e = this.chart, n = [], o = this.options.align === "left";
              this.allItems.forEach(function(C) {
                var M, O = o;
                if (C.yAxis) {
                  C.xAxis.options.reversed && (O = !O), C.points && (M = g(O ? C.points : C.points.slice(0).reverse(), function(w) {
                    return E(w.plotY);
                  })), O = this.itemMarginTop + C.legendItem.label.getBBox().height + this.itemMarginBottom;
                  var p = C.yAxis.top - e.plotTop;
                  C.visible ? (M = M ? M.plotY : C.yAxis.height, M += p - 0.3 * O) : M = p + C.yAxis.height, n.push({ target: M, size: O, item: C });
                }
              }, this);
              for (var i, c = 0, l = k(n, e.plotHeight); c < l.length; c++) {
                var h = l[c];
                i = h.item.legendItem || {}, E(h.pos) && (i.y = e.plotTop - e.spacing[0] + h.pos);
              }
            }, a.prototype.render = function() {
              var e = this.chart, n = e.renderer, o = this.options, i = this.padding, c = this.getAllItems(), l = this.group, h = this.box;
              this.itemX = i, this.itemY = this.initialItemY, this.lastItemY = this.offsetWidth = 0, this.widthOption = u(o.width, e.spacingBox.width - i);
              var C = e.spacingBox.width - 2 * i - o.x;
              -1 < ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) && (C /= 2), this.maxLegendWidth = this.widthOption || C, l || (this.group = l = n.g("legend").addClass(o.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = n.g().attr({ zIndex: 1 }).add(l), this.scrollGroup = n.g().add(this.contentGroup)), this.renderTitle(), y(c, function(O, p) {
                return (O.options && O.options.legendIndex || 0) - (p.options && p.options.legendIndex || 0);
              }), o.reversed && c.reverse(), this.allItems = c, this.display = C = !!c.length, this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0, c.forEach(this.renderItem, this), c.forEach(this.layoutItem, this), c = (this.widthOption || this.offsetWidth) + i;
              var M = this.lastItemY + this.lastLineHeight + this.titleHeight;
              M = this.handleOverflow(M), M += i, h || (this.box = h = n.rect().addClass("highcharts-legend-box").attr({ r: o.borderRadius }).add(l)), e.styledMode || h.attr({ stroke: o.borderColor, "stroke-width": o.borderWidth || 0, fill: o.backgroundColor || "none" }).shadow(o.shadow), 0 < c && 0 < M && h[h.placed ? "animate" : "attr"](h.crisp.call({}, { x: 0, y: 0, width: c, height: M }, h.strokeWidth())), l[C ? "show" : "hide"](), e.styledMode && l.getStyle("display") === "none" && (c = M = 0), this.legendWidth = c, this.legendHeight = M, C && this.align(), this.proximate || this.positionItems(), x(this, "afterRender");
            }, a.prototype.align = function(e) {
              e === void 0 && (e = this.chart.spacingBox);
              var n = this.chart, o = this.options, i = e.y;
              /(lth|ct|rth)/.test(this.getAlignment()) && 0 < n.titleOffset[0] ? i += n.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && 0 < n.titleOffset[2] && (i -= n.titleOffset[2]), i !== e.y && (e = P(e, { y: i })), n.hasRendered || (this.group.placed = !1), this.group.align(P(o, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : o.verticalAlign }), !0, e);
            }, a.prototype.handleOverflow = function(e) {
              var n, o, i, c = this, l = this.chart, h = l.renderer, C = this.options, M = C.y, O = C.verticalAlign === "top", p = this.padding, w = C.maxHeight, T = C.navigation, z = S(T.animation, !0), W = T.arrowSize || 12, L = this.pages, I = this.allItems, j = function(et) {
                typeof et == "number" ? X.attr({ height: et }) : X && (c.clipRect = X.destroy(), c.contentGroup.clip()), c.contentGroup.div && (c.contentGroup.div.style.clip = et ? "rect(" + p + "px,9999px," + (p + et) + "px,0)" : "auto");
              }, Z = function(et) {
                return c[et] = h.circle(0, 0, 1.3 * W).translate(W / 2, W / 2).add(V), l.styledMode || c[et].attr("fill", "rgba(0,0,0,0.0001)"), c[et];
              };
              M = l.spacingBox.height + (O ? -M : M) - p;
              var V = this.nav, X = this.clipRect;
              return C.layout !== "horizontal" || C.verticalAlign === "middle" || C.floating || (M /= 2), w && (M = Math.min(M, w)), L.length = 0, e && 0 < M && e > M && T.enabled !== !1 ? (this.clipHeight = n = Math.max(M - 20 - this.titleHeight - p, 0), this.currentPage = S(this.currentPage, 1), this.fullHeight = e, I.forEach(function(et, ot) {
                et = (i = et.legendItem || {}).y || 0;
                var it = Math.round(i.label.getBBox().height), pt = L.length;
                (!pt || et - L[pt - 1] > n && (o || et) !== L[pt - 1]) && (L.push(o || et), pt++), i.pageIx = pt - 1, o && ((I[ot - 1].legendItem || {}).pageIx = pt - 1), ot === I.length - 1 && et + it - L[pt - 1] > n && it <= n && (L.push(et), i.pageIx = pt), et !== o && (o = et);
              }), X || (X = c.clipRect = h.clipRect(0, p, 9999, 0), c.contentGroup.clip(X)), j(n), V || (this.nav = V = h.g().attr({ zIndex: 1 }).add(this.group), this.up = h.symbol("triangle", 0, 0, W, W).add(V), Z("upTracker").on("click", function() {
                c.scroll(-1, z);
              }), this.pager = h.text("", 15, 10).addClass("highcharts-legend-navigation"), !l.styledMode && T.style && this.pager.css(T.style), this.pager.add(V), this.down = h.symbol("triangle-down", 0, 0, W, W).add(V), Z("downTracker").on("click", function() {
                c.scroll(1, z);
              })), c.scroll(0), e = M) : V && (j(), this.nav = V.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), e;
            }, a.prototype.scroll = function(e, n) {
              var o = this, i = this.chart, c = this.pages, l = c.length, h = this.clipHeight, C = this.options.navigation, M = this.pager, O = this.padding, p = this.currentPage + e;
              p > l && (p = l), 0 < p && (n !== void 0 && U(n, i), this.nav.attr({ translateX: O, translateY: h + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(w) {
                w.attr({ class: p === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
              }), M.attr({ text: p + "/" + l }), [this.down, this.downTracker].forEach(function(w) {
                w.attr({ x: 18 + this.pager.getBBox().width, class: p === l ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
              }, this), i.styledMode || (this.up.attr({ fill: p === 1 ? C.inactiveColor : C.activeColor }), this.upTracker.css({ cursor: p === 1 ? "default" : "pointer" }), this.down.attr({ fill: p === l ? C.inactiveColor : C.activeColor }), this.downTracker.css({ cursor: p === l ? "default" : "pointer" })), this.scrollOffset = -c[p - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = p, this.positionCheckboxes(), e = q(S(n, i.renderer.globalAnimation, !0)), s(function() {
                x(o, "afterScroll", { currentPage: p });
              }, e.duration));
            }, a.prototype.setItemEvents = function(e, n, o) {
              var i = this, c = e.legendItem || {}, l = i.chart.renderer.boxWrapper, h = e instanceof Y, C = "highcharts-legend-" + (h ? "point" : "series") + "-active", M = i.chart.styledMode, O = function(w) {
                i.allItems.forEach(function(T) {
                  e !== T && [T].concat(T.linkedSeries || []).forEach(function(z) {
                    z.setState(w, !h);
                  });
                });
              }, p = 0;
              for (o = o ? [n, c.symbol] : [c.group]; p < o.length; p++)
                (c = o[p]) && c.on("mouseover", function() {
                  e.visible && O("inactive"), e.setState("hover"), e.visible && l.addClass(C), M || n.css(i.options.itemHoverStyle);
                }).on("mouseout", function() {
                  i.chart.styledMode || n.css(P(e.visible ? i.itemStyle : i.itemHiddenStyle)), O(""), l.removeClass(C), e.setState();
                }).on("click", function(w) {
                  var T = function() {
                    e.setVisible && e.setVisible(), O(e.visible ? "inactive" : "");
                  };
                  l.removeClass(C), w = { browserEvent: w }, e.firePointEvent ? e.firePointEvent("legendItemClick", w, T) : x(e, "legendItemClick", w, T);
                });
            }, a.prototype.createCheckboxForItem = function(e) {
              e.checkbox = b("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: e.selected, defaultChecked: e.selected }, this.options.itemCheckboxStyle, this.chart.container), A(e.checkbox, "click", function(n) {
                x(e.series || e, "checkboxClick", { checked: n.target.checked, item: e }, function() {
                  e.select();
                });
              });
            }, a;
          }(), G;
        }), _(at, "Core/Series/SeriesRegistry.js", [at["Core/Globals.js"], at["Core/Defaults.js"], at["Core/Series/Point.js"], at["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = F.defaultOptions, q = Y.extendClass, U = Y.merge;
          return function(N) {
            function D(k, A) {
              var b = Q.plotOptions || {}, d = A.defaultOptions, m = A.prototype;
              m.type = k, m.pointClass || (m.pointClass = $), d && (b[k] = d), N.seriesTypes[k] = A;
            }
            N.seriesTypes = G.seriesTypes, N.registerSeriesType = D, N.seriesType = function(k, A, b, d, m) {
              var v = Q.plotOptions || {};
              return A = A || "", v[k] = U(v[A], b), D(k, q(N.seriesTypes[A] || function() {
              }, d)), N.seriesTypes[k].prototype.type = k, m && (N.seriesTypes[k].prototype.pointClass = q($, m)), N.seriesTypes[k];
            };
          }(J || (J = {})), J;
        }), _(at, "Core/Chart/Chart.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Axis/Axis.js"], at["Core/Defaults.js"], at["Core/FormatUtilities.js"], at["Core/Foundation.js"], at["Core/Globals.js"], at["Core/Legend/Legend.js"], at["Core/MSPointer.js"], at["Core/Pointer.js"], at["Core/Renderer/RendererRegistry.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Renderer/SVG/SVGRenderer.js"], at["Core/Time.js"], at["Core/Utilities.js"], at["Core/Renderer/HTML/AST.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A, b, d, m) {
          var v = G.animate, g = G.animObject, x = G.setAnimation, E = $.defaultOptions, P = $.defaultTime, S = Y.numberFormat, u = J.registerEventOptions, y = Q.charts, s = Q.doc, a = Q.marginNames, e = Q.svg, n = Q.win, o = k.seriesTypes, i = d.addEvent, c = d.attr, l = d.cleanRecursively, h = d.createElement, C = d.css, M = d.defined, O = d.discardElement, p = d.erase, w = d.error, T = d.extend, z = d.find, W = d.fireEvent, L = d.getStyle, I = d.isArray, j = d.isNumber, Z = d.isObject, V = d.isString, X = d.merge, et = d.objectEach, ot = d.pick, it = d.pInt, pt = d.relativeLength, mt = d.removeEvent, Ct = d.splat, kt = d.syncTimeout, Lt = d.uniqueKey;
          return G = function() {
            function Tt(xt, ct, ft) {
              this.series = this.renderTo = this.renderer = this.pointer = this.pointCount = this.plotWidth = this.plotTop = this.plotLeft = this.plotHeight = this.plotBox = this.options = this.numberFormatter = this.margin = this.legend = this.labelCollectors = this.isResizing = this.index = this.eventOptions = this.container = this.colorCounter = this.clipBox = this.chartWidth = this.chartHeight = this.bounds = this.axisOffset = this.axes = void 0, this.sharedClips = {}, this.yAxis = this.xAxis = this.userOptions = this.titleOffset = this.time = this.symbolCounter = this.spacingBox = this.spacing = void 0, this.getArgs(xt, ct, ft);
            }
            return Tt.chart = function(xt, ct, ft) {
              return new Tt(xt, ct, ft);
            }, Tt.prototype.getArgs = function(xt, ct, ft) {
              V(xt) || xt.nodeName ? (this.renderTo = xt, this.init(ct, ft)) : this.init(xt, ct);
            }, Tt.prototype.init = function(xt, ct) {
              var ft = xt.plotOptions || {};
              W(this, "init", { args: arguments }, function() {
                var St = X(E, xt), Mt = St.chart;
                et(St.plotOptions, function(Ot, Nt) {
                  Z(Ot) && (Ot.tooltip = ft[Nt] && X(ft[Nt].tooltip) || void 0);
                }), St.tooltip.userOptions = xt.chart && xt.chart.forExport && xt.tooltip.userOptions || xt.tooltip, this.userOptions = xt, this.margin = [], this.spacing = [], this.bounds = { h: {}, v: {} }, this.labelCollectors = [], this.callback = ct, this.isResizing = 0;
                var Dt = Mt.zooming = Mt.zooming || {};
                xt.chart && !xt.chart.zooming && (Dt.resetButton = Mt.resetZoomButton), Dt.key = ot(Dt.key, Mt.zoomKey), Dt.pinchType = ot(Dt.pinchType, Mt.pinchType), Dt.singleTouch = ot(Dt.singleTouch, Mt.zoomBySingleTouch), Dt.type = ot(Dt.type, Mt.zoomType), this.options = St, this.axes = [], this.series = [], this.time = xt.time && Object.keys(xt.time).length ? new b(xt.time) : Q.time, this.numberFormatter = Mt.numberFormatter || S, this.styledMode = Mt.styledMode, this.hasCartesianSeries = Mt.showAxes, this.index = y.length, y.push(this), Q.chartCount++, u(this, Mt), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, W(this, "afterInit"), this.firstRender();
              });
            }, Tt.prototype.initSeries = function(xt) {
              var ct = this.options.chart;
              ct = xt.type || ct.type || ct.defaultSeriesType;
              var ft = o[ct];
              return ft || w(17, !0, this, { missingModuleFor: ct }), typeof (ct = new ft()).init == "function" && ct.init(this, xt), ct;
            }, Tt.prototype.setSeriesData = function() {
              this.getSeriesOrderByLinks().forEach(function(xt) {
                xt.points || xt.data || !xt.enabledDataSorting || xt.setData(xt.options.data, !1);
              });
            }, Tt.prototype.getSeriesOrderByLinks = function() {
              return this.series.concat().sort(function(xt, ct) {
                return xt.linkedSeries.length || ct.linkedSeries.length ? ct.linkedSeries.length - xt.linkedSeries.length : 0;
              });
            }, Tt.prototype.orderSeries = function(xt) {
              var ct = this.series;
              xt = xt || 0;
              for (var ft = ct.length; xt < ft; ++xt)
                ct[xt] && (ct[xt].index = xt, ct[xt].name = ct[xt].getName());
            }, Tt.prototype.isInsidePlot = function(xt, ct, ft) {
              ft === void 0 && (ft = {});
              var St = this.inverted, Mt = this.plotBox, Dt = this.plotLeft, Ot = this.plotTop, Nt = this.scrollablePlotBox, Wt = 0, zt = 0;
              ft.visiblePlotOnly && this.scrollingContainer && (Wt = (zt = this.scrollingContainer).scrollLeft, zt = zt.scrollTop);
              var Ht = ft.series;
              if (Mt = ft.visiblePlotOnly && Nt || Mt, xt = { x: Nt = ft.inverted ? ct : xt, y: ct = ft.inverted ? xt : ct, isInsidePlot: !0, options: ft }, !ft.ignoreX) {
                var Kt = Ht && (St && !this.polar ? Ht.yAxis : Ht.xAxis) || { pos: Dt, len: 1 / 0 };
                (Nt = ft.paneCoordinates ? Kt.pos + Nt : Dt + Nt) >= Math.max(Wt + Dt, Kt.pos) && Nt <= Math.min(Wt + Dt + Mt.width, Kt.pos + Kt.len) || (xt.isInsidePlot = !1);
              }
              return !ft.ignoreY && xt.isInsidePlot && (St = ft.axis && !ft.axis.isXAxis && ft.axis || Ht && (St ? Ht.xAxis : Ht.yAxis) || { pos: Ot, len: 1 / 0 }, (ft = ft.paneCoordinates ? St.pos + ct : Ot + ct) >= Math.max(zt + Ot, St.pos) && ft <= Math.min(zt + Ot + Mt.height, St.pos + St.len) || (xt.isInsidePlot = !1)), W(this, "afterIsInsidePlot", xt), xt.isInsidePlot;
            }, Tt.prototype.redraw = function(xt) {
              W(this, "beforeRedraw");
              var ct = this.hasCartesianSeries ? this.axes : this.colorAxis || [], ft = this.series, St = this.pointer, Mt = this.legend, Dt = this.userOptions.legend, Ot = this.renderer, Nt = Ot.isHidden(), Wt = [], zt = this.isDirtyBox, Ht = this.isDirtyLegend;
              for (this.setResponsive && this.setResponsive(!1), x(!!this.hasRendered && xt, this), Nt && this.temporaryDisplay(), this.layOutTitles(), xt = ft.length; xt--; ) {
                var Kt = ft[xt];
                if (Kt.options.stacking || Kt.options.centerInCategory) {
                  var Gt = !0;
                  if (Kt.isDirty) {
                    var ee = !0;
                    break;
                  }
                }
              }
              if (ee)
                for (xt = ft.length; xt--; )
                  (Kt = ft[xt]).options.stacking && (Kt.isDirty = !0);
              ft.forEach(function(Jt) {
                Jt.isDirty && (Jt.options.legendType === "point" ? (typeof Jt.updateTotals == "function" && Jt.updateTotals(), Ht = !0) : Dt && (Dt.labelFormatter || Dt.labelFormat) && (Ht = !0)), Jt.isDirtyData && W(Jt, "updatedData");
              }), Ht && Mt && Mt.options.enabled && (Mt.render(), this.isDirtyLegend = !1), Gt && this.getStacks(), ct.forEach(function(Jt) {
                Jt.updateNames(), Jt.setScale();
              }), this.getMargins(), ct.forEach(function(Jt) {
                Jt.isDirty && (zt = !0);
              }), ct.forEach(function(Jt) {
                var Qt = Jt.min + "," + Jt.max;
                Jt.extKey !== Qt && (Jt.extKey = Qt, Wt.push(function() {
                  W(Jt, "afterSetExtremes", T(Jt.eventArgs, Jt.getExtremes())), delete Jt.eventArgs;
                })), (zt || Gt) && Jt.redraw();
              }), zt && this.drawChartBox(), W(this, "predraw"), ft.forEach(function(Jt) {
                (zt || Jt.isDirty) && Jt.visible && Jt.redraw(), Jt.isDirtyData = !1;
              }), St && St.reset(!0), Ot.draw(), W(this, "redraw"), W(this, "render"), Nt && this.temporaryDisplay(!0), Wt.forEach(function(Jt) {
                Jt.call();
              });
            }, Tt.prototype.get = function(xt) {
              function ct(Dt) {
                return Dt.id === xt || Dt.options && Dt.options.id === xt;
              }
              for (var ft = this.series, St = z(this.axes, ct) || z(this.series, ct), Mt = 0; !St && Mt < ft.length; Mt++)
                St = z(ft[Mt].points || [], ct);
              return St;
            }, Tt.prototype.getAxes = function() {
              var xt = this, ct = this.options, ft = ct.xAxis = Ct(ct.xAxis || {});
              ct = ct.yAxis = Ct(ct.yAxis || {}), W(this, "getAxes"), ft.forEach(function(St, Mt) {
                St.index = Mt, St.isX = !0;
              }), ct.forEach(function(St, Mt) {
                St.index = Mt;
              }), ft.concat(ct).forEach(function(St) {
                new F(xt, St);
              }), W(this, "afterGetAxes");
            }, Tt.prototype.getSelectedPoints = function() {
              return this.series.reduce(function(xt, ct) {
                return ct.getPointsCollection().forEach(function(ft) {
                  ot(ft.selectedStaging, ft.selected) && xt.push(ft);
                }), xt;
              }, []);
            }, Tt.prototype.getSelectedSeries = function() {
              return this.series.filter(function(xt) {
                return xt.selected;
              });
            }, Tt.prototype.setTitle = function(xt, ct, ft) {
              this.applyDescription("title", xt), this.applyDescription("subtitle", ct), this.applyDescription("caption", void 0), this.layOutTitles(ft);
            }, Tt.prototype.applyDescription = function(xt, ct) {
              var ft = this, St = xt === "title" ? { color: "#333333", fontSize: this.options.isStock ? "16px" : "18px" } : { color: "#666666" };
              St = this.options[xt] = X(!this.styledMode && { style: St }, this.options[xt], ct);
              var Mt = this[xt];
              Mt && ct && (this[xt] = Mt = Mt.destroy()), St && !Mt && ((Mt = this.renderer.text(St.text, 0, 0, St.useHTML).attr({ align: St.align, class: "highcharts-" + xt, zIndex: St.zIndex || 4 }).add()).update = function(Dt) {
                ft[{ title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }[xt]](Dt);
              }, this.styledMode || Mt.css(St.style), this[xt] = Mt);
            }, Tt.prototype.layOutTitles = function(xt) {
              var ct = [0, 0, 0], ft = this.renderer, St = this.spacingBox;
              ["title", "subtitle", "caption"].forEach(function(Dt) {
                var Ot, Nt = this[Dt], Wt = this.options[Dt], zt = Wt.verticalAlign || "top";
                if (Dt = Dt === "title" ? zt === "top" ? -3 : 0 : zt === "top" ? ct[0] + 2 : 0, Nt) {
                  this.styledMode || (Ot = Wt.style && Wt.style.fontSize), Ot = ft.fontMetrics(Ot, Nt).b, Nt.css({ width: (Wt.width || St.width + (Wt.widthAdjust || 0)) + "px" });
                  var Ht = Math.round(Nt.getBBox(Wt.useHTML).height);
                  Nt.align(T({ y: zt === "bottom" ? Ot : Dt + Ot, height: Ht }, Wt), !1, "spacingBox"), Wt.floating || (zt === "top" ? ct[0] = Math.ceil(ct[0] + Ht) : zt === "bottom" && (ct[2] = Math.ceil(ct[2] + Ht)));
                }
              }, this), ct[0] && (this.options.title.verticalAlign || "top") === "top" && (ct[0] += this.options.title.margin), ct[2] && this.options.caption.verticalAlign === "bottom" && (ct[2] += this.options.caption.margin);
              var Mt = !this.titleOffset || this.titleOffset.join(",") !== ct.join(",");
              this.titleOffset = ct, W(this, "afterLayOutTitles"), !this.isDirtyBox && Mt && (this.isDirtyBox = this.isDirtyLegend = Mt, this.hasRendered && ot(xt, !0) && this.isDirtyBox && this.redraw());
            }, Tt.prototype.getChartSize = function() {
              var xt = this.options.chart, ct = xt.width;
              xt = xt.height;
              var ft = this.renderTo;
              M(ct) || (this.containerWidth = L(ft, "width")), M(xt) || (this.containerHeight = L(ft, "height")), this.chartWidth = Math.max(0, ct || this.containerWidth || 600), this.chartHeight = Math.max(0, pt(xt, this.chartWidth) || (1 < this.containerHeight ? this.containerHeight : 400));
            }, Tt.prototype.temporaryDisplay = function(xt) {
              var ct = this.renderTo;
              if (xt)
                for (; ct && ct.style; )
                  ct.hcOrigStyle && (C(ct, ct.hcOrigStyle), delete ct.hcOrigStyle), ct.hcOrigDetached && (s.body.removeChild(ct), ct.hcOrigDetached = !1), ct = ct.parentNode;
              else
                for (; ct && ct.style && (s.body.contains(ct) || ct.parentNode || (ct.hcOrigDetached = !0, s.body.appendChild(ct)), (L(ct, "display", !1) === "none" || ct.hcOricDetached) && (ct.hcOrigStyle = { display: ct.style.display, height: ct.style.height, overflow: ct.style.overflow }, xt = { display: "block", overflow: "hidden" }, ct !== this.renderTo && (xt.height = 0), C(ct, xt), ct.offsetWidth || ct.style.setProperty("display", "block", "important")), (ct = ct.parentNode) !== s.body); )
                  ;
            }, Tt.prototype.setClassName = function(xt) {
              this.container.className = "highcharts-container " + (xt || "");
            }, Tt.prototype.getContainer = function() {
              var xt, ct = this.options, ft = ct.chart, St = Lt(), Mt = this.renderTo;
              Mt || (this.renderTo = Mt = ft.renderTo), V(Mt) && (this.renderTo = Mt = s.getElementById(Mt)), Mt || w(13, !0, this);
              var Dt = it(c(Mt, "data-highcharts-chart"));
              j(Dt) && y[Dt] && y[Dt].hasRendered && y[Dt].destroy(), c(Mt, "data-highcharts-chart", this.index), Mt.innerHTML = m.emptyHTML, ft.skipClone || Mt.offsetWidth || this.temporaryDisplay(), this.getChartSize(), Dt = this.chartWidth;
              var Ot = this.chartHeight;
              if (C(Mt, { overflow: "hidden" }), this.styledMode || (xt = T({ position: "relative", overflow: "hidden", width: Dt + "px", height: Ot + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none" }, ft.style || {})), this.container = St = h("div", { id: St }, xt, Mt), this._cursor = St.style.cursor, this.renderer = new (ft.renderer || !e ? D.getRendererType(ft.renderer) : A)(St, Dt, Ot, void 0, ft.forExport, ct.exporting && ct.exporting.allowHTML, this.styledMode), x(void 0, this), this.setClassName(ft.className), this.styledMode)
                for (var Nt in ct.defs)
                  this.renderer.definition(ct.defs[Nt]);
              else
                this.renderer.setStyle(ft.style);
              this.renderer.chartIndex = this.index, W(this, "afterGetContainer");
            }, Tt.prototype.getMargins = function(xt) {
              var ct = this.spacing, ft = this.margin, St = this.titleOffset;
              this.resetMargins(), St[0] && !M(ft[0]) && (this.plotTop = Math.max(this.plotTop, St[0] + ct[0])), St[2] && !M(ft[2]) && (this.marginBottom = Math.max(this.marginBottom, St[2] + ct[2])), this.legend && this.legend.display && this.legend.adjustMargins(ft, ct), W(this, "getMargins"), xt || this.getAxisMargins();
            }, Tt.prototype.getAxisMargins = function() {
              var xt = this, ct = xt.axisOffset = [0, 0, 0, 0], ft = xt.colorAxis, St = xt.margin, Mt = function(Dt) {
                Dt.forEach(function(Ot) {
                  Ot.visible && Ot.getOffset();
                });
              };
              xt.hasCartesianSeries ? Mt(xt.axes) : ft && ft.length && Mt(ft), a.forEach(function(Dt, Ot) {
                M(St[Ot]) || (xt[Dt] += ct[Ot]);
              }), xt.setChartSize();
            }, Tt.prototype.reflow = function(xt) {
              var ct = this, ft = ct.options.chart, St = ct.renderTo, Mt = M(ft.width) && M(ft.height), Dt = ft.width || L(St, "width");
              ft = ft.height || L(St, "height"), St = xt ? xt.target : n, delete ct.pointer.chartPosition, Mt || ct.isPrinting || !Dt || !ft || St !== n && St !== s || (Dt === ct.containerWidth && ft === ct.containerHeight || (d.clearTimeout(ct.reflowTimeout), ct.reflowTimeout = kt(function() {
                ct.container && ct.setSize(void 0, void 0, !1);
              }, xt ? 100 : 0)), ct.containerWidth = Dt, ct.containerHeight = ft);
            }, Tt.prototype.setReflow = function(xt) {
              var ct = this;
              xt === !1 || this.unbindReflow ? xt === !1 && this.unbindReflow && (this.unbindReflow = this.unbindReflow()) : (this.unbindReflow = i(n, "resize", function(ft) {
                ct.options && ct.reflow(ft);
              }), i(this, "destroy", this.unbindReflow));
            }, Tt.prototype.setSize = function(xt, ct, ft) {
              var St = this, Mt = St.renderer;
              St.isResizing += 1, x(ft, St), ft = Mt.globalAnimation, St.oldChartHeight = St.chartHeight, St.oldChartWidth = St.chartWidth, xt !== void 0 && (St.options.chart.width = xt), ct !== void 0 && (St.options.chart.height = ct), St.getChartSize(), St.styledMode || (ft ? v : C)(St.container, { width: St.chartWidth + "px", height: St.chartHeight + "px" }, ft), St.setChartSize(!0), Mt.setSize(St.chartWidth, St.chartHeight, ft), St.axes.forEach(function(Dt) {
                Dt.isDirty = !0, Dt.setScale();
              }), St.isDirtyLegend = !0, St.isDirtyBox = !0, St.layOutTitles(), St.getMargins(), St.redraw(ft), St.oldChartHeight = null, W(St, "resize"), kt(function() {
                St && W(St, "endResize", null, function() {
                  --St.isResizing;
                });
              }, g(ft).duration);
            }, Tt.prototype.setChartSize = function(xt) {
              var ct, ft, St, Mt, Dt = this.inverted, Ot = this.renderer, Nt = this.chartWidth, Wt = this.chartHeight, zt = this.options.chart, Ht = this.spacing, Kt = this.clipOffset;
              this.plotLeft = ct = Math.round(this.plotLeft), this.plotTop = ft = Math.round(this.plotTop), this.plotWidth = St = Math.max(0, Math.round(Nt - ct - this.marginRight)), this.plotHeight = Mt = Math.max(0, Math.round(Wt - ft - this.marginBottom)), this.plotSizeX = Dt ? Mt : St, this.plotSizeY = Dt ? St : Mt, this.plotBorderWidth = zt.plotBorderWidth || 0, this.spacingBox = Ot.spacingBox = { x: Ht[3], y: Ht[0], width: Nt - Ht[3] - Ht[1], height: Wt - Ht[0] - Ht[2] }, this.plotBox = Ot.plotBox = { x: ct, y: ft, width: St, height: Mt }, Dt = 2 * Math.floor(this.plotBorderWidth / 2), Nt = Math.ceil(Math.max(Dt, Kt[3]) / 2), Wt = Math.ceil(Math.max(Dt, Kt[0]) / 2), this.clipBox = { x: Nt, y: Wt, width: Math.floor(this.plotSizeX - Math.max(Dt, Kt[1]) / 2 - Nt), height: Math.max(0, Math.floor(this.plotSizeY - Math.max(Dt, Kt[2]) / 2 - Wt)) }, xt || (this.axes.forEach(function(Gt) {
                Gt.setAxisSize(), Gt.setAxisTranslation();
              }), Ot.alignElements()), W(this, "afterSetChartSize", { skipAxes: xt });
            }, Tt.prototype.resetMargins = function() {
              W(this, "resetMargins");
              var xt = this, ct = xt.options.chart;
              ["margin", "spacing"].forEach(function(ft) {
                var St = ct[ft], Mt = Z(St) ? St : [St, St, St, St];
                ["Top", "Right", "Bottom", "Left"].forEach(function(Dt, Ot) {
                  xt[ft][Ot] = ot(ct[ft + Dt], Mt[Ot]);
                });
              }), a.forEach(function(ft, St) {
                xt[ft] = ot(xt.margin[St], xt.spacing[St]);
              }), xt.axisOffset = [0, 0, 0, 0], xt.clipOffset = [0, 0, 0, 0];
            }, Tt.prototype.drawChartBox = function() {
              var xt, ct = this.options.chart, ft = this.renderer, St = this.chartWidth, Mt = this.chartHeight, Dt = this.styledMode, Ot = this.plotBGImage, Nt = ct.backgroundColor, Wt = ct.plotBackgroundColor, zt = ct.plotBackgroundImage, Ht = this.plotLeft, Kt = this.plotTop, Gt = this.plotWidth, ee = this.plotHeight, Jt = this.plotBox, Qt = this.clipRect, ne = this.clipBox, ae = this.chartBackground, Me = this.plotBackground, he = this.plotBorder, fe = "animate";
              if (ae || (this.chartBackground = ae = ft.rect().addClass("highcharts-background").add(), fe = "attr"), Dt)
                var Ee = xt = ae.strokeWidth();
              else
                xt = (Ee = ct.borderWidth || 0) + (ct.shadow ? 8 : 0), Nt = { fill: Nt || "none" }, (Ee || ae["stroke-width"]) && (Nt.stroke = ct.borderColor, Nt["stroke-width"] = Ee), ae.attr(Nt).shadow(ct.shadow);
              ae[fe]({ x: xt / 2, y: xt / 2, width: St - xt - Ee % 2, height: Mt - xt - Ee % 2, r: ct.borderRadius }), fe = "animate", Me || (fe = "attr", this.plotBackground = Me = ft.rect().addClass("highcharts-plot-background").add()), Me[fe](Jt), Dt || (Me.attr({ fill: Wt || "none" }).shadow(ct.plotShadow), zt && (Ot ? (zt !== Ot.attr("href") && Ot.attr("href", zt), Ot.animate(Jt)) : this.plotBGImage = ft.image(zt, Ht, Kt, Gt, ee).add())), Qt ? Qt.animate({ width: ne.width, height: ne.height }) : this.clipRect = ft.clipRect(ne), fe = "animate", he || (fe = "attr", this.plotBorder = he = ft.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), Dt || he.attr({ stroke: ct.plotBorderColor, "stroke-width": ct.plotBorderWidth || 0, fill: "none" }), he[fe](he.crisp({ x: Ht, y: Kt, width: Gt, height: ee }, -he.strokeWidth())), this.isDirtyBox = !1, W(this, "afterDrawChartBox");
            }, Tt.prototype.propFromSeries = function() {
              var xt, ct, ft, St = this, Mt = St.options.chart, Dt = St.options.series;
              ["inverted", "angular", "polar"].forEach(function(Ot) {
                for (ct = o[Mt.type || Mt.defaultSeriesType], ft = Mt[Ot] || ct && ct.prototype[Ot], xt = Dt && Dt.length; !ft && xt--; )
                  (ct = o[Dt[xt].type]) && ct.prototype[Ot] && (ft = !0);
                St[Ot] = ft;
              });
            }, Tt.prototype.linkSeries = function() {
              var xt = this, ct = xt.series;
              ct.forEach(function(ft) {
                ft.linkedSeries.length = 0;
              }), ct.forEach(function(ft) {
                var St = ft.options.linkedTo;
                V(St) && (St = St === ":previous" ? xt.series[ft.index - 1] : xt.get(St)) && St.linkedParent !== ft && (St.linkedSeries.push(ft), ft.linkedParent = St, St.enabledDataSorting && ft.setDataSortingOptions(), ft.visible = ot(ft.options.visible, St.options.visible, ft.visible));
              }), W(this, "afterLinkSeries");
            }, Tt.prototype.renderSeries = function() {
              this.series.forEach(function(xt) {
                xt.translate(), xt.render();
              });
            }, Tt.prototype.renderLabels = function() {
              var xt = this, ct = xt.options.labels;
              ct.items && ct.items.forEach(function(ft) {
                var St = T(ct.style, ft.style), Mt = it(St.left) + xt.plotLeft, Dt = it(St.top) + xt.plotTop + 12;
                delete St.left, delete St.top, xt.renderer.text(ft.html, Mt, Dt).attr({ zIndex: 2 }).css(St).add();
              });
            }, Tt.prototype.render = function() {
              var xt = this.axes, ct = this.colorAxis, ft = this.renderer, St = this.options, Mt = function(zt) {
                zt.forEach(function(Ht) {
                  Ht.visible && Ht.render();
                });
              }, Dt = 0;
              this.setTitle(), this.legend = new q(this, St.legend), this.getStacks && this.getStacks(), this.getMargins(!0), this.setChartSize(), St = this.plotWidth, xt.some(function(zt) {
                if (zt.horiz && zt.visible && zt.options.labels.enabled && zt.series.length)
                  return Dt = 21, !0;
              });
              var Ot = this.plotHeight = Math.max(this.plotHeight - Dt, 0);
              xt.forEach(function(zt) {
                zt.setScale();
              }), this.getAxisMargins();
              var Nt = 1.1 < St / this.plotWidth, Wt = 1.05 < Ot / this.plotHeight;
              (Nt || Wt) && (xt.forEach(function(zt) {
                (zt.horiz && Nt || !zt.horiz && Wt) && zt.setTickInterval(!0);
              }), this.getMargins()), this.drawChartBox(), this.hasCartesianSeries ? Mt(xt) : ct && ct.length && Mt(ct), this.seriesGroup || (this.seriesGroup = ft.g("series-group").attr({ zIndex: 3 }).add()), this.renderSeries(), this.renderLabels(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
            }, Tt.prototype.addCredits = function(xt) {
              var ct = this, ft = X(!0, this.options.credits, xt);
              ft.enabled && !this.credits && (this.credits = this.renderer.text(ft.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                ft.href && (n.location.href = ft.href);
              }).attr({ align: ft.position.align, zIndex: 8 }), ct.styledMode || this.credits.css(ft.style), this.credits.add().align(ft.position), this.credits.update = function(St) {
                ct.credits = ct.credits.destroy(), ct.addCredits(St);
              });
            }, Tt.prototype.destroy = function() {
              var xt, ct = this, ft = ct.axes, St = ct.series, Mt = ct.container, Dt = Mt && Mt.parentNode;
              for (W(ct, "destroy"), ct.renderer.forExport ? p(y, ct) : y[ct.index] = void 0, Q.chartCount--, ct.renderTo.removeAttribute("data-highcharts-chart"), mt(ct), xt = ft.length; xt--; )
                ft[xt] = ft[xt].destroy();
              for (this.scroller && this.scroller.destroy && this.scroller.destroy(), xt = St.length; xt--; )
                St[xt] = St[xt].destroy();
              "title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(Ot) {
                var Nt = ct[Ot];
                Nt && Nt.destroy && (ct[Ot] = Nt.destroy());
              }), Mt && (Mt.innerHTML = m.emptyHTML, mt(Mt), Dt && O(Mt)), et(ct, function(Ot, Nt) {
                delete ct[Nt];
              });
            }, Tt.prototype.firstRender = function() {
              var xt = this, ct = xt.options;
              xt.isReadyToRender && !xt.isReadyToRender() || (xt.getContainer(), xt.resetMargins(), xt.setChartSize(), xt.propFromSeries(), xt.getAxes(), (I(ct.series) ? ct.series : []).forEach(function(ft) {
                xt.initSeries(ft);
              }), xt.linkSeries(), xt.setSeriesData(), W(xt, "beforeRender"), N && (U.isRequired() ? xt.pointer = new U(xt, ct) : xt.pointer = new N(xt, ct)), xt.render(), xt.pointer.getChartPosition(), xt.renderer.imgCount || xt.hasLoaded || xt.onload(), xt.temporaryDisplay(!0));
            }, Tt.prototype.onload = function() {
              this.callbacks.concat([this.callback]).forEach(function(xt) {
                xt && this.index !== void 0 && xt.apply(this, [this]);
              }, this), W(this, "load"), W(this, "render"), M(this.index) && this.setReflow(this.options.chart.reflow), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
            }, Tt.prototype.warnIfA11yModuleNotLoaded = function() {
              var xt = this.options, ct = this.title;
              xt && !this.accessibility && (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (ct && ct.element.textContent || "").replace(/</g, "&lt;") }), xt.accessibility && xt.accessibility.enabled === !1 || w('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }, Tt.prototype.addSeries = function(xt, ct, ft) {
              var St, Mt = this;
              return xt && (ct = ot(ct, !0), W(Mt, "addSeries", { options: xt }, function() {
                St = Mt.initSeries(xt), Mt.isDirtyLegend = !0, Mt.linkSeries(), St.enabledDataSorting && St.setData(xt.data, !1), W(Mt, "afterAddSeries", { series: St }), ct && Mt.redraw(ft);
              })), St;
            }, Tt.prototype.addAxis = function(xt, ct, ft, St) {
              return this.createAxis(ct ? "xAxis" : "yAxis", { axis: xt, redraw: ft, animation: St });
            }, Tt.prototype.addColorAxis = function(xt, ct, ft) {
              return this.createAxis("colorAxis", { axis: xt, redraw: ct, animation: ft });
            }, Tt.prototype.createAxis = function(xt, ct) {
              return xt = new F(this, X(ct.axis, { index: this[xt].length, isX: xt === "xAxis" })), ot(ct.redraw, !0) && this.redraw(ct.animation), xt;
            }, Tt.prototype.showLoading = function(xt) {
              var ct = this, ft = ct.options, St = ft.loading, Mt = function() {
                Dt && C(Dt, { left: ct.plotLeft + "px", top: ct.plotTop + "px", width: ct.plotWidth + "px", height: ct.plotHeight + "px" });
              }, Dt = ct.loadingDiv, Ot = ct.loadingSpan;
              Dt || (ct.loadingDiv = Dt = h("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, ct.container)), Ot || (ct.loadingSpan = Ot = h("span", { className: "highcharts-loading-inner" }, null, Dt), i(ct, "redraw", Mt)), Dt.className = "highcharts-loading", m.setElementHTML(Ot, ot(xt, ft.lang.loading, "")), ct.styledMode || (C(Dt, T(St.style, { zIndex: 10 })), C(Ot, St.labelStyle), ct.loadingShown || (C(Dt, { opacity: 0, display: "" }), v(Dt, { opacity: St.style.opacity || 0.5 }, { duration: St.showDuration || 0 }))), ct.loadingShown = !0, Mt();
            }, Tt.prototype.hideLoading = function() {
              var xt = this.options, ct = this.loadingDiv;
              ct && (ct.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || v(ct, { opacity: 0 }, { duration: xt.loading.hideDuration || 100, complete: function() {
                C(ct, { display: "none" });
              } })), this.loadingShown = !1;
            }, Tt.prototype.update = function(xt, ct, ft, St) {
              var Mt, Dt, Ot = this, Nt = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, Wt = xt.isResponsiveOptions, zt = [];
              W(Ot, "update", { options: xt }), Wt || Ot.setResponsive(!1, !0), xt = l(xt, Ot.options), Ot.userOptions = X(Ot.userOptions, xt);
              var Ht = xt.chart;
              if (Ht) {
                if (X(!0, Ot.options.chart, Ht), "className" in Ht && Ot.setClassName(Ht.className), "reflow" in Ht && Ot.setReflow(Ht.reflow), "inverted" in Ht || "polar" in Ht || "type" in Ht) {
                  Ot.propFromSeries();
                  var Kt = !0;
                }
                "alignTicks" in Ht && (Kt = !0), "events" in Ht && u(this, Ht), et(Ht, function(Gt, ee) {
                  Ot.propsRequireUpdateSeries.indexOf("chart." + ee) !== -1 && (Mt = !0), Ot.propsRequireDirtyBox.indexOf(ee) !== -1 && (Ot.isDirtyBox = !0), Ot.propsRequireReflow.indexOf(ee) !== -1 && (Wt ? Ot.isDirtyBox = !0 : Dt = !0);
                }), !Ot.styledMode && Ht.style && Ot.renderer.setStyle(Ot.options.chart.style || {});
              }
              !Ot.styledMode && xt.colors && (this.options.colors = xt.colors), xt.time && (this.time === P && (this.time = new b(xt.time)), X(!0, Ot.options.time, xt.time)), et(xt, function(Gt, ee) {
                Ot[ee] && typeof Ot[ee].update == "function" ? Ot[ee].update(Gt, !1) : typeof Ot[Nt[ee]] == "function" ? Ot[Nt[ee]](Gt) : ee !== "colors" && Ot.collectionsWithUpdate.indexOf(ee) === -1 && X(!0, Ot.options[ee], xt[ee]), ee !== "chart" && Ot.propsRequireUpdateSeries.indexOf(ee) !== -1 && (Mt = !0);
              }), this.collectionsWithUpdate.forEach(function(Gt) {
                if (xt[Gt]) {
                  var ee = [];
                  Ot[Gt].forEach(function(Jt, Qt) {
                    Jt.options.isInternal || ee.push(ot(Jt.options.index, Qt));
                  }), Ct(xt[Gt]).forEach(function(Jt, Qt) {
                    var ne, ae = M(Jt.id);
                    ae && (ne = Ot.get(Jt.id)), !ne && Ot[Gt] && (ne = Ot[Gt][ee ? ee[Qt] : Qt]) && ae && M(ne.options.id) && (ne = void 0), ne && ne.coll === Gt && (ne.update(Jt, !1), ft && (ne.touched = !0)), !ne && ft && Ot.collectionsWithInit[Gt] && (Ot.collectionsWithInit[Gt][0].apply(Ot, [Jt].concat(Ot.collectionsWithInit[Gt][1] || []).concat([!1])).touched = !0);
                  }), ft && Ot[Gt].forEach(function(Jt) {
                    Jt.touched || Jt.options.isInternal ? delete Jt.touched : zt.push(Jt);
                  });
                }
              }), zt.forEach(function(Gt) {
                Gt.chart && Gt.remove && Gt.remove(!1);
              }), Kt && Ot.axes.forEach(function(Gt) {
                Gt.update({}, !1);
              }), Mt && Ot.getSeriesOrderByLinks().forEach(function(Gt) {
                Gt.chart && Gt.update({}, !1);
              }, this), Kt = Ht && Ht.width, Ht = Ht && (V(Ht.height) ? pt(Ht.height, Kt || Ot.chartWidth) : Ht.height), Dt || j(Kt) && Kt !== Ot.chartWidth || j(Ht) && Ht !== Ot.chartHeight ? Ot.setSize(Kt, Ht, St) : ot(ct, !0) && Ot.redraw(St), W(Ot, "afterUpdate", { options: xt, redraw: ct, animation: St });
            }, Tt.prototype.setSubtitle = function(xt, ct) {
              this.applyDescription("subtitle", xt), this.layOutTitles(ct);
            }, Tt.prototype.setCaption = function(xt, ct) {
              this.applyDescription("caption", xt), this.layOutTitles(ct);
            }, Tt.prototype.showResetZoom = function() {
              function xt() {
                ct.zoomOut();
              }
              var ct = this, ft = E.lang, St = ct.options.chart.zooming.resetButton, Mt = St.theme, Dt = St.relativeTo === "chart" || St.relativeTo === "spacingBox" ? null : "scrollablePlotBox";
              W(this, "beforeShowResetZoom", null, function() {
                ct.resetZoomButton = ct.renderer.button(ft.resetZoom, null, null, xt, Mt).attr({ align: St.position.align, title: ft.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(St.position, !1, Dt);
              }), W(this, "afterShowResetZoom");
            }, Tt.prototype.zoomOut = function() {
              W(this, "selection", { resetSelection: !0 }, this.zoom);
            }, Tt.prototype.zoom = function(xt) {
              var ct, ft = this, St = ft.pointer, Mt = !1;
              !xt || xt.resetSelection ? (ft.axes.forEach(function(Ot) {
                ct = Ot.zoom();
              }), St.initiated = !1) : xt.xAxis.concat(xt.yAxis).forEach(function(Ot) {
                var Nt = Ot.axis;
                (St[Nt.isXAxis ? "zoomX" : "zoomY"] && M(St.mouseDownX) && M(St.mouseDownY) && ft.isInsidePlot(St.mouseDownX - ft.plotLeft, St.mouseDownY - ft.plotTop, { axis: Nt }) || !M(ft.inverted ? St.mouseDownX : St.mouseDownY)) && (ct = Nt.zoom(Ot.min, Ot.max), Nt.displayBtn && (Mt = !0));
              });
              var Dt = ft.resetZoomButton;
              Mt && !Dt ? ft.showResetZoom() : !Mt && Z(Dt) && (ft.resetZoomButton = Dt.destroy()), ct && ft.redraw(ot(ft.options.chart.animation, xt && xt.animation, 100 > ft.pointCount));
            }, Tt.prototype.pan = function(xt, ct) {
              var ft = this, St = ft.hoverPoints;
              ct = typeof ct == "object" ? ct : { enabled: ct, type: "x" };
              var Mt = ft.options.chart;
              Mt && Mt.panning && (Mt.panning = ct);
              var Dt, Ot = ct.type;
              W(this, "pan", { originalEvent: xt }, function() {
                St && St.forEach(function(zt) {
                  zt.setState();
                });
                var Nt = ft.xAxis;
                Ot === "xy" ? Nt = Nt.concat(ft.yAxis) : Ot === "y" && (Nt = ft.yAxis);
                var Wt = {};
                Nt.forEach(function(zt) {
                  if (zt.options.panningEnabled && !zt.options.isInternal) {
                    var Ht = zt.horiz, Kt = xt[Ht ? "chartX" : "chartY"], Gt = ft[Ht = Ht ? "mouseDownX" : "mouseDownY"], ee = zt.minPointOffset || 0, Jt = zt.reversed && !ft.inverted || !zt.reversed && ft.inverted ? -1 : 1, Qt = zt.getExtremes(), ne = zt.toValue(Gt - Kt, !0) + ee * Jt, ae = zt.toValue(Gt + zt.len - Kt, !0) - (ee * Jt || zt.isXAxis && zt.pointRangePadding || 0), Me = ae < ne;
                    Jt = zt.hasVerticalPanning(), Gt = Me ? ae : ne, ne = Me ? ne : ae;
                    var he = zt.panningState;
                    !Jt || zt.isXAxis || he && !he.isDirty || zt.series.forEach(function(fe) {
                      var Ee = fe.getProcessedData(!0);
                      Ee = fe.getExtremes(Ee.yData, !0), he || (he = { startMin: Number.MAX_VALUE, startMax: -Number.MAX_VALUE }), j(Ee.dataMin) && j(Ee.dataMax) && (he.startMin = Math.min(ot(fe.options.threshold, 1 / 0), Ee.dataMin, he.startMin), he.startMax = Math.max(ot(fe.options.threshold, -1 / 0), Ee.dataMax, he.startMax));
                    }), Jt = Math.min(ot(he && he.startMin, Qt.dataMin), ee ? Qt.min : zt.toValue(zt.toPixels(Qt.min) - zt.minPixelPadding)), ae = Math.max(ot(he && he.startMax, Qt.dataMax), ee ? Qt.max : zt.toValue(zt.toPixels(Qt.max) + zt.minPixelPadding)), zt.panningState = he, zt.isOrdinal || (0 < (ee = Jt - Gt) && (ne += ee, Gt = Jt), 0 < (ee = ne - ae) && (ne = ae, Gt -= ee), zt.series.length && Gt !== Qt.min && ne !== Qt.max && Gt >= Jt && ne <= ae && (zt.setExtremes(Gt, ne, !1, !1, { trigger: "pan" }), !ft.resetZoomButton && Gt !== Jt && ne !== ae && Ot.match("y") && (ft.showResetZoom(), zt.displayBtn = !1), Dt = !0), Wt[Ht] = Kt);
                  }
                }), et(Wt, function(zt, Ht) {
                  ft[Ht] = zt;
                }), Dt && ft.redraw(!1), C(ft.container, { cursor: "move" });
              });
            }, Tt;
          }(), T(G.prototype, { callbacks: [], collectionsWithInit: { xAxis: [G.prototype.addAxis, [!0]], yAxis: [G.prototype.addAxis, [!1]], series: [G.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: "backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "), propsRequireReflow: "margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "), propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" ") }), G;
        }), _(at, "Core/Legend/LegendSymbol.js", [at["Core/Utilities.js"]], function(G) {
          var F, $ = G.extend, Y = G.merge, J = G.pick;
          return function(Q) {
            Q.drawLineMarker = function(q) {
              var U = this.legendItem = this.legendItem || {}, N = this.options, D = q.symbolWidth, k = q.symbolHeight, A = k / 2, b = this.chart.renderer, d = U.group;
              q = q.baseline - Math.round(0.3 * q.fontMetrics.b);
              var m = {}, v = N.marker, g = 0;
              this.chart.styledMode || (m = { "stroke-width": Math.min(N.lineWidth || 0, 24) }, N.dashStyle ? m.dashstyle = N.dashStyle : N.linecap !== "square" && (m["stroke-linecap"] = "round")), U.line = b.path().addClass("highcharts-graph").attr(m).add(d), m["stroke-linecap"] && (g = Math.min(U.line.strokeWidth(), D) / 2), U.line.attr({ d: [["M", g, q], ["L", D - g, q]] }), v && v.enabled !== !1 && D && (N = Math.min(J(v.radius, A), A), this.symbol.indexOf("url") === 0 && (v = Y(v, { width: k, height: k }), N = 0), U.symbol = U = b.symbol(this.symbol, D / 2 - N, q - N, 2 * N, 2 * N, $({ context: "legend" }, v)).addClass("highcharts-point").add(d), U.isMarker = !0);
            }, Q.drawRectangle = function(q, U) {
              U = U.legendItem || {};
              var N = q.symbolHeight, D = q.options.squareSymbol;
              U.symbol = this.chart.renderer.rect(D ? (q.symbolWidth - N) / 2 : 0, q.baseline - N + 1, D ? N : q.symbolWidth, N, J(q.options.symbolRadius, N / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(U.group);
            };
          }(F || (F = {})), F;
        }), _(at, "Core/Series/SeriesDefaults.js", [], function() {
          return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 50 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
            var G = this.series.chart.numberFormatter;
            return typeof this.y != "number" ? "" : G(this.y, -1);
          }, padding: 5, style: { fontSize: "11px", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 50 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 50 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
        }), _(at, "Core/Series/Series.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Defaults.js"], at["Core/Foundation.js"], at["Core/Globals.js"], at["Core/Legend/LegendSymbol.js"], at["Core/Series/Point.js"], at["Core/Series/SeriesDefaults.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Renderer/SVG/SVGElement.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N, D) {
          var k = G.animObject, A = G.setAnimation, b = F.defaultOptions, d = $.registerEventOptions, m = Y.hasTouch, v = Y.svg, g = Y.win, x = U.seriesTypes, E = D.arrayMax, P = D.arrayMin, S = D.clamp, u = D.cleanRecursively, y = D.correctFloat, s = D.defined, a = D.erase, e = D.error, n = D.extend, o = D.find, i = D.fireEvent, c = D.getNestedProperty, l = D.isArray, h = D.isNumber, C = D.isString, M = D.merge, O = D.objectEach, p = D.pick, w = D.removeEvent, T = D.splat, z = D.syncTimeout;
          return G = function() {
            function W() {
              this.zones = this.yAxis = this.xAxis = this.userOptions = this.tooltipOptions = this.processedYData = this.processedXData = this.points = this.options = this.linkedSeries = this.index = this.eventsToUnbind = this.eventOptions = this.data = this.chart = this._i = void 0;
            }
            return W.prototype.init = function(L, I) {
              i(this, "init", { options: I });
              var j = this, Z = L.series;
              this.eventsToUnbind = [], j.chart = L, j.options = j.setOptions(I), I = j.options, j.linkedSeries = [], j.bindAxes(), n(j, { name: I.name, state: "", visible: I.visible !== !1, selected: I.selected === !0 }), d(this, I);
              var V, X = I.events;
              (X && X.click || I.point && I.point.events && I.point.events.click || I.allowPointSelect) && (L.runTrackerClick = !0), j.getColor(), j.getSymbol(), j.parallelArrays.forEach(function(et) {
                j[et + "Data"] || (j[et + "Data"] = []);
              }), j.isCartesian && (L.hasCartesianSeries = !0), Z.length && (V = Z[Z.length - 1]), j._i = p(V && V._i, -1) + 1, j.opacity = j.options.opacity, L.orderSeries(this.insert(Z)), I.dataSorting && I.dataSorting.enabled ? j.setDataSortingOptions() : j.points || j.data || j.setData(I.data, !1), i(this, "afterInit");
            }, W.prototype.is = function(L) {
              return x[L] && this instanceof x[L];
            }, W.prototype.insert = function(L) {
              var I, j = this.options.index;
              if (h(j)) {
                for (I = L.length; I--; )
                  if (j >= p(L[I].options.index, L[I]._i)) {
                    L.splice(I + 1, 0, this);
                    break;
                  }
                I === -1 && L.unshift(this), I += 1;
              } else
                L.push(this);
              return p(I, L.length - 1);
            }, W.prototype.bindAxes = function() {
              var L, I = this, j = I.options, Z = I.chart;
              i(this, "bindAxes", null, function() {
                (I.axisTypes || []).forEach(function(V) {
                  var X = 0;
                  Z[V].forEach(function(et) {
                    L = et.options, (j[V] === X && !L.isInternal || j[V] !== void 0 && j[V] === L.id || j[V] === void 0 && L.index === 0) && (I.insert(et.series), I[V] = et, et.isDirty = !0), L.isInternal || X++;
                  }), I[V] || I.optionalAxis === V || e(18, !0, Z);
                });
              }), i(this, "afterBindAxes");
            }, W.prototype.updateParallelArrays = function(L, I) {
              var j = L.series, Z = arguments, V = h(I) ? function(X) {
                var et = X === "y" && j.toYData ? j.toYData(L) : L[X];
                j[X + "Data"][I] = et;
              } : function(X) {
                Array.prototype[I].apply(j[X + "Data"], Array.prototype.slice.call(Z, 2));
              };
              j.parallelArrays.forEach(V);
            }, W.prototype.hasData = function() {
              return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && 0 < this.yData.length;
            }, W.prototype.autoIncrement = function(L) {
              var I, j = this.options, Z = j.pointIntervalUnit, V = j.relativeXValue, X = this.chart.time, et = this.xIncrement;
              return et = p(et, j.pointStart, 0), this.pointInterval = I = p(this.pointInterval, j.pointInterval, 1), V && h(L) && (I *= L), Z && (j = new X.Date(et), Z === "day" ? X.set("Date", j, X.get("Date", j) + I) : Z === "month" ? X.set("Month", j, X.get("Month", j) + I) : Z === "year" && X.set("FullYear", j, X.get("FullYear", j) + I), I = j.getTime() - et), V && h(L) ? et + I : (this.xIncrement = et + I, et);
            }, W.prototype.setDataSortingOptions = function() {
              var L = this.options;
              n(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), s(L.pointRange) || (L.pointRange = 1);
            }, W.prototype.setOptions = function(L) {
              var I = this.chart, j = I.options, Z = j.plotOptions, V = I.userOptions || {};
              L = M(L), I = I.styledMode;
              var X = { plotOptions: Z, userOptions: L };
              i(this, "setOptions", X);
              var et = X.plotOptions[this.type], ot = V.plotOptions || {};
              return this.userOptions = X.userOptions, V = M(et, Z.series, V.plotOptions && V.plotOptions[this.type], L), this.tooltipOptions = M(b.tooltip, b.plotOptions.series && b.plotOptions.series.tooltip, b.plotOptions[this.type].tooltip, j.tooltip.userOptions, Z.series && Z.series.tooltip, Z[this.type].tooltip, L.tooltip), this.stickyTracking = p(L.stickyTracking, ot[this.type] && ot[this.type].stickyTracking, ot.series && ot.series.stickyTracking, !(!this.tooltipOptions.shared || this.noSharedTooltip) || V.stickyTracking), et.marker === null && delete V.marker, this.zoneAxis = V.zoneAxis, Z = this.zones = (V.zones || []).slice(), !V.negativeColor && !V.negativeFillColor || V.zones || (j = { value: V[this.zoneAxis + "Threshold"] || V.threshold || 0, className: "highcharts-negative" }, I || (j.color = V.negativeColor, j.fillColor = V.negativeFillColor), Z.push(j)), Z.length && s(Z[Z.length - 1].value) && Z.push(I ? {} : { color: this.color, fillColor: this.fillColor }), i(this, "afterSetOptions", { options: V }), V;
            }, W.prototype.getName = function() {
              return p(this.options.name, "Series " + (this.index + 1));
            }, W.prototype.getCyclic = function(L, I, j) {
              var Z = this.chart, V = this.userOptions, X = L + "Index", et = L + "Counter", ot = j ? j.length : p(Z.options.chart[L + "Count"], Z[L + "Count"]);
              if (!I) {
                var it = p(V[X], V["_" + X]);
                s(it) || (Z.series.length || (Z[et] = 0), V["_" + X] = it = Z[et] % ot, Z[et] += 1), j && (I = j[it]);
              }
              it !== void 0 && (this[X] = it), this[L] = I;
            }, W.prototype.getColor = function() {
              this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || b.plotOptions[this.type].color, this.chart.options.colors);
            }, W.prototype.getPointsCollection = function() {
              return (this.hasGroupedData ? this.points : this.data) || [];
            }, W.prototype.getSymbol = function() {
              this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
            }, W.prototype.findPointIndex = function(L, I) {
              var j, Z, V = L.id, X = L.x, et = this.points, ot = this.options.dataSorting;
              if (V)
                (ot = this.chart.get(V)) instanceof Q && (j = ot);
              else if ((this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) && (j = function(pt) {
                return !pt.touched && pt.index === L.index;
              }, ot && ot.matchByName ? j = function(pt) {
                return !pt.touched && pt.name === L.name;
              } : this.options.relativeXValue && (j = function(pt) {
                return !pt.touched && pt.options.x === L.x;
              }), !(j = o(et, j))))
                return;
              if (j) {
                var it = j && j.index;
                it !== void 0 && (Z = !0);
              }
              return it === void 0 && h(X) && (it = this.xData.indexOf(X, I)), it !== -1 && it !== void 0 && this.cropped && (it = it >= this.cropStart ? it - this.cropStart : it), !Z && h(it) && et[it] && et[it].touched && (it = void 0), it;
            }, W.prototype.updateData = function(L, I) {
              var j, Z, V, X = this.options, et = X.dataSorting, ot = this.points, it = [], pt = this.requireSorting, mt = L.length === ot.length, Ct = !0;
              if (this.xIncrement = null, L.forEach(function(kt, Lt) {
                var Tt = s(kt) && this.pointClass.prototype.optionsToObject.call({ series: this }, kt) || {}, xt = Tt.x;
                Tt.id || h(xt) ? ((Tt = this.findPointIndex(Tt, V)) === -1 || Tt === void 0 ? it.push(kt) : ot[Tt] && kt !== X.data[Tt] ? (ot[Tt].update(kt, !1, null, !1), ot[Tt].touched = !0, pt && (V = Tt + 1)) : ot[Tt] && (ot[Tt].touched = !0), (!mt || Lt !== Tt || et && et.enabled || this.hasDerivedData) && (j = !0)) : it.push(kt);
              }, this), j)
                for (L = ot.length; L--; )
                  (Z = ot[L]) && !Z.touched && Z.remove && Z.remove(!1, I);
              else
                !mt || et && et.enabled ? Ct = !1 : (L.forEach(function(kt, Lt) {
                  kt !== ot[Lt].y && ot[Lt].update && ot[Lt].update(kt, !1, null, !1);
                }), it.length = 0);
              return ot.forEach(function(kt) {
                kt && (kt.touched = !1);
              }), !!Ct && (it.forEach(function(kt) {
                this.addPoint(kt, !1, null, null, !1);
              }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = E(this.xData), this.autoIncrement()), !0);
            }, W.prototype.setData = function(L, I, j, Z) {
              I === void 0 && (I = !0);
              var V = this, X = V.points, et = X && X.length || 0, ot = V.options, it = V.chart, pt = ot.dataSorting, mt = V.xAxis, Ct = ot.turboThreshold, kt = this.xData, Lt = this.yData, Tt = V.pointArrayMap;
              Tt = Tt && Tt.length;
              var xt, ct = ot.keys, ft = 0, St = 1, Mt = null;
              if (!it.options.chart.allowMutatingData) {
                ot.data && delete V.options.data, V.userOptions.data && delete V.userOptions.data;
                var Dt = M(!0, L);
              }
              if (Dt = (L = Dt || L || []).length, pt && pt.enabled && (L = this.sortData(L)), it.options.chart.allowMutatingData && Z !== !1 && Dt && et && !V.cropped && !V.hasGroupedData && V.visible && !V.boosted && (xt = this.updateData(L, j)), !xt) {
                if (V.xIncrement = null, V.colorCounter = 0, this.parallelArrays.forEach(function(Ot) {
                  V[Ot + "Data"].length = 0;
                }), Ct && Dt > Ct)
                  if (Mt = V.getFirstValidPoint(L), h(Mt))
                    for (j = 0; j < Dt; j++)
                      kt[j] = this.autoIncrement(), Lt[j] = L[j];
                  else if (l(Mt))
                    if (Tt)
                      if (Mt.length === Tt)
                        for (j = 0; j < Dt; j++)
                          kt[j] = this.autoIncrement(), Lt[j] = L[j];
                      else
                        for (j = 0; j < Dt; j++)
                          Z = L[j], kt[j] = Z[0], Lt[j] = Z.slice(1, Tt + 1);
                    else if (ct && (ft = 0 <= (ft = ct.indexOf("x")) ? ft : 0, St = 0 <= (St = ct.indexOf("y")) ? St : 1), Mt.length === 1 && (St = 0), ft === St)
                      for (j = 0; j < Dt; j++)
                        kt[j] = this.autoIncrement(), Lt[j] = L[j][St];
                    else
                      for (j = 0; j < Dt; j++)
                        Z = L[j], kt[j] = Z[ft], Lt[j] = Z[St];
                  else
                    e(12, !1, it);
                else
                  for (j = 0; j < Dt; j++)
                    L[j] !== void 0 && (Z = { series: V }, V.pointClass.prototype.applyOptions.apply(Z, [L[j]]), V.updateParallelArrays(Z, j));
                for (Lt && C(Lt[0]) && e(14, !0, it), V.data = [], V.options.data = V.userOptions.data = L, j = et; j--; )
                  X[j] && X[j].destroy && X[j].destroy();
                mt && (mt.minRange = mt.userMinRange), V.isDirty = it.isDirtyBox = !0, V.isDirtyData = !!X, j = !1;
              }
              ot.legendType === "point" && (this.processData(), this.generatePoints()), I && it.redraw(j);
            }, W.prototype.sortData = function(L) {
              var I = this, j = I.options.dataSorting.sortKey || "y", Z = function(V, X) {
                return s(X) && V.pointClass.prototype.optionsToObject.call({ series: V }, X) || {};
              };
              return L.forEach(function(V, X) {
                L[X] = Z(I, V), L[X].index = X;
              }, this), L.concat().sort(function(V, X) {
                return V = c(j, V), (X = c(j, X)) < V ? -1 : X > V ? 1 : 0;
              }).forEach(function(V, X) {
                V.x = X;
              }, this), I.linkedSeries && I.linkedSeries.forEach(function(V) {
                var X = V.options, et = X.data;
                X.dataSorting && X.dataSorting.enabled || !et || (et.forEach(function(ot, it) {
                  et[it] = Z(V, ot), L[it] && (et[it].x = L[it].x, et[it].index = it);
                }), V.setData(et, !1));
              }), L;
            }, W.prototype.getProcessedData = function(L) {
              var I = this.xAxis, j = this.options, Z = j.cropThreshold, V = L || this.getExtremesFromAll || j.getExtremesFromAll, X = this.isCartesian;
              L = I && I.val2lin, j = !(!I || !I.logarithmic);
              var et = 0, ot = this.xData, it = this.yData, pt = this.requireSorting, mt = !1, Ct = ot.length;
              if (I) {
                var kt = (mt = I.getExtremes()).min, Lt = mt.max;
                mt = !(!I.categories || I.names.length);
              }
              if (X && this.sorted && !V && (!Z || Ct > Z || this.forceCrop)) {
                if (ot[Ct - 1] < kt || ot[0] > Lt)
                  ot = [], it = [];
                else if (this.yData && (ot[0] < kt || ot[Ct - 1] > Lt)) {
                  var Tt = this.cropData(this.xData, this.yData, kt, Lt);
                  ot = Tt.xData, it = Tt.yData, et = Tt.start, Tt = !0;
                }
              }
              for (Z = ot.length || 1; --Z; )
                if (0 < (I = j ? L(ot[Z]) - L(ot[Z - 1]) : ot[Z] - ot[Z - 1]) && (xt === void 0 || I < xt))
                  var xt = I;
                else
                  0 > I && pt && !mt && (e(15, !1, this.chart), pt = !1);
              return { xData: ot, yData: it, cropped: Tt, cropStart: et, closestPointRange: xt };
            }, W.prototype.processData = function(L) {
              var I = this.xAxis;
              if (this.isCartesian && !this.isDirty && !I.isDirty && !this.yAxis.isDirty && !L)
                return !1;
              L = this.getProcessedData(), this.cropped = L.cropped, this.cropStart = L.cropStart, this.processedXData = L.xData, this.processedYData = L.yData, this.closestPointRange = this.basePointRange = L.closestPointRange, i(this, "afterProcessData");
            }, W.prototype.cropData = function(L, I, j, Z, V) {
              var X, et = L.length, ot = 0, it = et;
              for (V = p(V, this.cropShoulder), X = 0; X < et; X++)
                if (L[X] >= j) {
                  ot = Math.max(0, X - V);
                  break;
                }
              for (j = X; j < et; j++)
                if (L[j] > Z) {
                  it = j + V;
                  break;
                }
              return { xData: L.slice(ot, it), yData: I.slice(ot, it), start: ot, end: it };
            }, W.prototype.generatePoints = function() {
              var L = this.options, I = this.processedData || L.data, j = this.processedXData, Z = this.processedYData, V = this.pointClass, X = j.length, et = this.cropStart || 0, ot = this.hasGroupedData, it = L.keys, pt = [];
              L = L.dataGrouping && L.dataGrouping.groupAll ? et : 0;
              var mt, Ct, kt = this.data;
              if (!kt && !ot) {
                var Lt = [];
                Lt.length = I.length, kt = this.data = Lt;
              }
              for (it && ot && (this.options.keys = !1), Ct = 0; Ct < X; Ct++) {
                if (Lt = et + Ct, ot) {
                  var Tt = new V().init(this, [j[Ct]].concat(T(Z[Ct])));
                  Tt.dataGroup = this.groupMap[L + Ct], Tt.dataGroup.options && (Tt.options = Tt.dataGroup.options, n(Tt, Tt.dataGroup.options), delete Tt.dataLabels);
                } else
                  (Tt = kt[Lt]) || I[Lt] === void 0 || (kt[Lt] = Tt = new V().init(this, I[Lt], j[Ct]));
                Tt && (Tt.index = ot ? L + Ct : Lt, pt[Ct] = Tt);
              }
              if (this.options.keys = it, kt && (X !== (mt = kt.length) || ot))
                for (Ct = 0; Ct < mt; Ct++)
                  Ct !== et || ot || (Ct += X), kt[Ct] && (kt[Ct].destroyElements(), kt[Ct].plotX = void 0);
              this.data = kt, this.points = pt, i(this, "afterGeneratePoints");
            }, W.prototype.getXExtremes = function(L) {
              return { min: P(L), max: E(L) };
            }, W.prototype.getExtremes = function(L, I) {
              var j = this.xAxis, Z = this.yAxis, V = this.processedXData || this.xData, X = [], et = this.requireSorting ? this.cropShoulder : 0;
              Z = !!Z && Z.positiveValuesOnly;
              var ot, it = 0, pt = 0, mt = 0, Ct = (L = L || this.stackedYData || this.processedYData || []).length;
              if (j) {
                var kt = j.getExtremes();
                it = kt.min, pt = kt.max;
              }
              for (ot = 0; ot < Ct; ot++) {
                var Lt = V[ot];
                kt = L[ot];
                var Tt = (h(kt) || l(kt)) && (kt.length || 0 < kt || !Z);
                if (Lt = I || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !j || (V[ot + et] || Lt) >= it && (V[ot - et] || Lt) <= pt, Tt && Lt)
                  if (Tt = kt.length)
                    for (; Tt--; )
                      h(kt[Tt]) && (X[mt++] = kt[Tt]);
                  else
                    X[mt++] = kt;
              }
              return L = { activeYData: X, dataMin: P(X), dataMax: E(X) }, i(this, "afterGetExtremes", { dataExtremes: L }), L;
            }, W.prototype.applyExtremes = function() {
              var L = this.getExtremes();
              return this.dataMin = L.dataMin, this.dataMax = L.dataMax, L;
            }, W.prototype.getFirstValidPoint = function(L) {
              for (var I = L.length, j = 0, Z = null; Z === null && j < I; )
                Z = L[j], j++;
              return Z;
            }, W.prototype.translate = function() {
              this.processedXData || this.processData(), this.generatePoints();
              var L, I, j = this.options, Z = j.stacking, V = this.xAxis, X = V.categories, et = this.enabledDataSorting, ot = this.yAxis, it = this.points, pt = it.length, mt = this.pointPlacementToXValue(), Ct = !!mt, kt = j.threshold, Lt = j.startFromThreshold ? kt : 0, Tt = this.zoneAxis || "y", xt = Number.MAX_VALUE;
              for (L = 0; L < pt; L++) {
                var ct = it[L], ft = ct.x, St = void 0, Mt = void 0, Dt = ct.y, Ot = ct.low, Nt = Z && ot.stacking && ot.stacking.stacks[(this.negStacks && Dt < (Lt ? 0 : kt) ? "-" : "") + this.stackKey];
                if ((ot.positiveValuesOnly && !ot.validatePositiveValue(Dt) || V.positiveValuesOnly && !V.validatePositiveValue(ft)) && (ct.isNull = !0), ct.plotX = I = y(S(V.translate(ft, 0, 0, 0, 1, mt, this.type === "flags"), -1e5, 1e5)), Z && this.visible && Nt && Nt[ft]) {
                  var Wt = this.getStackIndicator(Wt, ft, this.index);
                  !ct.isNull && Wt.key && (Mt = (St = Nt[ft]).points[Wt.key]), St && l(Mt) && (Ot = Mt[0], Dt = Mt[1], Ot === Lt && Wt.key === Nt[ft].base && (Ot = p(h(kt) ? kt : ot.min)), ot.positiveValuesOnly && s(Ot) && 0 >= Ot && (Ot = void 0), ct.total = ct.stackTotal = p(St.total), ct.percentage = s(ct.y) && St.total ? ct.y / St.total * 100 : void 0, ct.stackY = Dt, this.irregularWidths || St.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis));
                }
                if (ct.yBottom = s(Ot) ? S(ot.translate(Ot, 0, 1, 0, 1), -1e5, 1e5) : void 0, this.dataModify && (Dt = this.dataModify.modifyValue(Dt, L)), ct.plotY = void 0, h(Dt) && (St = ot.translate(Dt, !1, !0, !1, !0)) !== void 0 && (ct.plotY = S(St, -1e5, 1e5)), ct.isInside = this.isPointInside(ct), ct.clientX = Ct ? y(V.translate(ft, 0, 0, 0, 1, mt)) : I, ct.negative = ct[Tt] < (j[Tt + "Threshold"] || kt || 0), ct.category = p(X && X[ct.x], ct.x), !ct.isNull && ct.visible !== !1) {
                  zt !== void 0 && (xt = Math.min(xt, Math.abs(I - zt)));
                  var zt = I;
                }
                ct.zone = this.zones.length ? ct.getZone() : void 0, !ct.graphic && this.group && et && (ct.isNew = !0);
              }
              this.closestPointRangePx = xt, i(this, "afterTranslate");
            }, W.prototype.getValidPoints = function(L, I, j) {
              var Z = this.chart;
              return (L || this.points || []).filter(function(V) {
                return !(I && !Z.isInsidePlot(V.plotX, V.plotY, { inverted: Z.inverted })) && V.visible !== !1 && (j || !V.isNull);
              });
            }, W.prototype.getClipBox = function() {
              var L = this.chart, I = this.xAxis, j = this.yAxis, Z = M(L.clipBox);
              return I && I.len !== L.plotSizeX && (Z.width = I.len), j && j.len !== L.plotSizeY && (Z.height = j.len), Z;
            }, W.prototype.getSharedClipKey = function() {
              return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0);
            }, W.prototype.setClip = function() {
              var L = this.chart, I = this.group, j = this.markerGroup, Z = L.sharedClips;
              L = L.renderer;
              var V = this.getClipBox(), X = this.getSharedClipKey(), et = Z[X];
              et ? et.animate(V) : Z[X] = et = L.clipRect(V), I && I.clip(this.options.clip === !1 ? void 0 : et), j && j.clip();
            }, W.prototype.animate = function(L) {
              var I = this.chart, j = this.group, Z = this.markerGroup, V = I.inverted, X = k(this.options.animation), et = [this.getSharedClipKey(), X.duration, X.easing, X.defer].join(), ot = I.sharedClips[et], it = I.sharedClips[et + "m"];
              if (L && j)
                X = this.getClipBox(), ot ? ot.attr("height", X.height) : (X.width = 0, V && (X.x = I.plotHeight), ot = I.renderer.clipRect(X), I.sharedClips[et] = ot, it = I.renderer.clipRect({ x: -99, y: -99, width: V ? I.plotWidth + 199 : 99, height: V ? 99 : I.plotHeight + 199 }), I.sharedClips[et + "m"] = it), j.clip(ot), Z && Z.clip(it);
              else if (ot && !ot.hasClass("highcharts-animating")) {
                I = this.getClipBox();
                var pt = X.step;
                Z && Z.element.childNodes.length && (X.step = function(mt, Ct) {
                  pt && pt.apply(Ct, arguments), Ct.prop === "width" && it && it.element && it.attr(V ? "height" : "width", mt + 99);
                }), ot.addClass("highcharts-animating").animate(I, X);
              }
            }, W.prototype.afterAnimate = function() {
              var L = this;
              this.setClip(), O(this.chart.sharedClips, function(I, j, Z) {
                I && !L.chart.container.querySelector('[clip-path="url(#'.concat(I.id, ')"]')) && (I.destroy(), delete Z[j]);
              }), this.finishedAnimating = !0, i(this, "afterAnimate");
            }, W.prototype.drawPoints = function(L) {
              L === void 0 && (L = this.points);
              var I, j, Z = this.chart, V = Z.styledMode, X = this.colorAxis, et = this.options.marker, ot = this[this.specialGroup || "markerGroup"], it = this.xAxis, pt = p(et.enabled, !(it && !it.isRadial) || null, this.closestPointRangePx >= et.enabledThreshold * et.radius);
              if (et.enabled !== !1 || this._hasPointMarkers)
                for (I = 0; I < L.length; I++) {
                  var mt = L[I], Ct = (j = mt.graphic) ? "animate" : "attr", kt = mt.marker || {}, Lt = !!mt.marker;
                  if ((pt && kt.enabled === void 0 || kt.enabled) && !mt.isNull && mt.visible !== !1) {
                    var Tt = p(kt.symbol, this.symbol, "rect"), xt = this.markerAttribs(mt, mt.selected && "select");
                    this.enabledDataSorting && (mt.startXPos = it.reversed ? -(xt.width || 0) : it.width);
                    var ct = mt.isInside !== !1;
                    !j && ct && (0 < (xt.width || 0) || mt.hasImage) && (mt.graphic = j = Z.renderer.symbol(Tt, xt.x, xt.y, xt.width, xt.height, Lt ? kt : et).add(ot), this.enabledDataSorting && Z.hasRendered && (j.attr({ x: mt.startXPos }), Ct = "animate")), j && Ct === "animate" && j[ct ? "show" : "hide"](ct).animate(xt), j && (kt = this.pointAttribs(mt, V || !mt.selected ? void 0 : "select"), V ? X && j.css({ fill: kt.fill }) : j[Ct](kt)), j && j.addClass(mt.getClassName(), !0);
                  } else
                    j && (mt.graphic = j.destroy());
                }
            }, W.prototype.markerAttribs = function(L, I) {
              var j = this.options, Z = j.marker, V = L.marker || {}, X = V.symbol || Z.symbol, et = {}, ot = p(V.radius, Z && Z.radius);
              return I && (Z = Z.states[I], I = V.states && V.states[I], ot = p(I && I.radius, Z && Z.radius, ot && ot + (Z && Z.radiusPlus || 0))), L.hasImage = X && X.indexOf("url") === 0, L.hasImage && (ot = 0), L = L.pos(), h(ot) && L && (et.x = L[0] - ot, et.y = L[1] - ot, j.crisp && (et.x = Math.floor(et.x))), ot && (et.width = et.height = 2 * ot), et;
            }, W.prototype.pointAttribs = function(L, I) {
              var j = this.options.marker, Z = L && L.options, V = Z && Z.marker || {}, X = Z && Z.color, et = L && L.color, ot = L && L.zone && L.zone.color, it = this.color;
              return L = p(V.lineWidth, j.lineWidth), Z = 1, it = X || ot || et || it, X = V.fillColor || j.fillColor || it, et = V.lineColor || j.lineColor || it, I = I || "normal", j = j.states[I] || {}, I = V.states && V.states[I] || {}, L = p(I.lineWidth, j.lineWidth, L + p(I.lineWidthPlus, j.lineWidthPlus, 0)), X = I.fillColor || j.fillColor || X, { stroke: et = I.lineColor || j.lineColor || et, "stroke-width": L, fill: X, opacity: Z = p(I.opacity, j.opacity, Z) };
            }, W.prototype.destroy = function(L) {
              var I, j, Z, V = this, X = V.chart, et = /AppleWebKit\/533/.test(g.navigator.userAgent), ot = V.data || [];
              for (i(V, "destroy", { keepEventsForUpdate: L }), this.removeEvents(L), (V.axisTypes || []).forEach(function(it) {
                (Z = V[it]) && Z.series && (a(Z.series, V), Z.isDirty = Z.forceRedraw = !0);
              }), V.legendItem && V.chart.legend.destroyItem(V), I = ot.length; I--; )
                (j = ot[I]) && j.destroy && j.destroy();
              V.clips && V.clips.forEach(function(it) {
                return it.destroy();
              }), D.clearTimeout(V.animationTimeout), O(V, function(it, pt) {
                it instanceof N && !it.survive && it[et && pt === "group" ? "hide" : "destroy"]();
              }), X.hoverSeries === V && (X.hoverSeries = void 0), a(X.series, V), X.orderSeries(), O(V, function(it, pt) {
                L && pt === "hcEvents" || delete V[pt];
              });
            }, W.prototype.applyZones = function() {
              var L, I, j, Z, V, X, et, ot, it = this, pt = this.chart, mt = pt.renderer, Ct = this.zones, kt = this.clips || [], Lt = this.graph, Tt = this.area, xt = Math.max(pt.plotWidth, pt.plotHeight), ct = this[(this.zoneAxis || "y") + "Axis"], ft = pt.inverted, St = !1;
              if (Ct.length && (Lt || Tt) && ct && ct.min !== void 0) {
                var Mt = ct.reversed, Dt = ct.horiz;
                Lt && !this.showLine && Lt.hide(), Tt && Tt.hide();
                var Ot = ct.getExtremes();
                Ct.forEach(function(Nt, Wt) {
                  L = Mt ? Dt ? pt.plotWidth : 0 : Dt ? 0 : ct.toPixels(Ot.min) || 0, L = S(p(I, L), 0, xt), I = S(Math.round(ct.toPixels(p(Nt.value, Ot.max), !0) || 0), 0, xt), St && (L = I = ct.toPixels(Ot.max)), Z = Math.abs(L - I), V = Math.min(L, I), X = Math.max(L, I), ct.isXAxis ? (j = { x: ft ? X : V, y: 0, width: Z, height: xt }, Dt || (j.x = pt.plotHeight - j.x)) : (j = { x: 0, y: ft ? X : V, width: xt, height: Z }, Dt && (j.y = pt.plotWidth - j.y)), ft && mt.isVML && (j = ct.isXAxis ? { x: 0, y: Mt ? V : X, height: j.width, width: pt.chartWidth } : { x: j.y - pt.plotLeft - pt.spacingBox.x, y: 0, width: j.height, height: pt.chartHeight }), kt[Wt] ? kt[Wt].animate(j) : kt[Wt] = mt.clipRect(j), et = it["zone-area-" + Wt], ot = it["zone-graph-" + Wt], Lt && ot && ot.clip(kt[Wt]), Tt && et && et.clip(kt[Wt]), St = Nt.value > Ot.max, it.resetZones && I === 0 && (I = void 0);
                }), this.clips = kt;
              } else
                it.visible && (Lt && Lt.show(), Tt && Tt.show());
            }, W.prototype.plotGroup = function(L, I, j, Z, V) {
              var X = this[L], et = !X;
              return j = { visibility: j, zIndex: Z || 0.1 }, this.opacity === void 0 || this.chart.styledMode || this.state === "inactive" || (j.opacity = this.opacity), et && (this[L] = X = this.chart.renderer.g().add(V)), X.addClass("highcharts-" + I + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (s(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (X.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), X.attr(j)[et ? "attr" : "animate"](this.getPlotBox(I)), X;
            }, W.prototype.getPlotBox = function(L) {
              var I = this.xAxis, j = this.yAxis, Z = this.chart;
              return L = Z.inverted && !Z.polar && I && this.invertible !== !1 && L === "series", Z.inverted && (I = j, j = this.xAxis), { translateX: I ? I.left : Z.plotLeft, translateY: j ? j.top : Z.plotTop, rotation: L ? 90 : 0, rotationOriginX: L ? (I.len - j.len) / 2 : 0, rotationOriginY: L ? (I.len + j.len) / 2 : 0, scaleX: L ? -1 : 1, scaleY: 1 };
            }, W.prototype.removeEvents = function(L) {
              L || w(this), this.eventsToUnbind.length && (this.eventsToUnbind.forEach(function(I) {
                I();
              }), this.eventsToUnbind.length = 0);
            }, W.prototype.render = function() {
              var L = this, I = L.chart, j = L.options, Z = k(j.animation), V = L.visible ? "inherit" : "hidden", X = j.zIndex, et = L.hasRendered, ot = I.seriesGroup;
              I = !L.finishedAnimating && I.renderer.isSVG ? Z.duration : 0, i(this, "render"), L.plotGroup("group", "series", V, X, ot), L.markerGroup = L.plotGroup("markerGroup", "markers", V, X, ot), j.clip !== !1 && L.setClip(), L.animate && I && L.animate(!0), L.drawGraph && (L.drawGraph(), L.applyZones()), L.visible && L.drawPoints(), L.drawDataLabels && L.drawDataLabels(), L.redrawPoints && L.redrawPoints(), L.drawTracker && L.options.enableMouseTracking !== !1 && L.drawTracker(), L.animate && I && L.animate(), et || (I && Z.defer && (I += Z.defer), L.animationTimeout = z(function() {
                L.afterAnimate();
              }, I || 0)), L.isDirty = !1, L.hasRendered = !0, i(L, "afterRender");
            }, W.prototype.redraw = function() {
              var L = this.isDirty || this.isDirtyData;
              this.translate(), this.render(), L && delete this.kdTree;
            }, W.prototype.searchPoint = function(L, I) {
              var j = this.xAxis, Z = this.yAxis, V = this.chart.inverted;
              return this.searchKDTree({ clientX: V ? j.len - L.chartY + j.pos : L.chartX - j.pos, plotY: V ? Z.len - L.chartX + Z.pos : L.chartY - Z.pos }, I, L);
            }, W.prototype.buildKDTree = function(L) {
              function I(V, X, et) {
                var ot = V && V.length;
                if (ot) {
                  var it = j.kdAxisArray[X % et];
                  return V.sort(function(pt, mt) {
                    return pt[it] - mt[it];
                  }), { point: V[ot = Math.floor(ot / 2)], left: I(V.slice(0, ot), X + 1, et), right: I(V.slice(ot + 1), X + 1, et) };
                }
              }
              this.buildingKdTree = !0;
              var j = this, Z = -1 < j.options.findNearestPointBy.indexOf("y") ? 2 : 1;
              delete j.kdTree, z(function() {
                j.kdTree = I(j.getValidPoints(null, !j.directTouch), Z, Z), j.buildingKdTree = !1;
              }, j.options.kdNow || L && L.type === "touchstart" ? 0 : 1);
            }, W.prototype.searchKDTree = function(L, I, j) {
              var Z = this, V = this.kdAxisArray[0], X = this.kdAxisArray[1], et = I ? "distX" : "dist";
              if (I = -1 < Z.options.findNearestPointBy.indexOf("y") ? 2 : 1, this.kdTree || this.buildingKdTree || this.buildKDTree(j), this.kdTree)
                return function ot(it, pt, mt, Ct) {
                  var kt = pt.point, Lt = Z.kdAxisArray[mt % Ct], Tt = kt, xt = s(it[V]) && s(kt[V]) ? Math.pow(it[V] - kt[V], 2) : null, ct = s(it[X]) && s(kt[X]) ? Math.pow(it[X] - kt[X], 2) : null;
                  return ct = (xt || 0) + (ct || 0), kt.dist = s(ct) ? Math.sqrt(ct) : Number.MAX_VALUE, kt.distX = s(xt) ? Math.sqrt(xt) : Number.MAX_VALUE, xt = 0 > (Lt = it[Lt] - kt[Lt]) ? "right" : "left", pt[ct = 0 > Lt ? "left" : "right"] && (Tt = (ct = ot(it, pt[ct], mt + 1, Ct))[et] < Tt[et] ? ct : kt), pt[xt] && Math.sqrt(Lt * Lt) < Tt[et] && (Tt = (it = ot(it, pt[xt], mt + 1, Ct))[et] < Tt[et] ? it : Tt), Tt;
                }(L, this.kdTree, I, I);
            }, W.prototype.pointPlacementToXValue = function() {
              var L = this.options, I = L.pointRange, j = this.xAxis;
              return (L = L.pointPlacement) === "between" && (L = j.reversed ? -0.5 : 0.5), h(L) ? L * (I || j.pointRange) : 0;
            }, W.prototype.isPointInside = function(L) {
              var I = this.chart, j = this.xAxis, Z = this.yAxis;
              return L.plotY !== void 0 && L.plotX !== void 0 && 0 <= L.plotY && L.plotY <= (Z ? Z.len : I.plotHeight) && 0 <= L.plotX && L.plotX <= (j ? j.len : I.plotWidth);
            }, W.prototype.drawTracker = function() {
              var L = this, I = L.options, j = I.trackByArea, Z = [].concat(j ? L.areaPath : L.graphPath), V = L.chart, X = V.pointer, et = V.renderer, ot = V.options.tooltip.snap, it = L.tracker, pt = function(Ct) {
                V.hoverSeries !== L && L.onMouseOver();
              }, mt = "rgba(192,192,192," + (v ? 1e-4 : 2e-3) + ")";
              it ? it.attr({ d: Z }) : L.graph && (L.tracker = et.path(Z).attr({ visibility: L.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(j ? "highcharts-tracker-area" : "highcharts-tracker-line").add(L.group), V.styledMode || L.tracker.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: mt, fill: j ? mt : "none", "stroke-width": L.graph.strokeWidth() + (j ? 0 : 2 * ot) }), [L.tracker, L.markerGroup, L.dataLabelsGroup].forEach(function(Ct) {
                Ct && (Ct.addClass("highcharts-tracker").on("mouseover", pt).on("mouseout", function(kt) {
                  X.onTrackerMouseOut(kt);
                }), I.cursor && !V.styledMode && Ct.css({ cursor: I.cursor }), m) && Ct.on("touchstart", pt);
              })), i(this, "afterDrawTracker");
            }, W.prototype.addPoint = function(L, I, j, Z, V) {
              var X = this.options, et = this.data, ot = this.chart, it = this.xAxis;
              it = it && it.hasNames && it.names;
              var pt, mt = X.data, Ct = this.xData;
              I = p(I, !0);
              var kt = { series: this };
              this.pointClass.prototype.applyOptions.apply(kt, [L]);
              var Lt = kt.x, Tt = Ct.length;
              if (this.requireSorting && Lt < Ct[Tt - 1])
                for (pt = !0; Tt && Ct[Tt - 1] > Lt; )
                  Tt--;
              this.updateParallelArrays(kt, "splice", Tt, 0, 0), this.updateParallelArrays(kt, Tt), it && kt.name && (it[Lt] = kt.name), mt.splice(Tt, 0, L), (pt || this.processedData) && (this.data.splice(Tt, 0, null), this.processData()), X.legendType === "point" && this.generatePoints(), j && (et[0] && et[0].remove ? et[0].remove(!1) : (et.shift(), this.updateParallelArrays(kt, "shift"), mt.shift())), V !== !1 && i(this, "addPoint", { point: kt }), this.isDirtyData = this.isDirty = !0, I && ot.redraw(Z);
            }, W.prototype.removePoint = function(L, I, j) {
              var Z = this, V = Z.data, X = V[L], et = Z.points, ot = Z.chart, it = function() {
                et && et.length === V.length && et.splice(L, 1), V.splice(L, 1), Z.options.data.splice(L, 1), Z.updateParallelArrays(X || { series: Z }, "splice", L, 1), X && X.destroy(), Z.isDirty = !0, Z.isDirtyData = !0, I && ot.redraw();
              };
              A(j, ot), I = p(I, !0), X ? X.firePointEvent("remove", null, it) : it();
            }, W.prototype.remove = function(L, I, j, Z) {
              function V() {
                X.destroy(Z), et.isDirtyLegend = et.isDirtyBox = !0, et.linkSeries(), p(L, !0) && et.redraw(I);
              }
              var X = this, et = X.chart;
              j !== !1 ? i(X, "remove", null, V) : V();
            }, W.prototype.update = function(L, I) {
              L = u(L, this.userOptions), i(this, "update", { options: L });
              var j = this, Z = j.chart, V = j.userOptions, X = j.initialType || j.type, et = Z.options.plotOptions, ot = x[X].prototype, it = j.finishedAnimating && { animation: !1 }, pt = {}, mt = ["eventOptions", "navigatorSeries", "baseSeries"], Ct = L.type || V.type || Z.options.chart.type, kt = !(this.hasDerivedData || Ct && Ct !== this.type || L.pointStart !== void 0 || L.pointInterval !== void 0 || L.relativeXValue !== void 0 || L.joinBy || L.mapData || j.hasOptionChanged("dataGrouping") || j.hasOptionChanged("pointStart") || j.hasOptionChanged("pointInterval") || j.hasOptionChanged("pointIntervalUnit") || j.hasOptionChanged("keys"));
              if (Ct = Ct || X, kt && (mt.push("data", "isDirtyData", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "_hasPointLabels", "clips", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX"), L.visible !== !1 && mt.push("area", "graph"), j.parallelArrays.forEach(function(Tt) {
                mt.push(Tt + "Data");
              }), L.data && (L.dataSorting && n(j.options.dataSorting, L.dataSorting), this.setData(L.data, !1))), L = M(V, it, { index: V.index === void 0 ? j.index : V.index, pointStart: p(et && et.series && et.series.pointStart, V.pointStart, j.xData[0]) }, !kt && { data: j.options.data }, L), kt && L.data && (L.data = j.options.data), (mt = ["group", "markerGroup", "dataLabelsGroup", "transformGroup", "shadowGroup"].concat(mt)).forEach(function(Tt) {
                mt[Tt] = j[Tt], delete j[Tt];
              }), et = !1, x[Ct]) {
                if (et = Ct !== j.type, j.remove(!1, !1, !1, !0), et)
                  if (Object.setPrototypeOf)
                    Object.setPrototypeOf(j, x[Ct].prototype);
                  else {
                    for (Lt in it = Object.hasOwnProperty.call(j, "hcEvents") && j.hcEvents, ot)
                      j[Lt] = void 0;
                    n(j, x[Ct].prototype), it ? j.hcEvents = it : delete j.hcEvents;
                  }
              } else
                e(17, !0, Z, { missingModuleFor: Ct });
              if (mt.forEach(function(Tt) {
                j[Tt] = mt[Tt];
              }), j.init(Z, L), kt && this.points) {
                if ((L = j.options).visible === !1)
                  pt.graphic = 1, pt.dataLabel = 1;
                else if (!j._hasPointLabels) {
                  ot = L.marker;
                  var Lt = L.dataLabels;
                  V = V.marker || {}, !ot || ot.enabled !== !1 && V.symbol === ot.symbol && V.height === ot.height && V.width === ot.width || (pt.graphic = 1), Lt && Lt.enabled === !1 && (pt.dataLabel = 1);
                }
                for (V = 0, ot = this.points; V < ot.length; V++)
                  (Lt = ot[V]) && Lt.series && (Lt.resolveColor(), Object.keys(pt).length && Lt.destroyElements(pt), L.showInLegend === !1 && Lt.legendItem && Z.legend.destroyItem(Lt));
              }
              j.initialType = X, Z.linkSeries(), et && j.linkedSeries.length && (j.isDirtyData = !0), i(this, "afterUpdate"), p(I, !0) && Z.redraw(!!kt && void 0);
            }, W.prototype.setName = function(L) {
              this.name = this.options.name = this.userOptions.name = L, this.chart.isDirtyLegend = !0;
            }, W.prototype.hasOptionChanged = function(L) {
              var I = this.options[L], j = this.chart.options.plotOptions, Z = this.userOptions[L];
              return Z ? I !== Z : I !== p(j && j[this.type] && j[this.type][L], j && j.series && j.series[L], I);
            }, W.prototype.onMouseOver = function() {
              var L = this.chart, I = L.hoverSeries;
              L.pointer.setHoverChartIndex(), I && I !== this && I.onMouseOut(), this.options.events.mouseOver && i(this, "mouseOver"), this.setState("hover"), L.hoverSeries = this;
            }, W.prototype.onMouseOut = function() {
              var L = this.options, I = this.chart, j = I.tooltip, Z = I.hoverPoint;
              I.hoverSeries = null, Z && Z.onMouseOut(), this && L.events.mouseOut && i(this, "mouseOut"), !j || this.stickyTracking || j.shared && !this.noSharedTooltip || j.hide(), I.series.forEach(function(V) {
                V.setState("", !0);
              });
            }, W.prototype.setState = function(L, I) {
              var j = this, Z = j.options, V = j.graph, X = Z.inactiveOtherPoints, et = Z.states, ot = p(et[L || "normal"] && et[L || "normal"].animation, j.chart.options.chart.animation), it = Z.lineWidth, pt = 0, mt = Z.opacity;
              if (L = L || "", j.state !== L && ([j.group, j.markerGroup, j.dataLabelsGroup].forEach(function(Ct) {
                Ct && (j.state && Ct.removeClass("highcharts-series-" + j.state), L && Ct.addClass("highcharts-series-" + L));
              }), j.state = L, !j.chart.styledMode)) {
                if (et[L] && et[L].enabled === !1)
                  return;
                if (L && (it = et[L].lineWidth || it + (et[L].lineWidthPlus || 0), mt = p(et[L].opacity, mt)), V && !V.dashstyle && h(it))
                  for (Z = { "stroke-width": it }, V.animate(Z, ot); j["zone-graph-" + pt]; )
                    j["zone-graph-" + pt].animate(Z, ot), pt += 1;
                X || [j.group, j.markerGroup, j.dataLabelsGroup, j.labelBySeries].forEach(function(Ct) {
                  Ct && Ct.animate({ opacity: mt }, ot);
                });
              }
              I && X && j.points && j.setAllPointsToState(L || void 0);
            }, W.prototype.setAllPointsToState = function(L) {
              this.points.forEach(function(I) {
                I.setState && I.setState(L);
              });
            }, W.prototype.setVisible = function(L, I) {
              var j = this, Z = j.chart, V = Z.options.chart.ignoreHiddenSeries, X = j.visible, et = (j.visible = L = j.options.visible = j.userOptions.visible = L === void 0 ? !X : L) ? "show" : "hide";
              ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach(function(ot) {
                j[ot] && j[ot][et]();
              }), Z.hoverSeries !== j && (Z.hoverPoint && Z.hoverPoint.series) !== j || j.onMouseOut(), j.legendItem && Z.legend.colorizeItem(j, L), j.isDirty = !0, j.options.stacking && Z.series.forEach(function(ot) {
                ot.options.stacking && ot.visible && (ot.isDirty = !0);
              }), j.linkedSeries.forEach(function(ot) {
                ot.setVisible(L, !1);
              }), V && (Z.isDirtyBox = !0), i(j, et), I !== !1 && Z.redraw();
            }, W.prototype.show = function() {
              this.setVisible(!0);
            }, W.prototype.hide = function() {
              this.setVisible(!1);
            }, W.prototype.select = function(L) {
              this.selected = L = this.options.selected = L === void 0 ? !this.selected : L, this.checkbox && (this.checkbox.checked = L), i(this, L ? "select" : "unselect");
            }, W.prototype.shouldShowTooltip = function(L, I, j) {
              return j === void 0 && (j = {}), j.series = this, j.visiblePlotOnly = !0, this.chart.isInsidePlot(L, I, j);
            }, W.defaultOptions = q, W.types = U.seriesTypes, W.registerType = U.registerSeriesType, W;
          }(), n(G.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, cropShoulder: 1, directTouch: !1, drawLegendSymbol: J.drawLineMarker, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: Q, requireSorting: !0, sorted: !0 }), U.series = G, G;
        }), _(at, "Extensions/ScrollablePlotArea.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Axis/Axis.js"], at["Core/Chart/Chart.js"], at["Core/Series/Series.js"], at["Core/Renderer/RendererRegistry.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = G.stop, U = Q.addEvent, N = Q.createElement, D = Q.defined, k = Q.merge, A = Q.pick;
          U($, "afterSetChartSize", function(b) {
            var d = this.options.chart.scrollablePlotArea, m = d && d.minWidth;
            if (d = d && d.minHeight, !this.renderer.forExport) {
              if (m) {
                if (this.scrollablePixelsX = m = Math.max(0, m - this.chartWidth)) {
                  this.scrollablePlotBox = this.renderer.scrollablePlotBox = k(this.plotBox), this.plotBox.width = this.plotWidth += m, this.inverted ? this.clipBox.height += m : this.clipBox.width += m;
                  var v = { 1: { name: "right", value: m } };
                }
              } else
                d && (this.scrollablePixelsY = m = Math.max(0, d - this.chartHeight), D(m) && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = k(this.plotBox), this.plotBox.height = this.plotHeight += m, this.inverted ? this.clipBox.width += m : this.clipBox.height += m, v = { 2: { name: "bottom", value: m } }));
              v && !b.skipAxes && this.axes.forEach(function(g) {
                v[g.side] ? g.getPlotLinePath = function() {
                  var x = v[g.side].name, E = this[x];
                  this[x] = E - v[g.side].value;
                  var P = F.prototype.getPlotLinePath.apply(this, arguments);
                  return this[x] = E, P;
                } : (g.setAxisSize(), g.setAxisTranslation());
              });
            }
          }), U($, "render", function() {
            this.scrollablePixelsX || this.scrollablePixelsY ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
          }), $.prototype.setUpScrolling = function() {
            var b, d = this, m = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
            this.scrollablePixelsX && (m.overflowX = "auto"), this.scrollablePixelsY && (m.overflowY = "auto"), this.scrollingParent = N("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, this.renderTo), this.scrollingContainer = N("div", { className: "highcharts-scrolling" }, m, this.scrollingParent), U(this.scrollingContainer, "scroll", function() {
              d.pointer && (delete d.pointer.chartPosition, d.hoverPoint && (b = d.hoverPoint), d.pointer.runPointActions(void 0, b, !0));
            }), this.innerContainer = N("div", { className: "highcharts-inner-container" }, null, this.scrollingContainer), this.innerContainer.appendChild(this.container), this.setUpScrolling = null;
          }, $.prototype.moveFixedElements = function() {
            var b, d = this.container, m = this.fixedRenderer, v = ".highcharts-breadcrumbs-group .highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-drillup-button .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" ");
            this.scrollablePixelsX && !this.inverted ? b = ".highcharts-yaxis" : this.scrollablePixelsX && this.inverted || this.scrollablePixelsY && !this.inverted ? b = ".highcharts-xaxis" : this.scrollablePixelsY && this.inverted && (b = ".highcharts-yaxis"), b && v.push(b + ":not(.highcharts-radial-axis)", b + "-labels:not(.highcharts-radial-axis-labels)"), v.forEach(function(g) {
              [].forEach.call(d.querySelectorAll(g), function(x) {
                (x.namespaceURI === m.SVG_NS ? m.box : m.box.parentNode).appendChild(x), x.style.pointerEvents = "auto";
              });
            });
          }, $.prototype.applyFixed = function() {
            var b = !this.fixedDiv, d = this.options.chart, m = d.scrollablePlotArea, v = J.getRendererType();
            b ? (this.fixedDiv = N("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (d.style && d.style.zIndex || 0) + 2, top: 0 }, null, !0), this.scrollingContainer && this.scrollingContainer.parentNode.insertBefore(this.fixedDiv, this.scrollingContainer), this.renderTo.style.overflow = "visible", this.fixedRenderer = d = new v(this.fixedDiv, this.chartWidth, this.chartHeight, this.options.chart.style), this.scrollableMask = d.path().attr({ fill: this.options.chart.backgroundColor || "#fff", "fill-opacity": A(m.opacity, 0.85), zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), U(this, "afterShowResetZoom", this.moveFixedElements), U(this, "afterApplyDrilldown", this.moveFixedElements), U(this, "afterLayOutTitles", this.moveFixedElements)) : this.fixedRenderer.setSize(this.chartWidth, this.chartHeight), (this.scrollableDirty || b) && (this.scrollableDirty = !1, this.moveFixedElements()), d = this.chartWidth + (this.scrollablePixelsX || 0), v = this.chartHeight + (this.scrollablePixelsY || 0), q(this.container), this.container.style.width = d + "px", this.container.style.height = v + "px", this.renderer.boxWrapper.attr({ width: d, height: v, viewBox: [0, 0, d, v].join(" ") }), this.chartBackground.attr({ width: d, height: v }), this.scrollingContainer.style.height = this.chartHeight + "px", b && (m.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixelsX * m.scrollPositionX), m.scrollPositionY && (this.scrollingContainer.scrollTop = this.scrollablePixelsY * m.scrollPositionY)), v = this.axisOffset, b = this.plotTop - v[0] - 1, m = this.plotLeft - v[3] - 1, d = this.plotTop + this.plotHeight + v[2] + 1, v = this.plotLeft + this.plotWidth + v[1] + 1;
            var g = this.plotLeft + this.plotWidth - (this.scrollablePixelsX || 0), x = this.plotTop + this.plotHeight - (this.scrollablePixelsY || 0);
            b = this.scrollablePixelsX ? [["M", 0, b], ["L", this.plotLeft - 1, b], ["L", this.plotLeft - 1, d], ["L", 0, d], ["Z"], ["M", g, b], ["L", this.chartWidth, b], ["L", this.chartWidth, d], ["L", g, d], ["Z"]] : this.scrollablePixelsY ? [["M", m, 0], ["L", m, this.plotTop - 1], ["L", v, this.plotTop - 1], ["L", v, 0], ["Z"], ["M", m, x], ["L", m, this.chartHeight], ["L", v, this.chartHeight], ["L", v, x], ["Z"]] : [["M", 0, 0]], this.redrawTrigger !== "adjustHeight" && this.scrollableMask.attr({ d: b });
          }, U(F, "afterInit", function() {
            this.chart.scrollableDirty = !0;
          }), U(Y, "show", function() {
            this.chart.scrollableDirty = !0;
          });
        }), _(at, "Core/Axis/Stacking/StackItem.js", [at["Core/FormatUtilities.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.format, J = F.series, Q = $.destroyObjectProperties, q = $.pick, U = $.isNumber;
          return G = function() {
            function N(D, k, A, b, d) {
              var m = D.chart.inverted, v = D.reversed;
              this.axis = D, D = this.isNegative = !!A != !!v, this.options = k = k || {}, this.x = b, this.cumulative = this.total = null, this.points = {}, this.hasValidPoints = !1, this.stack = d, this.rightCliff = this.leftCliff = 0, this.alignOptions = { align: k.align || (m ? D ? "left" : "right" : "center"), verticalAlign: k.verticalAlign || (m ? "middle" : D ? "bottom" : "top"), y: k.y, x: k.x }, this.textAlign = k.textAlign || (m ? D ? "right" : "left" : "center");
            }
            return N.prototype.destroy = function() {
              Q(this, this.axis);
            }, N.prototype.render = function(D) {
              var k = this.axis.chart, A = this.options, b = A.format;
              b = b ? Y(b, this, k) : A.formatter.call(this), this.label ? this.label.attr({ text: b, visibility: "hidden" }) : (this.label = k.renderer.label(b, null, void 0, A.shape, void 0, void 0, A.useHTML, !1, "stack-labels"), b = { r: A.borderRadius || 0, text: b, padding: q(A.padding, 5), visibility: "hidden" }, k.styledMode || (b.fill = A.backgroundColor, b.stroke = A.borderColor, b["stroke-width"] = A.borderWidth, this.label.css(A.style || {})), this.label.attr(b), this.label.added || this.label.add(D)), this.label.labelrank = k.plotSizeY;
            }, N.prototype.setOffset = function(D, k, A, b, d, m) {
              var v = this.alignOptions, g = this.axis, x = this.label, E = this.options, P = this.textAlign, S = g.chart;
              D = this.getStackBox({ xOffset: D, width: k, boxBottom: A, boxTop: b, defaultX: d, xAxis: m }), d = v.verticalAlign, x && D && (k = x.getBBox(), A = x.padding, b = q(E.overflow, "justify") === "justify", v.x = E.x || 0, v.y = E.y || 0, P = (d = this.adjustStackPosition({ labelBox: k, verticalAlign: d, textAlign: P })).x, d = d.y, D.x -= P, D.y -= d, x.align(v, !1, D), (P = S.isInsidePlot(x.alignAttr.x + v.x + P, x.alignAttr.y + v.y + d)) || (b = !1), b && J.prototype.justifyDataLabel.call(g, x, v, x.alignAttr, k, D), x.attr({ x: x.alignAttr.x, y: x.alignAttr.y, rotation: E.rotation, rotationOriginX: k.width / 2, rotationOriginY: k.height / 2 }), q(!b && E.crop, !0) && (P = U(x.x) && U(x.y) && S.isInsidePlot(x.x - A + x.width, x.y) && S.isInsidePlot(x.x + A, x.y)), x[P ? "show" : "hide"]());
            }, N.prototype.adjustStackPosition = function(D) {
              var k = D.labelBox, A = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 };
              return { x: k.width / 2 + k.width / 2 * A[D.textAlign], y: k.height / 2 * A[D.verticalAlign] };
            }, N.prototype.getStackBox = function(D) {
              var k = this.axis, A = k.chart, b = D.boxTop, d = D.defaultX, m = D.xOffset, v = D.width, g = D.boxBottom;
              return b = k.stacking.usePercentage ? 100 : q(b, this.total, 0), b = k.toPixels(b), D = q(d, (D.xAxis || A.xAxis[0]).toPixels(this.x)) + m, k = k.toPixels(g || 0), k = Math.abs(b - k), g = this.isNegative, A.inverted ? { x: (g ? b : b - k) - A.plotLeft, y: D - A.plotTop, width: k, height: v } : { x: D - A.plotLeft, y: (g ? b - k : b) - A.plotTop, width: v, height: k };
            }, N;
          }(), G;
        }), _(at, "Core/Axis/Stacking/StackingAxis.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Axis/Axis.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Axis/Stacking/StackItem.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J) {
          function Q() {
            var n = this, o = n.inverted;
            n.yAxis.forEach(function(i) {
              i.stacking && i.stacking.stacks && i.hasVisibleSeries && (i.stacking.oldStacks = i.stacking.stacks);
            }), n.series.forEach(function(i) {
              var c = i.xAxis && i.xAxis.options || {};
              !i.options.stacking || i.visible !== !0 && n.options.chart.ignoreHiddenSeries !== !1 || (i.stackKey = [i.type, a(i.options.stack, ""), o ? c.top : c.left, o ? c.height : c.width].join());
            });
          }
          function q() {
            var n = this.stacking;
            if (n) {
              var o = n.stacks;
              s(o, function(i, c) {
                P(i), o[c] = null;
              }), n && n.stackTotalGroup && n.stackTotalGroup.destroy();
            }
          }
          function U() {
            this.coll !== "yAxis" || this.stacking || (this.stacking = new e(this));
          }
          function N(n, o, i, c) {
            return !E(n) || n.x !== o || c && n.stackKey !== c ? n = { x: o, index: 0, key: c, stackKey: c } : n.index++, n.key = [i, o, n.index].join(), n;
          }
          function D() {
            var n, o = this, i = o.stackKey, c = o.yAxis.stacking.stacks, l = o.processedXData, h = o[o.options.stacking + "Stacker"];
            h && [i, "-" + i].forEach(function(C) {
              for (var M, O, p = l.length; p--; )
                M = l[p], n = o.getStackIndicator(n, M, o.index, C), (O = (M = c[C] && c[C][M]) && M.points[n.key]) && h.call(o, O, M, p);
            });
          }
          function k(n, o, i) {
            o = o.total ? 100 / o.total : 0, n[0] = x(n[0] * o), n[1] = x(n[1] * o), this.stackedYData[i] = n[1];
          }
          function A() {
            var n = this.yAxis.stacking;
            this.options.centerInCategory && (this.is("column") || this.is("columnrange")) && !this.options.stacking && 1 < this.chart.series.length ? v.setStackedPoints.call(this, "group") : n && s(n.stacks, function(o, i) {
              i.slice(-5) === "group" && (s(o, function(c) {
                return c.destroy();
              }), delete n.stacks[i]);
            });
          }
          function b(n) {
            var o = this.chart, i = n || this.options.stacking;
            if (i && (this.visible === !0 || o.options.chart.ignoreHiddenSeries === !1)) {
              var c = this.processedXData, l = this.processedYData, h = [], C = l.length, M = this.options, O = M.threshold, p = a(M.startFromThreshold && O, 0);
              M = M.stack;
              var w, T, z = "-" + (n = n ? "" + this.type + ",".concat(i) : this.stackKey), W = this.negStacks, L = (o = i === "group" ? o.yAxis[0] : this.yAxis).stacking.stacks, I = o.stacking.oldStacks;
              for (o.stacking.stacksTouched += 1, T = 0; T < C; T++) {
                var j = c[T], Z = l[T], V = this.getStackIndicator(V, j, this.index), X = V.key, et = (w = W && Z < (p ? 0 : O)) ? z : n;
                L[et] || (L[et] = {}), L[et][j] || (I[et] && I[et][j] ? (L[et][j] = I[et][j], L[et][j].total = null) : L[et][j] = new Y(o, o.options.stackLabels, !!w, j, M)), et = L[et][j], Z !== null ? (et.points[X] = et.points[this.index] = [a(et.cumulative, p)], E(et.cumulative) || (et.base = X), et.touched = o.stacking.stacksTouched, 0 < V.index && this.singleStacks === !1 && (et.points[X][0] = et.points[this.index + "," + j + ",0"][0])) : et.points[X] = et.points[this.index] = null, i === "percent" ? (w = w ? n : z, W && L[w] && L[w][j] ? (w = L[w][j], et.total = w.total = Math.max(w.total, et.total) + Math.abs(Z) || 0) : et.total = x(et.total + (Math.abs(Z) || 0))) : i === "group" ? (u(Z) && (Z = Z[0]), Z !== null && (et.total = (et.total || 0) + 1)) : et.total = x(et.total + (Z || 0)), et.cumulative = i === "group" ? (et.total || 1) - 1 : a(et.cumulative, p) + (Z || 0), Z !== null && (et.points[X].push(et.cumulative), h[T] = et.cumulative, et.hasValidPoints = !0);
              }
              i === "percent" && (o.stacking.usePercentage = !0), i !== "group" && (this.stackedYData = h), o.stacking.oldStacks = {};
            }
          }
          var d, m = G.getDeferredAnimation, v = $.series.prototype, g = J.addEvent, x = J.correctFloat, E = J.defined, P = J.destroyObjectProperties, S = J.fireEvent, u = J.isArray, y = J.isNumber, s = J.objectEach, a = J.pick, e = function() {
            function n(o) {
              this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = o;
            }
            return n.prototype.buildStacks = function() {
              var o, i = this.axis, c = i.series, l = i.options.reversedStacks, h = c.length;
              for (this.usePercentage = !1, o = h; o--; ) {
                var C = c[l ? o : h - o - 1];
                C.setStackedPoints(), C.setGroupedPoints();
              }
              for (o = 0; o < h; o++)
                c[o].modifyStacks();
              S(i, "afterBuildStacks");
            }, n.prototype.cleanStacks = function() {
              if (this.oldStacks)
                var o = this.stacks = this.oldStacks;
              s(o, function(i) {
                s(i, function(c) {
                  c.cumulative = c.total;
                });
              });
            }, n.prototype.resetStacks = function() {
              var o = this;
              s(this.stacks, function(i) {
                s(i, function(c, l) {
                  y(c.touched) && c.touched < o.stacksTouched ? (c.destroy(), delete i[l]) : (c.total = null, c.cumulative = null);
                });
              });
            }, n.prototype.renderStackTotals = function() {
              var o = this.axis, i = o.chart, c = i.renderer, l = this.stacks;
              o = m(i, o.options.stackLabels && o.options.stackLabels.animation || !1);
              var h = this.stackTotalGroup = this.stackTotalGroup || c.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
              h.translate(i.plotLeft, i.plotTop), s(l, function(C) {
                s(C, function(M) {
                  M.render(h);
                });
              }), h.animate({ opacity: 1 }, o);
            }, n;
          }();
          return function(n) {
            var o = [];
            n.compose = function(i, c, l) {
              o.indexOf(i) === -1 && (o.push(i), g(i, "init", U), g(i, "destroy", q)), o.indexOf(c) === -1 && (o.push(c), c.prototype.getStacks = Q), o.indexOf(l) === -1 && (o.push(l), (i = l.prototype).getStackIndicator = N, i.modifyStacks = D, i.percentStacker = k, i.setGroupedPoints = A, i.setStackedPoints = b);
            };
          }(d || (d = {})), d;
        }), _(at, "Series/Line/LineSeries.js", [at["Core/Series/Series.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = this && this.__extends || /* @__PURE__ */ function() {
            var q = function(U, N) {
              return (q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, k) {
                D.__proto__ = k;
              } || function(D, k) {
                for (var A in k)
                  k.hasOwnProperty(A) && (D[A] = k[A]);
              })(U, N);
            };
            return function(U, N) {
              function D() {
                this.constructor = U;
              }
              q(U, N), U.prototype = N === null ? Object.create(N) : (D.prototype = N.prototype, new D());
            };
          }(), J = $.defined, Q = $.merge;
          return $ = function(q) {
            function U() {
              var N = q !== null && q.apply(this, arguments) || this;
              return N.data = void 0, N.options = void 0, N.points = void 0, N;
            }
            return Y(U, q), U.prototype.drawGraph = function() {
              var N = this, D = this.options, k = (this.gappedPath || this.getGraphPath).call(this), A = this.chart.styledMode, b = [["graph", "highcharts-graph"]];
              A || b[0].push(D.lineColor || this.color || "#cccccc", D.dashStyle), (b = N.getZonesGraphs(b)).forEach(function(d, m) {
                var v = d[0], g = N[v], x = g ? "animate" : "attr";
                g ? (g.endX = N.preventGraphAnimation ? null : k.xMap, g.animate({ d: k })) : k.length && (N[v] = g = N.chart.renderer.path(k).addClass(d[1]).attr({ zIndex: 1 }).add(N.group)), g && !A && (v = { stroke: d[2], "stroke-width": D.lineWidth || 0, fill: N.fillGraph && N.color || "none" }, d[3] ? v.dashstyle = d[3] : D.linecap !== "square" && (v["stroke-linecap"] = v["stroke-linejoin"] = "round"), g[x](v).shadow(2 > m && D.shadow)), g && (g.startX = k.xMap, g.isArea = k.isArea);
              });
            }, U.prototype.getGraphPath = function(N, D, k) {
              var A, b = this, d = b.options, m = [], v = [], g = d.step, x = (N = N || b.points).reversed;
              return x && N.reverse(), (g = { right: 1, center: 2 }[g] || g && 3) && x && (g = 4 - g), (N = this.getValidPoints(N, !1, !(d.connectNulls && !D && !k))).forEach(function(E, P) {
                var S = E.plotX, u = E.plotY, y = N[P - 1];
                (E.leftCliff || y && y.rightCliff) && !k && (A = !0), E.isNull && !J(D) && 0 < P ? A = !d.connectNulls : E.isNull && !D ? A = !0 : (P === 0 || A ? P = [["M", E.plotX, E.plotY]] : b.getPointSpline ? P = [b.getPointSpline(N, E, P)] : g ? (P = g === 1 ? [["L", y.plotX, u]] : g === 2 ? [["L", (y.plotX + S) / 2, y.plotY], ["L", (y.plotX + S) / 2, u]] : [["L", S, y.plotY]]).push(["L", S, u]) : P = [["L", S, u]], v.push(E.x), g && (v.push(E.x), g === 2 && v.push(E.x)), m.push.apply(m, P), A = !1);
              }), m.xMap = v, b.graphPath = m;
            }, U.prototype.getZonesGraphs = function(N) {
              return this.zones.forEach(function(D, k) {
                k = ["zone-graph-" + k, "highcharts-graph highcharts-zone-graph-" + k + " " + (D.className || "")], this.chart.styledMode || k.push(D.color || this.color, D.dashStyle || this.options.dashStyle), N.push(k);
              }, this), N;
            }, U.defaultOptions = Q(G.defaultOptions, {}), U;
          }(G), F.registerSeriesType("line", $), $;
        }), _(at, "Series/Area/AreaSeries.js", [at["Core/Color/Color.js"], at["Core/Legend/LegendSymbol.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = this && this.__extends || /* @__PURE__ */ function() {
            var k = function(A, b) {
              return k = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, m) {
                d.__proto__ = m;
              } || function(d, m) {
                for (var v in m)
                  m.hasOwnProperty(v) && (d[v] = m[v]);
              }, k(A, b);
            };
            return function(A, b) {
              function d() {
                this.constructor = A;
              }
              k(A, b), A.prototype = b === null ? Object.create(b) : (d.prototype = b.prototype, new d());
            };
          }(), Q = G.parse, q = $.seriesTypes.line;
          G = Y.extend;
          var U = Y.merge, N = Y.objectEach, D = Y.pick;
          return Y = function(k) {
            function A() {
              var b = k !== null && k.apply(this, arguments) || this;
              return b.data = void 0, b.options = void 0, b.points = void 0, b;
            }
            return J(A, k), A.prototype.drawGraph = function() {
              this.areaPath = [], k.prototype.drawGraph.apply(this);
              var b = this, d = this.areaPath, m = this.options, v = [["area", "highcharts-area", this.color, m.fillColor]];
              this.zones.forEach(function(g, x) {
                v.push(["zone-area-" + x, "highcharts-area highcharts-zone-area-" + x + " " + g.className, g.color || b.color, g.fillColor || m.fillColor]);
              }), v.forEach(function(g) {
                var x = g[0], E = {}, P = b[x], S = P ? "animate" : "attr";
                P ? (P.endX = b.preventGraphAnimation ? null : d.xMap, P.animate({ d })) : (E.zIndex = 0, (P = b[x] = b.chart.renderer.path(d).addClass(g[1]).add(b.group)).isArea = !0), b.chart.styledMode || (E.fill = D(g[3], Q(g[2]).setOpacity(D(m.fillOpacity, 0.75)).get())), P[S](E), P.startX = d.xMap, P.shiftUnit = m.step ? 2 : 1;
              });
            }, A.prototype.getGraphPath = function(b) {
              var d = q.prototype.getGraphPath, m = this.options, v = m.stacking, g = this.yAxis, x = [], E = [], P = this.index, S = g.stacking.stacks[this.stackKey], u = m.threshold, y = Math.round(g.getThreshold(m.threshold));
              m = D(m.connectNulls, v === "percent");
              var s = function(c, l, h) {
                var C = b[c];
                c = v && S[C.x].points[P];
                var M = C[h + "Null"] || 0;
                if (h = C[h + "Cliff"] || 0, C = !0, h || M) {
                  var O = (M ? c[0] : c[1]) + h, p = c[0] + h;
                  C = !!M;
                } else
                  !v && b[l] && b[l].isNull && (O = p = u);
                O !== void 0 && (E.push({ plotX: o, plotY: O === null ? y : g.getThreshold(O), isNull: C, isCliff: !0 }), x.push({ plotX: o, plotY: p === null ? y : g.getThreshold(p), doCurve: !1 }));
              };
              b = b || this.points, v && (b = this.getStackPoints(b));
              for (var a = 0, e = b.length; a < e; ++a) {
                v || (b[a].leftCliff = b[a].rightCliff = b[a].leftNull = b[a].rightNull = void 0);
                var n = b[a].isNull, o = D(b[a].rectPlotX, b[a].plotX), i = v ? D(b[a].yBottom, y) : y;
                n && !m || (m || s(a, a - 1, "left"), n && !v && m || (E.push(b[a]), x.push({ x: a, plotX: o, plotY: i })), m || s(a, a + 1, "right"));
              }
              return s = d.call(this, E, !0, !0), x.reversed = !0, (i = (n = d.call(this, x, !0, !0))[0]) && i[0] === "M" && (n[0] = ["L", i[1], i[2]]), (n = s.concat(n)).length && n.push(["Z"]), d = d.call(this, E, !1, m), n.xMap = s.xMap, this.areaPath = n, d;
            }, A.prototype.getStackPoints = function(b) {
              var d = this, m = [], v = [], g = this.xAxis, x = this.yAxis, E = x.stacking.stacks[this.stackKey], P = {}, S = x.series, u = S.length, y = x.options.reversedStacks ? 1 : -1, s = S.indexOf(d);
              if (b = b || this.points, this.options.stacking) {
                for (var a = 0; a < b.length; a++)
                  b[a].leftNull = b[a].rightNull = void 0, P[b[a].x] = b[a];
                N(E, function(n, o) {
                  n.total !== null && v.push(o);
                }), v.sort(function(n, o) {
                  return n - o;
                });
                var e = S.map(function(n) {
                  return n.visible;
                });
                v.forEach(function(n, o) {
                  var i, c, l = 0;
                  if (P[n] && !P[n].isNull)
                    m.push(P[n]), [-1, 1].forEach(function(C) {
                      var M = C === 1 ? "rightNull" : "leftNull", O = E[v[o + C]], p = 0;
                      if (O)
                        for (var w = s; 0 <= w && w < u; ) {
                          var T = S[w].index;
                          (i = O.points[T]) || (T === d.index ? P[n][M] = !0 : e[w] && (c = E[n].points[T]) && (p -= c[1] - c[0])), w += y;
                        }
                      P[n][C === 1 ? "rightCliff" : "leftCliff"] = p;
                    });
                  else {
                    for (var h = s; 0 <= h && h < u; ) {
                      if (i = E[n].points[S[h].index]) {
                        l = i[1];
                        break;
                      }
                      h += y;
                    }
                    l = D(l, 0), l = x.translate(l, 0, 1, 0, 1), m.push({ isNull: !0, plotX: g.translate(n, 0, 0, 0, 1), x: n, plotY: l, yBottom: l });
                  }
                });
              }
              return m;
            }, A.defaultOptions = U(q.defaultOptions, { threshold: 0 }), A;
          }(q), G(Y.prototype, { singleStacks: !1, drawLegendSymbol: F.drawRectangle }), $.registerSeriesType("area", Y), Y;
        }), _(at, "Series/Spline/SplineSeries.js", [at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F) {
          var $ = this && this.__extends || /* @__PURE__ */ function() {
            var q = function(U, N) {
              return (q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, k) {
                D.__proto__ = k;
              } || function(D, k) {
                for (var A in k)
                  k.hasOwnProperty(A) && (D[A] = k[A]);
              })(U, N);
            };
            return function(U, N) {
              function D() {
                this.constructor = U;
              }
              q(U, N), U.prototype = N === null ? Object.create(N) : (D.prototype = N.prototype, new D());
            };
          }(), Y = G.seriesTypes.line, J = F.merge, Q = F.pick;
          return F = function(q) {
            function U() {
              var N = q !== null && q.apply(this, arguments) || this;
              return N.data = void 0, N.options = void 0, N.points = void 0, N;
            }
            return $(U, q), U.prototype.getPointSpline = function(N, D, k) {
              var A = D.plotX || 0, b = D.plotY || 0, d = N[k - 1];
              if (k = N[k + 1], d && !d.isNull && d.doCurve !== !1 && !D.isCliff && k && !k.isNull && k.doCurve !== !1 && !D.isCliff) {
                N = d.plotY || 0;
                var m = k.plotX || 0;
                k = k.plotY || 0;
                var v = 0, g = (1.5 * A + (d.plotX || 0)) / 2.5, x = (1.5 * b + N) / 2.5, E = (1.5 * b + k) / 2.5;
                (m = (1.5 * A + m) / 2.5) !== g && (v = (E - x) * (m - A) / (m - g) + b - E), E += v, (x += v) > N && x > b ? E = 2 * b - (x = Math.max(N, b)) : x < N && x < b && (E = 2 * b - (x = Math.min(N, b))), E > k && E > b ? x = 2 * b - (E = Math.max(k, b)) : E < k && E < b && (x = 2 * b - (E = Math.min(k, b))), D.rightContX = m, D.rightContY = E;
              }
              return D = ["C", Q(d.rightContX, d.plotX, 0), Q(d.rightContY, d.plotY, 0), Q(g, A, 0), Q(x, b, 0), A, b], d.rightContX = d.rightContY = void 0, D;
            }, U.defaultOptions = J(Y.defaultOptions), U;
          }(Y), G.registerSeriesType("spline", F), F;
        }), _(at, "Series/AreaSpline/AreaSplineSeries.js", [at["Series/Spline/SplineSeries.js"], at["Core/Legend/LegendSymbol.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = this && this.__extends || /* @__PURE__ */ function() {
            var D = function(k, A) {
              return D = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
                b.__proto__ = d;
              } || function(b, d) {
                for (var m in d)
                  d.hasOwnProperty(m) && (b[m] = d[m]);
              }, D(k, A);
            };
            return function(k, A) {
              function b() {
                this.constructor = k;
              }
              D(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
            };
          }(), Q = $.seriesTypes, q = Q.area;
          Q = Q.area.prototype;
          var U = Y.extend, N = Y.merge;
          return Y = function(D) {
            function k() {
              var A = D !== null && D.apply(this, arguments) || this;
              return A.data = void 0, A.points = void 0, A.options = void 0, A;
            }
            return J(k, D), k.defaultOptions = N(G.defaultOptions, q.defaultOptions), k;
          }(G), U(Y.prototype, { getGraphPath: Q.getGraphPath, getStackPoints: Q.getStackPoints, drawGraph: Q.drawGraph, drawLegendSymbol: F.drawRectangle }), $.registerSeriesType("areaspline", Y), Y;
        }), _(at, "Series/Column/ColumnSeriesDefaults.js", [], function() {
          return { borderRadius: 0, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
        }), _(at, "Series/Column/ColumnSeries.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Color/Color.js"], at["Series/Column/ColumnSeriesDefaults.js"], at["Core/Globals.js"], at["Core/Legend/LegendSymbol.js"], at["Core/Series/Series.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N = this && this.__extends || /* @__PURE__ */ function() {
            var u = function(y, s) {
              return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, e) {
                a.__proto__ = e;
              } || function(a, e) {
                for (var n in e)
                  e.hasOwnProperty(n) && (a[n] = e[n]);
              }, u(y, s);
            };
            return function(y, s) {
              function a() {
                this.constructor = y;
              }
              u(y, s), y.prototype = s === null ? Object.create(s) : (a.prototype = s.prototype, new a());
            };
          }(), D = G.animObject, k = F.parse, A = Y.hasTouch;
          G = Y.noop;
          var b = U.clamp, d = U.defined, m = U.extend, v = U.fireEvent, g = U.isArray, x = U.isNumber, E = U.merge, P = U.pick, S = U.objectEach;
          return U = function(u) {
            function y() {
              var s = u !== null && u.apply(this, arguments) || this;
              return s.borderWidth = void 0, s.data = void 0, s.group = void 0, s.options = void 0, s.points = void 0, s;
            }
            return N(y, u), y.prototype.animate = function(s) {
              var a = this, e = this.yAxis, n = a.options, o = this.chart.inverted, i = {}, c = o ? "translateX" : "translateY";
              if (s)
                i.scaleY = 1e-3, s = b(e.toPixels(n.threshold), e.pos, e.pos + e.len), o ? i.translateX = s - e.len : i.translateY = s, a.clipBox && a.setClip(), a.group.attr(i);
              else {
                var l = Number(a.group.attr(c));
                a.group.animate({ scaleY: 1 }, m(D(a.options.animation), { step: function(h, C) {
                  a.group && (i[c] = l + C.pos * (e.pos - l), a.group.attr(i));
                } }));
              }
            }, y.prototype.init = function(s, a) {
              u.prototype.init.apply(this, arguments);
              var e = this;
              (s = e.chart).hasRendered && s.series.forEach(function(n) {
                n.type === e.type && (n.isDirty = !0);
              });
            }, y.prototype.getColumnMetrics = function() {
              var s = this, a = s.options, e = s.xAxis, n = s.yAxis, o = e.options.reversedStacks;
              o = e.reversed && !o || !e.reversed && o;
              var i, c = {}, l = 0;
              a.grouping === !1 ? l = 1 : s.chart.series.forEach(function(O) {
                var p = O.yAxis, w = O.options;
                if (O.type === s.type && (O.visible || !s.chart.options.chart.ignoreHiddenSeries) && n.len === p.len && n.pos === p.pos) {
                  if (w.stacking && w.stacking !== "group") {
                    i = O.stackKey, c[i] === void 0 && (c[i] = l++);
                    var T = c[i];
                  } else
                    w.grouping !== !1 && (T = l++);
                  O.columnIndex = T;
                }
              });
              var h = Math.min(Math.abs(e.transA) * (e.ordinal && e.ordinal.slope || a.pointRange || e.closestPointRange || e.tickInterval || 1), e.len), C = h * a.groupPadding, M = (h - 2 * C) / (l || 1);
              return a = Math.min(a.maxPointWidth || e.len, P(a.pointWidth, M * (1 - 2 * a.pointPadding))), s.columnMetrics = { width: a, offset: (M - a) / 2 + (C + ((s.columnIndex || 0) + (o ? 1 : 0)) * M - h / 2) * (o ? -1 : 1), paddedWidth: M, columnCount: l }, s.columnMetrics;
            }, y.prototype.crispCol = function(s, a, e, n) {
              var o = this.chart, i = this.borderWidth, c = -(i % 2 ? 0.5 : 0);
              return i = i % 2 ? 0.5 : 1, o.inverted && o.renderer.isVML && (i += 1), this.options.crisp && (e = Math.round(s + e) + c, e -= s = Math.round(s) + c), n = Math.round(a + n) + i, c = 0.5 >= Math.abs(a) && 0.5 < n, n -= a = Math.round(a) + i, c && n && (--a, n += 1), { x: s, y: a, width: e, height: n };
            }, y.prototype.adjustForMissingColumns = function(s, a, e, n) {
              var o = this, i = this.options.stacking;
              if (!e.isNull && 1 < n.columnCount) {
                var c = this.yAxis.options.reversedStacks, l = 0, h = c ? 0 : -n.columnCount;
                S(this.yAxis.stacking && this.yAxis.stacking.stacks, function(C) {
                  if (typeof e.x == "number") {
                    var M = C[e.x.toString()];
                    M && (C = M.points[o.index], i ? (C && (l = h), M.hasValidPoints && (c ? h++ : h--)) : g(C) && (C = Object.keys(M.points).filter(function(O) {
                      return !O.match(",") && M.points[O] && 1 < M.points[O].length;
                    }).map(parseFloat).sort(function(O, p) {
                      return p - O;
                    }), l = C.indexOf(o.index), h = C.length));
                  }
                }), s = (e.plotX || 0) + ((h - 1) * n.paddedWidth + a) / 2 - a - l * n.paddedWidth;
              }
              return s;
            }, y.prototype.translate = function() {
              var s = this, a = s.chart, e = s.options, n = s.dense = 2 > s.closestPointRange * s.xAxis.transA;
              n = s.borderWidth = P(e.borderWidth, n ? 0 : 1);
              var o = s.xAxis, i = s.yAxis, c = e.threshold, l = s.translatedThreshold = i.getThreshold(c), h = P(e.minPointLength, 5), C = s.getColumnMetrics(), M = C.width, O = s.pointXOffset = C.offset, p = s.dataMin, w = s.dataMax, T = s.barW = Math.max(M, 1 + 2 * n);
              a.inverted && (l -= 0.5), e.pointPadding && (T = Math.ceil(T)), Q.prototype.translate.apply(s), s.points.forEach(function(z) {
                var W = P(z.yBottom, l), L = 999 + Math.abs(W), I = z.plotX || 0;
                L = b(z.plotY, -L, i.len + L);
                var j = Math.min(L, W), Z = Math.max(L, W) - j, V = M, X = I + O, et = T;
                h && Math.abs(Z) < h && (Z = h, I = !i.reversed && !z.negative || i.reversed && z.negative, x(c) && x(w) && z.y === c && w <= c && (i.min || 0) < c && (p !== w || (i.max || 0) <= c) && (I = !I), j = Math.abs(j - l) > h ? W - h : l - (I ? h : 0)), d(z.options.pointWidth) && (V = et = Math.ceil(z.options.pointWidth), X -= Math.round((V - M) / 2)), e.centerInCategory && (X = s.adjustForMissingColumns(X, V, z, C)), z.barX = X, z.pointWidth = V, z.tooltipPos = a.inverted ? [b(i.len + i.pos - a.plotLeft - L, i.pos - a.plotLeft, i.len + i.pos - a.plotLeft), o.len + o.pos - a.plotTop - X - et / 2, Z] : [o.left - a.plotLeft + X + et / 2, b(L + i.pos - a.plotTop, i.pos - a.plotTop, i.len + i.pos - a.plotTop), Z], z.shapeType = s.pointClass.prototype.shapeType || "rect", z.shapeArgs = s.crispCol.apply(s, z.isNull ? [X, l, et, 0] : [X, j, et, Z]);
              });
            }, y.prototype.drawGraph = function() {
              this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }, y.prototype.pointAttribs = function(s, a) {
              var e = this.options, n = this.pointAttrToOptions || {}, o = n.stroke || "borderColor", i = n["stroke-width"] || "borderWidth", c = s && s.color || this.color, l = s && s[o] || e[o] || c;
              n = s && s.options.dashStyle || e.dashStyle;
              var h = s && s[i] || e[i] || this[i] || 0, C = P(s && s.opacity, e.opacity, 1);
              if (s && this.zones.length) {
                var M = s.getZone();
                c = s.options.color || M && (M.color || s.nonZonedColor) || this.color, M && (l = M.borderColor || l, n = M.dashStyle || n, h = M.borderWidth || h);
              }
              return a && s && (a = (s = E(e.states[a], s.options.states && s.options.states[a] || {})).brightness, c = s.color || a !== void 0 && k(c).brighten(s.brightness).get() || c, l = s[o] || l, h = s[i] || h, n = s.dashStyle || n, C = P(s.opacity, C)), o = { fill: c, stroke: l, "stroke-width": h, opacity: C }, n && (o.dashstyle = n), o;
            }, y.prototype.drawPoints = function(s) {
              s === void 0 && (s = this.points);
              var a, e = this, n = this.chart, o = e.options, i = n.renderer, c = o.animationLimit || 250;
              s.forEach(function(l) {
                var h = l.graphic, C = !!h, M = h && n.pointCount < c ? "animate" : "attr";
                x(l.plotY) && l.y !== null ? (a = l.shapeArgs, h && l.hasNewShapeType() && (h = h.destroy()), e.enabledDataSorting && (l.startXPos = e.xAxis.reversed ? -(a && a.width || 0) : e.xAxis.width), h || (l.graphic = h = i[l.shapeType](a).add(l.group || e.group)) && e.enabledDataSorting && n.hasRendered && n.pointCount < c && (h.attr({ x: l.startXPos }), C = !0, M = "animate"), h && C && h[M](E(a)), o.borderRadius && h[M]({ r: o.borderRadius }), n.styledMode || h[M](e.pointAttribs(l, l.selected && "select")).shadow(l.allowShadow !== !1 && o.shadow, null, o.stacking && !o.borderRadius), h && (h.addClass(l.getClassName(), !0), h.attr({ visibility: l.visible ? "inherit" : "hidden" }))) : h && (l.graphic = h.destroy());
              });
            }, y.prototype.drawTracker = function(s) {
              s === void 0 && (s = this.points);
              var a, e = this, n = e.chart, o = n.pointer, i = function(c) {
                var l = o.getPointFromEvent(c);
                l !== void 0 && (o.isDirectTouch = !0, l.onMouseOver(c));
              };
              s.forEach(function(c) {
                a = g(c.dataLabels) ? c.dataLabels : c.dataLabel ? [c.dataLabel] : [], c.graphic && (c.graphic.element.point = c), a.forEach(function(l) {
                  l.div ? l.div.point = c : l.element.point = c;
                });
              }), e._hasTracking || (e.trackerGroups.forEach(function(c) {
                e[c] && (e[c].addClass("highcharts-tracker").on("mouseover", i).on("mouseout", function(l) {
                  o.onTrackerMouseOut(l);
                }), A && e[c].on("touchstart", i), !n.styledMode && e.options.cursor && e[c].css({ cursor: e.options.cursor }));
              }), e._hasTracking = !0), v(this, "afterDrawTracker");
            }, y.prototype.remove = function() {
              var s = this, a = s.chart;
              a.hasRendered && a.series.forEach(function(e) {
                e.type === s.type && (e.isDirty = !0);
              }), Q.prototype.remove.apply(s, arguments);
            }, y.defaultOptions = E(Q.defaultOptions, $), y;
          }(Q), m(U.prototype, { cropShoulder: 0, directTouch: !0, drawLegendSymbol: J.drawRectangle, getSymbol: G, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), q.registerSeriesType("column", U), U;
        }), _(at, "Core/Series/DataLabel.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/FormatUtilities.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = G.getDeferredAnimation, Q = F.format, q = $.defined, U = $.extend, N = $.fireEvent, D = $.isArray, k = $.isString, A = $.merge, b = $.objectEach, d = $.pick, m = $.splat;
          return function(v) {
            function g(y, s, a, e, n) {
              var o = this, i = this.chart, c = this.isCartesian && i.inverted, l = this.enabledDataSorting, h = y.plotX, C = y.plotY, M = a.rotation, O = a.align, p = q(h) && q(C) && i.isInsidePlot(h, Math.round(C), { inverted: c, paneCoordinates: !0, series: o });
              C = function(W) {
                l && o.xAxis && !w && o.setDataLabelStartPos(y, s, n, p, W);
              };
              var w = d(a.overflow, l ? "none" : "justify") === "justify";
              if (h = this.visible && y.visible !== !1 && q(h) && (y.series.forceDL || l && !w || p || d(a.inside, !!this.options.stacking) && e && i.isInsidePlot(h, c ? e.x + 1 : e.y + e.height - 1, { inverted: c, paneCoordinates: !0, series: o })), c = y.pos(), h && c) {
                M && s.attr({ align: O }), O = s.getBBox(!0);
                var T = [0, 0], z = i.renderer.fontMetrics(i.styledMode ? void 0 : a.style.fontSize, s).b;
                e = U({ x: c[0], y: Math.round(c[1]), width: 0, height: 0 }, e), U(a, { width: O.width, height: O.height }), M ? (w = !1, T = i.renderer.rotCorr(z, M), z = { x: e.x + (a.x || 0) + e.width / 2 + T.x, y: e.y + (a.y || 0) + { top: 0, middle: 0.5, bottom: 1 }[a.verticalAlign] * e.height }, T = [O.x - Number(s.attr("x")), O.y - Number(s.attr("y"))], C(z), s[n ? "attr" : "animate"](z)) : (C(e), s.align(a, void 0, e), z = s.alignAttr), w && 0 <= e.height ? this.justifyDataLabel(s, a, z, O, e, n) : d(a.crop, !0) && (e = z.x, C = z.y, e += T[0], C += T[1], h = i.isInsidePlot(e, C, { paneCoordinates: !0, series: o }) && i.isInsidePlot(e + O.width, C + O.height, { paneCoordinates: !0, series: o })), a.shape && !M && s[n ? "attr" : "animate"]({ anchorX: c[0], anchorY: c[1] });
              }
              n && l && (s.placed = !1), h || l && !w ? s.show() : (s.hide(), s.placed = !1);
            }
            function x(y) {
              y === void 0 && (y = this.points);
              var s = this, a = s.chart, e = s.options, n = s.hasRendered || 0, o = a.renderer, i = a.options.chart, c = i.backgroundColor;
              i = i.plotBackgroundColor;
              var l = o.getContrast(k(i) && i || k(c) && c || "#000000"), h = e.dataLabels;
              if (c = h.animation, c = h.defer ? J(a, c, s) : { defer: 0, duration: 0 }, h = P(P(a.options.plotOptions && a.options.plotOptions.series && a.options.plotOptions.series.dataLabels, a.options.plotOptions && a.options.plotOptions[s.type] && a.options.plotOptions[s.type].dataLabels), h), N(this, "drawDataLabels"), D(h) || h.enabled || s._hasPointLabels) {
                var C = s.plotGroup("dataLabelsGroup", "data-labels", n ? "inherit" : "hidden", h.zIndex || 6);
                C.attr({ opacity: +n }), !n && (n = s.dataLabelsGroup) && (s.visible && C.show(), n[e.animation ? "animate" : "attr"]({ opacity: 1 }, c)), y.forEach(function(M) {
                  m(P(h, M.dlOptions || M.options && M.options.dataLabels)).forEach(function(O, p) {
                    var w = O.enabled && (!M.isNull || M.dataLabelOnNull) && function(et, ot) {
                      var it = ot.filter;
                      return !it || (ot = it.operator, et = et[it.property], it = it.value, ot === ">" && et > it || ot === "<" && et < it || ot === ">=" && et >= it || ot === "<=" && et <= it || ot === "==" && et == it || ot === "===" && et === it);
                    }(M, O), T = M.connectors ? M.connectors[p] : M.connector, z = M.dataLabels ? M.dataLabels[p] : M.dataLabel, W = !z, L = d(O.distance, M.labelDistance);
                    if (w) {
                      var I = M.getLabelConfig(), j = d(O[M.formatPrefix + "Format"], O.format);
                      I = q(j) ? Q(j, I, a) : (O[M.formatPrefix + "Formatter"] || O.formatter).call(I, O), j = O.style;
                      var Z = O.rotation;
                      a.styledMode || (j.color = d(O.color, j.color, s.color, "#000000"), j.color === "contrast" ? (M.contrastColor = o.getContrast(M.color || s.color), j.color = !q(L) && O.inside || 0 > L || e.stacking ? M.contrastColor : l) : delete M.contrastColor, e.cursor && (j.cursor = e.cursor));
                      var V = { r: O.borderRadius || 0, rotation: Z, padding: O.padding, zIndex: 1 };
                      if (!a.styledMode) {
                        L = O.backgroundColor;
                        var X = O.borderColor;
                        V.fill = L === "auto" ? M.color : L, V.stroke = X === "auto" ? M.color : X, V["stroke-width"] = O.borderWidth;
                      }
                      b(V, function(et, ot) {
                        et === void 0 && delete V[ot];
                      });
                    }
                    !z || w && q(I) && !!z.div == !!O.useHTML && (z.rotation && O.rotation || z.rotation === O.rotation) || (W = !0, M.dataLabel = z = M.dataLabel && M.dataLabel.destroy(), M.dataLabels && (M.dataLabels.length === 1 ? delete M.dataLabels : delete M.dataLabels[p]), p || delete M.dataLabel, T && (M.connector = M.connector.destroy(), M.connectors && (M.connectors.length === 1 ? delete M.connectors : delete M.connectors[p]))), w && q(I) ? (z ? V.text = I : (M.dataLabels = M.dataLabels || [], z = M.dataLabels[p] = Z ? o.text(I, 0, 0, O.useHTML).addClass("highcharts-data-label") : o.label(I, 0, 0, O.shape, null, null, O.useHTML, null, "data-label"), p || (M.dataLabel = z), z.addClass(" highcharts-data-label-color-" + M.colorIndex + " " + (O.className || "") + (O.useHTML ? " highcharts-tracker" : ""))), z.options = O, z.attr(V), a.styledMode || z.css(j).shadow(O.shadow), (p = O[M.formatPrefix + "TextPath"] || O.textPath) && !O.useHTML && (z.setTextPath(M.getDataLabelPath && M.getDataLabelPath(z) || M.graphic, p), M.dataLabelPath && !p.enabled && (M.dataLabelPath = M.dataLabelPath.destroy())), z.added || z.add(C), s.alignDataLabel(M, z, O, null, W)) : z && z.hide();
                  });
                });
              }
              N(this, "afterDrawDataLabels");
            }
            function E(y, s, a, e, n, o) {
              var i = this.chart, c = s.align, l = s.verticalAlign, h = y.box ? 0 : y.padding || 0, C = s.x;
              C = C === void 0 ? 0 : C;
              var M = s.y;
              M = M === void 0 ? 0 : M;
              var O = (a.x || 0) + h;
              if (0 > O) {
                c === "right" && 0 <= C ? (s.align = "left", s.inside = !0) : C -= O;
                var p = !0;
              }
              return (O = (a.x || 0) + e.width - h) > i.plotWidth && (c === "left" && 0 >= C ? (s.align = "right", s.inside = !0) : C += i.plotWidth - O, p = !0), 0 > (O = a.y + h) && (l === "bottom" && 0 <= M ? (s.verticalAlign = "top", s.inside = !0) : M -= O, p = !0), (O = (a.y || 0) + e.height - h) > i.plotHeight && (l === "top" && 0 >= M ? (s.verticalAlign = "bottom", s.inside = !0) : M += i.plotHeight - O, p = !0), p && (s.x = C, s.y = M, y.placed = !o, y.align(s, void 0, n)), p;
            }
            function P(y, s) {
              var a, e = [];
              if (D(y) && !D(s))
                e = y.map(function(n) {
                  return A(n, s);
                });
              else if (D(s) && !D(y))
                e = s.map(function(n) {
                  return A(y, n);
                });
              else if (D(y) || D(s))
                for (a = Math.max(y.length, s.length); a--; )
                  e[a] = A(y[a], s[a]);
              else
                e = A(y, s);
              return e;
            }
            function S(y, s, a, e, n) {
              var o = this.chart, i = o.inverted, c = this.xAxis, l = c.reversed, h = i ? s.height / 2 : s.width / 2;
              y = (y = y.pointWidth) ? y / 2 : 0, s.startXPos = i ? n.x : l ? -h - y : c.width - h + y, s.startYPos = i ? l ? this.yAxis.height - h + y : -h - y : n.y, e ? s.visibility === "hidden" && (s.show(), s.attr({ opacity: 0 }).animate({ opacity: 1 })) : s.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, s.hide), o.hasRendered && (a && s.attr({ x: s.startXPos, y: s.startYPos }), s.placed = !0);
            }
            var u = [];
            v.compose = function(y) {
              if (u.indexOf(y) === -1) {
                var s = y.prototype;
                u.push(y), s.alignDataLabel = g, s.drawDataLabels = x, s.justifyDataLabel = E, s.setDataLabelStartPos = S;
              }
            };
          }(Y || (Y = {})), Y;
        }), _(at, "Series/Column/ColumnDataLabel.js", [at["Core/Series/DataLabel.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = F.series, Q = $.merge, q = $.pick;
          return function(U) {
            function N(k, A, b, d, m) {
              var v = this.chart.inverted, g = k.series, x = (g.xAxis ? g.xAxis.len : this.chart.plotSizeX) || 0;
              g = (g.yAxis ? g.yAxis.len : this.chart.plotSizeY) || 0;
              var E = k.dlBox || k.shapeArgs, P = q(k.below, k.plotY > q(this.translatedThreshold, g)), S = q(b.inside, !!this.options.stacking);
              E && (0 > (d = Q(E)).y && (d.height += d.y, d.y = 0), 0 < (E = d.y + d.height - g) && E < d.height && (d.height -= E), v && (d = { x: g - d.y - d.height, y: x - d.x - d.width, width: d.height, height: d.width }), S || (v ? (d.x += P ? 0 : d.width, d.width = 0) : (d.y += P ? d.height : 0, d.height = 0))), b.align = q(b.align, !v || S ? "center" : P ? "right" : "left"), b.verticalAlign = q(b.verticalAlign, v || S ? "middle" : P ? "top" : "bottom"), J.prototype.alignDataLabel.call(this, k, A, b, d, m), b.inside && k.contrastColor && A.css({ color: k.contrastColor });
            }
            var D = [];
            U.compose = function(k) {
              G.compose(J), D.indexOf(k) === -1 && (D.push(k), k.prototype.alignDataLabel = N);
            };
          }(Y || (Y = {})), Y;
        }), _(at, "Series/Bar/BarSeries.js", [at["Series/Column/ColumnSeries.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = this && this.__extends || /* @__PURE__ */ function() {
            var q = function(U, N) {
              return (q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, k) {
                D.__proto__ = k;
              } || function(D, k) {
                for (var A in k)
                  k.hasOwnProperty(A) && (D[A] = k[A]);
              })(U, N);
            };
            return function(U, N) {
              function D() {
                this.constructor = U;
              }
              q(U, N), U.prototype = N === null ? Object.create(N) : (D.prototype = N.prototype, new D());
            };
          }(), J = $.extend, Q = $.merge;
          return $ = function(q) {
            function U() {
              var N = q !== null && q.apply(this, arguments) || this;
              return N.data = void 0, N.options = void 0, N.points = void 0, N;
            }
            return Y(U, q), U.defaultOptions = Q(G.defaultOptions, {}), U;
          }(G), J($.prototype, { inverted: !0 }), F.registerSeriesType("bar", $), $;
        }), _(at, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
          return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
        }), _(at, "Series/Scatter/ScatterSeries.js", [at["Series/Scatter/ScatterSeriesDefaults.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = this && this.__extends || /* @__PURE__ */ function() {
            var D = function(k, A) {
              return D = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
                b.__proto__ = d;
              } || function(b, d) {
                for (var m in d)
                  d.hasOwnProperty(m) && (b[m] = d[m]);
              }, D(k, A);
            };
            return function(k, A) {
              function b() {
                this.constructor = k;
              }
              D(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
            };
          }(), J = F.seriesTypes, Q = J.column, q = J.line;
          J = $.addEvent;
          var U = $.extend, N = $.merge;
          return $ = function(D) {
            function k() {
              var A = D !== null && D.apply(this, arguments) || this;
              return A.data = void 0, A.options = void 0, A.points = void 0, A;
            }
            return Y(k, D), k.prototype.applyJitter = function() {
              var A = this, b = this.options.jitter, d = this.points.length;
              b && this.points.forEach(function(m, v) {
                ["x", "y"].forEach(function(g, x) {
                  var E = "plot" + g.toUpperCase();
                  if (b[g] && !m.isNull) {
                    var P = A[g + "Axis"], S = b[g] * P.transA;
                    if (P && !P.isLog) {
                      var u = Math.max(0, m[E] - S);
                      P = Math.min(P.len, m[E] + S), x = 1e4 * Math.sin(v + x * d), m[E] = u + (P - u) * (x - Math.floor(x)), g === "x" && (m.clientX = m.plotX);
                    }
                  }
                });
              });
            }, k.prototype.drawGraph = function() {
              this.options.lineWidth ? D.prototype.drawGraph.call(this) : this.graph && (this.graph = this.graph.destroy());
            }, k.defaultOptions = N(q.defaultOptions, G), k;
          }(q), U($.prototype, { drawTracker: Q.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], takeOrdinalPosition: !1 }), J($, "afterTranslate", function() {
            this.applyJitter();
          }), F.registerSeriesType("scatter", $), $;
        }), _(at, "Series/CenteredUtilities.js", [at["Core/Globals.js"], at["Core/Series/Series.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = G.deg2rad, Q = $.fireEvent, q = $.isNumber, U = $.pick, N = $.relativeLength;
          return function(D) {
            D.getCenter = function() {
              var k = this.options, A = this.chart, b = 2 * (k.slicedOffset || 0), d = A.plotWidth - 2 * b, m = A.plotHeight - 2 * b, v = k.center, g = Math.min(d, m), x = k.thickness, E = k.size, P = k.innerSize || 0;
              for (typeof E == "string" && (E = parseFloat(E)), typeof P == "string" && (P = parseFloat(P)), k = [U(v[0], "50%"), U(v[1], "50%"), U(E && 0 > E ? void 0 : k.size, "100%"), U(P && 0 > P ? void 0 : k.innerSize || 0, "0%")], !A.angular || this instanceof F || (k[3] = 0), v = 0; 4 > v; ++v)
                E = k[v], A = 2 > v || v === 2 && /%$/.test(E), k[v] = N(E, [d, m, g, k[2]][v]) + (A ? b : 0);
              return k[3] > k[2] && (k[3] = k[2]), q(x) && 2 * x < k[2] && 0 < x && (k[3] = k[2] - 2 * x), Q(this, "afterGetCenter", { positions: k }), k;
            }, D.getStartAndEndRadians = function(k, A) {
              return k = q(k) ? k : 0, A = q(A) && A > k && 360 > A - k ? A : k + 360, { start: J * (k + -90), end: J * (A + -90) };
            };
          }(Y || (Y = {})), Y;
        }), _(at, "Series/Pie/PiePoint.js", [at["Core/Animation/AnimationUtilities.js"], at["Core/Series/Point.js"], at["Core/Utilities.js"]], function(G, F, $) {
          var Y = this && this.__extends || /* @__PURE__ */ function() {
            var k = function(A, b) {
              return k = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, m) {
                d.__proto__ = m;
              } || function(d, m) {
                for (var v in m)
                  m.hasOwnProperty(v) && (d[v] = m[v]);
              }, k(A, b);
            };
            return function(A, b) {
              function d() {
                this.constructor = A;
              }
              k(A, b), A.prototype = b === null ? Object.create(b) : (d.prototype = b.prototype, new d());
            };
          }(), J = G.setAnimation, Q = $.addEvent, q = $.defined;
          G = $.extend;
          var U = $.isNumber, N = $.pick, D = $.relativeLength;
          return F = function(k) {
            function A() {
              var b = k !== null && k.apply(this, arguments) || this;
              return b.labelDistance = void 0, b.options = void 0, b.series = void 0, b;
            }
            return Y(A, k), A.prototype.getConnectorPath = function() {
              var b = this.labelPosition, d = this.series.options.dataLabels, m = this.connectorShapes, v = d.connectorShape;
              return m[v] && (v = m[v]), v.call(this, { x: b.final.x, y: b.final.y, alignment: b.alignment }, b.connectorPosition, d);
            }, A.prototype.getTranslate = function() {
              return this.sliced ? this.slicedTranslation : { translateX: 0, translateY: 0 };
            }, A.prototype.haloPath = function(b) {
              var d = this.shapeArgs;
              return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(d.x, d.y, d.r + b, d.r + b, { innerR: d.r - 1, start: d.start, end: d.end });
            }, A.prototype.init = function() {
              var b = this;
              k.prototype.init.apply(this, arguments), this.name = N(this.name, "Slice");
              var d = function(m) {
                b.slice(m.type === "select");
              };
              return Q(this, "select", d), Q(this, "unselect", d), this;
            }, A.prototype.isValid = function() {
              return U(this.y) && 0 <= this.y;
            }, A.prototype.setVisible = function(b, d) {
              var m = this, v = this.series, g = v.chart, x = v.options.ignoreHiddenPoint;
              d = N(d, x), b !== this.visible && (this.visible = this.options.visible = b = b === void 0 ? !this.visible : b, v.options.data[v.data.indexOf(this)] = this.options, ["graphic", "dataLabel", "connector", "shadowGroup"].forEach(function(E) {
                m[E] && m[E][b ? "show" : "hide"](b);
              }), this.legendItem && g.legend.colorizeItem(this, b), b || this.state !== "hover" || this.setState(""), x && (v.isDirty = !0), d && g.redraw());
            }, A.prototype.slice = function(b, d, m) {
              var v = this.series;
              J(m, v.chart), N(d, !0), this.sliced = this.options.sliced = q(b) ? b : !this.sliced, v.options.data[v.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate()), this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
            }, A;
          }(F), G(F.prototype, { connectorShapes: { fixedOffset: function(k, A, b) {
            var d = A.breakAt;
            return A = A.touchingSliceAt, [["M", k.x, k.y], b.softConnector ? ["C", k.x + (k.alignment === "left" ? -5 : 5), k.y, 2 * d.x - A.x, 2 * d.y - A.y, d.x, d.y] : ["L", d.x, d.y], ["L", A.x, A.y]];
          }, straight: function(k, A) {
            return A = A.touchingSliceAt, [["M", k.x, k.y], ["L", A.x, A.y]];
          }, crookedLine: function(k, A, b) {
            A = A.touchingSliceAt;
            var d = this.series, m = d.center[0], v = d.chart.plotWidth, g = d.chart.plotLeft;
            d = k.alignment;
            var x = this.shapeArgs.r;
            return b = D(b.crookDistance, 1), b = ["L", v = d === "left" ? m + x + (v + g - m - x) * (1 - b) : g + (m - x) * b, k.y], m = !0, (d === "left" ? v > k.x || v < A.x : v < k.x || v > A.x) && (m = !1), k = [["M", k.x, k.y]], m && k.push(b), k.push(["L", A.x, A.y]), k;
          } } }), F;
        }), _(at, "Series/Pie/PieSeriesDefaults.js", [], function() {
          return { center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { allowOverlap: !0, connectorPadding: 5, connectorShape: "fixedOffset", crookDistance: "70%", distance: 30, enabled: !0, formatter: function() {
            return this.point.isNull ? void 0 : this.point.name;
          }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
        }), _(at, "Series/Pie/PieSeries.js", [at["Series/CenteredUtilities.js"], at["Series/Column/ColumnSeries.js"], at["Core/Globals.js"], at["Core/Legend/LegendSymbol.js"], at["Series/Pie/PiePoint.js"], at["Series/Pie/PieSeriesDefaults.js"], at["Core/Series/Series.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Renderer/SVG/Symbols.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N, D) {
          var k = this && this.__extends || /* @__PURE__ */ function() {
            var E = function(P, S) {
              return E = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, y) {
                u.__proto__ = y;
              } || function(u, y) {
                for (var s in y)
                  y.hasOwnProperty(s) && (u[s] = y[s]);
              }, E(P, S);
            };
            return function(P, S) {
              function u() {
                this.constructor = P;
              }
              E(P, S), P.prototype = S === null ? Object.create(S) : (u.prototype = S.prototype, new u());
            };
          }(), A = G.getStartAndEndRadians;
          $ = $.noop;
          var b = D.clamp, d = D.extend, m = D.fireEvent, v = D.merge, g = D.pick, x = D.relativeLength;
          return D = function(E) {
            function P() {
              var S = E !== null && E.apply(this, arguments) || this;
              return S.center = void 0, S.data = void 0, S.maxLabelDistance = void 0, S.options = void 0, S.points = void 0, S;
            }
            return k(P, E), P.prototype.animate = function(S) {
              var u = this, y = u.points, s = u.startAngleRad;
              S || y.forEach(function(a) {
                var e = a.graphic, n = a.shapeArgs;
                e && n && (e.attr({ r: g(a.startR, u.center && u.center[3] / 2), start: s, end: s }), e.animate({ r: n.r, start: n.start, end: n.end }, u.options.animation));
              });
            }, P.prototype.drawEmpty = function() {
              var S = this.startAngleRad, u = this.endAngleRad, y = this.options;
              if (this.total === 0 && this.center) {
                var s = this.center[0], a = this.center[1];
                this.graph || (this.graph = this.chart.renderer.arc(s, a, this.center[1] / 2, 0, S, u).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: N.arc(s, a, this.center[2] / 2, 0, { start: S, end: u, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": y.borderWidth, fill: y.fillColor || "none", stroke: y.color || "#cccccc" });
              } else
                this.graph && (this.graph = this.graph.destroy());
            }, P.prototype.drawPoints = function() {
              var S = this.chart.renderer;
              this.points.forEach(function(u) {
                u.graphic && u.hasNewShapeType() && (u.graphic = u.graphic.destroy()), u.graphic || (u.graphic = S[u.shapeType](u.shapeArgs).add(u.series.group), u.delayedRendering = !0);
              });
            }, P.prototype.generatePoints = function() {
              E.prototype.generatePoints.call(this), this.updateTotals();
            }, P.prototype.getX = function(S, u, y) {
              var s = this.center, a = this.radii ? this.radii[y.index] || 0 : s[2] / 2;
              return S = Math.asin(b((S - s[1]) / (a + y.labelDistance), -1, 1)), s[0] + (u ? -1 : 1) * Math.cos(S) * (a + y.labelDistance) + (0 < y.labelDistance ? (u ? -1 : 1) * this.options.dataLabels.padding : 0);
            }, P.prototype.hasData = function() {
              return !!this.processedXData.length;
            }, P.prototype.redrawPoints = function() {
              var S, u, y, s, a = this, e = a.chart, n = e.renderer, o = a.options.shadow;
              this.drawEmpty(), !o || a.shadowGroup || e.styledMode || (a.shadowGroup = n.g("shadow").attr({ zIndex: -1 }).add(a.group)), a.points.forEach(function(i) {
                var c = {};
                if (u = i.graphic, !i.isNull && u) {
                  var l = void 0;
                  s = i.shapeArgs, S = i.getTranslate(), e.styledMode || (l = i.shadowGroup, o && !l && (l = i.shadowGroup = n.g("shadow").add(a.shadowGroup)), l && l.attr(S), y = a.pointAttribs(i, i.selected && "select")), i.delayedRendering ? (u.setRadialReference(a.center).attr(s).attr(S), e.styledMode || u.attr(y).attr({ "stroke-linejoin": "round" }).shadow(o, l), i.delayedRendering = !1) : (u.setRadialReference(a.center), e.styledMode || v(!0, c, y), v(!0, c, s, S), u.animate(c)), u.attr({ visibility: i.visible ? "inherit" : "hidden" }), u.addClass(i.getClassName(), !0);
                } else
                  u && (i.graphic = u.destroy());
              });
            }, P.prototype.sortByAngle = function(S, u) {
              S.sort(function(y, s) {
                return y.angle !== void 0 && (s.angle - y.angle) * u;
              });
            }, P.prototype.translate = function(S) {
              m(this, "translate"), this.generatePoints();
              var u = this.options, y = u.slicedOffset, s = y + (u.borderWidth || 0), a = A(u.startAngle, u.endAngle), e = this.startAngleRad = a.start;
              a = (this.endAngleRad = a.end) - e;
              var n = this.points, o = u.dataLabels.distance;
              u = u.ignoreHiddenPoint;
              var i, c = n.length, l = 0;
              for (S || (this.center = S = this.getCenter()), i = 0; i < c; i++) {
                var h = n[i], C = e + l * a;
                !h.isValid() || u && !h.visible || (l += h.percentage / 100);
                var M = e + l * a, O = { x: S[0], y: S[1], r: S[2] / 2, innerR: S[3] / 2, start: Math.round(1e3 * C) / 1e3, end: Math.round(1e3 * M) / 1e3 };
                h.shapeType = "arc", h.shapeArgs = O, h.labelDistance = g(h.options.dataLabels && h.options.dataLabels.distance, o), h.labelDistance = x(h.labelDistance, O.r), this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, h.labelDistance), (M = (M + C) / 2) > 1.5 * Math.PI ? M -= 2 * Math.PI : M < -Math.PI / 2 && (M += 2 * Math.PI), h.slicedTranslation = { translateX: Math.round(Math.cos(M) * y), translateY: Math.round(Math.sin(M) * y) }, O = Math.cos(M) * S[2] / 2;
                var p = Math.sin(M) * S[2] / 2;
                h.tooltipPos = [S[0] + 0.7 * O, S[1] + 0.7 * p], h.half = M < -Math.PI / 2 || M > Math.PI / 2 ? 1 : 0, h.angle = M, C = Math.min(s, h.labelDistance / 5), h.labelPosition = { natural: { x: S[0] + O + Math.cos(M) * h.labelDistance, y: S[1] + p + Math.sin(M) * h.labelDistance }, final: {}, alignment: 0 > h.labelDistance ? "center" : h.half ? "right" : "left", connectorPosition: { breakAt: { x: S[0] + O + Math.cos(M) * C, y: S[1] + p + Math.sin(M) * C }, touchingSliceAt: { x: S[0] + O, y: S[1] + p } } };
              }
              m(this, "afterTranslate");
            }, P.prototype.updateTotals = function() {
              var S, u = this.points, y = u.length, s = this.options.ignoreHiddenPoint, a = 0;
              for (S = 0; S < y; S++) {
                var e = u[S];
                !e.isValid() || s && !e.visible || (a += e.y);
              }
              for (this.total = a, S = 0; S < y; S++)
                (e = u[S]).percentage = 0 < a && (e.visible || !s) ? e.y / a * 100 : 0, e.total = a;
            }, P.defaultOptions = v(q.defaultOptions, Q), P;
          }(q), d(D.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawLegendSymbol: Y.drawRectangle, drawTracker: F.prototype.drawTracker, getCenter: G.getCenter, getSymbol: $, isCartesian: !1, noSharedTooltip: !0, pointAttribs: F.prototype.pointAttribs, pointClass: J, requireSorting: !1, searchPoint: $, trackerGroups: ["group", "dataLabelsGroup"] }), U.registerSeriesType("pie", D), D;
        }), _(at, "Series/Pie/PieDataLabel.js", [at["Core/Series/DataLabel.js"], at["Core/Globals.js"], at["Core/Renderer/RendererUtilities.js"], at["Core/Series/SeriesRegistry.js"], at["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q, q = F.noop, U = $.distribute, N = Y.series, D = J.arrayMax, k = J.clamp, A = J.defined, b = J.merge, d = J.pick, m = J.relativeLength;
          return function(v) {
            function g() {
              var u, y, s, a, e, n, o, i, c, l, h, C, M = this, O = M.data, p = M.chart, w = M.options.dataLabels || {}, T = w.connectorPadding, z = p.plotWidth, W = p.plotHeight, L = p.plotLeft, I = Math.round(p.chartWidth / 3), j = M.center, Z = j[2] / 2, V = j[1], X = [[], []], et = [0, 0, 0, 0], ot = M.dataLabelPositioners;
              M.visible && (w.enabled || M._hasPointLabels) && (O.forEach(function(it) {
                it.dataLabel && it.visible && it.dataLabel.shortened && (it.dataLabel.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), it.dataLabel.shortened = !1);
              }), N.prototype.drawDataLabels.apply(M), O.forEach(function(it) {
                it.dataLabel && (it.visible ? (X[it.half].push(it), it.dataLabel._pos = null, !A(w.style.width) && !A(it.options.dataLabels && it.options.dataLabels.style && it.options.dataLabels.style.width) && it.dataLabel.getBBox().width > I && (it.dataLabel.css({ width: Math.round(0.7 * I) + "px" }), it.dataLabel.shortened = !0)) : (it.dataLabel = it.dataLabel.destroy(), it.dataLabels && it.dataLabels.length === 1 && delete it.dataLabels));
              }), X.forEach(function(it, pt) {
                var mt, Ct = it.length, kt = [];
                if (Ct) {
                  if (M.sortByAngle(it, pt - 0.5), 0 < M.maxLabelDistance) {
                    var Lt = Math.max(0, V - Z - M.maxLabelDistance), Tt = Math.min(V + Z + M.maxLabelDistance, p.plotHeight);
                    it.forEach(function(xt) {
                      0 < xt.labelDistance && xt.dataLabel && (xt.top = Math.max(0, V - Z - xt.labelDistance), xt.bottom = Math.min(V + Z + xt.labelDistance, p.plotHeight), mt = xt.dataLabel.getBBox().height || 21, xt.distributeBox = { target: xt.labelPosition.natural.y - xt.top + mt / 2, size: mt, rank: xt.y }, kt.push(xt.distributeBox));
                    }), U(kt, Lt = Tt + mt - Lt, Lt / 5);
                  }
                  for (h = 0; h < Ct; h++) {
                    if (u = it[h], n = u.labelPosition, a = u.dataLabel, l = u.visible === !1 ? "hidden" : "inherit", c = Lt = n.natural.y, kt && A(u.distributeBox) && (u.distributeBox.pos === void 0 ? l = "hidden" : (o = u.distributeBox.size, c = ot.radialDistributionY(u))), delete u.positionIndex, w.justify)
                      i = ot.justify(u, Z, j);
                    else
                      switch (w.alignTo) {
                        case "connectors":
                          i = ot.alignToConnectors(it, pt, z, L);
                          break;
                        case "plotEdges":
                          i = ot.alignToPlotEdges(a, pt, z, L);
                          break;
                        default:
                          i = ot.radialDistributionX(M, u, c, Lt);
                      }
                    a._attr = { visibility: l, align: n.alignment }, C = u.options.dataLabels || {}, a._pos = { x: i + d(C.x, w.x) + ({ left: T, right: -T }[n.alignment] || 0), y: c + d(C.y, w.y) - 10 }, n.final.x = i, n.final.y = c, d(w.crop, !0) && (e = a.getBBox().width, Lt = null, i - e < T && pt === 1 ? (Lt = Math.round(e - i + T), et[3] = Math.max(Lt, et[3])) : i + e > z - T && pt === 0 && (Lt = Math.round(i + e - z + T), et[1] = Math.max(Lt, et[1])), 0 > c - o / 2 ? et[0] = Math.max(Math.round(o / 2 - c), et[0]) : c + o / 2 > W && (et[2] = Math.max(Math.round(c + o / 2 - W), et[2])), a.sideOverflow = Lt);
                  }
                }
              }), D(et) === 0 || this.verifyDataLabelOverflow(et)) && (this.placeDataLabels(), this.points.forEach(function(it) {
                var pt;
                C = b(w, it.options.dataLabels), (y = d(C.connectorWidth, 1)) && (s = it.connector, (a = it.dataLabel) && a._pos && it.visible && 0 < it.labelDistance ? (l = a._attr.visibility, (pt = !s) && (it.connector = s = p.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + it.colorIndex + (it.className ? " " + it.className : "")).add(M.dataLabelsGroup), p.styledMode || s.attr({ "stroke-width": y, stroke: C.connectorColor || it.color || "#666666" })), s[pt ? "attr" : "animate"]({ d: it.getConnectorPath() }), s.attr("visibility", l)) : s && (it.connector = s.destroy()));
              }));
            }
            function x() {
              this.points.forEach(function(u) {
                var y, s = u.dataLabel;
                s && u.visible && ((y = s._pos) ? (s.sideOverflow && (s._attr.width = Math.max(s.getBBox().width - s.sideOverflow, 0), s.css({ width: s._attr.width + "px", textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis" }), s.shortened = !0), s.attr(s._attr), s[s.moved ? "animate" : "attr"](y), s.moved = !0) : s && s.attr({ y: -9999 })), delete u.distributeBox;
              }, this);
            }
            function E(u) {
              var y = this.center, s = this.options, a = s.center, e = s.minSize || 80, n = s.size !== null;
              if (!n) {
                if (a[0] !== null)
                  var o = Math.max(y[2] - Math.max(u[1], u[3]), e);
                else
                  o = Math.max(y[2] - u[1] - u[3], e), y[0] += (u[3] - u[1]) / 2;
                a[1] !== null ? o = k(o, e, y[2] - Math.max(u[0], u[2])) : (o = k(o, e, y[2] - u[0] - u[2]), y[1] += (u[0] - u[2]) / 2), o < y[2] ? (y[2] = o, y[3] = Math.min(s.thickness ? Math.max(0, o - 2 * s.thickness) : Math.max(0, m(s.innerSize || 0, o)), o), this.translate(y), this.drawDataLabels && this.drawDataLabels()) : n = !0;
              }
              return n;
            }
            var P = [], S = { radialDistributionY: function(u) {
              return u.top + u.distributeBox.pos;
            }, radialDistributionX: function(u, y, s, a) {
              return u.getX(s < y.top + 2 || s > y.bottom - 2 ? a : s, y.half, y);
            }, justify: function(u, y, s) {
              return s[0] + (u.half ? -1 : 1) * (y + u.labelDistance);
            }, alignToPlotEdges: function(u, y, s, a) {
              return u = u.getBBox().width, y ? u + a : s - u - a;
            }, alignToConnectors: function(u, y, s, a) {
              var e, n = 0;
              return u.forEach(function(o) {
                (e = o.dataLabel.getBBox().width) > n && (n = e);
              }), y ? n + a : s - n - a;
            } };
            v.compose = function(u) {
              G.compose(N), P.indexOf(u) === -1 && (P.push(u), (u = u.prototype).dataLabelPositioners = S, u.alignDataLabel = q, u.drawDataLabels = g, u.placeDataLabels = x, u.verifyDataLabelOverflow = E);
            };
          }(Q || (Q = {})), Q;
        }), _(at, "Extensions/OverlappingDataLabels.js", [at["Core/Chart/Chart.js"], at["Core/Utilities.js"]], function(G, F) {
          function $(D, k) {
            var A = !1;
            if (D) {
              var b = D.newOpacity;
              D.oldOpacity !== b && (D.alignAttr && D.placed ? (D[b ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), A = !0, D.alignAttr.opacity = b, D[D.isOld ? "animate" : "attr"](D.alignAttr, null, function() {
                k.styledMode || D.css({ pointerEvents: b ? "auto" : "none" });
              }), J(k, "afterHideOverlappingLabel")) : D.attr({ opacity: b })), D.isOld = !0;
            }
            return A;
          }
          var Y = F.addEvent, J = F.fireEvent, Q = F.isArray, q = F.isNumber, U = F.objectEach, N = F.pick;
          Y(G, "render", function() {
            var D = this, k = [];
            (this.labelCollectors || []).forEach(function(A) {
              k = k.concat(A());
            }), (this.yAxis || []).forEach(function(A) {
              A.stacking && A.options.stackLabels && !A.options.stackLabels.allowOverlap && U(A.stacking.stacks, function(b) {
                U(b, function(d) {
                  d.label && k.push(d.label);
                });
              });
            }), (this.series || []).forEach(function(A) {
              var b = A.options.dataLabels;
              A.visible && (b.enabled !== !1 || A._hasPointLabels) && (b = function(d) {
                return d.forEach(function(m) {
                  m.visible && (Q(m.dataLabels) ? m.dataLabels : m.dataLabel ? [m.dataLabel] : []).forEach(function(v) {
                    var g = v.options;
                    v.labelrank = N(g.labelrank, m.labelrank, m.shapeArgs && m.shapeArgs.height), g.allowOverlap ? (v.oldOpacity = v.opacity, v.newOpacity = 1, $(v, D)) : k.push(v);
                  });
                });
              }, b(A.nodes || []), b(A.points));
            }), this.hideOverlappingLabels(k);
          }), G.prototype.hideOverlappingLabels = function(D) {
            var k, A, b, d = this, m = D.length, v = d.renderer, g = !1, x = function(S) {
              var u, y, s = S.box ? 0 : S.padding || 0, a = u = 0;
              if (S && (!S.alignAttr || S.placed)) {
                var e = S.alignAttr || { x: S.attr("x"), y: S.attr("y") }, n = S.parentGroup;
                S.width || (u = S.getBBox(), S.width = u.width, S.height = u.height, u = v.fontMetrics(null, S.element).h);
                var o = S.width - 2 * s;
                return (y = { left: "0", center: "0.5", right: "1" }[S.alignValue]) ? a = +y * o : q(S.x) && Math.round(S.x) !== S.translateX && (a = S.x - S.translateX), { x: e.x + (n.translateX || 0) + s - (a || 0), y: e.y + (n.translateY || 0) + s - u, width: S.width - 2 * s, height: S.height - 2 * s };
              }
            };
            for (A = 0; A < m; A++)
              (k = D[A]) && (k.oldOpacity = k.opacity, k.newOpacity = 1, k.absoluteBox = x(k));
            for (D.sort(function(S, u) {
              return (u.labelrank || 0) - (S.labelrank || 0);
            }), A = 0; A < m; A++) {
              var E = (x = D[A]) && x.absoluteBox;
              for (k = A + 1; k < m; ++k) {
                var P = (b = D[k]) && b.absoluteBox;
                !E || !P || x === b || x.newOpacity === 0 || b.newOpacity === 0 || x.visibility === "hidden" || b.visibility === "hidden" || P.x >= E.x + E.width || P.x + P.width <= E.x || P.y >= E.y + E.height || P.y + P.height <= E.y || ((x.labelrank < b.labelrank ? x : b).newOpacity = 0);
              }
            }
            D.forEach(function(S) {
              $(S, d) && (g = !0);
            }), g && J(d, "afterHideAllOverlappingLabels");
          };
        }), _(at, "Core/Responsive.js", [at["Core/Utilities.js"]], function(G) {
          var F, $ = G.extend, Y = G.find, J = G.isArray, Q = G.isObject, q = G.merge, U = G.objectEach, N = G.pick, D = G.splat, k = G.uniqueKey;
          return function(A) {
            var b = [];
            A.compose = function(m) {
              return b.indexOf(m) === -1 && (b.push(m), $(m.prototype, d.prototype)), m;
            };
            var d = function() {
              function m() {
              }
              return m.prototype.currentOptions = function(v) {
                var g = this, x = {};
                return function E(P, S, u, y) {
                  var s;
                  U(P, function(a, e) {
                    if (!y && -1 < g.collectionsWithUpdate.indexOf(e) && S[e])
                      for (a = D(a), u[e] = [], s = 0; s < Math.max(a.length, S[e].length); s++)
                        S[e][s] && (a[s] === void 0 ? u[e][s] = S[e][s] : (u[e][s] = {}, E(a[s], S[e][s], u[e][s], y + 1)));
                    else
                      Q(a) ? (u[e] = J(a) ? [] : {}, E(a, S[e] || {}, u[e], y + 1)) : u[e] = S[e] === void 0 ? null : S[e];
                  });
                }(v, this.options, x, 0), x;
              }, m.prototype.matchResponsiveRule = function(v, g) {
                var x = v.condition;
                (x.callback || function() {
                  return this.chartWidth <= N(x.maxWidth, Number.MAX_VALUE) && this.chartHeight <= N(x.maxHeight, Number.MAX_VALUE) && this.chartWidth >= N(x.minWidth, 0) && this.chartHeight >= N(x.minHeight, 0);
                }).call(this) && g.push(v._id);
              }, m.prototype.setResponsive = function(v, g) {
                var x = this, E = this.options.responsive, P = this.currentResponsive, S = [];
                !g && E && E.rules && E.rules.forEach(function(u) {
                  u._id === void 0 && (u._id = k()), x.matchResponsiveRule(u, S);
                }, this), g = q.apply(void 0, S.map(function(u) {
                  return Y((E || {}).rules || [], function(y) {
                    return y._id === u;
                  });
                }).map(function(u) {
                  return u && u.chartOptions;
                })), g.isResponsiveOptions = !0, (S = S.toString() || void 0) !== (P && P.ruleIds) && (P && this.update(P.undoOptions, v, !0), S ? ((P = this.currentOptions(g)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: S, mergedOptions: g, undoOptions: P }, this.update(g, v, !0)) : this.currentResponsive = void 0);
              }, m;
            }();
          }(F || (F = {})), F;
        }), _(at, "masters/highcharts.src.js", [at["Core/Globals.js"], at["Core/Utilities.js"], at["Core/Defaults.js"], at["Core/Animation/Fx.js"], at["Core/Animation/AnimationUtilities.js"], at["Core/Renderer/HTML/AST.js"], at["Core/FormatUtilities.js"], at["Core/Renderer/RendererUtilities.js"], at["Core/Renderer/SVG/SVGElement.js"], at["Core/Renderer/SVG/SVGRenderer.js"], at["Core/Renderer/HTML/HTMLElement.js"], at["Core/Renderer/HTML/HTMLRenderer.js"], at["Core/Axis/Axis.js"], at["Core/Axis/DateTimeAxis.js"], at["Core/Axis/LogarithmicAxis.js"], at["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], at["Core/Axis/Tick.js"], at["Core/Tooltip.js"], at["Core/Series/Point.js"], at["Core/Pointer.js"], at["Core/MSPointer.js"], at["Core/Legend/Legend.js"], at["Core/Chart/Chart.js"], at["Core/Axis/Stacking/StackingAxis.js"], at["Core/Axis/Stacking/StackItem.js"], at["Core/Series/Series.js"], at["Core/Series/SeriesRegistry.js"], at["Series/Column/ColumnSeries.js"], at["Series/Column/ColumnDataLabel.js"], at["Series/Pie/PieSeries.js"], at["Series/Pie/PieDataLabel.js"], at["Core/Series/DataLabel.js"], at["Core/Responsive.js"], at["Core/Color/Color.js"], at["Core/Time.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A, b, d, m, v, g, x, E, P, S, u, y, s, a, e, n, o, i, c, l, h, C, M, O) {
          return G.animate = J.animate, G.animObject = J.animObject, G.getDeferredAnimation = J.getDeferredAnimation, G.setAnimation = J.setAnimation, G.stop = J.stop, G.timers = Y.timers, G.AST = Q, G.Axis = b, G.Chart = y, G.chart = y.chart, G.Fx = Y, G.Legend = u, G.PlotLineOrBand = v, G.Point = E, G.Pointer = S.isRequired() ? S : P, G.Series = e, G.StackItem = a, G.SVGElement = N, G.SVGRenderer = D, G.Tick = g, G.Time = O, G.Tooltip = x, G.Color = M, G.color = M.parse, A.compose(D), k.compose(N), G.defaultOptions = $.defaultOptions, G.getOptions = $.getOptions, G.time = $.defaultTime, G.setOptions = $.setOptions, G.dateFormat = q.dateFormat, G.format = q.format, G.numberFormat = q.numberFormat, G.addEvent = F.addEvent, G.arrayMax = F.arrayMax, G.arrayMin = F.arrayMin, G.attr = F.attr, G.clearTimeout = F.clearTimeout, G.correctFloat = F.correctFloat, G.createElement = F.createElement, G.css = F.css, G.defined = F.defined, G.destroyObjectProperties = F.destroyObjectProperties, G.discardElement = F.discardElement, G.distribute = U.distribute, G.erase = F.erase, G.error = F.error, G.extend = F.extend, G.extendClass = F.extendClass, G.find = F.find, G.fireEvent = F.fireEvent, G.getMagnitude = F.getMagnitude, G.getStyle = F.getStyle, G.inArray = F.inArray, G.isArray = F.isArray, G.isClass = F.isClass, G.isDOMElement = F.isDOMElement, G.isFunction = F.isFunction, G.isNumber = F.isNumber, G.isObject = F.isObject, G.isString = F.isString, G.keys = F.keys, G.merge = F.merge, G.normalizeTickInterval = F.normalizeTickInterval, G.objectEach = F.objectEach, G.offset = F.offset, G.pad = F.pad, G.pick = F.pick, G.pInt = F.pInt, G.relativeLength = F.relativeLength, G.removeEvent = F.removeEvent, G.seriesType = n.seriesType, G.splat = F.splat, G.stableSort = F.stableSort, G.syncTimeout = F.syncTimeout, G.timeUnits = F.timeUnits, G.uniqueKey = F.uniqueKey, G.useSerialIds = F.useSerialIds, G.wrap = F.wrap, i.compose(o), h.compose(e), d.compose(b), m.compose(b), l.compose(c), v.compose(b), C.compose(y), s.compose(b, y, e), G;
        }), at["masters/highcharts.src.js"]._modules = at, at["masters/highcharts.src.js"];
      }, tt.exports ? (yt.default = yt, tt.exports = ut.document ? yt(ut) : yt) : (ht = function() {
        return yt(ut);
      }.call(st, lt, st, tt)) === void 0 || (tt.exports = ht);
    }, 3491: function(tt, st, lt) {
      var ht, ut, yt;
      ut = typeof window != "undefined" ? window : this, yt = function(gt) {
        var _ = {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && gt.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        return at(_, "Core/Globals.js", [], function() {
          var G;
          return function(F) {
            F.SVG_NS = "http://www.w3.org/2000/svg", F.product = "Highcharts", F.version = "10.3.3", F.win = gt !== void 0 ? gt : {}, F.doc = F.win.document, F.svg = F.doc && F.doc.createElementNS && !!F.doc.createElementNS(F.SVG_NS, "svg").createSVGRect, F.userAgent = F.win.navigator && F.win.navigator.userAgent || "", F.isChrome = F.userAgent.indexOf("Chrome") !== -1, F.isFirefox = F.userAgent.indexOf("Firefox") !== -1, F.isMS = /(edge|msie|trident)/i.test(F.userAgent) && !F.win.opera, F.isSafari = !F.isChrome && F.userAgent.indexOf("Safari") !== -1, F.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(F.userAgent), F.isWebKit = F.userAgent.indexOf("AppleWebKit") !== -1, F.deg2rad = 2 * Math.PI / 360, F.hasBidiBug = F.isFirefox && parseInt(F.userAgent.split("Firefox/")[1], 10) < 4, F.hasTouch = !!F.win.TouchEvent, F.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], F.noop = function() {
            }, F.supportsPassiveEvents = function() {
              var $ = !1;
              if (!F.isMS) {
                var Y = Object.defineProperty({}, "passive", { get: function() {
                  $ = !0;
                } });
                F.win.addEventListener && F.win.removeEventListener && (F.win.addEventListener("testPassive", F.noop, Y), F.win.removeEventListener("testPassive", F.noop, Y));
              }
              return $;
            }(), F.charts = [], F.dateFormats = {}, F.seriesTypes = {}, F.symbolSizes = {}, F.chartCount = 0;
          }(G || (G = {})), G;
        }), at(_, "Core/Utilities.js", [_["Core/Globals.js"]], function(G) {
          var F = G.charts, $ = G.doc, Y = G.win;
          function J(i, c, l, h) {
            var C = c ? "Highcharts error" : "Highcharts warning";
            i === 32 && (i = C + ": Deprecated member");
            var M = A(i), O = M ? C + " #" + i + ": www.highcharts.com/errors/" + i + "/" : i.toString();
            if (h !== void 0) {
              var p = "";
              M && (O += "?"), u(h, function(w, T) {
                p += `
 - `.concat(T, ": ").concat(w), M && (O += encodeURI(T) + "=" + encodeURI(w));
              }), O += p;
            }
            s(G, "displayError", { chart: l, code: i, message: O, params: h }, function() {
              if (c)
                throw new Error(O);
              Y.console && J.messages.indexOf(O) === -1 && console.warn(O);
            }), J.messages.push(O);
          }
          function Q(i, c) {
            return parseInt(i, c || 10);
          }
          function q(i) {
            return typeof i == "string";
          }
          function U(i) {
            var c = Object.prototype.toString.call(i);
            return c === "[object Array]" || c === "[object Array Iterator]";
          }
          function N(i, c) {
            return !(!i || typeof i != "object" || c && U(i));
          }
          function D(i) {
            return N(i) && typeof i.nodeType == "number";
          }
          function k(i) {
            var c = i && i.constructor;
            return !(!N(i, !0) || D(i) || !c || !c.name || c.name === "Object");
          }
          function A(i) {
            return typeof i == "number" && !isNaN(i) && i < 1 / 0 && i > -1 / 0;
          }
          function b(i) {
            return i != null;
          }
          function d(i, c, l) {
            var h, C = q(c) && !b(l), M = function(O, p) {
              b(O) ? i.setAttribute(p, O) : C ? (h = i.getAttribute(p)) || p !== "class" || (h = i.getAttribute(p + "Name")) : i.removeAttribute(p);
            };
            return q(c) ? M(l, c) : u(c, M), h;
          }
          function m(i, c) {
            var l;
            for (l in i || (i = {}), c)
              i[l] = c[l];
            return i;
          }
          function v() {
            for (var i = arguments, c = i.length, l = 0; l < c; l++) {
              var h = i[l];
              if (h != null)
                return h;
            }
          }
          function g(i, c) {
            G.isMS && !G.svg && c && b(c.opacity) && (c.filter = "alpha(opacity=".concat(100 * c.opacity, ")")), m(i.style, c);
          }
          function x(i) {
            return Math.pow(10, Math.floor(Math.log(i) / Math.LN10));
          }
          function E(i, c) {
            return i > 1e14 ? i : parseFloat(i.toPrecision(c || 14));
          }
          (function(i) {
            i.messages = [];
          })(J || (J = {})), Math.easeInOutSine = function(i) {
            return -0.5 * (Math.cos(Math.PI * i) - 1);
          };
          var P, S = Array.prototype.find ? function(i, c) {
            return i.find(c);
          } : function(i, c) {
            var l, h = i.length;
            for (l = 0; l < h; l++)
              if (c(i[l], l))
                return i[l];
          };
          function u(i, c, l) {
            for (var h in i)
              Object.hasOwnProperty.call(i, h) && c.call(l || i[h], i[h], h, i);
          }
          function y(i, c, l) {
            function h(w, T) {
              var z = i.removeEventListener || G.removeEventListenerPolyfill;
              z && z.call(i, w, T, !1);
            }
            function C(w) {
              var T, z;
              i.nodeName && (c ? (T = {})[c] = !0 : T = w, u(T, function(W, L) {
                if (w[L])
                  for (z = w[L].length; z--; )
                    h(L, w[L][z].fn);
              }));
            }
            var M = typeof i == "function" && i.prototype || i;
            if (Object.hasOwnProperty.call(M, "hcEvents")) {
              var O = M.hcEvents;
              if (c) {
                var p = O[c] || [];
                l ? (O[c] = p.filter(function(w) {
                  return l !== w.fn;
                }), h(c, l)) : (C(O), O[c] = []);
              } else
                C(O), delete M.hcEvents;
            }
          }
          function s(i, c, l, h) {
            var C;
            if (l = l || {}, $.createEvent && (i.dispatchEvent || i.fireEvent && i !== G))
              (C = $.createEvent("Events")).initEvent(c, !0, !0), l = m(C, l), i.dispatchEvent ? i.dispatchEvent(l) : i.fireEvent(c, l);
            else if (i.hcEvents) {
              l.target || m(l, { preventDefault: function() {
                l.defaultPrevented = !0;
              }, target: i, type: c });
              for (var M = [], O = i, p = !1; O.hcEvents; )
                Object.hasOwnProperty.call(O, "hcEvents") && O.hcEvents[c] && (M.length && (p = !0), M.unshift.apply(M, O.hcEvents[c])), O = Object.getPrototypeOf(O);
              p && M.sort(function(w, T) {
                return w.order - T.order;
              }), M.forEach(function(w) {
                w.fn.call(i, l) === !1 && l.preventDefault();
              });
            }
            h && !l.defaultPrevented && h.call(i, l);
          }
          u({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(i, c) {
            G[c] = function(l) {
              var h;
              return J(32, !1, void 0, ((h = {})["Highcharts.".concat(c)] = "use Array.".concat(i), h)), Array.prototype[i].apply(l, [].slice.call(arguments, 1));
            };
          });
          var a, e, n = (a = Math.random().toString(36).substring(2, 9) + "-", e = 0, function() {
            return "highcharts-" + (P ? "" : a) + e++;
          });
          Y.jQuery;
          var o = { addEvent: function(i, c, l, h) {
            h === void 0 && (h = {});
            var C = typeof i == "function" && i.prototype || i;
            Object.hasOwnProperty.call(C, "hcEvents") || (C.hcEvents = {});
            var M = C.hcEvents;
            G.Point && i instanceof G.Point && i.series && i.series.chart && (i.series.chart.runTrackerClick = !0);
            var O = i.addEventListener || G.addEventListenerPolyfill;
            O && O.call(i, c, l, !!G.supportsPassiveEvents && { passive: h.passive === void 0 ? c.indexOf("touch") !== -1 : h.passive, capture: !1 }), M[c] || (M[c] = []);
            var p = { fn: l, order: typeof h.order == "number" ? h.order : 1 / 0 };
            return M[c].push(p), M[c].sort(function(w, T) {
              return w.order - T.order;
            }), function() {
              y(i, c, l);
            };
          }, arrayMax: function(i) {
            for (var c = i.length, l = i[0]; c--; )
              i[c] > l && (l = i[c]);
            return l;
          }, arrayMin: function(i) {
            for (var c = i.length, l = i[0]; c--; )
              i[c] < l && (l = i[c]);
            return l;
          }, attr: d, clamp: function(i, c, l) {
            return i > c ? i < l ? i : l : c;
          }, cleanRecursively: function i(c, l) {
            var h = {};
            return u(c, function(C, M) {
              var O;
              N(c[M], !0) && !c.nodeType && l[M] ? (O = i(c[M], l[M]), Object.keys(O).length && (h[M] = O)) : (N(c[M]) || c[M] !== l[M] || M in c && !(M in l)) && (h[M] = c[M]);
            }), h;
          }, clearTimeout: function(i) {
            b(i) && clearTimeout(i);
          }, correctFloat: E, createElement: function(i, c, l, h, C) {
            var M = $.createElement(i);
            return c && m(M, c), C && g(M, { padding: "0", border: "none", margin: "0" }), l && g(M, l), h && h.appendChild(M), M;
          }, css: g, defined: b, destroyObjectProperties: function(i, c) {
            u(i, function(l, h) {
              l && l !== c && l.destroy && l.destroy(), delete i[h];
            });
          }, discardElement: function(i) {
            i && i.parentElement && i.parentElement.removeChild(i);
          }, erase: function(i, c) {
            for (var l = i.length; l--; )
              if (i[l] === c) {
                i.splice(l, 1);
                break;
              }
          }, error: J, extend: m, extendClass: function(i, c) {
            var l = function() {
            };
            return m(l.prototype = new i(), c), l;
          }, find: S, fireEvent: s, getMagnitude: x, getNestedProperty: function(i, c) {
            for (var l = i.split("."); l.length && b(c); ) {
              var h = l.shift();
              if (h === void 0 || h === "__proto__")
                return;
              var C = c[h];
              if (!b(C) || typeof C == "function" || typeof C.nodeType == "number" || C === Y)
                return;
              c = C;
            }
            return c;
          }, getStyle: function i(c, l, h) {
            var C, M = G.getStyle || i;
            if (l === "width") {
              var O = Math.min(c.offsetWidth, c.scrollWidth), p = c.getBoundingClientRect && c.getBoundingClientRect().width;
              return p < O && p >= O - 1 && (O = Math.floor(p)), Math.max(0, O - (M(c, "padding-left", !0) || 0) - (M(c, "padding-right", !0) || 0));
            }
            if (l === "height")
              return Math.max(0, Math.min(c.offsetHeight, c.scrollHeight) - (M(c, "padding-top", !0) || 0) - (M(c, "padding-bottom", !0) || 0));
            Y.getComputedStyle || J(27, !0);
            var w = Y.getComputedStyle(c, void 0);
            return w && (C = w.getPropertyValue(l), v(h, l !== "opacity") && (C = Q(C))), C;
          }, inArray: function(i, c, l) {
            return J(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), c.indexOf(i, l);
          }, isArray: U, isClass: k, isDOMElement: D, isFunction: function(i) {
            return typeof i == "function";
          }, isNumber: A, isObject: N, isString: q, keys: function(i) {
            return J(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(i);
          }, merge: function() {
            var i, c = arguments, l = {}, h = function(M, O) {
              return typeof M != "object" && (M = {}), u(O, function(p, w) {
                w !== "__proto__" && w !== "constructor" && (!N(p, !0) || k(p) || D(p) ? M[w] = O[w] : M[w] = h(M[w] || {}, p));
              }), M;
            };
            c[0] === !0 && (l = c[1], c = Array.prototype.slice.call(c, 2));
            var C = c.length;
            for (i = 0; i < C; i++)
              l = h(l, c[i]);
            return l;
          }, normalizeTickInterval: function(i, c, l, h, C) {
            var M, O = i, p = i / (l = v(l, x(i)));
            for (c || (c = C ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], h === !1 && (l === 1 ? c = c.filter(function(w) {
              return w % 1 == 0;
            }) : l <= 0.1 && (c = [1 / l]))), M = 0; M < c.length && (O = c[M], !(C && O * l >= i || !C && p <= (c[M] + (c[M + 1] || c[M])) / 2)); M++)
              ;
            return E(O * l, -Math.round(Math.log(1e-3) / Math.LN10));
          }, objectEach: u, offset: function(i) {
            var c = $.documentElement, l = i.parentElement || i.parentNode ? i.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
            return { top: l.top + (Y.pageYOffset || c.scrollTop) - (c.clientTop || 0), left: l.left + (Y.pageXOffset || c.scrollLeft) - (c.clientLeft || 0), width: l.width, height: l.height };
          }, pad: function(i, c, l) {
            return new Array((c || 2) + 1 - String(i).replace("-", "").length).join(l || "0") + i;
          }, pick: v, pInt: Q, relativeLength: function(i, c, l) {
            return /%$/.test(i) ? c * parseFloat(i) / 100 + (l || 0) : parseFloat(i);
          }, removeEvent: y, splat: function(i) {
            return U(i) ? i : [i];
          }, stableSort: function(i, c) {
            var l, h, C = i.length;
            for (h = 0; h < C; h++)
              i[h].safeI = h;
            for (i.sort(function(M, O) {
              return (l = c(M, O)) === 0 ? M.safeI - O.safeI : l;
            }), h = 0; h < C; h++)
              delete i[h].safeI;
          }, syncTimeout: function(i, c, l) {
            return c > 0 ? setTimeout(i, c, l) : (i.call(0, l), -1);
          }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: n, useSerialIds: function(i) {
            return P = v(i, P);
          }, wrap: function(i, c, l) {
            var h = i[c];
            i[c] = function() {
              var C = arguments, M = this;
              return l.apply(this, [function() {
                return h.apply(M, arguments.length ? arguments : C);
              }].concat([].slice.call(arguments)));
            };
          } };
          return o;
        }), at(_, "Core/Chart/ChartDefaults.js", [], function() {
          return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, defaultSeriesType: "line", ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } }, zoomBySingleTouch: !1, zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#335cad", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
        }), at(_, "Core/Color/Color.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = F.isNumber, Y = F.merge, J = F.pInt;
          return function() {
            function Q(q) {
              this.rgba = [NaN, NaN, NaN, NaN], this.input = q;
              var U = G.Color;
              return U && U !== Q ? new U(q) : this instanceof Q ? void this.init(q) : new Q(q);
            }
            return Q.parse = function(q) {
              return q ? new Q(q) : Q.None;
            }, Q.prototype.init = function(q) {
              var U, N, D, k;
              if (typeof q == "object" && q.stops !== void 0)
                this.stops = q.stops.map(function(d) {
                  return new Q(d[1]);
                });
              else if (typeof q == "string") {
                if (this.input = q = Q.names[q.toLowerCase()] || q, q.charAt(0) === "#") {
                  var A = q.length, b = parseInt(q.substr(1), 16);
                  A === 7 ? N = [(16711680 & b) >> 16, (65280 & b) >> 8, 255 & b, 1] : A === 4 && (N = [(3840 & b) >> 4 | (3840 & b) >> 8, (240 & b) >> 4 | 240 & b, (15 & b) << 4 | 15 & b, 1]);
                }
                if (!N)
                  for (D = Q.parsers.length; D-- && !N; )
                    (U = (k = Q.parsers[D]).regex.exec(q)) && (N = k.parse(U));
              }
              N && (this.rgba = N);
            }, Q.prototype.get = function(q) {
              var U = this.input, N = this.rgba;
              if (typeof U == "object" && this.stops !== void 0) {
                var D = Y(U);
                return D.stops = [].slice.call(D.stops), this.stops.forEach(function(k, A) {
                  D.stops[A] = [D.stops[A][0], k.get(q)];
                }), D;
              }
              return N && $(N[0]) ? q === "rgb" || !q && N[3] === 1 ? "rgb(" + N[0] + "," + N[1] + "," + N[2] + ")" : q === "a" ? "".concat(N[3]) : "rgba(" + N.join(",") + ")" : U;
            }, Q.prototype.brighten = function(q) {
              var U = this.rgba;
              if (this.stops)
                this.stops.forEach(function(D) {
                  D.brighten(q);
                });
              else if ($(q) && q !== 0)
                for (var N = 0; N < 3; N++)
                  U[N] += J(255 * q), U[N] < 0 && (U[N] = 0), U[N] > 255 && (U[N] = 255);
              return this;
            }, Q.prototype.setOpacity = function(q) {
              return this.rgba[3] = q, this;
            }, Q.prototype.tweenTo = function(q, U) {
              var N = this.rgba, D = q.rgba;
              if (!$(N[0]) || !$(D[0]))
                return q.input || "none";
              var k = D[3] !== 1 || N[3] !== 1;
              return (k ? "rgba(" : "rgb(") + Math.round(D[0] + (N[0] - D[0]) * (1 - U)) + "," + Math.round(D[1] + (N[1] - D[1]) * (1 - U)) + "," + Math.round(D[2] + (N[2] - D[2]) * (1 - U)) + (k ? "," + (D[3] + (N[3] - D[3]) * (1 - U)) : "") + ")";
            }, Q.names = { white: "#ffffff", black: "#000000" }, Q.parsers = [{ regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/, parse: function(q) {
              return [J(q[1]), J(q[2]), J(q[3]), parseFloat(q[4], 10)];
            } }, { regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/, parse: function(q) {
              return [J(q[1]), J(q[2]), J(q[3]), 1];
            } }], Q.None = new Q(""), Q;
          }();
        }), at(_, "Core/Color/Palettes.js", [], function() {
          return { colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"] };
        }), at(_, "Core/Time.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.win, Y = F.defined, J = F.error, Q = F.extend, q = F.isObject, U = F.merge, N = F.objectEach, D = F.pad, k = F.pick, A = F.splat, b = F.timeUnits, d = G.isSafari && $.Intl && $.Intl.DateTimeFormat.prototype.formatRange, m = G.isSafari && $.Intl && !$.Intl.DateTimeFormat.prototype.formatRange, v = function() {
            function g(x) {
              this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = $.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(x);
            }
            return g.prototype.get = function(x, E) {
              if (this.variableTimezone || this.timezoneOffset) {
                var P = E.getTime(), S = P - this.getTimezoneOffset(E);
                E.setTime(S);
                var u = E["getUTC" + x]();
                return E.setTime(P), u;
              }
              return this.useUTC ? E["getUTC" + x]() : E["get" + x]();
            }, g.prototype.set = function(x, E, P) {
              if (this.variableTimezone || this.timezoneOffset) {
                if (x === "Milliseconds" || x === "Seconds" || x === "Minutes" && this.getTimezoneOffset(E) % 36e5 == 0)
                  return E["setUTC" + x](P);
                var S = this.getTimezoneOffset(E), u = E.getTime() - S;
                E.setTime(u), E["setUTC" + x](P);
                var y = this.getTimezoneOffset(E);
                return u = E.getTime() + y, E.setTime(u);
              }
              return this.useUTC || d && x === "FullYear" ? E["setUTC" + x](P) : E["set" + x](P);
            }, g.prototype.update = function(x) {
              x === void 0 && (x = {});
              var E = k(x.useUTC, !0);
              this.options = x = U(!0, this.options, x), this.Date = x.Date || $.Date || Date, this.useUTC = E, this.timezoneOffset = E && x.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = E && !(!x.getTimezoneOffset && !x.timezone);
            }, g.prototype.makeTime = function(x, E, P, S, u, y) {
              var s, a, e;
              return this.useUTC ? (s = this.Date.UTC.apply(0, arguments), s += a = this.getTimezoneOffset(s), a !== (e = this.getTimezoneOffset(s)) ? s += e - a : a - 36e5 !== this.getTimezoneOffset(s - 36e5) || m || (s -= 36e5)) : s = new this.Date(x, E, k(P, 1), k(S, 0), k(u, 0), k(y, 0)).getTime(), s;
            }, g.prototype.timezoneOffsetFunction = function() {
              var x = this, E = this.options, P = E.getTimezoneOffset, S = E.moment || $.moment;
              if (!this.useUTC)
                return function(u) {
                  return 6e4 * new Date(u.toString()).getTimezoneOffset();
                };
              if (E.timezone) {
                if (S)
                  return function(u) {
                    return 6e4 * -S.tz(u, E.timezone).utcOffset();
                  };
                J(25);
              }
              return this.useUTC && P ? function(u) {
                return 6e4 * P(u.valueOf());
              } : function() {
                return 6e4 * (x.timezoneOffset || 0);
              };
            }, g.prototype.dateFormat = function(x, E, P) {
              if (!Y(E) || isNaN(E))
                return G.defaultOptions.lang && G.defaultOptions.lang.invalidDate || "";
              x = k(x, "%Y-%m-%d %H:%M:%S");
              var S = this, u = new this.Date(E), y = this.get("Hours", u), s = this.get("Day", u), a = this.get("Date", u), e = this.get("Month", u), n = this.get("FullYear", u), o = G.defaultOptions.lang, i = o && o.weekdays, c = o && o.shortWeekdays, l = Q({ a: c ? c[s] : i[s].substr(0, 3), A: i[s], d: D(a), e: D(a, 2, " "), w: s, b: o.shortMonths[e], B: o.months[e], m: D(e + 1), o: e + 1, y: n.toString().substr(2, 2), Y: n, H: D(y), k: y, I: D(y % 12 || 12), l: y % 12 || 12, M: D(this.get("Minutes", u)), p: y < 12 ? "AM" : "PM", P: y < 12 ? "am" : "pm", S: D(u.getSeconds()), L: D(Math.floor(E % 1e3), 3) }, G.dateFormats);
              return N(l, function(h, C) {
                for (; x.indexOf("%" + C) !== -1; )
                  x = x.replace("%" + C, typeof h == "function" ? h.call(S, E) : h);
              }), P ? x.substr(0, 1).toUpperCase() + x.substr(1) : x;
            }, g.prototype.resolveDTLFormat = function(x) {
              return q(x, !0) ? x : { main: (x = A(x))[0], from: x[1], to: x[2] };
            }, g.prototype.getTimeTicks = function(x, E, P, S) {
              var u, y, s, a, e = this, n = e.Date, o = [], i = {}, c = new n(E), l = x.unitRange, h = x.count || 1;
              if (S = k(S, 1), Y(E)) {
                e.set("Milliseconds", c, l >= b.second ? 0 : h * Math.floor(e.get("Milliseconds", c) / h)), l >= b.second && e.set("Seconds", c, l >= b.minute ? 0 : h * Math.floor(e.get("Seconds", c) / h)), l >= b.minute && e.set("Minutes", c, l >= b.hour ? 0 : h * Math.floor(e.get("Minutes", c) / h)), l >= b.hour && e.set("Hours", c, l >= b.day ? 0 : h * Math.floor(e.get("Hours", c) / h)), l >= b.day && e.set("Date", c, l >= b.month ? 1 : Math.max(1, h * Math.floor(e.get("Date", c) / h))), l >= b.month && (e.set("Month", c, l >= b.year ? 0 : h * Math.floor(e.get("Month", c) / h)), y = e.get("FullYear", c)), l >= b.year && (y -= y % h, e.set("FullYear", c, y)), l === b.week && (a = e.get("Day", c), e.set("Date", c, e.get("Date", c) - a + S + (a < S ? -7 : 0))), y = e.get("FullYear", c);
                var C = e.get("Month", c), M = e.get("Date", c), O = e.get("Hours", c);
                E = c.getTime(), !e.variableTimezone && e.useUTC || !Y(P) || (s = P - E > 4 * b.month || e.getTimezoneOffset(E) !== e.getTimezoneOffset(P));
                var p = c.getTime();
                for (u = 1; p < P; )
                  o.push(p), l === b.year ? p = e.makeTime(y + u * h, 0) : l === b.month ? p = e.makeTime(y, C + u * h) : !s || l !== b.day && l !== b.week ? s && l === b.hour && h > 1 ? p = e.makeTime(y, C, M, O + u * h) : p += l * h : p = e.makeTime(y, C, M + u * h * (l === b.day ? 1 : 7)), u++;
                o.push(p), l <= b.hour && o.length < 1e4 && o.forEach(function(w) {
                  w % 18e5 == 0 && e.dateFormat("%H%M%S%L", w) === "000000000" && (i[w] = "day");
                });
              }
              return o.info = Q(x, { higherRanks: i, totalRange: l * h }), o;
            }, g.prototype.getDateFormat = function(x, E, P, S) {
              var u = this.dateFormat("%m-%d %H:%M:%S.%L", E), y = "01-01 00:00:00.000", s = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, a = "millisecond", e = a;
              for (a in b) {
                if (x === b.week && +this.dateFormat("%w", E) === P && u.substr(6) === y.substr(6)) {
                  a = "week";
                  break;
                }
                if (b[a] > x) {
                  a = e;
                  break;
                }
                if (s[a] && u.substr(s[a]) !== y.substr(s[a]))
                  break;
                a !== "week" && (e = a);
              }
              return this.resolveDTLFormat(S[a]).main;
            }, g;
          }();
          return v;
        }), at(_, "Core/Defaults.js", [_["Core/Chart/ChartDefaults.js"], _["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Color/Palettes.js"], _["Core/Time.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = F.parse, U = $.isTouchDevice, N = $.svg, D = Q.merge, k = { colors: Y.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: {}, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: G, title: { text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, labels: { style: { position: "absolute", color: "#333333" } }, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", layout: "horizontal", labelFormatter: function() {
            return this.name;
          }, borderColor: "#999999", borderRadius: 0, navigation: { activeColor: "#003399", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "12px", fontWeight: "bold", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#cccccc" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: N, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %b %e, %H:%M:%S.%L", second: "%A, %b %e, %H:%M:%S", minute: "%A, %b %e, %H:%M", hour: "%A, %b %e, %H:%M", day: "%A, %b %e, %Y", week: "Week from %A, %b %e, %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: U ? 25 : 10, headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: q("#f7f7f7").setOpacity(0.85).get(), borderWidth: 1, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "12px", whiteSpace: "nowrap" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "9px" }, text: "Highcharts.com" } };
          k.chart.styledMode = !1;
          var A = new J(D(k.global, k.time));
          return { defaultOptions: k, defaultTime: A, getOptions: function() {
            return k;
          }, setOptions: function(b) {
            return D(!0, k, b), (b.time || b.global) && ($.time ? $.time.update(D(k.global, k.time, b.global, b.time)) : $.time = A), k;
          } };
        }), at(_, "Core/Animation/Fx.js", [_["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.parse, J = F.win, Q = $.isNumber, q = $.objectEach, U = function() {
            function N(D, k, A) {
              this.pos = NaN, this.options = k, this.elem = D, this.prop = A;
            }
            return N.prototype.dSetter = function() {
              var D = this.paths, k = D && D[0], A = D && D[1], b = this.now || 0, d = [];
              if (b !== 1 && k && A)
                if (k.length === A.length && b < 1)
                  for (var m = 0; m < A.length; m++) {
                    for (var v = k[m], g = A[m], x = [], E = 0; E < g.length; E++) {
                      var P = v[E], S = g[E];
                      Q(P) && Q(S) && (g[0] !== "A" || E !== 4 && E !== 5) ? x[E] = P + b * (S - P) : x[E] = S;
                    }
                    d.push(x);
                  }
                else
                  d = A;
              else
                d = this.toD || [];
              this.elem.attr("d", d, void 0, !0);
            }, N.prototype.update = function() {
              var D = this.elem, k = this.prop, A = this.now, b = this.options.step;
              this[k + "Setter"] ? this[k + "Setter"]() : D.attr ? D.element && D.attr(k, A, null, !0) : D.style[k] = A + this.unit, b && b.call(D, A, this);
            }, N.prototype.run = function(D, k, A) {
              var b = this, d = b.options, m = function(x) {
                return !m.stopped && b.step(x);
              }, v = J.requestAnimationFrame || function(x) {
                setTimeout(x, 13);
              }, g = function() {
                for (var x = 0; x < N.timers.length; x++)
                  N.timers[x]() || N.timers.splice(x--, 1);
                N.timers.length && v(g);
              };
              D !== k || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = D, this.end = k, this.unit = A, this.now = this.start, this.pos = 0, m.elem = this.elem, m.prop = this.prop, m() && N.timers.push(m) === 1 && v(g)) : (delete d.curAnim[this.prop], d.complete && Object.keys(d.curAnim).length === 0 && d.complete.call(this.elem));
            }, N.prototype.step = function(D) {
              var k, A, b = +/* @__PURE__ */ new Date(), d = this.options, m = this.elem, v = d.complete, g = d.duration, x = d.curAnim;
              return m.attr && !m.element ? k = !1 : D || b >= g + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), x[this.prop] = !0, A = !0, q(x, function(E) {
                E !== !0 && (A = !1);
              }), A && v && v.call(m), k = !1) : (this.pos = d.easing((b - this.startTime) / g), this.now = this.start + (this.end - this.start) * this.pos, this.update(), k = !0), k;
            }, N.prototype.initPath = function(D, k, A) {
              var b, d, m, v, g = D.startX, x = D.endX, E = A.slice(), P = D.isArea, S = P ? 2 : 1, u = k && k.slice();
              if (!u)
                return [E, E];
              function y(a, e) {
                for (; a.length < d; ) {
                  var n = a[0], o = e[d - a.length];
                  if (o && n[0] === "M" && (o[0] === "C" ? a[0] = ["C", n[1], n[2], n[1], n[2], n[1], n[2]] : a[0] = ["L", n[1], n[2]]), a.unshift(n), P) {
                    var i = a.pop();
                    a.push(a[a.length - 1], i);
                  }
                }
              }
              function s(a, e) {
                for (; a.length < d; ) {
                  var n = a[Math.floor(a.length / S) - 1].slice();
                  if (n[0] === "C" && (n[1] = n[5], n[2] = n[6]), P) {
                    var o = a[Math.floor(a.length / S)].slice();
                    a.splice(a.length / 2, 0, n, o);
                  } else
                    a.push(n);
                }
              }
              if (g && x && x.length) {
                for (m = 0; m < g.length; m++) {
                  if (g[m] === x[0]) {
                    b = m;
                    break;
                  }
                  if (g[0] === x[x.length - g.length + m]) {
                    b = m, v = !0;
                    break;
                  }
                  if (g[g.length - 1] === x[x.length - g.length + m]) {
                    b = g.length - m;
                    break;
                  }
                }
                b === void 0 && (u = []);
              }
              return u.length && Q(b) && (d = E.length + b * S, v ? (y(u, E), s(E)) : (y(E, u), s(u))), [u, E];
            }, N.prototype.fillSetter = function() {
              N.prototype.strokeSetter.apply(this, arguments);
            }, N.prototype.strokeSetter = function() {
              this.elem.attr(this.prop, Y(this.start).tweenTo(Y(this.end), this.pos), void 0, !0);
            }, N.timers = [], N;
          }();
          return U;
        }), at(_, "Core/Animation/AnimationUtilities.js", [_["Core/Animation/Fx.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = F.defined, Y = F.getStyle, J = F.isArray, Q = F.isNumber, q = F.isObject, U = F.merge, N = F.objectEach, D = F.pick;
          function k(d) {
            return q(d) ? U({ duration: 500, defer: 0 }, d) : { duration: d ? 500 : 0, defer: 0 };
          }
          function A(d, m) {
            for (var v = G.timers.length; v--; )
              G.timers[v].elem !== d || m && m !== G.timers[v].prop || (G.timers[v].stopped = !0);
          }
          var b = { animate: function(d, m, v) {
            var g, x, E, P, S = "";
            q(v) || (v = { duration: (P = arguments)[2], easing: P[3], complete: P[4] }), Q(v.duration) || (v.duration = 400), v.easing = typeof v.easing == "function" ? v.easing : Math[v.easing] || Math.easeInOutSine, v.curAnim = U(m), N(m, function(u, y) {
              A(d, y), E = new G(d, v, y), x = void 0, y === "d" && J(m.d) ? (E.paths = E.initPath(d, d.pathArray, m.d), E.toD = m.d, g = 0, x = 1) : d.attr ? g = d.attr(y) : (g = parseFloat(Y(d, y)) || 0, y !== "opacity" && (S = "px")), x || (x = u), typeof x == "string" && x.match("px") && (x = x.replace(/px/g, "")), E.run(g, x, S);
            });
          }, animObject: k, getDeferredAnimation: function(d, m, v) {
            var g = k(m), x = v ? [v] : d.series, E = 0, P = 0;
            return x.forEach(function(S) {
              var u = k(S.options.animation);
              E = m && $(m.defer) ? g.defer : Math.max(E, u.duration + u.defer), P = Math.min(g.duration, u.duration);
            }), d.renderer.forExport && (E = 0), { defer: Math.max(0, E - P), duration: Math.min(E, P) };
          }, setAnimation: function(d, m) {
            m.renderer.globalAnimation = D(d, m.options.chart.animation, !0);
          }, stop: A };
          return b;
        }), at(_, "Core/Renderer/HTML/AST.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.SVG_NS, Y = G.win, J = F.attr, Q = F.createElement, q = F.css, U = F.error, N = F.isFunction, D = F.isString, k = F.objectEach, A = F.splat, b = Y.trustedTypes, d = b && N(b.createPolicy) && b.createPolicy("highcharts", { createHTML: function(g) {
            return g;
          } }), m = d ? d.createHTML("") : "", v = function() {
            try {
              return !!new DOMParser().parseFromString(m, "text/html");
            } catch (g) {
              return !1;
            }
          }();
          return function() {
            function g(x) {
              this.nodes = typeof x == "string" ? this.parseMarkup(x) : x;
            }
            return g.filterUserAttributes = function(x) {
              return k(x, function(E, P) {
                var S = !0;
                g.allowedAttributes.indexOf(P) === -1 && (S = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(P) !== -1 && (S = D(E) && g.allowedReferences.some(function(u) {
                  return E.indexOf(u) === 0;
                })), S || (U(33, !1, void 0, { "Invalid attribute in config": "".concat(P) }), delete x[P]), D(E) && x[P] && (x[P] = E.replace(/</g, "&lt;"));
              }), x;
            }, g.parseStyle = function(x) {
              return x.split(";").reduce(function(E, P) {
                var S = P.split(":").map(function(y) {
                  return y.trim();
                }), u = S.shift();
                return u && S.length && (E[u.replace(/-([a-z])/g, function(y) {
                  return y[1].toUpperCase();
                })] = S.join(":")), E;
              }, {});
            }, g.setElementHTML = function(x, E) {
              x.innerHTML = g.emptyHTML, E && new g(E).addToDOM(x);
            }, g.prototype.addToDOM = function(x) {
              return function E(P, S) {
                var u;
                return A(P).forEach(function(y) {
                  var s, a = y.tagName, e = y.textContent ? G.doc.createTextNode(y.textContent) : void 0, n = g.bypassHTMLFiltering;
                  if (a)
                    if (a === "#text")
                      s = e;
                    else if (g.allowedTags.indexOf(a) !== -1 || n) {
                      var o = a === "svg" ? $ : S.namespaceURI || $, i = G.doc.createElementNS(o, a), c = y.attributes || {};
                      k(y, function(l, h) {
                        h !== "tagName" && h !== "attributes" && h !== "children" && h !== "style" && h !== "textContent" && (c[h] = l);
                      }), J(i, n ? c : g.filterUserAttributes(c)), y.style && q(i, y.style), e && i.appendChild(e), E(y.children || [], i), s = i;
                    } else
                      U(33, !1, void 0, { "Invalid tagName in config": a });
                  s && S.appendChild(s), u = s;
                }), u;
              }(this.nodes, x);
            }, g.prototype.parseMarkup = function(x) {
              var E, P = [];
              if (x = x.trim().replace(/ style=(["'])/g, " data-style=$1"), v)
                E = new DOMParser().parseFromString(d ? d.createHTML(x) : x, "text/html");
              else {
                var S = Q("div");
                S.innerHTML = x, E = { body: S };
              }
              var u = function(y, s) {
                var a = y.nodeName.toLowerCase(), e = { tagName: a };
                a === "#text" && (e.textContent = y.textContent || "");
                var n = y.attributes;
                if (n) {
                  var o = {};
                  [].forEach.call(n, function(c) {
                    c.name === "data-style" ? e.style = g.parseStyle(c.value) : o[c.name] = c.value;
                  }), e.attributes = o;
                }
                if (y.childNodes.length) {
                  var i = [];
                  [].forEach.call(y.childNodes, function(c) {
                    u(c, i);
                  }), i.length && (e.children = i);
                }
                s.push(e);
              };
              return [].forEach.call(E.body.childNodes, function(y) {
                return u(y, P);
              }), P;
            }, g.allowedAttributes = ["aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "height", "href", "id", "in", "markerHeight", "markerWidth", "offset", "opacity", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], g.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], g.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], g.emptyHTML = m, g.bypassHTMLFiltering = !1, g;
          }();
        }), at(_, "Core/FormatUtilities.js", [_["Core/Defaults.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.defaultOptions, Y = G.defaultTime, J = F.getNestedProperty, Q = F.isNumber, q = F.pick, U = F.pInt;
          function N(D, k, A, b) {
            var d, m;
            D = +D || 0, k = +k;
            var v = $.lang, g = (D.toString().split(".")[1] || "").split("e")[0].length, x = D.toString().split("e"), E = k;
            k === -1 ? k = Math.min(g, 20) : Q(k) ? k && x[1] && x[1] < 0 && ((m = k + +x[1]) >= 0 ? (x[0] = (+x[0]).toExponential(m).split("e")[0], k = m) : (x[0] = x[0].split(".")[0] || 0, D = k < 20 ? (x[0] * Math.pow(10, x[1])).toFixed(k) : 0, x[1] = 0)) : k = 2;
            var P = (Math.abs(x[1] ? x[0] : D) + Math.pow(10, -Math.max(k, g) - 1)).toFixed(k), S = String(U(P)), u = S.length > 3 ? S.length % 3 : 0;
            return A = q(A, v.decimalPoint), b = q(b, v.thousandsSep), d = D < 0 ? "-" : "", d += u ? S.substr(0, u) + b : "", +x[1] < 0 && !E ? d = "0" : d += S.substr(u).replace(/(\d{3})(?=\d)/g, "$1" + b), k && (d += A + P.slice(-k)), x[1] && +d != 0 && (d += "e" + x[1]), d;
          }
          return { dateFormat: function(D, k, A) {
            return Y.dateFormat(D, k, A);
          }, format: function(D, k, A) {
            for (var b, d, m, v, g = "{", x = !1, E = /f$/, P = /\.([0-9])/, S = $.lang, u = A && A.time || Y, y = A && A.numberFormatter || N, s = []; D && (v = D.indexOf(g)) !== -1; ) {
              if (b = D.slice(0, v), x) {
                if (d = b.split(":"), m = J(d.shift() || "", k), d.length && typeof m == "number")
                  if (b = d.join(":"), E.test(b)) {
                    var a = parseInt((b.match(P) || ["", "-1"])[1], 10);
                    m !== null && (m = y(m, a, S.decimalPoint, b.indexOf(",") > -1 ? S.thousandsSep : ""));
                  } else
                    m = u.dateFormat(b, m);
                s.push(m);
              } else
                s.push(b);
              D = D.slice(v + 1), g = (x = !x) ? "}" : "{";
            }
            return s.push(D), s.join("");
          }, numberFormat: N };
        }), at(_, "Core/Renderer/RendererUtilities.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.clamp, Y = G.pick, J = G.stableSort;
          return function(Q) {
            Q.distribute = function q(U, N, D) {
              var k, A, b, d = U, m = d.reducedLen || N, v = function(P, S) {
                return P.target - S.target;
              }, g = !0, x = [], E = 0;
              for (k = U.length; k--; )
                E += U[k].size;
              if (E > m) {
                for (J(U, function(P, S) {
                  return (S.rank || 0) - (P.rank || 0);
                }), k = 0, E = 0; E <= m; )
                  E += U[k].size, k++;
                x = U.splice(k - 1, U.length);
              }
              for (J(U, v), U = U.map(function(P) {
                return { size: P.size, targets: [P.target], align: Y(P.align, 0.5) };
              }); g; ) {
                for (k = U.length; k--; )
                  A = U[k], b = (Math.min.apply(0, A.targets) + Math.max.apply(0, A.targets)) / 2, A.pos = $(b - A.size * A.align, 0, N - A.size);
                for (k = U.length, g = !1; k--; )
                  k > 0 && U[k - 1].pos + U[k - 1].size > U[k].pos && (U[k - 1].size += U[k].size, U[k - 1].targets = U[k - 1].targets.concat(U[k].targets), U[k - 1].align = 0.5, U[k - 1].pos + U[k - 1].size > N && (U[k - 1].pos = N - U[k - 1].size), U.splice(k, 1), g = !0);
              }
              return d.push.apply(d, x), k = 0, U.some(function(P) {
                var S = 0;
                return (P.targets || []).some(function() {
                  return d[k].pos = P.pos + S, D !== void 0 && Math.abs(d[k].pos - d[k].target) > D ? (d.slice(0, k + 1).forEach(function(u) {
                    return delete u.pos;
                  }), d.reducedLen = (d.reducedLen || N) - 0.1 * N, d.reducedLen > 0.1 * N && q(d, N, D), !0) : (S += d[k].size, k++, !1);
                });
              }), J(d, v), d;
            };
          }(F || (F = {})), F;
        }), at(_, "Core/Renderer/SVG/SVGElement.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = G.animate, Q = G.animObject, q = G.stop, U = $.deg2rad, N = $.doc, D = $.svg, k = $.SVG_NS, A = $.win, b = Y.addEvent, d = Y.attr, m = Y.createElement, v = Y.css, g = Y.defined, x = Y.erase, E = Y.extend, P = Y.fireEvent, S = Y.isArray, u = Y.isFunction, y = Y.isString, s = Y.merge, a = Y.objectEach, e = Y.pick, n = Y.pInt, o = Y.syncTimeout, i = Y.uniqueKey, c = function() {
            function l() {
              this.element = void 0, this.onEvents = {}, this.opacity = 1, this.renderer = void 0, this.SVG_NS = k, this.symbolCustomAttribs = ["x", "y", "width", "height", "r", "start", "end", "innerR", "anchorX", "anchorY", "rounded"];
            }
            return l.prototype._defaultGetter = function(h) {
              var C = e(this[h + "Value"], this[h], this.element ? this.element.getAttribute(h) : null, 0);
              return /^[\-0-9\.]+$/.test(C) && (C = parseFloat(C)), C;
            }, l.prototype._defaultSetter = function(h, C, M) {
              M.setAttribute(C, h);
            }, l.prototype.add = function(h) {
              var C, M = this.renderer, O = this.element;
              return h && (this.parentGroup = h), this.textStr !== void 0 && this.element.nodeName === "text" && M.buildText(this), this.added = !0, (!h || h.handleZ || this.zIndex) && (C = this.zIndexSetter()), C || (h ? h.element : M.box).appendChild(O), this.onAdd && this.onAdd(), this;
            }, l.prototype.addClass = function(h, C) {
              var M = C ? "" : this.attr("class") || "";
              return (h = (h || "").split(/ /g).reduce(function(O, p) {
                return M.indexOf(p) === -1 && O.push(p), O;
              }, M ? [M] : []).join(" ")) !== M && this.attr("class", h), this;
            }, l.prototype.afterSetters = function() {
              this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }, l.prototype.align = function(h, C, M) {
              var O, p, w, T, z, W = {}, L = this.renderer, I = L.alignedObjects;
              h ? (this.alignOptions = h, this.alignByTranslate = C, M && !y(M) || (this.alignTo = w = M || "renderer", x(I, this), I.push(this), M = void 0)) : (h = this.alignOptions, C = this.alignByTranslate, w = this.alignTo), M = e(M, L[w], w === "scrollablePlotBox" ? L.plotBox : void 0, L);
              var j = h.align, Z = h.verticalAlign;
              return O = (M.x || 0) + (h.x || 0), p = (M.y || 0) + (h.y || 0), j === "right" ? T = 1 : j === "center" && (T = 2), T && (O += (M.width - (h.width || 0)) / T), W[C ? "translateX" : "x"] = Math.round(O), Z === "bottom" ? z = 1 : Z === "middle" && (z = 2), z && (p += (M.height - (h.height || 0)) / z), W[C ? "translateY" : "y"] = Math.round(p), this[this.placed ? "animate" : "attr"](W), this.placed = !0, this.alignAttr = W, this;
            }, l.prototype.alignSetter = function(h) {
              var C = { left: "start", center: "middle", right: "end" };
              C[h] && (this.alignValue = h, this.element.setAttribute("text-anchor", C[h]));
            }, l.prototype.animate = function(h, C, M) {
              var O = this, p = Q(e(C, this.renderer.globalAnimation, !0)), w = p.defer;
              return e(N.hidden, N.msHidden, N.webkitHidden, !1) && (p.duration = 0), p.duration !== 0 ? (M && (p.complete = M), o(function() {
                O.element && J(O, h, p);
              }, w)) : (this.attr(h, void 0, M || p.complete), a(h, function(T, z) {
                p.step && p.step.call(this, T, { prop: z, pos: 1, elem: this });
              }, this)), this;
            }, l.prototype.applyTextOutline = function(h) {
              var C = this.element;
              h.indexOf("contrast") !== -1 && (h = h.replace(/contrast/g, this.renderer.getContrast(C.style.fill)));
              var M = h.split(" "), O = M[M.length - 1], p = M[0];
              if (p && p !== "none" && $.svg) {
                this.fakeTS = !0, p = p.replace(/(^[\d\.]+)(.*?)$/g, function(L, I, j) {
                  return 2 * Number(I) + j;
                }), this.removeTextOutline();
                var w = N.createElementNS(k, "tspan");
                d(w, { class: "highcharts-text-outline", fill: O, stroke: O, "stroke-width": p, "stroke-linejoin": "round" });
                var T = C.querySelector("textPath") || C;
                [].forEach.call(T.childNodes, function(L) {
                  var I = L.cloneNode(!0);
                  I.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach(function(j) {
                    return I.removeAttribute(j);
                  }), w.appendChild(I);
                });
                var z = 0;
                [].forEach.call(T.querySelectorAll("text tspan"), function(L) {
                  z += Number(L.getAttribute("dy"));
                });
                var W = N.createElementNS(k, "tspan");
                W.textContent = "​", d(W, { x: Number(C.getAttribute("x")), dy: -z }), w.appendChild(W), T.insertBefore(w, T.firstChild);
              }
            }, l.prototype.attr = function(h, C, M, O) {
              var p, w, T, z, W = this.element, L = this.symbolCustomAttribs, I = this;
              return typeof h == "string" && C !== void 0 && (p = h, (h = {})[p] = C), typeof h == "string" ? I = (this[h + "Getter"] || this._defaultGetter).call(this, h, W) : (a(h, function(j, Z) {
                T = !1, O || q(this, Z), this.symbolName && L.indexOf(Z) !== -1 && (w || (this.symbolAttr(h), w = !0), T = !0), !this.rotation || Z !== "x" && Z !== "y" || (this.doTransform = !0), T || ((z = this[Z + "Setter"] || this._defaultSetter).call(this, j, Z, W), !this.styledMode && this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(Z) && this.updateShadows(Z, j, z));
              }, this), this.afterSetters()), M && M.call(this), I;
            }, l.prototype.clip = function(h) {
              return this.attr("clip-path", h ? "url(" + this.renderer.url + "#" + h.id + ")" : "none");
            }, l.prototype.crisp = function(h, C) {
              var M = this;
              C = C || h.strokeWidth || 0;
              var O = Math.round(C) % 2 / 2;
              return h.x = Math.floor(h.x || M.x || 0) + O, h.y = Math.floor(h.y || M.y || 0) + O, h.width = Math.floor((h.width || M.width || 0) - 2 * O), h.height = Math.floor((h.height || M.height || 0) - 2 * O), g(h.strokeWidth) && (h.strokeWidth = C), h;
            }, l.prototype.complexColor = function(h, C, M) {
              var O, p, w, T, z, W, L, I, j, Z, V, X = this.renderer, et = [];
              P(this.renderer, "complexColor", { args: arguments }, function() {
                if (h.radialGradient ? p = "radialGradient" : h.linearGradient && (p = "linearGradient"), p) {
                  if (w = h[p], z = X.gradients, W = h.stops, j = M.radialReference, S(w) && (h[p] = w = { x1: w[0], y1: w[1], x2: w[2], y2: w[3], gradientUnits: "userSpaceOnUse" }), p === "radialGradient" && j && !g(w.gradientUnits) && (T = w, w = s(w, X.getRadialAttr(j, T), { gradientUnits: "userSpaceOnUse" })), a(w, function(it, pt) {
                    pt !== "id" && et.push(pt, it);
                  }), a(W, function(it) {
                    et.push(it);
                  }), et = et.join(","), z[et])
                    Z = z[et].attr("id");
                  else {
                    w.id = Z = i();
                    var ot = z[et] = X.createElement(p).attr(w).add(X.defs);
                    ot.radAttr = T, ot.stops = [], W.forEach(function(it) {
                      it[1].indexOf("rgba") === 0 ? (O = F.parse(it[1]), L = O.get("rgb"), I = O.get("a")) : (L = it[1], I = 1);
                      var pt = X.createElement("stop").attr({ offset: it[0], "stop-color": L, "stop-opacity": I }).add(ot);
                      ot.stops.push(pt);
                    });
                  }
                  V = "url(" + X.url + "#" + Z + ")", M.setAttribute(C, V), M.gradient = et, h.toString = function() {
                    return V;
                  };
                }
              });
            }, l.prototype.css = function(h) {
              var C, M = this.styles, O = {}, p = this.element, w = !M;
              if (h.color && (h.fill = h.color), M && a(h, function(z, W) {
                M && M[W] !== z && (O[W] = z, w = !0);
              }), w) {
                M && (h = E(M, O)), h.width === null || h.width === "auto" ? delete this.textWidth : p.nodeName.toLowerCase() === "text" && h.width && (C = this.textWidth = n(h.width)), this.styles = h, C && !D && this.renderer.forExport && delete h.width;
                var T = s(h);
                p.namespaceURI === this.SVG_NS && ["textOutline", "textOverflow", "width"].forEach(function(z) {
                  return T && delete T[z];
                }), v(p, T), this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), h.textOutline && this.applyTextOutline(h.textOutline));
              }
              return this;
            }, l.prototype.dashstyleSetter = function(h) {
              var C, M = this["stroke-width"];
              if (M === "inherit" && (M = 1), h = h && h.toLowerCase()) {
                var O = h.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                for (C = O.length; C--; )
                  O[C] = "" + n(O[C]) * e(M, NaN);
                h = O.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", h);
              }
            }, l.prototype.destroy = function() {
              var h, C, M = this, O = M.element || {}, p = M.renderer, w = O.ownerSVGElement, T = p.isSVG && O.nodeName === "SPAN" && M.parentGroup || void 0;
              if (O.onclick = O.onmouseout = O.onmouseover = O.onmousemove = O.point = null, q(M), M.clipPath && w) {
                var z = M.clipPath;
                [].forEach.call(w.querySelectorAll("[clip-path],[CLIP-PATH]"), function(W) {
                  W.getAttribute("clip-path").indexOf(z.element.id) > -1 && W.removeAttribute("clip-path");
                }), M.clipPath = z.destroy();
              }
              if (M.stops) {
                for (C = 0; C < M.stops.length; C++)
                  M.stops[C].destroy();
                M.stops.length = 0, M.stops = void 0;
              }
              for (M.safeRemoveChild(O), p.styledMode || M.destroyShadows(); T && T.div && T.div.childNodes.length === 0; )
                h = T.parentGroup, M.safeRemoveChild(T.div), delete T.div, T = h;
              M.alignTo && x(p.alignedObjects, M), a(M, function(W, L) {
                M[L] && M[L].parentGroup === M && M[L].destroy && M[L].destroy(), delete M[L];
              });
            }, l.prototype.destroyShadows = function() {
              (this.shadows || []).forEach(function(h) {
                this.safeRemoveChild(h);
              }, this), this.shadows = void 0;
            }, l.prototype.dSetter = function(h, C, M) {
              S(h) && (typeof h[0] == "string" && (h = this.renderer.pathToSegments(h)), this.pathArray = h, h = h.reduce(function(O, p, w) {
                return p && p.join ? (w ? O + " " : "") + p.join(" ") : (p || "").toString();
              }, "")), /(NaN| {2}|^$)/.test(h) && (h = "M 0 0"), this[C] !== h && (M.setAttribute(C, h), this[C] = h);
            }, l.prototype.fadeOut = function(h) {
              var C = this;
              C.animate({ opacity: 0 }, { duration: e(h, 150), complete: function() {
                C.hide();
              } });
            }, l.prototype.fillSetter = function(h, C, M) {
              typeof h == "string" ? M.setAttribute(C, h) : h && this.complexColor(h, C, M);
            }, l.prototype.getBBox = function(h, C) {
              var M, O, p, w, T, z = this, W = z.alignValue, L = z.element, I = z.renderer, j = z.styles, Z = z.textStr, V = I.cache, X = I.cacheKeys, et = L.namespaceURI === z.SVG_NS, ot = e(C, z.rotation, 0), it = I.styledMode ? L && l.prototype.getStyle.call(L, "font-size") : j && j.fontSize;
              if (g(Z) && ((T = Z.toString()).indexOf("<") === -1 && (T = T.replace(/[0-9]/g, "0")), T += ["", ot, it, z.textWidth, W, j && j.textOverflow, j && j.fontWeight].join(",")), T && !h && (M = V[T]), !M) {
                if (et || I.forExport) {
                  try {
                    w = this.fakeTS && function(Ht) {
                      var Kt = L.querySelector(".highcharts-text-outline");
                      Kt && v(Kt, { display: Ht });
                    }, u(w) && w("none"), M = L.getBBox ? E({}, L.getBBox()) : { width: L.offsetWidth, height: L.offsetHeight, x: 0, y: 0 }, u(w) && w("");
                  } catch (Ht) {
                  }
                  (!M || M.width < 0) && (M = { x: 0, y: 0, width: 0, height: 0 });
                } else
                  M = z.htmlGetBBox();
                if (I.isSVG && (O = M.width, p = M.height, et && (M.height = p = { "11px,17": 14, "13px,20": 16 }["" + (it || "") + ",".concat(Math.round(p))] || p), ot)) {
                  var pt = Number(L.getAttribute("y") || 0) - M.y, mt = { right: 1, center: 0.5 }[W || 0] || 0, Ct = ot * U, kt = (ot - 90) * U, Lt = O * Math.cos(Ct), Tt = O * Math.sin(Ct), xt = Math.cos(kt), ct = Math.sin(kt), ft = M.x + mt * (O - Lt) + pt * xt, St = ft + Lt, Mt = St - p * xt, Dt = Mt - Lt, Ot = M.y + pt - mt * Tt + pt * ct, Nt = Ot + Tt, Wt = Nt - p * ct, zt = Wt - Tt;
                  M.x = Math.min(ft, St, Mt, Dt), M.y = Math.min(Ot, Nt, Wt, zt), M.width = Math.max(ft, St, Mt, Dt) - M.x, M.height = Math.max(Ot, Nt, Wt, zt) - M.y;
                }
                if (T && (Z === "" || M.height > 0)) {
                  for (; X.length > 250; )
                    delete V[X.shift()];
                  V[T] || X.push(T), V[T] = M;
                }
              }
              return M;
            }, l.prototype.getStyle = function(h) {
              return A.getComputedStyle(this.element || this, "").getPropertyValue(h);
            }, l.prototype.hasClass = function(h) {
              return ("" + this.attr("class")).split(" ").indexOf(h) !== -1;
            }, l.prototype.hide = function() {
              return this.attr({ visibility: "hidden" });
            }, l.prototype.htmlGetBBox = function() {
              return { height: 0, width: 0, x: 0, y: 0 };
            }, l.prototype.init = function(h, C) {
              this.element = C === "span" ? m(C) : N.createElementNS(this.SVG_NS, C), this.renderer = h, P(this, "afterInit");
            }, l.prototype.on = function(h, C) {
              var M = this.onEvents;
              return M[h] && M[h](), M[h] = b(this.element, h, C), this;
            }, l.prototype.opacitySetter = function(h, C, M) {
              var O = Number(Number(h).toFixed(3));
              this.opacity = O, M.setAttribute(C, O);
            }, l.prototype.removeClass = function(h) {
              return this.attr("class", ("" + this.attr("class")).replace(y(h) ? new RegExp("(^| )".concat(h, "( |$)")) : h, " ").replace(/ +/g, " ").trim());
            }, l.prototype.removeTextOutline = function() {
              var h = this.element.querySelector("tspan.highcharts-text-outline");
              h && this.safeRemoveChild(h);
            }, l.prototype.safeRemoveChild = function(h) {
              var C = h.parentNode;
              C && C.removeChild(h);
            }, l.prototype.setRadialReference = function(h) {
              var C = this.element.gradient && this.renderer.gradients[this.element.gradient];
              return this.element.radialReference = h, C && C.radAttr && C.animate(this.renderer.getRadialAttr(h, C.radAttr)), this;
            }, l.prototype.setTextPath = function(h, C) {
              var M = this;
              C = s(!0, { enabled: !0, attributes: { dy: -5, startOffset: "50%", textAnchor: "middle" } }, C);
              var O = this.renderer.url, p = this.text || this, w = p.textPath, T = C.attributes, z = C.enabled;
              if (h = h || w && w.path, w && w.undo(), h && z) {
                var W = b(p, "afterModifyTree", function(L) {
                  if (h && z) {
                    var I = h.attr("id");
                    I || h.attr("id", I = i());
                    var j = { x: 0, y: 0 };
                    g(T.dx) && (j.dx = T.dx, delete T.dx), g(T.dy) && (j.dy = T.dy, delete T.dy), p.attr(j), M.attr({ transform: "" }), M.box && (M.box = M.box.destroy());
                    var Z = L.nodes.slice(0);
                    L.nodes.length = 0, L.nodes[0] = { tagName: "textPath", attributes: E(T, { "text-anchor": T.textAnchor, href: "" + O + "#".concat(I) }), children: Z };
                  }
                });
                p.textPath = { path: h, undo: W };
              } else
                p.attr({ dx: 0, dy: 0 }), delete p.textPath;
              return this.added && (p.textCache = "", this.renderer.buildText(p)), this;
            }, l.prototype.shadow = function(h, C, M) {
              var O, p, w, T, z, W, L = [], I = this, j = I.element, Z = I.oldShadowOptions, V = I.parentGroup, X = V && V.rotation === 90, et = { color: "#000000", offsetX: X ? -1 : 1, offsetY: X ? -1 : 1, opacity: 0.15, width: 3 }, ot = !1;
              if (h === !0 ? W = et : typeof h == "object" && (W = E(et, h)), W && (W && Z && a(W, function(it, pt) {
                it !== Z[pt] && (ot = !0);
              }), ot && this.destroyShadows(), this.oldShadowOptions = W), W) {
                if (!this.shadows) {
                  for (T = W.opacity / W.width, z = X ? "translate(".concat(W.offsetY, ", ").concat(W.offsetX, ")") : "translate(".concat(W.offsetX, ", ").concat(W.offsetY, ")"), O = 1; O <= W.width; O++)
                    p = j.cloneNode(!1), w = 2 * W.width + 1 - 2 * O, d(p, { stroke: h.color || "#000000", "stroke-opacity": T * O, "stroke-width": w, transform: z, fill: "none" }), p.setAttribute("class", (p.getAttribute("class") || "") + " highcharts-shadow"), M && (d(p, "height", Math.max(d(p, "height") - w, 0)), p.cutHeight = w), C ? C.element.appendChild(p) : j.parentNode && j.parentNode.insertBefore(p, j), L.push(p);
                  this.shadows = L;
                }
              } else
                this.destroyShadows();
              return this;
            }, l.prototype.show = function(h) {
              return h === void 0 && (h = !0), this.attr({ visibility: h ? "inherit" : "visible" });
            }, l.prototype["stroke-widthSetter"] = function(h, C, M) {
              this[C] = h, M.setAttribute(C, h);
            }, l.prototype.strokeWidth = function() {
              if (!this.renderer.styledMode)
                return this["stroke-width"] || 0;
              var h, C = this.getStyle("stroke-width"), M = 0;
              return C.indexOf("px") === C.length - 2 ? M = n(C) : C !== "" && (h = N.createElementNS(k, "rect"), d(h, { width: C, "stroke-width": 0 }), this.element.parentNode.appendChild(h), M = h.getBBox().width, h.parentNode.removeChild(h)), M;
            }, l.prototype.symbolAttr = function(h) {
              var C = this;
              ["x", "y", "r", "start", "end", "width", "height", "innerR", "anchorX", "anchorY", "clockwise"].forEach(function(M) {
                C[M] = e(h[M], C[M]);
              }), C.attr({ d: C.renderer.symbols[C.symbolName](C.x, C.y, C.width, C.height, C) });
            }, l.prototype.textSetter = function(h) {
              h !== this.textStr && (delete this.textPxLength, this.textStr = h, this.added && this.renderer.buildText(this));
            }, l.prototype.titleSetter = function(h) {
              var C = this.element, M = C.getElementsByTagName("title")[0] || N.createElementNS(this.SVG_NS, "title");
              C.insertBefore ? C.insertBefore(M, C.firstChild) : C.appendChild(M), M.textContent = String(e(h, "")).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }, l.prototype.toFront = function() {
              var h = this.element;
              return h.parentNode.appendChild(h), this;
            }, l.prototype.translate = function(h, C) {
              return this.attr({ translateX: h, translateY: C });
            }, l.prototype.updateShadows = function(h, C, M) {
              var O = this.shadows;
              if (O)
                for (var p = O.length; p--; )
                  M.call(O[p], h === "height" ? Math.max(C - (O[p].cutHeight || 0), 0) : h === "d" ? this.d : C, h, O[p]);
            }, l.prototype.updateTransform = function() {
              var h = this, C = h.element, M = h.matrix, O = h.rotation, p = O === void 0 ? 0 : O, w = h.scaleX, T = h.scaleY, z = h.translateX, W = z === void 0 ? 0 : z, L = h.translateY, I = ["translate(" + W + "," + (L === void 0 ? 0 : L) + ")"];
              g(M) && I.push("matrix(" + M.join(",") + ")"), p && I.push("rotate(" + p + " " + e(this.rotationOriginX, C.getAttribute("x"), 0) + " " + e(this.rotationOriginY, C.getAttribute("y") || 0) + ")"), (g(w) || g(T)) && I.push("scale(" + e(w, 1) + " " + e(T, 1) + ")"), I.length && !(this.text || this).textPath && C.setAttribute("transform", I.join(" "));
            }, l.prototype.visibilitySetter = function(h, C, M) {
              h === "inherit" ? M.removeAttribute(C) : this[C] !== h && M.setAttribute(C, h), this[C] = h;
            }, l.prototype.xGetter = function(h) {
              return this.element.nodeName === "circle" && (h === "x" ? h = "cx" : h === "y" && (h = "cy")), this._defaultGetter(h);
            }, l.prototype.zIndexSetter = function(h, C) {
              var M, O, p, w, T, z = this.renderer, W = this.parentGroup, L = (W || z).element || z.box, I = this.element, j = L === z.box, Z = !1, V = this.added;
              if (g(h) ? (I.setAttribute("data-z-index", h), h = +h, this[C] === h && (V = !1)) : g(this[C]) && I.removeAttribute("data-z-index"), this[C] = h, V) {
                for ((h = this.zIndex) && W && (W.handleZ = !0), T = (M = L.childNodes).length - 1; T >= 0 && !Z; T--)
                  p = (O = M[T]).getAttribute("data-z-index"), w = !g(p), O !== I && (h < 0 && w && !j && !T ? (L.insertBefore(I, M[T]), Z = !0) : (n(p) <= h || w && (!g(h) || h >= 0)) && (L.insertBefore(I, M[T + 1] || null), Z = !0));
                Z || (L.insertBefore(I, M[j ? 3 : 0] || null), Z = !0);
              }
              return Z;
            }, l;
          }();
          return c.prototype.strokeSetter = c.prototype.fillSetter, c.prototype.yGetter = c.prototype.xGetter, c.prototype.matrixSetter = c.prototype.rotationOriginXSetter = c.prototype.rotationOriginYSetter = c.prototype.rotationSetter = c.prototype.scaleXSetter = c.prototype.scaleYSetter = c.prototype.translateXSetter = c.prototype.translateYSetter = c.prototype.verticalAlignSetter = function(l, h) {
            this[h] = l, this.doTransform = !0;
          }, c;
        }), at(_, "Core/Renderer/RendererRegistry.js", [_["Core/Globals.js"]], function(G) {
          var F;
          return function($) {
            var Y;
            $.rendererTypes = {}, $.getRendererType = function(J) {
              return J === void 0 && (J = Y), $.rendererTypes[J] || $.rendererTypes[Y];
            }, $.registerRendererType = function(J, Q, q) {
              $.rendererTypes[J] = Q, Y && !q || (Y = J, G.Renderer = Q);
            };
          }(F || (F = {})), F;
        }), at(_, "Core/Renderer/SVG/SVGLabel.js", [_["Core/Renderer/SVG/SVGElement.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(k, A) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
              b.__proto__ = d;
            } || function(b, d) {
              for (var m in d)
                d.hasOwnProperty(m) && (b[m] = d[m]);
            }, $(k, A);
          }, function(k, A) {
            function b() {
              this.constructor = k;
            }
            $(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
          }), J = F.defined, Q = F.extend, q = F.isNumber, U = F.merge, N = F.pick, D = F.removeEvent;
          return function(k) {
            function A(b, d, m, v, g, x, E, P, S, u) {
              var y, s = k.call(this) || this;
              return s.paddingLeftSetter = s.paddingSetter, s.paddingRightSetter = s.paddingSetter, s.init(b, "g"), s.textStr = d, s.x = m, s.y = v, s.anchorX = x, s.anchorY = E, s.baseline = S, s.className = u, s.addClass(u === "button" ? "highcharts-no-tooltip" : "highcharts-label"), u && s.addClass("highcharts-" + u), s.text = b.text(void 0, 0, 0, P).attr({ zIndex: 1 }), typeof g == "string" && ((y = /^url\((.*?)\)$/.test(g)) || s.renderer.symbols[g]) && (s.symbolKey = g), s.bBox = A.emptyBBox, s.padding = 3, s.baselineOffset = 0, s.needsBox = b.styledMode || y, s.deferredAttr = {}, s.alignFactor = 0, s;
            }
            return Y(A, k), A.prototype.alignSetter = function(b) {
              var d = { left: 0, center: 0.5, right: 1 }[b];
              d !== this.alignFactor && (this.alignFactor = d, this.bBox && q(this.xSetting) && this.attr({ x: this.xSetting }));
            }, A.prototype.anchorXSetter = function(b, d) {
              this.anchorX = b, this.boxAttr(d, Math.round(b) - this.getCrispAdjust() - this.xSetting);
            }, A.prototype.anchorYSetter = function(b, d) {
              this.anchorY = b, this.boxAttr(d, b - this.ySetting);
            }, A.prototype.boxAttr = function(b, d) {
              this.box ? this.box.attr(b, d) : this.deferredAttr[b] = d;
            }, A.prototype.css = function(b) {
              if (b) {
                var d = {};
                b = U(b), A.textProps.forEach(function(m) {
                  b[m] !== void 0 && (d[m] = b[m], delete b[m]);
                }), this.text.css(d), "fontSize" in d || "fontWeight" in d ? this.updateTextPadding() : ("width" in d || "textOverflow" in d) && this.updateBoxSize();
              }
              return G.prototype.css.call(this, b);
            }, A.prototype.destroy = function() {
              D(this.element, "mouseenter"), D(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), G.prototype.destroy.call(this);
            }, A.prototype.fillSetter = function(b, d) {
              b && (this.needsBox = !0), this.fill = b, this.boxAttr(d, b);
            }, A.prototype.getBBox = function() {
              this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
              var b = this.padding, d = N(this.paddingLeft, b);
              return { width: this.width, height: this.height, x: this.bBox.x - d, y: this.bBox.y - b };
            }, A.prototype.getCrispAdjust = function() {
              return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }, A.prototype.heightSetter = function(b) {
              this.heightSetting = b;
            }, A.prototype.onAdd = function() {
              this.text.add(this), this.attr({ text: N(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && J(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
            }, A.prototype.paddingSetter = function(b, d) {
              q(b) ? b !== this[d] && (this[d] = b, this.updateTextPadding()) : this[d] = void 0;
            }, A.prototype.rSetter = function(b, d) {
              this.boxAttr(d, b);
            }, A.prototype.shadow = function(b) {
              return b && !this.renderer.styledMode && (this.updateBoxSize(), this.box && this.box.shadow(b)), this;
            }, A.prototype.strokeSetter = function(b, d) {
              this.stroke = b, this.boxAttr(d, b);
            }, A.prototype["stroke-widthSetter"] = function(b, d) {
              b && (this.needsBox = !0), this["stroke-width"] = b, this.boxAttr(d, b);
            }, A.prototype["text-alignSetter"] = function(b) {
              this.textAlign = b;
            }, A.prototype.textSetter = function(b) {
              b !== void 0 && this.text.attr({ text: b }), this.updateTextPadding();
            }, A.prototype.updateBoxSize = function() {
              var b, d = this.text, m = d.element.style, v = {}, g = this.padding, x = this.bBox = q(this.widthSetting) && q(this.heightSetting) && !this.textAlign || !J(d.textStr) ? A.emptyBBox : d.getBBox();
              this.width = this.getPaddedWidth(), this.height = (this.heightSetting || x.height || 0) + 2 * g;
              var E = this.renderer.fontMetrics(m && m.fontSize, d);
              if (this.baselineOffset = g + Math.min((this.text.firstLineMetrics || E).b, x.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - E.h) / 2), this.needsBox && !d.textPath) {
                if (!this.box) {
                  var P = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
                  P.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), P.add(this);
                }
                b = this.getCrispAdjust(), v.x = b, v.y = (this.baseline ? -this.baselineOffset : 0) + b, v.width = Math.round(this.width), v.height = Math.round(this.height), this.box.attr(Q(v, this.deferredAttr)), this.deferredAttr = {};
              }
            }, A.prototype.updateTextPadding = function() {
              var b = this.text;
              if (!b.textPath) {
                this.updateBoxSize();
                var d = this.baseline ? 0 : this.baselineOffset, m = N(this.paddingLeft, this.padding);
                J(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (m += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), m === b.x && d === b.y || (b.attr("x", m), b.hasBoxWidthChanged && (this.bBox = b.getBBox(!0)), d !== void 0 && b.attr("y", d)), b.x = m, b.y = d;
              }
            }, A.prototype.widthSetter = function(b) {
              this.widthSetting = q(b) ? b : void 0;
            }, A.prototype.getPaddedWidth = function() {
              var b = this.padding, d = N(this.paddingLeft, b), m = N(this.paddingRight, b);
              return (this.widthSetting || this.bBox.width || 0) + d + m;
            }, A.prototype.xSetter = function(b) {
              this.x = b, this.alignFactor && (b -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(b), this.attr("translateX", this.xSetting);
            }, A.prototype.ySetter = function(b) {
              this.ySetting = this.y = Math.round(b), this.attr("translateY", this.ySetting);
            }, A.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, A.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "width"], A;
          }(G);
        }), at(_, "Core/Renderer/SVG/Symbols.js", [_["Core/Utilities.js"]], function(G) {
          var F = G.defined, $ = G.isNumber, Y = G.pick;
          function J(U, N, D, k, A) {
            var b = [];
            if (A) {
              var d = A.start || 0, m = Y(A.r, D), v = Y(A.r, k || D), g = 1e-3, x = Math.abs((A.end || 0) - d - 2 * Math.PI) < g, E = (A.end || 0) - g, P = A.innerR, S = Y(A.open, x), u = Math.cos(d), y = Math.sin(d), s = Math.cos(E), a = Math.sin(E), e = Y(A.longArc, E - d - Math.PI < g ? 0 : 1);
              b.push(["M", U + m * u, N + v * y], ["A", m, v, 0, e, Y(A.clockwise, 1), U + m * s, N + v * a]), F(P) && b.push(S ? ["M", U + P * s, N + P * a] : ["L", U + P * s, N + P * a], ["A", P, P, 0, e, F(A.clockwise) ? 1 - A.clockwise : 0, U + P * u, N + P * y]), S || b.push(["Z"]);
            }
            return b;
          }
          function Q(U, N, D, k, A) {
            return A && A.r ? q(U, N, D, k, A) : [["M", U, N], ["L", U + D, N], ["L", U + D, N + k], ["L", U, N + k], ["Z"]];
          }
          function q(U, N, D, k, A) {
            var b = A && A.r || 0;
            return [["M", U + b, N], ["L", U + D - b, N], ["C", U + D, N, U + D, N, U + D, N + b], ["L", U + D, N + k - b], ["C", U + D, N + k, U + D, N + k, U + D - b, N + k], ["L", U + b, N + k], ["C", U, N + k, U, N + k, U, N + k - b], ["L", U, N + b], ["C", U, N, U, N, U + b, N]];
          }
          return { arc: J, callout: function(U, N, D, k, A) {
            var b = Math.min(A && A.r || 0, D, k), d = b + 6, m = A && A.anchorX, v = A && A.anchorY || 0, g = q(U, N, D, k, { r: b });
            return $(m) && (U + m >= D ? v > N + d && v < N + k - d ? g.splice(3, 1, ["L", U + D, v - 6], ["L", U + D + 6, v], ["L", U + D, v + 6], ["L", U + D, N + k - b]) : g.splice(3, 1, ["L", U + D, k / 2], ["L", m, v], ["L", U + D, k / 2], ["L", U + D, N + k - b]) : U + m <= 0 ? v > N + d && v < N + k - d ? g.splice(7, 1, ["L", U, v + 6], ["L", U - 6, v], ["L", U, v - 6], ["L", U, N + b]) : g.splice(7, 1, ["L", U, k / 2], ["L", m, v], ["L", U, k / 2], ["L", U, N + b]) : v && v > k && m > U + d && m < U + D - d ? g.splice(5, 1, ["L", m + 6, N + k], ["L", m, N + k + 6], ["L", m - 6, N + k], ["L", U + b, N + k]) : v && v < 0 && m > U + d && m < U + D - d && g.splice(1, 1, ["L", m - 6, N], ["L", m, N - 6], ["L", m + 6, N], ["L", D - b, N])), g;
          }, circle: function(U, N, D, k) {
            return J(U + D / 2, N + k / 2, D / 2, k / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
          }, diamond: function(U, N, D, k) {
            return [["M", U + D / 2, N], ["L", U + D, N + k / 2], ["L", U + D / 2, N + k], ["L", U, N + k / 2], ["Z"]];
          }, rect: Q, roundedRect: q, square: Q, triangle: function(U, N, D, k) {
            return [["M", U + D / 2, N], ["L", U + D, N + k], ["L", U, N + k], ["Z"]];
          }, "triangle-down": function(U, N, D, k) {
            return [["M", U, N], ["L", U + D, N], ["L", U + D / 2, N + k], ["Z"]];
          } };
        }), at(_, "Core/Renderer/SVG/TextBuilder.js", [_["Core/Renderer/HTML/AST.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = F.doc, J = F.SVG_NS, Q = F.win, q = $.attr, U = $.extend, N = $.fireEvent, D = $.isString, k = $.objectEach, A = $.pick;
          return function() {
            function b(d) {
              var m = d.styles;
              this.renderer = d.renderer, this.svgElement = d, this.width = d.textWidth, this.textLineHeight = m && m.lineHeight, this.textOutline = m && m.textOutline, this.ellipsis = !!(m && m.textOverflow === "ellipsis"), this.noWrap = !!(m && m.whiteSpace === "nowrap"), this.fontSize = m && m.fontSize;
            }
            return b.prototype.buildSVG = function() {
              var d = this.svgElement, m = d.element, v = d.renderer, g = A(d.textStr, "").toString(), x = g.indexOf("<") !== -1, E = m.childNodes, P = this.width && !d.added && v.box, S = [g, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, this.fontSize, this.width].join(",");
              if (S !== d.textCache) {
                d.textCache = S, delete d.actualWidth;
                for (var u = E.length; u--; )
                  m.removeChild(E[u]);
                if (x || this.ellipsis || this.width || d.textPath || g.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(g))) {
                  if (g !== "") {
                    P && P.appendChild(m);
                    var y = new G(g);
                    this.modifyTree(y.nodes), y.addToDOM(m), this.modifyDOM(), this.ellipsis && (m.textContent || "").indexOf("…") !== -1 && d.attr("title", this.unescapeEntities(d.textStr || "", ["&lt;", "&gt;"])), P && P.removeChild(m);
                  }
                } else
                  m.appendChild(Y.createTextNode(this.unescapeEntities(g)));
                D(this.textOutline) && d.applyTextOutline && d.applyTextOutline(this.textOutline);
              }
            }, b.prototype.modifyDOM = function() {
              var d, m = this, v = this.svgElement, g = q(v.element, "x");
              for (v.firstLineMetrics = void 0; (d = v.element.firstChild) && /^[\s\u200B]*$/.test(d.textContent || " "); )
                v.element.removeChild(d);
              [].forEach.call(v.element.querySelectorAll("tspan.highcharts-br"), function(P, S) {
                P.nextSibling && P.previousSibling && (S === 0 && P.previousSibling.nodeType === 1 && (v.firstLineMetrics = v.renderer.fontMetrics(void 0, P.previousSibling)), q(P, { dy: m.getLineHeight(P.nextSibling), x: g }));
              });
              var x = this.width || 0;
              if (x) {
                var E = function(P) {
                  [].slice.call(P.childNodes).forEach(function(S) {
                    S.nodeType === Q.Node.TEXT_NODE ? function(u, y) {
                      var s = u.textContent || "", a = s.replace(/([^\^])-/g, "$1- ").split(" "), e = !m.noWrap && (a.length > 1 || v.element.childNodes.length > 1), n = m.getLineHeight(y), o = 0, i = v.actualWidth;
                      if (m.ellipsis)
                        s && m.truncate(u, s, void 0, 0, Math.max(0, x - parseInt(m.fontSize || 12, 10)), function(h, C) {
                          return h.substring(0, C) + "…";
                        });
                      else if (e) {
                        for (var c = [], l = []; y.firstChild && y.firstChild !== u; )
                          l.push(y.firstChild), y.removeChild(y.firstChild);
                        for (; a.length; )
                          a.length && !m.noWrap && o > 0 && (c.push(u.textContent || ""), u.textContent = a.join(" ").replace(/- /g, "-")), m.truncate(u, void 0, a, o === 0 && i || 0, x, function(h, C) {
                            return a.slice(0, C).join(" ").replace(/- /g, "-");
                          }), i = v.actualWidth, o++;
                        l.forEach(function(h) {
                          y.insertBefore(h, u);
                        }), c.forEach(function(h) {
                          y.insertBefore(Y.createTextNode(h), u);
                          var C = Y.createElementNS(J, "tspan");
                          C.textContent = "​", q(C, { dy: n, x: g }), y.insertBefore(C, u);
                        });
                      }
                    }(S, P) : (S.className.baseVal.indexOf("highcharts-br") !== -1 && (v.actualWidth = 0), E(S));
                  });
                };
                E(v.element);
              }
            }, b.prototype.getLineHeight = function(d) {
              var m, v = d.nodeType === Q.Node.TEXT_NODE ? d.parentElement : d;
              return this.renderer.styledMode || (m = v && /(px|em)$/.test(v.style.fontSize) ? v.style.fontSize : this.fontSize || this.renderer.style.fontSize || 12), this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(m, v || this.svgElement.element).h;
            }, b.prototype.modifyTree = function(d) {
              var m = this, v = function(g, x) {
                var E = g.attributes, P = E === void 0 ? {} : E, S = g.children, u = g.style, y = u === void 0 ? {} : u, s = g.tagName, a = m.renderer.styledMode;
                if (s === "b" || s === "strong" ? a ? P.class = "highcharts-strong" : y.fontWeight = "bold" : s !== "i" && s !== "em" || (a ? P.class = "highcharts-emphasized" : y.fontStyle = "italic"), y && y.color && (y.fill = y.color), s === "br") {
                  P.class = "highcharts-br", g.textContent = "​";
                  var e = d[x + 1];
                  e && e.textContent && (e.textContent = e.textContent.replace(/^ +/gm, ""));
                } else
                  s === "a" && S && S.some(function(n) {
                    return n.tagName === "#text";
                  }) && (g.children = [{ children: S, tagName: "tspan" }]);
                s !== "#text" && s !== "a" && (g.tagName = "tspan"), U(g, { attributes: P, style: y }), S && S.filter(function(n) {
                  return n.tagName !== "#text";
                }).forEach(v);
              };
              d.forEach(v), N(this.svgElement, "afterModifyTree", { nodes: d });
            }, b.prototype.truncate = function(d, m, v, g, x, E) {
              var P, S, u = this.svgElement, y = u.renderer, s = u.rotation, a = [], e = v ? 1 : 0, n = (m || v || "").length, o = n, i = function(c, l) {
                var h = l || c, C = d.parentNode;
                if (C && a[h] === void 0)
                  if (C.getSubStringLength)
                    try {
                      a[h] = g + C.getSubStringLength(0, v ? h + 1 : h);
                    } catch (M) {
                    }
                  else
                    y.getSpanWidth && (d.textContent = E(m || v, c), a[h] = g + y.getSpanWidth(u, d));
                return a[h];
              };
              if (u.rotation = 0, S = i(d.textContent.length), g + S > x) {
                for (; e <= n; )
                  o = Math.ceil((e + n) / 2), v && (P = E(v, o)), S = i(o, P && P.length - 1), e === n ? e = n + 1 : S > x ? n = o - 1 : e = o;
                n === 0 ? d.textContent = "" : m && n === m.length - 1 || (d.textContent = P || E(m || v, o));
              }
              v && v.splice(0, o), u.actualWidth = S, u.rotation = s;
            }, b.prototype.unescapeEntities = function(d, m) {
              return k(this.renderer.escapes, function(v, g) {
                m && m.indexOf(v) !== -1 || (d = d.toString().replace(new RegExp(v, "g"), g));
              }), d;
            }, b;
          }();
        }), at(_, "Core/Renderer/SVG/SVGRenderer.js", [_["Core/Renderer/HTML/AST.js"], _["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Renderer/RendererRegistry.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Renderer/SVG/SVGLabel.js"], _["Core/Renderer/SVG/Symbols.js"], _["Core/Renderer/SVG/TextBuilder.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N) {
          var D, k = $.charts, A = $.deg2rad, b = $.doc, d = $.isFirefox, m = $.isMS, v = $.isWebKit, g = $.noop, x = $.SVG_NS, E = $.symbolSizes, P = $.win, S = N.addEvent, u = N.attr, y = N.createElement, s = N.css, a = N.defined, e = N.destroyObjectProperties, n = N.extend, o = N.isArray, i = N.isNumber, c = N.isObject, l = N.isString, h = N.merge, C = N.pick, M = N.pInt, O = N.uniqueKey, p = function() {
            function w(T, z, W, L, I, j, Z) {
              this.alignedObjects = void 0, this.box = void 0, this.boxWrapper = void 0, this.cache = void 0, this.cacheKeys = void 0, this.chartIndex = void 0, this.defs = void 0, this.globalAnimation = void 0, this.gradients = void 0, this.height = void 0, this.imgCount = void 0, this.isSVG = void 0, this.style = void 0, this.url = void 0, this.width = void 0, this.init(T, z, W, L, I, j, Z);
            }
            return w.prototype.init = function(T, z, W, L, I, j, Z) {
              var V, X, et = this, ot = et.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), it = ot.element;
              Z || ot.css(this.getStyle(L)), T.appendChild(it), u(T, "dir", "ltr"), T.innerHTML.indexOf("xmlns") === -1 && u(it, "xmlns", this.SVG_NS), et.isSVG = !0, this.box = it, this.boxWrapper = ot, et.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(b.createTextNode("Created with Highcharts 10.3.3")), et.defs = this.createElement("defs").add(), et.allowHTML = j, et.forExport = I, et.styledMode = Z, et.gradients = {}, et.cache = {}, et.cacheKeys = [], et.imgCount = 0, et.setSize(z, W, !1), d && T.getBoundingClientRect && ((V = function() {
                s(T, { left: 0, top: 0 }), X = T.getBoundingClientRect(), s(T, { left: Math.ceil(X.left) - X.left + "px", top: Math.ceil(X.top) - X.top + "px" });
              })(), et.unSubPixelFix = S(P, "resize", V));
            }, w.prototype.definition = function(T) {
              return new G([T]).addToDOM(this.defs.element);
            }, w.prototype.getReferenceURL = function() {
              if ((d || v) && b.getElementsByTagName("base").length) {
                if (!a(D)) {
                  var T = O(), z = new G([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: T }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": "url(#".concat(T, ")"), fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(b.body);
                  s(z, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
                  var W = b.elementFromPoint(6, 6);
                  D = (W && W.id) === "hitme", b.body.removeChild(z);
                }
                if (D)
                  return P.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20");
              }
              return "";
            }, w.prototype.getStyle = function(T) {
              return this.style = n({ fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', fontSize: "12px" }, T), this.style;
            }, w.prototype.setStyle = function(T) {
              this.boxWrapper.css(this.getStyle(T));
            }, w.prototype.isHidden = function() {
              return !this.boxWrapper.getBBox().width;
            }, w.prototype.destroy = function() {
              var T = this, z = T.defs;
              return T.box = null, T.boxWrapper = T.boxWrapper.destroy(), e(T.gradients || {}), T.gradients = null, z && (T.defs = z.destroy()), T.unSubPixelFix && T.unSubPixelFix(), T.alignedObjects = null, null;
            }, w.prototype.createElement = function(T) {
              var z = new this.Element();
              return z.init(this, T), z;
            }, w.prototype.getRadialAttr = function(T, z) {
              return { cx: T[0] - T[2] / 2 + (z.cx || 0) * T[2], cy: T[1] - T[2] / 2 + (z.cy || 0) * T[2], r: (z.r || 0) * T[2] };
            }, w.prototype.buildText = function(T) {
              new U(T).buildSVG();
            }, w.prototype.getContrast = function(T) {
              var z = F.parse(T).rgba.map(function(L) {
                var I = L / 255;
                return I <= 0.03928 ? I / 12.92 : Math.pow((I + 0.055) / 1.055, 2.4);
              }), W = 0.2126 * z[0] + 0.7152 * z[1] + 0.0722 * z[2];
              return 1.05 / (W + 0.05) > (W + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
            }, w.prototype.button = function(T, z, W, L, I, j, Z, V, X, et) {
              I === void 0 && (I = {});
              var ot = this.label(T, z, W, X, void 0, void 0, et, void 0, "button"), it = this.styledMode, pt = I.states || {}, mt = 0;
              delete (I = h(I)).states;
              var Ct = h({ color: "#333333", cursor: "pointer", fontWeight: "normal" }, I.style);
              delete I.style;
              var kt, Lt, Tt, xt = G.filterUserAttributes(I);
              return ot.attr(h({ padding: 8, r: 2 }, xt)), it || (xt = h({ fill: "#f7f7f7", stroke: "#cccccc", "stroke-width": 1 }, xt), j = h(xt, { fill: "#e6e6e6" }, G.filterUserAttributes(j || pt.hover || {})), kt = j.style, delete j.style, Z = h(xt, { fill: "#e6ebf5", style: { color: "#000000", fontWeight: "bold" } }, G.filterUserAttributes(Z || pt.select || {})), Lt = Z.style, delete Z.style, V = h(xt, { style: { color: "#cccccc" } }, G.filterUserAttributes(V || pt.disabled || {})), Tt = V.style, delete V.style), S(ot.element, m ? "mouseover" : "mouseenter", function() {
                mt !== 3 && ot.setState(1);
              }), S(ot.element, m ? "mouseout" : "mouseleave", function() {
                mt !== 3 && ot.setState(mt);
              }), ot.setState = function(ct) {
                if (ct !== 1 && (ot.state = mt = ct), ot.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ct || 0]), !it) {
                  ot.attr([xt, j, Z, V][ct || 0]);
                  var ft = [Ct, kt, Lt, Tt][ct || 0];
                  c(ft) && ot.css(ft);
                }
              }, it || (ot.attr(xt).css(n({ cursor: "default" }, Ct)), et && ot.text.css({ pointerEvents: "none" })), ot.on("touchstart", function(ct) {
                return ct.stopPropagation();
              }).on("click", function(ct) {
                mt !== 3 && L.call(ot, ct);
              });
            }, w.prototype.crispLine = function(T, z, W) {
              W === void 0 && (W = "round");
              var L = T[0], I = T[1];
              return a(L[1]) && L[1] === I[1] && (L[1] = I[1] = Math[W](L[1]) - z % 2 / 2), a(L[2]) && L[2] === I[2] && (L[2] = I[2] = Math[W](L[2]) + z % 2 / 2), T;
            }, w.prototype.path = function(T) {
              var z = this.styledMode ? {} : { fill: "none" };
              return o(T) ? z.d = T : c(T) && n(z, T), this.createElement("path").attr(z);
            }, w.prototype.circle = function(T, z, W) {
              var L = c(T) ? T : T === void 0 ? {} : { x: T, y: z, r: W }, I = this.createElement("circle");
              return I.xSetter = I.ySetter = function(j, Z, V) {
                V.setAttribute("c" + Z, j);
              }, I.attr(L);
            }, w.prototype.arc = function(T, z, W, L, I, j) {
              var Z;
              c(T) ? (z = (Z = T).y, W = Z.r, L = Z.innerR, I = Z.start, j = Z.end, T = Z.x) : Z = { innerR: L, start: I, end: j };
              var V = this.symbol("arc", T, z, W, W, Z);
              return V.r = W, V;
            }, w.prototype.rect = function(T, z, W, L, I, j) {
              I = c(T) ? T.r : I;
              var Z = this.createElement("rect"), V = c(T) ? T : T === void 0 ? {} : { x: T, y: z, width: Math.max(W, 0), height: Math.max(L, 0) };
              return this.styledMode || (j !== void 0 && (V["stroke-width"] = j, V = Z.crisp(V)), V.fill = "none"), I && (V.r = I), Z.rSetter = function(X, et, ot) {
                Z.r = X, u(ot, { rx: X, ry: X });
              }, Z.rGetter = function() {
                return Z.r || 0;
              }, Z.attr(V);
            }, w.prototype.setSize = function(T, z, W) {
              var L = this;
              L.width = T, L.height = z, L.boxWrapper.animate({ width: T, height: z }, { step: function() {
                this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
              }, duration: C(W, !0) ? void 0 : 0 }), L.alignElements();
            }, w.prototype.g = function(T) {
              var z = this.createElement("g");
              return T ? z.attr({ class: "highcharts-" + T }) : z;
            }, w.prototype.image = function(T, z, W, L, I, j) {
              var Z = { preserveAspectRatio: "none" }, V = function(it, pt) {
                it.setAttributeNS ? it.setAttributeNS("http://www.w3.org/1999/xlink", "href", pt) : it.setAttribute("hc-svg-href", pt);
              };
              i(z) && (Z.x = z), i(W) && (Z.y = W), i(L) && (Z.width = L), i(I) && (Z.height = I);
              var X = this.createElement("image").attr(Z), et = function(it) {
                V(X.element, T), j.call(X, it);
              };
              if (j) {
                V(X.element, "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==");
                var ot = new P.Image();
                S(ot, "load", et), ot.src = T, ot.complete && et({});
              } else
                V(X.element, T);
              return X;
            }, w.prototype.symbol = function(T, z, W, L, I, j) {
              var Z, V, X, et, ot = this, it = /^url\((.*?)\)$/, pt = it.test(T), mt = !pt && (this.symbols[T] ? T : "circle"), Ct = mt && this.symbols[mt];
              if (Ct)
                typeof z == "number" && (V = Ct.call(this.symbols, Math.round(z || 0), Math.round(W || 0), L || 0, I || 0, j)), Z = this.path(V), ot.styledMode || Z.attr("fill", "none"), n(Z, { symbolName: mt || void 0, x: z, y: W, width: L, height: I }), j && n(Z, j);
              else if (pt) {
                X = T.match(it)[1];
                var kt = Z = this.image(X);
                kt.imgwidth = C(E[X] && E[X].width, j && j.width), kt.imgheight = C(E[X] && E[X].height, j && j.height), et = function(Lt) {
                  return Lt.attr({ width: Lt.width, height: Lt.height });
                }, ["width", "height"].forEach(function(Lt) {
                  kt[Lt + "Setter"] = function(Tt, xt) {
                    this[xt] = Tt;
                    var ct = this, ft = ct.alignByTranslate, St = ct.element, Mt = ct.width, Dt = ct.height, Ot = ct.imgwidth, Nt = ct.imgheight, Wt = this["img" + xt];
                    if (a(Wt)) {
                      var zt = 1;
                      j && j.backgroundSize === "within" && Mt && Dt ? (zt = Math.min(Mt / Ot, Dt / Nt), Wt = Math.round(Wt * zt), u(St, { width: Math.round(Ot * zt), height: Math.round(Nt * zt) })) : St && St.setAttribute(xt, Wt), ft || this.translate(((Mt || 0) - Wt * zt) / 2, ((Dt || 0) - Wt * zt) / 2);
                    }
                  };
                }), a(z) && kt.attr({ x: z, y: W }), kt.isImg = !0, a(kt.imgwidth) && a(kt.imgheight) ? et(kt) : (kt.attr({ width: 0, height: 0 }), y("img", { onload: function() {
                  var Lt = k[ot.chartIndex];
                  this.width === 0 && (s(this, { position: "absolute", top: "-999em" }), b.body.appendChild(this)), E[X] = { width: this.width, height: this.height }, kt.imgwidth = this.width, kt.imgheight = this.height, kt.element && et(kt), this.parentNode && this.parentNode.removeChild(this), ot.imgCount--, ot.imgCount || !Lt || Lt.hasLoaded || Lt.onload();
                }, src: X }), this.imgCount++);
              }
              return Z;
            }, w.prototype.clipRect = function(T, z, W, L) {
              var I = O() + "-", j = this.createElement("clipPath").attr({ id: I }).add(this.defs), Z = this.rect(T, z, W, L, 0).add(j);
              return Z.id = I, Z.clipPath = j, Z.count = 0, Z;
            }, w.prototype.text = function(T, z, W, L) {
              var I = this, j = {};
              if (L && (I.allowHTML || !I.forExport))
                return I.html(T, z, W);
              j.x = Math.round(z || 0), W && (j.y = Math.round(W)), a(T) && (j.text = T);
              var Z = I.createElement("text").attr(j);
              return (!L || I.forExport && !I.allowHTML) && (Z.xSetter = function(V, X, et) {
                for (var ot = et.getElementsByTagName("tspan"), it = et.getAttribute(X), pt = 0, mt = void 0; pt < ot.length; pt++)
                  (mt = ot[pt]).getAttribute(X) === it && mt.setAttribute(X, V);
                et.setAttribute(X, V);
              }), Z;
            }, w.prototype.fontMetrics = function(T, z) {
              T = !this.styledMode && /px/.test(T) || !P.getComputedStyle ? T || z && z.style && z.style.fontSize || this.style && this.style.fontSize : z && J.prototype.getStyle.call(z, "font-size");
              var W = (T = /px/.test(T) ? M(T) : 12) < 24 ? T + 3 : Math.round(1.2 * T);
              return { h: W, b: Math.round(0.8 * W), f: T };
            }, w.prototype.rotCorr = function(T, z, W) {
              var L = T;
              return z && W && (L = Math.max(L * Math.cos(z * A), 4)), { x: -T / 3 * Math.sin(z * A), y: L };
            }, w.prototype.pathToSegments = function(T) {
              for (var z = [], W = [], L = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 }, I = 0; I < T.length; I++)
                l(W[0]) && i(T[I]) && W.length === L[W[0].toUpperCase()] && T.splice(I, 0, W[0].replace("M", "L").replace("m", "l")), typeof T[I] == "string" && (W.length && z.push(W.slice(0)), W.length = 0), W.push(T[I]);
              return z.push(W.slice(0)), z;
            }, w.prototype.label = function(T, z, W, L, I, j, Z, V, X) {
              return new Q(this, T, z, W, L, I, j, Z, V, X);
            }, w.prototype.alignElements = function() {
              this.alignedObjects.forEach(function(T) {
                return T.align();
              });
            }, w;
          }();
          return n(p.prototype, { Element: J, SVG_NS: x, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: q, draw: g }), Y.registerRendererType("svg", p, !0), p;
        }), at(_, "Core/Renderer/HTML/HTMLElement.js", [_["Core/Globals.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(v, g) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(x, E) {
              x.__proto__ = E;
            } || function(x, E) {
              for (var P in E)
                E.hasOwnProperty(P) && (x[P] = E[P]);
            }, Y(v, g);
          }, function(v, g) {
            function x() {
              this.constructor = v;
            }
            Y(v, g), v.prototype = g === null ? Object.create(g) : (x.prototype = g.prototype, new x());
          }), Q = G.isFirefox, q = G.isMS, U = G.isWebKit, N = G.win, D = $.css, k = $.defined, A = $.extend, b = $.pick, d = $.pInt, m = function(v) {
            function g() {
              return v !== null && v.apply(this, arguments) || this;
            }
            return J(g, v), g.compose = function(x) {
              if (g.composedClasses.indexOf(x) === -1) {
                g.composedClasses.push(x);
                var E = g.prototype, P = x.prototype;
                P.getSpanCorrection = E.getSpanCorrection, P.htmlCss = E.htmlCss, P.htmlGetBBox = E.htmlGetBBox, P.htmlUpdateTransform = E.htmlUpdateTransform, P.setSpanRotation = E.setSpanRotation;
              }
              return x;
            }, g.prototype.getSpanCorrection = function(x, E, P) {
              this.xCorr = -x * P, this.yCorr = -E;
            }, g.prototype.htmlCss = function(x) {
              var E, P = this, S = P.element.tagName === "SPAN" && x && "width" in x, u = b(S && x.width, void 0);
              return S && (delete x.width, P.textWidth = u, E = !0), x && x.textOverflow === "ellipsis" && (x.whiteSpace = "nowrap", x.overflow = "hidden"), P.styles = A(P.styles, x), D(P.element, x), E && P.htmlUpdateTransform(), P;
            }, g.prototype.htmlGetBBox = function() {
              var x = this.element;
              return { x: x.offsetLeft, y: x.offsetTop, width: x.offsetWidth, height: x.offsetHeight };
            }, g.prototype.htmlUpdateTransform = function() {
              if (this.added) {
                var x = this, E = x.renderer, P = x.element, S = x.translateX || 0, u = x.translateY || 0, y = x.x || 0, s = x.y || 0, a = x.textAlign || "left", e = { left: 0, center: 0.5, right: 1 }[a], n = x.styles, o = n && n.whiteSpace;
                if (D(P, { marginLeft: S, marginTop: u }), !E.styledMode && x.shadows && x.shadows.forEach(function(O) {
                  D(O, { marginLeft: S + 1, marginTop: u + 1 });
                }), x.inverted && [].forEach.call(P.childNodes, function(O) {
                  E.invertChild(O, P);
                }), P.tagName === "SPAN") {
                  var i = x.rotation, c = x.textWidth && d(x.textWidth), l = [i, a, P.innerHTML, x.textWidth, x.textAlign].join(","), h = void 0, C = !1;
                  if (c !== x.oldTextWidth) {
                    var M = x.textPxLength ? x.textPxLength : (D(P, { width: "", whiteSpace: o || "nowrap" }), P.offsetWidth);
                    (c > x.oldTextWidth || M > c) && (/[ \-]/.test(P.textContent || P.innerText) || P.style.textOverflow === "ellipsis") && (D(P, { width: M > c || i ? c + "px" : "auto", display: "block", whiteSpace: o || "normal" }), x.oldTextWidth = c, C = !0);
                  }
                  x.hasBoxWidthChanged = C, l !== x.cTT && (h = E.fontMetrics(P.style.fontSize, P).b, !k(i) || i === (x.oldRotation || 0) && a === x.oldAlign || x.setSpanRotation(i, e, h), x.getSpanCorrection(!k(i) && x.textPxLength || P.offsetWidth, h, e, i, a)), D(P, { left: y + (x.xCorr || 0) + "px", top: s + (x.yCorr || 0) + "px" }), x.cTT = l, x.oldRotation = i, x.oldAlign = a;
                }
              } else
                this.alignOnAdd = !0;
            }, g.prototype.setSpanRotation = function(x, E, P) {
              var S = {}, u = q && !/Edge/.test(N.navigator.userAgent) ? "-ms-transform" : U ? "-webkit-transform" : Q ? "MozTransform" : N.opera ? "-o-transform" : void 0;
              u && (S[u] = S.transform = "rotate(" + x + "deg)", S[u + (Q ? "Origin" : "-origin")] = S.transformOrigin = 100 * E + "% " + P + "px", D(this.element, S));
            }, g.composedClasses = [], g;
          }(F);
          return m;
        }), at(_, "Core/Renderer/HTML/HTMLRenderer.js", [_["Core/Renderer/HTML/AST.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(A, b) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, m) {
              d.__proto__ = m;
            } || function(d, m) {
              for (var v in m)
                m.hasOwnProperty(v) && (d[v] = m[v]);
            }, J(A, b);
          }, function(A, b) {
            function d() {
              this.constructor = A;
            }
            J(A, b), A.prototype = b === null ? Object.create(b) : (d.prototype = b.prototype, new d());
          }), q = Y.attr, U = Y.createElement, N = Y.extend, D = Y.pick, k = function(A) {
            function b() {
              return A !== null && A.apply(this, arguments) || this;
            }
            return Q(b, A), b.compose = function(d) {
              if (b.composedClasses.indexOf(d) === -1) {
                b.composedClasses.push(d);
                var m = b.prototype;
                d.prototype.html = m.html;
              }
              return d;
            }, b.prototype.html = function(d, m, v) {
              var g = this.createElement("span"), x = g.element, E = g.renderer, P = E.isSVG, S = function(u, y) {
                ["opacity", "visibility"].forEach(function(s) {
                  u[s + "Setter"] = function(a, e, n) {
                    var o = u.div ? u.div.style : y;
                    F.prototype[s + "Setter"].call(this, a, e, n), o && (o[e] = a);
                  };
                }), u.addedSetters = !0;
              };
              return g.textSetter = function(u) {
                u !== this.textStr && (delete this.bBox, delete this.oldTextWidth, G.setElementHTML(this.element, D(u, "")), this.textStr = u, g.doTransform = !0);
              }, P && S(g, g.element.style), g.xSetter = g.ySetter = g.alignSetter = g.rotationSetter = function(u, y) {
                y === "align" ? g.alignValue = g.textAlign = u : g[y] = u, g.doTransform = !0;
              }, g.afterSetters = function() {
                this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
              }, g.attr({ text: d, x: Math.round(m), y: Math.round(v) }).css({ position: "absolute" }), E.styledMode || g.css({ fontFamily: this.style.fontFamily, fontSize: this.style.fontSize }), x.style.whiteSpace = "nowrap", g.css = g.htmlCss, P && (g.add = function(u) {
                var y, s, a = E.box.parentNode, e = [];
                if (this.parentGroup = u, u) {
                  if (!(y = u.div)) {
                    for (s = u; s; )
                      e.push(s), s = s.parentGroup;
                    e.reverse().forEach(function(n) {
                      var o = q(n.element, "class");
                      function i(h, C) {
                        n[C] = h, C === "translateX" ? l.left = h + "px" : l.top = h + "px", n.doTransform = !0;
                      }
                      var c = n.styles || {}, l = (y = n.div = n.div || U("div", o ? { className: o } : void 0, { position: "absolute", left: (n.translateX || 0) + "px", top: (n.translateY || 0) + "px", display: n.display, opacity: n.opacity, cursor: c.cursor, pointerEvents: c.pointerEvents, visibility: n.visibility }, y || a)).style;
                      N(n, { classSetter: /* @__PURE__ */ function(h) {
                        return function(C) {
                          this.element.setAttribute("class", C), h.className = C;
                        };
                      }(y), on: function() {
                        return e[0].div && g.on.apply({ element: e[0].div, onEvents: n.onEvents }, arguments), n;
                      }, translateXSetter: i, translateYSetter: i }), n.addedSetters || S(n);
                    });
                  }
                } else
                  y = a;
                return y.appendChild(x), g.added = !0, g.alignOnAdd && g.htmlUpdateTransform(), g;
              }), g;
            }, b.composedClasses = [], b;
          }($);
          return k;
        }), at(_, "Core/Axis/AxisDefaults.js", [], function() {
          var G;
          return function(F) {
            F.defaultXAxisOptions = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e. %b" }, week: { main: "%e. %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotation: void 0, autoRotationLimit: 80, distance: void 0, enabled: !0, indentation: 10, overflow: "justify", padding: 5, reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, x: 0, zIndex: 7, style: { color: "#666666", cursor: "default", fontSize: "11px" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minPadding: 0.01, offset: void 0, opposite: !1, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", rotation: 0, useHTML: !1, x: 0, y: 0, style: { color: "#666666" } }, type: "linear", uniqueNames: !0, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#ccd6eb", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#ccd6eb" }, F.defaultYAxisOptions = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: -8 }, startOnTick: !0, title: { rotation: 270, text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
              return (0, this.axis.chart.numberFormatter)(this.total || 0, -1);
            }, style: { color: "#000000", fontSize: "11px", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, F.defaultLeftAxisOptions = { labels: { x: -15 }, title: { rotation: 270 } }, F.defaultRightAxisOptions = { labels: { x: 15 }, title: { rotation: 90 } }, F.defaultBottomAxisOptions = { labels: { autoRotation: [-45], x: 0 }, margin: 15, title: { rotation: 0 } }, F.defaultTopAxisOptions = { labels: { autoRotation: [-45], x: 0 }, margin: 15, title: { rotation: 0 } };
          }(G || (G = {})), G;
        }), at(_, "Core/Foundation.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.addEvent, Y = G.isFunction, J = G.objectEach, Q = G.removeEvent;
          return function(q) {
            q.registerEventOptions = function(U, N) {
              U.eventOptions = U.eventOptions || {}, J(N.events, function(D, k) {
                U.eventOptions[k] !== D && (U.eventOptions[k] && (Q(U, k, U.eventOptions[k]), delete U.eventOptions[k]), Y(D) && (U.eventOptions[k] = D, $(U, k, D)));
              });
            };
          }(F || (F = {})), F;
        }), at(_, "Core/Axis/Tick.js", [_["Core/FormatUtilities.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = F.deg2rad, J = $.clamp, Q = $.correctFloat, q = $.defined, U = $.destroyObjectProperties, N = $.extend, D = $.fireEvent, k = $.isNumber, A = $.merge, b = $.objectEach, d = $.pick;
          return function() {
            function m(v, g, x, E, P) {
              this.isNew = !0, this.isNewLabel = !0, this.axis = v, this.pos = g, this.type = x || "", this.parameters = P || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, D(this, "init"), x || E || this.addLabel();
            }
            return m.prototype.addLabel = function() {
              var v, g, x, E = this, P = E.axis, S = P.options, u = P.chart, y = P.categories, s = P.logarithmic, a = P.names, e = E.pos, n = d(E.options && E.options.labels, S.labels), o = P.tickPositions, i = e === o[0], c = e === o[o.length - 1], l = (!n.step || n.step === 1) && P.tickInterval === 1, h = o.info, C = E.label, M = this.parameters.category || (y ? d(y[e], a[e], e) : e);
              s && k(M) && (M = Q(s.lin2log(M))), P.dateTime && (h ? v = (g = u.time.resolveDTLFormat(S.dateTimeLabelFormats[!S.grid && h.higherRanks[e] || h.unitName])).main : k(M) && (v = P.dateTime.getXDateFormat(M, S.dateTimeLabelFormats || {}))), E.isFirst = i, E.isLast = c;
              var O = { axis: P, chart: u, dateTimeLabelFormat: v, isFirst: i, isLast: c, pos: e, tick: E, tickPositionInfo: h, value: M };
              D(this, "labelFormat", O);
              var p = function(z) {
                return n.formatter ? n.formatter.call(z, z) : n.format ? (z.text = P.defaultLabelFormatter.call(z, z), G.format(n.format, z, u)) : P.defaultLabelFormatter.call(z, z);
              }, w = p.call(O, O), T = g && g.list;
              E.shortenLabel = T ? function() {
                for (x = 0; x < T.length; x++)
                  if (N(O, { dateTimeLabelFormat: T[x] }), C.attr({ text: p.call(O, O) }), C.getBBox().width < P.getSlotWidth(E) - 2 * n.padding)
                    return;
                C.attr({ text: "" });
              } : void 0, l && P._addedPlotLB && E.moveLabel(w, n), q(C) || E.movedLabel ? C && C.textStr !== w && !l && (!C.textWidth || n.style.width || C.styles.width || C.css({ width: null }), C.attr({ text: w }), C.textPxLength = C.getBBox().width) : (E.label = C = E.createLabel({ x: 0, y: 0 }, w, n), E.rotation = 0);
            }, m.prototype.createLabel = function(v, g, x) {
              var E = this.axis, P = E.chart, S = q(g) && x.enabled ? P.renderer.text(g, v.x, v.y, x.useHTML).add(E.labelGroup) : null;
              return S && (P.styledMode || S.css(A(x.style)), S.textPxLength = S.getBBox().width), S;
            }, m.prototype.destroy = function() {
              U(this, this.axis);
            }, m.prototype.getPosition = function(v, g, x, E) {
              var P = this.axis, S = P.chart, u = E && S.oldChartHeight || S.chartHeight, y = { x: v ? Q(P.translate(g + x, void 0, void 0, E) + P.transB) : P.left + P.offset + (P.opposite ? (E && S.oldChartWidth || S.chartWidth) - P.right - P.left : 0), y: v ? u - P.bottom + P.offset - (P.opposite ? P.height : 0) : Q(u - P.translate(g + x, void 0, void 0, E) - P.transB) };
              return y.y = J(y.y, -1e5, 1e5), D(this, "afterGetPosition", { pos: y }), y;
            }, m.prototype.getLabelPosition = function(v, g, x, E, P, S, u, y) {
              var s, a, e = this.axis, n = e.transA, o = e.isLinked && e.linkedParent ? e.linkedParent.reversed : e.reversed, i = e.staggerLines, c = e.tickRotCorr || { x: 0, y: 0 }, l = E || e.reserveSpaceDefault ? 0 : -e.labelOffset * (e.labelAlign === "center" ? 0.5 : 1), h = {};
              return s = e.side === 0 ? x.rotation ? -8 : -x.getBBox().height : e.side === 2 ? c.y + 8 : Math.cos(x.rotation * Y) * (c.y - x.getBBox(!1, 0).height / 2), q(P.y) && (s = e.side === 0 && e.horiz ? P.y + s : P.y), v = v + P.x + l + c.x - (S && E ? S * n * (o ? -1 : 1) : 0), g = g + s - (S && !E ? S * n * (o ? 1 : -1) : 0), i && (a = u / (y || 1) % i, e.opposite && (a = i - a - 1), g += a * (e.labelOffset / i)), h.x = v, h.y = Math.round(g), D(this, "afterGetLabelPosition", { pos: h, tickmarkOffset: S, index: u }), h;
            }, m.prototype.getLabelSize = function() {
              return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }, m.prototype.getMarkPath = function(v, g, x, E, P, S) {
              return S.crispLine([["M", v, g], ["L", v + (P ? 0 : -x), g + (P ? x : 0)]], E);
            }, m.prototype.handleOverflow = function(v) {
              var g, x, E = this, P = this.axis, S = P.options.labels, u = v.x, y = P.chart.chartWidth, s = P.chart.spacing, a = d(P.labelLeft, Math.min(P.pos, s[3])), e = d(P.labelRight, Math.max(P.isRadial ? 0 : P.pos + P.len, y - s[1])), n = this.label, o = this.rotation, i = { left: 0, center: 0.5, right: 1 }[P.labelAlign || n.attr("align")], c = n.getBBox().width, l = P.getSlotWidth(E), h = i, C = {}, M = l, O = 1;
              o || S.overflow !== "justify" ? o < 0 && u - i * c < a ? x = Math.round(u / Math.cos(o * Y) - a) : o > 0 && u + i * c > e && (x = Math.round((y - u) / Math.cos(o * Y))) : (g = u + (1 - i) * c, u - i * c < a ? M = v.x + M * (1 - i) - a : g > e && (M = e - v.x + M * i, O = -1), (M = Math.min(l, M)) < l && P.labelAlign === "center" && (v.x += O * (l - M - h * (l - Math.min(c, M)))), (c > M || P.autoRotation && (n.styles || {}).width) && (x = M)), x && (E.shortenLabel ? E.shortenLabel() : (C.width = Math.floor(x) + "px", (S.style || {}).textOverflow || (C.textOverflow = "ellipsis"), n.css(C)));
            }, m.prototype.moveLabel = function(v, g) {
              var x, E, P, S = this, u = S.label, y = S.axis, s = y.reversed, a = !1;
              u && u.textStr === v ? (S.movedLabel = u, a = !0, delete S.label) : b(y.ticks, function(e) {
                a || e.isNew || e === S || !e.label || e.label.textStr !== v || (S.movedLabel = e.label, a = !0, e.labelPos = S.movedLabel.xy, delete e.label);
              }), a || !S.labelPos && !u || (x = S.labelPos || u.xy, E = y.horiz ? s ? 0 : y.width + y.left : x.x, P = y.horiz ? x.y : s ? y.width + y.left : 0, S.movedLabel = S.createLabel({ x: E, y: P }, v, g), S.movedLabel && S.movedLabel.attr({ opacity: 0 }));
            }, m.prototype.render = function(v, g, x) {
              var E = this, P = E.axis, S = P.horiz, u = E.pos, y = d(E.tickmarkOffset, P.tickmarkOffset), s = E.getPosition(S, u, y, g), a = s.x, e = s.y, n = S && a === P.pos + P.len || !S && e === P.pos ? -1 : 1, o = d(x, E.label && E.label.newOpacity, 1);
              x = d(x, 1), this.isActive = !0, this.renderGridLine(g, x, n), this.renderMark(s, x, n), this.renderLabel(s, g, o, v), E.isNew = !1, D(this, "afterRender");
            }, m.prototype.renderGridLine = function(v, g, x) {
              var E, P = this, S = P.axis, u = S.options, y = {}, s = P.pos, a = P.type, e = d(P.tickmarkOffset, S.tickmarkOffset), n = S.chart.renderer, o = P.gridLine, i = u.gridLineWidth, c = u.gridLineColor, l = u.gridLineDashStyle;
              P.type === "minor" && (i = u.minorGridLineWidth, c = u.minorGridLineColor, l = u.minorGridLineDashStyle), o || (S.chart.styledMode || (y.stroke = c, y["stroke-width"] = i || 0, y.dashstyle = l), a || (y.zIndex = 1), v && (g = 0), P.gridLine = o = n.path().attr(y).addClass("highcharts-" + (a ? a + "-" : "") + "grid-line").add(S.gridGroup)), o && (E = S.getPlotLinePath({ value: s + e, lineWidth: o.strokeWidth() * x, force: "pass", old: v, acrossPanes: !1 })) && o[v || P.isNew ? "attr" : "animate"]({ d: E, opacity: g });
            }, m.prototype.renderMark = function(v, g, x) {
              var E = this, P = E.axis, S = P.options, u = P.chart.renderer, y = E.type, s = P.tickSize(y ? y + "Tick" : "tick"), a = v.x, e = v.y, n = d(S[y !== "minor" ? "tickWidth" : "minorTickWidth"], !y && P.isXAxis ? 1 : 0), o = S[y !== "minor" ? "tickColor" : "minorTickColor"], i = E.mark, c = !i;
              s && (P.opposite && (s[0] = -s[0]), i || (E.mark = i = u.path().addClass("highcharts-" + (y ? y + "-" : "") + "tick").add(P.axisGroup), P.chart.styledMode || i.attr({ stroke: o, "stroke-width": n })), i[c ? "attr" : "animate"]({ d: E.getMarkPath(a, e, s[0], i.strokeWidth() * x, P.horiz, u), opacity: g }));
            }, m.prototype.renderLabel = function(v, g, x, E) {
              var P = this, S = P.axis, u = S.horiz, y = S.options, s = P.label, a = y.labels, e = a.step, n = d(P.tickmarkOffset, S.tickmarkOffset), o = v.x, i = v.y, c = !0;
              s && k(o) && (s.xy = v = P.getLabelPosition(o, i, s, u, a, n, E, e), P.isFirst && !P.isLast && !y.showFirstLabel || P.isLast && !P.isFirst && !y.showLastLabel ? c = !1 : !u || a.step || a.rotation || g || x === 0 || P.handleOverflow(v), e && E % e && (c = !1), c && k(v.y) ? (v.opacity = x, s[P.isNewLabel ? "attr" : "animate"](v).show(!0), P.isNewLabel = !1) : (s.hide(), P.isNewLabel = !0));
            }, m.prototype.replaceMovedLabel = function() {
              var v, g, x = this, E = x.label, P = x.axis, S = P.reversed;
              E && !x.isNew && (v = P.horiz ? S ? P.left : P.width + P.left : E.xy.x, g = P.horiz ? E.xy.y : S ? P.width + P.top : P.top, E.animate({ x: v, y: g, opacity: 0 }, void 0, E.destroy), delete x.label), P.isDirty = !0, x.label = x.movedLabel, delete x.movedLabel;
            }, m;
          }();
        }), at(_, "Core/Axis/Axis.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Axis/AxisDefaults.js"], _["Core/Color/Color.js"], _["Core/Defaults.js"], _["Core/Foundation.js"], _["Core/Globals.js"], _["Core/Axis/Tick.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N = G.animObject, D = Y.defaultOptions, k = J.registerEventOptions, A = Q.deg2rad, b = U.arrayMax, d = U.arrayMin, m = U.clamp, v = U.correctFloat, g = U.defined, x = U.destroyObjectProperties, E = U.erase, P = U.error, S = U.extend, u = U.fireEvent, y = U.isArray, s = U.isNumber, a = U.isString, e = U.merge, n = U.normalizeTickInterval, o = U.objectEach, i = U.pick, c = U.relativeLength, l = U.removeEvent, h = U.splat, C = U.syncTimeout, M = function(O, p) {
            return n(p, void 0, void 0, i(O.options.allowDecimals, p < 0.5 || O.tickAmount !== void 0), !!O.tickAmount);
          };
          return function() {
            function O(p, w) {
              this.alternateBands = void 0, this.bottom = void 0, this.chart = void 0, this.closestPointRange = void 0, this.coll = void 0, this.eventOptions = void 0, this.hasNames = void 0, this.hasVisibleSeries = void 0, this.height = void 0, this.isLinked = void 0, this.labelEdge = void 0, this.labelFormatter = void 0, this.left = void 0, this.len = void 0, this.max = void 0, this.maxLabelLength = void 0, this.min = void 0, this.minorTickInterval = void 0, this.minorTicks = void 0, this.minPixelPadding = void 0, this.names = void 0, this.offset = void 0, this.options = void 0, this.overlap = void 0, this.paddedTicks = void 0, this.plotLinesAndBands = void 0, this.plotLinesAndBandsGroups = void 0, this.pointRange = void 0, this.pointRangePadding = void 0, this.pos = void 0, this.positiveValuesOnly = void 0, this.right = void 0, this.series = void 0, this.side = void 0, this.tickAmount = void 0, this.tickInterval = void 0, this.tickmarkOffset = void 0, this.tickPositions = void 0, this.tickRotCorr = void 0, this.ticks = void 0, this.top = void 0, this.transA = void 0, this.transB = void 0, this.translationSlope = void 0, this.userOptions = void 0, this.visible = void 0, this.width = void 0, this.zoomEnabled = void 0, this.init(p, w);
            }
            return O.prototype.init = function(p, w) {
              var T = w.isX, z = this;
              z.chart = p, z.horiz = p.inverted && !z.isZAxis ? !T : T, z.isXAxis = T, z.coll = z.coll || (T ? "xAxis" : "yAxis"), u(this, "init", { userOptions: w }), z.opposite = i(w.opposite, z.opposite), z.side = i(w.side, z.side, z.horiz ? z.opposite ? 0 : 2 : z.opposite ? 1 : 3), z.setOptions(w);
              var W = this.options, L = W.labels, I = W.type;
              z.userOptions = w, z.minPixelPadding = 0, z.reversed = i(W.reversed, z.reversed), z.visible = W.visible, z.zoomEnabled = W.zoomEnabled, z.hasNames = I === "category" || W.categories === !0, z.categories = W.categories || (z.hasNames ? [] : void 0), z.names || (z.names = [], z.names.keys = {}), z.plotLinesAndBandsGroups = {}, z.positiveValuesOnly = !!z.logarithmic, z.isLinked = g(W.linkedTo), z.ticks = {}, z.labelEdge = [], z.minorTicks = {}, z.plotLinesAndBands = [], z.alternateBands = {}, z.len = 0, z.minRange = z.userMinRange = W.minRange || W.maxZoom, z.range = W.range, z.offset = W.offset || 0, z.max = null, z.min = null;
              var j = i(W.crosshair, h(p.options.tooltip.crosshairs)[T ? 0 : 1]);
              z.crosshair = j === !0 ? {} : j, p.axes.indexOf(z) === -1 && (T ? p.axes.splice(p.xAxis.length, 0, z) : p.axes.push(z), p[z.coll].push(z)), z.series = z.series || [], p.inverted && !z.isZAxis && T && z.reversed === void 0 && (z.reversed = !0), z.labelRotation = s(L.rotation) ? L.rotation : void 0, k(z, W), u(this, "afterInit");
            }, O.prototype.setOptions = function(p) {
              this.options = e(F.defaultXAxisOptions, this.coll === "yAxis" && F.defaultYAxisOptions, [F.defaultTopAxisOptions, F.defaultRightAxisOptions, F.defaultBottomAxisOptions, F.defaultLeftAxisOptions][this.side], e(D[this.coll], p)), u(this, "afterSetOptions", { userOptions: p });
            }, O.prototype.defaultLabelFormatter = function(p) {
              var w, T, z = this.axis, W = this.chart.numberFormatter, L = s(this.value) ? this.value : NaN, I = z.chart.time, j = z.categories, Z = this.dateTimeLabelFormat, V = D.lang, X = V.numericSymbols, et = V.numericSymbolMagnitude || 1e3, ot = z.logarithmic ? Math.abs(L) : z.tickInterval, it = X && X.length;
              if (j)
                T = "".concat(this.value);
              else if (Z)
                T = I.dateFormat(Z, L);
              else if (it && ot >= 1e3)
                for (; it-- && T === void 0; )
                  ot >= (w = Math.pow(et, it + 1)) && 10 * L % w == 0 && X[it] !== null && L !== 0 && (T = W(L / w, -1) + X[it]);
              return T === void 0 && (T = Math.abs(L) >= 1e4 ? W(L, -1) : W(L, -1, void 0, "")), T;
            }, O.prototype.getSeriesExtremes = function() {
              var p, w = this, T = w.chart;
              u(this, "getSeriesExtremes", null, function() {
                w.hasVisibleSeries = !1, w.dataMin = w.dataMax = w.threshold = null, w.softThreshold = !w.isXAxis, w.series.forEach(function(z) {
                  if (z.visible || !T.options.chart.ignoreHiddenSeries) {
                    var W = z.options, L = void 0, I = W.threshold, j = void 0, Z = void 0;
                    if (w.hasVisibleSeries = !0, w.positiveValuesOnly && I <= 0 && (I = null), w.isXAxis)
                      (L = z.xData).length && (L = w.logarithmic ? L.filter(w.validatePositiveValue) : L, j = (p = z.getXExtremes(L)).min, Z = p.max, s(j) || j instanceof Date || (L = L.filter(s), j = (p = z.getXExtremes(L)).min, Z = p.max), L.length && (w.dataMin = Math.min(i(w.dataMin, j), j), w.dataMax = Math.max(i(w.dataMax, Z), Z)));
                    else {
                      var V = z.applyExtremes();
                      s(V.dataMin) && (j = V.dataMin, w.dataMin = Math.min(i(w.dataMin, j), j)), s(V.dataMax) && (Z = V.dataMax, w.dataMax = Math.max(i(w.dataMax, Z), Z)), g(I) && (w.threshold = I), W.softThreshold && !w.positiveValuesOnly || (w.softThreshold = !1);
                    }
                  }
                });
              }), u(this, "afterGetSeriesExtremes");
            }, O.prototype.translate = function(p, w, T, z, W, L) {
              var I = this.linkedParent || this, j = z && I.old ? I.old.min : I.min;
              if (!s(j))
                return NaN;
              var Z = I.minPixelPadding, V = (I.isOrdinal || I.brokenAxis && I.brokenAxis.hasBreaks || I.logarithmic && W) && I.lin2val, X = 1, et = 0, ot = z && I.old ? I.old.transA : I.transA, it = 0;
              if (ot || (ot = I.transA), T && (X *= -1, et = I.len), I.reversed && (et -= (X *= -1) * (I.sector || I.len)), w)
                p = p * X + et, it = (p -= Z) / ot + j, V && (it = I.lin2val(it));
              else {
                V && (p = I.val2lin(p));
                var pt = X * (p - j) * ot;
                it = (I.isRadial ? pt : v(pt)) + et + X * Z + (s(L) ? ot * L : 0);
              }
              return it;
            }, O.prototype.toPixels = function(p, w) {
              return this.translate(p, !1, !this.horiz, void 0, !0) + (w ? 0 : this.pos);
            }, O.prototype.toValue = function(p, w) {
              return this.translate(p - (w ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }, O.prototype.getPlotLinePath = function(p) {
              var w, T, z, W, L, I = this, j = I.chart, Z = I.left, V = I.top, X = p.old, et = p.value, ot = p.lineWidth, it = X && j.oldChartHeight || j.chartHeight, pt = X && j.oldChartWidth || j.chartWidth, mt = I.transB, Ct = p.translatedValue, kt = p.force;
              function Lt(xt, ct, ft) {
                return kt !== "pass" && (xt < ct || xt > ft) && (kt ? xt = m(xt, ct, ft) : L = !0), xt;
              }
              var Tt = { value: et, lineWidth: ot, old: X, force: kt, acrossPanes: p.acrossPanes, translatedValue: Ct };
              return u(this, "getPlotLinePath", Tt, function(xt) {
                Ct = i(Ct, I.translate(et, void 0, void 0, X)), Ct = m(Ct, -1e5, 1e5), w = z = Math.round(Ct + mt), T = W = Math.round(it - Ct - mt), s(Ct) ? I.horiz ? (T = V, W = it - I.bottom, w = z = Lt(w, Z, Z + I.width)) : (w = Z, z = pt - I.right, T = W = Lt(T, V, V + I.height)) : (L = !0, kt = !1), xt.path = L && !kt ? null : j.renderer.crispLine([["M", w, T], ["L", z, W]], ot || 1);
              }), Tt.path;
            }, O.prototype.getLinearTickPositions = function(p, w, T) {
              var z, W, L, I = v(Math.floor(w / p) * p), j = v(Math.ceil(T / p) * p), Z = [];
              if (v(I + p) === I && (L = 20), this.single)
                return [w];
              for (z = I; z <= j && (Z.push(z), (z = v(z + p, L)) !== W); )
                W = z;
              return Z;
            }, O.prototype.getMinorTickInterval = function() {
              var p = this.options;
              return p.minorTicks === !0 ? i(p.minorTickInterval, "auto") : p.minorTicks === !1 ? null : p.minorTickInterval;
            }, O.prototype.getMinorTickPositions = function() {
              var p, w = this, T = w.options, z = w.tickPositions, W = w.minorTickInterval, L = w.pointRangePadding || 0, I = w.min - L, j = w.max + L, Z = j - I, V = [];
              if (Z && Z / W < w.len / 3) {
                var X = w.logarithmic;
                if (X)
                  this.paddedTicks.forEach(function(et, ot, it) {
                    ot && V.push.apply(V, X.getLogTickPositions(W, it[ot - 1], it[ot], !0));
                  });
                else if (w.dateTime && this.getMinorTickInterval() === "auto")
                  V = V.concat(w.getTimeTicks(w.dateTime.normalizeTimeTickInterval(W), I, j, T.startOfWeek));
                else
                  for (p = I + (z[0] - I) % W; p <= j && p !== V[0]; p += W)
                    V.push(p);
              }
              return V.length !== 0 && w.trimTicks(V), V;
            }, O.prototype.adjustForMinRange = function() {
              var p, w, T, z, W, L, I, j, Z, V = this, X = V.options, et = V.logarithmic, ot = V.min, it = V.max, pt = 0;
              V.isXAxis && V.minRange === void 0 && !et && (g(X.min) || g(X.max) || g(X.floor) || g(X.ceiling) ? V.minRange = null : (V.series.forEach(function(mt) {
                if (W = mt.xData, L = mt.xIncrement ? 1 : W.length - 1, W.length > 1)
                  for (T = L; T > 0; T--)
                    z = W[T] - W[T - 1], (!pt || z < pt) && (pt = z);
              }), V.minRange = Math.min(5 * pt, V.dataMax - V.dataMin))), it - ot < V.minRange && (w = V.dataMax - V.dataMin >= V.minRange, I = [ot - (p = ((Z = V.minRange) - it + ot) / 2), i(X.min, ot - p)], w && (I[2] = V.logarithmic ? V.logarithmic.log2lin(V.dataMin) : V.dataMin), j = [(ot = b(I)) + Z, i(X.max, ot + Z)], w && (j[2] = et ? et.log2lin(V.dataMax) : V.dataMax), (it = d(j)) - ot < Z && (I[0] = it - Z, I[1] = i(X.min, it - Z), ot = b(I))), V.min = ot, V.max = it;
            }, O.prototype.getClosest = function() {
              var p;
              return this.categories ? p = 1 : this.series.forEach(function(w) {
                var T = w.closestPointRange, z = w.visible || !w.chart.options.chart.ignoreHiddenSeries;
                !w.noSharedTooltip && g(T) && z && (p = g(p) ? Math.min(p, T) : T);
              }), p;
            }, O.prototype.nameToX = function(p) {
              var w, T = y(this.options.categories), z = T ? this.categories : this.names, W = p.options.x;
              return p.series.requireSorting = !1, g(W) || (W = this.options.uniqueNames && z ? T ? z.indexOf(p.name) : i(z.keys[p.name], -1) : p.series.autoIncrement()), W === -1 ? !T && z && (w = z.length) : w = W, w !== void 0 ? (this.names[w] = p.name, this.names.keys[p.name] = w) : p.x && (w = p.x), w;
            }, O.prototype.updateNames = function() {
              var p = this, w = this.names;
              w.length > 0 && (Object.keys(w.keys).forEach(function(T) {
                delete w.keys[T];
              }), w.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function(T) {
                T.xIncrement = null, T.points && !T.isDirtyData || (p.max = Math.max(p.max, T.xData.length - 1), T.processData(), T.generatePoints()), T.data.forEach(function(z, W) {
                  var L;
                  z && z.options && z.name !== void 0 && (L = p.nameToX(z)) !== void 0 && L !== z.x && (z.x = L, T.xData[W] = L);
                });
              }));
            }, O.prototype.setAxisTranslation = function() {
              var p, w, T = this, z = T.max - T.min, W = T.linkedParent, L = !!T.categories, I = T.isXAxis, j = T.axisPointRange || 0, Z = 0, V = 0, X = T.transA;
              (I || L || j) && (p = T.getClosest(), W ? (Z = W.minPointOffset, V = W.pointRangePadding) : T.series.forEach(function(et) {
                var ot = L ? 1 : I ? i(et.options.pointRange, p, 0) : T.axisPointRange || 0, it = et.options.pointPlacement;
                if (j = Math.max(j, ot), !T.single || L) {
                  var pt = et.is("xrange") ? !I : I;
                  Z = Math.max(Z, pt && a(it) ? 0 : ot / 2), V = Math.max(V, pt && it === "on" ? 0 : ot);
                }
              }), w = T.ordinal && T.ordinal.slope && p ? T.ordinal.slope / p : 1, T.minPointOffset = Z *= w, T.pointRangePadding = V *= w, T.pointRange = Math.min(j, T.single && L ? 1 : z), I && (T.closestPointRange = p)), T.translationSlope = T.transA = X = T.staticScale || T.len / (z + V || 1), T.transB = T.horiz ? T.left : T.bottom, T.minPixelPadding = X * Z, u(this, "afterSetAxisTranslation");
            }, O.prototype.minFromRange = function() {
              return this.max - this.range;
            }, O.prototype.setTickInterval = function(p) {
              var w, T, z, W, L, I, j = this, Z = j.chart, V = j.logarithmic, X = j.options, et = j.isXAxis, ot = j.isLinked, it = X.tickPixelInterval, pt = j.categories, mt = j.softThreshold, Ct = X.maxPadding, kt = X.minPadding, Lt = s(X.tickInterval) && X.tickInterval >= 0 ? X.tickInterval : void 0, Tt = s(j.threshold) ? j.threshold : null;
              if (j.dateTime || pt || ot || this.getTickAmount(), L = i(j.userMin, X.min), I = i(j.userMax, X.max), ot ? (j.linkedParent = Z[j.coll][X.linkedTo], T = j.linkedParent.getExtremes(), j.min = i(T.min, T.dataMin), j.max = i(T.max, T.dataMax), X.type !== j.linkedParent.options.type && P(11, 1, Z)) : (mt && g(Tt) && (j.dataMin >= Tt ? (z = Tt, kt = 0) : j.dataMax <= Tt && (W = Tt, Ct = 0)), j.min = i(L, z, j.dataMin), j.max = i(I, W, j.dataMax)), V && (j.positiveValuesOnly && !p && Math.min(j.min, i(j.dataMin, j.min)) <= 0 && P(10, 1, Z), j.min = v(V.log2lin(j.min), 16), j.max = v(V.log2lin(j.max), 16)), j.range && g(j.max) && (j.userMin = j.min = L = Math.max(j.dataMin, j.minFromRange()), j.userMax = I = j.max, j.range = null), u(j, "foundExtremes"), j.beforePadding && j.beforePadding(), j.adjustForMinRange(), pt || j.axisPointRange || j.stacking && j.stacking.usePercentage || ot || !g(j.min) || !g(j.max) || (w = j.max - j.min) && (!g(L) && kt && (j.min -= w * kt), !g(I) && Ct && (j.max += w * Ct)), s(j.userMin) || (s(X.softMin) && X.softMin < j.min && (j.min = L = X.softMin), s(X.floor) && (j.min = Math.max(j.min, X.floor))), s(j.userMax) || (s(X.softMax) && X.softMax > j.max && (j.max = I = X.softMax), s(X.ceiling) && (j.max = Math.min(j.max, X.ceiling))), mt && g(j.dataMin) && (Tt = Tt || 0, !g(L) && j.min < Tt && j.dataMin >= Tt ? j.min = j.options.minRange ? Math.min(Tt, j.max - j.minRange) : Tt : !g(I) && j.max > Tt && j.dataMax <= Tt && (j.max = j.options.minRange ? Math.max(Tt, j.min + j.minRange) : Tt)), s(j.min) && s(j.max) && !this.chart.polar && j.min > j.max && (g(j.options.min) ? j.max = j.min : g(j.options.max) && (j.min = j.max)), j.min === j.max || j.min === void 0 || j.max === void 0 ? j.tickInterval = 1 : ot && j.linkedParent && !Lt && it === j.linkedParent.options.tickPixelInterval ? j.tickInterval = Lt = j.linkedParent.tickInterval : j.tickInterval = i(Lt, this.tickAmount ? (j.max - j.min) / Math.max(this.tickAmount - 1, 1) : void 0, pt ? 1 : (j.max - j.min) * it / Math.max(j.len, it)), et && !p) {
                var xt = j.min !== (j.old && j.old.min) || j.max !== (j.old && j.old.max);
                j.series.forEach(function(ft) {
                  ft.forceCrop = ft.forceCropping && ft.forceCropping(), ft.processData(xt);
                }), u(this, "postProcessData", { hasExtremesChanged: xt });
              }
              j.setAxisTranslation(), u(this, "initialAxisTranslation"), j.pointRange && !Lt && (j.tickInterval = Math.max(j.pointRange, j.tickInterval));
              var ct = i(X.minTickInterval, j.dateTime && !j.series.some(function(ft) {
                return ft.noSharedTooltip;
              }) ? j.closestPointRange : 0);
              !Lt && j.tickInterval < ct && (j.tickInterval = ct), j.dateTime || j.logarithmic || Lt || (j.tickInterval = M(j, j.tickInterval)), this.tickAmount || (j.tickInterval = j.unsquish()), this.setTickPositions();
            }, O.prototype.setTickPositions = function() {
              var p, w = this, T = this.options, z = T.tickPositions, W = T.tickPositioner, L = this.getMinorTickInterval(), I = this.hasVerticalPanning(), j = this.coll === "colorAxis", Z = (j || !I) && T.startOnTick, V = (j || !I) && T.endOnTick, X = [];
              if (this.tickmarkOffset = this.categories && T.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.minorTickInterval = L === "auto" && this.tickInterval ? this.tickInterval / 5 : L, this.single = this.min === this.max && g(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || T.allowDecimals !== !1), z)
                X = z.slice();
              else if (s(this.min) && s(this.max)) {
                if (w.ordinal && w.ordinal.positions || !((this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)))
                  if (w.dateTime)
                    X = w.getTimeTicks(w.dateTime.normalizeTimeTickInterval(this.tickInterval, T.units), this.min, this.max, T.startOfWeek, w.ordinal && w.ordinal.positions, this.closestPointRange, !0);
                  else if (w.logarithmic)
                    X = w.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                  else
                    for (var et = this.tickInterval, ot = et; ot <= 2 * et && (X = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && X.length > this.tickAmount); )
                      this.tickInterval = M(this, ot *= 1.1);
                else
                  X = [this.min, this.max], P(19, !1, this.chart);
                X.length > this.len && (X = [X[0], X[X.length - 1]])[0] === X[1] && (X.length = 1), W && (this.tickPositions = X, (p = W.apply(w, [this.min, this.max])) && (X = p));
              }
              this.tickPositions = X, this.paddedTicks = X.slice(0), this.trimTicks(X, Z, V), !this.isLinked && s(this.min) && s(this.max) && (this.single && X.length < 2 && !this.categories && !this.series.some(function(it) {
                return it.is("heatmap") && it.options.pointPlacement === "between";
              }) && (this.min -= 0.5, this.max += 0.5), z || p || this.adjustTickAmount()), u(this, "afterSetTickPositions");
            }, O.prototype.trimTicks = function(p, w, T) {
              var z = p[0], W = p[p.length - 1], L = !this.isOrdinal && this.minPointOffset || 0;
              if (u(this, "trimTicks"), !this.isLinked) {
                if (w && z !== -1 / 0)
                  this.min = z;
                else
                  for (; this.min - L > p[0]; )
                    p.shift();
                if (T)
                  this.max = W;
                else
                  for (; this.max + L < p[p.length - 1]; )
                    p.pop();
                p.length === 0 && g(z) && !this.options.tickPositions && p.push((W + z) / 2);
              }
            }, O.prototype.alignToOthers = function() {
              var p, w = this, T = [this], z = w.options, W = this.coll === "yAxis" && this.chart.options.chart.alignThresholds, L = [];
              if (w.thresholdAlignment = void 0, (this.chart.options.chart.alignTicks !== !1 && z.alignTicks || W) && z.startOnTick !== !1 && z.endOnTick !== !1 && !w.logarithmic) {
                var I = function(V) {
                  var X = V.horiz, et = V.options;
                  return [X ? et.left : et.top, et.width, et.height, et.pane].join(",");
                }, j = I(this);
                this.chart[this.coll].forEach(function(V) {
                  var X = V.series;
                  X.length && X.some(function(et) {
                    return et.visible;
                  }) && V !== w && I(V) === j && (p = !0, T.push(V));
                });
              }
              if (p && W) {
                T.forEach(function(V) {
                  var X = V.getThresholdAlignment(w);
                  s(X) && L.push(X);
                });
                var Z = L.length > 1 ? L.reduce(function(V, X) {
                  return V + X;
                }, 0) / L.length : void 0;
                T.forEach(function(V) {
                  V.thresholdAlignment = Z;
                });
              }
              return p;
            }, O.prototype.getThresholdAlignment = function(p) {
              if ((!s(this.dataMin) || this !== p && this.series.some(function(T) {
                return T.isDirty || T.isDirtyData;
              })) && this.getSeriesExtremes(), s(this.threshold)) {
                var w = m((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
                return this.options.reversed && (w = 1 - w), w;
              }
            }, O.prototype.getTickAmount = function() {
              var p = this.options, w = p.tickPixelInterval, T = p.tickAmount;
              !g(p.tickInterval) && !T && this.len < w && !this.isRadial && !this.logarithmic && p.startOnTick && p.endOnTick && (T = 2), !T && this.alignToOthers() && (T = Math.ceil(this.len / w) + 1), T < 4 && (this.finalTickAmt = T, T = 5), this.tickAmount = T;
            }, O.prototype.adjustTickAmount = function() {
              var p, w, T, z = this, W = z.finalTickAmt, L = z.max, I = z.min, j = z.options, Z = z.tickPositions, V = z.tickAmount, X = z.thresholdAlignment, et = Z && Z.length, ot = i(z.threshold, z.softThreshold ? 0 : null), it = z.tickInterval, pt = function() {
                return Z.push(v(Z[Z.length - 1] + it));
              }, mt = function() {
                return Z.unshift(v(Z[0] - it));
              };
              if (s(X) && (T = X < 0.5 ? Math.ceil(X * (V - 1)) : Math.floor(X * (V - 1)), j.reversed && (T = V - 1 - T)), z.hasData() && s(I) && s(L)) {
                var Ct = function() {
                  z.transA *= (et - 1) / (V - 1), z.min = j.startOnTick ? Z[0] : Math.min(I, Z[0]), z.max = j.endOnTick ? Z[Z.length - 1] : Math.max(L, Z[Z.length - 1]);
                };
                if (s(T) && s(z.threshold)) {
                  for (; Z[T] !== ot || Z.length !== V || Z[0] > I || Z[Z.length - 1] < L; ) {
                    for (Z.length = 0, Z.push(z.threshold); Z.length < V; )
                      Z[T] === void 0 || Z[T] > z.threshold ? mt() : pt();
                    if (it > 8 * z.tickInterval)
                      break;
                    it *= 2;
                  }
                  Ct();
                } else if (et < V) {
                  for (; Z.length < V; )
                    Z.length % 2 || I === ot ? pt() : mt();
                  Ct();
                }
                if (g(W)) {
                  for (w = p = Z.length; w--; )
                    (W === 3 && w % 2 == 1 || W <= 2 && w > 0 && w < p - 1) && Z.splice(w, 1);
                  z.finalTickAmt = void 0;
                }
              }
            }, O.prototype.setScale = function() {
              var p = this, w = !1, T = !1;
              p.series.forEach(function(W) {
                w = w || W.isDirtyData || W.isDirty, T = T || W.xAxis && W.xAxis.isDirty || !1;
              }), p.setAxisSize();
              var z = p.len !== (p.old && p.old.len);
              z || w || T || p.isLinked || p.forceRedraw || p.userMin !== (p.old && p.old.userMin) || p.userMax !== (p.old && p.old.userMax) || p.alignToOthers() ? (p.stacking && (p.stacking.resetStacks(), p.stacking.buildStacks()), p.forceRedraw = !1, p.getSeriesExtremes(), p.setTickInterval(), p.isDirty || (p.isDirty = z || p.min !== (p.old && p.old.min) || p.max !== (p.old && p.old.max))) : p.stacking && p.stacking.cleanStacks(), w && p.panningState && (p.panningState.isDirty = !0), u(this, "afterSetScale");
            }, O.prototype.setExtremes = function(p, w, T, z, W) {
              var L = this, I = L.chart;
              T = i(T, !0), L.series.forEach(function(j) {
                delete j.kdTree;
              }), W = S(W, { min: p, max: w }), u(L, "setExtremes", W, function() {
                L.userMin = p, L.userMax = w, L.eventArgs = W, T && I.redraw(z);
              });
            }, O.prototype.zoom = function(p, w) {
              var T = this, z = this.dataMin, W = this.dataMax, L = this.options, I = Math.min(z, i(L.min, z)), j = Math.max(W, i(L.max, W)), Z = { newMin: p, newMax: w };
              return u(this, "zoom", Z, function(V) {
                var X = V.newMin, et = V.newMax;
                X === T.min && et === T.max || (T.allowZoomOutside || (g(z) && (X < I && (X = I), X > j && (X = j)), g(W) && (et < I && (et = I), et > j && (et = j))), T.displayBtn = X !== void 0 || et !== void 0, T.setExtremes(X, et, !1, void 0, { trigger: "zoom" })), V.zoomed = !0;
              }), Z.zoomed;
            }, O.prototype.setAxisSize = function() {
              var p = this.chart, w = this.options, T = w.offsets || [0, 0, 0, 0], z = this.horiz, W = this.width = Math.round(c(i(w.width, p.plotWidth - T[3] + T[1]), p.plotWidth)), L = this.height = Math.round(c(i(w.height, p.plotHeight - T[0] + T[2]), p.plotHeight)), I = this.top = Math.round(c(i(w.top, p.plotTop + T[0]), p.plotHeight, p.plotTop)), j = this.left = Math.round(c(i(w.left, p.plotLeft + T[3]), p.plotWidth, p.plotLeft));
              this.bottom = p.chartHeight - L - I, this.right = p.chartWidth - W - j, this.len = Math.max(z ? W : L, 0), this.pos = z ? j : I;
            }, O.prototype.getExtremes = function() {
              var p = this, w = p.logarithmic;
              return { min: w ? v(w.lin2log(p.min)) : p.min, max: w ? v(w.lin2log(p.max)) : p.max, dataMin: p.dataMin, dataMax: p.dataMax, userMin: p.userMin, userMax: p.userMax };
            }, O.prototype.getThreshold = function(p) {
              var w = this, T = w.logarithmic, z = T ? T.lin2log(w.min) : w.min, W = T ? T.lin2log(w.max) : w.max;
              return p === null || p === -1 / 0 ? p = z : p === 1 / 0 ? p = W : z > p ? p = z : W < p && (p = W), w.translate(p, 0, 1, 0, 1);
            }, O.prototype.autoLabelAlign = function(p) {
              var w = (i(p, 0) - 90 * this.side + 720) % 360, T = { align: "center" };
              return u(this, "autoLabelAlign", T, function(z) {
                w > 15 && w < 165 ? z.align = "right" : w > 195 && w < 345 && (z.align = "left");
              }), T.align;
            }, O.prototype.tickSize = function(p) {
              var w, T = this.options, z = i(T[p === "tick" ? "tickWidth" : "minorTickWidth"], p === "tick" && this.isXAxis && !this.categories ? 1 : 0), W = T[p === "tick" ? "tickLength" : "minorTickLength"];
              z && W && (T[p + "Position"] === "inside" && (W = -W), w = [W, z]);
              var L = { tickSize: w };
              return u(this, "afterTickSize", L), L.tickSize;
            }, O.prototype.labelMetrics = function() {
              var p = this.tickPositions && this.tickPositions[0] || 0;
              return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize, this.ticks[p] && this.ticks[p].label);
            }, O.prototype.unsquish = function() {
              var p, w, T = this.options.labels, z = this.horiz, W = this.tickInterval, L = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / W), I = T.rotation, j = this.labelMetrics(), Z = Math.max(this.max - this.min, 0), V = function(kt) {
                var Lt = kt / (L || 1);
                return (Lt = Lt > 1 ? Math.ceil(Lt) : 1) * W > Z && kt !== 1 / 0 && L !== 1 / 0 && Z && (Lt = Math.ceil(Z / W)), v(Lt * W);
              }, X = W, et = Number.MAX_VALUE;
              if (z) {
                if (T.staggerLines || (s(I) ? w = [I] : L < T.autoRotationLimit && (w = T.autoRotation)), w)
                  for (var ot = void 0, it = void 0, pt = 0, mt = w; pt < mt.length; pt++) {
                    var Ct = mt[pt];
                    (Ct === I || Ct && Ct >= -90 && Ct <= 90) && (it = (ot = V(Math.abs(j.h / Math.sin(A * Ct)))) + Math.abs(Ct / 360)) < et && (et = it, p = Ct, X = ot);
                  }
              } else
                X = V(j.h);
              return this.autoRotation = w, this.labelRotation = i(p, s(I) ? I : 0), T.step ? W : X;
            }, O.prototype.getSlotWidth = function(p) {
              var w = this.chart, T = this.horiz, z = this.options.labels, W = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), L = w.margin[3];
              if (p && s(p.slotWidth))
                return p.slotWidth;
              if (T && z.step < 2)
                return z.rotation ? 0 : (this.staggerLines || 1) * this.len / W;
              if (!T) {
                var I = z.style.width;
                if (I !== void 0)
                  return parseInt(String(I), 10);
                if (L)
                  return L - w.spacing[3];
              }
              return 0.33 * w.chartWidth;
            }, O.prototype.renderUnsquish = function() {
              var p, w, T, z, W, L = this.chart, I = L.renderer, j = this.tickPositions, Z = this.ticks, V = this.options.labels, X = V.style, et = this.horiz, ot = this.getSlotWidth(), it = Math.max(1, Math.round(ot - 2 * V.padding)), pt = {}, mt = this.labelMetrics(), Ct = X.textOverflow, kt = 0;
              if (a(V.rotation) || (pt.rotation = V.rotation || 0), j.forEach(function(Lt) {
                var Tt = Z[Lt];
                Tt.movedLabel && Tt.replaceMovedLabel(), Tt && Tt.label && Tt.label.textPxLength > kt && (kt = Tt.label.textPxLength);
              }), this.maxLabelLength = kt, this.autoRotation)
                kt > it && kt > mt.h ? pt.rotation = this.labelRotation : this.labelRotation = 0;
              else if (ot && (p = it, !Ct))
                for (w = "clip", z = j.length; !et && z--; )
                  W = j[z], (T = Z[W].label) && (T.styles && T.styles.textOverflow === "ellipsis" ? T.css({ textOverflow: "clip" }) : T.textPxLength > ot && T.css({ width: ot + "px" }), T.getBBox().height > this.len / j.length - (mt.h - mt.f) && (T.specificTextOverflow = "ellipsis"));
              pt.rotation && (p = kt > 0.5 * L.chartHeight ? 0.33 * L.chartHeight : kt, Ct || (w = "ellipsis")), this.labelAlign = V.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (pt.align = this.labelAlign), j.forEach(function(Lt) {
                var Tt = Z[Lt], xt = Tt && Tt.label, ct = X.width, ft = {};
                xt && (xt.attr(pt), Tt.shortenLabel ? Tt.shortenLabel() : p && !ct && X.whiteSpace !== "nowrap" && (p < xt.textPxLength || xt.element.tagName === "SPAN") ? (ft.width = p + "px", Ct || (ft.textOverflow = xt.specificTextOverflow || w), xt.css(ft)) : xt.styles && xt.styles.width && !ft.width && !ct && xt.css({ width: null }), delete xt.specificTextOverflow, Tt.rotation = pt.rotation);
              }, this), this.tickRotCorr = I.rotCorr(mt.b, this.labelRotation || 0, this.side !== 0);
            }, O.prototype.hasData = function() {
              return this.series.some(function(p) {
                return p.hasData();
              }) || this.options.showEmpty && g(this.min) && g(this.max);
            }, O.prototype.addTitle = function(p) {
              var w, T = this, z = T.chart.renderer, W = T.horiz, L = T.opposite, I = T.options.title, j = T.chart.styledMode;
              T.axisTitle || ((w = I.textAlign) || (w = (W ? { low: "left", middle: "center", high: "right" } : { low: L ? "right" : "left", middle: "center", high: L ? "left" : "right" })[I.align]), T.axisTitle = z.text(I.text || "", 0, 0, I.useHTML).attr({ zIndex: 7, rotation: I.rotation, align: w }).addClass("highcharts-axis-title"), j || T.axisTitle.css(e(I.style)), T.axisTitle.add(T.axisGroup), T.axisTitle.isNew = !0), j || I.style.width || T.isRadial || T.axisTitle.css({ width: T.len + "px" }), T.axisTitle[p ? "show" : "hide"](p);
            }, O.prototype.generateTick = function(p) {
              var w = this.ticks;
              w[p] ? w[p].addLabel() : w[p] = new q(this, p);
            }, O.prototype.getOffset = function() {
              var p, w, T, z, W = this, L = this, I = L.chart, j = L.horiz, Z = L.options, V = L.side, X = L.ticks, et = L.tickPositions, ot = L.coll, it = L.axisParent, pt = I.renderer, mt = I.inverted && !L.isZAxis ? [1, 0, 3, 2][V] : V, Ct = L.hasData(), kt = Z.title, Lt = Z.labels, Tt = I.axisOffset, xt = I.clipOffset, ct = [-1, 1, 1, -1][V], ft = Z.className, St = 0, Mt = 0, Dt = 0;
              if (L.showAxis = p = Ct || Z.showEmpty, L.staggerLines = L.horiz && Lt.staggerLines || void 0, !L.axisGroup) {
                var Ot = function(zt, Ht, Kt) {
                  return pt.g(zt).attr({ zIndex: Kt }).addClass("highcharts-".concat(ot.toLowerCase()).concat(Ht, " ") + (W.isRadial ? "highcharts-radial-axis".concat(Ht, " ") : "") + (ft || "")).add(it);
                };
                L.gridGroup = Ot("grid", "-grid", Z.gridZIndex), L.axisGroup = Ot("axis", "", Z.zIndex), L.labelGroup = Ot("axis-labels", "-labels", Lt.zIndex);
              }
              if (Ct || L.isLinked ? (et.forEach(function(zt) {
                L.generateTick(zt);
              }), L.renderUnsquish(), L.reserveSpaceDefault = V === 0 || V === 2 || { 1: "left", 3: "right" }[V] === L.labelAlign, i(Lt.reserveSpace, L.labelAlign === "center" || null, L.reserveSpaceDefault) && et.forEach(function(zt) {
                Dt = Math.max(X[zt].getLabelSize(), Dt);
              }), L.staggerLines && (Dt *= L.staggerLines), L.labelOffset = Dt * (L.opposite ? -1 : 1)) : o(X, function(zt, Ht) {
                zt.destroy(), delete X[Ht];
              }), kt && kt.text && kt.enabled !== !1 && (L.addTitle(p), p && kt.reserveSpace !== !1 && (L.titleOffset = St = L.axisTitle.getBBox()[j ? "height" : "width"], w = kt.offset, Mt = g(w) ? 0 : i(kt.margin, j ? 5 : 10))), L.renderLine(), L.offset = ct * i(Z.offset, Tt[V] ? Tt[V] + (Z.margin || 0) : 0), L.tickRotCorr = L.tickRotCorr || { x: 0, y: 0 }, z = V === 0 ? -L.labelMetrics().h : V === 2 ? L.tickRotCorr.y : 0, T = Math.abs(Dt) + Mt, Dt && (T -= z, T += ct * (j ? i(Lt.y, L.tickRotCorr.y + 8 * ct) : Lt.x)), L.axisTitleMargin = i(w, T), L.getMaxLabelDimensions && (L.maxLabelDimensions = L.getMaxLabelDimensions(X, et)), ot !== "colorAxis") {
                var Nt = this.tickSize("tick");
                Tt[V] = Math.max(Tt[V], (L.axisTitleMargin || 0) + St + ct * L.offset, T, et && et.length && Nt ? Nt[0] + ct * L.offset : 0);
                var Wt = !L.axisLine || Z.offset ? 0 : 2 * Math.floor(L.axisLine.strokeWidth() / 2);
                xt[mt] = Math.max(xt[mt], Wt);
              }
              u(this, "afterGetOffset");
            }, O.prototype.getLinePath = function(p) {
              var w = this.chart, T = this.opposite, z = this.offset, W = this.horiz, L = this.left + (T ? this.width : 0) + z, I = w.chartHeight - this.bottom - (T ? this.height : 0) + z;
              return T && (p *= -1), w.renderer.crispLine([["M", W ? this.left : L, W ? I : this.top], ["L", W ? w.chartWidth - this.right : L, W ? I : w.chartHeight - this.bottom]], p);
            }, O.prototype.renderLine = function() {
              this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
            }, O.prototype.getTitlePosition = function() {
              var p = this.horiz, w = this.left, T = this.top, z = this.len, W = this.options.title, L = p ? w : T, I = this.opposite, j = this.offset, Z = W.x, V = W.y, X = this.axisTitle, et = this.chart.renderer.fontMetrics(W.style.fontSize, X), ot = X ? Math.max(X.getBBox(!1, 0).height - et.h - 1, 0) : 0, it = { low: L + (p ? 0 : z), middle: L + z / 2, high: L + (p ? z : 0) }[W.align], pt = (p ? T + this.height : w) + (p ? 1 : -1) * (I ? -1 : 1) * (this.axisTitleMargin || 0) + [-ot, ot, et.f, -ot][this.side], mt = { x: p ? it + Z : pt + (I ? this.width : 0) + j + Z, y: p ? pt + V - (I ? this.height : 0) + j : it + V };
              return u(this, "afterGetTitlePosition", { titlePosition: mt }), mt;
            }, O.prototype.renderMinorTick = function(p, w) {
              var T = this.minorTicks;
              T[p] || (T[p] = new q(this, p, "minor")), w && T[p].isNew && T[p].render(null, !0), T[p].render(null, !1, 1);
            }, O.prototype.renderTick = function(p, w, T) {
              var z = this, W = z.isLinked, L = z.ticks;
              (!W || p >= z.min && p <= z.max || z.grid && z.grid.isColumn) && (L[p] || (L[p] = new q(z, p)), T && L[p].isNew && L[p].render(w, !0, -1), L[p].render(w));
            }, O.prototype.render = function() {
              var p, w, T = this, z = T.chart, W = T.logarithmic, L = z.renderer, I = T.options, j = T.isLinked, Z = T.tickPositions, V = T.axisTitle, X = T.ticks, et = T.minorTicks, ot = T.alternateBands, it = I.stackLabels, pt = I.alternateGridColor, mt = T.tickmarkOffset, Ct = T.axisLine, kt = T.showAxis, Lt = N(L.globalAnimation);
              if (T.labelEdge.length = 0, T.overlap = !1, [X, et, ot].forEach(function(ct) {
                o(ct, function(ft) {
                  ft.isActive = !1;
                });
              }), T.hasData() || j) {
                var Tt = T.chart.hasRendered && T.old && s(T.old.min);
                T.minorTickInterval && !T.categories && T.getMinorTickPositions().forEach(function(ct) {
                  T.renderMinorTick(ct, Tt);
                }), Z.length && (Z.forEach(function(ct, ft) {
                  T.renderTick(ct, ft, Tt);
                }), mt && (T.min === 0 || T.single) && (X[-1] || (X[-1] = new q(T, -1, null, !0)), X[-1].render(-1))), pt && Z.forEach(function(ct, ft) {
                  w = Z[ft + 1] !== void 0 ? Z[ft + 1] + mt : T.max - mt, ft % 2 == 0 && ct < T.max && w <= T.max + (z.polar ? -mt : mt) && (ot[ct] || (ot[ct] = new Q.PlotLineOrBand(T)), p = ct + mt, ot[ct].options = { from: W ? W.lin2log(p) : p, to: W ? W.lin2log(w) : w, color: pt, className: "highcharts-alternate-grid" }, ot[ct].render(), ot[ct].isActive = !0);
                }), T._addedPlotLB || (T._addedPlotLB = !0, (I.plotLines || []).concat(I.plotBands || []).forEach(function(ct) {
                  T.addPlotBandOrLine(ct);
                }));
              }
              if ([X, et, ot].forEach(function(ct) {
                var ft = [], St = Lt.duration;
                o(ct, function(Mt, Dt) {
                  Mt.isActive || (Mt.render(Dt, !1, 0), Mt.isActive = !1, ft.push(Dt));
                }), C(function() {
                  for (var Mt = ft.length; Mt--; )
                    ct[ft[Mt]] && !ct[ft[Mt]].isActive && (ct[ft[Mt]].destroy(), delete ct[ft[Mt]]);
                }, ct !== ot && z.hasRendered && St ? St : 0);
              }), Ct && (Ct[Ct.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(Ct.strokeWidth()) }), Ct.isPlaced = !0, Ct[kt ? "show" : "hide"](kt)), V && kt) {
                var xt = T.getTitlePosition();
                V[V.isNew ? "attr" : "animate"](xt), V.isNew = !1;
              }
              it && it.enabled && T.stacking && T.stacking.renderStackTotals(), T.old = { len: T.len, max: T.max, min: T.min, transA: T.transA, userMax: T.userMax, userMin: T.userMin }, T.isDirty = !1, u(this, "afterRender");
            }, O.prototype.redraw = function() {
              this.visible && (this.render(), this.plotLinesAndBands.forEach(function(p) {
                p.render();
              })), this.series.forEach(function(p) {
                p.isDirty = !0;
              });
            }, O.prototype.getKeepProps = function() {
              return this.keepProps || O.keepProps;
            }, O.prototype.destroy = function(p) {
              var w = this, T = w.plotLinesAndBands, z = this.eventOptions;
              if (u(this, "destroy", { keepEvents: p }), p || l(w), [w.ticks, w.minorTicks, w.alternateBands].forEach(function(I) {
                x(I);
              }), T)
                for (var W = T.length; W--; )
                  T[W].destroy();
              for (var L in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(I) {
                w[I] && (w[I] = w[I].destroy());
              }), w.plotLinesAndBandsGroups)
                w.plotLinesAndBandsGroups[L] = w.plotLinesAndBandsGroups[L].destroy();
              o(w, function(I, j) {
                w.getKeepProps().indexOf(j) === -1 && delete w[j];
              }), this.eventOptions = z;
            }, O.prototype.drawCrosshair = function(p, w) {
              var T, z, W, L, I = this.crosshair, j = i(I && I.snap, !0), Z = this.chart, V = this.cross;
              if (u(this, "drawCrosshair", { e: p, point: w }), p || (p = this.cross && this.cross.e), I && (g(w) || !j) !== !1) {
                if (j ? g(w) && (z = i(this.coll !== "colorAxis" ? w.crosshairPos : null, this.isXAxis ? w.plotX : this.len - w.plotY)) : z = p && (this.horiz ? p.chartX - this.pos : this.len - p.chartY + this.pos), g(z) && (L = { value: w && (this.isXAxis ? w.x : i(w.stackY, w.y)), translatedValue: z }, Z.polar && S(L, { isCrosshair: !0, chartX: p && p.chartX, chartY: p && p.chartY, point: w }), T = this.getPlotLinePath(L) || null), !g(T))
                  return void this.hideCrosshair();
                W = this.categories && !this.isRadial, V || (this.cross = V = Z.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (W ? "category " : "thin ") + (I.className || "")).attr({ zIndex: i(I.zIndex, 2) }).add(), Z.styledMode || (V.attr({ stroke: I.color || (W ? $.parse("#ccd6eb").setOpacity(0.25).get() : "#cccccc"), "stroke-width": i(I.width, 1) }).css({ "pointer-events": "none" }), I.dashStyle && V.attr({ dashstyle: I.dashStyle }))), V.show().attr({ d: T }), W && !I.width && V.attr({ "stroke-width": this.transA }), this.cross.e = p;
              } else
                this.hideCrosshair();
              u(this, "afterDrawCrosshair", { e: p, point: w });
            }, O.prototype.hideCrosshair = function() {
              this.cross && this.cross.hide(), u(this, "afterHideCrosshair");
            }, O.prototype.hasVerticalPanning = function() {
              var p = this.chart.options.chart.panning;
              return !!(p && p.enabled && /y/.test(p.type));
            }, O.prototype.validatePositiveValue = function(p) {
              return s(p) && p > 0;
            }, O.prototype.update = function(p, w) {
              var T = this.chart;
              p = e(this.userOptions, p), this.destroy(!0), this.init(T, p), T.isDirtyBox = !0, i(w, !0) && T.redraw();
            }, O.prototype.remove = function(p) {
              for (var w = this.chart, T = this.coll, z = this.series, W = z.length; W--; )
                z[W] && z[W].remove(!1);
              E(w.axes, this), E(w[T], this), w[T].forEach(function(L, I) {
                L.options.index = L.userOptions.index = I;
              }), this.destroy(), w.isDirtyBox = !0, i(p, !0) && w.redraw();
            }, O.prototype.setTitle = function(p, w) {
              this.update({ title: p }, w);
            }, O.prototype.setCategories = function(p, w) {
              this.update({ categories: p }, w);
            }, O.defaultOptions = F.defaultXAxisOptions, O.keepProps = ["extKey", "hcEvents", "names", "series", "userMax", "userMin"], O;
          }();
        }), at(_, "Core/Axis/DateTimeAxis.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.addEvent, Y = G.getMagnitude, J = G.normalizeTickInterval, Q = G.timeUnits;
          return function(q) {
            var U = [];
            function N() {
              return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function D(A) {
              var b = this;
              A.userOptions.type === "datetime" ? b.dateTime || (b.dateTime = new k(b)) : b.dateTime = void 0;
            }
            q.compose = function(A) {
              return U.indexOf(A) === -1 && (U.push(A), A.keepProps.push("dateTime"), A.prototype.getTimeTicks = N, $(A, "init", D)), A;
            };
            var k = function() {
              function A(b) {
                this.axis = b;
              }
              return A.prototype.normalizeTimeTickInterval = function(b, d) {
                var m, v = d || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], g = v[v.length - 1], x = Q[g[0]], E = g[1];
                for (m = 0; m < v.length && (g = v[m], x = Q[g[0]], E = g[1], !(v[m + 1] && b <= (x * E[E.length - 1] + Q[v[m + 1][0]]) / 2)); m++)
                  ;
                return x === Q.year && b < 5 * x && (E = [1, 2, 5]), { unitRange: x, count: J(b / x, E, g[0] === "year" ? Math.max(Y(b / x), 1) : 1), unitName: g[0] };
              }, A.prototype.getXDateFormat = function(b, d) {
                var m = this.axis, v = m.chart.time;
                return m.closestPointRange ? v.getDateFormat(m.closestPointRange, b, m.options.startOfWeek, d) || v.resolveDTLFormat(d.year).main : v.resolveDTLFormat(d.day).main;
              }, A;
            }();
            q.Additions = k;
          }(F || (F = {})), F;
        }), at(_, "Core/Axis/LogarithmicAxis.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.addEvent, Y = G.normalizeTickInterval, J = G.pick;
          return function(Q) {
            var q = [];
            function U(k) {
              var A = this, b = k.userOptions, d = A.logarithmic;
              b.type !== "logarithmic" ? A.logarithmic = void 0 : d || (d = A.logarithmic = new D(A));
            }
            function N() {
              var k = this, A = k.logarithmic;
              A && (k.lin2val = function(b) {
                return A.lin2log(b);
              }, k.val2lin = function(b) {
                return A.log2lin(b);
              });
            }
            Q.compose = function(k) {
              return q.indexOf(k) === -1 && (q.push(k), k.keepProps.push("logarithmic"), $(k, "init", U), $(k, "afterInit", N)), k;
            };
            var D = function() {
              function k(A) {
                this.axis = A;
              }
              return k.prototype.getLogTickPositions = function(A, b, d, m) {
                var v = this, g = v.axis, x = g.len, E = g.options, P = [];
                if (m || (v.minorAutoInterval = void 0), A >= 0.5)
                  A = Math.round(A), P = g.getLinearTickPositions(A, b, d);
                else if (A >= 0.08) {
                  var S, u = void 0, y = void 0, s = void 0, a = void 0, e = void 0, n = void 0;
                  for (S = A > 0.3 ? [1, 2, 4] : A > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], u = Math.floor(b); u < d + 1 && !n; u++)
                    for (s = S.length, y = 0; y < s && !n; y++)
                      (a = v.log2lin(v.lin2log(u) * S[y])) > b && (!m || e <= d) && e !== void 0 && P.push(e), e > d && (n = !0), e = a;
                } else {
                  var o = v.lin2log(b), i = v.lin2log(d), c = m ? g.getMinorTickInterval() : E.tickInterval, l = c === "auto" ? null : c, h = E.tickPixelInterval / (m ? 5 : 1), C = m ? x / g.tickPositions.length : x;
                  A = J(l, v.minorAutoInterval, (i - o) * h / (C || 1)), A = Y(A), P = g.getLinearTickPositions(A, o, i).map(v.log2lin), m || (v.minorAutoInterval = A / 5);
                }
                return m || (g.tickInterval = A), P;
              }, k.prototype.lin2log = function(A) {
                return Math.pow(10, A);
              }, k.prototype.log2lin = function(A) {
                return Math.log(A) / Math.LN10;
              }, k;
            }();
            Q.Additions = D;
          }(F || (F = {})), F;
        }), at(_, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.erase, Y = G.extend, J = G.isNumber;
          return function(Q) {
            var q, U = [];
            Q.compose = function(D, k) {
              return q || (q = D), U.indexOf(k) === -1 && (U.push(k), Y(k.prototype, N.prototype)), k;
            };
            var N = function() {
              function D() {
              }
              return D.prototype.getPlotBandPath = function(k, A, b) {
                b === void 0 && (b = this.options);
                var d, m, v = this.getPlotLinePath({ value: A, force: !0, acrossPanes: b.acrossPanes }), g = [], x = this.horiz, E = !J(this.min) || !J(this.max) || k < this.min && A < this.min || k > this.max && A > this.max, P = this.getPlotLinePath({ value: k, force: !0, acrossPanes: b.acrossPanes }), S = 1;
                if (P && v)
                  for (E && (m = P.toString() === v.toString(), S = 0), d = 0; d < P.length; d += 2) {
                    var u = P[d], y = P[d + 1], s = v[d], a = v[d + 1];
                    u[0] !== "M" && u[0] !== "L" || y[0] !== "M" && y[0] !== "L" || s[0] !== "M" && s[0] !== "L" || a[0] !== "M" && a[0] !== "L" || (x && s[1] === u[1] ? (s[1] += S, a[1] += S) : x || s[2] !== u[2] || (s[2] += S, a[2] += S), g.push(["M", u[1], u[2]], ["L", y[1], y[2]], ["L", a[1], a[2]], ["L", s[1], s[2]], ["Z"])), g.isFlat = m;
                  }
                else
                  P = null;
                return g;
              }, D.prototype.addPlotBand = function(k) {
                return this.addPlotBandOrLine(k, "plotBands");
              }, D.prototype.addPlotLine = function(k) {
                return this.addPlotBandOrLine(k, "plotLines");
              }, D.prototype.addPlotBandOrLine = function(k, A) {
                var b = this, d = this.userOptions, m = new q(this, k);
                if (this.visible && (m = m.render()), m) {
                  if (this._addedPlotLB || (this._addedPlotLB = !0, (d.plotLines || []).concat(d.plotBands || []).forEach(function(g) {
                    b.addPlotBandOrLine(g);
                  })), A) {
                    var v = d[A] || [];
                    v.push(k), d[A] = v;
                  }
                  this.plotLinesAndBands.push(m);
                }
                return m;
              }, D.prototype.removePlotBandOrLine = function(k) {
                var A = this.plotLinesAndBands, b = this.options, d = this.userOptions;
                if (A) {
                  for (var m = A.length; m--; )
                    A[m].id === k && A[m].destroy();
                  [b.plotLines || [], d.plotLines || [], b.plotBands || [], d.plotBands || []].forEach(function(v) {
                    for (m = v.length; m--; )
                      (v[m] || {}).id === k && $(v, v[m]);
                  });
                }
              }, D.prototype.removePlotBand = function(k) {
                this.removePlotBandOrLine(k);
              }, D.prototype.removePlotLine = function(k) {
                this.removePlotBandOrLine(k);
              }, D;
            }();
          }(F || (F = {})), F;
        }), at(_, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [_["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = F.arrayMax, Y = F.arrayMin, J = F.defined, Q = F.destroyObjectProperties, q = F.erase, U = F.fireEvent, N = F.merge, D = F.objectEach, k = F.pick;
          return function() {
            function A(b, d) {
              this.axis = b, d && (this.options = d, this.id = d.id);
            }
            return A.compose = function(b) {
              return G.compose(A, b);
            }, A.prototype.render = function() {
              U(this, "render");
              var b, d = this, m = d.axis, v = m.horiz, g = m.logarithmic, x = d.options, E = x.color, P = k(x.zIndex, 0), S = x.events, u = {}, y = m.chart.renderer, s = x.label, a = d.label, e = x.to, n = x.from, o = x.value, i = d.svgElem, c = [], l = J(n) && J(e), h = J(o), C = !i, M = { class: "highcharts-plot-" + (l ? "band " : "line ") + (x.className || "") }, O = l ? "bands" : "lines";
              if (g && (n = g.log2lin(n), e = g.log2lin(e), o = g.log2lin(o)), m.chart.styledMode || (h ? (M.stroke = E || "#999999", M["stroke-width"] = k(x.width, 1), x.dashStyle && (M.dashstyle = x.dashStyle)) : l && (M.fill = E || "#e6ebf5", x.borderWidth && (M.stroke = x.borderColor, M["stroke-width"] = x.borderWidth))), u.zIndex = P, O += "-" + P, (b = m.plotLinesAndBandsGroups[O]) || (m.plotLinesAndBandsGroups[O] = b = y.g("plot-" + O).attr(u).add()), C && (d.svgElem = i = y.path().attr(M).add(b)), h)
                c = m.getPlotLinePath({ value: o, lineWidth: i.strokeWidth(), acrossPanes: x.acrossPanes });
              else {
                if (!l)
                  return;
                c = m.getPlotBandPath(n, e, x);
              }
              return !d.eventsAdded && S && (D(S, function(p, w) {
                i.on(w, function(T) {
                  S[w].apply(d, [T]);
                });
              }), d.eventsAdded = !0), (C || !i.d) && c && c.length ? i.attr({ d: c }) : i && (c ? (i.show(), i.animate({ d: c })) : i.d && (i.hide(), a && (d.label = a = a.destroy()))), s && (J(s.text) || J(s.formatter)) && c && c.length && m.width > 0 && m.height > 0 && !c.isFlat ? (s = N({ align: v && l && "center", x: v ? !l && 4 : 10, verticalAlign: !v && l && "middle", y: v ? l ? 16 : 10 : l ? 6 : -4, rotation: v && !l && 90 }, s), this.renderLabel(s, c, l, P)) : a && a.hide(), d;
            }, A.prototype.renderLabel = function(b, d, m, v) {
              var g = this, x = g.axis, E = x.chart.renderer, P = g.label;
              P || (g.label = P = E.text(this.getLabelText(b), 0, 0, b.useHTML).attr({ align: b.textAlign || b.align, rotation: b.rotation, class: "highcharts-plot-" + (m ? "band" : "line") + "-label " + (b.className || ""), zIndex: v }).add(), x.chart.styledMode || P.css(N({ textOverflow: "ellipsis" }, b.style)));
              var S = d.xBounds || [d[0][1], d[1][1], m ? d[2][1] : d[0][1]], u = d.yBounds || [d[0][2], d[1][2], m ? d[2][2] : d[0][2]], y = Y(S), s = Y(u);
              if (P.align(b, !1, { x: y, y: s, width: $(S) - y, height: $(u) - s }), !P.alignValue || P.alignValue === "left") {
                var a = b.clip ? x.width : x.chart.chartWidth;
                P.css({ width: (P.rotation === 90 ? x.height - (P.alignAttr.y - x.top) : a - (P.alignAttr.x - x.left)) + "px" });
              }
              P.show(!0);
            }, A.prototype.getLabelText = function(b) {
              return J(b.formatter) ? b.formatter.call(this) : b.text;
            }, A.prototype.destroy = function() {
              q(this.axis.plotLinesAndBands, this), delete this.axis, Q(this);
            }, A;
          }();
        }), at(_, "Core/Tooltip.js", [_["Core/FormatUtilities.js"], _["Core/Globals.js"], _["Core/Renderer/RendererUtilities.js"], _["Core/Renderer/RendererRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = G.format, q = F.doc, U = $.distribute, N = J.clamp, D = J.css, k = J.discardElement, A = J.extend, b = J.fireEvent, d = J.isArray, m = J.isNumber, v = J.isString, g = J.merge, x = J.pick, E = J.splat, P = J.syncTimeout;
          return function() {
            function S(u, y) {
              this.allowShared = !0, this.container = void 0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.now = {}, this.options = {}, this.outside = !1, this.chart = u, this.init(u, y);
            }
            return S.prototype.applyFilter = function() {
              var u = this.chart;
              u.renderer.definition({ tagName: "filter", attributes: { id: "drop-shadow-" + u.index, opacity: 0.5 }, children: [{ tagName: "feGaussianBlur", attributes: { in: "SourceAlpha", stdDeviation: 1 } }, { tagName: "feOffset", attributes: { dx: 1, dy: 1 } }, { tagName: "feComponentTransfer", children: [{ tagName: "feFuncA", attributes: { type: "linear", slope: 0.3 } }] }, { tagName: "feMerge", children: [{ tagName: "feMergeNode" }, { tagName: "feMergeNode", attributes: { in: "SourceGraphic" } }] }] });
            }, S.prototype.bodyFormatter = function(u) {
              return u.map(function(y) {
                var s = y.series.tooltipOptions;
                return (s[(y.point.formatPrefix || "point") + "Formatter"] || y.point.tooltipFormatter).call(y.point, s[(y.point.formatPrefix || "point") + "Format"] || "");
              });
            }, S.prototype.cleanSplit = function(u) {
              this.chart.series.forEach(function(y) {
                var s = y && y.tt;
                s && (!s.isActive || u ? y.tt = s.destroy() : s.isActive = !1);
              });
            }, S.prototype.defaultFormatter = function(u) {
              var y, s = this.points || E(this);
              return (y = (y = [u.tooltipFooterHeaderFormatter(s[0])]).concat(u.bodyFormatter(s))).push(u.tooltipFooterHeaderFormatter(s[0], !0)), y;
            }, S.prototype.destroy = function() {
              this.label && (this.label = this.label.destroy()), this.split && this.tt && (this.cleanSplit(!0), this.tt = this.tt.destroy()), this.renderer && (this.renderer = this.renderer.destroy(), k(this.container)), J.clearTimeout(this.hideTimer), J.clearTimeout(this.tooltipTimeout);
            }, S.prototype.getAnchor = function(u, y) {
              var s, a = this.chart, e = a.pointer, n = a.inverted, o = a.plotTop, i = a.plotLeft;
              if ((u = E(u))[0].series && u[0].series.yAxis && !u[0].series.yAxis.options.reversedStacks && (u = u.slice().reverse()), this.followPointer && y)
                y.chartX === void 0 && (y = e.normalize(y)), s = [y.chartX - i, y.chartY - o];
              else if (u[0].tooltipPos)
                s = u[0].tooltipPos;
              else {
                var c = 0, l = 0;
                u.forEach(function(h) {
                  var C = h.pos(!0);
                  C && (c += C[0], l += C[1]);
                }), c /= u.length, l /= u.length, this.shared && u.length > 1 && y && (n ? c = y.chartX : l = y.chartY), s = [c - i, l - o];
              }
              return s.map(Math.round);
            }, S.prototype.getClassName = function(u, y, s) {
              var a = this.options, e = u.series, n = e.options;
              return [a.className, "highcharts-label", s && "highcharts-tooltip-header", y ? "highcharts-tooltip-box" : "highcharts-tooltip", !s && "highcharts-color-" + x(u.colorIndex, e.colorIndex), n && n.className].filter(v).join(" ");
            }, S.prototype.getLabel = function() {
              var u, y = this, s = this.chart.styledMode, a = this.options, e = this.split && this.allowShared, n = a.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none"), o = this.chart.renderer;
              if (y.label) {
                var i = !y.label.hasClass("highcharts-label");
                (e && !i || !e && i) && y.destroy();
              }
              if (!this.label) {
                if (this.outside) {
                  var c = this.chart.options.chart.style, l = Y.getRendererType();
                  this.container = u = F.doc.createElement("div"), u.className = "highcharts-tooltip-container", D(u, { position: "absolute", top: "1px", pointerEvents: n, zIndex: Math.max(this.options.style.zIndex || 0, (c && c.zIndex || 0) + 3) }), F.doc.body.appendChild(u), this.renderer = o = new l(u, 0, 0, c, void 0, void 0, o.styledMode);
                }
                if (e ? this.label = o.g("tooltip") : (this.label = o.label("", 0, 0, a.shape, void 0, void 0, a.useHTML, void 0, "tooltip").attr({ padding: a.padding, r: a.borderRadius }), s || this.label.attr({ fill: a.backgroundColor, "stroke-width": a.borderWidth }).css(a.style).css({ pointerEvents: n }).shadow(a.shadow)), s && a.shadow && (this.applyFilter(), this.label.attr({ filter: "url(#drop-shadow-" + this.chart.index + ")" })), y.outside && !y.split) {
                  var h = this.label, C = h.xSetter, M = h.ySetter;
                  h.xSetter = function(O) {
                    C.call(h, y.distance), u.style.left = O + "px";
                  }, h.ySetter = function(O) {
                    M.call(h, y.distance), u.style.top = O + "px";
                  };
                }
                this.label.attr({ zIndex: 8 }).add();
              }
              return this.label;
            }, S.prototype.getPosition = function(u, y, s) {
              var a, e = this.chart, n = this.distance, o = {}, i = e.inverted && s.h || 0, c = this.outside, l = c ? q.documentElement.clientWidth - 2 * n : e.chartWidth, h = c ? Math.max(q.body.scrollHeight, q.documentElement.scrollHeight, q.body.offsetHeight, q.documentElement.offsetHeight, q.documentElement.clientHeight) : e.chartHeight, C = e.pointer.getChartPosition(), M = function(V) {
                return V * C.scaleX;
              }, O = function(V) {
                return V * C.scaleY;
              }, p = function(V) {
                var X = V === "x";
                return [V, X ? l : h, X ? u : y].concat(c ? [X ? M(u) : O(y), X ? C.left - n + M(s.plotX + e.plotLeft) : C.top - n + O(s.plotY + e.plotTop), 0, X ? l : h] : [X ? u : y, X ? s.plotX + e.plotLeft : s.plotY + e.plotTop, X ? e.plotLeft : e.plotTop, X ? e.plotLeft + e.plotWidth : e.plotTop + e.plotHeight]);
              }, w = p("y"), T = p("x"), z = !!s.negative;
              !e.polar && e.hoverSeries && e.hoverSeries.yAxis && e.hoverSeries.yAxis.reversed && (z = !z);
              var W = !this.followPointer && x(s.ttBelow, !e.inverted === z), L = function(V, X, et, ot, it, pt, mt) {
                var Ct = c ? V === "y" ? O(n) : M(n) : n, kt = (et - ot) / 2, Lt = ot < it - n, Tt = it + n + ot < X, xt = it - Ct - et + kt, ct = it + Ct - kt;
                if (W && Tt)
                  o[V] = ct;
                else if (!W && Lt)
                  o[V] = xt;
                else if (Lt)
                  o[V] = Math.min(mt - ot, xt - i < 0 ? xt : xt - i);
                else {
                  if (!Tt)
                    return !1;
                  o[V] = Math.max(pt, ct + i + et > X ? ct : ct + i);
                }
              }, I = function(V, X, et, ot, it) {
                var pt;
                return it < n || it > X - n ? pt = !1 : o[V] = it < et / 2 ? 1 : it > X - ot / 2 ? X - ot - 2 : it - et / 2, pt;
              }, j = function(V) {
                var X = w;
                w = T, T = X, a = V;
              }, Z = function() {
                L.apply(0, w) !== !1 ? I.apply(0, T) !== !1 || a || (j(!0), Z()) : a ? o.x = o.y = 0 : (j(!0), Z());
              };
              return (e.inverted || this.len > 1) && j(), Z(), o;
            }, S.prototype.hide = function(u) {
              var y = this;
              J.clearTimeout(this.hideTimer), u = x(u, this.options.hideDelay), this.isHidden || (this.hideTimer = P(function() {
                y.getLabel().fadeOut(u && void 0), y.isHidden = !0;
              }, u));
            }, S.prototype.init = function(u, y) {
              this.chart = u, this.options = y, this.crosshairs = [], this.now = { x: 0, y: 0 }, this.isHidden = !0, this.split = y.split && !u.inverted && !u.polar, this.shared = y.shared || this.split, this.outside = x(y.outside, !!(u.scrollablePixelsX || u.scrollablePixelsY));
            }, S.prototype.shouldStickOnContact = function(u) {
              return !(this.followPointer || !this.options.stickOnContact || u && !this.chart.pointer.inClass(u.target, "highcharts-tooltip"));
            }, S.prototype.move = function(u, y, s, a) {
              var e = this, n = e.now, o = e.options.animation !== !1 && !e.isHidden && (Math.abs(u - n.x) > 1 || Math.abs(y - n.y) > 1), i = e.followPointer || e.len > 1;
              A(n, { x: o ? (2 * n.x + u) / 3 : u, y: o ? (n.y + y) / 2 : y, anchorX: i ? void 0 : o ? (2 * n.anchorX + s) / 3 : s, anchorY: i ? void 0 : o ? (n.anchorY + a) / 2 : a }), e.getLabel().attr(n), e.drawTracker(), o && (J.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function() {
                e && e.move(u, y, s, a);
              }, 32));
            }, S.prototype.refresh = function(u, y) {
              var s = this, a = this.chart, e = s.options, n = a.pointer, o = E(u), i = o[0], c = [], l = e.formatter || s.defaultFormatter, h = s.shared, C = a.styledMode, M = {};
              if (e.enabled && i.series) {
                J.clearTimeout(this.hideTimer), s.allowShared = !(!d(u) && u.series && u.series.noSharedTooltip), s.followPointer = !s.split && i.series.tooltipOptions.followPointer;
                var O = s.getAnchor(u, y), p = O[0], w = O[1];
                h && s.allowShared ? (n.applyInactiveState(o), o.forEach(function(j) {
                  j.setState("hover"), c.push(j.getLabelConfig());
                }), (M = { x: i.category, y: i.y }).points = c) : M = i.getLabelConfig(), this.len = c.length;
                var T = l.call(M, s), z = i.series;
                if (this.distance = x(z.tooltipOptions.distance, 16), T === !1)
                  this.hide();
                else {
                  if (s.split && s.allowShared)
                    this.renderSplit(T, o);
                  else {
                    var W = p, L = w;
                    if (y && n.isDirectTouch && (W = y.chartX - a.plotLeft, L = y.chartY - a.plotTop), !a.polar && z.options.clip !== !1 && !o.some(function(j) {
                      return n.isDirectTouch || j.series.shouldShowTooltip(W, L);
                    }))
                      return void s.hide();
                    var I = s.getLabel();
                    e.style.width && !C || I.css({ width: a.spacingBox.width + "px" }), I.attr({ text: T && T.join ? T.join("") : T }), I.addClass(s.getClassName(i), !0), C || I.attr({ stroke: e.borderColor || i.color || z.color || "#666666" }), s.updatePosition({ plotX: p, plotY: w, negative: i.negative, ttBelow: i.ttBelow, h: O[2] || 0 });
                  }
                  s.isHidden && s.label && s.label.attr({ opacity: 1 }).show(), s.isHidden = !1;
                }
                b(this, "refresh");
              }
            }, S.prototype.renderSplit = function(u, y) {
              var s = this, a = s.chart, e = s.chart, n = e.chartWidth, o = e.chartHeight, i = e.plotHeight, c = e.plotLeft, l = e.plotTop, h = e.pointer, C = e.scrollablePixelsY, M = C === void 0 ? 0 : C, O = e.scrollablePixelsX, p = e.scrollingContainer, w = p === void 0 ? { scrollLeft: 0, scrollTop: 0 } : p, T = w.scrollLeft, z = w.scrollTop, W = e.styledMode, L = s.distance, I = s.options, j = s.options.positioner, Z = s.outside && typeof O != "number" ? q.documentElement.getBoundingClientRect() : { left: T, right: T + n, top: z, bottom: z + o }, V = s.getLabel(), X = this.renderer || a.renderer, et = !!(a.xAxis[0] && a.xAxis[0].opposite), ot = h.getChartPosition(), it = ot.left, pt = ot.top, mt = l + z, Ct = 0, kt = i - M;
              function Lt(zt, Ht, Kt, Gt, ee) {
                var Jt, Qt;
                return ee === void 0 && (ee = !0), Kt ? (Jt = et ? 0 : kt, Qt = N(zt - Gt / 2, Z.left, Z.right - Gt - (s.outside ? it : 0))) : (Jt = Ht - mt, Qt = N(Qt = ee ? zt - Gt - L : zt + L, ee ? Qt : Z.left, Z.right)), { x: Qt, y: Jt };
              }
              v(u) && (u = [!1, u]);
              var Tt = u.slice(0, y.length + 1).reduce(function(zt, Ht, Kt) {
                if (Ht !== !1 && Ht !== "") {
                  var Gt = y[Kt - 1] || { isHeader: !0, plotX: y[0].plotX, plotY: i, series: {} }, ee = Gt.isHeader, Jt = ee ? s : Gt.series, Qt = Jt.tt = function(Se, Le, Ye) {
                    var qt = Se, ue = Le.isHeader, ye = Le.series;
                    if (!qt) {
                      var xe = { padding: I.padding, r: I.borderRadius };
                      W || (xe.fill = I.backgroundColor, xe["stroke-width"] = I.borderWidth), qt = X.label("", 0, 0, I[ue ? "headerShape" : "shape"], void 0, void 0, I.useHTML).addClass(s.getClassName(Le, !0, ue)).attr(xe).add(V);
                    }
                    return qt.isActive = !0, qt.attr({ text: Ye }), W || qt.css(I.style).shadow(I.shadow).attr({ stroke: I.borderColor || Le.color || ye.color || "#333333" }), qt;
                  }(Jt.tt, Gt, Ht.toString()), ne = Qt.getBBox(), ae = ne.width + Qt.strokeWidth();
                  ee && (Ct = ne.height, kt += Ct, et && (mt -= Ct));
                  var Me = function(Se) {
                    var Le, Ye, qt = Se.isHeader, ue = Se.plotX, ye = ue === void 0 ? 0 : ue, xe = Se.plotY, Ve = xe === void 0 ? 0 : xe, ze = Se.series;
                    if (qt)
                      Le = c + ye, Ye = l + i / 2;
                    else {
                      var _e = ze.xAxis, Ce = ze.yAxis;
                      Le = _e.pos + N(ye, -L, _e.len + L), ze.shouldShowTooltip(0, Ce.pos - l + Ve, { ignoreX: !0 }) && (Ye = Ce.pos + Ve);
                    }
                    return { anchorX: Le = N(Le, Z.left - L, Z.right + L), anchorY: Ye };
                  }(Gt), he = Me.anchorX, fe = Me.anchorY;
                  if (typeof fe == "number") {
                    var Ee = ne.height + 1, Xe = j ? j.call(s, ae, Ee, Gt) : Lt(he, fe, ee, ae);
                    zt.push({ align: j ? 0 : void 0, anchorX: he, anchorY: fe, boxWidth: ae, point: Gt, rank: x(Xe.rank, ee ? 1 : 0), size: Ee, target: Xe.y, tt: Qt, x: Xe.x });
                  } else
                    Qt.isActive = !1;
                }
                return zt;
              }, []);
              !j && Tt.some(function(zt) {
                var Ht = (s.outside ? it : 0) + zt.anchorX;
                return Ht < Z.left && Ht + zt.boxWidth < Z.right || Ht < it - Z.left + zt.boxWidth && Z.right - Ht > Ht;
              }) && (Tt = Tt.map(function(zt) {
                var Ht = Lt(zt.anchorX, zt.anchorY, zt.point.isHeader, zt.boxWidth, !1), Kt = Ht.x, Gt = Ht.y;
                return A(zt, { target: Gt, x: Kt });
              })), s.cleanSplit(), U(Tt, kt);
              var xt = { left: it, right: it };
              Tt.forEach(function(zt) {
                var Ht = zt.x, Kt = zt.boxWidth, Gt = zt.isHeader;
                Gt || (s.outside && it + Ht < xt.left && (xt.left = it + Ht), !Gt && s.outside && xt.left + Kt > xt.right && (xt.right = it + Ht));
              }), Tt.forEach(function(zt) {
                var Ht = zt.x, Kt = zt.anchorX, Gt = zt.anchorY, ee = zt.pos, Jt = zt.point.isHeader, Qt = { visibility: ee === void 0 ? "hidden" : "inherit", x: Ht, y: (ee || 0) + mt, anchorX: Kt, anchorY: Gt };
                if (s.outside && Ht < Kt) {
                  var ne = it - xt.left;
                  ne > 0 && (Jt || (Qt.x = Ht + ne, Qt.anchorX = Kt + ne), Jt && (Qt.x = (xt.right - xt.left) / 2, Qt.anchorX = Kt + ne));
                }
                zt.tt.attr(Qt);
              });
              var ct = s.container, ft = s.outside, St = s.renderer;
              if (ft && ct && St) {
                var Mt = V.getBBox(), Dt = Mt.width, Ot = Mt.height, Nt = Mt.x, Wt = Mt.y;
                St.setSize(Dt + Nt, Ot + Wt, !1), ct.style.left = xt.left + "px", ct.style.top = pt + "px";
              }
            }, S.prototype.drawTracker = function() {
              var u = this;
              if (this.shouldStickOnContact()) {
                var y = u.chart, s = u.label, a = u.shared ? y.hoverPoints : y.hoverPoint;
                if (s && a) {
                  var e = { x: 0, y: 0, width: 0, height: 0 }, n = this.getAnchor(a), o = s.getBBox();
                  n[0] += y.plotLeft - s.translateX, n[1] += y.plotTop - s.translateY, e.x = Math.min(0, n[0]), e.y = Math.min(0, n[1]), e.width = n[0] < 0 ? Math.max(Math.abs(n[0]), o.width - n[0]) : Math.max(Math.abs(n[0]), o.width), e.height = n[1] < 0 ? Math.max(Math.abs(n[1]), o.height - Math.abs(n[1])) : Math.max(Math.abs(n[1]), o.height), u.tracker ? u.tracker.attr(e) : (u.tracker = s.renderer.rect(e).addClass("highcharts-tracker").add(s), y.styledMode || u.tracker.attr({ fill: "rgba(0,0,0,0)" }));
                }
              } else
                u.tracker && u.tracker.destroy();
            }, S.prototype.styledModeFormat = function(u) {
              return u.replace('style="font-size: 10px"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }, S.prototype.tooltipFooterHeaderFormatter = function(u, y) {
              var s = u.series, a = s.tooltipOptions, e = s.xAxis, n = e && e.dateTime, o = { isFooter: y, labelConfig: u }, i = a.xDateFormat, c = a[y ? "footerFormat" : "headerFormat"];
              return b(this, "headerFormatter", o, function(l) {
                n && !i && m(u.key) && (i = n.getXDateFormat(u.key, a.dateTimeLabelFormats)), n && i && (u.point && u.point.tooltipDateKeys || ["key"]).forEach(function(h) {
                  c = c.replace("{point." + h + "}", "{point." + h + ":" + i + "}");
                }), s.chart.styledMode && (c = this.styledModeFormat(c)), l.text = Q(c, { point: u, series: s }, this.chart);
              }), o.text;
            }, S.prototype.update = function(u) {
              this.destroy(), g(!0, this.chart.options.tooltip.userOptions, u), this.init(this.chart, g(!0, this.options, u));
            }, S.prototype.updatePosition = function(u) {
              var y, s = this, a = s.chart, e = s.distance, n = s.options, o = a.pointer, i = this.getLabel(), c = o.getChartPosition(), l = c.left, h = c.top, C = c.scaleX, M = c.scaleY, O = (n.positioner || this.getPosition).call(this, i.width, i.height, u), p = (u.plotX || 0) + a.plotLeft, w = (u.plotY || 0) + a.plotTop;
              this.outside && (n.positioner && (O.x += l - e, O.y += h - e), y = n.borderWidth + 2 * e, this.renderer.setSize(i.width + y, i.height + y, !1), C === 1 && M === 1 || (D(this.container, { transform: "scale(".concat(C, ", ").concat(M, ")") }), p *= C, w *= M), p += l - O.x, w += h - O.y), this.move(Math.round(O.x), Math.round(O.y || 0), p, w);
            }, S;
          }();
        }), at(_, "Core/Series/Point.js", [_["Core/Renderer/HTML/AST.js"], _["Core/Animation/AnimationUtilities.js"], _["Core/Defaults.js"], _["Core/FormatUtilities.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = F.animObject, q = $.defaultOptions, U = Y.format, N = J.addEvent, D = J.defined, k = J.erase, A = J.extend, b = J.fireEvent, d = J.getNestedProperty, m = J.isArray, v = J.isFunction, g = J.isNumber, x = J.isObject, E = J.merge, P = J.objectEach, S = J.pick, u = J.syncTimeout, y = J.removeEvent, s = J.uniqueKey;
          return function() {
            function a() {
              this.category = void 0, this.formatPrefix = "point", this.id = void 0, this.isNull = !1, this.name = void 0, this.options = void 0, this.percentage = void 0, this.selected = !1, this.series = void 0, this.shapeArgs = void 0, this.total = void 0, this.visible = !0, this.x = void 0;
            }
            return a.prototype.animateBeforeDestroy = function() {
              var e = this, n = { x: e.startXPos, opacity: 0 }, o = e.getGraphicalProps();
              o.singular.forEach(function(i) {
                var c = i === "dataLabel";
                e[i] = e[i].animate(c ? { x: e[i].startXPos, y: e[i].startYPos, opacity: 0 } : n);
              }), o.plural.forEach(function(i) {
                e[i].forEach(function(c) {
                  c.element && c.animate(A({ x: e.startXPos }, c.startYPos ? { x: c.startXPos, y: c.startYPos } : {}));
                });
              });
            }, a.prototype.applyOptions = function(e, n) {
              var o = this, i = o.series, c = i.options.pointValKey || i.pointValKey;
              return e = a.prototype.optionsToObject.call(this, e), A(o, e), o.options = o.options ? A(o.options, e) : e, e.group && delete o.group, e.dataLabels && delete o.dataLabels, c && (o.y = a.prototype.getNestedProperty.call(o, c)), o.isNull = this.isValid && !this.isValid(), o.formatPrefix = o.isNull ? "null" : "point", o.selected && (o.state = "select"), "name" in o && n === void 0 && i.xAxis && i.xAxis.hasNames && (o.x = i.xAxis.nameToX(o)), o.x === void 0 && i ? o.x = n === void 0 ? i.autoIncrement() : n : g(e.x) && i.options.relativeXValue && (o.x = i.autoIncrement(e.x)), o;
            }, a.prototype.destroy = function() {
              var e, n = this, o = n.series, i = o.chart, c = o.options.dataSorting, l = i.hoverPoints, h = n.series.chart.renderer.globalAnimation, C = Q(h);
              function M() {
                for (e in (n.graphic || n.graphics || n.dataLabel || n.dataLabels) && (y(n), n.destroyElements()), n)
                  n[e] = null;
              }
              n.legendItem && i.legend.destroyItem(n), l && (n.setState(), k(l, n), l.length || (i.hoverPoints = null)), n === i.hoverPoint && n.onMouseOut(), c && c.enabled ? (this.animateBeforeDestroy(), u(M, C.duration)) : M(), i.pointCount--;
            }, a.prototype.destroyElements = function(e) {
              var n = this, o = n.getGraphicalProps(e);
              o.singular.forEach(function(i) {
                n[i] = n[i].destroy();
              }), o.plural.forEach(function(i) {
                n[i].forEach(function(c) {
                  c && c.element && c.destroy();
                }), delete n[i];
              });
            }, a.prototype.firePointEvent = function(e, n, o) {
              var i = this, c = this.series.options;
              (c.point.events[e] || i.options && i.options.events && i.options.events[e]) && i.importEvents(), e === "click" && c.allowPointSelect && (o = function(l) {
                i.select && i.select(null, l.ctrlKey || l.metaKey || l.shiftKey);
              }), b(i, e, n, o);
            }, a.prototype.getClassName = function() {
              var e = this;
              return "highcharts-point" + (e.selected ? " highcharts-point-select" : "") + (e.negative ? " highcharts-negative" : "") + (e.isNull ? " highcharts-null-point" : "") + (e.colorIndex !== void 0 ? " highcharts-color-" + e.colorIndex : "") + (e.options.className ? " " + e.options.className : "") + (e.zone && e.zone.className ? " " + e.zone.className.replace("highcharts-negative", "") : "");
            }, a.prototype.getGraphicalProps = function(e) {
              var n, o, i = this, c = [], l = { singular: [], plural: [] };
              for ((e = e || { graphic: 1, dataLabel: 1 }).graphic && c.push("graphic", "shadowGroup"), e.dataLabel && c.push("dataLabel", "dataLabelPath", "dataLabelUpper", "connector"), o = c.length; o--; )
                n = c[o], i[n] && l.singular.push(n);
              return ["graphic", "dataLabel", "connector"].forEach(function(h) {
                var C = h + "s";
                e[h] && i[C] && l.plural.push(C);
              }), l;
            }, a.prototype.getLabelConfig = function() {
              return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
            }, a.prototype.getNestedProperty = function(e) {
              if (e)
                return e.indexOf("custom.") === 0 ? d(e, this.options) : this[e];
            }, a.prototype.getZone = function() {
              var e, n = this.series, o = n.zones, i = n.zoneAxis || "y", c = 0;
              for (e = o[c]; this[i] >= e.value; )
                e = o[++c];
              return this.nonZonedColor || (this.nonZonedColor = this.color), e && e.color && !this.options.color ? this.color = e.color : this.color = this.nonZonedColor, e;
            }, a.prototype.hasNewShapeType = function() {
              var e = this;
              return (e.graphic && (e.graphic.symbolName || e.graphic.element.nodeName)) !== this.shapeType;
            }, a.prototype.init = function(e, n, o) {
              return this.series = e, this.applyOptions(n, o), this.id = D(this.id) ? this.id : s(), this.resolveColor(), e.chart.pointCount++, b(this, "afterInit"), this;
            }, a.prototype.isValid = function() {
              return this.x !== null && g(this.y);
            }, a.prototype.optionsToObject = function(e) {
              var n, o = this.series, i = o.options.keys, c = i || o.pointArrayMap || ["y"], l = c.length, h = {}, C = 0, M = 0;
              if (g(e) || e === null)
                h[c[0]] = e;
              else if (m(e))
                for (!i && e.length > l && ((n = typeof e[0]) == "string" ? h.name = e[0] : n === "number" && (h.x = e[0]), C++); M < l; )
                  i && e[C] === void 0 || (c[M].indexOf(".") > 0 ? a.prototype.setNestedProperty(h, e[C], c[M]) : h[c[M]] = e[C]), C++, M++;
              else
                typeof e == "object" && (h = e, e.dataLabels && (o._hasPointLabels = !0), e.marker && (o._hasPointMarkers = !0));
              return h;
            }, a.prototype.pos = function(e, n) {
              n === void 0 && (n = this.plotY);
              var o = this.plotX, i = this.series, c = i.chart, l = i.xAxis, h = i.yAxis, C = 0, M = 0;
              if (g(o) && g(n))
                return e && (C = l ? l.pos : c.plotLeft, M = h ? h.pos : c.plotTop), c.inverted && l && h ? [h.len - n + M, l.len - o + C] : [o + C, n + M];
            }, a.prototype.resolveColor = function() {
              var e, n, o, i = this.series, c = i.chart.options.chart, l = i.chart.styledMode, h = c.colorCount;
              delete this.nonZonedColor, i.options.colorByPoint ? (l || (e = (n = i.options.colors || i.chart.options.colors)[i.colorCounter], h = n.length), o = i.colorCounter, i.colorCounter++, i.colorCounter === h && (i.colorCounter = 0)) : (l || (e = i.color), o = i.colorIndex), this.colorIndex = S(this.options.colorIndex, o), this.color = S(this.options.color, e);
            }, a.prototype.setNestedProperty = function(e, n, o) {
              return o.split(".").reduce(function(i, c, l, h) {
                var C = h.length - 1 === l;
                return i[c] = C ? n : x(i[c], !0) ? i[c] : {}, i[c];
              }, e), e;
            }, a.prototype.shouldDraw = function() {
              return !this.isNull;
            }, a.prototype.tooltipFormatter = function(e) {
              var n = this.series, o = n.tooltipOptions, i = S(o.valueDecimals, ""), c = o.valuePrefix || "", l = o.valueSuffix || "";
              return n.chart.styledMode && (e = n.chart.tooltip.styledModeFormat(e)), (n.pointArrayMap || ["y"]).forEach(function(h) {
                h = "{point." + h, (c || l) && (e = e.replace(RegExp(h + "}", "g"), c + h + "}" + l)), e = e.replace(RegExp(h + "}", "g"), h + ":,." + i + "f}");
              }), U(e, { point: this, series: this.series }, n.chart);
            }, a.prototype.update = function(e, n, o, i) {
              var c, l = this, h = l.series, C = l.graphic, M = h.chart, O = h.options;
              function p() {
                l.applyOptions(e);
                var w = C && l.hasMockGraphic, T = l.y === null ? !w : w;
                C && T && (l.graphic = C.destroy(), delete l.hasMockGraphic), x(e, !0) && (C && C.element && e && e.marker && e.marker.symbol !== void 0 && (l.graphic = C.destroy()), e && e.dataLabels && l.dataLabel && (l.dataLabel = l.dataLabel.destroy()), l.connector && (l.connector = l.connector.destroy())), c = l.index, h.updateParallelArrays(l, c), O.data[c] = x(O.data[c], !0) || x(e, !0) ? l.options : S(e, O.data[c]), h.isDirty = h.isDirtyData = !0, !h.fixedBox && h.hasCartesianSeries && (M.isDirtyBox = !0), O.legendType === "point" && (M.isDirtyLegend = !0), n && M.redraw(o);
              }
              n = S(n, !0), i === !1 ? p() : l.firePointEvent("update", { options: e }, p);
            }, a.prototype.remove = function(e, n) {
              this.series.removePoint(this.series.data.indexOf(this), e, n);
            }, a.prototype.select = function(e, n) {
              var o = this, i = o.series, c = i.chart;
              e = S(e, !o.selected), this.selectedStaging = e, o.firePointEvent(e ? "select" : "unselect", { accumulate: n }, function() {
                o.selected = o.options.selected = e, i.options.data[i.data.indexOf(o)] = o.options, o.setState(e && "select"), n || c.getSelectedPoints().forEach(function(l) {
                  var h = l.series;
                  l.selected && l !== o && (l.selected = l.options.selected = !1, h.options.data[h.data.indexOf(l)] = l.options, l.setState(c.hoverPoints && h.options.inactiveOtherPoints ? "inactive" : ""), l.firePointEvent("unselect"));
                });
              }), delete this.selectedStaging;
            }, a.prototype.onMouseOver = function(e) {
              var n = this, o = n.series.chart, i = o.pointer;
              e = e ? i.normalize(e) : i.getChartCoordinatesFromPoint(n, o.inverted), i.runPointActions(e, n);
            }, a.prototype.onMouseOut = function() {
              var e = this, n = e.series.chart;
              e.firePointEvent("mouseOut"), e.series.options.inactiveOtherPoints || (n.hoverPoints || []).forEach(function(o) {
                o.setState();
              }), n.hoverPoints = n.hoverPoint = null;
            }, a.prototype.importEvents = function() {
              if (!this.hasImportedEvents) {
                var e = this, n = E(e.series.options.point, e.options).events;
                e.events = n, P(n, function(o, i) {
                  v(o) && N(e, i, o);
                }), this.hasImportedEvents = !0;
              }
            }, a.prototype.setState = function(e, n) {
              var o, i, c, l, h = this, C = h.series, M = h.state, O = C.options.states[e || "normal"] || {}, p = q.plotOptions[C.type].marker && C.options.marker, w = p && p.enabled === !1, T = p && p.states && p.states[e || "normal"] || {}, z = T.enabled === !1, W = h.marker || {}, L = C.chart, I = p && C.markerAttribs, j = C.halo, Z = C.stateMarkerGraphic;
              if (!((e = e || "") === h.state && !n || h.selected && e !== "select" || O.enabled === !1 || e && (z || w && T.enabled === !1) || e && W.states && W.states[e] && W.states[e].enabled === !1)) {
                if (h.state = e, I && (o = C.markerAttribs(h, e)), h.graphic && !h.hasMockGraphic) {
                  if (M && h.graphic.removeClass("highcharts-point-" + M), e && h.graphic.addClass("highcharts-point-" + e), !L.styledMode) {
                    i = C.pointAttribs(h, e), c = S(L.options.chart.animation, O.animation);
                    var V = i.opacity;
                    C.options.inactiveOtherPoints && g(V) && ((h.dataLabels || []).forEach(function(it) {
                      it && !it.hasClass("highcharts-data-label-hidden") && it.animate({ opacity: V }, c);
                    }), h.connector && h.connector.animate({ opacity: V }, c)), h.graphic.animate(i, c);
                  }
                  o && h.graphic.animate(o, S(L.options.chart.animation, T.animation, p.animation)), Z && Z.hide();
                } else
                  e && T && (l = W.symbol || C.symbol, Z && Z.currentSymbol !== l && (Z = Z.destroy()), o && (Z ? Z[n ? "animate" : "attr"]({ x: o.x, y: o.y }) : l && (C.stateMarkerGraphic = Z = L.renderer.symbol(l, o.x, o.y, o.width, o.height).add(C.markerGroup), Z.currentSymbol = l)), !L.styledMode && Z && h.state !== "inactive" && Z.attr(C.pointAttribs(h, e))), Z && (Z[e && h.isInside ? "show" : "hide"](), Z.element.point = h, Z.addClass(h.getClassName(), !0));
                var X = O.halo, et = h.graphic || Z, ot = et && et.visibility || "inherit";
                X && X.size && et && ot !== "hidden" && !h.isCluster ? (j || (C.halo = j = L.renderer.path().add(et.parentGroup)), j.show()[n ? "animate" : "attr"]({ d: h.haloPath(X.size) }), j.attr({ class: "highcharts-halo highcharts-color-" + S(h.colorIndex, C.colorIndex) + (h.className ? " " + h.className : ""), visibility: ot, zIndex: -1 }), j.point = h, L.styledMode || j.attr(A({ fill: h.color || C.color, "fill-opacity": X.opacity }, G.filterUserAttributes(X.attributes || {})))) : j && j.point && j.point.haloPath && j.animate({ d: j.point.haloPath(0) }, null, j.hide), b(h, "afterSetState", { state: e });
              }
            }, a.prototype.haloPath = function(e) {
              var n = this.pos();
              return n ? this.series.chart.renderer.symbols.circle(Math.floor(n[0]) - e, n[1] - e, 2 * e, 2 * e) : [];
            }, a;
          }();
        }), at(_, "Core/Pointer.js", [_["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Tooltip.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = G.parse, Q = F.charts, q = F.noop, U = Y.addEvent, N = Y.attr, D = Y.css, k = Y.defined, A = Y.extend, b = Y.find, d = Y.fireEvent, m = Y.isNumber, v = Y.isObject, g = Y.objectEach, x = Y.offset, E = Y.pick, P = Y.splat;
          return function() {
            function S(u, y) {
              this.lastValidTouch = {}, this.pinchDown = [], this.runChartClick = !1, this.eventsToUnbind = [], this.chart = u, this.hasDragged = !1, this.options = y, this.init(u, y);
            }
            return S.prototype.applyInactiveState = function(u) {
              var y, s = [];
              (u || []).forEach(function(a) {
                y = a.series, s.push(y), y.linkedParent && s.push(y.linkedParent), y.linkedSeries && (s = s.concat(y.linkedSeries)), y.navigatorSeries && s.push(y.navigatorSeries);
              }), this.chart.series.forEach(function(a) {
                s.indexOf(a) === -1 ? a.setState("inactive", !0) : a.options.inactiveOtherPoints && a.setAllPointsToState("inactive");
              });
            }, S.prototype.destroy = function() {
              var u = this;
              this.eventsToUnbind.forEach(function(y) {
                return y();
              }), this.eventsToUnbind = [], F.chartCount || (S.unbindDocumentMouseUp && (S.unbindDocumentMouseUp = S.unbindDocumentMouseUp()), S.unbindDocumentTouchEnd && (S.unbindDocumentTouchEnd = S.unbindDocumentTouchEnd())), clearInterval(u.tooltipTimeout), g(u, function(y, s) {
                u[s] = void 0;
              });
            }, S.prototype.getSelectionMarkerAttrs = function(u, y) {
              var s = this, a = { args: { chartX: u, chartY: y }, attrs: {}, shapeType: "rect" };
              return d(this, "getSelectionMarkerAttrs", a, function(e) {
                var n, o = s, i = o.chart, c = o.mouseDownX, l = c === void 0 ? 0 : c, h = o.mouseDownY, C = h === void 0 ? 0 : h, M = o.zoomHor, O = o.zoomVert, p = e.attrs;
                p.x = i.plotLeft, p.y = i.plotTop, p.width = M ? 1 : i.plotWidth, p.height = O ? 1 : i.plotHeight, M && (n = u - l, p.width = Math.abs(n), p.x = (n > 0 ? 0 : n) + l), O && (n = y - C, p.height = Math.abs(n), p.y = (n > 0 ? 0 : n) + C);
              }), a;
            }, S.prototype.drag = function(u) {
              var y, s = this.chart, a = s.options.chart, e = s.plotLeft, n = s.plotTop, o = s.plotWidth, i = s.plotHeight, c = this.mouseDownX || 0, l = this.mouseDownY || 0, h = v(a.panning) ? a.panning && a.panning.enabled : a.panning, C = a.panKey && u[a.panKey + "Key"], M = u.chartX, O = u.chartY, p = this.selectionMarker;
              if ((!p || !p.touch) && (M < e ? M = e : M > e + o && (M = e + o), O < n ? O = n : O > n + i && (O = n + i), this.hasDragged = Math.sqrt(Math.pow(c - M, 2) + Math.pow(l - O, 2)), this.hasDragged > 10)) {
                y = s.isInsidePlot(c - e, l - n, { visiblePlotOnly: !0 });
                var w = this.getSelectionMarkerAttrs(M, O), T = w.shapeType, z = w.attrs;
                (s.hasCartesianSeries || s.mapView) && (this.zoomX || this.zoomY) && y && !C && (p || (this.selectionMarker = p = s.renderer[T](), p.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), s.styledMode || p.attr({ fill: a.selectionMarkerFill || J("#335cad").setOpacity(0.25).get() }))), p && p.attr(z), y && !p && h && s.pan(u, a.panning);
              }
            }, S.prototype.dragStart = function(u) {
              var y = this.chart;
              y.mouseIsDown = u.type, y.cancelClick = !1, y.mouseDownX = this.mouseDownX = u.chartX, y.mouseDownY = this.mouseDownY = u.chartY;
            }, S.prototype.getSelectionBox = function(u) {
              var y = { args: { marker: u }, result: {} };
              return d(this, "getSelectionBox", y, function(s) {
                s.result = { x: u.attr ? +u.attr("x") : u.x, y: u.attr ? +u.attr("y") : u.y, width: u.attr ? u.attr("width") : u.width, height: u.attr ? u.attr("height") : u.height };
              }), y.result;
            }, S.prototype.drop = function(u) {
              var y = this, s = this.chart, a = this.hasPinched;
              if (this.selectionMarker) {
                var e = this.getSelectionBox(this.selectionMarker), n = e.x, o = e.y, i = e.width, c = e.height, l = { originalEvent: u, xAxis: [], yAxis: [], x: n, y: o, width: i, height: c }, h = !!s.mapView;
                (this.hasDragged || a) && (s.axes.forEach(function(C) {
                  if (C.zoomEnabled && k(C.min) && (a || y[{ xAxis: "zoomX", yAxis: "zoomY" }[C.coll]]) && m(n) && m(o) && m(i) && m(c)) {
                    var M = C.horiz, O = u.type === "touchend" ? C.minPixelPadding : 0, p = C.toValue((M ? n : o) + O), w = C.toValue((M ? n + i : o + c) - O);
                    l[C.coll].push({ axis: C, min: Math.min(p, w), max: Math.max(p, w) }), h = !0;
                  }
                }), h && d(s, "selection", l, function(C) {
                  s.zoom(A(C, a ? { animation: !1 } : null));
                })), m(s.index) && (this.selectionMarker = this.selectionMarker.destroy()), a && this.scaleGroups();
              }
              s && m(s.index) && (D(s.container, { cursor: s._cursor }), s.cancelClick = this.hasDragged > 10, s.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
            }, S.prototype.findNearestKDPoint = function(u, y, s) {
              var a;
              return u.forEach(function(e) {
                var n, o, i, c, l, h = !(e.noSharedTooltip && y) && e.options.findNearestPointBy.indexOf("y") < 0, C = e.searchPoint(s, h);
                v(C, !0) && C.series && (!v(a, !0) || (o = C, i = (n = a).distX - o.distX, c = n.dist - o.dist, l = (o.series.group && o.series.group.zIndex) - (n.series.group && n.series.group.zIndex), (i !== 0 && y ? i : c !== 0 ? c : l !== 0 ? l : n.series.index > o.series.index ? -1 : 1) > 0)) && (a = C);
              }), a;
            }, S.prototype.getChartCoordinatesFromPoint = function(u, y) {
              var s = u.series, a = s.xAxis, e = s.yAxis, n = u.shapeArgs;
              if (a && e) {
                var o = E(u.clientX, u.plotX), i = u.plotY || 0;
                return u.isNode && n && m(n.x) && m(n.y) && (o = n.x, i = n.y), y ? { chartX: e.len + e.pos - i, chartY: a.len + a.pos - o } : { chartX: o + a.pos, chartY: i + e.pos };
              }
              if (n && n.x && n.y)
                return { chartX: n.x, chartY: n.y };
            }, S.prototype.getChartPosition = function() {
              if (this.chartPosition)
                return this.chartPosition;
              var u = this.chart.container, y = x(u);
              this.chartPosition = { left: y.left, top: y.top, scaleX: 1, scaleY: 1 };
              var s = u.offsetWidth, a = u.offsetHeight;
              return s > 2 && a > 2 && (this.chartPosition.scaleX = y.width / s, this.chartPosition.scaleY = y.height / a), this.chartPosition;
            }, S.prototype.getCoordinates = function(u) {
              var y = { xAxis: [], yAxis: [] };
              return this.chart.axes.forEach(function(s) {
                y[s.isXAxis ? "xAxis" : "yAxis"].push({ axis: s, value: s.toValue(u[s.horiz ? "chartX" : "chartY"]) });
              }), y;
            }, S.prototype.getHoverData = function(u, y, s, a, e, n) {
              var o, i = [], c = !(!a || !u), l = function(O) {
                return O.visible && !(!e && O.directTouch) && E(O.options.enableMouseTracking, !0);
              }, h = y, C = { chartX: n ? n.chartX : void 0, chartY: n ? n.chartY : void 0, shared: e };
              d(this, "beforeGetHoverData", C), o = h && !h.stickyTracking ? [h] : s.filter(function(O) {
                return O.stickyTracking && (C.filter || l)(O);
              });
              var M = c || !n ? u : this.findNearestKDPoint(o, e, n);
              return h = M && M.series, M && (e && !h.noSharedTooltip ? (o = s.filter(function(O) {
                return C.filter ? C.filter(O) : l(O) && !O.noSharedTooltip;
              })).forEach(function(O) {
                var p = b(O.points, function(w) {
                  return w.x === M.x && !w.isNull;
                });
                v(p) && (O.boosted && O.boost && (p = O.boost.getPoint(p)), i.push(p));
              }) : i.push(M)), d(this, "afterGetHoverData", C = { hoverPoint: M }), { hoverPoint: C.hoverPoint, hoverSeries: h, hoverPoints: i };
            }, S.prototype.getPointFromEvent = function(u) {
              for (var y, s = u.target; s && !y; )
                y = s.point, s = s.parentNode;
              return y;
            }, S.prototype.onTrackerMouseOut = function(u) {
              var y = this.chart, s = u.relatedTarget || u.toElement, a = y.hoverSeries;
              this.isDirectTouch = !1, !a || !s || a.stickyTracking || this.inClass(s, "highcharts-tooltip") || this.inClass(s, "highcharts-series-" + a.index) && this.inClass(s, "highcharts-tracker") || a.onMouseOut();
            }, S.prototype.inClass = function(u, y) {
              for (var s, a = u; a; ) {
                if (s = N(a, "class")) {
                  if (s.indexOf(y) !== -1)
                    return !0;
                  if (s.indexOf("highcharts-container") !== -1)
                    return !1;
                }
                a = a.parentElement;
              }
            }, S.prototype.init = function(u, y) {
              this.options = y, this.chart = u, this.runChartClick = !!(y.chart.events && y.chart.events.click), this.pinchDown = [], this.lastValidTouch = {}, $ && (u.tooltip = new $(u, y.tooltip)), this.setDOMEvents();
            }, S.prototype.normalize = function(u, y) {
              var s = u.touches, a = s ? s.length ? s.item(0) : E(s.changedTouches, u.changedTouches)[0] : u;
              y || (y = this.getChartPosition());
              var e = a.pageX - y.left, n = a.pageY - y.top;
              return e /= y.scaleX, n /= y.scaleY, A(u, { chartX: Math.round(e), chartY: Math.round(n) });
            }, S.prototype.onContainerClick = function(u) {
              var y = this.chart, s = y.hoverPoint, a = this.normalize(u), e = y.plotLeft, n = y.plotTop;
              y.cancelClick || (s && this.inClass(a.target, "highcharts-tracker") ? (d(s.series, "click", A(a, { point: s })), y.hoverPoint && s.firePointEvent("click", a)) : (A(a, this.getCoordinates(a)), y.isInsidePlot(a.chartX - e, a.chartY - n, { visiblePlotOnly: !0 }) && d(y, "click", a)));
            }, S.prototype.onContainerMouseDown = function(u) {
              var y = (1 & (u.buttons || u.button)) == 1;
              u = this.normalize(u), F.isFirefox && u.button !== 0 && this.onContainerMouseMove(u), (u.button === void 0 || y) && (this.zoomOption(u), y && u.preventDefault && u.preventDefault(), this.dragStart(u));
            }, S.prototype.onContainerMouseLeave = function(u) {
              var y = Q[E(S.hoverChartIndex, -1)], s = this.chart.tooltip;
              u = this.normalize(u), y && (u.relatedTarget || u.toElement) && (y.pointer.reset(), y.pointer.chartPosition = void 0), s && !s.isHidden && this.reset();
            }, S.prototype.onContainerMouseEnter = function(u) {
              delete this.chartPosition;
            }, S.prototype.onContainerMouseMove = function(u) {
              var y = this.chart, s = y.tooltip, a = this.normalize(u);
              this.setHoverChartIndex(), a.preventDefault || (a.returnValue = !1), (y.mouseIsDown === "mousedown" || this.touchSelect(a)) && this.drag(a), y.openMenu || !this.inClass(a.target, "highcharts-tracker") && !y.isInsidePlot(a.chartX - y.plotLeft, a.chartY - y.plotTop, { visiblePlotOnly: !0 }) || s && s.shouldStickOnContact(a) || (this.inClass(a.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(a));
            }, S.prototype.onDocumentTouchEnd = function(u) {
              var y = Q[E(S.hoverChartIndex, -1)];
              y && y.pointer.drop(u);
            }, S.prototype.onContainerTouchMove = function(u) {
              this.touchSelect(u) ? this.onContainerMouseMove(u) : this.touch(u);
            }, S.prototype.onContainerTouchStart = function(u) {
              this.touchSelect(u) ? this.onContainerMouseDown(u) : (this.zoomOption(u), this.touch(u, !0));
            }, S.prototype.onDocumentMouseMove = function(u) {
              var y = this.chart, s = y.tooltip, a = this.chartPosition, e = this.normalize(u, a);
              !a || y.isInsidePlot(e.chartX - y.plotLeft, e.chartY - y.plotTop, { visiblePlotOnly: !0 }) || s && s.shouldStickOnContact(e) || this.inClass(e.target, "highcharts-tracker") || this.reset();
            }, S.prototype.onDocumentMouseUp = function(u) {
              var y = Q[E(S.hoverChartIndex, -1)];
              y && y.pointer.drop(u);
            }, S.prototype.pinch = function(u) {
              var y = this, s = y.chart, a = y.pinchDown, e = u.touches || [], n = e.length, o = y.lastValidTouch, i = y.hasZoom, c = {}, l = n === 1 && (y.inClass(u.target, "highcharts-tracker") && s.runTrackerClick || y.runChartClick), h = {}, C = y.chart.tooltip, M = n === 1 && E(C && C.options.followTouchMove, !0), O = y.selectionMarker;
              n > 1 ? y.initiated = !0 : M && (y.initiated = !1), i && y.initiated && !l && u.cancelable !== !1 && u.preventDefault(), [].map.call(e, function(p) {
                return y.normalize(p);
              }), u.type === "touchstart" ? ([].forEach.call(e, function(p, w) {
                a[w] = { chartX: p.chartX, chartY: p.chartY };
              }), o.x = [a[0].chartX, a[1] && a[1].chartX], o.y = [a[0].chartY, a[1] && a[1].chartY], s.axes.forEach(function(p) {
                if (p.zoomEnabled) {
                  var w = s.bounds[p.horiz ? "h" : "v"], T = p.minPixelPadding, z = p.toPixels(Math.min(E(p.options.min, p.dataMin), p.dataMin)), W = p.toPixels(Math.max(E(p.options.max, p.dataMax), p.dataMax)), L = Math.min(z, W), I = Math.max(z, W);
                  w.min = Math.min(p.pos, L - T), w.max = Math.max(p.pos + p.len, I + T);
                }
              }), y.res = !0) : M ? this.runPointActions(y.normalize(u)) : a.length && (d(s, "touchpan", { originalEvent: u }, function() {
                O || (y.selectionMarker = O = A({ destroy: q, touch: !0 }, s.plotBox)), y.pinchTranslate(a, e, c, O, h, o), y.hasPinched = i, y.scaleGroups(c, h);
              }), y.res && (y.res = !1, this.reset(!1, 0)));
            }, S.prototype.pinchTranslate = function(u, y, s, a, e, n) {
              this.zoomHor && this.pinchTranslateDirection(!0, u, y, s, a, e, n), this.zoomVert && this.pinchTranslateDirection(!1, u, y, s, a, e, n);
            }, S.prototype.pinchTranslateDirection = function(u, y, s, a, e, n, o, i) {
              var c, l, h, C, M = this.chart, O = u ? "x" : "y", p = u ? "X" : "Y", w = "chart" + p, T = u ? "width" : "height", z = M["plot" + (u ? "Left" : "Top")], W = M.inverted, L = M.bounds[u ? "h" : "v"], I = y.length === 1, j = y[0][w], Z = !I && y[1][w], V = function() {
                typeof ot == "number" && Math.abs(j - Z) > 20 && (X = i || Math.abs(et - ot) / Math.abs(j - Z)), h = (z - et) / X + j, c = M["plot" + (u ? "Width" : "Height")] / X;
              }, X = i || 1, et = s[0][w], ot = !I && s[1][w];
              V(), (l = h) < L.min ? (l = L.min, C = !0) : l + c > L.max && (l = L.max - c, C = !0), C ? (et -= 0.8 * (et - o[O][0]), typeof ot == "number" && (ot -= 0.8 * (ot - o[O][1])), V()) : o[O] = [et, ot], W || (n[O] = h - z, n[T] = c);
              var it = W ? u ? "scaleY" : "scaleX" : "scale" + p, pt = W ? 1 / X : X;
              e[T] = c, e[O] = l, a[it] = X, a["translate" + p] = pt * z + (et - pt * j);
            }, S.prototype.reset = function(u, y) {
              var s = this, a = s.chart, e = a.hoverSeries, n = a.hoverPoint, o = a.hoverPoints, i = a.tooltip, c = i && i.shared ? o : n;
              u && c && P(c).forEach(function(l) {
                l.series.isCartesian && l.plotX === void 0 && (u = !1);
              }), u ? i && c && P(c).length && (i.refresh(c), i.shared && o ? o.forEach(function(l) {
                l.setState(l.state, !0), l.series.isCartesian && (l.series.xAxis.crosshair && l.series.xAxis.drawCrosshair(null, l), l.series.yAxis.crosshair && l.series.yAxis.drawCrosshair(null, l));
              }) : n && (n.setState(n.state, !0), a.axes.forEach(function(l) {
                l.crosshair && n.series[l.coll] === l && l.drawCrosshair(null, n);
              }))) : (n && n.onMouseOut(), o && o.forEach(function(l) {
                l.setState();
              }), e && e.onMouseOut(), i && i.hide(y), s.unDocMouseMove && (s.unDocMouseMove = s.unDocMouseMove()), a.axes.forEach(function(l) {
                l.hideCrosshair();
              }), s.hoverX = a.hoverPoints = a.hoverPoint = null);
            }, S.prototype.runPointActions = function(u, y, s) {
              var a = this, e = a.chart, n = e.series, o = e.tooltip && e.tooltip.options.enabled ? e.tooltip : void 0, i = !!o && o.shared, c = y || e.hoverPoint, l = c && c.series || e.hoverSeries, h = (!u || u.type !== "touchmove") && (!!y || l && l.directTouch && a.isDirectTouch), C = this.getHoverData(c, l, n, h, i, u);
              c = C.hoverPoint, l = C.hoverSeries;
              var M = C.hoverPoints, O = l && l.tooltipOptions.followPointer && !l.tooltipOptions.split, p = i && l && !l.noSharedTooltip;
              if (c && (s || c !== e.hoverPoint || o && o.isHidden)) {
                if ((e.hoverPoints || []).forEach(function(T) {
                  M.indexOf(T) === -1 && T.setState();
                }), e.hoverSeries !== l && l.onMouseOver(), a.applyInactiveState(M), (M || []).forEach(function(T) {
                  T.setState("hover");
                }), e.hoverPoint && e.hoverPoint.firePointEvent("mouseOut"), !c.series)
                  return;
                e.hoverPoints = M, e.hoverPoint = c, c.firePointEvent("mouseOver", void 0, function() {
                  o && c && o.refresh(p ? M : c, u);
                });
              } else if (O && o && !o.isHidden) {
                var w = o.getAnchor([{}], u);
                e.isInsidePlot(w[0], w[1], { visiblePlotOnly: !0 }) && o.updatePosition({ plotX: w[0], plotY: w[1] });
              }
              a.unDocMouseMove || (a.unDocMouseMove = U(e.container.ownerDocument, "mousemove", function(T) {
                var z = Q[S.hoverChartIndex];
                z && z.pointer.onDocumentMouseMove(T);
              }), a.eventsToUnbind.push(a.unDocMouseMove)), e.axes.forEach(function(T) {
                var z, W = E((T.crosshair || {}).snap, !0);
                W && ((z = e.hoverPoint) && z.series[T.coll] === T || (z = b(M, function(L) {
                  return L.series && L.series[T.coll] === T;
                }))), z || !W ? T.drawCrosshair(u, z) : T.hideCrosshair();
              });
            }, S.prototype.scaleGroups = function(u, y) {
              var s = this.chart;
              s.series.forEach(function(a) {
                var e = u || a.getPlotBox();
                a.group && (a.xAxis && a.xAxis.zoomEnabled || s.mapView) && (a.group.attr(e), a.markerGroup && (a.markerGroup.attr(e), a.markerGroup.clip(y ? s.clipRect : null)), a.dataLabelsGroup && a.dataLabelsGroup.attr(e));
              }), s.clipRect.attr(y || s.clipBox);
            }, S.prototype.setDOMEvents = function() {
              var u = this, y = this.chart.container, s = y.ownerDocument;
              y.onmousedown = this.onContainerMouseDown.bind(this), y.onmousemove = this.onContainerMouseMove.bind(this), y.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(U(y, "mouseenter", this.onContainerMouseEnter.bind(this))), this.eventsToUnbind.push(U(y, "mouseleave", this.onContainerMouseLeave.bind(this))), S.unbindDocumentMouseUp || (S.unbindDocumentMouseUp = U(s, "mouseup", this.onDocumentMouseUp.bind(this)));
              for (var a = this.chart.renderTo.parentElement; a && a.tagName !== "BODY"; )
                this.eventsToUnbind.push(U(a, "scroll", function() {
                  delete u.chartPosition;
                })), a = a.parentElement;
              F.hasTouch && (this.eventsToUnbind.push(U(y, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 })), this.eventsToUnbind.push(U(y, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), S.unbindDocumentTouchEnd || (S.unbindDocumentTouchEnd = U(s, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })));
            }, S.prototype.setHoverChartIndex = function() {
              var u = this.chart, y = F.charts[E(S.hoverChartIndex, -1)];
              y && y !== u && y.pointer.onContainerMouseLeave({ relatedTarget: u.container }), y && y.mouseIsDown || (S.hoverChartIndex = u.index);
            }, S.prototype.touch = function(u, y) {
              var s, a, e = this.chart;
              this.setHoverChartIndex(), u.touches.length === 1 ? (u = this.normalize(u), e.isInsidePlot(u.chartX - e.plotLeft, u.chartY - e.plotTop, { visiblePlotOnly: !0 }) && !e.openMenu ? (y && this.runPointActions(u), u.type === "touchmove" && (s = !!(a = this.pinchDown)[0] && Math.sqrt(Math.pow(a[0].chartX - u.chartX, 2) + Math.pow(a[0].chartY - u.chartY, 2)) >= 4), E(s, !0) && this.pinch(u)) : y && this.reset()) : u.touches.length === 2 && this.pinch(u);
            }, S.prototype.touchSelect = function(u) {
              return !!(this.chart.options.chart.zooming.singleTouch && u.touches && u.touches.length === 1);
            }, S.prototype.zoomOption = function(u) {
              var y, s, a = this.chart, e = a.options.chart, n = a.inverted, o = e.zooming.type || "";
              /touch/.test(u.type) && (o = E(e.zooming.pinchType, o)), this.zoomX = y = /x/.test(o), this.zoomY = s = /y/.test(o), this.zoomHor = y && !n || s && n, this.zoomVert = s && !n || y && n, this.hasZoom = y || s;
            }, S;
          }();
        }), at(_, "Core/MSPointer.js", [_["Core/Globals.js"], _["Core/Pointer.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(E, P) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(S, u) {
              S.__proto__ = u;
            } || function(S, u) {
              for (var y in u)
                u.hasOwnProperty(y) && (S[y] = u[y]);
            }, Y(E, P);
          }, function(E, P) {
            function S() {
              this.constructor = E;
            }
            Y(E, P), E.prototype = P === null ? Object.create(P) : (S.prototype = P.prototype, new S());
          }), Q = G.charts, q = G.doc, U = G.noop, N = G.win, D = $.addEvent, k = $.css, A = $.objectEach, b = $.pick, d = $.removeEvent, m = {}, v = !!N.PointerEvent;
          function g(E, P, S, u) {
            var y, s = Q[F.hoverChartIndex || NaN];
            if ((E.pointerType === "touch" || E.pointerType === E.MSPOINTER_TYPE_TOUCH) && s) {
              var a = s.pointer;
              u(E), a[P]({ type: S, target: E.currentTarget, preventDefault: U, touches: (y = [], y.item = function(e) {
                return this[e];
              }, A(m, function(e) {
                y.push({ pageX: e.pageX, pageY: e.pageY, target: e.target });
              }), y) });
            }
          }
          var x = function(E) {
            function P() {
              return E !== null && E.apply(this, arguments) || this;
            }
            return J(P, E), P.isRequired = function() {
              return !(G.hasTouch || !N.PointerEvent && !N.MSPointerEvent);
            }, P.prototype.batchMSEvents = function(S) {
              S(this.chart.container, v ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown), S(this.chart.container, v ? "pointermove" : "MSPointerMove", this.onContainerPointerMove), S(q, v ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
            }, P.prototype.destroy = function() {
              this.batchMSEvents(d), E.prototype.destroy.call(this);
            }, P.prototype.init = function(S, u) {
              E.prototype.init.call(this, S, u), this.hasZoom && k(S.container, { "-ms-touch-action": "none", "touch-action": "none" });
            }, P.prototype.onContainerPointerDown = function(S) {
              g(S, "onContainerTouchStart", "touchstart", function(u) {
                m[u.pointerId] = { pageX: u.pageX, pageY: u.pageY, target: u.currentTarget };
              });
            }, P.prototype.onContainerPointerMove = function(S) {
              g(S, "onContainerTouchMove", "touchmove", function(u) {
                m[u.pointerId] = { pageX: u.pageX, pageY: u.pageY }, m[u.pointerId].target || (m[u.pointerId].target = u.currentTarget);
              });
            }, P.prototype.onDocumentPointerUp = function(S) {
              g(S, "onDocumentTouchEnd", "touchend", function(u) {
                delete m[u.pointerId];
              });
            }, P.prototype.setDOMEvents = function() {
              var S = this.chart.tooltip;
              E.prototype.setDOMEvents.call(this), (this.hasZoom || b(S && S.options.followTouchMove, !0)) && this.batchMSEvents(D);
            }, P;
          }(F);
          return x;
        }), at(_, "Core/Legend/Legend.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/FormatUtilities.js"], _["Core/Globals.js"], _["Core/Series/Point.js"], _["Core/Renderer/RendererUtilities.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = G.animObject, U = G.setAnimation, N = F.format, D = $.marginNames, k = J.distribute, A = Q.addEvent, b = Q.createElement, d = Q.css, m = Q.defined, v = Q.discardElement, g = Q.find, x = Q.fireEvent, E = Q.isNumber, P = Q.merge, S = Q.pick, u = Q.relativeLength, y = Q.stableSort, s = Q.syncTimeout;
          return function() {
            function a(e, n) {
              this.allItems = [], this.box = void 0, this.contentGroup = void 0, this.display = !1, this.group = void 0, this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.options = void 0, this.padding = 0, this.pages = [], this.proximate = !1, this.scrollGroup = void 0, this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = e, this.init(e, n);
            }
            return a.prototype.init = function(e, n) {
              this.chart = e, this.setOptions(n), n.enabled && (this.render(), A(this.chart, "endResize", function() {
                this.legend.positionCheckboxes();
              }), this.proximate ? this.unchartrender = A(this.chart, "render", function() {
                this.legend.proximatePositions(), this.legend.positionItems();
              }) : this.unchartrender && this.unchartrender());
            }, a.prototype.setOptions = function(e) {
              var n = S(e.padding, 8);
              this.options = e, this.chart.styledMode || (this.itemStyle = e.itemStyle, this.itemHiddenStyle = P(this.itemStyle, e.itemHiddenStyle)), this.itemMarginTop = e.itemMarginTop || 0, this.itemMarginBottom = e.itemMarginBottom || 0, this.padding = n, this.initialItemY = n - 5, this.symbolWidth = S(e.symbolWidth, 16), this.pages = [], this.proximate = e.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
            }, a.prototype.update = function(e, n) {
              var o = this.chart;
              this.setOptions(P(!0, this.options, e)), this.destroy(), o.isDirtyLegend = o.isDirtyBox = !0, S(n, !0) && o.redraw(), x(this, "afterUpdate");
            }, a.prototype.colorizeItem = function(e, n) {
              var o = e.legendItem || {}, i = o.group, c = o.label, l = o.line, h = o.symbol;
              if (i && i[n ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                var C = this.options, M = this.itemHiddenStyle.color, O = n ? C.itemStyle.color : M, p = n && e.color || M, w = e.options && e.options.marker, T = { fill: p };
                c && c.css({ fill: O, color: O }), l && l.attr({ stroke: p }), h && (w && h.isMarker && (T = e.pointAttribs(), n || (T.stroke = T.fill = M)), h.attr(T));
              }
              x(this, "afterColorizeItem", { item: e, visible: n });
            }, a.prototype.positionItems = function() {
              this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
            }, a.prototype.positionItem = function(e) {
              var n = this, o = e.legendItem || {}, i = o.group, c = o.x, l = c === void 0 ? 0 : c, h = o.y, C = h === void 0 ? 0 : h, M = this.options, O = M.symbolPadding, p = !M.rtl, w = e.checkbox;
              if (i && i.element) {
                var T = { translateX: p ? l : this.legendWidth - l - 2 * O - 4, translateY: C };
                i[m(i.translateY) ? "animate" : "attr"](T, void 0, function() {
                  x(n, "afterPositionItem", { item: e });
                });
              }
              w && (w.x = l, w.y = C);
            }, a.prototype.destroyItem = function(e) {
              for (var n = e.checkbox, o = e.legendItem || {}, i = 0, c = ["group", "label", "line", "symbol"]; i < c.length; i++) {
                var l = c[i];
                o[l] && (o[l] = o[l].destroy());
              }
              n && v(n), e.legendItem = void 0;
            }, a.prototype.destroy = function() {
              for (var e = this, n = 0, o = this.getAllItems(); n < o.length; n++) {
                var i = o[n];
                this.destroyItem(i);
              }
              for (var c = 0, l = ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"]; c < l.length; c++) {
                var h = l[c];
                e[h] && (e[h] = e[h].destroy());
              }
              this.display = null;
            }, a.prototype.positionCheckboxes = function() {
              var e, n = this.group && this.group.alignAttr, o = this.clipHeight || this.legendHeight, i = this.titleHeight;
              n && (e = n.translateY, this.allItems.forEach(function(c) {
                var l, h = c.checkbox;
                h && (l = e + i + h.y + (this.scrollOffset || 0) + 3, d(h, { left: n.translateX + c.checkboxOffset + h.x - 20 + "px", top: l + "px", display: this.proximate || l > e - 6 && l < e + o - 6 ? "" : "none" }));
              }, this));
            }, a.prototype.renderTitle = function() {
              var e, n = this.options, o = this.padding, i = n.title, c = 0;
              i.text && (this.title || (this.title = this.chart.renderer.label(i.text, o - 3, o - 4, void 0, void 0, void 0, n.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(i.style), this.title.add(this.group)), i.width || this.title.css({ width: this.maxLegendWidth + "px" }), c = (e = this.title.getBBox()).height, this.offsetWidth = e.width, this.contentGroup.attr({ translateY: c })), this.titleHeight = c;
            }, a.prototype.setText = function(e) {
              var n = this.options;
              e.legendItem.label.attr({ text: n.labelFormat ? N(n.labelFormat, e, this.chart) : n.labelFormatter.call(e) });
            }, a.prototype.renderItem = function(e) {
              var n = this, o = e.legendItem = e.legendItem || {}, i = n.chart, c = i.renderer, l = n.options, h = l.layout === "horizontal", C = n.symbolWidth, M = l.symbolPadding || 0, O = n.itemStyle, p = n.itemHiddenStyle, w = h ? S(l.itemDistance, 20) : 0, T = !l.rtl, z = !e.series, W = !z && e.series.drawLegendSymbol ? e.series : e, L = W.options, I = n.createCheckboxForItem && L && L.showCheckbox, j = l.useHTML, Z = e.options.className, V = o.label, X = C + M + w + (I ? 20 : 0);
              V || (o.group = c.g("legend-item").addClass("highcharts-" + W.type + "-series highcharts-color-" + e.colorIndex + (Z ? " " + Z : "") + (z ? " highcharts-series-" + e.index : "")).attr({ zIndex: 1 }).add(n.scrollGroup), o.label = V = c.text("", T ? C + M : -M, n.baseline || 0, j), i.styledMode || V.css(P(e.visible ? O : p)), V.attr({ align: T ? "left" : "right", zIndex: 2 }).add(o.group), n.baseline || (n.fontMetrics = c.fontMetrics(i.styledMode ? 12 : O.fontSize, V), n.baseline = n.fontMetrics.f + 3 + n.itemMarginTop, V.attr("y", n.baseline), n.symbolHeight = l.symbolHeight || n.fontMetrics.f, l.squareSymbol && (n.symbolWidth = S(l.symbolWidth, Math.max(n.symbolHeight, 16)), X = n.symbolWidth + M + w + (I ? 20 : 0), T && V.attr("x", n.symbolWidth + M))), W.drawLegendSymbol(n, e), n.setItemEvents && n.setItemEvents(e, V, j)), I && !e.checkbox && n.createCheckboxForItem && n.createCheckboxForItem(e), n.colorizeItem(e, e.visible), !i.styledMode && O.width || V.css({ width: (l.itemWidth || n.widthOption || i.spacingBox.width) - X + "px" }), n.setText(e);
              var et = V.getBBox(), ot = n.fontMetrics && n.fontMetrics.h || 0;
              e.itemWidth = e.checkboxOffset = l.itemWidth || o.labelWidth || et.width + X, n.maxItemWidth = Math.max(n.maxItemWidth, e.itemWidth), n.totalItemWidth += e.itemWidth, n.itemHeight = e.itemHeight = Math.round(o.labelHeight || (et.height > 1.5 * ot ? et.height : ot));
            }, a.prototype.layoutItem = function(e) {
              var n = this.options, o = this.padding, i = n.layout === "horizontal", c = e.itemHeight, l = this.itemMarginBottom, h = this.itemMarginTop, C = i ? S(n.itemDistance, 20) : 0, M = this.maxLegendWidth, O = n.alignColumns && this.totalItemWidth > M ? this.maxItemWidth : e.itemWidth, p = e.legendItem || {};
              i && this.itemX - o + O > M && (this.itemX = o, this.lastLineHeight && (this.itemY += h + this.lastLineHeight + l), this.lastLineHeight = 0), this.lastItemY = h + this.itemY + l, this.lastLineHeight = Math.max(c, this.lastLineHeight), p.x = this.itemX, p.y = this.itemY, i ? this.itemX += O : (this.itemY += h + c + l, this.lastLineHeight = c), this.offsetWidth = this.widthOption || Math.max((i ? this.itemX - o - (e.checkbox ? 0 : C) : O) + o, this.offsetWidth);
            }, a.prototype.getAllItems = function() {
              var e = [];
              return this.chart.series.forEach(function(n) {
                var o = n && n.options;
                n && S(o.showInLegend, !m(o.linkedTo) && void 0, !0) && (e = e.concat((n.legendItem || {}).labels || (o.legendType === "point" ? n.data : n)));
              }), x(this, "afterGetAllItems", { allItems: e }), e;
            }, a.prototype.getAlignment = function() {
              var e = this.options;
              return this.proximate ? e.align.charAt(0) + "tv" : e.floating ? "" : e.align.charAt(0) + e.verticalAlign.charAt(0) + e.layout.charAt(0);
            }, a.prototype.adjustMargins = function(e, n) {
              var o = this.chart, i = this.options, c = this.getAlignment();
              c && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(l, h) {
                l.test(c) && !m(e[h]) && (o[D[h]] = Math.max(o[D[h]], o.legend[(h + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][h] * i[h % 2 ? "x" : "y"] + S(i.margin, 12) + n[h] + (o.titleOffset[h] || 0)));
              });
            }, a.prototype.proximatePositions = function() {
              var e, n = this.chart, o = [], i = this.options.align === "left";
              this.allItems.forEach(function(C) {
                var M, O, p, w, T = i;
                C.yAxis && (C.xAxis.options.reversed && (T = !T), C.points && (M = g(T ? C.points : C.points.slice(0).reverse(), function(z) {
                  return E(z.plotY);
                })), O = this.itemMarginTop + C.legendItem.label.getBBox().height + this.itemMarginBottom, w = C.yAxis.top - n.plotTop, C.visible ? (p = M ? M.plotY : C.yAxis.height, p += w - 0.3 * O) : p = w + C.yAxis.height, o.push({ target: p, size: O, item: C }));
              }, this);
              for (var c = 0, l = k(o, n.plotHeight); c < l.length; c++) {
                var h = l[c];
                e = h.item.legendItem || {}, E(h.pos) && (e.y = n.plotTop - n.spacing[0] + h.pos);
              }
            }, a.prototype.render = function() {
              var e, n, o, i, c = this, l = c.chart, h = l.renderer, C = c.options, M = c.padding, O = c.getAllItems(), p = c.group, w = c.box;
              c.itemX = M, c.itemY = c.initialItemY, c.offsetWidth = 0, c.lastItemY = 0, c.widthOption = u(C.width, l.spacingBox.width - M), i = l.spacingBox.width - 2 * M - C.x, ["rm", "lm"].indexOf(c.getAlignment().substring(0, 2)) > -1 && (i /= 2), c.maxLegendWidth = c.widthOption || i, p || (c.group = p = h.g("legend").addClass(C.className || "").attr({ zIndex: 7 }).add(), c.contentGroup = h.g().attr({ zIndex: 1 }).add(p), c.scrollGroup = h.g().add(c.contentGroup)), c.renderTitle(), y(O, function(T, z) {
                return (T.options && T.options.legendIndex || 0) - (z.options && z.options.legendIndex || 0);
              }), C.reversed && O.reverse(), c.allItems = O, c.display = e = !!O.length, c.lastLineHeight = 0, c.maxItemWidth = 0, c.totalItemWidth = 0, c.itemHeight = 0, O.forEach(c.renderItem, c), O.forEach(c.layoutItem, c), n = (c.widthOption || c.offsetWidth) + M, o = c.lastItemY + c.lastLineHeight + c.titleHeight, o = c.handleOverflow(o), o += M, w || (c.box = w = h.rect().addClass("highcharts-legend-box").attr({ r: C.borderRadius }).add(p)), l.styledMode || w.attr({ stroke: C.borderColor, "stroke-width": C.borderWidth || 0, fill: C.backgroundColor || "none" }).shadow(C.shadow), n > 0 && o > 0 && w[w.placed ? "animate" : "attr"](w.crisp.call({}, { x: 0, y: 0, width: n, height: o }, w.strokeWidth())), p[e ? "show" : "hide"](), l.styledMode && p.getStyle("display") === "none" && (n = o = 0), c.legendWidth = n, c.legendHeight = o, e && c.align(), this.proximate || this.positionItems(), x(this, "afterRender");
            }, a.prototype.align = function(e) {
              e === void 0 && (e = this.chart.spacingBox);
              var n = this.chart, o = this.options, i = e.y;
              /(lth|ct|rth)/.test(this.getAlignment()) && n.titleOffset[0] > 0 ? i += n.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && n.titleOffset[2] > 0 && (i -= n.titleOffset[2]), i !== e.y && (e = P(e, { y: i })), n.hasRendered || (this.group.placed = !1), this.group.align(P(o, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : o.verticalAlign }), !0, e);
            }, a.prototype.handleOverflow = function(e) {
              var n, o, i, c = this, l = this.chart, h = l.renderer, C = this.options, M = C.y, O = C.verticalAlign === "top", p = this.padding, w = C.maxHeight, T = C.navigation, z = S(T.animation, !0), W = T.arrowSize || 12, L = this.pages, I = this.allItems, j = function(ot) {
                typeof ot == "number" ? et.attr({ height: ot }) : et && (c.clipRect = et.destroy(), c.contentGroup.clip()), c.contentGroup.div && (c.contentGroup.div.style.clip = ot ? "rect(" + p + "px,9999px," + (p + ot) + "px,0)" : "auto");
              }, Z = function(ot) {
                return c[ot] = h.circle(0, 0, 1.3 * W).translate(W / 2, W / 2).add(X), l.styledMode || c[ot].attr("fill", "rgba(0,0,0,0.0001)"), c[ot];
              }, V = l.spacingBox.height + (O ? -M : M) - p, X = this.nav, et = this.clipRect;
              return C.layout !== "horizontal" || C.verticalAlign === "middle" || C.floating || (V /= 2), w && (V = Math.min(V, w)), L.length = 0, e && V > 0 && e > V && T.enabled !== !1 ? (this.clipHeight = n = Math.max(V - 20 - this.titleHeight - p, 0), this.currentPage = S(this.currentPage, 1), this.fullHeight = e, I.forEach(function(ot, it) {
                var pt = (i = ot.legendItem || {}).y || 0, mt = Math.round(i.label.getBBox().height), Ct = L.length;
                (!Ct || pt - L[Ct - 1] > n && (o || pt) !== L[Ct - 1]) && (L.push(o || pt), Ct++), i.pageIx = Ct - 1, o && ((I[it - 1].legendItem || {}).pageIx = Ct - 1), it === I.length - 1 && pt + mt - L[Ct - 1] > n && mt <= n && (L.push(pt), i.pageIx = Ct), pt !== o && (o = pt);
              }), et || (et = c.clipRect = h.clipRect(0, p, 9999, 0), c.contentGroup.clip(et)), j(n), X || (this.nav = X = h.g().attr({ zIndex: 1 }).add(this.group), this.up = h.symbol("triangle", 0, 0, W, W).add(X), Z("upTracker").on("click", function() {
                c.scroll(-1, z);
              }), this.pager = h.text("", 15, 10).addClass("highcharts-legend-navigation"), !l.styledMode && T.style && this.pager.css(T.style), this.pager.add(X), this.down = h.symbol("triangle-down", 0, 0, W, W).add(X), Z("downTracker").on("click", function() {
                c.scroll(1, z);
              })), c.scroll(0), e = V) : X && (j(), this.nav = X.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), e;
            }, a.prototype.scroll = function(e, n) {
              var o = this, i = this.chart, c = this.pages, l = c.length, h = this.clipHeight, C = this.options.navigation, M = this.pager, O = this.padding, p = this.currentPage + e;
              if (p > l && (p = l), p > 0) {
                n !== void 0 && U(n, i), this.nav.attr({ translateX: O, translateY: h + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(T) {
                  T.attr({ class: p === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
                }), M.attr({ text: p + "/" + l }), [this.down, this.downTracker].forEach(function(T) {
                  T.attr({ x: 18 + this.pager.getBBox().width, class: p === l ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
                }, this), i.styledMode || (this.up.attr({ fill: p === 1 ? C.inactiveColor : C.activeColor }), this.upTracker.css({ cursor: p === 1 ? "default" : "pointer" }), this.down.attr({ fill: p === l ? C.inactiveColor : C.activeColor }), this.downTracker.css({ cursor: p === l ? "default" : "pointer" })), this.scrollOffset = -c[p - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = p, this.positionCheckboxes();
                var w = q(S(n, i.renderer.globalAnimation, !0));
                s(function() {
                  x(o, "afterScroll", { currentPage: p });
                }, w.duration);
              }
            }, a.prototype.setItemEvents = function(e, n, o) {
              for (var i = this, c = e.legendItem || {}, l = i.chart.renderer.boxWrapper, h = e instanceof Y, C = "highcharts-legend-" + (h ? "point" : "series") + "-active", M = i.chart.styledMode, O = o ? [n, c.symbol] : [c.group], p = function(W) {
                i.allItems.forEach(function(L) {
                  e !== L && [L].concat(L.linkedSeries || []).forEach(function(I) {
                    I.setState(W, !h);
                  });
                });
              }, w = 0, T = O; w < T.length; w++) {
                var z = T[w];
                z && z.on("mouseover", function() {
                  e.visible && p("inactive"), e.setState("hover"), e.visible && l.addClass(C), M || n.css(i.options.itemHoverStyle);
                }).on("mouseout", function() {
                  i.chart.styledMode || n.css(P(e.visible ? i.itemStyle : i.itemHiddenStyle)), p(""), l.removeClass(C), e.setState();
                }).on("click", function(W) {
                  var L = "legendItemClick", I = function() {
                    e.setVisible && e.setVisible(), p(e.visible ? "inactive" : "");
                  };
                  l.removeClass(C), W = { browserEvent: W }, e.firePointEvent ? e.firePointEvent(L, W, I) : x(e, L, W, I);
                });
              }
            }, a.prototype.createCheckboxForItem = function(e) {
              e.checkbox = b("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: e.selected, defaultChecked: e.selected }, this.options.itemCheckboxStyle, this.chart.container), A(e.checkbox, "click", function(n) {
                var o = n.target;
                x(e.series || e, "checkboxClick", { checked: o.checked, item: e }, function() {
                  e.select();
                });
              });
            }, a;
          }();
        }), at(_, "Core/Series/SeriesRegistry.js", [_["Core/Globals.js"], _["Core/Defaults.js"], _["Core/Series/Point.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = F.defaultOptions, q = Y.extendClass, U = Y.merge;
          return function(N) {
            function D(k, A) {
              var b = Q.plotOptions || {}, d = A.defaultOptions, m = A.prototype;
              m.type = k, m.pointClass || (m.pointClass = $), d && (b[k] = d), N.seriesTypes[k] = A;
            }
            N.seriesTypes = G.seriesTypes, N.registerSeriesType = D, N.seriesType = function(k, A, b, d, m) {
              var v = Q.plotOptions || {};
              return A = A || "", v[k] = U(v[A], b), D(k, q(N.seriesTypes[A] || function() {
              }, d)), N.seriesTypes[k].prototype.type = k, m && (N.seriesTypes[k].prototype.pointClass = q($, m)), N.seriesTypes[k];
            };
          }(J || (J = {})), J;
        }), at(_, "Core/Chart/Chart.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Axis/Axis.js"], _["Core/Defaults.js"], _["Core/FormatUtilities.js"], _["Core/Foundation.js"], _["Core/Globals.js"], _["Core/Legend/Legend.js"], _["Core/MSPointer.js"], _["Core/Pointer.js"], _["Core/Renderer/RendererRegistry.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Time.js"], _["Core/Utilities.js"], _["Core/Renderer/HTML/AST.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A, b, d, m) {
          var v = G.animate, g = G.animObject, x = G.setAnimation, E = $.defaultOptions, P = $.defaultTime, S = Y.numberFormat, u = J.registerEventOptions, y = Q.charts, s = Q.doc, a = Q.marginNames, e = Q.svg, n = Q.win, o = k.seriesTypes, i = d.addEvent, c = d.attr, l = d.cleanRecursively, h = d.createElement, C = d.css, M = d.defined, O = d.discardElement, p = d.erase, w = d.error, T = d.extend, z = d.find, W = d.fireEvent, L = d.getStyle, I = d.isArray, j = d.isNumber, Z = d.isObject, V = d.isString, X = d.merge, et = d.objectEach, ot = d.pick, it = d.pInt, pt = d.relativeLength, mt = d.removeEvent, Ct = d.splat, kt = d.syncTimeout, Lt = d.uniqueKey, Tt = function() {
            function xt(ct, ft, St) {
              this.axes = void 0, this.axisOffset = void 0, this.bounds = void 0, this.chartHeight = void 0, this.chartWidth = void 0, this.clipBox = void 0, this.colorCounter = void 0, this.container = void 0, this.eventOptions = void 0, this.index = void 0, this.isResizing = void 0, this.labelCollectors = void 0, this.legend = void 0, this.margin = void 0, this.numberFormatter = void 0, this.options = void 0, this.plotBox = void 0, this.plotHeight = void 0, this.plotLeft = void 0, this.plotTop = void 0, this.plotWidth = void 0, this.pointCount = void 0, this.pointer = void 0, this.renderer = void 0, this.renderTo = void 0, this.series = void 0, this.sharedClips = {}, this.spacing = void 0, this.spacingBox = void 0, this.symbolCounter = void 0, this.time = void 0, this.titleOffset = void 0, this.userOptions = void 0, this.xAxis = void 0, this.yAxis = void 0, this.getArgs(ct, ft, St);
            }
            return xt.chart = function(ct, ft, St) {
              return new xt(ct, ft, St);
            }, xt.prototype.getArgs = function(ct, ft, St) {
              V(ct) || ct.nodeName ? (this.renderTo = ct, this.init(ft, St)) : this.init(ct, ft);
            }, xt.prototype.init = function(ct, ft) {
              var St = ct.plotOptions || {};
              W(this, "init", { args: arguments }, function() {
                var Mt = X(E, ct), Dt = Mt.chart;
                et(Mt.plotOptions, function(Wt, zt) {
                  Z(Wt) && (Wt.tooltip = St[zt] && X(St[zt].tooltip) || void 0);
                }), Mt.tooltip.userOptions = ct.chart && ct.chart.forExport && ct.tooltip.userOptions || ct.tooltip, this.userOptions = ct, this.margin = [], this.spacing = [], this.bounds = { h: {}, v: {} }, this.labelCollectors = [], this.callback = ft, this.isResizing = 0;
                var Ot = Dt.zooming = Dt.zooming || {};
                ct.chart && !ct.chart.zooming && (Ot.resetButton = Dt.resetZoomButton), Ot.key = ot(Ot.key, Dt.zoomKey), Ot.pinchType = ot(Ot.pinchType, Dt.pinchType), Ot.singleTouch = ot(Ot.singleTouch, Dt.zoomBySingleTouch), Ot.type = ot(Ot.type, Dt.zoomType), this.options = Mt, this.axes = [], this.series = [], this.time = ct.time && Object.keys(ct.time).length ? new b(ct.time) : Q.time, this.numberFormatter = Dt.numberFormatter || S, this.styledMode = Dt.styledMode, this.hasCartesianSeries = Dt.showAxes;
                var Nt = this;
                Nt.index = y.length, y.push(Nt), Q.chartCount++, u(this, Dt), Nt.xAxis = [], Nt.yAxis = [], Nt.pointCount = Nt.colorCounter = Nt.symbolCounter = 0, W(Nt, "afterInit"), Nt.firstRender();
              });
            }, xt.prototype.initSeries = function(ct) {
              var ft = this, St = ft.options.chart, Mt = ct.type || St.type || St.defaultSeriesType, Dt = o[Mt];
              Dt || w(17, !0, ft, { missingModuleFor: Mt });
              var Ot = new Dt();
              return typeof Ot.init == "function" && Ot.init(ft, ct), Ot;
            }, xt.prototype.setSeriesData = function() {
              this.getSeriesOrderByLinks().forEach(function(ct) {
                ct.points || ct.data || !ct.enabledDataSorting || ct.setData(ct.options.data, !1);
              });
            }, xt.prototype.getSeriesOrderByLinks = function() {
              return this.series.concat().sort(function(ct, ft) {
                return ct.linkedSeries.length || ft.linkedSeries.length ? ft.linkedSeries.length - ct.linkedSeries.length : 0;
              });
            }, xt.prototype.orderSeries = function(ct) {
              for (var ft = this.series, St = ct || 0, Mt = ft.length; St < Mt; ++St)
                ft[St] && (ft[St].index = St, ft[St].name = ft[St].getName());
            }, xt.prototype.isInsidePlot = function(ct, ft, St) {
              var Mt;
              St === void 0 && (St = {});
              var Dt = this, Ot = Dt.inverted, Nt = Dt.plotBox, Wt = Dt.plotLeft, zt = Dt.plotTop, Ht = Dt.scrollablePlotBox, Kt = 0, Gt = 0;
              St.visiblePlotOnly && this.scrollingContainer && (Kt = (Mt = this.scrollingContainer).scrollLeft, Gt = Mt.scrollTop);
              var ee = St.series, Jt = St.visiblePlotOnly && Ht || Nt, Qt = St.inverted ? ft : ct, ne = St.inverted ? ct : ft, ae = { x: Qt, y: ne, isInsidePlot: !0, options: St };
              if (!St.ignoreX) {
                var Me = ee && (Ot && !this.polar ? ee.yAxis : ee.xAxis) || { pos: Wt, len: 1 / 0 }, he = St.paneCoordinates ? Me.pos + Qt : Wt + Qt;
                he >= Math.max(Kt + Wt, Me.pos) && he <= Math.min(Kt + Wt + Jt.width, Me.pos + Me.len) || (ae.isInsidePlot = !1);
              }
              if (!St.ignoreY && ae.isInsidePlot) {
                var fe = St.axis && !St.axis.isXAxis && St.axis || ee && (Ot ? ee.xAxis : ee.yAxis) || { pos: zt, len: 1 / 0 }, Ee = St.paneCoordinates ? fe.pos + ne : zt + ne;
                Ee >= Math.max(Gt + zt, fe.pos) && Ee <= Math.min(Gt + zt + Jt.height, fe.pos + fe.len) || (ae.isInsidePlot = !1);
              }
              return W(this, "afterIsInsidePlot", ae), ae.isInsidePlot;
            }, xt.prototype.redraw = function(ct) {
              W(this, "beforeRedraw");
              var ft, St, Mt, Dt, Ot = this, Nt = Ot.hasCartesianSeries ? Ot.axes : Ot.colorAxis || [], Wt = Ot.series, zt = Ot.pointer, Ht = Ot.legend, Kt = Ot.userOptions.legend, Gt = Ot.renderer, ee = Gt.isHidden(), Jt = [], Qt = Ot.isDirtyBox, ne = Ot.isDirtyLegend;
              for (Ot.setResponsive && Ot.setResponsive(!1), x(!!Ot.hasRendered && ct, Ot), ee && Ot.temporaryDisplay(), Ot.layOutTitles(), Mt = Wt.length; Mt--; )
                if (((Dt = Wt[Mt]).options.stacking || Dt.options.centerInCategory) && (St = !0, Dt.isDirty)) {
                  ft = !0;
                  break;
                }
              if (ft)
                for (Mt = Wt.length; Mt--; )
                  (Dt = Wt[Mt]).options.stacking && (Dt.isDirty = !0);
              Wt.forEach(function(ae) {
                ae.isDirty && (ae.options.legendType === "point" ? (typeof ae.updateTotals == "function" && ae.updateTotals(), ne = !0) : Kt && (Kt.labelFormatter || Kt.labelFormat) && (ne = !0)), ae.isDirtyData && W(ae, "updatedData");
              }), ne && Ht && Ht.options.enabled && (Ht.render(), Ot.isDirtyLegend = !1), St && Ot.getStacks(), Nt.forEach(function(ae) {
                ae.updateNames(), ae.setScale();
              }), Ot.getMargins(), Nt.forEach(function(ae) {
                ae.isDirty && (Qt = !0);
              }), Nt.forEach(function(ae) {
                var Me = ae.min + "," + ae.max;
                ae.extKey !== Me && (ae.extKey = Me, Jt.push(function() {
                  W(ae, "afterSetExtremes", T(ae.eventArgs, ae.getExtremes())), delete ae.eventArgs;
                })), (Qt || St) && ae.redraw();
              }), Qt && Ot.drawChartBox(), W(Ot, "predraw"), Wt.forEach(function(ae) {
                (Qt || ae.isDirty) && ae.visible && ae.redraw(), ae.isDirtyData = !1;
              }), zt && zt.reset(!0), Gt.draw(), W(Ot, "redraw"), W(Ot, "render"), ee && Ot.temporaryDisplay(!0), Jt.forEach(function(ae) {
                ae.call();
              });
            }, xt.prototype.get = function(ct) {
              var ft = this.series;
              function St(Ot) {
                return Ot.id === ct || Ot.options && Ot.options.id === ct;
              }
              for (var Mt = z(this.axes, St) || z(this.series, St), Dt = 0; !Mt && Dt < ft.length; Dt++)
                Mt = z(ft[Dt].points || [], St);
              return Mt;
            }, xt.prototype.getAxes = function() {
              var ct = this, ft = this.options, St = ft.xAxis = Ct(ft.xAxis || {}), Mt = ft.yAxis = Ct(ft.yAxis || {});
              W(this, "getAxes"), St.forEach(function(Dt, Ot) {
                Dt.index = Ot, Dt.isX = !0;
              }), Mt.forEach(function(Dt, Ot) {
                Dt.index = Ot;
              }), St.concat(Mt).forEach(function(Dt) {
                new F(ct, Dt);
              }), W(this, "afterGetAxes");
            }, xt.prototype.getSelectedPoints = function() {
              return this.series.reduce(function(ct, ft) {
                return ft.getPointsCollection().forEach(function(St) {
                  ot(St.selectedStaging, St.selected) && ct.push(St);
                }), ct;
              }, []);
            }, xt.prototype.getSelectedSeries = function() {
              return this.series.filter(function(ct) {
                return ct.selected;
              });
            }, xt.prototype.setTitle = function(ct, ft, St) {
              this.applyDescription("title", ct), this.applyDescription("subtitle", ft), this.applyDescription("caption", void 0), this.layOutTitles(St);
            }, xt.prototype.applyDescription = function(ct, ft) {
              var St = this, Mt = ct === "title" ? { color: "#333333", fontSize: this.options.isStock ? "16px" : "18px" } : { color: "#666666" }, Dt = this.options[ct] = X(!this.styledMode && { style: Mt }, this.options[ct], ft), Ot = this[ct];
              Ot && ft && (this[ct] = Ot = Ot.destroy()), Dt && !Ot && ((Ot = this.renderer.text(Dt.text, 0, 0, Dt.useHTML).attr({ align: Dt.align, class: "highcharts-" + ct, zIndex: Dt.zIndex || 4 }).add()).update = function(Nt) {
                St[{ title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }[ct]](Nt);
              }, this.styledMode || Ot.css(Dt.style), this[ct] = Ot);
            }, xt.prototype.layOutTitles = function(ct) {
              var ft = [0, 0, 0], St = this.renderer, Mt = this.spacingBox;
              ["title", "subtitle", "caption"].forEach(function(Ot) {
                var Nt, Wt, zt = this[Ot], Ht = this.options[Ot], Kt = Ht.verticalAlign || "top", Gt = Ot === "title" ? Kt === "top" ? -3 : 0 : Kt === "top" ? ft[0] + 2 : 0;
                zt && (this.styledMode || (Nt = Ht.style && Ht.style.fontSize), Nt = St.fontMetrics(Nt, zt).b, zt.css({ width: (Ht.width || Mt.width + (Ht.widthAdjust || 0)) + "px" }), Wt = Math.round(zt.getBBox(Ht.useHTML).height), zt.align(T({ y: Kt === "bottom" ? Nt : Gt + Nt, height: Wt }, Ht), !1, "spacingBox"), Ht.floating || (Kt === "top" ? ft[0] = Math.ceil(ft[0] + Wt) : Kt === "bottom" && (ft[2] = Math.ceil(ft[2] + Wt))));
              }, this), ft[0] && (this.options.title.verticalAlign || "top") === "top" && (ft[0] += this.options.title.margin), ft[2] && this.options.caption.verticalAlign === "bottom" && (ft[2] += this.options.caption.margin);
              var Dt = !this.titleOffset || this.titleOffset.join(",") !== ft.join(",");
              this.titleOffset = ft, W(this, "afterLayOutTitles"), !this.isDirtyBox && Dt && (this.isDirtyBox = this.isDirtyLegend = Dt, this.hasRendered && ot(ct, !0) && this.isDirtyBox && this.redraw());
            }, xt.prototype.getChartSize = function() {
              var ct = this, ft = ct.options.chart, St = ft.width, Mt = ft.height, Dt = ct.renderTo;
              M(St) || (ct.containerWidth = L(Dt, "width")), M(Mt) || (ct.containerHeight = L(Dt, "height")), ct.chartWidth = Math.max(0, St || ct.containerWidth || 600), ct.chartHeight = Math.max(0, pt(Mt, ct.chartWidth) || (ct.containerHeight > 1 ? ct.containerHeight : 400));
            }, xt.prototype.temporaryDisplay = function(ct) {
              var ft, St = this.renderTo;
              if (ct)
                for (; St && St.style; )
                  St.hcOrigStyle && (C(St, St.hcOrigStyle), delete St.hcOrigStyle), St.hcOrigDetached && (s.body.removeChild(St), St.hcOrigDetached = !1), St = St.parentNode;
              else
                for (; St && St.style && (s.body.contains(St) || St.parentNode || (St.hcOrigDetached = !0, s.body.appendChild(St)), (L(St, "display", !1) === "none" || St.hcOricDetached) && (St.hcOrigStyle = { display: St.style.display, height: St.style.height, overflow: St.style.overflow }, ft = { display: "block", overflow: "hidden" }, St !== this.renderTo && (ft.height = 0), C(St, ft), St.offsetWidth || St.style.setProperty("display", "block", "important")), (St = St.parentNode) !== s.body); )
                  ;
            }, xt.prototype.setClassName = function(ct) {
              this.container.className = "highcharts-container " + (ct || "");
            }, xt.prototype.getContainer = function() {
              var ct, ft = this, St = ft.options, Mt = St.chart, Dt = "data-highcharts-chart", Ot = Lt(), Nt = ft.renderTo;
              Nt || (ft.renderTo = Nt = Mt.renderTo), V(Nt) && (ft.renderTo = Nt = s.getElementById(Nt)), Nt || w(13, !0, ft);
              var Wt = it(c(Nt, Dt));
              j(Wt) && y[Wt] && y[Wt].hasRendered && y[Wt].destroy(), c(Nt, Dt, ft.index), Nt.innerHTML = m.emptyHTML, Mt.skipClone || Nt.offsetWidth || ft.temporaryDisplay(), ft.getChartSize();
              var zt = ft.chartWidth, Ht = ft.chartHeight;
              C(Nt, { overflow: "hidden" }), ft.styledMode || (ct = T({ position: "relative", overflow: "hidden", width: zt + "px", height: Ht + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none" }, Mt.style || {}));
              var Kt = h("div", { id: Ot }, ct, Nt);
              ft.container = Kt, ft._cursor = Kt.style.cursor;
              var Gt = Mt.renderer || !e ? D.getRendererType(Mt.renderer) : A;
              if (ft.renderer = new Gt(Kt, zt, Ht, void 0, Mt.forExport, St.exporting && St.exporting.allowHTML, ft.styledMode), x(void 0, ft), ft.setClassName(Mt.className), ft.styledMode)
                for (var ee in St.defs)
                  this.renderer.definition(St.defs[ee]);
              else
                ft.renderer.setStyle(Mt.style);
              ft.renderer.chartIndex = ft.index, W(this, "afterGetContainer");
            }, xt.prototype.getMargins = function(ct) {
              var ft = this, St = ft.spacing, Mt = ft.margin, Dt = ft.titleOffset;
              this.resetMargins(), Dt[0] && !M(Mt[0]) && (this.plotTop = Math.max(this.plotTop, Dt[0] + St[0])), Dt[2] && !M(Mt[2]) && (this.marginBottom = Math.max(this.marginBottom, Dt[2] + St[2])), this.legend && this.legend.display && this.legend.adjustMargins(Mt, St), W(this, "getMargins"), ct || this.getAxisMargins();
            }, xt.prototype.getAxisMargins = function() {
              var ct = this, ft = ct.axisOffset = [0, 0, 0, 0], St = ct.colorAxis, Mt = ct.margin, Dt = function(Ot) {
                Ot.forEach(function(Nt) {
                  Nt.visible && Nt.getOffset();
                });
              };
              ct.hasCartesianSeries ? Dt(ct.axes) : St && St.length && Dt(St), a.forEach(function(Ot, Nt) {
                M(Mt[Nt]) || (ct[Ot] += ft[Nt]);
              }), ct.setChartSize();
            }, xt.prototype.reflow = function(ct) {
              var ft = this, St = ft.options.chart, Mt = ft.renderTo, Dt = M(St.width) && M(St.height), Ot = St.width || L(Mt, "width"), Nt = St.height || L(Mt, "height"), Wt = ct ? ct.target : n;
              delete ft.pointer.chartPosition, Dt || ft.isPrinting || !Ot || !Nt || Wt !== n && Wt !== s || (Ot === ft.containerWidth && Nt === ft.containerHeight || (d.clearTimeout(ft.reflowTimeout), ft.reflowTimeout = kt(function() {
                ft.container && ft.setSize(void 0, void 0, !1);
              }, ct ? 100 : 0)), ft.containerWidth = Ot, ft.containerHeight = Nt);
            }, xt.prototype.setReflow = function(ct) {
              var ft = this;
              ct === !1 || this.unbindReflow ? ct === !1 && this.unbindReflow && (this.unbindReflow = this.unbindReflow()) : (this.unbindReflow = i(n, "resize", function(St) {
                ft.options && ft.reflow(St);
              }), i(this, "destroy", this.unbindReflow));
            }, xt.prototype.setSize = function(ct, ft, St) {
              var Mt = this, Dt = Mt.renderer;
              Mt.isResizing += 1, x(St, Mt);
              var Ot = Dt.globalAnimation;
              Mt.oldChartHeight = Mt.chartHeight, Mt.oldChartWidth = Mt.chartWidth, ct !== void 0 && (Mt.options.chart.width = ct), ft !== void 0 && (Mt.options.chart.height = ft), Mt.getChartSize(), Mt.styledMode || (Ot ? v : C)(Mt.container, { width: Mt.chartWidth + "px", height: Mt.chartHeight + "px" }, Ot), Mt.setChartSize(!0), Dt.setSize(Mt.chartWidth, Mt.chartHeight, Ot), Mt.axes.forEach(function(Nt) {
                Nt.isDirty = !0, Nt.setScale();
              }), Mt.isDirtyLegend = !0, Mt.isDirtyBox = !0, Mt.layOutTitles(), Mt.getMargins(), Mt.redraw(Ot), Mt.oldChartHeight = null, W(Mt, "resize"), kt(function() {
                Mt && W(Mt, "endResize", null, function() {
                  Mt.isResizing -= 1;
                });
              }, g(Ot).duration);
            }, xt.prototype.setChartSize = function(ct) {
              var ft, St, Mt, Dt, Ot = this, Nt = Ot.inverted, Wt = Ot.renderer, zt = Ot.chartWidth, Ht = Ot.chartHeight, Kt = Ot.options.chart, Gt = Ot.spacing, ee = Ot.clipOffset;
              Ot.plotLeft = ft = Math.round(Ot.plotLeft), Ot.plotTop = St = Math.round(Ot.plotTop), Ot.plotWidth = Mt = Math.max(0, Math.round(zt - ft - Ot.marginRight)), Ot.plotHeight = Dt = Math.max(0, Math.round(Ht - St - Ot.marginBottom)), Ot.plotSizeX = Nt ? Dt : Mt, Ot.plotSizeY = Nt ? Mt : Dt, Ot.plotBorderWidth = Kt.plotBorderWidth || 0, Ot.spacingBox = Wt.spacingBox = { x: Gt[3], y: Gt[0], width: zt - Gt[3] - Gt[1], height: Ht - Gt[0] - Gt[2] }, Ot.plotBox = Wt.plotBox = { x: ft, y: St, width: Mt, height: Dt };
              var Jt = 2 * Math.floor(Ot.plotBorderWidth / 2), Qt = Math.ceil(Math.max(Jt, ee[3]) / 2), ne = Math.ceil(Math.max(Jt, ee[0]) / 2);
              Ot.clipBox = { x: Qt, y: ne, width: Math.floor(Ot.plotSizeX - Math.max(Jt, ee[1]) / 2 - Qt), height: Math.max(0, Math.floor(Ot.plotSizeY - Math.max(Jt, ee[2]) / 2 - ne)) }, ct || (Ot.axes.forEach(function(ae) {
                ae.setAxisSize(), ae.setAxisTranslation();
              }), Wt.alignElements()), W(Ot, "afterSetChartSize", { skipAxes: ct });
            }, xt.prototype.resetMargins = function() {
              W(this, "resetMargins");
              var ct = this, ft = ct.options.chart;
              ["margin", "spacing"].forEach(function(St) {
                var Mt = ft[St], Dt = Z(Mt) ? Mt : [Mt, Mt, Mt, Mt];
                ["Top", "Right", "Bottom", "Left"].forEach(function(Ot, Nt) {
                  ct[St][Nt] = ot(ft[St + Ot], Dt[Nt]);
                });
              }), a.forEach(function(St, Mt) {
                ct[St] = ot(ct.margin[Mt], ct.spacing[Mt]);
              }), ct.axisOffset = [0, 0, 0, 0], ct.clipOffset = [0, 0, 0, 0];
            }, xt.prototype.drawChartBox = function() {
              var ct, ft, St, Mt = this, Dt = Mt.options.chart, Ot = Mt.renderer, Nt = Mt.chartWidth, Wt = Mt.chartHeight, zt = Mt.styledMode, Ht = Mt.plotBGImage, Kt = Dt.backgroundColor, Gt = Dt.plotBackgroundColor, ee = Dt.plotBackgroundImage, Jt = Mt.plotLeft, Qt = Mt.plotTop, ne = Mt.plotWidth, ae = Mt.plotHeight, Me = Mt.plotBox, he = Mt.clipRect, fe = Mt.clipBox, Ee = Mt.chartBackground, Xe = Mt.plotBackground, Se = Mt.plotBorder, Le = "animate";
              Ee || (Mt.chartBackground = Ee = Ot.rect().addClass("highcharts-background").add(), Le = "attr"), zt ? ct = ft = Ee.strokeWidth() : (ft = (ct = Dt.borderWidth || 0) + (Dt.shadow ? 8 : 0), St = { fill: Kt || "none" }, (ct || Ee["stroke-width"]) && (St.stroke = Dt.borderColor, St["stroke-width"] = ct), Ee.attr(St).shadow(Dt.shadow)), Ee[Le]({ x: ft / 2, y: ft / 2, width: Nt - ft - ct % 2, height: Wt - ft - ct % 2, r: Dt.borderRadius }), Le = "animate", Xe || (Le = "attr", Mt.plotBackground = Xe = Ot.rect().addClass("highcharts-plot-background").add()), Xe[Le](Me), zt || (Xe.attr({ fill: Gt || "none" }).shadow(Dt.plotShadow), ee && (Ht ? (ee !== Ht.attr("href") && Ht.attr("href", ee), Ht.animate(Me)) : Mt.plotBGImage = Ot.image(ee, Jt, Qt, ne, ae).add())), he ? he.animate({ width: fe.width, height: fe.height }) : Mt.clipRect = Ot.clipRect(fe), Le = "animate", Se || (Le = "attr", Mt.plotBorder = Se = Ot.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), zt || Se.attr({ stroke: Dt.plotBorderColor, "stroke-width": Dt.plotBorderWidth || 0, fill: "none" }), Se[Le](Se.crisp({ x: Jt, y: Qt, width: ne, height: ae }, -Se.strokeWidth())), Mt.isDirtyBox = !1, W(this, "afterDrawChartBox");
            }, xt.prototype.propFromSeries = function() {
              var ct, ft, St, Mt = this, Dt = Mt.options.chart, Ot = Mt.options.series;
              ["inverted", "angular", "polar"].forEach(function(Nt) {
                for (ft = o[Dt.type || Dt.defaultSeriesType], St = Dt[Nt] || ft && ft.prototype[Nt], ct = Ot && Ot.length; !St && ct--; )
                  (ft = o[Ot[ct].type]) && ft.prototype[Nt] && (St = !0);
                Mt[Nt] = St;
              });
            }, xt.prototype.linkSeries = function() {
              var ct = this, ft = ct.series;
              ft.forEach(function(St) {
                St.linkedSeries.length = 0;
              }), ft.forEach(function(St) {
                var Mt = St.options.linkedTo;
                V(Mt) && (Mt = Mt === ":previous" ? ct.series[St.index - 1] : ct.get(Mt)) && Mt.linkedParent !== St && (Mt.linkedSeries.push(St), St.linkedParent = Mt, Mt.enabledDataSorting && St.setDataSortingOptions(), St.visible = ot(St.options.visible, Mt.options.visible, St.visible));
              }), W(this, "afterLinkSeries");
            }, xt.prototype.renderSeries = function() {
              this.series.forEach(function(ct) {
                ct.translate(), ct.render();
              });
            }, xt.prototype.renderLabels = function() {
              var ct = this, ft = ct.options.labels;
              ft.items && ft.items.forEach(function(St) {
                var Mt = T(ft.style, St.style), Dt = it(Mt.left) + ct.plotLeft, Ot = it(Mt.top) + ct.plotTop + 12;
                delete Mt.left, delete Mt.top, ct.renderer.text(St.html, Dt, Ot).attr({ zIndex: 2 }).css(Mt).add();
              });
            }, xt.prototype.render = function() {
              var ct = this, ft = ct.axes, St = ct.colorAxis, Mt = ct.renderer, Dt = ct.options, Ot = function(Gt) {
                Gt.forEach(function(ee) {
                  ee.visible && ee.render();
                });
              }, Nt = 0;
              ct.setTitle(), ct.legend = new q(ct, Dt.legend), ct.getStacks && ct.getStacks(), ct.getMargins(!0), ct.setChartSize();
              var Wt = ct.plotWidth;
              ft.some(function(Gt) {
                if (Gt.horiz && Gt.visible && Gt.options.labels.enabled && Gt.series.length)
                  return Nt = 21, !0;
              }), ct.plotHeight = Math.max(ct.plotHeight - Nt, 0);
              var zt = ct.plotHeight;
              ft.forEach(function(Gt) {
                Gt.setScale();
              }), ct.getAxisMargins();
              var Ht = Wt / ct.plotWidth > 1.1, Kt = zt / ct.plotHeight > 1.05;
              (Ht || Kt) && (ft.forEach(function(Gt) {
                (Gt.horiz && Ht || !Gt.horiz && Kt) && Gt.setTickInterval(!0);
              }), ct.getMargins()), ct.drawChartBox(), ct.hasCartesianSeries ? Ot(ft) : St && St.length && Ot(St), ct.seriesGroup || (ct.seriesGroup = Mt.g("series-group").attr({ zIndex: 3 }).add()), ct.renderSeries(), ct.renderLabels(), ct.addCredits(), ct.setResponsive && ct.setResponsive(), ct.hasRendered = !0;
            }, xt.prototype.addCredits = function(ct) {
              var ft = this, St = X(!0, this.options.credits, ct);
              St.enabled && !this.credits && (this.credits = this.renderer.text(St.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                St.href && (n.location.href = St.href);
              }).attr({ align: St.position.align, zIndex: 8 }), ft.styledMode || this.credits.css(St.style), this.credits.add().align(St.position), this.credits.update = function(Mt) {
                ft.credits = ft.credits.destroy(), ft.addCredits(Mt);
              });
            }, xt.prototype.destroy = function() {
              var ct, ft = this, St = ft.axes, Mt = ft.series, Dt = ft.container, Ot = Dt && Dt.parentNode;
              for (W(ft, "destroy"), ft.renderer.forExport ? p(y, ft) : y[ft.index] = void 0, Q.chartCount--, ft.renderTo.removeAttribute("data-highcharts-chart"), mt(ft), ct = St.length; ct--; )
                St[ct] = St[ct].destroy();
              for (this.scroller && this.scroller.destroy && this.scroller.destroy(), ct = Mt.length; ct--; )
                Mt[ct] = Mt[ct].destroy();
              ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(Nt) {
                var Wt = ft[Nt];
                Wt && Wt.destroy && (ft[Nt] = Wt.destroy());
              }), Dt && (Dt.innerHTML = m.emptyHTML, mt(Dt), Ot && O(Dt)), et(ft, function(Nt, Wt) {
                delete ft[Wt];
              });
            }, xt.prototype.firstRender = function() {
              var ct = this, ft = ct.options;
              ct.isReadyToRender && !ct.isReadyToRender() || (ct.getContainer(), ct.resetMargins(), ct.setChartSize(), ct.propFromSeries(), ct.getAxes(), (I(ft.series) ? ft.series : []).forEach(function(St) {
                ct.initSeries(St);
              }), ct.linkSeries(), ct.setSeriesData(), W(ct, "beforeRender"), N && (U.isRequired() ? ct.pointer = new U(ct, ft) : ct.pointer = new N(ct, ft)), ct.render(), ct.pointer.getChartPosition(), ct.renderer.imgCount || ct.hasLoaded || ct.onload(), ct.temporaryDisplay(!0));
            }, xt.prototype.onload = function() {
              this.callbacks.concat([this.callback]).forEach(function(ct) {
                ct && this.index !== void 0 && ct.apply(this, [this]);
              }, this), W(this, "load"), W(this, "render"), M(this.index) && this.setReflow(this.options.chart.reflow), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
            }, xt.prototype.warnIfA11yModuleNotLoaded = function() {
              var ct = this.options, ft = this.title;
              ct && !this.accessibility && (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (ft && ft.element.textContent || "").replace(/</g, "&lt;") }), ct.accessibility && ct.accessibility.enabled === !1 || w('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }, xt.prototype.addSeries = function(ct, ft, St) {
              var Mt, Dt = this;
              return ct && (ft = ot(ft, !0), W(Dt, "addSeries", { options: ct }, function() {
                Mt = Dt.initSeries(ct), Dt.isDirtyLegend = !0, Dt.linkSeries(), Mt.enabledDataSorting && Mt.setData(ct.data, !1), W(Dt, "afterAddSeries", { series: Mt }), ft && Dt.redraw(St);
              })), Mt;
            }, xt.prototype.addAxis = function(ct, ft, St, Mt) {
              return this.createAxis(ft ? "xAxis" : "yAxis", { axis: ct, redraw: St, animation: Mt });
            }, xt.prototype.addColorAxis = function(ct, ft, St) {
              return this.createAxis("colorAxis", { axis: ct, redraw: ft, animation: St });
            }, xt.prototype.createAxis = function(ct, ft) {
              var St = new F(this, X(ft.axis, { index: this[ct].length, isX: ct === "xAxis" }));
              return ot(ft.redraw, !0) && this.redraw(ft.animation), St;
            }, xt.prototype.showLoading = function(ct) {
              var ft = this, St = ft.options, Mt = St.loading, Dt = function() {
                Ot && C(Ot, { left: ft.plotLeft + "px", top: ft.plotTop + "px", width: ft.plotWidth + "px", height: ft.plotHeight + "px" });
              }, Ot = ft.loadingDiv, Nt = ft.loadingSpan;
              Ot || (ft.loadingDiv = Ot = h("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, ft.container)), Nt || (ft.loadingSpan = Nt = h("span", { className: "highcharts-loading-inner" }, null, Ot), i(ft, "redraw", Dt)), Ot.className = "highcharts-loading", m.setElementHTML(Nt, ot(ct, St.lang.loading, "")), ft.styledMode || (C(Ot, T(Mt.style, { zIndex: 10 })), C(Nt, Mt.labelStyle), ft.loadingShown || (C(Ot, { opacity: 0, display: "" }), v(Ot, { opacity: Mt.style.opacity || 0.5 }, { duration: Mt.showDuration || 0 }))), ft.loadingShown = !0, Dt();
            }, xt.prototype.hideLoading = function() {
              var ct = this.options, ft = this.loadingDiv;
              ft && (ft.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || v(ft, { opacity: 0 }, { duration: ct.loading.hideDuration || 100, complete: function() {
                C(ft, { display: "none" });
              } })), this.loadingShown = !1;
            }, xt.prototype.update = function(ct, ft, St, Mt) {
              var Dt, Ot, Nt, Wt = this, zt = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, Ht = ct.isResponsiveOptions, Kt = [];
              W(Wt, "update", { options: ct }), Ht || Wt.setResponsive(!1, !0), ct = l(ct, Wt.options), Wt.userOptions = X(Wt.userOptions, ct);
              var Gt = ct.chart;
              Gt && (X(!0, Wt.options.chart, Gt), "className" in Gt && Wt.setClassName(Gt.className), "reflow" in Gt && Wt.setReflow(Gt.reflow), ("inverted" in Gt || "polar" in Gt || "type" in Gt) && (Wt.propFromSeries(), Dt = !0), "alignTicks" in Gt && (Dt = !0), "events" in Gt && u(this, Gt), et(Gt, function(Qt, ne) {
                Wt.propsRequireUpdateSeries.indexOf("chart." + ne) !== -1 && (Ot = !0), Wt.propsRequireDirtyBox.indexOf(ne) !== -1 && (Wt.isDirtyBox = !0), Wt.propsRequireReflow.indexOf(ne) !== -1 && (Ht ? Wt.isDirtyBox = !0 : Nt = !0);
              }), !Wt.styledMode && Gt.style && Wt.renderer.setStyle(Wt.options.chart.style || {})), !Wt.styledMode && ct.colors && (this.options.colors = ct.colors), ct.time && (this.time === P && (this.time = new b(ct.time)), X(!0, Wt.options.time, ct.time)), et(ct, function(Qt, ne) {
                Wt[ne] && typeof Wt[ne].update == "function" ? Wt[ne].update(Qt, !1) : typeof Wt[zt[ne]] == "function" ? Wt[zt[ne]](Qt) : ne !== "colors" && Wt.collectionsWithUpdate.indexOf(ne) === -1 && X(!0, Wt.options[ne], ct[ne]), ne !== "chart" && Wt.propsRequireUpdateSeries.indexOf(ne) !== -1 && (Ot = !0);
              }), this.collectionsWithUpdate.forEach(function(Qt) {
                var ne;
                ct[Qt] && (ne = [], Wt[Qt].forEach(function(ae, Me) {
                  ae.options.isInternal || ne.push(ot(ae.options.index, Me));
                }), Ct(ct[Qt]).forEach(function(ae, Me) {
                  var he, fe = M(ae.id);
                  fe && (he = Wt.get(ae.id)), !he && Wt[Qt] && (he = Wt[Qt][ne ? ne[Me] : Me]) && fe && M(he.options.id) && (he = void 0), he && he.coll === Qt && (he.update(ae, !1), St && (he.touched = !0)), !he && St && Wt.collectionsWithInit[Qt] && (Wt.collectionsWithInit[Qt][0].apply(Wt, [ae].concat(Wt.collectionsWithInit[Qt][1] || []).concat([!1])).touched = !0);
                }), St && Wt[Qt].forEach(function(ae) {
                  ae.touched || ae.options.isInternal ? delete ae.touched : Kt.push(ae);
                }));
              }), Kt.forEach(function(Qt) {
                Qt.chart && Qt.remove && Qt.remove(!1);
              }), Dt && Wt.axes.forEach(function(Qt) {
                Qt.update({}, !1);
              }), Ot && Wt.getSeriesOrderByLinks().forEach(function(Qt) {
                Qt.chart && Qt.update({}, !1);
              }, this);
              var ee = Gt && Gt.width, Jt = Gt && (V(Gt.height) ? pt(Gt.height, ee || Wt.chartWidth) : Gt.height);
              Nt || j(ee) && ee !== Wt.chartWidth || j(Jt) && Jt !== Wt.chartHeight ? Wt.setSize(ee, Jt, Mt) : ot(ft, !0) && Wt.redraw(Mt), W(Wt, "afterUpdate", { options: ct, redraw: ft, animation: Mt });
            }, xt.prototype.setSubtitle = function(ct, ft) {
              this.applyDescription("subtitle", ct), this.layOutTitles(ft);
            }, xt.prototype.setCaption = function(ct, ft) {
              this.applyDescription("caption", ct), this.layOutTitles(ft);
            }, xt.prototype.showResetZoom = function() {
              var ct = this, ft = E.lang, St = ct.options.chart.zooming.resetButton, Mt = St.theme, Dt = St.relativeTo === "chart" || St.relativeTo === "spacingBox" ? null : "scrollablePlotBox";
              function Ot() {
                ct.zoomOut();
              }
              W(this, "beforeShowResetZoom", null, function() {
                ct.resetZoomButton = ct.renderer.button(ft.resetZoom, null, null, Ot, Mt).attr({ align: St.position.align, title: ft.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(St.position, !1, Dt);
              }), W(this, "afterShowResetZoom");
            }, xt.prototype.zoomOut = function() {
              W(this, "selection", { resetSelection: !0 }, this.zoom);
            }, xt.prototype.zoom = function(ct) {
              var ft, St = this, Mt = St.pointer, Dt = !1;
              !ct || ct.resetSelection ? (St.axes.forEach(function(Nt) {
                ft = Nt.zoom();
              }), Mt.initiated = !1) : ct.xAxis.concat(ct.yAxis).forEach(function(Nt) {
                var Wt = Nt.axis, zt = Wt.isXAxis;
                (Mt[zt ? "zoomX" : "zoomY"] && M(Mt.mouseDownX) && M(Mt.mouseDownY) && St.isInsidePlot(Mt.mouseDownX - St.plotLeft, Mt.mouseDownY - St.plotTop, { axis: Wt }) || !M(St.inverted ? Mt.mouseDownX : Mt.mouseDownY)) && (ft = Wt.zoom(Nt.min, Nt.max), Wt.displayBtn && (Dt = !0));
              });
              var Ot = St.resetZoomButton;
              Dt && !Ot ? St.showResetZoom() : !Dt && Z(Ot) && (St.resetZoomButton = Ot.destroy()), ft && St.redraw(ot(St.options.chart.animation, ct && ct.animation, St.pointCount < 100));
            }, xt.prototype.pan = function(ct, ft) {
              var St = this, Mt = St.hoverPoints, Dt = typeof ft == "object" ? ft : { enabled: ft, type: "x" }, Ot = St.options.chart;
              Ot && Ot.panning && (Ot.panning = Dt);
              var Nt, Wt = Dt.type;
              W(this, "pan", { originalEvent: ct }, function() {
                Mt && Mt.forEach(function(Kt) {
                  Kt.setState();
                });
                var zt = St.xAxis;
                Wt === "xy" ? zt = zt.concat(St.yAxis) : Wt === "y" && (zt = St.yAxis);
                var Ht = {};
                zt.forEach(function(Kt) {
                  if (Kt.options.panningEnabled && !Kt.options.isInternal) {
                    var Gt, ee = Kt.horiz, Jt = ct[ee ? "chartX" : "chartY"], Qt = ee ? "mouseDownX" : "mouseDownY", ne = St[Qt], ae = Kt.minPointOffset || 0, Me = Kt.reversed && !St.inverted || !Kt.reversed && St.inverted ? -1 : 1, he = Kt.getExtremes(), fe = Kt.toValue(ne - Jt, !0) + ae * Me, Ee = Kt.toValue(ne + Kt.len - Jt, !0) - (ae * Me || Kt.isXAxis && Kt.pointRangePadding || 0), Xe = Ee < fe, Se = Kt.hasVerticalPanning(), Le = Xe ? Ee : fe, Ye = Xe ? fe : Ee, qt = Kt.panningState;
                    !Se || Kt.isXAxis || qt && !qt.isDirty || Kt.series.forEach(function(xe) {
                      var Ve = xe.getProcessedData(!0), ze = xe.getExtremes(Ve.yData, !0);
                      qt || (qt = { startMin: Number.MAX_VALUE, startMax: -Number.MAX_VALUE }), j(ze.dataMin) && j(ze.dataMax) && (qt.startMin = Math.min(ot(xe.options.threshold, 1 / 0), ze.dataMin, qt.startMin), qt.startMax = Math.max(ot(xe.options.threshold, -1 / 0), ze.dataMax, qt.startMax));
                    });
                    var ue = Math.min(ot(qt && qt.startMin, he.dataMin), ae ? he.min : Kt.toValue(Kt.toPixels(he.min) - Kt.minPixelPadding)), ye = Math.max(ot(qt && qt.startMax, he.dataMax), ae ? he.max : Kt.toValue(Kt.toPixels(he.max) + Kt.minPixelPadding));
                    Kt.panningState = qt, Kt.isOrdinal || ((Gt = ue - Le) > 0 && (Ye += Gt, Le = ue), (Gt = Ye - ye) > 0 && (Ye = ye, Le -= Gt), Kt.series.length && Le !== he.min && Ye !== he.max && Le >= ue && Ye <= ye && (Kt.setExtremes(Le, Ye, !1, !1, { trigger: "pan" }), !St.resetZoomButton && Le !== ue && Ye !== ye && Wt.match("y") && (St.showResetZoom(), Kt.displayBtn = !1), Nt = !0), Ht[Qt] = Jt);
                  }
                }), et(Ht, function(Kt, Gt) {
                  St[Gt] = Kt;
                }), Nt && St.redraw(!1), C(St.container, { cursor: "move" });
              });
            }, xt;
          }();
          return T(Tt.prototype, { callbacks: [], collectionsWithInit: { xAxis: [Tt.prototype.addAxis, [!0]], yAxis: [Tt.prototype.addAxis, [!1]], series: [Tt.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), Tt;
        }), at(_, "Core/Legend/LegendSymbol.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.extend, Y = G.merge, J = G.pick;
          return function(Q) {
            Q.drawLineMarker = function(q) {
              var U, N = this.legendItem = this.legendItem || {}, D = this.options, k = q.symbolWidth, A = q.symbolHeight, b = A / 2, d = this.chart.renderer, m = N.group, v = q.baseline - Math.round(0.3 * q.fontMetrics.b), g = {}, x = D.marker, E = 0;
              if (this.chart.styledMode || (g = { "stroke-width": Math.min(D.lineWidth || 0, 24) }, D.dashStyle ? g.dashstyle = D.dashStyle : D.linecap !== "square" && (g["stroke-linecap"] = "round")), N.line = d.path().addClass("highcharts-graph").attr(g).add(m), g["stroke-linecap"] && (E = Math.min(N.line.strokeWidth(), k) / 2), N.line.attr({ d: [["M", E, v], ["L", k - E, v]] }), x && x.enabled !== !1 && k) {
                var P = Math.min(J(x.radius, b), b);
                this.symbol.indexOf("url") === 0 && (x = Y(x, { width: A, height: A }), P = 0), N.symbol = U = d.symbol(this.symbol, k / 2 - P, v - P, 2 * P, 2 * P, $({ context: "legend" }, x)).addClass("highcharts-point").add(m), U.isMarker = !0;
              }
            }, Q.drawRectangle = function(q, U) {
              var N = U.legendItem || {}, D = q.options, k = q.symbolHeight, A = D.squareSymbol, b = A ? k : q.symbolWidth;
              N.symbol = this.chart.renderer.rect(A ? (q.symbolWidth - k) / 2 : 0, q.baseline - k + 1, b, k, J(q.options.symbolRadius, k / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(N.group);
            };
          }(F || (F = {})), F;
        }), at(_, "Core/Series/SeriesDefaults.js", [], function() {
          return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 50 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
            var G = this.series.chart.numberFormatter;
            return typeof this.y != "number" ? "" : G(this.y, -1);
          }, padding: 5, style: { fontSize: "11px", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 50 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 50 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
        }), at(_, "Core/Series/Series.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Defaults.js"], _["Core/Foundation.js"], _["Core/Globals.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/Point.js"], _["Core/Series/SeriesDefaults.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N, D) {
          var k = G.animObject, A = G.setAnimation, b = F.defaultOptions, d = $.registerEventOptions, m = Y.hasTouch, v = Y.svg, g = Y.win, x = U.seriesTypes, E = D.arrayMax, P = D.arrayMin, S = D.clamp, u = D.cleanRecursively, y = D.correctFloat, s = D.defined, a = D.erase, e = D.error, n = D.extend, o = D.find, i = D.fireEvent, c = D.getNestedProperty, l = D.isArray, h = D.isNumber, C = D.isString, M = D.merge, O = D.objectEach, p = D.pick, w = D.removeEvent, T = D.splat, z = D.syncTimeout, W = function() {
            function L() {
              this._i = void 0, this.chart = void 0, this.data = void 0, this.eventOptions = void 0, this.eventsToUnbind = void 0, this.index = void 0, this.linkedSeries = void 0, this.options = void 0, this.points = void 0, this.processedXData = void 0, this.processedYData = void 0, this.tooltipOptions = void 0, this.userOptions = void 0, this.xAxis = void 0, this.yAxis = void 0, this.zones = void 0;
            }
            return L.prototype.init = function(I, j) {
              i(this, "init", { options: j });
              var Z = this, V = I.series;
              this.eventsToUnbind = [], Z.chart = I, Z.options = Z.setOptions(j);
              var X = Z.options;
              Z.linkedSeries = [], Z.bindAxes(), n(Z, { name: X.name, state: "", visible: X.visible !== !1, selected: X.selected === !0 }), d(this, X);
              var et, ot = X.events;
              (ot && ot.click || X.point && X.point.events && X.point.events.click || X.allowPointSelect) && (I.runTrackerClick = !0), Z.getColor(), Z.getSymbol(), Z.parallelArrays.forEach(function(it) {
                Z[it + "Data"] || (Z[it + "Data"] = []);
              }), Z.isCartesian && (I.hasCartesianSeries = !0), V.length && (et = V[V.length - 1]), Z._i = p(et && et._i, -1) + 1, Z.opacity = Z.options.opacity, I.orderSeries(this.insert(V)), X.dataSorting && X.dataSorting.enabled ? Z.setDataSortingOptions() : Z.points || Z.data || Z.setData(X.data, !1), i(this, "afterInit");
            }, L.prototype.is = function(I) {
              return x[I] && this instanceof x[I];
            }, L.prototype.insert = function(I) {
              var j, Z = this.options.index;
              if (h(Z)) {
                for (j = I.length; j--; )
                  if (Z >= p(I[j].options.index, I[j]._i)) {
                    I.splice(j + 1, 0, this);
                    break;
                  }
                j === -1 && I.unshift(this), j += 1;
              } else
                I.push(this);
              return p(j, I.length - 1);
            }, L.prototype.bindAxes = function() {
              var I, j = this, Z = j.options, V = j.chart;
              i(this, "bindAxes", null, function() {
                (j.axisTypes || []).forEach(function(X) {
                  var et = 0;
                  V[X].forEach(function(ot) {
                    I = ot.options, (Z[X] === et && !I.isInternal || Z[X] !== void 0 && Z[X] === I.id || Z[X] === void 0 && I.index === 0) && (j.insert(ot.series), j[X] = ot, ot.isDirty = !0), I.isInternal || et++;
                  }), j[X] || j.optionalAxis === X || e(18, !0, V);
                });
              }), i(this, "afterBindAxes");
            }, L.prototype.updateParallelArrays = function(I, j) {
              var Z = I.series, V = arguments, X = h(j) ? function(et) {
                var ot = et === "y" && Z.toYData ? Z.toYData(I) : I[et];
                Z[et + "Data"][j] = ot;
              } : function(et) {
                Array.prototype[j].apply(Z[et + "Data"], Array.prototype.slice.call(V, 2));
              };
              Z.parallelArrays.forEach(X);
            }, L.prototype.hasData = function() {
              return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
            }, L.prototype.autoIncrement = function(I) {
              var j, Z, V = this.options, X = V.pointIntervalUnit, et = V.relativeXValue, ot = this.chart.time, it = this.xIncrement;
              return it = p(it, V.pointStart, 0), this.pointInterval = Z = p(this.pointInterval, V.pointInterval, 1), et && h(I) && (Z *= I), X && (j = new ot.Date(it), X === "day" ? ot.set("Date", j, ot.get("Date", j) + Z) : X === "month" ? ot.set("Month", j, ot.get("Month", j) + Z) : X === "year" && ot.set("FullYear", j, ot.get("FullYear", j) + Z), Z = j.getTime() - it), et && h(I) ? it + Z : (this.xIncrement = it + Z, it);
            }, L.prototype.setDataSortingOptions = function() {
              var I = this.options;
              n(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), s(I.pointRange) || (I.pointRange = 1);
            }, L.prototype.setOptions = function(I) {
              var j, Z = this.chart, V = Z.options, X = V.plotOptions, et = Z.userOptions || {}, ot = M(I), it = Z.styledMode, pt = { plotOptions: X, userOptions: ot };
              i(this, "setOptions", pt);
              var mt = pt.plotOptions[this.type], Ct = et.plotOptions || {};
              this.userOptions = pt.userOptions;
              var kt = M(mt, X.series, et.plotOptions && et.plotOptions[this.type], ot);
              this.tooltipOptions = M(b.tooltip, b.plotOptions.series && b.plotOptions.series.tooltip, b.plotOptions[this.type].tooltip, V.tooltip.userOptions, X.series && X.series.tooltip, X[this.type].tooltip, ot.tooltip), this.stickyTracking = p(ot.stickyTracking, Ct[this.type] && Ct[this.type].stickyTracking, Ct.series && Ct.series.stickyTracking, !(!this.tooltipOptions.shared || this.noSharedTooltip) || kt.stickyTracking), mt.marker === null && delete kt.marker, this.zoneAxis = kt.zoneAxis;
              var Lt = this.zones = (kt.zones || []).slice();
              return !kt.negativeColor && !kt.negativeFillColor || kt.zones || (j = { value: kt[this.zoneAxis + "Threshold"] || kt.threshold || 0, className: "highcharts-negative" }, it || (j.color = kt.negativeColor, j.fillColor = kt.negativeFillColor), Lt.push(j)), Lt.length && s(Lt[Lt.length - 1].value) && Lt.push(it ? {} : { color: this.color, fillColor: this.fillColor }), i(this, "afterSetOptions", { options: kt }), kt;
            }, L.prototype.getName = function() {
              return p(this.options.name, "Series " + (this.index + 1));
            }, L.prototype.getCyclic = function(I, j, Z) {
              var V, X, et = this.chart, ot = this.userOptions, it = I + "Index", pt = I + "Counter", mt = Z ? Z.length : p(et.options.chart[I + "Count"], et[I + "Count"]);
              j || (X = p(ot[it], ot["_" + it]), s(X) ? V = X : (et.series.length || (et[pt] = 0), ot["_" + it] = V = et[pt] % mt, et[pt] += 1), Z && (j = Z[V])), V !== void 0 && (this[it] = V), this[I] = j;
            }, L.prototype.getColor = function() {
              this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || b.plotOptions[this.type].color, this.chart.options.colors);
            }, L.prototype.getPointsCollection = function() {
              return (this.hasGroupedData ? this.points : this.data) || [];
            }, L.prototype.getSymbol = function() {
              var I = this.options.marker;
              this.getCyclic("symbol", I.symbol, this.chart.options.symbols);
            }, L.prototype.findPointIndex = function(I, j) {
              var Z, V, X, et = I.id, ot = I.x, it = this.points, pt = this.options.dataSorting;
              if (et) {
                var mt = this.chart.get(et);
                mt instanceof Q && (Z = mt);
              } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                var Ct = function(kt) {
                  return !kt.touched && kt.index === I.index;
                };
                if (pt && pt.matchByName ? Ct = function(kt) {
                  return !kt.touched && kt.name === I.name;
                } : this.options.relativeXValue && (Ct = function(kt) {
                  return !kt.touched && kt.options.x === I.x;
                }), !(Z = o(it, Ct)))
                  return;
              }
              return Z && (X = Z && Z.index) !== void 0 && (V = !0), X === void 0 && h(ot) && (X = this.xData.indexOf(ot, j)), X !== -1 && X !== void 0 && this.cropped && (X = X >= this.cropStart ? X - this.cropStart : X), !V && h(X) && it[X] && it[X].touched && (X = void 0), X;
            }, L.prototype.updateData = function(I, j) {
              var Z, V, X, et, ot = this.options, it = ot.dataSorting, pt = this.points, mt = [], Ct = this.requireSorting, kt = I.length === pt.length, Lt = !0;
              if (this.xIncrement = null, I.forEach(function(Tt, xt) {
                var ct, ft = s(Tt) && this.pointClass.prototype.optionsToObject.call({ series: this }, Tt) || {}, St = ft.x;
                ft.id || h(St) ? ((ct = this.findPointIndex(ft, et)) === -1 || ct === void 0 ? mt.push(Tt) : pt[ct] && Tt !== ot.data[ct] ? (pt[ct].update(Tt, !1, null, !1), pt[ct].touched = !0, Ct && (et = ct + 1)) : pt[ct] && (pt[ct].touched = !0), (!kt || xt !== ct || it && it.enabled || this.hasDerivedData) && (Z = !0)) : mt.push(Tt);
              }, this), Z)
                for (V = pt.length; V--; )
                  (X = pt[V]) && !X.touched && X.remove && X.remove(!1, j);
              else
                !kt || it && it.enabled ? Lt = !1 : (I.forEach(function(Tt, xt) {
                  Tt !== pt[xt].y && pt[xt].update && pt[xt].update(Tt, !1, null, !1);
                }), mt.length = 0);
              return pt.forEach(function(Tt) {
                Tt && (Tt.touched = !1);
              }), !!Lt && (mt.forEach(function(Tt) {
                this.addPoint(Tt, !1, null, null, !1);
              }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = E(this.xData), this.autoIncrement()), !0);
            }, L.prototype.setData = function(I, j, Z, V) {
              j === void 0 && (j = !0);
              var X, et, ot, it, pt = this, mt = pt.points, Ct = mt && mt.length || 0, kt = pt.options, Lt = pt.chart, Tt = kt.dataSorting, xt = pt.xAxis, ct = kt.turboThreshold, ft = this.xData, St = this.yData, Mt = pt.pointArrayMap, Dt = Mt && Mt.length, Ot = kt.keys, Nt = 0, Wt = 1, zt = null;
              Lt.options.chart.allowMutatingData || (kt.data && delete pt.options.data, pt.userOptions.data && delete pt.userOptions.data, it = M(!0, I));
              var Ht = (I = it || I || []).length;
              if (Tt && Tt.enabled && (I = this.sortData(I)), Lt.options.chart.allowMutatingData && V !== !1 && Ht && Ct && !pt.cropped && !pt.hasGroupedData && pt.visible && !pt.boosted && (ot = this.updateData(I, Z)), !ot) {
                if (pt.xIncrement = null, pt.colorCounter = 0, this.parallelArrays.forEach(function(Kt) {
                  pt[Kt + "Data"].length = 0;
                }), ct && Ht > ct)
                  if (zt = pt.getFirstValidPoint(I), h(zt))
                    for (X = 0; X < Ht; X++)
                      ft[X] = this.autoIncrement(), St[X] = I[X];
                  else if (l(zt))
                    if (Dt)
                      if (zt.length === Dt)
                        for (X = 0; X < Ht; X++)
                          ft[X] = this.autoIncrement(), St[X] = I[X];
                      else
                        for (X = 0; X < Ht; X++)
                          et = I[X], ft[X] = et[0], St[X] = et.slice(1, Dt + 1);
                    else if (Ot && (Nt = (Nt = Ot.indexOf("x")) >= 0 ? Nt : 0, Wt = (Wt = Ot.indexOf("y")) >= 0 ? Wt : 1), zt.length === 1 && (Wt = 0), Nt === Wt)
                      for (X = 0; X < Ht; X++)
                        ft[X] = this.autoIncrement(), St[X] = I[X][Wt];
                    else
                      for (X = 0; X < Ht; X++)
                        et = I[X], ft[X] = et[Nt], St[X] = et[Wt];
                  else
                    e(12, !1, Lt);
                else
                  for (X = 0; X < Ht; X++)
                    I[X] !== void 0 && (et = { series: pt }, pt.pointClass.prototype.applyOptions.apply(et, [I[X]]), pt.updateParallelArrays(et, X));
                for (St && C(St[0]) && e(14, !0, Lt), pt.data = [], pt.options.data = pt.userOptions.data = I, X = Ct; X--; )
                  mt[X] && mt[X].destroy && mt[X].destroy();
                xt && (xt.minRange = xt.userMinRange), pt.isDirty = Lt.isDirtyBox = !0, pt.isDirtyData = !!mt, Z = !1;
              }
              kt.legendType === "point" && (this.processData(), this.generatePoints()), j && Lt.redraw(Z);
            }, L.prototype.sortData = function(I) {
              var j = this, Z = j.options.dataSorting.sortKey || "y", V = function(X, et) {
                return s(et) && X.pointClass.prototype.optionsToObject.call({ series: X }, et) || {};
              };
              return I.forEach(function(X, et) {
                I[et] = V(j, X), I[et].index = et;
              }, this), I.concat().sort(function(X, et) {
                var ot = c(Z, X), it = c(Z, et);
                return it < ot ? -1 : it > ot ? 1 : 0;
              }).forEach(function(X, et) {
                X.x = et;
              }, this), j.linkedSeries && j.linkedSeries.forEach(function(X) {
                var et = X.options, ot = et.data;
                et.dataSorting && et.dataSorting.enabled || !ot || (ot.forEach(function(it, pt) {
                  ot[pt] = V(X, it), I[pt] && (ot[pt].x = I[pt].x, ot[pt].index = pt);
                }), X.setData(ot, !1));
              }), I;
            }, L.prototype.getProcessedData = function(I) {
              var j, Z, V, X, et, ot, it, pt, mt = this, Ct = mt.xAxis, kt = mt.options, Lt = kt.cropThreshold, Tt = I || mt.getExtremesFromAll || kt.getExtremesFromAll, xt = mt.isCartesian, ct = Ct && Ct.val2lin, ft = !(!Ct || !Ct.logarithmic), St = 0, Mt = mt.xData, Dt = mt.yData, Ot = mt.requireSorting, Nt = !1, Wt = Mt.length;
              for (Ct && (it = (ot = Ct.getExtremes()).min, pt = ot.max, Nt = !(!Ct.categories || Ct.names.length)), xt && mt.sorted && !Tt && (!Lt || Wt > Lt || mt.forceCrop) && (Mt[Wt - 1] < it || Mt[0] > pt ? (Mt = [], Dt = []) : mt.yData && (Mt[0] < it || Mt[Wt - 1] > pt) && (Mt = (j = this.cropData(mt.xData, mt.yData, it, pt)).xData, Dt = j.yData, St = j.start, Z = !0)), et = Mt.length || 1; --et; )
                (V = ft ? ct(Mt[et]) - ct(Mt[et - 1]) : Mt[et] - Mt[et - 1]) > 0 && (X === void 0 || V < X) ? X = V : V < 0 && Ot && !Nt && (e(15, !1, mt.chart), Ot = !1);
              return { xData: Mt, yData: Dt, cropped: Z, cropStart: St, closestPointRange: X };
            }, L.prototype.processData = function(I) {
              var j = this, Z = j.xAxis;
              if (j.isCartesian && !j.isDirty && !Z.isDirty && !j.yAxis.isDirty && !I)
                return !1;
              var V = j.getProcessedData();
              j.cropped = V.cropped, j.cropStart = V.cropStart, j.processedXData = V.xData, j.processedYData = V.yData, j.closestPointRange = j.basePointRange = V.closestPointRange, i(j, "afterProcessData");
            }, L.prototype.cropData = function(I, j, Z, V, X) {
              var et, ot, it = I.length, pt = 0, mt = it;
              for (X = p(X, this.cropShoulder), et = 0; et < it; et++)
                if (I[et] >= Z) {
                  pt = Math.max(0, et - X);
                  break;
                }
              for (ot = et; ot < it; ot++)
                if (I[ot] > V) {
                  mt = ot + X;
                  break;
                }
              return { xData: I.slice(pt, mt), yData: j.slice(pt, mt), start: pt, end: mt };
            }, L.prototype.generatePoints = function() {
              var I, j, Z, V, X = this, et = X.options, ot = X.processedData || et.data, it = X.processedXData, pt = X.processedYData, mt = X.pointClass, Ct = it.length, kt = X.cropStart || 0, Lt = X.hasGroupedData, Tt = et.keys, xt = [], ct = et.dataGrouping && et.dataGrouping.groupAll ? kt : 0, ft = X.data;
              if (!ft && !Lt) {
                var St = [];
                St.length = ot.length, ft = X.data = St;
              }
              for (Tt && Lt && (X.options.keys = !1), V = 0; V < Ct; V++)
                j = kt + V, Lt ? ((Z = new mt().init(X, [it[V]].concat(T(pt[V])))).dataGroup = X.groupMap[ct + V], Z.dataGroup.options && (Z.options = Z.dataGroup.options, n(Z, Z.dataGroup.options), delete Z.dataLabels)) : (Z = ft[j]) || ot[j] === void 0 || (ft[j] = Z = new mt().init(X, ot[j], it[V])), Z && (Z.index = Lt ? ct + V : j, xt[V] = Z);
              if (X.options.keys = Tt, ft && (Ct !== (I = ft.length) || Lt))
                for (V = 0; V < I; V++)
                  V !== kt || Lt || (V += Ct), ft[V] && (ft[V].destroyElements(), ft[V].plotX = void 0);
              X.data = ft, X.points = xt, i(this, "afterGeneratePoints");
            }, L.prototype.getXExtremes = function(I) {
              return { min: P(I), max: E(I) };
            }, L.prototype.getExtremes = function(I, j) {
              var Z, V, X, et, ot, it, pt, mt = this.xAxis, Ct = this.yAxis, kt = this.processedXData || this.xData, Lt = [], Tt = this.requireSorting ? this.cropShoulder : 0, xt = !!Ct && Ct.positiveValuesOnly, ct = 0, ft = 0, St = 0, Mt = (I = I || this.stackedYData || this.processedYData || []).length;
              for (mt && (ct = (Z = mt.getExtremes()).min, ft = Z.max), it = 0; it < Mt; it++)
                if (et = kt[it], ot = I[it], V = (h(ot) || l(ot)) && (ot.length || ot > 0 || !xt), X = j || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !mt || (kt[it + Tt] || et) >= ct && (kt[it - Tt] || et) <= ft, V && X)
                  if (pt = ot.length)
                    for (; pt--; )
                      h(ot[pt]) && (Lt[St++] = ot[pt]);
                  else
                    Lt[St++] = ot;
              var Dt = { activeYData: Lt, dataMin: P(Lt), dataMax: E(Lt) };
              return i(this, "afterGetExtremes", { dataExtremes: Dt }), Dt;
            }, L.prototype.applyExtremes = function() {
              var I = this.getExtremes();
              return this.dataMin = I.dataMin, this.dataMax = I.dataMax, I;
            }, L.prototype.getFirstValidPoint = function(I) {
              for (var j = I.length, Z = 0, V = null; V === null && Z < j; )
                V = I[Z], Z++;
              return V;
            }, L.prototype.translate = function() {
              this.processedXData || this.processData(), this.generatePoints();
              var I, j, Z, V, X = this, et = X.options, ot = et.stacking, it = X.xAxis, pt = it.categories, mt = X.enabledDataSorting, Ct = X.yAxis, kt = X.points, Lt = kt.length, Tt = X.pointPlacementToXValue(), xt = !!Tt, ct = et.threshold, ft = et.startFromThreshold ? ct : 0, St = this.zoneAxis || "y", Mt = Number.MAX_VALUE;
              function Dt(Jt) {
                return S(Jt, -1e5, 1e5);
              }
              for (I = 0; I < Lt; I++) {
                var Ot = kt[I], Nt = Ot.x, Wt = void 0, zt = void 0, Ht = Ot.y, Kt = Ot.low, Gt = ot && Ct.stacking && Ct.stacking.stacks[(X.negStacks && Ht < (ft ? 0 : ct) ? "-" : "") + X.stackKey];
                if ((Ct.positiveValuesOnly && !Ct.validatePositiveValue(Ht) || it.positiveValuesOnly && !it.validatePositiveValue(Nt)) && (Ot.isNull = !0), Ot.plotX = j = y(Dt(it.translate(Nt, 0, 0, 0, 1, Tt, this.type === "flags"))), ot && X.visible && Gt && Gt[Nt] && (V = X.getStackIndicator(V, Nt, X.index), !Ot.isNull && V.key && (zt = (Wt = Gt[Nt]).points[V.key]), Wt && l(zt) && (Kt = zt[0], Ht = zt[1], Kt === ft && V.key === Gt[Nt].base && (Kt = p(h(ct) ? ct : Ct.min)), Ct.positiveValuesOnly && s(Kt) && Kt <= 0 && (Kt = void 0), Ot.total = Ot.stackTotal = p(Wt.total), Ot.percentage = s(Ot.y) && Wt.total ? Ot.y / Wt.total * 100 : void 0, Ot.stackY = Ht, X.irregularWidths || Wt.setOffset(X.pointXOffset || 0, X.barW || 0, void 0, void 0, void 0, X.xAxis))), Ot.yBottom = s(Kt) ? Dt(Ct.translate(Kt, 0, 1, 0, 1)) : void 0, X.dataModify && (Ht = X.dataModify.modifyValue(Ht, I)), Ot.plotY = void 0, h(Ht)) {
                  var ee = Ct.translate(Ht, !1, !0, !1, !0);
                  ee !== void 0 && (Ot.plotY = Dt(ee));
                }
                Ot.isInside = this.isPointInside(Ot), Ot.clientX = xt ? y(it.translate(Nt, 0, 0, 0, 1, Tt)) : j, Ot.negative = Ot[St] < (et[St + "Threshold"] || ct || 0), Ot.category = p(pt && pt[Ot.x], Ot.x), Ot.isNull || Ot.visible === !1 || (Z !== void 0 && (Mt = Math.min(Mt, Math.abs(j - Z))), Z = j), Ot.zone = this.zones.length ? Ot.getZone() : void 0, !Ot.graphic && X.group && mt && (Ot.isNew = !0);
              }
              X.closestPointRangePx = Mt, i(this, "afterTranslate");
            }, L.prototype.getValidPoints = function(I, j, Z) {
              var V = this.chart;
              return (I || this.points || []).filter(function(X) {
                return !(j && !V.isInsidePlot(X.plotX, X.plotY, { inverted: V.inverted })) && X.visible !== !1 && (Z || !X.isNull);
              });
            }, L.prototype.getClipBox = function() {
              var I = this, j = I.chart, Z = I.xAxis, V = I.yAxis, X = M(j.clipBox);
              return Z && Z.len !== j.plotSizeX && (X.width = Z.len), V && V.len !== j.plotSizeY && (X.height = V.len), X;
            }, L.prototype.getSharedClipKey = function() {
              return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
            }, L.prototype.setClip = function() {
              var I = this, j = I.chart, Z = I.group, V = I.markerGroup, X = j.sharedClips, et = j.renderer, ot = this.getClipBox(), it = this.getSharedClipKey(), pt = X[it];
              pt ? pt.animate(ot) : X[it] = pt = et.clipRect(ot), Z && Z.clip(this.options.clip === !1 ? void 0 : pt), V && V.clip();
            }, L.prototype.animate = function(I) {
              var j = this, Z = j.chart, V = j.group, X = j.markerGroup, et = Z.inverted, ot = k(this.options.animation), it = [this.getSharedClipKey(), ot.duration, ot.easing, ot.defer].join(","), pt = Z.sharedClips[it], mt = Z.sharedClips[it + "m"];
              if (I && V) {
                var Ct = this.getClipBox();
                if (pt)
                  pt.attr("height", Ct.height);
                else {
                  Ct.width = 0, et && (Ct.x = Z.plotHeight), pt = Z.renderer.clipRect(Ct), Z.sharedClips[it] = pt;
                  var kt = { x: -99, y: -99, width: et ? Z.plotWidth + 199 : 99, height: et ? 99 : Z.plotHeight + 199 };
                  mt = Z.renderer.clipRect(kt), Z.sharedClips[it + "m"] = mt;
                }
                V.clip(pt), X && X.clip(mt);
              } else if (pt && !pt.hasClass("highcharts-animating")) {
                var Lt = this.getClipBox(), Tt = ot.step;
                X && X.element.childNodes.length && (ot.step = function(xt, ct) {
                  Tt && Tt.apply(ct, arguments), ct.prop === "width" && mt && mt.element && mt.attr(et ? "height" : "width", xt + 99);
                }), pt.addClass("highcharts-animating").animate(Lt, ot);
              }
            }, L.prototype.afterAnimate = function() {
              var I = this;
              this.setClip(), O(this.chart.sharedClips, function(j, Z, V) {
                j && !I.chart.container.querySelector('[clip-path="url(#'.concat(j.id, ')"]')) && (j.destroy(), delete V[Z]);
              }), this.finishedAnimating = !0, i(this, "afterAnimate");
            }, L.prototype.drawPoints = function(I) {
              I === void 0 && (I = this.points);
              var j, Z, V, X, et, ot, it, pt = this, mt = pt.chart, Ct = mt.styledMode, kt = pt.colorAxis, Lt = pt.options.marker, Tt = pt[pt.specialGroup || "markerGroup"], xt = pt.xAxis, ct = p(Lt.enabled, !(xt && !xt.isRadial) || null, pt.closestPointRangePx >= Lt.enabledThreshold * Lt.radius);
              if (Lt.enabled !== !1 || pt._hasPointMarkers)
                for (j = 0; j < I.length; j++)
                  if (X = (V = (Z = I[j]).graphic) ? "animate" : "attr", et = Z.marker || {}, ot = !!Z.marker, (ct && et.enabled === void 0 || et.enabled) && !Z.isNull && Z.visible !== !1) {
                    var ft = p(et.symbol, pt.symbol, "rect");
                    it = pt.markerAttribs(Z, Z.selected && "select"), pt.enabledDataSorting && (Z.startXPos = xt.reversed ? -(it.width || 0) : xt.width);
                    var St = Z.isInside !== !1;
                    if (!V && St && ((it.width || 0) > 0 || Z.hasImage) && (Z.graphic = V = mt.renderer.symbol(ft, it.x, it.y, it.width, it.height, ot ? et : Lt).add(Tt), pt.enabledDataSorting && mt.hasRendered && (V.attr({ x: Z.startXPos }), X = "animate")), V && X === "animate" && V[St ? "show" : "hide"](St).animate(it), V) {
                      var Mt = pt.pointAttribs(Z, Ct || !Z.selected ? void 0 : "select");
                      Ct ? kt && V.css({ fill: Mt.fill }) : V[X](Mt);
                    }
                    V && V.addClass(Z.getClassName(), !0);
                  } else
                    V && (Z.graphic = V.destroy());
            }, L.prototype.markerAttribs = function(I, j) {
              var Z, V, X = this.options, et = X.marker, ot = I.marker || {}, it = ot.symbol || et.symbol, pt = {}, mt = p(ot.radius, et && et.radius);
              j && (Z = et.states[j], V = ot.states && ot.states[j], mt = p(V && V.radius, Z && Z.radius, mt && mt + (Z && Z.radiusPlus || 0))), I.hasImage = it && it.indexOf("url") === 0, I.hasImage && (mt = 0);
              var Ct = I.pos();
              return h(mt) && Ct && (pt.x = Ct[0] - mt, pt.y = Ct[1] - mt, X.crisp && (pt.x = Math.floor(pt.x))), mt && (pt.width = pt.height = 2 * mt), pt;
            }, L.prototype.pointAttribs = function(I, j) {
              var Z, V, X, et, ot = this.options.marker, it = I && I.options, pt = it && it.marker || {}, mt = it && it.color, Ct = I && I.color, kt = I && I.zone && I.zone.color, Lt = this.color, Tt = p(pt.lineWidth, ot.lineWidth), xt = 1;
              return Lt = mt || kt || Ct || Lt, X = pt.fillColor || ot.fillColor || Lt, et = pt.lineColor || ot.lineColor || Lt, (j = j || "normal") && (Z = ot.states[j] || {}, V = pt.states && pt.states[j] || {}, Tt = p(V.lineWidth, Z.lineWidth, Tt + p(V.lineWidthPlus, Z.lineWidthPlus, 0)), X = V.fillColor || Z.fillColor || X, et = V.lineColor || Z.lineColor || et, xt = p(V.opacity, Z.opacity, xt)), { stroke: et, "stroke-width": Tt, fill: X, opacity: xt };
            }, L.prototype.destroy = function(I) {
              var j, Z, V, X = this, et = X.chart, ot = /AppleWebKit\/533/.test(g.navigator.userAgent), it = X.data || [];
              for (i(X, "destroy", { keepEventsForUpdate: I }), this.removeEvents(I), (X.axisTypes || []).forEach(function(pt) {
                (V = X[pt]) && V.series && (a(V.series, X), V.isDirty = V.forceRedraw = !0);
              }), X.legendItem && X.chart.legend.destroyItem(X), j = it.length; j--; )
                (Z = it[j]) && Z.destroy && Z.destroy();
              X.clips && X.clips.forEach(function(pt) {
                return pt.destroy();
              }), D.clearTimeout(X.animationTimeout), O(X, function(pt, mt) {
                pt instanceof N && !pt.survive && pt[ot && mt === "group" ? "hide" : "destroy"]();
              }), et.hoverSeries === X && (et.hoverSeries = void 0), a(et.series, X), et.orderSeries(), O(X, function(pt, mt) {
                I && mt === "hcEvents" || delete X[mt];
              });
            }, L.prototype.applyZones = function() {
              var I, j, Z, V, X, et, ot, it, pt, mt, Ct, kt = this, Lt = this.chart, Tt = Lt.renderer, xt = this.zones, ct = this.clips || [], ft = this.graph, St = this.area, Mt = Math.max(Lt.plotWidth, Lt.plotHeight), Dt = this[(this.zoneAxis || "y") + "Axis"], Ot = Lt.inverted, Nt = !1;
              xt.length && (ft || St) && Dt && Dt.min !== void 0 ? (X = Dt.reversed, et = Dt.horiz, ft && !this.showLine && ft.hide(), St && St.hide(), V = Dt.getExtremes(), xt.forEach(function(Wt, zt) {
                I = X ? et ? Lt.plotWidth : 0 : et ? 0 : Dt.toPixels(V.min) || 0, I = S(p(j, I), 0, Mt), j = S(Math.round(Dt.toPixels(p(Wt.value, V.max), !0) || 0), 0, Mt), Nt && (I = j = Dt.toPixels(V.max)), ot = Math.abs(I - j), it = Math.min(I, j), pt = Math.max(I, j), Dt.isXAxis ? (Z = { x: Ot ? pt : it, y: 0, width: ot, height: Mt }, et || (Z.x = Lt.plotHeight - Z.x)) : (Z = { x: 0, y: Ot ? pt : it, width: Mt, height: ot }, et && (Z.y = Lt.plotWidth - Z.y)), Ot && Tt.isVML && (Z = Dt.isXAxis ? { x: 0, y: X ? it : pt, height: Z.width, width: Lt.chartWidth } : { x: Z.y - Lt.plotLeft - Lt.spacingBox.x, y: 0, width: Z.height, height: Lt.chartHeight }), ct[zt] ? ct[zt].animate(Z) : ct[zt] = Tt.clipRect(Z), mt = kt["zone-area-" + zt], Ct = kt["zone-graph-" + zt], ft && Ct && Ct.clip(ct[zt]), St && mt && mt.clip(ct[zt]), Nt = Wt.value > V.max, kt.resetZones && j === 0 && (j = void 0);
              }), this.clips = ct) : kt.visible && (ft && ft.show(), St && St.show());
            }, L.prototype.plotGroup = function(I, j, Z, V, X) {
              var et = this[I], ot = !et, it = { visibility: Z, zIndex: V || 0.1 };
              return this.opacity === void 0 || this.chart.styledMode || this.state === "inactive" || (it.opacity = this.opacity), ot && (this[I] = et = this.chart.renderer.g().add(X)), et.addClass("highcharts-" + j + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (s(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (et.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), et.attr(it)[ot ? "attr" : "animate"](this.getPlotBox(j)), et;
            }, L.prototype.getPlotBox = function(I) {
              var j = this.xAxis, Z = this.yAxis, V = this.chart, X = V.inverted && !V.polar && j && this.invertible !== !1 && I === "series";
              return V.inverted && (j = Z, Z = this.xAxis), { translateX: j ? j.left : V.plotLeft, translateY: Z ? Z.top : V.plotTop, rotation: X ? 90 : 0, rotationOriginX: X ? (j.len - Z.len) / 2 : 0, rotationOriginY: X ? (j.len + Z.len) / 2 : 0, scaleX: X ? -1 : 1, scaleY: 1 };
            }, L.prototype.removeEvents = function(I) {
              var j = this;
              I || w(j), j.eventsToUnbind.length && (j.eventsToUnbind.forEach(function(Z) {
                Z();
              }), j.eventsToUnbind.length = 0);
            }, L.prototype.render = function() {
              var I = this, j = I.chart, Z = I.options, V = k(Z.animation), X = I.visible ? "inherit" : "hidden", et = Z.zIndex, ot = I.hasRendered, it = j.seriesGroup, pt = !I.finishedAnimating && j.renderer.isSVG ? V.duration : 0;
              i(this, "render"), I.plotGroup("group", "series", X, et, it), I.markerGroup = I.plotGroup("markerGroup", "markers", X, et, it), Z.clip !== !1 && I.setClip(), I.animate && pt && I.animate(!0), I.drawGraph && (I.drawGraph(), I.applyZones()), I.visible && I.drawPoints(), I.drawDataLabels && I.drawDataLabels(), I.redrawPoints && I.redrawPoints(), I.drawTracker && I.options.enableMouseTracking !== !1 && I.drawTracker(), I.animate && pt && I.animate(), ot || (pt && V.defer && (pt += V.defer), I.animationTimeout = z(function() {
                I.afterAnimate();
              }, pt || 0)), I.isDirty = !1, I.hasRendered = !0, i(I, "afterRender");
            }, L.prototype.redraw = function() {
              var I = this.isDirty || this.isDirtyData;
              this.translate(), this.render(), I && delete this.kdTree;
            }, L.prototype.searchPoint = function(I, j) {
              var Z = this, V = Z.xAxis, X = Z.yAxis, et = Z.chart.inverted;
              return this.searchKDTree({ clientX: et ? V.len - I.chartY + V.pos : I.chartX - V.pos, plotY: et ? X.len - I.chartX + X.pos : I.chartY - X.pos }, j, I);
            }, L.prototype.buildKDTree = function(I) {
              this.buildingKdTree = !0;
              var j = this, Z = j.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
              function V(X, et, ot) {
                var it, pt, mt = X && X.length;
                if (mt)
                  return it = j.kdAxisArray[et % ot], X.sort(function(Ct, kt) {
                    return Ct[it] - kt[it];
                  }), { point: X[pt = Math.floor(mt / 2)], left: V(X.slice(0, pt), et + 1, ot), right: V(X.slice(pt + 1), et + 1, ot) };
              }
              delete j.kdTree, z(function() {
                j.kdTree = V(j.getValidPoints(null, !j.directTouch), Z, Z), j.buildingKdTree = !1;
              }, j.options.kdNow || I && I.type === "touchstart" ? 0 : 1);
            }, L.prototype.searchKDTree = function(I, j, Z) {
              var V = this, X = this.kdAxisArray[0], et = this.kdAxisArray[1], ot = j ? "distX" : "dist", it = V.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
              if (this.kdTree || this.buildingKdTree || this.buildKDTree(Z), this.kdTree)
                return function pt(mt, Ct, kt, Lt) {
                  var Tt, xt, ct, ft, St, Mt, Dt = Ct.point, Ot = V.kdAxisArray[kt % Lt], Nt = Dt;
                  ft = Dt, Mt = ((St = s((ct = mt)[X]) && s(ft[X]) ? Math.pow(ct[X] - ft[X], 2) : null) || 0) + ((s(ct[et]) && s(ft[et]) ? Math.pow(ct[et] - ft[et], 2) : null) || 0), ft.dist = s(Mt) ? Math.sqrt(Mt) : Number.MAX_VALUE, ft.distX = s(St) ? Math.sqrt(St) : Number.MAX_VALUE;
                  var Wt = mt[Ot] - Dt[Ot], zt = Wt < 0 ? "left" : "right", Ht = Wt < 0 ? "right" : "left";
                  return Ct[zt] && (Nt = (Tt = pt(mt, Ct[zt], kt + 1, Lt))[ot] < Nt[ot] ? Tt : Dt), Ct[Ht] && Math.sqrt(Wt * Wt) < Nt[ot] && (Nt = (xt = pt(mt, Ct[Ht], kt + 1, Lt))[ot] < Nt[ot] ? xt : Nt), Nt;
                }(I, this.kdTree, it, it);
            }, L.prototype.pointPlacementToXValue = function() {
              var I = this.options, j = I.pointPlacement, Z = I.pointRange, V = this.xAxis, X = j;
              return X === "between" && (X = V.reversed ? -0.5 : 0.5), h(X) ? X * (Z || V.pointRange) : 0;
            }, L.prototype.isPointInside = function(I) {
              var j = this, Z = j.chart, V = j.xAxis, X = j.yAxis;
              return I.plotY !== void 0 && I.plotX !== void 0 && I.plotY >= 0 && I.plotY <= (X ? X.len : Z.plotHeight) && I.plotX >= 0 && I.plotX <= (V ? V.len : Z.plotWidth);
            }, L.prototype.drawTracker = function() {
              var I = this, j = I.options, Z = j.trackByArea, V = [].concat(Z ? I.areaPath : I.graphPath), X = I.chart, et = X.pointer, ot = X.renderer, it = X.options.tooltip.snap, pt = I.tracker, mt = function(kt) {
                X.hoverSeries !== I && I.onMouseOver();
              }, Ct = "rgba(192,192,192," + (v ? 1e-4 : 2e-3) + ")";
              pt ? pt.attr({ d: V }) : I.graph && (I.tracker = ot.path(V).attr({ visibility: I.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(Z ? "highcharts-tracker-area" : "highcharts-tracker-line").add(I.group), X.styledMode || I.tracker.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: Ct, fill: Z ? Ct : "none", "stroke-width": I.graph.strokeWidth() + (Z ? 0 : 2 * it) }), [I.tracker, I.markerGroup, I.dataLabelsGroup].forEach(function(kt) {
                kt && (kt.addClass("highcharts-tracker").on("mouseover", mt).on("mouseout", function(Lt) {
                  et.onTrackerMouseOut(Lt);
                }), j.cursor && !X.styledMode && kt.css({ cursor: j.cursor }), m && kt.on("touchstart", mt));
              })), i(this, "afterDrawTracker");
            }, L.prototype.addPoint = function(I, j, Z, V, X) {
              var et, ot, it = this, pt = it.options, mt = it.data, Ct = it.chart, kt = it.xAxis, Lt = kt && kt.hasNames && kt.names, Tt = pt.data, xt = it.xData;
              j = p(j, !0);
              var ct = { series: it };
              it.pointClass.prototype.applyOptions.apply(ct, [I]);
              var ft = ct.x;
              if (ot = xt.length, it.requireSorting && ft < xt[ot - 1])
                for (et = !0; ot && xt[ot - 1] > ft; )
                  ot--;
              it.updateParallelArrays(ct, "splice", ot, 0, 0), it.updateParallelArrays(ct, ot), Lt && ct.name && (Lt[ft] = ct.name), Tt.splice(ot, 0, I), (et || it.processedData) && (it.data.splice(ot, 0, null), it.processData()), pt.legendType === "point" && it.generatePoints(), Z && (mt[0] && mt[0].remove ? mt[0].remove(!1) : (mt.shift(), it.updateParallelArrays(ct, "shift"), Tt.shift())), X !== !1 && i(it, "addPoint", { point: ct }), it.isDirty = !0, it.isDirtyData = !0, j && Ct.redraw(V);
            }, L.prototype.removePoint = function(I, j, Z) {
              var V = this, X = V.data, et = X[I], ot = V.points, it = V.chart, pt = function() {
                ot && ot.length === X.length && ot.splice(I, 1), X.splice(I, 1), V.options.data.splice(I, 1), V.updateParallelArrays(et || { series: V }, "splice", I, 1), et && et.destroy(), V.isDirty = !0, V.isDirtyData = !0, j && it.redraw();
              };
              A(Z, it), j = p(j, !0), et ? et.firePointEvent("remove", null, pt) : pt();
            }, L.prototype.remove = function(I, j, Z, V) {
              var X = this, et = X.chart;
              function ot() {
                X.destroy(V), et.isDirtyLegend = et.isDirtyBox = !0, et.linkSeries(), p(I, !0) && et.redraw(j);
              }
              Z !== !1 ? i(X, "remove", null, ot) : ot();
            }, L.prototype.update = function(I, j) {
              I = u(I, this.userOptions), i(this, "update", { options: I });
              var Z, V, X = this, et = X.chart, ot = X.userOptions, it = X.initialType || X.type, pt = et.options.plotOptions, mt = x[it].prototype, Ct = X.finishedAnimating && { animation: !1 }, kt = {}, Lt = ["eventOptions", "navigatorSeries", "baseSeries"], Tt = I.type || ot.type || et.options.chart.type, xt = !(this.hasDerivedData || Tt && Tt !== this.type || I.pointStart !== void 0 || I.pointInterval !== void 0 || I.relativeXValue !== void 0 || I.joinBy || I.mapData || X.hasOptionChanged("dataGrouping") || X.hasOptionChanged("pointStart") || X.hasOptionChanged("pointInterval") || X.hasOptionChanged("pointIntervalUnit") || X.hasOptionChanged("keys"));
              Tt = Tt || it, xt && (Lt.push("data", "isDirtyData", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "_hasPointLabels", "clips", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX"), I.visible !== !1 && Lt.push("area", "graph"), X.parallelArrays.forEach(function(zt) {
                Lt.push(zt + "Data");
              }), I.data && (I.dataSorting && n(X.options.dataSorting, I.dataSorting), this.setData(I.data, !1))), I = M(ot, Ct, { index: ot.index === void 0 ? X.index : ot.index, pointStart: p(pt && pt.series && pt.series.pointStart, ot.pointStart, X.xData[0]) }, !xt && { data: X.options.data }, I), xt && I.data && (I.data = X.options.data), (Lt = ["group", "markerGroup", "dataLabelsGroup", "transformGroup", "shadowGroup"].concat(Lt)).forEach(function(zt) {
                Lt[zt] = X[zt], delete X[zt];
              });
              var ct = !1;
              if (x[Tt]) {
                if (ct = Tt !== X.type, X.remove(!1, !1, !1, !0), ct)
                  if (Object.setPrototypeOf)
                    Object.setPrototypeOf(X, x[Tt].prototype);
                  else {
                    var ft = Object.hasOwnProperty.call(X, "hcEvents") && X.hcEvents;
                    for (V in mt)
                      X[V] = void 0;
                    n(X, x[Tt].prototype), ft ? X.hcEvents = ft : delete X.hcEvents;
                  }
              } else
                e(17, !0, et, { missingModuleFor: Tt });
              if (Lt.forEach(function(zt) {
                X[zt] = Lt[zt];
              }), X.init(et, I), xt && this.points) {
                if ((Z = X.options).visible === !1)
                  kt.graphic = 1, kt.dataLabel = 1;
                else if (!X._hasPointLabels) {
                  var St = Z.marker, Mt = Z.dataLabels, Dt = ot.marker || {};
                  !St || St.enabled !== !1 && Dt.symbol === St.symbol && Dt.height === St.height && Dt.width === St.width || (kt.graphic = 1), Mt && Mt.enabled === !1 && (kt.dataLabel = 1);
                }
                for (var Ot = 0, Nt = this.points; Ot < Nt.length; Ot++) {
                  var Wt = Nt[Ot];
                  Wt && Wt.series && (Wt.resolveColor(), Object.keys(kt).length && Wt.destroyElements(kt), Z.showInLegend === !1 && Wt.legendItem && et.legend.destroyItem(Wt));
                }
              }
              X.initialType = it, et.linkSeries(), ct && X.linkedSeries.length && (X.isDirtyData = !0), i(this, "afterUpdate"), p(j, !0) && et.redraw(!!xt && void 0);
            }, L.prototype.setName = function(I) {
              this.name = this.options.name = this.userOptions.name = I, this.chart.isDirtyLegend = !0;
            }, L.prototype.hasOptionChanged = function(I) {
              var j = this.chart, Z = this.options[I], V = j.options.plotOptions, X = this.userOptions[I];
              return X ? Z !== X : Z !== p(V && V[this.type] && V[this.type][I], V && V.series && V.series[I], Z);
            }, L.prototype.onMouseOver = function() {
              var I = this, j = I.chart, Z = j.hoverSeries;
              j.pointer.setHoverChartIndex(), Z && Z !== I && Z.onMouseOut(), I.options.events.mouseOver && i(I, "mouseOver"), I.setState("hover"), j.hoverSeries = I;
            }, L.prototype.onMouseOut = function() {
              var I = this, j = I.options, Z = I.chart, V = Z.tooltip, X = Z.hoverPoint;
              Z.hoverSeries = null, X && X.onMouseOut(), I && j.events.mouseOut && i(I, "mouseOut"), !V || I.stickyTracking || V.shared && !I.noSharedTooltip || V.hide(), Z.series.forEach(function(et) {
                et.setState("", !0);
              });
            }, L.prototype.setState = function(I, j) {
              var Z, V = this, X = V.options, et = V.graph, ot = X.inactiveOtherPoints, it = X.states, pt = p(it[I || "normal"] && it[I || "normal"].animation, V.chart.options.chart.animation), mt = X.lineWidth, Ct = 0, kt = X.opacity;
              if (I = I || "", V.state !== I && ([V.group, V.markerGroup, V.dataLabelsGroup].forEach(function(Lt) {
                Lt && (V.state && Lt.removeClass("highcharts-series-" + V.state), I && Lt.addClass("highcharts-series-" + I));
              }), V.state = I, !V.chart.styledMode)) {
                if (it[I] && it[I].enabled === !1)
                  return;
                if (I && (mt = it[I].lineWidth || mt + (it[I].lineWidthPlus || 0), kt = p(it[I].opacity, kt)), et && !et.dashstyle && h(mt))
                  for (Z = { "stroke-width": mt }, et.animate(Z, pt); V["zone-graph-" + Ct]; )
                    V["zone-graph-" + Ct].animate(Z, pt), Ct += 1;
                ot || [V.group, V.markerGroup, V.dataLabelsGroup, V.labelBySeries].forEach(function(Lt) {
                  Lt && Lt.animate({ opacity: kt }, pt);
                });
              }
              j && ot && V.points && V.setAllPointsToState(I || void 0);
            }, L.prototype.setAllPointsToState = function(I) {
              this.points.forEach(function(j) {
                j.setState && j.setState(I);
              });
            }, L.prototype.setVisible = function(I, j) {
              var Z = this, V = Z.chart, X = V.options.chart.ignoreHiddenSeries, et = Z.visible;
              Z.visible = I = Z.options.visible = Z.userOptions.visible = I === void 0 ? !et : I;
              var ot = I ? "show" : "hide";
              ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach(function(it) {
                Z[it] && Z[it][ot]();
              }), V.hoverSeries !== Z && (V.hoverPoint && V.hoverPoint.series) !== Z || Z.onMouseOut(), Z.legendItem && V.legend.colorizeItem(Z, I), Z.isDirty = !0, Z.options.stacking && V.series.forEach(function(it) {
                it.options.stacking && it.visible && (it.isDirty = !0);
              }), Z.linkedSeries.forEach(function(it) {
                it.setVisible(I, !1);
              }), X && (V.isDirtyBox = !0), i(Z, ot), j !== !1 && V.redraw();
            }, L.prototype.show = function() {
              this.setVisible(!0);
            }, L.prototype.hide = function() {
              this.setVisible(!1);
            }, L.prototype.select = function(I) {
              var j = this;
              j.selected = I = this.options.selected = I === void 0 ? !j.selected : I, j.checkbox && (j.checkbox.checked = I), i(j, I ? "select" : "unselect");
            }, L.prototype.shouldShowTooltip = function(I, j, Z) {
              return Z === void 0 && (Z = {}), Z.series = this, Z.visiblePlotOnly = !0, this.chart.isInsidePlot(I, j, Z);
            }, L.defaultOptions = q, L.types = U.seriesTypes, L.registerType = U.registerSeriesType, L;
          }();
          return n(W.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, cropShoulder: 1, directTouch: !1, drawLegendSymbol: J.drawLineMarker, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: Q, requireSorting: !0, sorted: !0 }), U.series = W, W;
        }), at(_, "Extensions/ScrollablePlotArea.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Axis/Axis.js"], _["Core/Chart/Chart.js"], _["Core/Series/Series.js"], _["Core/Renderer/RendererRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = G.stop, U = Q.addEvent, N = Q.createElement, D = Q.defined, k = Q.merge, A = Q.pick;
          U($, "afterSetChartSize", function(b) {
            var d, m, v, g = this.options.chart.scrollablePlotArea, x = g && g.minWidth, E = g && g.minHeight;
            this.renderer.forExport || (x ? (this.scrollablePixelsX = d = Math.max(0, x - this.chartWidth), d && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = k(this.plotBox), this.plotBox.width = this.plotWidth += d, this.inverted ? this.clipBox.height += d : this.clipBox.width += d, v = { 1: { name: "right", value: d } })) : E && (this.scrollablePixelsY = m = Math.max(0, E - this.chartHeight), D(m) && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = k(this.plotBox), this.plotBox.height = this.plotHeight += m, this.inverted ? this.clipBox.width += m : this.clipBox.height += m, v = { 2: { name: "bottom", value: m } })), v && !b.skipAxes && this.axes.forEach(function(P) {
              v[P.side] ? P.getPlotLinePath = function() {
                var S, u = v[P.side].name, y = v[P.side].value, s = this[u];
                return this[u] = s - y, S = F.prototype.getPlotLinePath.apply(this, arguments), this[u] = s, S;
              } : (P.setAxisSize(), P.setAxisTranslation());
            }));
          }), U($, "render", function() {
            this.scrollablePixelsX || this.scrollablePixelsY ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
          }), $.prototype.setUpScrolling = function() {
            var b, d = this, m = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
            this.scrollablePixelsX && (m.overflowX = "auto"), this.scrollablePixelsY && (m.overflowY = "auto"), this.scrollingParent = N("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, this.renderTo), this.scrollingContainer = N("div", { className: "highcharts-scrolling" }, m, this.scrollingParent), U(this.scrollingContainer, "scroll", function() {
              d.pointer && (delete d.pointer.chartPosition, d.hoverPoint && (b = d.hoverPoint), d.pointer.runPointActions(void 0, b, !0));
            }), this.innerContainer = N("div", { className: "highcharts-inner-container" }, null, this.scrollingContainer), this.innerContainer.appendChild(this.container), this.setUpScrolling = null;
          }, $.prototype.moveFixedElements = function() {
            var b, d = this.container, m = this.fixedRenderer, v = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-credits", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-reset-zoom", ".highcharts-drillup-button", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"];
            this.scrollablePixelsX && !this.inverted ? b = ".highcharts-yaxis" : this.scrollablePixelsX && this.inverted || this.scrollablePixelsY && !this.inverted ? b = ".highcharts-xaxis" : this.scrollablePixelsY && this.inverted && (b = ".highcharts-yaxis"), b && v.push(b + ":not(.highcharts-radial-axis)", b + "-labels:not(.highcharts-radial-axis-labels)"), v.forEach(function(g) {
              [].forEach.call(d.querySelectorAll(g), function(x) {
                (x.namespaceURI === m.SVG_NS ? m.box : m.box.parentNode).appendChild(x), x.style.pointerEvents = "auto";
              });
            });
          }, $.prototype.applyFixed = function() {
            var b, d, m, v = !this.fixedDiv, g = this.options.chart, x = g.scrollablePlotArea, E = J.getRendererType();
            v ? (this.fixedDiv = N("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (g.style && g.style.zIndex || 0) + 2, top: 0 }, null, !0), this.scrollingContainer && this.scrollingContainer.parentNode.insertBefore(this.fixedDiv, this.scrollingContainer), this.renderTo.style.overflow = "visible", this.fixedRenderer = b = new E(this.fixedDiv, this.chartWidth, this.chartHeight, this.options.chart.style), this.scrollableMask = b.path().attr({ fill: this.options.chart.backgroundColor || "#fff", "fill-opacity": A(x.opacity, 0.85), zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), U(this, "afterShowResetZoom", this.moveFixedElements), U(this, "afterApplyDrilldown", this.moveFixedElements), U(this, "afterLayOutTitles", this.moveFixedElements)) : this.fixedRenderer.setSize(this.chartWidth, this.chartHeight), (this.scrollableDirty || v) && (this.scrollableDirty = !1, this.moveFixedElements()), d = this.chartWidth + (this.scrollablePixelsX || 0), m = this.chartHeight + (this.scrollablePixelsY || 0), q(this.container), this.container.style.width = d + "px", this.container.style.height = m + "px", this.renderer.boxWrapper.attr({ width: d, height: m, viewBox: [0, 0, d, m].join(" ") }), this.chartBackground.attr({ width: d, height: m }), this.scrollingContainer.style.height = this.chartHeight + "px", v && (x.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixelsX * x.scrollPositionX), x.scrollPositionY && (this.scrollingContainer.scrollTop = this.scrollablePixelsY * x.scrollPositionY));
            var P, S = this.axisOffset, u = this.plotTop - S[0] - 1, y = this.plotLeft - S[3] - 1, s = this.plotTop + this.plotHeight + S[2] + 1, a = this.plotLeft + this.plotWidth + S[1] + 1, e = this.plotLeft + this.plotWidth - (this.scrollablePixelsX || 0), n = this.plotTop + this.plotHeight - (this.scrollablePixelsY || 0);
            P = this.scrollablePixelsX ? [["M", 0, u], ["L", this.plotLeft - 1, u], ["L", this.plotLeft - 1, s], ["L", 0, s], ["Z"], ["M", e, u], ["L", this.chartWidth, u], ["L", this.chartWidth, s], ["L", e, s], ["Z"]] : this.scrollablePixelsY ? [["M", y, 0], ["L", y, this.plotTop - 1], ["L", a, this.plotTop - 1], ["L", a, 0], ["Z"], ["M", y, n], ["L", y, this.chartHeight], ["L", a, this.chartHeight], ["L", a, n], ["Z"]] : [["M", 0, 0]], this.redrawTrigger !== "adjustHeight" && this.scrollableMask.attr({ d: P });
          }, U(F, "afterInit", function() {
            this.chart.scrollableDirty = !0;
          }), U(Y, "show", function() {
            this.chart.scrollableDirty = !0;
          });
        }), at(_, "Core/Axis/Stacking/StackItem.js", [_["Core/FormatUtilities.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.format, J = F.series, Q = $.destroyObjectProperties, q = $.pick, U = $.isNumber;
          return function() {
            function N(D, k, A, b, d) {
              var m = D.chart.inverted, v = D.reversed;
              this.axis = D;
              var g = this.isNegative = !!A != !!v;
              this.options = k = k || {}, this.x = b, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = d, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: k.align || (m ? g ? "left" : "right" : "center"), verticalAlign: k.verticalAlign || (m ? "middle" : g ? "bottom" : "top"), y: k.y, x: k.x }, this.textAlign = k.textAlign || (m ? g ? "right" : "left" : "center");
            }
            return N.prototype.destroy = function() {
              Q(this, this.axis);
            }, N.prototype.render = function(D) {
              var k = this.axis.chart, A = this.options, b = A.format, d = b ? Y(b, this, k) : A.formatter.call(this);
              if (this.label)
                this.label.attr({ text: d, visibility: "hidden" });
              else {
                this.label = k.renderer.label(d, null, void 0, A.shape, void 0, void 0, A.useHTML, !1, "stack-labels");
                var m = { r: A.borderRadius || 0, text: d, padding: q(A.padding, 5), visibility: "hidden" };
                k.styledMode || (m.fill = A.backgroundColor, m.stroke = A.borderColor, m["stroke-width"] = A.borderWidth, this.label.css(A.style || {})), this.label.attr(m), this.label.added || this.label.add(D);
              }
              this.label.labelrank = k.plotSizeY;
            }, N.prototype.setOffset = function(D, k, A, b, d, m) {
              var v = this, g = v.alignOptions, x = v.axis, E = v.label, P = v.options, S = v.textAlign, u = x.chart, y = this.getStackBox({ xOffset: D, width: k, boxBottom: A, boxTop: b, defaultX: d, xAxis: m }), s = g.verticalAlign;
              if (E && y) {
                var a = E.getBBox(), e = E.padding, n = q(P.overflow, "justify") === "justify", o = void 0;
                g.x = P.x || 0, g.y = P.y || 0;
                var i = this.adjustStackPosition({ labelBox: a, verticalAlign: s, textAlign: S }), c = i.x, l = i.y;
                y.x -= c, y.y -= l, E.align(g, !1, y), (o = u.isInsidePlot(E.alignAttr.x + g.x + c, E.alignAttr.y + g.y + l)) || (n = !1), n && J.prototype.justifyDataLabel.call(x, E, g, E.alignAttr, a, y), E.attr({ x: E.alignAttr.x, y: E.alignAttr.y, rotation: P.rotation, rotationOriginX: a.width / 2, rotationOriginY: a.height / 2 }), q(!n && P.crop, !0) && (o = U(E.x) && U(E.y) && u.isInsidePlot(E.x - e + E.width, E.y) && u.isInsidePlot(E.x + e, E.y)), E[o ? "show" : "hide"]();
              }
            }, N.prototype.adjustStackPosition = function(D) {
              var k = D.labelBox, A = D.verticalAlign, b = D.textAlign, d = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, m = d[A], v = d[b];
              return { x: k.width / 2 + k.width / 2 * v, y: k.height / 2 * m };
            }, N.prototype.getStackBox = function(D) {
              var k = this.axis, A = k.chart, b = D.boxTop, d = D.defaultX, m = D.xOffset, v = D.width, g = D.boxBottom, x = k.stacking.usePercentage ? 100 : q(b, this.total, 0), E = k.toPixels(x), P = D.xAxis || A.xAxis[0], S = q(d, P.toPixels(this.x)) + m, u = k.toPixels(g || 0), y = Math.abs(E - u), s = A.inverted, a = this.isNegative;
              return s ? { x: (a ? E : E - y) - A.plotLeft, y: S - A.plotTop, width: y, height: v } : { x: S - A.plotLeft, y: (a ? E - y : E) - A.plotTop, width: v, height: y };
            }, N;
          }();
        }), at(_, "Core/Axis/Stacking/StackingAxis.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Axis/Axis.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Axis/Stacking/StackItem.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = G.getDeferredAnimation, q = $.series.prototype, U = J.addEvent, N = J.correctFloat, D = J.defined, k = J.destroyObjectProperties, A = J.fireEvent, b = J.isArray, d = J.isNumber, m = J.objectEach, v = J.pick;
          function g() {
            var n = this, o = n.inverted;
            n.yAxis.forEach(function(i) {
              i.stacking && i.stacking.stacks && i.hasVisibleSeries && (i.stacking.oldStacks = i.stacking.stacks);
            }), n.series.forEach(function(i) {
              var c = i.xAxis && i.xAxis.options || {};
              !i.options.stacking || i.visible !== !0 && n.options.chart.ignoreHiddenSeries !== !1 || (i.stackKey = [i.type, v(i.options.stack, ""), o ? c.top : c.left, o ? c.height : c.width].join(","));
            });
          }
          function x() {
            var n = this.stacking;
            if (n) {
              var o = n.stacks;
              m(o, function(i, c) {
                k(i), o[c] = null;
              }), n && n.stackTotalGroup && n.stackTotalGroup.destroy();
            }
          }
          function E() {
            this.coll !== "yAxis" || this.stacking || (this.stacking = new e(this));
          }
          function P(n, o, i, c) {
            return !D(n) || n.x !== o || c && n.stackKey !== c ? n = { x: o, index: 0, key: c, stackKey: c } : n.index++, n.key = [i, o, n.index].join(","), n;
          }
          function S() {
            var n, o = this, i = o.yAxis, c = o.stackKey, l = i.stacking.stacks, h = o.processedXData, C = o.options.stacking, M = o[C + "Stacker"];
            M && [c, "-" + c].forEach(function(O) {
              for (var p, w, T, z = h.length; z--; )
                p = h[z], n = o.getStackIndicator(n, p, o.index, O), (T = (w = l[O] && l[O][p]) && w.points[n.key]) && M.call(o, T, w, z);
            });
          }
          function u(n, o, i) {
            var c = o.total ? 100 / o.total : 0;
            n[0] = N(n[0] * c), n[1] = N(n[1] * c), this.stackedYData[i] = n[1];
          }
          function y() {
            var n = this.yAxis.stacking;
            this.options.centerInCategory && (this.is("column") || this.is("columnrange")) && !this.options.stacking && this.chart.series.length > 1 ? q.setStackedPoints.call(this, "group") : n && m(n.stacks, function(o, i) {
              i.slice(-5) === "group" && (m(o, function(c) {
                return c.destroy();
              }), delete n.stacks[i]);
            });
          }
          function s(n) {
            var o = this.chart, i = n || this.options.stacking;
            if (i && (this.visible === !0 || o.options.chart.ignoreHiddenSeries === !1)) {
              var c, l, h, C, M, O, p, w, T, z = this, W = z.processedXData, L = z.processedYData, I = [], j = L.length, Z = z.options, V = Z.threshold, X = v(Z.startFromThreshold && V, 0), et = Z.stack, ot = n ? "" + z.type + ",".concat(i) : z.stackKey, it = "-" + ot, pt = z.negStacks, mt = i === "group" ? o.yAxis[0] : z.yAxis, Ct = mt.stacking.stacks, kt = mt.stacking.oldStacks;
              for (mt.stacking.stacksTouched += 1, p = 0; p < j; p++)
                w = W[p], T = L[p], O = (c = z.getStackIndicator(c, w, z.index)).key, Ct[M = (l = pt && T < (X ? 0 : V)) ? it : ot] || (Ct[M] = {}), Ct[M][w] || (kt[M] && kt[M][w] ? (Ct[M][w] = kt[M][w], Ct[M][w].total = null) : Ct[M][w] = new Y(mt, mt.options.stackLabels, !!l, w, et)), h = Ct[M][w], T !== null ? (h.points[O] = h.points[z.index] = [v(h.cumulative, X)], D(h.cumulative) || (h.base = O), h.touched = mt.stacking.stacksTouched, c.index > 0 && z.singleStacks === !1 && (h.points[O][0] = h.points[z.index + "," + w + ",0"][0])) : h.points[O] = h.points[z.index] = null, i === "percent" ? (C = l ? ot : it, pt && Ct[C] && Ct[C][w] ? (C = Ct[C][w], h.total = C.total = Math.max(C.total, h.total) + Math.abs(T) || 0) : h.total = N(h.total + (Math.abs(T) || 0))) : i === "group" ? (b(T) && (T = T[0]), T !== null && (h.total = (h.total || 0) + 1)) : h.total = N(h.total + (T || 0)), h.cumulative = i === "group" ? (h.total || 1) - 1 : v(h.cumulative, X) + (T || 0), T !== null && (h.points[O].push(h.cumulative), I[p] = h.cumulative, h.hasValidPoints = !0);
              i === "percent" && (mt.stacking.usePercentage = !0), i !== "group" && (this.stackedYData = I), mt.stacking.oldStacks = {};
            }
          }
          var a, e = function() {
            function n(o) {
              this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = o;
            }
            return n.prototype.buildStacks = function() {
              var o, i, c = this.axis, l = c.series, h = c.options.reversedStacks, C = l.length;
              for (this.usePercentage = !1, i = C; i--; )
                (o = l[h ? i : C - i - 1]).setStackedPoints(), o.setGroupedPoints();
              for (i = 0; i < C; i++)
                l[i].modifyStacks();
              A(c, "afterBuildStacks");
            }, n.prototype.cleanStacks = function() {
              var o, i = this;
              i.oldStacks && (o = i.stacks = i.oldStacks), m(o, function(c) {
                m(c, function(l) {
                  l.cumulative = l.total;
                });
              });
            }, n.prototype.resetStacks = function() {
              var o = this;
              m(this.stacks, function(i) {
                m(i, function(c, l) {
                  d(c.touched) && c.touched < o.stacksTouched ? (c.destroy(), delete i[l]) : (c.total = null, c.cumulative = null);
                });
              });
            }, n.prototype.renderStackTotals = function() {
              var o = this, i = o.axis, c = i.chart, l = c.renderer, h = o.stacks, C = i.options.stackLabels && i.options.stackLabels.animation, M = Q(c, C || !1), O = o.stackTotalGroup = o.stackTotalGroup || l.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
              O.translate(c.plotLeft, c.plotTop), m(h, function(p) {
                m(p, function(w) {
                  w.render(O);
                });
              }), O.animate({ opacity: 1 }, M);
            }, n;
          }();
          return function(n) {
            var o = [];
            n.compose = function(i, c, l) {
              if (o.indexOf(i) === -1 && (o.push(i), U(i, "init", E), U(i, "destroy", x)), o.indexOf(c) === -1 && (o.push(c), c.prototype.getStacks = g), o.indexOf(l) === -1) {
                o.push(l);
                var h = l.prototype;
                h.getStackIndicator = P, h.modifyStacks = S, h.percentStacker = u, h.setGroupedPoints = y, h.setStackedPoints = s;
              }
            };
          }(a || (a = {})), a;
        }), at(_, "Series/Line/LineSeries.js", [_["Core/Series/Series.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(N, D) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, A) {
              k.__proto__ = A;
            } || function(k, A) {
              for (var b in A)
                A.hasOwnProperty(b) && (k[b] = A[b]);
            }, Y(N, D);
          }, function(N, D) {
            function k() {
              this.constructor = N;
            }
            Y(N, D), N.prototype = D === null ? Object.create(D) : (k.prototype = D.prototype, new k());
          }), Q = $.defined, q = $.merge, U = function(N) {
            function D() {
              var k = N !== null && N.apply(this, arguments) || this;
              return k.data = void 0, k.options = void 0, k.points = void 0, k;
            }
            return J(D, N), D.prototype.drawGraph = function() {
              var k = this, A = this.options, b = (this.gappedPath || this.getGraphPath).call(this), d = this.chart.styledMode, m = [["graph", "highcharts-graph"]];
              d || m[0].push(A.lineColor || this.color || "#cccccc", A.dashStyle), (m = k.getZonesGraphs(m)).forEach(function(v, g) {
                var x, E = v[0], P = k[E], S = P ? "animate" : "attr";
                P ? (P.endX = k.preventGraphAnimation ? null : b.xMap, P.animate({ d: b })) : b.length && (k[E] = P = k.chart.renderer.path(b).addClass(v[1]).attr({ zIndex: 1 }).add(k.group)), P && !d && (x = { stroke: v[2], "stroke-width": A.lineWidth || 0, fill: k.fillGraph && k.color || "none" }, v[3] ? x.dashstyle = v[3] : A.linecap !== "square" && (x["stroke-linecap"] = x["stroke-linejoin"] = "round"), P[S](x).shadow(g < 2 && A.shadow)), P && (P.startX = b.xMap, P.isArea = b.isArea);
              });
            }, D.prototype.getGraphPath = function(k, A, b) {
              var d, m = this, v = m.options, g = [], x = [], E = v.step, P = (k = k || m.points).reversed;
              return P && k.reverse(), (E = { right: 1, center: 2 }[E] || E && 3) && P && (E = 4 - E), (k = this.getValidPoints(k, !1, !(v.connectNulls && !A && !b))).forEach(function(S, u) {
                var y, s = S.plotX, a = S.plotY, e = k[u - 1];
                (S.leftCliff || e && e.rightCliff) && !b && (d = !0), S.isNull && !Q(A) && u > 0 ? d = !v.connectNulls : S.isNull && !A ? d = !0 : (u === 0 || d ? y = [["M", S.plotX, S.plotY]] : m.getPointSpline ? y = [m.getPointSpline(k, S, u)] : E ? (y = E === 1 ? [["L", e.plotX, a]] : E === 2 ? [["L", (e.plotX + s) / 2, e.plotY], ["L", (e.plotX + s) / 2, a]] : [["L", s, e.plotY]]).push(["L", s, a]) : y = [["L", s, a]], x.push(S.x), E && (x.push(S.x), E === 2 && x.push(S.x)), g.push.apply(g, y), d = !1);
              }), g.xMap = x, m.graphPath = g, g;
            }, D.prototype.getZonesGraphs = function(k) {
              return this.zones.forEach(function(A, b) {
                var d = ["zone-graph-" + b, "highcharts-graph highcharts-zone-graph-" + b + " " + (A.className || "")];
                this.chart.styledMode || d.push(A.color || this.color, A.dashStyle || this.options.dashStyle), k.push(d);
              }, this), k;
            }, D.defaultOptions = q(G.defaultOptions, {}), D;
          }(G);
          return F.registerSeriesType("line", U), U;
        }), at(_, "Series/Area/AreaSeries.js", [_["Core/Color/Color.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(d, m) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
              v.__proto__ = g;
            } || function(v, g) {
              for (var x in g)
                g.hasOwnProperty(x) && (v[x] = g[x]);
            }, J(d, m);
          }, function(d, m) {
            function v() {
              this.constructor = d;
            }
            J(d, m), d.prototype = m === null ? Object.create(m) : (v.prototype = m.prototype, new v());
          }), q = G.parse, U = $.seriesTypes.line, N = Y.extend, D = Y.merge, k = Y.objectEach, A = Y.pick, b = function(d) {
            function m() {
              var v = d !== null && d.apply(this, arguments) || this;
              return v.data = void 0, v.options = void 0, v.points = void 0, v;
            }
            return Q(m, d), m.prototype.drawGraph = function() {
              this.areaPath = [], d.prototype.drawGraph.apply(this);
              var v = this, g = this.areaPath, x = this.options, E = this.zones, P = [["area", "highcharts-area", this.color, x.fillColor]];
              E.forEach(function(S, u) {
                P.push(["zone-area-" + u, "highcharts-area highcharts-zone-area-" + u + " " + S.className, S.color || v.color, S.fillColor || x.fillColor]);
              }), P.forEach(function(S) {
                var u = S[0], y = {}, s = v[u], a = s ? "animate" : "attr";
                s ? (s.endX = v.preventGraphAnimation ? null : g.xMap, s.animate({ d: g })) : (y.zIndex = 0, (s = v[u] = v.chart.renderer.path(g).addClass(S[1]).add(v.group)).isArea = !0), v.chart.styledMode || (y.fill = A(S[3], q(S[2]).setOpacity(A(x.fillOpacity, 0.75)).get())), s[a](y), s.startX = g.xMap, s.shiftUnit = x.step ? 2 : 1;
              });
            }, m.prototype.getGraphPath = function(v) {
              var g, x, E, P = U.prototype.getGraphPath, S = this.options, u = S.stacking, y = this.yAxis, s = [], a = [], e = this.index, n = y.stacking.stacks[this.stackKey], o = S.threshold, i = Math.round(y.getThreshold(S.threshold)), c = A(S.connectNulls, u === "percent"), l = function(z, W, L) {
                var I, j, Z = v[z], V = u && n[Z.x].points[e], X = Z[L + "Null"] || 0, et = Z[L + "Cliff"] || 0, ot = !0;
                et || X ? (I = (X ? V[0] : V[1]) + et, j = V[0] + et, ot = !!X) : !u && v[W] && v[W].isNull && (I = j = o), I !== void 0 && (a.push({ plotX: g, plotY: I === null ? i : y.getThreshold(I), isNull: ot, isCliff: !0 }), s.push({ plotX: g, plotY: j === null ? i : y.getThreshold(j), doCurve: !1 }));
              };
              v = v || this.points, u && (v = this.getStackPoints(v));
              for (var h = 0, C = v.length; h < C; ++h)
                u || (v[h].leftCliff = v[h].rightCliff = v[h].leftNull = v[h].rightNull = void 0), x = v[h].isNull, g = A(v[h].rectPlotX, v[h].plotX), E = u ? A(v[h].yBottom, i) : i, x && !c || (c || l(h, h - 1, "left"), x && !u && c || (a.push(v[h]), s.push({ x: h, plotX: g, plotY: E })), c || l(h, h + 1, "right"));
              var M = P.call(this, a, !0, !0);
              s.reversed = !0;
              var O = P.call(this, s, !0, !0), p = O[0];
              p && p[0] === "M" && (O[0] = ["L", p[1], p[2]]);
              var w = M.concat(O);
              w.length && w.push(["Z"]);
              var T = P.call(this, a, !1, c);
              return w.xMap = M.xMap, this.areaPath = w, T;
            }, m.prototype.getStackPoints = function(v) {
              var g = this, x = [], E = [], P = this.xAxis, S = this.yAxis, u = S.stacking.stacks[this.stackKey], y = {}, s = S.series, a = s.length, e = S.options.reversedStacks ? 1 : -1, n = s.indexOf(g);
              if (v = v || this.points, this.options.stacking) {
                for (var o = 0; o < v.length; o++)
                  v[o].leftNull = v[o].rightNull = void 0, y[v[o].x] = v[o];
                k(u, function(c, l) {
                  c.total !== null && E.push(l);
                }), E.sort(function(c, l) {
                  return c - l;
                });
                var i = s.map(function(c) {
                  return c.visible;
                });
                E.forEach(function(c, l) {
                  var h, C, M = 0;
                  if (y[c] && !y[c].isNull)
                    x.push(y[c]), [-1, 1].forEach(function(w) {
                      var T = w === 1 ? "rightNull" : "leftNull", z = w === 1 ? "rightCliff" : "leftCliff", W = u[E[l + w]], L = 0;
                      if (W)
                        for (var I = n; I >= 0 && I < a; ) {
                          var j = s[I].index;
                          (h = W.points[j]) || (j === g.index ? y[c][T] = !0 : i[I] && (C = u[c].points[j]) && (L -= C[1] - C[0])), I += e;
                        }
                      y[c][z] = L;
                    });
                  else {
                    for (var O = n; O >= 0 && O < a; ) {
                      var p = s[O].index;
                      if (h = u[c].points[p]) {
                        M = h[1];
                        break;
                      }
                      O += e;
                    }
                    M = A(M, 0), M = S.translate(M, 0, 1, 0, 1), x.push({ isNull: !0, plotX: P.translate(c, 0, 0, 0, 1), x: c, plotY: M, yBottom: M });
                  }
                });
              }
              return x;
            }, m.defaultOptions = D(U.defaultOptions, { threshold: 0 }), m;
          }(U);
          return N(b.prototype, { singleStacks: !1, drawLegendSymbol: F.drawRectangle }), $.registerSeriesType("area", b), b;
        }), at(_, "Series/Spline/SplineSeries.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(N, D) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, A) {
              k.__proto__ = A;
            } || function(k, A) {
              for (var b in A)
                A.hasOwnProperty(b) && (k[b] = A[b]);
            }, $(N, D);
          }, function(N, D) {
            function k() {
              this.constructor = N;
            }
            $(N, D), N.prototype = D === null ? Object.create(D) : (k.prototype = D.prototype, new k());
          }), J = G.seriesTypes.line, Q = F.merge, q = F.pick, U = function(N) {
            function D() {
              var k = N !== null && N.apply(this, arguments) || this;
              return k.data = void 0, k.options = void 0, k.points = void 0, k;
            }
            return Y(D, N), D.prototype.getPointSpline = function(k, A, b) {
              var d, m, v, g, x = 1.5, E = 2.5, P = A.plotX || 0, S = A.plotY || 0, u = k[b - 1], y = k[b + 1];
              function s(l) {
                return l && !l.isNull && l.doCurve !== !1 && !A.isCliff;
              }
              if (s(u) && s(y)) {
                var a = u.plotX || 0, e = u.plotY || 0, n = y.plotX || 0, o = y.plotY || 0, i = 0;
                m = (x * S + e) / E, g = (x * S + o) / E, (v = (x * P + n) / E) != (d = (x * P + a) / E) && (i = (g - m) * (v - P) / (v - d) + S - g), g += i, (m += i) > e && m > S ? g = 2 * S - (m = Math.max(e, S)) : m < e && m < S && (g = 2 * S - (m = Math.min(e, S))), g > o && g > S ? m = 2 * S - (g = Math.max(o, S)) : g < o && g < S && (m = 2 * S - (g = Math.min(o, S))), A.rightContX = v, A.rightContY = g;
              }
              var c = ["C", q(u.rightContX, u.plotX, 0), q(u.rightContY, u.plotY, 0), q(d, P, 0), q(m, S, 0), P, S];
              return u.rightContX = u.rightContY = void 0, c;
            }, D.defaultOptions = Q(J.defaultOptions), D;
          }(J);
          return G.registerSeriesType("spline", U), U;
        }), at(_, "Series/AreaSpline/AreaSplineSeries.js", [_["Series/Spline/SplineSeries.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(b, d) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, J(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            J(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), q = $.seriesTypes, U = q.area, N = q.area.prototype, D = Y.extend, k = Y.merge, A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.data = void 0, m.points = void 0, m.options = void 0, m;
            }
            return Q(d, b), d.defaultOptions = k(G.defaultOptions, U.defaultOptions), d;
          }(G);
          return D(A.prototype, { getGraphPath: N.getGraphPath, getStackPoints: N.getStackPoints, drawGraph: N.drawGraph, drawLegendSymbol: F.drawRectangle }), $.registerSeriesType("areaspline", A), A;
        }), at(_, "Series/Column/ColumnSeriesDefaults.js", [], function() {
          return { borderRadius: 0, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
        }), at(_, "Series/Column/ColumnSeries.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Color/Color.js"], _["Series/Column/ColumnSeriesDefaults.js"], _["Core/Globals.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/Series.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N, D = this && this.__extends || (N = function(a, e) {
            return N = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
              n.__proto__ = o;
            } || function(n, o) {
              for (var i in o)
                o.hasOwnProperty(i) && (n[i] = o[i]);
            }, N(a, e);
          }, function(a, e) {
            function n() {
              this.constructor = a;
            }
            N(a, e), a.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
          }), k = G.animObject, A = F.parse, b = Y.hasTouch, d = Y.noop, m = U.clamp, v = U.defined, g = U.extend, x = U.fireEvent, E = U.isArray, P = U.isNumber, S = U.merge, u = U.pick, y = U.objectEach, s = function(a) {
            function e() {
              var n = a !== null && a.apply(this, arguments) || this;
              return n.borderWidth = void 0, n.data = void 0, n.group = void 0, n.options = void 0, n.points = void 0, n;
            }
            return D(e, a), e.prototype.animate = function(n) {
              var o, i, c = this, l = this.yAxis, h = c.options, C = this.chart.inverted, M = {}, O = C ? "translateX" : "translateY";
              n ? (M.scaleY = 1e-3, i = m(l.toPixels(h.threshold), l.pos, l.pos + l.len), C ? M.translateX = i - l.len : M.translateY = i, c.clipBox && c.setClip(), c.group.attr(M)) : (o = Number(c.group.attr(O)), c.group.animate({ scaleY: 1 }, g(k(c.options.animation), { step: function(p, w) {
                c.group && (M[O] = o + w.pos * (l.pos - o), c.group.attr(M));
              } })));
            }, e.prototype.init = function(n, o) {
              a.prototype.init.apply(this, arguments);
              var i = this;
              (n = i.chart).hasRendered && n.series.forEach(function(c) {
                c.type === i.type && (c.isDirty = !0);
              });
            }, e.prototype.getColumnMetrics = function() {
              var n, o = this, i = o.options, c = o.xAxis, l = o.yAxis, h = c.options.reversedStacks, C = c.reversed && !h || !c.reversed && h, M = {}, O = 0;
              i.grouping === !1 ? O = 1 : o.chart.series.forEach(function(L) {
                var I, j = L.yAxis, Z = L.options;
                L.type !== o.type || !L.visible && o.chart.options.chart.ignoreHiddenSeries || l.len !== j.len || l.pos !== j.pos || (Z.stacking && Z.stacking !== "group" ? (n = L.stackKey, M[n] === void 0 && (M[n] = O++), I = M[n]) : Z.grouping !== !1 && (I = O++), L.columnIndex = I);
              });
              var p = Math.min(Math.abs(c.transA) * (c.ordinal && c.ordinal.slope || i.pointRange || c.closestPointRange || c.tickInterval || 1), c.len), w = p * i.groupPadding, T = (p - 2 * w) / (O || 1), z = Math.min(i.maxPointWidth || c.len, u(i.pointWidth, T * (1 - 2 * i.pointPadding))), W = (T - z) / 2 + (w + ((o.columnIndex || 0) + (C ? 1 : 0)) * T - p / 2) * (C ? -1 : 1);
              return o.columnMetrics = { width: z, offset: W, paddedWidth: T, columnCount: O }, o.columnMetrics;
            }, e.prototype.crispCol = function(n, o, i, c) {
              var l = this.chart, h = this.borderWidth, C = -(h % 2 ? 0.5 : 0), M = h % 2 ? 0.5 : 1;
              l.inverted && l.renderer.isVML && (M += 1), this.options.crisp && (i = Math.round(n + i) + C - (n = Math.round(n) + C));
              var O = Math.round(o + c) + M, p = Math.abs(o) <= 0.5 && O > 0.5;
              return c = O - (o = Math.round(o) + M), p && c && (o -= 1, c += 1), { x: n, y: o, width: i, height: c };
            }, e.prototype.adjustForMissingColumns = function(n, o, i, c) {
              var l = this, h = this.options.stacking;
              if (!i.isNull && c.columnCount > 1) {
                var C = this.yAxis.options.reversedStacks, M = 0, O = C ? 0 : -c.columnCount;
                y(this.yAxis.stacking && this.yAxis.stacking.stacks, function(w) {
                  if (typeof i.x == "number") {
                    var T = w[i.x.toString()];
                    if (T) {
                      var z = T.points[l.index];
                      if (h)
                        z && (M = O), T.hasValidPoints && (C ? O++ : O--);
                      else if (E(z)) {
                        var W = Object.keys(T.points).filter(function(L) {
                          return !L.match(",") && T.points[L] && T.points[L].length > 1;
                        }).map(parseFloat).sort(function(L, I) {
                          return I - L;
                        });
                        M = W.indexOf(l.index), O = W.length;
                      }
                    }
                  }
                });
                var p = (O - 1) * c.paddedWidth + o;
                n = (i.plotX || 0) + p / 2 - o - M * c.paddedWidth;
              }
              return n;
            }, e.prototype.translate = function() {
              var n = this, o = n.chart, i = n.options, c = n.dense = n.closestPointRange * n.xAxis.transA < 2, l = n.borderWidth = u(i.borderWidth, c ? 0 : 1), h = n.xAxis, C = n.yAxis, M = i.threshold, O = n.translatedThreshold = C.getThreshold(M), p = u(i.minPointLength, 5), w = n.getColumnMetrics(), T = w.width, z = n.pointXOffset = w.offset, W = n.dataMin, L = n.dataMax, I = n.barW = Math.max(T, 1 + 2 * l);
              o.inverted && (O -= 0.5), i.pointPadding && (I = Math.ceil(I)), Q.prototype.translate.apply(n), n.points.forEach(function(j) {
                var Z, V = u(j.yBottom, O), X = 999 + Math.abs(V), et = j.plotX || 0, ot = m(j.plotY, -X, C.len + X), it = Math.min(ot, V), pt = Math.max(ot, V) - it, mt = T, Ct = et + z, kt = I;
                p && Math.abs(pt) < p && (pt = p, Z = !C.reversed && !j.negative || C.reversed && j.negative, P(M) && P(L) && j.y === M && L <= M && (C.min || 0) < M && (W !== L || (C.max || 0) <= M) && (Z = !Z), it = Math.abs(it - O) > p ? V - p : O - (Z ? p : 0)), v(j.options.pointWidth) && (mt = kt = Math.ceil(j.options.pointWidth), Ct -= Math.round((mt - T) / 2)), i.centerInCategory && (Ct = n.adjustForMissingColumns(Ct, mt, j, w)), j.barX = Ct, j.pointWidth = mt, j.tooltipPos = o.inverted ? [m(C.len + C.pos - o.plotLeft - ot, C.pos - o.plotLeft, C.len + C.pos - o.plotLeft), h.len + h.pos - o.plotTop - Ct - kt / 2, pt] : [h.left - o.plotLeft + Ct + kt / 2, m(ot + C.pos - o.plotTop, C.pos - o.plotTop, C.len + C.pos - o.plotTop), pt], j.shapeType = n.pointClass.prototype.shapeType || "rect", j.shapeArgs = n.crispCol.apply(n, j.isNull ? [Ct, O, kt, 0] : [Ct, it, kt, pt]);
              });
            }, e.prototype.drawGraph = function() {
              this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }, e.prototype.pointAttribs = function(n, o) {
              var i, c, l, h = this.options, C = this.pointAttrToOptions || {}, M = C.stroke || "borderColor", O = C["stroke-width"] || "borderWidth", p = n && n.color || this.color, w = n && n[M] || h[M] || p, T = n && n.options.dashStyle || h.dashStyle, z = n && n[O] || h[O] || this[O] || 0, W = u(n && n.opacity, h.opacity, 1);
              n && this.zones.length && (c = n.getZone(), p = n.options.color || c && (c.color || n.nonZonedColor) || this.color, c && (w = c.borderColor || w, T = c.dashStyle || T, z = c.borderWidth || z)), o && n && (l = (i = S(h.states[o], n.options.states && n.options.states[o] || {})).brightness, p = i.color || l !== void 0 && A(p).brighten(i.brightness).get() || p, w = i[M] || w, z = i[O] || z, T = i.dashStyle || T, W = u(i.opacity, W));
              var L = { fill: p, stroke: w, "stroke-width": z, opacity: W };
              return T && (L.dashstyle = T), L;
            }, e.prototype.drawPoints = function(n) {
              n === void 0 && (n = this.points);
              var o, i = this, c = this.chart, l = i.options, h = c.renderer, C = l.animationLimit || 250;
              n.forEach(function(M) {
                var O = M.plotY, p = M.graphic, w = !!p, T = p && c.pointCount < C ? "animate" : "attr";
                P(O) && M.y !== null ? (o = M.shapeArgs, p && M.hasNewShapeType() && (p = p.destroy()), i.enabledDataSorting && (M.startXPos = i.xAxis.reversed ? -(o && o.width || 0) : i.xAxis.width), p || (M.graphic = p = h[M.shapeType](o).add(M.group || i.group), p && i.enabledDataSorting && c.hasRendered && c.pointCount < C && (p.attr({ x: M.startXPos }), w = !0, T = "animate")), p && w && p[T](S(o)), l.borderRadius && p[T]({ r: l.borderRadius }), c.styledMode || p[T](i.pointAttribs(M, M.selected && "select")).shadow(M.allowShadow !== !1 && l.shadow, null, l.stacking && !l.borderRadius), p && (p.addClass(M.getClassName(), !0), p.attr({ visibility: M.visible ? "inherit" : "hidden" }))) : p && (M.graphic = p.destroy());
              });
            }, e.prototype.drawTracker = function(n) {
              n === void 0 && (n = this.points);
              var o, i = this, c = i.chart, l = c.pointer, h = function(C) {
                var M = l.getPointFromEvent(C);
                M !== void 0 && (l.isDirectTouch = !0, M.onMouseOver(C));
              };
              n.forEach(function(C) {
                o = E(C.dataLabels) ? C.dataLabels : C.dataLabel ? [C.dataLabel] : [], C.graphic && (C.graphic.element.point = C), o.forEach(function(M) {
                  M.div ? M.div.point = C : M.element.point = C;
                });
              }), i._hasTracking || (i.trackerGroups.forEach(function(C) {
                i[C] && (i[C].addClass("highcharts-tracker").on("mouseover", h).on("mouseout", function(M) {
                  l.onTrackerMouseOut(M);
                }), b && i[C].on("touchstart", h), !c.styledMode && i.options.cursor && i[C].css({ cursor: i.options.cursor }));
              }), i._hasTracking = !0), x(this, "afterDrawTracker");
            }, e.prototype.remove = function() {
              var n = this, o = n.chart;
              o.hasRendered && o.series.forEach(function(i) {
                i.type === n.type && (i.isDirty = !0);
              }), Q.prototype.remove.apply(n, arguments);
            }, e.defaultOptions = S(Q.defaultOptions, $), e;
          }(Q);
          return g(s.prototype, { cropShoulder: 0, directTouch: !0, drawLegendSymbol: J.drawRectangle, getSymbol: d, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), q.registerSeriesType("column", s), s;
        }), at(_, "Core/Series/DataLabel.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/FormatUtilities.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = G.getDeferredAnimation, Q = F.format, q = $.defined, U = $.extend, N = $.fireEvent, D = $.isArray, k = $.isString, A = $.merge, b = $.objectEach, d = $.pick, m = $.splat;
          return function(v) {
            var g = [];
            function x(y, s, a, e, n) {
              var o, i, c, l = this, h = this.chart, C = this.isCartesian && h.inverted, M = this.enabledDataSorting, O = y.plotX, p = y.plotY, w = a.rotation, T = a.align, z = q(O) && q(p) && h.isInsidePlot(O, Math.round(p), { inverted: C, paneCoordinates: !0, series: l }), W = function(ot) {
                M && l.xAxis && !L && l.setDataLabelStartPos(y, s, n, z, ot);
              }, L = d(a.overflow, M ? "none" : "justify") === "justify", I = this.visible && y.visible !== !1 && q(O) && (y.series.forceDL || M && !L || z || d(a.inside, !!this.options.stacking) && e && h.isInsidePlot(O, C ? e.x + 1 : e.y + e.height - 1, { inverted: C, paneCoordinates: !0, series: l })), j = y.pos();
              if (I && j) {
                w && s.attr({ align: T });
                var Z = s.getBBox(!0), V = [0, 0];
                if (o = h.renderer.fontMetrics(h.styledMode ? void 0 : a.style.fontSize, s).b, e = U({ x: j[0], y: Math.round(j[1]), width: 0, height: 0 }, e), U(a, { width: Z.width, height: Z.height }), w ? (L = !1, i = h.renderer.rotCorr(o, w), c = { x: e.x + (a.x || 0) + e.width / 2 + i.x, y: e.y + (a.y || 0) + { top: 0, middle: 0.5, bottom: 1 }[a.verticalAlign] * e.height }, V = [Z.x - Number(s.attr("x")), Z.y - Number(s.attr("y"))], W(c), s[n ? "attr" : "animate"](c)) : (W(e), s.align(a, void 0, e), c = s.alignAttr), L && e.height >= 0)
                  this.justifyDataLabel(s, a, c, Z, e, n);
                else if (d(a.crop, !0)) {
                  var X = c.x, et = c.y;
                  X += V[0], et += V[1], I = h.isInsidePlot(X, et, { paneCoordinates: !0, series: l }) && h.isInsidePlot(X + Z.width, et + Z.height, { paneCoordinates: !0, series: l });
                }
                a.shape && !w && s[n ? "attr" : "animate"]({ anchorX: j[0], anchorY: j[1] });
              }
              n && M && (s.placed = !1), I || M && !L ? s.show() : (s.hide(), s.placed = !1);
            }
            function E(y) {
              y === void 0 && (y = this.points);
              var s, a = this, e = a.chart, n = a.options, o = a.hasRendered || 0, i = e.renderer, c = e.options.chart, l = c.backgroundColor, h = c.plotBackgroundColor, C = i.getContrast(k(h) && h || k(l) && l || "#000000"), M = n.dataLabels, O = M.animation, p = M.defer ? J(e, O, a) : { defer: 0, duration: 0 };
              if (M = S(S(e.options.plotOptions && e.options.plotOptions.series && e.options.plotOptions.series.dataLabels, e.options.plotOptions && e.options.plotOptions[a.type] && e.options.plotOptions[a.type].dataLabels), M), N(this, "drawDataLabels"), D(M) || M.enabled || a._hasPointLabels) {
                if ((s = a.plotGroup("dataLabelsGroup", "data-labels", o ? "inherit" : "hidden", M.zIndex || 6)).attr({ opacity: +o }), !o) {
                  var w = a.dataLabelsGroup;
                  w && (a.visible && s.show(), w[n.animation ? "animate" : "attr"]({ opacity: 1 }, p));
                }
                y.forEach(function(T) {
                  m(S(M, T.dlOptions || T.options && T.options.dataLabels)).forEach(function(z, W) {
                    var L, I, j, Z, V, X, et = z.enabled && (!T.isNull || T.dataLabelOnNull) && function(Tt, xt) {
                      var ct = xt.filter;
                      if (ct) {
                        var ft = ct.operator, St = Tt[ct.property], Mt = ct.value;
                        return ft === ">" && St > Mt || ft === "<" && St < Mt || ft === ">=" && St >= Mt || ft === "<=" && St <= Mt || ft === "==" && St == Mt || ft === "===" && St === Mt;
                      }
                      return !0;
                    }(T, z), ot = T.connectors ? T.connectors[W] : T.connector, it = T.dataLabels ? T.dataLabels[W] : T.dataLabel, pt = !it, mt = d(z.distance, T.labelDistance);
                    if (et) {
                      if (L = T.getLabelConfig(), I = d(z[T.formatPrefix + "Format"], z.format), j = q(I) ? Q(I, L, e) : (z[T.formatPrefix + "Formatter"] || z.formatter).call(L, z), Z = z.style, V = z.rotation, e.styledMode || (Z.color = d(z.color, Z.color, a.color, "#000000"), Z.color === "contrast" ? (T.contrastColor = i.getContrast(T.color || a.color), Z.color = !q(mt) && z.inside || mt < 0 || n.stacking ? T.contrastColor : C) : delete T.contrastColor, n.cursor && (Z.cursor = n.cursor)), X = { r: z.borderRadius || 0, rotation: V, padding: z.padding, zIndex: 1 }, !e.styledMode) {
                        var Ct = z.backgroundColor, kt = z.borderColor;
                        X.fill = Ct === "auto" ? T.color : Ct, X.stroke = kt === "auto" ? T.color : kt, X["stroke-width"] = z.borderWidth;
                      }
                      b(X, function(Tt, xt) {
                        Tt === void 0 && delete X[xt];
                      });
                    }
                    if (!it || et && q(j) && !!it.div == !!z.useHTML && (it.rotation && z.rotation || it.rotation === z.rotation) || (pt = !0, T.dataLabel = it = T.dataLabel && T.dataLabel.destroy(), T.dataLabels && (T.dataLabels.length === 1 ? delete T.dataLabels : delete T.dataLabels[W]), W || delete T.dataLabel, ot && (T.connector = T.connector.destroy(), T.connectors && (T.connectors.length === 1 ? delete T.connectors : delete T.connectors[W]))), et && q(j)) {
                      it ? X.text = j : (T.dataLabels = T.dataLabels || [], it = T.dataLabels[W] = V ? i.text(j, 0, 0, z.useHTML).addClass("highcharts-data-label") : i.label(j, 0, 0, z.shape, null, null, z.useHTML, null, "data-label"), W || (T.dataLabel = it), it.addClass(" highcharts-data-label-color-" + T.colorIndex + " " + (z.className || "") + (z.useHTML ? " highcharts-tracker" : ""))), it.options = z, it.attr(X), e.styledMode || it.css(Z).shadow(z.shadow);
                      var Lt = z[T.formatPrefix + "TextPath"] || z.textPath;
                      Lt && !z.useHTML && (it.setTextPath(T.getDataLabelPath && T.getDataLabelPath(it) || T.graphic, Lt), T.dataLabelPath && !Lt.enabled && (T.dataLabelPath = T.dataLabelPath.destroy())), it.added || it.add(s), a.alignDataLabel(T, it, z, null, pt);
                    } else
                      it && it.hide();
                  });
                });
              }
              N(this, "afterDrawDataLabels");
            }
            function P(y, s, a, e, n, o) {
              var i, c, l = this.chart, h = s.align, C = s.verticalAlign, M = y.box ? 0 : y.padding || 0, O = s.x, p = O === void 0 ? 0 : O, w = s.y, T = w === void 0 ? 0 : w;
              return (i = (a.x || 0) + M) < 0 && (h === "right" && p >= 0 ? (s.align = "left", s.inside = !0) : p -= i, c = !0), (i = (a.x || 0) + e.width - M) > l.plotWidth && (h === "left" && p <= 0 ? (s.align = "right", s.inside = !0) : p += l.plotWidth - i, c = !0), (i = a.y + M) < 0 && (C === "bottom" && T >= 0 ? (s.verticalAlign = "top", s.inside = !0) : T -= i, c = !0), (i = (a.y || 0) + e.height - M) > l.plotHeight && (C === "top" && T <= 0 ? (s.verticalAlign = "bottom", s.inside = !0) : T += l.plotHeight - i, c = !0), c && (s.x = p, s.y = T, y.placed = !o, y.align(s, void 0, n)), c;
            }
            function S(y, s) {
              var a, e = [];
              if (D(y) && !D(s))
                e = y.map(function(n) {
                  return A(n, s);
                });
              else if (D(s) && !D(y))
                e = s.map(function(n) {
                  return A(y, n);
                });
              else if (D(y) || D(s))
                for (a = Math.max(y.length, s.length); a--; )
                  e[a] = A(y[a], s[a]);
              else
                e = A(y, s);
              return e;
            }
            function u(y, s, a, e, n) {
              var o = this.chart, i = o.inverted, c = this.xAxis, l = c.reversed, h = i ? s.height / 2 : s.width / 2, C = y.pointWidth, M = C ? C / 2 : 0;
              s.startXPos = i ? n.x : l ? -h - M : c.width - h + M, s.startYPos = i ? l ? this.yAxis.height - h + M : -h - M : n.y, e ? s.visibility === "hidden" && (s.show(), s.attr({ opacity: 0 }).animate({ opacity: 1 })) : s.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, s.hide), o.hasRendered && (a && s.attr({ x: s.startXPos, y: s.startYPos }), s.placed = !0);
            }
            v.compose = function(y) {
              if (g.indexOf(y) === -1) {
                var s = y.prototype;
                g.push(y), s.alignDataLabel = x, s.drawDataLabels = E, s.justifyDataLabel = P, s.setDataLabelStartPos = u;
              }
            };
          }(Y || (Y = {})), Y;
        }), at(_, "Series/Column/ColumnDataLabel.js", [_["Core/Series/DataLabel.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = F.series, Q = $.merge, q = $.pick;
          return function(U) {
            var N = [];
            function D(k, A, b, d, m) {
              var v, g = this.chart.inverted, x = k.series, E = (x.xAxis ? x.xAxis.len : this.chart.plotSizeX) || 0, P = (x.yAxis ? x.yAxis.len : this.chart.plotSizeY) || 0, S = k.dlBox || k.shapeArgs, u = q(k.below, k.plotY > q(this.translatedThreshold, P)), y = q(b.inside, !!this.options.stacking);
              S && ((d = Q(S)).y < 0 && (d.height += d.y, d.y = 0), (v = d.y + d.height - P) > 0 && v < d.height && (d.height -= v), g && (d = { x: P - d.y - d.height, y: E - d.x - d.width, width: d.height, height: d.width }), y || (g ? (d.x += u ? 0 : d.width, d.width = 0) : (d.y += u ? d.height : 0, d.height = 0))), b.align = q(b.align, !g || y ? "center" : u ? "right" : "left"), b.verticalAlign = q(b.verticalAlign, g || y ? "middle" : u ? "top" : "bottom"), J.prototype.alignDataLabel.call(this, k, A, b, d, m), b.inside && k.contrastColor && A.css({ color: k.contrastColor });
            }
            U.compose = function(k) {
              G.compose(J), N.indexOf(k) === -1 && (N.push(k), k.prototype.alignDataLabel = D);
            };
          }(Y || (Y = {})), Y;
        }), at(_, "Series/Bar/BarSeries.js", [_["Series/Column/ColumnSeries.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(N, D) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, A) {
              k.__proto__ = A;
            } || function(k, A) {
              for (var b in A)
                A.hasOwnProperty(b) && (k[b] = A[b]);
            }, Y(N, D);
          }, function(N, D) {
            function k() {
              this.constructor = N;
            }
            Y(N, D), N.prototype = D === null ? Object.create(D) : (k.prototype = D.prototype, new k());
          }), Q = $.extend, q = $.merge, U = function(N) {
            function D() {
              var k = N !== null && N.apply(this, arguments) || this;
              return k.data = void 0, k.options = void 0, k.points = void 0, k;
            }
            return J(D, N), D.defaultOptions = q(G.defaultOptions, {}), D;
          }(G);
          return Q(U.prototype, { inverted: !0 }), F.registerSeriesType("bar", U), U;
        }), at(_, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
          return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
        }), at(_, "Series/Scatter/ScatterSeries.js", [_["Series/Scatter/ScatterSeriesDefaults.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(b, d) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, Y(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            Y(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), Q = F.seriesTypes, q = Q.column, U = Q.line, N = $.addEvent, D = $.extend, k = $.merge, A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.data = void 0, m.options = void 0, m.points = void 0, m;
            }
            return J(d, b), d.prototype.applyJitter = function() {
              var m = this, v = this.options.jitter, g = this.points.length;
              v && this.points.forEach(function(x, E) {
                ["x", "y"].forEach(function(P, S) {
                  var u, y, s, a, e, n, o = "plot" + P.toUpperCase();
                  v[P] && !x.isNull && (u = m[P + "Axis"], a = v[P] * u.transA, u && !u.isLog && (y = Math.max(0, x[o] - a), s = Math.min(u.len, x[o] + a), x[o] = y + (s - y) * (e = E + S * g, (n = 1e4 * Math.sin(e)) - Math.floor(n)), P === "x" && (x.clientX = x.plotX)));
                });
              });
            }, d.prototype.drawGraph = function() {
              this.options.lineWidth ? b.prototype.drawGraph.call(this) : this.graph && (this.graph = this.graph.destroy());
            }, d.defaultOptions = k(U.defaultOptions, G), d;
          }(U);
          return D(A.prototype, { drawTracker: q.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], takeOrdinalPosition: !1 }), N(A, "afterTranslate", function() {
            this.applyJitter();
          }), F.registerSeriesType("scatter", A), A;
        }), at(_, "Series/CenteredUtilities.js", [_["Core/Globals.js"], _["Core/Series/Series.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = G.deg2rad, Q = $.fireEvent, q = $.isNumber, U = $.pick, N = $.relativeLength;
          return function(D) {
            D.getCenter = function() {
              var k, A, b, d = this.options, m = this.chart, v = 2 * (d.slicedOffset || 0), g = m.plotWidth - 2 * v, x = m.plotHeight - 2 * v, E = d.center, P = Math.min(g, x), S = d.thickness, u = d.size, y = d.innerSize || 0;
              typeof u == "string" && (u = parseFloat(u)), typeof y == "string" && (y = parseFloat(y));
              var s = [U(E[0], "50%"), U(E[1], "50%"), U(u && u < 0 ? void 0 : d.size, "100%"), U(y && y < 0 ? void 0 : d.innerSize || 0, "0%")];
              for (!m.angular || this instanceof F || (s[3] = 0), A = 0; A < 4; ++A)
                b = s[A], k = A < 2 || A === 2 && /%$/.test(b), s[A] = N(b, [g, x, P, s[2]][A]) + (k ? v : 0);
              return s[3] > s[2] && (s[3] = s[2]), q(S) && 2 * S < s[2] && S > 0 && (s[3] = s[2] - 2 * S), Q(this, "afterGetCenter", { positions: s }), s;
            }, D.getStartAndEndRadians = function(k, A) {
              var b = q(k) ? k : 0, d = q(A) && A > b && A - b < 360 ? A : b + 360;
              return { start: J * (b + -90), end: J * (d + -90) };
            };
          }(Y || (Y = {})), Y;
        }), at(_, "Series/Pie/PiePoint.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Series/Point.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(d, m) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
              v.__proto__ = g;
            } || function(v, g) {
              for (var x in g)
                g.hasOwnProperty(x) && (v[x] = g[x]);
            }, Y(d, m);
          }, function(d, m) {
            function v() {
              this.constructor = d;
            }
            Y(d, m), d.prototype = m === null ? Object.create(m) : (v.prototype = m.prototype, new v());
          }), Q = G.setAnimation, q = $.addEvent, U = $.defined, N = $.extend, D = $.isNumber, k = $.pick, A = $.relativeLength, b = function(d) {
            function m() {
              var v = d !== null && d.apply(this, arguments) || this;
              return v.labelDistance = void 0, v.options = void 0, v.series = void 0, v;
            }
            return J(m, d), m.prototype.getConnectorPath = function() {
              var v = this.labelPosition, g = this.series.options.dataLabels, x = this.connectorShapes, E = g.connectorShape;
              return x[E] && (E = x[E]), E.call(this, { x: v.final.x, y: v.final.y, alignment: v.alignment }, v.connectorPosition, g);
            }, m.prototype.getTranslate = function() {
              return this.sliced ? this.slicedTranslation : { translateX: 0, translateY: 0 };
            }, m.prototype.haloPath = function(v) {
              var g = this.shapeArgs;
              return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(g.x, g.y, g.r + v, g.r + v, { innerR: g.r - 1, start: g.start, end: g.end });
            }, m.prototype.init = function() {
              var v = this;
              d.prototype.init.apply(this, arguments), this.name = k(this.name, "Slice");
              var g = function(x) {
                v.slice(x.type === "select");
              };
              return q(this, "select", g), q(this, "unselect", g), this;
            }, m.prototype.isValid = function() {
              return D(this.y) && this.y >= 0;
            }, m.prototype.setVisible = function(v, g) {
              var x = this, E = this.series, P = E.chart, S = E.options.ignoreHiddenPoint;
              g = k(g, S), v !== this.visible && (this.visible = this.options.visible = v = v === void 0 ? !this.visible : v, E.options.data[E.data.indexOf(this)] = this.options, ["graphic", "dataLabel", "connector", "shadowGroup"].forEach(function(u) {
                x[u] && x[u][v ? "show" : "hide"](v);
              }), this.legendItem && P.legend.colorizeItem(this, v), v || this.state !== "hover" || this.setState(""), S && (E.isDirty = !0), g && P.redraw());
            }, m.prototype.slice = function(v, g, x) {
              var E = this.series, P = E.chart;
              Q(x, P), g = k(g, !0), this.sliced = this.options.sliced = v = U(v) ? v : !this.sliced, E.options.data[E.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate()), this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
            }, m;
          }(F);
          return N(b.prototype, { connectorShapes: { fixedOffset: function(d, m, v) {
            var g = m.breakAt, x = m.touchingSliceAt, E = v.softConnector ? ["C", d.x + (d.alignment === "left" ? -5 : 5), d.y, 2 * g.x - x.x, 2 * g.y - x.y, g.x, g.y] : ["L", g.x, g.y];
            return [["M", d.x, d.y], E, ["L", x.x, x.y]];
          }, straight: function(d, m) {
            var v = m.touchingSliceAt;
            return [["M", d.x, d.y], ["L", v.x, v.y]];
          }, crookedLine: function(d, m, v) {
            var g = m.touchingSliceAt, x = this.series, E = x.center[0], P = x.chart.plotWidth, S = x.chart.plotLeft, u = d.alignment, y = this.shapeArgs.r, s = A(v.crookDistance, 1), a = u === "left" ? E + y + (P + S - E - y) * (1 - s) : S + (E - y) * s, e = ["L", a, d.y], n = !0;
            (u === "left" ? a > d.x || a < g.x : a < d.x || a > g.x) && (n = !1);
            var o = [["M", d.x, d.y]];
            return n && o.push(e), o.push(["L", g.x, g.y]), o;
          } } }), b;
        }), at(_, "Series/Pie/PieSeriesDefaults.js", [], function() {
          return { center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { allowOverlap: !0, connectorPadding: 5, connectorShape: "fixedOffset", crookDistance: "70%", distance: 30, enabled: !0, formatter: function() {
            return this.point.isNull ? void 0 : this.point.name;
          }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
        }), at(_, "Series/Pie/PieSeries.js", [_["Series/CenteredUtilities.js"], _["Series/Column/ColumnSeries.js"], _["Core/Globals.js"], _["Core/Legend/LegendSymbol.js"], _["Series/Pie/PiePoint.js"], _["Series/Pie/PieSeriesDefaults.js"], _["Core/Series/Series.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/Symbols.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N, D) {
          var k, A = this && this.__extends || (k = function(u, y) {
            return k = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, a) {
              s.__proto__ = a;
            } || function(s, a) {
              for (var e in a)
                a.hasOwnProperty(e) && (s[e] = a[e]);
            }, k(u, y);
          }, function(u, y) {
            function s() {
              this.constructor = u;
            }
            k(u, y), u.prototype = y === null ? Object.create(y) : (s.prototype = y.prototype, new s());
          }), b = G.getStartAndEndRadians, d = $.noop, m = D.clamp, v = D.extend, g = D.fireEvent, x = D.merge, E = D.pick, P = D.relativeLength, S = function(u) {
            function y() {
              var s = u !== null && u.apply(this, arguments) || this;
              return s.center = void 0, s.data = void 0, s.maxLabelDistance = void 0, s.options = void 0, s.points = void 0, s;
            }
            return A(y, u), y.prototype.animate = function(s) {
              var a = this, e = a.points, n = a.startAngleRad;
              s || e.forEach(function(o) {
                var i = o.graphic, c = o.shapeArgs;
                i && c && (i.attr({ r: E(o.startR, a.center && a.center[3] / 2), start: n, end: n }), i.animate({ r: c.r, start: c.start, end: c.end }, a.options.animation));
              });
            }, y.prototype.drawEmpty = function() {
              var s, a, e = this.startAngleRad, n = this.endAngleRad, o = this.options;
              this.total === 0 && this.center ? (s = this.center[0], a = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(s, a, this.center[1] / 2, 0, e, n).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: N.arc(s, a, this.center[2] / 2, 0, { start: e, end: n, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": o.borderWidth, fill: o.fillColor || "none", stroke: o.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
            }, y.prototype.drawPoints = function() {
              var s = this.chart.renderer;
              this.points.forEach(function(a) {
                a.graphic && a.hasNewShapeType() && (a.graphic = a.graphic.destroy()), a.graphic || (a.graphic = s[a.shapeType](a.shapeArgs).add(a.series.group), a.delayedRendering = !0);
              });
            }, y.prototype.generatePoints = function() {
              u.prototype.generatePoints.call(this), this.updateTotals();
            }, y.prototype.getX = function(s, a, e) {
              var n = this.center, o = this.radii ? this.radii[e.index] || 0 : n[2] / 2, i = Math.asin(m((s - n[1]) / (o + e.labelDistance), -1, 1));
              return n[0] + (a ? -1 : 1) * (Math.cos(i) * (o + e.labelDistance)) + (e.labelDistance > 0 ? (a ? -1 : 1) * this.options.dataLabels.padding : 0);
            }, y.prototype.hasData = function() {
              return !!this.processedXData.length;
            }, y.prototype.redrawPoints = function() {
              var s, a, e, n, o = this, i = o.chart, c = i.renderer, l = o.options.shadow;
              this.drawEmpty(), !l || o.shadowGroup || i.styledMode || (o.shadowGroup = c.g("shadow").attr({ zIndex: -1 }).add(o.group)), o.points.forEach(function(h) {
                var C = {};
                if (a = h.graphic, !h.isNull && a) {
                  var M = void 0;
                  n = h.shapeArgs, s = h.getTranslate(), i.styledMode || (M = h.shadowGroup, l && !M && (M = h.shadowGroup = c.g("shadow").add(o.shadowGroup)), M && M.attr(s), e = o.pointAttribs(h, h.selected && "select")), h.delayedRendering ? (a.setRadialReference(o.center).attr(n).attr(s), i.styledMode || a.attr(e).attr({ "stroke-linejoin": "round" }).shadow(l, M), h.delayedRendering = !1) : (a.setRadialReference(o.center), i.styledMode || x(!0, C, e), x(!0, C, n, s), a.animate(C)), a.attr({ visibility: h.visible ? "inherit" : "hidden" }), a.addClass(h.getClassName(), !0);
                } else
                  a && (h.graphic = a.destroy());
              });
            }, y.prototype.sortByAngle = function(s, a) {
              s.sort(function(e, n) {
                return e.angle !== void 0 && (n.angle - e.angle) * a;
              });
            }, y.prototype.translate = function(s) {
              g(this, "translate"), this.generatePoints();
              var a, e, n, o, i, c, l, h, C = this, M = 1e3, O = C.options, p = O.slicedOffset, w = p + (O.borderWidth || 0), T = b(O.startAngle, O.endAngle), z = C.startAngleRad = T.start, W = (C.endAngleRad = T.end) - z, L = C.points, I = O.dataLabels.distance, j = O.ignoreHiddenPoint, Z = L.length, V = 0;
              for (s || (C.center = s = C.getCenter()), l = 0; l < Z; l++) {
                e = z + V * W, !(h = L[l]).isValid() || j && !h.visible || (V += h.percentage / 100), n = z + V * W;
                var X = { x: s[0], y: s[1], r: s[2] / 2, innerR: s[3] / 2, start: Math.round(e * M) / M, end: Math.round(n * M) / M };
                h.shapeType = "arc", h.shapeArgs = X, h.labelDistance = E(h.options.dataLabels && h.options.dataLabels.distance, I), h.labelDistance = P(h.labelDistance, X.r), C.maxLabelDistance = Math.max(C.maxLabelDistance || 0, h.labelDistance), (o = (n + e) / 2) > 1.5 * Math.PI ? o -= 2 * Math.PI : o < -Math.PI / 2 && (o += 2 * Math.PI), h.slicedTranslation = { translateX: Math.round(Math.cos(o) * p), translateY: Math.round(Math.sin(o) * p) }, i = Math.cos(o) * s[2] / 2, c = Math.sin(o) * s[2] / 2, h.tooltipPos = [s[0] + 0.7 * i, s[1] + 0.7 * c], h.half = o < -Math.PI / 2 || o > Math.PI / 2 ? 1 : 0, h.angle = o, a = Math.min(w, h.labelDistance / 5), h.labelPosition = { natural: { x: s[0] + i + Math.cos(o) * h.labelDistance, y: s[1] + c + Math.sin(o) * h.labelDistance }, final: {}, alignment: h.labelDistance < 0 ? "center" : h.half ? "right" : "left", connectorPosition: { breakAt: { x: s[0] + i + Math.cos(o) * a, y: s[1] + c + Math.sin(o) * a }, touchingSliceAt: { x: s[0] + i, y: s[1] + c } } };
              }
              g(C, "afterTranslate");
            }, y.prototype.updateTotals = function() {
              var s, a, e = this.points, n = e.length, o = this.options.ignoreHiddenPoint, i = 0;
              for (s = 0; s < n; s++)
                !(a = e[s]).isValid() || o && !a.visible || (i += a.y);
              for (this.total = i, s = 0; s < n; s++)
                (a = e[s]).percentage = i > 0 && (a.visible || !o) ? a.y / i * 100 : 0, a.total = i;
            }, y.defaultOptions = x(q.defaultOptions, Q), y;
          }(q);
          return v(S.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawLegendSymbol: Y.drawRectangle, drawTracker: F.prototype.drawTracker, getCenter: G.getCenter, getSymbol: d, isCartesian: !1, noSharedTooltip: !0, pointAttribs: F.prototype.pointAttribs, pointClass: J, requireSorting: !1, searchPoint: d, trackerGroups: ["group", "dataLabelsGroup"] }), U.registerSeriesType("pie", S), S;
        }), at(_, "Series/Pie/PieDataLabel.js", [_["Core/Series/DataLabel.js"], _["Core/Globals.js"], _["Core/Renderer/RendererUtilities.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q, q = F.noop, U = $.distribute, N = Y.series, D = J.arrayMax, k = J.clamp, A = J.defined, b = J.merge, d = J.pick, m = J.relativeLength;
          return function(v) {
            var g = [], x = { radialDistributionY: function(u) {
              return u.top + u.distributeBox.pos;
            }, radialDistributionX: function(u, y, s, a) {
              return u.getX(s < y.top + 2 || s > y.bottom - 2 ? a : s, y.half, y);
            }, justify: function(u, y, s) {
              return s[0] + (u.half ? -1 : 1) * (y + u.labelDistance);
            }, alignToPlotEdges: function(u, y, s, a) {
              var e = u.getBBox().width;
              return y ? e + a : s - e - a;
            }, alignToConnectors: function(u, y, s, a) {
              var e, n = 0;
              return u.forEach(function(o) {
                (e = o.dataLabel.getBBox().width) > n && (n = e);
              }), y ? n + a : s - n - a;
            } };
            function E() {
              var u, y, s, a, e, n, o, i, c, l, h, C, M = this, O = M.data, p = M.chart, w = M.options.dataLabels || {}, T = w.connectorPadding, z = p.plotWidth, W = p.plotHeight, L = p.plotLeft, I = Math.round(p.chartWidth / 3), j = M.center, Z = j[2] / 2, V = j[1], X = [[], []], et = [0, 0, 0, 0], ot = M.dataLabelPositioners;
              M.visible && (w.enabled || M._hasPointLabels) && (O.forEach(function(it) {
                it.dataLabel && it.visible && it.dataLabel.shortened && (it.dataLabel.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), it.dataLabel.shortened = !1);
              }), N.prototype.drawDataLabels.apply(M), O.forEach(function(it) {
                it.dataLabel && (it.visible ? (X[it.half].push(it), it.dataLabel._pos = null, A(w.style.width) || A(it.options.dataLabels && it.options.dataLabels.style && it.options.dataLabels.style.width) || it.dataLabel.getBBox().width > I && (it.dataLabel.css({ width: Math.round(0.7 * I) + "px" }), it.dataLabel.shortened = !0)) : (it.dataLabel = it.dataLabel.destroy(), it.dataLabels && it.dataLabels.length === 1 && delete it.dataLabels));
              }), X.forEach(function(it, pt) {
                var mt, Ct, kt, Lt, Tt, xt, ct = it.length, ft = [];
                if (ct)
                  for (M.sortByAngle(it, pt - 0.5), M.maxLabelDistance > 0 && (mt = Math.max(0, V - Z - M.maxLabelDistance), Ct = Math.min(V + Z + M.maxLabelDistance, p.plotHeight), it.forEach(function(St) {
                    St.labelDistance > 0 && St.dataLabel && (St.top = Math.max(0, V - Z - St.labelDistance), St.bottom = Math.min(V + Z + St.labelDistance, p.plotHeight), Tt = St.dataLabel.getBBox().height || 21, St.distributeBox = { target: St.labelPosition.natural.y - St.top + Tt / 2, size: Tt, rank: St.y }, ft.push(St.distributeBox));
                  }), U(ft, xt = Ct + Tt - mt, xt / 5)), h = 0; h < ct; h++) {
                    if (u = it[h], n = u.labelPosition, a = u.dataLabel, l = u.visible === !1 ? "hidden" : "inherit", kt = n.natural.y, c = kt, ft && A(u.distributeBox) && (u.distributeBox.pos === void 0 ? l = "hidden" : (o = u.distributeBox.size, c = ot.radialDistributionY(u))), delete u.positionIndex, w.justify)
                      i = ot.justify(u, Z, j);
                    else
                      switch (w.alignTo) {
                        case "connectors":
                          i = ot.alignToConnectors(it, pt, z, L);
                          break;
                        case "plotEdges":
                          i = ot.alignToPlotEdges(a, pt, z, L);
                          break;
                        default:
                          i = ot.radialDistributionX(M, u, c, kt);
                      }
                    a._attr = { visibility: l, align: n.alignment }, C = u.options.dataLabels || {}, a._pos = { x: i + d(C.x, w.x) + ({ left: T, right: -T }[n.alignment] || 0), y: c + d(C.y, w.y) - 10 }, n.final.x = i, n.final.y = c, d(w.crop, !0) && (e = a.getBBox().width, Lt = null, i - e < T && pt === 1 ? (Lt = Math.round(e - i + T), et[3] = Math.max(Lt, et[3])) : i + e > z - T && pt === 0 && (Lt = Math.round(i + e - z + T), et[1] = Math.max(Lt, et[1])), c - o / 2 < 0 ? et[0] = Math.max(Math.round(o / 2 - c), et[0]) : c + o / 2 > W && (et[2] = Math.max(Math.round(c + o / 2 - W), et[2])), a.sideOverflow = Lt);
                  }
              }), (D(et) === 0 || this.verifyDataLabelOverflow(et)) && (this.placeDataLabels(), this.points.forEach(function(it) {
                if (C = b(w, it.options.dataLabels), y = d(C.connectorWidth, 1)) {
                  var pt = void 0;
                  s = it.connector, (a = it.dataLabel) && a._pos && it.visible && it.labelDistance > 0 ? (l = a._attr.visibility, (pt = !s) && (it.connector = s = p.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + it.colorIndex + (it.className ? " " + it.className : "")).add(M.dataLabelsGroup), p.styledMode || s.attr({ "stroke-width": y, stroke: C.connectorColor || it.color || "#666666" })), s[pt ? "attr" : "animate"]({ d: it.getConnectorPath() }), s.attr("visibility", l)) : s && (it.connector = s.destroy());
                }
              })));
            }
            function P() {
              this.points.forEach(function(u) {
                var y, s = u.dataLabel;
                s && u.visible && ((y = s._pos) ? (s.sideOverflow && (s._attr.width = Math.max(s.getBBox().width - s.sideOverflow, 0), s.css({ width: s._attr.width + "px", textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis" }), s.shortened = !0), s.attr(s._attr), s[s.moved ? "animate" : "attr"](y), s.moved = !0) : s && s.attr({ y: -9999 })), delete u.distributeBox;
              }, this);
            }
            function S(u) {
              var y = this.center, s = this.options, a = s.center, e = s.minSize || 80, n = e, o = s.size !== null;
              return o || (a[0] !== null ? n = Math.max(y[2] - Math.max(u[1], u[3]), e) : (n = Math.max(y[2] - u[1] - u[3], e), y[0] += (u[3] - u[1]) / 2), a[1] !== null ? n = k(n, e, y[2] - Math.max(u[0], u[2])) : (n = k(n, e, y[2] - u[0] - u[2]), y[1] += (u[0] - u[2]) / 2), n < y[2] ? (y[2] = n, y[3] = Math.min(s.thickness ? Math.max(0, n - 2 * s.thickness) : Math.max(0, m(s.innerSize || 0, n)), n), this.translate(y), this.drawDataLabels && this.drawDataLabels()) : o = !0), o;
            }
            v.compose = function(u) {
              if (G.compose(N), g.indexOf(u) === -1) {
                g.push(u);
                var y = u.prototype;
                y.dataLabelPositioners = x, y.alignDataLabel = q, y.drawDataLabels = E, y.placeDataLabels = P, y.verifyDataLabelOverflow = S;
              }
            };
          }(Q || (Q = {})), Q;
        }), at(_, "Extensions/OverlappingDataLabels.js", [_["Core/Chart/Chart.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = F.addEvent, Y = F.fireEvent, J = F.isArray, Q = F.isNumber, q = F.objectEach, U = F.pick;
          function N(D, k) {
            var A, b, d = !1;
            return D && (b = D.newOpacity, D.oldOpacity !== b && (D.alignAttr && D.placed ? (D[b ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), A = function() {
              k.styledMode || D.css({ pointerEvents: b ? "auto" : "none" });
            }, d = !0, D.alignAttr.opacity = b, D[D.isOld ? "animate" : "attr"](D.alignAttr, null, A), Y(k, "afterHideOverlappingLabel")) : D.attr({ opacity: b })), D.isOld = !0), d;
          }
          $(G, "render", function() {
            var D = this, k = [];
            (this.labelCollectors || []).forEach(function(A) {
              k = k.concat(A());
            }), (this.yAxis || []).forEach(function(A) {
              A.stacking && A.options.stackLabels && !A.options.stackLabels.allowOverlap && q(A.stacking.stacks, function(b) {
                q(b, function(d) {
                  d.label && k.push(d.label);
                });
              });
            }), (this.series || []).forEach(function(A) {
              var b = A.options.dataLabels;
              if (A.visible && (b.enabled !== !1 || A._hasPointLabels)) {
                var d = function(m) {
                  return m.forEach(function(v) {
                    v.visible && (J(v.dataLabels) ? v.dataLabels : v.dataLabel ? [v.dataLabel] : []).forEach(function(g) {
                      var x = g.options;
                      g.labelrank = U(x.labelrank, v.labelrank, v.shapeArgs && v.shapeArgs.height), x.allowOverlap ? (g.oldOpacity = g.opacity, g.newOpacity = 1, N(g, D)) : k.push(g);
                    });
                  });
                };
                d(A.nodes || []), d(A.points);
              }
            }), this.hideOverlappingLabels(k);
          }), G.prototype.hideOverlappingLabels = function(D) {
            var k, A, b, d, m, v, g, x = this, E = D.length, P = x.renderer, S = !1, u = function(s, a) {
              return !(a.x >= s.x + s.width || a.x + a.width <= s.x || a.y >= s.y + s.height || a.y + a.height <= s.y);
            }, y = function(s) {
              var a, e, n, o, i, c = s.box ? 0 : s.padding || 0, l = 0, h = 0;
              if (s && (!s.alignAttr || s.placed))
                return a = s.alignAttr || { x: s.attr("x"), y: s.attr("y") }, e = s.parentGroup, s.width || (n = s.getBBox(), s.width = n.width, s.height = n.height, l = P.fontMetrics(null, s.element).h), o = s.width - 2 * c, (i = { left: "0", center: "0.5", right: "1" }[s.alignValue]) ? h = +i * o : Q(s.x) && Math.round(s.x) !== s.translateX && (h = s.x - s.translateX), { x: a.x + (e.translateX || 0) + c - (h || 0), y: a.y + (e.translateY || 0) + c - l, width: s.width - 2 * c, height: s.height - 2 * c };
            };
            for (A = 0; A < E; A++)
              (k = D[A]) && (k.oldOpacity = k.opacity, k.newOpacity = 1, k.absoluteBox = y(k));
            for (D.sort(function(s, a) {
              return (a.labelrank || 0) - (s.labelrank || 0);
            }), A = 0; A < E; A++)
              for (v = (d = D[A]) && d.absoluteBox, b = A + 1; b < E; ++b)
                g = (m = D[b]) && m.absoluteBox, v && g && d !== m && d.newOpacity !== 0 && m.newOpacity !== 0 && d.visibility !== "hidden" && m.visibility !== "hidden" && u(v, g) && ((d.labelrank < m.labelrank ? d : m).newOpacity = 0);
            D.forEach(function(s) {
              N(s, x) && (S = !0);
            }), S && Y(x, "afterHideAllOverlappingLabels");
          };
        }), at(_, "Core/Responsive.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.extend, Y = G.find, J = G.isArray, Q = G.isObject, q = G.merge, U = G.objectEach, N = G.pick, D = G.splat, k = G.uniqueKey;
          return function(A) {
            var b = [];
            A.compose = function(m) {
              return b.indexOf(m) === -1 && (b.push(m), $(m.prototype, d.prototype)), m;
            };
            var d = function() {
              function m() {
              }
              return m.prototype.currentOptions = function(v) {
                var g = this, x = {};
                return function E(P, S, u, y) {
                  var s;
                  U(P, function(a, e) {
                    if (!y && g.collectionsWithUpdate.indexOf(e) > -1 && S[e])
                      for (a = D(a), u[e] = [], s = 0; s < Math.max(a.length, S[e].length); s++)
                        S[e][s] && (a[s] === void 0 ? u[e][s] = S[e][s] : (u[e][s] = {}, E(a[s], S[e][s], u[e][s], y + 1)));
                    else
                      Q(a) ? (u[e] = J(a) ? [] : {}, E(a, S[e] || {}, u[e], y + 1)) : S[e] === void 0 ? u[e] = null : u[e] = S[e];
                  });
                }(v, this.options, x, 0), x;
              }, m.prototype.matchResponsiveRule = function(v, g) {
                var x = v.condition;
                (x.callback || function() {
                  return this.chartWidth <= N(x.maxWidth, Number.MAX_VALUE) && this.chartHeight <= N(x.maxHeight, Number.MAX_VALUE) && this.chartWidth >= N(x.minWidth, 0) && this.chartHeight >= N(x.minHeight, 0);
                }).call(this) && g.push(v._id);
              }, m.prototype.setResponsive = function(v, g) {
                var x, E = this, P = this.options.responsive, S = this.currentResponsive, u = [];
                !g && P && P.rules && P.rules.forEach(function(a) {
                  a._id === void 0 && (a._id = k()), E.matchResponsiveRule(a, u);
                }, this);
                var y = q.apply(void 0, u.map(function(a) {
                  return Y((P || {}).rules || [], function(e) {
                    return e._id === a;
                  });
                }).map(function(a) {
                  return a && a.chartOptions;
                }));
                y.isResponsiveOptions = !0, u = u.toString() || void 0;
                var s = S && S.ruleIds;
                u !== s && (S && this.update(S.undoOptions, v, !0), u ? ((x = this.currentOptions(y)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: u, mergedOptions: y, undoOptions: x }, this.update(y, v, !0)) : this.currentResponsive = void 0);
              }, m;
            }();
          }(F || (F = {})), F;
        }), at(_, "masters/highcharts.src.js", [_["Core/Globals.js"], _["Core/Utilities.js"], _["Core/Defaults.js"], _["Core/Animation/Fx.js"], _["Core/Animation/AnimationUtilities.js"], _["Core/Renderer/HTML/AST.js"], _["Core/FormatUtilities.js"], _["Core/Renderer/RendererUtilities.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Renderer/HTML/HTMLElement.js"], _["Core/Renderer/HTML/HTMLRenderer.js"], _["Core/Axis/Axis.js"], _["Core/Axis/DateTimeAxis.js"], _["Core/Axis/LogarithmicAxis.js"], _["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], _["Core/Axis/Tick.js"], _["Core/Tooltip.js"], _["Core/Series/Point.js"], _["Core/Pointer.js"], _["Core/MSPointer.js"], _["Core/Legend/Legend.js"], _["Core/Chart/Chart.js"], _["Core/Axis/Stacking/StackingAxis.js"], _["Core/Axis/Stacking/StackItem.js"], _["Core/Series/Series.js"], _["Core/Series/SeriesRegistry.js"], _["Series/Column/ColumnSeries.js"], _["Series/Column/ColumnDataLabel.js"], _["Series/Pie/PieSeries.js"], _["Series/Pie/PieDataLabel.js"], _["Core/Series/DataLabel.js"], _["Core/Responsive.js"], _["Core/Color/Color.js"], _["Core/Time.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A, b, d, m, v, g, x, E, P, S, u, y, s, a, e, n, o, i, c, l, h, C, M, O) {
          var p = G;
          return p.animate = J.animate, p.animObject = J.animObject, p.getDeferredAnimation = J.getDeferredAnimation, p.setAnimation = J.setAnimation, p.stop = J.stop, p.timers = Y.timers, p.AST = Q, p.Axis = b, p.Chart = y, p.chart = y.chart, p.Fx = Y, p.Legend = u, p.PlotLineOrBand = v, p.Point = E, p.Pointer = S.isRequired() ? S : P, p.Series = e, p.StackItem = a, p.SVGElement = N, p.SVGRenderer = D, p.Tick = g, p.Time = O, p.Tooltip = x, p.Color = M, p.color = M.parse, A.compose(D), k.compose(N), p.defaultOptions = $.defaultOptions, p.getOptions = $.getOptions, p.time = $.defaultTime, p.setOptions = $.setOptions, p.dateFormat = q.dateFormat, p.format = q.format, p.numberFormat = q.numberFormat, p.addEvent = F.addEvent, p.arrayMax = F.arrayMax, p.arrayMin = F.arrayMin, p.attr = F.attr, p.clearTimeout = F.clearTimeout, p.correctFloat = F.correctFloat, p.createElement = F.createElement, p.css = F.css, p.defined = F.defined, p.destroyObjectProperties = F.destroyObjectProperties, p.discardElement = F.discardElement, p.distribute = U.distribute, p.erase = F.erase, p.error = F.error, p.extend = F.extend, p.extendClass = F.extendClass, p.find = F.find, p.fireEvent = F.fireEvent, p.getMagnitude = F.getMagnitude, p.getStyle = F.getStyle, p.inArray = F.inArray, p.isArray = F.isArray, p.isClass = F.isClass, p.isDOMElement = F.isDOMElement, p.isFunction = F.isFunction, p.isNumber = F.isNumber, p.isObject = F.isObject, p.isString = F.isString, p.keys = F.keys, p.merge = F.merge, p.normalizeTickInterval = F.normalizeTickInterval, p.objectEach = F.objectEach, p.offset = F.offset, p.pad = F.pad, p.pick = F.pick, p.pInt = F.pInt, p.relativeLength = F.relativeLength, p.removeEvent = F.removeEvent, p.seriesType = n.seriesType, p.splat = F.splat, p.stableSort = F.stableSort, p.syncTimeout = F.syncTimeout, p.timeUnits = F.timeUnits, p.uniqueKey = F.uniqueKey, p.useSerialIds = F.useSerialIds, p.wrap = F.wrap, i.compose(o), h.compose(e), d.compose(b), m.compose(b), l.compose(c), v.compose(b), C.compose(y), s.compose(b, y, e), p;
        }), at(_, "Core/Axis/BrokenAxis.js", [_["Core/Axis/Stacking/StackItem.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = F.addEvent, J = F.find, Q = F.fireEvent, q = F.isArray, U = F.isNumber, N = F.pick;
          return function(D) {
            var k = [];
            function A() {
              this.brokenAxis !== void 0 && this.brokenAxis.setBreaks(this.options.breaks, !1);
            }
            function b() {
              var S = this;
              S.brokenAxis && S.brokenAxis.hasBreaks && (S.options.ordinal = !1);
            }
            function d() {
              var S = this, u = S.brokenAxis;
              if (u && u.hasBreaks) {
                for (var y = S.tickPositions, s = S.tickPositions.info, a = [], e = 0; e < y.length; e++)
                  u.isInAnyBreak(y[e]) || a.push(y[e]);
                S.tickPositions = a, S.tickPositions.info = s;
              }
            }
            function m() {
              var S = this;
              S.brokenAxis || (S.brokenAxis = new P(S));
            }
            function v() {
              var S = this, u = S.isDirty, y = S.options.connectNulls, s = S.points, a = S.xAxis, e = S.yAxis;
              if (u)
                for (var n = s.length; n--; ) {
                  var o = s[n], i = !(o.y === null && y === !1) && (a && a.brokenAxis && a.brokenAxis.isInAnyBreak(o.x, !0) || e && e.brokenAxis && e.brokenAxis.isInAnyBreak(o.y, !0));
                  o.visible = !i && o.options.visible !== !1;
                }
            }
            function g() {
              this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, N(this.pointArrayMap, ["y"]));
            }
            function x(S, u) {
              var y, s, a, e, n = this, o = n.points;
              if (S && S.brokenAxis && S.brokenAxis.hasBreaks) {
                var i = S.brokenAxis;
                u.forEach(function(c) {
                  y = i && i.breakArray || [], s = S.isXAxis ? S.min : N(n.options.threshold, S.min), o.forEach(function(l) {
                    e = N(l["stack" + c.toUpperCase()], l[c]), y.forEach(function(h) {
                      U(s) && U(e) && (a = !1, s < h.from && e > h.to || s > h.from && e < h.from ? a = "pointBreak" : (s < h.from && e > h.from && e < h.to || s > h.from && e > h.to && e < h.from) && (a = "pointInBreak"), a && Q(S, a, { point: l, brk: h }));
                    });
                  });
                });
              }
            }
            function E() {
              var S = this.currentDataGrouping, u = S && S.gapSize, y = this.points.slice(), s = this.yAxis, a = this.options.gapSize, e = y.length - 1;
              if (a && e > 0) {
                this.options.gapUnit !== "value" && (a *= this.basePointRange), u && u > a && u >= this.basePointRange && (a = u);
                for (var n = void 0, o = void 0; e--; )
                  if (o && o.visible !== !1 || (o = y[e + 1]), n = y[e], o.visible !== !1 && n.visible !== !1) {
                    if (o.x - n.x > a) {
                      var i = (n.x + o.x) / 2;
                      y.splice(e + 1, 0, { isNull: !0, x: i }), s.stacking && this.options.stacking && ((s.stacking.stacks[this.stackKey][i] = new G(s, s.options.stackLabels, !1, i, this.stack)).total = 0);
                    }
                    o = n;
                  }
              }
              return this.getGraphPath(y);
            }
            D.compose = function(S, u) {
              if (k.indexOf(S) === -1 && (k.push(S), S.keepProps.push("brokenAxis"), Y(S, "init", m), Y(S, "afterInit", A), Y(S, "afterSetTickPositions", d), Y(S, "afterSetOptions", b)), k.indexOf(u) === -1) {
                k.push(u);
                var y = u.prototype;
                y.drawBreaks = x, y.gappedPath = E, Y(u, "afterGeneratePoints", v), Y(u, "afterRender", g);
              }
              return S;
            };
            var P = function() {
              function S(u) {
                this.hasBreaks = !1, this.axis = u;
              }
              return S.isInBreak = function(u, y) {
                var s = u.repeat || 1 / 0, a = u.from, e = u.to - u.from, n = y >= a ? (y - a) % s : s - (a - y) % s;
                return u.inclusive ? n <= e : n < e && n !== 0;
              }, S.lin2Val = function(u) {
                var y = this.brokenAxis, s = y && y.breakArray;
                if (!s || !U(u))
                  return u;
                var a, e, n = u;
                for (e = 0; e < s.length && !((a = s[e]).from >= n); e++)
                  (a.to < n || S.isInBreak(a, n)) && (n += a.len);
                return n;
              }, S.val2Lin = function(u) {
                var y = this.brokenAxis, s = y && y.breakArray;
                if (!s || !U(u))
                  return u;
                var a, e, n = u;
                for (e = 0; e < s.length; e++)
                  if ((a = s[e]).to <= u)
                    n -= a.len;
                  else {
                    if (a.from >= u)
                      break;
                    if (S.isInBreak(a, u)) {
                      n -= u - a.from;
                      break;
                    }
                  }
                return n;
              }, S.prototype.findBreakAt = function(u, y) {
                return J(y, function(s) {
                  return s.from < u && u < s.to;
                });
              }, S.prototype.isInAnyBreak = function(u, y) {
                var s, a, e, n = this.axis, o = n.options.breaks || [], i = o.length;
                if (i && U(u)) {
                  for (; i--; )
                    S.isInBreak(o[i], u) && (s = !0, a || (a = N(o[i].showPoints, !n.isXAxis)));
                  e = s && y ? s && !a : s;
                }
                return e;
              }, S.prototype.setBreaks = function(u, y) {
                var s = this, a = s.axis, e = q(u) && !!u.length;
                a.isDirty = s.hasBreaks !== e, s.hasBreaks = e, a.options.breaks = a.userOptions.breaks = u, a.forceRedraw = !0, a.series.forEach(function(n) {
                  n.isDirty = !0;
                }), e || a.val2lin !== S.val2Lin || (delete a.val2lin, delete a.lin2val), e && (a.userOptions.ordinal = !1, a.lin2val = S.lin2Val, a.val2lin = S.val2Lin, a.setExtremes = function(n, o, i, c, l) {
                  if (s.hasBreaks) {
                    for (var h = this.options.breaks || [], C = void 0; C = s.findBreakAt(n, h); )
                      n = C.to;
                    for (; C = s.findBreakAt(o, h); )
                      o = C.from;
                    o < n && (o = n);
                  }
                  a.constructor.prototype.setExtremes.call(this, n, o, i, c, l);
                }, a.setAxisTranslation = function() {
                  if (a.constructor.prototype.setAxisTranslation.call(this), s.unitLength = void 0, s.hasBreaks) {
                    var n, o, i, c, l = a.options.breaks || [], h = [], C = [], M = N(a.pointRangePadding, 0), O = 0, p = a.userMin || a.min, w = a.userMax || a.max;
                    l.forEach(function(T) {
                      o = T.repeat || 1 / 0, U(p) && U(w) && (S.isInBreak(T, p) && (p += T.to % o - p % o), S.isInBreak(T, w) && (w -= w % o - T.from % o));
                    }), l.forEach(function(T) {
                      if (i = T.from, o = T.repeat || 1 / 0, U(p) && U(w)) {
                        for (; i - o > p; )
                          i -= o;
                        for (; i < p; )
                          i += o;
                        for (c = i; c < w; c += o)
                          h.push({ value: c, move: "in" }), h.push({ value: c + T.to - T.from, move: "out", size: T.breakSize });
                      }
                    }), h.sort(function(T, z) {
                      return T.value === z.value ? (T.move === "in" ? 0 : 1) - (z.move === "in" ? 0 : 1) : T.value - z.value;
                    }), n = 0, i = p, h.forEach(function(T) {
                      (n += T.move === "in" ? 1 : -1) === 1 && T.move === "in" && (i = T.value), n === 0 && U(i) && (C.push({ from: i, to: T.value, len: T.value - i - (T.size || 0) }), O += T.value - i - (T.size || 0));
                    }), s.breakArray = C, U(p) && U(w) && U(a.min) && (s.unitLength = w - p - O + M, Q(a, "afterBreaks"), a.staticScale ? a.transA = a.staticScale : s.unitLength && (a.transA *= (w - a.min + M) / s.unitLength), M && (a.minPixelPadding = a.transA * (a.minPointOffset || 0)), a.min = p, a.max = w);
                  }
                }), N(y, !0) && a.chart.redraw();
              }, S;
            }();
            D.Additions = P;
          }($ || ($ = {})), $;
        }), at(_, "masters/modules/broken-axis.src.js", [_["Core/Globals.js"], _["Core/Axis/BrokenAxis.js"]], function(G, F) {
          var $ = G;
          F.compose($.Axis, $.Series);
        }), at(_, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
          return {};
        }), at(_, "Extensions/DataGrouping/ApproximationDefaults.js", [_["Extensions/DataGrouping/ApproximationRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = F.arrayMax, Y = F.arrayMin, J = F.correctFloat, Q = F.extend, q = F.isNumber;
          function U(k) {
            var A = k.length, b = N(k);
            return q(b) && A && (b = J(b / A)), b;
          }
          function N(k) {
            var A, b = k.length;
            if (!b && k.hasNulls)
              A = null;
            else if (b)
              for (A = 0; b--; )
                A += k[b];
            return A;
          }
          var D = { average: U, averages: function() {
            var k = [];
            return [].forEach.call(arguments, function(A) {
              k.push(U(A));
            }), k[0] === void 0 ? void 0 : k;
          }, close: function(k) {
            return k.length ? k[k.length - 1] : k.hasNulls ? null : void 0;
          }, high: function(k) {
            return k.length ? $(k) : k.hasNulls ? null : void 0;
          }, hlc: function(k, A, b) {
            if (k = G.high(k), A = G.low(A), b = G.close(b), q(k) || q(A) || q(b))
              return [k, A, b];
          }, low: function(k) {
            return k.length ? Y(k) : k.hasNulls ? null : void 0;
          }, ohlc: function(k, A, b, d) {
            if (k = G.open(k), A = G.high(A), b = G.low(b), d = G.close(d), q(k) || q(A) || q(b) || q(d))
              return [k, A, b, d];
          }, open: function(k) {
            return k.length ? k[0] : k.hasNulls ? null : void 0;
          }, range: function(k, A) {
            return k = G.low(k), A = G.high(A), q(k) || q(A) ? [k, A] : k === null && A === null ? null : void 0;
          }, sum: N };
          return Q(G, D), D;
        }), at(_, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
          return { common: { groupPixelWidth: 2, dateTimeLabelFormats: { millisecond: ["%A, %b %e, %H:%M:%S.%L", "%A, %b %e, %H:%M:%S.%L", "-%H:%M:%S.%L"], second: ["%A, %b %e, %H:%M:%S", "%A, %b %e, %H:%M:%S", "-%H:%M:%S"], minute: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"], hour: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"], day: ["%A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"], week: ["Week from %A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"], month: ["%B %Y", "%B", "-%B %Y"], year: ["%Y", "%Y", "-%Y"] } }, seriesSpecific: { line: {}, spline: {}, area: {}, areaspline: {}, arearange: {}, column: { groupPixelWidth: 10 }, columnrange: { groupPixelWidth: 10 }, candlestick: { groupPixelWidth: 10 }, ohlc: { groupPixelWidth: 5 }, hlc: { groupPixelWidth: 5 }, heikinashi: { groupPixelWidth: 10 } }, units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]] };
        }), at(_, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [_["Extensions/DataGrouping/DataGroupingDefaults.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = F.addEvent, J = F.extend, Q = F.merge, q = F.pick, U = [];
          function N(b) {
            var d = this, m = d.series;
            m.forEach(function(v) {
              v.groupPixelWidth = void 0;
            }), m.forEach(function(v) {
              v.groupPixelWidth = d.getGroupPixelWidth && d.getGroupPixelWidth(), v.groupPixelWidth && (v.hasProcessed = !0), v.applyGrouping(!!b.hasExtremesChanged);
            });
          }
          function D() {
            for (var b, d, m = this.series, v = m.length, g = 0, x = !1; v--; )
              (d = m[v].options.dataGrouping) && (g = Math.max(g, q(d.groupPixelWidth, G.common.groupPixelWidth)), b = (m[v].processedXData || m[v].data).length, (m[v].groupPixelWidth || b > this.chart.plotSizeX / g || b && d.forced) && (x = !0));
            return x ? g : 0;
          }
          function k() {
            this.series.forEach(function(b) {
              b.hasProcessed = !1;
            });
          }
          function A(b, d) {
            var m;
            if (d = q(d, !0), b || (b = { forced: !1, units: null }), this instanceof $)
              for (m = this.series.length; m--; )
                this.series[m].update({ dataGrouping: b }, !1);
            else
              this.chart.options.series.forEach(function(v) {
                v.dataGrouping = typeof b == "boolean" ? b : Q(b, v.dataGrouping);
              });
            this.ordinal && (this.ordinal.slope = void 0), d && this.chart.redraw();
          }
          return { compose: function(b) {
            $ = b, U.indexOf(b) === -1 && (U.push(b), Y(b, "afterSetScale", k), Y(b, "postProcessData", N), J(b.prototype, { applyGrouping: N, getGroupPixelWidth: D, setDataGrouping: A }));
          } };
        }), at(_, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [_["Extensions/DataGrouping/ApproximationRegistry.js"], _["Extensions/DataGrouping/DataGroupingDefaults.js"], _["Core/Axis/DateTimeAxis.js"], _["Core/Defaults.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = J.series.prototype, U = Q.addEvent, N = Q.defined, D = Q.error, k = Q.extend, A = Q.isNumber, b = Q.merge, d = Q.pick, m = q.generatePoints, v = [];
          function g(y) {
            var s, a, e = this, n = e.chart, o = e.options.dataGrouping, i = e.allowDG !== !1 && o && d(o.enabled, n.options.isStock), c = e.visible || !n.options.chart.ignoreHiddenSeries, l = this.currentDataGrouping, h = !1;
            i && !e.requireSorting && (e.requireSorting = h = !0);
            var C = function(mt, Ct) {
              return !(mt.isCartesian && !mt.isDirty && !mt.xAxis.isDirty && !mt.yAxis.isDirty && !Ct);
            }(e, y) === !1 || !i;
            if (h && (e.requireSorting = !1), !C) {
              e.destroyGroupedData();
              var M = o.groupAll ? e.xData : e.processedXData, O = o.groupAll ? e.yData : e.processedYData, p = n.plotSizeX, w = e.xAxis, T = w.options.ordinal, z = e.groupPixelWidth, W = void 0, L = void 0;
              if (z && M && M.length && p) {
                L = !0, e.isDirty = !0, e.points = null;
                var I = w.getExtremes(), j = I.min, Z = I.max, V = z * (Z - j) / p * (T && w.ordinal && w.ordinal.getGroupIntervalFactor(j, Z, e) || 1), X = w.getTimeTicks($.Additions.prototype.normalizeTimeTickInterval(V, o.units || F.units), Math.min(j, M[0]), Math.max(Z, M[M.length - 1]), w.options.startOfWeek, M, e.closestPointRange), et = q.groupData.apply(e, [M, O, X, o.approximation]), ot = et.groupedXData, it = et.groupedYData, pt = 0;
                for (o && o.smoothed && ot.length && (o.firstAnchor = "firstPoint", o.anchor = "middle", o.lastAnchor = "lastPoint", D(32, !1, n, { "dataGrouping.smoothed": "use dataGrouping.anchor" })), function(mt, Ct, kt) {
                  var Lt, Tt = mt.options.dataGrouping, xt = mt.currentDataGrouping && mt.currentDataGrouping.gapSize;
                  if (Tt && mt.xData && xt && mt.groupMap) {
                    var ct = Ct.length - 1, ft = Tt.anchor, St = d(Tt.firstAnchor, ft), Mt = d(Tt.lastAnchor, ft);
                    if (ft && ft !== "start") {
                      var Dt = xt * { middle: 0.5, end: 1 }[ft];
                      for (Lt = Ct.length - 1; Lt-- && Lt > 0; )
                        Ct[Lt] += Dt;
                    }
                    if (St && St !== "start" && mt.xData[0] >= Ct[0]) {
                      var Ot = mt.groupMap[0].start, Nt = mt.groupMap[0].length, Wt = void 0;
                      A(Ot) && A(Nt) && (Wt = Ot + (Nt - 1)), Ct[0] = { middle: Ct[0] + 0.5 * xt, end: Ct[0] + xt, firstPoint: mt.xData[0], lastPoint: Wt && mt.xData[Wt] }[St];
                    }
                    if (Mt && Mt !== "start" && xt && Ct[ct] >= kt - xt) {
                      var zt = mt.groupMap[mt.groupMap.length - 1].start;
                      Ct[ct] = { middle: Ct[ct] + 0.5 * xt, end: Ct[ct] + xt, firstPoint: zt && mt.xData[zt], lastPoint: mt.xData[mt.xData.length - 1] }[Mt];
                    }
                  }
                }(e, ot, Z), W = 1; W < X.length; W++)
                  X.info.segmentStarts && X.info.segmentStarts.indexOf(W) !== -1 || (pt = Math.max(X[W] - X[W - 1], pt));
                (s = X.info).gapSize = pt, e.closestPointRange = X.info.totalRange, e.groupMap = et.groupMap, c && function(mt, Ct) {
                  N(Ct[0]) && A(mt.min) && A(mt.dataMin) && Ct[0] < mt.min && ((!N(mt.options.min) && mt.min <= mt.dataMin || mt.min === mt.dataMin) && (mt.min = Math.min(Ct[0], mt.min)), mt.dataMin = Math.min(Ct[0], mt.dataMin)), N(Ct[Ct.length - 1]) && A(mt.max) && A(mt.dataMax) && Ct[Ct.length - 1] > mt.max && ((!N(mt.options.max) && A(mt.dataMax) && mt.max >= mt.dataMax || mt.max === mt.dataMax) && (mt.max = Math.max(Ct[Ct.length - 1], mt.max)), mt.dataMax = Math.max(Ct[Ct.length - 1], mt.dataMax));
                }(w, ot), o.groupAll && (e.allGroupedData = it, ot = (a = e.cropData(ot, it, w.min, w.max, 1)).xData, it = a.yData, e.cropStart = a.start), e.processedXData = ot, e.processedYData = it;
              } else
                e.groupMap = null;
              e.hasGroupedData = L, e.currentDataGrouping = s, e.preventGraphAnimation = (l && l.totalRange) !== (s && s.totalRange);
            }
          }
          function x() {
            this.groupedData && (this.groupedData.forEach(function(y, s) {
              y && (this.groupedData[s] = y.destroy ? y.destroy() : null);
            }, this), this.groupedData.length = 0);
          }
          function E() {
            m.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
          }
          function P() {
            return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") ? "sum" : "average";
          }
          function S(y, s, a, e) {
            var n, o, i, c = this, l = c.data, h = c.options && c.options.data, C = [], M = [], O = [], p = y.length, w = !!s, T = [], z = c.pointArrayMap, W = z && z.length, L = ["x"].concat(z || ["y"]), I = this.options.dataGrouping && this.options.dataGrouping.groupAll, j = 0, Z = 0, V = typeof e == "function" ? e : e && G[e] ? G[e] : G[c.getDGApproximation && c.getDGApproximation() || "average"];
            if (W)
              for (var X = z.length; X--; )
                T.push([]);
            else
              T.push([]);
            for (var et = W || 1, ot = 0; ot <= p; ot++)
              if (!(y[ot] < a[0])) {
                for (; a[j + 1] !== void 0 && y[ot] >= a[j + 1] || ot === p; ) {
                  n = a[j], c.dataGroupInfo = { start: I ? Z : c.cropStart + Z, length: T[0].length }, i = V.apply(c, T), c.pointClass && !N(c.dataGroupInfo.options) && (c.dataGroupInfo.options = b(c.pointClass.prototype.optionsToObject.call({ series: c }, c.options.data[c.cropStart + Z])), L.forEach(function(kt) {
                    delete c.dataGroupInfo.options[kt];
                  })), i !== void 0 && (C.push(n), M.push(i), O.push(c.dataGroupInfo)), Z = ot;
                  for (var it = 0; it < et; it++)
                    T[it].length = 0, T[it].hasNulls = !1;
                  if (j += 1, ot === p)
                    break;
                }
                if (ot === p)
                  break;
                if (z) {
                  var pt = c.options.dataGrouping && c.options.dataGrouping.groupAll ? ot : c.cropStart + ot, mt = l && l[pt] || c.pointClass.prototype.applyOptions.apply({ series: c }, [h[pt]]), Ct = void 0;
                  for (it = 0; it < W; it++)
                    Ct = mt[z[it]], A(Ct) ? T[it].push(Ct) : Ct === null && (T[it].hasNulls = !0);
                } else
                  o = w ? s[ot] : null, A(o) ? T[0].push(o) : o === null && (T[0].hasNulls = !0);
              }
            return { groupedXData: C, groupedYData: M, groupMap: O };
          }
          function u(y) {
            var s = y.options, a = this.type, e = this.chart.options.plotOptions, n = this.useCommonDataGrouping && F.common, o = F.seriesSpecific, i = Y.defaultOptions.plotOptions[a].dataGrouping;
            if (e && (o[a] || n)) {
              var c = this.chart.rangeSelector;
              i || (i = b(F.common, o[a])), s.dataGrouping = b(n, i, e.series && e.series.dataGrouping, e[a].dataGrouping, this.userOptions.dataGrouping, !s.isInternal && c && A(c.selected) && c.buttonOptions[c.selected].dataGrouping);
            }
          }
          return { compose: function(y) {
            var s = y.prototype.pointClass;
            v.indexOf(s) === -1 && (v.push(s), U(s, "update", function() {
              if (this.dataGroup)
                return D(24, !1, this.series.chart), !1;
            })), v.indexOf(y) === -1 && (v.push(y), U(y, "afterSetOptions", u), U(y, "destroy", x), k(y.prototype, { applyGrouping: g, destroyGroupedData: x, generatePoints: E, getDGApproximation: P, groupData: S }));
          }, groupData: S };
        }), at(_, "Extensions/DataGrouping/DataGrouping.js", [_["Extensions/DataGrouping/DataGroupingAxisComposition.js"], _["Extensions/DataGrouping/DataGroupingDefaults.js"], _["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], _["Core/FormatUtilities.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = Y.format, q = J.addEvent, U = J.extend, N = J.isNumber, D = [];
          function k(A) {
            var b, d, m, v, g, x = this.chart, E = x.time, P = A.labelConfig, S = P.series, u = S.options, y = S.tooltipOptions, s = u.dataGrouping, a = S.xAxis, e = y.xDateFormat, n = y[A.isFooter ? "footerFormat" : "headerFormat"];
            a && a.options.type === "datetime" && s && N(P.key) && (d = S.currentDataGrouping, m = s.dateTimeLabelFormats || F.common.dateTimeLabelFormats, d ? (v = m[d.unitName], d.count === 1 ? e = v[0] : (e = v[1], b = v[2])) : !e && m && a.dateTime && (e = a.dateTime.getXDateFormat(P.x, y.dateTimeLabelFormats)), g = E.dateFormat(e, P.key), b && (g += E.dateFormat(b, P.key + d.totalRange - 1)), S.chart.styledMode && (n = this.styledModeFormat(n)), A.text = Q(n, { point: U(P.point, { key: g }), series: S }, x), A.preventDefault());
          }
          return { compose: function(A, b, d) {
            G.compose(A), $.compose(b), D.indexOf(d) === -1 && (D.push(d), q(d, "headerFormatter", k));
          }, groupData: $.groupData };
        }), at(_, "masters/modules/datagrouping.src.js", [_["Core/Globals.js"], _["Extensions/DataGrouping/ApproximationDefaults.js"], _["Extensions/DataGrouping/ApproximationRegistry.js"], _["Extensions/DataGrouping/DataGrouping.js"]], function(G, F, $, Y) {
          var J = G;
          J.dataGrouping = { approximationDefaults: F, approximations: $ }, Y.compose(J.Axis, J.Series, J.Tooltip);
        }), at(_, "Series/DataModifyComposition.js", [_["Core/Axis/Axis.js"], _["Core/Series/Point.js"], _["Core/Series/Series.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = F.prototype.tooltipFormatter, q = Y.addEvent, U = Y.arrayMax, N = Y.arrayMin, D = Y.correctFloat, k = Y.defined, A = Y.isArray, b = Y.isNumber, d = Y.isString, m = Y.pick;
          return function(v) {
            var g = [];
            function x(o, i, c) {
              this.isXAxis || (this.series.forEach(function(l) {
                o === "compare" && typeof i != "boolean" ? l.setCompare(i, !1) : o !== "cumulative" || d(i) || l.setCumulative(i, !1);
              }), m(c, !0) && this.chart.redraw());
            }
            function E(o) {
              var i = this, c = i.series.chart.numberFormatter, l = function(h) {
                o = o.replace("{point." + h + "}", (i[h] > 0 && h === "change" ? "+" : "") + c(i[h], m(i.series.tooltipOptions.changeDecimals, 2)));
              };
              return k(i.change) && l("change"), k(i.cumulativeSum) && l("cumulativeSum"), Q.apply(this, [o]);
            }
            function P() {
              var o, i = this.options.compare;
              (i === "percent" || i === "value" || this.options.cumulative) && (o = new n(this), i === "percent" || i === "value" ? o.initCompare(i) : o.initCumulative()), this.dataModify = o;
            }
            function S(o) {
              var i = o.dataExtremes, c = i.activeYData;
              if (this.dataModify && i) {
                var l = void 0;
                this.options.compare ? l = [this.dataModify.modifyValue(i.dataMin), this.dataModify.modifyValue(i.dataMax)] : this.options.cumulative && A(c) && c.length >= 2 && (l = n.getCumulativeExtremes(c)), l && (i.dataMin = N(l), i.dataMax = U(l));
              }
            }
            function u(o, i) {
              this.options.compare = this.userOptions.compare = o, this.update({}, m(i, !0)), !this.dataModify || o !== "value" && o !== "percent" ? this.points.forEach(function(c) {
                delete c.change;
              }) : this.dataModify.initCompare(o);
            }
            function y() {
              var o = this;
              if (o.xAxis && o.processedYData && o.dataModify) {
                var i = o.processedXData, c = o.processedYData, l = c.length, h = o.options.compareStart === !0 ? 0 : 1, C = -1, M = void 0;
                for (o.pointArrayMap && (C = o.pointArrayMap.indexOf(o.options.pointValKey || o.pointValKey || "y")), M = 0; M < l - h; M++) {
                  var O = c[M] && C > -1 ? c[M][C] : c[M];
                  if (b(O) && O !== 0 && i[M + h] >= (o.xAxis.min || 0)) {
                    o.dataModify.compareValue = O;
                    break;
                  }
                }
              }
            }
            function s(o, i) {
              this.setModifier("compare", o, i);
            }
            function a(o, i) {
              o = m(o, !1), this.options.cumulative = this.userOptions.cumulative = o, this.update({}, m(i, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach(function(c) {
                delete c.cumulativeSum;
              });
            }
            function e(o, i) {
              this.setModifier("cumulative", o, i);
            }
            v.compose = function(o, i, c) {
              if (g.indexOf(o) === -1) {
                g.push(o);
                var l = o.prototype;
                l.setCompare = u, l.setCumulative = a, q(o, "afterInit", P), q(o, "afterGetExtremes", S), q(o, "afterProcessData", y);
              }
              if (g.indexOf(i) === -1) {
                g.push(i);
                var h = i.prototype;
                h.setCompare = s, h.setModifier = x, h.setCumulative = e;
              }
              return g.indexOf(c) === -1 && (g.push(c), c.prototype.tooltipFormatter = E), o;
            };
            var n = function() {
              function o(i) {
                this.series = i;
              }
              return o.prototype.modifyValue = function() {
                return 0;
              }, o.getCumulativeExtremes = function(i) {
                var c = 1 / 0, l = -1 / 0;
                return i.reduce(function(h, C) {
                  var M = h + C;
                  return c = Math.min(c, M, h), l = Math.max(l, M, h), M;
                }), [c, l];
              }, o.prototype.initCompare = function(i) {
                this.modifyValue = function(c, l) {
                  c === null && (c = 0);
                  var h = this.compareValue;
                  if (c !== void 0 && h !== void 0) {
                    if (i === "value" ? c -= h : c = c / h * 100 - (this.series.options.compareBase === 100 ? 0 : 100), l !== void 0) {
                      var C = this.series.points[l];
                      C && (C.change = c);
                    }
                    return c;
                  }
                  return 0;
                };
              }, o.prototype.initCumulative = function() {
                this.modifyValue = function(i, c) {
                  if (i === null && (i = 0), i !== void 0 && c !== void 0) {
                    var l = c > 0 ? this.series.points[c - 1] : null;
                    l && l.cumulativeSum && (i = D(l.cumulativeSum + i));
                    var h = this.series.points[c];
                    return h && (h.cumulativeSum = i), i;
                  }
                  return 0;
                };
              }, o;
            }();
            v.Additions = n;
          }(J || (J = {})), J;
        }), at(_, "Core/Axis/NavigatorAxisComposition.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.isTouchDevice, Y = F.addEvent, J = F.correctFloat, Q = F.defined, q = F.isNumber, U = F.pick, N = [];
          function D() {
            var b = this;
            b.navigatorAxis || (b.navigatorAxis = new A(b));
          }
          function k(b) {
            var d = this, m = d.chart.options, v = m.navigator, g = d.navigatorAxis, x = m.chart.zooming.pinchType, E = m.rangeSelector, P = m.chart.zooming.type;
            if (d.isXAxis && (v && v.enabled || E && E.enabled)) {
              if (P === "y")
                b.zoomed = !1;
              else if ((!$ && P === "xy" || $ && x === "xy") && d.options.range) {
                var S = g.previousZoom;
                Q(b.newMin) ? g.previousZoom = [d.min, d.max] : S && (b.newMin = S[0], b.newMax = S[1], g.previousZoom = void 0);
              }
            }
            b.zoomed !== void 0 && b.preventDefault();
          }
          var A = function() {
            function b(d) {
              this.axis = d;
            }
            return b.compose = function(d) {
              N.indexOf(d) === -1 && (N.push(d), d.keepProps.push("navigatorAxis"), Y(d, "init", D), Y(d, "zoom", k));
            }, b.prototype.destroy = function() {
              this.axis = void 0;
            }, b.prototype.toFixedRange = function(d, m, v, g) {
              var x = this.axis, E = x.chart, P = U(v, x.translate(d, !0, !x.horiz)), S = U(g, x.translate(m, !0, !x.horiz)), u = E && E.fixedRange, y = (x.pointRange || 0) / 2, s = u && (S - P) / u;
              return Q(v) || (P = J(P + y)), Q(g) || (S = J(S - y)), s > 0.7 && s < 1.3 && (g ? P = S - u : S = P + u), q(P) && q(S) || (P = S = void 0), { min: P, max: S };
            }, b;
          }();
          return A;
        }), at(_, "Stock/Navigator/NavigatorDefaults.js", [_["Core/Color/Color.js"], _["Core/Series/SeriesRegistry.js"]], function(G, F) {
          var $ = G.parse, Y = F.seriesTypes;
          return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: $("#6685c2").setOpacity(0.3).get(), outlineColor: "#cccccc", outlineWidth: 1, series: { type: Y.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { overscroll: 0, className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#999999" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
        }), at(_, "Stock/Navigator/NavigatorSymbols.js", [], function() {
          return { "navigator-handle": function(G, F, $, Y, J) {
            J === void 0 && (J = {});
            var Q = J.width ? J.width / 2 : $, q = Math.round(Q / 3) + 0.5;
            return [["M", -Q - 1, 0.5], ["L", Q, 0.5], ["L", Q, (Y = J.height || Y) + 0.5], ["L", -Q - 1, Y + 0.5], ["L", -Q - 1, 0.5], ["M", -q, 4], ["L", -q, Y - 3], ["M", q - 1, 4], ["L", q - 1, Y - 3]];
          } };
        }), at(_, "Stock/Navigator/NavigatorComposition.js", [_["Core/Defaults.js"], _["Core/Globals.js"], _["Core/Axis/NavigatorAxisComposition.js"], _["Stock/Navigator/NavigatorDefaults.js"], _["Stock/Navigator/NavigatorSymbols.js"], _["Core/Renderer/RendererRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q) {
          var U, N = G.defaultOptions, D = G.setOptions, k = F.isTouchDevice, A = Q.getRendererType, b = q.addEvent, d = q.extend, m = q.merge, v = q.pick, g = [];
          function x() {
            this.navigator && this.navigator.setBaseSeries(null, !1);
          }
          function E() {
            var e, n, o, i, c = this.legend, l = this.navigator;
            l && (n = c && c.options, o = l.xAxis, i = l.yAxis, e = l.scrollbarHeight, this.inverted ? (l.left = l.opposite ? this.chartWidth - e - l.height : this.spacing[3] + e, l.top = this.plotTop + e) : (l.left = v(o.left, this.plotLeft + e), l.top = l.navigatorOptions.top || this.chartHeight - l.height - e - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (n && n.verticalAlign === "bottom" && n.layout !== "proximate" && n.enabled && !n.floating ? c.legendHeight + v(n.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), o && i && (this.inverted ? o.options.left = i.options.left = l.left : o.options.top = i.options.top = l.top, o.setAxisSize(), i.setAxisSize()));
          }
          function P(e) {
            this.navigator || this.scroller || !this.options.navigator.enabled && !this.options.scrollbar.enabled || (this.scroller = this.navigator = new U(this), v(e.redraw, !0) && this.redraw(e.animation));
          }
          function S() {
            var e = this.options;
            (e.navigator.enabled || e.scrollbar.enabled) && (this.scroller = this.navigator = new U(this));
          }
          function u() {
            var e = this.options, n = e.navigator, o = e.rangeSelector;
            if ((n && n.enabled || o && o.enabled) && (!k && e.chart.zooming.type === "x" || k && e.chart.zooming.pinchType === "x"))
              return !1;
          }
          function y(e) {
            var n = e.navigator;
            if (n && e.xAxis[0]) {
              var o = e.xAxis[0].getExtremes();
              n.render(o.min, o.max);
            }
          }
          function s(e) {
            var n = e.options.navigator || {}, o = e.options.scrollbar || {};
            this.navigator || this.scroller || !n.enabled && !o.enabled || (m(!0, this.options.navigator, n), m(!0, this.options.scrollbar, o), delete e.options.navigator, delete e.options.scrollbar);
          }
          function a() {
            this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
          }
          return { compose: function(e, n, o, i) {
            $.compose(e), U = o, g.indexOf(n) === -1 && (g.push(n), n.prototype.callbacks.push(y), b(n, "afterAddSeries", x), b(n, "afterSetChartSize", E), b(n, "afterUpdate", P), b(n, "beforeRender", S), b(n, "beforeShowResetZoom", u), b(n, "update", s)), g.indexOf(i) === -1 && (g.push(i), b(i, "afterUpdate", a)), g.indexOf(A) === -1 && (g.push(A), d(A().prototype.symbols, J)), g.indexOf(D) === -1 && (g.push(D), d(N, { navigator: Y }));
          } };
        }), at(_, "Core/Axis/ScrollbarAxis.js", [_["Core/Utilities.js"]], function(G) {
          var F = G.addEvent, $ = G.defined, Y = G.pick;
          return function() {
            function J() {
            }
            return J.compose = function(Q, q) {
              if (J.composed.indexOf(Q) !== -1)
                return Q;
              J.composed.push(Q);
              var U = function(N) {
                var D = Y(N.options && N.options.min, N.min), k = Y(N.options && N.options.max, N.max);
                return { axisMin: D, axisMax: k, scrollMin: $(N.dataMin) ? Math.min(D, N.min, N.dataMin, Y(N.threshold, 1 / 0)) : D, scrollMax: $(N.dataMax) ? Math.max(k, N.max, N.dataMax, Y(N.threshold, -1 / 0)) : k };
              };
              return F(Q, "afterInit", function() {
                var N = this;
                N.options && N.options.scrollbar && N.options.scrollbar.enabled && (N.options.scrollbar.vertical = !N.horiz, N.options.startOnTick = N.options.endOnTick = !1, N.scrollbar = new q(N.chart.renderer, N.options.scrollbar, N.chart), F(N.scrollbar, "changed", function(D) {
                  var k, A, b = U(N), d = b.axisMin, m = b.axisMax, v = b.scrollMin, g = b.scrollMax - v;
                  $(d) && $(m) && (N.horiz && !N.reversed || !N.horiz && N.reversed ? (k = v + g * this.to, A = v + g * this.from) : (k = v + g * (1 - this.from), A = v + g * (1 - this.to)), this.shouldUpdateExtremes(D.DOMType) ? N.setExtremes(A, k, !0, D.DOMType !== "mousemove" && D.DOMType !== "touchmove", D) : this.setRange(this.from, this.to));
                }));
              }), F(Q, "afterRender", function() {
                var N, D, k, A = this, b = U(A), d = b.scrollMin, m = b.scrollMax, v = A.scrollbar, g = A.axisTitleMargin + (A.titleOffset || 0), x = A.chart.scrollbarsOffsets, E = A.options.margin || 0;
                if (v) {
                  if (A.horiz)
                    A.opposite || (x[1] += g), v.position(A.left, A.top + A.height + 2 + x[1] - (A.opposite ? E : 0), A.width, A.height), A.opposite || (x[1] += E), N = 1;
                  else {
                    A.opposite && (x[0] += g);
                    var P;
                    P = v.options.opposite ? A.left + A.width + 2 + x[0] - (A.opposite ? 0 : E) : A.opposite ? 0 : E, v.position(P, A.top, A.width, A.height), A.opposite && (x[0] += E), N = 0;
                  }
                  x[N] += v.size + v.options.margin, isNaN(d) || isNaN(m) || !$(A.min) || !$(A.max) || A.min === A.max ? v.setRange(0, 1) : (D = (A.min - d) / (m - d), k = (A.max - d) / (m - d), A.horiz && !A.reversed || !A.horiz && A.reversed ? v.setRange(D, k) : v.setRange(1 - k, 1 - D));
                }
              }), F(Q, "afterGetOffset", function() {
                var N = this, D = N.scrollbar && !N.scrollbar.options.opposite, k = N.horiz ? 2 : D ? 3 : 1, A = N.scrollbar;
                A && (N.chart.scrollbarsOffsets = [0, 0], N.chart.axisOffset[k] += A.size + A.options.margin);
              }), Q;
            }, J.composed = [], J;
          }();
        }), at(_, "Stock/Scrollbar/ScrollbarDefaults.js", [_["Core/Globals.js"]], function(G) {
          return { height: G.isTouchDevice ? 20 : 14, barBorderRadius: 0, buttonBorderRadius: 0, liveRedraw: void 0, margin: 10, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 1, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "#333333", trackBackgroundColor: "#f2f2f2", trackBorderColor: "#f2f2f2", trackBorderWidth: 1 };
        }), at(_, "Stock/Scrollbar/Scrollbar.js", [_["Core/Defaults.js"], _["Core/Globals.js"], _["Core/Axis/ScrollbarAxis.js"], _["Stock/Scrollbar/ScrollbarDefaults.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = G.defaultOptions, q = J.addEvent, U = J.correctFloat, N = J.defined, D = J.destroyObjectProperties, k = J.fireEvent, A = J.merge, b = J.pick, d = J.removeEvent, m = function() {
            function v(g, x, E) {
              this._events = [], this.chart = void 0, this.chartX = 0, this.chartY = 0, this.from = 0, this.group = void 0, this.options = void 0, this.renderer = void 0, this.scrollbar = void 0, this.scrollbarButtons = [], this.scrollbarGroup = void 0, this.scrollbarLeft = 0, this.scrollbarRifles = void 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.track = void 0, this.trackBorderWidth = 1, this.userOptions = void 0, this.x = 0, this.y = 0, this.init(g, x, E);
            }
            return v.compose = function(g) {
              $.compose(g, v);
            }, v.swapXY = function(g, x) {
              return x && g.forEach(function(E) {
                for (var P, S = E.length, u = 0; u < S; u += 2)
                  typeof (P = E[u + 1]) == "number" && (E[u + 1] = E[u + 2], E[u + 2] = P);
              }), g;
            }, v.prototype.addEvents = function() {
              var g = this.options.inverted ? [1, 0] : [0, 1], x = this.scrollbarButtons, E = this.scrollbarGroup.element, P = this.track.element, S = this.mouseDownHandler.bind(this), u = this.mouseMoveHandler.bind(this), y = this.mouseUpHandler.bind(this), s = [[x[g[0]].element, "click", this.buttonToMinClick.bind(this)], [x[g[1]].element, "click", this.buttonToMaxClick.bind(this)], [P, "click", this.trackClick.bind(this)], [E, "mousedown", S], [E.ownerDocument, "mousemove", u], [E.ownerDocument, "mouseup", y]];
              F.hasTouch && s.push([E, "touchstart", S], [E.ownerDocument, "touchmove", u], [E.ownerDocument, "touchend", y]), s.forEach(function(a) {
                q.apply(null, a);
              }), this._events = s;
            }, v.prototype.buttonToMaxClick = function(g) {
              var x = this, E = (x.to - x.from) * b(x.options.step, 0.2);
              x.updatePosition(x.from + E, x.to + E), k(x, "changed", { from: x.from, to: x.to, trigger: "scrollbar", DOMEvent: g });
            }, v.prototype.buttonToMinClick = function(g) {
              var x = this, E = U(x.to - x.from) * b(x.options.step, 0.2);
              x.updatePosition(U(x.from - E), U(x.to - E)), k(x, "changed", { from: x.from, to: x.to, trigger: "scrollbar", DOMEvent: g });
            }, v.prototype.cursorToScrollbarPosition = function(g) {
              var x = this, E = x.options, P = E.minWidth > x.calculatedWidth ? E.minWidth : 0;
              return { chartX: (g.chartX - x.x - x.xOffset) / (x.barWidth - P), chartY: (g.chartY - x.y - x.yOffset) / (x.barWidth - P) };
            }, v.prototype.destroy = function() {
              var g = this, x = g.chart.scroller;
              g.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(E) {
                g[E] && g[E].destroy && (g[E] = g[E].destroy());
              }), x && g === x.scrollbar && (x.scrollbar = null, D(x.scrollbarButtons));
            }, v.prototype.drawScrollbarButton = function(g) {
              var x, E = this, P = E.renderer, S = E.scrollbarButtons, u = E.options, y = E.size, s = P.g().add(E.group);
              S.push(s), x = P.rect().addClass("highcharts-scrollbar-button").add(s), E.chart.styledMode || x.attr({ stroke: u.buttonBorderColor, "stroke-width": u.buttonBorderWidth, fill: u.buttonBackgroundColor }), x.attr(x.crisp({ x: -0.5, y: -0.5, width: y + 1, height: y + 1, r: u.buttonBorderRadius }, x.strokeWidth())), x = P.path(v.swapXY([["M", y / 2 + (g ? -1 : 1), y / 2 - 3], ["L", y / 2 + (g ? -1 : 1), y / 2 + 3], ["L", y / 2 + (g ? 2 : -2), y / 2]], u.vertical)).addClass("highcharts-scrollbar-arrow").add(S[g]), E.chart.styledMode || x.attr({ fill: u.buttonArrowColor });
            }, v.prototype.init = function(g, x, E) {
              var P = this;
              P.scrollbarButtons = [], P.renderer = g, P.userOptions = x, P.options = A(Y, Q.scrollbar, x), P.chart = E, P.size = b(P.options.size, P.options.height), x.enabled && (P.render(), P.addEvents());
            }, v.prototype.mouseDownHandler = function(g) {
              var x = this, E = x.chart.pointer.normalize(g), P = x.cursorToScrollbarPosition(E);
              x.chartX = P.chartX, x.chartY = P.chartY, x.initPositions = [x.from, x.to], x.grabbedCenter = !0;
            }, v.prototype.mouseMoveHandler = function(g) {
              var x, E = this, P = E.chart.pointer.normalize(g), S = E.options.vertical ? "chartY" : "chartX", u = E.initPositions || [];
              !E.grabbedCenter || g.touches && g.touches[0][S] === 0 || (x = E.cursorToScrollbarPosition(P)[S] - E[S], E.hasDragged = !0, E.updatePosition(u[0] + x, u[1] + x), E.hasDragged && k(E, "changed", { from: E.from, to: E.to, trigger: "scrollbar", DOMType: g.type, DOMEvent: g }));
            }, v.prototype.mouseUpHandler = function(g) {
              var x = this;
              x.hasDragged && k(x, "changed", { from: x.from, to: x.to, trigger: "scrollbar", DOMType: g.type, DOMEvent: g }), x.grabbedCenter = x.hasDragged = x.chartX = x.chartY = null;
            }, v.prototype.position = function(g, x, E, P) {
              var S = this, u = S.options.vertical, y = S.rendered ? "animate" : "attr", s = P, a = 0;
              S.group.show(), S.x = g, S.y = x + this.trackBorderWidth, S.width = E, S.height = P, S.xOffset = s, S.yOffset = a, u ? (S.width = S.yOffset = E = a = S.size, S.xOffset = s = 0, S.barWidth = P - 2 * E, S.x = g += S.options.margin) : (S.height = S.xOffset = P = s = S.size, S.barWidth = E - 2 * P, S.y = S.y + S.options.margin), S.group[y]({ translateX: g, translateY: S.y }), S.track[y]({ width: E, height: P }), S.scrollbarButtons[1][y]({ translateX: u ? 0 : E - s, translateY: u ? P - a : 0 });
            }, v.prototype.removeEvents = function() {
              this._events.forEach(function(g) {
                d.apply(null, g);
              }), this._events.length = 0;
            }, v.prototype.render = function() {
              var g = this, x = g.renderer, E = g.options, P = g.size, S = g.chart.styledMode, u = x.g("scrollbar").attr({ zIndex: E.zIndex }).hide().add();
              g.group = u, g.track = x.rect().addClass("highcharts-scrollbar-track").attr({ x: 0, r: E.trackBorderRadius || 0, height: P, width: P }).add(u), S || g.track.attr({ fill: E.trackBackgroundColor, stroke: E.trackBorderColor, "stroke-width": E.trackBorderWidth }), g.trackBorderWidth = g.track.strokeWidth(), g.track.attr({ y: -this.trackBorderWidth % 2 / 2 }), g.scrollbarGroup = x.g().add(u), g.scrollbar = x.rect().addClass("highcharts-scrollbar-thumb").attr({ height: P, width: P, r: E.barBorderRadius || 0 }).add(g.scrollbarGroup), g.scrollbarRifles = x.path(v.swapXY([["M", -3, P / 4], ["L", -3, 2 * P / 3], ["M", 0, P / 4], ["L", 0, 2 * P / 3], ["M", 3, P / 4], ["L", 3, 2 * P / 3]], E.vertical)).addClass("highcharts-scrollbar-rifles").add(g.scrollbarGroup), S || (g.scrollbar.attr({ fill: E.barBackgroundColor, stroke: E.barBorderColor, "stroke-width": E.barBorderWidth }), g.scrollbarRifles.attr({ stroke: E.rifleColor, "stroke-width": 1 })), g.scrollbarStrokeWidth = g.scrollbar.strokeWidth(), g.scrollbarGroup.translate(-g.scrollbarStrokeWidth % 2 / 2, -g.scrollbarStrokeWidth % 2 / 2), g.drawScrollbarButton(0), g.drawScrollbarButton(1);
            }, v.prototype.setRange = function(g, x) {
              var E = this, P = E.options, S = P.vertical, u = P.minWidth, y = E.barWidth, s = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
              if (N(y)) {
                var a, e, n = y * Math.min(x, 1);
                g = Math.max(g, 0), a = Math.ceil(y * g), E.calculatedWidth = e = U(n - a), e < u && (a = (y - u + e) * g, e = u);
                var o = Math.floor(a + E.xOffset + E.yOffset), i = e / 2 - 0.5;
                E.from = g, E.to = x, S ? (E.scrollbarGroup[s]({ translateY: o }), E.scrollbar[s]({ height: e }), E.scrollbarRifles[s]({ translateY: i }), E.scrollbarTop = o, E.scrollbarLeft = 0) : (E.scrollbarGroup[s]({ translateX: o }), E.scrollbar[s]({ width: e }), E.scrollbarRifles[s]({ translateX: i }), E.scrollbarLeft = o, E.scrollbarTop = 0), e <= 12 ? E.scrollbarRifles.hide() : E.scrollbarRifles.show(), P.showFull === !1 && (g <= 0 && x >= 1 ? E.group.hide() : E.group.show()), E.rendered = !0;
              }
            }, v.prototype.shouldUpdateExtremes = function(g) {
              return b(this.options.liveRedraw, F.svg && !F.isTouchDevice && !this.chart.boosted) || g === "mouseup" || g === "touchend" || !N(g);
            }, v.prototype.trackClick = function(g) {
              var x = this, E = x.chart.pointer.normalize(g), P = x.to - x.from, S = x.y + x.scrollbarTop, u = x.x + x.scrollbarLeft;
              x.options.vertical && E.chartY > S || !x.options.vertical && E.chartX > u ? x.updatePosition(x.from + P, x.to + P) : x.updatePosition(x.from - P, x.to - P), k(x, "changed", { from: x.from, to: x.to, trigger: "scrollbar", DOMEvent: g });
            }, v.prototype.update = function(g) {
              this.destroy(), this.init(this.chart.renderer, A(!0, this.options, g), this.chart);
            }, v.prototype.updatePosition = function(g, x) {
              x > 1 && (g = U(1 - U(x - g)), x = 1), g < 0 && (x = U(x - g), g = 0), this.from = g, this.to = x;
            }, v.defaultOptions = Y, v;
          }();
          return Q.scrollbar = A(!0, m.defaultOptions, Q.scrollbar), m;
        }), at(_, "Stock/Navigator/Navigator.js", [_["Core/Axis/Axis.js"], _["Core/Defaults.js"], _["Core/Globals.js"], _["Core/Axis/NavigatorAxisComposition.js"], _["Stock/Navigator/NavigatorComposition.js"], _["Stock/Scrollbar/Scrollbar.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q) {
          var U = F.defaultOptions, N = $.hasTouch, D = $.isTouchDevice, k = q.addEvent, A = q.clamp, b = q.correctFloat, d = q.defined, m = q.destroyObjectProperties, v = q.erase, g = q.extend, x = q.find, E = q.isArray, P = q.isNumber, S = q.merge, u = q.pick, y = q.removeEvent, s = q.splat;
          function a(e) {
            for (var n = [], o = 1; o < arguments.length; o++)
              n[o - 1] = arguments[o];
            var i = [].filter.call(n, P);
            if (i.length)
              return Math[e].apply(0, i);
          }
          return function() {
            function e(n) {
              this.baseSeries = void 0, this.chart = void 0, this.handles = void 0, this.height = void 0, this.left = void 0, this.navigatorEnabled = void 0, this.navigatorGroup = void 0, this.navigatorOptions = void 0, this.navigatorSeries = void 0, this.navigatorSize = void 0, this.opposite = void 0, this.outline = void 0, this.outlineHeight = void 0, this.range = void 0, this.rendered = void 0, this.shades = void 0, this.size = void 0, this.top = void 0, this.xAxis = void 0, this.yAxis = void 0, this.zoomedMax = void 0, this.zoomedMin = void 0, this.init(n);
            }
            return e.compose = function(n, o, i) {
              J.compose(n, o, e, i);
            }, e.prototype.drawHandle = function(n, o, i, c) {
              var l = this, h = l.navigatorOptions.handles.height;
              l.handles[o][c](i ? { translateX: Math.round(l.left + l.height / 2), translateY: Math.round(l.top + parseInt(n, 10) + 0.5 - h) } : { translateX: Math.round(l.left + parseInt(n, 10)), translateY: Math.round(l.top + l.height / 2 - h / 2 - 1) });
            }, e.prototype.drawOutline = function(n, o, i, c) {
              var l, h, C = this, M = C.navigatorOptions.maskInside, O = C.outline.strokeWidth(), p = O / 2, w = O % 2 / 2, T = C.outlineHeight, z = C.scrollbarHeight || 0, W = C.size, L = C.left - z, I = C.top;
              i ? (h = [["M", (L -= p) + T, I - z - w], ["L", L + T, l = I + o + w], ["L", L, l], ["L", L, o = I + n + w], ["L", L + T, o], ["L", L + T, I + W + z]], M && h.push(["M", L + T, l - p], ["L", L + T, o + p])) : (h = [["M", L, I += p], ["L", n += L + z - w, I], ["L", n, I + T], ["L", o += L + z - w, I + T], ["L", o, I], ["L", L + W + 2 * z, I]], M && h.push(["M", n - p, I], ["L", o + p, I])), C.outline[c]({ d: h });
            }, e.prototype.drawMasks = function(n, o, i, c) {
              var l, h, C, M, O = this, p = O.left, w = O.top, T = O.height;
              i ? (C = [p, p, p], M = [w, w + n, w + o], h = [T, T, T], l = [n, o - n, O.size - o]) : (C = [p, p + n, p + o], M = [w, w, w], h = [n, o - n, O.size - o], l = [T, T, T]), O.shades.forEach(function(z, W) {
                z[c]({ x: C[W], y: M[W], width: h[W], height: l[W] });
              });
            }, e.prototype.renderElements = function() {
              var n = this, o = n.navigatorOptions, i = o.maskInside, c = n.chart, l = c.inverted, h = c.renderer, C = { cursor: l ? "ns-resize" : "ew-resize" }, M = n.navigatorGroup = h.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
              if ([!i, i, !i].forEach(function(T, z) {
                var W = h.rect().addClass("highcharts-navigator-mask" + (z === 1 ? "-inside" : "-outside")).add(M);
                c.styledMode || (W.attr({ fill: T ? o.maskFill : "rgba(0,0,0,0)" }), z === 1 && W.css(C)), n.shades[z] = W;
              }), n.outline = h.path().addClass("highcharts-navigator-outline").add(M), c.styledMode || n.outline.attr({ "stroke-width": o.outlineWidth, stroke: o.outlineColor }), o.handles && o.handles.enabled) {
                var O = o.handles, p = O.height, w = O.width;
                [0, 1].forEach(function(T) {
                  n.handles[T] = h.symbol(O.symbols[T], -w / 2 - 1, 0, w, p, O), c.inverted && n.handles[T].attr({ rotation: 90, rotationOriginX: Math.floor(-w / 2), rotationOriginY: (p + w) / 2 }), n.handles[T].attr({ zIndex: 7 - T }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][T]).add(M), c.styledMode || n.handles[T].attr({ fill: O.backgroundColor, stroke: O.borderColor, "stroke-width": O.lineWidth }).css(C);
                });
              }
            }, e.prototype.update = function(n) {
              (this.series || []).forEach(function(i) {
                i.baseSeries && delete i.baseSeries.navigatorSeries;
              }), this.destroy();
              var o = this.chart.options;
              S(!0, o.navigator, n), this.init(this.chart);
            }, e.prototype.render = function(n, o, i, c) {
              var l, h, C, M, O, p = this, w = p.chart, T = p.xAxis, z = T.pointRange || 0, W = T.navigatorAxis.fake ? w.xAxis[0] : T, L = p.navigatorEnabled, I = p.rendered, j = w.inverted, Z = w.xAxis[0].minRange, V = w.xAxis[0].options.maxRange, X = p.scrollbarHeight;
              if (!this.hasDragged || d(i)) {
                if (n = b(n - z / 2), o = b(o + z / 2), !P(n) || !P(o)) {
                  if (!I)
                    return;
                  i = 0, c = u(T.width, W.width);
                }
                p.left = u(T.left, w.plotLeft + X + (j ? w.plotWidth : 0));
                var et = p.size = M = u(T.len, (j ? w.plotHeight : w.plotWidth) - 2 * X);
                l = j ? X : M + 2 * X, i = u(i, T.toPixels(n, !0)), c = u(c, T.toPixels(o, !0)), P(i) && Math.abs(i) !== 1 / 0 || (i = 0, c = l);
                var ot = T.toValue(i, !0), it = T.toValue(c, !0), pt = Math.abs(b(it - ot));
                pt < Z ? this.grabbedLeft ? i = T.toPixels(it - Z - z, !0) : this.grabbedRight && (c = T.toPixels(ot + Z + z, !0)) : d(V) && b(pt - z) > V && (this.grabbedLeft ? i = T.toPixels(it - V - z, !0) : this.grabbedRight && (c = T.toPixels(ot + V + z, !0))), p.zoomedMax = A(Math.max(i, c), 0, et), p.zoomedMin = A(p.fixedWidth ? p.zoomedMax - p.fixedWidth : Math.min(i, c), 0, et), p.range = p.zoomedMax - p.zoomedMin, et = Math.round(p.zoomedMax);
                var mt = Math.round(p.zoomedMin);
                L && (p.navigatorGroup.attr({ visibility: "inherit" }), O = I && !p.hasDragged ? "animate" : "attr", p.drawMasks(mt, et, j, O), p.drawOutline(mt, et, j, O), p.navigatorOptions.handles.enabled && (p.drawHandle(mt, 0, j, O), p.drawHandle(et, 1, j, O))), p.scrollbar && (j ? (C = p.top - X, h = p.left - X + (L || !W.opposite ? 0 : (W.titleOffset || 0) + W.axisTitleMargin), X = M + 2 * X) : (C = p.top + (L ? p.height : -X), h = p.left - X), p.scrollbar.position(h, C, l, X), p.scrollbar.setRange(p.zoomedMin / (M || 1), p.zoomedMax / (M || 1))), p.rendered = !0;
              }
            }, e.prototype.addMouseEvents = function() {
              var n, o, i = this, c = i.chart, l = c.container, h = [];
              i.mouseMoveHandler = n = function(C) {
                i.onMouseMove(C);
              }, i.mouseUpHandler = o = function(C) {
                i.onMouseUp(C);
              }, (h = i.getPartsEvents("mousedown")).push(k(c.renderTo, "mousemove", n), k(l.ownerDocument, "mouseup", o)), N && (h.push(k(c.renderTo, "touchmove", n), k(l.ownerDocument, "touchend", o)), h.concat(i.getPartsEvents("touchstart"))), i.eventsToUnbind = h, i.series && i.series[0] && h.push(k(i.series[0].xAxis, "foundExtremes", function() {
                c.navigator.modifyNavigatorAxisExtremes();
              }));
            }, e.prototype.getPartsEvents = function(n) {
              var o = this, i = [];
              return ["shades", "handles"].forEach(function(c) {
                o[c].forEach(function(l, h) {
                  i.push(k(l.element, n, function(C) {
                    o[c + "Mousedown"](C, h);
                  }));
                });
              }), i;
            }, e.prototype.shadesMousedown = function(n, o) {
              n = this.chart.pointer.normalize(n);
              var i, c, l, h, C = this, M = C.chart, O = C.xAxis, p = C.zoomedMin, w = C.size, T = C.range, z = C.left, W = n.chartX;
              M.inverted && (W = n.chartY, z = C.top), o === 1 ? (C.grabbedCenter = W, C.fixedWidth = T, C.dragOffset = W - p) : (h = W - z - T / 2, o === 0 ? h = Math.max(0, h) : o === 2 && h + T >= w && (h = w - T, C.reversedExtremes ? (h -= T, c = C.getUnionExtremes().dataMin) : i = C.getUnionExtremes().dataMax), h !== p && (C.fixedWidth = T, l = O.navigatorAxis.toFixedRange(h, h + T, c, i), d(l.min) && M.xAxis[0].setExtremes(Math.min(l.min, l.max), Math.max(l.min, l.max), !0, null, { trigger: "navigator" })));
            }, e.prototype.handlesMousedown = function(n, o) {
              n = this.chart.pointer.normalize(n);
              var i = this, c = i.chart, l = c.xAxis[0], h = i.reversedExtremes;
              o === 0 ? (i.grabbedLeft = !0, i.otherHandlePos = i.zoomedMax, i.fixedExtreme = h ? l.min : l.max) : (i.grabbedRight = !0, i.otherHandlePos = i.zoomedMin, i.fixedExtreme = h ? l.max : l.min), c.fixedRange = null;
            }, e.prototype.onMouseMove = function(n) {
              var o, i = this, c = i.chart, l = i.navigatorSize, h = i.range, C = i.dragOffset, M = c.inverted, O = i.left;
              n.touches && n.touches[0].pageX === 0 || (o = (n = c.pointer.normalize(n)).chartX, M && (O = i.top, o = n.chartY), i.grabbedLeft ? (i.hasDragged = !0, i.render(0, 0, o - O, i.otherHandlePos)) : i.grabbedRight ? (i.hasDragged = !0, i.render(0, 0, i.otherHandlePos, o - O)) : i.grabbedCenter && (i.hasDragged = !0, o < C ? o = C : o > l + C - h && (o = l + C - h), i.render(0, 0, o - C, o - C + h)), i.hasDragged && i.scrollbar && u(i.scrollbar.options.liveRedraw, $.svg && !D && !this.chart.boosted) && (n.DOMType = n.type, setTimeout(function() {
                i.onMouseUp(n);
              }, 0)));
            }, e.prototype.onMouseUp = function(n) {
              var o, i, c, l, h, C, M = this, O = M.chart, p = M.xAxis, w = M.scrollbar, T = n.DOMEvent || n, z = O.inverted, W = M.rendered && !M.hasDragged ? "animate" : "attr";
              (!M.hasDragged || w && w.hasDragged) && n.trigger !== "scrollbar" || (c = M.getUnionExtremes(), M.zoomedMin === M.otherHandlePos ? l = M.fixedExtreme : M.zoomedMax === M.otherHandlePos && (h = M.fixedExtreme), M.zoomedMax === M.size && (h = M.reversedExtremes ? c.dataMin : c.dataMax), M.zoomedMin === 0 && (l = M.reversedExtremes ? c.dataMax : c.dataMin), C = p.navigatorAxis.toFixedRange(M.zoomedMin, M.zoomedMax, l, h), d(C.min) && O.xAxis[0].setExtremes(Math.min(C.min, C.max), Math.max(C.min, C.max), !0, !M.hasDragged && null, { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: T })), n.DOMType !== "mousemove" && n.DOMType !== "touchmove" && (M.grabbedLeft = M.grabbedRight = M.grabbedCenter = M.fixedWidth = M.fixedExtreme = M.otherHandlePos = M.hasDragged = M.dragOffset = null), M.navigatorEnabled && P(M.zoomedMin) && P(M.zoomedMax) && (i = Math.round(M.zoomedMin), o = Math.round(M.zoomedMax), M.shades && M.drawMasks(i, o, z, W), M.outline && M.drawOutline(i, o, z, W), M.navigatorOptions.handles.enabled && Object.keys(M.handles).length === M.handles.length && (M.drawHandle(i, 0, z, W), M.drawHandle(o, 1, z, W)));
            }, e.prototype.removeEvents = function() {
              this.eventsToUnbind && (this.eventsToUnbind.forEach(function(n) {
                n();
              }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
            }, e.prototype.removeBaseSeriesEvents = function() {
              var n = this.baseSeries || [];
              this.navigatorEnabled && n[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && n.forEach(function(o) {
                y(o, "updatedData", this.updatedDataHandler);
              }, this), n[0].xAxis && y(n[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
            }, e.prototype.init = function(n) {
              var o = n.options, i = o.navigator || {}, c = i.enabled, l = o.scrollbar || {}, h = l.enabled, C = c && i.height || 0, M = h && l.height || 0;
              this.handles = [], this.shades = [], this.chart = n, this.setBaseSeries(), this.height = C, this.scrollbarHeight = M, this.scrollbarEnabled = h, this.navigatorEnabled = c, this.navigatorOptions = i, this.scrollbarOptions = l, this.outlineHeight = C + M, this.opposite = u(i.opposite, !!(!c && n.inverted));
              var O = this, p = O.baseSeries, w = n.xAxis.length, T = n.yAxis.length, z = p && p[0] && p[0].xAxis || n.xAxis[0] || { options: {} };
              n.isDirtyBox = !0, O.navigatorEnabled ? (O.xAxis = new G(n, S({ breaks: z.options.breaks, ordinal: z.options.ordinal }, i.xAxis, { id: "navigator-x-axis", yAxis: "navigator-y-axis", isX: !0, type: "datetime", index: w, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: 0, maxPadding: 0, zoomEnabled: !1 }, n.inverted ? { offsets: [M, 0, -M, 0], width: C } : { offsets: [0, -M, 0, M], height: C })), O.yAxis = new G(n, S(i.yAxis, { id: "navigator-y-axis", alignTicks: !1, offset: 0, index: T, isInternal: !0, reversed: u(i.yAxis && i.yAxis.reversed, n.yAxis[0] && n.yAxis[0].reversed, !1), zoomEnabled: !1 }, n.inverted ? { width: C } : { height: C })), p || i.series.data ? O.updateNavigatorSeries(!1) : n.series.length === 0 && (O.unbindRedraw = k(n, "beforeRedraw", function() {
                n.series.length > 0 && !O.series && (O.setBaseSeries(), O.unbindRedraw());
              })), O.reversedExtremes = n.inverted && !O.xAxis.reversed || !n.inverted && O.xAxis.reversed, O.renderElements(), O.addMouseEvents()) : (O.xAxis = { chart: n, navigatorAxis: { fake: !0 }, translate: function(W, L) {
                var I = n.xAxis[0], j = I.getExtremes(), Z = I.len - 2 * M, V = a("min", I.options.min, j.dataMin), X = a("max", I.options.max, j.dataMax) - V;
                return L ? W * X / Z + V : Z * (W - V) / X;
              }, toPixels: function(W) {
                return this.translate(W);
              }, toValue: function(W) {
                return this.translate(W, !0);
              } }, O.xAxis.navigatorAxis.axis = O.xAxis, O.xAxis.navigatorAxis.toFixedRange = Y.prototype.toFixedRange.bind(O.xAxis.navigatorAxis)), n.options.scrollbar.enabled && (n.scrollbar = O.scrollbar = new Q(n.renderer, S(n.options.scrollbar, { margin: O.navigatorEnabled ? 0 : 10, vertical: n.inverted }), n), k(O.scrollbar, "changed", function(W) {
                var L = O.size, I = L * this.to, j = L * this.from;
                O.hasDragged = O.scrollbar.hasDragged, O.render(0, 0, j, I), this.shouldUpdateExtremes(W.DOMType) && setTimeout(function() {
                  O.onMouseUp(W);
                });
              })), O.addBaseSeriesEvents(), O.addChartEvents();
            }, e.prototype.getUnionExtremes = function(n) {
              var o, i = this.chart.xAxis[0], c = this.xAxis, l = c.options, h = i.options;
              return n && i.dataMin === null || (o = { dataMin: u(l && l.min, a("min", h.min, i.dataMin, c.dataMin, c.min)), dataMax: u(l && l.max, a("max", h.max, i.dataMax, c.dataMax, c.max)) }), o;
            }, e.prototype.setBaseSeries = function(n, o) {
              var i = this.chart, c = this.baseSeries = [];
              n = n || i.options && i.options.navigator.baseSeries || (i.series.length ? x(i.series, function(l) {
                return !l.options.isInternal;
              }).index : 0), (i.series || []).forEach(function(l, h) {
                l.options.isInternal || !l.options.showInNavigator && (h !== n && l.options.id !== n || l.options.showInNavigator === !1) || c.push(l);
              }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, o);
            }, e.prototype.updateNavigatorSeries = function(n, o) {
              var i, c, l, h = this, C = h.chart, M = h.baseSeries, O = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: "navigator-x-axis", yAxis: "navigator-y-axis", showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, p = h.series = (h.series || []).filter(function(T) {
                var z = T.baseSeries;
                return !(M.indexOf(z) < 0 && (z && (y(z, "updatedData", h.updatedDataHandler), delete z.navigatorSeries), T.chart && T.destroy(), 1));
              }), w = h.navigatorOptions.series;
              M && M.length && M.forEach(function(T) {
                var z = T.navigatorSeries, W = g({ color: T.color, visible: T.visible }, E(w) ? U.navigator.series : w);
                if (!z || h.navigatorOptions.adaptToUpdatedData !== !1) {
                  O.name = "Navigator " + M.length, i = T.options || {}, l = i.navigatorOptions || {}, W.dataLabels = s(W.dataLabels), (c = S(i, O, W, l)).pointRange = u(W.pointRange, l.pointRange, U.plotOptions[c.type || "line"].pointRange);
                  var L = l.data || W.data;
                  h.hasNavigatorData = h.hasNavigatorData || !!L, c.data = L || i.data && i.data.slice(0), z && z.options ? z.update(c, o) : (T.navigatorSeries = C.initSeries(c), T.navigatorSeries.baseSeries = T, p.push(T.navigatorSeries));
                }
              }), (!w.data || M && M.length) && !E(w) || (h.hasNavigatorData = !1, (w = s(w)).forEach(function(T, z) {
                O.name = "Navigator " + (p.length + 1), (c = S(U.navigator.series, { color: C.series[z] && !C.series[z].options.isInternal && C.series[z].color || C.options.colors[z] || C.options.colors[0] }, O, T)).data = T.data, c.data && (h.hasNavigatorData = !0, p.push(C.initSeries(c)));
              })), n && this.addBaseSeriesEvents();
            }, e.prototype.addBaseSeriesEvents = function() {
              var n = this, o = this, i = o.baseSeries || [];
              i[0] && i[0].xAxis && i[0].eventsToUnbind.push(k(i[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), i.forEach(function(c) {
                c.eventsToUnbind.push(k(c, "show", function() {
                  this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
                })), c.eventsToUnbind.push(k(c, "hide", function() {
                  this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
                })), n.navigatorOptions.adaptToUpdatedData !== !1 && c.xAxis && c.eventsToUnbind.push(k(c, "updatedData", n.updatedDataHandler)), c.eventsToUnbind.push(k(c, "remove", function() {
                  this.navigatorSeries && (v(o.series, this.navigatorSeries), d(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
                }));
              });
            }, e.prototype.getBaseSeriesMin = function(n) {
              return this.baseSeries.reduce(function(o, i) {
                return Math.min(o, i.xData && i.xData.length ? i.xData[0] : o);
              }, n);
            }, e.prototype.modifyNavigatorAxisExtremes = function() {
              var n = this.xAxis;
              if (n.getExtremes !== void 0) {
                var o = this.getUnionExtremes(!0);
                !o || o.dataMin === n.min && o.dataMax === n.max || (n.min = o.dataMin, n.max = o.dataMax);
              }
            }, e.prototype.modifyBaseAxisExtremes = function() {
              var n, o, i = this, c = i.chart.navigator, l = i.getExtremes(), h = l.min, C = l.max, M = l.dataMin, O = l.dataMax, p = C - h, w = c.stickToMin, T = c.stickToMax, z = u(i.options.overscroll, 0), W = c.series && c.series[0], L = !!i.setExtremes;
              i.eventArgs && i.eventArgs.trigger === "rangeSelectorButton" || (w && (n = (o = M) + p), T && (n = O + z, w || (o = Math.max(M, n - p, c.getBaseSeriesMin(W && W.xData ? W.xData[0] : -Number.MAX_VALUE)))), L && (w || T) && P(o) && (i.min = i.userMin = o, i.max = i.userMax = n)), c.stickToMin = c.stickToMax = null;
            }, e.prototype.updatedDataHandler = function() {
              var n = this.chart.navigator, o = this, i = this.navigatorSeries, c = n.reversedExtremes ? Math.round(n.zoomedMin) === 0 : Math.round(n.zoomedMax) >= Math.round(n.size);
              n.stickToMax = u(this.chart.options.navigator && this.chart.options.navigator.stickToMax, c), n.stickToMin = n.shouldStickToMin(o, n), i && !n.hasNavigatorData && (i.options.pointStart = o.xData[0], i.setData(o.options.data, !1, null, !1));
            }, e.prototype.shouldStickToMin = function(n, o) {
              var i = o.getBaseSeriesMin(n.xData[0]), c = n.xAxis, l = c.max, h = c.min, C = c.options.range;
              return !(!P(l) || !P(h)) && (C && l - i > 0 ? l - i < C : h <= i);
            }, e.prototype.addChartEvents = function() {
              this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(k(this.chart, "redraw", function() {
                var n = this.navigator, o = n && (n.baseSeries && n.baseSeries[0] && n.baseSeries[0].xAxis || this.xAxis[0]);
                o && n.render(o.min, o.max);
              }), k(this.chart, "getMargins", function() {
                var n = this, o = n.navigator, i = o.opposite ? "plotTop" : "marginBottom";
                n.inverted && (i = o.opposite ? "marginRight" : "plotLeft"), n[i] = (n[i] || 0) + (o.navigatorEnabled || !n.inverted ? o.outlineHeight : 0) + o.navigatorOptions.margin;
              }));
            }, e.prototype.destroy = function() {
              var n = this;
              this.removeEvents(), this.xAxis && (v(this.chart.xAxis, this.xAxis), v(this.chart.axes, this.xAxis)), this.yAxis && (v(this.chart.yAxis, this.yAxis), v(this.chart.axes, this.yAxis)), (this.series || []).forEach(function(o) {
                o.destroy && o.destroy();
              }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach(function(o) {
                n[o] && n[o].destroy && n[o].destroy(), n[o] = null;
              }), [this.handles].forEach(function(o) {
                m(o);
              });
            }, e;
          }();
        }), at(_, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
          return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%b %e, %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#335cad", cursor: "pointer" }, labelStyle: { color: "#666666" } } };
        }), at(_, "Stock/RangeSelector/RangeSelectorComposition.js", [_["Core/Defaults.js"], _["Stock/RangeSelector/RangeSelectorDefaults.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = G.defaultOptions, Q = G.setOptions, q = $.addEvent, U = $.defined, N = $.extend, D = $.find, k = $.isNumber, A = $.merge, b = $.pick, d = [], m = [];
          function v() {
            var s, a, e = this.range, n = e.type, o = this.max, i = this.chart.time, c = function(h, C) {
              var M = n === "year" ? "FullYear" : "Month", O = new i.Date(h), p = i.get(M, O);
              return i.set(M, O, p + C), p === i.get(M, O) && i.set("Date", O, 0), O.getTime() - h;
            };
            k(e) ? (s = o - e, a = e) : e && (s = o + c(o, -(e.count || 1)), this.chart && (this.chart.fixedRange = o - s));
            var l = b(this.dataMin, Number.MIN_VALUE);
            return k(s) || (s = l), s <= l && (s = l, a === void 0 && (a = c(s, e.count)), this.newMax = Math.min(s + a, b(this.dataMax, Number.MAX_VALUE))), k(o) ? !k(e) && e && e._offsetMin && (s += e._offsetMin) : s = void 0, s;
          }
          function g() {
            this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new Y(this));
          }
          function x() {
            var s = this, a = s.axes, e = s.rangeSelector;
            if (e) {
              k(e.deferredYTDClick) && (e.clickButton(e.deferredYTDClick), delete e.deferredYTDClick), a.forEach(function(o) {
                o.updateNames(), o.setScale();
              }), s.getAxisMargins(), e.render();
              var n = e.options.verticalAlign;
              e.options.floating || (n === "bottom" ? this.extraBottomMargin = !0 : n !== "middle" && (this.extraTopMargin = !0));
            }
          }
          function E(s) {
            var a, e, n, o, i = s.rangeSelector, c = function() {
              i && (a = s.xAxis[0].getExtremes(), e = s.legend, o = i && i.options.verticalAlign, k(a.min) && i.render(a.min, a.max), e.display && o === "top" && o === e.options.verticalAlign && (n = A(s.spacingBox), e.options.layout === "vertical" ? n.y = s.plotTop : n.y += i.getHeight(), e.group.placed = !1, e.align(n)));
            };
            i && (D(d, function(l) {
              return l[0] === s;
            }) || d.push([s, [q(s.xAxis[0], "afterSetExtremes", function(l) {
              i && i.render(l.min, l.max);
            }), q(s, "redraw", c)]]), c());
          }
          function P() {
            for (var s = 0, a = d.length; s < a; ++s) {
              var e = d[s];
              if (e[0] === this)
                return e[1].forEach(function(n) {
                  return n();
                }), void d.splice(s, 1);
            }
          }
          function S() {
            var s = this.rangeSelector;
            if (s) {
              var a = s.getHeight();
              this.extraTopMargin && (this.plotTop += a), this.extraBottomMargin && (this.marginBottom += a);
            }
          }
          function u() {
            var s = this.rangeSelector;
            if (s && !s.options.floating) {
              s.render();
              var a = s.options.verticalAlign;
              a === "bottom" ? this.extraBottomMargin = !0 : a !== "middle" && (this.extraTopMargin = !0);
            }
          }
          function y(s) {
            var a = s.options.rangeSelector, e = this.extraBottomMargin, n = this.extraTopMargin, o = this.rangeSelector;
            if (a && a.enabled && !U(o) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = o = new Y(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, o) {
              E(this);
              var i = a && a.verticalAlign || o.options && o.options.verticalAlign;
              o.options.floating || (i === "bottom" ? this.extraBottomMargin = !0 : i !== "middle" && (this.extraTopMargin = !0)), this.extraBottomMargin === e && this.extraTopMargin === n || (this.isDirtyBox = !0);
            }
          }
          return { compose: function(s, a, e) {
            Y = e, m.indexOf(s) === -1 && (m.push(s), s.prototype.minFromRange = v), m.indexOf(a) === -1 && (m.push(a), q(a, "afterGetContainer", g), q(a, "beforeRender", x), q(a, "destroy", P), q(a, "getMargins", S), q(a, "render", u), q(a, "update", y), a.prototype.callbacks.push(E)), m.indexOf(Q) === -1 && (N(J, { rangeSelector: F.rangeSelector }), N(J.lang, F.lang));
          } };
        }), at(_, "Stock/RangeSelector/RangeSelector.js", [_["Core/Axis/Axis.js"], _["Core/Defaults.js"], _["Core/Globals.js"], _["Stock/RangeSelector/RangeSelectorComposition.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = F.defaultOptions, U = Q.addEvent, N = Q.createElement, D = Q.css, k = Q.defined, A = Q.destroyObjectProperties, b = Q.discardElement, d = Q.extend, m = Q.fireEvent, v = Q.isNumber, g = Q.merge, x = Q.objectEach, E = Q.pad, P = Q.pick, S = Q.pInt, u = Q.splat, y = function() {
            function s(a) {
              this.buttons = void 0, this.buttonOptions = s.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.options = void 0, this.chart = a, this.init(a);
            }
            return s.compose = function(a, e) {
              Y.compose(a, e, s);
            }, s.prototype.clickButton = function(a, e) {
              var n, o, i, c, l, h, C, M = this, O = M.chart, p = M.buttonOptions[a], w = O.xAxis[0], T = O.scroller && O.scroller.getUnionExtremes() || w || {}, z = p.type, W = p.dataGrouping, L = T.dataMin, I = T.dataMax, j = w && Math.round(Math.min(w.max, P(I, w.max))), Z = p._range, V = !0;
              if (L !== null && I !== null) {
                if (O.fixedRange = Z, M.setSelected(a), W && (this.forcedDataGrouping = !0, G.prototype.setDataGrouping.call(w || { chart: this.chart }, W, !1), this.frozenStates = p.preserveDataGrouping), z === "month" || z === "year")
                  w ? (h = { range: p, max: j, chart: O, dataMin: L, dataMax: I }, n = w.minFromRange.call(h), v(h.newMax) && (j = h.newMax), V = !1) : Z = p;
                else if (Z)
                  n = Math.max(j - Z, L), j = Math.min(n + Z, I), V = !1;
                else if (z === "ytd") {
                  if (!w)
                    return void (M.deferredYTDClick = a);
                  I !== void 0 && L !== void 0 || (L = Number.MAX_VALUE, I = Number.MIN_VALUE, O.series.forEach(function(X) {
                    var et = X.xData;
                    et && (L = Math.min(et[0], L), I = Math.max(et[et.length - 1], I));
                  }), e = !1), n = i = (C = M.getYTDExtremes(I, L, O.time.useUTC)).min, j = C.max;
                } else
                  z === "all" && w && (O.navigator && O.navigator.baseSeries[0] && (O.navigator.baseSeries[0].xAxis.options.range = void 0), n = L, j = I);
                V && p._offsetMin && k(n) && (n += p._offsetMin), p._offsetMax && k(j) && (j += p._offsetMax), this.dropdown && (this.dropdown.selectedIndex = a + 1), w ? w.setExtremes(n, j, P(e, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: p }) : (o = u(O.options.xAxis)[0], l = o.range, o.range = Z, c = o.min, o.min = i, U(O, "load", function() {
                  o.range = l, o.min = c;
                })), m(this, "afterBtnClick");
              }
            }, s.prototype.setSelected = function(a) {
              this.selected = this.options.selected = a;
            }, s.prototype.init = function(a) {
              var e = this, n = a.options.rangeSelector, o = n.buttons || e.defaultButtons.slice(), i = n.selected, c = function() {
                var l = e.minInput, h = e.maxInput;
                l && l.blur && m(l, "blur"), h && h.blur && m(h, "blur");
              };
              e.chart = a, e.options = n, e.buttons = [], e.buttonOptions = o, this.eventsToUnbind = [], this.eventsToUnbind.push(U(a.container, "mousedown", c)), this.eventsToUnbind.push(U(a, "resize", c)), o.forEach(e.computeButtonRange), i !== void 0 && o[i] && this.clickButton(i, !1), this.eventsToUnbind.push(U(a, "load", function() {
                a.xAxis && a.xAxis[0] && U(a.xAxis[0], "setExtremes", function(l) {
                  this.max - this.min !== a.fixedRange && l.trigger !== "rangeSelectorButton" && l.trigger !== "updatedData" && e.forcedDataGrouping && !e.frozenStates && this.setDataGrouping(!1, !1);
                });
              }));
            }, s.prototype.updateButtonStates = function() {
              var a = this, e = this.chart, n = this.dropdown, o = e.xAxis[0], i = Math.round(o.max - o.min), c = !o.hasVisibleSeries, l = 864e5, h = e.scroller && e.scroller.getUnionExtremes() || o, C = h.dataMin, M = h.dataMax, O = a.getYTDExtremes(M, C, e.time.useUTC), p = O.min, w = O.max, T = a.selected, z = a.options.allButtonsEnabled, W = a.buttons, L = v(T);
              a.buttonOptions.forEach(function(I, j) {
                var Z = I._range, V = I.type, X = I.count || 1, et = W[j], ot = I._offsetMax - I._offsetMin, it = j === T, pt = Z > M - C, mt = Z < o.minRange, Ct = 0, kt = !1, Lt = !1, Tt = Z === i;
                (V === "month" || V === "year") && i + 36e5 >= { month: 28, year: 365 }[V] * l * X - ot && i - 36e5 <= { month: 31, year: 366 }[V] * l * X + ot ? Tt = !0 : V === "ytd" ? (Tt = w - p + ot === i, kt = !it) : V === "all" && (Tt = o.max - o.min >= M - C, Lt = !it && L && Tt);
                var xt = !z && (pt || mt || Lt || c), ct = it && Tt || Tt && !L && !kt || it && a.frozenStates;
                xt ? Ct = 3 : ct && (L = !0, Ct = 2), et.state !== Ct && (et.setState(Ct), n && (n.options[j + 1].disabled = xt, Ct === 2 && (n.selectedIndex = j + 1)), Ct === 0 && T === j && a.setSelected());
              });
            }, s.prototype.computeButtonRange = function(a) {
              var e = a.type, n = a.count || 1, o = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
              o[e] ? a._range = o[e] * n : e !== "month" && e !== "year" || (a._range = 24 * { month: 30, year: 365 }[e] * 36e5 * n), a._offsetMin = P(a.offsetMin, 0), a._offsetMax = P(a.offsetMax, 0), a._range += a._offsetMax - a._offsetMin;
            }, s.prototype.getInputValue = function(a) {
              var e = a === "min" ? this.minInput : this.maxInput, n = this.chart.options.rangeSelector, o = this.chart.time;
              return e ? (e.type === "text" && n.inputDateParser || this.defaultInputDateParser)(e.value, o.useUTC, o) : 0;
            }, s.prototype.setInputValue = function(a, e) {
              var n = this.options, o = this.chart.time, i = a === "min" ? this.minInput : this.maxInput, c = a === "min" ? this.minDateBox : this.maxDateBox;
              if (i) {
                var l = i.getAttribute("data-hc-time"), h = k(l) ? Number(l) : void 0;
                if (k(e)) {
                  var C = h;
                  k(C) && i.setAttribute("data-hc-time-previous", C), i.setAttribute("data-hc-time", e), h = e;
                }
                i.value = o.dateFormat(this.inputTypeFormats[i.type] || n.inputEditDateFormat, h), c && c.attr({ text: o.dateFormat(n.inputDateFormat, h) });
              }
            }, s.prototype.setInputExtremes = function(a, e, n) {
              var o = a === "min" ? this.minInput : this.maxInput;
              if (o) {
                var i = this.inputTypeFormats[o.type], c = this.chart.time;
                if (i) {
                  var l = c.dateFormat(i, e);
                  o.min !== l && (o.min = l);
                  var h = c.dateFormat(i, n);
                  o.max !== h && (o.max = h);
                }
              }
            }, s.prototype.showInput = function(a) {
              var e = a === "min" ? this.minDateBox : this.maxDateBox, n = a === "min" ? this.minInput : this.maxInput;
              if (n && e && this.inputGroup) {
                var o = n.type === "text", i = this.inputGroup, c = i.translateX, l = i.translateY, h = this.options.inputBoxWidth;
                D(n, { width: o ? e.width + (h ? -2 : 20) + "px" : "auto", height: o ? e.height - 2 + "px" : "auto", border: "2px solid silver" }), D(n, o && h ? { left: c + e.x + "px", top: l + "px" } : { left: Math.min(Math.round(e.x + c - (n.offsetWidth - e.width) / 2), this.chart.chartWidth - n.offsetWidth) + "px", top: l - (n.offsetHeight - e.height) / 2 + "px" });
              }
            }, s.prototype.hideInput = function(a) {
              var e = a === "min" ? this.minInput : this.maxInput;
              e && D(e, { top: "-9999em", border: 0, width: "1px", height: "1px" });
            }, s.prototype.defaultInputDateParser = function(a, e, n) {
              var o, i = a.split("/").join("-").split(" ").join("T");
              if (i.indexOf("T") === -1 && (i += "T00:00"), e)
                i += "Z";
              else if ($.isSafari && (!((o = i).length > 6) || o.lastIndexOf("-") !== o.length - 6 && o.lastIndexOf("+") !== o.length - 6)) {
                var c = new Date(i).getTimezoneOffset() / 60;
                i += c <= 0 ? "+".concat(E(-c), ":00") : "-".concat(E(c), ":00");
              }
              var l = Date.parse(i);
              if (!v(l)) {
                var h = a.split("-");
                l = Date.UTC(S(h[0]), S(h[1]) - 1, S(h[2]));
              }
              return n && e && v(l) && (l += n.getTimezoneOffset(l)), l;
            }, s.prototype.drawInput = function(a) {
              var e = this, n = e.chart, o = e.div, i = e.inputGroup, c = this, l = n.renderer.style || {}, h = n.renderer, C = n.options.rangeSelector, M = q.lang, O = a === "min";
              function p() {
                var I = c.maxInput, j = c.minInput, Z = n.xAxis[0], V = n.scroller && n.scroller.xAxis ? n.scroller.xAxis : Z, X = V.dataMin, et = V.dataMax, ot = c.getInputValue(a);
                ot !== Number(W.getAttribute("data-hc-time-previous")) && v(ot) && (W.setAttribute("data-hc-time-previous", ot), O && I && v(X) ? ot > Number(I.getAttribute("data-hc-time")) ? ot = void 0 : ot < X && (ot = X) : j && v(et) && (ot < Number(j.getAttribute("data-hc-time")) ? ot = void 0 : ot > et && (ot = et)), ot !== void 0 && Z.setExtremes(O ? ot : Z.min, O ? Z.max : ot, void 0, void 0, { trigger: "rangeSelectorInput" }));
              }
              var w = M[O ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", T = h.label(w, 0).addClass("highcharts-range-label").attr({ padding: w ? 2 : 0, height: w ? C.inputBoxHeight : 0 }).add(i), z = h.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: C.inputBoxWidth, height: C.inputBoxHeight, "text-align": "center" }).on("click", function() {
                c.showInput(a), c[a + "Input"].focus();
              });
              n.styledMode || z.attr({ stroke: C.inputBoxBorderColor, "stroke-width": 1 }), z.add(i);
              var W = N("input", { name: a, className: "highcharts-range-selector" }, void 0, o);
              W.setAttribute("type", function(I) {
                if (I.indexOf("%L") !== -1)
                  return "text";
                var j = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some(function(V) {
                  return I.indexOf("%" + V) !== -1;
                }), Z = ["H", "k", "I", "l", "M", "S"].some(function(V) {
                  return I.indexOf("%" + V) !== -1;
                });
                return j && Z ? "datetime-local" : j ? "date" : Z ? "time" : "text";
              }(C.inputDateFormat || "%b %e, %Y")), n.styledMode || (T.css(g(l, C.labelStyle)), z.css(g({ color: "#333333" }, l, C.inputStyle)), D(W, d({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: l.fontSize, fontFamily: l.fontFamily, top: "-9999em" }, C.inputStyle))), W.onfocus = function() {
                c.showInput(a);
              }, W.onblur = function() {
                W === $.doc.activeElement && p(), c.hideInput(a), c.setInputValue(a), W.blur();
              };
              var L = !1;
              return W.onchange = function() {
                L || (p(), c.hideInput(a), W.blur());
              }, W.onkeypress = function(I) {
                I.keyCode === 13 && p();
              }, W.onkeydown = function(I) {
                L = !0, I.keyCode !== 38 && I.keyCode !== 40 || p();
              }, W.onkeyup = function() {
                L = !1;
              }, { dateBox: z, input: W, label: T };
            }, s.prototype.getPosition = function() {
              var a = this.chart, e = a.options.rangeSelector, n = e.verticalAlign === "top" ? a.plotTop - a.axisOffset[0] : 0;
              return { buttonTop: n + e.buttonPosition.y, inputTop: n + e.inputPosition.y - 10 };
            }, s.prototype.getYTDExtremes = function(a, e, n) {
              var o = this.chart.time, i = new o.Date(a), c = o.get("FullYear", i), l = n ? o.Date.UTC(c, 0, 1) : +new o.Date(c, 0, 1), h = Math.max(e, l), C = i.getTime();
              return { max: Math.min(a || C, C), min: h };
            }, s.prototype.render = function(a, e) {
              var n = this.chart, o = n.renderer, i = n.container, c = n.options, l = c.rangeSelector, h = P(c.chart.style && c.chart.style.zIndex, 0) + 1, C = l.inputEnabled, M = this.rendered;
              if (l.enabled !== !1) {
                if (!M && (this.group = o.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = N("div", void 0, { position: "relative", height: 0, zIndex: h }), this.buttonOptions.length && this.renderButtons(), i.parentNode && i.parentNode.insertBefore(this.div, i), C)) {
                  this.inputGroup = o.g("input-group").add(this.group);
                  var O = this.drawInput("min");
                  this.minDateBox = O.dateBox, this.minLabel = O.label, this.minInput = O.input;
                  var p = this.drawInput("max");
                  this.maxDateBox = p.dateBox, this.maxLabel = p.label, this.maxInput = p.input;
                }
                if (C) {
                  this.setInputValue("min", a), this.setInputValue("max", e);
                  var w = n.scroller && n.scroller.getUnionExtremes() || n.xAxis[0] || {};
                  if (k(w.dataMin) && k(w.dataMax)) {
                    var T = n.xAxis[0].minRange || 0;
                    this.setInputExtremes("min", w.dataMin, Math.min(w.dataMax, this.getInputValue("max")) - T), this.setInputExtremes("max", Math.max(w.dataMin, this.getInputValue("min")) + T, w.dataMax);
                  }
                  if (this.inputGroup) {
                    var z = 0;
                    [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach(function(W) {
                      if (W) {
                        var L = W.getBBox().width;
                        L && (W.attr({ x: z }), z += L + l.inputSpacing);
                      }
                    });
                  }
                }
                this.alignElements(), this.rendered = !0;
              }
            }, s.prototype.renderButtons = function() {
              var a = this, e = this, n = e.buttons, o = e.chart, i = e.options, c = q.lang, l = o.renderer, h = g(i.buttonTheme), C = h && h.states, M = h.width || 28;
              delete h.width, delete h.states, this.buttonGroup = l.g("range-selector-buttons").add(this.group);
              var O = this.dropdown = N("select", void 0, { position: "absolute", width: "1px", height: "1px", padding: 0, border: 0, top: "-9999em", cursor: "pointer", opacity: 1e-4 }, this.div);
              U(O, "touchstart", function() {
                O.style.fontSize = "16px";
              }), [[$.isMS ? "mouseover" : "mouseenter"], [$.isMS ? "mouseout" : "mouseleave"], ["change", "click"]].forEach(function(p) {
                var w = p[0], T = p[1];
                U(O, w, function() {
                  var z = n[a.currentButtonIndex()];
                  z && m(z.element, T || w);
                });
              }), this.zoomText = l.label(c && c.rangeSelectorZoom || "", 0).attr({ padding: i.buttonTheme.padding, height: i.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(i.labelStyle), h["stroke-width"] = P(h["stroke-width"], 0)), N("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, O), this.buttonOptions.forEach(function(p, w) {
                N("option", { textContent: p.title || p.text }, void 0, O), n[w] = l.button(p.text, 0, 0, function(T) {
                  var z, W = p.events && p.events.click;
                  W && (z = W.call(p, T)), z !== !1 && a.clickButton(w), a.isActive = !0;
                }, h, C && C.hover, C && C.select, C && C.disabled).attr({ "text-align": "center", width: M }).add(a.buttonGroup), p.title && n[w].attr("title", p.title);
              });
            }, s.prototype.alignElements = function() {
              var a = this, e = this, n = e.buttonGroup, o = e.buttons, i = e.chart, c = e.group, l = e.inputGroup, h = e.options, C = e.zoomText, M = i.options, O = M.exporting && M.exporting.enabled !== !1 && M.navigation && M.navigation.buttonOptions, p = h.buttonPosition, w = h.inputPosition, T = h.verticalAlign, z = function(kt, Lt) {
                return O && a.titleCollision(i) && T === "top" && Lt.align === "right" && Lt.y - kt.getBBox().height - 12 < (O.y || 0) + (O.height || 0) + i.spacing[0] ? -40 : 0;
              }, W = i.plotLeft;
              if (c && p && w) {
                var L = p.x - i.spacing[3];
                if (n) {
                  if (this.positionButtons(), !this.initialButtonGroupWidth) {
                    var I = 0;
                    C && (I += C.getBBox().width + 5), o.forEach(function(kt, Lt) {
                      I += kt.width, Lt !== o.length - 1 && (I += h.buttonSpacing);
                    }), this.initialButtonGroupWidth = I;
                  }
                  W -= i.spacing[3], this.updateButtonStates();
                  var j = z(n, p);
                  this.alignButtonGroup(j), c.placed = n.placed = i.hasLoaded;
                }
                var Z = 0;
                l && (Z = z(l, w), w.align === "left" ? L = W : w.align === "right" && (L = -Math.max(i.axisOffset[1], -Z)), l.align({ y: w.y, width: l.getBBox().width, align: w.align, x: w.x + L - 2 }, !0, i.spacingBox), l.placed = i.hasLoaded), this.handleCollision(Z), c.align({ verticalAlign: T }, !0, i.spacingBox);
                var V = c.alignAttr.translateY, X = c.getBBox().height + 20, et = 0;
                if (T === "bottom") {
                  var ot = i.legend && i.legend.options;
                  et = V - (X = X + (ot && ot.verticalAlign === "bottom" && ot.enabled && !ot.floating ? i.legend.legendHeight + P(ot.margin, 10) : 0) - 20) - (h.floating ? 0 : h.y) - (i.titleOffset ? i.titleOffset[2] : 0) - 10;
                }
                T === "top" ? (h.floating && (et = 0), i.titleOffset && i.titleOffset[0] && (et = i.titleOffset[0]), et += i.margin[0] - i.spacing[0] || 0) : T === "middle" && (w.y === p.y ? et = V : (w.y || p.y) && (w.y < 0 || p.y < 0 ? et -= Math.min(w.y, p.y) : et = V - X)), c.translate(h.x, h.y + Math.floor(et));
                var it = this, pt = it.minInput, mt = it.maxInput, Ct = it.dropdown;
                h.inputEnabled && pt && mt && (pt.style.marginTop = c.translateY + "px", mt.style.marginTop = c.translateY + "px"), Ct && (Ct.style.marginTop = c.translateY + "px");
              }
            }, s.prototype.alignButtonGroup = function(a, e) {
              var n = this, o = n.chart, i = n.options, c = n.buttonGroup, l = i.buttonPosition, h = o.plotLeft - o.spacing[3], C = l.x - o.spacing[3];
              l.align === "right" ? C += a - h : l.align === "center" && (C -= h / 2), c && c.align({ y: l.y, width: P(e, this.initialButtonGroupWidth), align: l.align, x: C }, !0, o.spacingBox);
            }, s.prototype.positionButtons = function() {
              var a = this, e = a.buttons, n = a.chart, o = a.options, i = a.zoomText, c = n.hasLoaded ? "animate" : "attr", l = o.buttonPosition, h = n.plotLeft, C = h;
              i && i.visibility !== "hidden" && (i[c]({ x: P(h + l.x, h) }), C += l.x + i.getBBox().width + 5);
              for (var M = 0, O = this.buttonOptions.length; M < O; ++M)
                e[M].visibility !== "hidden" ? (e[M][c]({ x: C }), C += e[M].width + o.buttonSpacing) : e[M][c]({ x: h });
            }, s.prototype.handleCollision = function(a) {
              var e = this, n = this, o = n.chart, i = n.buttonGroup, c = n.inputGroup, l = this.options, h = l.buttonPosition, C = l.dropdown, M = l.inputPosition, O = function() {
                var T = 0;
                return e.buttons.forEach(function(z) {
                  var W = z.getBBox();
                  W.width > T && (T = W.width);
                }), T;
              }, p = function(T) {
                if (c && i) {
                  var z = c.alignAttr.translateX + c.alignOptions.x - a + c.getBBox().x + 2, W = c.alignOptions.width, L = i.alignAttr.translateX + i.getBBox().x;
                  return L + T > z && z + W > L && h.y < M.y + c.getBBox().height;
                }
                return !1;
              }, w = function() {
                c && i && c.attr({ translateX: c.alignAttr.translateX + (o.axisOffset[1] >= -a ? 0 : -a), translateY: c.alignAttr.translateY + i.getBBox().height + 10 });
              };
              if (i) {
                if (C === "always")
                  return this.collapseButtons(a), void (p(O()) && w());
                C === "never" && this.expandButtons();
              }
              c && i ? M.align === h.align || p(this.initialButtonGroupWidth + 20) ? C === "responsive" ? (this.collapseButtons(a), p(O()) && w()) : w() : C === "responsive" && this.expandButtons() : i && C === "responsive" && (this.initialButtonGroupWidth > o.plotWidth ? this.collapseButtons(a) : this.expandButtons());
            }, s.prototype.collapseButtons = function(a) {
              var e = this, n = e.buttons, o = e.buttonOptions, i = e.chart, c = e.dropdown, l = e.options, h = e.zoomText, C = i.userOptions.rangeSelector && i.userOptions.rangeSelector.buttonTheme || {}, M = function(w) {
                return { text: w ? w + " ▾" : "▾", width: "auto", paddingLeft: P(l.buttonTheme.paddingLeft, C.padding, 8), paddingRight: P(l.buttonTheme.paddingRight, C.padding, 8) };
              };
              h && h.hide();
              var O = !1;
              o.forEach(function(w, T) {
                var z = n[T];
                z.state !== 2 ? z.hide() : (z.show(), z.attr(M(w.text)), O = !0);
              }), O || (c && (c.selectedIndex = 0), n[0].show(), n[0].attr(M(this.zoomText && this.zoomText.textStr)));
              var p = l.buttonPosition.align;
              this.positionButtons(), p !== "right" && p !== "center" || this.alignButtonGroup(a, n[this.currentButtonIndex()].getBBox().width), this.showDropdown();
            }, s.prototype.expandButtons = function() {
              var a = this, e = a.buttons, n = a.buttonOptions, o = a.options, i = a.zoomText;
              this.hideDropdown(), i && i.show(), n.forEach(function(c, l) {
                var h = e[l];
                h.show(), h.attr({ text: c.text, width: o.buttonTheme.width || 28, paddingLeft: P(o.buttonTheme.paddingLeft, "unset"), paddingRight: P(o.buttonTheme.paddingRight, "unset") }), h.state < 2 && h.setState(0);
              }), this.positionButtons();
            }, s.prototype.currentButtonIndex = function() {
              var a = this.dropdown;
              return a && a.selectedIndex > 0 ? a.selectedIndex - 1 : 0;
            }, s.prototype.showDropdown = function() {
              var a = this, e = a.buttonGroup, n = a.buttons, o = a.chart, i = a.dropdown;
              if (e && i) {
                var c = e.translateX, l = e.translateY, h = n[this.currentButtonIndex()].getBBox();
                D(i, { left: o.plotLeft + c + "px", top: l + 0.5 + "px", width: h.width + "px", height: h.height + "px" }), this.hasVisibleDropdown = !0;
              }
            }, s.prototype.hideDropdown = function() {
              var a = this.dropdown;
              a && (D(a, { top: "-9999em", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
            }, s.prototype.getHeight = function() {
              var a = this.options, e = this.group, n = a.inputPosition, o = a.buttonPosition, i = a.y, c = o.y, l = n.y, h = 0;
              if (a.height)
                return a.height;
              this.alignElements(), h = e ? e.getBBox(!0).height + 13 + i : 0;
              var C = Math.min(l, c);
              return (l < 0 && c < 0 || l > 0 && c > 0) && (h += Math.abs(C)), h;
            }, s.prototype.titleCollision = function(a) {
              return !(a.options.title.text || a.options.subtitle.text);
            }, s.prototype.update = function(a) {
              var e = this.chart;
              g(!0, e.options.rangeSelector, a), this.destroy(), this.init(e), this.render();
            }, s.prototype.destroy = function() {
              var a = this, e = a.minInput, n = a.maxInput;
              a.eventsToUnbind && (a.eventsToUnbind.forEach(function(o) {
                return o();
              }), a.eventsToUnbind = void 0), A(a.buttons), e && (e.onfocus = e.onblur = e.onchange = null), n && (n.onfocus = n.onblur = n.onchange = null), x(a, function(o, i) {
                o && i !== "chart" && (o instanceof J ? o.destroy() : o instanceof gt.HTMLElement && b(o)), o !== s.prototype[i] && (a[i] = null);
              }, this);
            }, s;
          }();
          return d(y.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), y;
        }), at(_, "Core/Axis/OrdinalAxis.js", [_["Core/Axis/Axis.js"], _["Core/Globals.js"], _["Core/Series/Series.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = Y.addEvent, q = Y.correctFloat, U = Y.css, N = Y.defined, D = Y.error, k = Y.pick, A = Y.timeUnits, b = [];
          return function(d) {
            function m(n, o, i, c, l, h, C) {
              l === void 0 && (l = []), h === void 0 && (h = 0);
              var M, O, p, w, T, z = {}, W = this.options.tickPixelInterval, L = this.chart.time, I = [], j = 0, Z = [], V = -Number.MAX_VALUE;
              if (!this.options.ordinal && !this.options.breaks || !l || l.length < 3 || o === void 0)
                return L.getTimeTicks.apply(L, arguments);
              var X = l.length;
              for (M = 0; M < X; M++) {
                if (T = M && l[M - 1] > i, l[M] < o && (j = M), M === X - 1 || l[M + 1] - l[M] > 5 * h || T) {
                  if (l[M] > V) {
                    for (O = L.getTimeTicks(n, l[j], l[M], c); O.length && O[0] <= V; )
                      O.shift();
                    O.length && (V = O[O.length - 1]), I.push(Z.length), Z = Z.concat(O);
                  }
                  j = M + 1;
                }
                if (T)
                  break;
              }
              if (O) {
                if (w = O.info, C && w.unitRange <= A.hour) {
                  for (M = Z.length - 1, j = 1; j < M; j++)
                    L.dateFormat("%d", Z[j]) !== L.dateFormat("%d", Z[j - 1]) && (z[Z[j]] = "day", p = !0);
                  p && (z[Z[0]] = "day"), w.higherRanks = z;
                }
                w.segmentStarts = I, Z.info = w;
              } else
                D(12, !1, this.chart);
              if (C && N(W)) {
                for (var et = Z.length, ot = [], it = [], pt = void 0, mt = void 0, Ct = void 0, kt = void 0, Lt = void 0, Tt = et; Tt--; )
                  mt = this.translate(Z[Tt]), Ct && (it[Tt] = Ct - mt), ot[Tt] = Ct = mt;
                for (it.sort(), (kt = it[Math.floor(it.length / 2)]) < 0.6 * W && (kt = null), Tt = Z[et - 1] > i ? et - 1 : et, Ct = void 0; Tt--; )
                  mt = ot[Tt], Lt = Math.abs(Ct - mt), Ct && Lt < 0.8 * W && (kt === null || Lt < 0.8 * kt) ? (z[Z[Tt]] && !z[Z[Tt + 1]] ? (pt = Tt + 1, Ct = mt) : pt = Tt, Z.splice(pt, 1)) : Ct = mt;
              }
              return Z;
            }
            function v(n) {
              var o = this.ordinal.positions;
              if (!o)
                return n;
              var i, c = o.length - 1;
              return n < 0 ? n = o[0] : n > c ? n = o[c] : i = n - (c = Math.floor(n)), i !== void 0 && o[c] !== void 0 ? o[c] + (i ? i * (o[c + 1] - o[c]) : 0) : n;
            }
            function g(n) {
              var o = this, i = o.ordinal, c = o.old ? o.old.min : o.min, l = o.old ? o.old.transA : o.transA, h = i.positions;
              if (!h)
                return n;
              var C = (n - c) * l + o.minPixelPadding;
              if (C > 0 && C < o.left + o.len || (i.extendedOrdinalPositions || (i.extendedOrdinalPositions = i.getExtendedPositions()), h = i.extendedOrdinalPositions), h && h.length) {
                var M = i.getIndexOfPoint(C, h), O = q(M % 1);
                if (M >= 0 && M < h.length - 1) {
                  var p = h[Math.floor(M)], w = h[Math.ceil(M)] - p;
                  return h[Math.floor(M)] + O * w;
                }
                var T = h.length, z = h[0], W = h[T - 1], L = (W - z) / (T - 1);
                return M < 0 ? z + L * M : W + L * (M - T);
              }
              return n;
            }
            function x(n, o) {
              var i = d.Additions.findIndexOf(n, o, !0);
              return n[i] === o ? i : i + (o - n[i]) / (n[i + 1] - n[i]);
            }
            function E() {
              var n = this;
              n.ordinal || (n.ordinal = new d.Additions(n));
            }
            function P() {
              var n = this;
              n.isXAxis && N(n.options.overscroll) && n.max === n.dataMax && (!n.chart.mouseIsDown || n.isInternal) && (!n.eventArgs || n.eventArgs && n.eventArgs.trigger !== "navigator") && (n.max += n.options.overscroll, !n.isInternal && N(n.userMin) && (n.min += n.options.overscroll));
            }
            function S() {
              var n = this;
              n.horiz && !n.isDirty && (n.isDirty = n.isOrdinal && n.chart.navigator && !n.chart.navigator.adaptToUpdatedData);
            }
            function u() {
              var n = this;
              n.ordinal && (n.ordinal.beforeSetTickPositions(), n.tickInterval = n.ordinal.postProcessTickInterval(n.tickInterval));
            }
            function y(n) {
              var o = this, i = o.xAxis[0], c = i.options.overscroll, l = n.originalEvent.chartX, h = o.options.chart.panning, C = !1;
              if (h && h.type !== "y" && i.options.ordinal && i.series.length) {
                var M = o.mouseDownX, O = i.getExtremes(), p = O.dataMax, w = O.min, T = O.max, z = o.hoverPoints, W = i.closestPointRange || i.ordinal && i.ordinal.overscrollPointsRange, L = (M - l) / (i.translationSlope * (i.ordinal.slope || W)), I = i.ordinal.getExtendedPositions(), j = { ordinal: { positions: I, extendedOrdinalPositions: I } }, Z = i.index2val, V = i.val2lin, X = void 0, et = void 0, ot = void 0, it = void 0;
                j.ordinal.positions ? Math.abs(L) > 1 && (z && z.forEach(function(pt) {
                  pt.setState();
                }), L < 0 ? (ot = j, it = i.ordinal.positions ? i : j) : (ot = i.ordinal.positions ? i : j, it = j), p > (et = it.ordinal.positions)[et.length - 1] && et.push(p), o.fixedRange = T - w, (X = i.navigatorAxis.toFixedRange(void 0, void 0, Z.apply(ot, [V.apply(ot, [w, !0]) + L]), Z.apply(it, [V.apply(it, [T, !0]) + L]))).min >= Math.min(O.dataMin, w) && X.max <= Math.max(p, T) + c && i.setExtremes(X.min, X.max, !0, !1, { trigger: "pan" }), o.mouseDownX = l, U(o.container, { cursor: "move" })) : C = !0;
              } else
                C = !0;
              C || h && /y/.test(h.type) ? c && (i.max = i.dataMax + c) : n.preventDefault();
            }
            function s() {
              var n = this.xAxis;
              n && n.options.ordinal && (delete n.ordinal.index, delete n.ordinal.extendedOrdinalPositions);
            }
            function a(n, o) {
              var i = this.ordinal, c = i.positions, l = i.slope, h = i.extendedOrdinalPositions;
              if (!c)
                return n;
              var C, M = c.length;
              if (c[0] <= n && c[M - 1] >= n)
                C = x(c, n);
              else {
                if (h || (h = i.getExtendedPositions && i.getExtendedPositions(), i.extendedOrdinalPositions = h), !h || !h.length)
                  return n;
                var O = h.length;
                l || (l = (h[O - 1] - h[0]) / O);
                var p = x(h, c[0]);
                C = n >= h[0] && n <= h[O - 1] ? x(h, n) - p : n < h[0] ? -p - (h[0] - n) / l : (n - h[O - 1]) / l + O - p;
              }
              return o ? C : l * (C || 0) + i.offset;
            }
            d.compose = function(n, o, i) {
              if (b.indexOf(n) === -1) {
                b.push(n);
                var c = n.prototype;
                c.getTimeTicks = m, c.index2val = v, c.lin2val = g, c.val2lin = a, c.ordinal2lin = c.val2lin, Q(n, "afterInit", E), Q(n, "foundExtremes", P), Q(n, "afterSetScale", S), Q(n, "initialAxisTranslation", u);
              }
              return b.indexOf(i) === -1 && (b.push(i), Q(i, "pan", y)), b.indexOf(o) === -1 && (b.push(o), Q(o, "updatedData", s)), n;
            };
            var e = function() {
              function n(o) {
                this.index = {}, this.axis = o;
              }
              return n.prototype.beforeSetTickPositions = function() {
                var o, i, c, l, h, C, M, O = this.axis, p = O.ordinal, w = O.getExtremes(), T = w.min, z = w.max, W = O.isXAxis && !!O.options.breaks, L = O.options.ordinal, I = O.chart.options.chart.ignoreHiddenSeries, j = [], Z = Number.MAX_VALUE, V = !1, X = !1, et = !1;
                if (L || W) {
                  var ot = 0;
                  if (O.series.forEach(function(it, pt) {
                    if (i = [], pt > 0 && it.options.id !== "highcharts-navigator-series" && it.processedXData.length > 1 && (X = ot !== it.processedXData[1] - it.processedXData[0]), ot = it.processedXData[1] - it.processedXData[0], it.boosted && (et = it.boosted), (!I || it.visible !== !1) && (it.takeOrdinalPosition !== !1 || W) && (j = j.concat(it.processedXData), o = j.length, j.sort(function(mt, Ct) {
                      return mt - Ct;
                    }), Z = Math.min(Z, k(it.closestPointRange, Z)), o)) {
                      for (pt = 0; pt < o - 1; )
                        j[pt] !== j[pt + 1] && i.push(j[pt + 1]), pt++;
                      i[0] !== j[0] && i.unshift(j[0]), j = i;
                    }
                  }), X && et && (j.pop(), j.shift()), (o = j.length) > 2) {
                    for (c = j[1] - j[0], M = o - 1; M-- && !V; )
                      j[M + 1] - j[M] !== c && (V = !0);
                    !O.options.keepOrdinalPadding && (j[0] - T > c || z - j[j.length - 1] > c) && (V = !0);
                  } else
                    O.options.overscroll && (o === 2 ? Z = j[1] - j[0] : o === 1 ? (Z = O.options.overscroll, j = [j[0], j[0] + Z]) : Z = p.overscrollPointsRange);
                  V || O.forceOrdinal ? (O.options.overscroll && (p.overscrollPointsRange = Z, j = j.concat(p.getOverscrollPositions())), p.positions = j, l = O.ordinal2lin(Math.max(T, j[0]), !0), h = Math.max(O.ordinal2lin(Math.min(z, j[j.length - 1]), !0), 1), p.slope = C = (z - T) / (h - l), p.offset = T - l * C) : (p.overscrollPointsRange = k(O.closestPointRange, p.overscrollPointsRange), p.positions = O.ordinal.slope = p.offset = void 0);
                }
                O.isOrdinal = L && V, p.groupIntervalFactor = null;
              }, n.findIndexOf = function(o, i, c) {
                for (var l, h = 0, C = o.length - 1; h < C; )
                  o[l = Math.ceil((h + C) / 2)] <= i ? h = l : C = l - 1;
                return o[h] === i || c ? h : -1;
              }, n.prototype.getExtendedPositions = function() {
                var o, i = this, c = i.axis, l = c.constructor.prototype, h = c.chart, C = c.series[0].currentDataGrouping, M = C ? C.count + C.unitName : "raw", O = c.options.overscroll, p = c.getExtremes(), w = void 0, T = i.index;
                return T || (T = i.index = {}), T[M] || ((o = { series: [], chart: h, forceOrdinal: !1, getExtremes: function() {
                  return { min: p.dataMin, max: p.dataMax + O };
                }, getGroupPixelWidth: l.getGroupPixelWidth, getTimeTicks: l.getTimeTicks, options: { ordinal: !0 }, ordinal: { getGroupIntervalFactor: this.getGroupIntervalFactor }, ordinal2lin: l.ordinal2lin, getIndexOfPoint: l.getIndexOfPoint, val2lin: l.val2lin }).ordinal.axis = o, c.series.forEach(function(z) {
                  (w = { xAxis: o, xData: z.xData.slice(), chart: h, destroyGroupedData: F.noop, getProcessedData: $.prototype.getProcessedData, applyGrouping: $.prototype.applyGrouping }).xData = w.xData.concat(i.getOverscrollPositions()), w.options = { dataGrouping: C ? { firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", enabled: !0, forced: !0, approximation: "open", units: [[C.unitName, [C.count]]] } : { enabled: !1 } }, o.series.push(w), z.processData.apply(w);
                }), w.closestPointRange !== w.basePointRange && w.currentDataGrouping && (o.forceOrdinal = !0), c.ordinal.beforeSetTickPositions.apply({ axis: o }), T[M] = o.ordinal.positions), T[M];
              }, n.prototype.getGroupIntervalFactor = function(o, i, c) {
                var l, h, C = this, M = c.processedXData, O = M.length, p = [], w = C.groupIntervalFactor;
                if (!w) {
                  for (h = 0; h < O - 1; h++)
                    p[h] = M[h + 1] - M[h];
                  p.sort(function(T, z) {
                    return T - z;
                  }), l = p[Math.floor(O / 2)], o = Math.max(o, M[0]), i = Math.min(i, M[O - 1]), C.groupIntervalFactor = w = O * l / (i - o);
                }
                return w;
              }, n.prototype.getIndexOfPoint = function(o, i) {
                var c = this, l = c.axis, h = c.positions ? c.positions[0] : 0, C = l.series[0].points && l.series[0].points[0] && l.series[0].points[0].plotX || l.minPixelPadding;
                l.series.length > 1 && l.series.forEach(function(p) {
                  p.points && N(p.points[0]) && N(p.points[0].plotX) && p.points[0].plotX < C && p.points[0].plotX >= k(l.min, -1 / 0) && (C = p.points[0].plotX);
                });
                var M = l.translationSlope * (c.slope || l.closestPointRange || c.overscrollPointsRange), O = (o - C) / M;
                return n.findIndexOf(i, h) + O;
              }, n.prototype.getOverscrollPositions = function() {
                var o = this.axis, i = o.options.overscroll, c = this.overscrollPointsRange, l = [], h = o.dataMax;
                if (N(c))
                  for (; h <= o.dataMax + i; )
                    h += c, l.push(h);
                return l;
              }, n.prototype.postProcessTickInterval = function(o) {
                var i = this.axis, c = this.slope;
                return c ? i.options.breaks ? i.closestPointRange || o : o / (c / i.closestPointRange) : o;
              }, n;
            }();
            d.Additions = e;
          }(J || (J = {})), J;
        }), at(_, "Series/HLC/HLCPoint.js", [_["Core/Series/SeriesRegistry.js"]], function(G) {
          var F, $ = this && this.__extends || (F = function(J, Q) {
            return F = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(q, U) {
              q.__proto__ = U;
            } || function(q, U) {
              for (var N in U)
                U.hasOwnProperty(N) && (q[N] = U[N]);
            }, F(J, Q);
          }, function(J, Q) {
            function q() {
              this.constructor = J;
            }
            F(J, Q), J.prototype = Q === null ? Object.create(Q) : (q.prototype = Q.prototype, new q());
          }), Y = function(J) {
            function Q() {
              var q = J !== null && J.apply(this, arguments) || this;
              return q.close = void 0, q.high = void 0, q.low = void 0, q.options = void 0, q.plotClose = void 0, q.series = void 0, q;
            }
            return $(Q, J), Q;
          }(G.seriesTypes.column.prototype.pointClass);
          return Y;
        }), at(_, "Series/HLC/HLCSeriesDefaults.js", [], function() {
          return { lineWidth: 1, tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' }, threshold: null, states: { hover: { lineWidth: 3 } }, stickyTracking: !0 };
        }), at(_, "Series/HLC/HLCSeries.js", [_["Series/HLC/HLCPoint.js"], _["Series/HLC/HLCSeriesDefaults.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(k, A) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
              b.__proto__ = d;
            } || function(b, d) {
              for (var m in d)
                d.hasOwnProperty(m) && (b[m] = d[m]);
            }, J(k, A);
          }, function(k, A) {
            function b() {
              this.constructor = k;
            }
            J(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
          }), q = $.seriesTypes.column, U = Y.extend, N = Y.merge, D = function(k) {
            function A() {
              var b = k !== null && k.apply(this, arguments) || this;
              return b.data = void 0, b.options = void 0, b.points = void 0, b.yData = void 0, b;
            }
            return Q(A, k), A.prototype.extendStem = function(b, d, m) {
              var v = b[0], g = b[1];
              typeof v[2] == "number" && (v[2] = Math.max(m + d, v[2])), typeof g[2] == "number" && (g[2] = Math.min(m - d, g[2]));
            }, A.prototype.getPointPath = function(b, d) {
              var m = d.strokeWidth(), v = b.series, g = m % 2 / 2, x = Math.round(b.plotX) - g, E = Math.round(b.shapeArgs.width / 2), P = b.plotClose, S = [["M", x, Math.round(b.yBottom)], ["L", x, Math.round(b.plotHigh)]];
              return b.close !== null && (P = Math.round(b.plotClose) + g, S.push(["M", x, P], ["L", x + E, P]), v.extendStem(S, m / 2, P)), S;
            }, A.prototype.drawSinglePoint = function(b) {
              var d, m = b.series, v = m.chart, g = b.graphic;
              b.plotY !== void 0 && (g || (b.graphic = g = v.renderer.path().add(m.group)), v.styledMode || g.attr(m.pointAttribs(b, b.selected && "select")), d = m.getPointPath(b, g), g[g ? "animate" : "attr"]({ d }).addClass(b.getClassName(), !0));
            }, A.prototype.drawPoints = function() {
              this.points.forEach(this.drawSinglePoint);
            }, A.prototype.init = function() {
              k.prototype.init.apply(this, arguments), this.options.stacking = void 0;
            }, A.prototype.pointAttribs = function(b, d) {
              var m = k.prototype.pointAttribs.call(this, b, d);
              return delete m.fill, m;
            }, A.prototype.toYData = function(b) {
              return [b.high, b.low, b.close];
            }, A.prototype.translate = function() {
              var b = this, d = b.yAxis, m = this.pointArrayMap && this.pointArrayMap.slice() || [], v = m.map(function(g) {
                return "plot".concat(g.charAt(0).toUpperCase() + g.slice(1));
              });
              v.push("yBottom"), m.push("low"), k.prototype.translate.apply(b), b.points.forEach(function(g) {
                m.forEach(function(x, E) {
                  var P = g[x];
                  P !== null && (b.dataModify && (P = b.dataModify.modifyValue(P)), g[v[E]] = d.toPixels(P, !0));
                }), g.tooltipPos[1] = g.plotHigh + d.pos - b.chart.plotTop;
              });
            }, A.defaultOptions = N(q.defaultOptions, F), A;
          }(q);
          return U(D.prototype, { pointClass: G, animate: null, directTouch: !1, pointArrayMap: ["high", "low", "close"], pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" }, pointValKey: "close" }), $.registerSeriesType("hlc", D), D;
        }), at(_, "Series/OHLC/OHLCPoint.js", [_["Core/Series/SeriesRegistry.js"]], function(G) {
          var F, $ = this && this.__extends || (F = function(J, Q) {
            return F = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(q, U) {
              q.__proto__ = U;
            } || function(q, U) {
              for (var N in U)
                U.hasOwnProperty(N) && (q[N] = U[N]);
            }, F(J, Q);
          }, function(J, Q) {
            function q() {
              this.constructor = J;
            }
            F(J, Q), J.prototype = Q === null ? Object.create(Q) : (q.prototype = Q.prototype, new q());
          }), Y = function(J) {
            function Q() {
              var q = J !== null && J.apply(this, arguments) || this;
              return q.open = void 0, q.options = void 0, q.plotOpen = void 0, q.series = void 0, q;
            }
            return $(Q, J), Q.prototype.getClassName = function() {
              return J.prototype.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
            }, Q.prototype.resolveUpColor = function() {
              this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
            }, Q.prototype.resolveColor = function() {
              J.prototype.resolveColor.call(this), this.resolveUpColor();
            }, Q.prototype.getZone = function() {
              var q = J.prototype.getZone.call(this);
              return this.resolveUpColor(), q;
            }, Q.prototype.applyOptions = function() {
              return J.prototype.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
            }, Q;
          }(G.seriesTypes.hlc.prototype.pointClass);
          return Y;
        }), at(_, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
          return { tooltip: { pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>' } };
        }), at(_, "Series/OHLC/OHLCSeries.js", [_["Series/OHLC/OHLCPoint.js"], _["Series/OHLC/OHLCSeriesDefaults.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(m, v) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, x) {
              g.__proto__ = x;
            } || function(g, x) {
              for (var E in x)
                x.hasOwnProperty(E) && (g[E] = x[E]);
            }, J(m, v);
          }, function(m, v) {
            function g() {
              this.constructor = m;
            }
            J(m, v), m.prototype = v === null ? Object.create(v) : (g.prototype = v.prototype, new g());
          }), q = $.seriesTypes.hlc, U = Y.addEvent, N = Y.extend, D = Y.merge, k = [];
          function A(m) {
            var v = m.options, g = v.dataGrouping;
            g && v.useOhlcData && v.id !== "highcharts-navigator-series" && (g.approximation = "ohlc");
          }
          function b(m) {
            var v = m.options;
            v.useOhlcData && v.id !== "highcharts-navigator-series" && N(this, { pointValKey: d.prototype.pointValKey, pointArrayMap: d.prototype.pointArrayMap, toYData: d.prototype.toYData });
          }
          var d = function(m) {
            function v() {
              var g = m !== null && m.apply(this, arguments) || this;
              return g.data = void 0, g.options = void 0, g.points = void 0, g;
            }
            return Q(v, m), v.compose = function(g) {
              for (var x = [], E = 1; E < arguments.length; E++)
                x[E - 1] = arguments[E];
              k.indexOf(g) === -1 && (k.push(g), U(g, "afterSetOptions", A), U(g, "init", b));
            }, v.prototype.getPointPath = function(g, x) {
              var E = m.prototype.getPointPath.call(this, g, x), P = x.strokeWidth(), S = P % 2 / 2, u = Math.round(g.plotX) - S, y = Math.round(g.shapeArgs.width / 2), s = g.plotOpen;
              return g.open !== null && (s = Math.round(g.plotOpen) + S, E.push(["M", u, s], ["L", u - y, s]), m.prototype.extendStem.call(this, E, P / 2, s)), E;
            }, v.prototype.pointAttribs = function(g, x) {
              var E = m.prototype.pointAttribs.call(this, g, x), P = this.options;
              return delete E.fill, !g.options.color && P.upColor && g.open < g.close && (E.stroke = P.upColor), E;
            }, v.prototype.toYData = function(g) {
              return [g.open, g.high, g.low, g.close];
            }, v.defaultOptions = D(q.defaultOptions, F), v;
          }(q);
          return N(d.prototype, { pointClass: G, pointArrayMap: ["open", "high", "low", "close"] }), $.registerSeriesType("ohlc", d), d;
        }), at(_, "Series/Candlestick/CandlestickSeriesDefaults.js", [_["Core/Defaults.js"], _["Core/Utilities.js"]], function(G, F) {
          return { states: { hover: { lineWidth: 2 } }, threshold: null, lineColor: "#000000", lineWidth: 1, upColor: "#ffffff", stickyTracking: !0 };
        }), at(_, "Series/Candlestick/CandlestickSeries.js", [_["Series/Candlestick/CandlestickSeriesDefaults.js"], _["Core/Defaults.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(b, d) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, J(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            J(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), q = F.defaultOptions, U = $.seriesTypes, N = U.column, D = U.ohlc, k = Y.merge, A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.data = void 0, m.options = void 0, m.points = void 0, m;
            }
            return Q(d, b), d.prototype.pointAttribs = function(m, v) {
              var g = N.prototype.pointAttribs.call(this, m, v), x = this.options, E = m.open < m.close, P = x.lineColor || this.color, S = m.color || this.color;
              if (g["stroke-width"] = x.lineWidth, g.fill = m.options.color || E && x.upColor || S, g.stroke = m.options.lineColor || E && x.upLineColor || P, v) {
                var u = x.states[v];
                g.fill = u.color || g.fill, g.stroke = u.lineColor || g.stroke, g["stroke-width"] = u.lineWidth || g["stroke-width"];
              }
              return g;
            }, d.prototype.drawPoints = function() {
              for (var m = this, v = m.points, g = m.chart, x = m.yAxis.reversed, E = 0, P = v; E < P.length; E++) {
                var S = P[E], u = S.graphic, y = void 0, s = void 0, a = void 0, e = void 0, n = void 0, o = void 0, i = void 0, c = void 0, l = void 0, h = void 0, C = !u;
                S.plotY !== void 0 && (u || (S.graphic = u = g.renderer.path().add(m.group)), m.chart.styledMode || u.attr(m.pointAttribs(S, S.selected && "select")).shadow(m.options.shadow), i = u.strokeWidth() % 2 / 2, c = Math.round(S.plotX) - i, y = S.plotOpen, s = S.plotClose, a = Math.min(y, s), e = Math.max(y, s), h = Math.round(S.shapeArgs.width / 2), n = x ? e !== S.yBottom : Math.round(a) !== Math.round(S.plotHigh), o = x ? Math.round(a) !== Math.round(S.plotHigh) : e !== S.yBottom, a = Math.round(a) + i, e = Math.round(e) + i, (l = []).push(["M", c - h, e], ["L", c - h, a], ["L", c + h, a], ["L", c + h, e], ["Z"], ["M", c, a], ["L", c, n ? Math.round(x ? S.yBottom : S.plotHigh) : a], ["M", c, e], ["L", c, o ? Math.round(x ? S.plotHigh : S.yBottom) : e]), u[C ? "attr" : "animate"]({ d: l }).addClass(S.getClassName(), !0));
              }
            }, d.defaultOptions = k(D.defaultOptions, q.plotOptions, { tooltip: D.defaultOptions.tooltip }, G), d;
          }(D);
          return $.registerSeriesType("candlestick", A), A;
        }), at(_, "Series/Flags/FlagsPoint.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(U, N) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, k) {
              D.__proto__ = k;
            } || function(D, k) {
              for (var A in k)
                k.hasOwnProperty(A) && (D[A] = k[A]);
            }, $(U, N);
          }, function(U, N) {
            function D() {
              this.constructor = U;
            }
            $(U, N), U.prototype = N === null ? Object.create(N) : (D.prototype = N.prototype, new D());
          }), J = G.seriesTypes.column.prototype.pointClass, Q = F.isNumber, q = function(U) {
            function N() {
              var D = U !== null && U.apply(this, arguments) || this;
              return D.options = void 0, D.series = void 0, D.ttBelow = !1, D;
            }
            return Y(N, U), N.prototype.isValid = function() {
              return Q(this.y) || this.y === void 0;
            }, N.prototype.hasNewShapeType = function() {
              var D = this.options.shape || this.series.options.shape;
              return this.graphic && D && D !== this.graphic.symbolKey;
            }, N;
          }(J);
          return q;
        }), at(_, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
          return { pointRange: 0, allowOverlapX: !1, shape: "flag", stackDistance: 12, textAlign: "center", tooltip: { pointFormat: "{point.text}" }, threshold: null, y: -30, fillColor: "#ffffff", lineWidth: 1, states: { hover: { lineColor: "#000000", fillColor: "#ccd6eb" } }, style: { fontSize: "11px", fontWeight: "bold" } };
        }), at(_, "Series/Flags/FlagsSymbols.js", [_["Core/Renderer/RendererRegistry.js"]], function(G) {
          var F;
          return function($) {
            var Y = [];
            function J(q, U, N, D, k) {
              var A = k && k.anchorX || q, b = k && k.anchorY || U, d = this.circle(A - 1, b - 1, 2, 2);
              return d.push(["M", A, b], ["L", q, U + D], ["L", q, U], ["L", q + N, U], ["L", q + N, U + D], ["L", q, U + D], ["Z"]), d;
            }
            function Q(q, U) {
              q[U + "pin"] = function(N, D, k, A, b) {
                var d, m = b && b.anchorX, v = b && b.anchorY;
                if (U === "circle" && A > k && (N -= Math.round((A - k) / 2), k = A), d = q[U](N, D, k, A), m && v) {
                  var g = m;
                  if (U === "circle")
                    g = N + k / 2;
                  else {
                    var x = d[0], E = d[1];
                    x[0] === "M" && E[0] === "L" && (g = (x[1] + E[1]) / 2);
                  }
                  var P = D > v ? D : D + A;
                  d.push(["M", g, P], ["L", m, v]), d = d.concat(q.circle(m - 1, v - 1, 2, 2));
                }
                return d;
              };
            }
            $.compose = function(q) {
              Y.indexOf(q) === -1 && (Y.push(q), (N = q.prototype.symbols).flag = J, Q(N, "circle"), Q(N, "square"));
              var U = G.getRendererType();
              if (Y.indexOf(U)) {
                Y.push(U);
                var N = q.prototype.symbols, D = U.prototype.symbols;
                D.circlepin = N.circlepin, D.flag = N.flag.bind(N), D.squarepin = N.squarepin;
              }
            };
          }(F || (F = {})), F;
        }), at(_, "Series/OnSeriesComposition.js", [_["Series/Column/ColumnSeries.js"], _["Core/Series/Series.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = G.prototype, Q = F.prototype, q = $.defined, U = $.stableSort;
          return function(N) {
            var D = [];
            function k(b) {
              return Q.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, b);
            }
            function A() {
              J.translate.apply(this);
              var b, d, m, v, g, x, E, P = this, S = P.options, u = P.chart, y = P.points, s = S.onSeries, a = s && u.get(s), e = a && a.options.step, n = a && a.points, o = u.inverted, i = P.xAxis, c = P.yAxis, l = y.length - 1, h = S.onKey || "y", C = n && n.length, M = 0;
              if (a && a.visible && C)
                for (M = (a.pointXOffset || 0) + (a.barW || 0) / 2, x = a.currentDataGrouping, v = n[C - 1].x + (x ? x.totalRange : 0), U(y, function(O, p) {
                  return O.x - p.x;
                }), h = "plot" + h[0].toUpperCase() + h.substr(1); C-- && y[l] && (m = n[C], (b = y[l]).y = m.y, !(m.x <= b.x && m[h] !== void 0 && (b.x <= v && (b.plotY = m[h], m.x < b.x && !e && (g = n[C + 1]) && g[h] !== void 0 && (E = (b.x - m.x) / (g.x - m.x), b.plotY += E * (g[h] - m[h]), b.y += E * (g.y - m.y))), C++, --l < 0))); )
                  ;
              y.forEach(function(O, p) {
                var w;
                O.plotX += M, (O.plotY === void 0 || o) && (O.plotX >= 0 && O.plotX <= i.len ? o ? (O.plotY = i.translate(O.x, 0, 1, 0, 1), O.plotX = q(O.y) ? c.translate(O.y, 0, 0, 0, 1) : 0) : O.plotY = (i.opposite ? 0 : P.yAxis.len) + i.offset : O.shapeArgs = {}), (d = y[p - 1]) && d.plotX === O.plotX && (d.stackIndex === void 0 && (d.stackIndex = 0), w = d.stackIndex + 1), O.stackIndex = w;
              }), this.onSeries = a;
            }
            N.compose = function(b) {
              if (D.indexOf(b) === -1) {
                D.push(b);
                var d = b.prototype;
                d.getPlotBox = k, d.translate = A;
              }
              return b;
            }, N.getPlotBox = k, N.translate = A;
          }(Y || (Y = {})), Y;
        }), at(_, "Series/Flags/FlagsSeries.js", [_["Series/Flags/FlagsPoint.js"], _["Series/Flags/FlagsSeriesDefaults.js"], _["Series/Flags/FlagsSymbols.js"], _["Core/Globals.js"], _["Series/OnSeriesComposition.js"], _["Core/Renderer/RendererUtilities.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N) {
          var D, k = this && this.__extends || (D = function(y, s) {
            return D = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, e) {
              a.__proto__ = e;
            } || function(a, e) {
              for (var n in e)
                e.hasOwnProperty(n) && (a[n] = e[n]);
            }, D(y, s);
          }, function(y, s) {
            function a() {
              this.constructor = y;
            }
            D(y, s), y.prototype = s === null ? Object.create(s) : (a.prototype = s.prototype, new a());
          }), A = Y.noop, b = Q.distribute, d = q.series, m = q.seriesTypes.column, v = N.addEvent, g = N.defined, x = N.extend, E = N.merge, P = N.objectEach, S = N.wrap, u = function(y) {
            function s() {
              var a = y !== null && y.apply(this, arguments) || this;
              return a.data = void 0, a.options = void 0, a.points = void 0, a;
            }
            return k(s, y), s.prototype.animate = function(a) {
              a && this.setClip();
            }, s.prototype.drawPoints = function() {
              var a, e, n, o, i, c, l, h, C, M, O, p = this, w = p.points, T = p.chart, z = T.renderer, W = T.inverted, L = p.options, I = L.y, j = p.yAxis, Z = {}, V = [];
              for (o = w.length; o--; )
                i = w[o], M = (W ? i.plotY : i.plotX) > p.xAxis.len, a = i.plotX, l = i.stackIndex, n = i.options.shape || L.shape, (e = i.plotY) !== void 0 && (e = i.plotY + I - (l !== void 0 && l * L.stackDistance)), i.anchorX = l ? void 0 : i.plotX, h = l ? void 0 : i.plotY, O = n !== "flag", c = i.graphic, e !== void 0 && a >= 0 && !M ? (c && i.hasNewShapeType() && (c = c.destroy()), c || (c = i.graphic = z.label("", null, null, n, null, null, L.useHTML).addClass("highcharts-point").add(p.markerGroup), i.graphic.div && (i.graphic.div.point = i), c.isNew = !0), c.attr({ align: O ? "center" : "left", width: L.width, height: L.height, "text-align": L.textAlign }), T.styledMode || c.attr(p.pointAttribs(i)).css(E(L.style, i.style)).shadow(L.shadow), a > 0 && (a -= c.strokeWidth() % 2), C = { y: e, anchorY: h }, L.allowOverlapX && (C.x = a, C.anchorX = i.anchorX), c.attr({ text: i.options.title || L.title || "A" })[c.isNew ? "attr" : "animate"](C), L.allowOverlapX || (Z[i.plotX] ? Z[i.plotX].size = Math.max(Z[i.plotX].size, c.width) : Z[i.plotX] = { align: O ? 0.5 : 0, size: c.width, target: a, anchorX: a }), i.tooltipPos = [a, e + j.pos - T.plotTop]) : c && (i.graphic = c.destroy());
              if (!L.allowOverlapX) {
                var X = 100;
                P(Z, function(kt) {
                  kt.plotX = kt.anchorX, V.push(kt), X = Math.max(kt.size, X);
                }), b(V, W ? j.len : this.xAxis.len, X);
                for (var et = 0, ot = w; et < ot.length; et++) {
                  var it = ot[et], pt = it.plotX, mt = it.graphic, Ct = mt && Z[pt];
                  Ct && mt && (g(Ct.pos) ? mt[mt.isNew ? "attr" : "animate"]({ x: Ct.pos + (Ct.align || 0) * Ct.size, anchorX: it.anchorX }).show().isNew = !1 : mt.hide().isNew = !0);
                }
              }
              L.useHTML && p.markerGroup && S(p.markerGroup, "on", function(kt) {
                return U.prototype.on.apply(kt.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
              });
            }, s.prototype.drawTracker = function() {
              var a = this.points;
              y.prototype.drawTracker.call(this);
              for (var e = function(i) {
                var c = i.graphic;
                c && (i.unbindMouseOver && i.unbindMouseOver(), i.unbindMouseOver = v(c.element, "mouseover", function() {
                  i.stackIndex > 0 && !i.raised && (i._y = c.y, c.attr({ y: i._y - 8 }), i.raised = !0);
                  for (var l = 0, h = a; l < h.length; l++) {
                    var C = h[l];
                    C !== i && C.raised && C.graphic && (C.graphic.attr({ y: C._y }), C.raised = !1);
                  }
                }));
              }, n = 0, o = a; n < o.length; n++)
                e(o[n]);
            }, s.prototype.pointAttribs = function(a, e) {
              var n = this.options, o = a && a.color || this.color, i = n.lineColor, c = a && a.lineWidth, l = a && a.fillColor || n.fillColor;
              return e && (l = n.states[e].fillColor, i = n.states[e].lineColor, c = n.states[e].lineWidth), { fill: l || o, stroke: i || o, "stroke-width": c || n.lineWidth || 0 };
            }, s.prototype.setClip = function() {
              d.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
            }, s.compose = $.compose, s.defaultOptions = E(m.defaultOptions, F), s;
          }(m);
          return J.compose(u), x(u.prototype, { allowDG: !1, forceCrop: !0, invertible: !1, noSharedTooltip: !0, pointClass: G, sorted: !1, takeOrdinalPosition: !1, trackerGroups: ["markerGroup"], buildKDTree: A, init: d.prototype.init }), q.registerSeriesType("flags", u), u;
        }), at(_, "Core/Chart/StockChart.js", [_["Core/Axis/Axis.js"], _["Core/Chart/Chart.js"], _["Core/FormatUtilities.js"], _["Core/Defaults.js"], _["Stock/Navigator/NavigatorDefaults.js"], _["Stock/RangeSelector/RangeSelectorDefaults.js"], _["Stock/Scrollbar/ScrollbarDefaults.js"], _["Core/Series/Series.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N, D) {
          var k, A = this && this.__extends || (k = function(o, i) {
            return k = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, l) {
              c.__proto__ = l;
            } || function(c, l) {
              for (var h in l)
                l.hasOwnProperty(h) && (c[h] = l[h]);
            }, k(o, i);
          }, function(o, i) {
            function c() {
              this.constructor = o;
            }
            k(o, i), o.prototype = i === null ? Object.create(i) : (c.prototype = i.prototype, new c());
          }), b = $.format, d = Y.getOptions, m = D.addEvent, v = D.clamp, g = D.defined, x = D.extend, E = D.find, P = D.isNumber, S = D.isString, u = D.merge, y = D.pick, s = D.splat, a = function(o) {
            function i() {
              return o !== null && o.apply(this, arguments) || this;
            }
            return A(i, o), i.prototype.init = function(c, l) {
              var h = d(), C = c.xAxis, M = c.yAxis, O = y(c.navigator && c.navigator.enabled, J.enabled, !0);
              c.xAxis = c.yAxis = void 0;
              var p = u({ chart: { panning: { enabled: !0, type: "x" }, zooming: { pinchType: "x" } }, navigator: { enabled: O }, scrollbar: { enabled: y(q.enabled, !0) }, rangeSelector: { enabled: y(Q.rangeSelector.enabled, !0) }, title: { text: null }, tooltip: { split: y(h.tooltip.split, !0), crosshairs: !0 }, legend: { enabled: !1 } }, c, { isStock: !0 });
              c.xAxis = C, c.yAxis = M, p.xAxis = s(c.xAxis || {}).map(function(w, T) {
                return u(e("xAxis", w), h.xAxis, h.xAxis && h.xAxis[T], w, n("xAxis", c));
              }), p.yAxis = s(c.yAxis || {}).map(function(w, T) {
                return u(e("yAxis", w), h.yAxis, h.yAxis && h.yAxis[T], w);
              }), o.prototype.init.call(this, p, l);
            }, i.prototype.createAxis = function(c, l) {
              return l.axis = u(e(c, l.axis), l.axis, n(c, this.userOptions)), o.prototype.createAxis.call(this, c, l);
            }, i;
          }(F);
          function e(o, i) {
            return o === "xAxis" ? { minPadding: 0, maxPadding: 0, overscroll: 0, ordinal: !0, title: { text: null }, labels: { overflow: "justify" }, showLastLabel: !0 } : o === "yAxis" ? { labels: { y: -2 }, opposite: y(i.opposite, !0), showLastLabel: !(!i.categories && i.type !== "category"), title: { text: null } } : {};
          }
          function n(o, i) {
            if (o === "xAxis") {
              var c = { type: "datetime", categories: void 0 };
              return y(i.navigator && i.navigator.enabled, J.enabled, !0) && (c.startOnTick = !1, c.endOnTick = !1), c;
            }
            return {};
          }
          return function(o) {
            o.stockChart = function(i, c, l) {
              return new o(i, c, l);
            };
          }(a || (a = {})), m(U, "setOptions", function(o) {
            var i;
            this.chart.options.isStock && (this.is("column") || this.is("columnrange") ? i = { borderWidth: 0, shadow: !1 } : this.is("scatter") || this.is("sma") || (i = { marker: { enabled: !1, radius: 2 } }), i && (o.plotOptions[this.type] = u(o.plotOptions[this.type], i)));
          }), m(G, "autoLabelAlign", function(o) {
            var i, c = this.chart, l = this.options, h = c._labelPanes = c._labelPanes || {}, C = this.options.labels;
            this.chart.options.isStock && this.coll === "yAxis" && !h[i = l.top + "," + l.height] && C.enabled && (C.x === 15 && (C.x = 0), C.align === void 0 && (C.align = "right"), h[i] = this, o.align = "right", o.preventDefault());
          }), m(G, "destroy", function() {
            var o = this.chart, i = this.options && this.options.top + "," + this.options.height;
            i && o._labelPanes && o._labelPanes[i] === this && delete o._labelPanes[i];
          }), m(G, "getPlotLinePath", function(o) {
            var i, c, l, h, C, M, O, p, w, T = this, z = this.isLinked && !this.series ? this.linkedParent.series : this.series, W = T.chart, L = W.renderer, I = T.left, j = T.top, Z = [], V = [], X = o.translatedValue, et = o.value, ot = o.force;
            (W.options.isStock && o.acrossPanes !== !1 && T.coll === "xAxis" || T.coll === "yAxis") && (o.preventDefault(), O = T.coll, p = O === "xAxis" ? "yAxis" : "xAxis", w = T.options[p], V = P(w) ? [W[p][w]] : S(w) ? [W.get(w)] : z.map(function(it) {
              return it[p];
            }), (T.isXAxis ? W.yAxis : W.xAxis).forEach(function(it) {
              if (!g(it.options.id) || it.options.id.indexOf("navigator") === -1) {
                var pt = it.isXAxis ? "yAxis" : "xAxis", mt = g(it.options[pt]) ? W[pt][it.options[pt]] : W[pt][0];
                T === mt && V.push(it);
              }
            }), C = V.length ? [] : [T.isXAxis ? W.yAxis[0] : W.xAxis[0]], V.forEach(function(it) {
              C.indexOf(it) !== -1 || E(C, function(pt) {
                return pt.pos === it.pos && pt.len === it.len;
              }) || C.push(it);
            }), M = y(X, T.translate(et, void 0, void 0, o.old)), P(M) && (T.horiz ? C.forEach(function(it) {
              var pt;
              c = it.pos, h = c + it.len, i = l = Math.round(M + T.transB), ot !== "pass" && (i < I || i > I + T.width) && (ot ? i = l = v(i, I, I + T.width) : pt = !0), pt || Z.push(["M", i, c], ["L", l, h]);
            }) : C.forEach(function(it) {
              var pt;
              i = it.pos, l = i + it.len, c = h = Math.round(j + T.height - M), ot !== "pass" && (c < j || c > j + T.height) && (ot ? c = h = v(c, j, j + T.height) : pt = !0), pt || Z.push(["M", i, c], ["L", l, h]);
            })), o.path = Z.length > 0 ? L.crispPolyLine(Z, o.lineWidth || 1) : null);
          }), N.prototype.crispPolyLine = function(o, i) {
            for (var c = 0; c < o.length; c += 2) {
              var l = o[c], h = o[c + 1];
              l[1] === h[1] && (l[1] = h[1] = Math.round(l[1]) - i % 2 / 2), l[2] === h[2] && (l[2] = h[2] = Math.round(l[2]) + i % 2 / 2);
            }
            return o;
          }, m(G, "afterHideCrosshair", function() {
            this.crossLabel && (this.crossLabel = this.crossLabel.hide());
          }), m(G, "afterDrawCrosshair", function(o) {
            if (this.crosshair && this.crosshair.label && this.crosshair.label.enabled && this.cross && P(this.min) && P(this.max)) {
              var i, c, l, h, C, M = this.chart, O = this.logarithmic, p = this.crosshair.label, w = this.horiz, T = this.opposite, z = this.left, W = this.top, L = this.crossLabel, I = p.format, j = "", Z = this.options.tickPosition === "inside", V = this.crosshair.snap !== !1, X = 0, et = o.e || this.cross && this.cross.e, ot = o.point, it = this.min, pt = this.max;
              O && (it = O.lin2log(it), pt = O.lin2log(pt)), C = w ? "center" : T ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center", L || (L = this.crossLabel = M.renderer.label("", 0, void 0, p.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (ot && ot.series ? ot.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({ align: p.align || C, padding: y(p.padding, 8), r: y(p.borderRadius, 3), zIndex: 2 }).add(this.labelGroup), M.styledMode || L.attr({ fill: p.backgroundColor || ot && ot.series && ot.series.color || "#666666", stroke: p.borderColor || "", "stroke-width": p.borderWidth || 0 }).css(x({ color: "#ffffff", fontWeight: "normal", fontSize: "11px", textAlign: "center" }, p.style || {}))), w ? (i = V ? (ot.plotX || 0) + z : et.chartX, c = W + (T ? 0 : this.height)) : (i = T ? this.width + z : 0, c = V ? (ot.plotY || 0) + W : et.chartY), I || p.formatter || (this.dateTime && (j = "%b %d, %Y"), I = "{value" + (j ? ":" + j : "") + "}");
              var mt = V ? this.isXAxis ? ot.x : ot.y : this.toValue(w ? et.chartX : et.chartY), Ct = ot && ot.series ? ot.series.isPointInside(ot) : P(mt) && mt > it && mt < pt, kt = "";
              I ? kt = b(I, { value: mt }, M) : p.formatter && P(mt) && (kt = p.formatter.call(this, mt)), L.attr({ text: kt, x: i, y: c, visibility: Ct ? "inherit" : "hidden" }), l = L.getBBox(), P(L.y) && (w ? (Z && !T || !Z && T) && (c = L.y - l.height) : c = L.y - l.height / 2), h = w ? { left: z - l.x, right: z + this.width - l.x } : { left: this.labelAlign === "left" ? z : 0, right: this.labelAlign === "right" ? z + this.width : M.chartWidth }, L.translateX < h.left && (X = h.left - L.translateX), L.translateX + l.width >= h.right && (X = -(L.translateX + l.width - h.right)), L.attr({ x: i + X, y: c, anchorX: w ? i : this.opposite ? 0 : M.chartWidth, anchorY: w ? this.opposite ? M.chartHeight : 0 : c + l.height / 2 });
            }
          }), U.prototype.forceCropping = function() {
            var o = this.chart, i = this.options.dataGrouping;
            return this.allowDG !== !1 && i && y(i.enabled, o.options.isStock);
          }, m(F, "update", function(o) {
            var i = o.options;
            "scrollbar" in i && this.navigator && (u(!0, this.options.scrollbar, i.scrollbar), this.navigator.update({}), delete i.scrollbar);
          }), a;
        }), at(_, "masters/modules/stock.src.js", [_["Core/Globals.js"], _["Series/DataModifyComposition.js"], _["Stock/Navigator/Navigator.js"], _["Stock/RangeSelector/RangeSelector.js"], _["Stock/Scrollbar/Scrollbar.js"], _["Core/Axis/OrdinalAxis.js"], _["Series/OHLC/OHLCSeries.js"], _["Series/Flags/FlagsSeries.js"], _["Core/Chart/StockChart.js"]], function(G, F, $, Y, J, Q, q, U, N) {
          var D = G;
          D.Navigator = $, D.RangeSelector = Y, D.Scrollbar = J, D.StockChart = D.stockChart = N.stockChart, F.compose(D.Series, D.Axis, D.Point), U.compose(D.Renderer), $.compose(D.Axis, D.Chart, D.Series), q.compose(D.Series), Q.compose(D.Axis, D.Series, D.Chart), Y.compose(D.Axis, D.Chart), J.compose(D.Axis);
        }), at(_, "masters/highstock.src.js", [_["masters/highcharts.src.js"]], function(G) {
          return G.product = "Highstock", G;
        }), _["masters/highstock.src.js"]._modules = _, _["masters/highstock.src.js"];
      }, tt.exports ? (yt.default = yt, tt.exports = ut.document ? yt(ut) : yt) : (ht = function() {
        return yt(ut);
      }.call(st, lt, st, tt)) === void 0 || (tt.exports = ht);
    }, 3968: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Accessibility/Utils/HTMLUtilities.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.doc, Y = G.win, J = F.css, Q = Y.EventTarget && new Y.EventTarget() || "none";
          function q(N) {
            if (typeof Y.MouseEvent == "function")
              return new Y.MouseEvent(N.type, N);
            if ($.createEvent) {
              var D = $.createEvent("MouseEvent");
              if (D.initMouseEvent)
                return D.initMouseEvent(N.type, N.bubbles, N.cancelable, N.view || Y, N.detail, N.screenX, N.screenY, N.clientX, N.clientY, N.ctrlKey, N.altKey, N.shiftKey, N.metaKey, N.button, N.relatedTarget), D;
            }
            return U(N.type);
          }
          function U(N, D, k) {
            var A = D || { x: 0, y: 0 };
            if (typeof Y.MouseEvent == "function")
              return new Y.MouseEvent(N, { bubbles: !0, cancelable: !0, composed: !0, button: 0, buttons: 1, relatedTarget: k || Q, view: Y, detail: N === "click" ? 1 : 0, screenX: A.x, screenY: A.y, clientX: A.x, clientY: A.y });
            if ($.createEvent) {
              var b = $.createEvent("MouseEvent");
              if (b.initMouseEvent)
                return b.initMouseEvent(N, !0, !0, Y, N === "click" ? 1 : 0, A.x, A.y, A.x, A.y, !1, !1, !1, !1, 0, null), b;
            }
            return { type: N };
          }
          return { addClass: function(N, D) {
            N.classList ? N.classList.add(D) : N.className.indexOf(D) < 0 && (N.className += " " + D);
          }, cloneMouseEvent: q, cloneTouchEvent: function(N) {
            var D = function(b) {
              for (var d = [], m = 0; m < b.length; ++m) {
                var v = b.item(m);
                v && d.push(v);
              }
              return d;
            };
            if (typeof Y.TouchEvent == "function") {
              var k = new Y.TouchEvent(N.type, { touches: D(N.touches), targetTouches: D(N.targetTouches), changedTouches: D(N.changedTouches), ctrlKey: N.ctrlKey, shiftKey: N.shiftKey, altKey: N.altKey, metaKey: N.metaKey, bubbles: N.bubbles, cancelable: N.cancelable, composed: N.composed, detail: N.detail, view: N.view });
              return N.defaultPrevented && k.preventDefault(), k;
            }
            var A = q(N);
            return A.touches = N.touches, A.changedTouches = N.changedTouches, A.targetTouches = N.targetTouches, A;
          }, escapeStringForHTML: function(N) {
            return N.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
          }, getElement: function(N) {
            return $.getElementById(N);
          }, getFakeMouseEvent: U, getHeadingTagNameForElement: function(N) {
            var D = function(b) {
              var d = parseInt(b.slice(1), 10);
              return "h" + Math.min(6, d + 1);
            }, k = function(b) {
              return /H[1-6]/.test(b);
            }, A = function(b) {
              var d = function(g) {
                for (var x = g; x = x.previousSibling; ) {
                  var E = x.tagName || "";
                  if (k(E))
                    return E;
                }
                return "";
              }(b);
              if (d)
                return D(d);
              var m = b.parentElement;
              if (!m)
                return "p";
              var v = m.tagName;
              return k(v) ? D(v) : A(m);
            };
            return A(N);
          }, removeChildNodes: function(N) {
            for (; N.lastChild; )
              N.removeChild(N.lastChild);
          }, removeClass: function(N, D) {
            N.classList ? N.classList.remove(D) : N.className = N.className.replace(new RegExp(D, "g"), "");
          }, removeElement: function(N) {
            N && N.parentNode && N.parentNode.removeChild(N);
          }, reverseChildNodes: function(N) {
            for (var D = N.childNodes.length; D--; )
              N.appendChild(N.childNodes[D]);
          }, simulatedEventTarget: Q, stripHTMLTagsFromString: function(N) {
            return typeof N == "string" ? N.replace(/<\/?[^>]+(>|$)/g, "") : N;
          }, visuallyHideElement: function(N) {
            J(N, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
          } };
        }), at(_, "Accessibility/A11yI18n.js", [_["Core/FormatUtilities.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = G.format, J = F.getNestedProperty, Q = F.pick;
          return function(q) {
            var U = [];
            function N(k, A, b) {
              var d, m, v = function(E, P) {
                var S = E.slice(P || 0), u = S.indexOf("{"), y = S.indexOf("}");
                if (u > -1 && y > u)
                  return { statement: S.substring(u + 1, y), begin: P + u + 1, end: P + y };
              }, g = [], x = 0;
              do
                d = v(k, x), (m = k.substring(x, d && d.begin - 1)).length && g.push({ value: m, type: "constant" }), d && g.push({ value: d.statement, type: "statement" }), x = d ? d.end + 1 : x + 1;
              while (d);
              return g.forEach(function(E) {
                E.type === "statement" && (E.value = function(P, S) {
                  var u, y, s, a = P.indexOf("#each("), e = P.indexOf("#plural("), n = P.indexOf("["), o = P.indexOf("]");
                  if (a > -1) {
                    var i = P.slice(a).indexOf(")") + a, c = P.substring(0, a), l = P.substring(i + 1), h = P.substring(a + 6, i).split(","), C = Number(h[1]), M = void 0;
                    if (y = "", u = J(h[0], S)) {
                      M = (C = isNaN(C) ? u.length : C) < 0 ? u.length + C : Math.min(C, u.length);
                      for (var O = 0; O < M; ++O)
                        y += c + u[O] + l;
                    }
                    return y.length ? y : "";
                  }
                  if (e > -1) {
                    var p = P.slice(e).indexOf(")") + e, w = P.substring(e + 8, p).split(",");
                    switch (Number(J(w[0], S))) {
                      case 0:
                        y = Q(w[4], w[1]);
                        break;
                      case 1:
                        y = Q(w[2], w[1]);
                        break;
                      case 2:
                        y = Q(w[3], w[1]);
                        break;
                      default:
                        y = w[1];
                    }
                    return y ? (s = y).trim && s.trim() || s.replace(/^\s+|\s+$/g, "") : "";
                  }
                  if (n > -1) {
                    var T = P.substring(0, n), z = Number(P.substring(n + 1, o)), W = void 0;
                    return u = J(T, S), !isNaN(z) && u && (z < 0 ? (W = u[u.length + z]) === void 0 && (W = u[0]) : (W = u[z]) === void 0 && (W = u[u.length - 1])), W !== void 0 ? W : "";
                  }
                  return "{" + P + "}";
                }(E.value, A));
              }), Y(g.reduce(function(E, P) {
                return E + P.value;
              }, ""), A, b);
            }
            function D(k, A) {
              for (var b = k.split("."), d = this.options.lang, m = 0; m < b.length; ++m)
                d = d && d[b[m]];
              return typeof d == "string" ? N(d, A, this) : "";
            }
            q.compose = function(k) {
              return U.indexOf(k) === -1 && (U.push(k), k.prototype.langFormat = D), k;
            }, q.i18nFormat = N;
          }($ || ($ = {})), $;
        }), at(_, "Accessibility/Utils/ChartUtilities.js", [_["Core/Globals.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.doc, J = F.stripHTMLTagsFromString, Q = $.defined, q = $.find, U = $.fireEvent;
          function N(k) {
            if (k.points && k.points.length) {
              var A = q(k.points, function(b) {
                return !!b.graphic;
              });
              return A && A.graphic && A.graphic.element;
            }
          }
          function D(k) {
            var A = N(k);
            return A && A.parentNode || k.graph && k.graph.element || k.group && k.group.element;
          }
          return { fireEventOnWrappedOrUnwrappedElement: function k(A, b) {
            var d = b.type, m = A.hcEvents;
            Y.createEvent && (A.dispatchEvent || A.fireEvent) ? A.dispatchEvent ? A.dispatchEvent(b) : A.fireEvent(d, b) : m && m[d] ? U(A, d, b) : A.element && k(A.element, b);
          }, getChartTitle: function(k) {
            return J(k.options.title.text || k.langFormat("accessibility.defaultChartTitle", { chart: k }));
          }, getAxisDescription: function(k) {
            return k && (k.userOptions && k.userOptions.accessibility && k.userOptions.accessibility.description || k.axisTitle && k.axisTitle.textStr || k.options.id || k.categories && "categories" || k.dateTime && "Time" || "values");
          }, getAxisRangeDescription: function(k) {
            var A = k.options || {};
            return A.accessibility && A.accessibility.rangeDescription !== void 0 ? A.accessibility.rangeDescription : k.categories ? function(b) {
              var d = b.chart;
              return b.dataMax && b.dataMin ? d.langFormat("accessibility.axis.rangeCategories", { chart: d, axis: b, numCategories: b.dataMax - b.dataMin + 1 }) : "";
            }(k) : !k.dateTime || k.min !== 0 && k.dataMin !== 0 ? function(b) {
              var d = b.chart, m = d.options, v = m && m.accessibility && m.accessibility.screenReaderSection.axisRangeDateFormat || "", g = { min: b.dataMin || b.min || 0, max: b.dataMax || b.max || 0 }, x = function(E) {
                return b.dateTime ? d.time.dateFormat(v, g[E]) : g[E].toString();
              };
              return d.langFormat("accessibility.axis.rangeFromTo", { chart: d, axis: b, rangeFrom: x("min"), rangeTo: x("max") });
            }(k) : function(b) {
              var d = b.chart, m = {}, v = b.dataMin || b.min || 0, g = b.dataMax || b.max || 0, x = "Seconds";
              m.Seconds = (g - v) / 1e3, m.Minutes = m.Seconds / 60, m.Hours = m.Minutes / 60, m.Days = m.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(P) {
                m[P] > 2 && (x = P);
              });
              var E = m[x].toFixed(x !== "Seconds" && x !== "Minutes" ? 1 : 0);
              return d.langFormat("accessibility.axis.timeRange" + x, { chart: d, axis: b, range: E.replace(".0", "") });
            }(k);
          }, getPointFromXY: function(k, A, b) {
            for (var d, m = k.length; m--; )
              if (d = q(k[m].points || [], function(v) {
                return v.x === A && v.y === b;
              }))
                return d;
          }, getSeriesFirstPointElement: N, getSeriesFromName: function(k, A) {
            return A ? (k.series || []).filter(function(b) {
              return b.name === A;
            }) : k.series;
          }, getSeriesA11yElement: D, unhideChartElementFromAT: function k(A, b) {
            b.setAttribute("aria-hidden", !1), b !== A.renderTo && b.parentNode && b.parentNode !== Y.body && (Array.prototype.forEach.call(b.parentNode.childNodes, function(d) {
              d.hasAttribute("aria-hidden") || d.setAttribute("aria-hidden", !0);
            }), k(A, b.parentNode));
          }, hideSeriesFromAT: function(k) {
            var A = D(k);
            A && A.setAttribute("aria-hidden", !0);
          }, scrollToPoint: function(k) {
            var A = k.series.xAxis, b = k.series.yAxis, d = A && A.scrollbar ? A : b, m = d && d.scrollbar;
            if (m && Q(m.to) && Q(m.from)) {
              var v = m.to - m.from, g = function(x, E) {
                if (!Q(x.dataMin) || !Q(x.dataMax))
                  return 0;
                var P = x.toPixels(x.dataMin), S = x.toPixels(x.dataMax), u = x.coll === "xAxis" ? "x" : "y";
                return (x.toPixels(E[u] || 0) - P) / (S - P);
              }(d, k);
              m.updatePosition(g - v / 2, g + v / 2), U(m, "changed", { from: m.from, to: m.to, trigger: "scrollbar", DOMEvent: null });
            }
          } };
        }), at(_, "Accessibility/Utils/DOMElementProvider.js", [_["Core/Globals.js"], _["Accessibility/Utils/HTMLUtilities.js"]], function(G, F) {
          var $ = G.doc, Y = F.removeElement, J = function() {
            function Q() {
              this.elements = [];
            }
            return Q.prototype.createElement = function() {
              var q = $.createElement.apply($, arguments);
              return this.elements.push(q), q;
            }, Q.prototype.destroyCreatedElements = function() {
              this.elements.forEach(function(q) {
                Y(q);
              }), this.elements = [];
            }, Q;
          }();
          return J;
        }), at(_, "Accessibility/Utils/EventProvider.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = F.addEvent, Y = function() {
            function J() {
              this.eventRemovers = [];
            }
            return J.prototype.addEvent = function() {
              var Q = $.apply(G, arguments);
              return this.eventRemovers.push(Q), Q;
            }, J.prototype.removeAddedEvents = function() {
              this.eventRemovers.forEach(function(Q) {
                return Q();
              }), this.eventRemovers = [];
            }, J;
          }();
          return Y;
        }), at(_, "Accessibility/AccessibilityComponent.js", [_["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/DOMElementProvider.js"], _["Accessibility/Utils/EventProvider.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = G.fireEventOnWrappedOrUnwrappedElement, q = Y.getFakeMouseEvent, U = J.extend, N = function() {
            function D() {
              this.chart = void 0, this.domElementProvider = void 0, this.eventProvider = void 0, this.keyCodes = void 0, this.proxyProvider = void 0;
            }
            return D.prototype.initBase = function(k, A) {
              this.chart = k, this.eventProvider = new $(), this.domElementProvider = new F(), this.proxyProvider = A, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
            }, D.prototype.addEvent = function(k, A, b, d) {
              return this.eventProvider.addEvent(k, A, b, d);
            }, D.prototype.createElement = function(k, A) {
              return this.domElementProvider.createElement(k, A);
            }, D.prototype.fakeClickEvent = function(k) {
              var A = q("click");
              Q(k, A);
            }, D.prototype.destroyBase = function() {
              this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
            }, D;
          }();
          return U(N.prototype, { init: function() {
          }, getKeyboardNavigation: function() {
          }, onChartUpdate: function() {
          }, onChartRender: function() {
          }, destroy: function() {
          } }), N;
        }), at(_, "Accessibility/KeyboardNavigationHandler.js", [_["Core/Utilities.js"]], function(G) {
          var F = G.find;
          return function() {
            function $(Y, J) {
              this.chart = Y, this.keyCodeMap = J.keyCodeMap || [], this.validate = J.validate, this.init = J.init, this.terminate = J.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
            }
            return $.prototype.run = function(Y) {
              var J = Y.which || Y.keyCode, Q = this.response.noHandler, q = F(this.keyCodeMap, function(U) {
                return U[0].indexOf(J) > -1;
              });
              return q ? Q = q[1].call(this, J, Y) : J === 9 && (Q = this.response[Y.shiftKey ? "prev" : "next"]), Q;
            }, $;
          }();
        }), at(_, "Accessibility/Components/ContainerComponent.js", [_["Accessibility/AccessibilityComponent.js"], _["Accessibility/KeyboardNavigationHandler.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Core/Globals.js"], _["Accessibility/Utils/HTMLUtilities.js"]], function(G, F, $, Y, J) {
          var Q, q = this && this.__extends || (Q = function(b, d) {
            return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, Q(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            Q(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), U = $.unhideChartElementFromAT, N = $.getChartTitle, D = Y.doc, k = J.stripHTMLTagsFromString, A = function(b) {
            function d() {
              return b !== null && b.apply(this, arguments) || this;
            }
            return q(d, b), d.prototype.onChartUpdate = function() {
              this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
            }, d.prototype.handleSVGTitleElement = function() {
              var m = this.chart, v = "highcharts-title-" + m.index, g = k(m.langFormat("accessibility.svgContainerTitle", { chartTitle: N(m) }));
              if (g.length) {
                var x = this.svgTitleElement = this.svgTitleElement || D.createElementNS("http://www.w3.org/2000/svg", "title");
                x.textContent = g, x.id = v, m.renderTo.insertBefore(x, m.renderTo.firstChild);
              }
            }, d.prototype.setSVGContainerLabel = function() {
              var m = this.chart, v = m.langFormat("accessibility.svgContainerLabel", { chartTitle: N(m) });
              m.renderer.box && v.length && m.renderer.box.setAttribute("aria-label", v);
            }, d.prototype.setGraphicContainerAttrs = function() {
              var m = this.chart, v = m.langFormat("accessibility.graphicContainerLabel", { chartTitle: N(m) });
              v.length && m.container.setAttribute("aria-label", v);
            }, d.prototype.setRenderToAttrs = function() {
              var m = this.chart, v = m.options.accessibility.landmarkVerbosity !== "disabled", g = m.langFormat("accessibility.chartContainerLabel", { title: N(m), chart: m });
              g && (m.renderTo.setAttribute("role", v ? "region" : "group"), m.renderTo.setAttribute("aria-label", g));
            }, d.prototype.makeCreditsAccessible = function() {
              var m = this.chart, v = m.credits;
              v && (v.textStr && v.element.setAttribute("aria-label", m.langFormat("accessibility.credits", { creditsStr: k(v.textStr) })), U(m, v.element));
            }, d.prototype.getKeyboardNavigation = function() {
              var m = this.chart;
              return new F(m, { keyCodeMap: [], validate: function() {
                return !0;
              }, init: function() {
                var v = m.accessibility;
                v && v.keyboardNavigation.tabindexContainer.focus();
              } });
            }, d.prototype.destroy = function() {
              this.chart.renderTo.setAttribute("aria-hidden", !0);
            }, d;
          }(G);
          return A;
        }), at(_, "Accessibility/FocusBorder.js", [_["Core/Renderer/SVG/SVGLabel.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = F.addEvent, J = F.pick;
          return function(Q) {
            var q = [], U = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
            function N() {
              var b = this.focusElement, d = this.options.accessibility.keyboardNavigation.focusBorder;
              b && (b.removeFocusBorder(), d.enabled && b.addFocusBorder(d.margin, { stroke: d.style.color, strokeWidth: d.style.lineWidth, r: d.style.borderRadius }));
            }
            function D(b, d) {
              var m = this.options.accessibility.keyboardNavigation.focusBorder, v = d || b.element;
              v && v.focus && (v.hcEvents && v.hcEvents.focusin || Y(v, "focusin", function() {
              }), v.focus(), m.hideBrowserFocusOutline && (v.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = b, this.renderFocusBorder();
            }
            function k(b, d) {
              this.focusBorder && this.removeFocusBorder();
              var m = this.getBBox(), v = J(b, 3), g = this.parentGroup, x = this.scaleX || g && g.scaleX, E = this.scaleY || g && g.scaleY, P = (x ? !E : E) ? Math.abs(x || E || 1) : (Math.abs(x || 1) + Math.abs(E || 1)) / 2;
              m.x += this.translateX ? this.translateX : 0, m.y += this.translateY ? this.translateY : 0;
              var S, u, y, s = m.x - v, a = m.y - v, e = m.width + 2 * v, n = m.height + 2 * v, o = this instanceof G;
              if (this.element.nodeName === "text" || o) {
                var i = !!this.rotation, c = o ? { x: i ? 1 : 0, y: 0 } : (u = 0, y = 0, (S = this).attr("text-anchor") === "middle" ? u = y = 0.5 : S.rotation ? u = 0.25 : y = 0.75, { x: u, y }), l = +this.attr("x"), h = +this.attr("y");
                if (isNaN(l) || (s = l - m.width * c.x - v), isNaN(h) || (a = h - m.height * c.y - v), o && i) {
                  var C = e;
                  e = n, n = C, isNaN(l) || (s = l - m.height * c.x - v), isNaN(h) || (a = h - m.width * c.y - v);
                }
              }
              this.focusBorder = this.renderer.rect(s, a, e, n, parseInt((d && d.r || 0).toString(), 10) / P).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(g), this.renderer.styledMode || this.focusBorder.attr({ stroke: d && d.stroke, "stroke-width": (d && d.strokeWidth || 0) / P }), function(M) {
                for (var O = [], p = 1; p < arguments.length; p++)
                  O[p - 1] = arguments[p];
                M.focusBorderUpdateHooks || (M.focusBorderUpdateHooks = {}, U.forEach(function(w) {
                  var T = w + "Setter", z = M[T] || M._defaultSetter;
                  M.focusBorderUpdateHooks[T] = z, M[T] = function() {
                    var W = z.apply(M, arguments);
                    return M.addFocusBorder.apply(M, O), W;
                  };
                }));
              }(this, b, d), function(M) {
                if (!M.focusBorderDestroyHook) {
                  var O = M.destroy;
                  M.destroy = function() {
                    return M.focusBorder && M.focusBorder.destroy && M.focusBorder.destroy(), O.apply(M, arguments);
                  }, M.focusBorderDestroyHook = O;
                }
              }(this);
            }
            function A() {
              var b;
              (function(d) {
                d.focusBorderUpdateHooks && (Object.keys(d.focusBorderUpdateHooks).forEach(function(m) {
                  var v = d.focusBorderUpdateHooks[m];
                  v === d._defaultSetter ? delete d[m] : d[m] = v;
                }), delete d.focusBorderUpdateHooks);
              })(this), (b = this).focusBorderDestroyHook && (b.destroy = b.focusBorderDestroyHook, delete b.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
            }
            Q.compose = function(b, d) {
              if (q.indexOf(b) === -1) {
                q.push(b);
                var m = b.prototype;
                m.renderFocusBorder = N, m.setFocusToElement = D;
              }
              if (q.indexOf(d) === -1) {
                q.push(d);
                var v = d.prototype;
                v.addFocusBorder = k, v.removeFocusBorder = A;
              }
            };
          }($ || ($ = {})), $;
        }), at(_, "Accessibility/Utils/Announcer.js", [_["Core/Renderer/HTML/AST.js"], _["Accessibility/Utils/DOMElementProvider.js"], _["Core/Globals.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = $.doc, q = Y.addClass, U = Y.visuallyHideElement, N = J.attr;
          return function() {
            function D(k, A) {
              this.chart = k, this.domElementProvider = new F(), this.announceRegion = this.addAnnounceRegion(A);
            }
            return D.prototype.destroy = function() {
              this.domElementProvider.destroyCreatedElements();
            }, D.prototype.announce = function(k) {
              var A = this;
              G.setElementHTML(this.announceRegion, k), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(function() {
                A.announceRegion.innerHTML = G.emptyHTML, delete A.clearAnnouncementRegionTimer;
              }, 1e3);
            }, D.prototype.addAnnounceRegion = function(k) {
              var A = this.chart.announcerContainer || this.createAnnouncerContainer(), b = this.domElementProvider.createElement("div");
              return N(b, { "aria-hidden": !1, "aria-live": k }), this.chart.styledMode ? q(b, "highcharts-visually-hidden") : U(b), A.appendChild(b), b;
            }, D.prototype.createAnnouncerContainer = function() {
              var k = this.chart, A = Q.createElement("div");
              return N(A, { "aria-hidden": !1, class: "highcharts-announcer-container" }), A.style.position = "relative", k.renderTo.insertBefore(A, k.renderTo.firstChild), k.announcerContainer = A, A;
            }, D;
          }();
        }), at(_, "Accessibility/Components/AnnotationsA11y.js", [_["Accessibility/Utils/HTMLUtilities.js"]], function(G) {
          var F = G.escapeStringForHTML, $ = G.stripHTMLTagsFromString;
          function Y(U) {
            return (U.annotations || []).reduce(function(N, D) {
              return D.options && D.options.visible !== !1 && (N = N.concat(D.labels)), N;
            }, []);
          }
          function J(U) {
            return U.options && U.options.accessibility && U.options.accessibility.description || U.graphic && U.graphic.text && U.graphic.text.textStr || "";
          }
          function Q(U) {
            var N = U.options && U.options.accessibility && U.options.accessibility.description;
            if (N)
              return N;
            var D = U.chart, k = J(U), A = U.points.filter(function(v) {
              return !!v.graphic;
            }).map(function(v) {
              var g = v.accessibility && v.accessibility.valueDescription || function(E) {
                return E.graphic && E.graphic.element && E.graphic.element.getAttribute("aria-label") || "";
              }(v), x = v && v.series.name || "";
              return (x ? x + ", " : "") + "data point " + g;
            }).filter(function(v) {
              return !!v;
            }), b = A.length, d = "accessibility.screenReaderSection.annotations.description" + (b > 1 ? "MultiplePoints" : b ? "SinglePoint" : "NoPoints"), m = { annotationText: k, annotation: U, numPoints: b, annotationPoint: A[0], additionalAnnotationPoints: A.slice(1) };
            return D.langFormat(d, m);
          }
          function q(U) {
            return Y(U).map(function(N) {
              var D = F($(Q(N)));
              return D ? "<li>".concat(D, "</li>") : "";
            });
          }
          return { getAnnotationsInfoHTML: function(U) {
            var N = U.annotations;
            if (!N || !N.length)
              return "";
            var D = q(U);
            return '<ul style="list-style-type: none">'.concat(D.join(" "), "</ul>");
          }, getAnnotationLabelDescription: Q, getAnnotationListItems: q, getPointAnnotationTexts: function(U) {
            var N = Y(U.series.chart).filter(function(D) {
              return D.points.indexOf(U) > -1;
            });
            return N.length ? N.map(function(D) {
              return "".concat(J(D));
            }) : [];
          } };
        }), at(_, "Accessibility/Components/InfoRegionsComponent.js", [_["Accessibility/A11yI18n.js"], _["Accessibility/AccessibilityComponent.js"], _["Accessibility/Utils/Announcer.js"], _["Accessibility/Components/AnnotationsA11y.js"], _["Core/Renderer/HTML/AST.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Core/FormatUtilities.js"], _["Core/Globals.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N, D) {
          var k, A = this && this.__extends || (k = function(i, c) {
            return k = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, h) {
              l.__proto__ = h;
            } || function(l, h) {
              for (var C in h)
                h.hasOwnProperty(C) && (l[C] = h[C]);
            }, k(i, c);
          }, function(i, c) {
            function l() {
              this.constructor = i;
            }
            k(i, c), i.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
          }), b = Y.getAnnotationsInfoHTML, d = Q.getAxisDescription, m = Q.getAxisRangeDescription, v = Q.getChartTitle, g = Q.unhideChartElementFromAT, x = q.format, E = U.doc, P = N.addClass, S = N.getElement, u = N.getHeadingTagNameForElement, y = N.stripHTMLTagsFromString, s = N.visuallyHideElement, a = D.attr, e = D.pick;
          function n(i) {
            return i.replace(/<(\w+)[^>]*?>\s*<\/\1>/g, "");
          }
          var o = function(i) {
            function c() {
              var l = i !== null && i.apply(this, arguments) || this;
              return l.announcer = void 0, l.screenReaderSections = {}, l;
            }
            return A(c, i), c.prototype.init = function() {
              var l = this.chart, h = this;
              this.initRegionsDefinitions(), this.addEvent(l, "aftergetTableAST", function(C) {
                h.onDataTableCreated(C);
              }), this.addEvent(l, "afterViewData", function(C) {
                C.wasHidden && (h.dataTableDiv = C.element, setTimeout(function() {
                  h.focusDataTable();
                }, 300));
              }), this.announcer = new $(l, "assertive");
            }, c.prototype.initRegionsDefinitions = function() {
              var l = this;
              this.screenReaderSections = { before: { element: null, buildContent: function(h) {
                var C = h.options.accessibility.screenReaderSection.beforeChartFormatter;
                return C ? C(h) : l.defaultBeforeChartFormatter(h);
              }, insertIntoDOM: function(h, C) {
                C.renderTo.insertBefore(h, C.renderTo.firstChild);
              }, afterInserted: function() {
                l.sonifyButtonId !== void 0 && l.initSonifyButton(l.sonifyButtonId), l.dataTableButtonId !== void 0 && l.initDataTableButton(l.dataTableButtonId);
              } }, after: { element: null, buildContent: function(h) {
                var C = h.options.accessibility.screenReaderSection.afterChartFormatter;
                return C ? C(h) : l.defaultAfterChartFormatter();
              }, insertIntoDOM: function(h, C) {
                C.renderTo.insertBefore(h, C.container.nextSibling);
              }, afterInserted: function() {
                l.chart.accessibility && l.chart.accessibility.keyboardNavigation.updateExitAnchor();
              } } };
            }, c.prototype.onChartRender = function() {
              var l = this;
              this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), Object.keys(this.screenReaderSections).forEach(function(h) {
                l.updateScreenReaderSection(h);
              });
            }, c.prototype.getLinkedDescriptionElement = function() {
              var l = this.chart.options.accessibility.linkedDescription;
              if (l) {
                if (typeof l != "string")
                  return l;
                var h = x(l, this.chart), C = E.querySelectorAll(h);
                return C.length === 1 ? C[0] : void 0;
              }
            }, c.prototype.setLinkedDescriptionAttrs = function() {
              var l = this.linkedDescriptionElement;
              l && (l.setAttribute("aria-hidden", "true"), P(l, "highcharts-linked-description"));
            }, c.prototype.updateScreenReaderSection = function(l) {
              var h = this.chart, C = this.screenReaderSections[l], M = C.buildContent(h), O = C.element = C.element || this.createElement("div"), p = O.firstChild || this.createElement("div");
              M ? (this.setScreenReaderSectionAttribs(O, l), J.setElementHTML(p, M), O.appendChild(p), C.insertIntoDOM(O, h), h.styledMode ? P(p, "highcharts-visually-hidden") : s(p), g(h, p), C.afterInserted && C.afterInserted()) : (O.parentNode && O.parentNode.removeChild(O), C.element = null);
            }, c.prototype.setScreenReaderSectionAttribs = function(l, h) {
              var C = this.chart, M = C.langFormat("accessibility.screenReaderSection." + h + "RegionLabel", { chart: C, chartTitle: v(C) }), O = "highcharts-screen-reader-region-".concat(h, "-").concat(C.index);
              a(l, { id: O, "aria-label": M || void 0 }), l.style.position = "relative", M && l.setAttribute("role", C.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
            }, c.prototype.defaultBeforeChartFormatter = function() {
              var l = this.chart, h = l.options.accessibility.screenReaderSection.beforeChartFormat;
              if (!h)
                return "";
              var C = this.getAxesDescription(), M = l.sonify && l.options.sonification && l.options.sonification.enabled, O = "highcharts-a11y-sonify-data-btn-" + l.index, p = "hc-linkto-highcharts-data-table-" + l.index, w = b(l), T = l.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: l }), z = { headingTagName: u(l.renderTo), chartTitle: v(l), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: C.xAxis, yAxisDescription: C.yAxis, playAsSoundButton: M ? this.getSonifyButtonText(O) : "", viewTableButton: l.getCSV ? this.getDataTableButtonText(p) : "", annotationsTitle: w ? T : "", annotationsList: w }, W = G.i18nFormat(h, z, l);
              return this.dataTableButtonId = p, this.sonifyButtonId = O, n(W);
            }, c.prototype.defaultAfterChartFormatter = function() {
              var l = this.chart, h = l.options.accessibility.screenReaderSection.afterChartFormat;
              if (!h)
                return "";
              var C = { endOfChartMarker: this.getEndOfChartMarkerText() };
              return n(G.i18nFormat(h, C, l));
            }, c.prototype.getLinkedDescription = function() {
              var l = this.linkedDescriptionElement, h = l && l.innerHTML || "";
              return y(h);
            }, c.prototype.getLongdescText = function() {
              var l = this.chart.options, h = l.caption, C = h && h.text, M = this.getLinkedDescription();
              return l.accessibility.description || M || C || "";
            }, c.prototype.getTypeDescriptionText = function() {
              var l = this.chart;
              return l.types ? l.options.accessibility.typeDescription || function(h, C) {
                var M = C[0], O = h.series && h.series[0] || {}, p = h.mapView && h.mapView.geoMap && h.mapView.geoMap.title, w = { numSeries: h.series.length, numPoints: O.points && O.points.length, chart: h, mapTitle: p };
                return M ? M === "map" ? function(T, z) {
                  return z.mapTitle ? T.langFormat("accessibility.chartTypes.mapTypeDescription", z) : T.langFormat("accessibility.chartTypes.unknownMap", z);
                }(h, w) : h.types.length > 1 ? function(T, z) {
                  return T.langFormat("accessibility.chartTypes.combinationChart", z);
                }(h, w) : function(T, z, W) {
                  var L = z[0], I = T.langFormat("accessibility.seriesTypeDescriptions." + L, W), j = T.series && T.series.length < 2 ? "Single" : "Multiple";
                  return (T.langFormat("accessibility.chartTypes." + L + j, W) || T.langFormat("accessibility.chartTypes.default" + j, W)) + (I ? " " + I : "");
                }(h, C, w) : function(T, z) {
                  return T.langFormat("accessibility.chartTypes.emptyChart", z);
                }(h, w);
              }(l, l.types) : "";
            }, c.prototype.getDataTableButtonText = function(l) {
              var h = this.chart;
              return '<button id="' + l + '">' + h.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: h, chartTitle: v(h) }) + "</button>";
            }, c.prototype.getSonifyButtonText = function(l) {
              var h = this.chart;
              return h.options.sonification && h.options.sonification.enabled === !1 ? "" : '<button id="' + l + '">' + h.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: h, chartTitle: v(h) }) + "</button>";
            }, c.prototype.getSubtitleText = function() {
              var l = this.chart.options.subtitle;
              return y(l && l.text || "");
            }, c.prototype.getEndOfChartMarkerText = function() {
              var l = this.chart, h = l.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: l });
              return '<div id="highcharts-end-of-chart-marker-' + l.index + '">' + h + "</div>";
            }, c.prototype.onDataTableCreated = function(l) {
              var h = this.chart;
              if (h.options.accessibility.enabled) {
                this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
                var C = l.tree.attributes || {};
                C.tabindex = -1, C.summary = function(M) {
                  return M.langFormat("accessibility.table.tableSummary", { chart: M });
                }(h), l.tree.attributes = C;
              }
            }, c.prototype.focusDataTable = function() {
              var l = this.dataTableDiv, h = l && l.getElementsByTagName("table")[0];
              h && h.focus && h.focus();
            }, c.prototype.initSonifyButton = function(l) {
              var h = this, C = this.sonifyButton = S(l), M = this.chart, O = function(p) {
                C && (C.setAttribute("aria-hidden", "true"), C.setAttribute("aria-label", "")), p.preventDefault(), p.stopPropagation();
                var w = M.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: M });
                h.announcer.announce(w), setTimeout(function() {
                  C && (C.removeAttribute("aria-hidden"), C.removeAttribute("aria-label")), M.sonify && M.sonify();
                }, 1e3);
              };
              C && M && (C.setAttribute("tabindex", -1), C.onclick = function(p) {
                (M.options.accessibility && M.options.accessibility.screenReaderSection.onPlayAsSoundClick || O).call(this, p, M);
              });
            }, c.prototype.initDataTableButton = function(l) {
              var h = this.viewDataTableButton = S(l), C = this.chart, M = l.replace("hc-linkto-", "");
              h && (a(h, { tabindex: -1, "aria-expanded": !!S(M) }), h.onclick = C.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
                C.viewData();
              });
            }, c.prototype.getAxesDescription = function() {
              var l = this.chart, h = function(T, z) {
                var W = l[T];
                return W.length > 1 || W[0] && e(W[0].options.accessibility && W[0].options.accessibility.enabled, z);
              }, C = !!l.types && l.types.indexOf("map") < 0 && l.types.indexOf("treemap") < 0 && l.types.indexOf("tilemap") < 0, M = !!l.hasCartesianSeries, O = h("xAxis", !l.angular && M && C), p = h("yAxis", M && C), w = {};
              return O && (w.xAxis = this.getAxisDescriptionText("xAxis")), p && (w.yAxis = this.getAxisDescriptionText("yAxis")), w;
            }, c.prototype.getAxisDescriptionText = function(l) {
              var h = this.chart, C = h[l];
              return h.langFormat("accessibility.axis." + l + "Description" + (C.length > 1 ? "Plural" : "Singular"), { chart: h, names: C.map(function(M) {
                return d(M);
              }), ranges: C.map(function(M) {
                return m(M);
              }), numAxes: C.length });
            }, c.prototype.destroy = function() {
              this.announcer && this.announcer.destroy();
            }, c;
          }(F);
          return o;
        }), at(_, "Accessibility/Components/MenuComponent.js", [_["Core/Chart/Chart.js"], _["Core/Utilities.js"], _["Accessibility/AccessibilityComponent.js"], _["Accessibility/KeyboardNavigationHandler.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/HTMLUtilities.js"]], function(G, F, $, Y, J, Q) {
          var q, U = this && this.__extends || (q = function(m, v) {
            return q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, x) {
              g.__proto__ = x;
            } || function(g, x) {
              for (var E in x)
                x.hasOwnProperty(E) && (g[E] = x[E]);
            }, q(m, v);
          }, function(m, v) {
            function g() {
              this.constructor = m;
            }
            q(m, v), m.prototype = v === null ? Object.create(v) : (g.prototype = v.prototype, new g());
          }), N = F.attr, D = J.getChartTitle, k = J.unhideChartElementFromAT, A = Q.getFakeMouseEvent;
          function b(m) {
            return m.exportSVGElements && m.exportSVGElements[0];
          }
          var d = function(m) {
            function v() {
              return m !== null && m.apply(this, arguments) || this;
            }
            return U(v, m), v.prototype.init = function() {
              var g = this.chart, x = this;
              this.addEvent(g, "exportMenuShown", function() {
                x.onMenuShown();
              }), this.addEvent(g, "exportMenuHidden", function() {
                x.onMenuHidden();
              }), this.createProxyGroup();
            }, v.prototype.onMenuHidden = function() {
              var g = this.chart.exportContextMenu;
              g && g.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
            }, v.prototype.onMenuShown = function() {
              var g = this.chart, x = g.exportContextMenu;
              x && (this.addAccessibleContextMenuAttribs(), k(g, x)), this.setExportButtonExpandedState("true");
            }, v.prototype.setExportButtonExpandedState = function(g) {
              this.exportButtonProxy && this.exportButtonProxy.buttonElement.setAttribute("aria-expanded", g);
            }, v.prototype.onChartRender = function() {
              var g = this.chart, x = g.focusElement, E = g.accessibility;
              this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && x && x === g.exportingGroup && (x.focusBorder ? g.setFocusToElement(x, this.exportButtonProxy.buttonElement) : E && E.keyboardNavigation.tabindexContainer.focus());
            }, v.prototype.proxyMenuButton = function() {
              var g = this.chart, x = this.proxyProvider, E = b(g);
              (function(P) {
                var S = P.options.exporting, u = b(P);
                return !!(S && S.enabled !== !1 && S.accessibility && S.accessibility.enabled && u && u.element);
              })(g) && E && (this.exportButtonProxy = x.addProxyElement("chartMenu", { click: E }, { "aria-label": g.langFormat("accessibility.exporting.menuButtonLabel", { chart: g, chartTitle: D(g) }), "aria-expanded": !1, title: g.options.lang.contextButtonTitle || null }));
            }, v.prototype.createProxyGroup = function() {
              this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu", "div");
            }, v.prototype.addAccessibleContextMenuAttribs = function() {
              var g = this.chart, x = g.exportDivElements;
              if (x && x.length) {
                x.forEach(function(P) {
                  P && (P.tagName !== "LI" || P.children && P.children.length ? P.setAttribute("aria-hidden", "true") : P.setAttribute("tabindex", -1));
                });
                var E = x[0] && x[0].parentNode;
                E && N(E, { "aria-hidden": void 0, "aria-label": g.langFormat("accessibility.exporting.chartMenuLabel", { chart: g }), role: "list" });
              }
            }, v.prototype.getKeyboardNavigation = function() {
              var g = this.keyCodes, x = this.chart, E = this;
              return new Y(x, { keyCodeMap: [[[g.left, g.up], function() {
                return E.onKbdPrevious(this);
              }], [[g.right, g.down], function() {
                return E.onKbdNext(this);
              }], [[g.enter, g.space], function() {
                return E.onKbdClick(this);
              }]], validate: function() {
                return !!x.exporting && x.options.exporting.enabled !== !1 && x.options.exporting.accessibility.enabled !== !1;
              }, init: function() {
                var P = E.exportButtonProxy, S = E.chart.exportingGroup;
                P && S && x.setFocusToElement(S, P.buttonElement);
              }, terminate: function() {
                x.hideExportMenu();
              } });
            }, v.prototype.onKbdPrevious = function(g) {
              for (var x = this.chart, E = x.options.accessibility, P = g.response, S = x.highlightedExportItemIx || 0; S--; )
                if (x.highlightExportItem(S))
                  return P.success;
              return E.keyboardNavigation.wrapAround ? (x.highlightLastExportItem(), P.success) : P.prev;
            }, v.prototype.onKbdNext = function(g) {
              for (var x = this.chart, E = x.options.accessibility, P = g.response, S = (x.highlightedExportItemIx || 0) + 1; S < x.exportDivElements.length; ++S)
                if (x.highlightExportItem(S))
                  return P.success;
              return E.keyboardNavigation.wrapAround ? (x.highlightExportItem(0), P.success) : P.next;
            }, v.prototype.onKbdClick = function(g) {
              var x = this.chart, E = x.exportDivElements[x.highlightedExportItemIx], P = b(x).element;
              return x.openMenu ? this.fakeClickEvent(E) : (this.fakeClickEvent(P), x.highlightExportItem(0)), g.response.success;
            }, v;
          }($);
          return function(m) {
            var v = [];
            function g() {
              var S = b(this);
              if (S) {
                var u = S.element;
                u.onclick && u.onclick(A("click"));
              }
            }
            function x() {
              var S = this, u = S.exportDivElements;
              u && S.exportContextMenu && S.openMenu && (u.forEach(function(y) {
                y && y.className === "highcharts-menu-item" && y.onmouseout && y.onmouseout(A("mouseout"));
              }), S.highlightedExportItemIx = 0, S.exportContextMenu.hideMenu(), S.container.focus());
            }
            function E(S) {
              var u = this.exportDivElements && this.exportDivElements[S], y = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
              if (u && u.tagName === "LI" && (!u.children || !u.children.length)) {
                var s = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
                return u.focus && s && u.focus(), y && y.onmouseout && y.onmouseout(A("mouseout")), u.onmouseover && u.onmouseover(A("mouseover")), this.highlightedExportItemIx = S, !0;
              }
              return !1;
            }
            function P() {
              var S = this;
              if (S.exportDivElements) {
                for (var u = S.exportDivElements.length; u--; )
                  if (S.highlightExportItem(u))
                    return !0;
              }
              return !1;
            }
            m.compose = function(S) {
              if (v.indexOf(S) === -1) {
                v.push(S);
                var u = G.prototype;
                u.hideExportMenu = x, u.highlightExportItem = E, u.highlightLastExportItem = P, u.showExportMenu = g;
              }
            };
          }(d || (d = {})), d;
        }), at(_, "Accessibility/KeyboardNavigation.js", [_["Core/Globals.js"], _["Accessibility/Components/MenuComponent.js"], _["Core/Utilities.js"], _["Accessibility/Utils/EventProvider.js"], _["Accessibility/Utils/HTMLUtilities.js"]], function(G, F, $, Y, J) {
          var Q = G.doc, q = G.win, U = $.addEvent, N = $.fireEvent, D = J.getElement, k = J.simulatedEventTarget, A = function() {
            function b(d, m) {
              this.chart = void 0, this.components = void 0, this.currentModuleIx = NaN, this.eventProvider = void 0, this.exitAnchor = void 0, this.modules = [], this.tabindexContainer = void 0, this.init(d, m);
            }
            return b.prototype.init = function(d, m) {
              var v = this, g = this.eventProvider = new Y();
              this.chart = d, this.components = m, this.modules = [], this.currentModuleIx = 0, this.update(), g.addEvent(this.tabindexContainer, "keydown", function(x) {
                return v.onKeydown(x);
              }), g.addEvent(this.tabindexContainer, "focus", function(x) {
                return v.onFocus(x);
              }), ["mouseup", "touchend"].forEach(function(x) {
                return g.addEvent(Q, x, function(E) {
                  return v.onMouseUp(E);
                });
              }), ["mousedown", "touchstart"].forEach(function(x) {
                return g.addEvent(d.renderTo, x, function() {
                  v.isClickingChart = !0;
                });
              }), g.addEvent(d.renderTo, "mouseover", function() {
                v.pointerIsOverChart = !0;
              }), g.addEvent(d.renderTo, "mouseout", function() {
                v.pointerIsOverChart = !1;
              });
            }, b.prototype.update = function(d) {
              var m = this.chart.options.accessibility, v = m && m.keyboardNavigation, g = this.components;
              this.updateContainerTabindex(), v && v.enabled && d && d.length ? (this.modules = d.reduce(function(x, E) {
                var P = g[E].getKeyboardNavigation();
                return x.concat(P);
              }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
            }, b.prototype.updateExitAnchor = function() {
              var d = "highcharts-end-of-chart-marker-".concat(this.chart.index), m = D(d);
              this.removeExitAnchor(), m ? (this.makeElementAnExitAnchor(m), this.exitAnchor = m) : this.createExitAnchor();
            }, b.prototype.move = function(d) {
              var m = this.modules && this.modules[this.currentModuleIx];
              m && m.terminate && m.terminate(d), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += d;
              var v = this.modules && this.modules[this.currentModuleIx];
              if (v) {
                if (v.validate && !v.validate())
                  return this.move(d);
                if (v.init)
                  return v.init(d), !0;
              }
              return this.currentModuleIx = 0, this.exiting = !0, d > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
            }, b.prototype.onFocus = function(d) {
              var m = this.chart, v = d.relatedTarget && m.container.contains(d.relatedTarget);
              if (!(this.exiting || this.tabbingInBackwards || this.isClickingChart || v)) {
                var g = this.getFirstValidModuleIx();
                g !== null && (this.currentModuleIx = g, this.modules[g].init(1));
              }
              this.exiting = !1;
            }, b.prototype.onMouseUp = function(d) {
              if (delete this.isClickingChart, !this.keyboardReset && d.relatedTarget !== k) {
                var m = this.chart;
                if (!this.pointerIsOverChart) {
                  var v = this.modules && this.modules[this.currentModuleIx || 0];
                  v && v.terminate && v.terminate(), this.currentModuleIx = 0;
                }
                m.focusElement && (m.focusElement.removeFocusBorder(), delete m.focusElement), this.keyboardReset = !0;
              }
            }, b.prototype.onKeydown = function(d) {
              var m, v = d || q.event, g = this.modules && this.modules.length && this.modules[this.currentModuleIx];
              if (this.keyboardReset = !1, this.exiting = !1, g) {
                var x = g.run(v);
                x === g.response.success ? m = !0 : x === g.response.prev ? m = this.move(-1) : x === g.response.next && (m = this.move(1)), m && (v.preventDefault(), v.stopPropagation());
              }
            }, b.prototype.updateContainerTabindex = function() {
              var d, m = this.chart.options.accessibility, v = m && m.keyboardNavigation, g = !(v && v.enabled === !1), x = this.chart, E = x.container;
              x.renderTo.hasAttribute("tabindex") ? (E.removeAttribute("tabindex"), d = x.renderTo) : d = E, this.tabindexContainer = d;
              var P = d.getAttribute("tabindex");
              g && !P ? d.setAttribute("tabindex", "0") : g || x.container.removeAttribute("tabindex");
            }, b.prototype.createExitAnchor = function() {
              var d = this.chart, m = this.exitAnchor = Q.createElement("div");
              d.renderTo.appendChild(m), this.makeElementAnExitAnchor(m);
            }, b.prototype.makeElementAnExitAnchor = function(d) {
              var m = this.tabindexContainer.getAttribute("tabindex") || 0;
              d.setAttribute("class", "highcharts-exit-anchor"), d.setAttribute("tabindex", m), d.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(d);
            }, b.prototype.removeExitAnchor = function() {
              this.exitAnchor && this.exitAnchor.parentNode && (this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor);
            }, b.prototype.addExitAnchorEventsToEl = function(d) {
              var m = this.chart, v = this;
              this.eventProvider.addEvent(d, "focus", function(g) {
                var x = g || q.event, E = !(x.relatedTarget && m.container.contains(x.relatedTarget) || v.exiting);
                if (m.focusElement && delete m.focusElement, E) {
                  if (v.tabbingInBackwards = !0, v.tabindexContainer.focus(), delete v.tabbingInBackwards, x.preventDefault(), v.modules && v.modules.length) {
                    v.currentModuleIx = v.modules.length - 1;
                    var P = v.modules[v.currentModuleIx];
                    P && P.validate && !P.validate() ? v.move(-1) : P && P.init(-1);
                  }
                } else
                  v.exiting = !1;
              });
            }, b.prototype.getFirstValidModuleIx = function() {
              for (var d = this.modules.length, m = 0; m < d; ++m) {
                var v = this.modules[m];
                if (!v.validate || v.validate())
                  return m;
              }
              return null;
            }, b.prototype.destroy = function() {
              this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
            }, b;
          }();
          return function(b) {
            var d = [];
            function m() {
              var g = this;
              N(this, "dismissPopupContent", {}, function() {
                g.tooltip && g.tooltip.hide(0), g.hideExportMenu();
              });
            }
            function v(g) {
              (g.which || g.keyCode) === 27 && G.charts && G.charts.forEach(function(x) {
                x && x.dismissPopupContent && x.dismissPopupContent();
              });
            }
            b.compose = function(g) {
              return F.compose(g), d.indexOf(g) === -1 && (d.push(g), g.prototype.dismissPopupContent = m), d.indexOf(Q) === -1 && (d.push(Q), U(Q, "keydown", v)), g;
            };
          }(A || (A = {})), A;
        }), at(_, "Accessibility/Components/LegendComponent.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Globals.js"], _["Core/Legend/Legend.js"], _["Core/Utilities.js"], _["Accessibility/AccessibilityComponent.js"], _["Accessibility/KeyboardNavigationHandler.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/HTMLUtilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N, D = this && this.__extends || (N = function(a, e) {
            return N = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
              n.__proto__ = o;
            } || function(n, o) {
              for (var i in o)
                o.hasOwnProperty(i) && (n[i] = o[i]);
            }, N(a, e);
          }, function(a, e) {
            function n() {
              this.constructor = a;
            }
            N(a, e), a.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
          }), k = G.animObject, A = F.doc, b = Y.addEvent, d = Y.fireEvent, m = Y.isNumber, v = Y.pick, g = Y.syncTimeout, x = q.getChartTitle, E = U.stripHTMLTagsFromString, P = U.addClass, S = U.removeClass;
          function u(a) {
            var e = a.legend && a.legend.allItems, n = a.options.legend.accessibility || {}, o = a.colorAxis && a.colorAxis.some(function(i) {
              return !i.dataClasses || !i.dataClasses.length;
            });
            return !(!e || !e.length || o || n.enabled === !1);
          }
          function y(a, e) {
            var n = e.legendItem || {};
            e.setState(a ? "hover" : "", !0);
            for (var o = 0, i = ["group", "label", "symbol"]; o < i.length; o++) {
              var c = n[i[o]], l = c && c.element || c;
              l && d(l, a ? "mouseover" : "mouseout");
            }
          }
          var s = function(a) {
            function e() {
              var n = a !== null && a.apply(this, arguments) || this;
              return n.highlightedLegendItemIx = NaN, n.proxyGroup = null, n;
            }
            return D(e, a), e.prototype.init = function() {
              var n = this;
              this.recreateProxies(), this.addEvent($, "afterScroll", function() {
                this.chart === n.chart && (n.proxyProvider.updateGroupProxyElementPositions("legend"), n.updateLegendItemProxyVisibility(), n.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(n.highlightedLegendItemIx));
              }), this.addEvent($, "afterPositionItem", function(o) {
                this.chart === n.chart && this.chart.renderer && n.updateProxyPositionForItem(o.item);
              }), this.addEvent($, "afterRender", function() {
                this.chart === n.chart && this.chart.renderer && n.recreateProxies() && g(function() {
                  return n.proxyProvider.updateGroupProxyElementPositions("legend");
                }, k(v(this.chart.renderer.globalAnimation, !0)).duration);
              });
            }, e.prototype.updateLegendItemProxyVisibility = function() {
              var n, o = this.chart, i = o.legend, c = i.allItems || [], l = i.currentPage || 1, h = i.clipHeight || 0;
              c.forEach(function(C) {
                if (C.a11yProxyElement) {
                  var M = i.pages && i.pages.length, O = C.a11yProxyElement.element, p = !1;
                  if (n = C.legendItem || {}, M) {
                    var w = n.pageIx || 0;
                    p = (n.y || 0) + (n.label ? Math.round(n.label.getBBox().height) : 0) - i.pages[w] > h || w !== l - 1;
                  }
                  p ? o.styledMode ? P(O, "highcharts-a11y-invisible") : O.style.visibility = "hidden" : (S(O, "highcharts-a11y-invisible"), O.style.visibility = "");
                }
              });
            }, e.prototype.onChartRender = function() {
              u(this.chart) || this.removeProxies();
            }, e.prototype.highlightAdjacentLegendPage = function(n) {
              var o = this.chart, i = o.legend, c = (i.currentPage || 1) + n, l = i.pages || [];
              if (c > 0 && c <= l.length)
                for (var h = 0, C = 0, M = i.allItems; C < M.length; C++)
                  ((M[C].legendItem || {}).pageIx || 0) + 1 === c && o.highlightLegendItem(h) && (this.highlightedLegendItemIx = h), ++h;
            }, e.prototype.updateProxyPositionForItem = function(n) {
              n.a11yProxyElement && n.a11yProxyElement.refreshPosition();
            }, e.prototype.recreateProxies = function() {
              var n = A.activeElement, o = this.proxyGroup, i = n && o && o.contains(n);
              return this.removeProxies(), !!u(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), i && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
            }, e.prototype.removeProxies = function() {
              this.proxyProvider.removeGroup("legend");
            }, e.prototype.updateLegendTitle = function() {
              var n = this.chart, o = E((n.legend && n.legend.options.title && n.legend.options.title.text || "").replace(/<br ?\/?>/g, " ")), i = n.langFormat("accessibility.legend.legendLabel" + (o ? "" : "NoTitle"), { chart: n, legendTitle: o, chartTitle: x(n) });
              this.proxyProvider.updateGroupAttrs("legend", { "aria-label": i });
            }, e.prototype.addLegendProxyGroup = function() {
              var n = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
              this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: n });
            }, e.prototype.proxyLegendItems = function() {
              var n, o = this;
              ((this.chart.legend || {}).allItems || []).forEach(function(i) {
                (n = i.legendItem || {}).label && n.label.element && o.proxyLegendItem(i);
              });
            }, e.prototype.proxyLegendItem = function(n) {
              var o = n.legendItem || {};
              if (o.label && o.group) {
                var i = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: E(n.name), item: n }), c = { tabindex: -1, "aria-pressed": n.visible, "aria-label": i }, l = o.group.div ? o.label : o.group;
                n.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: o.label, visual: l.element }, c);
              }
            }, e.prototype.getKeyboardNavigation = function() {
              var n = this.keyCodes, o = this, i = this.chart;
              return new Q(i, { keyCodeMap: [[[n.left, n.right, n.up, n.down], function(c) {
                return o.onKbdArrowKey(this, c);
              }], [[n.enter, n.space], function() {
                return o.onKbdClick(this);
              }], [[n.pageDown, n.pageUp], function(c) {
                var l = c === n.pageDown ? 1 : -1;
                return o.highlightAdjacentLegendPage(l), this.response.success;
              }]], validate: function() {
                return o.shouldHaveLegendNavigation();
              }, init: function() {
                i.highlightLegendItem(0), o.highlightedLegendItemIx = 0;
              }, terminate: function() {
                o.highlightedLegendItemIx = -1, i.legend.allItems.forEach(function(c) {
                  return y(!1, c);
                });
              } });
            }, e.prototype.onKbdArrowKey = function(n, o) {
              var i = this.keyCodes, c = n.response, l = this.chart, h = l.options.accessibility, C = l.legend.allItems.length, M = o === i.left || o === i.up ? -1 : 1;
              return l.highlightLegendItem(this.highlightedLegendItemIx + M) ? (this.highlightedLegendItemIx += M, c.success) : (C > 1 && h.keyboardNavigation.wrapAround && n.init(M), c.success);
            }, e.prototype.onKbdClick = function(n) {
              var o = this.chart.legend.allItems[this.highlightedLegendItemIx];
              return o && o.a11yProxyElement && o.a11yProxyElement.click(), n.response.success;
            }, e.prototype.shouldHaveLegendNavigation = function() {
              if (!u(this.chart))
                return !1;
              var n = this.chart, o = (n.options.legend || {}).accessibility || {};
              return !!(n.legend.display && o.keyboardNavigation && o.keyboardNavigation.enabled);
            }, e;
          }(J);
          return function(a) {
            var e = [];
            function n(i) {
              var c, l, h, C, M = this.legend.allItems, O = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, p = M[i], w = p.legendItem || {};
              if (p) {
                m(O) && M[O] && y(!1, M[O]), l = i, h = ((c = this.legend).allItems[l].legendItem || {}).pageIx, C = c.currentPage, h !== void 0 && h + 1 !== C && c.scroll(1 + h - C);
                var T = w.label, z = p.a11yProxyElement && p.a11yProxyElement.buttonElement;
                return T && T.element && z && this.setFocusToElement(T, z), y(!0, p), !0;
              }
              return !1;
            }
            function o(i) {
              var c = this.chart.options.accessibility, l = i.item;
              c.enabled && l && l.a11yProxyElement && l.a11yProxyElement.buttonElement.setAttribute("aria-pressed", i.visible ? "true" : "false");
            }
            a.compose = function(i, c) {
              e.indexOf(i) === -1 && (e.push(i), i.prototype.highlightLegendItem = n), e.indexOf(c) === -1 && (e.push(c), b(c, "afterColorizeItem", o));
            };
          }(s || (s = {})), s;
        }), at(_, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [_["Accessibility/Components/AnnotationsA11y.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Core/FormatUtilities.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q = G.getPointAnnotationTexts, q = F.getAxisDescription, U = F.getSeriesFirstPointElement, N = F.getSeriesA11yElement, D = F.unhideChartElementFromAT, k = $.format, A = $.numberFormat, b = Y.reverseChildNodes, d = Y.stripHTMLTagsFromString, m = J.find, v = J.isNumber, g = J.pick, x = J.defined;
          function E(e) {
            var n = e.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
            return !!(n !== !1 && e.points && e.points.length >= n);
          }
          function P(e, n) {
            var o = e.series, i = o.chart, c = i.options.accessibility.point || {}, l = o.options.accessibility && o.options.accessibility.point || {}, h = o.tooltipOptions || {}, C = i.options.lang;
            return v(n) ? A(n, l.valueDecimals || c.valueDecimals || h.valueDecimals || -1, C.decimalPoint, C.accessibility.thousandsSep || C.thousandsSep) : n;
          }
          function S(e, n) {
            var o = e[n];
            return e.chart.langFormat("accessibility.series." + n + "Description", { name: q(o), series: e });
          }
          function u(e) {
            var n = e.series, o = n.chart.options.accessibility.point || {}, i = n.chart.options.accessibility && n.chart.options.accessibility.point || {}, c = n.tooltipOptions || {}, l = i.valuePrefix || o.valuePrefix || c.valuePrefix || "", h = i.valueSuffix || o.valueSuffix || c.valueSuffix || "", C = P(e, e[e.value !== void 0 ? "value" : "y"]);
            return e.isNull ? n.chart.langFormat("accessibility.series.nullPointValue", { point: e }) : n.pointArrayMap ? function(M, O, p) {
              var w = O || "", T = p || "";
              return M.series.pointArrayMap.reduce(function(z, W) {
                return z + (z.length ? ", " : "") + function(L) {
                  var I = P(M, g(M[L], M.options[L]));
                  return L + ": " + w + I + T;
                }(W);
              }, "");
            }(e, l, h) : l + C + h;
          }
          function y(e) {
            var n = e.series, o = n.chart.series.length > 1 || n.options.name, i = function(O) {
              var p = O.series, w = p.chart, T = p.options.accessibility, z = T && T.point && T.point.valueDescriptionFormat || w.options.accessibility.point.valueDescriptionFormat, W = g(p.xAxis && p.xAxis.options.accessibility && p.xAxis.options.accessibility.enabled, !w.angular), L = W ? function(j) {
                var Z = function(ot) {
                  var it = ot.series, pt = it.chart, mt = it.options.accessibility && it.options.accessibility.point || {}, Ct = pt.options.accessibility.point || {}, kt = it.xAxis && it.xAxis.dateTime;
                  if (kt) {
                    var Lt = kt.getXDateFormat(ot.x || 0, pt.options.tooltip.dateTimeLabelFormats), Tt = mt.dateFormatter && mt.dateFormatter(ot) || Ct.dateFormatter && Ct.dateFormatter(ot) || mt.dateFormat || Ct.dateFormat || Lt;
                    return pt.time.dateFormat(Tt, ot.x || 0, void 0);
                  }
                }(j), V = (j.series.xAxis || {}).categories && x(j.category) && ("" + j.category).replace("<br/>", " "), X = x(j.id) && ("" + j.id).indexOf("highcharts-") < 0, et = "x, " + j.x;
                return j.name || Z || V || (X ? j.id : et);
              }(O) : "", I = { point: O, index: x(O.index) ? O.index + 1 : "", xDescription: L, value: u(O), separator: W ? ", " : "" };
              return k(z, I, w);
            }(e), c = e.options && e.options.accessibility && e.options.accessibility.description, l = c ? " " + c : "", h = o ? " " + n.name + "." : "", C = function(O) {
              var p = O.series.chart, w = Q(O), T = { point: O, annotations: w };
              return w.length ? p.langFormat("accessibility.series.pointAnnotationsDescription", T) : "";
            }(e), M = C ? " " + C : "";
            return e.accessibility = e.accessibility || {}, e.accessibility.valueDescription = i, i + l + h + M;
          }
          function s(e) {
            var n = function(c) {
              var l = c.options.accessibility || {};
              return !E(c) && !l.exposeAsGroupOnly;
            }(e), o = function(c) {
              var l = c.chart.options.accessibility.keyboardNavigation.seriesNavigation;
              return !(!c.points || !(c.points.length < l.pointNavigationEnabledThreshold || l.pointNavigationEnabledThreshold === !1));
            }(e), i = e.chart.options.accessibility.point.describeNull;
            (n || o) && e.points.forEach(function(c) {
              var l = c.graphic && c.graphic.element || function(C) {
                var M = C.series, O = M && M.chart, p = M && M.is("sunburst"), w = C.isNull, T = O && O.options.accessibility.point.describeNull;
                return w && !p && T;
              }(c) && function(C) {
                var M = C.series, O = function(z) {
                  var W = z.index;
                  return z.series && z.series.data && x(W) && m(z.series.data, function(L) {
                    return !!(L && L.index !== void 0 && L.index > W && L.graphic && L.graphic.element);
                  }) || null;
                }(C), p = O && O.graphic, w = p ? p.parentGroup : M.graph || M.group, T = function(z, W) {
                  var L = z.series.chart.renderer.rect(W.x, W.y, 1, 1);
                  return L.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), L;
                }(C, O ? { x: g(C.plotX, O.plotX, 0), y: g(C.plotY, O.plotY, 0) } : { x: g(C.plotX, 0), y: g(C.plotY, 0) });
                if (w && w.element)
                  return C.graphic = T, C.hasMockGraphic = !0, T.add(w), w.element.insertBefore(T.element, p ? p.element : null), T.element;
              }(c), h = c.options && c.options.accessibility && c.options.accessibility.enabled === !1;
              if (l) {
                if (c.isNull && !i)
                  return void l.setAttribute("aria-hidden", !0);
                l.setAttribute("tabindex", "-1"), e.chart.styledMode || (l.style.outline = "none"), n && !h ? function(C, M) {
                  var O = C.series, p = O.chart.options.accessibility.point || {}, w = O.options.accessibility && O.options.accessibility.point || {}, T = d(w.descriptionFormatter && w.descriptionFormatter(C) || p.descriptionFormatter && p.descriptionFormatter(C) || y(C));
                  M.setAttribute("role", "img"), M.setAttribute("aria-label", T);
                }(c, l) : l.setAttribute("aria-hidden", !0);
              }
            });
          }
          function a(e) {
            var n = e.chart, o = n.types || [], i = function(z) {
              var W = (z.options.accessibility || {}).description;
              return W && z.chart.langFormat("accessibility.series.description", { description: W, series: z }) || "";
            }(e), c = function(z) {
              return n[z] && n[z].length > 1 && e[z];
            }, l = e.index + 1, h = S(e, "xAxis"), C = S(e, "yAxis"), M = { seriesNumber: l, series: e, chart: n }, O = o.length > 1 ? "Combination" : "", p = n.langFormat("accessibility.series.summary." + e.type + O, M) || n.langFormat("accessibility.series.summary.default" + O, M), w = (c("yAxis") ? " " + C + "." : "") + (c("xAxis") ? " " + h + "." : ""), T = n.options.accessibility.series.descriptionFormat || "";
            return k(T, { seriesDescription: p, authorDescription: i ? " " + i : "", axisDescription: w, series: e, chart: n, seriesNumber: l }, void 0);
          }
          return { defaultPointDescriptionFormatter: y, defaultSeriesDescriptionFormatter: a, describeSeries: function(e) {
            var n = e.chart, o = U(e), i = N(e), c = n.is3d && n.is3d();
            i && (i.lastChild !== o || c || b(i), s(e), D(n, i), function(l) {
              var h = l.chart, C = h.options.chart, M = C.options3d && C.options3d.enabled, O = h.series.length > 1, p = h.options.accessibility.series.describeSingleSeries, w = (l.options.accessibility || {}).exposeAsGroupOnly;
              return !(M && O) && (O || p || w || E(l));
            }(e) ? function(l, h) {
              var C = l.options.accessibility || {}, M = l.chart.options.accessibility, O = M.landmarkVerbosity;
              C.exposeAsGroupOnly ? h.setAttribute("role", "img") : O === "all" ? h.setAttribute("role", "region") : h.setAttribute("role", "group"), h.setAttribute("tabindex", "-1"), l.chart.styledMode || (h.style.outline = "none"), h.setAttribute("aria-label", d(M.series.descriptionFormatter && M.series.descriptionFormatter(l) || a(l)));
            }(e, i) : i.removeAttribute("aria-label"));
          } };
        }), at(_, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [_["Core/Globals.js"], _["Core/Utilities.js"], _["Accessibility/Utils/Announcer.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/EventProvider.js"], _["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(G, F, $, Y, J, Q) {
          var q = F.addEvent, U = F.defined, N = Y.getChartTitle, D = Q.defaultPointDescriptionFormatter, k = Q.defaultSeriesDescriptionFormatter;
          function A(d) {
            return !!d.options.accessibility.announceNewData.enabled;
          }
          var b = function() {
            function d(m) {
              this.announcer = void 0, this.dirty = { allSeries: {} }, this.eventProvider = void 0, this.lastAnnouncementTime = 0, this.chart = m;
            }
            return d.prototype.init = function() {
              var m = this.chart, v = m.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
              this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new J(), this.announcer = new $(m, v), this.addEventListeners();
            }, d.prototype.destroy = function() {
              this.eventProvider.removeAddedEvents(), this.announcer.destroy();
            }, d.prototype.addEventListeners = function() {
              var m = this, v = this.chart, g = this.eventProvider;
              g.addEvent(v, "afterApplyDrilldown", function() {
                m.lastAnnouncementTime = 0;
              }), g.addEvent(v, "afterAddSeries", function(x) {
                m.onSeriesAdded(x.series);
              }), g.addEvent(v, "redraw", function() {
                m.announceDirtyData();
              });
            }, d.prototype.onSeriesAdded = function(m) {
              A(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[m.name + m.index] = m, this.dirty.newSeries = U(this.dirty.newSeries) ? void 0 : m);
            }, d.prototype.announceDirtyData = function() {
              var m, v, g = this.chart, x = this;
              if (g.options.accessibility.announceNewData && this.dirty.hasDirty) {
                var E = this.dirty.newPoint;
                E && (E = (v = (m = E).series.data.filter(function(P) {
                  return m.x === P.x && m.y === P.y;
                })).length === 1 ? v[0] : m), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map(function(P) {
                  return x.dirty.allSeries[P];
                }), this.dirty.newSeries, E), this.dirty = { allSeries: {} };
              }
            }, d.prototype.queueAnnouncement = function(m, v, g) {
              var x, E, P, S = this, u = this.chart.options.accessibility.announceNewData;
              if (u.enabled) {
                var y = +/* @__PURE__ */ new Date(), s = y - this.lastAnnouncementTime, a = Math.max(0, u.minAnnounceInterval - s), e = (x = this.queuedAnnouncement && this.queuedAnnouncement.series, E = m, P = (x || []).concat(E || []).reduce(function(o, i) {
                  return o[i.name + i.index] = i, o;
                }, {}), Object.keys(P).map(function(o) {
                  return P[o];
                })), n = this.buildAnnouncementMessage(e, v, g);
                n && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: y, message: n, series: e }, this.queuedAnnouncementTimer = setTimeout(function() {
                  S && S.announcer && (S.lastAnnouncementTime = +/* @__PURE__ */ new Date(), S.announcer.announce(S.queuedAnnouncement.message), delete S.queuedAnnouncement, delete S.queuedAnnouncementTimer);
                }, a));
              }
            }, d.prototype.buildAnnouncementMessage = function(m, v, g) {
              var x = this.chart, E = x.options.accessibility.announceNewData;
              if (E.announcementFormatter) {
                var P = E.announcementFormatter(m, v, g);
                if (P !== !1)
                  return P.length ? P : null;
              }
              var S = G.charts && G.charts.length > 1 ? "Multiple" : "Single", u = v ? "newSeriesAnnounce" + S : g ? "newPointAnnounce" + S : "newDataAnnounce", y = N(x);
              return x.langFormat("accessibility.announceNewData." + u, { chartTitle: y, seriesDesc: v ? k(v) : null, pointDesc: g ? D(g) : null, point: g, series: v });
            }, d;
          }();
          return function(d) {
            function m(g) {
              var x = this.chart, E = this.newDataAnnouncer;
              E && E.chart === x && A(x) && (E.dirty.newPoint = U(E.dirty.newPoint) ? void 0 : g.point);
            }
            function v() {
              var g = this.chart, x = this.newDataAnnouncer;
              x && x.chart === g && A(g) && (x.dirty.hasDirty = !0, x.dirty.allSeries[this.name + this.index] = this);
            }
            d.composedClasses = [], d.compose = function(g) {
              d.composedClasses.indexOf(g) === -1 && (d.composedClasses.push(g), q(g, "addPoint", m), q(g, "updatedData", v));
            };
          }(b || (b = {})), b;
        }), at(_, "Accessibility/ProxyElement.js", [_["Core/Globals.js"], _["Core/Utilities.js"], _["Accessibility/Utils/EventProvider.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/HTMLUtilities.js"]], function(G, F, $, Y, J) {
          var Q = G.doc, q = F.attr, U = F.css, N = F.merge, D = Y.fireEventOnWrappedOrUnwrappedElement, k = J.cloneMouseEvent, A = J.cloneTouchEvent, b = J.getFakeMouseEvent, d = J.removeElement;
          return function() {
            function m(v, g, x, E) {
              this.chart = v, this.target = g, this.groupType = x;
              var P = x === "ul";
              this.eventProvider = new $();
              var S = P ? Q.createElement("li") : null, u = this.buttonElement = Q.createElement("button");
              v.styledMode || this.hideButtonVisually(u), S ? (P && !v.styledMode && (S.style.listStyle = "none"), S.appendChild(u), this.element = S) : this.element = u, this.updateTarget(g, E);
            }
            return m.prototype.click = function() {
              var v = this.getTargetPosition();
              v.x += v.width / 2, v.y += v.height / 2;
              var g = b("click", v);
              D(this.target.click, g);
            }, m.prototype.updateTarget = function(v, g) {
              this.target = v, this.updateCSSClassName();
              var x = g || {};
              Object.keys(x).forEach(function(E) {
                x[E] === null && delete x[E];
              }), q(this.buttonElement, N({ "aria-label": this.getTargetAttr(v.click, "aria-label") }, x)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToButton(this.buttonElement, v.click), this.refreshPosition();
            }, m.prototype.refreshPosition = function() {
              var v = this.getTargetPosition();
              U(this.buttonElement, { width: (v.width || 1) + "px", height: (v.height || 1) + "px", left: (Math.round(v.x) || 0) + "px", top: (Math.round(v.y) || 0) + "px" });
            }, m.prototype.remove = function() {
              this.eventProvider.removeAddedEvents(), d(this.element);
            }, m.prototype.updateCSSClassName = function() {
              var v = function(S) {
                return S.indexOf("highcharts-no-tooltip") > -1;
              }, g = this.chart.legend, x = g.group && g.group.div, E = v(x && x.className || ""), P = v(this.getTargetAttr(this.target.click, "class") || "");
              this.buttonElement.className = E || P ? "highcharts-a11y-proxy-button highcharts-no-tooltip" : "highcharts-a11y-proxy-button";
            }, m.prototype.addProxyEventsToButton = function(v, g) {
              var x = this;
              ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach(function(E) {
                var P = E.indexOf("touch") === 0;
                x.eventProvider.addEvent(v, E, function(S) {
                  var u = P ? A(S) : k(S);
                  g && D(g, u), S.stopPropagation(), P || S.preventDefault();
                }, { passive: !1 });
              });
            }, m.prototype.hideButtonVisually = function(v) {
              U(v, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
            }, m.prototype.getTargetPosition = function() {
              var v = this.target.click, g = v.element ? v.element : v, x = this.target.visual || g;
              if (this.chart.renderTo && x && x.getBoundingClientRect) {
                var E = x.getBoundingClientRect(), P = this.chart.pointer.getChartPosition();
                return { x: (E.left - P.left) / P.scaleX, y: (E.top - P.top) / P.scaleY, width: E.right / P.scaleX - E.left / P.scaleX, height: E.bottom / P.scaleY - E.top / P.scaleY };
              }
              return { x: 0, y: 0, width: 1, height: 1 };
            }, m.prototype.getTargetAttr = function(v, g) {
              return v.element ? v.element.getAttribute(g) : v.getAttribute(g);
            }, m;
          }();
        }), at(_, "Accessibility/ProxyProvider.js", [_["Core/Globals.js"], _["Core/Utilities.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/DOMElementProvider.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Accessibility/ProxyElement.js"]], function(G, F, $, Y, J, Q) {
          var q = G.doc, U = F.attr, N = F.css, D = $.unhideChartElementFromAT, k = J.removeElement, A = J.removeChildNodes;
          return function() {
            function b(d) {
              this.chart = d, this.domElementProvider = new Y(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
            }
            return b.prototype.addProxyElement = function(d, m, v) {
              var g = this.groups[d];
              if (!g)
                throw new Error("ProxyProvider.addProxyElement: Invalid group key " + d);
              var x = new Q(this.chart, m, g.type, v);
              return g.proxyContainerElement.appendChild(x.element), g.proxyElements.push(x), x;
            }, b.prototype.addGroup = function(d, m, v) {
              var g = this.groups[d];
              if (g)
                return g.groupElement;
              var x, E = this.domElementProvider.createElement(m);
              return v && v.role && m !== "div" ? (x = this.domElementProvider.createElement("div")).appendChild(E) : x = E, x.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + d.replace(/\W/g, "-"), this.groups[d] = { proxyContainerElement: E, groupElement: x, type: m, proxyElements: [] }, U(x, v || {}), m === "ul" && E.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(x), this.updateGroupOrder(this.groupOrder), x;
            }, b.prototype.updateGroupAttrs = function(d, m) {
              var v = this.groups[d];
              if (!v)
                throw new Error("ProxyProvider.updateGroupAttrs: Invalid group key " + d);
              U(v.groupElement, m);
            }, b.prototype.updateGroupOrder = function(d) {
              var m = this;
              if (this.groupOrder = d.slice(), !this.isDOMOrderGroupOrder()) {
                var v = d.indexOf("series"), g = v > -1 ? d.slice(0, v) : d, x = v > -1 ? d.slice(v + 1) : [], E = q.activeElement;
                ["before", "after"].forEach(function(P) {
                  var S = m[P === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"], u = P === "before" ? g : x;
                  A(S), u.forEach(function(y) {
                    var s = m.groups[y];
                    s && S.appendChild(s.groupElement);
                  });
                }), (this.beforeChartProxyPosContainer.contains(E) || this.afterChartProxyPosContainer.contains(E)) && E && E.focus && E.focus();
              }
            }, b.prototype.clearGroup = function(d) {
              var m = this.groups[d];
              if (!m)
                throw new Error("ProxyProvider.clearGroup: Invalid group key " + d);
              A(m.proxyContainerElement);
            }, b.prototype.removeGroup = function(d) {
              var m = this.groups[d];
              m && (k(m.groupElement), delete this.groups[d]);
            }, b.prototype.update = function() {
              this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
            }, b.prototype.updateProxyElementPositions = function() {
              Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
            }, b.prototype.updateGroupProxyElementPositions = function(d) {
              var m = this.groups[d];
              m && m.proxyElements.forEach(function(v) {
                return v.refreshPosition();
              });
            }, b.prototype.destroy = function() {
              this.domElementProvider.destroyCreatedElements();
            }, b.prototype.createProxyPosContainer = function(d) {
              var m = this.domElementProvider.createElement("div");
              return m.setAttribute("aria-hidden", "false"), m.className = "highcharts-a11y-proxy-container" + (d ? "-" + d : ""), N(m, { top: "0", left: "0" }), this.chart.styledMode || (m.style.whiteSpace = "nowrap", m.style.position = "absolute"), m;
            }, b.prototype.getCurrentGroupOrderInDOM = function() {
              var d = this, m = function(E) {
                for (var P = Object.keys(d.groups), S = P.length; S--; ) {
                  var u = P[S], y = d.groups[u];
                  if (y && E === y.groupElement)
                    return u;
                }
              }, v = function(E) {
                for (var P = [], S = E.children, u = 0; u < S.length; ++u) {
                  var y = m(S[u]);
                  y && P.push(y);
                }
                return P;
              }, g = v(this.beforeChartProxyPosContainer), x = v(this.afterChartProxyPosContainer);
              return g.push("series"), g.concat(x);
            }, b.prototype.isDOMOrderGroupOrder = function() {
              var d = this, m = this.getCurrentGroupOrderInDOM(), v = this.groupOrder.filter(function(x) {
                return x === "series" || !!d.groups[x];
              }), g = m.length;
              if (g !== v.length)
                return !1;
              for (; g--; )
                if (m[g] !== v[g])
                  return !1;
              return !0;
            }, b.prototype.updatePosContainerPositions = function() {
              var d = this.chart;
              if (!d.renderer.forExport) {
                var m = d.renderer.box;
                d.container.insertBefore(this.afterChartProxyPosContainer, m.nextSibling), d.container.insertBefore(this.beforeChartProxyPosContainer, m), D(this.chart, this.afterChartProxyPosContainer), D(this.chart, this.beforeChartProxyPosContainer);
              }
            }, b;
          }();
        }), at(_, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
          return { lang: { rangeSelectorZoom: "Zoom", rangeSelectorFrom: "", rangeSelectorTo: "→" }, rangeSelector: { allButtonsEnabled: !1, buttons: void 0, buttonSpacing: 5, dropdown: "responsive", enabled: void 0, verticalAlign: "top", buttonTheme: { width: 28, height: 18, padding: 2, zIndex: 7 }, floating: !1, x: 0, y: 0, height: void 0, inputBoxBorderColor: "none", inputBoxHeight: 17, inputBoxWidth: void 0, inputDateFormat: "%b %e, %Y", inputDateParser: void 0, inputEditDateFormat: "%Y-%m-%d", inputEnabled: !0, inputPosition: { align: "right", x: 0, y: 0 }, inputSpacing: 5, selected: void 0, buttonPosition: { align: "left", x: 0, y: 0 }, inputStyle: { color: "#335cad", cursor: "pointer" }, labelStyle: { color: "#666666" } } };
        }), at(_, "Stock/RangeSelector/RangeSelectorComposition.js", [_["Core/Defaults.js"], _["Stock/RangeSelector/RangeSelectorDefaults.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = G.defaultOptions, Q = G.setOptions, q = $.addEvent, U = $.defined, N = $.extend, D = $.find, k = $.isNumber, A = $.merge, b = $.pick, d = [], m = [];
          function v() {
            var s, a, e = this.range, n = e.type, o = this.max, i = this.chart.time, c = function(h, C) {
              var M = n === "year" ? "FullYear" : "Month", O = new i.Date(h), p = i.get(M, O);
              return i.set(M, O, p + C), p === i.get(M, O) && i.set("Date", O, 0), O.getTime() - h;
            };
            k(e) ? (s = o - e, a = e) : e && (s = o + c(o, -(e.count || 1)), this.chart && (this.chart.fixedRange = o - s));
            var l = b(this.dataMin, Number.MIN_VALUE);
            return k(s) || (s = l), s <= l && (s = l, a === void 0 && (a = c(s, e.count)), this.newMax = Math.min(s + a, b(this.dataMax, Number.MAX_VALUE))), k(o) ? !k(e) && e && e._offsetMin && (s += e._offsetMin) : s = void 0, s;
          }
          function g() {
            this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new Y(this));
          }
          function x() {
            var s = this, a = s.axes, e = s.rangeSelector;
            if (e) {
              k(e.deferredYTDClick) && (e.clickButton(e.deferredYTDClick), delete e.deferredYTDClick), a.forEach(function(o) {
                o.updateNames(), o.setScale();
              }), s.getAxisMargins(), e.render();
              var n = e.options.verticalAlign;
              e.options.floating || (n === "bottom" ? this.extraBottomMargin = !0 : n !== "middle" && (this.extraTopMargin = !0));
            }
          }
          function E(s) {
            var a, e, n, o, i = s.rangeSelector, c = function() {
              i && (a = s.xAxis[0].getExtremes(), e = s.legend, o = i && i.options.verticalAlign, k(a.min) && i.render(a.min, a.max), e.display && o === "top" && o === e.options.verticalAlign && (n = A(s.spacingBox), e.options.layout === "vertical" ? n.y = s.plotTop : n.y += i.getHeight(), e.group.placed = !1, e.align(n)));
            };
            i && (D(d, function(l) {
              return l[0] === s;
            }) || d.push([s, [q(s.xAxis[0], "afterSetExtremes", function(l) {
              i && i.render(l.min, l.max);
            }), q(s, "redraw", c)]]), c());
          }
          function P() {
            for (var s = 0, a = d.length; s < a; ++s) {
              var e = d[s];
              if (e[0] === this)
                return e[1].forEach(function(n) {
                  return n();
                }), void d.splice(s, 1);
            }
          }
          function S() {
            var s = this.rangeSelector;
            if (s) {
              var a = s.getHeight();
              this.extraTopMargin && (this.plotTop += a), this.extraBottomMargin && (this.marginBottom += a);
            }
          }
          function u() {
            var s = this.rangeSelector;
            if (s && !s.options.floating) {
              s.render();
              var a = s.options.verticalAlign;
              a === "bottom" ? this.extraBottomMargin = !0 : a !== "middle" && (this.extraTopMargin = !0);
            }
          }
          function y(s) {
            var a = s.options.rangeSelector, e = this.extraBottomMargin, n = this.extraTopMargin, o = this.rangeSelector;
            if (a && a.enabled && !U(o) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = o = new Y(this)), this.extraBottomMargin = !1, this.extraTopMargin = !1, o) {
              E(this);
              var i = a && a.verticalAlign || o.options && o.options.verticalAlign;
              o.options.floating || (i === "bottom" ? this.extraBottomMargin = !0 : i !== "middle" && (this.extraTopMargin = !0)), this.extraBottomMargin === e && this.extraTopMargin === n || (this.isDirtyBox = !0);
            }
          }
          return { compose: function(s, a, e) {
            Y = e, m.indexOf(s) === -1 && (m.push(s), s.prototype.minFromRange = v), m.indexOf(a) === -1 && (m.push(a), q(a, "afterGetContainer", g), q(a, "beforeRender", x), q(a, "destroy", P), q(a, "getMargins", S), q(a, "render", u), q(a, "update", y), a.prototype.callbacks.push(E)), m.indexOf(Q) === -1 && (N(J, { rangeSelector: F.rangeSelector }), N(J.lang, F.lang));
          } };
        }), at(_, "Stock/RangeSelector/RangeSelector.js", [_["Core/Axis/Axis.js"], _["Core/Defaults.js"], _["Core/Globals.js"], _["Stock/RangeSelector/RangeSelectorComposition.js"], _["Core/Renderer/SVG/SVGElement.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q = F.defaultOptions, U = Q.addEvent, N = Q.createElement, D = Q.css, k = Q.defined, A = Q.destroyObjectProperties, b = Q.discardElement, d = Q.extend, m = Q.fireEvent, v = Q.isNumber, g = Q.merge, x = Q.objectEach, E = Q.pad, P = Q.pick, S = Q.pInt, u = Q.splat, y = function() {
            function s(a) {
              this.buttons = void 0, this.buttonOptions = s.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.options = void 0, this.chart = a, this.init(a);
            }
            return s.compose = function(a, e) {
              Y.compose(a, e, s);
            }, s.prototype.clickButton = function(a, e) {
              var n, o, i, c, l, h, C, M = this, O = M.chart, p = M.buttonOptions[a], w = O.xAxis[0], T = O.scroller && O.scroller.getUnionExtremes() || w || {}, z = p.type, W = p.dataGrouping, L = T.dataMin, I = T.dataMax, j = w && Math.round(Math.min(w.max, P(I, w.max))), Z = p._range, V = !0;
              if (L !== null && I !== null) {
                if (O.fixedRange = Z, M.setSelected(a), W && (this.forcedDataGrouping = !0, G.prototype.setDataGrouping.call(w || { chart: this.chart }, W, !1), this.frozenStates = p.preserveDataGrouping), z === "month" || z === "year")
                  w ? (h = { range: p, max: j, chart: O, dataMin: L, dataMax: I }, n = w.minFromRange.call(h), v(h.newMax) && (j = h.newMax), V = !1) : Z = p;
                else if (Z)
                  n = Math.max(j - Z, L), j = Math.min(n + Z, I), V = !1;
                else if (z === "ytd") {
                  if (!w)
                    return void (M.deferredYTDClick = a);
                  I !== void 0 && L !== void 0 || (L = Number.MAX_VALUE, I = Number.MIN_VALUE, O.series.forEach(function(X) {
                    var et = X.xData;
                    et && (L = Math.min(et[0], L), I = Math.max(et[et.length - 1], I));
                  }), e = !1), n = i = (C = M.getYTDExtremes(I, L, O.time.useUTC)).min, j = C.max;
                } else
                  z === "all" && w && (O.navigator && O.navigator.baseSeries[0] && (O.navigator.baseSeries[0].xAxis.options.range = void 0), n = L, j = I);
                V && p._offsetMin && k(n) && (n += p._offsetMin), p._offsetMax && k(j) && (j += p._offsetMax), this.dropdown && (this.dropdown.selectedIndex = a + 1), w ? w.setExtremes(n, j, P(e, !0), void 0, { trigger: "rangeSelectorButton", rangeSelectorButton: p }) : (o = u(O.options.xAxis)[0], l = o.range, o.range = Z, c = o.min, o.min = i, U(O, "load", function() {
                  o.range = l, o.min = c;
                })), m(this, "afterBtnClick");
              }
            }, s.prototype.setSelected = function(a) {
              this.selected = this.options.selected = a;
            }, s.prototype.init = function(a) {
              var e = this, n = a.options.rangeSelector, o = n.buttons || e.defaultButtons.slice(), i = n.selected, c = function() {
                var l = e.minInput, h = e.maxInput;
                l && l.blur && m(l, "blur"), h && h.blur && m(h, "blur");
              };
              e.chart = a, e.options = n, e.buttons = [], e.buttonOptions = o, this.eventsToUnbind = [], this.eventsToUnbind.push(U(a.container, "mousedown", c)), this.eventsToUnbind.push(U(a, "resize", c)), o.forEach(e.computeButtonRange), i !== void 0 && o[i] && this.clickButton(i, !1), this.eventsToUnbind.push(U(a, "load", function() {
                a.xAxis && a.xAxis[0] && U(a.xAxis[0], "setExtremes", function(l) {
                  this.max - this.min !== a.fixedRange && l.trigger !== "rangeSelectorButton" && l.trigger !== "updatedData" && e.forcedDataGrouping && !e.frozenStates && this.setDataGrouping(!1, !1);
                });
              }));
            }, s.prototype.updateButtonStates = function() {
              var a = this, e = this.chart, n = this.dropdown, o = e.xAxis[0], i = Math.round(o.max - o.min), c = !o.hasVisibleSeries, l = 864e5, h = e.scroller && e.scroller.getUnionExtremes() || o, C = h.dataMin, M = h.dataMax, O = a.getYTDExtremes(M, C, e.time.useUTC), p = O.min, w = O.max, T = a.selected, z = a.options.allButtonsEnabled, W = a.buttons, L = v(T);
              a.buttonOptions.forEach(function(I, j) {
                var Z = I._range, V = I.type, X = I.count || 1, et = W[j], ot = I._offsetMax - I._offsetMin, it = j === T, pt = Z > M - C, mt = Z < o.minRange, Ct = 0, kt = !1, Lt = !1, Tt = Z === i;
                (V === "month" || V === "year") && i + 36e5 >= { month: 28, year: 365 }[V] * l * X - ot && i - 36e5 <= { month: 31, year: 366 }[V] * l * X + ot ? Tt = !0 : V === "ytd" ? (Tt = w - p + ot === i, kt = !it) : V === "all" && (Tt = o.max - o.min >= M - C, Lt = !it && L && Tt);
                var xt = !z && (pt || mt || Lt || c), ct = it && Tt || Tt && !L && !kt || it && a.frozenStates;
                xt ? Ct = 3 : ct && (L = !0, Ct = 2), et.state !== Ct && (et.setState(Ct), n && (n.options[j + 1].disabled = xt, Ct === 2 && (n.selectedIndex = j + 1)), Ct === 0 && T === j && a.setSelected());
              });
            }, s.prototype.computeButtonRange = function(a) {
              var e = a.type, n = a.count || 1, o = { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5 };
              o[e] ? a._range = o[e] * n : e !== "month" && e !== "year" || (a._range = 24 * { month: 30, year: 365 }[e] * 36e5 * n), a._offsetMin = P(a.offsetMin, 0), a._offsetMax = P(a.offsetMax, 0), a._range += a._offsetMax - a._offsetMin;
            }, s.prototype.getInputValue = function(a) {
              var e = a === "min" ? this.minInput : this.maxInput, n = this.chart.options.rangeSelector, o = this.chart.time;
              return e ? (e.type === "text" && n.inputDateParser || this.defaultInputDateParser)(e.value, o.useUTC, o) : 0;
            }, s.prototype.setInputValue = function(a, e) {
              var n = this.options, o = this.chart.time, i = a === "min" ? this.minInput : this.maxInput, c = a === "min" ? this.minDateBox : this.maxDateBox;
              if (i) {
                var l = i.getAttribute("data-hc-time"), h = k(l) ? Number(l) : void 0;
                if (k(e)) {
                  var C = h;
                  k(C) && i.setAttribute("data-hc-time-previous", C), i.setAttribute("data-hc-time", e), h = e;
                }
                i.value = o.dateFormat(this.inputTypeFormats[i.type] || n.inputEditDateFormat, h), c && c.attr({ text: o.dateFormat(n.inputDateFormat, h) });
              }
            }, s.prototype.setInputExtremes = function(a, e, n) {
              var o = a === "min" ? this.minInput : this.maxInput;
              if (o) {
                var i = this.inputTypeFormats[o.type], c = this.chart.time;
                if (i) {
                  var l = c.dateFormat(i, e);
                  o.min !== l && (o.min = l);
                  var h = c.dateFormat(i, n);
                  o.max !== h && (o.max = h);
                }
              }
            }, s.prototype.showInput = function(a) {
              var e = a === "min" ? this.minDateBox : this.maxDateBox, n = a === "min" ? this.minInput : this.maxInput;
              if (n && e && this.inputGroup) {
                var o = n.type === "text", i = this.inputGroup, c = i.translateX, l = i.translateY, h = this.options.inputBoxWidth;
                D(n, { width: o ? e.width + (h ? -2 : 20) + "px" : "auto", height: o ? e.height - 2 + "px" : "auto", border: "2px solid silver" }), D(n, o && h ? { left: c + e.x + "px", top: l + "px" } : { left: Math.min(Math.round(e.x + c - (n.offsetWidth - e.width) / 2), this.chart.chartWidth - n.offsetWidth) + "px", top: l - (n.offsetHeight - e.height) / 2 + "px" });
              }
            }, s.prototype.hideInput = function(a) {
              var e = a === "min" ? this.minInput : this.maxInput;
              e && D(e, { top: "-9999em", border: 0, width: "1px", height: "1px" });
            }, s.prototype.defaultInputDateParser = function(a, e, n) {
              var o, i = a.split("/").join("-").split(" ").join("T");
              if (i.indexOf("T") === -1 && (i += "T00:00"), e)
                i += "Z";
              else if ($.isSafari && (!((o = i).length > 6) || o.lastIndexOf("-") !== o.length - 6 && o.lastIndexOf("+") !== o.length - 6)) {
                var c = new Date(i).getTimezoneOffset() / 60;
                i += c <= 0 ? "+".concat(E(-c), ":00") : "-".concat(E(c), ":00");
              }
              var l = Date.parse(i);
              if (!v(l)) {
                var h = a.split("-");
                l = Date.UTC(S(h[0]), S(h[1]) - 1, S(h[2]));
              }
              return n && e && v(l) && (l += n.getTimezoneOffset(l)), l;
            }, s.prototype.drawInput = function(a) {
              var e = this, n = e.chart, o = e.div, i = e.inputGroup, c = this, l = n.renderer.style || {}, h = n.renderer, C = n.options.rangeSelector, M = q.lang, O = a === "min";
              function p() {
                var I = c.maxInput, j = c.minInput, Z = n.xAxis[0], V = n.scroller && n.scroller.xAxis ? n.scroller.xAxis : Z, X = V.dataMin, et = V.dataMax, ot = c.getInputValue(a);
                ot !== Number(W.getAttribute("data-hc-time-previous")) && v(ot) && (W.setAttribute("data-hc-time-previous", ot), O && I && v(X) ? ot > Number(I.getAttribute("data-hc-time")) ? ot = void 0 : ot < X && (ot = X) : j && v(et) && (ot < Number(j.getAttribute("data-hc-time")) ? ot = void 0 : ot > et && (ot = et)), ot !== void 0 && Z.setExtremes(O ? ot : Z.min, O ? Z.max : ot, void 0, void 0, { trigger: "rangeSelectorInput" }));
              }
              var w = M[O ? "rangeSelectorFrom" : "rangeSelectorTo"] || "", T = h.label(w, 0).addClass("highcharts-range-label").attr({ padding: w ? 2 : 0, height: w ? C.inputBoxHeight : 0 }).add(i), z = h.label("", 0).addClass("highcharts-range-input").attr({ padding: 2, width: C.inputBoxWidth, height: C.inputBoxHeight, "text-align": "center" }).on("click", function() {
                c.showInput(a), c[a + "Input"].focus();
              });
              n.styledMode || z.attr({ stroke: C.inputBoxBorderColor, "stroke-width": 1 }), z.add(i);
              var W = N("input", { name: a, className: "highcharts-range-selector" }, void 0, o);
              W.setAttribute("type", function(I) {
                if (I.indexOf("%L") !== -1)
                  return "text";
                var j = ["a", "A", "d", "e", "w", "b", "B", "m", "o", "y", "Y"].some(function(V) {
                  return I.indexOf("%" + V) !== -1;
                }), Z = ["H", "k", "I", "l", "M", "S"].some(function(V) {
                  return I.indexOf("%" + V) !== -1;
                });
                return j && Z ? "datetime-local" : j ? "date" : Z ? "time" : "text";
              }(C.inputDateFormat || "%b %e, %Y")), n.styledMode || (T.css(g(l, C.labelStyle)), z.css(g({ color: "#333333" }, l, C.inputStyle)), D(W, d({ position: "absolute", border: 0, boxShadow: "0 0 15px rgba(0,0,0,0.3)", width: "1px", height: "1px", padding: 0, textAlign: "center", fontSize: l.fontSize, fontFamily: l.fontFamily, top: "-9999em" }, C.inputStyle))), W.onfocus = function() {
                c.showInput(a);
              }, W.onblur = function() {
                W === $.doc.activeElement && p(), c.hideInput(a), c.setInputValue(a), W.blur();
              };
              var L = !1;
              return W.onchange = function() {
                L || (p(), c.hideInput(a), W.blur());
              }, W.onkeypress = function(I) {
                I.keyCode === 13 && p();
              }, W.onkeydown = function(I) {
                L = !0, I.keyCode !== 38 && I.keyCode !== 40 || p();
              }, W.onkeyup = function() {
                L = !1;
              }, { dateBox: z, input: W, label: T };
            }, s.prototype.getPosition = function() {
              var a = this.chart, e = a.options.rangeSelector, n = e.verticalAlign === "top" ? a.plotTop - a.axisOffset[0] : 0;
              return { buttonTop: n + e.buttonPosition.y, inputTop: n + e.inputPosition.y - 10 };
            }, s.prototype.getYTDExtremes = function(a, e, n) {
              var o = this.chart.time, i = new o.Date(a), c = o.get("FullYear", i), l = n ? o.Date.UTC(c, 0, 1) : +new o.Date(c, 0, 1), h = Math.max(e, l), C = i.getTime();
              return { max: Math.min(a || C, C), min: h };
            }, s.prototype.render = function(a, e) {
              var n = this.chart, o = n.renderer, i = n.container, c = n.options, l = c.rangeSelector, h = P(c.chart.style && c.chart.style.zIndex, 0) + 1, C = l.inputEnabled, M = this.rendered;
              if (l.enabled !== !1) {
                if (!M && (this.group = o.g("range-selector-group").attr({ zIndex: 7 }).add(), this.div = N("div", void 0, { position: "relative", height: 0, zIndex: h }), this.buttonOptions.length && this.renderButtons(), i.parentNode && i.parentNode.insertBefore(this.div, i), C)) {
                  this.inputGroup = o.g("input-group").add(this.group);
                  var O = this.drawInput("min");
                  this.minDateBox = O.dateBox, this.minLabel = O.label, this.minInput = O.input;
                  var p = this.drawInput("max");
                  this.maxDateBox = p.dateBox, this.maxLabel = p.label, this.maxInput = p.input;
                }
                if (C) {
                  this.setInputValue("min", a), this.setInputValue("max", e);
                  var w = n.scroller && n.scroller.getUnionExtremes() || n.xAxis[0] || {};
                  if (k(w.dataMin) && k(w.dataMax)) {
                    var T = n.xAxis[0].minRange || 0;
                    this.setInputExtremes("min", w.dataMin, Math.min(w.dataMax, this.getInputValue("max")) - T), this.setInputExtremes("max", Math.max(w.dataMin, this.getInputValue("min")) + T, w.dataMax);
                  }
                  if (this.inputGroup) {
                    var z = 0;
                    [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach(function(W) {
                      if (W) {
                        var L = W.getBBox().width;
                        L && (W.attr({ x: z }), z += L + l.inputSpacing);
                      }
                    });
                  }
                }
                this.alignElements(), this.rendered = !0;
              }
            }, s.prototype.renderButtons = function() {
              var a = this, e = this, n = e.buttons, o = e.chart, i = e.options, c = q.lang, l = o.renderer, h = g(i.buttonTheme), C = h && h.states, M = h.width || 28;
              delete h.width, delete h.states, this.buttonGroup = l.g("range-selector-buttons").add(this.group);
              var O = this.dropdown = N("select", void 0, { position: "absolute", width: "1px", height: "1px", padding: 0, border: 0, top: "-9999em", cursor: "pointer", opacity: 1e-4 }, this.div);
              U(O, "touchstart", function() {
                O.style.fontSize = "16px";
              }), [[$.isMS ? "mouseover" : "mouseenter"], [$.isMS ? "mouseout" : "mouseleave"], ["change", "click"]].forEach(function(p) {
                var w = p[0], T = p[1];
                U(O, w, function() {
                  var z = n[a.currentButtonIndex()];
                  z && m(z.element, T || w);
                });
              }), this.zoomText = l.label(c && c.rangeSelectorZoom || "", 0).attr({ padding: i.buttonTheme.padding, height: i.buttonTheme.height, paddingLeft: 0, paddingRight: 0 }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(i.labelStyle), h["stroke-width"] = P(h["stroke-width"], 0)), N("option", { textContent: this.zoomText.textStr, disabled: !0 }, void 0, O), this.buttonOptions.forEach(function(p, w) {
                N("option", { textContent: p.title || p.text }, void 0, O), n[w] = l.button(p.text, 0, 0, function(T) {
                  var z, W = p.events && p.events.click;
                  W && (z = W.call(p, T)), z !== !1 && a.clickButton(w), a.isActive = !0;
                }, h, C && C.hover, C && C.select, C && C.disabled).attr({ "text-align": "center", width: M }).add(a.buttonGroup), p.title && n[w].attr("title", p.title);
              });
            }, s.prototype.alignElements = function() {
              var a = this, e = this, n = e.buttonGroup, o = e.buttons, i = e.chart, c = e.group, l = e.inputGroup, h = e.options, C = e.zoomText, M = i.options, O = M.exporting && M.exporting.enabled !== !1 && M.navigation && M.navigation.buttonOptions, p = h.buttonPosition, w = h.inputPosition, T = h.verticalAlign, z = function(kt, Lt) {
                return O && a.titleCollision(i) && T === "top" && Lt.align === "right" && Lt.y - kt.getBBox().height - 12 < (O.y || 0) + (O.height || 0) + i.spacing[0] ? -40 : 0;
              }, W = i.plotLeft;
              if (c && p && w) {
                var L = p.x - i.spacing[3];
                if (n) {
                  if (this.positionButtons(), !this.initialButtonGroupWidth) {
                    var I = 0;
                    C && (I += C.getBBox().width + 5), o.forEach(function(kt, Lt) {
                      I += kt.width, Lt !== o.length - 1 && (I += h.buttonSpacing);
                    }), this.initialButtonGroupWidth = I;
                  }
                  W -= i.spacing[3], this.updateButtonStates();
                  var j = z(n, p);
                  this.alignButtonGroup(j), c.placed = n.placed = i.hasLoaded;
                }
                var Z = 0;
                l && (Z = z(l, w), w.align === "left" ? L = W : w.align === "right" && (L = -Math.max(i.axisOffset[1], -Z)), l.align({ y: w.y, width: l.getBBox().width, align: w.align, x: w.x + L - 2 }, !0, i.spacingBox), l.placed = i.hasLoaded), this.handleCollision(Z), c.align({ verticalAlign: T }, !0, i.spacingBox);
                var V = c.alignAttr.translateY, X = c.getBBox().height + 20, et = 0;
                if (T === "bottom") {
                  var ot = i.legend && i.legend.options;
                  et = V - (X = X + (ot && ot.verticalAlign === "bottom" && ot.enabled && !ot.floating ? i.legend.legendHeight + P(ot.margin, 10) : 0) - 20) - (h.floating ? 0 : h.y) - (i.titleOffset ? i.titleOffset[2] : 0) - 10;
                }
                T === "top" ? (h.floating && (et = 0), i.titleOffset && i.titleOffset[0] && (et = i.titleOffset[0]), et += i.margin[0] - i.spacing[0] || 0) : T === "middle" && (w.y === p.y ? et = V : (w.y || p.y) && (w.y < 0 || p.y < 0 ? et -= Math.min(w.y, p.y) : et = V - X)), c.translate(h.x, h.y + Math.floor(et));
                var it = this, pt = it.minInput, mt = it.maxInput, Ct = it.dropdown;
                h.inputEnabled && pt && mt && (pt.style.marginTop = c.translateY + "px", mt.style.marginTop = c.translateY + "px"), Ct && (Ct.style.marginTop = c.translateY + "px");
              }
            }, s.prototype.alignButtonGroup = function(a, e) {
              var n = this, o = n.chart, i = n.options, c = n.buttonGroup, l = i.buttonPosition, h = o.plotLeft - o.spacing[3], C = l.x - o.spacing[3];
              l.align === "right" ? C += a - h : l.align === "center" && (C -= h / 2), c && c.align({ y: l.y, width: P(e, this.initialButtonGroupWidth), align: l.align, x: C }, !0, o.spacingBox);
            }, s.prototype.positionButtons = function() {
              var a = this, e = a.buttons, n = a.chart, o = a.options, i = a.zoomText, c = n.hasLoaded ? "animate" : "attr", l = o.buttonPosition, h = n.plotLeft, C = h;
              i && i.visibility !== "hidden" && (i[c]({ x: P(h + l.x, h) }), C += l.x + i.getBBox().width + 5);
              for (var M = 0, O = this.buttonOptions.length; M < O; ++M)
                e[M].visibility !== "hidden" ? (e[M][c]({ x: C }), C += e[M].width + o.buttonSpacing) : e[M][c]({ x: h });
            }, s.prototype.handleCollision = function(a) {
              var e = this, n = this, o = n.chart, i = n.buttonGroup, c = n.inputGroup, l = this.options, h = l.buttonPosition, C = l.dropdown, M = l.inputPosition, O = function() {
                var T = 0;
                return e.buttons.forEach(function(z) {
                  var W = z.getBBox();
                  W.width > T && (T = W.width);
                }), T;
              }, p = function(T) {
                if (c && i) {
                  var z = c.alignAttr.translateX + c.alignOptions.x - a + c.getBBox().x + 2, W = c.alignOptions.width, L = i.alignAttr.translateX + i.getBBox().x;
                  return L + T > z && z + W > L && h.y < M.y + c.getBBox().height;
                }
                return !1;
              }, w = function() {
                c && i && c.attr({ translateX: c.alignAttr.translateX + (o.axisOffset[1] >= -a ? 0 : -a), translateY: c.alignAttr.translateY + i.getBBox().height + 10 });
              };
              if (i) {
                if (C === "always")
                  return this.collapseButtons(a), void (p(O()) && w());
                C === "never" && this.expandButtons();
              }
              c && i ? M.align === h.align || p(this.initialButtonGroupWidth + 20) ? C === "responsive" ? (this.collapseButtons(a), p(O()) && w()) : w() : C === "responsive" && this.expandButtons() : i && C === "responsive" && (this.initialButtonGroupWidth > o.plotWidth ? this.collapseButtons(a) : this.expandButtons());
            }, s.prototype.collapseButtons = function(a) {
              var e = this, n = e.buttons, o = e.buttonOptions, i = e.chart, c = e.dropdown, l = e.options, h = e.zoomText, C = i.userOptions.rangeSelector && i.userOptions.rangeSelector.buttonTheme || {}, M = function(w) {
                return { text: w ? w + " ▾" : "▾", width: "auto", paddingLeft: P(l.buttonTheme.paddingLeft, C.padding, 8), paddingRight: P(l.buttonTheme.paddingRight, C.padding, 8) };
              };
              h && h.hide();
              var O = !1;
              o.forEach(function(w, T) {
                var z = n[T];
                z.state !== 2 ? z.hide() : (z.show(), z.attr(M(w.text)), O = !0);
              }), O || (c && (c.selectedIndex = 0), n[0].show(), n[0].attr(M(this.zoomText && this.zoomText.textStr)));
              var p = l.buttonPosition.align;
              this.positionButtons(), p !== "right" && p !== "center" || this.alignButtonGroup(a, n[this.currentButtonIndex()].getBBox().width), this.showDropdown();
            }, s.prototype.expandButtons = function() {
              var a = this, e = a.buttons, n = a.buttonOptions, o = a.options, i = a.zoomText;
              this.hideDropdown(), i && i.show(), n.forEach(function(c, l) {
                var h = e[l];
                h.show(), h.attr({ text: c.text, width: o.buttonTheme.width || 28, paddingLeft: P(o.buttonTheme.paddingLeft, "unset"), paddingRight: P(o.buttonTheme.paddingRight, "unset") }), h.state < 2 && h.setState(0);
              }), this.positionButtons();
            }, s.prototype.currentButtonIndex = function() {
              var a = this.dropdown;
              return a && a.selectedIndex > 0 ? a.selectedIndex - 1 : 0;
            }, s.prototype.showDropdown = function() {
              var a = this, e = a.buttonGroup, n = a.buttons, o = a.chart, i = a.dropdown;
              if (e && i) {
                var c = e.translateX, l = e.translateY, h = n[this.currentButtonIndex()].getBBox();
                D(i, { left: o.plotLeft + c + "px", top: l + 0.5 + "px", width: h.width + "px", height: h.height + "px" }), this.hasVisibleDropdown = !0;
              }
            }, s.prototype.hideDropdown = function() {
              var a = this.dropdown;
              a && (D(a, { top: "-9999em", width: "1px", height: "1px" }), this.hasVisibleDropdown = !1);
            }, s.prototype.getHeight = function() {
              var a = this.options, e = this.group, n = a.inputPosition, o = a.buttonPosition, i = a.y, c = o.y, l = n.y, h = 0;
              if (a.height)
                return a.height;
              this.alignElements(), h = e ? e.getBBox(!0).height + 13 + i : 0;
              var C = Math.min(l, c);
              return (l < 0 && c < 0 || l > 0 && c > 0) && (h += Math.abs(C)), h;
            }, s.prototype.titleCollision = function(a) {
              return !(a.options.title.text || a.options.subtitle.text);
            }, s.prototype.update = function(a) {
              var e = this.chart;
              g(!0, e.options.rangeSelector, a), this.destroy(), this.init(e), this.render();
            }, s.prototype.destroy = function() {
              var a = this, e = a.minInput, n = a.maxInput;
              a.eventsToUnbind && (a.eventsToUnbind.forEach(function(o) {
                return o();
              }), a.eventsToUnbind = void 0), A(a.buttons), e && (e.onfocus = e.onblur = e.onchange = null), n && (n.onfocus = n.onblur = n.onchange = null), x(a, function(o, i) {
                o && i !== "chart" && (o instanceof J ? o.destroy() : o instanceof window.HTMLElement && b(o)), o !== s.prototype[i] && (a[i] = null);
              }, this);
            }, s;
          }();
          return d(y.prototype, { defaultButtons: [{ type: "month", count: 1, text: "1m", title: "View 1 month" }, { type: "month", count: 3, text: "3m", title: "View 3 months" }, { type: "month", count: 6, text: "6m", title: "View 6 months" }, { type: "ytd", text: "YTD", title: "View year to date" }, { type: "year", count: 1, text: "1y", title: "View 1 year" }, { type: "all", text: "All", title: "View all" }], inputTypeFormats: { "datetime-local": "%Y-%m-%dT%H:%M:%S", date: "%Y-%m-%d", time: "%H:%M:%S" } }), y;
        }), at(_, "Accessibility/Components/RangeSelectorComponent.js", [_["Stock/RangeSelector/RangeSelector.js"], _["Accessibility/AccessibilityComponent.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/Announcer.js"], _["Accessibility/KeyboardNavigationHandler.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q, U = this && this.__extends || (q = function(d, m) {
            return q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
              v.__proto__ = g;
            } || function(v, g) {
              for (var x in g)
                g.hasOwnProperty(x) && (v[x] = g[x]);
            }, q(d, m);
          }, function(d, m) {
            function v() {
              this.constructor = d;
            }
            q(d, m), d.prototype = m === null ? Object.create(m) : (v.prototype = m.prototype, new v());
          }), N = $.unhideChartElementFromAT, D = $.getAxisRangeDescription, k = Q.addEvent, A = Q.attr, b = function(d) {
            function m() {
              var v = d !== null && d.apply(this, arguments) || this;
              return v.announcer = void 0, v;
            }
            return U(m, d), m.prototype.init = function() {
              var v = this.chart;
              this.announcer = new Y(v, "polite");
            }, m.prototype.onChartUpdate = function() {
              var v = this.chart, g = this, x = v.rangeSelector;
              x && (this.updateSelectorVisibility(), this.setDropdownAttrs(), x.buttons && x.buttons.length && x.buttons.forEach(function(E) {
                g.setRangeButtonAttrs(E);
              }), x.maxInput && x.minInput && ["minInput", "maxInput"].forEach(function(E, P) {
                var S = x[E];
                S && (N(v, S), g.setRangeInputAttrs(S, "accessibility.rangeSelector." + (P ? "max" : "min") + "InputLabel"));
              }));
            }, m.prototype.updateSelectorVisibility = function() {
              var v = this.chart, g = v.rangeSelector, x = g && g.dropdown, E = g && g.buttons || [], P = function(S) {
                return S.setAttribute("aria-hidden", !0);
              };
              g && g.hasVisibleDropdown && x ? (N(v, x), E.forEach(function(S) {
                return P(S.element);
              })) : (x && P(x), E.forEach(function(S) {
                return N(v, S.element);
              }));
            }, m.prototype.setDropdownAttrs = function() {
              var v = this.chart, g = v.rangeSelector && v.rangeSelector.dropdown;
              if (g) {
                var x = v.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: v.options.lang.rangeSelectorZoom });
                g.setAttribute("aria-label", x), g.setAttribute("tabindex", -1);
              }
            }, m.prototype.setRangeButtonAttrs = function(v) {
              A(v.element, { tabindex: -1, role: "button" });
            }, m.prototype.setRangeInputAttrs = function(v, g) {
              var x = this.chart;
              A(v, { tabindex: -1, "aria-label": x.langFormat(g, { chart: x }) });
            }, m.prototype.onButtonNavKbdArrowKey = function(v, g) {
              var x = v.response, E = this.keyCodes, P = this.chart, S = P.options.accessibility.keyboardNavigation.wrapAround, u = g === E.left || g === E.up ? -1 : 1;
              return P.highlightRangeSelectorButton(P.highlightedRangeSelectorItemIx + u) ? x.success : S ? (v.init(u), x.success) : x[u > 0 ? "next" : "prev"];
            }, m.prototype.onButtonNavKbdClick = function(v) {
              var g = v.response, x = this.chart;
              return x.oldRangeSelectorItemState === 3 || this.fakeClickEvent(x.rangeSelector.buttons[x.highlightedRangeSelectorItemIx].element), g.success;
            }, m.prototype.onAfterBtnClick = function() {
              var v = this.chart, g = D(v.xAxis[0]), x = v.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: v, axisRangeDescription: g });
              x && this.announcer.announce(x);
            }, m.prototype.onInputKbdMove = function(v) {
              var g = this.chart, x = g.rangeSelector, E = g.highlightedInputRangeIx = (g.highlightedInputRangeIx || 0) + v;
              if (E > 1 || E < 0)
                g.accessibility && (g.accessibility.keyboardNavigation.tabindexContainer.focus(), g.accessibility.keyboardNavigation.move(v));
              else if (x) {
                var P = x[E ? "maxDateBox" : "minDateBox"], S = x[E ? "maxInput" : "minInput"];
                P && S && g.setFocusToElement(P, S);
              }
            }, m.prototype.onInputNavInit = function(v) {
              var g = this, x = this, E = this.chart, P = v > 0 ? 0 : 1, S = E.rangeSelector, u = S && S[P ? "maxDateBox" : "minDateBox"], y = S && S.minInput, s = S && S.maxInput, a = P ? s : y;
              if (E.highlightedInputRangeIx = P, u && y && s) {
                E.setFocusToElement(u, a), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
                var e = function(i) {
                  (i.which || i.keyCode) === g.keyCodes.tab && (i.preventDefault(), i.stopPropagation(), x.onInputKbdMove(i.shiftKey ? -1 : 1));
                }, n = k(y, "keydown", e), o = k(s, "keydown", e);
                this.removeInputKeydownHandler = function() {
                  n(), o();
                };
              }
            }, m.prototype.onInputNavTerminate = function() {
              var v = this.chart.rangeSelector || {};
              v.maxInput && v.hideInput("max"), v.minInput && v.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
            }, m.prototype.initDropdownNav = function() {
              var v = this, g = this.chart, x = g.rangeSelector, E = x && x.dropdown;
              x && E && (g.setFocusToElement(x.buttonGroup, E), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = k(E, "keydown", function(P) {
                var S = (P.which || P.keyCode) === v.keyCodes.tab, u = g.accessibility;
                S && (P.preventDefault(), P.stopPropagation(), u && (u.keyboardNavigation.tabindexContainer.focus(), u.keyboardNavigation.move(P.shiftKey ? -1 : 1)));
              }));
            }, m.prototype.getRangeSelectorButtonNavigation = function() {
              var v = this.chart, g = this.keyCodes, x = this;
              return new J(v, { keyCodeMap: [[[g.left, g.right, g.up, g.down], function(E) {
                return x.onButtonNavKbdArrowKey(this, E);
              }], [[g.enter, g.space], function() {
                return x.onButtonNavKbdClick(this);
              }]], validate: function() {
                return !!(v.rangeSelector && v.rangeSelector.buttons && v.rangeSelector.buttons.length);
              }, init: function(E) {
                var P = v.rangeSelector;
                if (P && P.hasVisibleDropdown)
                  x.initDropdownNav();
                else if (P) {
                  var S = P.buttons.length - 1;
                  v.highlightRangeSelectorButton(E > 0 ? 0 : S);
                }
              }, terminate: function() {
                x.removeDropdownKeydownHandler && (x.removeDropdownKeydownHandler(), delete x.removeDropdownKeydownHandler);
              } });
            }, m.prototype.getRangeSelectorInputNavigation = function() {
              var v = this.chart, g = this;
              return new J(v, { keyCodeMap: [], validate: function() {
                return function(x) {
                  return !!(x.rangeSelector && x.rangeSelector.inputGroup && x.rangeSelector.inputGroup.element.style.visibility !== "hidden" && x.options.rangeSelector.inputEnabled !== !1 && x.rangeSelector.minInput && x.rangeSelector.maxInput);
                }(v);
              }, init: function(x) {
                g.onInputNavInit(x);
              }, terminate: function() {
                g.onInputNavTerminate();
              } });
            }, m.prototype.getKeyboardNavigation = function() {
              return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
            }, m.prototype.destroy = function() {
              this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
            }, m;
          }(F);
          return function(d) {
            var m = [];
            function v(x) {
              var E = this.rangeSelector && this.rangeSelector.buttons || [], P = this.highlightedRangeSelectorItemIx, S = this.rangeSelector && this.rangeSelector.selected;
              return P !== void 0 && E[P] && P !== S && E[P].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = x, !!E[x] && (this.setFocusToElement(E[x].box, E[x].element), x !== S && (this.oldRangeSelectorItemState = E[x].state, E[x].setState(1)), !0);
            }
            function g() {
              var x = this.chart.accessibility;
              if (x && x.components.rangeSelector)
                return x.components.rangeSelector.onAfterBtnClick();
            }
            d.compose = function(x, E) {
              m.indexOf(x) === -1 && (m.push(x), x.prototype.highlightRangeSelectorButton = v), m.indexOf(E) === -1 && (m.push(E), k(G, "afterBtnClick", g));
            };
          }(b || (b = {})), b;
        }), at(_, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.addEvent, Y = G.merge;
          return function(J) {
            var Q = [];
            function q(d) {
              Y(!0, d, { marker: { enabled: !0, states: { normal: { opacity: 0 } } } });
            }
            function U(d) {
              return d.marker.states && d.marker.states.normal && d.marker.states.normal.opacity;
            }
            function N(d) {
              return !!(d._hasPointMarkers && d.points && d.points.length);
            }
            function D() {
              var d = this;
              d.chart.styledMode && (d.markerGroup && d.markerGroup[d.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), N(d) && d.points.forEach(function(m) {
                m.graphic && (m.graphic[m.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), m.graphic[m.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
              }));
            }
            function k(d) {
              this.resetA11yMarkerOptions = Y(d.options.marker || {}, this.userOptions.marker || {});
            }
            function A() {
              var d = this, m = d.options;
              (function(v) {
                var g = v.chart.options.accessibility.enabled, x = (v.options.accessibility && v.options.accessibility.enabled) !== !1;
                return g && x && function(E) {
                  var P = E.chart.options.accessibility;
                  return E.points.length < P.series.pointDescriptionEnabledThreshold || P.series.pointDescriptionEnabledThreshold === !1;
                }(v);
              })(d) ? (m.marker && m.marker.enabled === !1 && (d.a11yMarkersForced = !0, q(d.options)), N(d) && function(v) {
                for (var g = v.points.length; g--; ) {
                  var x = v.points[g], E = x.options, P = x.hasForcedA11yMarker;
                  if (delete x.hasForcedA11yMarker, E.marker) {
                    var S = P && U(E) === 0;
                    E.marker.enabled && !S ? (b(E), x.hasForcedA11yMarker = !1) : E.marker.enabled === !1 && (q(E), x.hasForcedA11yMarker = !0);
                  }
                }
              }(d)) : d.a11yMarkersForced && (delete d.a11yMarkersForced, function(v) {
                var g = v.resetA11yMarkerOptions;
                if (g) {
                  var x = g.states && g.states.normal && g.states.normal.opacity;
                  v.update({ marker: { enabled: g.enabled, states: { normal: { opacity: x } } } });
                }
              }(d), delete d.resetA11yMarkerOptions);
            }
            function b(d) {
              Y(!0, d.marker, { states: { normal: { opacity: U(d) || 1 } } });
            }
            J.compose = function(d) {
              Q.indexOf(d) === -1 && (Q.push(d), $(d, "afterSetOptions", k), $(d, "render", A), $(d, "afterRender", D));
            };
          }(F || (F = {})), F;
        }), at(_, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [_["Core/Series/Point.js"], _["Core/Series/Series.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Globals.js"], _["Core/Utilities.js"], _["Accessibility/KeyboardNavigationHandler.js"], _["Accessibility/Utils/EventProvider.js"], _["Accessibility/Utils/ChartUtilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N = $.seriesTypes, D = Y.doc, k = J.defined, A = J.fireEvent, b = U.getPointFromXY, d = U.getSeriesFromName, m = U.scrollToPoint;
          function v(s) {
            var a = s.index, e = s.series.points, n = e.length;
            if (e[a] === s)
              return a;
            for (; n--; )
              if (e[n] === s)
                return n;
          }
          function g(s) {
            var a = s.chart.options.accessibility.keyboardNavigation.seriesNavigation, e = s.options.accessibility || {}, n = e.keyboardNavigation;
            return n && n.enabled === !1 || e.enabled === !1 || s.options.enableMouseTracking === !1 || !s.visible || a.pointNavigationEnabledThreshold && a.pointNavigationEnabledThreshold <= s.points.length;
          }
          function x(s) {
            var a = s.series.chart.options.accessibility, e = s.options.accessibility && s.options.accessibility.enabled === !1;
            return s.isNull && a.keyboardNavigation.seriesNavigation.skipNullPoints || s.visible === !1 || s.isInside === !1 || e || g(s.series);
          }
          function E(s) {
            for (var a = s.points || [], e = a.length, n = 0; n < e; ++n)
              if (!x(a[n]))
                return a[n];
            return null;
          }
          function P(s) {
            for (var a = s.series || [], e = a.length, n = 0; n < e; ++n)
              if (!g(a[n])) {
                var o = E(a[n]);
                if (o)
                  return o;
              }
            return null;
          }
          function S(s) {
            for (var a = s.series.length, e = !1; a-- && (s.highlightedPoint = s.series[a].points[s.series[a].points.length - 1], !(e = s.series[a].highlightNextValidPoint())); )
              ;
            return e;
          }
          function u(s) {
            delete s.highlightedPoint;
            var a = P(s);
            return !!a && a.highlight();
          }
          var y = function() {
            function s(a, e) {
              this.keyCodes = e, this.chart = a;
            }
            return s.prototype.init = function() {
              var a = this, e = this.chart, n = this.eventProvider = new q();
              n.addEvent(F, "destroy", function() {
                return a.onSeriesDestroy(this);
              }), n.addEvent(e, "afterApplyDrilldown", function() {
                (function(o) {
                  var i = P(o);
                  i && i.highlight(!1);
                })(this);
              }), n.addEvent(e, "drilldown", function(o) {
                var i = o.point, c = i.series;
                a.lastDrilledDownPoint = { x: i.x, y: i.y, seriesName: c ? c.name : "" };
              }), n.addEvent(e, "drillupall", function() {
                setTimeout(function() {
                  a.onDrillupAll();
                }, 10);
              }), n.addEvent(G, "afterSetState", function() {
                var o = this, i = o.graphic && o.graphic.element, c = D.activeElement, l = c && c.getAttribute("class"), h = l && l.indexOf("highcharts-a11y-proxy-button") > -1;
                e.highlightedPoint === o && c !== i && !h && i && i.focus && i.focus();
              });
            }, s.prototype.onDrillupAll = function() {
              var a, e = this.lastDrilledDownPoint, n = this.chart, o = e && d(n, e.seriesName);
              e && o && k(e.x) && k(e.y) && (a = b(o, e.x, e.y)), a = a || P(n), n.container && n.container.focus(), a && a.highlight && a.highlight(!1);
            }, s.prototype.getKeyboardNavigationHandler = function() {
              var a = this, e = this.keyCodes, n = this.chart, o = n.inverted;
              return new Q(n, { keyCodeMap: [[o ? [e.up, e.down] : [e.left, e.right], function(i) {
                return a.onKbdSideways(this, i);
              }], [o ? [e.left, e.right] : [e.up, e.down], function(i) {
                return a.onKbdVertical(this, i);
              }], [[e.enter, e.space], function(i, c) {
                var l = n.highlightedPoint;
                return l && (c.point = l, A(l.series, "click", c), l.firePointEvent("click")), this.response.success;
              }], [[e.home], function() {
                return u(n), this.response.success;
              }], [[e.end], function() {
                return S(n), this.response.success;
              }], [[e.pageDown, e.pageUp], function(i) {
                return n.highlightAdjacentSeries(i === e.pageDown), this.response.success;
              }]], init: function() {
                return a.onHandlerInit(this);
              }, validate: function() {
                return !!P(n);
              }, terminate: function() {
                return a.onHandlerTerminate();
              } });
            }, s.prototype.onKbdSideways = function(a, e) {
              var n = this.keyCodes, o = e === n.right || e === n.down;
              return this.attemptHighlightAdjacentPoint(a, o);
            }, s.prototype.onHandlerInit = function(a) {
              var e = this.chart;
              return e.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && e.highlightedPoint ? e.highlightedPoint.highlight() : u(e), a.response.success;
            }, s.prototype.onKbdVertical = function(a, e) {
              var n = this.chart, o = this.keyCodes, i = e === o.down || e === o.right, c = n.options.accessibility.keyboardNavigation.seriesNavigation;
              return c.mode && c.mode === "serialize" ? this.attemptHighlightAdjacentPoint(a, i) : (n[n.highlightedPoint && n.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries"](i), a.response.success);
            }, s.prototype.onHandlerTerminate = function() {
              var a = this.chart, e = a.options.accessibility.keyboardNavigation;
              a.tooltip && a.tooltip.hide(0);
              var n = a.highlightedPoint && a.highlightedPoint.series;
              n && n.onMouseOut && n.onMouseOut(), a.highlightedPoint && a.highlightedPoint.onMouseOut && a.highlightedPoint.onMouseOut(), e.seriesNavigation.rememberPointFocus || delete a.highlightedPoint;
            }, s.prototype.attemptHighlightAdjacentPoint = function(a, e) {
              var n = this.chart, o = n.options.accessibility.keyboardNavigation.wrapAround;
              return n.highlightAdjacentPoint(e) || o && (e ? u(n) : S(n)) ? a.response.success : a.response[e ? "next" : "prev"];
            }, s.prototype.onSeriesDestroy = function(a) {
              var e = this.chart;
              e.highlightedPoint && e.highlightedPoint.series === a && (delete e.highlightedPoint, e.focusElement && e.focusElement.removeFocusBorder());
            }, s.prototype.destroy = function() {
              this.eventProvider.removeAddedEvents();
            }, s;
          }();
          return function(s) {
            var a = [];
            function e(l) {
              var h, C, M = this, O = M.series, p = M.highlightedPoint, w = p && v(p) || 0, T = p && p.series.points || [], z = M.series && M.series[M.series.length - 1], W = z && z.points && z.points[z.points.length - 1];
              if (!O[0] || !O[0].points)
                return !1;
              if (p) {
                if (h = O[p.series.index + (l ? 1 : -1)], !(C = T[w + (l ? 1 : -1)]) && h && (C = h.points[l ? 0 : h.points.length - 1]), !C)
                  return !1;
              } else
                C = l ? O[0].points[0] : W;
              return x(C) ? (g(h = C.series) ? M.highlightedPoint = l ? h.points[h.points.length - 1] : h.points[0] : M.highlightedPoint = C, M.highlightAdjacentPoint(l)) : C.highlight();
            }
            function n(l) {
              var h, C = this.highlightedPoint, M = 1 / 0;
              return !(!k(C.plotX) || !k(C.plotY)) && (this.series.forEach(function(O) {
                g(O) || O.points.forEach(function(p) {
                  if (k(p.plotY) && k(p.plotX) && p !== C) {
                    var w = p.plotY - C.plotY, T = Math.abs(p.plotX - C.plotX), z = Math.abs(w) * Math.abs(w) + T * T * 4;
                    O.yAxis && O.yAxis.reversed && (w *= -1), w <= 0 && l || w >= 0 && !l || z < 5 || x(p) || z < M && (M = z, h = p);
                  }
                });
              }), !!h && h.highlight());
            }
            function o(l) {
              var h, C, M = this, O = M.highlightedPoint, p = M.series && M.series[M.series.length - 1], w = p && p.points && p.points[p.points.length - 1];
              return M.highlightedPoint ? !!(h = M.series[O.series.index + (l ? -1 : 1)]) && !!(C = function(T, z, W, L) {
                var I, j, Z, V = 1 / 0, X = z.points.length, et = function(ot) {
                  return !(k(ot.plotX) && k(ot.plotY));
                };
                if (!et(T)) {
                  for (; X--; )
                    et(I = z.points[X]) || (Z = (T.plotX - I.plotX) * (T.plotX - I.plotX) * 4 + (T.plotY - I.plotY) * (T.plotY - I.plotY) * 1) < V && (V = Z, j = X);
                  return k(j) ? z.points[j] : void 0;
                }
              }(O, h)) && (g(h) ? (C.highlight(), M.highlightAdjacentSeries(l) || (O.highlight(), !1)) : (C.highlight(), C.series.highlightNextValidPoint())) : (h = l ? M.series && M.series[0] : p, !!(C = l ? h && h.points && h.points[0] : w) && C.highlight());
            }
            function i(l) {
              l === void 0 && (l = !0);
              var h = this.series.chart;
              return !this.isNull && l ? this.onMouseOver() : h.tooltip && h.tooltip.hide(0), m(this), this.graphic && (h.setFocusToElement(this.graphic), !l && h.focusElement && h.focusElement.removeFocusBorder()), h.highlightedPoint = this, this;
            }
            function c() {
              var l = this.chart.highlightedPoint, h = (l && l.series) === this ? v(l) : 0, C = this.points, M = C.length;
              if (C && M) {
                for (var O = h; O < M; ++O)
                  if (!x(C[O]))
                    return C[O].highlight();
                for (var p = h; p >= 0; --p)
                  if (!x(C[p]))
                    return C[p].highlight();
              }
              return !1;
            }
            s.compose = function(l, h, C) {
              if (a.indexOf(l) === -1) {
                a.push(l);
                var M = l.prototype;
                M.highlightAdjacentPoint = e, M.highlightAdjacentPointVertical = n, M.highlightAdjacentSeries = o;
              }
              if (a.indexOf(h) === -1 && (a.push(h), h.prototype.highlight = i), a.indexOf(C) === -1) {
                a.push(C);
                var O = C.prototype;
                O.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach(function(p) {
                  N[p] && (N[p].prototype.keyboardMoveVertical = !1);
                }), O.highlightNextValidPoint = c;
              }
            };
          }(y || (y = {})), y;
        }), at(_, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [_["Accessibility/AccessibilityComponent.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], _["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], _["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], _["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"], _["Core/Tooltip.js"]], function(G, F, $, Y, J, Q, q) {
          var U, N = this && this.__extends || (U = function(b, d) {
            return U = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, U(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            U(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), D = F.hideSeriesFromAT, k = J.describeSeries, A = function(b) {
            function d() {
              return b !== null && b.apply(this, arguments) || this;
            }
            return N(d, b), d.compose = function(m, v, g) {
              Y.compose(g), $.compose(g), Q.compose(m, v, g);
            }, d.prototype.init = function() {
              this.newDataAnnouncer = new Y(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new Q(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
            }, d.prototype.hideTooltipFromATWhenShown = function() {
              var m = this;
              this.addEvent(q, "refresh", function() {
                this.chart === m.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
              });
            }, d.prototype.hideSeriesLabelsFromATWhenShown = function() {
              this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
                this.series.forEach(function(m) {
                  m.labelBySeries && m.labelBySeries.attr("aria-hidden", !0);
                });
              });
            }, d.prototype.onChartRender = function() {
              this.chart.series.forEach(function(m) {
                (m.options.accessibility && m.options.accessibility.enabled) !== !1 && m.visible ? k(m) : D(m);
              });
            }, d.prototype.getKeyboardNavigation = function() {
              return this.keyboardNavigation.getKeyboardNavigationHandler();
            }, d.prototype.destroy = function() {
              this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
            }, d;
          }(G);
          return A;
        }), at(_, "Accessibility/Components/ZoomComponent.js", [_["Accessibility/AccessibilityComponent.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Accessibility/KeyboardNavigationHandler.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q, q = this && this.__extends || (Q = function(b, d) {
            return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, Q(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            Q(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), U = F.unhideChartElementFromAT, N = $.getFakeMouseEvent, D = J.attr, k = J.pick, A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.focusedMapNavButtonIx = -1, m;
            }
            return q(d, b), d.prototype.init = function() {
              var m = this, v = this.chart;
              this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach(function(g) {
                m.addEvent(v, g, function() {
                  m.updateProxyOverlays();
                });
              });
            }, d.prototype.onChartUpdate = function() {
              var m = this.chart, v = this;
              m.mapNavigation && m.mapNavigation.navButtons.forEach(function(g, x) {
                U(m, g.element), v.setMapNavButtonAttrs(g.element, "accessibility.zoom.mapZoom" + (x ? "Out" : "In"));
              });
            }, d.prototype.setMapNavButtonAttrs = function(m, v) {
              var g = this.chart, x = g.langFormat(v, { chart: g });
              D(m, { tabindex: -1, role: "button", "aria-label": x });
            }, d.prototype.onChartRender = function() {
              this.updateProxyOverlays();
            }, d.prototype.updateProxyOverlays = function() {
              var m = this.chart;
              if (this.proxyProvider.clearGroup("zoom"), m.resetZoomButton && this.createZoomProxyButton(m.resetZoomButton, "resetZoomProxyButton", m.langFormat("accessibility.zoom.resetZoomButton", { chart: m })), m.drillUpButton && m.breadcrumbs && m.breadcrumbs.list) {
                var v = m.breadcrumbs.list[m.breadcrumbs.list.length - 1];
                this.createZoomProxyButton(m.drillUpButton, "drillUpProxyButton", m.langFormat("accessibility.drillUpButton", { chart: m, buttonText: m.breadcrumbs.getButtonText(v) }));
              }
            }, d.prototype.createZoomProxyButton = function(m, v, g) {
              this[v] = this.proxyProvider.addProxyElement("zoom", { click: m }, { "aria-label": g, tabindex: -1 });
            }, d.prototype.getMapZoomNavigation = function() {
              var m = this.keyCodes, v = this.chart, g = this;
              return new Y(v, { keyCodeMap: [[[m.up, m.down, m.left, m.right], function(x) {
                return g.onMapKbdArrow(this, x);
              }], [[m.tab], function(x, E) {
                return g.onMapKbdTab(this, E);
              }], [[m.space, m.enter], function() {
                return g.onMapKbdClick(this);
              }]], validate: function() {
                return function(x) {
                  return !!(x.mapView && x.mapNavigation && x.mapNavigation.navButtons.length);
                }(v);
              }, init: function(x) {
                return g.onMapNavInit(x);
              } });
            }, d.prototype.onMapKbdArrow = function(m, v) {
              var g = this.chart, x = this.keyCodes, E = g.container, P = v === x.up || v === x.down, S = v === x.left || v === x.up ? 1 : -1, u = (P ? g.plotHeight : g.plotWidth) / 10 * S, y = 10 * Math.random(), s = { x: E.offsetLeft + g.plotLeft + g.plotWidth / 2 + y, y: E.offsetTop + g.plotTop + g.plotHeight / 2 + y }, a = P ? { x: s.x, y: s.y + u } : { x: s.x + u, y: s.y };
              return [N("mousedown", s), N("mousemove", a), N("mouseup", a)].forEach(function(e) {
                return E.dispatchEvent(e);
              }), m.response.success;
            }, d.prototype.onMapKbdTab = function(m, v) {
              var g = this.chart, x = m.response, E = v.shiftKey, P = E && !this.focusedMapNavButtonIx || !E && this.focusedMapNavButtonIx;
              if (g.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), P)
                return g.mapView && g.mapView.zoomBy(), x[E ? "prev" : "next"];
              this.focusedMapNavButtonIx += E ? -1 : 1;
              var S = g.mapNavigation.navButtons[this.focusedMapNavButtonIx];
              return g.setFocusToElement(S.box, S.element), S.setState(2), x.success;
            }, d.prototype.onMapKbdClick = function(m) {
              var v = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
              return this.fakeClickEvent(v), m.response.success;
            }, d.prototype.onMapNavInit = function(m) {
              var v = this.chart, g = v.mapNavigation.navButtons[0], x = v.mapNavigation.navButtons[1], E = m > 0 ? g : x;
              v.setFocusToElement(E.box, E.element), E.setState(2), this.focusedMapNavButtonIx = m > 0 ? 0 : 1;
            }, d.prototype.simpleButtonNavigation = function(m, v, g) {
              var x = this.keyCodes, E = this, P = this.chart;
              return new Y(P, { keyCodeMap: [[[x.tab, x.up, x.down, x.left, x.right], function(S, u) {
                var y = S === x.tab && u.shiftKey || S === x.left || S === x.up;
                return this.response[y ? "prev" : "next"];
              }], [[x.space, x.enter], function() {
                var S = g(this, P);
                return k(S, this.response.success);
              }]], validate: function() {
                return P[m] && P[m].box && E[v].buttonElement;
              }, init: function() {
                P.setFocusToElement(P[m].box, E[v].buttonElement);
              } });
            }, d.prototype.getKeyboardNavigation = function() {
              return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(m, v) {
                v.zoomOut();
              }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(m, v) {
                return v.drillUp(), m.response.prev;
              }), this.getMapZoomNavigation()];
            }, d;
          }(G);
          return A;
        }), at(_, "Accessibility/HighContrastMode.js", [_["Core/Globals.js"]], function(G) {
          var F = G.doc, $ = G.isMS, Y = G.win;
          return { isHighContrastModeActive: function() {
            var J = /(Edg)/.test(Y.navigator.userAgent);
            if (Y.matchMedia && J)
              return Y.matchMedia("(-ms-high-contrast: active)").matches;
            if ($ && Y.getComputedStyle) {
              var Q = F.createElement("div");
              Q.style.backgroundImage = "url(".concat("data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", ")"), F.body.appendChild(Q);
              var q = (Q.currentStyle || Y.getComputedStyle(Q)).backgroundImage;
              return F.body.removeChild(Q), q === "none";
            }
            return Y.matchMedia && Y.matchMedia("(forced-colors: active)").matches;
          }, setHighContrastTheme: function(J) {
            J.highContrastModeActive = !0;
            var Q = J.options.accessibility.highContrastTheme;
            J.update(Q, !1), J.series.forEach(function(q) {
              var U = Q.plotOptions[q.type] || {};
              q.update({ color: U.color || "windowText", colors: [U.color || "windowText"], borderColor: U.borderColor || "window" }), q.points.forEach(function(N) {
                N.options && N.options.color && N.update({ color: U.color || "windowText", borderColor: U.borderColor || "window" }, !1);
              });
            }), J.redraw();
          } };
        }), at(_, "Accessibility/HighContrastTheme.js", [], function() {
          return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, labels: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
        }), at(_, "Accessibility/Options/A11yDefaults.js", [], function() {
          return { accessibility: { enabled: !0, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: !1, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: !0 }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', keyboardNavigation: { enabled: !0, focusBorder: { enabled: !0, hideBrowserFocusOutline: !0, style: { color: "#335cad", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "legend", "chartMenu"], wrapAround: !0, seriesNavigation: { skipNullPoints: !0, pointNavigationEnabledThreshold: !1, rememberPointFocus: !1 } }, announceNewData: { enabled: !1, minAnnounceInterval: 5e3, interruptUser: !1 } }, legend: { accessibility: { enabled: !0, keyboardNavigation: { enabled: !0 } } }, exporting: { accessibility: { enabled: !0 } } };
        }), at(_, "Accessibility/Options/LangDefaults.js", [], function() {
          return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{ Also related to, #each(additionalAnnotationPoints)}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#plural(numPoints, points, point)}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#plural(numPoints, points, point)}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#plural(numPoints, points, point)}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#plural(numPoints, slices, slice)}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#plural(numPoints, points, point)}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#plural(numPoints, boxes, box)}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#plural(numPoints, bubbles, bubble)}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each(names, -1) }and {names[-1]}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each(names, -1) }and {names[-1]}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bars, bar)}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#plural(series.points.length, bars, bar)}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bars, bar)}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#plural(series.points.length, bars, bar)}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, slices, slice)}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#plural(series.points.length, slices, slice)}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, points, point)}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#plural(series.points.length, points, point)}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, boxes, box)}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#plural(series.points.length, boxes, box)}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, areas, area)}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#plural(series.points.length, areas, area)}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#plural(series.points.length, bubbles, bubble)}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{Annotation: #each(annotations). }" } } };
        }), at(_, "Accessibility/Options/DeprecatedOptions.js", [_["Core/Utilities.js"]], function(G) {
          var F = G.error, $ = G.pick;
          function Y(Q, q, U) {
            for (var N, D = Q, k = 0; k < q.length - 1; ++k)
              D = D[N = q[k]] = $(D[N], {});
            D[q[q.length - 1]] = U;
          }
          function J(Q, q, U, N) {
            function D(b, d) {
              return d.reduce(function(m, v) {
                return m[v];
              }, b);
            }
            var k = D(Q.options, q), A = D(Q.options, U);
            Object.keys(N).forEach(function(b) {
              var d, m = k[b];
              m !== void 0 && (Y(A, N[b], m), F(32, !1, Q, ((d = {})[q.join(".") + "." + b] = U.join(".") + "." + N[b].join("."), d)));
            });
          }
          return function(Q) {
            (function(q) {
              var U = q.options.chart, N = q.options.accessibility || {};
              ["description", "typeDescription"].forEach(function(D) {
                var k;
                U[D] && (N[D] = U[D], F(32, !1, q, ((k = {})["chart.".concat(D)] = "use accessibility.".concat(D), k)));
              });
            })(Q), function(q) {
              q.axes.forEach(function(U) {
                var N = U.options;
                N && N.description && (N.accessibility = N.accessibility || {}, N.accessibility.description = N.description, F(32, !1, q, { "axis.description": "use axis.accessibility.description" }));
              });
            }(Q), Q.series && function(q) {
              var U = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
              q.series.forEach(function(N) {
                Object.keys(U).forEach(function(D) {
                  var k, A = N.options[D];
                  D === "accessibility.pointDescriptionFormatter" && (A = N.options.accessibility && N.options.accessibility.pointDescriptionFormatter), A !== void 0 && (Y(N.options, U[D], D === "skipKeyboardNavigation" ? !A : A), F(32, !1, q, ((k = {})["series.".concat(D)] = "series." + U[D].join("."), k)));
                });
              });
            }(Q), function(q) {
              J(q, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] });
            }(Q), function(q) {
              J(q, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] });
            }(Q), function(q) {
              J(q, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
            }(Q);
          };
        }), at(_, "Accessibility/Accessibility.js", [_["Core/Defaults.js"], _["Core/Globals.js"], _["Core/Utilities.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Accessibility/A11yI18n.js"], _["Accessibility/Components/ContainerComponent.js"], _["Accessibility/FocusBorder.js"], _["Accessibility/Components/InfoRegionsComponent.js"], _["Accessibility/KeyboardNavigation.js"], _["Accessibility/Components/LegendComponent.js"], _["Accessibility/Components/MenuComponent.js"], _["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], _["Accessibility/ProxyProvider.js"], _["Accessibility/Components/RangeSelectorComponent.js"], _["Accessibility/Components/SeriesComponent/SeriesComponent.js"], _["Accessibility/Components/ZoomComponent.js"], _["Accessibility/HighContrastMode.js"], _["Accessibility/HighContrastTheme.js"], _["Accessibility/Options/A11yDefaults.js"], _["Accessibility/Options/LangDefaults.js"], _["Accessibility/Options/DeprecatedOptions.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A, b, d, m, v, g, x, E, P, S) {
          var u = G.defaultOptions, y = F.doc, s = $.addEvent, a = $.extend, e = $.fireEvent, n = $.merge, o = Y.removeElement, i = function() {
            function c(l) {
              this.chart = void 0, this.components = void 0, this.keyboardNavigation = void 0, this.proxyProvider = void 0, this.init(l);
            }
            return c.prototype.init = function(l) {
              if (this.chart = l, !y.addEventListener || !l.renderer.isSVG)
                return this.zombie = !0, this.components = {}, void l.renderTo.setAttribute("aria-hidden", !0);
              S(l), this.proxyProvider = new b(this.chart), this.initComponents(), this.keyboardNavigation = new N(l, this.components);
            }, c.prototype.initComponents = function() {
              var l = this.chart, h = this.proxyProvider, C = l.options.accessibility;
              this.components = { container: new Q(), infoRegions: new U(), legend: new D(), chartMenu: new k(), rangeSelector: new d(), series: new m(), zoom: new v() }, C.customComponents && a(this.components, C.customComponents);
              var M = this.components;
              this.getComponentOrder().forEach(function(O) {
                M[O].initBase(l, h), M[O].init();
              });
            }, c.prototype.getComponentOrder = function() {
              if (!this.components)
                return [];
              if (!this.components.series)
                return Object.keys(this.components);
              var l = Object.keys(this.components).filter(function(h) {
                return h !== "series";
              });
              return ["series"].concat(l);
            }, c.prototype.update = function() {
              var l = this.components, h = this.chart, C = h.options.accessibility;
              e(h, "beforeA11yUpdate"), h.types = this.getChartTypes();
              var M = C.keyboardNavigation.order;
              this.proxyProvider.updateGroupOrder(M), this.getComponentOrder().forEach(function(O) {
                l[O].onChartUpdate(), e(h, "afterA11yComponentUpdate", { name: O, component: l[O] });
              }), this.keyboardNavigation.update(M), !h.highContrastModeActive && g.isHighContrastModeActive() && g.setHighContrastTheme(h), e(h, "afterA11yUpdate", { accessibility: this });
            }, c.prototype.destroy = function() {
              var l = this.chart || {}, h = this.components;
              Object.keys(h).forEach(function(C) {
                h[C].destroy(), h[C].destroyBase();
              }), this.proxyProvider && this.proxyProvider.destroy(), l.announcerContainer && o(l.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), l.renderTo && l.renderTo.setAttribute("aria-hidden", !0), l.focusElement && l.focusElement.removeFocusBorder();
            }, c.prototype.getChartTypes = function() {
              var l = {};
              return this.chart.series.forEach(function(h) {
                l[h.type] = 1;
              }), Object.keys(l);
            }, c;
          }();
          return function(c) {
            var l = [];
            function h() {
              this.accessibility && this.accessibility.destroy();
            }
            function C() {
              this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
              var w = this.accessibility;
              w && !w.zombie && (w.proxyProvider.updateProxyElementPositions(), w.getComponentOrder().forEach(function(T) {
                w.components[T].onChartRender();
              }));
            }
            function M(w) {
              var T = w.options.accessibility;
              T && (T.customComponents && (this.options.accessibility.customComponents = T.customComponents, delete T.customComponents), n(!0, this.options.accessibility, T), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
            }
            function O() {
              var w = this.accessibility, T = this.options.accessibility;
              T && T.enabled ? w && !w.zombie ? w.update() : (this.accessibility = w = new c(this), w && !w.zombie && w.update()) : w ? (w.destroy && w.destroy(), delete this.accessibility) : this.renderTo.setAttribute("aria-hidden", !0);
            }
            function p() {
              this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
            }
            c.i18nFormat = J.i18nFormat, c.compose = function(w, T, z, W, L, I) {
              N.compose(w), A.compose(W), D.compose(w, T), k.compose(w), m.compose(w, z, W), J.compose(w), q.compose(w, L), I && d.compose(w, I), l.indexOf(w) === -1 && (l.push(w), w.prototype.updateA11yEnabled = O, s(w, "destroy", h), s(w, "render", C), s(w, "update", M), ["addSeries", "init"].forEach(function(j) {
                s(w, j, function() {
                  this.a11yDirty = !0;
                });
              }), ["afterApplyDrilldown", "drillupall"].forEach(function(j) {
                s(w, j, function() {
                  var Z = this.accessibility;
                  Z && !Z.zombie && Z.update();
                });
              })), l.indexOf(z) === -1 && (l.push(z), s(z, "update", p)), l.indexOf(W) === -1 && (l.push(W), ["update", "updatedData", "remove"].forEach(function(j) {
                s(W, j, function() {
                  this.chart.accessibility && (this.chart.a11yDirty = !0);
                });
              }));
            };
          }(i || (i = {})), n(!0, u, E, { accessibility: { highContrastTheme: x }, lang: P }), i;
        }), at(_, "masters/modules/accessibility.src.js", [_["Core/Globals.js"], _["Accessibility/Accessibility.js"], _["Accessibility/AccessibilityComponent.js"], _["Accessibility/Utils/ChartUtilities.js"], _["Accessibility/Utils/HTMLUtilities.js"], _["Accessibility/KeyboardNavigationHandler.js"], _["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(G, F, $, Y, J, Q, q) {
          var U = G;
          U.i18nFormat = F.i18nFormat, U.A11yChartUtilities = Y, U.A11yHTMLUtilities = J, U.AccessibilityComponent = $, U.KeyboardNavigationHandler = Q, U.SeriesAccessibilityDescriber = q, F.compose(U.Chart, U.Legend, U.Point, U.Series, U.SVGElement, U.RangeSelector);
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 8291: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Core/HttpUtilities.js", [_["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = G.doc, Y = F.createElement, J = F.discardElement, Q = F.merge, q = F.objectEach, U = { ajax: function(N) {
            var D = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, k = new XMLHttpRequest();
            function A(b, d) {
              N.error && N.error(b, d);
            }
            if (!N.url)
              return !1;
            k.open((N.type || "get").toUpperCase(), N.url, !0), N.headers && N.headers["Content-Type"] || k.setRequestHeader("Content-Type", D[N.dataType || "json"] || D.text), q(N.headers, function(b, d) {
              k.setRequestHeader(d, b);
            }), N.responseType && (k.responseType = N.responseType), k.onreadystatechange = function() {
              var b;
              if (k.readyState === 4) {
                if (k.status === 200) {
                  if (N.responseType !== "blob" && (b = k.responseText, N.dataType === "json"))
                    try {
                      b = JSON.parse(b);
                    } catch (d) {
                      if (d instanceof Error)
                        return A(k, d);
                    }
                  return N.success && N.success(b, k);
                }
                A(k, k.responseText);
              }
            }, N.data && typeof N.data != "string" && (N.data = JSON.stringify(N.data)), k.send(N.data);
          }, getJSON: function(N, D) {
            U.ajax({ url: N, success: D, dataType: "json", headers: { "Content-Type": "text/plain" } });
          }, post: function(N, D, k) {
            var A = Y("form", Q({ method: "post", action: N, enctype: "multipart/form-data" }, k), { display: "none" }, $.body);
            q(D, function(b, d) {
              Y("input", { type: "hidden", name: d, value: b }, void 0, A);
            }), A.submit(), J(A);
          } };
          return U;
        }), at(_, "Extensions/Data.js", [_["Core/Chart/Chart.js"], _["Core/Defaults.js"], _["Core/Globals.js"], _["Core/HttpUtilities.js"], _["Core/Series/Point.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q) {
          var U = F.getOptions, N = $.doc, D = Y.ajax, k = Q.seriesTypes, A = q.addEvent, b = q.defined, d = q.extend, m = q.fireEvent, v = q.isNumber, g = q.merge, x = q.objectEach, E = q.pick, P = q.splat;
          function S(s) {
            return !!(s && (s.rowsURL || s.csvURL || s.columnsURL));
          }
          var u = function() {
            function s(a, e, n) {
              e === void 0 && (e = {}), this.rowsToColumns = s.rowsToColumns, this.dateFormats = { "YYYY/mm/dd": { regex: /^([0-9]{4})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{1,2})$/, parser: function(o) {
                return o ? Date.UTC(+o[1], o[2] - 1, +o[3]) : NaN;
              } }, "dd/mm/YYYY": { regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{4})$/, parser: function(o) {
                return o ? Date.UTC(+o[3], o[2] - 1, +o[1]) : NaN;
              }, alternative: "mm/dd/YYYY" }, "mm/dd/YYYY": { regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{4})$/, parser: function(o) {
                return o ? Date.UTC(+o[3], o[1] - 1, +o[2]) : NaN;
              } }, "dd/mm/YY": { regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{2})$/, parser: function(o) {
                if (!o)
                  return NaN;
                var i = /* @__PURE__ */ new Date(), c = +o[3];
                return c > i.getFullYear() - 2e3 ? c += 1900 : c += 2e3, Date.UTC(c, o[2] - 1, +o[1]);
              }, alternative: "mm/dd/YY" }, "mm/dd/YY": { regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{2})$/, parser: function(o) {
                return o ? Date.UTC(+o[3] + 2e3, o[1] - 1, +o[2]) : NaN;
              } } }, this.chart = n, this.chartOptions = e, this.options = a, this.rawColumns = [], this.init(a, e, n);
            }
            return s.data = function(a, e, n) {
              return e === void 0 && (e = {}), new s(a, e, n);
            }, s.rowsToColumns = function(a) {
              var e, n, o, i, c;
              if (a)
                for (c = [], n = a.length, e = 0; e < n; e++)
                  for (i = a[e].length, o = 0; o < i; o++)
                    c[o] || (c[o] = []), c[o][e] = a[e][o];
              return c;
            }, s.prototype.init = function(a, e, n) {
              var o, i = a.decimalPoint;
              e && (this.chartOptions = e), n && (this.chart = n), i !== "." && i !== "," && (i = void 0), this.options = a, this.columns = a.columns || this.rowsToColumns(a.rows) || [], this.firstRowAsNames = E(a.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = i && new RegExp("^(-?[0-9]+)" + i + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), o = !S(a)), o || (o = this.fetchLiveData()), o || (o = !!this.parseCSV().length), o || (o = !!this.parseTable().length), o || (o = this.parseGoogleSpreadsheet()), !o && a.afterComplete && a.afterComplete();
            }, s.prototype.getColumnDistribution = function() {
              var a, e = this.chartOptions, n = this.options, o = [], i = function(w) {
                return (k[w || "line"].prototype.pointArrayMap || [0]).length;
              }, c = function(w) {
                return k[w || "line"].prototype.pointArrayMap;
              }, l = e && e.chart && e.chart.type, h = [], C = [], M = n && n.seriesMapping || e && e.series && e.series.map(function() {
                return { x: 0 };
              }) || [], O = 0;
              (e && e.series || []).forEach(function(w) {
                h.push(i(w.type || l));
              }), M.forEach(function(w) {
                o.push(w.x || 0);
              }), o.length === 0 && o.push(0), M.forEach(function(w) {
                var T = new y(), z = h[O] || i(l), W = (e && e.series || [])[O] || {}, L = c(W.type || l), I = L || ["y"];
                for ((b(w.x) || W.isCartesian || !L) && T.addColumnReader(w.x, "x"), x(w, function(j, Z) {
                  Z !== "x" && T.addColumnReader(j, Z);
                }), a = 0; a < z; a++)
                  T.hasReader(I[a]) || T.addColumnReader(void 0, I[a]);
                C.push(T), O++;
              });
              var p = c(l);
              p === void 0 && (p = ["y"]), this.valueCount = { global: i(l), xColumns: o, individual: h, seriesBuilders: C, globalPointArrayMap: p };
            }, s.prototype.dataFound = function() {
              this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== !1 && this.complete();
            }, s.prototype.parseCSV = function(a) {
              var e, n, o = this, i = this.columns = [], c = a || this.options, l = c.startColumn !== void 0 && c.startColumn ? c.startColumn : 0, h = c.endColumn || Number.MAX_VALUE, C = [], M = { ",": 0, ";": 0, "	": 0 }, O = c.csv, p = c.startRow !== void 0 && c.startRow ? c.startRow : 0, w = c.endRow || Number.MAX_VALUE, T = 0;
              function z(L, I, j, Z) {
                var V = 0, X = "", et = "", ot = "", it = "", pt = 0, mt = 0;
                function Ct(Tt) {
                  X = L[Tt], et = L[Tt - 1], ot = L[Tt + 1];
                }
                function kt(Tt) {
                  C.length < mt + 1 && C.push([Tt]), C[mt][C[mt].length - 1] !== Tt && C[mt].push(Tt);
                }
                function Lt() {
                  if (l > pt || pt > h)
                    return ++pt, void (it = "");
                  !isNaN(parseFloat(it)) && isFinite(it) ? (it = parseFloat(it), kt("number")) : isNaN(Date.parse(it)) ? kt("string") : (it = it.replace(/\//g, "-"), kt("date")), i.length < mt + 1 && i.push([]), i[mt][I] = it, it = "", ++mt, ++pt;
                }
                if (L.trim().length && L.trim()[0] !== "#") {
                  for (; V < L.length; V++)
                    if (Ct(V), X === '"')
                      for (Ct(++V); V < L.length && (X !== '"' || et === '"' || ot === '"'); )
                        (X !== '"' || X === '"' && et !== '"') && (it += X), Ct(++V);
                    else
                      X === e ? Lt() : it += X;
                  Lt();
                }
              }
              if (O && c.beforeParse && (O = c.beforeParse.call(this, O)), O) {
                n = O.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(c.lineDelimiter || `
`), (!p || p < 0) && (p = 0), (!w || w >= n.length) && (w = n.length - 1), c.itemDelimiter ? e = c.itemDelimiter : (e = null, e = function(L) {
                  var I, j = 0, Z = 0;
                  return L.some(function(V, X) {
                    var et, ot, it, pt = !1, mt = "";
                    if (X > 13)
                      return !0;
                    for (var Ct = 0; Ct < V.length; Ct++) {
                      if (et = V[Ct], ot = V[Ct + 1], it = V[Ct - 1], et === "#")
                        return;
                      if (et === '"')
                        if (pt) {
                          if (it !== '"' && ot !== '"') {
                            for (; ot === " " && Ct < V.length; )
                              ot = V[++Ct];
                            M[ot] !== void 0 && M[ot]++, pt = !1;
                          }
                        } else
                          pt = !0;
                      else
                        M[et] !== void 0 ? (mt = mt.trim(), isNaN(Date.parse(mt)) && !isNaN(mt) && isFinite(mt) || M[et]++, mt = "") : mt += et;
                      et === "," && Z++, et === "." && j++;
                    }
                  }), I = M[";"] > M[","] ? ";" : ",", c.decimalPoint || (c.decimalPoint = j > Z ? "." : ",", o.decimalRegex = new RegExp("^(-?[0-9]+)" + c.decimalPoint + "([0-9]+)$")), I;
                }(n));
                var W = 0;
                for (T = p; T <= w; T++)
                  n[T][0] === "#" ? W++ : z(n[T], T - p - W);
                c.columnTypes && c.columnTypes.length !== 0 || !C.length || !C[0].length || C[0][1] !== "date" || c.dateFormat || (c.dateFormat = function(L, I) {
                  var j, Z, V, X = "YYYY/mm/dd", et = [], ot = [], it = [], pt = 0, mt = !1;
                  for ((!I || I > L.length) && (I = L.length); pt < I; pt++)
                    if (L[pt] !== void 0 && L[pt] && L[pt].length)
                      for (j = L[pt].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), it = ["", "", ""], V = 0; V < j.length; V++)
                        V < it.length && (j[V] = parseInt(j[V], 10), j[V] && (ot[V] = !ot[V] || ot[V] < j[V] ? j[V] : ot[V], et[V] !== void 0 ? et[V] !== j[V] && (et[V] = !1) : et[V] = j[V], j[V] > 31 ? j[V] < 100 ? it[V] = "YY" : it[V] = "YYYY" : j[V] > 12 && j[V] <= 31 ? (it[V] = "dd", mt = !0) : it[V].length || (it[V] = "mm")));
                  if (mt) {
                    for (V = 0; V < et.length; V++)
                      et[V] !== !1 ? ot[V] > 12 && it[V] !== "YY" && it[V] !== "YYYY" && (it[V] = "YY") : ot[V] > 12 && it[V] === "mm" && (it[V] = "dd");
                    return it.length === 3 && it[1] === "dd" && it[2] === "dd" && (it[2] = "YY"), Z = it.join("/"), (c.dateFormats || o.dateFormats)[Z] ? Z : (m("deduceDateFailed"), X);
                  }
                  return X;
                }(i[0])), this.dataFound();
              }
              return i;
            }, s.prototype.parseTable = function() {
              var a = this.options, e = this.columns || [], n = a.startRow || 0, o = a.endRow || Number.MAX_VALUE, i = a.startColumn || 0, c = a.endColumn || Number.MAX_VALUE;
              if (a.table) {
                var l = a.table;
                typeof l == "string" && (l = N.getElementById(l)), [].forEach.call(l.getElementsByTagName("tr"), function(h, C) {
                  C >= n && C <= o && [].forEach.call(h.children, function(M, O) {
                    var p = e[O - i], w = 1;
                    if ((M.tagName === "TD" || M.tagName === "TH") && O >= i && O <= c)
                      for (e[O - i] || (e[O - i] = []), e[O - i][C - n] = M.innerHTML; C - n >= w && p[C - n - w] === void 0; )
                        p[C - n - w] = null, w++;
                  });
                }), this.dataFound();
              }
              return e;
            }, s.prototype.fetchLiveData = function() {
              var a = this, e = this.chart, n = this.options, o = n.enablePolling, i = g(n), c = 0, l = 1e3 * (n.dataRefreshRate || 2);
              return !!S(n) && (l < 1e3 && (l = 1e3), delete n.csvURL, delete n.rowsURL, delete n.columnsURL, function h(C) {
                function M(O, p, w) {
                  if (!O || !/^(http|\/|\.\/|\.\.\/)/.test(O))
                    return O && n.error && n.error("Invalid URL"), !1;
                  function T() {
                    o && e.liveDataURL === O && (a.liveDataTimeout = setTimeout(h, l));
                  }
                  return C && (clearTimeout(a.liveDataTimeout), e.liveDataURL = O), D({ url: O, dataType: w || "json", success: function(z) {
                    e && e.series && p(z), T();
                  }, error: function(z, W) {
                    return ++c < 3 && T(), n.error && n.error(W, z);
                  } }), !0;
                }
                M(i.csvURL, function(O) {
                  e.update({ data: { csv: O } });
                }, "text") || M(i.rowsURL, function(O) {
                  e.update({ data: { rows: O } });
                }) || M(i.columnsURL, function(O) {
                  e.update({ data: { columns: O } });
                });
              }(!0), S(n));
            }, s.prototype.parseGoogleSpreadsheet = function() {
              var a = this, e = this.options, n = e.googleSpreadsheetKey, o = this.chart, i = Math.max(1e3 * (e.dataRefreshRate || 2), 4e3), c = function() {
                if (e.googleSpreadsheetRange)
                  return e.googleSpreadsheetRange;
                var l = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", h = (l.charAt(e.startColumn || 0) || "A") + ((e.startRow || 0) + 1), C = l.charAt(E(e.endColumn, -1)) || "ZZ";
                return b(e.endRow) && (C += e.endRow + 1), "" + h + ":".concat(C);
              };
              return n && (delete e.googleSpreadsheetKey, function l(h) {
                var C = ["https://sheets.googleapis.com/v4/spreadsheets", n, "values", c(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + e.googleAPIKey].join("/");
                D({ url: C, dataType: "json", success: function(M) {
                  h(M), e.enablePolling && (a.liveDataTimeout = setTimeout(function() {
                    l(h);
                  }, i));
                }, error: function(M, O) {
                  return e.error && e.error(O, M);
                } });
              }(function(l) {
                var h = l.values;
                if (!h || h.length === 0)
                  return !1;
                var C = h.reduce(function(M, O) {
                  return Math.max(M, O.length);
                }, 0);
                h.forEach(function(M) {
                  for (var O = 0; O < C; O++)
                    M[O] === void 0 && (M[O] = null);
                }), o && o.series ? o.update({ data: { columns: h } }) : (a.columns = h, a.dataFound());
              })), !1;
            }, s.prototype.trim = function(a, e) {
              return typeof a == "string" && (a = a.replace(/^\s+|\s+$/g, ""), e && /^[0-9\s]+$/.test(a) && (a = a.replace(/\s/g, "")), this.decimalRegex && (a = a.replace(this.decimalRegex, "$1.$2"))), a;
            }, s.prototype.parseTypes = function() {
              for (var a = this.columns || [], e = a.length; e--; )
                this.parseColumn(a[e], e);
            }, s.prototype.parseColumn = function(a, e) {
              var n, o, i, c, l, h, C, M = this.rawColumns, O = this.columns, p = this.firstRowAsNames, w = this.valueCount.xColumns.indexOf(e) !== -1, T = [], z = this.chartOptions, W = (this.options.columnTypes || [])[e], L = w && (z && z.xAxis && P(z.xAxis)[0].type === "category" || W === "string"), I = b(a.name), j = a.length;
              for (M[e] || (M[e] = []); j--; )
                n = T[j] || a[j], i = this.trim(n), c = this.trim(n, !0), o = parseFloat(c), M[e][j] === void 0 && (M[e][j] = i), L || j === 0 && p && !I ? a[j] = "" + i : +c === o ? (a[j] = o, o > 31536e6 && W !== "float" ? a.isDatetime = !0 : a.isNumeric = !0, a[j + 1] !== void 0 && (C = o > a[j + 1])) : (i && i.length && (l = this.parseDate(n)), w && v(l) && W !== "float" ? (T[j] = n, a[j] = l, a.isDatetime = !0, a[j + 1] !== void 0 && ((h = l > a[j + 1]) !== C && C !== void 0 && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, j = a.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : a.unsorted = !0), C = h)) : (a[j] = i === "" ? null : i, j !== 0 && (a.isDatetime || a.isNumeric) && (a.mixed = !0)));
              if (w && a.mixed && (O[e] = M[e]), w && C && this.options.sort)
                for (e = 0; e < O.length; e++)
                  O[e].reverse(), p && O[e].unshift(O[e].pop());
            }, s.prototype.parseDate = function(a) {
              var e, n, o, i, c = this.options.parseDate, l = this.options.dateFormat || this.dateFormat;
              if (c)
                e = c(a);
              else if (typeof a == "string") {
                if (l)
                  (o = this.dateFormats[l]) || (o = this.dateFormats["YYYY/mm/dd"]), (i = a.match(o.regex)) && (e = o.parser(i));
                else
                  for (n in this.dateFormats)
                    if (o = this.dateFormats[n], i = a.match(o.regex)) {
                      this.dateFormat = l = n, this.alternativeFormat = o.alternative, e = o.parser(i);
                      break;
                    }
                i || (a.match(/:.+(GMT|UTC|[Z+-])/) && (a = a.replace(/\s*(?:GMT|UTC)?([+-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), typeof (i = Date.parse(a)) == "object" && i !== null && i.getTime ? e = i.getTime() - 6e4 * i.getTimezoneOffset() : v(i) && (e = i - 6e4 * new Date(i).getTimezoneOffset()));
              }
              return e;
            }, s.prototype.getData = function() {
              if (this.columns)
                return this.rowsToColumns(this.columns).slice(1);
            }, s.prototype.parsed = function() {
              if (this.options.parsed)
                return this.options.parsed.call(this, this.columns);
            }, s.prototype.complete = function() {
              var a, e, n, o, i, c, l, h, C, M, O, p, w = this.columns, T = this.options, z = [];
              if (T.complete || T.afterComplete) {
                if (this.firstRowAsNames)
                  for (o = 0; o < w.length; o++) {
                    var W = w[o];
                    b(W.name) || (W.name = E(W.shift(), "").toString());
                  }
                for (e = [], M = function(L, I) {
                  var j, Z, V, X = [], et = [];
                  for (Z = 0; Z < L; Z += 1)
                    X.push(!0);
                  for (j = 0; j < I.length; j += 1)
                    for (V = I[j].getReferencedColumnIndexes(), Z = 0; Z < V.length; Z += 1)
                      X[V[Z]] = !1;
                  for (Z = 0; Z < X.length; Z += 1)
                    X[Z] && et.push(Z);
                  return et;
                }(w.length, this.valueCount.seriesBuilders), l = 0; l < this.valueCount.seriesBuilders.length; l++)
                  (C = this.valueCount.seriesBuilders[l]).populateColumns(M) && z.push(C);
                for (; M.length > 0; ) {
                  for ((C = new y()).addColumnReader(0, "x"), (p = M.indexOf(0)) !== -1 && M.splice(p, 1), o = 0; o < this.valueCount.global; o++)
                    C.addColumnReader(void 0, this.valueCount.globalPointArrayMap[o]);
                  C.populateColumns(M) && z.push(C);
                }
                if (z.length > 0 && z[0].readers.length > 0 && (O = w[z[0].readers[0].columnIndex]) !== void 0 && (O.isDatetime ? a = "datetime" : O.isNumeric || (a = "category")), a === "category")
                  for (l = 0; l < z.length; l++)
                    for (C = z[l], c = 0; c < C.readers.length; c++)
                      C.readers[c].configName === "x" && (C.readers[c].configName = "name");
                for (l = 0; l < z.length; l++) {
                  for (C = z[l], n = [], i = 0; i < w[0].length; i++)
                    n[i] = C.read(w, i);
                  e[l] = { data: n }, C.name && (e[l].name = C.name), a === "category" && (e[l].turboThreshold = 0);
                }
                h = { series: e }, a && (h.xAxis = { type: a }, a === "category" && (h.xAxis.uniqueNames = !1)), T.complete && T.complete(h), T.afterComplete && T.afterComplete(h);
              }
            }, s.prototype.update = function(a, e) {
              var n = this.chart, o = n.options;
              a && (a.afterComplete = function(i) {
                i && (i.xAxis && n.xAxis[0] && i.xAxis.type === n.xAxis[0].options.type && delete i.xAxis, n.update(i, e, !0));
              }, g(!0, o.data, a), o.data && o.data.googleSpreadsheetKey && !a.columns && delete o.data.columns, this.init(o.data));
            }, s;
          }();
          A(G, "init", function(s) {
            var a = this, e = s.args[1], n = U().data, o = s.args[0] || {};
            if ((n || o && o.data) && !a.hasDataDef) {
              a.hasDataDef = !0;
              var i = g(n, o.data);
              a.data = new u(d(i, { afterComplete: function(c) {
                var l, h;
                if (Object.hasOwnProperty.call(o, "series"))
                  if (typeof o.series == "object")
                    for (l = Math.max(o.series.length, c && c.series ? c.series.length : 0); l--; )
                      h = o.series[l] || {}, o.series[l] = g(h, c && c.series ? c.series[l] : {});
                  else
                    delete o.series;
                o = g(c, o), a.init(o, e);
              } }), o, a), s.preventDefault();
            }
          });
          var y = function() {
            function s() {
              this.readers = [], this.pointIsArray = !0;
            }
            return s.prototype.populateColumns = function(a) {
              var e = !0;
              return this.readers.forEach(function(n) {
                n.columnIndex === void 0 && (n.columnIndex = a.shift());
              }), this.readers.forEach(function(n) {
                n.columnIndex === void 0 && (e = !1);
              }), e;
            }, s.prototype.read = function(a, e) {
              var n, o = this, i = o.pointIsArray, c = i ? [] : {};
              return o.readers.forEach(function(l) {
                var h = a[l.columnIndex][e];
                i ? c.push(h) : l.configName.indexOf(".") > 0 ? J.prototype.setNestedProperty(c, h, l.configName) : c[l.configName] = h;
              }), this.name === void 0 && o.readers.length >= 2 && (n = o.getReferencedColumnIndexes()).length >= 2 && (n.shift(), n.sort(function(l, h) {
                return l - h;
              }), this.name = a[n.shift()].name), c;
            }, s.prototype.addColumnReader = function(a, e) {
              this.readers.push({ columnIndex: a, configName: e }), e !== "x" && e !== "y" && e !== void 0 && (this.pointIsArray = !1);
            }, s.prototype.getReferencedColumnIndexes = function() {
              var a, e, n = [];
              for (a = 0; a < this.readers.length; a += 1)
                (e = this.readers[a]).columnIndex !== void 0 && n.push(e.columnIndex);
              return n;
            }, s.prototype.hasReader = function(a) {
              var e;
              for (e = 0; e < this.readers.length; e += 1)
                if (this.readers[e].configName === a)
                  return !0;
            }, s;
          }();
          return u;
        }), at(_, "masters/modules/data.src.js", [_["Core/Globals.js"], _["Core/HttpUtilities.js"], _["Extensions/Data.js"]], function(G, F, $) {
          var Y = G;
          Y.ajax = F.ajax, Y.data = $.data, Y.getJSON = F.getJSON, Y.post = F.post, Y.Data = $, Y.HttpUtilities = F;
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 7330: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Extensions/Breadcrumbs.js", [_["Core/Chart/Chart.js"], _["Core/Defaults.js"], _["Core/Globals.js"], _["Core/Utilities.js"], _["Core/FormatUtilities.js"]], function(G, F, $, Y, J) {
          var Q = F.defaultOptions, q = J.format, U = Y.addEvent, N = Y.objectEach, D = Y.extend, k = Y.fireEvent, A = Y.merge, b = Y.pick, d = Y.defined, m = Y.isString;
          D(Q.lang, { mainBreadcrumb: "Main" });
          var v = function() {
            function g(x, E) {
              this.group = void 0, this.list = [], this.elementList = {}, this.isDirty = !0, this.level = 0, this.options = void 0;
              var P = A(x.options.drilldown && x.options.drilldown.drillUpButton, g.defaultBreadcrumbsOptions, x.options.navigation && x.options.navigation.breadcrumbs, E);
              this.chart = x, this.options = P || {};
            }
            return g.prototype.updateProperties = function(x) {
              this.setList(x), this.setLevel(), this.isDirty = !0;
            }, g.prototype.setList = function(x) {
              this.list = x;
            }, g.prototype.setLevel = function() {
              this.level = this.list.length && this.list.length - 1;
            }, g.prototype.getLevel = function() {
              return this.level;
            }, g.prototype.getButtonText = function(x) {
              var E = this.chart, P = this.options, S = E.options.lang, u = b(P.format, P.showFullPath ? "{level.name}" : "← {level.name}"), y = S && b(S.drillUpText, S.mainBreadcrumb), s = P.formatter && P.formatter(x) || q(u, { level: x.levelOptions }, E) || "";
              return (m(s) && !s.length || s === "← ") && d(y) && (s = P.showFullPath ? y : "← " + y), s;
            }, g.prototype.redraw = function() {
              this.isDirty && this.render(), this.group && this.group.align(), this.isDirty = !1;
            }, g.prototype.render = function() {
              var x = this, E = x.chart, P = x.options;
              !x.group && P && (x.group = E.renderer.g("breadcrumbs-group").addClass("highcharts-no-tooltip highcharts-breadcrumbs").attr({ zIndex: P.zIndex }).add()), P.showFullPath ? this.renderFullPathButtons() : this.renderSingleButton(), this.alignBreadcrumbsGroup();
            }, g.prototype.renderFullPathButtons = function() {
              this.destroySingleButton(), this.resetElementListState(), this.updateListElements(), this.destroyListElements();
            }, g.prototype.renderSingleButton = function() {
              var x = this, E = x.chart, P = x.list, S = x.options.buttonSpacing;
              this.destroyListElements();
              var u = x.group ? x.group.getBBox().width : S, y = S, s = P[P.length - 2];
              !E.drillUpButton && this.level > 0 ? E.drillUpButton = x.renderButton(s, u, y) : E.drillUpButton && (this.level > 0 ? this.updateSingleButton() : this.destroySingleButton());
            }, g.prototype.alignBreadcrumbsGroup = function(x) {
              var E = this;
              if (E.group) {
                var P = E.options, S = P.buttonTheme, u = P.position, y = P.relativeTo === "chart" || P.relativeTo === "spacingBox" ? void 0 : "scrollablePlotBox", s = E.group.getBBox(), a = 2 * (S.padding || 0) + P.buttonSpacing;
                u.width = s.width + a, u.height = s.height + a;
                var e = A(u);
                x && (e.x += x), E.options.rtl && (e.x += u.width), e.y = b(e.y, this.yOffset, 0), E.group.align(e, !0, y);
              }
            }, g.prototype.renderButton = function(x, E, P) {
              var S = this, u = this.chart, y = S.options, s = A(y.buttonTheme), a = u.renderer.button(S.getButtonText(x), E, P, function(e) {
                var n, o = y.events && y.events.click;
                o && (n = o.call(S, e, x)), n !== !1 && (y.showFullPath ? e.newLevel = x.level : e.newLevel = S.level - 1, k(S, "up", e));
              }, s).addClass("highcharts-breadcrumbs-button").add(S.group);
              return u.styledMode || a.attr(y.style), a;
            }, g.prototype.renderSeparator = function(x, E) {
              var P = this.chart, S = this.options.separator, u = P.renderer.label(S.text, x, E, void 0, void 0, void 0, !1).addClass("highcharts-breadcrumbs-separator").add(this.group);
              return P.styledMode || u.css(S.style), u;
            }, g.prototype.update = function(x) {
              A(!0, this.options, x), this.destroy(), this.isDirty = !0;
            }, g.prototype.updateSingleButton = function() {
              var x = this.chart, E = this.list[this.level - 1];
              x.drillUpButton && x.drillUpButton.attr({ text: this.getButtonText(E) });
            }, g.prototype.destroy = function() {
              this.destroySingleButton(), this.destroyListElements(!0), this.group && this.group.destroy(), this.group = void 0;
            }, g.prototype.destroyListElements = function(x) {
              var E = this.elementList;
              N(E, function(P, S) {
                !x && E[S].updated || ((P = E[S]).button && P.button.destroy(), P.separator && P.separator.destroy(), delete P.button, delete P.separator, delete E[S]);
              }), x && (this.elementList = {});
            }, g.prototype.destroySingleButton = function() {
              this.chart.drillUpButton && (this.chart.drillUpButton.destroy(), this.chart.drillUpButton = void 0);
            }, g.prototype.resetElementListState = function() {
              N(this.elementList, function(x) {
                x.updated = !1;
              });
            }, g.prototype.updateListElements = function() {
              var x, E = this, P = E.elementList, S = E.options.buttonSpacing, u = E.list, y = E.options.rtl, s = y ? -1 : 1, a = function(i, c) {
                return s * i.getBBox().width + s * c;
              }, e = function(i, c, l) {
                i.translate(c - i.getBBox().width, l);
              }, n = E.group ? a(E.group, S) : S, o = S;
              u.forEach(function(i, c) {
                var l, h, C = c === u.length - 1;
                P[i.level] ? (l = (x = P[i.level]).button, x.separator || C ? x.separator && C && (x.separator.destroy(), delete x.separator) : (n += s * S, x.separator = E.renderSeparator(n, o), y && e(x.separator, n, o), n += a(x.separator, S)), P[i.level].updated = !0) : (l = E.renderButton(i, n, o), y && e(l, n, o), n += a(l, S), C || (h = E.renderSeparator(n, o), y && e(h, n, o), n += a(h, S)), P[i.level] = { button: l, separator: h, updated: !0 }), l && l.setState(C ? 2 : 0);
              });
            }, g.defaultBreadcrumbsOptions = { buttonTheme: { fill: "none", height: 18, padding: 2, "stroke-width": 0, zIndex: 7, states: { select: { fill: "none" } }, style: { color: "#335cad" } }, buttonSpacing: 5, floating: !1, format: void 0, relativeTo: "plotBox", rtl: !1, position: { align: "left", verticalAlign: "top", x: 0, y: void 0 }, separator: { text: "/", style: { color: "#666666" } }, showFullPath: !0, style: {}, useHTML: !1, zIndex: 7 }, g;
          }();
          return $.Breadcrumbs || ($.Breadcrumbs = v, U(G, "getMargins", function() {
            var g = this.breadcrumbs;
            if (g && !g.options.floating && g.level) {
              var x = g.options, E = x.buttonTheme, P = (E.height || 0) + 2 * (E.padding || 0) + x.buttonSpacing, S = x.position.verticalAlign;
              S === "bottom" ? (this.marginBottom = (this.marginBottom || 0) + P, g.yOffset = P) : S !== "middle" ? (this.plotTop += P, g.yOffset = -P) : g.yOffset = void 0;
            }
          }), U(G, "redraw", function() {
            this.breadcrumbs && this.breadcrumbs.redraw();
          }), U(G, "destroy", function() {
            this.breadcrumbs && (this.breadcrumbs.destroy(), this.breadcrumbs = void 0);
          }), U(G, "afterShowResetZoom", function() {
            var g = this;
            if (g.breadcrumbs) {
              var x = g.resetZoomButton && g.resetZoomButton.getBBox(), E = g.breadcrumbs.options;
              x && E.position.align === "right" && E.relativeTo === "plotBox" && g.breadcrumbs.alignBreadcrumbsGroup(-x.width - E.buttonSpacing);
            }
          }), U(G, "selection", function(g) {
            g.resetSelection === !0 && this.breadcrumbs && this.breadcrumbs.alignBreadcrumbsGroup();
          })), v;
        }), at(_, "Extensions/Drilldown.js", [_["Core/Animation/AnimationUtilities.js"], _["Core/Axis/Axis.js"], _["Core/Chart/Chart.js"], _["Core/Color/Color.js"], _["Series/Column/ColumnSeries.js"], _["Core/Globals.js"], _["Core/Defaults.js"], _["Core/Series/Point.js"], _["Core/Series/Series.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Axis/Tick.js"], _["Core/Utilities.js"], _["Extensions/Breadcrumbs.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A, b, d) {
          var m = G.animObject, v = Q.noop, g = q.defaultOptions, x = D.seriesTypes, E = b.addEvent, P = b.removeEvent, S = b.extend, u = b.fireEvent, y = b.merge, s = b.objectEach, a = b.pick, e = b.syncTimeout, n = x.pie, o = 1;
          S(g.lang, {}), g.drilldown = { activeAxisLabelStyle: { cursor: "pointer", color: "#003399", fontWeight: "bold", textDecoration: "underline" }, activeDataLabelStyle: { cursor: "pointer", color: "#003399", fontWeight: "bold", textDecoration: "underline" }, animation: { duration: 500 }, drillUpButton: { position: { align: "right", x: -10, y: 10 } } }, k.prototype.Element.prototype.fadeIn = function(C) {
            this.attr({ opacity: 0.1, visibility: "inherit" }).animate({ opacity: a(this.newOpacity, 1) }, C || { duration: 250 });
          }, $.prototype.addSeriesAsDrilldown = function(C, M) {
            this.addSingleSeriesAsDrilldown(C, M), this.applyDrilldown();
          }, $.prototype.addSingleSeriesAsDrilldown = function(C, M) {
            var O, p, w, T, z, W, L = C.series, I = L.xAxis, j = L.yAxis, Z = [], V = [];
            W = this.styledMode ? { colorIndex: a(C.colorIndex, L.colorIndex) } : { color: C.color || L.color }, this.drilldownLevels || (this.drilldownLevels = []), T = L.options._levelNumber || 0, (z = this.drilldownLevels[this.drilldownLevels.length - 1]) && z.levelNumber !== T && (z = void 0), M = S(S({ _ddSeriesId: o++ }, W), M), p = L.points.indexOf(C), L.chart.series.forEach(function(X) {
              X.xAxis !== I || X.isDrilling || (X.options._ddSeriesId = X.options._ddSeriesId || o++, X.options._colorIndex = X.userOptions._colorIndex, X.options._levelNumber = X.options._levelNumber || T, z ? (Z = z.levelSeries, V = z.levelSeriesOptions) : (Z.push(X), X.purgedOptions = y({ _ddSeriesId: X.options._ddSeriesId, _levelNumber: X.options._levelNumber, selected: X.options.selected }, X.userOptions), V.push(X.purgedOptions)));
            }), w = S({ levelNumber: T, seriesOptions: L.options, seriesPurgedOptions: L.purgedOptions, levelSeriesOptions: V, levelSeries: Z, shapeArgs: C.shapeArgs, bBox: C.graphic ? C.graphic.getBBox() : {}, color: C.isNull ? Y.parse(W.color).setOpacity(0).get() : W.color, lowerSeriesOptions: M, pointOptions: L.options.data[p], pointIndex: p, oldExtremes: { xMin: I && I.userMin, xMax: I && I.userMax, yMin: j && j.userMin, yMax: j && j.userMax }, resetZoomButton: z && z.levelNumber === T ? void 0 : this.resetZoomButton }, W), this.drilldownLevels.push(w), I && I.names && (I.names.length = 0), (O = w.lowerSeries = this.addSeries(M, !1)).options._levelNumber = T + 1, I && (I.oldPos = I.pos, I.userMin = I.userMax = null, j.userMin = j.userMax = null), L.type === O.type && (O.animate = O.animateDrilldown || v, O.options.animation = !0);
          }, $.prototype.applyDrilldown = function() {
            var C, M = this.drilldownLevels;
            M && M.length > 0 && (C = M[M.length - 1].levelNumber, this.drilldownLevels.forEach(function(O) {
              O.levelNumber === C && O.levelSeries.forEach(function(p) {
                p.options && p.options._levelNumber === C && p.remove(!1);
              });
            })), this.resetZoomButton && (this.resetZoomButton.hide(), delete this.resetZoomButton), this.pointer.reset(), u(this, "afterDrilldown"), this.redraw(), u(this, "afterApplyDrilldown");
          };
          var i = function(C) {
            var M = [], O = C.drilldownLevels;
            return O && O.length && (M[0] || M.push({ level: 0, levelOptions: O[0].seriesOptions }), O.forEach(function(p, w) {
              var T = M[M.length - 1];
              p.levelNumber + 1 > T.level && M.push({ level: p.levelNumber + 1, levelOptions: y({ name: p.lowerSeries.name }, p.pointOptions) });
            })), M;
          };
          function c(C) {
            var M = m(this.chart.options.drilldown.animation);
            C && (C.hide(), e(function() {
              C && C.added && C.fadeIn();
            }, Math.max(M.duration - 50, 0)));
          }
          $.prototype.drillUp = function() {
            if (this.drilldownLevels && this.drilldownLevels.length !== 0) {
              u(this, "beforeDrillUp");
              for (var C, M, O, p, w, T = this, z = T.drilldownLevels, W = z[z.length - 1].levelNumber, L = z.length, I = T.series, j = function(V) {
                var X;
                I.forEach(function(et) {
                  et.options._ddSeriesId === V._ddSeriesId && (X = et);
                }), (X = X || T.addSeries(V, !1)).type === O.type && X.animateDrillupTo && (X.animate = X.animateDrillupTo), V === M.seriesPurgedOptions && (p = X);
              }, Z = T.drilldownLevels.length; L--; )
                if ((M = z[L]).levelNumber === W) {
                  if (z.pop(), !(O = M.lowerSeries).chart) {
                    for (C = I.length; C--; )
                      if (I[C].options.id === M.lowerSeriesOptions.id && I[C].options._levelNumber === W + 1) {
                        O = I[C];
                        break;
                      }
                  }
                  O.xData = [], O.xAxis && O.xAxis.names && (Z === 0 || L === Z) && (O.xAxis.names.length = 0), M.levelSeriesOptions.forEach(j), u(T, "drillup", { seriesOptions: M.seriesPurgedOptions || M.seriesOptions }), p.type === O.type && (p.drilldownLevel = M, p.options.animation = T.options.drilldown.animation, O.animateDrillupFrom && O.chart && O.animateDrillupFrom(M)), p.options._levelNumber = W, O.remove(!1), p.xAxis && (w = M.oldExtremes, p.xAxis.setExtremes(w.xMin, w.xMax, !1), p.yAxis.setExtremes(w.yMin, w.yMax, !1)), M.resetZoomButton && (T.resetZoomButton = M.resetZoomButton);
                }
              u(T, "afterDrillUp"), this.redraw(), this.ddDupes && (this.ddDupes.length = 0), u(T, "drillupall");
            }
          }, E($, "afterInit", function() {
            var C = this;
            C.drilldown = { chart: C, fadeInGroup: c, update: function(M, O) {
              y(!0, C.options.drilldown, M), a(O, !0) && C.redraw();
            } };
          }), E($, "render", function() {
            (this.xAxis || []).forEach(function(C) {
              C.ddPoints = {}, C.series.forEach(function(M) {
                var O, p, w = M.xData || [], T = M.points;
                for (O = 0; O < w.length; O++)
                  if (typeof (p = M.options.data[O]) != "number" && (p = M.pointClass.prototype.optionsToObject.call({ series: M }, p)).drilldown) {
                    C.ddPoints[w[O]] || (C.ddPoints[w[O]] = []);
                    var z = O - (M.cropStart || 0);
                    C.ddPoints[w[O]].push(!(T && z >= 0 && z < T.length) || T[z]);
                  }
              }), s(C.ticks, A.prototype.drillable);
            });
          }), E(Q.Breadcrumbs, "up", function(C) {
            for (var M = this.chart, O = this.getLevel() - C.newLevel, p = 0; p < O; p++)
              M.drillUp();
          }), E($, "afterDrilldown", function() {
            var C = this, M = C.options.drilldown, O = M && M.breadcrumbs;
            C.breadcrumbs || (C.breadcrumbs = new d(C, O)), C.breadcrumbs.updateProperties(i(C));
          }), E($, "afterDrillUp", function() {
            var C = this;
            C.breadcrumbs && C.breadcrumbs.updateProperties(i(C));
          }), E($, "update", function(C) {
            var M = this.breadcrumbs, O = C.options.drilldown && C.options.drilldown.breadcrumbs;
            M && O && M.update(C.options.drilldown.breadcrumbs);
          }), J.prototype.animateDrillupTo = function(C) {
            if (!C) {
              var M = this, O = M.drilldownLevel;
              this.points.forEach(function(p) {
                var w = p.dataLabel;
                p.graphic && p.graphic.hide(), w && (w.hidden = w.attr("visibility") === "hidden", w.hidden || (w.hide(), p.connector && p.connector.hide()));
              }), e(function() {
                if (M.points) {
                  var p = [];
                  M.data.forEach(function(w) {
                    p.push(w);
                  }), M.nodes && (p = p.concat(M.nodes)), p.forEach(function(w, T) {
                    var z = T === (O && O.pointIndex) ? "show" : "fadeIn", W = z === "show" || void 0, L = w.dataLabel;
                    w.graphic && w.graphic[z](W), L && !L.hidden && (L.fadeIn(), w.connector && w.connector.fadeIn());
                  });
                }
              }, Math.max(this.chart.options.drilldown.animation.duration - 50, 0)), delete this.animate;
            }
          }, J.prototype.animateDrilldown = function(C) {
            var M, O = this, p = this.chart, w = p.drilldownLevels, T = m(p.options.drilldown.animation), z = this.xAxis, W = p.styledMode;
            C || (w.forEach(function(L) {
              O.options._ddSeriesId === L.lowerSeriesOptions._ddSeriesId && (M = L.shapeArgs, W || (M.fill = L.color));
            }), M.x += a(z.oldPos, z.pos) - z.pos, this.points.forEach(function(L) {
              var I = L.shapeArgs;
              W || (I.fill = L.color), L.graphic && L.graphic.attr(M).animate(S(L.shapeArgs, { fill: L.color || O.color }), T);
            }), p.drilldown && p.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate);
          }, J.prototype.animateDrillupFrom = function(C) {
            var M = m(this.chart.options.drilldown.animation), O = this.group, p = O !== this.chart.columnGroup, w = this;
            w.trackerGroups.forEach(function(T) {
              w[T] && w[T].on("mouseover");
            }), p && delete this.group, this.points.forEach(function(T) {
              var z = T.graphic, W = C.shapeArgs, L = function() {
                z.destroy(), O && p && (O = O.destroy());
              };
              z && W && (delete T.graphic, w.chart.styledMode || (W.fill = C.color), M.duration ? z.animate(W, y(M, { complete: L })) : (z.attr(W), L()));
            });
          }, n && S(n.prototype, { animateDrillupTo: J.prototype.animateDrillupTo, animateDrillupFrom: J.prototype.animateDrillupFrom, animateDrilldown: function(C) {
            var M = this.chart.drilldownLevels[this.chart.drilldownLevels.length - 1], O = this.chart.options.drilldown.animation;
            if (this.is("item") && (O.duration = 0), this.center) {
              var p = M.shapeArgs, w = p.start, T = (p.end - w) / this.points.length, z = this.chart.styledMode;
              C || (this.points.forEach(function(W, L) {
                var I = W.shapeArgs;
                z || (p.fill = M.color, I.fill = W.color), W.graphic && W.graphic.attr(y(p, { start: w + L * T, end: w + (L + 1) * T }))[O ? "animate" : "attr"](I, O);
              }), this.chart.drilldown && this.chart.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate);
            }
          } }), U.prototype.doDrilldown = function() {
            this.runDrilldown();
          }, U.prototype.runDrilldown = function(C, M, O) {
            var p, w = this.series.chart, T = w.options.drilldown, z = (T.series || []).length;
            for (w.ddDupes || (w.ddDupes = []); z-- && !p; )
              T.series[z].id === this.drilldown && w.ddDupes.indexOf(this.drilldown) === -1 && (p = T.series[z], w.ddDupes.push(this.drilldown));
            u(w, "drilldown", { point: this, seriesOptions: p, category: M, originalEvent: O, points: M !== void 0 && this.series.xAxis.getDDPoints(M).slice(0) }, function(W) {
              var L = W.point.series && W.point.series.chart, I = W.seriesOptions;
              L && I && (C ? L.addSingleSeriesAsDrilldown(W.point, I) : L.addSeriesAsDrilldown(W.point, I));
            });
          }, F.prototype.drilldownCategory = function(C, M) {
            this.getDDPoints(C).forEach(function(O) {
              O && O.series && O.series.visible && O.runDrilldown && O.runDrilldown(!0, C, M);
            }), this.chart.applyDrilldown();
          }, F.prototype.getDDPoints = function(C) {
            return this.ddPoints && this.ddPoints[C] || [];
          }, A.prototype.drillable = function() {
            var C = this.pos, M = this.label, O = this.axis, p = O.coll === "xAxis" && O.getDDPoints, w = p && O.getDDPoints(C), T = O.chart.styledMode;
            p && (M && w && w.length ? (M.drillable = !0, M.basicStyles || T || (M.basicStyles = y(M.styles)), M.addClass("highcharts-drilldown-axis-label"), M.removeOnDrillableClick && P(M.element, "click"), M.removeOnDrillableClick = E(M.element, "click", function(z) {
              z.preventDefault(), O.drilldownCategory(C, z);
            }), T || M.css(O.chart.options.drilldown.activeAxisLabelStyle)) : M && M.drillable && M.removeOnDrillableClick && (T || (M.styles = {}, M.element.removeAttribute("style"), M.css(M.basicStyles)), M.removeOnDrillableClick(), M.removeClass("highcharts-drilldown-axis-label")));
          }, E(U, "afterInit", function() {
            var C = this;
            return C.drilldown && !C.unbindDrilldownClick && (C.unbindDrilldownClick = E(C, "click", l)), C;
          }), E(U, "update", function(C) {
            var M = this, O = C.options || {};
            O.drilldown && !M.unbindDrilldownClick ? M.unbindDrilldownClick = E(M, "click", l) : !O.drilldown && O.drilldown !== void 0 && M.unbindDrilldownClick && (M.unbindDrilldownClick = M.unbindDrilldownClick());
          });
          var l = function(C) {
            var M = this, O = M.series;
            O.xAxis && O.chart.options.drilldown.allowPointDrilldown === !1 ? O.xAxis.drilldownCategory(M.x, C) : M.runDrilldown(void 0, void 0, C);
          };
          E(N, "afterDrawDataLabels", function() {
            var C = this.chart.options.drilldown.activeDataLabelStyle, M = this.chart.renderer, O = this.chart.styledMode;
            this.points.forEach(function(p) {
              var w = p.options.dataLabels, T = a(p.dlOptions, w && w.style, {});
              p.drilldown && p.dataLabel && (C.color !== "contrast" || O || (T.color = M.getContrast(p.color || this.color)), w && w.color && (T.color = w.color), p.dataLabel.addClass("highcharts-drilldown-data-label"), O || p.dataLabel.css(C).css(T));
            }, this);
          });
          var h = function(C, M, O, p) {
            C[O ? "addClass" : "removeClass"]("highcharts-drilldown-point"), p || C.css({ cursor: M });
          };
          E(N, "afterDrawTracker", function() {
            var C = this.chart.styledMode;
            this.points.forEach(function(M) {
              M.drilldown && M.graphic && h(M.graphic, "pointer", !0, C);
            });
          }), E(U, "afterSetState", function() {
            var C = this.series.chart.styledMode;
            this.drilldown && this.series.halo && this.state === "hover" ? h(this.series.halo, "pointer", !0, C) : this.series.halo && h(this.series.halo, "auto", !1, C);
          }), E($, "drillup", function() {
            this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy());
          }), E($, "drillupall", function() {
            this.resetZoomButton && this.showResetZoom();
          });
        }), at(_, "masters/modules/drilldown.src.js", [], function() {
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 8693: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Series/Funnel/FunnelSeries.js", [_["Core/Chart/Chart.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(g, x) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, P) {
              E.__proto__ = P;
            } || function(E, P) {
              for (var S in P)
                P.hasOwnProperty(S) && (E[S] = P[S]);
            }, J(g, x);
          }, function(g, x) {
            function E() {
              this.constructor = g;
            }
            J(g, x), g.prototype = x === null ? Object.create(x) : (E.prototype = x.prototype, new E());
          }), q = F.noop, U = $.series, N = $.seriesTypes.pie, D = Y.addEvent, k = Y.extend, A = Y.fireEvent, b = Y.isArray, d = Y.merge, m = Y.pick, v = function(g) {
            function x() {
              var E = g !== null && g.apply(this, arguments) || this;
              return E.data = void 0, E.options = void 0, E.points = void 0, E;
            }
            return Q(x, g), x.prototype.alignDataLabel = function(E, P, S, u, y) {
              var s = E.series, a = s.options.reversed, e = E.dlBox || E.shapeArgs, n = S.align, o = S.verticalAlign, i = ((s.options || {}).dataLabels || {}).inside, c = s.center[1], l = a ? 2 * c - E.plotY : E.plotY, h = s.getWidthAt(l - e.height / 2 + P.height), C = o === "middle" ? (e.topWidth - e.bottomWidth) / 4 : (h - e.bottomWidth) / 2, M = e.y, O = e.x, p = m(P.height, P.getBBox().height);
              o === "middle" ? M = e.y - e.height / 2 + p / 2 : o === "top" && (M = e.y - e.height + p + S.padding), (o === "top" && !a || o === "bottom" && a || o === "middle") && (n === "right" ? O = e.x - S.padding + C : n === "left" && (O = e.x + S.padding - C)), u = { x: O, y: a ? M - e.height : M, width: e.bottomWidth, height: e.height }, S.verticalAlign = "bottom", i && !E.visible || U.prototype.alignDataLabel.call(this, E, P, S, u, y), i && (!E.visible && E.dataLabel && (E.dataLabel.placed = !1), E.contrastColor && P.css({ color: E.contrastColor }));
            }, x.prototype.drawDataLabels = function() {
              var E, P, S, u, y, s = this, a = s.data, e = s.options.dataLabels.distance, n = a.length;
              for (s.center[2] -= 2 * e; n--; )
                P = (E = (S = a[n]).half) ? 1 : -1, y = S.plotY, S.labelDistance = m(S.options.dataLabels && S.options.dataLabels.distance, e), s.maxLabelDistance = Math.max(S.labelDistance, s.maxLabelDistance || 0), u = s.getX(y, E, S), S.labelPosition = { natural: { x: 0, y }, final: {}, alignment: E ? "right" : "left", connectorPosition: { breakAt: { x: u + (S.labelDistance - 5) * P, y }, touchingSliceAt: { x: u + S.labelDistance * P, y } } };
              $.seriesTypes[s.options.dataLabels.inside ? "column" : "pie"].prototype.drawDataLabels.call(this);
            }, x.prototype.translate = function() {
              var E, P, S, u, y, s, a, e, n, o, i = 0, c = this, l = c.chart, h = c.options, C = h.reversed, M = h.ignoreHiddenPoint, O = l.plotWidth, p = l.plotHeight, w = 0, T = h.center, z = ot(T[0], O), W = ot(T[1], p), L = ot(h.width, O), I = ot(h.height, p), j = ot(h.neckWidth, O), Z = ot(h.neckHeight, p), V = W - I / 2 + I - Z, X = c.data, et = h.dataLabels.position === "left" ? 1 : 0;
              function ot(it, pt) {
                return /%$/.test(it) ? pt * parseInt(it, 10) / 100 : parseInt(it, 10);
              }
              c.getWidthAt = function(it) {
                return it > V || I === Z ? j : j + (L - j) * (1 - (it - (W - I / 2)) / (I - Z));
              }, c.getX = function(it, pt, mt) {
                return z + (pt ? -1 : 1) * (c.getWidthAt(C ? 2 * W - it : it) / 2 + mt.labelDistance);
              }, c.center = [z, W, I], c.centerX = z, X.forEach(function(it) {
                M && it.visible === !1 || (i += it.y);
              }), X.forEach(function(it) {
                o = null, S = i ? it.y / i : 0, e = (y = W - I / 2 + w * I) + S * I, E = c.getWidthAt(y), s = (u = z - E / 2) + E, E = c.getWidthAt(e), n = (a = z - E / 2) + E, y > V ? (u = a = z - j / 2, s = n = z + j / 2) : e > V && (o = e, E = c.getWidthAt(V), n = (a = z - E / 2) + E, e = V), C && (y = 2 * W - y, e = 2 * W - e, o !== null && (o = 2 * W - o)), P = [["M", u, y], ["L", s, y], ["L", n, e]], o !== null && P.push(["L", n, o], ["L", a, o]), P.push(["L", a, e], ["Z"]), it.shapeType = "path", it.shapeArgs = { d: P }, it.percentage = 100 * S, it.plotX = z, it.plotY = (y + (o || e)) / 2, it.tooltipPos = [z, it.plotY], it.dlBox = { x: a, y, topWidth: s - u, bottomWidth: n - a, height: Math.abs(m(o, e) - y), width: NaN }, it.slice = q, it.half = et, M && it.visible === !1 || (w += S);
              }), A(c, "afterTranslate");
            }, x.prototype.sortByAngle = function(E) {
              E.sort(function(P, S) {
                return P.plotY - S.plotY;
              });
            }, x.defaultOptions = d(N.defaultOptions, { animation: !1, center: ["50%", "50%"], width: "90%", neckWidth: "30%", height: "100%", neckHeight: "25%", reversed: !1, size: !0, dataLabels: { connectorWidth: 1, verticalAlign: "middle" }, states: { select: { color: "#cccccc", borderColor: "#000000" } } }), x;
          }(N);
          return k(v.prototype, { animate: q }), D(G, "afterHideAllOverlappingLabels", function() {
            this.series.forEach(function(g) {
              var x = g.options && g.options.dataLabels;
              b(x) && (x = x[0]), g.is("pie") && g.placeDataLabels && x && !x.inside && g.placeDataLabels();
            });
          }), $.registerSeriesType("funnel", v), v;
        }), at(_, "Series/Pyramid/PyramidSeries.js", [_["Series/Funnel/FunnelSeries.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(U, N) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, k) {
              D.__proto__ = k;
            } || function(D, k) {
              for (var A in k)
                k.hasOwnProperty(A) && (D[A] = k[A]);
            }, Y(U, N);
          }, function(U, N) {
            function D() {
              this.constructor = U;
            }
            Y(U, N), U.prototype = N === null ? Object.create(N) : (D.prototype = N.prototype, new D());
          }), Q = $.merge, q = function(U) {
            function N() {
              var D = U !== null && U.apply(this, arguments) || this;
              return D.data = void 0, D.options = void 0, D.points = void 0, D;
            }
            return J(N, U), N.defaultOptions = Q(G.defaultOptions, { neckWidth: "0%", neckHeight: "0%", reversed: !0 }), N;
          }(G);
          return F.registerSeriesType("pyramid", q), q;
        }), at(_, "masters/modules/funnel.src.js", [], function() {
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 7922: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Core/Axis/Color/ColorAxisComposition.js", [_["Core/Color/Color.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = G.parse, J = F.addEvent, Q = F.extend, q = F.merge, U = F.pick, N = F.splat;
          return function(D) {
            var k, A = [];
            function b() {
              var y = this, s = this.options;
              this.colorAxis = [], s.colorAxis && (s.colorAxis = N(s.colorAxis), s.colorAxis.forEach(function(a, e) {
                a.index = e, new k(y, a);
              }));
            }
            function d(y) {
              var s, a, e = this, n = this.chart.colorAxis || [], o = function(c) {
                var l = y.allItems.indexOf(c);
                l !== -1 && (e.destroyItem(y.allItems[l]), y.allItems.splice(l, 1));
              }, i = [];
              for (n.forEach(function(c) {
                (s = c.options) && s.showInLegend && (s.dataClasses && s.visible ? i = i.concat(c.getDataClassLegendSymbols()) : s.visible && i.push(c), c.series.forEach(function(l) {
                  l.options.showInLegend && !s.dataClasses || (l.options.legendType === "point" ? l.points.forEach(function(h) {
                    o(h);
                  }) : o(l));
                }));
              }), a = i.length; a--; )
                y.allItems.unshift(i[a]);
            }
            function m(y) {
              y.visible && y.item.legendColor && y.item.legendItem.symbol.attr({ fill: y.item.legendColor });
            }
            function v() {
              var y = this.chart.colorAxis;
              y && y.forEach(function(s) {
                s.update({}, arguments[2]);
              });
            }
            function g() {
              (this.chart.colorAxis && this.chart.colorAxis.length || this.colorAttribs) && this.translateColors();
            }
            function x() {
              var y = this.axisTypes;
              y ? y.indexOf("colorAxis") === -1 && y.push("colorAxis") : this.axisTypes = ["colorAxis"];
            }
            function E(y) {
              var s = this, a = y ? "show" : "hide";
              s.visible = s.options.visible = !!y, ["graphic", "dataLabel"].forEach(function(e) {
                s[e] && s[e][a]();
              }), this.series.buildKDTree();
            }
            function P() {
              var y = this, s = this.data.length ? this.data : this.points, a = this.options.nullColor, e = this.colorAxis, n = this.colorKey;
              s.forEach(function(o) {
                var i = o.getNestedProperty(n), c = o.options.color || (o.isNull || o.value === null ? a : e && i !== void 0 ? e.toColor(i, o) : o.color || y.color);
                c && o.color !== c && (o.color = c, y.options.legendType === "point" && o.legendItem && o.legendItem.label && y.chart.legend.colorizeItem(o, o.visible));
              });
            }
            function S() {
              this.elem.attr("fill", Y(this.start).tweenTo(Y(this.end), this.pos), void 0, !0);
            }
            function u() {
              this.elem.attr("stroke", Y(this.start).tweenTo(Y(this.end), this.pos), void 0, !0);
            }
            D.compose = function(y, s, a, e, n) {
              if (k || (k = y), A.indexOf(s) === -1) {
                A.push(s);
                var o = s.prototype;
                o.collectionsWithUpdate.push("colorAxis"), o.collectionsWithInit.colorAxis = [o.addColorAxis], J(s, "afterGetAxes", b), function(c) {
                  var l = c.prototype.createAxis;
                  c.prototype.createAxis = function(h, C) {
                    if (h !== "colorAxis")
                      return l.apply(this, arguments);
                    var M = new k(this, q(C.axis, { index: this[h].length, isX: !1 }));
                    return this.isDirtyLegend = !0, this.axes.forEach(function(O) {
                      O.series = [];
                    }), this.series.forEach(function(O) {
                      O.bindAxes(), O.isDirtyData = !0;
                    }), U(C.redraw, !0) && this.redraw(C.animation), M;
                  };
                }(s);
              }
              if (A.indexOf(a) === -1) {
                A.push(a);
                var i = a.prototype;
                i.fillSetter = S, i.strokeSetter = u;
              }
              A.indexOf(e) === -1 && (A.push(e), J(e, "afterGetAllItems", d), J(e, "afterColorizeItem", m), J(e, "afterUpdate", v)), A.indexOf(n) === -1 && (A.push(n), Q(n.prototype, { optionalAxis: "colorAxis", translateColors: P }), Q(n.prototype.pointClass.prototype, { setVisible: E }), J(n, "afterTranslate", g, { order: 1 }), J(n, "bindAxes", x));
            }, D.pointSetVisible = E;
          }($ || ($ = {})), $;
        }), at(_, "Core/Axis/Color/ColorAxisDefaults.js", [], function() {
          return { lineWidth: 0, minPadding: 0, maxPadding: 0, gridLineWidth: 1, tickPixelInterval: 72, startOnTick: !0, endOnTick: !0, offset: 0, marker: { animation: { duration: 50 }, width: 0.01, color: "#999999" }, labels: { overflow: "justify", rotation: 0 }, minColor: "#e6ebf5", maxColor: "#003399", tickLength: 5, showInLegend: !0 };
        }), at(_, "Core/Axis/Color/ColorAxis.js", [_["Core/Axis/Axis.js"], _["Core/Color/Color.js"], _["Core/Axis/Color/ColorAxisComposition.js"], _["Core/Axis/Color/ColorAxisDefaults.js"], _["Core/Globals.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N, D = this && this.__extends || (N = function(x, E) {
            return N = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(P, S) {
              P.__proto__ = S;
            } || function(P, S) {
              for (var u in S)
                S.hasOwnProperty(u) && (P[u] = S[u]);
            }, N(x, E);
          }, function(x, E) {
            function P() {
              this.constructor = x;
            }
            N(x, E), x.prototype = E === null ? Object.create(E) : (P.prototype = E.prototype, new P());
          }), k = F.parse, A = q.series, b = U.extend, d = U.isNumber, m = U.merge, v = U.pick, g = function(x) {
            function E(P, S) {
              var u = x.call(this, P, S) || this;
              return u.beforePadding = !1, u.chart = void 0, u.coll = "colorAxis", u.dataClasses = void 0, u.name = "", u.options = void 0, u.stops = void 0, u.visible = !0, u.init(P, S), u;
            }
            return D(E, x), E.compose = function(P, S, u, y) {
              $.compose(E, P, S, u, y);
            }, E.prototype.init = function(P, S) {
              var u = this, y = P.options.legend || {}, s = S.layout ? S.layout !== "vertical" : y.layout !== "vertical", a = S.visible, e = m(E.defaultColorAxisOptions, S, { showEmpty: !1, title: null, visible: y.enabled && a !== !1 });
              u.coll = "colorAxis", u.side = S.side || s ? 2 : 1, u.reversed = S.reversed || !s, u.opposite = !s, x.prototype.init.call(this, P, e), u.userOptions.visible = a, S.dataClasses && u.initDataClasses(S), u.initStops(), u.horiz = s, u.zoomEnabled = !1;
            }, E.prototype.initDataClasses = function(P) {
              var S, u = this, y = u.chart, s = u.legendItem = u.legendItem || {}, a = P.dataClasses.length, e = u.options, n = 0, o = y.options.chart.colorCount;
              u.dataClasses = S = [], s.labels = [], (P.dataClasses || []).forEach(function(i, c) {
                var l;
                i = m(i), S.push(i), !y.styledMode && i.color || (e.dataClassColor === "category" ? (y.styledMode || (l = y.options.colors, o = l.length, i.color = l[n]), i.colorIndex = n, ++n === o && (n = 0)) : i.color = k(e.minColor).tweenTo(k(e.maxColor), a < 2 ? 0.5 : c / (a - 1)));
              });
            }, E.prototype.hasData = function() {
              return !!(this.tickPositions || []).length;
            }, E.prototype.setTickPositions = function() {
              if (!this.dataClasses)
                return x.prototype.setTickPositions.call(this);
            }, E.prototype.initStops = function() {
              var P = this;
              P.stops = P.options.stops || [[0, P.options.minColor], [1, P.options.maxColor]], P.stops.forEach(function(S) {
                S.color = k(S[1]);
              });
            }, E.prototype.setOptions = function(P) {
              x.prototype.setOptions.call(this, P), this.options.crosshair = this.options.marker;
            }, E.prototype.setAxisSize = function() {
              var P, S, u, y, s = this, a = s.legendItem && s.legendItem.symbol, e = s.chart, n = e.options.legend || {};
              a ? (this.left = P = a.attr("x"), this.top = S = a.attr("y"), this.width = u = a.attr("width"), this.height = y = a.attr("height"), this.right = e.chartWidth - P - u, this.bottom = e.chartHeight - S - y, this.len = this.horiz ? u : y, this.pos = this.horiz ? P : S) : this.len = (this.horiz ? n.symbolWidth : n.symbolHeight) || E.defaultLegendLength;
            }, E.prototype.normalizedValue = function(P) {
              var S = this;
              return S.logarithmic && (P = S.logarithmic.log2lin(P)), 1 - (S.max - P) / (S.max - S.min || 1);
            }, E.prototype.toColor = function(P, S) {
              var u, y, s, a, e, n, o = this, i = o.dataClasses, c = o.stops;
              if (i) {
                for (n = i.length; n--; )
                  if (y = (e = i[n]).from, s = e.to, (y === void 0 || P >= y) && (s === void 0 || P <= s)) {
                    a = e.color, S && (S.dataClass = n, S.colorIndex = e.colorIndex);
                    break;
                  }
              } else {
                for (u = o.normalizedValue(P), n = c.length; n-- && !(u > c[n][0]); )
                  ;
                y = c[n] || c[n + 1], u = 1 - ((s = c[n + 1] || y)[0] - u) / (s[0] - y[0] || 1), a = y.color.tweenTo(s.color, u);
              }
              return a;
            }, E.prototype.getOffset = function() {
              var P = this, S = P.legendItem && P.legendItem.group, u = P.chart.axisOffset[P.side];
              if (S) {
                P.axisParent = S, x.prototype.getOffset.call(this);
                var y = this.chart.legend;
                y.allItems.forEach(function(s) {
                  s instanceof E && s.drawLegendSymbol(y, s);
                }), y.render(), this.chart.getMargins(!0), P.added || (P.added = !0, P.labelLeft = 0, P.labelRight = P.width), P.chart.axisOffset[P.side] = u;
              }
            }, E.prototype.setLegendColor = function() {
              var P = this, S = P.horiz, u = P.reversed, y = u ? 1 : 0, s = u ? 0 : 1, a = S ? [y, 0, s, 0] : [0, s, 0, y];
              P.legendColor = { linearGradient: { x1: a[0], y1: a[1], x2: a[2], y2: a[3] }, stops: P.stops };
            }, E.prototype.drawLegendSymbol = function(P, S) {
              var u = S.legendItem || {}, y = P.padding, s = P.options, a = v(s.itemDistance, 10), e = this.horiz, n = v(s.symbolWidth, e ? E.defaultLegendLength : 12), o = v(s.symbolHeight, e ? 12 : E.defaultLegendLength), i = v(s.labelPadding, e ? 16 : 30);
              this.setLegendColor(), u.symbol || (u.symbol = this.chart.renderer.rect(0, P.baseline - 11, n, o).attr({ zIndex: 1 }).add(u.group)), u.labelWidth = n + y + (e ? a : this.options.labels.x + this.maxLabelLength), u.labelHeight = o + y + (e ? i : 0);
            }, E.prototype.setState = function(P) {
              this.series.forEach(function(S) {
                S.setState(P);
              });
            }, E.prototype.setVisible = function() {
            }, E.prototype.getSeriesExtremes = function() {
              var P, S, u, y, s, a, e, n, o = this.series, i = o.length;
              for (this.dataMin = 1 / 0, this.dataMax = -1 / 0; i--; ) {
                if (S = (a = o[i]).colorKey = v(a.options.colorKey, a.colorKey, a.pointValKey, a.zoneAxis, "y"), y = a.pointArrayMap, s = a[S + "Min"] && a[S + "Max"], a[S + "Data"])
                  P = a[S + "Data"];
                else if (y) {
                  if (P = [], u = y.indexOf(S), e = a.yData, u >= 0 && e)
                    for (n = 0; n < e.length; n++)
                      P.push(v(e[n][u], e[n]));
                } else
                  P = a.yData;
                if (s)
                  a.minColorValue = a[S + "Min"], a.maxColorValue = a[S + "Max"];
                else {
                  var c = A.prototype.getExtremes.call(a, P);
                  a.minColorValue = c.dataMin, a.maxColorValue = c.dataMax;
                }
                a.minColorValue !== void 0 && (this.dataMin = Math.min(this.dataMin, a.minColorValue), this.dataMax = Math.max(this.dataMax, a.maxColorValue)), s || A.prototype.applyExtremes.call(a);
              }
            }, E.prototype.drawCrosshair = function(P, S) {
              var u, y = this, s = y.legendItem || {}, a = S && S.plotX, e = S && S.plotY, n = y.pos, o = y.len;
              S && ((u = y.toPixels(S.getNestedProperty(S.series.colorKey))) < n ? u = n - 2 : u > n + o && (u = n + o + 2), S.plotX = u, S.plotY = y.len - u, x.prototype.drawCrosshair.call(this, P, S), S.plotX = a, S.plotY = e, y.cross && !y.cross.addedToColorAxis && s.group && (y.cross.addClass("highcharts-coloraxis-marker").add(s.group), y.cross.addedToColorAxis = !0, y.chart.styledMode || typeof y.crosshair != "object" || y.cross.attr({ fill: y.crosshair.color })));
            }, E.prototype.getPlotLinePath = function(P) {
              var S = this, u = S.left, y = P.translatedValue, s = S.top;
              return d(y) ? S.horiz ? [["M", y - 4, s - 6], ["L", y + 4, s - 6], ["L", y, s], ["Z"]] : [["M", u, y], ["L", u - 6, y + 6], ["L", u - 6, y - 6], ["Z"]] : x.prototype.getPlotLinePath.call(this, P);
            }, E.prototype.update = function(P, S) {
              var u = this, y = u.chart.legend;
              this.series.forEach(function(s) {
                s.isDirtyData = !0;
              }), (P.dataClasses && y.allItems || u.dataClasses) && u.destroyItems(), x.prototype.update.call(this, P, S), u.legendItem && u.legendItem.label && (u.setLegendColor(), y.colorizeItem(this, !0));
            }, E.prototype.destroyItems = function() {
              var P = this, S = P.chart, u = P.legendItem || {};
              if (u.label)
                S.legend.destroyItem(P);
              else if (u.labels)
                for (var y = 0, s = u.labels; y < s.length; y++) {
                  var a = s[y];
                  S.legend.destroyItem(a);
                }
              S.isDirtyLegend = !0;
            }, E.prototype.destroy = function() {
              this.chart.isDirtyLegend = !0, this.destroyItems(), x.prototype.destroy.apply(this, [].slice.call(arguments));
            }, E.prototype.remove = function(P) {
              this.destroyItems(), x.prototype.remove.call(this, P);
            }, E.prototype.getDataClassLegendSymbols = function() {
              var P, S = this, u = S.chart, y = S.legendItem && S.legendItem.labels || [], s = u.options.legend, a = v(s.valueDecimals, -1), e = v(s.valueSuffix, ""), n = function(o) {
                return S.series.reduce(function(i, c) {
                  return i.push.apply(i, c.points.filter(function(l) {
                    return l.dataClass === o;
                  })), i;
                }, []);
              };
              return y.length || S.dataClasses.forEach(function(o, i) {
                var c = o.from, l = o.to, h = u.numberFormatter, C = !0;
                P = "", c === void 0 ? P = "< " : l === void 0 && (P = "> "), c !== void 0 && (P += h(c, a) + e), c !== void 0 && l !== void 0 && (P += " - "), l !== void 0 && (P += h(l, a) + e), y.push(b({ chart: u, name: P, options: {}, drawLegendSymbol: Q.drawRectangle, visible: !0, isDataClass: !0, setState: function(M) {
                  for (var O = 0, p = n(i); O < p.length; O++)
                    p[O].setState(M);
                }, setVisible: function() {
                  this.visible = C = S.visible = !C;
                  for (var M = 0, O = n(i); M < O.length; M++)
                    O[M].setVisible(C);
                  u.legend.colorizeItem(this, C);
                } }, o));
              }), y;
            }, E.defaultColorAxisOptions = Y, E.defaultLegendLength = 200, E.keepProps = ["legendItem"], E;
          }(G);
          return Array.prototype.push.apply(G.keepProps, g.keepProps), g;
        }), at(_, "Maps/MapNavigationDefaults.js", [_["Core/Defaults.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = { buttonOptions: { alignTo: "plotBox", align: "left", verticalAlign: "top", x: 0, width: 18, height: 18, padding: 5, style: { fontSize: "15px", fontWeight: "bold" }, theme: { "stroke-width": 1, "text-align": "center" } }, buttons: { zoomIn: { onclick: function() {
            this.mapZoom(0.5);
          }, text: "+", y: 0 }, zoomOut: { onclick: function() {
            this.mapZoom(2);
          }, text: "-", y: 28 } }, mouseWheelSensitivity: 1.1 };
          return (0, F.extend)(G.defaultOptions.lang, { zoomIn: "Zoom in", zoomOut: "Zoom out" }), G.defaultOptions.mapNavigation = $, $;
        }), at(_, "Maps/MapNavigation.js", [_["Core/Chart/Chart.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = F.doc, J = $.addEvent, Q = $.extend, q = $.isNumber, U = $.merge, N = $.objectEach, D = $.pick;
          function k(b) {
            b && (b.preventDefault && b.preventDefault(), b.stopPropagation && b.stopPropagation(), b.cancelBubble = !0);
          }
          function A(b) {
            this.navButtons = [], this.init(b);
          }
          A.prototype.init = function(b) {
            this.chart = b;
          }, A.prototype.update = function(b) {
            var d, m = this, v = this.chart, g = v.options.mapNavigation, x = function(P) {
              this.handler.call(v, P), k(P);
            }, E = m.navButtons;
            for (b && (g = v.options.mapNavigation = U(v.options.mapNavigation, b)); E.length; )
              E.pop().destroy();
            D(g.enableButtons, g.enabled) && !v.renderer.forExport && (m.navButtonsGroup || (m.navButtonsGroup = v.renderer.g().attr({ zIndex: 4 }).add()), N(g.buttons, function(P, S) {
              P = U(g.buttonOptions, P), !v.styledMode && P.theme && ((d = P.theme).style = U(P.theme.style, P.style));
              var u = v.renderer.button(P.text || "", 0, 0, x, d, void 0, void 0, void 0, S === "zoomIn" ? "topbutton" : "bottombutton").addClass("highcharts-map-navigation highcharts-" + { zoomIn: "zoom-in", zoomOut: "zoom-out" }[S]).attr({ width: P.width, height: P.height, title: v.options.lang[S], padding: P.padding, zIndex: 5 }).add(m.navButtonsGroup);
              if (u.handler = P.onclick, J(u.element, "dblclick", k), E.push(u), Q(P, { width: u.width, height: 2 * u.height }), v.hasLoaded)
                u.align(P, !1, P.alignTo);
              else
                var y = J(v, "load", function() {
                  u.element && u.align(P, !1, P.alignTo), y();
                });
            }), v.hasLoaded || J(v, "render", function() {
              var P, S, u = v.exportingGroup && v.exportingGroup.getBBox();
              if (u) {
                var y = m.navButtonsGroup.getBBox();
                if (P = u, !((S = y).x >= P.x + P.width || S.x + S.width <= P.x || S.y >= P.y + P.height || S.y + S.height <= P.y)) {
                  var s = -y.y - y.height + u.y - 5, a = u.y + u.height - y.y + 5, e = g.buttonOptions && g.buttonOptions.verticalAlign;
                  m.navButtonsGroup.attr({ translateY: e === "bottom" ? s : a });
                }
              }
            })), this.updateEvents(g);
          }, A.prototype.updateEvents = function(b) {
            var d = this.chart;
            D(b.enableDoubleClickZoom, b.enabled) || b.enableDoubleClickZoomTo ? this.unbindDblClick = this.unbindDblClick || J(d.container, "dblclick", function(m) {
              d.pointer.onContainerDblClick(m);
            }) : this.unbindDblClick && (this.unbindDblClick = this.unbindDblClick()), D(b.enableMouseWheelZoom, b.enabled) ? this.unbindMouseWheel = this.unbindMouseWheel || J(d.container, Y.onwheel !== void 0 ? "wheel" : Y.onmousewheel !== void 0 ? "mousewheel" : "DOMMouseScroll", function(m) {
              return d.pointer.inClass(m.target, "highcharts-no-mousewheel") || (d.pointer.onContainerMouseWheel(m), k(m)), !1;
            }) : this.unbindMouseWheel && (this.unbindMouseWheel = this.unbindMouseWheel());
          }, Q(G.prototype, { fitToBox: function(b, d) {
            return [["x", "width"], ["y", "height"]].forEach(function(m) {
              var v = m[0], g = m[1];
              b[v] + b[g] > d[v] + d[g] && (b[g] > d[g] ? (b[g] = d[g], b[v] = d[v]) : b[v] = d[v] + d[g] - b[g]), b[g] > d[g] && (b[g] = d[g]), b[v] < d[v] && (b[v] = d[v]);
            }), b;
          }, mapZoom: function(b, d, m, v, g) {
            this.mapView && (q(b) && (b = Math.log(b) / Math.log(0.5)), this.mapView.zoomBy(b, q(d) && q(m) ? this.mapView.projection.inverse([d, m]) : void 0, q(v) && q(g) ? [v, g] : void 0));
          } }), J(G, "beforeRender", function() {
            this.mapNavigation = new A(this), this.mapNavigation.update();
          }), F.MapNavigation = A;
        }), at(_, "Maps/MapPointer.js", [_["Core/Pointer.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = F.defined, J = F.extend, Q = F.pick, q = F.wrap, U = G.prototype.normalize, N = 0;
          J(G.prototype, { normalize: function(D, k) {
            var A = this.chart;
            if (D = U.call(this, D, k), A && A.mapView) {
              var b = A.mapView.pixelsToLonLat({ x: D.chartX - A.plotLeft, y: D.chartY - A.plotTop });
              b && J(D, b);
            }
            return D;
          }, onContainerDblClick: function(D) {
            var k = this.chart;
            D = this.normalize(D), k.options.mapNavigation.enableDoubleClickZoomTo ? k.pointer.inClass(D.target, "highcharts-tracker") && k.hoverPoint && k.hoverPoint.zoomTo() : k.isInsidePlot(D.chartX - k.plotLeft, D.chartY - k.plotTop) && k.mapZoom(0.5, void 0, void 0, D.chartX, D.chartY);
          }, onContainerMouseWheel: function(D) {
            var k = this.chart;
            D = this.normalize(D);
            var A = Y(D.wheelDelta) && -D.wheelDelta / 120 || D.deltaY || D.detail;
            Math.abs(A) >= 1 && (N += Math.abs(A), $ && clearTimeout($), $ = setTimeout(function() {
              N = 0;
            }, 50)), N < 10 && k.isInsidePlot(D.chartX - k.plotLeft, D.chartY - k.plotTop) && k.mapView && k.mapView.zoomBy((k.options.mapNavigation.mouseWheelSensitivity - 1) * -A, void 0, [D.chartX, D.chartY], !(Math.abs(A) < 1) && void 0);
          } }), q(G.prototype, "zoomOption", function(D) {
            var k = this.chart.options.mapNavigation;
            Q(k.enableTouchZoom, k.enabled) && (this.chart.options.chart.zooming.pinchType = "xy"), D.apply(this, [].slice.call(arguments, 1));
          }), q(G.prototype, "pinchTranslate", function(D, k, A, b, d, m, v) {
            var g;
            D.call(this, k, A, b, d, m, v), this.chart.options.chart.type === "map" && this.hasZoom && (g = b.scaleX > b.scaleY, this.pinchTranslateDirection(!g, k, A, b, d, m, v, g ? b.scaleX : b.scaleY));
          });
        }), at(_, "Series/ColorMapComposition.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = G.seriesTypes.column.prototype, J = F.addEvent, Q = F.defined;
          return function(q) {
            var U = [];
            function N(D) {
              var k = this;
              k.moveToTopOnHover && k.graphic && k.graphic.attr({ zIndex: D && D.state === "hover" ? 1 : 0 });
            }
            q.pointMembers = { dataLabelOnNull: !0, moveToTopOnHover: !0, isValid: function() {
              return this.value !== null && this.value !== 1 / 0 && this.value !== -1 / 0 && (this.value === void 0 || !isNaN(this.value));
            } }, q.seriesMembers = { colorKey: "value", axisTypes: ["xAxis", "yAxis", "colorAxis"], parallelArrays: ["x", "y", "value"], pointArrayMap: ["value"], trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], colorAttribs: function(D) {
              var k = {};
              return !Q(D.color) || D.state && D.state !== "normal" || (k[this.colorProp || "fill"] = D.color), k;
            }, pointAttribs: Y.pointAttribs }, q.compose = function(D) {
              var k = D.prototype.pointClass;
              return U.indexOf(k) === -1 && (U.push(k), J(k, "afterSetState", N)), D;
            };
          }($ || ($ = {})), $;
        }), at(_, "Maps/MapSymbols.js", [_["Core/Renderer/SVG/SVGRenderer.js"]], function(G) {
          var F = G.prototype.symbols;
          function $(Y, J, Q, q, U, N, D, k) {
            return [["M", Y + U, J], ["L", Y + Q - N, J], ["C", Y + Q - N / 2, J, Y + Q, J + N / 2, Y + Q, J + N], ["L", Y + Q, J + q - D], ["C", Y + Q, J + q - D / 2, Y + Q - D / 2, J + q, Y + Q - D, J + q], ["L", Y + k, J + q], ["C", Y + k / 2, J + q, Y, J + q - k / 2, Y, J + q - k], ["L", Y, J + U], ["C", Y, J + U / 2, Y + U / 2, J, Y + U, J], ["Z"]];
          }
          return F.bottombutton = function(Y, J, Q, q, U) {
            var N = U && U.r || 0;
            return $(Y - 1, J - 1, Q, q, 0, 0, N, N);
          }, F.topbutton = function(Y, J, Q, q, U) {
            var N = U && U.r || 0;
            return $(Y - 1, J - 1, Q, q, N, N, 0, 0);
          }, F;
        }), at(_, "Core/Chart/MapChart.js", [_["Core/Chart/Chart.js"], _["Core/Defaults.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(k, A) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
              b.__proto__ = d;
            } || function(b, d) {
              for (var m in d)
                d.hasOwnProperty(m) && (b[m] = d[m]);
            }, J(k, A);
          }, function(k, A) {
            function b() {
              this.constructor = k;
            }
            J(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
          }), q = F.getOptions, U = Y.merge, N = Y.pick, D = function(k) {
            function A() {
              return k !== null && k.apply(this, arguments) || this;
            }
            return Q(A, k), A.prototype.init = function(b, d) {
              var m = q().credits, v = U({ chart: { panning: { enabled: !0, type: "xy" }, type: "map" }, credits: { mapText: N(m.mapText, ' © <a href="{geojson.copyrightUrl}">{geojson.copyrightShort}</a>'), mapTextFull: N(m.mapTextFull, "{geojson.copyright}") }, mapView: {}, tooltip: { followTouchMove: !1 } }, b);
              k.prototype.init.call(this, v, d);
            }, A;
          }(G);
          return function(k) {
            k.maps = {}, k.mapChart = function(A, b, d) {
              return new k(A, b, d);
            }, k.splitPath = function(A) {
              var b;
              return b = typeof A == "string" ? (A = A.replace(/([A-Za-z])/g, " $1 ").replace(/^\s*/, "").replace(/\s*$/, "")).split(/[ ,;]+/).map(function(d) {
                return /[A-za-z]/.test(d) ? d : parseFloat(d);
              }) : A, $.prototype.pathToSegments(b);
            };
          }(D || (D = {})), D;
        }), at(_, "Maps/MapUtilities.js", [], function() {
          return { boundsFromPath: function(G) {
            var F, $ = -Number.MAX_VALUE, Y = Number.MAX_VALUE, J = -Number.MAX_VALUE, Q = Number.MAX_VALUE;
            if (G.forEach(function(q) {
              var U = q[q.length - 2], N = q[q.length - 1];
              typeof U == "number" && typeof N == "number" && (Y = Math.min(Y, U), $ = Math.max($, U), Q = Math.min(Q, N), J = Math.max(J, N), F = !0);
            }), F)
              return { x1: Y, y1: Q, x2: $, y2: J };
          }, pointInPolygon: function(G, F) {
            var $, Y, J = !1, Q = G.x, q = G.y;
            for ($ = 0, Y = F.length - 1; $ < F.length; Y = $++)
              F[$][1] > q != F[Y][1] > q && Q < (F[Y][0] - F[$][0]) * (q - F[$][1]) / (F[Y][1] - F[$][1]) + F[$][0] && (J = !J);
            return J;
          } };
        }), at(_, "Series/Map/MapPoint.js", [_["Series/ColorMapComposition.js"], _["Maps/MapUtilities.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(b, d) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, J(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            J(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), q = F.boundsFromPath, U = $.seriesTypes.scatter, N = Y.extend, D = Y.isNumber, k = Y.pick, A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.options = void 0, m.path = void 0, m.series = void 0, m;
            }
            return Q(d, b), d.getProjectedPath = function(m, v) {
              return m.projectedPath || (v && m.geometry ? (v.hasCoordinates = !0, m.projectedPath = v.path(m.geometry)) : m.projectedPath = m.path), m.projectedPath || [];
            }, d.prototype.applyOptions = function(m, v) {
              var g = this.series, x = b.prototype.applyOptions.call(this, m, v), E = g.joinBy;
              if (g.mapData && g.mapMap) {
                var P = E[1], S = b.prototype.getNestedProperty.call(x, P), u = S !== void 0 && g.mapMap[S];
                u ? N(x, u) : g.pointArrayMap.indexOf("value") !== -1 && (x.value = x.value || null);
              }
              return x;
            }, d.prototype.getProjectedBounds = function(m) {
              var v = d.getProjectedPath(this, m), g = q(v), x = this.properties;
              if (g) {
                var E = x && x["hc-middle-x"], P = x && x["hc-middle-y"];
                g.midX = g.x1 + (g.x2 - g.x1) * k(this.middleX, D(E) ? E : 0.5);
                var S = k(this.middleY, D(P) ? P : 0.5);
                return this.geometry || (S = 1 - S), g.midY = g.y2 - (g.y2 - g.y1) * S, g;
              }
            }, d.prototype.onMouseOver = function(m) {
              Y.clearTimeout(this.colorInterval), !this.isNull && this.visible || this.series.options.nullInteraction ? b.prototype.onMouseOver.call(this, m) : this.series.onMouseOut(m);
            }, d.prototype.setVisible = function(m) {
              var v = m ? "show" : "hide";
              this.visible = this.options.visible = !!m, this.dataLabel && this.dataLabel[v](), this.graphic && this.graphic.attr(this.series.pointAttribs(this));
            }, d.prototype.zoomTo = function() {
              var m = this, v = m.series.chart, g = v.mapView, x = m.bounds;
              if (g && x) {
                var E = D(m.insetIndex) && g.insets[m.insetIndex];
                if (E) {
                  var P = E.projectedUnitsToPixels({ x: x.x1, y: x.y1 }), S = E.projectedUnitsToPixels({ x: x.x2, y: x.y2 }), u = g.pixelsToProjectedUnits({ x: P.x, y: P.y }), y = g.pixelsToProjectedUnits({ x: S.x, y: S.y });
                  x = { x1: u.x, y1: u.y, x2: y.x, y2: y.y };
                }
                g.fitToBounds(x, void 0, !1), m.series.isDirty = !0, v.redraw();
              }
            }, d;
          }(U.prototype.pointClass);
          return N(A.prototype, { dataLabelOnNull: G.pointMembers.dataLabelOnNull, moveToTopOnHover: G.pointMembers.moveToTopOnHover, isValid: G.pointMembers.isValid }), A;
        }), at(_, "Maps/MapViewOptionsDefault.js", [], function() {
          return { center: [0, 0], fitToGeometry: void 0, maxZoom: void 0, padding: 0, projection: { name: void 0, parallels: void 0, rotation: void 0 }, zoom: void 0 };
        }), at(_, "Maps/MapViewInsetsOptionsDefault.js", [], function() {
          return { borderColor: "#cccccc", borderWidth: 1, center: [0, 0], padding: "10%", relativeTo: "mapBoundingBox", units: "percent" };
        }), at(_, "Extensions/GeoJSON.js", [_["Core/Chart/Chart.js"], _["Core/FormatUtilities.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = F.format, Q = $.win, q = Y.error, U = Y.extend, N = Y.merge, D = Y.wrap;
          function k(b, d) {
            d || (d = Object.keys(b.objects)[0]);
            var m = b.objects[d];
            if (m["hc-decoded-geojson"])
              return m["hc-decoded-geojson"];
            var v = b.arcs;
            if (b.transform) {
              var g = b.transform, x = g.scale, E = g.translate;
              v = b.arcs.map(function(y) {
                var s = 0, a = 0;
                return y.map(function(e) {
                  return (e = e.slice())[0] = (s += e[0]) * x[0] + E[0], e[1] = (a += e[1]) * x[1] + E[1], e;
                });
              });
            }
            var P = function(y) {
              return typeof y[0] == "number" ? y.reduce(function(s, a, e) {
                var n = a < 0 ? v[~a] : v[a];
                return a < 0 ? (n = n.slice(0, e === 0 ? n.length : n.length - 1)).reverse() : e && (n = n.slice(1)), s.concat(n);
              }, []) : y.map(P);
            }, S = m.geometries.map(function(y) {
              return { type: "Feature", properties: y.properties, geometry: { type: y.type, coordinates: y.coordinates || P(y.arcs) } };
            }), u = { type: "FeatureCollection", copyright: b.copyright, copyrightShort: b.copyrightShort, copyrightUrl: b.copyrightUrl, features: S, "hc-recommended-mapview": m["hc-recommended-mapview"], bbox: b.bbox, title: b.title };
            return m["hc-decoded-geojson"] = u, u;
          }
          function A(b, d, m) {
            d === void 0 && (d = "map");
            var v = [], g = b.type === "Topology" ? k(b) : b;
            return g.features.forEach(function(x) {
              var E, P = x.geometry || {}, S = P.type, u = P.coordinates, y = x.properties;
              if ((d !== "map" && d !== "mapbubble" || S !== "Polygon" && S !== "MultiPolygon") && (d !== "mapline" || S !== "LineString" && S !== "MultiLineString") ? d === "mappoint" && S === "Point" && u.length && (E = { geometry: { coordinates: u, type: S } }) : u.length && (E = { geometry: { coordinates: u, type: S } }), E) {
                var s = y && (y.name || y.NAME), a = y && y.lon, e = y && y.lat;
                v.push(U(E, { lat: typeof e == "number" ? e : void 0, lon: typeof a == "number" ? a : void 0, name: typeof s == "string" ? s : void 0, properties: y }));
              }
            }), m && g.copyrightShort && (m.chart.mapCredits = J(m.chart.options.credits.mapText, { geojson: g }), m.chart.mapCreditsFull = J(m.chart.options.credits.mapTextFull, { geojson: g })), v;
          }
          return G.prototype.transformFromLatLon = function(b, d) {
            var m = this.options.chart.proj4 || Q.proj4;
            if (m) {
              var v = d.jsonmarginX, g = v === void 0 ? 0 : v, x = d.jsonmarginY, E = x === void 0 ? 0 : x, P = d.jsonres, S = P === void 0 ? 1 : P, u = d.scale, y = u === void 0 ? 1 : u, s = d.xoffset, a = s === void 0 ? 0 : s, e = d.xpan, n = e === void 0 ? 0 : e, o = d.yoffset, i = o === void 0 ? 0 : o, c = d.ypan, l = c === void 0 ? 0 : c, h = m(d.crs, [b.lon, b.lat]), C = d.cosAngle || d.rotation && Math.cos(d.rotation), M = d.sinAngle || d.rotation && Math.sin(d.rotation), O = d.rotation ? [h[0] * C + h[1] * M, -h[0] * M + h[1] * C] : h;
              return { x: ((O[0] - a) * y + n) * S + g, y: -(((i - O[1]) * y + l) * S - E) };
            }
            q(21, !1, this);
          }, G.prototype.transformToLatLon = function(b, d) {
            var m = this.options.chart.proj4 || Q.proj4;
            if (m) {
              if (b.y !== null) {
                var v = d.jsonmarginX, g = v === void 0 ? 0 : v, x = d.jsonmarginY, E = x === void 0 ? 0 : x, P = d.jsonres, S = P === void 0 ? 1 : P, u = d.scale, y = u === void 0 ? 1 : u, s = d.xoffset, a = s === void 0 ? 0 : s, e = d.xpan, n = e === void 0 ? 0 : e, o = d.yoffset, i = o === void 0 ? 0 : o, c = d.ypan, l = c === void 0 ? 0 : c, h = { x: ((b.x - g) / S - n) / y + a, y: ((b.y - E) / S + l) / y + i }, C = d.cosAngle || d.rotation && Math.cos(d.rotation), M = d.sinAngle || d.rotation && Math.sin(d.rotation), O = m(d.crs, "WGS84", d.rotation ? { x: h.x * C + h.y * -M, y: h.x * M + h.y * C } : h);
                return { lat: O.y, lon: O.x };
              }
            } else
              q(21, !1, this);
          }, G.prototype.fromPointToLatLon = function(b) {
            return this.mapView && this.mapView.projectedUnitsToLonLat(b);
          }, G.prototype.fromLatLonToPoint = function(b) {
            return this.mapView && this.mapView.lonLatToProjectedUnits(b);
          }, D(G.prototype, "addCredits", function(b, d) {
            d = N(!0, this.options.credits, d), this.mapCredits && (d.href = null), b.call(this, d), this.credits && this.mapCreditsFull && this.credits.attr({ title: this.mapCreditsFull });
          }), $.geojson = A, $.topo2geo = k, { geojson: A, topo2geo: k };
        }), at(_, "Core/Geometry/PolygonClip.js", [], function() {
          var G, F = function(Y, J, Q) {
            return (J[0] - Y[0]) * (Q[1] - Y[1]) > (J[1] - Y[1]) * (Q[0] - Y[0]);
          }, $ = function(Y, J, Q, q) {
            var U = [Y[0] - J[0], Y[1] - J[1]], N = [Q[0] - q[0], Q[1] - q[1]], D = Y[0] * J[1] - Y[1] * J[0], k = Q[0] * q[1] - Q[1] * q[0], A = 1 / (U[0] * N[1] - U[1] * N[0]), b = [(D * N[0] - k * U[0]) * A, (D * N[1] - k * U[1]) * A];
            return b.isIntersection = !0, b;
          };
          return function(Y) {
            Y.clipLineString = function(J, Q) {
              for (var q = [], U = Y.clipPolygon(J, Q, !1), N = 1; N < U.length; N++)
                U[N].isIntersection && U[N - 1].isIntersection && (q.push(U.splice(0, N)), N = 0), N === U.length - 1 && q.push(U);
              return q;
            }, Y.clipPolygon = function(J, Q, q) {
              q === void 0 && (q = !0);
              for (var U, N, D, k = Q[Q.length - 1], A = J, b = 0; b < Q.length; b++) {
                var d = A;
                U = Q[b], A = [], N = q ? d[d.length - 1] : d[0];
                for (var m = 0; m < d.length; m++)
                  D = d[m], F(k, U, D) ? (F(k, U, N) || A.push($(k, U, N, D)), A.push(D)) : F(k, U, N) && A.push($(k, U, N, D)), N = D;
                k = U;
              }
              return A;
            };
          }(G || (G = {})), G;
        }), at(_, "Maps/Projections/LambertConformalConic.js", [], function() {
          var G = Math.sign || function(q) {
            return q === 0 ? 0 : q > 0 ? 1 : -1;
          }, F = 63.78137, $ = Math.PI / 180, Y = Math.PI / 2, J = 1e-6, Q = function(q) {
            return Math.tan((Y + q) / 2);
          };
          return function() {
            function q(U) {
              var N, D = (U.parallels || []).map(function(m) {
                return m * $;
              }), k = D[0] || 0, A = (N = D[1]) !== null && N !== void 0 ? N : k, b = Math.cos(k);
              typeof U.projectedBounds == "object" && (this.projectedBounds = U.projectedBounds);
              var d = k === A ? Math.sin(k) : Math.log(b / Math.cos(A)) / Math.log(Q(A) / Q(k));
              Math.abs(d) < 1e-10 && (d = 1e-10 * (G(d) || 1)), this.n = d, this.c = b * Math.pow(Q(k), d) / d;
            }
            return q.prototype.forward = function(U) {
              var N = U[0] * $, D = this, k = D.c, A = D.n, b = D.projectedBounds, d = U[1] * $;
              k > 0 ? d < -Y + J && (d = -Y + J) : d > Y - J && (d = Y - J);
              var m = k / Math.pow(Q(d), A), v = m * Math.sin(A * N) * F, g = (k - m * Math.cos(A * N)) * F, x = [v, g];
              return b && (v < b.x1 || v > b.x2 || g < b.y1 || g > b.y2) && (x.outside = !0), x;
            }, q.prototype.inverse = function(U) {
              var N = U[0] / F, D = U[1] / F, k = this.c, A = this.n, b = k - D, d = G(A) * Math.sqrt(N * N + b * b), m = Math.atan2(N, Math.abs(b)) * G(b);
              return b * A < 0 && (m -= Math.PI * G(N) * G(b)), [m / A / $, (2 * Math.atan(Math.pow(k / d, 1 / A)) - Y) / $];
            }, q;
          }();
        }), at(_, "Maps/Projections/EqualEarth.js", [], function() {
          var G = 1.340264, F = -0.081106, $ = 893e-6, Y = 3796e-6, J = Math.sqrt(3) / 2, Q = 74.03120656864502;
          return function() {
            function q() {
              this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -97.52595454902263, y2: 97.52595454902263 };
            }
            return q.prototype.forward = function(U) {
              var N = Math.PI / 180, D = Math.asin(J * Math.sin(U[1] * N)), k = D * D, A = k * k * k;
              return [U[0] * N * Math.cos(D) * Q / (J * (G + 3 * F * k + A * (7 * $ + 9 * Y * k))), D * Q * (G + F * k + A * ($ + Y * k))];
            }, q.prototype.inverse = function(U) {
              var N, D, k, A, b = U[0] / Q, d = U[1] / Q, m = 180 / Math.PI, v = d;
              for (A = 0; A < 12 && (v -= k = (v * (G + F * (N = v * v) + (D = N * N * N) * ($ + Y * N)) - d) / (G + 3 * F * N + D * (7 * $ + 9 * Y * N)), !(Math.abs(k) < 1e-9)); ++A)
                ;
              return [m * J * b * (G + 3 * F * (N = v * v) + (D = N * N * N) * (7 * $ + 9 * Y * N)) / Math.cos(v), m * Math.asin(Math.sin(v) / J)];
            }, q;
          }();
        }), at(_, "Maps/Projections/Miller.js", [], function() {
          var G = Math.PI / 4, F = Math.PI / 180, $ = 63.78137;
          return function() {
            function Y() {
              this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -146.91480769173063, y2: 146.91480769173063 };
            }
            return Y.prototype.forward = function(J) {
              return [J[0] * F * $, 79.7267125 * Math.log(Math.tan(G + 0.4 * J[1] * F))];
            }, Y.prototype.inverse = function(J) {
              return [J[0] / $ / F, 2.5 * (Math.atan(Math.exp(J[1] / $ * 0.8)) - G) / F];
            }, Y;
          }();
        }), at(_, "Maps/Projections/Orthographic.js", [], function() {
          var G = Math.PI / 180, F = 63.78460826781007;
          return function() {
            function $() {
              this.antimeridianCutting = !1, this.bounds = { x1: -F, x2: F, y1: -F, y2: F };
            }
            return $.prototype.forward = function(Y) {
              var J = Y[0], Q = Y[1] * G, q = [Math.cos(Q) * Math.sin(J * G) * F, Math.sin(Q) * F];
              return (J < -90 || J > 90) && (q.outside = !0), q;
            }, $.prototype.inverse = function(Y) {
              var J = Y[0] / F, Q = Y[1] / F, q = Math.sqrt(J * J + Q * Q), U = Math.asin(q), N = Math.sin(U), D = Math.cos(U);
              return [Math.atan2(J * N, q * D) / G, Math.asin(q && Q * N / q) / G];
            }, $;
          }();
        }), at(_, "Maps/Projections/WebMercator.js", [], function() {
          var G = 85.0511287798, F = 63.78137, $ = Math.PI / 180;
          return function() {
            function Y() {
              this.bounds = { x1: -200.37508342789243, x2: 200.37508342789243, y1: -200.3750834278071, y2: 200.3750834278071 }, this.maxLatitude = G;
            }
            return Y.prototype.forward = function(J) {
              var Q = Math.sin(J[1] * $), q = [F * J[0] * $, F * Math.log((1 + Q) / (1 - Q)) / 2];
              return Math.abs(J[1]) > G && (q.outside = !0), q;
            }, Y.prototype.inverse = function(J) {
              return [J[0] / (F * $), (2 * Math.atan(Math.exp(J[1] / F)) - Math.PI / 2) / $];
            }, Y;
          }();
        }), at(_, "Maps/Projections/ProjectionRegistry.js", [_["Maps/Projections/LambertConformalConic.js"], _["Maps/Projections/EqualEarth.js"], _["Maps/Projections/Miller.js"], _["Maps/Projections/Orthographic.js"], _["Maps/Projections/WebMercator.js"]], function(G, F, $, Y, J) {
          return { EqualEarth: F, LambertConformalConic: G, Miller: $, Orthographic: Y, WebMercator: J };
        }), at(_, "Maps/Projection.js", [_["Core/Geometry/PolygonClip.js"], _["Maps/Projections/ProjectionRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = this && this.__spreadArray || function(A, b, d) {
            if (d || arguments.length === 2)
              for (var m, v = 0, g = b.length; v < g; v++)
                !m && v in b || (m || (m = Array.prototype.slice.call(b, 0, v)), m[v] = b[v]);
            return A.concat(m || Array.prototype.slice.call(b));
          }, J = G.clipLineString, Q = G.clipPolygon, q = $.clamp, U = $.erase, N = 2 * Math.PI / 360, D = 1e-6, k = function(A) {
            return A < -180 && (A += 360), A > 180 && (A -= 360), A;
          };
          return function() {
            function A(b) {
              b === void 0 && (b = {}), this.hasCoordinates = !1, this.hasGeoProjection = !1, this.maxLatitude = 90, this.options = b;
              var d = b.name, m = b.projectedBounds, v = b.rotation;
              this.rotator = v ? this.getRotator(v) : void 0;
              var g = d ? A.registry[d] : void 0;
              g && (this.def = new g(b));
              var x = this.def, E = this.rotator;
              x && (this.maxLatitude = x.maxLatitude || 90, this.hasGeoProjection = !0), E && x ? (this.forward = function(P) {
                return x.forward(E.forward(P));
              }, this.inverse = function(P) {
                return E.inverse(x.inverse(P));
              }) : x ? (this.forward = function(P) {
                return x.forward(P);
              }, this.inverse = function(P) {
                return x.inverse(P);
              }) : E && (this.forward = E.forward, this.inverse = E.inverse), this.bounds = m === "world" ? x && x.bounds : m;
            }
            return A.add = function(b, d) {
              A.registry[b] = d;
            }, A.greatCircle = function(b, d, m) {
              var v = Math.atan2, g = Math.cos, x = Math.sin, E = Math.sqrt, P = b[1] * N, S = b[0] * N, u = d[1] * N, y = d[0] * N, s = u - P, a = y - S, e = x(s / 2) * x(s / 2) + g(P) * g(u) * x(a / 2) * x(a / 2), n = 2 * v(E(e), E(1 - e)), o = 6371e3 * n, i = Math.round(o / 5e5), c = [];
              if (m && c.push(b), i > 1)
                for (var l = 1 / i, h = l; h < 0.999; h += l) {
                  var C = x((1 - h) * n) / x(n), M = x(h * n) / x(n), O = C * g(P) * g(S) + M * g(u) * g(y), p = C * g(P) * x(S) + M * g(u) * x(y), w = v(C * x(P) + M * x(u), E(O * O + p * p)), T = v(p, O);
                  c.push([T / N, w / N]);
                }
              return m && c.push(d), c;
            }, A.insertGreatCircles = function(b) {
              for (var d = b.length - 1; d--; )
                if (Math.max(Math.abs(b[d][0] - b[d + 1][0]), Math.abs(b[d][1] - b[d + 1][1])) > 10) {
                  var m = A.greatCircle(b[d], b[d + 1]);
                  m.length && b.splice.apply(b, Y([d + 1, 0], m, !1));
                }
            }, A.toString = function(b) {
              var d = b || {}, m = d.name, v = d.rotation;
              return [m, v && v.join(",")].join(";");
            }, A.prototype.lineIntersectsBounds = function(b) {
              var d, m = this.bounds || {}, v = m.x1, g = m.x2, x = m.y1, E = m.y2, P = function(u, y, s) {
                var a = u[0], e = u[1], n = y ? 0 : 1;
                if (typeof s == "number" && a[y] >= s != e[y] >= s) {
                  var o = (s - a[y]) / (e[y] - a[y]), i = a[n] + o * (e[n] - a[n]);
                  return y ? [i, s] : [s, i];
                }
              }, S = b[0];
              return ((d = P(b, 0, v)) || (d = P(b, 0, g))) && (S = d, b[1] = d), ((d = P(b, 1, x)) || (d = P(b, 1, E))) && (S = d), S;
            }, A.prototype.getRotator = function(b) {
              var d = b[0] * N, m = (b[1] || 0) * N, v = (b[2] || 0) * N, g = Math.cos(m), x = Math.sin(m), E = Math.cos(v), P = Math.sin(v);
              if (d !== 0 || m !== 0 || v !== 0)
                return { forward: function(S) {
                  var u = S[0] * N + d, y = S[1] * N, s = Math.cos(y), a = Math.cos(u) * s, e = Math.sin(u) * s, n = Math.sin(y), o = n * g + a * x;
                  return [Math.atan2(e * E - o * P, a * g - n * x) / N, Math.asin(o * E + e * P) / N];
                }, inverse: function(S) {
                  var u = S[0] * N, y = S[1] * N, s = Math.cos(y), a = Math.cos(u) * s, e = Math.sin(u) * s, n = Math.sin(y), o = n * E - e * P;
                  return [(Math.atan2(e * E + n * P, a * g + o * x) - d) / N, Math.asin(o * g - a * x) / N];
                } };
            }, A.prototype.forward = function(b) {
              return b;
            }, A.prototype.inverse = function(b) {
              return b;
            }, A.prototype.cutOnAntimeridian = function(b, d) {
              var m, v = 180, g = [], x = [b];
              if (b.forEach(function(M, O) {
                var p = b[O - 1];
                if (!O) {
                  if (!d)
                    return;
                  p = b[b.length - 1];
                }
                var w = p[0], T = M[0];
                if ((w < -90 || w > 90) && (T < -90 || T > 90) && w > 0 != T > 0) {
                  var z = q((v - (w + 360) % 360) / ((T + 360) % 360 - (w + 360) % 360), 0, 1), W = p[1] + z * (M[1] - p[1]);
                  g.push({ i: O, lat: W, direction: w < 0 ? 1 : -1, previousLonLat: p, lonLat: M });
                }
              }), g.length)
                if (d) {
                  g.length % 2 == 1 && (m = g.slice().sort(function(M, O) {
                    return Math.abs(O.lat) - Math.abs(M.lat);
                  })[0], U(g, m));
                  for (var E = g.length - 2; E >= 0; ) {
                    var P = g[E].i, S = k(v + g[E].direction * D), u = k(v - g[E].direction * D);
                    (C = b.splice.apply(b, Y([P, g[E + 1].i - P], A.greatCircle([S, g[E].lat], [S, g[E + 1].lat], !0), !1))).push.apply(C, A.greatCircle([u, g[E + 1].lat], [u, g[E].lat], !0)), x.push(C), E -= 2;
                  }
                  if (m)
                    for (var y = 0; y < x.length; y++) {
                      var s = m.direction, a = m.lat, e = x[y], n = e.indexOf(m.lonLat);
                      if (n > -1) {
                        for (var o = (a < 0 ? -1 : 1) * this.maxLatitude, i = k(v + s * D), c = k(v - s * D), l = A.greatCircle([i, a], [i, o], !0), h = i + 120 * s; h > -180 && h < 180; h += 120 * s)
                          l.push([h, o]);
                        l.push.apply(l, A.greatCircle([c, o], [c, m.lat], !0)), e.splice.apply(e, Y([n, 0], l, !1));
                        break;
                      }
                    }
                } else
                  for (E = g.length; E--; ) {
                    var C;
                    P = g[E].i, (C = b.splice(P, b.length, [k(v + g[E].direction * D), g[E].lat])).unshift([k(v - g[E].direction * D), g[E].lat]), x.push(C);
                  }
              return x;
            }, A.prototype.path = function(b) {
              var d, m = this, v = this, g = v.bounds, x = v.def, E = v.rotator, P = [], S = b.type === "Polygon" || b.type === "MultiPolygon", u = this.hasGeoProjection, y = !x || x.antimeridianCutting !== !1, s = y ? E : void 0, a = y && x || this;
              g && (d = [[g.x1, g.y1], [g.x2, g.y1], [g.x2, g.y2], [g.x1, g.y2]]);
              var e = function(n) {
                var o = n.map(function(c) {
                  if (y) {
                    s && (c = s.forward(c));
                    var l = c[0];
                    Math.abs(l - 180) < D && (l = l < 180 ? 179.999999 : 180.000001), c = [l, c[1]];
                  }
                  return c;
                }), i = [o];
                u && (A.insertGreatCircles(o), y && (i = m.cutOnAntimeridian(o, S))), i.forEach(function(c) {
                  if (!(c.length < 2)) {
                    var l, h, C = !1, M = !1, O = function(I) {
                      C ? P.push(["L", I[0], I[1]]) : (P.push(["M", I[0], I[1]]), C = !0);
                    }, p = !1, w = !1, T = c.map(function(I) {
                      var j = a.forward(I);
                      return j.outside ? p = !0 : w = !0, j[1] === 1 / 0 ? j[1] = 1e10 : j[1] === -1 / 0 && (j[1] = -1e10), j;
                    });
                    if (y) {
                      if (S && T.push(T[0]), p) {
                        if (!w)
                          return;
                        if (d) {
                          if (S)
                            T = Q(T, d);
                          else if (g)
                            return void J(T, d).forEach(function(I) {
                              C = !1, I.forEach(O);
                            });
                        }
                      }
                      T.forEach(O);
                    } else
                      for (var z = 0; z < T.length; z++) {
                        var W = c[z], L = T[z];
                        L.outside ? M = !0 : (S && !l && (l = W, c.push(W), T.push(L)), M && h && (S && u ? A.greatCircle(h, W).forEach(function(I) {
                          return O(a.forward(I));
                        }) : C = !1), O(L), h = W, M = !1);
                      }
                  }
                });
              };
              return b.type === "LineString" ? e(b.coordinates) : b.type === "MultiLineString" ? b.coordinates.forEach(function(n) {
                return e(n);
              }) : b.type === "Polygon" ? (b.coordinates.forEach(function(n) {
                return e(n);
              }), P.length && P.push(["Z"])) : b.type === "MultiPolygon" && (b.coordinates.forEach(function(n) {
                n.forEach(function(o) {
                  return e(o);
                });
              }), P.length && P.push(["Z"])), P;
            }, A.registry = F, A;
          }();
        }), at(_, "Maps/MapView.js", [_["Maps/MapViewOptionsDefault.js"], _["Maps/MapViewInsetsOptionsDefault.js"], _["Extensions/GeoJSON.js"], _["Core/Chart/MapChart.js"], _["Maps/MapUtilities.js"], _["Maps/Projection.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q) {
          var U, N = this && this.__extends || (U = function(i, c) {
            return U = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, h) {
              l.__proto__ = h;
            } || function(l, h) {
              for (var C in h)
                h.hasOwnProperty(C) && (l[C] = h[C]);
            }, U(i, c);
          }, function(i, c) {
            function l() {
              this.constructor = i;
            }
            U(i, c), i.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
          }), D = this && this.__spreadArray || function(i, c, l) {
            if (l || arguments.length === 2)
              for (var h, C = 0, M = c.length; C < M; C++)
                !h && C in c || (h || (h = Array.prototype.slice.call(c, 0, C)), h[C] = c[C]);
            return i.concat(h || Array.prototype.slice.call(c));
          }, k = $.topo2geo, A = Y.maps, b = J.boundsFromPath, d = J.pointInPolygon, m = q.addEvent, v = q.clamp, g = q.fireEvent, x = q.isArray, E = q.isNumber, P = q.isObject, S = q.isString, u = q.merge, y = q.pick, s = q.relativeLength, a = 400.979322, e = function(i, c) {
            var l = c.width, h = c.height, C = Math.max((i.x2 - i.x1) / (l / 256), (i.y2 - i.y1) / (h / 256));
            return Math.log(a / C) / Math.log(2);
          }, n = function() {
            function i(c, l) {
              var h, C, M = this;
              if (this.insets = [], this.padding = [0, 0, 0, 0], this.eventsToUnbind = [], !(this instanceof o)) {
                var O = D([c.options.chart.map], (c.options.series || []).map(function(V) {
                  return V.mapData;
                }), !0).map(function(V) {
                  return M.getGeoMap(V);
                }), p = [];
                O.forEach(function(V) {
                  if (V && (h || (h = V["hc-recommended-mapview"]), V.bbox)) {
                    var X = V.bbox, et = X[0], ot = X[1], it = X[2], pt = X[3];
                    p.push({ x1: et, y1: ot, x2: it, y2: pt });
                  }
                });
                var w = p.length && i.compositeBounds(p);
                if (w) {
                  var T = w.x1, z = w.y1, W = w.x2, L = w.y2;
                  C = W - T > 180 && L - z > 90 ? { name: "EqualEarth" } : { name: "LambertConformalConic", parallels: [z, L], rotation: [-(T + W) / 2] };
                }
                this.geoMap = O[0];
              }
              this.userOptions = l || {};
              var I = u(G, { projection: C }, h, l), j = h && h.insets, Z = l && l.insets;
              j && Z && (I.insets = i.mergeInsets(j, Z)), this.chart = c, this.center = I.center, this.options = I, this.projection = new Q(I.projection), this.playingField = c.plotBox, this.zoom = I.zoom || 0, this.createInsets(), this.eventsToUnbind.push(m(c, "afterSetChartSize", function() {
                M.playingField = M.getField(), M.minZoom !== void 0 && M.minZoom !== M.zoom || (M.fitToBounds(void 0, void 0, !1), !M.chart.hasRendered && E(M.userOptions.zoom) && (M.zoom = M.userOptions.zoom), M.userOptions.center && u(!0, M.center, M.userOptions.center));
              })), this.setUpEvents();
            }
            return i.mergeInsets = function(c, l) {
              var h = function(M) {
                var O = {};
                return M.forEach(function(p, w) {
                  O[p && p.id || "i".concat(w)] = p;
                }), O;
              }, C = u(h(c), h(l));
              return Object.keys(C).map(function(M) {
                return C[M];
              });
            }, i.prototype.createInsets = function() {
              var c = this, l = this.options, h = l.insets;
              h && h.forEach(function(C) {
                var M = new o(c, u(l.insetOptions, C));
                c.insets.push(M);
              });
            }, i.prototype.fitToBounds = function(c, l, h, C) {
              h === void 0 && (h = !0);
              var M = c || this.getProjectedBounds();
              if (M) {
                var O = y(l, c ? 0 : this.options.padding), p = this.getField(!1), w = x(O) ? O : [O, O, O, O];
                this.padding = [s(w[0], p.height), s(w[1], p.width), s(w[2], p.height), s(w[3], p.width)], this.playingField = this.getField();
                var T = e(M, this.playingField);
                c || (this.minZoom = T);
                var z = this.projection.inverse([(M.x2 + M.x1) / 2, (M.y2 + M.y1) / 2]);
                this.setView(z, T, h, C);
              }
            }, i.prototype.getField = function(c) {
              c === void 0 && (c = !0);
              var l = c ? this.padding : [0, 0, 0, 0];
              return { x: l[3], y: l[0], width: this.chart.plotWidth - l[1] - l[3], height: this.chart.plotHeight - l[0] - l[2] };
            }, i.prototype.getGeoMap = function(c) {
              if (S(c))
                return A[c];
              if (P(c, !0)) {
                if (c.type === "FeatureCollection")
                  return c;
                if (c.type === "Topology")
                  return k(c);
              }
            }, i.prototype.getMapBBox = function() {
              var c = this.getProjectedBounds(), l = this.getScale();
              if (c) {
                var h = this.padding, C = this.projectedUnitsToPixels({ x: c.x1, y: c.y2 });
                return { width: (c.x2 - c.x1) * l + h[1] + h[3], height: (c.y2 - c.y1) * l + h[0] + h[2], x: C.x - h[3], y: C.y - h[0] };
              }
            }, i.prototype.getProjectedBounds = function() {
              var c = this.projection, l = this.chart.series.reduce(function(p, w) {
                var T = w.getProjectedBounds && w.getProjectedBounds();
                return T && w.options.affectsMapView !== !1 && p.push(T), p;
              }, []), h = this.options.fitToGeometry;
              if (h) {
                if (!this.fitToGeometryCache)
                  if (h.type === "MultiPoint") {
                    var C = h.coordinates.map(function(p) {
                      return c.forward(p);
                    }), M = C.map(function(p) {
                      return p[0];
                    }), O = C.map(function(p) {
                      return p[1];
                    });
                    this.fitToGeometryCache = { x1: Math.min.apply(0, M), x2: Math.max.apply(0, M), y1: Math.min.apply(0, O), y2: Math.max.apply(0, O) };
                  } else
                    this.fitToGeometryCache = b(c.path(h));
                return this.fitToGeometryCache;
              }
              return this.projection.bounds || i.compositeBounds(l);
            }, i.prototype.getScale = function() {
              return 256 / a * Math.pow(2, this.zoom);
            }, i.prototype.getSVGTransform = function() {
              var c = this.playingField, l = c.x, h = c.y, C = c.width, M = c.height, O = this.projection.forward(this.center), p = this.projection.hasCoordinates ? -1 : 1, w = this.getScale(), T = w * p;
              return { scaleX: w, scaleY: T, translateX: l + C / 2 - O[0] * w, translateY: h + M / 2 - O[1] * T };
            }, i.prototype.lonLatToPixels = function(c) {
              var l = this.lonLatToProjectedUnits(c);
              if (l)
                return this.projectedUnitsToPixels(l);
            }, i.prototype.lonLatToProjectedUnits = function(c) {
              var l = this.chart, h = l.mapTransforms;
              if (h) {
                for (var C in h)
                  if (Object.hasOwnProperty.call(h, C) && h[C].hitZone) {
                    var M = l.transformFromLatLon(c, h[C]);
                    if (M && d(M, h[C].hitZone.coordinates[0]))
                      return M;
                  }
                return l.transformFromLatLon(c, h.default);
              }
              for (var O = 0, p = this.insets; O < p.length; O++) {
                var w = p[O];
                if (w.options.geoBounds && d({ x: c.lon, y: c.lat }, w.options.geoBounds.coordinates[0])) {
                  var T = w.projection.forward([c.lon, c.lat]), z = w.projectedUnitsToPixels({ x: T[0], y: T[1] });
                  return this.pixelsToProjectedUnits(z);
                }
              }
              var W = this.projection.forward([c.lon, c.lat]);
              if (!W.outside)
                return { x: W[0], y: W[1] };
            }, i.prototype.projectedUnitsToLonLat = function(c) {
              var l = this.chart, h = l.mapTransforms;
              if (h) {
                for (var C in h)
                  if (Object.hasOwnProperty.call(h, C) && h[C].hitZone && d(c, h[C].hitZone.coordinates[0]))
                    return l.transformToLatLon(c, h[C]);
                return l.transformToLatLon(c, h.default);
              }
              for (var M = this.projectedUnitsToPixels(c), O = 0, p = this.insets; O < p.length; O++) {
                var w = p[O];
                if (w.hitZone && d(M, w.hitZone.coordinates[0])) {
                  var T = w.pixelsToProjectedUnits(M), z = w.projection.inverse([T.x, T.y]);
                  return { lon: z[0], lat: z[1] };
                }
              }
              var W = this.projection.inverse([c.x, c.y]);
              return { lon: W[0], lat: W[1] };
            }, i.prototype.redraw = function(c) {
              this.chart.series.forEach(function(l) {
                l.useMapGeometry && (l.isDirty = !0);
              }), this.chart.redraw(c);
            }, i.prototype.setView = function(c, l, h, C) {
              h === void 0 && (h = !0), c && (this.center = c), typeof l == "number" && (typeof this.minZoom == "number" && (l = Math.max(l, this.minZoom)), typeof this.options.maxZoom == "number" && (l = Math.min(l, this.options.maxZoom)), E(l) && (this.zoom = l));
              var M = this.getProjectedBounds();
              if (M) {
                var O = this.projection.forward(this.center), p = this.playingField, w = p.x, T = p.y, z = p.width, W = p.height, L = this.getScale(), I = this.projectedUnitsToPixels({ x: M.x1, y: M.y1 }), j = this.projectedUnitsToPixels({ x: M.x2, y: M.y2 }), Z = [(M.x1 + M.x2) / 2, (M.y1 + M.y2) / 2], V = I.x, X = j.y, et = j.x, ot = I.y;
                et - V < z ? O[0] = Z[0] : V < w && et < w + z ? O[0] += Math.max(V - w, et - z - w) / L : et > w + z && V > w && (O[0] += Math.min(et - z - w, V - w) / L), ot - X < W ? O[1] = Z[1] : X < T && ot < T + W ? O[1] -= Math.max(X - T, ot - W - T) / L : ot > T + W && X > T && (O[1] -= Math.min(ot - W - T, X - T) / L), this.center = this.projection.inverse(O), this.insets.forEach(function(it) {
                  it.options.field && (it.hitZone = it.getHitZone(), it.playingField = it.getField());
                }), this.render();
              }
              g(this, "afterSetView"), h && this.redraw(C);
            }, i.prototype.projectedUnitsToPixels = function(c) {
              var l = this.getScale(), h = this.projection.forward(this.center), C = this.playingField, M = C.x + C.width / 2, O = C.y + C.height / 2;
              return { x: M - l * (h[0] - c.x), y: O + l * (h[1] - c.y) };
            }, i.prototype.pixelsToLonLat = function(c) {
              return this.projectedUnitsToLonLat(this.pixelsToProjectedUnits(c));
            }, i.prototype.pixelsToProjectedUnits = function(c) {
              var l = c.x, h = c.y, C = this.getScale(), M = this.projection.forward(this.center), O = this.playingField, p = O.x + O.width / 2, w = O.y + O.height / 2;
              return { x: M[0] + (l - p) / C, y: M[1] - (h - w) / C };
            }, i.prototype.setUpEvents = function() {
              var c, l, h, C = this, M = this.chart, O = function(p) {
                var w = M.pointer.pinchDown, T = C.projection, z = M.mouseDownX, W = M.mouseDownY;
                if (w.length === 1 && (z = w[0].chartX, W = w[0].chartY), typeof z == "number" && typeof W == "number") {
                  var L = "" + z + ",".concat(W), I = p.originalEvent, j = I.chartX, Z = I.chartY;
                  L !== l && (l = L, c = C.projection.forward(C.center), h = (C.projection.options.rotation || [0, 0]).slice());
                  var V = T.def && T.def.bounds, X = V && e(V, C.playingField) || -1 / 0;
                  if (T.options.name === "Orthographic" && (C.minZoom || 1 / 0) < 1.1 * X) {
                    var et = 440 / (C.getScale() * Math.min(M.plotWidth, M.plotHeight));
                    if (h) {
                      var ot = (z - j) * et - h[0], it = v(-h[1] - (W - Z) * et, -80, 80), pt = C.zoom;
                      C.update({ projection: { rotation: [-ot, -it] } }, !1), C.zoom = pt, M.redraw(!1);
                    }
                  } else if (E(j) && E(Z)) {
                    var mt = C.getScale(), Ct = C.projection.hasCoordinates ? 1 : -1, kt = C.projection.inverse([c[0] + (z - j) / mt, c[1] - (W - Z) / mt * Ct]);
                    C.setView(kt, void 0, !0, !1);
                  }
                  p.preventDefault();
                }
              };
              m(M, "pan", O), m(M, "touchpan", O), m(M, "selection", function(p) {
                if (p.resetSelection)
                  C.zoomBy();
                else {
                  var w = p.x - M.plotLeft, T = p.y - M.plotTop, z = C.pixelsToProjectedUnits({ x: w, y: T }), W = z.y, L = z.x, I = C.pixelsToProjectedUnits({ x: w + p.width, y: T + p.height }), j = I.y, Z = I.x;
                  C.fitToBounds({ x1: L, y1: W, x2: Z, y2: j }, void 0, !0, !p.originalEvent.touches && void 0), /^touch/.test(p.originalEvent.type) || M.showResetZoom(), p.preventDefault();
                }
              });
            }, i.prototype.render = function() {
              this.group || (this.group = this.chart.renderer.g("map-view").attr({ zIndex: 4 }).add());
            }, i.prototype.update = function(c, l, h) {
              l === void 0 && (l = !0);
              var C = c.projection, M = C && Q.toString(C) !== Q.toString(this.options.projection), O = !1;
              u(!0, this.userOptions, c), u(!0, this.options, c), "insets" in c && (this.insets.forEach(function(p) {
                return p.destroy();
              }), this.insets.length = 0, O = !0), (M || "fitToGeometry" in c) && delete this.fitToGeometryCache, (M || O) && (this.chart.series.forEach(function(p) {
                var w = p.transformGroups;
                if (p.clearBounds && p.clearBounds(), p.isDirty = !0, p.isDirtyData = !0, O && w)
                  for (; w.length > 1; ) {
                    var T = w.pop();
                    T && T.destroy();
                  }
              }), M && (this.projection = new Q(this.options.projection)), O && this.createInsets(), c.center || E(c.zoom) || this.fitToBounds(void 0, void 0, !1)), c.center || E(c.zoom) ? this.setView(this.options.center, c.zoom, !1) : "fitToGeometry" in c && this.fitToBounds(void 0, void 0, !1), l && this.chart.redraw(h);
            }, i.prototype.zoomBy = function(c, l, h, C) {
              var M = this.chart, O = this.projection.forward(this.center), p = l ? this.projection.forward(l) : [], w = p[0], T = p[1];
              if (typeof c == "number") {
                var z = this.zoom + c, W = void 0;
                if (h) {
                  var L = h[0], I = h[1], j = this.getScale(), Z = L - M.plotLeft - M.plotWidth / 2, V = I - M.plotTop - M.plotHeight / 2;
                  w = O[0] + Z / j, T = O[1] + V / j;
                }
                typeof w == "number" && typeof T == "number" && (j = 1 - Math.pow(2, this.zoom) / Math.pow(2, z), Z = O[0] - w, V = O[1] - T, O[0] -= Z * j, O[1] += V * j, W = this.projection.inverse(O)), this.setView(W, z, void 0, C);
              } else
                this.fitToBounds(void 0, void 0, void 0, C);
            }, i.compositeBounds = function(c) {
              if (c.length)
                return c.slice(1).reduce(function(l, h) {
                  return l.x1 = Math.min(l.x1, h.x1), l.y1 = Math.min(l.y1, h.y1), l.x2 = Math.max(l.x2, h.x2), l.y2 = Math.max(l.y2, h.y2), l;
                }, u(c[0]));
            }, i;
          }(), o = function(i) {
            function c(l, h) {
              var C = i.call(this, l.chart, h) || this;
              if (C.id = h.id, C.mapView = l, C.options = u(F, h), C.allBounds = [], C.options.geoBounds) {
                var M = l.projection.path(C.options.geoBounds);
                C.geoBoundsProjectedBox = b(M), C.geoBoundsProjectedPolygon = M.map(function(O) {
                  return [O[1] || 0, O[2] || 0];
                });
              }
              return C;
            }
            return N(c, i), c.prototype.getField = function(l) {
              l === void 0 && (l = !0);
              var h = this.hitZone;
              if (h) {
                var C = l ? this.padding : [0, 0, 0, 0], M = h.coordinates[0], O = M.map(function(L) {
                  return L[0];
                }), p = M.map(function(L) {
                  return L[1];
                }), w = Math.min.apply(0, O) + C[3], T = Math.max.apply(0, O) - C[1], z = Math.min.apply(0, p) + C[0], W = Math.max.apply(0, p) - C[2];
                if (E(w) && E(z))
                  return { x: w, y: z, width: T - w, height: W - z };
              }
              return i.prototype.getField.call(this, l);
            }, c.prototype.getHitZone = function() {
              var l = this, h = l.chart, C = l.mapView, M = l.options, O = (M.field || {}).coordinates;
              if (O) {
                var p = O[0];
                if (M.units === "percent") {
                  var w = M.relativeTo === "mapBoundingBox" && C.getMapBBox() || u(h.plotBox, { x: 0, y: 0 });
                  p = p.map(function(T) {
                    return [s(T[0] + "%", w.width, w.x), s(T[1] + "%", w.height, w.y)];
                  });
                }
                return { type: "Polygon", coordinates: [p] };
              }
            }, c.prototype.getProjectedBounds = function() {
              return n.compositeBounds(this.allBounds);
            }, c.prototype.isInside = function(l) {
              var h = this.geoBoundsProjectedBox, C = this.geoBoundsProjectedPolygon;
              return !!(h && l.x >= h.x1 && l.x <= h.x2 && l.y >= h.y1 && l.y <= h.y2 && C && d(l, C));
            }, c.prototype.render = function() {
              var l = this, h = l.chart, C = l.mapView, M = l.options, O = M.borderPath || M.field;
              if (O && C.group) {
                var p = !0;
                this.border || (this.border = h.renderer.path().addClass("highcharts-mapview-inset-border").add(C.group), p = !1), h.styledMode || this.border.attr({ stroke: M.borderColor, "stroke-width": M.borderWidth });
                var w = Math.round(this.border.strokeWidth()) % 2 / 2, T = M.relativeTo === "mapBoundingBox" && C.getMapBBox() || C.playingField, z = (O.coordinates || []).reduce(function(W, L) {
                  return L.reduce(function(I, j, Z) {
                    var V = j[0], X = j[1];
                    return M.units === "percent" && (V = h.plotLeft + s(V + "%", T.width, T.x), X = h.plotTop + s(X + "%", T.height, T.y)), V = Math.floor(V) + w, X = Math.floor(X) + w, I.push(Z === 0 ? ["M", V, X] : ["L", V, X]), I;
                  }, W);
                }, []);
                this.border[p ? "animate" : "attr"]({ d: z });
              }
            }, c.prototype.destroy = function() {
              this.border && (this.border = this.border.destroy()), this.eventsToUnbind.forEach(function(l) {
                return l();
              });
            }, c.prototype.setUpEvents = function() {
            }, c;
          }(n);
          return m(Y, "afterInit", function() {
            this.mapView = new n(this, this.options.mapView);
          }), n;
        }), at(_, "Series/Map/MapSeries.js", [_["Core/Animation/AnimationUtilities.js"], _["Series/ColorMapComposition.js"], _["Series/CenteredUtilities.js"], _["Core/Globals.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Chart/MapChart.js"], _["Series/Map/MapPoint.js"], _["Maps/MapView.js"], _["Core/Series/Series.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A) {
          var b, d = this && this.__extends || (b = function(M, O) {
            return b = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, w) {
              p.__proto__ = w;
            } || function(p, w) {
              for (var T in w)
                w.hasOwnProperty(T) && (p[T] = w[T]);
            }, b(M, O);
          }, function(M, O) {
            function p() {
              this.constructor = M;
            }
            b(M, O), M.prototype = O === null ? Object.create(O) : (p.prototype = O.prototype, new p());
          }), m = G.animObject, v = Y.noop, g = Q.splitPath, x = D.seriesTypes, E = x.column, P = x.scatter, S = A.extend, u = A.find, y = A.fireEvent, s = A.getNestedProperty, a = A.isArray, e = A.defined, n = A.isNumber, o = A.isObject, i = A.merge, c = A.objectEach, l = A.pick, h = A.splat, C = function(M) {
            function O() {
              var p = M !== null && M.apply(this, arguments) || this;
              return p.chart = void 0, p.data = void 0, p.group = void 0, p.joinBy = void 0, p.options = void 0, p.points = void 0, p.processedData = [], p;
            }
            return d(O, M), O.prototype.animate = function(p) {
              var w = this.chart, T = this.group, z = m(this.options.animation);
              w.renderer.isSVG && (p ? T.attr({ translateX: w.plotLeft + w.plotWidth / 2, translateY: w.plotTop + w.plotHeight / 2, scaleX: 1e-3, scaleY: 1e-3 }) : T.animate({ translateX: w.plotLeft, translateY: w.plotTop, scaleX: 1, scaleY: 1 }, z));
            }, O.prototype.animateDrilldown = function(p) {
              var w = this.chart, T = this.group;
              w.renderer.isSVG && (p ? T.attr({ translateX: w.plotLeft + w.plotWidth / 2, translateY: w.plotTop + w.plotHeight / 2, scaleX: 0.1, scaleY: 0.1, opacity: 0.01 }) : (T.animate({ translateX: w.plotLeft, translateY: w.plotTop, scaleX: 1, scaleY: 1, opacity: 1 }, this.chart.options.drilldown.animation), w.drilldown && w.drilldown.fadeInGroup(this.dataLabelsGroup)));
            }, O.prototype.animateDrillupFrom = function() {
              var p = this.chart;
              p.renderer.isSVG && this.group.animate({ translateX: p.plotLeft + p.plotWidth / 2, translateY: p.plotTop + p.plotHeight / 2, scaleX: 0.1, scaleY: 0.1, opacity: 0.01 });
            }, O.prototype.animateDrillupTo = function(p) {
              E.prototype.animateDrillupTo.call(this, p);
            }, O.prototype.clearBounds = function() {
              this.points.forEach(function(p) {
                delete p.bounds, delete p.insetIndex, delete p.projectedPath;
              }), delete this.bounds;
            }, O.prototype.doFullTranslate = function() {
              return !!(this.isDirtyData || this.chart.isResizing || this.chart.renderer.isVML || !this.hasRendered);
            }, O.prototype.drawMapDataLabels = function() {
              N.prototype.drawDataLabels.call(this), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
            }, O.prototype.drawPoints = function() {
              var p = this, w = this, T = this, z = T.chart, W = T.group, L = T.transformGroups, I = L === void 0 ? [] : L, j = z.mapView, Z = z.renderer;
              j && (this.transformGroups = I, I[0] || (I[0] = Z.g().add(W)), j.insets.forEach(function(V, X) {
                I[X + 1] || I.push(Z.g().add(W));
              }), this.doFullTranslate() && (this.points.forEach(function(V) {
                var X = V.graphic, et = V.shapeArgs;
                V.group = I[typeof V.insetIndex == "number" ? V.insetIndex + 1 : 0], X && X.parentGroup !== V.group && X.add(V.group), et && z.hasRendered && !z.styledMode && (et.fill = p.pointAttribs(V, V.state).fill);
              }), E.prototype.drawPoints.apply(this), this.points.forEach(function(V) {
                var X = V.graphic;
                if (X) {
                  var et = X.animate, ot = "";
                  V.name && (ot += "highcharts-name-" + V.name.replace(/ /g, "-").toLowerCase()), V.properties && V.properties["hc-key"] && (ot += " highcharts-key-" + V.properties["hc-key"].toString().toLowerCase()), ot && X.addClass(ot), z.styledMode && X.css(p.pointAttribs(V, V.selected ? "select" : void 0)), X.animate = function(it, pt, mt) {
                    var Ct = n(it["stroke-width"]) && !n(X["stroke-width"]), kt = n(X["stroke-width"]) && !n(it["stroke-width"]);
                    if (Ct || kt) {
                      var Lt = l(w.getStrokeWidth(w.options), 1) / (z.mapView && z.mapView.getScale() || 1);
                      Ct && (X["stroke-width"] = Lt), kt && (it["stroke-width"] = Lt);
                    }
                    var Tt = et.call(X, it, pt, kt ? function() {
                      X.element.removeAttribute("stroke-width"), delete X["stroke-width"], mt && mt.apply(this, arguments);
                    } : mt);
                    return Tt;
                  };
                }
              })), I.forEach(function(V, X) {
                var et = (X === 0 ? j : j.insets[X - 1]).getSVGTransform(), ot = l(p.getStrokeWidth(p.options), 1), it = et.scaleX, pt = et.scaleY > 0 ? 1 : -1, mt = function(Tt) {
                  (w.points || []).forEach(function(xt) {
                    var ct, ft = xt.graphic;
                    ft && ft["stroke-width"] && (ct = p.getStrokeWidth(xt.options)) && ft.attr({ "stroke-width": ct / Tt });
                  });
                };
                if (Z.globalAnimation && z.hasRendered) {
                  var Ct = Number(V.attr("translateX")), kt = Number(V.attr("translateY")), Lt = Number(V.attr("scaleX"));
                  V.attr({ animator: 0 }).animate({ animator: 1 }, { step: function(Tt, xt) {
                    var ct = Lt + (it - Lt) * xt.pos;
                    V.attr({ translateX: Ct + (et.translateX - Ct) * xt.pos, translateY: kt + (et.translateY - kt) * xt.pos, scaleX: ct, scaleY: ct * pt, "stroke-width": ot / ct }), mt(ct);
                  } });
                } else
                  V.attr(i(et, { "stroke-width": ot / it })), mt(it);
              }), this.drawMapDataLabels());
            }, O.prototype.getProjectedBounds = function() {
              if (!this.bounds && this.chart.mapView) {
                var p = this.chart.mapView, w = p.insets, T = p.projection, z = [];
                (this.points || []).forEach(function(W) {
                  if (W.path || W.geometry) {
                    if (typeof W.path == "string" ? W.path = g(W.path) : a(W.path) && W.path[0] === "M" && (W.path = k.prototype.pathToSegments(W.path)), !W.bounds) {
                      var L = W.getProjectedBounds(T);
                      if (L) {
                        W.labelrank = l(W.labelrank, (L.x2 - L.x1) * (L.y2 - L.y1));
                        var I = L.midX, j = L.midY;
                        if (w && n(I) && n(j)) {
                          var Z = u(w, function(V) {
                            return V.isInside({ x: I, y: j });
                          });
                          Z && (delete W.projectedPath, (L = W.getProjectedBounds(Z.projection)) && Z.allBounds.push(L), W.insetIndex = w.indexOf(Z));
                        }
                        W.bounds = L;
                      }
                    }
                    W.bounds && W.insetIndex === void 0 && z.push(W.bounds);
                  }
                }), this.bounds = U.compositeBounds(z);
              }
              return this.bounds;
            }, O.prototype.getStrokeWidth = function(p) {
              var w = this.pointAttrToOptions;
              return p[w && w["stroke-width"] || "borderWidth"];
            }, O.prototype.hasData = function() {
              return !!this.processedXData.length;
            }, O.prototype.pointAttribs = function(p, w) {
              var T = p.series.chart, z = T.mapView, W = T.styledMode ? this.colorAttribs(p) : E.prototype.pointAttribs.call(this, p, w), L = this.getStrokeWidth(p.options);
              if (w) {
                var I = i(this.options.states[w], p.options.states && p.options.states[w] || {}), j = this.getStrokeWidth(I);
                e(j) && (L = j);
              }
              L && z && (L /= z.getScale());
              var Z = this.getStrokeWidth(this.options);
              return W.dashstyle && z && n(Z) && (L = Z / z.getScale()), p.visible || (W.fill = this.options.nullColor), e(L) ? W["stroke-width"] = L : delete W["stroke-width"], W["stroke-linecap"] = W["stroke-linejoin"] = this.options.linecap, W;
            }, O.prototype.updateData = function() {
              return !this.processedData && M.prototype.updateData.apply(this, arguments);
            }, O.prototype.setData = function(p, w, T, z) {
              w === void 0 && (w = !0), delete this.bounds, M.prototype.setData.call(this, p, !1, void 0, z), this.processData(), this.generatePoints(), w && this.chart.redraw(T);
            }, O.prototype.processData = function() {
              var p, w, T, z, W = this.options, L = W.data, I = this.chart.options.chart, j = this.joinBy, Z = W.keys || this.pointArrayMap, V = [], X = {}, et = this.chart.mapView, ot = et && (o(W.mapData, !0) ? et.getGeoMap(W.mapData) : et.geoMap), it = this.chart.mapTransforms;
              this.chart.mapTransforms = it = I.mapTransforms || ot && ot["hc-transform"] || it, it && c(it, function(Lt) {
                Lt.rotation && (Lt.cosAngle = Math.cos(Lt.rotation), Lt.sinAngle = Math.sin(Lt.rotation));
              }), a(W.mapData) ? z = W.mapData : ot && ot.type === "FeatureCollection" && (this.mapTitle = ot.title, z = Y.geojson(ot, this.type, this)), this.processedData = [];
              var pt = this.processedData;
              if (L && L.forEach(function(Lt, Tt) {
                var xt = 0;
                if (n(Lt))
                  pt[Tt] = { value: Lt };
                else if (a(Lt)) {
                  pt[Tt] = {}, !W.keys && Lt.length > Z.length && typeof Lt[0] == "string" && (pt[Tt]["hc-key"] = Lt[0], ++xt);
                  for (var ct = 0; ct < Z.length; ++ct, ++xt)
                    Z[ct] && Lt[xt] !== void 0 && (Z[ct].indexOf(".") > 0 ? q.prototype.setNestedProperty(pt[Tt], Lt[xt], Z[ct]) : pt[Tt][Z[ct]] = Lt[xt]);
                } else
                  pt[Tt] = L[Tt];
                j && j[0] === "_i" && (pt[Tt]._i = Tt);
              }), z) {
                for (this.mapData = z, this.mapMap = {}, T = 0; T < z.length; T++)
                  w = (p = z[T]).properties, p._i = T, j[0] && w && w[j[0]] && (p[j[0]] = w[j[0]]), X[p[j[0]]] = p;
                if (this.mapMap = X, j[1]) {
                  var mt = j[1];
                  pt.forEach(function(Lt) {
                    var Tt = s(mt, Lt);
                    X[Tt] && V.push(X[Tt]);
                  });
                }
                if (W.allAreas) {
                  if (j[1]) {
                    var Ct = j[1];
                    pt.forEach(function(Lt) {
                      V.push(s(Ct, Lt));
                    });
                  }
                  var kt = "|" + V.map(function(Lt) {
                    return Lt && Lt[j[0]];
                  }).join("|") + "|";
                  z.forEach(function(Lt) {
                    j[0] && kt.indexOf("|" + Lt[j[0]] + "|") !== -1 || pt.push(i(Lt, { value: null }));
                  });
                }
              }
              this.processedXData = new Array(pt.length);
            }, O.prototype.setOptions = function(p) {
              var w = N.prototype.setOptions.call(this, p), T = w.joinBy;
              return T === null && (T = "_i"), (T = this.joinBy = h(T))[1] || (T[1] = T[0]), w;
            }, O.prototype.translate = function() {
              var p = this, w = p.doFullTranslate(), T = this.chart.mapView, z = T && T.projection;
              if (!this.chart.hasRendered || !this.isDirtyData && this.hasRendered || (this.processData(), this.generatePoints(), delete this.bounds, !T || T.userOptions.center || n(T.userOptions.zoom) ? this.getProjectedBounds() : T.fitToBounds(void 0, void 0, !1)), T) {
                var W = T.getSVGTransform();
                p.points.forEach(function(L) {
                  var I = n(L.insetIndex) && T.insets[L.insetIndex].getSVGTransform() || W;
                  I && L.bounds && n(L.bounds.midX) && n(L.bounds.midY) && (L.plotX = L.bounds.midX * I.scaleX + I.translateX, L.plotY = L.bounds.midY * I.scaleY + I.translateY), w && (L.shapeType = "path", L.shapeArgs = { d: q.getProjectedPath(L, z) });
                });
              }
              y(p, "afterTranslate");
            }, O.defaultOptions = i(P.defaultOptions, { affectsMapView: !0, animation: !1, dataLabels: { crop: !1, formatter: function() {
              var p = this.series.chart.numberFormatter, w = this.point.value;
              return n(w) ? p(w, -1) : "";
            }, inside: !0, overflow: !1, padding: 0, verticalAlign: "middle" }, linecap: "butt", marker: null, nullColor: "#f7f7f7", stickyTracking: !1, tooltip: { followPointer: !0, pointFormat: "{point.name}: {point.value}<br/>" }, turboThreshold: 0, allAreas: !0, borderColor: "#cccccc", borderWidth: 1, joinBy: "hc-key", states: { hover: { halo: null, brightness: 0.2 }, normal: { animation: !0 }, select: { color: "#cccccc" } } }), O;
          }(P);
          return S(C.prototype, { type: "map", axisTypes: F.seriesMembers.axisTypes, colorAttribs: F.seriesMembers.colorAttribs, colorKey: F.seriesMembers.colorKey, directTouch: !0, drawDataLabels: v, drawGraph: v, drawLegendSymbol: J.drawRectangle, forceDL: !0, getCenter: $.getCenter, getExtremesFromAll: !0, getSymbol: v, isCartesian: !1, parallelArrays: F.seriesMembers.parallelArrays, pointArrayMap: F.seriesMembers.pointArrayMap, pointClass: q, preserveAspectRatio: !0, searchPoint: v, trackerGroups: F.seriesMembers.trackerGroups, useMapGeometry: !0 }), F.compose(C), D.registerSeriesType("map", C), C;
        }), at(_, "Series/MapLine/MapLineSeries.js", [_["Series/Map/MapSeries.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(D, k) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, b) {
              A.__proto__ = b;
            } || function(A, b) {
              for (var d in b)
                b.hasOwnProperty(d) && (A[d] = b[d]);
            }, Y(D, k);
          }, function(D, k) {
            function A() {
              this.constructor = D;
            }
            Y(D, k), D.prototype = k === null ? Object.create(k) : (A.prototype = k.prototype, new A());
          }), Q = F.series, q = $.extend, U = $.merge, N = function(D) {
            function k() {
              var A = D !== null && D.apply(this, arguments) || this;
              return A.data = void 0, A.options = void 0, A.points = void 0, A;
            }
            return J(k, D), k.prototype.pointAttribs = function(A, b) {
              var d = G.prototype.pointAttribs.call(this, A, b);
              return d.fill = this.options.fillColor, d;
            }, k.defaultOptions = U(G.defaultOptions, { lineWidth: 1, fillColor: "none" }), k;
          }(G);
          return q(N.prototype, { type: "mapline", colorProp: "stroke", drawLegendSymbol: Q.prototype.drawLegendSymbol, pointAttrToOptions: { stroke: "color", "stroke-width": "lineWidth" } }), F.registerSeriesType("mapline", N), N;
        }), at(_, "Series/MapPoint/MapPointPoint.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(U, N) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(D, k) {
              D.__proto__ = k;
            } || function(D, k) {
              for (var A in k)
                k.hasOwnProperty(A) && (D[A] = k[A]);
            }, $(U, N);
          }, function(U, N) {
            function D() {
              this.constructor = U;
            }
            $(U, N), U.prototype = N === null ? Object.create(N) : (D.prototype = N.prototype, new D());
          }), J = G.seriesTypes.scatter, Q = F.isNumber, q = function(U) {
            function N() {
              var D = U !== null && U.apply(this, arguments) || this;
              return D.options = void 0, D.series = void 0, D;
            }
            return Y(N, U), N.prototype.isValid = function() {
              return !!(this.options.geometry || Q(this.x) && Q(this.y) || Q(this.options.lon) && Q(this.options.lat));
            }, N;
          }(J.prototype.pointClass);
          return q;
        }), at(_, "Series/MapPoint/MapPointSeries.js", [_["Core/Globals.js"], _["Series/MapPoint/MapPointPoint.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J) {
          var Q, q = this && this.__extends || (Q = function(g, x) {
            return Q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, P) {
              E.__proto__ = P;
            } || function(E, P) {
              for (var S in P)
                P.hasOwnProperty(S) && (E[S] = P[S]);
            }, Q(g, x);
          }, function(g, x) {
            function E() {
              this.constructor = g;
            }
            Q(g, x), g.prototype = x === null ? Object.create(x) : (E.prototype = x.prototype, new E());
          }), U = G.noop, N = $.seriesTypes, D = N.map, k = N.scatter, A = J.extend, b = J.fireEvent, d = J.isNumber, m = J.merge, v = function(g) {
            function x() {
              var E = g !== null && g.apply(this, arguments) || this;
              return E.chart = void 0, E.data = void 0, E.options = void 0, E.points = void 0, E.clearBounds = D.prototype.clearBounds, E;
            }
            return q(x, g), x.prototype.drawDataLabels = function() {
              g.prototype.drawDataLabels.call(this), this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
            }, x.prototype.projectPoint = function(E) {
              var P = this.chart.mapView;
              if (P) {
                var S = E.geometry, u = E.lon, y = E.lat, s = S && S.type === "Point" && S.coordinates;
                if (d(u) && d(y) && (s = [u, y]), s)
                  return P.lonLatToProjectedUnits({ lon: s[0], lat: s[1] });
              }
            }, x.prototype.translate = function() {
              var E = this, P = this.chart.mapView;
              if (this.processedXData || this.processData(), this.generatePoints(), this.getProjectedBounds && this.isDirtyData && (delete this.bounds, this.getProjectedBounds()), P) {
                var S = P.getSVGTransform(), u = P.projection.hasCoordinates;
                this.points.forEach(function(y) {
                  var s, a = y.x, e = a === void 0 ? void 0 : a, n = y.y, o = n === void 0 ? void 0 : n, i = d(y.insetIndex) && P.insets[y.insetIndex].getSVGTransform() || S, c = E.projectPoint(y.options) || y.properties && E.projectPoint(y.properties);
                  if (c ? (e = c.x, o = c.y) : y.bounds && (e = y.bounds.midX, o = y.bounds.midY, i && d(e) && d(o) && (y.plotX = e * i.scaleX + i.translateX, y.plotY = o * i.scaleY + i.translateY, s = !0)), d(e) && d(o)) {
                    if (!s) {
                      var l = P.projectedUnitsToPixels({ x: e, y: o });
                      y.plotX = l.x, y.plotY = u ? l.y : E.chart.plotHeight - l.y;
                    }
                  } else
                    y.y = y.plotX = y.plotY = void 0;
                  y.isInside = E.isPointInside(y), y.zone = E.zones.length ? y.getZone() : void 0;
                });
              }
              b(this, "afterTranslate");
            }, x.defaultOptions = m(k.defaultOptions, { dataLabels: { crop: !1, defer: !1, enabled: !0, formatter: function() {
              return this.point.name;
            }, overflow: !1, style: { color: "#000000" } } }), x;
          }(k);
          return Y.prototype.symbols.mapmarker = function(g, x, E, P, S) {
            var u, y, s = S && S.context === "legend";
            s ? (u = g + E / 2, y = x + P) : S && typeof S.anchorX == "number" && typeof S.anchorY == "number" ? (u = S.anchorX, y = S.anchorY) : (u = g + E / 2, y = x + P / 2, x -= P);
            var a = s ? P / 3 : P / 2;
            return [["M", u, y], ["C", u, y, u - a, x + 1.5 * a, u - a, x + a], ["A", a, a, 1, 1, 1, u + a, x + a], ["C", u + a, x + 1.5 * a, u, y, u, y], ["Z"]];
          }, A(v.prototype, { type: "mappoint", axisTypes: ["colorAxis"], forceDL: !0, isCartesian: !1, pointClass: F, searchPoint: U, useMapGeometry: !0 }), $.registerSeriesType("mappoint", v), v;
        }), at(_, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
          return { borderColor: void 0, borderWidth: 2, className: void 0, color: void 0, connectorClassName: void 0, connectorColor: void 0, connectorDistance: 60, connectorWidth: 1, enabled: !1, labels: { className: void 0, allowOverlap: !1, format: "", formatter: void 0, align: "right", style: { fontSize: "10px", color: "#000000" }, x: 0, y: 0 }, maxSize: 60, minSize: 10, legendIndex: 0, ranges: { value: void 0, borderColor: void 0, color: void 0, connectorColor: void 0 }, sizeBy: "area", sizeByAbsoluteValue: !1, zIndex: 1, zThreshold: 0 };
        }), at(_, "Series/Bubble/BubbleLegendItem.js", [_["Core/Color/Color.js"], _["Core/FormatUtilities.js"], _["Core/Globals.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = G.parse, Q = $.noop, q = Y.arrayMax, U = Y.arrayMin, N = Y.isNumber, D = Y.merge, k = Y.pick, A = Y.stableSort;
          return function() {
            function b(d, m) {
              this.chart = void 0, this.fontMetrics = void 0, this.legend = void 0, this.maxLabel = void 0, this.movementX = void 0, this.ranges = void 0, this.selected = void 0, this.visible = void 0, this.symbols = void 0, this.options = void 0, this.setState = Q, this.init(d, m);
            }
            return b.prototype.init = function(d, m) {
              this.options = d, this.visible = !0, this.chart = m.chart, this.legend = m;
            }, b.prototype.addToLegend = function(d) {
              d.splice(this.options.legendIndex, 0, this);
            }, b.prototype.drawLegendSymbol = function(d) {
              var m, v = this.chart, g = k(d.options.itemDistance, 20), x = this.legendItem || {}, E = this.options, P = E.ranges, S = E.connectorDistance;
              if (this.fontMetrics = v.renderer.fontMetrics(E.labels.style.fontSize), P && P.length && N(P[0].value)) {
                A(P, function(a, e) {
                  return e.value - a.value;
                }), this.ranges = P, this.setOptions(), this.render();
                var u = this.getMaxLabelSize(), y = this.ranges[0].radius, s = 2 * y;
                m = (m = S - y + u.width) > 0 ? m : 0, this.maxLabel = u, this.movementX = E.labels.align === "left" ? m : 0, x.labelWidth = s + m + g, x.labelHeight = s + this.fontMetrics.h / 2;
              } else
                d.options.bubbleLegend.autoRanges = !0;
            }, b.prototype.setOptions = function() {
              var d = this.ranges, m = this.options, v = this.chart.series[m.seriesIndex], g = this.legend.baseline, x = { zIndex: m.zIndex, "stroke-width": m.borderWidth }, E = { zIndex: m.zIndex, "stroke-width": m.connectorWidth }, P = { align: this.legend.options.rtl || m.labels.align === "left" ? "right" : "left", zIndex: m.zIndex }, S = v.options.marker.fillOpacity, u = this.chart.styledMode;
              d.forEach(function(y, s) {
                u || (x.stroke = k(y.borderColor, m.borderColor, v.color), x.fill = k(y.color, m.color, S !== 1 ? J(v.color).setOpacity(S).get("rgba") : v.color), E.stroke = k(y.connectorColor, m.connectorColor, v.color)), d[s].radius = this.getRangeRadius(y.value), d[s] = D(d[s], { center: d[0].radius - d[s].radius + g }), u || D(!0, d[s], { bubbleAttribs: D(x), connectorAttribs: D(E), labelAttribs: P });
              }, this);
            }, b.prototype.getRangeRadius = function(d) {
              var m = this.options, v = this.options.seriesIndex, g = this.chart.series[v], x = m.ranges[0].value, E = m.ranges[m.ranges.length - 1].value, P = m.minSize, S = m.maxSize;
              return g.getRadius.call(this, E, x, P, S, d);
            }, b.prototype.render = function() {
              var d = this.legendItem || {}, m = this.chart.renderer, v = this.options.zThreshold;
              this.symbols || (this.symbols = { connectors: [], bubbleItems: [], labels: [] }), d.symbol = m.g("bubble-legend"), d.label = m.g("bubble-legend-item"), d.symbol.translateX = 0, d.symbol.translateY = 0;
              for (var g = 0, x = this.ranges; g < x.length; g++) {
                var E = x[g];
                E.value >= v && this.renderRange(E);
              }
              d.symbol.add(d.label), d.label.add(d.group), this.hideOverlappingLabels();
            }, b.prototype.renderRange = function(d) {
              var m = this.ranges[0], v = this.legend, g = this.options, x = g.labels, E = this.chart, P = E.series[g.seriesIndex], S = E.renderer, u = this.symbols, y = u.labels, s = d.center, a = Math.abs(d.radius), e = g.connectorDistance || 0, n = x.align, o = v.options.rtl, i = g.borderWidth, c = g.connectorWidth, l = m.radius || 0, h = s - a - i / 2 + c / 2, C = this.fontMetrics, M = C.f / 2 - (C.h - C.f) / 2, O = (h % 1 ? 1 : 0.5) - (c % 2 ? 0 : 0.5), p = S.styledMode, w = o || n === "left" ? -e : e;
              n === "center" && (w = 0, g.connectorDistance = 0, d.labelAttribs.align = "center");
              var T = h + g.labels.y, z = l + w + g.labels.x;
              u.bubbleItems.push(S.circle(l, s + O, a).attr(p ? {} : d.bubbleAttribs).addClass((p ? "highcharts-color-" + P.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (g.className || "")).add(this.legendItem.symbol)), u.connectors.push(S.path(S.crispLine([["M", l, h], ["L", l + w, h]], g.connectorWidth)).attr(p ? {} : d.connectorAttribs).addClass((p ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (g.connectorClassName || "")).add(this.legendItem.symbol));
              var W = S.text(this.formatLabel(d), z, T + M).attr(p ? {} : d.labelAttribs).css(p ? {} : x.style).addClass("highcharts-bubble-legend-labels " + (g.labels.className || "")).add(this.legendItem.symbol);
              y.push(W), W.placed = !0, W.alignAttr = { x: z, y: T + M };
            }, b.prototype.getMaxLabelSize = function() {
              var d, m;
              return this.symbols.labels.forEach(function(v) {
                m = v.getBBox(!0), d = d ? m.width > d.width ? m : d : m;
              }), d || {};
            }, b.prototype.formatLabel = function(d) {
              var m = this.options, v = m.labels.formatter, g = m.labels.format, x = this.chart.numberFormatter;
              return g ? F.format(g, d) : v ? v.call(d) : x(d.value, 1);
            }, b.prototype.hideOverlappingLabels = function() {
              var d = this.chart, m = this.options.labels.allowOverlap, v = this.symbols;
              !m && v && (d.hideOverlappingLabels(v.labels), v.labels.forEach(function(g, x) {
                g.newOpacity ? g.newOpacity !== g.oldOpacity && v.connectors[x].show() : v.connectors[x].hide();
              }));
            }, b.prototype.getRanges = function() {
              var d, m, v = this.legend.bubbleLegend, g = v.chart.series, x = v.options.ranges, E = Number.MAX_VALUE, P = -Number.MAX_VALUE;
              return g.forEach(function(S) {
                S.isBubble && !S.ignoreSeries && (m = S.zData.filter(N)).length && (E = k(S.options.zMin, Math.min(E, Math.max(U(m), S.options.displayNegative === !1 ? S.options.zThreshold : -Number.MAX_VALUE))), P = k(S.options.zMax, Math.max(P, q(m))));
              }), d = E === P ? [{ value: P }] : [{ value: E }, { value: (E + P) / 2 }, { value: P, autoRanges: !0 }], x.length && x[0].radius && d.reverse(), d.forEach(function(S, u) {
                x && x[u] && (d[u] = D(x[u], S));
              }), d;
            }, b.prototype.predictBubbleSizes = function() {
              var d, m = this.chart, v = this.fontMetrics, g = m.legend.options, x = g.floating, E = g.layout === "horizontal", P = E ? m.legend.lastLineHeight : 0, S = m.plotSizeX, u = m.plotSizeY, y = m.series[this.options.seriesIndex], s = y.getPxExtremes(), a = Math.ceil(s.minPxSize), e = Math.ceil(s.maxPxSize), n = Math.min(u, S), o = y.options.maxSize;
              return x || !/%$/.test(o) ? d = e : (o = parseFloat(o), d = (n + P - v.h / 2) * o / 100 / (o / 100 + 1), (E && u - d >= S || !E && S - d >= u) && (d = e)), [a, Math.ceil(d)];
            }, b.prototype.updateRanges = function(d, m) {
              var v = this.legend.options.bubbleLegend;
              v.minSize = d, v.maxSize = m, v.ranges = this.getRanges();
            }, b.prototype.correctSizes = function() {
              var d = this.legend, m = this.chart.series[this.options.seriesIndex].getPxExtremes(), v = m.maxPxSize, g = this.options.maxSize;
              Math.abs(Math.ceil(v) - g) > 1 && (this.updateRanges(this.options.minSize, m.maxPxSize), d.render());
            }, b;
          }();
        }), at(_, "Series/Bubble/BubbleLegendComposition.js", [_["Series/Bubble/BubbleLegendDefaults.js"], _["Series/Bubble/BubbleLegendItem.js"], _["Core/Defaults.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J = $.setOptions, Q = Y.addEvent, q = Y.objectEach, U = Y.wrap, N = [];
          function D(v, g, x) {
            var E, P, S, u = this, y = u.legend, s = k(u) >= 0;
            y && y.options.enabled && y.bubbleLegend && y.options.bubbleLegend.autoRanges && s ? (E = y.bubbleLegend.options, P = y.bubbleLegend.predictBubbleSizes(), y.bubbleLegend.updateRanges(P[0], P[1]), E.placed || (y.group.placed = !1, y.allItems.forEach(function(a) {
              (S = a.legendItem || {}).group && (S.group.translateY = null);
            })), y.render(), u.getMargins(), u.axes.forEach(function(a) {
              a.visible && a.render(), E.placed || (a.setScale(), a.updateNames(), q(a.ticks, function(e) {
                e.isNew = !0, e.isNewLabel = !0;
              }));
            }), E.placed = !0, u.getMargins(), v.call(u, g, x), y.bubbleLegend.correctSizes(), m(y, A(y))) : (v.call(u, g, x), y && y.options.enabled && y.bubbleLegend && (y.render(), m(y, A(y))));
          }
          function k(v) {
            for (var g = v.series, x = 0; x < g.length; ) {
              if (g[x] && g[x].isBubble && g[x].visible && g[x].zData.length)
                return x;
              x++;
            }
            return -1;
          }
          function A(v) {
            var g, x, E, P = v.allItems, S = [], u = P.length, y = 0, s = 0;
            for (y = 0; y < u; y++)
              if (x = P[y].legendItem || {}, E = (P[y + 1] || {}).legendItem || {}, x.labelHeight && (P[y].itemHeight = x.labelHeight), P[y] === P[u - 1] || x.y !== E.y) {
                for (S.push({ height: 0 }), g = S[S.length - 1]; s <= y; s++)
                  P[s].itemHeight > g.height && (g.height = P[s].itemHeight);
                g.step = y;
              }
            return S;
          }
          function b(v) {
            var g = this, x = g.bubbleLegend, E = g.options, P = E.bubbleLegend, S = k(g.chart);
            x && x.ranges && x.ranges.length && (P.ranges.length && (P.autoRanges = !!P.ranges[0].autoRanges), g.destroyItem(x)), S >= 0 && E.enabled && P.enabled && (P.seriesIndex = S, g.bubbleLegend = new F(P, g), g.bubbleLegend.addToLegend(v.allItems));
          }
          function d() {
            var v, g = this, x = g.chart, E = g.visible, P = g.chart.legend;
            P && P.bubbleLegend && (g.visible = !E, g.ignoreSeries = E, v = k(x) >= 0, P.bubbleLegend.visible !== v && (P.update({ bubbleLegend: { enabled: v } }), P.bubbleLegend.visible = v), g.visible = E);
          }
          function m(v, g) {
            var x, E, P, S, u = v.allItems, y = v.options.rtl, s = 0;
            u.forEach(function(a, e) {
              (S = a.legendItem || {}).group && (x = S.group.translateX || 0, E = S.y || 0, ((P = a.movementX) || y && a.ranges) && (P = y ? x - a.options.maxSize / 2 : x + P, S.group.attr({ translateX: P })), e > g[s].step && s++, S.group.attr({ translateY: Math.round(E + g[s].height / 2) }), S.y = E + g[s].height / 2);
            });
          }
          return { compose: function(v, g, x) {
            N.indexOf(v) === -1 && (N.push(v), J({ legend: { bubbleLegend: G } }), U(v.prototype, "drawChartBox", D)), N.indexOf(g) === -1 && (N.push(g), Q(g, "afterGetAllItems", b)), N.indexOf(x) === -1 && (N.push(x), Q(x, "legendItemClick", d));
          } };
        }), at(_, "Series/Bubble/BubblePoint.js", [_["Core/Series/Point.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(N, D) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, A) {
              k.__proto__ = A;
            } || function(k, A) {
              for (var b in A)
                A.hasOwnProperty(b) && (k[b] = A[b]);
            }, Y(N, D);
          }, function(N, D) {
            function k() {
              this.constructor = N;
            }
            Y(N, D), N.prototype = D === null ? Object.create(D) : (k.prototype = D.prototype, new k());
          }), Q = F.seriesTypes.scatter.prototype.pointClass, q = $.extend, U = function(N) {
            function D() {
              var k = N !== null && N.apply(this, arguments) || this;
              return k.options = void 0, k.series = void 0, k;
            }
            return J(D, N), D.prototype.haloPath = function(k) {
              return G.prototype.haloPath.call(this, k === 0 ? 0 : (this.marker && this.marker.radius || 0) + k);
            }, D;
          }(Q);
          return q(U.prototype, { ttBelow: !1 }), U;
        }), at(_, "Series/Bubble/BubbleSeries.js", [_["Series/Bubble/BubbleLegendComposition.js"], _["Series/Bubble/BubblePoint.js"], _["Core/Color/Color.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q) {
          var q, U = this && this.__extends || (q = function(e, n) {
            return q = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, i) {
              o.__proto__ = i;
            } || function(o, i) {
              for (var c in i)
                i.hasOwnProperty(c) && (o[c] = i[c]);
            }, q(e, n);
          }, function(e, n) {
            function o() {
              this.constructor = e;
            }
            q(e, n), e.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
          }), N = $.parse, D = Y.noop, k = J.series, A = J.seriesTypes, b = A.column.prototype, d = A.scatter, m = Q.addEvent, v = Q.arrayMax, g = Q.arrayMin, x = Q.clamp, E = Q.extend, P = Q.isNumber, S = Q.merge, u = Q.pick, y = [];
          function s() {
            var e, n = this, o = this.len, i = this.chart, c = this.isXAxis, l = c ? "xData" : "yData", h = this.min, C = this.max - h, M = 0, O = o, p = o / C;
            this.series.forEach(function(w) {
              if (w.bubblePadding && (w.visible || !i.options.chart.ignoreHiddenSeries)) {
                n.allowZoomOutside = !0, e = !0;
                var T = w[l];
                if (c && ((w.onPoint || w).getRadii(0, 0, w), w.onPoint && (w.radii = w.onPoint.radii)), C > 0) {
                  for (var z = T.length; z--; )
                    if (P(T[z]) && n.dataMin <= T[z] && T[z] <= n.max) {
                      var W = w.radii && w.radii[z] || 0;
                      M = Math.min((T[z] - h) * p - W, M), O = Math.max((T[z] - h) * p + W, O);
                    }
                }
              }
            }), e && C > 0 && !this.logarithmic && (O -= o, p *= (o + Math.max(0, M) - Math.min(O, o)) / o, [["min", "userMin", M], ["max", "userMax", O]].forEach(function(w) {
              u(n.options[w[0]], n[w[1]]) === void 0 && (n[w[0]] += w[2] / p);
            }));
          }
          var a = function(e) {
            function n() {
              var o = e !== null && e.apply(this, arguments) || this;
              return o.data = void 0, o.maxPxSize = void 0, o.minPxSize = void 0, o.options = void 0, o.points = void 0, o.radii = void 0, o.yData = void 0, o.zData = void 0, o;
            }
            return U(n, e), n.compose = function(o, i, c, l) {
              G.compose(i, c, l), y.indexOf(o) === -1 && (y.push(o), o.prototype.beforePadding = s);
            }, n.prototype.animate = function(o) {
              !o && this.points.length < this.options.animationLimit && this.points.forEach(function(i) {
                var c = i.graphic;
                c && c.width && (this.hasRendered || c.attr({ x: i.plotX, y: i.plotY, width: 1, height: 1 }), c.animate(this.markerAttribs(i), this.options.animation));
              }, this);
            }, n.prototype.getRadii = function() {
              var o, i, c, l = this, h = this.zData, C = this.yData, M = [], O = this.chart.bubbleZExtremes, p = this.getPxExtremes(), w = p.minPxSize, T = p.maxPxSize;
              if (!O) {
                var z, W = Number.MAX_VALUE, L = -Number.MAX_VALUE;
                this.chart.series.forEach(function(I) {
                  if (I.bubblePadding && (I.visible || !l.chart.options.chart.ignoreHiddenSeries)) {
                    var j = (I.onPoint || I).getZExtremes();
                    j && (W = Math.min(W || j.zMin, j.zMin), L = Math.max(L || j.zMax, j.zMax), z = !0);
                  }
                }), z ? (O = { zMin: W, zMax: L }, this.chart.bubbleZExtremes = O) : O = { zMin: 0, zMax: 0 };
              }
              for (i = 0, o = h.length; i < o; i++)
                c = h[i], M.push(this.getRadius(O.zMin, O.zMax, w, T, c, C && C[i]));
              this.radii = M;
            }, n.prototype.getRadius = function(o, i, c, l, h, C) {
              var M = this.options, O = M.sizeBy !== "width", p = M.zThreshold, w = i - o, T = 0.5;
              if (C === null || h === null)
                return null;
              if (P(h)) {
                if (M.sizeByAbsoluteValue && (h = Math.abs(h - p), i = w = Math.max(i - p, Math.abs(o - p)), o = 0), h < o)
                  return c / 2 - 1;
                w > 0 && (T = (h - o) / w);
              }
              return O && T >= 0 && (T = Math.sqrt(T)), Math.ceil(c + T * (l - c)) / 2;
            }, n.prototype.hasData = function() {
              return !!this.processedXData.length;
            }, n.prototype.pointAttribs = function(o, i) {
              var c = this.options.marker.fillOpacity, l = k.prototype.pointAttribs.call(this, o, i);
              return c !== 1 && (l.fill = N(l.fill).setOpacity(c).get("rgba")), l;
            }, n.prototype.translate = function() {
              e.prototype.translate.call(this), this.getRadii(), this.translateBubble();
            }, n.prototype.translateBubble = function() {
              for (var o = this.data, i = this.radii, c = this.getPxExtremes().minPxSize, l = o.length; l--; ) {
                var h = o[l], C = i ? i[l] : 0;
                P(C) && C >= c / 2 ? (h.marker = E(h.marker, { radius: C, width: 2 * C, height: 2 * C }), h.dlBox = { x: h.plotX - C, y: h.plotY - C, width: 2 * C, height: 2 * C }) : (h.shapeArgs = h.plotY = h.dlBox = void 0, h.isInside = !1);
              }
            }, n.prototype.getPxExtremes = function() {
              var o = Math.min(this.chart.plotWidth, this.chart.plotHeight), i = function(l) {
                var h;
                return typeof l == "string" && (h = /%$/.test(l), l = parseInt(l, 10)), h ? o * l / 100 : l;
              }, c = i(u(this.options.minSize, 8));
              return { minPxSize: c, maxPxSize: Math.max(i(u(this.options.maxSize, "20%")), c) };
            }, n.prototype.getZExtremes = function() {
              var o = this.options, i = (this.zData || []).filter(P);
              if (i.length) {
                var c = u(o.zMin, x(g(i), o.displayNegative === !1 ? o.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), l = u(o.zMax, v(i));
                if (P(c) && P(l))
                  return { zMin: c, zMax: l };
              }
            }, n.defaultOptions = S(d.defaultOptions, { dataLabels: { formatter: function() {
              var o = this.series.chart.numberFormatter, i = this.point.z;
              return P(i) ? o(i, -1) : "";
            }, inside: !0, verticalAlign: "middle" }, animationLimit: 250, marker: { lineColor: null, lineWidth: 1, fillOpacity: 0.5, radius: null, states: { hover: { radiusPlus: 0 } }, symbol: "circle" }, minSize: 8, maxSize: "20%", softThreshold: !1, states: { hover: { halo: { size: 5 } } }, tooltip: { pointFormat: "({point.x}, {point.y}), Size: {point.z}" }, turboThreshold: 0, zThreshold: 0, zoneAxis: "z" }), n;
          }(d);
          return E(a.prototype, { alignDataLabel: b.alignDataLabel, applyZones: D, bubblePadding: !0, buildKDTree: D, directTouch: !0, isBubble: !0, pointArrayMap: ["y", "z"], pointClass: F, parallelArrays: ["x", "y", "z"], trackerGroups: ["group", "dataLabelsGroup"], specialGroup: "group", zoneAxis: "z" }), m(a, "updatedData", function(e) {
            delete e.target.chart.bubbleZExtremes;
          }), m(a, "remove", function(e) {
            delete e.target.chart.bubbleZExtremes;
          }), J.registerSeriesType("bubble", a), a;
        }), at(_, "Series/MapBubble/MapBubblePoint.js", [_["Series/Bubble/BubblePoint.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(N, D) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(k, A) {
              k.__proto__ = A;
            } || function(k, A) {
              for (var b in A)
                A.hasOwnProperty(b) && (k[b] = A[b]);
            }, Y(N, D);
          }, function(N, D) {
            function k() {
              this.constructor = N;
            }
            Y(N, D), N.prototype = D === null ? Object.create(D) : (k.prototype = D.prototype, new k());
          }), Q = F.seriesTypes.map.prototype.pointClass.prototype, q = $.extend, U = function(N) {
            function D() {
              return N !== null && N.apply(this, arguments) || this;
            }
            return J(D, N), D.prototype.isValid = function() {
              return typeof this.z == "number";
            }, D;
          }(G);
          return q(U.prototype, { applyOptions: Q.applyOptions, getProjectedBounds: Q.getProjectedBounds }), U;
        }), at(_, "Series/MapBubble/MapBubbleSeries.js", [_["Series/Bubble/BubbleSeries.js"], _["Series/MapBubble/MapBubblePoint.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $, Y) {
          var J, Q = this && this.__extends || (J = function(b, d) {
            return J = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, v) {
              m.__proto__ = v;
            } || function(m, v) {
              for (var g in v)
                v.hasOwnProperty(g) && (m[g] = v[g]);
            }, J(b, d);
          }, function(b, d) {
            function m() {
              this.constructor = b;
            }
            J(b, d), b.prototype = d === null ? Object.create(d) : (m.prototype = d.prototype, new m());
          }), q = $.seriesTypes, U = q.map.prototype, N = q.mappoint.prototype, D = Y.extend, k = Y.merge, A = function(b) {
            function d() {
              var m = b !== null && b.apply(this, arguments) || this;
              return m.data = void 0, m.options = void 0, m.points = void 0, m.clearBounds = U.clearBounds, m;
            }
            return Q(d, b), d.prototype.searchPoint = function(m, v) {
              return this.searchKDTree({ clientX: m.chartX - this.chart.plotLeft, plotY: m.chartY - this.chart.plotTop }, v, m);
            }, d.prototype.translate = function() {
              N.translate.call(this), this.getRadii(), this.translateBubble();
            }, d.defaultOptions = k(G.defaultOptions, { lineWidth: 0, animationLimit: 500, joinBy: "hc-key", tooltip: { pointFormat: "{point.name}: {point.z}" } }), d;
          }(G);
          return D(A.prototype, { type: "mapbubble", axisTypes: ["colorAxis"], getProjectedBounds: U.getProjectedBounds, isCartesian: !1, pointArrayMap: ["z"], pointClass: F, processData: U.processData, projectPoint: N.projectPoint, setData: U.setData, setOptions: U.setOptions, updateData: U.updateData, useMapGeometry: !0, xyFromShape: !0 }), $.registerSeriesType("mapbubble", A), A;
        }), at(_, "Series/Heatmap/HeatmapPoint.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(k, A) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, d) {
              b.__proto__ = d;
            } || function(b, d) {
              for (var m in d)
                d.hasOwnProperty(m) && (b[m] = d[m]);
            }, $(k, A);
          }, function(k, A) {
            function b() {
              this.constructor = k;
            }
            $(k, A), k.prototype = A === null ? Object.create(A) : (b.prototype = A.prototype, new b());
          }), J = G.seriesTypes.scatter.prototype.pointClass, Q = F.clamp, q = F.defined, U = F.extend, N = F.pick, D = function(k) {
            function A() {
              var b = k !== null && k.apply(this, arguments) || this;
              return b.options = void 0, b.series = void 0, b.value = void 0, b.x = void 0, b.y = void 0, b;
            }
            return Y(A, k), A.prototype.applyOptions = function(b, d) {
              return (this.isNull || this.value === null) && delete this.color, k.prototype.applyOptions.call(this, b, d), this.formatPrefix = this.isNull || this.value === null ? "null" : "point", this;
            }, A.prototype.getCellAttributes = function() {
              var b = this, d = b.series, m = d.options, v = (m.colsize || 1) / 2, g = (m.rowsize || 1) / 2, x = d.xAxis, E = d.yAxis, P = b.options.marker || d.options.marker, S = d.pointPlacementToXValue(), u = N(b.pointPadding, m.pointPadding, 0), y = { x1: Q(Math.round(x.len - x.translate(b.x - v, !1, !0, !1, !0, -S)), -x.len, 2 * x.len), x2: Q(Math.round(x.len - x.translate(b.x + v, !1, !0, !1, !0, -S)), -x.len, 2 * x.len), y1: Q(Math.round(E.translate(b.y - g, !1, !0, !1, !0)), -E.len, 2 * E.len), y2: Q(Math.round(E.translate(b.y + g, !1, !0, !1, !0)), -E.len, 2 * E.len) };
              return [["width", "x"], ["height", "y"]].forEach(function(s) {
                var a = s[0], e = s[1], n = e + "1", o = e + "2", i = Math.abs(y[n] - y[o]), c = P && P.lineWidth || 0, l = Math.abs(y[n] + y[o]) / 2, h = P && P[a];
                if (q(h) && h < i) {
                  var C = h / 2 + c / 2;
                  y[n] = l - C, y[o] = l + C;
                }
                u && (e === "y" && (n = o, o = e + "1"), y[n] += u, y[o] -= u);
              }), y;
            }, A.prototype.haloPath = function(b) {
              if (!b)
                return [];
              var d = this.shapeArgs || {}, m = d.x, v = m === void 0 ? 0 : m, g = d.y, x = g === void 0 ? 0 : g, E = d.width, P = E === void 0 ? 0 : E, S = d.height, u = S === void 0 ? 0 : S;
              return [["M", v - b, x - b], ["L", v - b, x + u + b], ["L", v + P + b, x + u + b], ["L", v + P + b, x - b], ["Z"]];
            }, A.prototype.isValid = function() {
              return this.value !== 1 / 0 && this.value !== -1 / 0;
            }, A;
          }(J);
          return U(D.prototype, { dataLabelOnNull: !0, moveToTopOnHover: !0, ttBelow: !1 }), D;
        }), at(_, "Series/Heatmap/HeatmapSeries.js", [_["Core/Color/Color.js"], _["Series/ColorMapComposition.js"], _["Series/Heatmap/HeatmapPoint.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Renderer/SVG/SVGRenderer.js"], _["Core/Utilities.js"]], function(G, F, $, Y, J, Q, q) {
          var U, N = this && this.__extends || (U = function(S, u) {
            return U = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(y, s) {
              y.__proto__ = s;
            } || function(y, s) {
              for (var a in s)
                s.hasOwnProperty(a) && (y[a] = s[a]);
            }, U(S, u);
          }, function(S, u) {
            function y() {
              this.constructor = S;
            }
            U(S, u), S.prototype = u === null ? Object.create(u) : (y.prototype = u.prototype, new y());
          }), D = J.series, k = J.seriesTypes, A = k.column, b = k.scatter, d = Q.prototype.symbols, m = q.extend, v = q.fireEvent, g = q.isNumber, x = q.merge, E = q.pick, P = function(S) {
            function u() {
              var y = S !== null && S.apply(this, arguments) || this;
              return y.colorAxis = void 0, y.data = void 0, y.options = void 0, y.points = void 0, y.valueMax = NaN, y.valueMin = NaN, y;
            }
            return N(u, S), u.prototype.drawPoints = function() {
              var y = this;
              ((this.options.marker || {}).enabled || this._hasPointMarkers) && (D.prototype.drawPoints.call(this), this.points.forEach(function(s) {
                s.graphic && (s.graphic[y.chart.styledMode ? "css" : "animate"](y.colorAttribs(s)), s.value === null && s.graphic.addClass("highcharts-null-point"));
              }));
            }, u.prototype.getExtremes = function() {
              var y = D.prototype.getExtremes.call(this, this.valueData), s = y.dataMin, a = y.dataMax;
              return g(s) && (this.valueMin = s), g(a) && (this.valueMax = a), D.prototype.getExtremes.call(this);
            }, u.prototype.getValidPoints = function(y, s) {
              return D.prototype.getValidPoints.call(this, y, s, !0);
            }, u.prototype.hasData = function() {
              return !!this.processedXData.length;
            }, u.prototype.init = function() {
              S.prototype.init.apply(this, arguments);
              var y = this.options;
              y.pointRange = E(y.pointRange, y.colsize || 1), this.yAxis.axisPointRange = y.rowsize || 1, d.ellipse = d.circle, y.marker && (y.marker.r = y.borderRadius);
            }, u.prototype.markerAttribs = function(y, s) {
              var a = y.shapeArgs || {};
              if (y.hasImage)
                return { x: y.plotX, y: y.plotY };
              if (s && s !== "normal") {
                var e = y.options.marker || {}, n = this.options.marker || {}, o = n.states && n.states[s] || {}, i = e.states && e.states[s] || {}, c = (i.width || o.width || a.width || 0) + (i.widthPlus || o.widthPlus || 0), l = (i.height || o.height || a.height || 0) + (i.heightPlus || o.heightPlus || 0);
                return { x: (a.x || 0) + ((a.width || 0) - c) / 2, y: (a.y || 0) + ((a.height || 0) - l) / 2, width: c, height: l };
              }
              return a;
            }, u.prototype.pointAttribs = function(y, s) {
              var a = this, e = D.prototype.pointAttribs.call(a, y, s), n = a.options || {}, o = a.chart.options.plotOptions || {}, i = o.series || {}, c = o.heatmap || {}, l = y && y.options.borderColor || n.borderColor || c.borderColor || i.borderColor, h = y && y.options.borderWidth || n.borderWidth || c.borderWidth || i.borderWidth || e["stroke-width"];
              if (e.stroke = y && y.marker && y.marker.lineColor || n.marker && n.marker.lineColor || l || this.color, e["stroke-width"] = h, s && s !== "normal") {
                var C = x(n.states && n.states[s], n.marker && n.marker.states && n.marker.states[s], y && y.options.states && y.options.states[s] || {});
                e.fill = C.color || G.parse(e.fill).brighten(C.brightness || 0).get(), e.stroke = C.lineColor || e.stroke;
              }
              return e;
            }, u.prototype.translate = function() {
              var y = this, s = y.options, a = s.marker && s.marker.symbol || "rect", e = d[a] ? a : "rect", n = ["circle", "square"].indexOf(e) !== -1;
              y.generatePoints(), y.points.forEach(function(o) {
                var i = o.getCellAttributes(), c = Math.min(i.x1, i.x2), l = Math.min(i.y1, i.y2), h = Math.max(Math.abs(i.x2 - i.x1), 0), C = Math.max(Math.abs(i.y2 - i.y1), 0);
                if (o.hasImage = (o.marker && o.marker.symbol || a || "").indexOf("url") === 0, n) {
                  var M = Math.abs(h - C);
                  c = Math.min(i.x1, i.x2) + (h < C ? 0 : M / 2), l = Math.min(i.y1, i.y2) + (h < C ? M / 2 : 0), h = C = Math.min(h, C);
                }
                o.hasImage && (o.marker = { width: h, height: C }), o.plotX = o.clientX = (i.x1 + i.x2) / 2, o.plotY = (i.y1 + i.y2) / 2, o.shapeType = "path", o.shapeArgs = x(!0, { x: c, y: l, width: h, height: C }, { d: d[e](c, l, h, C, { r: s.borderRadius }) });
              }), v(y, "afterTranslate");
            }, u.defaultOptions = x(b.defaultOptions, { animation: !1, borderRadius: 0, borderWidth: 0, nullColor: "#f7f7f7", dataLabels: { formatter: function() {
              var y = this.series.chart.numberFormatter, s = this.point.value;
              return g(s) ? y(s, -1) : "";
            }, inside: !0, verticalAlign: "middle", crop: !1, overflow: "allow", padding: 0 }, marker: { symbol: "rect", radius: 0, lineColor: void 0, states: { hover: { lineWidthPlus: 0 }, select: {} } }, clip: !0, pointRange: null, tooltip: { pointFormat: "{point.x}, {point.y}: {point.value}<br/>" }, states: { hover: { halo: !1, brightness: 0.2 } } }), u;
          }(b);
          return m(P.prototype, { axisTypes: F.seriesMembers.axisTypes, colorKey: F.seriesMembers.colorKey, directTouch: !0, getExtremesFromAll: !0, parallelArrays: F.seriesMembers.parallelArrays, pointArrayMap: ["y", "value"], pointClass: $, specialGroup: "group", trackerGroups: F.seriesMembers.trackerGroups, alignDataLabel: A.prototype.alignDataLabel, colorAttribs: F.seriesMembers.colorAttribs, drawLegendSymbol: Y.drawRectangle, getSymbol: D.prototype.getSymbol }), F.compose(P), J.registerSeriesType("heatmap", P), P;
        }), at(_, "masters/modules/map.src.js", [_["Core/Globals.js"], _["Core/Axis/Color/ColorAxis.js"], _["Series/MapBubble/MapBubbleSeries.js"], _["Core/Chart/MapChart.js"], _["Maps/MapView.js"], _["Maps/Projection.js"]], function(G, F, $, Y, J, Q) {
          var q = G;
          q.ColorAxis = F, q.MapChart = Y, q.mapChart = q.Map = Y.mapChart, q.MapView = J, q.maps = Y.maps, q.Projection = Q, F.compose(q.Chart, q.Fx, q.Legend, q.Series), $.compose(q.Axis, q.Chart, q.Legend, q.Series);
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 1548: (tt, st, lt) => {
      var ht, ut, yt;
      yt = function(gt) {
        var _ = gt ? gt._modules : {};
        function at(G, F, $, Y) {
          G.hasOwnProperty(F) || (G[F] = Y.apply(null, $), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: F, module: G[F] } })));
        }
        at(_, "Series/ColorMapComposition.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = G.seriesTypes.column.prototype, J = F.addEvent, Q = F.defined;
          return function(q) {
            var U = [];
            function N(D) {
              var k = this;
              k.moveToTopOnHover && k.graphic && k.graphic.attr({ zIndex: D && D.state === "hover" ? 1 : 0 });
            }
            q.pointMembers = { dataLabelOnNull: !0, moveToTopOnHover: !0, isValid: function() {
              return this.value !== null && this.value !== 1 / 0 && this.value !== -1 / 0 && (this.value === void 0 || !isNaN(this.value));
            } }, q.seriesMembers = { colorKey: "value", axisTypes: ["xAxis", "yAxis", "colorAxis"], parallelArrays: ["x", "y", "value"], pointArrayMap: ["value"], trackerGroups: ["group", "markerGroup", "dataLabelsGroup"], colorAttribs: function(D) {
              var k = {};
              return !Q(D.color) || D.state && D.state !== "normal" || (k[this.colorProp || "fill"] = D.color), k;
            }, pointAttribs: Y.pointAttribs }, q.compose = function(D) {
              var k = D.prototype.pointClass;
              return U.indexOf(k) === -1 && (U.push(k), J(k, "afterSetState", N)), D;
            };
          }($ || ($ = {})), $;
        }), at(_, "Series/Treemap/TreemapAlgorithmGroup.js", [], function() {
          return function() {
            function G(F, $, Y, J) {
              this.height = F, this.width = $, this.plot = J, this.direction = Y, this.startDirection = Y, this.total = 0, this.nW = 0, this.lW = 0, this.nH = 0, this.lH = 0, this.elArr = [], this.lP = { total: 0, lH: 0, nH: 0, lW: 0, nW: 0, nR: 0, lR: 0, aspectRatio: function(Q, q) {
                return Math.max(Q / q, q / Q);
              } };
            }
            return G.prototype.addElement = function(F) {
              this.lP.total = this.elArr[this.elArr.length - 1], this.total = this.total + F, this.direction === 0 ? (this.lW = this.nW, this.lP.lH = this.lP.total / this.lW, this.lP.lR = this.lP.aspectRatio(this.lW, this.lP.lH), this.nW = this.total / this.height, this.lP.nH = this.lP.total / this.nW, this.lP.nR = this.lP.aspectRatio(this.nW, this.lP.nH)) : (this.lH = this.nH, this.lP.lW = this.lP.total / this.lH, this.lP.lR = this.lP.aspectRatio(this.lP.lW, this.lH), this.nH = this.total / this.width, this.lP.nW = this.lP.total / this.nH, this.lP.nR = this.lP.aspectRatio(this.lP.nW, this.nH)), this.elArr.push(F);
            }, G.prototype.reset = function() {
              this.nW = 0, this.lW = 0, this.elArr = [], this.total = 0;
            }, G;
          }();
        }), at(_, "Series/DrawPointUtilities.js", [_["Core/Utilities.js"]], function(G) {
          return { draw: function(F, $) {
            var Y = $.animatableAttribs, J = $.onComplete, Q = $.css, q = $.renderer, U = F.series && F.series.chart.hasRendered ? void 0 : F.series && F.series.options.animation, N = F.graphic;
            if ($.attribs = $.attribs || {}, $.attribs.class = F.getClassName(), F.shouldDraw())
              N || (F.graphic = N = $.shapeType === "text" ? q.text() : q[$.shapeType]($.shapeArgs || {}), N.add($.group)), Q && N.css(Q), N.attr($.attribs).animate(Y, !$.isNew && U, J);
            else if (N) {
              var D = function() {
                F.graphic = N = N && N.destroy(), typeof J == "function" && J();
              };
              Object.keys(Y).length ? N.animate(Y, void 0, function() {
                return D();
              }) : D();
            }
          } };
        }), at(_, "Series/Treemap/TreemapPoint.js", [_["Series/DrawPointUtilities.js"], _["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y, J = this && this.__extends || (Y = function(d, m) {
            return Y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
              v.__proto__ = g;
            } || function(v, g) {
              for (var x in g)
                g.hasOwnProperty(x) && (v[x] = g[x]);
            }, Y(d, m);
          }, function(d, m) {
            function v() {
              this.constructor = d;
            }
            Y(d, m), d.prototype = m === null ? Object.create(m) : (v.prototype = m.prototype, new v());
          }), Q = F.series.prototype.pointClass, q = F.seriesTypes, U = q.pie.prototype.pointClass, N = q.scatter.prototype.pointClass, D = $.extend, k = $.isNumber, A = $.pick, b = function(d) {
            function m() {
              var v = d !== null && d.apply(this, arguments) || this;
              return v.name = void 0, v.node = void 0, v.options = void 0, v.series = void 0, v.shapeType = "rect", v.value = void 0, v;
            }
            return J(m, d), m.prototype.draw = function(v) {
              G.draw(this, v);
            }, m.prototype.getClassName = function() {
              var v = Q.prototype.getClassName.call(this), g = this.series, x = g.options;
              return this.node.level <= g.nodeMap[g.rootNode].level ? v += " highcharts-above-level" : this.node.isLeaf || A(x.interactByLeaf, !x.allowTraversingTree) ? this.node.isLeaf || (v += " highcharts-internal-node") : v += " highcharts-internal-node-interactive", v;
            }, m.prototype.isValid = function() {
              return !!(this.id || k(this.value));
            }, m.prototype.setState = function(v) {
              Q.prototype.setState.call(this, v), this.graphic && this.graphic.attr({ zIndex: v === "hover" ? 1 : 0 });
            }, m.prototype.shouldDraw = function() {
              return k(this.plotY) && this.y !== null;
            }, m;
          }(N);
          return D(b.prototype, { setVisible: U.prototype.setVisible }), b;
        }), at(_, "Series/Treemap/TreemapUtilities.js", [_["Core/Utilities.js"]], function(G) {
          var F, $ = G.objectEach;
          return function(Y) {
            Y.AXIS_MAX = 100, Y.isBoolean = function(J) {
              return typeof J == "boolean";
            }, Y.eachObject = function(J, Q, q) {
              q = q || this, $(J, function(U, N) {
                Q.call(q, U, N, J);
              });
            }, Y.recursive = function J(Q, q, U) {
              var N;
              U === void 0 && (U = this), (N = q.call(U, Q)) !== !1 && J(N, q, U);
            };
          }(F || (F = {})), F;
        }), at(_, "Series/TreeUtilities.js", [_["Core/Color/Color.js"], _["Core/Utilities.js"]], function(G, F) {
          var $ = F.extend, Y = F.isArray, J = F.isNumber, Q = F.isObject, q = F.merge, U = F.pick;
          return { getColor: function(N, D) {
            var k, A, b, d, m, v, g = D.index, x = D.mapOptionsToLevel, E = D.parentColor, P = D.parentColorIndex, S = D.series, u = D.colors, y = D.siblings, s = S.points, a = S.chart.options.chart;
            return N && (k = s[N.i], A = x[N.level] || {}, k && A.colorByPoint && (d = k.index % (u ? u.length : a.colorCount), b = u && u[d]), S.chart.styledMode || (m = U(k && k.options.color, A && A.color, b, E && function(e) {
              var n = A && A.colorVariation;
              return n && n.key === "brightness" && g && y ? G.parse(e).brighten(n.to * (g / y)).get() : e;
            }(E), S.color)), v = U(k && k.options.colorIndex, A && A.colorIndex, d, P, D.colorIndex)), { color: m, colorIndex: v };
          }, getLevelOptions: function(N) {
            var D, k, A, b, d, m, v = {};
            if (Q(N))
              for (b = J(N.from) ? N.from : 1, m = N.levels, k = {}, D = Q(N.defaults) ? N.defaults : {}, Y(m) && (k = m.reduce(function(g, x) {
                var E, P, S;
                return Q(x) && J(x.level) && (S = q({}, x), P = U(S.levelIsConstant, D.levelIsConstant), delete S.levelIsConstant, delete S.level, E = x.level + (P ? 0 : b - 1), Q(g[E]) ? q(!0, g[E], S) : g[E] = S), g;
              }, {})), d = J(N.to) ? N.to : 1, A = 0; A <= d; A++)
                v[A] = q({}, D, Q(k[A]) ? k[A] : {});
            return v;
          }, setTreeValues: function N(D, k) {
            var A = k.before, b = k.idRoot, d = k.mapIdToNode[b], m = k.levelIsConstant !== !1, v = k.points[D.i], g = v && v.options || {}, x = [], E = 0;
            D.levelDynamic = D.level - (m ? 0 : d.level), D.name = U(v && v.name, ""), D.visible = b === D.id || k.visible === !0, typeof A == "function" && (D = A(D, k)), D.children.forEach(function(S, u) {
              var y = $({}, k);
              $(y, { index: u, siblings: D.children.length, visible: D.visible }), S = N(S, y), x.push(S), S.visible && (E += S.val);
            });
            var P = U(g.value, E);
            return D.visible = P >= 0 && (E > 0 || D.visible), D.children = x, D.childrenTotal = E, D.isLeaf = D.visible && !E, D.val = P, D;
          }, updateRootId: function(N) {
            var D, k;
            return Q(N) && (k = Q(N.options) ? N.options : {}, D = U(N.rootNode, k.rootId, ""), Q(N.userOptions) && (N.userOptions.rootId = D), N.rootNode = D), D;
          } };
        }), at(_, "Extensions/Breadcrumbs.js", [_["Core/Chart/Chart.js"], _["Core/Defaults.js"], _["Core/Globals.js"], _["Core/Utilities.js"], _["Core/FormatUtilities.js"]], function(G, F, $, Y, J) {
          var Q = F.defaultOptions, q = J.format, U = Y.addEvent, N = Y.objectEach, D = Y.extend, k = Y.fireEvent, A = Y.merge, b = Y.pick, d = Y.defined, m = Y.isString;
          D(Q.lang, { mainBreadcrumb: "Main" });
          var v = function() {
            function g(x, E) {
              this.group = void 0, this.list = [], this.elementList = {}, this.isDirty = !0, this.level = 0, this.options = void 0;
              var P = A(x.options.drilldown && x.options.drilldown.drillUpButton, g.defaultBreadcrumbsOptions, x.options.navigation && x.options.navigation.breadcrumbs, E);
              this.chart = x, this.options = P || {};
            }
            return g.prototype.updateProperties = function(x) {
              this.setList(x), this.setLevel(), this.isDirty = !0;
            }, g.prototype.setList = function(x) {
              this.list = x;
            }, g.prototype.setLevel = function() {
              this.level = this.list.length && this.list.length - 1;
            }, g.prototype.getLevel = function() {
              return this.level;
            }, g.prototype.getButtonText = function(x) {
              var E = this.chart, P = this.options, S = E.options.lang, u = b(P.format, P.showFullPath ? "{level.name}" : "← {level.name}"), y = S && b(S.drillUpText, S.mainBreadcrumb), s = P.formatter && P.formatter(x) || q(u, { level: x.levelOptions }, E) || "";
              return (m(s) && !s.length || s === "← ") && d(y) && (s = P.showFullPath ? y : "← " + y), s;
            }, g.prototype.redraw = function() {
              this.isDirty && this.render(), this.group && this.group.align(), this.isDirty = !1;
            }, g.prototype.render = function() {
              var x = this, E = x.chart, P = x.options;
              !x.group && P && (x.group = E.renderer.g("breadcrumbs-group").addClass("highcharts-no-tooltip highcharts-breadcrumbs").attr({ zIndex: P.zIndex }).add()), P.showFullPath ? this.renderFullPathButtons() : this.renderSingleButton(), this.alignBreadcrumbsGroup();
            }, g.prototype.renderFullPathButtons = function() {
              this.destroySingleButton(), this.resetElementListState(), this.updateListElements(), this.destroyListElements();
            }, g.prototype.renderSingleButton = function() {
              var x = this, E = x.chart, P = x.list, S = x.options.buttonSpacing;
              this.destroyListElements();
              var u = x.group ? x.group.getBBox().width : S, y = S, s = P[P.length - 2];
              !E.drillUpButton && this.level > 0 ? E.drillUpButton = x.renderButton(s, u, y) : E.drillUpButton && (this.level > 0 ? this.updateSingleButton() : this.destroySingleButton());
            }, g.prototype.alignBreadcrumbsGroup = function(x) {
              var E = this;
              if (E.group) {
                var P = E.options, S = P.buttonTheme, u = P.position, y = P.relativeTo === "chart" || P.relativeTo === "spacingBox" ? void 0 : "scrollablePlotBox", s = E.group.getBBox(), a = 2 * (S.padding || 0) + P.buttonSpacing;
                u.width = s.width + a, u.height = s.height + a;
                var e = A(u);
                x && (e.x += x), E.options.rtl && (e.x += u.width), e.y = b(e.y, this.yOffset, 0), E.group.align(e, !0, y);
              }
            }, g.prototype.renderButton = function(x, E, P) {
              var S = this, u = this.chart, y = S.options, s = A(y.buttonTheme), a = u.renderer.button(S.getButtonText(x), E, P, function(e) {
                var n, o = y.events && y.events.click;
                o && (n = o.call(S, e, x)), n !== !1 && (y.showFullPath ? e.newLevel = x.level : e.newLevel = S.level - 1, k(S, "up", e));
              }, s).addClass("highcharts-breadcrumbs-button").add(S.group);
              return u.styledMode || a.attr(y.style), a;
            }, g.prototype.renderSeparator = function(x, E) {
              var P = this.chart, S = this.options.separator, u = P.renderer.label(S.text, x, E, void 0, void 0, void 0, !1).addClass("highcharts-breadcrumbs-separator").add(this.group);
              return P.styledMode || u.css(S.style), u;
            }, g.prototype.update = function(x) {
              A(!0, this.options, x), this.destroy(), this.isDirty = !0;
            }, g.prototype.updateSingleButton = function() {
              var x = this.chart, E = this.list[this.level - 1];
              x.drillUpButton && x.drillUpButton.attr({ text: this.getButtonText(E) });
            }, g.prototype.destroy = function() {
              this.destroySingleButton(), this.destroyListElements(!0), this.group && this.group.destroy(), this.group = void 0;
            }, g.prototype.destroyListElements = function(x) {
              var E = this.elementList;
              N(E, function(P, S) {
                !x && E[S].updated || ((P = E[S]).button && P.button.destroy(), P.separator && P.separator.destroy(), delete P.button, delete P.separator, delete E[S]);
              }), x && (this.elementList = {});
            }, g.prototype.destroySingleButton = function() {
              this.chart.drillUpButton && (this.chart.drillUpButton.destroy(), this.chart.drillUpButton = void 0);
            }, g.prototype.resetElementListState = function() {
              N(this.elementList, function(x) {
                x.updated = !1;
              });
            }, g.prototype.updateListElements = function() {
              var x, E = this, P = E.elementList, S = E.options.buttonSpacing, u = E.list, y = E.options.rtl, s = y ? -1 : 1, a = function(i, c) {
                return s * i.getBBox().width + s * c;
              }, e = function(i, c, l) {
                i.translate(c - i.getBBox().width, l);
              }, n = E.group ? a(E.group, S) : S, o = S;
              u.forEach(function(i, c) {
                var l, h, C = c === u.length - 1;
                P[i.level] ? (l = (x = P[i.level]).button, x.separator || C ? x.separator && C && (x.separator.destroy(), delete x.separator) : (n += s * S, x.separator = E.renderSeparator(n, o), y && e(x.separator, n, o), n += a(x.separator, S)), P[i.level].updated = !0) : (l = E.renderButton(i, n, o), y && e(l, n, o), n += a(l, S), C || (h = E.renderSeparator(n, o), y && e(h, n, o), n += a(h, S)), P[i.level] = { button: l, separator: h, updated: !0 }), l && l.setState(C ? 2 : 0);
              });
            }, g.defaultBreadcrumbsOptions = { buttonTheme: { fill: "none", height: 18, padding: 2, "stroke-width": 0, zIndex: 7, states: { select: { fill: "none" } }, style: { color: "#335cad" } }, buttonSpacing: 5, floating: !1, format: void 0, relativeTo: "plotBox", rtl: !1, position: { align: "left", verticalAlign: "top", x: 0, y: void 0 }, separator: { text: "/", style: { color: "#666666" } }, showFullPath: !0, style: {}, useHTML: !1, zIndex: 7 }, g;
          }();
          return $.Breadcrumbs || ($.Breadcrumbs = v, U(G, "getMargins", function() {
            var g = this.breadcrumbs;
            if (g && !g.options.floating && g.level) {
              var x = g.options, E = x.buttonTheme, P = (E.height || 0) + 2 * (E.padding || 0) + x.buttonSpacing, S = x.position.verticalAlign;
              S === "bottom" ? (this.marginBottom = (this.marginBottom || 0) + P, g.yOffset = P) : S !== "middle" ? (this.plotTop += P, g.yOffset = -P) : g.yOffset = void 0;
            }
          }), U(G, "redraw", function() {
            this.breadcrumbs && this.breadcrumbs.redraw();
          }), U(G, "destroy", function() {
            this.breadcrumbs && (this.breadcrumbs.destroy(), this.breadcrumbs = void 0);
          }), U(G, "afterShowResetZoom", function() {
            var g = this;
            if (g.breadcrumbs) {
              var x = g.resetZoomButton && g.resetZoomButton.getBBox(), E = g.breadcrumbs.options;
              x && E.position.align === "right" && E.relativeTo === "plotBox" && g.breadcrumbs.alignBreadcrumbsGroup(-x.width - E.buttonSpacing);
            }
          }), U(G, "selection", function(g) {
            g.resetSelection === !0 && this.breadcrumbs && this.breadcrumbs.alignBreadcrumbsGroup();
          })), v;
        }), at(_, "Series/Treemap/TreemapComposition.js", [_["Core/Series/SeriesRegistry.js"], _["Series/Treemap/TreemapUtilities.js"], _["Core/Utilities.js"]], function(G, F, $) {
          var Y = G.series, J = $.addEvent, Q = $.extend, q = !1;
          J(Y, "afterBindAxes", function() {
            var U, N = this, D = N.xAxis, k = N.yAxis;
            D && k && (N.is("treemap") ? (U = { endOnTick: !1, gridLineWidth: 0, lineWidth: 0, min: 0, minPadding: 0, max: F.AXIS_MAX, maxPadding: 0, startOnTick: !1, title: void 0, tickPositions: [] }, Q(k.options, U), Q(D.options, U), q = !0) : q && (k.setOptions(k.userOptions), D.setOptions(D.userOptions), q = !1));
          });
        }), at(_, "Series/Treemap/TreemapNode.js", [], function() {
          return function() {
            function G() {
              this.childrenTotal = 0, this.visible = !1;
            }
            return G.prototype.init = function(F, $, Y, J, Q, q, U) {
              return this.id = F, this.i = $, this.children = Y, this.height = J, this.level = Q, this.series = q, this.parent = U, this;
            }, G;
          }();
        }), at(_, "Series/Treemap/TreemapSeries.js", [_["Core/Color/Color.js"], _["Series/ColorMapComposition.js"], _["Core/Globals.js"], _["Core/Legend/LegendSymbol.js"], _["Core/Series/SeriesRegistry.js"], _["Series/Treemap/TreemapAlgorithmGroup.js"], _["Series/Treemap/TreemapPoint.js"], _["Series/Treemap/TreemapUtilities.js"], _["Series/TreeUtilities.js"], _["Extensions/Breadcrumbs.js"], _["Core/Utilities.js"], _["Series/Treemap/TreemapNode.js"]], function(G, F, $, Y, J, Q, q, U, N, D, k, A) {
          var b, d = this && this.__extends || (b = function(T, z) {
            return b = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(W, L) {
              W.__proto__ = L;
            } || function(W, L) {
              for (var I in L)
                L.hasOwnProperty(I) && (W[I] = L[I]);
            }, b(T, z);
          }, function(T, z) {
            function W() {
              this.constructor = T;
            }
            b(T, z), T.prototype = z === null ? Object.create(z) : (W.prototype = z.prototype, new W());
          }), m = G.parse, v = $.noop, g = J.series, x = J.seriesTypes, E = x.column, P = x.heatmap, S = x.scatter, u = N.getColor, y = N.getLevelOptions, s = N.updateRootId, a = k.addEvent, e = k.correctFloat, n = k.defined, o = k.error, i = k.extend, c = k.fireEvent, l = k.isArray, h = k.isObject, C = k.isString, M = k.merge, O = k.pick, p = k.stableSort, w = function(T) {
            function z() {
              var W = T !== null && T.apply(this, arguments) || this;
              return W.axisRatio = void 0, W.data = void 0, W.mapOptionsToLevel = void 0, W.nodeMap = void 0, W.nodeList = void 0, W.options = void 0, W.points = void 0, W.rootNode = void 0, W.tree = void 0, W.level = void 0, W;
            }
            return d(z, T), z.prototype.algorithmCalcPoints = function(W, L, I, j) {
              var Z, V, X, et, ot, it = I.lW, pt = I.lH, mt = I.plot, Ct = 0, kt = I.elArr.length - 1;
              L ? (it = I.nW, pt = I.nH) : ot = I.elArr[I.elArr.length - 1], I.elArr.forEach(function(Lt) {
                (L || Ct < kt) && (I.direction === 0 ? (Z = mt.x, V = mt.y, et = Lt / (X = it)) : (Z = mt.x, V = mt.y, X = Lt / (et = pt)), j.push({ x: Z, y: V, width: X, height: e(et) }), I.direction === 0 ? mt.y = mt.y + et : mt.x = mt.x + X), Ct += 1;
              }), I.reset(), I.direction === 0 ? I.width = I.width - it : I.height = I.height - pt, mt.y = mt.parent.y + (mt.parent.height - I.height), mt.x = mt.parent.x + (mt.parent.width - I.width), W && (I.direction = 1 - I.direction), L || I.addElement(ot);
            }, z.prototype.algorithmFill = function(W, L, I) {
              var j, Z, V, X, et, ot = [], it = L.direction, pt = L.x, mt = L.y, Ct = L.width, kt = L.height;
              return I.forEach(function(Lt) {
                j = L.width * L.height * (Lt.val / L.val), Z = pt, V = mt, it === 0 ? (Ct -= X = j / (et = kt), pt += X) : (kt -= et = j / (X = Ct), mt += et), ot.push({ x: Z, y: V, width: X, height: et }), W && (it = 1 - it);
              }), ot;
            }, z.prototype.algorithmLowAspectRatio = function(W, L, I) {
              var j, Z = [], V = this, X = { x: L.x, y: L.y, parent: L }, et = L.direction, ot = 0, it = I.length - 1, pt = new Q(L.height, L.width, et, X);
              return I.forEach(function(mt) {
                j = L.width * L.height * (mt.val / L.val), pt.addElement(j), pt.lP.nR > pt.lP.lR && V.algorithmCalcPoints(W, !1, pt, Z, X), ot === it && V.algorithmCalcPoints(W, !0, pt, Z, X), ot += 1;
              }), Z;
            }, z.prototype.alignDataLabel = function(W, L, I) {
              var j = I.style;
              j && !n(j.textOverflow) && L.text && L.getBBox().width > L.text.textWidth && L.css({ textOverflow: "ellipsis", width: j.width += "px" }), E.prototype.alignDataLabel.apply(this, arguments), W.dataLabel && W.dataLabel.attr({ zIndex: (W.node.zIndex || 0) + 1 });
            }, z.prototype.calculateChildrenAreas = function(W, L) {
              var I, j, Z = this, V = Z.options, X = Z.mapOptionsToLevel[W.level + 1], et = O(Z[X && X.layoutAlgorithm] && X.layoutAlgorithm, V.layoutAlgorithm), ot = V.alternateStartingDirection;
              j = W.children.filter(function(it) {
                return !it.ignore;
              }), X && X.layoutStartingDirection && (L.direction = X.layoutStartingDirection === "vertical" ? 0 : 1), I = Z[et](L, j), j.forEach(function(it, pt) {
                var mt = I[pt];
                it.values = M(mt, { val: it.childrenTotal, direction: ot ? 1 - L.direction : L.direction }), it.pointValues = M(mt, { x: mt.x / Z.axisRatio, y: U.AXIS_MAX - mt.y - mt.height, width: mt.width / Z.axisRatio }), it.children.length && Z.calculateChildrenAreas(it, it.values);
              });
            }, z.prototype.createList = function(W) {
              var L = this.chart, I = L.breadcrumbs, j = [];
              if (I) {
                var Z = 0;
                j.push({ level: Z, levelOptions: L.series[0] });
                for (var V = W.target.nodeMap[W.newRootId], X = []; V.parent || V.parent === ""; )
                  X.push(V), V = W.target.nodeMap[V.parent];
                X.reverse().forEach(function(et) {
                  j.push({ level: ++Z, levelOptions: et });
                }), j.length <= 1 && (j.length = 0);
              }
              return j;
            }, z.prototype.drawDataLabels = function() {
              var W, L, I = this, j = I.mapOptionsToLevel;
              I.points.filter(function(Z) {
                return Z.node.visible;
              }).forEach(function(Z) {
                L = j[Z.node.level], W = { style: {} }, Z.node.isLeaf || (W.enabled = !1), L && L.dataLabels && (W = M(W, L.dataLabels), I._hasPointLabels = !0), Z.shapeArgs && (W.style.width = Z.shapeArgs.width, Z.dataLabel && Z.dataLabel.css({ width: Z.shapeArgs.width + "px" })), Z.dlOptions = M(W, Z.options.dataLabels);
              }), g.prototype.drawDataLabels.call(this);
            }, z.prototype.drawPoints = function(W) {
              W === void 0 && (W = this.points);
              var L = this, I = L.chart, j = I.renderer, Z = I.styledMode, V = L.options, X = Z ? {} : V.shadow, et = V.borderRadius, ot = I.pointCount < V.animationLimit, it = V.allowTraversingTree;
              W.forEach(function(pt) {
                var mt = pt.node.levelDynamic, Ct = {}, kt = {}, Lt = {}, Tt = "level-group-" + pt.node.level, xt = !!pt.graphic, ct = ot && xt, ft = pt.shapeArgs;
                pt.shouldDraw() && (pt.isInside = !0, et && (kt.r = et), M(!0, ct ? Ct : kt, xt ? ft : {}, Z ? {} : L.pointAttribs(pt, pt.selected ? "select" : void 0)), L.colorAttribs && Z && i(Lt, L.colorAttribs(pt)), L[Tt] || (L[Tt] = j.g(Tt).attr({ zIndex: 1e3 - (mt || 0) }).add(L.group), L[Tt].survive = !0)), pt.draw({ animatableAttribs: Ct, attribs: kt, css: Lt, group: L[Tt], renderer: j, shadow: X, shapeArgs: ft, shapeType: pt.shapeType }), it && pt.graphic && (pt.drillId = V.interactByLeaf ? L.drillToByLeaf(pt) : L.drillToByGroup(pt));
              });
            }, z.prototype.drillToByGroup = function(W) {
              var L = !1;
              return W.node.level - this.nodeMap[this.rootNode].level != 1 || W.node.isLeaf || (L = W.id), L;
            }, z.prototype.drillToByLeaf = function(W) {
              var L, I = this, j = !1;
              if (W.node.parent !== I.rootNode && W.node.isLeaf)
                for (L = W.node; !j; )
                  (L = I.nodeMap[L.parent]).parent === I.rootNode && (j = L.id);
              return j;
            }, z.prototype.drillToNode = function(W, L) {
              o(32, !1, void 0, { "treemap.drillToNode": "use treemap.setRootNode" }), this.setRootNode(W, L);
            }, z.prototype.drillUp = function() {
              var W = this, L = W.nodeMap[W.rootNode];
              L && C(L.parent) && W.setRootNode(L.parent, !0, { trigger: "traverseUpButton" });
            }, z.prototype.getExtremes = function() {
              var W = g.prototype.getExtremes.call(this, this.colorValueData), L = W.dataMin, I = W.dataMax;
              return this.valueMin = L, this.valueMax = I, g.prototype.getExtremes.call(this);
            }, z.prototype.getListOfParents = function(W, L) {
              var I = l(W) ? W : [], j = l(L) ? L : [], Z = I.reduce(function(V, X, et) {
                var ot = O(X.parent, "");
                return V[ot] === void 0 && (V[ot] = []), V[ot].push(et), V;
              }, { "": [] });
              return U.eachObject(Z, function(V, X, et) {
                X !== "" && j.indexOf(X) === -1 && (V.forEach(function(ot) {
                  et[""].push(ot);
                }), delete et[X]);
              }), Z;
            }, z.prototype.getTree = function() {
              var W = this, L = this.data.map(function(j) {
                return j.id;
              }), I = W.getListOfParents(this.data, L);
              return W.nodeMap = {}, W.nodeList = [], W.buildTree("", -1, 0, I);
            }, z.prototype.buildTree = function(W, L, I, j, Z) {
              var V, X, et = this, ot = [], it = et.points[L], pt = 0;
              return (j[W] || []).forEach(function(mt) {
                X = et.buildTree(et.points[mt].id, mt, I + 1, j, W), pt = Math.max(X.height + 1, pt), ot.push(X);
              }), V = new et.NodeClass().init(W, L, ot, pt, I, et, Z), ot.forEach(function(mt) {
                mt.parentNode = V;
              }), et.nodeMap[V.id] = V, et.nodeList.push(V), it && (it.node = V, V.point = it), V;
            }, z.prototype.hasData = function() {
              return !!this.processedXData.length;
            }, z.prototype.init = function(W, L) {
              var I, j = this, Z = M(L.drillUpButton, L.breadcrumbs);
              I = a(j, "setOptions", function(V) {
                var X = V.userOptions;
                n(X.allowDrillToNode) && !n(X.allowTraversingTree) && (X.allowTraversingTree = X.allowDrillToNode, delete X.allowDrillToNode), n(X.drillUpButton) && !n(X.traverseUpButton) && (X.traverseUpButton = X.drillUpButton, delete X.drillUpButton);
              }), g.prototype.init.call(j, W, L), delete j.opacity, j.eventsToUnbind.push(I), j.options.allowTraversingTree && (j.eventsToUnbind.push(a(j, "click", j.onClickDrillToNode)), j.eventsToUnbind.push(a(j, "setRootNode", function(V) {
                var X = j.chart;
                X.breadcrumbs && X.breadcrumbs.updateProperties(j.createList(V));
              })), j.eventsToUnbind.push(a(j, "update", function(V, X) {
                var et = this.chart.breadcrumbs;
                et && V.options.breadcrumbs && et.update(V.options.breadcrumbs);
              })), j.eventsToUnbind.push(a(j, "destroy", function(V) {
                var X = this.chart;
                X.breadcrumbs && (X.breadcrumbs.destroy(), V.keepEventsForUpdate || (X.breadcrumbs = void 0));
              }))), W.breadcrumbs || (W.breadcrumbs = new D(W, Z)), j.eventsToUnbind.push(a(W.breadcrumbs, "up", function(V) {
                for (var X = this.level - V.newLevel, et = 0; et < X; et++)
                  j.drillUp();
              }));
            }, z.prototype.onClickDrillToNode = function(W) {
              var L = W.point, I = L && L.drillId;
              C(I) && (L.setState(""), this.setRootNode(I, !0, { trigger: "click" }));
            }, z.prototype.pointAttribs = function(W, L) {
              var I, j, Z = h(this.mapOptionsToLevel) ? this.mapOptionsToLevel : {}, V = W && Z[W.node.level] || {}, X = this.options, et = L && X.states && X.states[L] || {}, ot = W && W.getClassName() || "";
              return I = { stroke: W && W.borderColor || V.borderColor || et.borderColor || X.borderColor, "stroke-width": O(W && W.borderWidth, V.borderWidth, et.borderWidth, X.borderWidth), dashstyle: W && W.borderDashStyle || V.borderDashStyle || et.borderDashStyle || X.borderDashStyle, fill: W && W.color || this.color }, ot.indexOf("highcharts-above-level") !== -1 ? (I.fill = "none", I["stroke-width"] = 0) : ot.indexOf("highcharts-internal-node-interactive") !== -1 ? (j = O(et.opacity, X.opacity), I.fill = m(I.fill).setOpacity(j).get(), I.cursor = "pointer") : ot.indexOf("highcharts-internal-node") !== -1 ? I.fill = "none" : L && (I.fill = m(I.fill).brighten(et.brightness).get()), I;
            }, z.prototype.setColorRecursive = function(W, L, I, j, Z) {
              var V, X, et = this, ot = et && et.chart, it = ot && ot.options && ot.options.colors;
              W && (V = u(W, { colors: it, index: j, mapOptionsToLevel: et.mapOptionsToLevel, parentColor: L, parentColorIndex: I, series: et, siblings: Z }), (X = et.points[W.i]) && (X.color = V.color, X.colorIndex = V.colorIndex), (W.children || []).forEach(function(pt, mt) {
                et.setColorRecursive(pt, V.color, V.colorIndex, mt, W.children.length);
              }));
            }, z.prototype.setPointValues = function() {
              var W = this, L = W.points, I = W.xAxis, j = W.yAxis, Z = W.chart.styledMode;
              L.forEach(function(V) {
                var X = V.node, et = X.pointValues, ot = X.visible;
                if (et && ot) {
                  var it = et.height, pt = et.width, mt = et.x, Ct = et.y, kt = function(St) {
                    return Z ? 0 : (W.pointAttribs(St)["stroke-width"] || 0) % 2 / 2;
                  }(V), Lt = Math.round(I.toPixels(mt, !0)) - kt, Tt = Math.round(I.toPixels(mt + pt, !0)) - kt, xt = Math.round(j.toPixels(Ct, !0)) - kt, ct = Math.round(j.toPixels(Ct + it, !0)) - kt, ft = { x: Math.min(Lt, Tt), y: Math.min(xt, ct), width: Math.abs(Tt - Lt), height: Math.abs(ct - xt) };
                  V.plotX = ft.x + ft.width / 2, V.plotY = ft.y + ft.height / 2, V.shapeArgs = ft;
                } else
                  delete V.plotX, delete V.plotY;
              });
            }, z.prototype.setRootNode = function(W, L, I) {
              var j = this, Z = i({ newRootId: W, previousRootId: j.rootNode, redraw: O(L, !0), series: j }, I);
              c(j, "setRootNode", Z, function(V) {
                var X = V.series;
                X.idPreviousRoot = V.previousRootId, X.rootNode = V.newRootId, X.isDirty = !0, V.redraw && X.chart.redraw();
              });
            }, z.prototype.setState = function(W) {
              this.options.inactiveOtherPoints = !0, g.prototype.setState.call(this, W, !1), this.options.inactiveOtherPoints = !1;
            }, z.prototype.setTreeValues = function(W) {
              var L, I = this, j = I.options, Z = I.rootNode, V = I.nodeMap[Z], X = !U.isBoolean(j.levelIsConstant) || j.levelIsConstant, et = 0, ot = [], it = I.points[W.i];
              return W.children.forEach(function(pt) {
                pt = I.setTreeValues(pt), ot.push(pt), pt.ignore || (et += pt.val);
              }), p(ot, function(pt, mt) {
                return (pt.sortIndex || 0) - (mt.sortIndex || 0);
              }), L = O(it && it.options.value, et), it && (it.value = L), i(W, { children: ot, childrenTotal: et, ignore: !(O(it && it.visible, !0) && L > 0), isLeaf: W.visible && !et, levelDynamic: W.level - (X ? 0 : V.level), name: O(it && it.name, ""), sortIndex: O(it && it.sortIndex, -L), val: L }), W;
            }, z.prototype.sliceAndDice = function(W, L) {
              return this.algorithmFill(!0, W, L);
            }, z.prototype.squarified = function(W, L) {
              return this.algorithmLowAspectRatio(!0, W, L);
            }, z.prototype.strip = function(W, L) {
              return this.algorithmLowAspectRatio(!1, W, L);
            }, z.prototype.stripes = function(W, L) {
              return this.algorithmFill(!1, W, L);
            }, z.prototype.translate = function() {
              var W, L, I, j, Z, V = this, X = V.options, et = s(V);
              g.prototype.translate.call(V), j = V.tree = V.getTree(), W = V.nodeMap[et], et === "" || W && W.children.length || (V.setRootNode("", !1), et = V.rootNode, W = V.nodeMap[et]), V.mapOptionsToLevel = y({ from: W.level + 1, levels: X.levels, to: j.height, defaults: { levelIsConstant: V.options.levelIsConstant, colorByPoint: X.colorByPoint } }), U.recursive(V.nodeMap[V.rootNode], function(ot) {
                var it = !1, pt = ot.parent;
                return ot.visible = !0, (pt || pt === "") && (it = V.nodeMap[pt]), it;
              }), U.recursive(V.nodeMap[V.rootNode].children, function(ot) {
                var it = !1;
                return ot.forEach(function(pt) {
                  pt.visible = !0, pt.children.length && (it = (it || []).concat(pt.children));
                }), it;
              }), V.setTreeValues(j), V.axisRatio = V.xAxis.len / V.yAxis.len, V.nodeMap[""].pointValues = L = { x: 0, y: 0, width: U.AXIS_MAX, height: U.AXIS_MAX }, V.nodeMap[""].values = I = M(L, { width: L.width * V.axisRatio, direction: X.layoutStartingDirection === "vertical" ? 0 : 1, val: j.val }), V.calculateChildrenAreas(j, I), V.colorAxis || X.colorByPoint || V.setColorRecursive(V.tree), X.allowTraversingTree && (Z = W.pointValues, V.xAxis.setExtremes(Z.x, Z.x + Z.width, !1), V.yAxis.setExtremes(Z.y, Z.y + Z.height, !1), V.xAxis.setScale(), V.yAxis.setScale()), V.setPointValues();
            }, z.defaultOptions = M(S.defaultOptions, { allowTraversingTree: !1, animationLimit: 250, borderRadius: 0, showInLegend: !1, marker: void 0, colorByPoint: !1, dataLabels: { defer: !1, enabled: !0, formatter: function() {
              var W = this && this.point ? this.point : {};
              return C(W.name) ? W.name : "";
            }, inside: !0, verticalAlign: "middle" }, tooltip: { headerFormat: "", pointFormat: "<b>{point.name}</b>: {point.value}<br/>" }, ignoreHiddenPoint: !0, layoutAlgorithm: "sliceAndDice", layoutStartingDirection: "vertical", alternateStartingDirection: !1, levelIsConstant: !0, traverseUpButton: { position: { align: "right", x: -10, y: 10 } }, borderColor: "#e6e6e6", borderWidth: 1, colorKey: "colorValue", opacity: 0.15, states: { hover: { borderColor: "#999999", brightness: P ? 0 : 0.1, halo: !1, opacity: 0.75, shadow: !1 } } }), z;
          }(S);
          return i(w.prototype, { buildKDTree: v, colorAttribs: F.seriesMembers.colorAttribs, colorKey: "colorValue", directTouch: !0, drawLegendSymbol: Y.drawRectangle, getExtremesFromAll: !0, getSymbol: v, optionalAxis: "colorAxis", parallelArrays: ["x", "y", "value", "colorValue"], pointArrayMap: ["value"], pointClass: q, NodeClass: A, trackerGroups: ["group", "dataLabelsGroup"], utils: { recursive: U.recursive } }), F.compose(w), J.registerSeriesType("treemap", w), w;
        }), at(_, "Series/Sunburst/SunburstPoint.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = this && this.__extends || ($ = function(D, k) {
            return $ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, b) {
              A.__proto__ = b;
            } || function(A, b) {
              for (var d in b)
                b.hasOwnProperty(d) && (A[d] = b[d]);
            }, $(D, k);
          }, function(D, k) {
            function A() {
              this.constructor = D;
            }
            $(D, k), D.prototype = k === null ? Object.create(k) : (A.prototype = k.prototype, new A());
          }), J = G.series.prototype.pointClass, Q = G.seriesTypes.treemap.prototype.pointClass, q = F.correctFloat, U = F.extend, N = function(D) {
            function k() {
              var A = D !== null && D.apply(this, arguments) || this;
              return A.node = void 0, A.options = void 0, A.series = void 0, A.shapeExisting = void 0, A.shapeType = void 0, A;
            }
            return Y(k, D), k.prototype.getDataLabelPath = function(A) {
              var b, d = this.series.chart.renderer, m = this.shapeExisting, v = m.start, g = m.end, x = v + (g - v) / 2, E = x < 0 && x > -Math.PI || x > Math.PI, P = m.r + (A.options.distance || 0);
              return v === -Math.PI / 2 && q(g) === q(1.5 * Math.PI) && (v = -Math.PI + Math.PI / 360, g = -Math.PI / 360, E = !0), g - v > Math.PI && (E = !1, b = !0), this.dataLabelPath && (this.dataLabelPath = this.dataLabelPath.destroy()), this.dataLabelPath = d.arc({ open: !0, longArc: b ? 1 : 0 }).attr({ start: E ? v : g, end: E ? g : v, clockwise: +E, x: m.x, y: m.y, r: (P + m.innerR) / 2 }).add(d.defs), this.dataLabelPath;
            }, k.prototype.isValid = function() {
              return !0;
            }, k;
          }(Q);
          return U(N.prototype, { getClassName: J.prototype.getClassName, haloPath: J.prototype.haloPath, setState: J.prototype.setState }), N;
        }), at(_, "Series/Sunburst/SunburstUtilities.js", [_["Core/Series/SeriesRegistry.js"], _["Core/Utilities.js"]], function(G, F) {
          var $, Y = G.seriesTypes.treemap, J = F.isNumber, Q = F.isObject, q = F.merge;
          return function(U) {
            function N(D, k) {
              var A, b = [];
              if (J(D) && J(k) && D <= k)
                for (A = D; A <= k; A++)
                  b.push(A);
              return b;
            }
            U.recursive = Y.prototype.utils.recursive, U.calculateLevelSizes = function(D, k) {
              var A, b, d, m, v, g, x, E = Q(k) ? k : {}, P = 0;
              return Q(D) && (A = q({}, D), g = J(E.from) ? E.from : 0, x = J(E.to) ? E.to : 0, d = N(g, x), m = Object.keys(A).filter(function(S) {
                return d.indexOf(+S) === -1;
              }), b = v = J(E.diffRadius) ? E.diffRadius : 0, d.forEach(function(S) {
                var u = A[S], y = u.levelSize.unit, s = u.levelSize.value;
                y === "weight" ? P += s : y === "percentage" ? (u.levelSize = { unit: "pixels", value: s / 100 * b }, v -= u.levelSize.value) : y === "pixels" && (v -= s);
              }), d.forEach(function(S) {
                var u, y = A[S];
                y.levelSize.unit === "weight" && (u = y.levelSize.value, A[S].levelSize = { unit: "pixels", value: u / P * v });
              }), m.forEach(function(S) {
                A[S].levelSize = { value: 0, unit: "pixels" };
              })), A;
            }, U.getLevelFromAndTo = function(D) {
              var k = D.level;
              return { from: k > 0 ? k : 1, to: k + D.height };
            }, U.range = N;
          }($ || ($ = {})), $;
        }), at(_, "Series/Sunburst/SunburstNode.js", [_["Series/Treemap/TreemapNode.js"]], function(G) {
          var F, $ = this && this.__extends || (F = function(J, Q) {
            return F = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(q, U) {
              q.__proto__ = U;
            } || function(q, U) {
              for (var N in U)
                U.hasOwnProperty(N) && (q[N] = U[N]);
            }, F(J, Q);
          }, function(J, Q) {
            function q() {
              this.constructor = J;
            }
            F(J, Q), J.prototype = Q === null ? Object.create(Q) : (q.prototype = Q.prototype, new q());
          }), Y = function(J) {
            function Q() {
              return J !== null && J.apply(this, arguments) || this;
            }
            return $(Q, J), Q;
          }(G);
          return Y;
        }), at(_, "Series/Sunburst/SunburstSeries.js", [_["Series/CenteredUtilities.js"], _["Core/Globals.js"], _["Core/Series/SeriesRegistry.js"], _["Series/Sunburst/SunburstPoint.js"], _["Series/Sunburst/SunburstUtilities.js"], _["Series/TreeUtilities.js"], _["Core/Utilities.js"], _["Series/Sunburst/SunburstNode.js"]], function(G, F, $, Y, J, Q, q, U) {
          var N, D = this && this.__extends || (N = function(O, p) {
            return N = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, T) {
              w.__proto__ = T;
            } || function(w, T) {
              for (var z in T)
                T.hasOwnProperty(z) && (w[z] = T[z]);
            }, N(O, p);
          }, function(O, p) {
            function w() {
              this.constructor = O;
            }
            N(O, p), O.prototype = p === null ? Object.create(p) : (w.prototype = p.prototype, new w());
          }), k = G.getCenter, A = G.getStartAndEndRadians, b = F.noop, d = $.series, m = $.seriesTypes, v = m.column, g = m.treemap, x = Q.getColor, E = Q.getLevelOptions, P = Q.setTreeValues, S = Q.updateRootId, u = q.defined, y = q.error, s = q.extend, a = q.isNumber, e = q.isObject, n = q.isString, o = q.merge, i = q.splat, c = 180 / Math.PI, l = function(O, p, w, T) {
            return { x: O + Math.cos(w) * T, y: p + Math.sin(w) * T };
          };
          function h(O, p, w) {
            var T;
            return O.node.isLeaf || (T = p === O.id ? w[p].parent : O.id), T;
          }
          function C(O, p) {
            var w = p.mapIdToNode, T = O.parent, z = T ? w[T] : void 0, W = p.series, L = W.chart, I = W.points[O.i], j = W.options.colors || L && L.options.colors, Z = x(O, { colors: j, colorIndex: W.colorIndex, index: p.index, mapOptionsToLevel: p.mapOptionsToLevel, parentColor: z && z.color, parentColorIndex: z && z.colorIndex, series: p.series, siblings: p.siblings });
            return O.color = Z.color, O.colorIndex = Z.colorIndex, I && (I.color = O.color, I.colorIndex = O.colorIndex, O.sliced = O.id !== p.idRoot && I.sliced), O;
          }
          var M = function(O) {
            function p() {
              var w = O !== null && O.apply(this, arguments) || this;
              return w.center = void 0, w.data = void 0, w.mapOptionsToLevel = void 0, w.nodeMap = void 0, w.options = void 0, w.points = void 0, w.shapeRoot = void 0, w.startAndEndRadians = void 0, w.tree = void 0, w;
            }
            return D(p, O), p.prototype.alignDataLabel = function(w, T, z) {
              if (!z.textPath || !z.textPath.enabled)
                return O.prototype.alignDataLabel.apply(this, arguments);
            }, p.prototype.animate = function(w) {
              var T, z = this.chart, W = [z.plotWidth / 2, z.plotHeight / 2], L = z.plotLeft, I = z.plotTop, j = this.group;
              w ? (T = { translateX: W[0] + L, translateY: W[1] + I, scaleX: 1e-3, scaleY: 1e-3, rotation: 10, opacity: 0.01 }, j.attr(T)) : (T = { translateX: L, translateY: I, scaleX: 1, scaleY: 1, rotation: 0, opacity: 1 }, j.animate(T, this.options.animation));
            }, p.prototype.drawPoints = function() {
              var w, T = this, z = T.mapOptionsToLevel, W = T.shapeRoot, L = T.group, I = T.hasRendered, j = T.rootNode, Z = T.idPreviousRoot, V = T.nodeMap, X = V[Z], et = X && X.shapeArgs, ot = T.points, it = T.startAndEndRadians, pt = T.chart, mt = pt && pt.options && pt.options.chart || {}, Ct = typeof mt.animation != "boolean" || mt.animation, kt = T.center, Lt = { x: kt[0], y: kt[1] }, Tt = kt[3] / 2, xt = T.chart.renderer, ct = !1, ft = !1, St = !!(Ct && I && j !== Z && T.dataLabelsGroup);
              St && (T.dataLabelsGroup.attr({ opacity: 0 }), w = function() {
                var Mt = T;
                ct = !0, Mt.dataLabelsGroup && Mt.dataLabelsGroup.animate({ opacity: 1, visibility: "inherit" });
              }), ot.forEach(function(Mt) {
                var Dt, Ot, Nt = Mt.node, Wt = z[Nt.level], zt = Mt.shapeExisting || {}, Ht = Nt.shapeArgs || {}, Kt = !(!Nt.visible || !Nt.shapeArgs);
                Dt = I && Ct ? function(Gt, ee) {
                  var Jt = ee.point, Qt = ee.radians, ne = ee.innerR, ae = ee.idRoot, Me = ee.idPreviousRoot, he = ee.shapeExisting, fe = ee.shapeRoot, Ee = ee.shapePreviousRoot, Xe = ee.visible, Se = {}, Le = { end: Gt.end, start: Gt.start, innerR: Gt.innerR, r: Gt.r, x: Gt.x, y: Gt.y };
                  return Xe ? !Jt.graphic && Ee && ((Se = ae === Jt.id ? { start: Qt.start, end: Qt.end } : Ee.end <= Gt.start ? { start: Qt.end, end: Qt.end } : { start: Qt.start, end: Qt.start }).innerR = Se.r = ne) : Jt.graphic && (Me === Jt.id ? Le = { innerR: ne, r: ne } : fe && (Le = fe.end <= he.start ? { innerR: ne, r: ne, start: Qt.end, end: Qt.end } : { innerR: ne, r: ne, start: Qt.start, end: Qt.start })), { from: Se, to: Le };
                }(Ht, { center: Lt, point: Mt, radians: it, innerR: Tt, idRoot: j, idPreviousRoot: Z, shapeExisting: zt, shapeRoot: W, shapePreviousRoot: et, visible: Kt }) : { to: Ht, from: {} }, s(Mt, { shapeExisting: Ht, tooltipPos: [Ht.plotX, Ht.plotY], drillId: h(Mt, j, V), name: "" + (Mt.name || Mt.id || Mt.index), plotX: Ht.plotX, plotY: Ht.plotY, value: Nt.val, isInside: Kt, isNull: !Kt }), Mt.dlOptions = function(Gt) {
                  var ee, Jt, Qt = Gt.point, ne = e(Gt.shapeArgs) ? Gt.shapeArgs : {}, ae = e(Gt.optionsPoint) ? Gt.optionsPoint.dataLabels : {}, Me = i(e(Gt.level) ? Gt.level.dataLabels : {})[0], he = o({ style: {} }, Me, ae), fe = he.rotationMode;
                  return a(he.rotation) || (fe !== "auto" && fe !== "circular" || (Qt.innerArcLength < 1 && Qt.outerArcLength > ne.radius ? (ee = 0, Qt.dataLabelPath && fe === "circular" && (he.textPath = { enabled: !0 })) : Qt.innerArcLength > 1 && Qt.outerArcLength > 1.5 * ne.radius ? fe === "circular" ? he.textPath = { enabled: !0, attributes: { dy: 5 } } : fe = "parallel" : (Qt.dataLabel && Qt.dataLabel.textPath && fe === "circular" && (he.textPath = { enabled: !1 }), fe = "perpendicular")), fe !== "auto" && fe !== "circular" && (ee = ne.end - (ne.end - ne.start) / 2), fe === "parallel" ? he.style.width = Math.min(2.5 * ne.radius, (Qt.outerArcLength + Qt.innerArcLength) / 2) : !u(he.style.width) && ne.radius && (he.style.width = Qt.node.level === 1 ? 2 * ne.radius : ne.radius), fe === "perpendicular" && Qt.series.chart.renderer.fontMetrics(he.style.fontSize).h > Qt.outerArcLength && (he.style.width = 1), he.style.width = Math.max(he.style.width - 2 * (he.padding || 0), 1), Jt = ee * c % 180, fe === "parallel" && (Jt -= 90), Jt > 90 ? Jt -= 180 : Jt < -90 && (Jt += 180), he.rotation = Jt), he.textPath && (Qt.shapeExisting.innerR === 0 && he.textPath.enabled ? (he.rotation = 0, he.textPath.enabled = !1, he.style.width = Math.max(2 * Qt.shapeExisting.r - 2 * (he.padding || 0), 1)) : Qt.dlOptions && Qt.dlOptions.textPath && !Qt.dlOptions.textPath.enabled && fe === "circular" && (he.textPath.enabled = !0), he.textPath.enabled && (he.rotation = 0, he.style.width = Math.max((Qt.outerArcLength + Qt.innerArcLength) / 2 - 2 * (he.padding || 0), 1))), he.rotation === 0 && (he.rotation = 1e-3), he;
                }({ point: Mt, level: Wt, optionsPoint: Mt.options, shapeArgs: Ht }), !ft && Kt && (ft = !0, Ot = w), Mt.draw({ animatableAttribs: Dt.to, attribs: s(Dt.from, !pt.styledMode && T.pointAttribs(Mt, Mt.selected && "select")), onComplete: Ot, group: L, renderer: xt, shapeType: "arc", shapeArgs: Ht });
              }), St && ft ? (T.hasRendered = !1, T.options.dataLabels.defer = !0, d.prototype.drawDataLabels.call(T), T.hasRendered = !0, ct && w()) : d.prototype.drawDataLabels.call(T);
            }, p.prototype.layoutAlgorithm = function(w, T, z) {
              var W = w.start, L = w.end - W, I = w.val, j = w.x, Z = w.y, V = z && e(z.levelSize) && a(z.levelSize.value) ? z.levelSize.value : 0, X = w.r, et = X + V, ot = z && a(z.slicedOffset) ? z.slicedOffset : 0;
              return (T || []).reduce(function(it, pt) {
                var mt = 1 / I * pt.val * L, Ct = l(j, Z, W + mt / 2, ot), kt = { x: pt.sliced ? Ct.x : j, y: pt.sliced ? Ct.y : Z, innerR: X, r: et, radius: V, start: W, end: W + mt };
                return it.push(kt), W = kt.end, it;
              }, []);
            }, p.prototype.setShapeArgs = function(w, T, z) {
              var W, L = w.level + 1, I = z[L], j = w.children.filter(function(Z) {
                return Z.visible;
              });
              W = this.layoutAlgorithm(T, j, I), j.forEach(function(Z, V) {
                var X = W[V], et = X.start + (X.end - X.start) / 2, ot = X.innerR + (X.r - X.innerR) / 2, it = X.end - X.start, pt = X.innerR === 0 && it > 6.28 ? { x: X.x, y: X.y } : l(X.x, X.y, et, ot), mt = Z.val ? Z.childrenTotal > Z.val ? Z.childrenTotal : Z.val : Z.childrenTotal;
                this.points[Z.i] && (this.points[Z.i].innerArcLength = it * X.innerR, this.points[Z.i].outerArcLength = it * X.r), Z.shapeArgs = o(X, { plotX: pt.x, plotY: pt.y + 4 * Math.abs(Math.cos(et)) }), Z.values = o(X, { val: mt }), Z.children.length && this.setShapeArgs(Z, Z.values, z);
              }, this);
            }, p.prototype.translate = function() {
              var w, T, z, W, L = this, I = L.options, j = L.center = L.getCenter(), Z = L.startAndEndRadians = A(I.startAngle, I.endAngle), V = j[3] / 2, X = j[2] / 2 - V, et = S(L), ot = L.nodeMap, it = ot && ot[et], pt = {};
              L.shapeRoot = it && it.shapeArgs, d.prototype.translate.call(L), z = L.tree = L.getTree(), it = (ot = L.nodeMap)[et], T = ot[n(it.parent) ? it.parent : ""];
              var mt = J.getLevelFromAndTo(it), Ct = mt.from, kt = mt.to;
              w = E({ from: Ct, levels: L.options.levels, to: kt, defaults: { colorByPoint: I.colorByPoint, dataLabels: I.dataLabels, levelIsConstant: I.levelIsConstant, levelSize: I.levelSize, slicedOffset: I.slicedOffset } }), w = J.calculateLevelSizes(w, { diffRadius: X, from: Ct, to: kt }), P(z, { before: C, idRoot: et, levelIsConstant: I.levelIsConstant, mapOptionsToLevel: w, mapIdToNode: ot, points: L.points, series: L }), W = ot[""].shapeArgs = { end: Z.end, r: V, start: Z.start, val: it.val, x: j[0], y: j[1] }, this.setShapeArgs(T, W, w), L.mapOptionsToLevel = w, L.data.forEach(function(Lt) {
                pt[Lt.id] && y(31, !1, L.chart), pt[Lt.id] = !0;
              }), pt = {};
            }, p.defaultOptions = o(g.defaultOptions, { center: ["50%", "50%"], colorByPoint: !1, opacity: 1, dataLabels: { allowOverlap: !0, defer: !0, rotationMode: "auto", style: { textOverflow: "ellipsis" } }, rootId: void 0, levelIsConstant: !0, levelSize: { value: 1, unit: "weight" }, slicedOffset: 10 }), p;
          }(g);
          return s(M.prototype, { drawDataLabels: b, getCenter: k, onPointSupported: !0, pointAttribs: v.prototype.pointAttribs, pointClass: Y, NodeClass: U, utils: J }), $.registerSeriesType("sunburst", M), M;
        }), at(_, "masters/modules/sunburst.src.js", [], function() {
        });
      }, tt.exports ? (yt.default = yt, tt.exports = yt) : (ht = [lt(8840)], (ut = function(gt) {
        return yt(gt), yt.Highcharts = gt, yt;
      }.apply(st, ht)) === void 0 || (tt.exports = ut));
    }, 4649: (tt, st, lt) => {
      lt.d(st, { Z: () => _ });
      var ht = lt(8804);
      const ut = function(at, G) {
        for (var F = at.length; F--; )
          if ((0, ht.Z)(at[F][0], G))
            return F;
        return -1;
      };
      var yt = Array.prototype.splice;
      function gt(at) {
        var G = -1, F = at == null ? 0 : at.length;
        for (this.clear(); ++G < F; ) {
          var $ = at[G];
          this.set($[0], $[1]);
        }
      }
      gt.prototype.clear = function() {
        this.__data__ = [], this.size = 0;
      }, gt.prototype.delete = function(at) {
        var G = this.__data__, F = ut(G, at);
        return !(F < 0 || (F == G.length - 1 ? G.pop() : yt.call(G, F, 1), --this.size, 0));
      }, gt.prototype.get = function(at) {
        var G = this.__data__, F = ut(G, at);
        return F < 0 ? void 0 : G[F][1];
      }, gt.prototype.has = function(at) {
        return ut(this.__data__, at) > -1;
      }, gt.prototype.set = function(at, G) {
        var F = this.__data__, $ = ut(F, at);
        return $ < 0 ? (++this.size, F.push([at, G])) : F[$][1] = G, this;
      };
      const _ = gt;
    }, 8896: (tt, st, lt) => {
      lt.d(st, { Z: () => yt });
      var ht = lt(5546), ut = lt(3221);
      const yt = (0, ht.Z)(ut.Z, "Map");
    }, 3703: (tt, st, lt) => {
      lt.d(st, { Z: () => Y });
      const ht = (0, lt(5546).Z)(Object, "create");
      var ut = Object.prototype.hasOwnProperty, yt = Object.prototype.hasOwnProperty;
      function gt(J) {
        var Q = -1, q = J == null ? 0 : J.length;
        for (this.clear(); ++Q < q; ) {
          var U = J[Q];
          this.set(U[0], U[1]);
        }
      }
      gt.prototype.clear = function() {
        this.__data__ = ht ? ht(null) : {}, this.size = 0;
      }, gt.prototype.delete = function(J) {
        var Q = this.has(J) && delete this.__data__[J];
        return this.size -= Q ? 1 : 0, Q;
      }, gt.prototype.get = function(J) {
        var Q = this.__data__;
        if (ht) {
          var q = Q[J];
          return q === "__lodash_hash_undefined__" ? void 0 : q;
        }
        return ut.call(Q, J) ? Q[J] : void 0;
      }, gt.prototype.has = function(J) {
        var Q = this.__data__;
        return ht ? Q[J] !== void 0 : yt.call(Q, J);
      }, gt.prototype.set = function(J, Q) {
        var q = this.__data__;
        return this.size += this.has(J) ? 0 : 1, q[J] = ht && Q === void 0 ? "__lodash_hash_undefined__" : Q, this;
      };
      const _ = gt;
      var at = lt(4649), G = lt(8896);
      const F = function(J, Q) {
        var q, U, N = J.__data__;
        return ((U = typeof (q = Q)) == "string" || U == "number" || U == "symbol" || U == "boolean" ? q !== "__proto__" : q === null) ? N[typeof Q == "string" ? "string" : "hash"] : N.map;
      };
      function $(J) {
        var Q = -1, q = J == null ? 0 : J.length;
        for (this.clear(); ++Q < q; ) {
          var U = J[Q];
          this.set(U[0], U[1]);
        }
      }
      $.prototype.clear = function() {
        this.size = 0, this.__data__ = { hash: new _(), map: new (G.Z || at.Z)(), string: new _() };
      }, $.prototype.delete = function(J) {
        var Q = F(this, J).delete(J);
        return this.size -= Q ? 1 : 0, Q;
      }, $.prototype.get = function(J) {
        return F(this, J).get(J);
      }, $.prototype.has = function(J) {
        return F(this, J).has(J);
      }, $.prototype.set = function(J, Q) {
        var q = F(this, J), U = q.size;
        return q.set(J, Q), this.size += q.size == U ? 0 : 1, this;
      };
      const Y = $;
    }, 187: (tt, st, lt) => {
      lt.d(st, { Z: () => ht });
      const ht = lt(3221).Z.Symbol;
    }, 6299: (tt, st, lt) => {
      lt.d(st, { Z: () => gt });
      var ht = lt(3896), ut = lt(8804), yt = Object.prototype.hasOwnProperty;
      const gt = function(_, at, G) {
        var F = _[at];
        yt.call(_, at) && (0, ut.Z)(F, G) && (G !== void 0 || at in _) || (0, ht.Z)(_, at, G);
      };
    }, 3896: (tt, st, lt) => {
      lt.d(st, { Z: () => yt });
      var ht = lt(5546);
      const ut = function() {
        try {
          var gt = (0, ht.Z)(Object, "defineProperty");
          return gt({}, "", {}), gt;
        } catch (_) {
        }
      }(), yt = function(gt, _, at) {
        _ == "__proto__" && ut ? ut(gt, _, { configurable: !0, enumerable: !0, value: at, writable: !0 }) : gt[_] = at;
      };
    }, 9001: (tt, st, lt) => {
      lt.d(st, { Z: () => F });
      var ht = lt(187), ut = Object.prototype, yt = ut.hasOwnProperty, gt = ut.toString, _ = ht.Z ? ht.Z.toStringTag : void 0, at = Object.prototype.toString, G = ht.Z ? ht.Z.toStringTag : void 0;
      const F = function($) {
        return $ == null ? $ === void 0 ? "[object Undefined]" : "[object Null]" : G && G in Object($) ? function(Y) {
          var J = yt.call(Y, _), Q = Y[_];
          try {
            Y[_] = void 0;
            var q = !0;
          } catch (N) {
          }
          var U = gt.call(Y);
          return q && (J ? Y[_] = Q : delete Y[_]), U;
        }($) : function(Y) {
          return at.call(Y);
        }($);
      };
    }, 8525: (tt, st, lt) => {
      lt.d(st, { Z: () => D });
      var ht = lt(7885), ut = lt(2758), yt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, gt = /^\w*$/, _ = lt(3703);
      function at(k, A) {
        if (typeof k != "function" || A != null && typeof A != "function")
          throw new TypeError("Expected a function");
        var b = function() {
          var d = arguments, m = A ? A.apply(this, d) : d[0], v = b.cache;
          if (v.has(m))
            return v.get(m);
          var g = k.apply(this, d);
          return b.cache = v.set(m, g) || v, g;
        };
        return b.cache = new (at.Cache || _.Z)(), b;
      }
      at.Cache = _.Z;
      var G = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, F = /\\(\\)?/g;
      const $ = (Y = at(function(k) {
        var A = [];
        return k.charCodeAt(0) === 46 && A.push(""), k.replace(G, function(b, d, m, v) {
          A.push(m ? v.replace(F, "$1") : d || b);
        }), A;
      }, function(k) {
        return J.size === 500 && J.clear(), k;
      }), J = Y.cache, Y);
      var Y, J, Q = lt(187), q = Q.Z ? Q.Z.prototype : void 0, U = q ? q.toString : void 0;
      const N = function k(A) {
        if (typeof A == "string")
          return A;
        if ((0, ht.Z)(A))
          return function(d, m) {
            for (var v = -1, g = d == null ? 0 : d.length, x = Array(g); ++v < g; )
              x[v] = m(d[v], v, d);
            return x;
          }(A, k) + "";
        if ((0, ut.Z)(A))
          return U ? U.call(A) : "";
        var b = A + "";
        return b == "0" && 1 / A == -1 / 0 ? "-0" : b;
      }, D = function(k, A) {
        return (0, ht.Z)(k) ? k : function(b, d) {
          if ((0, ht.Z)(b))
            return !1;
          var m = typeof b;
          return !(m != "number" && m != "symbol" && m != "boolean" && b != null && !(0, ut.Z)(b)) || gt.test(b) || !yt.test(b) || d != null && b in Object(d);
        }(k, A) ? [k] : $(function(b) {
          return b == null ? "" : N(b);
        }(k));
      };
    }, 2168: (tt, st, lt) => {
      lt.d(st, { Z: () => ht });
      const ht = typeof Nc == "object" && Nc && Nc.Object === Object && Nc;
    }, 5546: (tt, st, lt) => {
      lt.d(st, { Z: () => U });
      var ht = lt(8936);
      const ut = lt(3221).Z["__core-js_shared__"];
      var yt, gt = (yt = /[^.]+$/.exec(ut && ut.keys && ut.keys.IE_PROTO || "")) ? "Symbol(src)_1." + yt : "", _ = lt(3122), at = lt(6682), G = /^\[object .+?Constructor\]$/, F = Function.prototype, $ = Object.prototype, Y = F.toString, J = $.hasOwnProperty, Q = RegExp("^" + Y.call(J).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      const q = function(N) {
        return !(!(0, _.Z)(N) || (D = N, gt && gt in D)) && ((0, ht.Z)(N) ? Q : G).test((0, at.Z)(N));
        var D;
      }, U = function(N, D) {
        var k = function(A, b) {
          return A == null ? void 0 : A[b];
        }(N, D);
        return q(k) ? k : void 0;
      };
    }, 6401: (tt, st, lt) => {
      lt.d(st, { Z: () => ut });
      var ht = /^(?:0|[1-9]\d*)$/;
      const ut = function(yt, gt) {
        var _ = typeof yt;
        return !!(gt = gt == null ? 9007199254740991 : gt) && (_ == "number" || _ != "symbol" && ht.test(yt)) && yt > -1 && yt % 1 == 0 && yt < gt;
      };
    }, 3221: (tt, st, lt) => {
      lt.d(st, { Z: () => yt });
      var ht = lt(2168), ut = typeof self == "object" && self && self.Object === Object && self;
      const yt = ht.Z || ut || Function("return this")();
    }, 7969: (tt, st, lt) => {
      lt.d(st, { Z: () => ut });
      var ht = lt(2758);
      const ut = function(yt) {
        if (typeof yt == "string" || (0, ht.Z)(yt))
          return yt;
        var gt = yt + "";
        return gt == "0" && 1 / yt == -1 / 0 ? "-0" : gt;
      };
    }, 6682: (tt, st, lt) => {
      lt.d(st, { Z: () => ut });
      var ht = Function.prototype.toString;
      const ut = function(yt) {
        if (yt != null) {
          try {
            return ht.call(yt);
          } catch (gt) {
          }
          try {
            return yt + "";
          } catch (gt) {
          }
        }
        return "";
      };
    }, 5998: (tt, st, lt) => {
      lt.r(st), lt.d(st, { default: () => Ye });
      var ht = lt(4649), ut = lt(8896), yt = lt(3703);
      function gt(qt) {
        var ue = this.__data__ = new ht.Z(qt);
        this.size = ue.size;
      }
      gt.prototype.clear = function() {
        this.__data__ = new ht.Z(), this.size = 0;
      }, gt.prototype.delete = function(qt) {
        var ue = this.__data__, ye = ue.delete(qt);
        return this.size = ue.size, ye;
      }, gt.prototype.get = function(qt) {
        return this.__data__.get(qt);
      }, gt.prototype.has = function(qt) {
        return this.__data__.has(qt);
      }, gt.prototype.set = function(qt, ue) {
        var ye = this.__data__;
        if (ye instanceof ht.Z) {
          var xe = ye.__data__;
          if (!ut.Z || xe.length < 199)
            return xe.push([qt, ue]), this.size = ++ye.size, this;
          ye = this.__data__ = new yt.Z(xe);
        }
        return ye.set(qt, ue), this.size = ye.size, this;
      };
      const _ = gt;
      var at = lt(6299);
      lt(3896);
      var G = lt(9001), F = lt(3391);
      const $ = function(qt) {
        return (0, F.Z)(qt) && (0, G.Z)(qt) == "[object Arguments]";
      };
      var Y = Object.prototype, J = Y.hasOwnProperty, Q = Y.propertyIsEnumerable;
      const q = $(/* @__PURE__ */ function() {
        return arguments;
      }()) ? $ : function(qt) {
        return (0, F.Z)(qt) && J.call(qt, "callee") && !Q.call(qt, "callee");
      };
      var U = lt(7885), N = lt(3221), D = r && !r.nodeType && r, k = D && !0 && t && !t.nodeType && t, A = k && k.exports === D ? N.Z.Buffer : void 0;
      const b = (A ? A.isBuffer : void 0) || function() {
        return !1;
      };
      var d = lt(6401);
      const m = function(qt) {
        return typeof qt == "number" && qt > -1 && qt % 1 == 0 && qt <= 9007199254740991;
      };
      var v = {};
      v["[object Float32Array]"] = v["[object Float64Array]"] = v["[object Int8Array]"] = v["[object Int16Array]"] = v["[object Int32Array]"] = v["[object Uint8Array]"] = v["[object Uint8ClampedArray]"] = v["[object Uint16Array]"] = v["[object Uint32Array]"] = !0, v["[object Arguments]"] = v["[object Array]"] = v["[object ArrayBuffer]"] = v["[object Boolean]"] = v["[object DataView]"] = v["[object Date]"] = v["[object Error]"] = v["[object Function]"] = v["[object Map]"] = v["[object Number]"] = v["[object Object]"] = v["[object RegExp]"] = v["[object Set]"] = v["[object String]"] = v["[object WeakMap]"] = !1;
      const g = function(qt) {
        return function(ue) {
          return qt(ue);
        };
      };
      var x = lt(2168), E = r && !r.nodeType && r, P = E && !0 && t && !t.nodeType && t, S = P && P.exports === E && x.Z.process;
      const u = function() {
        try {
          return P && P.require && P.require("util").types || S && S.binding && S.binding("util");
        } catch (qt) {
        }
      }();
      var y = u && u.isTypedArray;
      const s = y ? g(y) : function(qt) {
        return (0, F.Z)(qt) && m(qt.length) && !!v[(0, G.Z)(qt)];
      };
      var a = Object.prototype.hasOwnProperty;
      const e = function(qt, ue) {
        var ye = (0, U.Z)(qt), xe = !ye && q(qt), Ve = !ye && !xe && b(qt), ze = !ye && !xe && !Ve && s(qt), _e = ye || xe || Ve || ze, Ce = _e ? function(pi, Ki) {
          for (var ni = -1, Fe = Array(pi); ++ni < pi; )
            Fe[ni] = Ki(ni);
          return Fe;
        }(qt.length, String) : [], bi = Ce.length;
        for (var ti in qt)
          !a.call(qt, ti) || _e && (ti == "length" || Ve && (ti == "offset" || ti == "parent") || ze && (ti == "buffer" || ti == "byteLength" || ti == "byteOffset") || (0, d.Z)(ti, bi)) || Ce.push(ti);
        return Ce;
      };
      var n = Object.prototype;
      const o = function(qt) {
        var ue = qt && qt.constructor;
        return qt === (typeof ue == "function" && ue.prototype || n);
      }, i = function(qt, ue) {
        return function(ye) {
          return qt(ue(ye));
        };
      }, c = i(Object.keys, Object);
      var l = Object.prototype.hasOwnProperty, h = lt(8936);
      const C = function(qt) {
        return qt != null && m(qt.length) && !(0, h.Z)(qt);
      }, M = function(qt) {
        return C(qt) ? e(qt) : function(ue) {
          if (!o(ue))
            return c(ue);
          var ye = [];
          for (var xe in Object(ue))
            l.call(ue, xe) && xe != "constructor" && ye.push(xe);
          return ye;
        }(qt);
      };
      var O = lt(3122);
      const p = function() {
        return [];
      };
      var w = Object.prototype.propertyIsEnumerable, T = Object.getOwnPropertySymbols;
      const z = T ? function(qt) {
        return qt == null ? [] : (qt = Object(qt), function(ue, ye) {
          for (var xe = -1, Ve = ue == null ? 0 : ue.length, ze = 0, _e = []; ++xe < Ve; ) {
            var Ce = ue[xe];
            ye(Ce, xe, ue) && (_e[ze++] = Ce);
          }
          return _e;
        }(T(qt), function(ue) {
          return w.call(qt, ue);
        }));
      } : p, W = function(qt, ue) {
        for (var ye = -1, xe = ue.length, Ve = qt.length; ++ye < xe; )
          qt[Ve + ye] = ue[ye];
        return qt;
      }, L = i(Object.getPrototypeOf, Object), I = function(qt, ue, ye) {
        var xe = ue(qt);
        return (0, U.Z)(qt) ? xe : W(xe, ye(qt));
      }, j = function(qt) {
        return I(qt, M, z);
      };
      var Z = lt(5546);
      const V = (0, Z.Z)(N.Z, "DataView"), X = (0, Z.Z)(N.Z, "Promise"), et = (0, Z.Z)(N.Z, "Set"), ot = (0, Z.Z)(N.Z, "WeakMap");
      var it = lt(6682), pt = "[object Map]", mt = "[object Promise]", Ct = "[object Set]", kt = "[object WeakMap]", Lt = "[object DataView]", Tt = (0, it.Z)(V), xt = (0, it.Z)(ut.Z), ct = (0, it.Z)(X), ft = (0, it.Z)(et), St = (0, it.Z)(ot), Mt = G.Z;
      (V && Mt(new V(new ArrayBuffer(1))) != Lt || ut.Z && Mt(new ut.Z()) != pt || X && Mt(X.resolve()) != mt || et && Mt(new et()) != Ct || ot && Mt(new ot()) != kt) && (Mt = function(qt) {
        var ue = (0, G.Z)(qt), ye = ue == "[object Object]" ? qt.constructor : void 0, xe = ye ? (0, it.Z)(ye) : "";
        if (xe)
          switch (xe) {
            case Tt:
              return Lt;
            case xt:
              return pt;
            case ct:
              return mt;
            case ft:
              return Ct;
            case St:
              return kt;
          }
        return ue;
      });
      const Dt = Mt;
      var Ot = Object.prototype.hasOwnProperty;
      const Nt = N.Z.Uint8Array, Wt = function(qt) {
        var ue = new qt.constructor(qt.byteLength);
        return new Nt(ue).set(new Nt(qt)), ue;
      };
      var zt = /\w*$/, Ht = lt(187), Kt = Ht.Z ? Ht.Z.prototype : void 0, Gt = Kt ? Kt.valueOf : void 0;
      const ee = function(qt, ue, ye) {
        var xe, Ve, ze, _e = qt.constructor;
        switch (ue) {
          case "[object ArrayBuffer]":
            return Wt(qt);
          case "[object Boolean]":
          case "[object Date]":
            return new _e(+qt);
          case "[object DataView]":
            return function(Ce, bi) {
              var ti = Wt(Ce.buffer);
              return new Ce.constructor(ti, Ce.byteOffset, Ce.byteLength);
            }(qt);
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return function(Ce, bi) {
              var ti = Wt(Ce.buffer);
              return new Ce.constructor(ti, Ce.byteOffset, Ce.length);
            }(qt);
          case "[object Map]":
          case "[object Set]":
            return new _e();
          case "[object Number]":
          case "[object String]":
            return new _e(qt);
          case "[object RegExp]":
            return (ze = new (Ve = qt).constructor(Ve.source, zt.exec(Ve))).lastIndex = Ve.lastIndex, ze;
          case "[object Symbol]":
            return xe = qt, Gt ? Object(Gt.call(xe)) : {};
        }
      };
      var Jt = Object.create;
      const Qt = /* @__PURE__ */ function() {
        function qt() {
        }
        return function(ue) {
          if (!(0, O.Z)(ue))
            return {};
          if (Jt)
            return Jt(ue);
          qt.prototype = ue;
          var ye = new qt();
          return qt.prototype = void 0, ye;
        };
      }();
      var ne = u && u.isMap;
      const ae = ne ? g(ne) : function(qt) {
        return (0, F.Z)(qt) && Dt(qt) == "[object Map]";
      };
      var Me = u && u.isSet;
      const he = Me ? g(Me) : function(qt) {
        return (0, F.Z)(qt) && Dt(qt) == "[object Set]";
      };
      var fe = "[object Arguments]", Ee = "[object Function]", Xe = "[object Object]", Se = {};
      Se[fe] = Se["[object Array]"] = Se["[object ArrayBuffer]"] = Se["[object DataView]"] = Se["[object Boolean]"] = Se["[object Date]"] = Se["[object Float32Array]"] = Se["[object Float64Array]"] = Se["[object Int8Array]"] = Se["[object Int16Array]"] = Se["[object Int32Array]"] = Se["[object Map]"] = Se["[object Number]"] = Se[Xe] = Se["[object RegExp]"] = Se["[object Set]"] = Se["[object String]"] = Se["[object Symbol]"] = Se["[object Uint8Array]"] = Se["[object Uint8ClampedArray]"] = Se["[object Uint16Array]"] = Se["[object Uint32Array]"] = !0, Se["[object Error]"] = Se[Ee] = Se["[object WeakMap]"] = !1;
      const Le = function qt(ue, ye, xe, Ve, ze, _e) {
        var Ce, bi = 1 & ye;
        if (Ce !== void 0)
          return Ce;
        if (!(0, O.Z)(ue))
          return ue;
        var ti = (0, U.Z)(ue);
        if (ti)
          Ce = function(Ie) {
            var qe = Ie.length, si = new Ie.constructor(qe);
            return qe && typeof Ie[0] == "string" && Ot.call(Ie, "index") && (si.index = Ie.index, si.input = Ie.input), si;
          }(ue);
        else {
          var pi = Dt(ue), Ki = pi == Ee || pi == "[object GeneratorFunction]";
          if (b(ue))
            return function(Ie, qe) {
              return Ie.slice();
            }(ue);
          if (pi == Xe || pi == fe || Ki && !ze)
            Ce = Ki ? {} : function(Ie) {
              return typeof Ie.constructor != "function" || o(Ie) ? {} : Qt(L(Ie));
            }(ue);
          else {
            if (!Se[pi])
              return ze ? ue : {};
            Ce = ee(ue, pi);
          }
        }
        _e || (_e = new _());
        var ni = _e.get(ue);
        if (ni)
          return ni;
        _e.set(ue, Ce), he(ue) ? ue.forEach(function(Ie) {
          Ce.add(qt(Ie, ye, xe, Ie, ue, _e));
        }) : ae(ue) && ue.forEach(function(Ie, qe) {
          Ce.set(qe, qt(Ie, ye, xe, qe, ue, _e));
        });
        var Fe = ti ? void 0 : j(ue);
        return function(Ie, qe) {
          for (var si = -1, sr = Ie == null ? 0 : Ie.length; ++si < sr && qe(Ie[si], si, Ie) !== !1; )
            ;
        }(Fe || ue, function(Ie, qe) {
          Fe && (Ie = ue[qe = Ie]), (0, at.Z)(Ce, qe, qt(Ie, ye, xe, qe, ue, _e));
        }), Ce;
      }, Ye = function(qt) {
        return Le(qt, 5);
      };
    }, 8804: (tt, st, lt) => {
      lt.d(st, { Z: () => ht });
      const ht = function(ut, yt) {
        return ut === yt || ut != ut && yt != yt;
      };
    }, 1857: (tt, st, lt) => {
      lt.r(st), lt.d(st, { default: () => yt });
      var ht = lt(8525), ut = lt(7969);
      const yt = function(gt, _, at) {
        var G = gt == null ? void 0 : function(F, $) {
          for (var Y = 0, J = ($ = (0, ht.Z)($, F)).length; F != null && Y < J; )
            F = F[(0, ut.Z)($[Y++])];
          return Y && Y == J ? F : void 0;
        }(gt, _);
        return G === void 0 ? at : G;
      };
    }, 7885: (tt, st, lt) => {
      lt.d(st, { Z: () => ht });
      const ht = Array.isArray;
    }, 8936: (tt, st, lt) => {
      lt.d(st, { Z: () => yt });
      var ht = lt(9001), ut = lt(3122);
      const yt = function(gt) {
        if (!(0, ut.Z)(gt))
          return !1;
        var _ = (0, ht.Z)(gt);
        return _ == "[object Function]" || _ == "[object GeneratorFunction]" || _ == "[object AsyncFunction]" || _ == "[object Proxy]";
      };
    }, 3122: (tt, st, lt) => {
      lt.d(st, { Z: () => ht });
      const ht = function(ut) {
        var yt = typeof ut;
        return ut != null && (yt == "object" || yt == "function");
      };
    }, 3391: (tt, st, lt) => {
      lt.d(st, { Z: () => ht });
      const ht = function(ut) {
        return ut != null && typeof ut == "object";
      };
    }, 1284: (tt, st, lt) => {
      lt.r(st), lt.d(st, { default: () => gt });
      var ht = lt(9001), ut = lt(7885), yt = lt(3391);
      const gt = function(_) {
        return typeof _ == "string" || !(0, ut.Z)(_) && (0, yt.Z)(_) && (0, ht.Z)(_) == "[object String]";
      };
    }, 2758: (tt, st, lt) => {
      lt.d(st, { Z: () => yt });
      var ht = lt(9001), ut = lt(3391);
      const yt = function(gt) {
        return typeof gt == "symbol" || (0, ut.Z)(gt) && (0, ht.Z)(gt) == "[object Symbol]";
      };
    }, 4402: (tt, st, lt) => {
      lt.r(st), lt.d(st, { default: () => ht });
      const ht = function(ut) {
        return ut === void 0;
      };
    }, 4891: (tt, st, lt) => {
      lt.r(st), lt.d(st, { default: () => at });
      var ht = lt(6299), ut = lt(8525), yt = lt(6401), gt = lt(3122), _ = lt(7969);
      const at = function(G, F, $) {
        return G == null ? G : function(Y, J, Q, q) {
          if (!(0, gt.Z)(Y))
            return Y;
          for (var U = -1, N = (J = (0, ut.Z)(J, Y)).length, D = N - 1, k = Y; k != null && ++U < N; ) {
            var A = (0, _.Z)(J[U]), b = Q;
            if (A === "__proto__" || A === "constructor" || A === "prototype")
              return Y;
            if (U != D) {
              var d = k[A];
              (b = void 0) == void 0 && (b = (0, gt.Z)(d) ? d : (0, yt.Z)(J[U + 1]) ? [] : {});
            }
            (0, ht.Z)(k, A, b), k = k[A];
          }
          return Y;
        }(G, F, $);
      };
    } }, B = {};
    function H(tt) {
      var st = B[tt];
      if (st !== void 0)
        return st.exports;
      var lt = B[tt] = { exports: {} };
      return f[tt].call(lt.exports, lt, lt.exports, H), lt.exports;
    }
    return H.d = (tt, st) => {
      for (var lt in st)
        H.o(st, lt) && !H.o(tt, lt) && Object.defineProperty(tt, lt, { enumerable: !0, get: st[lt] });
    }, H.o = (tt, st) => Object.prototype.hasOwnProperty.call(tt, st), H.r = (tt) => {
      typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(tt, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(tt, "__esModule", { value: !0 });
    }, H(4658);
  })());
})(Ed, Ed.exports);
var VE = Ed.exports;
const $E = /* @__PURE__ */ Hg(VE), ZE = "rgb(255, 255, 255)", Og = "rgb(43, 51, 66)", Eh = 20, Lh = 4, KE = 2, Ld = 1, qE = Eh * 2, JE = 26, QE = 20, Dg = 35, t2 = Eh + Lh - 2, Ig = {
  key: "brightness",
  to: 0.15
};
$E.Series.types.treemap.prototype.squarifiedWithTopSpacing = function(t, r) {
  const f = n2(t.height, this.chart.plotHeight), B = this.squarified(t, r), H = f(t2);
  return o2(this.chart) ? B.map((tt, st) => {
    const lt = tt.height >= f(qE);
    return r[st].point.options.custom.bigLabelSpacing = lt, lt && (tt.height = tt.height - H, tt.y = tt.y + H), tt;
  }) : B;
};
function e2(t, r, f) {
  const B = i2();
  return B.forEach((H, tt) => {
    var lt, ht, ut, yt, gt, _, at;
    const st = H.dataLabels;
    (lt = r == null ? void 0 : r.labels) != null && lt.category && (st.enabled = (gt = (yt = (ut = (ht = r.labels) == null ? void 0 : ht.category) == null ? void 0 : ut[tt]) == null ? void 0 : yt.enabled) != null ? gt : !0), (_ = f == null ? void 0 : f.typography) != null && _.fontFamily && (st.style.fontFamily = (at = f == null ? void 0 : f.typography) == null ? void 0 : at.fontFamily);
  }), t.breakBy.length === 1 && (B[0].borderWidth = Ld, B[0].borderColor = "black", B[0].layoutAlgorithm = "strip", B[0].dataLabels = B[1].dataLabels), t.breakBy.length === 2 && (B[1].borderWidth = Ld, B[1].borderColor = "black"), t.breakBy.some(({ isColored: H }) => H) && (B[1].colorVariation = Ig, B[2].colorVariation = Ig), B;
}
function Qu() {
  var f, B;
  const t = Xh(tn(this.color)) > 0.4 && !((B = (f = this.point.options) == null ? void 0 : f.custom) != null && B.blur), { width: r } = dv(this.point);
  return r2(this.point) ? uv(this.point) ? `<div
              style="
                width:${r - Lh}px;
                height: ${Eh}px;
                background: #e6e6e6;
                color: ${Og};
                padding: 3px;
                position: absolute;
                top: -${Eh}px;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                left: ${Lh / 2}px;
                "
           >${this.key}</div>` : `<div style="fill:${t ? ZE : Og};">${this.key}</div>` : "";
}
function i2() {
  return [
    {
      level: 1,
      borderWidth: Lh,
      borderColor: "white",
      layoutAlgorithm: "squarifiedWithTopSpacing",
      dataLabels: {
        useHTML: !0,
        enabled: !0,
        align: "left",
        verticalAlign: "top",
        allowOverlap: !0,
        padding: 0,
        style: {
          fontSize: "14px"
        },
        formatter: Qu
      }
    },
    {
      level: 2,
      borderWidth: KE,
      borderColor: "white",
      dataLabels: {
        enabled: !0,
        align: "left",
        verticalAlign: "top",
        style: {
          fontSize: "14px"
        },
        formatter: Qu
      }
    },
    {
      level: 3,
      borderColor: "black",
      borderWidth: Ld,
      dataLabels: {
        enabled: !0,
        align: "center",
        verticalAlign: "middle",
        style: {
          fontSize: "13px"
        },
        formatter: Qu
      }
    }
  ];
}
function uv(t) {
  var r, f, B, H;
  return ((f = (r = t.options) == null ? void 0 : r.custom) == null ? void 0 : f.levelsCount) !== 1 && ((H = (B = t.options) == null ? void 0 : B.custom) == null ? void 0 : H.level) === 1;
}
function r2(t) {
  const { height: r, width: f } = dv(t), { level: B } = t.options.custom;
  return uv(t) ? !!t.options.custom.bigLabelSpacing : B !== 3 ? r >= JE && f >= Dg : r >= QE && f >= Dg;
}
function n2(t, r) {
  return (f) => {
    const B = r / t;
    return f / B;
  };
}
function o2(t) {
  var B, H, tt, st, lt, ht;
  const r = (H = (B = t.options.series) == null ? void 0 : B[0]) != null ? H : {};
  return (ht = ((lt = (st = (tt = r == null ? void 0 : r.levels) == null ? void 0 : tt[0]) == null ? void 0 : st.dataLabels) != null ? lt : {}).enabled) != null ? ht : !0;
}
function dv(t) {
  var r, f, B, H;
  return {
    width: (f = (r = t.shapeArgs) == null ? void 0 : r.width) != null ? f : 0,
    height: (H = (B = t.shapeArgs) == null ? void 0 : B.height) != null ? H : 0
  };
}
function pv(t, r, f) {
  if (!t.series[0])
    return [];
  const B = s2(t), H = t.series[0].data.map((tt) => {
    var st, lt;
    return {
      value: tt.value,
      name: (st = tt.xDisplayValue) == null ? void 0 : st.slice(-1).toString(),
      parent: (lt = tt.xValue) == null ? void 0 : lt.slice(0, -1).join("_"),
      custom: oe(Ut({}, tt), {
        level: t.xAxisCount,
        levelsCount: t.xAxisCount
      })
    };
  });
  return a2(
    [...B, ...H],
    r,
    f
  );
}
function s2(t) {
  const r = {};
  return t.xValues.forEach((f) => {
    f.rawValues.slice(0, -1).forEach((B, H) => {
      var st;
      const tt = f.rawValues.slice(0, H + 1).join("_");
      r[tt] = {
        id: tt,
        name: f.xValues[H],
        parent: f.rawValues.slice(0, H).join("_"),
        custom: {
          xValues: f.xValues.slice(0, H + 1),
          rawValues: (st = f.rawValues) == null ? void 0 : st.slice(0, H + 1),
          level: H + 1,
          levelsCount: t.xAxisCount
        }
      };
    });
  }), Object.values(r);
}
function a2(t, r, f) {
  const B = r.breakBy.map((tt) => tt.isColored).indexOf(!0) + 1, H = /* @__PURE__ */ new Map();
  return t.map((tt) => {
    var st;
    return tt.custom.level === B ? (H.has(tt.name) || H.set(tt.name, H.size), oe(Ut({}, tt), {
      color: (st = Kh(r, tt.name)) != null ? st : en(
        f == null ? void 0 : f.palette.variantColors,
        H.get(tt.name)
      )
    })) : tt;
  });
}
const l2 = "rgb(0, 206, 230)", c2 = {
  type: "treemap",
  layoutAlgorithm: "strip",
  layoutStartingDirection: "horizontal",
  clip: !1,
  color: l2,
  dataLabels: {
    style: {
      textOutline: "none"
    }
  }
}, h2 = {
  title: { text: null },
  chart: {
    type: "treemap",
    spacing: [20, 20, 20, 20],
    alignTicks: !1,
    polar: !1,
    animation: {
      duration: 300
    }
  },
  series: []
};
function u2(t, r, f, B) {
  return oe(Ut({}, h2), {
    series: [
      oe(Ut({}, c2), {
        name: Li(r.y[0]),
        data: pv(t, r, B),
        levels: e2(r, f, B)
      })
    ],
    tooltip: hv(r, f)
  });
}
const d2 = Object.freeze({
  1: 80,
  2: 70,
  3: 60,
  4: 50
});
function p2(t, r, f, B) {
  var st, lt;
  const H = {
    level: 1,
    color: (lt = (st = B == null ? void 0 : B.chart) == null ? void 0 : st.backgroundColor) != null ? lt : "white",
    dataLabels: {
      enabled: !0,
      useHTML: !0,
      className: "!csdk-overflow-visible",
      formatter() {
        var yt, gt, _, at, G, F;
        const ht = li(
          (gt = (yt = r.y) == null ? void 0 : yt[0]) == null ? void 0 : gt.numberFormatConfig
        ), { value: ut } = this.point;
        return `
        <div style="text-align: center; transform: translateY(calc(-50% + 15px))">
          <div style="color: ${(at = (_ = B == null ? void 0 : B.chart) == null ? void 0 : _.secondaryTextColor) != null ? at : "#9EA2AB"}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 18px">${this.point.name}</div>
          ${qn()}
          <div style="
            font-weight: 600;
            font-size: 18px;
            color: ${(F = (G = B == null ? void 0 : B.chart) == null ? void 0 : G.textColor) != null ? F : "#5B6372"}
            "
            >${ra(ht, ut)}</div>
        </div>
      `;
      }
    },
    levelSize: {
      unit: "percentage",
      value: d2[r.breakBy.length] || 50
    }
  }, tt = Array.from(new Array(t.xAxisCount)).map((ht, ut) => {
    var yt, gt, _, at;
    return {
      level: ut + 2,
      dataLabels: {
        enabled: (at = (_ = (gt = (yt = f == null ? void 0 : f.labels) == null ? void 0 : yt.category) == null ? void 0 : gt[ut]) == null ? void 0 : _.enabled) != null ? at : !1,
        formatter() {
          return `<span style="color: ${Xh(tn(this.color)) > 0.4 ? "white" : "rgb(43, 51, 66)"}">${this.point.name}</span>`;
        }
      }
    };
  });
  return [H, ...tt];
}
const Od = "SUNBURST_ROOT_PARENT_ID";
function f2(t, r, f) {
  const B = {
    id: Od,
    name: Li(r.y[0]),
    custom: { level: 0, levelsCount: t.xAxisCount }
  }, H = pv(t, r, f).map((lt) => lt.parent === "" ? oe(Ut({}, lt), {
    parent: Od
  }) : lt), tt = y2(H), st = g2(
    tt,
    r,
    f
  );
  return [B, ...st];
}
function g2(t, r, f) {
  const H = m2(r), tt = r.breakBy.map(() => /* @__PURE__ */ new Map());
  t.forEach((ht) => {
    var yt, gt, _, at;
    const ut = tt[ht.custom.level - 1];
    if (ut) {
      const G = (yt = ut.get(ht.name)) != null ? yt : 0, F = (at = (_ = ht.value) != null ? _ : (gt = ht.custom) == null ? void 0 : gt.subtotalValue) != null ? at : 0;
      ut.set(ht.name, G + F);
    }
  });
  const lt = tt.map((ht) => Array.from(ht.entries()).sort(([, ut], [, yt]) => ut - yt).map(([ut]) => ut)).map((ht, ut) => {
    var G, F;
    const yt = /* @__PURE__ */ new Map(), gt = en(f == null ? void 0 : f.palette.variantColors, ut), _ = ((F = (G = r.breakBy[ut]) == null ? void 0 : G.color) == null ? void 0 : F.color) || gt, at = LA(
      Ah(_, 0.3),
      Ah(_, -0.3),
      ht.length
    );
    return ht.forEach(($, Y) => {
      yt.set($, at[Y]);
    }), yt;
  });
  return t.map((ht) => {
    var gt, _, at;
    const ut = (_ = H[((gt = ht.custom) == null ? void 0 : gt.level) || ""]) == null ? void 0 : _[(ht == null ? void 0 : ht.name) || ""], yt = (at = lt[ht.custom.level - 1]) == null ? void 0 : at.get(ht.name);
    return oe(Ut({}, ht), {
      color: ut || yt
    });
  });
}
function m2(t) {
  return t.breakBy.reduce((r, { column: f }, B) => {
    var H;
    return (H = t == null ? void 0 : t.seriesToColorMap) != null && H[f.name] && (r[B + 1] = t.seriesToColorMap[f.name]), r;
  }, {});
}
function y2(t) {
  const r = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map();
  t.forEach((H) => {
    H.parent && (r.has(H.parent) || r.set(H.parent, []), r.get(H.parent).push(H));
  }), Array.from(r.values()).sort((H, tt) => {
    var st, lt, ht, ut, yt, gt;
    return ((ht = (lt = (st = tt[0]) == null ? void 0 : st.custom) == null ? void 0 : lt.level) != null ? ht : 0) - ((gt = (yt = (ut = H[0]) == null ? void 0 : ut.custom) == null ? void 0 : yt.level) != null ? gt : 0);
  }).forEach((H) => {
    H.forEach((tt) => {
      var ht, ut;
      const st = (ut = (ht = tt.value) != null ? ht : f.get(tt.id)) != null ? ut : 0, lt = f.get(tt.parent) || 0;
      f.set(tt.parent, lt + st), tt.id && (tt.custom.subtotalValue = f.get(tt.id));
    });
  });
  const B = [];
  return r.forEach((H) => {
    H.sort((tt, st) => {
      var ut, yt, gt, _;
      const lt = (yt = (ut = tt.value) != null ? ut : f.get(tt.id)) != null ? yt : 0, ht = (_ = (gt = st.value) != null ? gt : f.get(st.id)) != null ? _ : 0;
      return lt - ht;
    }), B.push(...H);
  }), B;
}
const fv = 50, v2 = 1e3, b2 = 500, Dd = 1e5, Ir = {
  lineType: "straight",
  stackType: "classic",
  legend: "bottom",
  lineWidth: 2,
  valueLabel: {},
  marker: { enabled: !1, size: "small", fill: "full" },
  xAxis: {
    type: "linear",
    enabled: !0,
    titleEnabled: !0,
    title: "X Axis title",
    gridLine: !0,
    labels: !0,
    min: null,
    max: null,
    tickInterval: null
  },
  yAxis: {
    type: "linear",
    enabled: !0,
    titleEnabled: !0,
    title: "Y Axis title",
    gridLine: !0,
    labels: !0,
    min: null,
    max: null,
    tickInterval: null
  },
  autoZoom: {
    enabled: !0
  },
  pieType: nv,
  pieLabels: rv,
  funnelType: bp,
  funnelSize: vp,
  funnelDirection: xp,
  funnelLabels: yp,
  indicatorType: "numeric",
  numericSubtype: "numericSimple",
  skin: "vertical",
  indicatorComponents: {
    title: {
      shouldBeShown: !1,
      text: ""
    },
    secondaryTitle: {
      text: ""
    },
    ticks: {
      shouldBeShown: !0
    },
    labels: {
      shouldBeShown: !0
    }
  },
  dataLimits: {
    seriesCapacity: fv,
    categoriesCapacity: Dd
  }
}, gv = {
  scatterDefaultSize: 10,
  scatterBubbleMinSize: 12,
  scatterBubbleMaxSize: 48
}, x2 = (t, r) => {
  var H;
  if (!t.enabled)
    return { enabled: !1 };
  const f = (H = t.rotation) != null ? H : 0, B = Ut({
    enabled: !0,
    align: "center",
    verticalAlign: "middle",
    types: {
      count: !1,
      relative: !0,
      totals: !0
    },
    rotation: f
  }, mp(f) === "horizontal" ? { y: -1 } : null);
  return B.formatter = function() {
    var _, at;
    const tt = this, st = {
      maskedY: r.y,
      maskedX: r.x,
      maskedSize: r.size,
      maskedBreakByColor: r.breakByColor
    }, ht = [
      r.y,
      r.x,
      r.size,
      r.breakByColor
    ].find(
      (G) => G && vn(G)
    ), ut = (_ = Object.entries(st).find(
      ([, G]) => G === ht
    )) == null ? void 0 : _[0], yt = ((at = tt.point.custom) == null ? void 0 : at[ut]) || "";
    if (isNaN(parseFloat(yt)))
      return yt;
    const gt = li(ht == null ? void 0 : ht.numberFormatConfig);
    return Hi(gt, parseFloat(yt));
  }, B.style = oe(Ut({}, B.style), {
    fontWeight: "",
    textOutline: ""
  }), B;
}, S2 = (t, r) => ({
  minSize: r ? t.scatterBubbleMinSize : t.scatterDefaultSize,
  maxSize: r ? t.scatterBubbleMaxSize : t.scatterDefaultSize
}), w2 = (t, r) => {
  var B;
  const f = !!r.size;
  return {
    bubble: Ut({
      animation: !1
    }, S2(
      (B = t.markerSize) != null ? B : gv,
      f
    )),
    series: {
      allowPointSelect: !1,
      boostThreshold: 0,
      dataLabels: x2(t.valueLabel, r),
      stickyTracking: !1,
      turboThreshold: 0
    }
  };
};
function C2(t, r, f, B) {
  if (!jr(t))
    return t;
  r = Nh(r, t);
  for (var H = -1, tt = r.length, st = tt - 1, lt = t; lt != null && ++H < tt; ) {
    var ht = Rl(r[H]), ut = f;
    if (ht === "__proto__" || ht === "constructor" || ht === "prototype")
      return t;
    if (H != st) {
      var yt = lt[ht];
      ut = void 0, ut === void 0 && (ut = jr(yt) ? yt : Fd(r[H + 1]) ? [] : {});
    }
    Jd(lt, ht, ut), lt = lt[ht];
  }
  return t;
}
function k2(t, r, f) {
  for (var B = -1, H = r.length, tt = {}; ++B < H; ) {
    var st = r[B], lt = Kd(t, st);
    f(lt, st) && C2(tt, Nh(st, t), lt);
  }
  return tt;
}
function T2(t, r) {
  return k2(t, r, function(f, B) {
    return hm(t, B);
  });
}
var M2 = lp(function(t, r) {
  return t == null ? {} : T2(t, r);
});
const A2 = Object.freeze({
  "area/basic": { lineType: "straight", stackType: "classic" },
  "area/stacked": { lineType: "straight", stackType: "stacked" },
  "area/stacked100": { lineType: "straight", stackType: "stack100" },
  "area/spline": { lineType: "smooth", stackType: "classic" },
  "area/stackedspline": { lineType: "smooth", stackType: "stacked" },
  "area/stackedspline100": { lineType: "smooth", stackType: "stack100" },
  "arearange/basic": { lineType: "straight", stackType: "classic" },
  "arearange/spline": { lineType: "smooth", stackType: "classic" },
  "bar/classic": { stackType: "classic" },
  "bar/stacked": { stackType: "stacked" },
  "bar/stacked100": { stackType: "stack100" },
  "column/classic": { stackType: "classic" },
  "column/stackedcolumn": { stackType: "stacked" },
  "column/stackedcolumn100": { stackType: "stack100" },
  "line/basic": { lineType: "straight" },
  "line/spline": { lineType: "smooth" },
  "pie/classic": { pieType: "classic" },
  "pie/donut": { pieType: "donut" },
  "pie/ring": { pieType: "ring" },
  "polar/column": { polarType: "column" },
  "polar/area": { polarType: "area" },
  "polar/line": { polarType: "line" },
  "indicator/numeric": { indicatorType: "numeric" },
  "indicator/gauge": { indicatorType: "gauge" },
  treemap: {},
  sunburst: {},
  "boxplot/full": { boxplotType: "full" },
  "boxplot/hollow": { boxplotType: "hollow" },
  scattermap: {},
  "areamap/world": { mapType: "world" },
  "areamap/usa": { mapType: "usa" }
});
function P2(t) {
  let r;
  switch (t.subtype) {
    case "indicator/numeric":
      r = Ut({
        indicatorType: "numeric",
        numericSubtype: t.numericSubtype
      }, t.numericSubtype === "numericSimple" ? { skin: t.skin } : null);
      break;
    case "indicator/gauge":
      r = Ut({
        indicatorType: "gauge",
        skin: t.skin
      }, t.tickerBarHeight ? { tickerBarHeight: t.tickerBarHeight } : null);
      break;
  }
  return oe(Ut(Ut({}, Ir), r), {
    indicatorComponents: t.indicatorComponents || Ir.indicatorComponents,
    forceTickerView: !!t.forceTickerView
  });
}
const E2 = (t) => oe(Ut({}, Ir), { mapType: t.mapType || "world" }), L2 = (t, r, f) => {
  const B = "y" in f && Array.isArray(f.y) ? f.y.some((lt) => lt.showOnRightAxis) : !1;
  let H;
  switch (t) {
    case "bar":
    case "column":
      H = mv(
        r,
        f,
        B,
        t
      );
      break;
    case "area":
      H = z2(
        r,
        f,
        B
      );
      break;
    case "arearange":
    case "line":
      H = N2(
        r,
        f,
        B
      );
      break;
    case "pie":
      H = H2(r);
      break;
    case "funnel":
      H = U2(r);
      break;
    case "treemap":
      H = G2(r);
      break;
    case "sunburst":
      H = X2(
        r
      );
      break;
    case "polar":
      H = V2(
        r,
        f
      );
      break;
    case "indicator":
      H = P2(
        r
      );
      break;
    case "scatter":
      H = Z2(r);
      break;
    case "boxplot":
      H = K2(r);
      break;
    case "areamap":
      H = E2(r);
      break;
    case "scattermap":
      H = J2(
        r
      );
      break;
    default:
      throw new Jn("errors.chartTypeNotSupported", { chartType: t });
  }
  const tt = "subtype" in r && r.subtype ? r.subtype : "line/basic", st = A2[tt];
  return Ut(Ut({}, H), st);
};
function NO(t, r, f) {
  const B = zl(
    f != null ? f : {},
    Wl()
  );
  return L2(
    t,
    B,
    r
  );
}
function zl(t, r) {
  return Or.withOptions(
    {
      mergeArrays: !1
    },
    r,
    t
  );
}
function Sp(t, r, f) {
  return O2(t, r).map(
    (H) => {
      const tt = H.seriesId, st = H.seriesStyleOptions, lt = B2(
        r,
        zl(st, f)
      );
      return {
        seriesId: tt,
        designOptions: M2(lt, ["lineWidth", "marker"])
      };
    }
  ).reduce(
    (H, { seriesId: tt, designOptions: st }) => oe(Ut({}, H), { [tt]: st }),
    {}
  );
}
function O2(t, r) {
  return Zm(r) ? D2(
    t
  ) : [];
}
function D2(t) {
  return t.y.filter(I2).map(({ column: { name: r }, seriesStyleOptions: f }) => ({
    seriesId: r,
    seriesStyleOptions: f
  }));
}
function I2(t) {
  return t.seriesStyleOptions !== void 0;
}
const Fl = (t) => t != null && t.enabled && t.position || null, Id = (t, r) => {
  var f, B, H, tt, st;
  return t ? {
    enabled: t.enabled,
    gridLine: t.gridLines,
    labels: (f = t.labels) == null ? void 0 : f.enabled,
    type: t.logarithmic ? "logarithmic" : "linear",
    titleEnabled: (B = t.title) == null ? void 0 : B.enabled,
    title: ((H = t == null ? void 0 : t.title) == null ? void 0 : H.text) || null,
    min: (tt = t.min) != null ? tt : null,
    max: (st = t.max) != null ? st : null,
    tickInterval: t.isIntervalEnabled && (t != null && t.intervalJumps) ? t == null ? void 0 : t.intervalJumps : null
  } : r;
}, R2 = (t) => ({
  enabled: (t == null ? void 0 : t.enabled) || !1,
  scrollerLocation: t == null ? void 0 : t.scrollerLocation
}), j2 = (t) => {
  const r = Id(t, Ir.yAxis);
  return r.gridLine = t.templateMainYHasGridLines || !1, r;
}, wp = (t) => {
  let r = 1;
  switch (t.width) {
    case "thin":
      r = 1;
      break;
    case "bold":
      r = 3;
      break;
    case "thick":
      r = 5;
      break;
  }
  return r;
}, _2 = "classic", ua = (t, r) => {
  var ut, yt, gt, _;
  const f = Fl(t.legend), B = Jh(t, "cartesian"), H = Id(t.xAxis, Ir.xAxis);
  let tt = null;
  (yt = (ut = t == null ? void 0 : t.xAxis) == null ? void 0 : ut.x2Title) != null && yt.enabled && ((_ = (gt = t == null ? void 0 : t.xAxis) == null ? void 0 : gt.x2Title) != null && _.text) && (tt = oe(Ut({}, Ir.xAxis), {
    title: t.xAxis.x2Title.text
  }));
  const st = Id(t.yAxis, Ir.yAxis);
  let lt = {
    type: "linear",
    enabled: !0,
    titleEnabled: !0,
    title: "Y2 Axis title",
    gridLine: !0,
    labels: !0,
    min: null,
    max: null,
    tickInterval: null
  };
  t.y2Axis && (lt = Ut(Ut({}, lt), j2(t.y2Axis)));
  const ht = R2(t.navigator);
  return oe(Ut(Ut(oe(Ut({}, Ir), {
    legend: f,
    autoZoom: ht,
    valueLabel: t.seriesLabels || {},
    xAxis: H,
    yAxis: st
  }), r && lt && { y2Axis: lt }), tt && { x2Axis: tt }), {
    dataLimits: B
  });
}, qh = (t) => ({
  enabled: t.enabled,
  fill: t.fill === "filled" ? "full" : "hollow",
  size: t.size === "small" ? "small" : "large"
}), mv = (t, r, f, B) => {
  const H = ua(t, f), tt = zl(
    t != null ? t : {},
    Wl()
  ), st = Sp(
    r,
    B,
    tt
  );
  return oe(Ut({}, H), {
    designPerSeries: st,
    stackType: _2
  });
}, B2 = (t, r) => {
  var B;
  const f = ua(
    r,
    !1
  );
  if (t === "line") {
    const H = r;
    f.lineWidth = wp(H.lineWidth || { width: "bold" }), f.marker = qh(
      (B = H == null ? void 0 : H.markers) != null ? B : { enabled: !0, fill: "filled", size: "small" }
    );
  }
  return f;
}, N2 = (t, r, f) => {
  var st;
  const B = ua(t, f);
  B.lineWidth = wp(t.lineWidth || { width: "bold" }), B.marker = qh(
    (st = t == null ? void 0 : t.markers) != null ? st : { enabled: !0, fill: "filled", size: "small" }
  );
  const H = zl(
    t != null ? t : {},
    Wl()
  ), tt = Sp(r, "line", H);
  return oe(Ut({}, B), {
    designPerSeries: tt
  });
}, z2 = (t, r, f) => {
  var B;
  return oe(Ut({}, mv(t, r, f, "area")), {
    lineWidth: wp(t.lineWidth || { width: "thin" }),
    marker: qh((B = t == null ? void 0 : t.markers) != null ? B : { enabled: !0, fill: "filled", size: "small" })
  });
}, Jh = (t, r) => {
  var H;
  const f = {
    seriesCapacity: r === "categorical" ? Dd : r === "pie" ? v2 : fv,
    categoriesCapacity: r === "scatter" ? b2 : Dd
  }, B = (H = t == null ? void 0 : t.dataLimits) != null ? H : {};
  return "categoriesCapacity" in B && (B == null ? void 0 : B.categoriesCapacity) !== void 0 && (f.categoriesCapacity = B == null ? void 0 : B.categoriesCapacity), (B == null ? void 0 : B.seriesCapacity) !== void 0 && (f.seriesCapacity = B == null ? void 0 : B.seriesCapacity), f;
}, F2 = {
  enabled: !0,
  showCategories: !0,
  showValue: !0,
  showPercent: !0,
  showDecimals: !1
}, W2 = "classic", H2 = (t) => {
  var lt, ht, ut, yt, gt;
  const { legend: r, labels: f } = t;
  let B = F2;
  f && (B = oe(Ut({}, B), {
    showCategories: (lt = f.categories) != null ? lt : !1,
    showDecimals: (ht = f.decimals) != null ? ht : !1,
    enabled: (ut = f.enabled) != null ? ut : !1,
    showPercent: (yt = f.percent) != null ? yt : !1,
    showValue: (gt = f.value) != null ? gt : !1
  }));
  const H = W2, tt = t != null && t.convolution ? t.convolution : { enabled: !1 }, st = Jh(t, "pie");
  return oe(Ut({}, Ir), {
    pieLabels: B,
    pieType: H,
    convolution: tt,
    legend: Fl(r),
    dataLimits: st
  });
}, U2 = (t) => {
  var ht, ut, yt, gt, _;
  const {
    funnelType: r = bp,
    funnelSize: f = vp,
    funnelDirection: B = xp,
    legend: H,
    labels: tt
  } = t;
  let st = yp;
  tt && (st = oe(Ut({}, st), {
    showCategories: (ht = tt.categories) != null ? ht : !1,
    showDecimals: (ut = tt.decimals) != null ? ut : !1,
    enabled: (yt = tt.enabled) != null ? yt : !1,
    showPercent: (gt = tt.percent) != null ? gt : !1,
    showValue: (_ = tt.value) != null ? _ : !1
  }));
  const lt = Jh(t, "categorical");
  return oe(Ut({}, Ir), {
    funnelSize: f,
    funnelType: r,
    funnelDirection: B,
    funnelLabels: st,
    legend: Fl(H),
    dataLimits: lt
  });
}, G2 = (t) => t, X2 = (t) => t, Y2 = "column", V2 = (t, r) => {
  const f = ua(t, !1), B = zl(
    t != null ? t : {},
    Wl()
  ), H = Sp(r, "polar", B);
  return oe(Ut({}, f), {
    polarType: Y2,
    designPerSeries: H
  });
}, $2 = (t) => Ut(Ut({}, gv), t), Z2 = (t) => {
  var r;
  return oe(Ut({}, ua(t, !1)), {
    lineWidth: 0,
    marker: qh((r = t == null ? void 0 : t.markers) != null ? r : { enabled: !0, fill: "filled", size: "small" }),
    dataLimits: Jh(t, "scatter"),
    markerSize: $2(t.markerSize),
    legend: Fl(t.legend)
  });
}, K2 = (t) => oe(Ut({}, ua(t, !1)), {
  boxplotType: t.subtype === "boxplot/hollow" ? "hollow" : "full"
}), q2 = {
  fill: "filled",
  size: {
    defaultSize: 4,
    minSize: 4,
    maxSize: 24
  }
}, J2 = (t) => oe(Ut({}, Ir), {
  markers: Or(
    q2,
    t.markers || {}
  )
}), Q2 = {
  type: "sunburst",
  borderWidth: 0,
  dataLabels: {
    style: {
      textOutline: "none"
    }
  }
}, tL = {
  title: { text: null },
  chart: {
    type: "sunburst",
    spacing: [20, 20, 20, 20],
    alignTicks: !1,
    polar: !1,
    animation: {
      duration: 300
    }
  },
  series: [],
  plotOptions: {
    series: {},
    sunburst: {
      events: {
        legendItemClick: function(t) {
          t.preventDefault();
        }
      }
    }
  }
};
function eL(t, r, f, B) {
  return oe(Ut({}, tL), {
    series: [
      oe(Ut({}, Q2), {
        name: "Root",
        data: f2(t, r, B),
        levels: p2(t, r, f, B),
        showInLegend: !1,
        turboThreshold: 2e3
      }),
      ...r.breakBy.map((H, tt) => {
        var st;
        return {
          name: Li(H),
          showInLegend: !0,
          color: ((st = H == null ? void 0 : H.color) == null ? void 0 : st.color) || en(B == null ? void 0 : B.palette.variantColors, tt),
          data: [],
          states: {
            hover: {
              enabled: !1
            }
          }
        };
      })
    ],
    tooltip: hv(r, f, {
      displayTotalContribution: !0,
      displayColorCircles: !0,
      shouldSkip: (H) => H.point.options.id === Od
    }),
    legend: Wo(Fl(f.legend))
  });
}
const iL = (t, r, f, B, H) => {
  var ht, ut;
  const tt = [], st = Zh(r, f), lt = 20;
  switch (r) {
    case "pie":
      const yt = f, {
        series: gt,
        convolutionSeries: _,
        alerts: at
      } = NE(
        t,
        B,
        yt,
        H
      );
      return tt.push(...at), { options: {
        title: { text: null },
        chart: {
          type: st,
          spacing: [lt, 20, 20, 20],
          alignTicks: !1,
          polar: !1
        },
        xAxis: [],
        yAxis: [],
        // The series level animation disables all animations, the chart
        // level animation only disables initial or subsequent paints
        legend: Wo(yt.legend),
        series: gt,
        plotOptions: kE(
          yt.pieType,
          yt.pieLabels,
          B,
          H
        ),
        tooltip: Ag((ht = yt.pieLabels) == null ? void 0 : ht.showDecimals, B),
        drilldown: {
          activeDataLabelStyle: {
            cursor: "pointer",
            fontWeight: "bold",
            textDecoration: "none"
          },
          series: _
        }
      }, alerts: tt };
    case "funnel":
      const F = f, { series: $, alerts: Y } = HE(
        t,
        B,
        F,
        H
      );
      return tt.push(...Y), { options: {
        title: { text: null },
        chart: {
          type: st,
          spacing: [30, 30, 30, 30],
          alignTicks: !1,
          polar: !1
        },
        xAxis: [],
        yAxis: [],
        // The series level animation disables all animations, the chart
        // level animation only disables initial or subsequent paints
        legend: Wo(F.legend),
        series: $,
        plotOptions: _E(F, B, H),
        tooltip: Ag((ut = F.funnelLabels) == null ? void 0 : ut.showDecimals, B)
      }, alerts: tt };
    case "treemap":
      return {
        options: u2(
          t,
          B,
          f,
          H
        ),
        alerts: tt
      };
    case "sunburst":
      return {
        options: eL(
          t,
          B,
          f,
          H
        ),
        alerts: tt
      };
    default:
      throw new Jn("errors.unexpectedChartType", { chartType: r });
  }
}, $r = "#d1d1d7";
function yv(t, r, f) {
  if (f && f.length && !f.includes(r))
    return "";
  const B = typeof r == "number" ? r : parseFloat(r);
  return isNaN(B) ? `${r}` : t && !vn(t) && !Fi(t.column.type) ? `${r}` : Hi(
    li(t == null ? void 0 : t.numberFormatConfig),
    B
  );
}
const rL = (t, r, f) => [{
  type: t.type,
  startOnTick: !1,
  endOnTick: !(t.max || r),
  labels: {
    overflow: "justify",
    enabled: t.enabled && t.labels,
    autoRotation: [-10, -20, -30, -40, -50, -60, -70, -80, -90],
    style: ki,
    formatter: function() {
      return yv(f == null ? void 0 : f.x, this.value, this.axis.categories);
    }
  },
  categories: r || void 0,
  gridLineWidth: t.enabled && t.gridLine ? 1 : 0,
  gridLineColor: $r,
  gridLineDashStyle: "Dot",
  title: {
    enabled: t.enabled && t.titleEnabled,
    margin: 25,
    text: t.title || null
  },
  lineColor: $r,
  lineWidth: 1,
  minorTickColor: $r,
  minorGridLineColor: $r,
  minorGridLineDashStyle: "Dot",
  minorTickLength: 0,
  tickLength: 0,
  tickColor: $r,
  tickmarkPlacement: "on",
  tickInterval: t.enabled ? t.tickInterval : null,
  min: t.enabled ? t.min : null,
  max: t.enabled ? t.max : null
}], nL = (t, r, f) => [{
  type: t.type,
  startOnTick: !1,
  endOnTick: !(t.max || r),
  title: {
    enabled: t.enabled && t.titleEnabled,
    text: t.title || null
  },
  labels: {
    enabled: t.labels,
    autoRotation: [-10, -20, -30, -40, -50, -60, -70, -80, -90],
    style: ki,
    formatter: function() {
      return yv(f == null ? void 0 : f.y, this.value, this.axis.categories);
    }
  },
  categories: r || void 0,
  gridLineColor: $r,
  gridLineDashStyle: "Dot",
  gridLineWidth: 1,
  lineColor: $r,
  lineWidth: 1,
  maxPadding: 0.025,
  minPadding: 0.025,
  minorGridLineColor: $r,
  minorGridLineDashStyle: "Dot",
  minorGridLineWidth: 0,
  minorTickColor: $r,
  minorTickWidth: 0,
  opposite: !1,
  tickColor: $r,
  tickWidth: 0,
  tickmarkPlacement: "on",
  tickInterval: t.enabled ? t.tickInterval : null,
  min: t.enabled ? t.min : null,
  max: t.enabled ? t.max : null
}], vv = "#00cee6", Rd = (t) => {
  const r = t.rawValue == null ? Number(t.displayValue) : Number(t.rawValue);
  return Number.isNaN(r) || r === void 0 ? null : r;
}, oL = (t) => t ? Rd(t) : 1, sL = (t, r) => {
  const { xAxis: f, yAxis: B, breakByPoint: H, breakByColor: tt, size: st } = t, { xCategoriesMap: lt, yCategoriesMap: ht } = r, ut = lt.get(f.displayValue), yt = ht.get(B.displayValue), gt = f.blur || B.blur || (H == null ? void 0 : H.blur);
  return {
    x: ut !== void 0 ? ut : Rd(f),
    y: yt !== void 0 ? yt : Rd(B),
    z: oL(st),
    maskedX: f.displayValue,
    maskedY: B.displayValue,
    maskedBreakByPoint: H == null ? void 0 : H.displayValue,
    maskedBreakByColor: tt == null ? void 0 : tt.displayValue,
    color: tt == null ? void 0 : tt.color,
    maskedSize: st == null ? void 0 : st.displayValue,
    selected: gt
  };
}, aL = (t, r, f) => {
  var st, lt;
  const B = /* @__PURE__ */ new Map();
  t.forEach((ht) => {
    var ut;
    if (ht.breakByColor) {
      const { displayValue: yt, color: gt } = ht.breakByColor;
      if (yt && !B.has(yt)) {
        const _ = gt || ((ut = r == null ? void 0 : r.seriesToColorMap) == null ? void 0 : ut[yt]);
        B.set(yt, _);
      }
    }
  });
  const H = /* @__PURE__ */ new Map(), tt = Fi((lt = (st = r == null ? void 0 : r.breakByColor) == null ? void 0 : st.column) == null ? void 0 : lt.type) ? "number" : "string";
  return Array.from(B).sort(([ht], [ut]) => Xm(ht, ut, Gm.ASC, tt)).forEach(([ht, ut], yt) => {
    H.set(ht, {
      // applies default color from themeSettings
      color: ut != null ? ut : en(f == null ? void 0 : f.palette.variantColors, yt),
      index: yt
    });
  }), H;
}, lL = (t, r, f) => {
  const B = {
    enabled: !0,
    fillOpacity: 0.7,
    lineWidth: 1,
    states: {
      select: {
        fillOpacity: 0.3,
        lineWidth: 1
      }
    }
  };
  return t.size ? Array.from(t).map(([H, { index: tt, color: st }]) => ({
    data: [],
    index: tt,
    marker: B,
    name: H,
    showInLegend: !0,
    type: "bubble",
    color: st
  })) : [
    {
      data: [],
      index: 0,
      marker: B,
      name: r,
      showInLegend: !!r,
      type: "bubble",
      color: oy(f) || vv
    }
  ];
}, cL = (t, r) => {
  const f = t.get(r);
  return f ? f.index : 0;
}, hL = (t, r) => {
  const f = jy({
    getValueFromDataStructure: (B) => {
      var H;
      return parseFloat(`${(H = B.custom) == null ? void 0 : H.maskedBreakByColor}`);
    },
    applyColorToDataStructure: (B, H) => oe(Ut({}, B), {
      color: H
    })
  });
  return t.map((B) => oe(Ut({}, B), {
    data: f(B.data, r)
  }));
}, uL = (t) => {
  if (t && vn(t) && t.color)
    return t.color;
}, dL = (t, r, f, B) => {
  for (const H of r) {
    const {
      x: tt,
      y: st,
      z: lt,
      maskedX: ht,
      maskedY: ut,
      maskedBreakByPoint: yt,
      maskedSize: gt,
      color: _,
      maskedBreakByColor: at,
      selected: G
    } = sL(H, f);
    if (tt !== null && st !== null) {
      const F = t[cL(B, at)], $ = {
        color: _ || F.color || vv,
        x: tt,
        y: st,
        z: lt,
        custom: {
          maskedX: ht,
          maskedY: ut,
          maskedBreakByPoint: yt,
          maskedBreakByColor: at,
          maskedSize: gt
        },
        selected: G
      };
      F.data.push($);
    }
  }
  return t;
}, pL = (t) => {
  const r = t == null ? void 0 : t.breakByColor, f = t == null ? void 0 : t.breakByPoint;
  return r && Li(r) || f && Li(f) || "";
}, fL = (t, r, f, B) => {
  const H = f == null ? void 0 : f.breakByColor, tt = pL(f), st = uL(H), lt = H && !vn(H) ? aL(t, f, B) : /* @__PURE__ */ new Map();
  let ht = lL(lt, tt, st);
  return ht = dL(ht, t, r, lt), st && (ht = hL(ht, st)), ht;
}, gL = (t, r) => r ? t.slice(0, r) : t, mL = (t, r, f, B, H) => {
  const tt = [], st = fL(t, r, f, B);
  return H && st.length > H ? (tt.push(aa(st.length, H)), {
    series: gL(st, H),
    alerts: tt
  }) : { series: st, alerts: tt };
}, Jc = 20, yL = 30, vL = (t) => oe(Ut({}, Wo(t)), {
  symbolHeight: 12,
  symbolWidth: 12,
  itemMarginBottom: 0,
  itemMarginTop: 0
}), bL = (t, r, f, B, H) => {
  const tt = [], st = Zh(r, f), lt = B, { scatterDataTable: ht } = t, { seriesCapacity: ut, categoriesCapacity: yt } = f.dataLimits;
  let { xCategories: gt, yCategories: _ } = t;
  gt && gt.length > yt && (tt.push(Ad("x", gt.length, yt)), gt = gt.slice(0, yt)), _ && _.length > yt && (tt.push(Ad("y", _.length, yt)), _ = _.slice(0, yt));
  const { series: at, alerts: G } = mL(
    ht,
    KA(gt, _),
    lt,
    H,
    ut
  );
  return tt.unshift(...G), { options: {
    title: { text: null },
    subtitle: { text: null },
    chart: {
      type: st,
      spacing: [Jc, Jc, Jc, Jc],
      marginTop: yL,
      alignTicks: !1,
      polar: !1
    },
    xAxis: rL(
      f.xAxis,
      gt == null ? void 0 : gt.slice(0, yt),
      lt
    ),
    yAxis: nL(
      f.yAxis,
      _ == null ? void 0 : _.slice(0, yt),
      lt
    ),
    legend: vL(f.legend),
    series: at,
    plotOptions: w2(f, lt),
    tooltip: KP(lt)
  }, alerts: tt };
}, xL = (t, r, f) => {
  const B = [], [H, tt] = t.series, { boxplotType: st } = r, lt = 0.15, ht = en(f, 0), ut = ht, yt = Ah(ht, -1 * lt), gt = Ah(ht, -2 * lt), _ = EA(gt, 2 * lt), at = [
    oe(Ut({}, H), {
      data: H.data.map((G, F) => {
        var $;
        return oe(Ut({}, G), {
          color: gt,
          fillColor: st === "hollow" ? "transparent" : ut,
          innerBoxColor: st === "hollow" ? "transparent" : yt,
          selected: ($ = G.blur) != null ? $ : !1,
          custom: {
            xValue: t.xValues[F].rawValues
          }
        });
      }),
      medianWidth: 1,
      maxPointWidth: 42,
      minPointWidth: 20,
      whiskerWidth: 1,
      whiskerLength: "100%",
      fillOpacity: 0.8,
      strokeOpacity: 0.8,
      showInLegend: !0,
      legendIndex: 0,
      yAxis: 0,
      color: gt
    })
  ];
  return tt && at.push(oe(Ut({}, tt), {
    data: tt.data.map((G) => oe(Ut({}, G), {
      marker: {
        lineColor: G.blur ? _ : gt
      },
      custom: {
        xValue: t.xValues[G.x].rawValues
      }
    })),
    type: "scatter",
    legendIndex: 1,
    showInLegend: !1,
    marker: {
      enabled: !0,
      fillColor: "transparent",
      lineWidth: 1,
      lineColor: gt
    },
    color: gt
  })), { series: at, alerts: B };
}, Zr = "#d1d1d7", SL = (t) => t.series[0].data.reduce(
  (r, { low: f, high: B }) => ({
    min: Math.min(r.min, f),
    max: Math.max(r.max, B)
  }),
  { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY }
), wL = (t, r, f) => [
  {
    labels: {
      overflow: "none",
      enabled: t.enabled && t.labels,
      autoRotation: [-10, -20, -30, -40, -50, -60, -70, -80, -90],
      style: ki,
      formatter() {
        const { value: B } = this;
        if (f && !vn(f) && !Fi(f.column.type))
          return `${B}`;
        const H = typeof B == "number" ? B : parseFloat(B);
        return isNaN(H) ? `${B}` : Hi(
          li(f == null ? void 0 : f.numberFormatConfig),
          H
        );
      }
    },
    categories: r,
    title: {
      text: t.enabled && t.titleEnabled && t.title || null,
      margin: 25
    },
    tickmarkPlacement: "on",
    gridLineWidth: t.enabled && t.gridLine ? 1 : 0,
    minorTickLength: 0,
    tickLength: 0,
    startOnTick: !0,
    endOnTick: !0,
    lineColor: Zr,
    tickColor: Zr,
    minorTickColor: Zr,
    gridLineColor: Zr,
    gridLineDashStyle: "Dot",
    minorGridLineColor: Zr,
    minorGridLineDashStyle: "Dot",
    min: t.enabled ? t.min : null,
    max: t.enabled ? t.max : null
  }
], CL = (t, r, f) => {
  const B = SL(r);
  return [
    {
      labels: {
        enabled: t.enabled && t.labels,
        autoRotation: [-10, -20, -30, -40, -50, -60, -70, -80, -90],
        style: ki,
        formatter() {
          return Hi(
            li(f == null ? void 0 : f.numberFormatConfig),
            this.value
          );
        }
      },
      tickmarkPlacement: "on",
      title: {
        text: t.enabled && t.titleEnabled && t.title || null,
        margin: 25,
        style: ki
      },
      minorGridLineWidth: 0,
      lineColor: Zr,
      lineWidth: 1,
      tickColor: Zr,
      minorTickColor: Zr,
      gridLineColor: Zr,
      gridLineDashStyle: "Dot",
      gridLineWidth: t.enabled && t.gridLine ? 1 : 0,
      minorGridLineColor: Zr,
      minorGridLineDashStyle: "Dot",
      min: t.enabled && yg(t.min) ? t.min : B.min,
      max: t.enabled && yg(t.max) ? t.max : B.max,
      tickInterval: t.enabled ? t.tickInterval : null
    }
  ];
}, Rg = (t) => function(r, f) {
  const B = f ? this.point[f] : void 0;
  return B === void 0 || isNaN(B) ? "" : Hi(li(t), B);
}, kL = (t) => {
  var r, f, B, H;
  return {
    series: {
      dataLabels: {
        enabled: (r = t.enabled) != null ? r : !1,
        style: {
          fontFamily: "Open Sans",
          fontSize: "13px",
          fontWeight: "normal",
          color: "#001b4f"
        },
        rotation: (f = t.rotation) != null ? f : 0,
        align: "center",
        formatter: Rg()
      },
      grouping: !1,
      stickyTracking: !1,
      turboThreshold: 0,
      boostThreshold: 0,
      softThreshold: !1
    },
    boxplot: {
      dataLabels: {
        enabled: (B = t.enabled) != null ? B : !1,
        style: {
          fontFamily: "Open Sans",
          fontSize: "13px",
          fontWeight: "normal",
          color: "#001b4f"
        },
        rotation: (H = t.rotation) != null ? H : 0,
        align: "center",
        formatter: Rg()
      }
    },
    scatter: {
      dataLabels: {
        enabled: !1
      }
    }
  };
};
function TL(t) {
  return t === void 0;
}
const ML = (t, r) => ({
  animation: !1,
  backgroundColor: eo,
  borderColor: to,
  borderRadius: 10,
  borderWidth: 1,
  useHTML: !0,
  // eslint-disable-next-line max-lines-per-function
  formatter() {
    const { x: f, y: B } = this, {
      high: H,
      low: tt,
      q3: st,
      q1: lt,
      median: ht
    } = this.point, ut = TL(H), yt = Dl(t.category, f, `${f}`);
    if (ut) {
      const $ = vi(t.outliers, B, `${B}`);
      return oa(`
          <div>${this.series.name}</div>
          <div>${Ei($, this.point.color)}</div>
          ${t.category ? `${qn()}<div>${yt}</div>` : ""}
        `);
    }
    const gt = vi(
      t.whiskerMax,
      H,
      `${H}`
    ), _ = vi(
      t.whiskerMin,
      tt,
      `${tt}`
    ), at = vi(t.boxMax, st, `${st}`), G = vi(t.boxMin, lt, `${lt}`), F = vi(
      t.boxMedian,
      ht,
      `${ht}`
    );
    return oa(`
        <div>${r("boxplot.tooltip.whiskers")}</div>
        <div class="csdk-boxplot-tooltip-row">
          <span>${r("boxplot.tooltip.max")}</span>
          ${Ei(gt, this.point.color)}
        </div>
        <div class="csdk-boxplot-tooltip-row">
          <span>${r("boxplot.tooltip.min")}</span>
          ${Ei(_, this.point.color)}
        </div>
        ${qn()}
        <div>${r("boxplot.tooltip.box")}</div>
        <div class="csdk-boxplot-tooltip-row">
          <span>${r("boxplot.tooltip.max")}</span>
          ${Ei(at, this.point.color)}
        </div>
        <div class="csdk-boxplot-tooltip-row">
          <span>${r("boxplot.tooltip.min")}</span>
          ${Ei(G, this.point.color)}
        </div>
        <div class="csdk-boxplot-tooltip-row">
          <span>${r("boxplot.tooltip.median")}</span>
          ${Ei(F, this.point.color)}
        </div>
        ${qn()}
        <div>${t.category ? yt : this.series.name}</div>
      `);
  }
}), AL = (t, r, f, B, H) => {
  const tt = Zh("boxplot", r), { series: st, alerts: lt } = xL(
    t,
    r,
    H == null ? void 0 : H.palette.variantColors
  ), ht = t.xValues.map((yt) => yt.key);
  return { options: {
    title: { text: null },
    chart: {
      type: tt,
      spacing: [25, 20, 20, 20],
      polar: !1,
      zooming: {
        type: "x"
      },
      events: {
        load: function() {
          const yt = this;
          if (r.autoZoom && r.autoZoom.scrollerLocation) {
            const { min: at, max: G } = r.autoZoom.scrollerLocation;
            iv(yt, at, G);
          }
          const gt = yt.chartWidth, _ = ev(
            tt,
            r.autoZoom.enabled,
            t.xValues.length,
            gt
          );
          yt.update({ navigator: _ }, !0);
        },
        // disables default zooming
        selection: (yt) => {
          yt.preventDefault();
        }
      }
    },
    legend: Wo(r.legend),
    xAxis: wL(r.xAxis, ht, f.category),
    // Note: as we have multiple data options that describe the yAxis,
    // we are just using one of them to get formatting configuration
    yAxis: CL(r.yAxis, t, f.whiskerMax),
    series: st,
    plotOptions: kL(r.valueLabel),
    tooltip: ML(f, B)
  }, alerts: lt };
}, PL = (t, r, f) => ({
  animation: !1,
  crosshairs: !0,
  backgroundColor: eo,
  borderColor: to,
  borderRadius: 10,
  borderWidth: 1,
  useHTML: !0,
  formatter: function() {
    var Q, q, U, N;
    const B = this;
    if (!B.point.low || !B.point.high)
      return tv(B, t, r, f);
    let H;
    B.percentage && (H = `${Math.round(B.percentage)}`);
    const tt = r, st = (Q = tt.rangeValues) == null ? void 0 : Q.find(
      tt.breakBy.length > 0 ? (D) => D[0].enabled : (D) => Li(D[0]) === B.series.name
    ), [lt, ht] = st != null ? st : [void 0, void 0], ut = $y(lt), yt = vi(lt, B.point.high, ""), gt = vi(ht, B.point.low, ""), _ = (N = (U = (q = B.point) == null ? void 0 : q.custom) == null ? void 0 : U.xDisplayValue) != null ? N : B.x, at = tt.x ? Dl(tt.x[0], B.x, _) : _, G = yt + (ut && H ? ` / ${H}%` : ""), F = gt + (ut && H ? ` / ${H}%` : ""), $ = B.point.color || B.series.color, { upperPointName: Y, lowerPointName: J } = B.point;
    return oa(`
      <div>${B.series.name}</div>
      <div class="csdk-range-tooltip-row">
        <span>${Y || f("arearange.tooltip.max")}</span>
        ${Ei(G, $)}
      </div>
      <div class="csdk-range-tooltip-row">
        <span>${J || f("arearange.tooltip.min")}</span>
        ${Ei(F, $)}
      </div>
      ${qn()}
      <div>${at || ""}</div>
    `);
  }
}), jg = (t, r, f, B, H, tt, st) => {
  var D, k;
  const lt = [], ht = [];
  B.seriesValues.forEach((A) => {
    ht.push(A), lt.push(A);
  }), B.rangeValues.forEach(([A, b]) => {
    ht.push(b), lt.push(A);
  });
  const gt = oe(Ut({}, B), {
    y: ht,
    seriesToColorMap: B.seriesToColorMap
  }), _ = Pd(
    oe(Ut({}, t), {
      type: "cartesian"
    }),
    r,
    f,
    gt,
    H,
    tt,
    st
  ), at = {};
  _.options.series.forEach((A) => {
    at[A.name] = A;
  });
  const G = oe(Ut({}, B), {
    y: lt,
    seriesToColorMap: B.seriesToColorMap
  }), F = Pd(
    oe(Ut({}, t.seriesOther), {
      type: "cartesian"
    }),
    r,
    f,
    G,
    H,
    tt,
    st
  ), $ = {};
  F.options.series.forEach((A) => {
    $[A.name] = A;
  });
  let Y = 1 / 0, J = -1 / 0, Q = -1, q = 0;
  if (_.options.series.forEach((A, b) => {
    if (B.breakBy.length === 0 && b < B.seriesValues.length)
      Qs(A.name) && (Q = kP(A, $, at)), A.zIndex = 1, A.data.forEach((d) => {
        d.y && d.y < Y && (Y = d.y), d.y && d.y > J && (J = d.y);
      });
    else {
      const d = $[A.name].data;
      A.yAxis = 0;
      let m = 0;
      B.breakBy.length === 0 && (m = b - B.seriesValues.length);
      const v = B.rangeValues[m], g = v[0].column.name.indexOf("_") + 1, x = v[1].column.name.substring(g), E = v[0].column.name.substring(g);
      A.type = "arearange", Qs(A.name) && TP(A, $), q = Math.max(A.data.length, q), A.data = A.data.map((P, S) => {
        const u = oe(Ut({}, P), {
          low: d[S].y,
          high: P.y,
          y: void 0,
          upperPointName: x,
          lowerPointName: E
        });
        return u.low && u.low < Y && (Y = u.low), u.high && u.high > J && (J = u.high), u;
      }), Qs(A.name) && MP(A, $);
    }
  }), _.options.xAxis || (_.options.xAxis = []), Q > 0 && AP(_.options.xAxis, Q, q), r === "arearange" && f.lineType === "smooth") {
    const A = "areasplinerange";
    _.options.chart.type = A, (D = _.options.navigator) != null && D.series && (_.options.navigator.series.type = A);
  }
  r === "arearange" && (_.options.tooltip = PL(!1, B, H));
  const [U] = (k = _.options.yAxis) != null ? k : [], N = oe(Ut({}, U), {
    min: Y,
    max: J
  });
  return _.options.yAxis = [N], _;
}, zO = (t, r, f, B, H, tt, st) => {
  switch (t.type) {
    case "range":
      return jg(
        t,
        r,
        f,
        B,
        H,
        tt,
        st
      );
    case "cartesian": {
      const lt = B, ht = LP(lt) ? jg(
        oe(Ut({}, t), { type: "range" }),
        r,
        f,
        Yy(lt),
        H,
        tt,
        st
      ) : Pd(
        t,
        r,
        f,
        lt,
        H,
        tt,
        st
      );
      return EP(ht.options.series), ht;
    }
    case "categorical":
      return iL(
        t,
        r,
        f,
        B,
        tt
      );
    case "scatter":
      return bL(
        t,
        r,
        f,
        B,
        tt
      );
    case "boxplot":
      return AL(
        t,
        f,
        B,
        H,
        tt
      );
    default:
      throw new Jn("errors.unexpectedChartType", { chartType: t.type });
  }
}, EL = {
  legend: {
    enabled: !0,
    position: "bottom"
  },
  navigator: {
    enabled: !0
  },
  markers: { enabled: !1, fill: "filled", size: "small" },
  seriesLabels: { enabled: !1, rotation: 0 },
  xAxis: {
    enabled: !0,
    gridLines: !1,
    isIntervalEnabled: !1,
    labels: {
      enabled: !0
    },
    logarithmic: !1,
    title: {
      enabled: !1,
      text: "X Axis title"
    }
  },
  yAxis: {
    enabled: !0,
    gridLines: !0,
    isIntervalEnabled: !1,
    labels: {
      enabled: !0
    },
    logarithmic: !1,
    title: {
      enabled: !1,
      text: "Y Axis title"
    }
  },
  y2Axis: {
    enabled: !0,
    gridLines: !0,
    isIntervalEnabled: !1,
    labels: {
      enabled: !0
    },
    logarithmic: !1,
    title: {
      enabled: !1,
      text: "Y2 Axis title"
    }
  },
  convolution: {
    enabled: !1,
    selectedConvolutionType: "byPercentage",
    minimalIndependentSlicePercentage: 3,
    independentSlicesCount: 7
  },
  labels: {
    categories: !0,
    enabled: !0,
    percent: !0,
    decimals: !1,
    value: !1
  }
}, Wl = () => Fh(EL);
class LL extends Ih {
  constructor(f, B) {
    var H;
    super((H = f.jaql.title) != null ? H : "", B);
    ui(this, "metadataItem");
    ui(this, "expression");
    ui(this, "skipValidation");
    // aggregation or formula is needed to differentiate between internal Category and Value
    // see isCategory() and isValue()
    // TODO refactor to create Attribute or Measure from MetadataItem
    ui(this, "aggregation");
    ui(this, "formula");
    ui(this, "sortType");
    this.expression = f.jaql.dim || f.jaql.formula, this.metadataItem = f, f.jaql.agg ? this.aggregation = f.jaql.agg : delete this.aggregation, f.jaql.formula ? this.formula = f.jaql.formula : delete this.formula, f.jaql.sort ? this.sortType = UP(f.jaql.sort) : delete this.sortType, this.skipValidation = !0;
  }
  get id() {
    return this.expression;
  }
  jaql() {
    return this.metadataItem;
  }
}
const OL = {
  text: De.TextAttribute,
  numeric: De.NumericAttribute,
  datetime: De.DateLevel
};
function bv(t) {
  var r;
  return new LL(t, (r = OL[t.jaql.datatype]) != null ? r : "numeric");
}
const FO = (t) => "chartType" in t.chartRecommendations ? t.chartRecommendations : {
  chartType: "table",
  chartFamily: "table",
  axesMapping: {}
}, DL = (t) => ({
  dataOptions: { columns: t.map(bv) }
}), IL = Object.freeze({
  convolution: {
    enabled: !0,
    selectedConvolutionType: "bySlicesCount",
    independentSlicesCount: 7
  },
  lineWidth: { width: "bold" },
  markers: {
    enabled: !1
  },
  legend: {
    enabled: !1
  },
  yAxis: {
    gridLines: !1
  },
  xAxis: {
    gridLines: !1
  }
}), RL = Object.freeze({
  line: "line/spline",
  pie: "pie/donut",
  bar: "bar/stacked",
  column: "column/stackedcolumn"
}), jL = (t, r) => {
  const { axesMapping: f, chartFamily: B } = r, H = t.reduce((st, lt) => (st[lt.jaql.title] = lt, st), {}), tt = Object.entries(f).reduce((st, lt) => {
    const [ht, ut] = lt;
    return st[`${ht}`] = Array.isArray(ut) ? ut.map((yt) => {
      var at, G;
      const gt = H[yt.name];
      if (!gt)
        return { column: { type: "", name: yt.name } };
      const _ = bv(gt);
      if (gt.panel === "measures")
        return {
          column: _,
          sortType: "sortNone"
        };
      if (pn(_.type)) {
        const F = (G = (at = gt.format) == null ? void 0 : at.mask) == null ? void 0 : G[gt.jaql.level];
        if (F)
          return {
            column: _,
            dateFormat: F
          };
      }
      return _;
    }) : ut, st;
  }, {});
  switch (B) {
    case "cartesian":
      return Ut({
        category: [],
        value: [],
        breakBy: []
      }, tt);
    case "categorical":
      return Ut({
        category: [],
        value: []
      }, tt);
    case "scatter":
      return Object.keys(tt).forEach((st) => {
        tt[`${st}`] = tt[`${st}`][0];
      }), tt;
    case "scattermap":
      return Object.keys(tt).forEach((st) => {
        st !== "geo" && (tt[`${st}`] = tt[`${st}`][0]);
      }), tt;
    case "table":
      return Object.keys(tt).length === 0 ? DL(t).dataOptions : tt;
    case "boxplot":
    case "areamap":
    case "indicator":
    default:
      return tt;
  }
}, _g = (t, r) => {
  var f, B, H, tt;
  return r === "x" ? (B = (f = t.axesMapping.category) != null ? f : t.axesMapping.x) == null ? void 0 : B.map((st) => st.name).join(", ") : (tt = (H = t.axesMapping.value) != null ? H : t.axesMapping.y) == null ? void 0 : tt.map((st) => st.name).join(", ");
}, WO = (t, r, f = !0) => {
  const B = jL(t, r);
  let H, tt;
  return f ? (H = Or(IL, {
    subtype: RL[r.chartType]
  }), tt = Or(H, {
    legend: {
      enabled: !0,
      position: "right"
    },
    yAxis: {
      title: {
        enabled: !0,
        text: _g(r, "y")
      }
    },
    xAxis: {
      title: {
        enabled: !0,
        text: _g(r, "x")
      }
    }
  })) : (H = Wl(), tt = H), {
    dataOptions: B,
    chartStyleOptions: H,
    expandedChartStyleOptions: tt
  };
}, HO = (t) => Zm(t) ? "cartesian" : dT(t) ? "categorical" : pT(t) ? "scatter" : fT(t) ? "scattermap" : gT(t) ? "indicator" : yT(t) ? "areamap" : mT(t) ? "boxplot" : "table";
export {
  FP as $,
  Wg as A,
  HP as B,
  me as C,
  Rr as D,
  de as E,
  ek as F,
  BP as G,
  MO as H,
  NP as I,
  AO as J,
  TO as K,
  CO as L,
  De as M,
  Zm as N,
  zA as O,
  FA as P,
  cO as Q,
  gT as R,
  tO as S,
  Jn as T,
  PO as U,
  wO as V,
  HL as W,
  iO as X,
  rO as Y,
  Xg as Z,
  WP as _,
  jC as a,
  LO as a$,
  zP as a0,
  gp as a1,
  yg as a2,
  uO as a3,
  Ud as a4,
  Nd as a5,
  zh as a6,
  Qd as a7,
  fh as a8,
  tm as a9,
  Uw as aA,
  Gw as aB,
  hd as aC,
  Rw as aD,
  iC as aE,
  rC as aF,
  Nw as aG,
  jw as aH,
  Fw as aI,
  Bw as aJ,
  zw as aK,
  _w as aL,
  qL as aM,
  Wi as aN,
  Cm as aO,
  mn as aP,
  GL as aQ,
  $L as aR,
  VL as aS,
  ZL as aT,
  YL as aU,
  UL as aV,
  Fh as aW,
  XL as aX,
  Ow as aY,
  kd as aZ,
  qu as a_,
  nr as aa,
  fm as ab,
  U1 as ac,
  eS as ad,
  zd as ae,
  jr as af,
  Bd as ag,
  wS as ah,
  Z0 as ai,
  qr as aj,
  OP as ak,
  Tw as al,
  Fi as am,
  EA as an,
  Vw as ao,
  oO as ap,
  sO as aq,
  KL as ar,
  Ml as as,
  $w as at,
  Zw as au,
  Hw as av,
  ci as aw,
  Ww as ax,
  Xw as ay,
  Yw as az,
  FC as b,
  kx as b$,
  DO as b0,
  OO as b1,
  IO as b2,
  EO as b3,
  IP as b4,
  jO as b5,
  _O as b6,
  BO as b7,
  vn as b8,
  li as b9,
  kT as bA,
  ny as bB,
  en as bC,
  qs as bD,
  Ah as bE,
  gd as bF,
  TA as bG,
  jy as bH,
  ld as bI,
  Mk as bJ,
  cm as bK,
  Rh as bL,
  ta as bM,
  Uy as bN,
  _y as bO,
  bh as bP,
  LP as bQ,
  xO as bR,
  dT as bS,
  pT as bT,
  yO as bU,
  fT as bV,
  mT as bW,
  yT as bX,
  hO as bY,
  CP as bZ,
  ad as b_,
  eO as ba,
  bv as bb,
  DL as bc,
  WO as bd,
  FO as be,
  Ne as bf,
  HO as bg,
  LL as bh,
  h0 as bi,
  nO as bj,
  ak as bk,
  sk as bl,
  rm as bm,
  Fd as bn,
  Dk as bo,
  Jr as bp,
  Uo as bq,
  m0 as br,
  eT as bs,
  hg as bt,
  Bo as bu,
  CT as bv,
  WA as bw,
  HA as bx,
  Vm as by,
  Jm as bz,
  Nc as c,
  Hk as c0,
  gh as c1,
  xx as c2,
  Rk as c3,
  Qm as c4,
  ST as c5,
  xT as c6,
  _A as c7,
  Yd as c8,
  zm as c9,
  aO as cA,
  vO as cB,
  bO as cC,
  y1 as cD,
  Kd as cE,
  Nh as cF,
  Rl as cG,
  gm as cH,
  lp as cI,
  Zd as cJ,
  V1 as cK,
  th as cL,
  zb as cM,
  M1 as cN,
  Al as cO,
  la as cP,
  Zn as cQ,
  zu as cR,
  RP as cS,
  FL as cT,
  $h as cU,
  _r as cV,
  nf as cW,
  oi as cX,
  vi as ca,
  oa as cb,
  Ei as cc,
  Li as cd,
  rp as ce,
  Lr as cf,
  $E as cg,
  zO as ch,
  rT as ci,
  nT as cj,
  oT as ck,
  lT as cl,
  uT as cm,
  TL as cn,
  iT as co,
  vh as cp,
  Yh as cq,
  mO as cr,
  wd as cs,
  NO as ct,
  lO as cu,
  di as cv,
  wT as cw,
  E1 as cx,
  L1 as cy,
  b1 as cz,
  np as d,
  Hg as e,
  QL as f,
  zL as g,
  UP as h,
  Fg as i,
  pO as j,
  Hi as k,
  JL as l,
  Or as m,
  gO as n,
  _P as o,
  Xh as p,
  tn as q,
  dO as r,
  O1 as s,
  fO as t,
  SO as u,
  RO as v,
  kO as w,
  um as x,
  Bm as y,
  pn as z
};
